import React from 'react';

export function ManagementLiabilitySvg({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 1051 493"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        id="Path"
        fill="#f9f9f9"
        stroke="none"
        d="M 530.059998 478.5 C 793.5 478.5 1007.059998 446.712006 1007.059998 407.5 C 1007.059998 368.287994 793.5 336.5 530.059998 336.5 C 266.619995 336.5 53.059898 368.287994 53.059898 407.5 C 53.059898 446.712006 266.619995 478.5 530.059998 478.5 Z"
      />
      <linearGradient
        id="linearGradient1"
        x1="591.51"
        y1="313.91"
        x2="591.51"
        y2="44.0601"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#bdb9d9" stopOpacity={1} />
        <stop offset={1} stopColor="#75699b" stopOpacity={1} />
      </linearGradient>
      <path
        id="path1"
        fill="url(#linearGradient1)"
        fillRule="evenodd"
        stroke="none"
        d="M 297.01001 313.910004 L 288.26001 44.070099 C 288.26001 44.070099 408.820007 59.330109 591.570007 59.330109 C 774.320007 59.330109 894.780029 48.100098 894.780029 48.100098 L 882.219971 309.359985 C 882.219971 309.359985 752.72998 291.850006 595.429993 291.850006 C 438.130005 291.850006 297.019989 313.920013 297.019989 313.920013 L 297.01001 313.910004 Z"
      />
      <path
        id="path2"
        fill="#ffffff"
        fillRule="evenodd"
        stroke="none"
        d="M 301.589996 313.269989 L 297.01001 45.279999 C 297.01001 45.279999 634.75 64.429993 888.23999 46.589996 L 877.349976 307.640015 C 877.349976 307.640015 633.179993 276.730011 301.589996 313.269989 Z"
      />
      <linearGradient
        id="linearGradient2"
        x1="591.98"
        y1="180.3"
        x2="591.98"
        y2="178.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9e98c7" stopOpacity={1} />
        <stop offset={1} stopColor="#8b6a92" stopOpacity={1} />
      </linearGradient>
      <path
        id="path3"
        fill="url(#linearGradient2)"
        stroke="none"
        d="M 884.669983 178.27002 L 299.299988 178.27002 L 299.299988 180.299988 L 884.669983 180.299988 L 884.669983 178.27002 Z"
      />
      <linearGradient
        id="linearGradient3"
        x1="591.21"
        y1={101}
        x2="591.21"
        y2="86.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9e98c7" stopOpacity={1} />
        <stop offset={1} stopColor="#8b6a92" stopOpacity={1} />
      </linearGradient>
      <path
        id="path4"
        fill="url(#linearGradient3)"
        stroke="none"
        d="M 598.710022 101 C 436.339996 101 298.290009 88.940002 296.920013 88.809998 L 297.100006 86.790009 C 298.470001 86.910004 436.440002 98.970001 598.719971 98.970001 C 761 98.970001 884.119995 89.589996 885.349976 89.5 L 885.51001 91.519989 C 884.280029 91.609985 761.090027 101 598.72998 101 L 598.710022 101 Z"
      />
      <linearGradient
        id="linearGradient4"
        x1="591.29"
        y1="269.98"
        x2="591.29"
        y2="253.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9e98c7" stopOpacity={1} />
        <stop offset={1} stopColor="#8b6a92" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5"
        fill="url(#linearGradient4)"
        stroke="none"
        d="M 301.040009 269.980011 L 300.820007 267.959991 C 302.140015 267.820007 434.459991 253.429993 596.849976 253.429993 C 759.23999 253.429993 880.559998 265.329987 881.76001 265.450012 L 881.559998 267.470001 C 880.349976 267.350006 759.119995 255.460007 596.849976 255.460007 C 434.579987 255.460007 302.359985 269.829987 301.049988 269.980011 L 301.040009 269.980011 Z"
      />
      <linearGradient
        id="linearGradient5"
        x1="729.546"
        y1="297.175"
        x2="729.546"
        y2="56.6447"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9e98c7" stopOpacity={1} />
        <stop offset={1} stopColor="#8b6a92" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6"
        fill="url(#linearGradient5)"
        stroke="none"
        d="M 733.945984 56.592407 L 723.153992 297.040009 L 725.182007 297.131012 L 735.973999 56.683411 L 733.945984 56.592407 Z"
      />
      <linearGradient
        id="linearGradient6"
        x1="446.461"
        y1="297.598"
        x2="446.461"
        y2="54.7185"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9e98c7" stopOpacity={1} />
        <stop offset={1} stopColor="#8b6a92" stopOpacity={1} />
      </linearGradient>
      <path
        id="path7"
        fill="url(#linearGradient6)"
        stroke="none"
        d="M 446.230011 54.684998 L 444.200012 54.706299 L 446.743988 297.562988 L 448.773987 297.541992 L 446.230011 54.684998 Z"
      />
      <linearGradient
        id="linearGradient7"
        x1="598.71"
        y1="291.97"
        x2="598.71"
        y2="59.3201"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#bdb9d9" stopOpacity={1} />
        <stop offset={1} stopColor="#75699b" stopOpacity={1} />
      </linearGradient>
      <path
        id="path8"
        fill="url(#linearGradient7)"
        fillRule="evenodd"
        stroke="none"
        d="M 595.419983 291.839996 L 595.419983 59.320099 L 602 59.380096 L 598.710022 291.970001 L 595.419983 291.839996 Z"
      />
      <path
        id="path9"
        fill="#f4f4f4"
        fillRule="evenodd"
        stroke="none"
        d="M 1038.400024 327.160004 C 953.080017 312.359985 787.349976 288.790009 597.27002 288.790009 C 320.209991 288.790009 84 338.859985 84 338.859985 L 84 342.589996 L 83.970001 351.660004 C 83.970001 351.660004 84.010002 351.649994 84.089996 351.640015 C 90.370003 350.149994 339.369995 291.829987 597.609985 291.829987 C 778.679993 291.829987 949.650024 321.019989 1037.72998 338.98999 C 1037.969971 335.049988 1038.209961 331.100006 1038.410034 327.160004 L 1038.400024 327.160004 Z"
      />
      <g id="Group" opacity="0.87" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path10"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 1038.26001 329.690002 C 950.130005 314.619995 777.640015 289.799988 597.01001 289.799988 C 333.339996 289.799988 83.980003 342.589996 83.980003 342.589996 L 83.959999 351.660004 C 83.959999 351.660004 84 351.649994 84.080002 351.640015 C 90.360001 350.149994 339.359985 291.829987 597.599976 291.829987 C 778.669983 291.829987 949.640015 321.019989 1037.719971 338.98999 C 1037.910034 335.890015 1038.089966 332.790009 1038.26001 329.690002 Z"
        />
      </g>
      <path
        id="path11"
        fill="#f4f4f4"
        fillRule="evenodd"
        stroke="none"
        d="M 1045.380005 14.880005 C 971.130005 31.190002 820.630005 56.359985 598.72998 56.359985 C 270.399994 56.359985 83.959999 0 83.959999 0 L 83.959999 16.75 C 83.959999 16.75 262.019989 62.290009 598.700012 62.290009 C 829.900024 62.290009 979.52002 40.820007 1050.579956 27.359985 C 1048.73999 23.220001 1046.930054 19.089996 1045.380005 14.880005 Z"
      />
      <g id="g1" opacity="0.87" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path12"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 1045.380005 14.880005 C 971.130005 31.190002 820.630005 56.359985 598.72998 56.359985 C 270.399994 56.359985 83.959999 0 83.959999 0 L 83.959999 12.179993 C 83.959999 12.179993 320.720001 60.779999 599.51001 60.779999 C 805.25 60.779999 969.400024 36.640015 1048.400024 22.390015 C 1047.329956 19.899994 1046.310059 17.410004 1045.369995 14.880005 L 1045.380005 14.880005 Z"
        />
      </g>
      <path
        id="path13"
        fill="#cecece"
        stroke="none"
        d="M 517.530029 189.51001 L 516.219971 189.51001 L 516.219971 223.910004 L 517.530029 223.910004 L 517.530029 189.51001 Z"
      />
      <path
        id="path14"
        fill="#cecece"
        stroke="none"
        d="M 508.649994 205.429993 L 507.339996 205.429993 L 507.339996 236.220001 L 508.649994 236.220001 L 508.649994 205.429993 Z"
      />
      <path
        id="path15"
        fill="#cecece"
        stroke="none"
        d="M 511.190002 203.660004 L 510.269989 203.660004 L 510.269989 237.410004 L 511.190002 237.410004 L 511.190002 203.660004 Z"
      />
      <path
        id="path16"
        fill="#cecece"
        stroke="none"
        d="M 458.799988 204.039978 L 458.26001 204.039978 L 458.26001 183.640015 L 458.799988 183.700012 L 458.799988 204.039978 Z"
      />
      <path
        id="path17"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 199.160004 L 459.410004 199.160004 L 459.410004 178.76001 L 459.950012 178.820007 L 459.950012 199.160004 Z"
      />
      <path
        id="path18"
        fill="#cecece"
        stroke="none"
        d="M 457.920013 209.820007 L 457.390015 209.820007 L 457.390015 197.910004 L 457.920013 197.940002 L 457.920013 209.820007 Z"
      />
      <path
        id="path19"
        fill="#cecece"
        stroke="none"
        d="M 514.299988 218.609985 L 513.380005 218.609985 L 513.380005 243.729996 L 514.299988 243.729996 L 514.299988 218.609985 Z"
      />
      <path
        id="path20"
        fill="#cecece"
        stroke="none"
        d="M 519.299988 184.27002 L 518.280029 184.27002 L 518.280029 218.669983 L 519.299988 218.669983 L 519.299988 184.27002 Z"
      />
      <path
        id="path21"
        fill="#cecece"
        stroke="none"
        d="M 520.869995 195.5 L 519.849976 195.5 L 519.849976 207.320007 L 520.869995 207.320007 L 520.869995 195.5 Z"
      />
      <path
        id="path22"
        fill="#cecece"
        stroke="none"
        d="M 529.710022 184.51001 L 528.630005 184.559998 L 528.630005 183.109985 L 529.710022 183.059998 L 529.710022 184.51001 Z"
      />
      <path
        id="path23"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 188.76001 L 528.630005 188.779999 L 528.630005 187.289978 L 529.700012 187.27002 L 529.700012 188.76001 Z"
      />
      <path
        id="path24"
        fill="#cecece"
        stroke="none"
        d="M 531.380005 188.73999 L 530.309998 188.75 L 530.309998 187.26001 L 531.380005 187.25 L 531.380005 188.73999 Z"
      />
      <path
        id="path25"
        fill="#cecece"
        stroke="none"
        d="M 533.02002 184.369995 L 531.950012 184.419983 L 531.950012 182.970001 L 533.02002 182.910004 L 533.02002 184.369995 Z"
      />
      <path
        id="path26"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 186.48999 L 533.650024 186.52002 L 533.650024 185.059998 L 534.719971 185.02002 L 534.719971 186.48999 Z"
      />
      <path
        id="path27"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 189.369995 L 533.650024 189.369995 L 533.650024 190.880005 L 534.719971 190.880005 L 534.719971 189.369995 Z"
      />
      <path
        id="path28"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 184.220001 L 535.359985 184.27002 L 535.359985 182.820007 L 536.429993 182.77002 L 536.429993 184.220001 Z"
      />
      <path
        id="path29"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 184.059998 L 549.150024 184.01001 L 549.150024 182.539978 L 550.659973 182.589996 L 550.659973 184.059998 Z"
      />
      <path
        id="path30"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 188.52002 L 549.150024 188.5 L 549.150024 187 L 550.659973 187.02002 L 550.659973 188.52002 Z"
      />
      <path
        id="path31"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 186.390015 L 549.150024 186.369995 L 549.150024 184.869995 L 550.659973 184.890015 L 550.659973 186.390015 Z"
      />
      <path
        id="path32"
        fill="#cecece"
        stroke="none"
        d="M 554.210022 186.669983 L 553.200012 186.649994 L 553.200012 185.160004 L 554.210022 185.169983 L 554.210022 186.669983 Z"
      />
      <path
        id="path33"
        fill="#cecece"
        stroke="none"
        d="M 554.210022 188.809998 L 553.200012 188.789978 L 553.200012 187.299988 L 554.210022 187.320007 L 554.210022 188.809998 Z"
      />
      <path
        id="path34"
        fill="#cecece"
        stroke="none"
        d="M 555.51001 184.289978 L 554.659973 184.23999 L 554.659973 182.789978 L 555.51001 182.839996 L 555.51001 184.289978 Z"
      />
      <path
        id="path35"
        fill="#cecece"
        stroke="none"
        d="M 555.51001 189.22998 L 554.659973 189.22998 L 554.659973 190.73999 L 555.51001 190.73999 L 555.51001 189.22998 Z"
      />
      <path
        id="path36"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 184.100006 L 540.98999 184.119995 L 540.98999 182.660004 C 540.98999 182.660004 542.419983 182.640015 542.460022 182.640015 L 542.460022 184.109985 L 542.460022 184.100006 Z"
      />
      <path
        id="path37"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 188.619995 L 540.98999 188.619995 L 540.98999 187.130005 C 540.98999 187.130005 542.440002 187.130005 542.450012 187.130005 L 542.450012 188.619995 Z"
      />
      <path
        id="path38"
        fill="#cecece"
        stroke="none"
        d="M 545.400024 186.52002 L 543.47998 186.52002 L 543.47998 185.02002 C 543.47998 185.02002 545.380005 185.02002 545.400024 185.02002 L 545.400024 186.52002 Z"
      />
      <path
        id="path39"
        fill="#cecece"
        stroke="none"
        d="M 545.390015 189.369995 L 543.47998 189.369995 L 543.47998 190.880005 L 545.390015 190.880005 L 545.390015 189.369995 Z"
      />
      <path
        id="path40"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 184.160004 L 537.109985 184.200012 L 537.109985 182.75 L 538.349976 182.710022 L 538.349976 184.160004 Z"
      />
      <path
        id="path41"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 186.399994 L 537.109985 186.429993 L 537.109985 184.960022 L 538.349976 184.929993 L 538.349976 186.399994 Z"
      />
      <path
        id="path42"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 188.640015 L 537.109985 188.649994 L 537.109985 187.169983 L 538.349976 187.149994 L 538.349976 188.640015 Z"
      />
      <path
        id="path43"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 195.559998 L 528.630005 195.580017 L 528.630005 194.089996 L 529.700012 194.070007 L 529.700012 195.559998 Z"
      />
      <path
        id="path44"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 193.450012 L 528.630005 193.470001 L 528.630005 191.97998 L 529.700012 191.960022 L 529.700012 193.450012 Z"
      />
      <path
        id="path45"
        fill="#cecece"
        stroke="none"
        d="M 531.380005 195.529999 L 530.309998 195.549988 L 530.309998 194.059998 L 531.380005 194.049988 L 531.380005 195.529999 Z"
      />
      <path
        id="path46"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 193.289978 L 533.650024 193.320007 L 533.650024 191.859985 L 534.719971 191.820007 L 534.719971 193.289978 Z"
      />
      <path
        id="path47"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 196.169983 L 533.650024 196.169983 L 533.650024 197.679993 L 534.719971 197.679993 L 534.719971 196.169983 Z"
      />
      <path
        id="path48"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 198.429993 L 533.650024 198.429993 L 533.650024 199.940002 L 534.719971 199.940002 L 534.719971 198.429993 Z"
      />
      <path
        id="path49"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 194.049988 L 535.359985 194.049988 L 535.359985 195.559998 L 536.429993 195.559998 L 536.429993 194.049988 Z"
      />
      <path
        id="path50"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 196.299988 L 535.359985 196.299988 L 535.359985 197.809998 L 536.429993 197.809998 L 536.429993 196.299988 Z"
      />
      <path
        id="path51"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 195.320007 L 549.150024 195.299988 L 549.150024 193.799988 L 550.659973 193.820007 L 550.659973 195.320007 Z"
      />
      <path
        id="path52"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 193.190002 L 549.150024 193.169983 L 549.150024 191.669983 L 550.659973 191.690002 L 550.659973 193.190002 Z"
      />
      <path
        id="path53"
        fill="#cecece"
        stroke="none"
        d="M 554.210022 193.460022 L 553.200012 193.450012 L 553.200012 191.960022 L 554.210022 191.970001 L 554.210022 193.460022 Z"
      />
      <path
        id="path54"
        fill="#cecece"
        stroke="none"
        d="M 554.210022 195.609985 L 553.200012 195.589996 L 553.200012 194.100006 L 554.210022 194.109985 L 554.210022 195.609985 Z"
      />
      <path
        id="path55"
        fill="#cecece"
        stroke="none"
        d="M 555.51001 196.029999 L 554.659973 196.029999 L 554.659973 197.539978 L 555.51001 197.539978 L 555.51001 196.029999 Z"
      />
      <path
        id="path56"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 195.419983 L 540.98999 195.419983 L 540.98999 193.929993 C 540.98999 193.929993 542.440002 193.929993 542.450012 193.929993 L 542.450012 195.419983 Z"
      />
      <path
        id="path57"
        fill="#cecece"
        stroke="none"
        d="M 545.400024 193.320007 L 543.47998 193.320007 L 543.47998 191.820007 C 543.47998 191.820007 545.380005 191.820007 545.400024 191.820007 L 545.400024 193.320007 Z"
      />
      <path
        id="path58"
        fill="#cecece"
        stroke="none"
        d="M 545.390015 196.169983 L 543.47998 196.169983 L 543.47998 197.679993 L 545.390015 197.679993 L 545.390015 196.169983 Z"
      />
      <path
        id="path59"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 193.200012 L 537.109985 193.22998 L 537.109985 191.76001 L 538.349976 191.72998 L 538.349976 193.200012 Z"
      />
      <path
        id="path60"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 195.440002 L 537.109985 195.450012 L 537.109985 193.970001 L 538.349976 193.950012 L 538.349976 195.440002 Z"
      />
      <path
        id="path61"
        fill="#cecece"
        stroke="none"
        d="M 522.140015 197.970001 L 521.130005 197.970001 L 521.130005 199.390015 L 522.140015 199.390015 L 522.140015 197.970001 Z"
      />
      <path
        id="path62"
        fill="#cecece"
        stroke="none"
        d="M 525.570007 197.970001 L 524.400024 197.970001 L 524.400024 199.390015 L 525.570007 199.390015 L 525.570007 197.970001 Z"
      />
      <path
        id="path63"
        fill="#cecece"
        stroke="none"
        d="M 508.279999 198.77002 L 507.339996 198.820007 L 507.339996 197.570007 L 508.279999 197.51001 L 508.279999 198.77002 Z"
      />
      <path
        id="path64"
        fill="#cecece"
        stroke="none"
        d="M 509.720001 200.580017 L 508.779999 200.630005 L 508.779999 199.359985 L 509.720001 199.309998 L 509.720001 200.580017 Z"
      />
      <path
        id="path65"
        fill="#cecece"
        stroke="none"
        d="M 511.209991 198.600006 L 510.269989 198.660004 L 510.269989 197.410004 L 511.209991 197.339996 L 511.209991 198.600006 Z"
      />
      <path
        id="path66"
        fill="#cecece"
        stroke="none"
        d="M 511.200012 201.619995 L 510.26001 201.660004 L 510.26001 200.390015 L 511.200012 200.350006 L 511.200012 201.619995 Z"
      />
      <path
        id="path67"
        fill="#cecece"
        stroke="none"
        d="M 511.209991 202.440002 L 510.269989 202.470001 L 510.269989 201.190002 L 511.209991 201.160004 L 511.209991 202.440002 Z"
      />
      <path
        id="path68"
        fill="#cecece"
        stroke="none"
        d="M 512.700012 200.460022 L 511.76001 200.5 L 511.76001 199.22998 L 512.700012 199.190002 L 512.700012 200.460022 Z"
      />
      <path
        id="path69"
        fill="#cecece"
        stroke="none"
        d="M 514.390015 198.440002 L 513.299988 198.48999 L 513.299988 197.23999 L 514.390015 197.190002 L 514.390015 198.440002 Z"
      />
      <path
        id="path70"
        fill="#cecece"
        stroke="none"
        d="M 514.390015 200.399994 L 513.299988 200.440002 L 513.299988 199.169983 L 514.390015 199.130005 L 514.390015 200.399994 Z"
      />
      <path
        id="path71"
        fill="#cecece"
        stroke="none"
        d="M 514.390015 202.359985 L 513.299988 202.390015 L 513.299988 201.100006 L 514.390015 201.080017 L 514.390015 202.359985 Z"
      />
      <path
        id="path72"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 158.960022 L 416.630005 159.880005 C 416.630005 159.880005 412.549988 160.130005 410.390015 161.75 L 410.390015 161.210022 C 410.390015 161.210022 412.410004 159.5 416.630005 158.960022 Z"
      />
      <path
        id="path73"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 161.910004 C 416.630005 161.910004 412.450012 162.140015 410.390015 163.700012 L 410.390015 163.140015 C 410.390015 163.140015 412.589996 161.51001 416.630005 160.98999 L 416.630005 161.910004 Z"
      />
      <path
        id="path74"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 163.919983 C 416.630005 163.919983 412.359985 164.140015 410.390015 165.630005 L 410.390015 165.049988 C 410.390015 165.049988 412.779999 163.48999 416.630005 162.98999 L 416.630005 163.919983 Z"
      />
      <path
        id="path75"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 165.940002 C 416.630005 165.940002 412.26001 166.149994 410.390015 167.570007 L 410.390015 166.970001 C 410.390015 166.970001 412.959991 165.47998 416.630005 165.01001 L 416.630005 165.940002 Z"
      />
      <path
        id="path76"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 167.960022 C 416.630005 167.960022 412.170013 168.160004 410.390015 169.5 L 410.390015 168.890015 C 410.390015 168.890015 413.140015 167.47998 416.630005 167.029999 L 416.630005 167.960022 Z"
      />
      <path
        id="path77"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 169.97998 C 416.630005 169.97998 412.079987 170.169983 410.390015 171.440002 L 410.390015 170.809998 C 410.390015 170.809998 413.329987 169.470001 416.630005 169.049988 L 416.630005 169.97998 Z"
      />
      <path
        id="path78"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 174.02002 C 416.630005 174.02002 411.890015 174.190002 410.390015 175.320007 L 410.390015 174.649994 C 410.390015 174.649994 413.690002 173.460022 416.630005 173.080017 L 416.630005 174.01001 L 416.630005 174.02002 Z"
      />
      <path
        id="path79"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 176.029999 C 416.630005 176.029999 411.799988 176.190002 410.390015 177.25 L 410.390015 176.570007 C 410.390015 176.570007 413.880005 175.460022 416.630005 175.100006 L 416.630005 176.029999 Z"
      />
      <path
        id="path80"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 178.049988 C 416.630005 178.049988 411.700012 178.200012 410.390015 179.190002 L 410.390015 178.48999 C 410.390015 178.48999 414.059998 177.450012 416.630005 177.119995 L 416.630005 178.049988 Z"
      />
      <path
        id="path81"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 180.070007 C 416.630005 180.070007 411.609985 180.210022 410.390015 181.130005 L 410.390015 180.410004 C 410.390015 180.410004 414.23999 179.440002 416.630005 179.140015 L 416.630005 180.080017 L 416.630005 180.070007 Z"
      />
      <path
        id="path82"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 182.089996 C 416.630005 182.089996 411.519989 182.220001 410.390015 183.070007 L 410.390015 182.330017 C 410.390015 182.330017 414.429993 181.440002 416.630005 181.160004 L 416.630005 182.100006 L 416.630005 182.089996 Z"
      />
      <path
        id="path83"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 186.130005 C 416.630005 186.130005 411.329987 186.23999 410.390015 186.940002 L 410.390015 186.169983 C 410.390015 186.169983 414.790009 185.429993 416.630005 185.190002 L 416.630005 186.130005 Z"
      />
      <path
        id="path84"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 188.149994 C 416.630005 188.149994 411.230011 188.25 410.390015 188.880005 L 410.390015 188.089996 C 410.390015 188.089996 414.980011 187.419983 416.630005 187.210022 L 416.630005 188.149994 Z"
      />
      <path
        id="path85"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 192.179993 C 416.630005 192.179993 411.049988 192.25 410.390015 192.75 L 410.390015 191.919983 C 410.390015 191.919983 415.339996 191.399994 416.630005 191.23999 L 416.630005 192.179993 Z"
      />
      <path
        id="path86"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 194.200012 C 416.630005 194.200012 410.950012 194.26001 410.390015 194.690002 L 410.390015 193.839996 C 410.390015 193.839996 415.529999 193.390015 416.630005 193.25 L 416.630005 194.200012 Z"
      />
      <path
        id="path87"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 196.220001 C 416.630005 196.220001 410.859985 196.27002 410.390015 196.630005 L 410.390015 195.77002 C 410.390015 195.77002 415.709991 195.399994 416.630005 195.279999 L 416.630005 196.22998 L 416.630005 196.220001 Z"
      />
      <path
        id="path88"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 200.26001 C 416.630005 200.26001 410.670013 200.289978 410.390015 200.5 L 410.390015 199.600006 C 410.390015 199.600006 416.079987 199.380005 416.630005 199.309998 L 416.630005 200.26001 Z"
      />
      <path
        id="path89"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 204.289978 C 416.630005 204.289978 410.480011 204.299988 410.390015 204.369995 L 410.390015 203.440002 C 410.390015 203.440002 416.440002 203.369995 416.630005 203.339996 L 416.630005 204.289978 Z"
      />
      <path
        id="path90"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 159.23999 L 426.26001 160.359985 L 424.549988 160.179993 L 424.549988 158.960022 L 426.26001 159.23999 Z"
      />
      <path
        id="path91"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 161.22998 L 426.26001 162.359985 L 424.549988 162.190002 L 424.549988 160.970001 L 426.26001 161.22998 Z"
      />
      <path
        id="path92"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 163.22998 L 426.26001 164.359985 L 424.549988 164.190002 L 424.549988 162.97998 L 426.26001 163.22998 Z"
      />
      <path
        id="path93"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 165.22998 L 426.26001 166.350006 L 424.549988 166.200012 L 424.549988 164.98999 L 426.26001 165.22998 Z"
      />
      <path
        id="path94"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 167.22998 L 426.26001 168.350006 L 424.549988 168.200012 L 424.549988 167 L 426.26001 167.22998 Z"
      />
      <path
        id="path95"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 171.22998 L 426.26001 172.350006 L 424.549988 172.210022 L 424.549988 171.029999 L 426.26001 171.22998 Z"
      />
      <path
        id="path96"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 173.220001 L 426.26001 174.350006 L 424.549988 174.220001 L 424.549988 173.029999 L 426.26001 173.220001 Z"
      />
      <path
        id="path97"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 177.220001 L 426.26001 178.339996 L 424.549988 178.22998 L 424.549988 177.049988 L 426.26001 177.220001 Z"
      />
      <path
        id="path98"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 179.220001 L 426.26001 180.339996 L 424.549988 180.23999 L 424.549988 179.059998 L 426.26001 179.220001 Z"
      />
      <path
        id="path99"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 181.220001 L 426.26001 182.339996 L 424.549988 182.23999 L 424.549988 181.080017 L 426.26001 181.220001 Z"
      />
      <path
        id="path100"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 183.220001 L 426.26001 184.330017 L 424.549988 184.25 L 424.549988 183.080017 L 426.26001 183.220001 Z"
      />
      <path
        id="path101"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 187.210022 L 426.26001 188.330017 L 424.549988 188.26001 L 424.549988 187.109985 L 426.26001 187.210022 Z"
      />
      <path
        id="path102"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 189.210022 L 426.26001 190.330017 L 424.549988 190.26001 L 424.549988 189.119995 L 426.26001 189.210022 Z"
      />
      <path
        id="path103"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 191.210022 L 426.26001 192.330017 L 424.549988 192.27002 L 424.549988 191.119995 L 426.26001 191.210022 Z"
      />
      <path
        id="path104"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 195.200012 L 426.26001 196.320007 L 424.549988 196.279999 L 424.549988 195.149994 L 426.26001 195.200012 Z"
      />
      <path
        id="path105"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 197.200012 L 426.26001 198.320007 L 424.549988 198.289978 L 424.549988 197.160004 L 426.26001 197.200012 Z"
      />
      <path
        id="path106"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 201.200012 L 426.26001 202.320007 L 424.549988 202.299988 L 424.549988 201.179993 L 426.26001 201.200012 Z"
      />
      <path
        id="path107"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 205.200012 L 424.549988 205.200012 L 424.549988 206.320007 L 426.26001 206.320007 L 426.26001 205.200012 Z"
      />
      <path
        id="path108"
        fill="#cecece"
        stroke="none"
        d="M 423.880005 158.869995 L 423.880005 160.089996 L 422.269989 159.97998 L 422.269989 158.73999 L 423.880005 158.869995 Z"
      />
      <path
        id="path109"
        fill="#cecece"
        stroke="none"
        d="M 423.890015 160.880005 L 423.890015 162.100006 L 422.269989 162 L 422.269989 160.76001 L 423.890015 160.880005 Z"
      />
      <path
        id="path110"
        fill="#cecece"
        stroke="none"
        d="M 423.890015 162.899994 L 423.890015 164.109985 L 422.269989 164.01001 L 422.269989 162.779999 L 423.890015 162.899994 Z"
      />
      <path
        id="path111"
        fill="#cecece"
        stroke="none"
        d="M 423.890015 164.910004 L 423.890015 166.119995 L 422.269989 166.02002 L 422.269989 164.799988 L 423.890015 164.910004 Z"
      />
      <path
        id="path112"
        fill="#cecece"
        stroke="none"
        d="M 423.890015 166.919983 L 423.890015 168.130005 L 422.269989 168.039978 L 422.269989 166.820007 L 423.890015 166.919983 Z"
      />
      <path
        id="path113"
        fill="#cecece"
        stroke="none"
        d="M 423.890015 168.940002 L 423.890015 170.140015 L 422.269989 170.049988 L 422.269989 168.839996 L 423.890015 168.940002 Z"
      />
      <path
        id="path114"
        fill="#cecece"
        stroke="none"
        d="M 423.899994 170.950012 L 423.899994 172.140015 L 422.269989 172.070007 L 422.269989 170.859985 L 423.899994 170.950012 Z"
      />
      <path
        id="path115"
        fill="#cecece"
        stroke="none"
        d="M 423.899994 172.970001 L 423.899994 174.160004 L 422.269989 174.080017 L 422.269989 172.880005 L 423.899994 172.970001 Z"
      />
      <path
        id="path116"
        fill="#cecece"
        stroke="none"
        d="M 423.899994 174.97998 L 423.899994 176.160004 L 422.269989 176.100006 L 422.269989 174.899994 L 423.899994 174.97998 Z"
      />
      <path
        id="path117"
        fill="#cecece"
        stroke="none"
        d="M 423.899994 179.01001 L 423.899994 180.179993 L 422.269989 180.119995 L 422.269989 178.940002 L 423.899994 179.01001 Z"
      />
      <path
        id="path118"
        fill="#cecece"
        stroke="none"
        d="M 423.910004 181.02002 L 423.910004 182.190002 L 422.269989 182.140015 L 422.269989 180.960022 L 423.910004 181.02002 Z"
      />
      <path
        id="path119"
        fill="#cecece"
        stroke="none"
        d="M 423.910004 185.049988 L 423.910004 186.210022 L 422.269989 186.169983 L 422.269989 185 L 423.910004 185.049988 Z"
      />
      <path
        id="path120"
        fill="#cecece"
        stroke="none"
        d="M 423.910004 187.070007 L 423.910004 188.220001 L 422.269989 188.179993 L 422.269989 187.02002 L 423.910004 187.070007 Z"
      />
      <path
        id="path121"
        fill="#cecece"
        stroke="none"
        d="M 423.910004 189.080017 L 423.910004 190.22998 L 422.269989 190.200012 L 422.269989 189.039978 L 423.910004 189.080017 Z"
      />
      <path
        id="path122"
        fill="#cecece"
        stroke="none"
        d="M 423.920013 191.100006 L 423.920013 192.23999 L 422.269989 192.210022 L 422.269989 191.059998 L 423.920013 191.100006 Z"
      />
      <path
        id="path123"
        fill="#cecece"
        stroke="none"
        d="M 423.920013 193.109985 L 423.920013 194.25 L 422.269989 194.22998 L 422.269989 193.080017 L 423.920013 193.109985 Z"
      />
      <path
        id="path124"
        fill="#cecece"
        stroke="none"
        d="M 423.920013 195.119995 L 423.920013 196.26001 L 422.269989 196.23999 L 422.269989 195.100006 L 423.920013 195.119995 Z"
      />
      <path
        id="path125"
        fill="#cecece"
        stroke="none"
        d="M 423.920013 199.149994 L 423.920013 200.279999 L 422.269989 200.27002 L 422.269989 199.140015 L 423.920013 199.149994 Z"
      />
      <path
        id="path126"
        fill="#cecece"
        stroke="none"
        d="M 423.929993 201.169983 L 423.929993 202.289978 L 422.269989 202.279999 L 422.269989 201.160004 L 423.929993 201.169983 Z"
      />
      <path
        id="path127"
        fill="#cecece"
        stroke="none"
        d="M 423.929993 205.200012 L 422.269989 205.200012 L 422.269989 206.320007 L 423.929993 206.320007 L 423.929993 205.200012 Z"
      />
      <path
        id="path128"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 158.669983 L 421.559998 159.880005 L 419.899994 159.820007 L 419.899994 158.589996 L 421.559998 158.669983 Z"
      />
      <path
        id="path129"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 160.690002 L 421.559998 161.899994 L 419.899994 161.839996 L 419.899994 160.619995 L 421.559998 160.690002 Z"
      />
      <path
        id="path130"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 162.720001 L 421.559998 163.919983 L 419.890015 163.859985 L 419.890015 162.640015 L 421.559998 162.720001 Z"
      />
      <path
        id="path131"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 164.73999 L 421.559998 165.940002 L 419.890015 165.890015 L 419.890015 164.669983 L 421.559998 164.73999 Z"
      />
      <path
        id="path132"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 166.76001 L 421.559998 167.950012 L 419.890015 167.910004 L 419.890015 166.700012 L 421.559998 166.76001 Z"
      />
      <path
        id="path133"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 168.789978 L 421.559998 169.970001 L 419.890015 169.929993 L 419.890015 168.720001 L 421.559998 168.789978 Z"
      />
      <path
        id="path134"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 170.809998 L 421.559998 171.98999 L 419.890015 171.950012 L 419.890015 170.75 L 421.559998 170.809998 Z"
      />
      <path
        id="path135"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 172.830017 L 421.559998 174.01001 L 419.890015 173.970001 L 419.890015 172.779999 L 421.559998 172.830017 Z"
      />
      <path
        id="path136"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 174.850006 L 421.559998 176.029999 L 419.890015 175.98999 L 419.890015 174.799988 L 421.559998 174.850006 Z"
      />
      <path
        id="path137"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 176.880005 L 421.559998 178.049988 L 419.890015 178.01001 L 419.890015 176.830017 L 421.559998 176.880005 Z"
      />
      <path
        id="path138"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 178.899994 L 421.559998 180.070007 L 419.890015 180.039978 L 419.890015 178.850006 L 421.559998 178.899994 Z"
      />
      <path
        id="path139"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 180.919983 L 421.559998 182.089996 L 419.890015 182.059998 L 419.890015 180.880005 L 421.559998 180.919983 Z"
      />
      <path
        id="path140"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 182.940002 L 421.559998 184.100006 L 419.890015 184.080017 L 419.890015 182.910004 L 421.559998 182.940002 Z"
      />
      <path
        id="path141"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 184.970001 L 421.559998 186.119995 L 419.890015 186.100006 L 419.890015 184.929993 L 421.559998 184.970001 Z"
      />
      <path
        id="path142"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 189.01001 L 421.559998 190.160004 L 419.880005 190.140015 L 419.880005 188.98999 L 421.559998 189.01001 Z"
      />
      <path
        id="path143"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 193.059998 L 421.559998 194.200012 L 419.880005 194.179993 L 419.880005 193.039978 L 421.559998 193.059998 Z"
      />
      <path
        id="path144"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 197.100006 L 421.559998 198.23999 L 419.880005 198.22998 L 419.880005 197.089996 L 421.559998 197.100006 Z"
      />
      <path
        id="path145"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 199.130005 L 421.559998 200.26001 L 419.880005 200.25 L 419.880005 199.119995 L 421.559998 199.130005 Z"
      />
      <path
        id="path146"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 201.149994 L 421.559998 202.27002 L 419.880005 202.27002 L 419.880005 201.140015 L 421.559998 201.149994 Z"
      />
      <path
        id="path147"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 203.169983 L 421.559998 204.289978 L 419.880005 204.289978 L 419.880005 203.169983 L 421.559998 203.169983 Z"
      />
      <path
        id="path148"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 158.559998 L 417.619995 158.559998 L 417.619995 159.799988 L 419.100006 159.799988 L 419.100006 158.559998 Z"
      />
      <path
        id="path149"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 160.589996 L 417.619995 160.589996 L 417.619995 161.830017 L 419.100006 161.830017 L 419.100006 160.589996 Z"
      />
      <path
        id="path150"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 162.619995 L 417.619995 162.619995 L 417.619995 163.850006 L 419.100006 163.850006 L 419.100006 162.619995 Z"
      />
      <path
        id="path151"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 164.649994 L 417.619995 164.649994 L 417.619995 165.880005 L 419.100006 165.880005 L 419.100006 164.649994 Z"
      />
      <path
        id="path152"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 166.669983 L 417.619995 166.669983 L 417.619995 167.890015 L 419.100006 167.890015 L 419.100006 166.669983 Z"
      />
      <path
        id="path153"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 168.700012 L 417.619995 168.700012 L 417.619995 169.910004 L 419.100006 169.910004 L 419.100006 168.700012 Z"
      />
      <path
        id="path154"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 170.72998 L 417.619995 170.72998 L 417.619995 171.940002 L 419.100006 171.940002 L 419.100006 170.72998 Z"
      />
      <path
        id="path155"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 172.76001 L 417.619995 172.76001 L 417.619995 173.960022 L 419.100006 173.960022 L 419.100006 172.76001 Z"
      />
      <path
        id="path156"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 174.779999 L 417.619995 174.779999 L 417.619995 175.97998 L 419.100006 175.97998 L 419.100006 174.779999 Z"
      />
      <path
        id="path157"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 176.809998 L 417.619995 176.809998 L 417.619995 178 L 419.100006 178 L 419.100006 176.809998 Z"
      />
      <path
        id="path158"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 178.839996 L 417.619995 178.839996 L 417.619995 180.029999 L 419.100006 180.029999 L 419.100006 178.839996 Z"
      />
      <path
        id="path159"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 180.869995 L 417.619995 180.869995 L 417.619995 182.049988 L 419.100006 182.049988 L 419.100006 180.869995 Z"
      />
      <path
        id="path160"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 182.890015 L 417.619995 182.890015 L 417.619995 184.070007 L 419.100006 184.070007 L 419.100006 182.890015 Z"
      />
      <path
        id="path161"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 184.919983 L 417.619995 184.919983 L 417.619995 186.089996 L 419.100006 186.089996 L 419.100006 184.919983 Z"
      />
      <path
        id="path162"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 186.950012 L 417.619995 186.950012 L 417.619995 188.109985 L 419.100006 188.109985 L 419.100006 186.950012 Z"
      />
      <path
        id="path163"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 191 L 417.619995 191 L 417.619995 192.149994 L 419.100006 192.149994 L 419.100006 191 Z"
      />
      <path
        id="path164"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 193.029999 L 417.619995 193.029999 L 417.619995 194.179993 L 419.100006 194.179993 L 419.100006 193.029999 Z"
      />
      <path
        id="path165"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 195.059998 L 417.619995 195.059998 L 417.619995 196.200012 L 419.100006 196.200012 L 419.100006 195.059998 Z"
      />
      <path
        id="path166"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 197.089996 L 417.619995 197.089996 L 417.619995 198.22998 L 419.100006 198.22998 L 419.100006 197.089996 Z"
      />
      <path
        id="path167"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 199.109985 L 417.619995 199.109985 L 417.619995 200.23999 L 419.100006 200.23999 L 419.100006 199.109985 Z"
      />
      <path
        id="path168"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 201.140015 L 417.619995 201.140015 L 417.619995 202.27002 L 419.100006 202.27002 L 419.100006 201.140015 Z"
      />
      <path
        id="path169"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 205.200012 L 417.619995 205.200012 L 417.619995 206.320007 L 419.100006 206.320007 L 419.100006 205.200012 Z"
      />
      <path
        id="path170"
        fill="#cecece"
        stroke="none"
        d="M 416.630005 212.779999 C 416.630005 212.779999 410.480011 212.789978 410.390015 212.859985 L 410.390015 211.919983 C 410.390015 211.919983 416.440002 211.850006 416.630005 211.820007 L 416.630005 212.77002 L 416.630005 212.779999 Z"
      />
      <path
        id="path171"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 159.600006 L 427.320007 160.52002 C 427.320007 160.52002 430.23999 160.76001 431.790009 162.390015 L 431.790009 161.850006 C 431.790009 161.850006 430.339996 160.140015 427.320007 159.600006 Z"
      />
      <path
        id="path172"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 162.539978 C 427.320007 162.539978 430.309998 162.77002 431.790009 164.330017 L 431.790009 163.77002 C 431.790009 163.77002 430.209991 162.140015 427.320007 161.619995 L 427.320007 162.539978 Z"
      />
      <path
        id="path173"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 164.559998 C 427.320007 164.559998 430.380005 164.779999 431.790009 166.27002 L 431.790009 165.690002 C 431.790009 165.690002 430.079987 164.130005 427.320007 163.630005 L 427.320007 164.559998 Z"
      />
      <path
        id="path174"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 166.580017 C 427.320007 166.580017 430.450012 166.789978 431.790009 168.210022 L 431.790009 167.609985 C 431.790009 167.609985 429.950012 166.119995 427.320007 165.649994 L 427.320007 166.580017 Z"
      />
      <path
        id="path175"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 168.600006 C 427.320007 168.600006 430.51001 168.799988 431.790009 170.149994 L 431.790009 169.539978 C 431.790009 169.539978 429.820007 168.130005 427.320007 167.679993 L 427.320007 168.609985 L 427.320007 168.600006 Z"
      />
      <path
        id="path176"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 170.619995 C 427.320007 170.619995 430.579987 170.809998 431.790009 172.080017 L 431.790009 171.450012 C 431.790009 171.450012 429.690002 170.109985 427.320007 169.690002 L 427.320007 170.619995 Z"
      />
      <path
        id="path177"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 174.649994 C 427.320007 174.649994 430.709991 174.820007 431.790009 175.950012 L 431.790009 175.279999 C 431.790009 175.279999 429.429993 174.089996 427.320007 173.710022 L 427.320007 174.640015 L 427.320007 174.649994 Z"
      />
      <path
        id="path178"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 176.669983 C 427.320007 176.669983 430.779999 176.830017 431.790009 177.890015 L 431.790009 177.210022 C 431.790009 177.210022 429.290009 176.100006 427.320007 175.73999 L 427.320007 176.669983 Z"
      />
      <path
        id="path179"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 178.690002 C 427.320007 178.690002 430.850006 178.839996 431.790009 179.830017 L 431.790009 179.130005 C 431.790009 179.130005 429.160004 178.089996 427.320007 177.76001 L 427.320007 178.690002 Z"
      />
      <path
        id="path180"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 180.710022 C 427.320007 180.710022 430.910004 180.850006 431.790009 181.77002 L 431.790009 181.049988 C 431.790009 181.049988 429.029999 180.080017 427.320007 179.779999 L 427.320007 180.720001 L 427.320007 180.710022 Z"
      />
      <path
        id="path181"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 182.72998 C 427.320007 182.72998 430.980011 182.859985 431.790009 183.710022 L 431.790009 182.970001 C 431.790009 182.970001 428.899994 182.080017 427.320007 181.799988 L 427.320007 182.73999 L 427.320007 182.72998 Z"
      />
      <path
        id="path182"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 186.77002 C 427.320007 186.77002 431.119995 186.880005 431.790009 187.580017 L 431.790009 186.809998 C 431.790009 186.809998 428.640015 186.070007 427.320007 185.830017 L 427.320007 186.77002 Z"
      />
      <path
        id="path183"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 188.779999 C 427.320007 188.779999 431.179993 188.880005 431.790009 189.51001 L 431.790009 188.720001 C 431.790009 188.720001 428.51001 188.049988 427.320007 187.839996 L 427.320007 188.779999 Z"
      />
      <path
        id="path184"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 192.820007 C 427.320007 192.820007 431.320007 192.890015 431.790009 193.390015 L 431.790009 192.559998 C 431.790009 192.559998 428.23999 192.039978 427.320007 191.880005 L 427.320007 192.820007 Z"
      />
      <path
        id="path185"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 194.839996 C 427.320007 194.839996 431.380005 194.899994 431.790009 195.330017 L 431.790009 194.47998 C 431.790009 194.47998 428.109985 194.029999 427.320007 193.890015 L 427.320007 194.839996 Z"
      />
      <path
        id="path186"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 196.859985 C 427.320007 196.859985 431.450012 196.910004 431.790009 197.27002 L 431.790009 196.410004 C 431.790009 196.410004 427.980011 196.039978 427.320007 195.919983 L 427.320007 196.869995 L 427.320007 196.859985 Z"
      />
      <path
        id="path187"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 200.890015 C 427.320007 200.890015 431.579987 200.919983 431.790009 201.130005 L 431.790009 200.22998 C 431.790009 200.22998 427.720001 200.01001 427.320007 199.940002 L 427.320007 200.890015 Z"
      />
      <path
        id="path188"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 204.929993 C 427.320007 204.929993 431.720001 204.940002 431.790009 205.01001 L 431.790009 204.080017 C 431.790009 204.080017 427.459991 204 427.320007 203.97998 L 427.320007 204.929993 Z"
      />
      <path
        id="path189"
        fill="#cecece"
        stroke="none"
        d="M 427.320007 213.410004 C 427.320007 213.410004 431.720001 213.419983 431.790009 213.48999 L 431.790009 212.549988 C 431.790009 212.549988 427.459991 212.47998 427.320007 212.450012 L 427.320007 213.399994 L 427.320007 213.410004 Z"
      />
      <path
        id="path190"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 208.5 L 426.26001 209.619995 L 424.549988 209.600006 L 424.549988 208.47998 L 426.26001 208.5 Z"
      />
      <path
        id="path191"
        fill="#cecece"
        stroke="none"
        d="M 426.26001 213.679993 L 424.549988 213.679993 L 424.549988 214.799988 L 426.26001 214.799988 L 426.26001 213.679993 Z"
      />
      <path
        id="path192"
        fill="#cecece"
        stroke="none"
        d="M 423.929993 208.470001 L 423.929993 209.589996 L 422.269989 209.580017 L 422.269989 208.460022 L 423.929993 208.470001 Z"
      />
      <path
        id="path193"
        fill="#cecece"
        stroke="none"
        d="M 423.929993 213.679993 L 422.269989 213.679993 L 422.269989 214.799988 L 423.929993 214.799988 L 423.929993 213.679993 Z"
      />
      <path
        id="path194"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 208.450012 L 421.559998 209.570007 L 419.880005 209.570007 L 419.880005 208.440002 L 421.559998 208.450012 Z"
      />
      <path
        id="path195"
        fill="#cecece"
        stroke="none"
        d="M 421.559998 210.470001 L 421.559998 211.589996 L 419.880005 211.589996 L 419.880005 210.470001 L 421.559998 210.470001 Z"
      />
      <path
        id="path196"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 208.440002 L 417.619995 208.440002 L 417.619995 209.570007 L 419.100006 209.570007 L 419.100006 208.440002 Z"
      />
      <path
        id="path197"
        fill="#cecece"
        stroke="none"
        d="M 419.100006 213.679993 L 417.619995 213.679993 L 417.619995 214.799988 L 419.100006 214.799988 L 419.100006 213.679993 Z"
      />
      <path
        id="path198"
        fill="#cecece"
        stroke="none"
        d="M 528.52002 106.73999 L 529.630005 106.119995 L 529.630005 106.98999 L 528.52002 107.570007 L 528.52002 106.73999 Z"
      />
      <path
        id="path199"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 109.140015 L 528.52002 109.700012 L 528.52002 108.839996 L 529.630005 108.25 L 529.630005 109.140015 Z"
      />
      <path
        id="path200"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 111.279999 L 528.52002 111.820007 L 528.52002 110.950012 L 529.630005 110.369995 L 529.630005 111.279999 Z"
      />
      <path
        id="path201"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 113.419983 L 528.52002 113.940002 L 528.52002 113.049988 L 529.630005 112.48999 L 529.630005 113.419983 Z"
      />
      <path
        id="path202"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 115.559998 L 528.52002 116.070007 L 528.52002 115.160004 L 529.630005 114.609985 L 529.630005 115.559998 Z"
      />
      <path
        id="path203"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 117.700012 L 528.52002 118.190002 L 528.52002 117.26001 L 529.630005 116.730011 L 529.630005 117.700012 Z"
      />
      <path
        id="path204"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 119.839996 L 528.52002 120.320007 L 528.52002 119.369995 L 529.630005 118.859985 L 529.630005 119.839996 Z"
      />
      <path
        id="path205"
        fill="#cecece"
        stroke="none"
        d="M 529.630005 121.980011 L 528.52002 122.440002 L 528.52002 121.470001 L 529.630005 120.980011 L 529.630005 121.980011 Z"
      />
      <path
        id="path206"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 124.119995 L 528.52002 124.559998 L 528.52002 123.570007 L 529.619995 123.100006 L 529.619995 124.119995 Z"
      />
      <path
        id="path207"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 126.26001 L 528.52002 126.690002 L 528.52002 125.679993 L 529.619995 125.220001 L 529.619995 126.26001 Z"
      />
      <path
        id="path208"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 128.399994 L 528.52002 128.809998 L 528.52002 127.779999 L 529.619995 127.339996 L 529.619995 128.399994 Z"
      />
      <path
        id="path209"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 130.539978 L 528.52002 130.940002 L 528.52002 129.890015 L 529.619995 129.460022 L 529.619995 130.539978 Z"
      />
      <path
        id="path210"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 136.960022 L 528.52002 137.309998 L 528.52002 136.200012 L 529.619995 135.830017 L 529.619995 136.960022 Z"
      />
      <path
        id="path211"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 139.100006 L 528.52002 139.429993 L 528.52002 138.299988 L 529.619995 137.950012 L 529.619995 139.100006 Z"
      />
      <path
        id="path212"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 141.23999 L 528.52002 141.559998 L 528.52002 140.410004 L 529.619995 140.070007 L 529.619995 141.23999 Z"
      />
      <path
        id="path213"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 143.380005 L 528.52002 143.679993 L 528.52002 142.51001 L 529.619995 142.200012 L 529.619995 143.380005 Z"
      />
      <path
        id="path214"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 147.660004 L 528.52002 147.929993 L 528.52002 146.720001 L 529.619995 146.440002 L 529.619995 147.660004 Z"
      />
      <path
        id="path215"
        fill="#cecece"
        stroke="none"
        d="M 529.619995 149.799988 L 528.52002 150.049988 L 528.52002 148.830017 L 529.619995 148.559998 L 529.619995 149.799988 Z"
      />
      <path
        id="path216"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 156.220001 L 528.52002 156.419983 L 528.52002 155.140015 L 529.609985 154.929993 L 529.609985 156.220001 Z"
      />
      <path
        id="path217"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 160.51001 L 528.52002 160.669983 L 528.52002 159.350006 L 529.609985 159.169983 L 529.609985 160.51001 Z"
      />
      <path
        id="path218"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 162.649994 L 528.52002 162.799988 L 528.52002 161.450012 L 529.609985 161.289978 L 529.609985 162.649994 Z"
      />
      <path
        id="path219"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 166.929993 L 528.52002 167.039978 L 528.52002 165.660004 L 529.609985 165.539978 L 529.609985 166.929993 Z"
      />
      <path
        id="path220"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 169.070007 L 528.52002 169.169983 L 528.52002 167.76001 L 529.609985 167.660004 L 529.609985 169.070007 Z"
      />
      <path
        id="path221"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 173.350006 L 528.52002 173.410004 L 528.52002 171.970001 L 529.609985 171.899994 L 529.609985 173.350006 Z"
      />
      <path
        id="path222"
        fill="#cecece"
        stroke="none"
        d="M 529.609985 175.48999 L 528.52002 175.539978 L 528.52002 174.080017 L 529.609985 174.02002 L 529.609985 175.48999 Z"
      />
      <path
        id="path223"
        fill="#cecece"
        stroke="none"
        d="M 529.599976 179.77002 L 528.52002 179.789978 L 528.52002 178.289978 L 529.599976 178.27002 L 529.599976 179.77002 Z"
      />
      <path
        id="path224"
        fill="#cecece"
        stroke="none"
        d="M 530.190002 105.869995 L 531.299988 105.26001 L 531.299988 106.130005 L 530.190002 106.709991 L 530.190002 105.869995 Z"
      />
      <path
        id="path225"
        fill="#cecece"
        stroke="none"
        d="M 531.299988 108.290009 L 530.190002 108.850006 L 530.190002 108 L 531.299988 107.399994 L 531.299988 108.290009 Z"
      />
      <path
        id="path226"
        fill="#cecece"
        stroke="none"
        d="M 531.299988 110.459991 L 530.190002 111 L 530.190002 110.130005 L 531.299988 109.549988 L 531.299988 110.459991 Z"
      />
      <path
        id="path227"
        fill="#cecece"
        stroke="none"
        d="M 531.299988 112.619995 L 530.190002 113.149994 L 530.190002 112.26001 L 531.299988 111.700012 L 531.299988 112.619995 Z"
      />
      <path
        id="path228"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 114.790009 L 530.190002 115.299988 L 530.190002 114.390015 L 531.289978 113.839996 L 531.289978 114.790009 Z"
      />
      <path
        id="path229"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 116.950012 L 530.190002 117.450012 L 530.190002 116.519989 L 531.289978 115.98999 L 531.289978 116.950012 Z"
      />
      <path
        id="path230"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 119.119995 L 530.190002 119.600006 L 530.190002 118.649994 L 531.289978 118.140015 L 531.289978 119.119995 Z"
      />
      <path
        id="path231"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 121.279999 L 530.190002 121.75 L 530.190002 120.779999 L 531.289978 120.279999 L 531.289978 121.279999 Z"
      />
      <path
        id="path232"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 123.450012 L 530.190002 123.899994 L 530.190002 122.910004 L 531.289978 122.429993 L 531.289978 123.450012 Z"
      />
      <path
        id="path233"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 125.609985 L 530.190002 126.040009 L 530.190002 125.029999 L 531.289978 124.580017 L 531.289978 125.609985 Z"
      />
      <path
        id="path234"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 127.779999 L 530.200012 128.190002 L 530.200012 127.160004 L 531.289978 126.720001 L 531.289978 127.779999 Z"
      />
      <path
        id="path235"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 129.940002 L 530.200012 130.339996 L 530.200012 129.289978 L 531.289978 128.869995 L 531.289978 129.940002 Z"
      />
      <path
        id="path236"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 134.279999 L 530.200012 134.640015 L 530.200012 133.549988 L 531.289978 133.160004 L 531.289978 134.279999 Z"
      />
      <path
        id="path237"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 136.440002 L 530.200012 136.789978 L 530.200012 135.679993 L 531.289978 135.309998 L 531.289978 136.440002 Z"
      />
      <path
        id="path238"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 138.609985 L 530.200012 138.940002 L 530.200012 137.809998 L 531.289978 137.460022 L 531.289978 138.609985 Z"
      />
      <path
        id="path239"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 140.77002 L 530.200012 141.080017 L 530.200012 139.940002 L 531.289978 139.600006 L 531.289978 140.77002 Z"
      />
      <path
        id="path240"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 142.940002 L 530.200012 143.22998 L 530.200012 142.070007 L 531.289978 141.75 L 531.289978 142.940002 Z"
      />
      <path
        id="path241"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 147.27002 L 530.200012 147.529999 L 530.200012 146.330017 L 531.289978 146.039978 L 531.289978 147.27002 Z"
      />
      <path
        id="path242"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 149.429993 L 530.200012 149.679993 L 530.200012 148.450012 L 531.289978 148.190002 L 531.289978 149.429993 Z"
      />
      <path
        id="path243"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 151.600006 L 530.200012 151.830017 L 530.200012 150.580017 L 531.289978 150.339996 L 531.289978 151.600006 Z"
      />
      <path
        id="path244"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 153.76001 L 530.200012 153.97998 L 530.200012 152.710022 L 531.289978 152.47998 L 531.289978 153.76001 Z"
      />
      <path
        id="path245"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 155.929993 L 530.200012 156.130005 L 530.200012 154.839996 L 531.289978 154.630005 L 531.289978 155.929993 Z"
      />
      <path
        id="path246"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 160.26001 L 530.210022 160.419983 L 530.210022 159.100006 L 531.289978 158.919983 L 531.289978 160.26001 Z"
      />
      <path
        id="path247"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 166.75 L 530.210022 166.869995 L 530.210022 165.48999 L 531.289978 165.359985 L 531.289978 166.75 Z"
      />
      <path
        id="path248"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 173.25 L 530.210022 173.320007 L 530.210022 171.869995 L 531.289978 171.799988 L 531.289978 173.25 Z"
      />
      <path
        id="path249"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 179.75 L 530.210022 179.76001 L 530.210022 178.26001 L 531.289978 178.23999 L 531.289978 179.75 Z"
      />
      <path
        id="path250"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 186.419983 L 530.210022 186.440002 L 530.210022 184.940002 L 531.289978 184.919983 L 531.289978 186.419983 Z"
      />
      <path
        id="path251"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 190.899994 L 530.210022 190.910004 L 530.210022 189.410004 L 531.289978 189.399994 L 531.289978 190.899994 Z"
      />
      <path
        id="path252"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 197.669983 L 530.210022 197.690002 L 530.210022 196.190002 L 531.289978 196.169983 L 531.289978 197.669983 Z"
      />
      <path
        id="path253"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 199.929993 L 530.210022 199.950012 L 530.210022 198.450012 L 531.289978 198.429993 L 531.289978 199.929993 Z"
      />
      <path
        id="path254"
        fill="#cecece"
        stroke="none"
        d="M 531.849976 105.019989 L 532.960022 104.399994 L 532.960022 105.269989 L 531.849976 105.850006 L 531.849976 105.019989 Z"
      />
      <path
        id="path255"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 107.459991 L 531.849976 108.029999 L 531.849976 107.169983 L 532.960022 106.580017 L 532.960022 107.459991 Z"
      />
      <path
        id="path256"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 109.649994 L 531.849976 110.200012 L 531.849976 109.330017 L 532.960022 108.75 L 532.960022 109.649994 Z"
      />
      <path
        id="path257"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 111.839996 L 531.859985 112.369995 L 531.859985 111.480011 L 532.960022 110.919983 L 532.960022 111.839996 Z"
      />
      <path
        id="path258"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 114.029999 L 531.859985 114.549988 L 531.859985 113.630005 L 532.960022 113.089996 L 532.960022 114.029999 Z"
      />
      <path
        id="path259"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 116.220001 L 531.859985 116.720001 L 531.859985 115.790009 L 532.960022 115.26001 L 532.960022 116.220001 Z"
      />
      <path
        id="path260"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 118.410004 L 531.859985 118.890015 L 531.859985 117.940002 L 532.960022 117.429993 L 532.960022 118.410004 Z"
      />
      <path
        id="path261"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 120.600006 L 531.859985 121.059998 L 531.859985 120.089996 L 532.960022 119.600006 L 532.960022 120.600006 Z"
      />
      <path
        id="path262"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 122.790009 L 531.859985 123.23999 L 531.859985 122.25 L 532.960022 121.769989 L 532.960022 122.790009 Z"
      />
      <path
        id="path263"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 124.980011 L 531.859985 125.410004 L 531.859985 124.399994 L 532.960022 123.940002 L 532.960022 124.980011 Z"
      />
      <path
        id="path264"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 127.169983 L 531.859985 127.580017 L 531.859985 126.549988 L 532.960022 126.109985 L 532.960022 127.169983 Z"
      />
      <path
        id="path265"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 131.549988 L 531.859985 131.929993 L 531.859985 130.859985 L 532.960022 130.460022 L 532.960022 131.549988 Z"
      />
      <path
        id="path266"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 135.929993 L 531.859985 136.279999 L 531.859985 135.169983 L 532.960022 134.799988 L 532.960022 135.929993 Z"
      />
      <path
        id="path267"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 138.119995 L 531.859985 138.450012 L 531.859985 137.320007 L 532.960022 136.970001 L 532.960022 138.119995 Z"
      />
      <path
        id="path268"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 140.309998 L 531.859985 140.619995 L 531.859985 139.47998 L 532.960022 139.140015 L 532.960022 140.309998 Z"
      />
      <path
        id="path269"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 142.5 L 531.859985 142.789978 L 531.859985 141.630005 L 532.960022 141.309998 L 532.960022 142.5 Z"
      />
      <path
        id="path270"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 149.070007 L 531.859985 149.309998 L 531.859985 148.089996 L 532.960022 147.820007 L 532.960022 149.070007 Z"
      />
      <path
        id="path271"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 151.26001 L 531.859985 151.48999 L 531.859985 150.23999 L 532.960022 150 L 532.960022 151.26001 Z"
      />
      <path
        id="path272"
        fill="#cecece"
        stroke="none"
        d="M 532.960022 153.450012 L 531.859985 153.660004 L 531.859985 152.399994 L 532.960022 152.169983 L 532.960022 153.450012 Z"
      />
      <path
        id="path273"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 155.630005 L 531.859985 155.830017 L 531.859985 154.549988 L 532.950012 154.339996 L 532.950012 155.630005 Z"
      />
      <path
        id="path274"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 160.01001 L 531.869995 160.179993 L 531.869995 158.859985 L 532.950012 158.679993 L 532.950012 160.01001 Z"
      />
      <path
        id="path275"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 164.390015 L 531.869995 164.529999 L 531.869995 163.160004 L 532.950012 163.02002 L 532.950012 164.390015 Z"
      />
      <path
        id="path276"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 168.77002 L 531.869995 168.869995 L 531.869995 167.470001 L 532.950012 167.359985 L 532.950012 168.77002 Z"
      />
      <path
        id="path277"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 170.960022 L 531.869995 171.039978 L 531.869995 169.619995 L 532.950012 169.529999 L 532.950012 170.960022 Z"
      />
      <path
        id="path278"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 175.339996 L 531.869995 175.390015 L 531.869995 173.929993 L 532.950012 173.880005 L 532.950012 175.339996 Z"
      />
      <path
        id="path279"
        fill="#cecece"
        stroke="none"
        d="M 533.549988 104.190002 L 534.659973 103.570007 L 534.659973 104.440002 L 533.549988 105.019989 L 533.549988 104.190002 Z"
      />
      <path
        id="path280"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 106.660004 L 533.559998 107.220001 L 533.559998 106.369995 L 534.659973 105.769989 L 534.659973 106.660004 Z"
      />
      <path
        id="path281"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 111.080017 L 533.559998 111.609985 L 533.559998 110.720001 L 534.659973 110.160004 L 534.659973 111.080017 Z"
      />
      <path
        id="path282"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 113.299988 L 533.559998 113.809998 L 533.559998 112.899994 L 534.659973 112.350006 L 534.659973 113.299988 Z"
      />
      <path
        id="path283"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 115.51001 L 533.559998 116.01001 L 533.559998 115.070007 L 534.659973 114.549988 L 534.659973 115.51001 Z"
      />
      <path
        id="path284"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 117.720001 L 533.559998 118.200012 L 533.559998 117.25 L 534.659973 116.73999 L 534.659973 117.720001 Z"
      />
      <path
        id="path285"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 122.149994 L 533.559998 122.600006 L 533.559998 121.609985 L 534.659973 121.130005 L 534.659973 122.149994 Z"
      />
      <path
        id="path286"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 124.359985 L 533.559998 124.790009 L 533.559998 123.779999 L 534.659973 123.320007 L 534.659973 124.359985 Z"
      />
      <path
        id="path287"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 126.580017 L 533.559998 126.98999 L 533.559998 125.959991 L 534.659973 125.519989 L 534.659973 126.580017 Z"
      />
      <path
        id="path288"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 128.789978 L 533.559998 129.190002 L 533.559998 128.140015 L 534.659973 127.709991 L 534.659973 128.789978 Z"
      />
      <path
        id="path289"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 131 L 533.559998 131.380005 L 533.559998 130.309998 L 534.659973 129.910004 L 534.659973 131 Z"
      />
      <path
        id="path290"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 133.220001 L 533.570007 133.580017 L 533.570007 132.48999 L 534.659973 132.100006 L 534.659973 133.220001 Z"
      />
      <path
        id="path291"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 135.429993 L 533.570007 135.779999 L 533.570007 134.669983 L 534.659973 134.299988 L 534.659973 135.429993 Z"
      />
      <path
        id="path292"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 137.640015 L 533.570007 137.970001 L 533.570007 136.850006 L 534.659973 136.48999 L 534.659973 137.640015 Z"
      />
      <path
        id="path293"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 142.070007 L 533.570007 142.369995 L 533.570007 141.200012 L 534.659973 140.880005 L 534.659973 142.070007 Z"
      />
      <path
        id="path294"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 144.279999 L 533.570007 144.559998 L 533.570007 143.380005 L 534.659973 143.080017 L 534.659973 144.279999 Z"
      />
      <path
        id="path295"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 146.5 L 533.570007 146.76001 L 533.570007 145.549988 L 534.659973 145.27002 L 534.659973 146.5 Z"
      />
      <path
        id="path296"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 148.710022 L 533.570007 148.960022 L 533.570007 147.72998 L 534.659973 147.470001 L 534.659973 148.710022 Z"
      />
      <path
        id="path297"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 150.919983 L 533.570007 151.149994 L 533.570007 149.910004 L 534.659973 149.660004 L 534.659973 150.919983 Z"
      />
      <path
        id="path298"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 153.140015 L 533.570007 153.350006 L 533.570007 152.089996 L 534.659973 151.859985 L 534.659973 153.140015 Z"
      />
      <path
        id="path299"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 157.559998 L 533.580017 157.73999 L 533.580017 156.440002 L 534.659973 156.25 L 534.659973 157.559998 Z"
      />
      <path
        id="path300"
        fill="#cecece"
        stroke="none"
        d="M 534.659973 159.779999 L 533.580017 159.940002 L 533.580017 158.619995 L 534.659973 158.440002 L 534.659973 159.779999 Z"
      />
      <path
        id="path301"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 164.200012 L 533.580017 164.339996 L 533.580017 162.970001 L 534.669983 162.830017 L 534.669983 164.200012 Z"
      />
      <path
        id="path302"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 168.630005 L 533.580017 168.72998 L 533.580017 167.330017 L 534.669983 167.220001 L 534.669983 168.630005 Z"
      />
      <path
        id="path303"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 170.839996 L 533.580017 170.929993 L 533.580017 169.5 L 534.669983 169.419983 L 534.669983 170.839996 Z"
      />
      <path
        id="path304"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 173.059998 L 533.580017 173.119995 L 533.580017 171.679993 L 534.669983 171.609985 L 534.669983 173.059998 Z"
      />
      <path
        id="path305"
        fill="#cecece"
        stroke="none"
        d="M 534.650024 176.529999 L 533.570007 176.580017 L 533.570007 175.119995 L 534.650024 175.070007 L 534.650024 176.529999 Z"
      />
      <path
        id="path306"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 177.47998 L 533.580017 177.52002 L 533.580017 176.039978 L 534.669983 176 L 534.669983 177.47998 Z"
      />
      <path
        id="path307"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 180.390015 L 533.590027 180.390015 L 533.590027 181.910004 L 534.669983 181.910004 L 534.669983 180.390015 Z"
      />
      <path
        id="path308"
        fill="#cecece"
        stroke="none"
        d="M 535.320007 103.350006 L 536.440002 102.730011 L 536.440002 103.600006 L 535.320007 104.179993 L 535.320007 103.350006 Z"
      />
      <path
        id="path309"
        fill="#cecece"
        stroke="none"
        d="M 536.440002 105.839996 L 535.320007 106.410004 L 535.320007 105.549988 L 536.440002 104.950012 L 536.440002 105.839996 Z"
      />
      <path
        id="path310"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 108.080017 L 535.320007 108.630005 L 535.320007 107.75 L 536.429993 107.160004 L 536.429993 108.080017 Z"
      />
      <path
        id="path311"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 110.309998 L 535.320007 110.850006 L 535.320007 109.950012 L 536.429993 109.380005 L 536.429993 110.309998 Z"
      />
      <path
        id="path312"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 112.549988 L 535.320007 113.070007 L 535.320007 112.149994 L 536.429993 111.600006 L 536.429993 112.549988 Z"
      />
      <path
        id="path313"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 114.790009 L 535.320007 115.290009 L 535.320007 114.350006 L 536.429993 113.820007 L 536.429993 114.790009 Z"
      />
      <path
        id="path314"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 117.029999 L 535.320007 117.51001 L 535.320007 116.549988 L 536.429993 116.040009 L 536.429993 117.029999 Z"
      />
      <path
        id="path315"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 119.26001 L 535.320007 119.730011 L 535.320007 118.76001 L 536.429993 118.26001 L 536.429993 119.26001 Z"
      />
      <path
        id="path316"
        fill="#cecece"
        stroke="none"
        d="M 536.419983 121.5 L 535.320007 121.950012 L 535.320007 120.959991 L 536.419983 120.480011 L 536.419983 121.5 Z"
      />
      <path
        id="path317"
        fill="#cecece"
        stroke="none"
        d="M 536.419983 123.73999 L 535.320007 124.169983 L 535.320007 123.160004 L 536.419983 122.700012 L 536.419983 123.73999 Z"
      />
      <path
        id="path318"
        fill="#cecece"
        stroke="none"
        d="M 536.419983 125.980011 L 535.320007 126.390015 L 535.320007 125.359985 L 536.419983 124.919983 L 536.419983 125.980011 Z"
      />
      <path
        id="path319"
        fill="#cecece"
        stroke="none"
        d="M 536.419983 128.210022 L 535.320007 128.609985 L 535.320007 127.559998 L 536.419983 127.130005 L 536.419983 128.210022 Z"
      />
      <path
        id="path320"
        fill="#cecece"
        stroke="none"
        d="M 536.419983 130.450012 L 535.320007 130.830017 L 535.320007 129.76001 L 536.419983 129.350006 L 536.419983 130.450012 Z"
      />
      <path
        id="path321"
        fill="#cecece"
        stroke="none"
        d="M 536.419983 132.690002 L 535.309998 133.049988 L 535.309998 131.960022 L 536.419983 131.570007 L 536.419983 132.690002 Z"
      />
      <path
        id="path322"
        fill="#cecece"
        stroke="none"
        d="M 536.409973 134.929993 L 535.309998 135.27002 L 535.309998 134.160004 L 536.409973 133.789978 L 536.409973 134.929993 Z"
      />
      <path
        id="path323"
        fill="#cecece"
        stroke="none"
        d="M 536.409973 137.160004 L 535.309998 137.5 L 535.309998 136.369995 L 536.409973 136.01001 L 536.409973 137.160004 Z"
      />
      <path
        id="path324"
        fill="#cecece"
        stroke="none"
        d="M 536.409973 139.399994 L 535.309998 139.720001 L 535.309998 138.570007 L 536.409973 138.22998 L 536.409973 139.399994 Z"
      />
      <path
        id="path325"
        fill="#cecece"
        stroke="none"
        d="M 536.409973 141.640015 L 535.309998 141.940002 L 535.309998 140.77002 L 536.409973 140.450012 L 536.409973 141.640015 Z"
      />
      <path
        id="path326"
        fill="#cecece"
        stroke="none"
        d="M 536.409973 146.109985 L 535.309998 146.380005 L 535.309998 145.169983 L 536.409973 144.890015 L 536.409973 146.109985 Z"
      />
      <path
        id="path327"
        fill="#cecece"
        stroke="none"
        d="M 536.400024 148.350006 L 535.309998 148.600006 L 535.309998 147.369995 L 536.400024 147.109985 L 536.400024 148.350006 Z"
      />
      <path
        id="path328"
        fill="#cecece"
        stroke="none"
        d="M 536.400024 150.589996 L 535.309998 150.820007 L 535.309998 149.570007 L 536.400024 149.320007 L 536.400024 150.589996 Z"
      />
      <path
        id="path329"
        fill="#cecece"
        stroke="none"
        d="M 536.400024 152.820007 L 535.309998 153.039978 L 535.309998 151.77002 L 536.400024 151.539978 L 536.400024 152.820007 Z"
      />
      <path
        id="path330"
        fill="#cecece"
        stroke="none"
        d="M 536.400024 155.059998 L 535.309998 155.26001 L 535.309998 153.97998 L 536.400024 153.76001 L 536.400024 155.059998 Z"
      />
      <path
        id="path331"
        fill="#cecece"
        stroke="none"
        d="M 536.400024 157.299988 L 535.309998 157.47998 L 535.309998 156.179993 L 536.400024 155.97998 L 536.400024 157.299988 Z"
      />
      <path
        id="path332"
        fill="#cecece"
        stroke="none"
        d="M 536.390015 161.77002 L 535.309998 161.919983 L 535.309998 160.580017 L 536.390015 160.419983 L 536.390015 161.77002 Z"
      />
      <path
        id="path333"
        fill="#cecece"
        stroke="none"
        d="M 536.390015 164.01001 L 535.309998 164.140015 L 535.309998 162.779999 L 536.390015 162.640015 L 536.390015 164.01001 Z"
      />
      <path
        id="path334"
        fill="#cecece"
        stroke="none"
        d="M 536.390015 166.25 L 535.309998 166.359985 L 535.309998 164.97998 L 536.390015 164.859985 L 536.390015 166.25 Z"
      />
      <path
        id="path335"
        fill="#cecece"
        stroke="none"
        d="M 536.390015 170.720001 L 535.299988 170.809998 L 535.299988 169.380005 L 536.390015 169.289978 L 536.390015 170.720001 Z"
      />
      <path
        id="path336"
        fill="#cecece"
        stroke="none"
        d="M 536.390015 175.200012 L 535.299988 175.25 L 535.299988 173.789978 L 536.390015 173.72998 L 536.390015 175.200012 Z"
      />
      <path
        id="path337"
        fill="#cecece"
        stroke="none"
        d="M 549.23999 102.799988 L 550.719971 103.390015 L 550.719971 102.26001 L 549.23999 101.690002 L 549.23999 102.799988 Z"
      />
      <path
        id="path338"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 105.630005 L 549.23999 105.059998 L 549.23999 103.940002 L 550.719971 104.48999 L 550.719971 105.630005 Z"
      />
      <path
        id="path339"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 107.880005 L 549.23999 107.320007 L 549.23999 106.190002 L 550.719971 106.730011 L 550.719971 107.880005 Z"
      />
      <path
        id="path340"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 110.119995 L 549.23999 109.580017 L 549.23999 108.440002 L 550.719971 108.959991 L 550.719971 110.119995 Z"
      />
      <path
        id="path341"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 112.359985 L 549.23999 111.839996 L 549.23999 110.679993 L 550.719971 111.190002 L 550.719971 112.359985 Z"
      />
      <path
        id="path342"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 114.609985 L 549.23999 114.100006 L 549.23999 112.929993 L 550.719971 113.419983 L 550.719971 114.609985 Z"
      />
      <path
        id="path343"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 116.850006 L 549.23999 116.359985 L 549.23999 115.179993 L 550.719971 115.660004 L 550.719971 116.850006 Z"
      />
      <path
        id="path344"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 119.089996 L 549.23999 118.619995 L 549.23999 117.429993 L 550.719971 117.890015 L 550.719971 119.089996 Z"
      />
      <path
        id="path345"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 121.339996 L 549.22998 120.880005 L 549.22998 119.679993 L 550.719971 120.119995 L 550.719971 121.339996 Z"
      />
      <path
        id="path346"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 123.580017 L 549.22998 123.140015 L 549.22998 121.929993 L 550.719971 122.350006 L 550.719971 123.580017 Z"
      />
      <path
        id="path347"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 125.830017 L 549.22998 125.399994 L 549.22998 124.179993 L 550.719971 124.589996 L 550.719971 125.830017 Z"
      />
      <path
        id="path348"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 128.070007 L 549.22998 127.660004 L 549.22998 126.419983 L 550.719971 126.820007 L 550.719971 128.070007 Z"
      />
      <path
        id="path349"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 130.309998 L 549.22998 129.919983 L 549.22998 128.669983 L 550.719971 129.049988 L 550.719971 130.309998 Z"
      />
      <path
        id="path350"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 132.549988 L 549.22998 132.179993 L 549.22998 130.919983 L 550.719971 131.279999 L 550.719971 132.549988 Z"
      />
      <path
        id="path351"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 134.799988 L 549.22998 134.440002 L 549.22998 133.169983 L 550.719971 133.51001 L 550.719971 134.799988 Z"
      />
      <path
        id="path352"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 139.289978 L 549.22998 138.960022 L 549.22998 137.669983 L 550.719971 137.97998 L 550.719971 139.289978 Z"
      />
      <path
        id="path353"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 141.529999 L 549.22998 141.220001 L 549.22998 139.919983 L 550.719971 140.210022 L 550.719971 141.529999 Z"
      />
      <path
        id="path354"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 143.77002 L 549.219971 143.47998 L 549.219971 142.160004 L 550.719971 142.440002 L 550.719971 143.77002 Z"
      />
      <path
        id="path355"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 146.02002 L 549.219971 145.73999 L 549.219971 144.410004 L 550.719971 144.669983 L 550.719971 146.02002 Z"
      />
      <path
        id="path356"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 148.26001 L 549.219971 148 L 549.219971 146.660004 L 550.719971 146.910004 L 550.719971 148.26001 Z"
      />
      <path
        id="path357"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 150.5 L 549.219971 150.26001 L 549.219971 148.910004 L 550.719971 149.140015 L 550.719971 150.5 Z"
      />
      <path
        id="path358"
        fill="#cecece"
        stroke="none"
        d="M 550.719971 152.75 L 549.219971 152.52002 L 549.219971 151.160004 L 550.719971 151.369995 L 550.719971 152.75 Z"
      />
      <path
        id="path359"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 157.22998 L 549.219971 157.049988 L 549.219971 155.660004 L 550.72998 155.839996 L 550.72998 157.22998 Z"
      />
      <path
        id="path360"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 159.47998 L 549.219971 159.309998 L 549.219971 157.899994 L 550.72998 158.070007 L 550.72998 159.47998 Z"
      />
      <path
        id="path361"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 161.720001 L 549.219971 161.570007 L 549.219971 160.149994 L 550.72998 160.299988 L 550.72998 161.720001 Z"
      />
      <path
        id="path362"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 163.960022 L 549.219971 163.830017 L 549.219971 162.399994 L 550.72998 162.529999 L 550.72998 163.960022 Z"
      />
      <path
        id="path363"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 166.210022 L 549.210022 166.089996 L 549.210022 164.649994 L 550.72998 164.76001 L 550.72998 166.210022 Z"
      />
      <path
        id="path364"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 168.450012 L 549.210022 168.350006 L 549.210022 166.899994 L 550.72998 167 L 550.72998 168.450012 Z"
      />
      <path
        id="path365"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 172.940002 L 549.210022 172.869995 L 549.210022 171.399994 L 550.72998 171.460022 L 550.72998 172.940002 Z"
      />
      <path
        id="path366"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 175.179993 L 549.210022 175.130005 L 549.210022 173.640015 L 550.72998 173.690002 L 550.72998 175.179993 Z"
      />
      <path
        id="path367"
        fill="#cecece"
        stroke="none"
        d="M 550.72998 179.669983 L 549.210022 179.649994 L 549.210022 178.140015 L 550.72998 178.160004 L 550.72998 179.669983 Z"
      />
      <path
        id="path368"
        fill="#cecece"
        stroke="none"
        d="M 551.450012 103.669983 L 552.690002 104.309998 L 552.690002 103.290009 L 551.450012 102.589996 L 551.450012 103.669983 Z"
      />
      <path
        id="path369"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 106.529999 L 551.440002 105.910004 L 551.440002 104.809998 L 552.690002 105.48999 L 552.690002 106.529999 Z"
      />
      <path
        id="path370"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 108.75 L 551.440002 108.140015 L 551.440002 107.029999 L 552.690002 107.690002 L 552.690002 108.75 Z"
      />
      <path
        id="path371"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 110.970001 L 551.440002 110.380005 L 551.440002 109.25 L 552.690002 109.899994 L 552.690002 110.970001 Z"
      />
      <path
        id="path372"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 113.179993 L 551.440002 112.609985 L 551.440002 111.480011 L 552.690002 112.100006 L 552.690002 113.179993 Z"
      />
      <path
        id="path373"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 115.399994 L 551.440002 114.850006 L 551.440002 113.700012 L 552.690002 114.299988 L 552.690002 115.399994 Z"
      />
      <path
        id="path374"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 117.619995 L 551.429993 117.080017 L 551.429993 115.919983 L 552.690002 116.51001 L 552.690002 117.619995 Z"
      />
      <path
        id="path375"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 119.830017 L 551.429993 119.320007 L 551.429993 118.149994 L 552.690002 118.709991 L 552.690002 119.830017 Z"
      />
      <path
        id="path376"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 122.049988 L 551.429993 121.549988 L 551.429993 120.369995 L 552.690002 120.910004 L 552.690002 122.049988 Z"
      />
      <path
        id="path377"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 124.269989 L 551.429993 123.790009 L 551.429993 122.589996 L 552.690002 123.109985 L 552.690002 124.269989 Z"
      />
      <path
        id="path378"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 126.480011 L 551.429993 126.019989 L 551.429993 124.820007 L 552.690002 125.320007 L 552.690002 126.480011 Z"
      />
      <path
        id="path379"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 133.140015 L 551.419983 132.72998 L 551.419983 131.47998 L 552.690002 131.929993 L 552.690002 133.140015 Z"
      />
      <path
        id="path380"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 135.350006 L 551.419983 134.970001 L 551.419983 133.710022 L 552.690002 134.130005 L 552.690002 135.350006 Z"
      />
      <path
        id="path381"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 137.570007 L 551.419983 137.200012 L 551.419983 135.929993 L 552.690002 136.330017 L 552.690002 137.570007 Z"
      />
      <path
        id="path382"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 139.789978 L 551.419983 139.440002 L 551.419983 138.149994 L 552.690002 138.529999 L 552.690002 139.789978 Z"
      />
      <path
        id="path383"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 142 L 551.419983 141.669983 L 551.419983 140.380005 L 552.690002 140.73999 L 552.690002 142 Z"
      />
      <path
        id="path384"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 144.220001 L 551.409973 143.910004 L 551.409973 142.600006 L 552.690002 142.940002 L 552.690002 144.220001 Z"
      />
      <path
        id="path385"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 146.440002 L 551.409973 146.140015 L 551.409973 144.820007 L 552.690002 145.140015 L 552.690002 146.440002 Z"
      />
      <path
        id="path386"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 150.869995 L 551.409973 150.609985 L 551.409973 149.27002 L 552.690002 149.549988 L 552.690002 150.869995 Z"
      />
      <path
        id="path387"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 155.309998 L 551.409973 155.080017 L 551.409973 153.710022 L 552.690002 153.960022 L 552.690002 155.309998 Z"
      />
      <path
        id="path388"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 159.73999 L 551.400024 159.559998 L 551.400024 158.160004 L 552.690002 158.359985 L 552.690002 159.73999 Z"
      />
      <path
        id="path389"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 164.169983 L 551.400024 164.029999 L 551.400024 162.609985 L 552.690002 162.77002 L 552.690002 164.169983 Z"
      />
      <path
        id="path390"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 166.390015 L 551.400024 166.26001 L 551.400024 164.830017 L 552.690002 164.970001 L 552.690002 166.390015 Z"
      />
      <path
        id="path391"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 168.609985 L 551.390015 168.5 L 551.390015 167.049988 L 552.690002 167.169983 L 552.690002 168.609985 Z"
      />
      <path
        id="path392"
        fill="#cecece"
        stroke="none"
        d="M 552.710022 170.77002 L 551.419983 170.679993 L 551.419983 169.22998 L 552.710022 169.330017 L 552.710022 170.77002 Z"
      />
      <path
        id="path393"
        fill="#cecece"
        stroke="none"
        d="M 552.690002 173.039978 L 551.390015 172.970001 L 551.390015 171.5 L 552.690002 171.580017 L 552.690002 173.039978 Z"
      />
      <path
        id="path394"
        fill="#cecece"
        stroke="none"
        d="M 553.289978 104.609985 L 554.299988 105.26001 L 554.299988 104.309998 L 553.289978 103.640015 L 553.289978 104.609985 Z"
      />
      <path
        id="path395"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 107.450012 L 553.289978 106.820007 L 553.289978 105.839996 L 554.299988 106.48999 L 554.299988 107.450012 Z"
      />
      <path
        id="path396"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 109.640015 L 553.289978 109.029999 L 553.289978 108.029999 L 554.299988 108.660004 L 554.299988 109.640015 Z"
      />
      <path
        id="path397"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 111.830017 L 553.289978 111.23999 L 553.289978 110.220001 L 554.299988 110.839996 L 554.299988 111.830017 Z"
      />
      <path
        id="path398"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 116.209991 L 553.289978 115.649994 L 553.289978 114.609985 L 554.299988 115.179993 L 554.299988 116.209991 Z"
      />
      <path
        id="path399"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 118.399994 L 553.289978 117.859985 L 553.289978 116.799988 L 554.299988 117.359985 L 554.299988 118.399994 Z"
      />
      <path
        id="path400"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 120.589996 L 553.289978 120.070007 L 553.289978 118.98999 L 554.299988 119.529999 L 554.299988 120.589996 Z"
      />
      <path
        id="path401"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 122.779999 L 553.289978 122.279999 L 553.289978 121.190002 L 554.299988 121.700012 L 554.299988 122.779999 Z"
      />
      <path
        id="path402"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 124.970001 L 553.289978 124.48999 L 553.289978 123.380005 L 554.299988 123.880005 L 554.299988 124.970001 Z"
      />
      <path
        id="path403"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 127.160004 L 553.289978 126.700012 L 553.289978 125.570007 L 554.299988 126.049988 L 554.299988 127.160004 Z"
      />
      <path
        id="path404"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 129.350006 L 553.289978 128.910004 L 553.289978 127.76001 L 554.299988 128.220001 L 554.299988 129.350006 Z"
      />
      <path
        id="path405"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 131.539978 L 553.289978 131.109985 L 553.289978 129.960022 L 554.299988 130.399994 L 554.299988 131.539978 Z"
      />
      <path
        id="path406"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 135.919983 L 553.289978 135.529999 L 553.289978 134.339996 L 554.299988 134.73999 L 554.299988 135.919983 Z"
      />
      <path
        id="path407"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 142.48999 L 553.289978 142.160004 L 553.289978 140.919983 L 554.299988 141.27002 L 554.299988 142.48999 Z"
      />
      <path
        id="path408"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 144.679993 L 553.289978 144.359985 L 553.289978 143.109985 L 554.299988 143.440002 L 554.299988 144.679993 Z"
      />
      <path
        id="path409"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 151.25 L 553.289978 150.98999 L 553.289978 149.690002 L 554.299988 149.960022 L 554.299988 151.25 Z"
      />
      <path
        id="path410"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 153.440002 L 553.289978 153.200012 L 553.289978 151.880005 L 554.299988 152.130005 L 554.299988 153.440002 Z"
      />
      <path
        id="path411"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 155.630005 L 553.289978 155.410004 L 553.289978 154.080017 L 554.299988 154.309998 L 554.299988 155.630005 Z"
      />
      <path
        id="path412"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 157.820007 L 553.289978 157.619995 L 553.289978 156.27002 L 554.299988 156.47998 L 554.299988 157.820007 Z"
      />
      <path
        id="path413"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 162.200012 L 553.289978 162.029999 L 553.289978 160.660004 L 554.299988 160.830017 L 554.299988 162.200012 Z"
      />
      <path
        id="path414"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 164.390015 L 553.289978 164.23999 L 553.289978 162.850006 L 554.299988 163 L 554.299988 164.390015 Z"
      />
      <path
        id="path415"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 173.149994 L 553.289978 173.080017 L 553.289978 171.619995 L 554.299988 171.700012 L 554.299988 173.149994 Z"
      />
      <path
        id="path416"
        fill="#cecece"
        stroke="none"
        d="M 554.299988 179.720001 L 553.289978 179.700012 L 553.289978 178.200012 L 554.299988 178.220001 L 554.299988 179.720001 Z"
      />
      <path
        id="path417"
        fill="#cecece"
        stroke="none"
        d="M 554.799988 105.5 L 555.640015 106.029999 L 555.640015 105.160004 L 554.799988 104.600006 L 554.799988 105.5 Z"
      />
      <path
        id="path418"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 108.200012 L 554.799988 107.679993 L 554.799988 106.769989 L 555.640015 107.309998 L 555.640015 108.200012 Z"
      />
      <path
        id="path419"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 110.369995 L 554.799988 109.869995 L 554.799988 108.929993 L 555.640015 109.459991 L 555.640015 110.369995 Z"
      />
      <path
        id="path420"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 112.540009 L 554.799988 112.049988 L 554.799988 111.100006 L 555.640015 111.609985 L 555.640015 112.540009 Z"
      />
      <path
        id="path421"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 114.709991 L 554.799988 114.230011 L 554.799988 113.269989 L 555.640015 113.76001 L 555.640015 114.709991 Z"
      />
      <path
        id="path422"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 116.869995 L 554.799988 116.419983 L 554.799988 115.429993 L 555.640015 115.910004 L 555.640015 116.869995 Z"
      />
      <path
        id="path423"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 119.040009 L 554.799988 118.600006 L 554.799988 117.600006 L 555.640015 118.059998 L 555.640015 119.040009 Z"
      />
      <path
        id="path424"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 121.209991 L 554.789978 120.779999 L 554.789978 119.76001 L 555.640015 120.209991 L 555.640015 121.209991 Z"
      />
      <path
        id="path425"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 123.380005 L 554.789978 122.970001 L 554.789978 121.929993 L 555.640015 122.359985 L 555.640015 123.380005 Z"
      />
      <path
        id="path426"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 125.540009 L 554.789978 125.149994 L 554.789978 124.089996 L 555.640015 124.5 L 555.640015 125.540009 Z"
      />
      <path
        id="path427"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 129.880005 L 554.789978 129.51001 L 554.789978 128.419983 L 555.640015 128.799988 L 555.640015 129.880005 Z"
      />
      <path
        id="path428"
        fill="#cecece"
        stroke="none"
        d="M 555.640015 132.049988 L 554.789978 131.700012 L 554.789978 130.589996 L 555.640015 130.950012 L 555.640015 132.049988 Z"
      />
      <path
        id="path429"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 136.380005 L 554.789978 136.059998 L 554.789978 134.919983 L 555.630005 135.25 L 555.630005 136.380005 Z"
      />
      <path
        id="path430"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 138.549988 L 554.780029 138.25 L 554.780029 137.080017 L 555.630005 137.399994 L 555.630005 138.549988 Z"
      />
      <path
        id="path431"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 140.720001 L 554.780029 140.429993 L 554.780029 139.25 L 555.630005 139.549988 L 555.630005 140.720001 Z"
      />
      <path
        id="path432"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 142.890015 L 554.780029 142.609985 L 554.780029 141.410004 L 555.630005 141.700012 L 555.630005 142.890015 Z"
      />
      <path
        id="path433"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 145.059998 L 554.780029 144.799988 L 554.780029 143.580017 L 555.630005 143.850006 L 555.630005 145.059998 Z"
      />
      <path
        id="path434"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 147.220001 L 554.780029 146.97998 L 554.780029 145.75 L 555.630005 146 L 555.630005 147.220001 Z"
      />
      <path
        id="path435"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 149.390015 L 554.780029 149.160004 L 554.780029 147.910004 L 555.630005 148.149994 L 555.630005 149.390015 Z"
      />
      <path
        id="path436"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 151.559998 L 554.780029 151.350006 L 554.780029 150.080017 L 555.630005 150.299988 L 555.630005 151.559998 Z"
      />
      <path
        id="path437"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 160.22998 L 554.77002 160.080017 L 554.77002 158.73999 L 555.630005 158.899994 L 555.630005 160.22998 Z"
      />
      <path
        id="path438"
        fill="#cecece"
        stroke="none"
        d="M 555.630005 162.399994 L 554.77002 162.26001 L 554.77002 160.899994 L 555.630005 161.049988 L 555.630005 162.399994 Z"
      />
      <path
        id="path439"
        fill="#cecece"
        stroke="none"
        d="M 555.619995 168.899994 L 554.77002 168.809998 L 554.77002 167.399994 L 555.619995 167.48999 L 555.619995 168.899994 Z"
      />
      <path
        id="path440"
        fill="#cecece"
        stroke="none"
        d="M 555.619995 171.070007 L 554.77002 170.98999 L 554.77002 169.559998 L 555.619995 169.640015 L 555.619995 171.070007 Z"
      />
      <path
        id="path441"
        fill="#cecece"
        stroke="none"
        d="M 555.619995 175.410004 L 554.76001 175.359985 L 554.76001 173.890015 L 555.619995 173.940002 L 555.619995 175.410004 Z"
      />
      <path
        id="path442"
        fill="#cecece"
        stroke="none"
        d="M 555.619995 180.390015 L 554.76001 180.390015 L 554.76001 181.910004 L 555.619995 181.910004 L 555.619995 180.390015 Z"
      />
      <path
        id="path443"
        fill="#cecece"
        stroke="none"
        d="M 556.179993 105.589996 L 556.73999 106.089996 L 556.73999 106.649994 L 556.179993 106.25 L 556.179993 105.589996 Z"
      />
      <path
        id="path444"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 108.799988 L 556.169983 108.419983 L 556.169983 107.720001 L 556.73999 108.209991 L 556.73999 108.799988 Z"
      />
      <path
        id="path445"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 110.950012 L 556.169983 110.580017 L 556.169983 109.859985 L 556.73999 110.330017 L 556.73999 110.950012 Z"
      />
      <path
        id="path446"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 113.100006 L 556.169983 112.73999 L 556.169983 112 L 556.73999 112.459991 L 556.73999 113.100006 Z"
      />
      <path
        id="path447"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 115.25 L 556.169983 114.899994 L 556.169983 114.140015 L 556.73999 114.580017 L 556.73999 115.25 Z"
      />
      <path
        id="path448"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 117.399994 L 556.169983 117.059998 L 556.169983 116.269989 L 556.73999 116.700012 L 556.73999 117.399994 Z"
      />
      <path
        id="path449"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 119.549988 L 556.169983 119.220001 L 556.169983 118.410004 L 556.73999 118.820007 L 556.73999 119.549988 Z"
      />
      <path
        id="path450"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 121.700012 L 556.159973 121.390015 L 556.159973 120.549988 L 556.73999 120.950012 L 556.73999 121.700012 Z"
      />
      <path
        id="path451"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 123.850006 L 556.159973 123.549988 L 556.159973 122.679993 L 556.73999 123.070007 L 556.73999 123.850006 Z"
      />
      <path
        id="path452"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 126 L 556.159973 125.709991 L 556.159973 124.820007 L 556.73999 125.190002 L 556.73999 126 Z"
      />
      <path
        id="path453"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 128.149994 L 556.159973 127.869995 L 556.159973 126.959991 L 556.73999 127.320007 L 556.73999 128.149994 Z"
      />
      <path
        id="path454"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 130.299988 L 556.159973 130.029999 L 556.159973 129.100006 L 556.73999 129.440002 L 556.73999 130.299988 Z"
      />
      <path
        id="path455"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 132.450012 L 556.159973 132.190002 L 556.159973 131.22998 L 556.73999 131.559998 L 556.73999 132.450012 Z"
      />
      <path
        id="path456"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 134.600006 L 556.159973 134.350006 L 556.159973 133.369995 L 556.73999 133.690002 L 556.73999 134.600006 Z"
      />
      <path
        id="path457"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 136.75 L 556.150024 136.52002 L 556.150024 135.51001 L 556.73999 135.809998 L 556.73999 136.75 Z"
      />
      <path
        id="path458"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 138.899994 L 556.150024 138.679993 L 556.150024 137.649994 L 556.73999 137.929993 L 556.73999 138.899994 Z"
      />
      <path
        id="path459"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 141.049988 L 556.150024 140.839996 L 556.150024 139.779999 L 556.73999 140.049988 L 556.73999 141.049988 Z"
      />
      <path
        id="path460"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 143.200012 L 556.150024 143 L 556.150024 141.919983 L 556.73999 142.179993 L 556.73999 143.200012 Z"
      />
      <path
        id="path461"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 147.5 L 556.150024 147.320007 L 556.150024 146.190002 L 556.73999 146.419983 L 556.73999 147.5 Z"
      />
      <path
        id="path462"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 149.649994 L 556.140015 149.48999 L 556.140015 148.330017 L 556.73999 148.549988 L 556.73999 149.649994 Z"
      />
      <path
        id="path463"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 151.809998 L 556.140015 151.649994 L 556.140015 150.470001 L 556.73999 150.669983 L 556.73999 151.809998 Z"
      />
      <path
        id="path464"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 153.960022 L 556.140015 153.809998 L 556.140015 152.609985 L 556.73999 152.789978 L 556.73999 153.960022 Z"
      />
      <path
        id="path465"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 156.109985 L 556.140015 155.970001 L 556.140015 154.73999 L 556.73999 154.910004 L 556.73999 156.109985 Z"
      />
      <path
        id="path466"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 160.410004 L 556.140015 160.289978 L 556.140015 159.02002 L 556.73999 159.160004 L 556.73999 160.410004 Z"
      />
      <path
        id="path467"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 162.559998 L 556.130005 162.460022 L 556.130005 161.149994 L 556.73999 161.279999 L 556.73999 162.559998 Z"
      />
      <path
        id="path468"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 166.859985 L 556.130005 166.779999 L 556.130005 165.429993 L 556.73999 165.529999 L 556.73999 166.859985 Z"
      />
      <path
        id="path469"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 171.160004 L 556.130005 171.100006 L 556.130005 169.700012 L 556.73999 169.779999 L 556.73999 171.160004 Z"
      />
      <path
        id="path470"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 173.359985 L 556.130005 173.299988 L 556.130005 171.910004 L 556.73999 171.97998 L 556.73999 173.359985 Z"
      />
      <path
        id="path471"
        fill="#cecece"
        stroke="none"
        d="M 555.619995 179.799988 L 554.76001 179.75 L 554.76001 178.289978 L 555.619995 178.330017 L 555.619995 179.799988 Z"
      />
      <path
        id="path472"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 177.75 L 556.130005 177.700012 L 556.130005 176.299988 L 556.73999 176.369995 L 556.73999 177.75 Z"
      />
      <path
        id="path473"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 181.880005 L 556.130005 181.820007 L 556.130005 180.419983 L 556.73999 180.48999 L 556.73999 181.880005 Z"
      />
      <path
        id="path474"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 186.839996 L 556.130005 186.789978 L 556.130005 185.390015 L 556.73999 185.460022 L 556.73999 186.839996 Z"
      />
      <path
        id="path475"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 189.049988 L 556.130005 188.98999 L 556.130005 187.600006 L 556.73999 187.669983 L 556.73999 189.049988 Z"
      />
      <path
        id="path476"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 193.710022 L 556.130005 193.649994 L 556.130005 192.25 L 556.73999 192.330017 L 556.73999 193.710022 Z"
      />
      <path
        id="path477"
        fill="#cecece"
        stroke="none"
        d="M 542.51001 101.089996 L 542.51001 102.119995 L 540.929993 102.299988 L 540.929993 101.320007 C 540.929993 101.320007 542.130005 101.140015 542.51001 101.089996 Z"
      />
      <path
        id="path478"
        fill="#cecece"
        stroke="none"
        d="M 542.51001 104.410004 L 540.940002 104.580017 L 540.940002 103.589996 C 540.940002 103.589996 542.140015 103.410004 542.51001 103.359985 L 542.51001 104.410004 Z"
      />
      <path
        id="path479"
        fill="#cecece"
        stroke="none"
        d="M 542.5 106.690002 L 540.929993 106.859985 L 540.929993 105.850006 C 540.929993 105.850006 542.140015 105.679993 542.5 105.630005 L 542.5 106.690002 Z"
      />
      <path
        id="path480"
        fill="#cecece"
        stroke="none"
        d="M 542.5 108.970001 L 540.929993 109.130005 L 540.929993 108.109985 C 540.929993 108.109985 542.150024 107.940002 542.5 107.899994 L 542.5 108.980011 L 542.5 108.970001 Z"
      />
      <path
        id="path481"
        fill="#cecece"
        stroke="none"
        d="M 542.5 111.25 L 540.940002 111.410004 L 540.940002 110.369995 C 540.940002 110.369995 542.169983 110.209991 542.5 110.160004 L 542.5 111.25 Z"
      />
      <path
        id="path482"
        fill="#cecece"
        stroke="none"
        d="M 542.5 113.529999 L 540.940002 113.679993 L 540.940002 112.619995 C 540.940002 112.619995 542.169983 112.459991 542.5 112.419983 L 542.5 113.519989 L 542.5 113.529999 Z"
      />
      <path
        id="path483"
        fill="#cecece"
        stroke="none"
        d="M 542.5 115.809998 L 540.940002 115.959991 L 540.940002 114.890015 C 540.940002 114.890015 542.179993 114.73999 542.5 114.700012 L 542.5 115.820007 L 542.5 115.809998 Z"
      />
      <path
        id="path484"
        fill="#cecece"
        stroke="none"
        d="M 542.5 118.080017 L 540.950012 118.220001 L 540.950012 117.130005 C 540.950012 117.130005 542.200012 116.980011 542.5 116.940002 L 542.5 118.070007 L 542.5 118.080017 Z"
      />
      <path
        id="path485"
        fill="#cecece"
        stroke="none"
        d="M 542.5 120.359985 L 540.950012 120.5 L 540.950012 119.399994 C 540.950012 119.399994 542.210022 119.26001 542.5 119.220001 L 542.5 120.369995 L 542.5 120.359985 Z"
      />
      <path
        id="path486"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 122.640015 L 540.940002 122.769989 L 540.940002 121.649994 C 540.940002 121.649994 542.210022 121.51001 542.48999 121.480011 L 542.48999 122.640015 Z"
      />
      <path
        id="path487"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 124.919983 L 540.940002 125.049988 L 540.940002 123.919983 C 540.940002 123.919983 542.210022 123.790009 542.48999 123.75 L 542.48999 124.919983 Z"
      />
      <path
        id="path488"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 127.200012 L 540.950012 127.320007 L 540.950012 126.169983 C 540.950012 126.169983 542.22998 126.040009 542.48999 126.01001 L 542.48999 127.200012 Z"
      />
      <path
        id="path489"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 129.47998 L 540.950012 129.600006 L 540.950012 128.440002 C 540.950012 128.440002 542.23999 128.320007 542.48999 128.289978 L 542.48999 129.48999 L 542.48999 129.47998 Z"
      />
      <path
        id="path490"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 131.76001 L 540.950012 131.869995 L 540.950012 130.690002 C 540.950012 130.690002 542.25 130.570007 542.48999 130.539978 L 542.48999 131.76001 Z"
      />
      <path
        id="path491"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 134.039978 L 540.960022 134.149994 L 540.960022 132.960022 C 540.960022 132.960022 542.27002 132.850006 542.48999 132.820007 L 542.48999 134.049988 L 542.48999 134.039978 Z"
      />
      <path
        id="path492"
        fill="#cecece"
        stroke="none"
        d="M 542.48999 136.320007 L 540.960022 136.419983 L 540.960022 135.210022 C 540.960022 135.210022 542.27002 135.109985 542.48999 135.080017 L 542.48999 136.320007 Z"
      />
      <path
        id="path493"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 138.600006 L 540.950012 138.700012 L 540.950012 137.470001 C 540.950012 137.470001 542.27002 137.369995 542.47998 137.339996 L 542.47998 138.600006 Z"
      />
      <path
        id="path494"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 140.880005 L 540.960022 140.970001 L 540.960022 139.72998 C 540.960022 139.72998 542.289978 139.640015 542.47998 139.609985 L 542.47998 140.880005 Z"
      />
      <path
        id="path495"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 143.160004 L 540.960022 143.25 L 540.960022 141.98999 C 540.960022 141.98999 542.299988 141.899994 542.47998 141.880005 L 542.47998 143.160004 Z"
      />
      <path
        id="path496"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 145.440002 L 540.960022 145.52002 L 540.960022 144.25 C 540.960022 144.25 542.299988 144.169983 542.47998 144.140015 L 542.47998 145.440002 Z"
      />
      <path
        id="path497"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 147.720001 L 540.960022 147.799988 L 540.960022 146.51001 C 540.960022 146.51001 542.309998 146.429993 542.47998 146.410004 L 542.47998 147.720001 Z"
      />
      <path
        id="path498"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 150 L 540.969971 150.070007 L 540.969971 148.77002 C 540.969971 148.77002 542.330017 148.700012 542.47998 148.679993 L 542.47998 150.01001 L 542.47998 150 Z"
      />
      <path
        id="path499"
        fill="#cecece"
        stroke="none"
        d="M 542.47998 152.279999 L 540.969971 152.350006 L 540.969971 151.029999 C 540.969971 151.029999 542.340027 150.960022 542.47998 150.940002 L 542.47998 152.279999 Z"
      />
      <path
        id="path500"
        fill="#cecece"
        stroke="none"
        d="M 542.469971 156.839996 L 540.969971 156.899994 L 540.969971 155.549988 C 540.969971 155.549988 542.349976 155.48999 542.469971 155.47998 L 542.469971 156.850006 L 542.469971 156.839996 Z"
      />
      <path
        id="path501"
        fill="#cecece"
        stroke="none"
        d="M 542.469971 159.109985 L 540.969971 159.160004 L 540.969971 157.789978 C 540.969971 157.789978 542.359985 157.73999 542.469971 157.720001 L 542.469971 159.100006 L 542.469971 159.109985 Z"
      />
      <path
        id="path502"
        fill="#cecece"
        stroke="none"
        d="M 542.469971 161.390015 L 540.969971 161.440002 L 540.969971 160.059998 C 540.969971 160.059998 542.369995 160.01001 542.469971 160 L 542.469971 161.399994 L 542.469971 161.390015 Z"
      />
      <path
        id="path503"
        fill="#cecece"
        stroke="none"
        d="M 542.469971 163.669983 L 540.97998 163.710022 L 540.97998 162.309998 C 540.97998 162.309998 542.390015 162.27002 542.469971 162.26001 L 542.469971 163.669983 Z"
      />
      <path
        id="path504"
        fill="#cecece"
        stroke="none"
        d="M 542.469971 165.950012 L 540.97998 165.98999 L 540.97998 164.580017 C 540.97998 164.580017 542.390015 164.539978 542.469971 164.529999 L 542.469971 165.950012 Z"
      />
      <path
        id="path505"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 170.51001 L 540.97998 170.539978 L 540.97998 169.100006 C 540.97998 169.100006 542.409973 169.070007 542.460022 169.070007 L 542.460022 170.52002 L 542.460022 170.51001 Z"
      />
      <path
        id="path506"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 175.070007 L 540.97998 175.089996 L 540.97998 173.619995 C 540.97998 173.619995 542.429993 173.600006 542.460022 173.600006 L 542.460022 175.080017 L 542.460022 175.070007 Z"
      />
      <path
        id="path507"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 179.630005 L 540.98999 179.630005 L 540.98999 178.130005 C 540.98999 178.130005 542.450012 178.130005 542.460022 178.130005 L 542.460022 179.640015 L 542.460022 179.630005 Z"
      />
      <path
        id="path508"
        fill="#cecece"
        stroke="none"
        d="M 543.450012 101.070007 C 543.450012 101.070007 544.840027 100.959991 545.48999 101.070007 L 545.48999 102.160004 L 543.450012 102.160004 L 543.450012 101.070007 Z"
      />
      <path
        id="path509"
        fill="#cecece"
        stroke="none"
        d="M 545.48999 104.440002 L 543.450012 104.440002 L 543.450012 103.330017 C 543.450012 103.330017 544.849976 103.220001 545.48999 103.330017 L 545.48999 104.440002 Z"
      />
      <path
        id="path510"
        fill="#cecece"
        stroke="none"
        d="M 545.48999 106.720001 L 543.460022 106.720001 L 543.460022 105.600006 C 543.460022 105.600006 544.880005 105.48999 545.48999 105.600006 L 545.48999 106.720001 Z"
      />
      <path
        id="path511"
        fill="#cecece"
        stroke="none"
        d="M 545.48999 109 L 543.460022 109 L 543.460022 107.869995 C 543.460022 107.869995 544.890015 107.769989 545.48999 107.869995 L 545.48999 109 Z"
      />
      <path
        id="path512"
        fill="#cecece"
        stroke="none"
        d="M 545.47998 111.279999 L 543.450012 111.279999 L 543.450012 110.140015 C 543.450012 110.140015 544.900024 110.040009 545.47998 110.140015 L 545.47998 111.279999 Z"
      />
      <path
        id="path513"
        fill="#cecece"
        stroke="none"
        d="M 545.47998 113.559998 L 543.460022 113.559998 L 543.460022 112.399994 C 543.460022 112.399994 544.919983 112.299988 545.47998 112.399994 L 545.47998 113.559998 Z"
      />
      <path
        id="path514"
        fill="#cecece"
        stroke="none"
        d="M 545.47998 118.109985 L 543.460022 118.109985 L 543.460022 116.929993 C 543.460022 116.929993 544.950012 116.839996 545.47998 116.929993 L 545.47998 118.109985 Z"
      />
      <path
        id="path515"
        fill="#cecece"
        stroke="none"
        d="M 545.47998 120.390015 L 543.460022 120.390015 L 543.460022 119.200012 C 543.460022 119.200012 544.969971 119.109985 545.47998 119.200012 L 545.47998 120.390015 Z"
      />
      <path
        id="path516"
        fill="#cecece"
        stroke="none"
        d="M 545.469971 122.669983 L 543.460022 122.669983 L 543.460022 121.470001 C 543.460022 121.470001 544.98999 121.390015 545.469971 121.470001 L 545.469971 122.669983 Z"
      />
      <path
        id="path517"
        fill="#cecece"
        stroke="none"
        d="M 545.469971 124.950012 L 543.460022 124.950012 L 543.460022 123.730011 C 543.460022 123.730011 545 123.649994 545.469971 123.730011 L 545.469971 124.950012 Z"
      />
      <path
        id="path518"
        fill="#cecece"
        stroke="none"
        d="M 545.469971 127.230011 L 543.460022 127.230011 L 543.460022 126 C 543.460022 126 545.02002 125.919983 545.469971 126 L 545.469971 127.230011 Z"
      />
      <path
        id="path519"
        fill="#cecece"
        stroke="none"
        d="M 545.469971 129.51001 L 543.469971 129.51001 L 543.469971 128.27002 C 543.469971 128.27002 545.039978 128.200012 545.469971 128.27002 L 545.469971 129.51001 Z"
      />
      <path
        id="path520"
        fill="#cecece"
        stroke="none"
        d="M 545.460022 134.059998 L 543.460022 134.059998 L 543.460022 132.799988 C 543.460022 132.799988 545.059998 132.72998 545.460022 132.799988 L 545.460022 134.059998 Z"
      />
      <path
        id="path521"
        fill="#cecece"
        stroke="none"
        d="M 545.460022 136.339996 L 543.469971 136.339996 L 543.469971 135.059998 C 543.469971 135.059998 545.090027 135 545.460022 135.059998 L 545.460022 136.339996 Z"
      />
      <path
        id="path522"
        fill="#cecece"
        stroke="none"
        d="M 545.460022 138.619995 L 543.469971 138.619995 L 543.469971 137.330017 C 543.469971 137.330017 545.099976 137.27002 545.460022 137.330017 L 545.460022 138.619995 Z"
      />
      <path
        id="path523"
        fill="#cecece"
        stroke="none"
        d="M 545.460022 140.899994 L 543.469971 140.899994 L 543.469971 139.600006 C 543.469971 139.600006 545.119995 139.539978 545.460022 139.600006 L 545.460022 140.899994 Z"
      />
      <path
        id="path524"
        fill="#cecece"
        stroke="none"
        d="M 545.460022 143.179993 L 543.47998 143.179993 L 543.47998 141.869995 C 543.47998 141.869995 545.140015 141.820007 545.460022 141.869995 L 545.460022 143.179993 Z"
      />
      <path
        id="path525"
        fill="#cecece"
        stroke="none"
        d="M 545.450012 145.460022 L 543.469971 145.460022 L 543.469971 144.130005 C 543.469971 144.130005 545.150024 144.080017 545.450012 144.130005 L 545.450012 145.460022 Z"
      />
      <path
        id="path526"
        fill="#cecece"
        stroke="none"
        d="M 545.450012 147.72998 L 543.469971 147.72998 L 543.469971 146.390015 C 543.469971 146.390015 545.169983 146.339996 545.450012 146.390015 L 545.450012 147.72998 Z"
      />
      <path
        id="path527"
        fill="#cecece"
        stroke="none"
        d="M 545.450012 150.01001 L 543.47998 150.01001 L 543.47998 148.660004 C 543.47998 148.660004 545.190002 148.609985 545.450012 148.660004 L 545.450012 150.01001 Z"
      />
      <path
        id="path528"
        fill="#cecece"
        stroke="none"
        d="M 545.450012 152.289978 L 543.47998 152.289978 L 543.47998 150.929993 C 543.47998 150.929993 545.210022 150.890015 545.450012 150.929993 L 545.450012 152.289978 Z"
      />
      <path
        id="path529"
        fill="#cecece"
        stroke="none"
        d="M 545.440002 154.570007 L 543.469971 154.570007 L 543.469971 153.200012 C 543.469971 153.200012 545.210022 153.160004 545.440002 153.200012 L 545.440002 154.570007 Z"
      />
      <path
        id="path530"
        fill="#cecece"
        stroke="none"
        d="M 545.440002 156.850006 L 543.47998 156.850006 L 543.47998 155.460022 C 543.47998 155.460022 545.23999 155.419983 545.440002 155.460022 L 545.440002 156.850006 Z"
      />
      <path
        id="path531"
        fill="#cecece"
        stroke="none"
        d="M 545.440002 159.130005 L 543.47998 159.130005 L 543.47998 157.72998 C 543.47998 157.72998 545.25 157.700012 545.440002 157.72998 L 545.440002 159.130005 Z"
      />
      <path
        id="path532"
        fill="#cecece"
        stroke="none"
        d="M 545.440002 163.679993 L 543.48999 163.679993 L 543.48999 162.26001 C 543.48999 162.26001 545.289978 162.22998 545.440002 162.26001 L 545.440002 163.679993 Z"
      />
      <path
        id="path533"
        fill="#cecece"
        stroke="none"
        d="M 545.429993 165.960022 L 543.47998 165.960022 L 543.47998 164.529999 C 543.47998 164.529999 545.299988 164.51001 545.429993 164.529999 L 545.429993 165.960022 Z"
      />
      <path
        id="path534"
        fill="#cecece"
        stroke="none"
        d="M 545.429993 170.52002 L 543.48999 170.52002 L 543.48999 169.059998 C 543.48999 169.059998 545.340027 169.039978 545.429993 169.059998 L 545.429993 170.52002 Z"
      />
      <path
        id="path535"
        fill="#cecece"
        stroke="none"
        d="M 545.429993 175.070007 L 543.48999 175.070007 L 543.48999 173.589996 C 543.48999 173.589996 545.369995 173.589996 545.429993 173.589996 L 545.429993 175.070007 Z"
      />
      <path
        id="path536"
        fill="#cecece"
        stroke="none"
        d="M 545.419983 179.630005 L 543.48999 179.630005 L 543.48999 178.119995 C 543.48999 178.119995 545.400024 178.119995 545.419983 178.119995 L 545.419983 179.630005 Z"
      />
      <path
        id="path537"
        fill="#cecece"
        stroke="none"
        d="M 545.419983 180.390015 L 543.48999 180.390015 L 543.48999 181.910004 L 545.419983 181.910004 L 545.419983 180.390015 Z"
      />
      <path
        id="path538"
        fill="#cecece"
        stroke="none"
        d="M 546.429993 101.130005 C 546.429993 101.130005 547.72998 101.279999 548.23999 101.48999 L 548.23999 102.540009 C 548.23999 102.540009 546.690002 102.200012 546.429993 102.169983 L 546.429993 101.140015 L 546.429993 101.130005 Z"
      />
      <path
        id="path539"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 104.809998 C 548.23999 104.809998 546.679993 104.480011 546.429993 104.450012 L 546.429993 103.399994 C 546.429993 103.399994 547.73999 103.540009 548.23999 103.75 L 548.23999 104.809998 Z"
      />
      <path
        id="path540"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 107.080017 C 548.23999 107.080017 546.669983 106.76001 546.429993 106.730011 L 546.429993 105.669983 C 546.429993 105.669983 547.76001 105.809998 548.23999 106.01001 L 548.23999 107.080017 Z"
      />
      <path
        id="path541"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 109.339996 C 548.23999 109.339996 546.659973 109.029999 546.429993 109 L 546.429993 107.919983 C 546.429993 107.919983 547.77002 108.049988 548.23999 108.25 L 548.23999 109.339996 Z"
      />
      <path
        id="path542"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 111.609985 C 548.23999 111.609985 546.659973 111.309998 546.429993 111.279999 L 546.429993 110.190002 C 546.429993 110.190002 547.789978 110.320007 548.23999 110.51001 L 548.23999 111.609985 Z"
      />
      <path
        id="path543"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 113.880005 C 548.23999 113.880005 546.650024 113.589996 546.429993 113.559998 L 546.429993 112.459991 C 546.429993 112.459991 547.799988 112.589996 548.23999 112.769989 L 548.23999 113.880005 Z"
      />
      <path
        id="path544"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 116.149994 C 548.23999 116.149994 546.640015 115.869995 546.429993 115.839996 L 546.429993 114.720001 C 546.429993 114.720001 547.809998 114.839996 548.23999 115.019989 L 548.23999 116.149994 Z"
      />
      <path
        id="path545"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 118.410004 C 548.23999 118.410004 546.630005 118.140015 546.429993 118.109985 L 546.429993 116.980011 C 546.429993 116.980011 547.830017 117.100006 548.23999 117.269989 L 548.23999 118.410004 Z"
      />
      <path
        id="path546"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 120.679993 C 548.23999 120.679993 546.630005 120.419983 546.429993 120.390015 L 546.429993 119.23999 C 546.429993 119.23999 547.840027 119.350006 548.23999 119.519989 L 548.23999 120.669983 L 548.23999 120.679993 Z"
      />
      <path
        id="path547"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 122.950012 C 548.23999 122.950012 546.619995 122.700012 546.429993 122.669983 L 546.429993 121.51001 C 546.429993 121.51001 547.859985 121.619995 548.23999 121.779999 L 548.23999 122.950012 Z"
      />
      <path
        id="path548"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 125.220001 C 548.23999 125.220001 546.609985 124.980011 546.429993 124.950012 L 546.429993 123.779999 C 546.429993 123.779999 547.869995 123.880005 548.23999 124.040009 L 548.23999 125.220001 Z"
      />
      <path
        id="path549"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 129.75 C 548.23999 129.75 546.599976 129.52002 546.429993 129.5 L 546.429993 128.299988 C 546.429993 128.299988 547.900024 128.399994 548.23999 128.539978 L 548.23999 129.75 Z"
      />
      <path
        id="path550"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 132.02002 C 548.23999 132.02002 546.590027 131.799988 546.429993 131.779999 L 546.429993 130.570007 C 546.429993 130.570007 547.919983 130.660004 548.23999 130.799988 L 548.23999 132.02002 Z"
      />
      <path
        id="path551"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 134.289978 C 548.23999 134.289978 546.580017 134.080017 546.429993 134.059998 L 546.429993 132.830017 C 546.429993 132.830017 547.929993 132.919983 548.23999 133.049988 L 548.23999 134.289978 Z"
      />
      <path
        id="path552"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 136.559998 C 548.23999 136.559998 546.580017 136.359985 546.429993 136.350006 L 546.429993 135.109985 C 546.429993 135.109985 547.950012 135.190002 548.23999 135.320007 L 548.23999 136.570007 L 548.23999 136.559998 Z"
      />
      <path
        id="path553"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 138.820007 C 548.23999 138.820007 546.570007 138.630005 546.429993 138.619995 L 546.429993 137.359985 C 546.429993 137.359985 547.960022 137.440002 548.23999 137.559998 L 548.23999 138.820007 Z"
      />
      <path
        id="path554"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 141.089996 C 548.23999 141.089996 546.559998 140.910004 546.429993 140.899994 L 546.429993 139.630005 C 546.429993 139.630005 547.97998 139.700012 548.23999 139.820007 L 548.23999 141.100006 L 548.23999 141.089996 Z"
      />
      <path
        id="path555"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 145.630005 C 548.23999 145.630005 546.549988 145.470001 546.429993 145.460022 L 546.429993 144.160004 C 546.429993 144.160004 548.01001 144.22998 548.23999 144.330017 L 548.23999 145.630005 Z"
      />
      <path
        id="path556"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 147.890015 C 548.23999 147.890015 546.539978 147.73999 546.429993 147.72998 L 546.429993 146.419983 C 546.429993 146.419983 548.02002 146.47998 548.23999 146.580017 L 548.23999 147.899994 L 548.23999 147.890015 Z"
      />
      <path
        id="path557"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 152.429993 C 548.23999 152.429993 546.52002 152.299988 546.429993 152.289978 L 546.429993 150.950012 C 546.429993 150.950012 548.049988 151 548.23999 151.080017 L 548.23999 152.419983 L 548.23999 152.429993 Z"
      />
      <path
        id="path558"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 154.700012 C 548.23999 154.700012 546.51001 154.580017 546.429993 154.570007 L 546.429993 153.220001 C 546.429993 153.220001 548.070007 153.27002 548.23999 153.339996 L 548.23999 154.700012 Z"
      />
      <path
        id="path559"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 156.970001 C 548.23999 156.970001 546.51001 156.859985 546.429993 156.850006 L 546.429993 155.47998 C 546.429993 155.47998 548.080017 155.529999 548.23999 155.589996 L 548.23999 156.960022 L 548.23999 156.970001 Z"
      />
      <path
        id="path560"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 159.22998 C 548.23999 159.22998 546.5 159.130005 546.429993 159.119995 L 546.429993 157.73999 C 546.429993 157.73999 548.099976 157.779999 548.23999 157.839996 L 548.23999 159.220001 L 548.23999 159.22998 Z"
      />
      <path
        id="path561"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 161.5 C 548.23999 161.5 546.48999 161.410004 546.429993 161.399994 L 546.429993 160 C 546.429993 160 548.109985 160.039978 548.23999 160.089996 L 548.23999 161.48999 L 548.23999 161.5 Z"
      />
      <path
        id="path562"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 163.77002 C 548.23999 163.77002 546.48999 163.690002 546.429993 163.679993 L 546.429993 162.27002 C 546.429993 162.27002 548.130005 162.299988 548.23999 162.350006 L 548.23999 163.76001 L 548.23999 163.77002 Z"
      />
      <path
        id="path563"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 168.299988 C 548.23999 168.299988 546.469971 168.23999 546.429993 168.23999 L 546.429993 166.799988 C 546.429993 166.799988 548.150024 166.830017 548.23999 166.859985 L 548.23999 168.299988 Z"
      />
      <path
        id="path564"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 170.570007 C 548.23999 170.570007 546.460022 170.52002 546.429993 170.52002 L 546.429993 169.070007 C 546.429993 169.070007 548.169983 169.089996 548.23999 169.119995 L 548.23999 170.570007 Z"
      />
      <path
        id="path565"
        fill="#cecece"
        stroke="none"
        d="M 548.25 172.839996 C 548.25 172.839996 546.469971 172.799988 546.440002 172.799988 L 546.440002 171.339996 C 546.440002 171.339996 548.190002 171.359985 548.25 171.380005 L 548.25 172.850006 L 548.25 172.839996 Z"
      />
      <path
        id="path566"
        fill="#cecece"
        stroke="none"
        d="M 540.25 102.399994 L 540.25 101.48999 C 540.25 101.48999 539.349976 101.640015 538.919983 101.820007 L 538.919983 102.690002 L 540.25 102.390015 L 540.25 102.399994 Z"
      />
      <path
        id="path567"
        fill="#cecece"
        stroke="none"
        d="M 540.25 104.669983 L 538.919983 104.959991 L 538.919983 104.070007 C 539.340027 103.890015 540.25 103.75 540.25 103.75 L 540.25 104.669983 Z"
      />
      <path
        id="path568"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 106.940002 L 538.909973 107.220001 L 538.909973 106.309998 C 539.320007 106.140015 540.23999 106 540.23999 106 L 540.23999 106.940002 Z"
      />
      <path
        id="path569"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 109.209991 L 538.909973 109.480011 L 538.909973 108.549988 C 539.299988 108.380005 540.23999 108.23999 540.23999 108.23999 L 540.23999 109.200012 L 540.23999 109.209991 Z"
      />
      <path
        id="path570"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 111.48999 L 538.909973 111.76001 L 538.909973 110.809998 C 539.289978 110.649994 540.23999 110.51001 540.23999 110.51001 L 540.23999 111.48999 Z"
      />
      <path
        id="path571"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 113.76001 L 538.909973 114.019989 L 538.909973 113.059998 C 539.280029 112.899994 540.23999 112.769989 540.23999 112.769989 L 540.23999 113.76001 Z"
      />
      <path
        id="path572"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 116.029999 L 538.909973 116.279999 L 538.909973 115.299988 C 539.27002 115.149994 540.23999 115.019989 540.23999 115.019989 L 540.23999 116.029999 Z"
      />
      <path
        id="path573"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 118.299988 L 538.909973 118.540009 L 538.909973 117.540009 C 539.25 117.390015 540.23999 117.269989 540.23999 117.269989 L 540.23999 118.299988 Z"
      />
      <path
        id="path574"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 120.570007 L 538.909973 120.799988 L 538.909973 119.779999 C 539.23999 119.640015 540.23999 119.519989 540.23999 119.519989 L 540.23999 120.570007 Z"
      />
      <path
        id="path575"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 122.839996 L 538.909973 123.059998 L 538.909973 122.019989 C 539.22998 121.880005 540.23999 121.769989 540.23999 121.769989 L 540.23999 122.830017 L 540.23999 122.839996 Z"
      />
      <path
        id="path576"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 127.390015 L 538.900024 127.600006 L 538.900024 126.519989 C 539.190002 126.390015 540.23999 126.290009 540.23999 126.290009 L 540.23999 127.390015 Z"
      />
      <path
        id="path577"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 129.660004 L 538.900024 129.859985 L 538.900024 128.77002 C 539.179993 128.649994 540.23999 128.549988 540.23999 128.549988 L 540.23999 129.669983 L 540.23999 129.660004 Z"
      />
      <path
        id="path578"
        fill="#cecece"
        stroke="none"
        d="M 540.23999 131.929993 L 538.900024 132.119995 L 538.900024 131.01001 C 539.169983 130.890015 540.23999 130.799988 540.23999 130.799988 L 540.23999 131.929993 Z"
      />
      <path
        id="path579"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 134.200012 L 538.890015 134.380005 L 538.890015 133.25 C 539.150024 133.140015 540.22998 133.049988 540.22998 133.049988 L 540.22998 134.200012 Z"
      />
      <path
        id="path580"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 138.75 L 538.890015 138.910004 L 538.890015 137.73999 C 539.119995 137.640015 540.22998 137.559998 540.22998 137.559998 L 540.22998 138.75 Z"
      />
      <path
        id="path581"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 141.02002 L 538.890015 141.169983 L 538.890015 139.97998 C 539.109985 139.890015 540.22998 139.809998 540.22998 139.809998 L 540.22998 141.01001 L 540.22998 141.02002 Z"
      />
      <path
        id="path582"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 143.289978 L 538.890015 143.440002 L 538.890015 142.22998 C 539.099976 142.140015 540.22998 142.070007 540.22998 142.070007 L 540.22998 143.289978 Z"
      />
      <path
        id="path583"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 145.559998 L 538.890015 145.700012 L 538.890015 144.47998 C 539.090027 144.399994 540.22998 144.330017 540.22998 144.330017 L 540.22998 145.570007 L 540.22998 145.559998 Z"
      />
      <path
        id="path584"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 147.830017 L 538.890015 147.960022 L 538.890015 146.720001 C 539.070007 146.640015 540.22998 146.580017 540.22998 146.580017 L 540.22998 147.839996 L 540.22998 147.830017 Z"
      />
      <path
        id="path585"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 152.380005 L 538.890015 152.48999 L 538.890015 151.210022 C 539.049988 151.140015 540.22998 151.089996 540.22998 151.089996 L 540.22998 152.380005 Z"
      />
      <path
        id="path586"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 154.649994 L 538.890015 154.75 L 538.890015 153.450012 C 539.039978 153.390015 540.22998 153.339996 540.22998 153.339996 L 540.22998 154.649994 Z"
      />
      <path
        id="path587"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 156.919983 L 538.890015 157.01001 L 538.890015 155.690002 C 539.02002 155.630005 540.22998 155.580017 540.22998 155.580017 L 540.22998 156.910004 L 540.22998 156.919983 Z"
      />
      <path
        id="path588"
        fill="#cecece"
        stroke="none"
        d="M 540.219971 159.190002 L 538.880005 159.279999 L 538.880005 157.940002 C 539 157.890015 540.219971 157.839996 540.219971 157.839996 L 540.219971 159.179993 L 540.219971 159.190002 Z"
      />
      <path
        id="path589"
        fill="#cecece"
        stroke="none"
        d="M 540.219971 166.01001 L 538.869995 166.070007 L 538.869995 164.679993 C 538.960022 164.640015 540.219971 164.609985 540.219971 164.609985 L 540.219971 166.01001 Z"
      />
      <path
        id="path590"
        fill="#cecece"
        stroke="none"
        d="M 540.219971 168.279999 L 538.869995 168.330017 L 538.869995 166.919983 C 538.940002 166.890015 540.219971 166.859985 540.219971 166.859985 L 540.219971 168.27002 L 540.219971 168.279999 Z"
      />
      <path
        id="path591"
        fill="#cecece"
        stroke="none"
        d="M 540.219971 170.549988 L 538.869995 170.589996 L 538.869995 169.160004 C 538.929993 169.130005 540.219971 169.109985 540.219971 169.109985 L 540.219971 170.539978 L 540.219971 170.549988 Z"
      />
      <path
        id="path592"
        fill="#cecece"
        stroke="none"
        d="M 538.369995 102.01001 L 538.369995 102.869995 L 537.039978 103.290009 L 537.039978 102.529999 L 538.369995 102.01001 Z"
      />
      <path
        id="path593"
        fill="#cecece"
        stroke="none"
        d="M 538.369995 105.130005 L 537.039978 105.540009 L 537.039978 104.76001 L 538.369995 104.25 L 538.369995 105.130005 Z"
      />
      <path
        id="path594"
        fill="#cecece"
        stroke="none"
        d="M 538.369995 107.380005 L 537.049988 107.790009 L 537.049988 106.980011 L 538.369995 106.48999 L 538.369995 107.380005 Z"
      />
      <path
        id="path595"
        fill="#cecece"
        stroke="none"
        d="M 538.369995 109.640015 L 537.049988 110.029999 L 537.049988 109.209991 L 538.369995 108.730011 L 538.369995 109.640015 Z"
      />
      <path
        id="path596"
        fill="#cecece"
        stroke="none"
        d="M 538.369995 111.899994 L 537.049988 112.279999 L 537.049988 111.429993 L 538.369995 110.970001 L 538.369995 111.899994 Z"
      />
      <path
        id="path597"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 116.419983 L 537.049988 116.769989 L 537.049988 115.880005 L 538.359985 115.450012 L 538.359985 116.419983 Z"
      />
      <path
        id="path598"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 118.679993 L 537.049988 119.019989 L 537.049988 118.100006 L 538.359985 117.690002 L 538.359985 118.679993 Z"
      />
      <path
        id="path599"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 120.929993 L 537.049988 121.26001 L 537.049988 120.330017 L 538.359985 119.929993 L 538.359985 120.929993 Z"
      />
      <path
        id="path600"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 123.190002 L 537.049988 123.51001 L 537.049988 122.549988 L 538.359985 122.169983 L 538.359985 123.190002 Z"
      />
      <path
        id="path601"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 125.450012 L 537.049988 125.76001 L 537.049988 124.779999 L 538.359985 124.410004 L 538.359985 125.450012 Z"
      />
      <path
        id="path602"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 127.709991 L 537.049988 128 L 537.049988 127 L 538.359985 126.649994 L 538.359985 127.709991 Z"
      />
      <path
        id="path603"
        fill="#cecece"
        stroke="none"
        d="M 538.359985 129.970001 L 537.049988 130.25 L 537.049988 129.22998 L 538.359985 128.890015 L 538.359985 129.970001 Z"
      />
      <path
        id="path604"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 132.22998 L 537.049988 132.48999 L 537.049988 131.450012 L 538.349976 131.119995 L 538.349976 132.22998 Z"
      />
      <path
        id="path605"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 134.47998 L 537.049988 134.73999 L 537.049988 133.679993 L 538.349976 133.359985 L 538.349976 134.47998 Z"
      />
      <path
        id="path606"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 136.73999 L 537.049988 136.98999 L 537.049988 135.899994 L 538.349976 135.600006 L 538.349976 136.73999 Z"
      />
      <path
        id="path607"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 139 L 537.059998 139.22998 L 537.059998 138.119995 L 538.349976 137.839996 L 538.349976 139 Z"
      />
      <path
        id="path608"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 141.26001 L 537.059998 141.47998 L 537.059998 140.350006 L 538.349976 140.080017 L 538.349976 141.26001 Z"
      />
      <path
        id="path609"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 143.52002 L 537.059998 143.720001 L 537.059998 142.570007 L 538.349976 142.320007 L 538.349976 143.52002 Z"
      />
      <path
        id="path610"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 145.779999 L 537.059998 145.970001 L 537.059998 144.799988 L 538.340027 144.559998 L 538.340027 145.779999 Z"
      />
      <path
        id="path611"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 148.029999 L 537.059998 148.220001 L 537.059998 147.02002 L 538.340027 146.799988 L 538.340027 148.029999 Z"
      />
      <path
        id="path612"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 150.289978 L 537.059998 150.460022 L 537.059998 149.25 L 538.340027 149.039978 L 538.340027 150.289978 Z"
      />
      <path
        id="path613"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 152.549988 L 537.059998 152.710022 L 537.059998 151.470001 L 538.340027 151.279999 L 538.340027 152.549988 Z"
      />
      <path
        id="path614"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 154.809998 L 537.059998 154.960022 L 537.059998 153.700012 L 538.340027 153.52002 L 538.340027 154.809998 Z"
      />
      <path
        id="path615"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 157.070007 L 537.059998 157.200012 L 537.059998 155.919983 L 538.340027 155.76001 L 538.340027 157.070007 Z"
      />
      <path
        id="path616"
        fill="#cecece"
        stroke="none"
        d="M 538.340027 159.330017 L 537.059998 159.450012 L 537.059998 158.149994 L 538.340027 158 L 538.340027 159.330017 Z"
      />
      <path
        id="path617"
        fill="#cecece"
        stroke="none"
        d="M 538.330017 161.580017 L 537.059998 161.690002 L 537.059998 160.369995 L 538.330017 160.23999 L 538.330017 161.580017 Z"
      />
      <path
        id="path618"
        fill="#cecece"
        stroke="none"
        d="M 538.330017 166.100006 L 537.059998 166.190002 L 537.059998 164.820007 L 538.330017 164.710022 L 538.330017 166.100006 Z"
      />
      <path
        id="path619"
        fill="#cecece"
        stroke="none"
        d="M 538.330017 168.359985 L 537.070007 168.429993 L 537.070007 167.039978 L 538.330017 166.950012 L 538.330017 168.359985 Z"
      />
      <path
        id="path620"
        fill="#cecece"
        stroke="none"
        d="M 538.330017 172.880005 L 537.070007 172.919983 L 537.070007 171.48999 L 538.330017 171.429993 L 538.330017 172.880005 Z"
      />
      <path
        id="path621"
        fill="#cecece"
        stroke="none"
        d="M 538.330017 175.130005 L 537.070007 175.169983 L 537.070007 173.720001 L 538.330017 173.669983 L 538.330017 175.130005 Z"
      />
      <path
        id="path622"
        fill="#cecece"
        stroke="none"
        d="M 538.320007 177.390015 L 537.070007 177.419983 L 537.070007 175.940002 L 538.320007 175.910004 L 538.320007 177.390015 Z"
      />
      <path
        id="path623"
        fill="#cecece"
        stroke="none"
        d="M 538.320007 179.649994 L 537.070007 179.660004 L 537.070007 178.169983 L 538.320007 178.149994 L 538.320007 179.649994 Z"
      />
      <path
        id="path624"
        fill="#cecece"
        stroke="none"
        d="M 538.320007 180.390015 L 537.070007 180.390015 L 537.070007 181.910004 L 538.320007 181.910004 L 538.320007 180.390015 Z"
      />
      <path
        id="path625"
        fill="#cecece"
        stroke="none"
        d="M 516.450012 112.230011 L 517.5 111.649994 L 517.5 112.470001 L 516.450012 113.019989 L 516.450012 112.230011 Z"
      />
      <path
        id="path626"
        fill="#cecece"
        stroke="none"
        d="M 517.5 114.5 L 516.450012 115.029999 L 516.450012 114.220001 L 517.5 113.660004 L 517.5 114.5 Z"
      />
      <path
        id="path627"
        fill="#cecece"
        stroke="none"
        d="M 517.5 116.519989 L 516.450012 117.040009 L 516.450012 116.209991 L 517.5 115.660004 L 517.5 116.519989 Z"
      />
      <path
        id="path628"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 118.540009 L 516.450012 119.040009 L 516.450012 118.200012 L 517.48999 117.669983 L 517.48999 118.540009 Z"
      />
      <path
        id="path629"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 120.570007 L 516.450012 121.049988 L 516.450012 120.190002 L 517.48999 119.669983 L 517.48999 120.570007 Z"
      />
      <path
        id="path630"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 122.589996 L 516.450012 123.059998 L 516.450012 122.179993 L 517.48999 121.679993 L 517.48999 122.589996 Z"
      />
      <path
        id="path631"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 124.609985 L 516.450012 125.070007 L 516.450012 124.169983 L 517.48999 123.679993 L 517.48999 124.609985 Z"
      />
      <path
        id="path632"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 126.640015 L 516.450012 127.070007 L 516.450012 126.160004 L 517.48999 125.690002 L 517.48999 126.640015 Z"
      />
      <path
        id="path633"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 128.660004 L 516.450012 129.080017 L 516.450012 128.149994 L 517.48999 127.700012 L 517.48999 128.660004 Z"
      />
      <path
        id="path634"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 130.679993 L 516.450012 131.089996 L 516.450012 130.140015 L 517.48999 129.700012 L 517.48999 130.679993 Z"
      />
      <path
        id="path635"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 132.710022 L 516.450012 133.100006 L 516.450012 132.119995 L 517.48999 131.710022 L 517.48999 132.710022 Z"
      />
      <path
        id="path636"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 134.72998 L 516.450012 135.100006 L 516.450012 134.109985 L 517.48999 133.710022 L 517.48999 134.72998 Z"
      />
      <path
        id="path637"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 136.75 L 516.450012 137.109985 L 516.450012 136.100006 L 517.48999 135.720001 L 517.48999 136.75 Z"
      />
      <path
        id="path638"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 138.779999 L 516.450012 139.119995 L 516.450012 138.089996 L 517.48999 137.720001 L 517.48999 138.779999 Z"
      />
      <path
        id="path639"
        fill="#cecece"
        stroke="none"
        d="M 517.48999 140.799988 L 516.450012 141.130005 L 516.450012 140.080017 L 517.48999 139.72998 L 517.48999 140.799988 Z"
      />
      <path
        id="path640"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 144.850006 L 516.450012 145.140015 L 516.450012 144.059998 L 517.47998 143.73999 L 517.47998 144.850006 Z"
      />
      <path
        id="path641"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 146.869995 L 516.450012 147.149994 L 516.450012 146.049988 L 517.47998 145.75 L 517.47998 146.869995 Z"
      />
      <path
        id="path642"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 150.919983 L 516.450012 151.169983 L 516.450012 150.029999 L 517.47998 149.76001 L 517.47998 150.919983 Z"
      />
      <path
        id="path643"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 152.940002 L 516.450012 153.169983 L 516.450012 152.01001 L 517.47998 151.76001 L 517.47998 152.940002 Z"
      />
      <path
        id="path644"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 159.01001 L 516.450012 159.200012 L 516.450012 157.97998 L 517.47998 157.779999 L 517.47998 159.01001 Z"
      />
      <path
        id="path645"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 163.049988 L 516.450012 163.210022 L 516.450012 161.960022 L 517.47998 161.789978 L 517.47998 163.049988 Z"
      />
      <path
        id="path646"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 165.080017 L 516.450012 165.220001 L 516.450012 163.950012 L 517.47998 163.799988 L 517.47998 165.080017 Z"
      />
      <path
        id="path647"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 169.130005 L 516.450012 169.22998 L 516.450012 167.929993 L 517.47998 167.809998 L 517.47998 169.130005 Z"
      />
      <path
        id="path648"
        fill="#cecece"
        stroke="none"
        d="M 517.47998 171.149994 L 516.450012 171.23999 L 516.450012 169.919983 L 517.47998 169.820007 L 517.47998 171.149994 Z"
      />
      <path
        id="path649"
        fill="#cecece"
        stroke="none"
        d="M 517.469971 175.190002 L 516.450012 175.26001 L 516.450012 173.899994 L 517.469971 173.830017 L 517.469971 175.190002 Z"
      />
      <path
        id="path650"
        fill="#cecece"
        stroke="none"
        d="M 517.469971 177.220001 L 516.450012 177.26001 L 516.450012 175.880005 L 517.469971 175.830017 L 517.469971 177.220001 Z"
      />
      <path
        id="path651"
        fill="#cecece"
        stroke="none"
        d="M 517.469971 181.27002 L 516.450012 181.279999 L 516.450012 179.859985 L 517.469971 179.839996 L 517.469971 181.27002 Z"
      />
      <path
        id="path652"
        fill="#cecece"
        stroke="none"
        d="M 518.02002 111.410004 L 519.070007 110.830017 L 519.070007 111.649994 L 518.02002 112.200012 L 518.02002 111.410004 Z"
      />
      <path
        id="path653"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 113.700012 L 518.030029 114.230011 L 518.030029 113.429993 L 519.070007 112.859985 L 519.070007 113.700012 Z"
      />
      <path
        id="path654"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 115.75 L 518.030029 116.26001 L 518.030029 115.440002 L 519.070007 114.890015 L 519.070007 115.75 Z"
      />
      <path
        id="path655"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 117.790009 L 518.030029 118.290009 L 518.030029 117.450012 L 519.070007 116.919983 L 519.070007 117.790009 Z"
      />
      <path
        id="path656"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 119.839996 L 518.030029 120.320007 L 518.030029 119.459991 L 519.070007 118.950012 L 519.070007 119.839996 Z"
      />
      <path
        id="path657"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 121.890015 L 518.030029 122.359985 L 518.030029 121.480011 L 519.070007 120.980011 L 519.070007 121.890015 Z"
      />
      <path
        id="path658"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 123.929993 L 518.030029 124.390015 L 518.030029 123.48999 L 519.070007 123.01001 L 519.070007 123.929993 Z"
      />
      <path
        id="path659"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 125.980011 L 518.030029 126.419983 L 518.030029 125.5 L 519.070007 125.029999 L 519.070007 125.980011 Z"
      />
      <path
        id="path660"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 128.029999 L 518.030029 128.450012 L 518.030029 127.51001 L 519.070007 127.059998 L 519.070007 128.029999 Z"
      />
      <path
        id="path661"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 130.070007 L 518.030029 130.47998 L 518.030029 129.529999 L 519.070007 129.089996 L 519.070007 130.070007 Z"
      />
      <path
        id="path662"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 132.119995 L 518.030029 132.51001 L 518.030029 131.539978 L 519.070007 131.119995 L 519.070007 132.119995 Z"
      />
      <path
        id="path663"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 134.169983 L 518.030029 134.539978 L 518.030029 133.549988 L 519.070007 133.149994 L 519.070007 134.169983 Z"
      />
      <path
        id="path664"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 136.210022 L 518.030029 136.570007 L 518.030029 135.559998 L 519.070007 135.179993 L 519.070007 136.210022 Z"
      />
      <path
        id="path665"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 138.26001 L 518.030029 138.600006 L 518.030029 137.580017 L 519.070007 137.210022 L 519.070007 138.26001 Z"
      />
      <path
        id="path666"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 140.309998 L 518.030029 140.640015 L 518.030029 139.589996 L 519.070007 139.23999 L 519.070007 140.309998 Z"
      />
      <path
        id="path667"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 146.450012 L 518.030029 146.72998 L 518.030029 145.630005 L 519.070007 145.330017 L 519.070007 146.450012 Z"
      />
      <path
        id="path668"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 148.48999 L 518.039978 148.76001 L 518.039978 147.640015 L 519.070007 147.359985 L 519.070007 148.48999 Z"
      />
      <path
        id="path669"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 152.589996 L 518.039978 152.820007 L 518.039978 151.660004 L 519.070007 151.410004 L 519.070007 152.589996 Z"
      />
      <path
        id="path670"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 154.630005 L 518.039978 154.850006 L 518.039978 153.679993 L 519.070007 153.440002 L 519.070007 154.630005 Z"
      />
      <path
        id="path671"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 156.679993 L 518.039978 156.880005 L 518.039978 155.690002 L 519.070007 155.470001 L 519.070007 156.679993 Z"
      />
      <path
        id="path672"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 158.72998 L 518.039978 158.919983 L 518.039978 157.700012 L 519.070007 157.5 L 519.070007 158.72998 Z"
      />
      <path
        id="path673"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 162.820007 L 518.039978 162.97998 L 518.039978 161.72998 L 519.070007 161.559998 L 519.070007 162.820007 Z"
      />
      <path
        id="path674"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 168.960022 L 518.039978 169.070007 L 518.039978 167.76001 L 519.070007 167.649994 L 519.070007 168.960022 Z"
      />
      <path
        id="path675"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 175.100006 L 518.039978 175.160004 L 518.039978 173.799988 L 519.070007 173.72998 L 519.070007 175.100006 Z"
      />
      <path
        id="path676"
        fill="#cecece"
        stroke="none"
        d="M 519.070007 181.23999 L 518.049988 181.26001 L 518.049988 179.839996 L 519.070007 179.820007 L 519.070007 181.23999 Z"
      />
      <path
        id="path677"
        fill="#cecece"
        stroke="none"
        d="M 519.599976 110.609985 L 520.640015 110.019989 L 520.640015 110.850006 L 519.599976 111.390015 L 519.599976 110.609985 Z"
      />
      <path
        id="path678"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 112.919983 L 519.599976 113.450012 L 519.599976 112.640015 L 520.640015 112.080017 L 520.640015 112.919983 Z"
      />
      <path
        id="path679"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 114.98999 L 519.599976 115.5 L 519.599976 114.679993 L 520.640015 114.130005 L 520.640015 114.98999 Z"
      />
      <path
        id="path680"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 117.059998 L 519.599976 117.559998 L 519.599976 116.709991 L 520.640015 116.179993 L 520.640015 117.059998 Z"
      />
      <path
        id="path681"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 119.130005 L 519.599976 119.609985 L 519.599976 118.75 L 520.640015 118.230011 L 520.640015 119.130005 Z"
      />
      <path
        id="path682"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 121.200012 L 519.599976 121.660004 L 519.599976 120.790009 L 520.640015 120.290009 L 520.640015 121.200012 Z"
      />
      <path
        id="path683"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 123.269989 L 519.599976 123.720001 L 519.599976 122.820007 L 520.640015 122.339996 L 520.640015 123.269989 Z"
      />
      <path
        id="path684"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 125.339996 L 519.599976 125.769989 L 519.599976 124.859985 L 520.640015 124.390015 L 520.640015 125.339996 Z"
      />
      <path
        id="path685"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 127.410004 L 519.599976 127.830017 L 519.599976 126.890015 L 520.640015 126.440002 L 520.640015 127.410004 Z"
      />
      <path
        id="path686"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 129.47998 L 519.599976 129.880005 L 519.599976 128.929993 L 520.640015 128.48999 L 520.640015 129.47998 Z"
      />
      <path
        id="path687"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 131.539978 L 519.599976 131.940002 L 519.599976 130.960022 L 520.640015 130.549988 L 520.640015 131.539978 Z"
      />
      <path
        id="path688"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 135.679993 L 519.599976 136.039978 L 519.599976 135.029999 L 520.640015 134.649994 L 520.640015 135.679993 Z"
      />
      <path
        id="path689"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 139.820007 L 519.599976 140.149994 L 519.599976 139.109985 L 520.640015 138.76001 L 520.640015 139.820007 Z"
      />
      <path
        id="path690"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 141.890015 L 519.609985 142.210022 L 519.609985 141.140015 L 520.640015 140.809998 L 520.640015 141.890015 Z"
      />
      <path
        id="path691"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 146.029999 L 519.609985 146.309998 L 519.609985 145.210022 L 520.640015 144.910004 L 520.640015 146.029999 Z"
      />
      <path
        id="path692"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 148.100006 L 519.609985 148.369995 L 519.609985 147.25 L 520.640015 146.960022 L 520.640015 148.100006 Z"
      />
      <path
        id="path693"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 152.23999 L 519.609985 152.47998 L 519.609985 151.320007 L 520.640015 151.070007 L 520.640015 152.23999 Z"
      />
      <path
        id="path694"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 154.309998 L 519.609985 154.529999 L 519.609985 153.350006 L 520.640015 153.119995 L 520.640015 154.309998 Z"
      />
      <path
        id="path695"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 156.380005 L 519.609985 156.580017 L 519.609985 155.390015 L 520.640015 155.169983 L 520.640015 156.380005 Z"
      />
      <path
        id="path696"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 158.450012 L 519.609985 158.640015 L 519.609985 157.419983 L 520.640015 157.22998 L 520.640015 158.450012 Z"
      />
      <path
        id="path697"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 160.52002 L 519.609985 160.690002 L 519.609985 159.460022 L 520.640015 159.279999 L 520.640015 160.52002 Z"
      />
      <path
        id="path698"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 162.589996 L 519.609985 162.75 L 519.609985 161.5 L 520.640015 161.330017 L 520.640015 162.589996 Z"
      />
      <path
        id="path699"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 166.72998 L 519.609985 166.859985 L 519.609985 165.570007 L 520.640015 165.429993 L 520.640015 166.72998 Z"
      />
      <path
        id="path700"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 170.869995 L 519.609985 170.960022 L 519.609985 169.640015 L 520.640015 169.539978 L 520.640015 170.869995 Z"
      />
      <path
        id="path701"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 172.940002 L 519.609985 173.02002 L 519.609985 171.669983 L 520.640015 171.589996 L 520.640015 172.940002 Z"
      />
      <path
        id="path702"
        fill="#cecece"
        stroke="none"
        d="M 520.640015 177.080017 L 519.609985 177.130005 L 519.609985 175.75 L 520.640015 175.690002 L 520.640015 177.080017 Z"
      />
      <path
        id="path703"
        fill="#cecece"
        stroke="none"
        d="M 521.210022 109.820007 L 522.25 109.23999 L 522.25 110.059998 L 521.210022 110.609985 L 521.210022 109.820007 Z"
      />
      <path
        id="path704"
        fill="#cecece"
        stroke="none"
        d="M 522.25 112.149994 L 521.210022 112.679993 L 521.210022 111.880005 L 522.25 111.309998 L 522.25 112.149994 Z"
      />
      <path
        id="path705"
        fill="#cecece"
        stroke="none"
        d="M 522.25 116.339996 L 521.210022 116.839996 L 521.210022 116 L 522.25 115.459991 L 522.25 116.339996 Z"
      />
      <path
        id="path706"
        fill="#cecece"
        stroke="none"
        d="M 522.25 118.429993 L 521.210022 118.910004 L 521.210022 118.049988 L 522.25 117.540009 L 522.25 118.429993 Z"
      />
      <path
        id="path707"
        fill="#cecece"
        stroke="none"
        d="M 522.25 120.519989 L 521.210022 120.98999 L 521.210022 120.109985 L 522.25 119.609985 L 522.25 120.519989 Z"
      />
      <path
        id="path708"
        fill="#cecece"
        stroke="none"
        d="M 522.25 122.609985 L 521.210022 123.070007 L 521.210022 122.169983 L 522.25 121.690002 L 522.25 122.609985 Z"
      />
      <path
        id="path709"
        fill="#cecece"
        stroke="none"
        d="M 522.25 126.799988 L 521.210022 127.220001 L 521.210022 126.290009 L 522.25 125.839996 L 522.25 126.799988 Z"
      />
      <path
        id="path710"
        fill="#cecece"
        stroke="none"
        d="M 522.25 128.890015 L 521.210022 129.299988 L 521.210022 128.339996 L 522.25 127.910004 L 522.25 128.890015 Z"
      />
      <path
        id="path711"
        fill="#cecece"
        stroke="none"
        d="M 522.25 130.97998 L 521.210022 131.369995 L 521.210022 130.399994 L 522.25 129.97998 L 522.25 130.97998 Z"
      />
      <path
        id="path712"
        fill="#cecece"
        stroke="none"
        d="M 522.25 133.080017 L 521.219971 133.450012 L 521.219971 132.460022 L 522.25 132.059998 L 522.25 133.080017 Z"
      />
      <path
        id="path713"
        fill="#cecece"
        stroke="none"
        d="M 522.25 135.169983 L 521.219971 135.529999 L 521.219971 134.52002 L 522.25 134.130005 L 522.25 135.169983 Z"
      />
      <path
        id="path714"
        fill="#cecece"
        stroke="none"
        d="M 522.25 137.26001 L 521.219971 137.600006 L 521.219971 136.580017 L 522.25 136.210022 L 522.25 137.26001 Z"
      />
      <path
        id="path715"
        fill="#cecece"
        stroke="none"
        d="M 522.25 139.350006 L 521.219971 139.679993 L 521.219971 138.630005 L 522.25 138.279999 L 522.25 139.350006 Z"
      />
      <path
        id="path716"
        fill="#cecece"
        stroke="none"
        d="M 522.25 141.440002 L 521.219971 141.76001 L 521.219971 140.690002 L 522.25 140.359985 L 522.25 141.440002 Z"
      />
      <path
        id="path717"
        fill="#cecece"
        stroke="none"
        d="M 522.25 145.630005 L 521.219971 145.910004 L 521.219971 144.809998 L 522.25 144.51001 L 522.25 145.630005 Z"
      />
      <path
        id="path718"
        fill="#cecece"
        stroke="none"
        d="M 522.25 147.720001 L 521.219971 147.98999 L 521.219971 146.869995 L 522.25 146.580017 L 522.25 147.720001 Z"
      />
      <path
        id="path719"
        fill="#cecece"
        stroke="none"
        d="M 522.25 149.809998 L 521.219971 150.059998 L 521.219971 148.919983 L 522.25 148.660004 L 522.25 149.809998 Z"
      />
      <path
        id="path720"
        fill="#cecece"
        stroke="none"
        d="M 522.25 151.910004 L 521.219971 152.140015 L 521.219971 150.97998 L 522.25 150.72998 L 522.25 151.910004 Z"
      />
      <path
        id="path721"
        fill="#cecece"
        stroke="none"
        d="M 522.25 154 L 521.219971 154.220001 L 521.219971 153.039978 L 522.25 152.809998 L 522.25 154 Z"
      />
      <path
        id="path722"
        fill="#cecece"
        stroke="none"
        d="M 522.25 156.089996 L 521.219971 156.289978 L 521.219971 155.100006 L 522.25 154.880005 L 522.25 156.089996 Z"
      />
      <path
        id="path723"
        fill="#cecece"
        stroke="none"
        d="M 522.25 160.27002 L 521.22998 160.450012 L 521.22998 159.210022 L 522.25 159.029999 L 522.25 160.27002 Z"
      />
      <path
        id="path724"
        fill="#cecece"
        stroke="none"
        d="M 522.25 162.369995 L 521.22998 162.52002 L 521.22998 161.27002 L 522.25 161.100006 L 522.25 162.369995 Z"
      />
      <path
        id="path725"
        fill="#cecece"
        stroke="none"
        d="M 522.26001 166.549988 L 521.22998 166.679993 L 521.22998 165.390015 L 522.26001 165.25 L 522.26001 166.549988 Z"
      />
      <path
        id="path726"
        fill="#cecece"
        stroke="none"
        d="M 522.26001 170.73999 L 521.22998 170.830017 L 521.22998 169.5 L 522.26001 169.399994 L 522.26001 170.73999 Z"
      />
      <path
        id="path727"
        fill="#cecece"
        stroke="none"
        d="M 522.26001 172.830017 L 521.22998 172.899994 L 521.22998 171.559998 L 522.26001 171.47998 L 522.26001 172.830017 Z"
      />
      <path
        id="path728"
        fill="#cecece"
        stroke="none"
        d="M 522.26001 174.919983 L 521.22998 174.97998 L 521.22998 173.619995 L 522.26001 173.549988 L 522.26001 174.919983 Z"
      />
      <path
        id="path729"
        fill="#cecece"
        stroke="none"
        d="M 522.23999 178.200012 L 521.219971 178.25 L 521.219971 176.869995 L 522.23999 176.820007 L 522.23999 178.200012 Z"
      />
      <path
        id="path730"
        fill="#cecece"
        stroke="none"
        d="M 522.26001 179.100006 L 521.22998 179.130005 L 521.22998 177.73999 L 522.26001 177.700012 L 522.26001 179.100006 Z"
      />
      <path
        id="path731"
        fill="#cecece"
        stroke="none"
        d="M 522.26001 181.850006 L 521.23999 181.850006 L 521.23999 183.289978 L 522.26001 183.289978 L 522.26001 181.850006 Z"
      />
      <path
        id="path732"
        fill="#cecece"
        stroke="none"
        d="M 522.880005 109.029999 L 523.929993 108.440002 L 523.929993 109.269989 L 522.880005 109.820007 L 522.880005 109.029999 Z"
      />
      <path
        id="path733"
        fill="#cecece"
        stroke="none"
        d="M 523.929993 111.380005 L 522.880005 111.919983 L 522.880005 111.109985 L 523.929993 110.540009 L 523.929993 111.380005 Z"
      />
      <path
        id="path734"
        fill="#cecece"
        stroke="none"
        d="M 523.929993 113.5 L 522.880005 114.019989 L 522.880005 113.190002 L 523.929993 112.630005 L 523.929993 113.5 Z"
      />
      <path
        id="path735"
        fill="#cecece"
        stroke="none"
        d="M 523.929993 115.609985 L 522.880005 116.109985 L 522.880005 115.269989 L 523.929993 114.730011 L 523.929993 115.609985 Z"
      />
      <path
        id="path736"
        fill="#cecece"
        stroke="none"
        d="M 523.919983 117.730011 L 522.869995 118.209991 L 522.869995 117.350006 L 523.919983 116.830017 L 523.919983 117.730011 Z"
      />
      <path
        id="path737"
        fill="#cecece"
        stroke="none"
        d="M 523.919983 119.839996 L 522.869995 120.309998 L 522.869995 119.429993 L 523.919983 118.929993 L 523.919983 119.839996 Z"
      />
      <path
        id="path738"
        fill="#cecece"
        stroke="none"
        d="M 523.919983 121.959991 L 522.869995 122.410004 L 522.869995 121.51001 L 523.919983 121.019989 L 523.919983 121.959991 Z"
      />
      <path
        id="path739"
        fill="#cecece"
        stroke="none"
        d="M 523.919983 124.070007 L 522.869995 124.51001 L 522.869995 123.589996 L 523.919983 123.119995 L 523.919983 124.070007 Z"
      />
      <path
        id="path740"
        fill="#cecece"
        stroke="none"
        d="M 523.919983 126.190002 L 522.869995 126.609985 L 522.869995 125.669983 L 523.919983 125.220001 L 523.919983 126.190002 Z"
      />
      <path
        id="path741"
        fill="#cecece"
        stroke="none"
        d="M 523.919983 128.299988 L 522.869995 128.710022 L 522.869995 127.75 L 523.919983 127.320007 L 523.919983 128.299988 Z"
      />
      <path
        id="path742"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 130.419983 L 522.869995 130.809998 L 522.869995 129.830017 L 523.909973 129.410004 L 523.909973 130.419983 Z"
      />
      <path
        id="path743"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 132.529999 L 522.869995 132.910004 L 522.869995 131.910004 L 523.909973 131.51001 L 523.909973 132.529999 Z"
      />
      <path
        id="path744"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 134.649994 L 522.869995 135.01001 L 522.869995 133.98999 L 523.909973 133.609985 L 523.909973 134.649994 Z"
      />
      <path
        id="path745"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 136.76001 L 522.869995 137.109985 L 522.869995 136.080017 L 523.909973 135.710022 L 523.909973 136.76001 Z"
      />
      <path
        id="path746"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 138.880005 L 522.869995 139.210022 L 522.869995 138.160004 L 523.909973 137.799988 L 523.909973 138.880005 Z"
      />
      <path
        id="path747"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 140.98999 L 522.869995 141.299988 L 522.869995 140.23999 L 523.909973 139.899994 L 523.909973 140.98999 Z"
      />
      <path
        id="path748"
        fill="#cecece"
        stroke="none"
        d="M 523.909973 143.100006 L 522.869995 143.399994 L 522.869995 142.320007 L 523.909973 142 L 523.909973 143.100006 Z"
      />
      <path
        id="path749"
        fill="#cecece"
        stroke="none"
        d="M 523.900024 145.220001 L 522.869995 145.5 L 522.869995 144.399994 L 523.900024 144.100006 L 523.900024 145.220001 Z"
      />
      <path
        id="path750"
        fill="#cecece"
        stroke="none"
        d="M 523.900024 149.450012 L 522.869995 149.700012 L 522.869995 148.559998 L 523.900024 148.289978 L 523.900024 149.450012 Z"
      />
      <path
        id="path751"
        fill="#cecece"
        stroke="none"
        d="M 523.900024 151.559998 L 522.869995 151.799988 L 522.869995 150.640015 L 523.900024 150.390015 L 523.900024 151.559998 Z"
      />
      <path
        id="path752"
        fill="#cecece"
        stroke="none"
        d="M 523.900024 153.679993 L 522.869995 153.899994 L 522.869995 152.720001 L 523.900024 152.48999 L 523.900024 153.679993 Z"
      />
      <path
        id="path753"
        fill="#cecece"
        stroke="none"
        d="M 523.900024 155.789978 L 522.859985 156 L 522.859985 154.799988 L 523.900024 154.580017 L 523.900024 155.789978 Z"
      />
      <path
        id="path754"
        fill="#cecece"
        stroke="none"
        d="M 523.890015 160.02002 L 522.859985 160.200012 L 522.859985 158.960022 L 523.890015 158.779999 L 523.890015 160.02002 Z"
      />
      <path
        id="path755"
        fill="#cecece"
        stroke="none"
        d="M 523.890015 164.25 L 522.859985 164.399994 L 522.859985 163.130005 L 523.890015 162.970001 L 523.890015 164.25 Z"
      />
      <path
        id="path756"
        fill="#cecece"
        stroke="none"
        d="M 523.890015 166.369995 L 522.859985 166.48999 L 522.859985 165.210022 L 523.890015 165.070007 L 523.890015 166.369995 Z"
      />
      <path
        id="path757"
        fill="#cecece"
        stroke="none"
        d="M 523.890015 168.47998 L 522.859985 168.589996 L 522.859985 167.289978 L 523.890015 167.169983 L 523.890015 168.47998 Z"
      />
      <path
        id="path758"
        fill="#cecece"
        stroke="none"
        d="M 523.880005 172.710022 L 522.859985 172.789978 L 522.859985 171.450012 L 523.880005 171.359985 L 523.880005 172.710022 Z"
      />
      <path
        id="path759"
        fill="#cecece"
        stroke="none"
        d="M 523.880005 176.940002 L 522.859985 176.98999 L 522.859985 175.609985 L 523.880005 175.559998 L 523.880005 176.940002 Z"
      />
      <path
        id="path760"
        fill="#cecece"
        stroke="none"
        d="M 525.76001 107.769989 L 525.76001 108.570007 L 524.5 108.980011 L 524.5 108.26001 L 525.76001 107.769989 Z"
      />
      <path
        id="path761"
        fill="#cecece"
        stroke="none"
        d="M 525.76001 110.709991 L 524.51001 111.100006 L 524.51001 110.359985 L 525.76001 109.880005 L 525.76001 110.709991 Z"
      />
      <path
        id="path762"
        fill="#cecece"
        stroke="none"
        d="M 525.76001 112.839996 L 524.51001 113.220001 L 524.51001 112.459991 L 525.76001 112 L 525.76001 112.839996 Z"
      />
      <path
        id="path763"
        fill="#cecece"
        stroke="none"
        d="M 525.76001 114.980011 L 524.51001 115.350006 L 524.51001 114.559998 L 525.76001 114.119995 L 525.76001 114.980011 Z"
      />
      <path
        id="path764"
        fill="#cecece"
        stroke="none"
        d="M 525.75 117.109985 L 524.51001 117.470001 L 524.51001 116.669983 L 525.75 116.230011 L 525.75 117.109985 Z"
      />
      <path
        id="path765"
        fill="#cecece"
        stroke="none"
        d="M 525.75 121.380005 L 524.51001 121.709991 L 524.51001 120.869995 L 525.75 120.470001 L 525.75 121.380005 Z"
      />
      <path
        id="path766"
        fill="#cecece"
        stroke="none"
        d="M 525.75 123.51001 L 524.51001 123.839996 L 524.51001 122.980011 L 525.75 122.580017 L 525.75 123.51001 Z"
      />
      <path
        id="path767"
        fill="#cecece"
        stroke="none"
        d="M 525.75 125.649994 L 524.51001 125.959991 L 524.51001 125.080017 L 525.75 124.700012 L 525.75 125.649994 Z"
      />
      <path
        id="path768"
        fill="#cecece"
        stroke="none"
        d="M 525.75 127.779999 L 524.51001 128.080017 L 524.51001 127.179993 L 525.75 126.820007 L 525.75 127.779999 Z"
      />
      <path
        id="path769"
        fill="#cecece"
        stroke="none"
        d="M 525.75 129.919983 L 524.51001 130.210022 L 524.51001 129.279999 L 525.75 128.929993 L 525.75 129.919983 Z"
      />
      <path
        id="path770"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 132.049988 L 524.51001 132.330017 L 524.51001 131.390015 L 525.73999 131.049988 L 525.73999 132.049988 Z"
      />
      <path
        id="path771"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 134.190002 L 524.51001 134.450012 L 524.51001 133.48999 L 525.73999 133.169983 L 525.73999 134.190002 Z"
      />
      <path
        id="path772"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 136.320007 L 524.51001 136.580017 L 524.51001 135.589996 L 525.73999 135.279999 L 525.73999 136.320007 Z"
      />
      <path
        id="path773"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 138.460022 L 524.51001 138.700012 L 524.51001 137.690002 L 525.73999 137.399994 L 525.73999 138.460022 Z"
      />
      <path
        id="path774"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 140.589996 L 524.51001 140.820007 L 524.51001 139.799988 L 525.73999 139.52002 L 525.73999 140.589996 Z"
      />
      <path
        id="path775"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 142.72998 L 524.52002 142.950012 L 524.52002 141.899994 L 525.73999 141.630005 L 525.73999 142.72998 Z"
      />
      <path
        id="path776"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 144.859985 L 524.52002 145.070007 L 524.52002 144 L 525.73999 143.75 L 525.73999 144.859985 Z"
      />
      <path
        id="path777"
        fill="#cecece"
        stroke="none"
        d="M 525.73999 147 L 524.52002 147.190002 L 524.52002 146.100006 L 525.73999 145.869995 L 525.73999 147 Z"
      />
      <path
        id="path778"
        fill="#cecece"
        stroke="none"
        d="M 525.72998 149.130005 L 524.52002 149.320007 L 524.52002 148.210022 L 525.72998 147.97998 L 525.72998 149.130005 Z"
      />
      <path
        id="path779"
        fill="#cecece"
        stroke="none"
        d="M 525.72998 151.27002 L 524.52002 151.440002 L 524.52002 150.309998 L 525.72998 150.100006 L 525.72998 151.27002 Z"
      />
      <path
        id="path780"
        fill="#cecece"
        stroke="none"
        d="M 525.72998 153.399994 L 524.52002 153.559998 L 524.52002 152.410004 L 525.72998 152.220001 L 525.72998 153.399994 Z"
      />
      <path
        id="path781"
        fill="#cecece"
        stroke="none"
        d="M 525.72998 155.539978 L 524.52002 155.690002 L 524.52002 154.52002 L 525.72998 154.330017 L 525.72998 155.539978 Z"
      />
      <path
        id="path782"
        fill="#cecece"
        stroke="none"
        d="M 525.72998 159.809998 L 524.52002 159.929993 L 524.52002 158.720001 L 525.72998 158.570007 L 525.72998 159.809998 Z"
      />
      <path
        id="path783"
        fill="#cecece"
        stroke="none"
        d="M 525.72998 161.940002 L 524.52002 162.059998 L 524.52002 160.820007 L 525.72998 160.679993 L 525.72998 161.940002 Z"
      />
      <path
        id="path784"
        fill="#cecece"
        stroke="none"
        d="M 525.719971 164.080017 L 524.52002 164.179993 L 524.52002 162.929993 L 525.719971 162.799988 L 525.719971 164.080017 Z"
      />
      <path
        id="path785"
        fill="#cecece"
        stroke="none"
        d="M 525.719971 168.350006 L 524.52002 168.429993 L 524.52002 167.130005 L 525.719971 167.029999 L 525.719971 168.350006 Z"
      />
      <path
        id="path786"
        fill="#cecece"
        stroke="none"
        d="M 525.719971 170.47998 L 524.52002 170.549988 L 524.52002 169.22998 L 525.719971 169.149994 L 525.719971 170.47998 Z"
      />
      <path
        id="path787"
        fill="#cecece"
        stroke="none"
        d="M 525.719971 174.75 L 524.530029 174.789978 L 524.530029 173.440002 L 525.719971 173.380005 L 525.719971 174.75 Z"
      />
      <path
        id="path788"
        fill="#cecece"
        stroke="none"
        d="M 525.719971 176.880005 L 524.530029 176.919983 L 524.530029 175.539978 L 525.719971 175.5 L 525.719971 176.880005 Z"
      />
      <path
        id="path789"
        fill="#cecece"
        stroke="none"
        d="M 525.710022 179.02002 L 524.530029 179.039978 L 524.530029 177.649994 L 525.710022 177.619995 L 525.710022 179.02002 Z"
      />
      <path
        id="path790"
        fill="#cecece"
        stroke="none"
        d="M 525.710022 181.149994 L 524.530029 181.160004 L 524.530029 179.75 L 525.710022 179.72998 L 525.710022 181.149994 Z"
      />
      <path
        id="path791"
        fill="#cecece"
        stroke="none"
        d="M 525.710022 181.850006 L 524.530029 181.850006 L 524.530029 183.289978 L 525.710022 183.289978 L 525.710022 181.850006 Z"
      />
      <path
        id="path792"
        fill="#cecece"
        stroke="none"
        d="M 507.320007 130.109985 L 508.290009 129.570007 L 508.290009 130.330017 L 507.320007 130.830017 L 507.320007 130.109985 Z"
      />
      <path
        id="path793"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 132.220001 L 507.320007 132.720001 L 507.320007 131.970001 L 508.290009 131.450012 L 508.290009 132.220001 Z"
      />
      <path
        id="path794"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 134.119995 L 507.320007 134.600006 L 507.320007 133.830017 L 508.290009 133.320007 L 508.290009 134.119995 Z"
      />
      <path
        id="path795"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 136.01001 L 507.320007 136.47998 L 507.320007 135.700012 L 508.290009 135.200012 L 508.290009 136.01001 Z"
      />
      <path
        id="path796"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 137.910004 L 507.320007 138.359985 L 507.320007 137.559998 L 508.290009 137.080017 L 508.290009 137.910004 Z"
      />
      <path
        id="path797"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 139.799988 L 507.320007 140.23999 L 507.320007 139.419983 L 508.290009 138.960022 L 508.290009 139.799988 Z"
      />
      <path
        id="path798"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 141.700012 L 507.320007 142.119995 L 507.320007 141.289978 L 508.290009 140.839996 L 508.290009 141.700012 Z"
      />
      <path
        id="path799"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 143.589996 L 507.320007 144 L 507.320007 143.149994 L 508.290009 142.720001 L 508.290009 143.589996 Z"
      />
      <path
        id="path800"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 145.48999 L 507.320007 145.880005 L 507.320007 145.01001 L 508.290009 144.600006 L 508.290009 145.48999 Z"
      />
      <path
        id="path801"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 147.380005 L 507.320007 147.76001 L 507.320007 146.869995 L 508.290009 146.470001 L 508.290009 147.380005 Z"
      />
      <path
        id="path802"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 149.279999 L 507.329987 149.640015 L 507.329987 148.73999 L 508.290009 148.350006 L 508.290009 149.279999 Z"
      />
      <path
        id="path803"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 151.169983 L 507.329987 151.52002 L 507.329987 150.600006 L 508.290009 150.22998 L 508.290009 151.169983 Z"
      />
      <path
        id="path804"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 153.070007 L 507.329987 153.399994 L 507.329987 152.460022 L 508.290009 152.109985 L 508.290009 153.070007 Z"
      />
      <path
        id="path805"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 156.859985 L 507.329987 157.160004 L 507.329987 156.190002 L 508.290009 155.869995 L 508.290009 156.859985 Z"
      />
      <path
        id="path806"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 158.75 L 507.329987 159.039978 L 507.329987 158.049988 L 508.290009 157.75 L 508.290009 158.75 Z"
      />
      <path
        id="path807"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 162.539978 L 507.329987 162.799988 L 507.329987 161.779999 L 508.290009 161.5 L 508.290009 162.539978 Z"
      />
      <path
        id="path808"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 164.440002 L 507.329987 164.679993 L 507.329987 163.640015 L 508.290009 163.380005 L 508.290009 164.440002 Z"
      />
      <path
        id="path809"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 166.330017 L 507.329987 166.559998 L 507.329987 165.51001 L 508.290009 165.26001 L 508.290009 166.330017 Z"
      />
      <path
        id="path810"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 168.22998 L 507.329987 168.440002 L 507.329987 167.369995 L 508.290009 167.140015 L 508.290009 168.22998 Z"
      />
      <path
        id="path811"
        fill="#cecece"
        stroke="none"
        d="M 508.290009 172.01001 L 507.329987 172.200012 L 507.329987 171.100006 L 508.290009 170.899994 L 508.290009 172.01001 Z"
      />
      <path
        id="path812"
        fill="#cecece"
        stroke="none"
        d="M 508.279999 173.910004 L 507.329987 174.080017 L 507.329987 172.960022 L 508.279999 172.77002 L 508.279999 173.910004 Z"
      />
      <path
        id="path813"
        fill="#cecece"
        stroke="none"
        d="M 508.279999 177.700012 L 507.329987 177.839996 L 507.329987 176.690002 L 508.279999 176.529999 L 508.279999 177.700012 Z"
      />
      <path
        id="path814"
        fill="#cecece"
        stroke="none"
        d="M 508.279999 183.380005 L 507.339996 183.48999 L 507.339996 182.279999 L 508.279999 182.169983 L 508.279999 183.380005 Z"
      />
      <path
        id="path815"
        fill="#cecece"
        stroke="none"
        d="M 508.279999 189.070007 L 507.339996 189.130005 L 507.339996 187.869995 L 508.279999 187.799988 L 508.279999 189.070007 Z"
      />
      <path
        id="path816"
        fill="#cecece"
        stroke="none"
        d="M 508.279999 194.75 L 507.339996 194.77002 L 507.339996 193.450012 L 508.279999 193.440002 L 508.279999 194.75 Z"
      />
      <path
        id="path817"
        fill="#cecece"
        stroke="none"
        d="M 508.779999 129.359985 L 509.73999 128.820007 L 509.73999 129.580017 L 508.779999 130.089996 L 508.779999 129.359985 Z"
      />
      <path
        id="path818"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 131.5 L 508.779999 131.98999 L 508.779999 131.23999 L 509.73999 130.720001 L 509.73999 131.5 Z"
      />
      <path
        id="path819"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 133.410004 L 508.779999 133.890015 L 508.779999 133.130005 L 509.73999 132.619995 L 509.73999 133.410004 Z"
      />
      <path
        id="path820"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 135.330017 L 508.779999 135.789978 L 508.779999 135.01001 L 509.73999 134.52002 L 509.73999 135.330017 Z"
      />
      <path
        id="path821"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 137.25 L 508.779999 137.700012 L 508.779999 136.899994 L 509.73999 136.419983 L 509.73999 137.25 Z"
      />
      <path
        id="path822"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 139.160004 L 508.779999 139.600006 L 508.779999 138.779999 L 509.73999 138.320007 L 509.73999 139.160004 Z"
      />
      <path
        id="path823"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 141.080017 L 508.779999 141.5 L 508.779999 140.669983 L 509.73999 140.220001 L 509.73999 141.080017 Z"
      />
      <path
        id="path824"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 143 L 508.779999 143.399994 L 508.779999 142.549988 L 509.73999 142.119995 L 509.73999 143 Z"
      />
      <path
        id="path825"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 144.910004 L 508.779999 145.299988 L 508.779999 144.440002 L 509.73999 144.02002 L 509.73999 144.910004 Z"
      />
      <path
        id="path826"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 146.830017 L 508.779999 147.200012 L 508.779999 146.320007 L 509.73999 145.919983 L 509.73999 146.830017 Z"
      />
      <path
        id="path827"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 148.73999 L 508.779999 149.109985 L 508.779999 148.210022 L 509.73999 147.820007 L 509.73999 148.73999 Z"
      />
      <path
        id="path828"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 152.580017 L 508.779999 152.910004 L 508.779999 151.970001 L 509.73999 151.619995 L 509.73999 152.580017 Z"
      />
      <path
        id="path829"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 156.410004 L 508.779999 156.710022 L 508.779999 155.73999 L 509.73999 155.419983 L 509.73999 156.410004 Z"
      />
      <path
        id="path830"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 158.320007 L 508.779999 158.609985 L 508.779999 157.630005 L 509.73999 157.320007 L 509.73999 158.320007 Z"
      />
      <path
        id="path831"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 162.160004 L 508.779999 162.419983 L 508.779999 161.399994 L 509.73999 161.119995 L 509.73999 162.160004 Z"
      />
      <path
        id="path832"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 164.070007 L 508.779999 164.320007 L 508.779999 163.279999 L 509.73999 163.02002 L 509.73999 164.070007 Z"
      />
      <path
        id="path833"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 167.910004 L 508.779999 168.119995 L 508.779999 167.049988 L 509.73999 166.820007 L 509.73999 167.910004 Z"
      />
      <path
        id="path834"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 171.73999 L 508.790009 171.929993 L 508.790009 170.820007 L 509.73999 170.619995 L 509.73999 171.73999 Z"
      />
      <path
        id="path835"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 173.649994 L 508.790009 173.830017 L 508.790009 172.700012 L 509.73999 172.52002 L 509.73999 173.649994 Z"
      />
      <path
        id="path836"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 175.570007 L 508.790009 175.72998 L 508.790009 174.589996 L 509.73999 174.419983 L 509.73999 175.570007 Z"
      />
      <path
        id="path837"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 177.48999 L 508.790009 177.630005 L 508.790009 176.470001 L 509.73999 176.320007 L 509.73999 177.48999 Z"
      />
      <path
        id="path838"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 181.320007 L 508.790009 181.429993 L 508.790009 180.23999 L 509.73999 180.119995 L 509.73999 181.320007 Z"
      />
      <path
        id="path839"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 185.149994 L 508.790009 185.23999 L 508.790009 184.01001 L 509.73999 183.919983 L 509.73999 185.149994 Z"
      />
      <path
        id="path840"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 187.070007 L 508.790009 187.140015 L 508.790009 185.890015 L 509.73999 185.820007 L 509.73999 187.070007 Z"
      />
      <path
        id="path841"
        fill="#cecece"
        stroke="none"
        d="M 509.73999 190.899994 L 508.790009 190.940002 L 508.790009 189.660004 L 509.73999 189.619995 L 509.73999 190.899994 Z"
      />
      <path
        id="path842"
        fill="#cecece"
        stroke="none"
        d="M 510.26001 128.630005 L 511.230011 128.089996 L 511.230011 128.850006 L 510.26001 129.359985 L 510.26001 128.630005 Z"
      />
      <path
        id="path843"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 130.789978 L 510.26001 131.279999 L 510.26001 130.539978 L 511.230011 130.01001 L 511.230011 130.789978 Z"
      />
      <path
        id="path844"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 134.669983 L 510.269989 135.130005 L 510.269989 134.350006 L 511.230011 133.850006 L 511.230011 134.669983 Z"
      />
      <path
        id="path845"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 136.600006 L 510.269989 137.049988 L 510.269989 136.25 L 511.230011 135.779999 L 511.230011 136.600006 Z"
      />
      <path
        id="path846"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 138.539978 L 510.269989 138.970001 L 510.269989 138.160004 L 511.230011 137.700012 L 511.230011 138.539978 Z"
      />
      <path
        id="path847"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 140.47998 L 510.269989 140.899994 L 510.269989 140.059998 L 511.230011 139.619995 L 511.230011 140.47998 Z"
      />
      <path
        id="path848"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 144.350006 L 510.269989 144.73999 L 510.269989 143.869995 L 511.230011 143.460022 L 511.230011 144.350006 Z"
      />
      <path
        id="path849"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 146.289978 L 510.269989 146.660004 L 510.269989 145.779999 L 511.230011 145.380005 L 511.230011 146.289978 Z"
      />
      <path
        id="path850"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 148.220001 L 510.269989 148.589996 L 510.269989 147.690002 L 511.230011 147.299988 L 511.230011 148.220001 Z"
      />
      <path
        id="path851"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 150.160004 L 510.269989 150.51001 L 510.269989 149.589996 L 511.230011 149.220001 L 511.230011 150.160004 Z"
      />
      <path
        id="path852"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 152.100006 L 510.269989 152.429993 L 510.269989 151.5 L 511.230011 151.140015 L 511.230011 152.100006 Z"
      />
      <path
        id="path853"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 154.039978 L 510.269989 154.350006 L 510.269989 153.399994 L 511.230011 153.059998 L 511.230011 154.039978 Z"
      />
      <path
        id="path854"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 155.970001 L 510.269989 156.279999 L 510.269989 155.309998 L 511.230011 154.97998 L 511.230011 155.970001 Z"
      />
      <path
        id="path855"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 157.910004 L 510.279999 158.200012 L 510.279999 157.210022 L 511.230011 156.899994 L 511.230011 157.910004 Z"
      />
      <path
        id="path856"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 161.779999 L 510.279999 162.039978 L 510.279999 161.02002 L 511.23999 160.73999 L 511.23999 161.779999 Z"
      />
      <path
        id="path857"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 163.720001 L 510.279999 163.970001 L 510.279999 162.929993 L 511.23999 162.669983 L 511.23999 163.720001 Z"
      />
      <path
        id="path858"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 165.660004 L 510.279999 165.890015 L 510.279999 164.830017 L 511.23999 164.589996 L 511.23999 165.660004 Z"
      />
      <path
        id="path859"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 167.589996 L 510.279999 167.809998 L 510.279999 166.73999 L 511.23999 166.51001 L 511.23999 167.589996 Z"
      />
      <path
        id="path860"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 169.529999 L 510.279999 169.72998 L 510.279999 168.640015 L 511.23999 168.429993 L 511.23999 169.529999 Z"
      />
      <path
        id="path861"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 171.470001 L 510.279999 171.660004 L 510.279999 170.549988 L 511.23999 170.350006 L 511.23999 171.470001 Z"
      />
      <path
        id="path862"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 175.339996 L 510.279999 175.5 L 510.279999 174.359985 L 511.23999 174.190002 L 511.23999 175.339996 Z"
      />
      <path
        id="path863"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 177.279999 L 510.279999 177.419983 L 510.279999 176.26001 L 511.23999 176.109985 L 511.23999 177.279999 Z"
      />
      <path
        id="path864"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 181.149994 L 510.290009 181.27002 L 510.290009 180.080017 L 511.23999 179.950012 L 511.23999 181.149994 Z"
      />
      <path
        id="path865"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 185.029999 L 510.290009 185.109985 L 510.290009 183.890015 L 511.23999 183.789978 L 511.23999 185.029999 Z"
      />
      <path
        id="path866"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 186.960022 L 510.290009 187.039978 L 510.290009 185.789978 L 511.23999 185.710022 L 511.23999 186.960022 Z"
      />
      <path
        id="path867"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 188.899994 L 510.290009 188.960022 L 510.290009 187.700012 L 511.23999 187.630005 L 511.23999 188.899994 Z"
      />
      <path
        id="path868"
        fill="#cecece"
        stroke="none"
        d="M 511.220001 191.940002 L 510.269989 191.97998 L 510.269989 190.710022 L 511.220001 190.660004 L 511.220001 191.940002 Z"
      />
      <path
        id="path869"
        fill="#cecece"
        stroke="none"
        d="M 511.23999 192.77002 L 510.290009 192.799988 L 510.290009 191.51001 L 511.23999 191.47998 L 511.23999 192.77002 Z"
      />
      <path
        id="path870"
        fill="#cecece"
        stroke="none"
        d="M 511.230011 195.320007 L 510.290009 195.320007 L 510.290009 196.649994 L 511.230011 196.649994 L 511.230011 195.320007 Z"
      />
      <path
        id="path871"
        fill="#cecece"
        stroke="none"
        d="M 511.809998 127.899994 L 512.789978 127.350006 L 512.789978 128.119995 L 511.809998 128.630005 L 511.809998 127.899994 Z"
      />
      <path
        id="path872"
        fill="#cecece"
        stroke="none"
        d="M 512.789978 130.080017 L 511.809998 130.570007 L 511.809998 129.820007 L 512.789978 129.289978 L 512.789978 130.080017 Z"
      />
      <path
        id="path873"
        fill="#cecece"
        stroke="none"
        d="M 512.780029 132.029999 L 511.809998 132.52002 L 511.809998 131.75 L 512.780029 131.23999 L 512.780029 132.029999 Z"
      />
      <path
        id="path874"
        fill="#cecece"
        stroke="none"
        d="M 512.780029 133.98999 L 511.809998 134.460022 L 511.809998 133.669983 L 512.780029 133.179993 L 512.780029 133.98999 Z"
      />
      <path
        id="path875"
        fill="#cecece"
        stroke="none"
        d="M 512.780029 135.950012 L 511.809998 136.399994 L 511.809998 135.600006 L 512.780029 135.119995 L 512.780029 135.950012 Z"
      />
      <path
        id="path876"
        fill="#cecece"
        stroke="none"
        d="M 512.780029 137.910004 L 511.809998 138.350006 L 511.809998 137.529999 L 512.780029 137.059998 L 512.780029 137.910004 Z"
      />
      <path
        id="path877"
        fill="#cecece"
        stroke="none"
        d="M 512.780029 139.869995 L 511.809998 140.289978 L 511.809998 139.450012 L 512.780029 139 L 512.780029 139.869995 Z"
      />
      <path
        id="path878"
        fill="#cecece"
        stroke="none"
        d="M 512.780029 141.820007 L 511.809998 142.22998 L 511.809998 141.380005 L 512.780029 140.950012 L 512.780029 141.820007 Z"
      />
      <path
        id="path879"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 143.779999 L 511.809998 144.179993 L 511.809998 143.309998 L 512.77002 142.890015 L 512.77002 143.779999 Z"
      />
      <path
        id="path880"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 145.73999 L 511.809998 146.119995 L 511.809998 145.22998 L 512.77002 144.830017 L 512.77002 145.73999 Z"
      />
      <path
        id="path881"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 147.700012 L 511.809998 148.059998 L 511.809998 147.160004 L 512.77002 146.77002 L 512.77002 147.700012 Z"
      />
      <path
        id="path882"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 149.660004 L 511.809998 150.01001 L 511.809998 149.089996 L 512.77002 148.710022 L 512.77002 149.660004 Z"
      />
      <path
        id="path883"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 151.609985 L 511.809998 151.950012 L 511.809998 151.01001 L 512.77002 150.649994 L 512.77002 151.609985 Z"
      />
      <path
        id="path884"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 153.570007 L 511.799988 153.890015 L 511.799988 152.940002 L 512.77002 152.600006 L 512.77002 153.570007 Z"
      />
      <path
        id="path885"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 155.529999 L 511.799988 155.839996 L 511.799988 154.859985 L 512.77002 154.539978 L 512.77002 155.529999 Z"
      />
      <path
        id="path886"
        fill="#cecece"
        stroke="none"
        d="M 512.77002 157.48999 L 511.799988 157.779999 L 511.799988 156.789978 L 512.77002 156.47998 L 512.77002 157.48999 Z"
      />
      <path
        id="path887"
        fill="#cecece"
        stroke="none"
        d="M 512.76001 159.450012 L 511.799988 159.720001 L 511.799988 158.720001 L 512.76001 158.419983 L 512.76001 159.450012 Z"
      />
      <path
        id="path888"
        fill="#cecece"
        stroke="none"
        d="M 512.76001 161.399994 L 511.799988 161.669983 L 511.799988 160.640015 L 512.76001 160.359985 L 512.76001 161.399994 Z"
      />
      <path
        id="path889"
        fill="#cecece"
        stroke="none"
        d="M 512.76001 165.320007 L 511.799988 165.549988 L 511.799988 164.5 L 512.76001 164.25 L 512.76001 165.320007 Z"
      />
      <path
        id="path890"
        fill="#cecece"
        stroke="none"
        d="M 512.76001 167.279999 L 511.799988 167.5 L 511.799988 166.419983 L 512.76001 166.190002 L 512.76001 167.279999 Z"
      />
      <path
        id="path891"
        fill="#cecece"
        stroke="none"
        d="M 512.76001 169.23999 L 511.799988 169.440002 L 511.799988 168.350006 L 512.76001 168.130005 L 512.76001 169.23999 Z"
      />
      <path
        id="path892"
        fill="#cecece"
        stroke="none"
        d="M 512.76001 171.190002 L 511.799988 171.380005 L 511.799988 170.279999 L 512.76001 170.070007 L 512.76001 171.190002 Z"
      />
      <path
        id="path893"
        fill="#cecece"
        stroke="none"
        d="M 512.75 173.149994 L 511.799988 173.330017 L 511.799988 172.200012 L 512.75 172.02002 L 512.75 173.149994 Z"
      />
      <path
        id="path894"
        fill="#cecece"
        stroke="none"
        d="M 512.75 175.109985 L 511.799988 175.27002 L 511.799988 174.130005 L 512.75 173.960022 L 512.75 175.109985 Z"
      />
      <path
        id="path895"
        fill="#cecece"
        stroke="none"
        d="M 512.75 179.029999 L 511.799988 179.160004 L 511.799988 177.97998 L 512.75 177.839996 L 512.75 179.029999 Z"
      />
      <path
        id="path896"
        fill="#cecece"
        stroke="none"
        d="M 512.75 180.97998 L 511.799988 181.100006 L 511.799988 179.910004 L 512.75 179.779999 L 512.75 180.97998 Z"
      />
      <path
        id="path897"
        fill="#cecece"
        stroke="none"
        d="M 512.75 182.940002 L 511.799988 183.039978 L 511.799988 181.830017 L 512.75 181.720001 L 512.75 182.940002 Z"
      />
      <path
        id="path898"
        fill="#cecece"
        stroke="none"
        d="M 512.73999 186.859985 L 511.799988 186.929993 L 511.799988 185.690002 L 512.73999 185.609985 L 512.73999 186.859985 Z"
      />
      <path
        id="path899"
        fill="#cecece"
        stroke="none"
        d="M 512.73999 190.77002 L 511.790009 190.820007 L 511.790009 189.539978 L 512.73999 189.48999 L 512.73999 190.77002 Z"
      />
      <path
        id="path900"
        fill="#cecece"
        stroke="none"
        d="M 514.47998 126.730011 L 514.47998 127.470001 L 513.320007 127.850006 L 513.320007 127.179993 L 514.47998 126.730011 Z"
      />
      <path
        id="path901"
        fill="#cecece"
        stroke="none"
        d="M 514.47998 129.450012 L 513.320007 129.809998 L 513.320007 129.130005 L 514.47998 128.690002 L 514.47998 129.450012 Z"
      />
      <path
        id="path902"
        fill="#cecece"
        stroke="none"
        d="M 514.47998 131.429993 L 513.320007 131.779999 L 513.320007 131.080017 L 514.47998 130.649994 L 514.47998 131.429993 Z"
      />
      <path
        id="path903"
        fill="#cecece"
        stroke="none"
        d="M 514.47998 133.399994 L 513.320007 133.75 L 513.320007 133.02002 L 514.47998 132.609985 L 514.47998 133.399994 Z"
      />
      <path
        id="path904"
        fill="#cecece"
        stroke="none"
        d="M 514.47998 135.380005 L 513.320007 135.710022 L 513.320007 134.970001 L 514.47998 134.570007 L 514.47998 135.380005 Z"
      />
      <path
        id="path905"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 139.330017 L 513.320007 139.640015 L 513.320007 138.859985 L 514.469971 138.48999 L 514.469971 139.330017 Z"
      />
      <path
        id="path906"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 141.309998 L 513.320007 141.609985 L 513.320007 140.809998 L 514.469971 140.450012 L 514.469971 141.309998 Z"
      />
      <path
        id="path907"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 143.289978 L 513.320007 143.570007 L 513.320007 142.76001 L 514.469971 142.410004 L 514.469971 143.289978 Z"
      />
      <path
        id="path908"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 145.26001 L 513.320007 145.539978 L 513.320007 144.700012 L 514.469971 144.369995 L 514.469971 145.26001 Z"
      />
      <path
        id="path909"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 147.23999 L 513.320007 147.51001 L 513.320007 146.649994 L 514.469971 146.330017 L 514.469971 147.23999 Z"
      />
      <path
        id="path910"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 149.220001 L 513.330017 149.470001 L 513.330017 148.600006 L 514.469971 148.289978 L 514.469971 149.220001 Z"
      />
      <path
        id="path911"
        fill="#cecece"
        stroke="none"
        d="M 514.469971 151.190002 L 513.330017 151.440002 L 513.330017 150.539978 L 514.469971 150.23999 L 514.469971 151.190002 Z"
      />
      <path
        id="path912"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 153.169983 L 513.330017 153.399994 L 513.330017 152.48999 L 514.460022 152.210022 L 514.460022 153.169983 Z"
      />
      <path
        id="path913"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 155.140015 L 513.330017 155.369995 L 513.330017 154.440002 L 514.460022 154.160004 L 514.460022 155.140015 Z"
      />
      <path
        id="path914"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 157.119995 L 513.330017 157.330017 L 513.330017 156.380005 L 514.460022 156.119995 L 514.460022 157.119995 Z"
      />
      <path
        id="path915"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 159.100006 L 513.330017 159.299988 L 513.330017 158.330017 L 514.460022 158.080017 L 514.460022 159.100006 Z"
      />
      <path
        id="path916"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 161.070007 L 513.330017 161.27002 L 513.330017 160.279999 L 514.460022 160.039978 L 514.460022 161.070007 Z"
      />
      <path
        id="path917"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 163.049988 L 513.330017 163.22998 L 513.330017 162.220001 L 514.460022 162 L 514.460022 163.049988 Z"
      />
      <path
        id="path918"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 165.029999 L 513.330017 165.200012 L 513.330017 164.169983 L 514.460022 163.960022 L 514.460022 165.029999 Z"
      />
      <path
        id="path919"
        fill="#cecece"
        stroke="none"
        d="M 514.460022 167 L 513.330017 167.160004 L 513.330017 166.119995 L 514.460022 165.919983 L 514.460022 167 Z"
      />
      <path
        id="path920"
        fill="#cecece"
        stroke="none"
        d="M 514.450012 168.97998 L 513.330017 169.130005 L 513.330017 168.059998 L 514.450012 167.880005 L 514.450012 168.97998 Z"
      />
      <path
        id="path921"
        fill="#cecece"
        stroke="none"
        d="M 514.450012 170.960022 L 513.330017 171.089996 L 513.330017 170.01001 L 514.450012 169.839996 L 514.450012 170.960022 Z"
      />
      <path
        id="path922"
        fill="#cecece"
        stroke="none"
        d="M 514.450012 172.929993 L 513.330017 173.059998 L 513.330017 171.960022 L 514.450012 171.799988 L 514.450012 172.929993 Z"
      />
      <path
        id="path923"
        fill="#cecece"
        stroke="none"
        d="M 514.450012 174.910004 L 513.330017 175.029999 L 513.330017 173.899994 L 514.450012 173.76001 L 514.450012 174.910004 Z"
      />
      <path
        id="path924"
        fill="#cecece"
        stroke="none"
        d="M 514.450012 176.880005 L 513.330017 176.98999 L 513.330017 175.850006 L 514.450012 175.720001 L 514.450012 176.880005 Z"
      />
      <path
        id="path925"
        fill="#cecece"
        stroke="none"
        d="M 514.450012 178.859985 L 513.340027 178.960022 L 513.340027 177.799988 L 514.450012 177.679993 L 514.450012 178.859985 Z"
      />
      <path
        id="path926"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 182.809998 L 513.340027 182.890015 L 513.340027 181.690002 L 514.440002 181.600006 L 514.440002 182.809998 Z"
      />
      <path
        id="path927"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 184.789978 L 513.340027 184.850006 L 513.340027 183.640015 L 514.440002 183.559998 L 514.440002 184.789978 Z"
      />
      <path
        id="path928"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 188.73999 L 513.340027 188.779999 L 513.340027 187.529999 L 514.440002 187.47998 L 514.440002 188.73999 Z"
      />
      <path
        id="path929"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 190.720001 L 513.340027 190.75 L 513.340027 189.47998 L 514.440002 189.440002 L 514.440002 190.720001 Z"
      />
      <path
        id="path930"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 192.690002 L 513.340027 192.720001 L 513.340027 191.419983 L 514.440002 191.399994 L 514.440002 192.690002 Z"
      />
      <path
        id="path931"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 194.669983 L 513.340027 194.679993 L 513.340027 193.369995 L 514.440002 193.359985 L 514.440002 194.669983 Z"
      />
      <path
        id="path932"
        fill="#cecece"
        stroke="none"
        d="M 514.440002 195.320007 L 513.340027 195.320007 L 513.340027 196.649994 L 514.440002 196.649994 L 514.440002 195.320007 Z"
      />
      <path
        id="path933"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 142.27002 L 558.76001 143.309998 L 560.340027 143.190002 L 560.340027 142.089996 L 558.76001 142.27002 Z"
      />
      <path
        id="path934"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 144.119995 L 558.76001 145.160004 L 560.340027 145.039978 L 560.340027 143.950012 L 558.76001 144.119995 Z"
      />
      <path
        id="path935"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 147.820007 L 558.76001 148.859985 L 560.340027 148.76001 L 560.340027 147.669983 L 558.76001 147.820007 Z"
      />
      <path
        id="path936"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 149.669983 L 558.76001 150.710022 L 560.340027 150.619995 L 560.340027 149.529999 L 558.76001 149.669983 Z"
      />
      <path
        id="path937"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 151.529999 L 558.76001 152.559998 L 560.340027 152.47998 L 560.340027 151.390015 L 558.76001 151.529999 Z"
      />
      <path
        id="path938"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 153.380005 L 558.76001 154.410004 L 560.340027 154.330017 L 560.340027 153.26001 L 558.76001 153.380005 Z"
      />
      <path
        id="path939"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 157.080017 L 558.76001 158.109985 L 560.340027 158.049988 L 560.340027 156.97998 L 558.76001 157.080017 Z"
      />
      <path
        id="path940"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 158.929993 L 558.76001 159.960022 L 560.340027 159.910004 L 560.340027 158.839996 L 558.76001 158.929993 Z"
      />
      <path
        id="path941"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 160.779999 L 558.76001 161.809998 L 560.340027 161.76001 L 560.340027 160.700012 L 558.76001 160.779999 Z"
      />
      <path
        id="path942"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 164.47998 L 558.76001 165.51001 L 560.340027 165.47998 L 560.340027 164.429993 L 558.76001 164.47998 Z"
      />
      <path
        id="path943"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 166.330017 L 558.76001 167.369995 L 560.340027 167.339996 L 560.340027 166.289978 L 558.76001 166.330017 Z"
      />
      <path
        id="path944"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 170.029999 L 558.76001 171.070007 L 560.340027 171.049988 L 560.340027 170.01001 L 558.76001 170.029999 Z"
      />
      <path
        id="path945"
        fill="#cecece"
        stroke="none"
        d="M 560.340027 173.72998 L 558.76001 173.72998 L 558.76001 174.76001 L 560.340027 174.76001 L 560.340027 173.72998 Z"
      />
      <path
        id="path946"
        fill="#cecece"
        stroke="none"
        d="M 560.950012 142.02002 L 560.950012 143.119995 L 562.450012 143.049988 L 562.450012 141.929993 L 560.950012 142.02002 Z"
      />
      <path
        id="path947"
        fill="#cecece"
        stroke="none"
        d="M 560.950012 143.880005 L 560.950012 144.97998 L 562.450012 144.919983 L 562.450012 143.799988 L 560.950012 143.880005 Z"
      />
      <path
        id="path948"
        fill="#cecece"
        stroke="none"
        d="M 560.950012 145.75 L 560.950012 146.850006 L 562.450012 146.779999 L 562.450012 145.669983 L 560.950012 145.75 Z"
      />
      <path
        id="path949"
        fill="#cecece"
        stroke="none"
        d="M 560.940002 149.47998 L 560.940002 150.570007 L 562.450012 150.51001 L 562.450012 149.419983 L 560.940002 149.47998 Z"
      />
      <path
        id="path950"
        fill="#cecece"
        stroke="none"
        d="M 560.940002 151.350006 L 560.940002 152.429993 L 562.450012 152.380005 L 562.450012 151.289978 L 560.940002 151.350006 Z"
      />
      <path
        id="path951"
        fill="#cecece"
        stroke="none"
        d="M 560.940002 155.080017 L 560.940002 156.149994 L 562.450012 156.109985 L 562.450012 155.029999 L 560.940002 155.080017 Z"
      />
      <path
        id="path952"
        fill="#cecece"
        stroke="none"
        d="M 560.929993 156.940002 L 560.929993 158.01001 L 562.450012 157.97998 L 562.450012 156.899994 L 560.929993 156.940002 Z"
      />
      <path
        id="path953"
        fill="#cecece"
        stroke="none"
        d="M 560.929993 158.809998 L 560.929993 159.880005 L 562.450012 159.839996 L 562.450012 158.77002 L 560.929993 158.809998 Z"
      />
      <path
        id="path954"
        fill="#cecece"
        stroke="none"
        d="M 560.929993 160.669983 L 560.929993 161.73999 L 562.450012 161.710022 L 562.450012 160.640015 L 560.929993 160.669983 Z"
      />
      <path
        id="path955"
        fill="#cecece"
        stroke="none"
        d="M 560.929993 162.539978 L 560.929993 163.600006 L 562.450012 163.570007 L 562.450012 162.51001 L 560.929993 162.539978 Z"
      />
      <path
        id="path956"
        fill="#cecece"
        stroke="none"
        d="M 560.929993 164.410004 L 560.929993 165.460022 L 562.450012 165.440002 L 562.450012 164.380005 L 560.929993 164.410004 Z"
      />
      <path
        id="path957"
        fill="#cecece"
        stroke="none"
        d="M 560.919983 168.140015 L 560.919983 169.179993 L 562.450012 169.169983 L 562.450012 168.119995 L 560.919983 168.140015 Z"
      />
      <path
        id="path958"
        fill="#cecece"
        stroke="none"
        d="M 560.919983 170 L 560.919983 171.039978 L 562.450012 171.039978 L 562.450012 169.98999 L 560.919983 170 Z"
      />
      <path
        id="path959"
        fill="#cecece"
        stroke="none"
        d="M 562.450012 173.72998 L 560.919983 173.72998 L 560.919983 174.76001 L 562.450012 174.76001 L 562.450012 173.72998 Z"
      />
      <path
        id="path960"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 141.880005 L 563.099976 142.97998 L 564.650024 142.940002 L 564.650024 141.830017 L 563.099976 141.880005 Z"
      />
      <path
        id="path961"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 143.76001 L 563.099976 144.850006 L 564.650024 144.809998 L 564.650024 143.710022 L 563.099976 143.76001 Z"
      />
      <path
        id="path962"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 145.630005 L 563.099976 146.720001 L 564.650024 146.690002 L 564.650024 145.580017 L 563.099976 145.630005 Z"
      />
      <path
        id="path963"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 147.51001 L 563.099976 148.589996 L 564.650024 148.559998 L 564.650024 147.460022 L 563.099976 147.51001 Z"
      />
      <path
        id="path964"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 149.380005 L 563.099976 150.460022 L 564.650024 150.429993 L 564.650024 149.339996 L 563.099976 149.380005 Z"
      />
      <path
        id="path965"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 151.25 L 563.099976 152.330017 L 564.650024 152.299988 L 564.650024 151.210022 L 563.099976 151.25 Z"
      />
      <path
        id="path966"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 153.130005 L 563.099976 154.200012 L 564.659973 154.169983 L 564.659973 153.089996 L 563.099976 153.130005 Z"
      />
      <path
        id="path967"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 155 L 563.099976 156.070007 L 564.659973 156.049988 L 564.659973 154.970001 L 563.099976 155 Z"
      />
      <path
        id="path968"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 158.75 L 563.099976 159.809998 L 564.659973 159.789978 L 564.659973 158.720001 L 563.099976 158.75 Z"
      />
      <path
        id="path969"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 162.48999 L 563.099976 163.549988 L 564.659973 163.529999 L 564.659973 162.470001 L 563.099976 162.48999 Z"
      />
      <path
        id="path970"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 166.23999 L 563.099976 167.289978 L 564.659973 167.279999 L 564.659973 166.22998 L 563.099976 166.23999 Z"
      />
      <path
        id="path971"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 168.109985 L 563.099976 169.160004 L 564.659973 169.149994 L 564.659973 168.100006 L 563.099976 168.109985 Z"
      />
      <path
        id="path972"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 169.98999 L 563.099976 171.029999 L 564.659973 171.02002 L 564.659973 169.97998 L 563.099976 169.98999 Z"
      />
      <path
        id="path973"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 171.859985 L 563.099976 172.899994 L 564.659973 172.899994 L 564.659973 171.859985 L 563.099976 171.859985 Z"
      />
      <path
        id="path974"
        fill="#cecece"
        stroke="none"
        d="M 566.75 141.809998 L 565.380005 141.809998 L 565.380005 142.929993 L 566.75 142.929993 L 566.75 141.809998 Z"
      />
      <path
        id="path975"
        fill="#cecece"
        stroke="none"
        d="M 566.75 143.690002 L 565.380005 143.690002 L 565.380005 144.799988 L 566.75 144.799988 L 566.75 143.690002 Z"
      />
      <path
        id="path976"
        fill="#cecece"
        stroke="none"
        d="M 566.75 145.570007 L 565.380005 145.570007 L 565.380005 146.679993 L 566.75 146.679993 L 566.75 145.570007 Z"
      />
      <path
        id="path977"
        fill="#cecece"
        stroke="none"
        d="M 566.75 147.440002 L 565.380005 147.440002 L 565.380005 148.539978 L 566.75 148.539978 L 566.75 147.440002 Z"
      />
      <path
        id="path978"
        fill="#cecece"
        stroke="none"
        d="M 566.75 149.320007 L 565.380005 149.320007 L 565.380005 150.419983 L 566.75 150.419983 L 566.75 149.320007 Z"
      />
      <path
        id="path979"
        fill="#cecece"
        stroke="none"
        d="M 566.75 151.200012 L 565.380005 151.200012 L 565.380005 152.289978 L 566.75 152.289978 L 566.75 151.200012 Z"
      />
      <path
        id="path980"
        fill="#cecece"
        stroke="none"
        d="M 566.75 153.080017 L 565.380005 153.080017 L 565.380005 154.169983 L 566.75 154.169983 L 566.75 153.080017 Z"
      />
      <path
        id="path981"
        fill="#cecece"
        stroke="none"
        d="M 566.75 154.960022 L 565.380005 154.960022 L 565.380005 156.039978 L 566.75 156.039978 L 566.75 154.960022 Z"
      />
      <path
        id="path982"
        fill="#cecece"
        stroke="none"
        d="M 566.75 156.830017 L 565.380005 156.830017 L 565.380005 157.910004 L 566.75 157.910004 L 566.75 156.830017 Z"
      />
      <path
        id="path983"
        fill="#cecece"
        stroke="none"
        d="M 566.75 160.589996 L 565.380005 160.589996 L 565.380005 161.660004 L 566.75 161.660004 L 566.75 160.589996 Z"
      />
      <path
        id="path984"
        fill="#cecece"
        stroke="none"
        d="M 566.75 162.470001 L 565.380005 162.470001 L 565.380005 163.529999 L 566.75 163.529999 L 566.75 162.470001 Z"
      />
      <path
        id="path985"
        fill="#cecece"
        stroke="none"
        d="M 566.75 164.339996 L 565.380005 164.339996 L 565.380005 165.399994 L 566.75 165.399994 L 566.75 164.339996 Z"
      />
      <path
        id="path986"
        fill="#cecece"
        stroke="none"
        d="M 566.75 166.220001 L 565.380005 166.220001 L 565.380005 167.27002 L 566.75 167.27002 L 566.75 166.220001 Z"
      />
      <path
        id="path987"
        fill="#cecece"
        stroke="none"
        d="M 566.75 168.100006 L 565.380005 168.100006 L 565.380005 169.149994 L 566.75 169.149994 L 566.75 168.100006 Z"
      />
      <path
        id="path988"
        fill="#cecece"
        stroke="none"
        d="M 566.75 169.97998 L 565.380005 169.97998 L 565.380005 171.02002 L 566.75 171.02002 L 566.75 169.97998 Z"
      />
      <path
        id="path989"
        fill="#cecece"
        stroke="none"
        d="M 566.75 173.72998 L 565.380005 173.72998 L 565.380005 174.76001 L 566.75 174.76001 L 566.75 173.72998 Z"
      />
      <path
        id="path990"
        fill="#cecece"
        stroke="none"
        d="M 558.76001 176.799988 L 558.76001 177.830017 L 560.340027 177.809998 L 560.340027 176.77002 L 558.76001 176.799988 Z"
      />
      <path
        id="path991"
        fill="#cecece"
        stroke="none"
        d="M 560.340027 181.589996 L 558.76001 181.589996 L 558.76001 182.619995 L 560.340027 182.619995 L 560.340027 181.589996 Z"
      />
      <path
        id="path992"
        fill="#cecece"
        stroke="none"
        d="M 560.919983 176.77002 L 560.919983 177.809998 L 562.450012 177.799988 L 562.450012 176.75 L 560.919983 176.77002 Z"
      />
      <path
        id="path993"
        fill="#cecece"
        stroke="none"
        d="M 562.450012 181.589996 L 560.919983 181.589996 L 560.919983 182.619995 L 562.450012 182.619995 L 562.450012 181.589996 Z"
      />
      <path
        id="path994"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 176.75 L 563.099976 177.789978 L 564.659973 177.789978 L 564.659973 176.73999 L 563.099976 176.75 Z"
      />
      <path
        id="path995"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 178.619995 L 563.099976 179.660004 L 564.659973 179.660004 L 564.659973 178.619995 L 563.099976 178.619995 Z"
      />
      <path
        id="path996"
        fill="#cecece"
        stroke="none"
        d="M 566.75 176.73999 L 565.380005 176.73999 L 565.380005 177.779999 L 566.75 177.779999 L 566.75 176.73999 Z"
      />
      <path
        id="path997"
        fill="#cecece"
        stroke="none"
        d="M 566.75 181.589996 L 565.380005 181.589996 L 565.380005 182.619995 L 566.75 182.619995 L 566.75 181.589996 Z"
      />
      <path
        id="path998"
        fill="#cecece"
        stroke="none"
        d="M 566.75 179.910004 L 565.380005 179.910004 L 565.380005 180.940002 L 566.75 180.940002 L 566.75 179.910004 Z"
      />
      <path
        id="path999"
        fill="#cecece"
        stroke="none"
        d="M 560.919983 183.190002 L 560.919983 184.22998 L 562.450012 184.220001 L 562.450012 183.179993 L 560.919983 183.190002 Z"
      />
      <path
        id="path1000"
        fill="#cecece"
        stroke="none"
        d="M 562.450012 186.919983 L 560.919983 186.919983 L 560.919983 187.950012 L 562.450012 187.950012 L 562.450012 186.919983 Z"
      />
      <path
        id="path1001"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 183.169983 L 563.099976 184.210022 L 564.659973 184.210022 L 564.659973 183.160004 L 563.099976 183.169983 Z"
      />
      <path
        id="path1002"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 185.039978 L 563.099976 186.080017 L 564.659973 186.080017 L 564.659973 185.039978 L 563.099976 185.039978 Z"
      />
      <path
        id="path1003"
        fill="#cecece"
        stroke="none"
        d="M 566.75 183.160004 L 565.380005 183.160004 L 565.380005 184.200012 L 566.75 184.200012 L 566.75 183.160004 Z"
      />
      <path
        id="path1004"
        fill="#cecece"
        stroke="none"
        d="M 566.75 186.919983 L 565.380005 186.919983 L 565.380005 187.950012 L 566.75 187.950012 L 566.75 186.919983 Z"
      />
      <path
        id="path1005"
        fill="#cecece"
        stroke="none"
        d="M 560.919983 189.950012 L 560.919983 190.98999 L 562.450012 190.97998 L 562.450012 189.940002 L 560.919983 189.950012 Z"
      />
      <path
        id="path1006"
        fill="#cecece"
        stroke="none"
        d="M 564.650024 193.410004 L 563.119995 193.410004 L 563.119995 194.440002 L 564.650024 194.440002 L 564.650024 193.410004 Z"
      />
      <path
        id="path1007"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 189.929993 L 563.099976 190.970001 L 564.659973 190.970001 L 564.659973 189.929993 L 563.099976 189.929993 Z"
      />
      <path
        id="path1008"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 191.809998 L 563.099976 192.839996 L 564.659973 192.839996 L 564.659973 191.799988 L 563.099976 191.809998 Z"
      />
      <path
        id="path1009"
        fill="#cecece"
        stroke="none"
        d="M 566.75 189.919983 L 565.380005 189.919983 L 565.380005 190.960022 L 566.75 190.960022 L 566.75 189.919983 Z"
      />
      <path
        id="path1010"
        fill="#cecece"
        stroke="none"
        d="M 566.75 194.77002 L 565.380005 194.77002 L 565.380005 195.799988 L 566.75 195.799988 L 566.75 194.77002 Z"
      />
      <path
        id="path1011"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 172.130005 L 710.809998 172.130005 L 710.809998 173.160004 L 712.080017 173.160004 L 712.080017 172.130005 Z"
      />
      <path
        id="path1012"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 170.419983 L 712.080017 170.440002 L 712.080017 171.47998 L 711.450012 171.470001 L 710.809998 171.470001 L 710.809998 170.419983 Z"
      />
      <path
        id="path1013"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 168.700012 L 712.080017 168.73999 L 712.080017 169.799988 L 711.450012 169.779999 L 710.809998 169.76001 L 710.809998 168.700012 Z"
      />
      <path
        id="path1014"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 166.98999 L 712.080017 167.039978 L 712.080017 168.119995 L 711.450012 168.089996 L 710.809998 168.059998 L 710.809998 166.98999 Z"
      />
      <path
        id="path1015"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 165.27002 L 712.080017 165.350006 L 712.080017 166.440002 L 711.450012 166.399994 L 710.809998 166.359985 L 710.809998 165.27002 Z"
      />
      <path
        id="path1016"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 163.559998 L 712.080017 163.649994 L 712.080017 164.76001 L 711.450012 164.710022 L 710.809998 164.660004 L 710.809998 163.559998 Z"
      />
      <path
        id="path1017"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 161.839996 L 712.080017 161.950012 L 712.080017 163.080017 L 711.450012 163.02002 L 710.809998 162.960022 L 710.809998 161.839996 Z"
      />
      <path
        id="path1018"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 158.410004 L 712.080017 158.559998 L 712.080017 159.710022 L 711.450012 159.640015 L 710.809998 159.559998 L 710.809998 158.410004 Z"
      />
      <path
        id="path1019"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 156.700012 L 712.080017 156.869995 L 712.080017 158.029999 L 711.450012 157.940002 L 710.809998 157.859985 L 710.809998 156.700012 Z"
      />
      <path
        id="path1020"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 154.97998 L 712.080017 155.169983 L 712.080017 156.350006 L 711.450012 156.25 L 710.809998 156.160004 L 710.809998 154.97998 Z"
      />
      <path
        id="path1021"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 153.27002 L 712.080017 153.470001 L 712.080017 154.669983 L 711.450012 154.559998 L 710.809998 154.460022 L 710.809998 153.27002 Z"
      />
      <path
        id="path1022"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 151.549988 L 712.080017 151.779999 L 712.080017 152.98999 L 711.450012 152.869995 L 710.809998 152.75 L 710.809998 151.549988 Z"
      />
      <path
        id="path1023"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 149.839996 L 710.809998 151.049988 L 711.450012 151.179993 L 712.080017 151.299988 L 712.080017 150.080017 L 710.809998 149.839996 Z"
      />
      <path
        id="path1024"
        fill="#cecece"
        stroke="none"
        d="M 714.159973 172.130005 L 712.890015 172.130005 L 712.890015 173.160004 L 714.159973 173.160004 L 714.159973 172.130005 Z"
      />
      <path
        id="path1025"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 170.450012 L 714.159973 170.470001 L 714.159973 171.52002 L 713.530029 171.51001 L 712.890015 171.5 L 712.890015 170.450012 Z"
      />
      <path
        id="path1026"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 167.080017 L 714.159973 167.140015 L 714.159973 168.220001 L 713.530029 168.190002 L 712.890015 168.160004 L 712.890015 167.080017 Z"
      />
      <path
        id="path1027"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 165.390015 L 714.159973 165.470001 L 714.159973 166.570007 L 713.530029 166.529999 L 712.890015 166.48999 L 712.890015 165.390015 Z"
      />
      <path
        id="path1028"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 163.710022 L 714.159973 163.799988 L 714.159973 164.919983 L 713.530029 164.869995 L 712.890015 164.820007 L 712.890015 163.710022 Z"
      />
      <path
        id="path1029"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 162.029999 L 714.159973 162.140015 L 714.159973 163.27002 L 713.530029 163.210022 L 712.890015 163.149994 L 712.890015 162.029999 Z"
      />
      <path
        id="path1030"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 160.339996 L 714.159973 160.470001 L 714.159973 161.619995 L 713.530029 161.549988 L 712.890015 161.47998 L 712.890015 160.339996 Z"
      />
      <path
        id="path1031"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 158.660004 L 714.159973 158.809998 L 714.159973 159.970001 L 713.530029 159.890015 L 712.890015 159.809998 L 712.890015 158.660004 Z"
      />
      <path
        id="path1032"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 155.289978 L 714.159973 155.470001 L 714.159973 156.660004 L 713.530029 156.570007 L 712.890015 156.470001 L 712.890015 155.289978 Z"
      />
      <path
        id="path1033"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 151.919983 L 714.159973 152.140015 L 714.159973 153.359985 L 713.530029 153.25 L 712.890015 153.130005 L 712.890015 151.919983 Z"
      />
      <path
        id="path1034"
        fill="#cecece"
        stroke="none"
        d="M 712.890015 150.22998 L 712.890015 151.460022 L 713.530029 151.589996 L 714.159973 151.710022 L 714.159973 150.47998 L 712.890015 150.22998 Z"
      />
      <path
        id="path1035"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 170.47998 L 716.27002 170.5 L 716.27002 171.549988 L 715.630005 171.539978 L 714.98999 171.529999 L 714.98999 170.47998 Z"
      />
      <path
        id="path1036"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 168.830017 L 716.27002 168.859985 L 716.27002 169.929993 L 715.630005 169.910004 L 714.98999 169.890015 L 714.98999 168.830017 Z"
      />
      <path
        id="path1037"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 167.169983 L 716.27002 167.22998 L 716.27002 168.309998 L 715.630005 168.279999 L 714.98999 168.25 L 714.98999 167.169983 Z"
      />
      <path
        id="path1038"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 163.859985 L 716.27002 163.960022 L 716.27002 165.080017 L 715.630005 165.029999 L 714.98999 164.97998 L 714.98999 163.859985 Z"
      />
      <path
        id="path1039"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 160.559998 L 716.27002 160.690002 L 716.27002 161.839996 L 715.630005 161.77002 L 714.98999 161.700012 L 714.98999 160.559998 Z"
      />
      <path
        id="path1040"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 158.899994 L 716.27002 159.049988 L 716.27002 160.220001 L 715.630005 160.140015 L 714.98999 160.070007 L 714.98999 158.899994 Z"
      />
      <path
        id="path1041"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 157.25 L 716.27002 157.419983 L 716.27002 158.600006 L 715.630005 158.52002 L 714.98999 158.429993 L 714.98999 157.25 Z"
      />
      <path
        id="path1042"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 155.589996 L 716.27002 155.779999 L 716.27002 156.97998 L 715.630005 156.890015 L 714.98999 156.789978 L 714.98999 155.589996 Z"
      />
      <path
        id="path1043"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 152.289978 L 716.27002 152.51001 L 716.27002 153.75 L 715.630005 153.630005 L 714.98999 153.52002 L 714.98999 152.289978 Z"
      />
      <path
        id="path1044"
        fill="#cecece"
        stroke="none"
        d="M 714.98999 150.630005 L 714.98999 151.880005 L 715.630005 152 L 716.27002 152.130005 L 716.27002 150.880005 L 714.98999 150.630005 Z"
      />
      <path
        id="path1045"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 170.51001 L 718.320007 170.529999 L 718.320007 171.580017 L 717.679993 171.570007 L 717.049988 171.559998 L 717.049988 170.51001 Z"
      />
      <path
        id="path1046"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 168.890015 L 718.320007 168.919983 L 718.320007 169.98999 L 717.679993 169.970001 L 717.049988 169.950012 L 717.049988 168.890015 Z"
      />
      <path
        id="path1047"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 167.26001 L 718.320007 167.320007 L 718.320007 168.410004 L 717.679993 168.380005 L 717.049988 168.350006 L 717.049988 167.26001 Z"
      />
      <path
        id="path1048"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 164.01001 L 718.320007 164.109985 L 718.320007 165.22998 L 717.679993 165.179993 L 717.049988 165.130005 L 717.049988 164.01001 Z"
      />
      <path
        id="path1049"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 162.390015 L 718.320007 162.5 L 718.320007 163.640015 L 717.679993 163.589996 L 717.049988 163.529999 L 717.049988 162.390015 Z"
      />
      <path
        id="path1050"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 160.77002 L 718.320007 160.899994 L 718.320007 162.059998 L 717.679993 161.98999 L 717.049988 161.919983 L 717.049988 160.77002 Z"
      />
      <path
        id="path1051"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 159.140015 L 718.320007 159.289978 L 718.320007 160.470001 L 717.679993 160.390015 L 717.049988 160.320007 L 717.049988 159.140015 Z"
      />
      <path
        id="path1052"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 155.899994 L 718.320007 156.080017 L 718.320007 157.299988 L 717.679993 157.200012 L 717.049988 157.100006 L 717.049988 155.899994 Z"
      />
      <path
        id="path1053"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 154.27002 L 718.320007 154.47998 L 718.320007 155.710022 L 717.679993 155.600006 L 717.049988 155.5 L 717.049988 154.27002 Z"
      />
      <path
        id="path1054"
        fill="#cecece"
        stroke="none"
        d="M 717.049988 151.029999 L 717.049988 152.279999 L 717.679993 152.410004 L 718.320007 152.529999 L 718.320007 151.27002 L 717.049988 151.029999 Z"
      />
      <path
        id="path1055"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 172.130005 L 702.640015 172.130005 L 702.640015 173.160004 L 703.909973 173.160004 L 703.909973 172.130005 Z"
      />
      <path
        id="path1056"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 168.929993 L 703.919983 168.890015 L 703.919983 169.950012 L 703.280029 169.970001 L 702.640015 169.98999 L 702.640015 168.929993 Z"
      />
      <path
        id="path1057"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 167.330017 L 703.919983 167.27002 L 703.919983 168.339996 L 703.280029 168.369995 L 702.640015 168.399994 L 702.640015 167.330017 Z"
      />
      <path
        id="path1058"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 165.72998 L 703.919983 165.649994 L 703.919983 166.72998 L 703.280029 166.77002 L 702.640015 166.809998 L 702.640015 165.72998 Z"
      />
      <path
        id="path1059"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 162.52002 L 703.919983 162.410004 L 703.919983 163.51001 L 703.280029 163.570007 L 702.640015 163.619995 L 702.640015 162.52002 Z"
      />
      <path
        id="path1060"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 160.919983 L 703.919983 160.779999 L 703.919983 161.899994 L 703.280029 161.970001 L 702.640015 162.029999 L 702.640015 160.919983 Z"
      />
      <path
        id="path1061"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 159.320007 L 703.919983 159.160004 L 703.919983 160.289978 L 703.280029 160.369995 L 702.640015 160.440002 L 702.640015 159.320007 Z"
      />
      <path
        id="path1062"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 156.109985 L 703.919983 155.919983 L 703.919983 157.070007 L 703.280029 157.169983 L 702.640015 157.26001 L 702.640015 156.109985 Z"
      />
      <path
        id="path1063"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 154.51001 L 703.919983 154.299988 L 703.919983 155.460022 L 703.280029 155.570007 L 702.640015 155.669983 L 702.640015 154.51001 Z"
      />
      <path
        id="path1064"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 152.910004 L 703.919983 152.679993 L 703.919983 153.850006 L 703.280029 153.970001 L 702.640015 154.080017 L 702.640015 152.910004 Z"
      />
      <path
        id="path1065"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 172.130005 L 704.719971 172.130005 L 704.719971 173.160004 L 705.98999 173.160004 L 705.98999 172.130005 Z"
      />
      <path
        id="path1066"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 170.5 L 706 170.47998 L 706 171.529999 L 705.359985 171.529999 L 704.719971 171.539978 L 704.719971 170.5 Z"
      />
      <path
        id="path1067"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 167.22998 L 706 167.169983 L 706 168.23999 L 705.359985 168.27002 L 704.719971 168.299988 L 704.719971 167.22998 Z"
      />
      <path
        id="path1068"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 163.970001 L 706 163.869995 L 706 164.960022 L 705.359985 165.01001 L 704.719971 165.059998 L 704.719971 163.970001 Z"
      />
      <path
        id="path1069"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 162.330017 L 706 162.220001 L 706 163.320007 L 705.359985 163.380005 L 704.719971 163.440002 L 704.719971 162.330017 Z"
      />
      <path
        id="path1070"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 160.700012 L 706 160.559998 L 706 161.679993 L 705.359985 161.75 L 704.719971 161.809998 L 704.719971 160.700012 Z"
      />
      <path
        id="path1071"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 159.070007 L 706 158.910004 L 706 160.039978 L 705.359985 160.109985 L 704.719971 160.190002 L 704.719971 159.070007 Z"
      />
      <path
        id="path1072"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 157.429993 L 706 157.26001 L 706 158.399994 L 705.359985 158.47998 L 704.719971 158.570007 L 704.719971 157.429993 Z"
      />
      <path
        id="path1073"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 154.160004 L 706 153.950012 L 706 155.109985 L 705.359985 155.220001 L 704.719971 155.330017 L 704.719971 154.160004 Z"
      />
      <path
        id="path1074"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 152.529999 L 706 152.299988 L 706 153.470001 L 705.359985 153.589996 L 704.719971 153.700012 L 704.719971 152.529999 Z"
      />
      <path
        id="path1075"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 170.470001 L 708.099976 170.450012 L 708.099976 171.48999 L 707.460022 171.5 L 706.830017 171.51001 L 706.830017 170.470001 Z"
      />
      <path
        id="path1076"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 168.799988 L 708.099976 168.76001 L 708.099976 169.820007 L 707.460022 169.839996 L 706.830017 169.859985 L 706.830017 168.799988 Z"
      />
      <path
        id="path1077"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 167.140015 L 708.099976 167.080017 L 708.099976 168.149994 L 707.460022 168.179993 L 706.830017 168.200012 L 706.830017 167.140015 Z"
      />
      <path
        id="path1078"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 165.470001 L 708.099976 165.390015 L 708.099976 166.470001 L 707.460022 166.51001 L 706.830017 166.549988 L 706.830017 165.470001 Z"
      />
      <path
        id="path1079"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 163.809998 L 708.099976 163.710022 L 708.099976 164.799988 L 707.460022 164.850006 L 706.830017 164.899994 L 706.830017 163.809998 Z"
      />
      <path
        id="path1080"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 158.809998 L 708.099976 158.649994 L 708.099976 159.779999 L 707.460022 159.859985 L 706.830017 159.940002 L 706.830017 158.809998 Z"
      />
      <path
        id="path1081"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 157.140015 L 708.099976 156.970001 L 708.099976 158.109985 L 707.460022 158.200012 L 706.830017 158.279999 L 706.830017 157.140015 Z"
      />
      <path
        id="path1082"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 155.47998 L 708.099976 155.279999 L 708.099976 156.440002 L 707.460022 156.529999 L 706.830017 156.630005 L 706.830017 155.47998 Z"
      />
      <path
        id="path1083"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 152.149994 L 708.099976 151.919983 L 708.099976 153.089996 L 707.460022 153.210022 L 706.830017 153.320007 L 706.830017 152.149994 Z"
      />
      <path
        id="path1084"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 150.47998 L 706.830017 151.669983 L 707.460022 151.539978 L 708.099976 151.419983 L 708.099976 150.22998 L 706.830017 150.47998 Z"
      />
      <path
        id="path1085"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 172.130005 L 708.880005 172.130005 L 708.880005 173.160004 L 710.150024 173.160004 L 710.150024 172.130005 Z"
      />
      <path
        id="path1086"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 170.440002 L 710.150024 170.419983 L 710.150024 171.460022 L 709.52002 171.470001 L 708.880005 171.47998 L 708.880005 170.440002 Z"
      />
      <path
        id="path1087"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 178.140015 L 710.809998 178.140015 L 710.809998 179.169983 L 712.080017 179.169983 L 712.080017 178.140015 Z"
      />
      <path
        id="path1088"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 174.710022 L 712.080017 174.75 L 712.080017 175.809998 L 711.450012 175.789978 L 710.809998 175.77002 L 710.809998 174.710022 Z"
      />
      <path
        id="path1089"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 180.279999 L 702.640015 180.279999 L 702.640015 181.309998 L 703.909973 181.309998 L 703.909973 180.279999 Z"
      />
      <path
        id="path1090"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 183.929993 L 702.640015 183.929993 L 702.640015 184.960022 L 703.909973 184.960022 L 703.909973 183.929993 Z"
      />
      <path
        id="path1091"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 188.109985 L 702.640015 188.109985 L 702.640015 189.140015 L 703.909973 189.140015 L 703.909973 188.109985 Z"
      />
      <path
        id="path1092"
        fill="#cecece"
        stroke="none"
        d="M 702.640015 174.940002 L 703.919983 174.899994 L 703.919983 175.960022 L 703.280029 175.970001 L 702.640015 175.98999 L 702.640015 174.940002 Z"
      />
      <path
        id="path1093"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 181.97998 L 704.719971 181.97998 L 704.719971 183.01001 L 705.98999 183.01001 L 705.98999 181.97998 Z"
      />
      <path
        id="path1094"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 183.929993 L 704.719971 183.929993 L 704.719971 184.960022 L 705.98999 184.960022 L 705.98999 183.929993 Z"
      />
      <path
        id="path1095"
        fill="#cecece"
        stroke="none"
        d="M 708.099976 183.929993 L 706.830017 183.929993 L 706.830017 184.960022 L 708.099976 184.960022 L 708.099976 183.929993 Z"
      />
      <path
        id="path1096"
        fill="#cecece"
        stroke="none"
        d="M 714.159973 183.850006 L 712.890015 183.850006 L 712.890015 184.880005 L 714.159973 184.880005 L 714.159973 183.850006 Z"
      />
      <path
        id="path1097"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 185.890015 L 704.719971 185.890015 L 704.719971 186.919983 L 705.98999 186.919983 L 705.98999 185.890015 Z"
      />
      <path
        id="path1098"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 176.51001 L 706 176.48999 L 706 177.529999 L 705.359985 177.539978 L 704.719971 177.549988 L 704.719971 176.51001 Z"
      />
      <path
        id="path1099"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 176.47998 L 708.099976 176.460022 L 708.099976 177.5 L 707.460022 177.51001 L 706.830017 177.52002 L 706.830017 176.47998 Z"
      />
      <path
        id="path1100"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 187.839996 L 708.099976 187.830017 L 708.099976 188.869995 L 707.460022 188.880005 L 706.830017 188.890015 L 706.830017 187.839996 Z"
      />
      <path
        id="path1101"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 174.809998 L 708.099976 174.77002 L 708.099976 175.830017 L 707.460022 175.850006 L 706.830017 175.869995 L 706.830017 174.809998 Z"
      />
      <path
        id="path1102"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 178.140015 L 708.880005 178.140015 L 708.880005 179.169983 L 710.150024 179.169983 L 710.150024 178.140015 Z"
      />
      <path
        id="path1103"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 176.440002 L 710.150024 176.429993 L 710.150024 177.470001 L 709.52002 177.47998 L 708.880005 177.48999 L 708.880005 176.440002 Z"
      />
      <path
        id="path1104"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 181.97998 L 710.809998 181.97998 L 710.809998 183.01001 L 712.080017 183.01001 L 712.080017 181.97998 Z"
      />
      <path
        id="path1105"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 180.26001 L 712.080017 180.279999 L 712.080017 181.330017 L 711.450012 181.320007 L 710.809998 181.309998 L 710.809998 180.26001 Z"
      />
      <path
        id="path1106"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 180.309998 L 708.099976 180.289978 L 708.099976 181.339996 L 707.460022 181.350006 L 706.830017 181.359985 L 706.830017 180.309998 Z"
      />
      <path
        id="path1107"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 181.97998 L 708.880005 181.97998 L 708.880005 183.01001 L 710.150024 183.01001 L 710.150024 181.97998 Z"
      />
      <path
        id="path1108"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 180.279999 L 710.150024 180.26001 L 710.150024 181.309998 L 709.52002 181.320007 L 708.880005 181.330017 L 708.880005 180.279999 Z"
      />
      <path
        id="path1109"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 185.890015 L 710.809998 185.890015 L 710.809998 186.919983 L 712.080017 186.919983 L 712.080017 185.890015 Z"
      />
      <path
        id="path1110"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 183.929993 L 710.150024 183.910004 L 710.150024 184.960022 L 709.52002 184.970001 L 708.880005 184.97998 L 708.880005 183.929993 Z"
      />
      <path
        id="path1111"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 191.75 L 710.809998 191.75 L 710.809998 192.779999 L 712.080017 192.779999 L 712.080017 191.75 Z"
      />
      <path
        id="path1112"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 191.75 L 702.640015 191.75 L 702.640015 192.779999 L 703.909973 192.779999 L 703.909973 191.75 Z"
      />
      <path
        id="path1113"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 195.589996 L 702.640015 195.589996 L 702.640015 196.619995 L 703.909973 196.619995 L 703.909973 195.589996 Z"
      />
      <path
        id="path1114"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 191.75 L 704.719971 191.75 L 704.719971 192.779999 L 705.98999 192.779999 L 705.98999 191.75 Z"
      />
      <path
        id="path1115"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 190.119995 L 706 190.100006 L 706 191.140015 L 705.359985 191.149994 L 704.719971 191.160004 L 704.719971 190.119995 Z"
      />
      <path
        id="path1116"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 190.089996 L 708.099976 190.070007 L 708.099976 191.109985 L 707.460022 191.119995 L 706.830017 191.130005 L 706.830017 190.089996 Z"
      />
      <path
        id="path1117"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 191.75 L 708.880005 191.75 L 708.880005 192.779999 L 710.150024 192.779999 L 710.150024 191.75 Z"
      />
      <path
        id="path1118"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 187.839996 L 710.150024 187.820007 L 710.150024 188.869995 L 709.52002 188.880005 L 708.880005 188.890015 L 708.880005 187.839996 Z"
      />
      <path
        id="path1119"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 195.589996 L 710.809998 195.589996 L 710.809998 196.619995 L 712.080017 196.619995 L 712.080017 195.589996 Z"
      />
      <path
        id="path1120"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 185.919983 L 710.150024 185.899994 L 710.150024 186.950012 L 709.52002 186.960022 L 708.880005 186.970001 L 708.880005 185.919983 Z"
      />
      <path
        id="path1121"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 189.73999 L 712.080017 189.76001 L 712.080017 190.809998 L 711.450012 190.799988 L 710.809998 190.789978 L 710.809998 189.73999 Z"
      />
      <path
        id="path1122"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 193.919983 L 708.099976 193.910004 L 708.099976 194.950012 L 707.460022 194.960022 L 706.830017 194.970001 L 706.830017 193.919983 Z"
      />
      <path
        id="path1123"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 195.710022 L 708.099976 195.690002 L 708.099976 196.73999 L 707.460022 196.75 L 706.830017 196.75 L 706.830017 195.710022 Z"
      />
      <path
        id="path1124"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 199.619995 L 704.719971 199.619995 L 704.719971 200.649994 L 705.98999 200.649994 L 705.98999 199.619995 Z"
      />
      <path
        id="path1125"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 197.97998 L 706 197.960022 L 706 199.01001 L 705.359985 199.02002 L 704.719971 199.029999 L 704.719971 197.97998 Z"
      />
      <path
        id="path1126"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 197.950012 L 708.099976 197.929993 L 708.099976 198.97998 L 707.460022 198.98999 L 706.830017 199 L 706.830017 197.950012 Z"
      />
      <path
        id="path1127"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 201.789978 L 708.099976 201.77002 L 708.099976 202.820007 L 707.460022 202.830017 L 706.830017 202.839996 L 706.830017 201.789978 Z"
      />
      <path
        id="path1128"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 178.140015 L 712.900024 178.140015 L 712.900024 179.169983 L 714.169983 179.169983 L 714.169983 178.140015 Z"
      />
      <path
        id="path1129"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 180.279999 L 712.900024 180.279999 L 712.900024 181.309998 L 714.169983 181.309998 L 714.169983 180.279999 Z"
      />
      <path
        id="path1130"
        fill="#cecece"
        stroke="none"
        d="M 712.900024 174.619995 L 714.179993 174.589996 L 714.179993 175.640015 L 713.539978 175.660004 L 712.900024 175.679993 L 712.900024 174.619995 Z"
      />
      <path
        id="path1131"
        fill="#cecece"
        stroke="none"
        d="M 716.25 178.140015 L 714.97998 178.140015 L 714.97998 179.169983 L 716.25 179.169983 L 716.25 178.140015 Z"
      />
      <path
        id="path1132"
        fill="#cecece"
        stroke="none"
        d="M 716.25 183.779999 L 714.97998 183.779999 L 714.97998 184.809998 L 716.25 184.809998 L 716.25 183.779999 Z"
      />
      <path
        id="path1133"
        fill="#cecece"
        stroke="none"
        d="M 714.97998 176.200012 L 716.26001 176.179993 L 716.26001 177.220001 L 715.619995 177.22998 L 714.97998 177.23999 L 714.97998 176.200012 Z"
      />
      <path
        id="path1134"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 176.160004 L 718.359985 176.140015 L 718.359985 177.190002 L 717.719971 177.200012 L 717.080017 177.210022 L 717.080017 176.160004 Z"
      />
      <path
        id="path1135"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 183.690002 L 718.359985 183.669983 L 718.359985 184.710022 L 717.719971 184.720001 L 717.080017 184.72998 L 717.080017 183.690002 Z"
      />
      <path
        id="path1136"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 174.5 L 718.359985 174.460022 L 718.359985 175.52002 L 717.719971 175.539978 L 717.080017 175.559998 L 717.080017 174.5 Z"
      />
      <path
        id="path1137"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 180 L 718.359985 179.97998 L 718.359985 181.029999 L 717.719971 181.039978 L 717.080017 181.049988 L 717.080017 180 Z"
      />
      <path
        id="path1138"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 187.589996 L 712.900024 187.589996 L 712.900024 188.619995 L 714.169983 188.619995 L 714.169983 187.589996 Z"
      />
      <path
        id="path1139"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 191.75 L 712.900024 191.75 L 712.900024 192.779999 L 714.169983 192.779999 L 714.169983 191.75 Z"
      />
      <path
        id="path1140"
        fill="#cecece"
        stroke="none"
        d="M 716.25 187.589996 L 714.97998 187.589996 L 714.97998 188.619995 L 716.25 188.619995 L 716.25 187.589996 Z"
      />
      <path
        id="path1141"
        fill="#cecece"
        stroke="none"
        d="M 716.25 193.380005 L 714.97998 193.380005 L 714.97998 194.410004 L 716.25 194.410004 L 716.25 193.380005 Z"
      />
      <path
        id="path1142"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 201.669983 L 712.900024 201.669983 L 712.900024 202.700012 L 714.169983 202.700012 L 714.169983 201.669983 Z"
      />
      <path
        id="path1143"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 199.5 L 702.640015 199.5 L 702.640015 200.529999 L 703.909973 200.529999 L 703.909973 199.5 Z"
      />
      <path
        id="path1144"
        fill="#cecece"
        stroke="none"
        d="M 714.97998 185.960022 L 716.26001 185.940002 L 716.26001 186.98999 L 715.619995 187 L 714.97998 187.01001 L 714.97998 185.960022 Z"
      />
      <path
        id="path1145"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 197.869995 L 718.359985 197.850006 L 718.359985 198.899994 L 717.719971 198.910004 L 717.080017 198.919983 L 717.080017 197.869995 Z"
      />
      <path
        id="path1146"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 189.77002 L 718.359985 189.75 L 718.359985 190.789978 L 717.719971 190.799988 L 717.080017 190.809998 L 717.080017 189.77002 Z"
      />
      <path
        id="path1147"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 195.539978 L 718.359985 195.52002 L 718.359985 196.570007 L 717.719971 196.580017 L 717.080017 196.589996 L 717.080017 195.539978 Z"
      />
      <path
        id="path1148"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 195.589996 L 708.880005 195.589996 L 708.880005 196.619995 L 710.150024 196.619995 L 710.150024 195.589996 Z"
      />
      <path
        id="path1149"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 193.890015 L 710.150024 193.869995 L 710.150024 194.919983 L 709.52002 194.929993 L 708.880005 194.940002 L 708.880005 193.890015 Z"
      />
      <path
        id="path1150"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 199.5 L 710.809998 199.5 L 710.809998 200.529999 L 712.080017 200.529999 L 712.080017 199.5 Z"
      />
      <path
        id="path1151"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 199.5 L 712.900024 199.5 L 712.900024 200.529999 L 714.169983 200.529999 L 714.169983 199.5 Z"
      />
      <path
        id="path1152"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 197.799988 L 710.150024 197.779999 L 710.150024 198.830017 L 709.52002 198.839996 L 708.880005 198.850006 L 708.880005 197.799988 Z"
      />
      <path
        id="path1153"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 203.369995 L 702.640015 203.369995 L 702.640015 204.399994 L 703.909973 204.399994 L 703.909973 203.369995 Z"
      />
      <path
        id="path1154"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 203.369995 L 704.719971 203.369995 L 704.719971 204.399994 L 705.98999 204.399994 L 705.98999 203.369995 Z"
      />
      <path
        id="path1155"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 209.390015 L 704.719971 209.390015 L 704.719971 210.419983 L 705.98999 210.419983 L 705.98999 209.390015 Z"
      />
      <path
        id="path1156"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 213.649994 L 708.099976 213.630005 L 708.099976 214.669983 L 707.460022 214.679993 L 706.830017 214.690002 L 706.830017 213.649994 Z"
      />
      <path
        id="path1157"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 203.369995 L 708.880005 203.369995 L 708.880005 204.399994 L 710.150024 204.399994 L 710.150024 203.369995 Z"
      />
      <path
        id="path1158"
        fill="#cecece"
        stroke="none"
        d="M 710.809998 205.5 L 712.080017 205.51001 L 712.080017 206.559998 L 711.450012 206.549988 L 710.809998 206.539978 L 710.809998 205.5 Z"
      />
      <path
        id="path1159"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 205.539978 L 708.099976 205.52002 L 708.099976 206.570007 L 707.460022 206.580017 L 706.830017 206.589996 L 706.830017 205.539978 Z"
      />
      <path
        id="path1160"
        fill="#cecece"
        stroke="none"
        d="M 716.25 205.539978 L 714.97998 205.539978 L 714.97998 206.570007 L 716.25 206.570007 L 716.25 205.539978 Z"
      />
      <path
        id="path1161"
        fill="#cecece"
        stroke="none"
        d="M 716.25 207.22998 L 714.97998 207.22998 L 714.97998 208.26001 L 716.25 208.26001 L 716.25 207.22998 Z"
      />
      <path
        id="path1162"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 209.48999 L 718.359985 209.470001 L 718.359985 210.52002 L 717.719971 210.529999 L 717.080017 210.529999 L 717.080017 209.48999 Z"
      />
      <path
        id="path1163"
        fill="#cecece"
        stroke="none"
        d="M 717.080017 201.390015 L 718.359985 201.369995 L 718.359985 202.410004 L 717.719971 202.419983 L 717.080017 202.429993 L 717.080017 201.390015 Z"
      />
      <path
        id="path1164"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 209.419983 L 708.099976 209.399994 L 708.099976 210.450012 L 707.460022 210.460022 L 706.830017 210.470001 L 706.830017 209.419983 Z"
      />
      <path
        id="path1165"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 209.390015 L 710.150024 209.369995 L 710.150024 210.419983 L 709.52002 210.429993 L 708.880005 210.440002 L 708.880005 209.390015 Z"
      />
      <path
        id="path1166"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 211.660004 L 708.099976 211.640015 L 708.099976 212.690002 L 707.460022 212.700012 L 706.830017 212.710022 L 706.830017 211.660004 Z"
      />
      <path
        id="path1167"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 209.399994 L 702.640015 209.399994 L 702.640015 210.429993 L 703.909973 210.429993 L 703.909973 209.399994 Z"
      />
      <path
        id="path1168"
        fill="#cecece"
        stroke="none"
        d="M 714.169983 209.399994 L 712.900024 209.399994 L 712.900024 210.429993 L 714.169983 210.429993 L 714.169983 209.399994 Z"
      />
      <path
        id="path1169"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 213.279999 L 710.809998 213.279999 L 710.809998 214.309998 L 712.080017 214.309998 L 712.080017 213.279999 Z"
      />
      <path
        id="path1170"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 211.640015 L 706 211.619995 L 706 212.669983 L 705.359985 212.679993 L 704.719971 212.690002 L 704.719971 211.640015 Z"
      />
      <path
        id="path1171"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 211.609985 L 708.099976 211.589996 L 708.099976 212.640015 L 707.460022 212.649994 L 706.830017 212.660004 L 706.830017 211.609985 Z"
      />
      <path
        id="path1172"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 217.100006 L 702.640015 217.100006 L 702.640015 218.130005 L 703.909973 218.130005 L 703.909973 217.100006 Z"
      />
      <path
        id="path1173"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 217.100006 L 704.719971 217.100006 L 704.719971 218.130005 L 705.98999 218.130005 L 705.98999 217.100006 Z"
      />
      <path
        id="path1174"
        fill="#cecece"
        stroke="none"
        d="M 705.98999 222.890015 L 704.719971 222.890015 L 704.719971 223.919983 L 705.98999 223.919983 L 705.98999 222.890015 Z"
      />
      <path
        id="path1175"
        fill="#cecece"
        stroke="none"
        d="M 704.719971 215.470001 L 706 215.450012 L 706 216.48999 L 705.359985 216.5 L 704.719971 216.51001 L 704.719971 215.470001 Z"
      />
      <path
        id="path1176"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 226.809998 L 708.099976 226.789978 L 708.099976 227.839996 L 707.460022 227.850006 L 706.830017 227.859985 L 706.830017 226.809998 Z"
      />
      <path
        id="path1177"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 215.399994 L 710.150024 215.390015 L 710.150024 216.429993 L 709.52002 216.440002 L 708.880005 216.450012 L 708.880005 215.399994 Z"
      />
      <path
        id="path1178"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 219.27002 L 708.099976 219.25 L 708.099976 220.299988 L 707.460022 220.309998 L 706.830017 220.320007 L 706.830017 219.27002 Z"
      />
      <path
        id="path1179"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 224.830017 L 708.099976 224.809998 L 708.099976 225.850006 L 707.460022 225.859985 L 706.830017 225.869995 L 706.830017 224.830017 Z"
      />
      <path
        id="path1180"
        fill="#cecece"
        stroke="none"
        d="M 703.909973 223.130005 L 702.640015 223.130005 L 702.640015 224.160004 L 703.909973 224.160004 L 703.909973 223.130005 Z"
      />
      <path
        id="path1181"
        fill="#cecece"
        stroke="none"
        d="M 699.73999 173.089996 L 698.469971 173.089996 L 698.469971 174.119995 L 699.73999 174.119995 L 699.73999 173.089996 Z"
      />
      <path
        id="path1182"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 169.890015 L 699.73999 169.850006 L 699.73999 170.899994 L 699.109985 170.919983 L 698.469971 170.940002 L 698.469971 169.890015 Z"
      />
      <path
        id="path1183"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 168.279999 L 699.73999 168.22998 L 699.73999 169.289978 L 699.109985 169.320007 L 698.469971 169.350006 L 698.469971 168.279999 Z"
      />
      <path
        id="path1184"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 166.679993 L 699.73999 166.600006 L 699.73999 167.679993 L 699.109985 167.720001 L 698.469971 167.76001 L 698.469971 166.679993 Z"
      />
      <path
        id="path1185"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 163.47998 L 699.73999 163.359985 L 699.73999 164.470001 L 699.109985 164.52002 L 698.469971 164.580017 L 698.469971 163.47998 Z"
      />
      <path
        id="path1186"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 161.880005 L 699.73999 161.73999 L 699.73999 162.859985 L 699.109985 162.919983 L 698.469971 162.98999 L 698.469971 161.880005 Z"
      />
      <path
        id="path1187"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 160.279999 L 699.73999 160.119995 L 699.73999 161.25 L 699.109985 161.320007 L 698.469971 161.399994 L 698.469971 160.279999 Z"
      />
      <path
        id="path1188"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 157.070007 L 699.73999 156.880005 L 699.73999 158.029999 L 699.109985 158.119995 L 698.469971 158.220001 L 698.469971 157.070007 Z"
      />
      <path
        id="path1189"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 155.470001 L 699.73999 155.26001 L 699.73999 156.419983 L 699.109985 156.52002 L 698.469971 156.630005 L 698.469971 155.470001 Z"
      />
      <path
        id="path1190"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 153.869995 L 699.73999 153.640015 L 699.73999 154.809998 L 699.109985 154.919983 L 698.469971 155.039978 L 698.469971 153.869995 Z"
      />
      <path
        id="path1191"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 173.089996 L 700.549988 173.089996 L 700.549988 174.119995 L 701.820007 174.119995 L 701.820007 173.089996 Z"
      />
      <path
        id="path1192"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 171.460022 L 701.820007 171.440002 L 701.820007 172.47998 L 701.190002 172.48999 L 700.549988 172.5 L 700.549988 171.460022 Z"
      />
      <path
        id="path1193"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 168.190002 L 701.820007 168.130005 L 701.820007 169.200012 L 701.190002 169.22998 L 700.549988 169.26001 L 700.549988 168.190002 Z"
      />
      <path
        id="path1194"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 164.919983 L 701.820007 164.830017 L 701.820007 165.919983 L 701.190002 165.970001 L 700.549988 166.01001 L 700.549988 164.919983 Z"
      />
      <path
        id="path1195"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 163.289978 L 701.820007 163.169983 L 701.820007 164.279999 L 701.190002 164.330017 L 700.549988 164.390015 L 700.549988 163.289978 Z"
      />
      <path
        id="path1196"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 161.660004 L 701.820007 161.52002 L 701.820007 162.640015 L 701.190002 162.700012 L 700.549988 162.77002 L 700.549988 161.660004 Z"
      />
      <path
        id="path1197"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 160.02002 L 701.820007 159.869995 L 701.820007 160.98999 L 701.190002 161.070007 L 700.549988 161.149994 L 700.549988 160.02002 Z"
      />
      <path
        id="path1198"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 158.390015 L 701.820007 158.220001 L 701.820007 159.350006 L 701.190002 159.440002 L 700.549988 159.529999 L 700.549988 158.390015 Z"
      />
      <path
        id="path1199"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 155.119995 L 701.820007 154.910004 L 701.820007 156.070007 L 701.190002 156.179993 L 700.549988 156.279999 L 700.549988 155.119995 Z"
      />
      <path
        id="path1200"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 153.48999 L 701.820007 153.26001 L 701.820007 154.429993 L 701.190002 154.539978 L 700.549988 154.660004 L 700.549988 153.48999 Z"
      />
      <path
        id="path1201"
        fill="#cecece"
        stroke="none"
        d="M 699.73999 179.100006 L 698.469971 179.100006 L 698.469971 180.130005 L 699.73999 180.130005 L 699.73999 179.100006 Z"
      />
      <path
        id="path1202"
        fill="#cecece"
        stroke="none"
        d="M 699.73999 181.23999 L 698.469971 181.23999 L 698.469971 182.27002 L 699.73999 182.27002 L 699.73999 181.23999 Z"
      />
      <path
        id="path1203"
        fill="#cecece"
        stroke="none"
        d="M 698.469971 175.890015 L 699.73999 175.859985 L 699.73999 176.910004 L 699.109985 176.929993 L 698.469971 176.950012 L 698.469971 175.890015 Z"
      />
      <path
        id="path1204"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 179.100006 L 700.549988 179.100006 L 700.549988 180.130005 L 701.820007 180.130005 L 701.820007 179.100006 Z"
      />
      <path
        id="path1205"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 182.940002 L 700.549988 182.940002 L 700.549988 183.970001 L 701.820007 183.970001 L 701.820007 182.940002 Z"
      />
      <path
        id="path1206"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 184.890015 L 700.549988 184.890015 L 700.549988 185.919983 L 701.820007 185.919983 L 701.820007 184.890015 Z"
      />
      <path
        id="path1207"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 186.839996 L 700.549988 186.839996 L 700.549988 187.869995 L 701.820007 187.869995 L 701.820007 186.839996 Z"
      />
      <path
        id="path1208"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 177.460022 L 701.820007 177.450012 L 701.820007 178.48999 L 701.190002 178.5 L 700.549988 178.51001 L 700.549988 177.460022 Z"
      />
      <path
        id="path1209"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 192.710022 L 700.549988 192.710022 L 700.549988 193.73999 L 701.820007 193.73999 L 701.820007 192.710022 Z"
      />
      <path
        id="path1210"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 191.080017 L 701.820007 191.059998 L 701.820007 192.100006 L 701.190002 192.109985 L 700.549988 192.119995 L 700.549988 191.080017 Z"
      />
      <path
        id="path1211"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 200.570007 L 700.549988 200.570007 L 700.549988 201.600006 L 701.820007 201.600006 L 701.820007 200.570007 Z"
      />
      <path
        id="path1212"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 198.940002 L 701.820007 198.919983 L 701.820007 199.970001 L 701.190002 199.97998 L 700.549988 199.98999 L 700.549988 198.940002 Z"
      />
      <path
        id="path1213"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 204.330017 L 700.549988 204.330017 L 700.549988 205.359985 L 701.820007 205.359985 L 701.820007 204.330017 Z"
      />
      <path
        id="path1214"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 210.350006 L 700.549988 210.350006 L 700.549988 211.380005 L 701.820007 211.380005 L 701.820007 210.350006 Z"
      />
      <path
        id="path1215"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 202.700012 L 701.820007 202.679993 L 701.820007 203.720001 L 701.190002 203.72998 L 700.549988 203.73999 L 700.549988 202.700012 Z"
      />
      <path
        id="path1216"
        fill="#cecece"
        stroke="none"
        d="M 699.73999 210.359985 L 698.469971 210.359985 L 698.469971 211.390015 L 699.73999 211.390015 L 699.73999 210.359985 Z"
      />
      <path
        id="path1217"
        fill="#cecece"
        stroke="none"
        d="M 700.549988 212.600006 L 701.820007 212.580017 L 701.820007 213.630005 L 701.190002 213.640015 L 700.549988 213.640015 L 700.549988 212.600006 Z"
      />
      <path
        id="path1218"
        fill="#cecece"
        stroke="none"
        d="M 699.73999 218.059998 L 698.469971 218.059998 L 698.469971 219.089996 L 699.73999 219.089996 L 699.73999 218.059998 Z"
      />
      <path
        id="path1219"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 218.059998 L 700.549988 218.059998 L 700.549988 219.089996 L 701.820007 219.089996 L 701.820007 218.059998 Z"
      />
      <path
        id="path1220"
        fill="#cecece"
        stroke="none"
        d="M 701.820007 223.850006 L 700.549988 223.850006 L 700.549988 224.880005 L 701.820007 224.880005 L 701.820007 223.850006 Z"
      />
      <path
        id="path1221"
        fill="#cecece"
        stroke="none"
        d="M 699.73999 224.089996 L 698.469971 224.089996 L 698.469971 225.119995 L 699.73999 225.119995 L 699.73999 224.089996 Z"
      />
      <path
        id="path1222"
        fill="#cecece"
        stroke="none"
        d="M 706.830017 224.779999 L 708.099976 224.76001 L 708.099976 225.799988 L 707.460022 225.809998 L 706.830017 225.820007 L 706.830017 224.779999 Z"
      />
      <path
        id="path1223"
        fill="#cecece"
        stroke="none"
        d="M 712.080017 221.02002 L 710.809998 221.02002 L 710.809998 222.049988 L 712.080017 222.049988 L 712.080017 221.02002 Z"
      />
      <path
        id="path1224"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 165.350006 L 710.150024 165.27002 L 710.150024 166.350006 L 709.52002 166.390015 L 708.880005 166.429993 L 708.880005 165.350006 Z"
      />
      <path
        id="path1225"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 161.950012 L 710.150024 161.839996 L 710.150024 162.940002 L 709.52002 163 L 708.880005 163.059998 L 708.880005 161.950012 Z"
      />
      <path
        id="path1226"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 160.26001 L 710.150024 160.119995 L 710.150024 161.23999 L 709.52002 161.299988 L 708.880005 161.369995 L 708.880005 160.26001 Z"
      />
      <path
        id="path1227"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 158.559998 L 710.150024 158.399994 L 710.150024 159.529999 L 709.52002 159.609985 L 708.880005 159.690002 L 708.880005 158.559998 Z"
      />
      <path
        id="path1228"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 155.169983 L 710.150024 154.970001 L 710.150024 156.119995 L 709.52002 156.220001 L 708.880005 156.320007 L 708.880005 155.169983 Z"
      />
      <path
        id="path1229"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 153.470001 L 710.150024 153.26001 L 710.150024 154.419983 L 709.52002 154.529999 L 708.880005 154.630005 L 708.880005 153.470001 Z"
      />
      <path
        id="path1230"
        fill="#cecece"
        stroke="none"
        d="M 708.880005 150.080017 L 708.880005 151.26001 L 709.52002 151.140015 L 710.150024 151.01001 L 710.150024 149.830017 L 708.880005 150.080017 Z"
      />
      <path
        id="path1231"
        fill="#cecece"
        stroke="none"
        d="M 597.669983 133.380005 L 597.669983 133.570007 L 592.98999 134.410004 L 592.98999 134.25 L 597.669983 133.380005 Z"
      />
      <path
        id="path1232"
        fill="#cecece"
        stroke="none"
        d="M 597.669983 132.380005 L 597.669983 132.559998 L 592.98999 133.419983 L 592.98999 133.26001 L 597.669983 132.380005 Z"
      />
      <path
        id="path1233"
        fill="#cecece"
        stroke="none"
        d="M 594.76001 133.899994 L 594.76001 134.080017 L 590.090027 134.899994 L 590.090027 134.75 L 594.76001 133.899994 Z"
      />
      <path
        id="path1234"
        fill="#cecece"
        stroke="none"
        d="M 594.76001 132.899994 L 594.76001 133.089996 L 590.090027 133.929993 L 590.090027 133.77002 L 594.76001 132.899994 Z"
      />
      <path
        id="path1235"
        fill="#cecece"
        stroke="none"
        d="M 603.320007 136.059998 L 597.679993 132.559998 L 597.679993 132.190002 L 603.320007 135.76001 L 603.320007 136.059998 Z"
      />
      <path
        id="path1236"
        fill="#cecece"
        stroke="none"
        d="M 603.320007 137.029999 L 597.679993 133.619995 L 597.679993 133.23999 L 603.320007 136.720001 L 603.320007 137.029999 Z"
      />
      <path
        id="path1237"
        fill="#cecece"
        stroke="none"
        d="M 615.27002 147.5 L 615.27002 148.130005 L 616.159973 147.970001 L 616.159973 147.309998 L 615.27002 147.5 Z"
      />
      <path
        id="path1238"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 150 L 615.27002 150.160004 L 615.27002 149.5 L 616.159973 149.320007 L 616.159973 150 Z"
      />
      <path
        id="path1239"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 152.039978 L 615.27002 152.190002 L 615.27002 151.51001 L 616.159973 151.339996 L 616.159973 152.039978 Z"
      />
      <path
        id="path1240"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 154.070007 L 615.27002 154.210022 L 615.27002 153.52002 L 616.159973 153.350006 L 616.159973 154.070007 Z"
      />
      <path
        id="path1241"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 156.100006 L 615.27002 156.23999 L 615.27002 155.529999 L 616.159973 155.369995 L 616.159973 156.100006 Z"
      />
      <path
        id="path1242"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 158.140015 L 615.27002 158.26001 L 615.27002 157.529999 L 616.159973 157.380005 L 616.159973 158.140015 Z"
      />
      <path
        id="path1243"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 160.169983 L 615.27002 160.289978 L 615.27002 159.539978 L 616.159973 159.399994 L 616.159973 160.169983 Z"
      />
      <path
        id="path1244"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 162.200012 L 615.27002 162.320007 L 615.27002 161.549988 L 616.159973 161.419983 L 616.159973 162.200012 Z"
      />
      <path
        id="path1245"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 164.23999 L 615.26001 164.339996 L 615.26001 163.549988 L 616.159973 163.429993 L 616.159973 164.23999 Z"
      />
      <path
        id="path1246"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 166.27002 L 615.26001 166.369995 L 615.26001 165.559998 L 616.159973 165.450012 L 616.159973 166.27002 Z"
      />
      <path
        id="path1247"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 168.299988 L 615.26001 168.390015 L 615.26001 167.570007 L 616.159973 167.460022 L 616.159973 168.299988 Z"
      />
      <path
        id="path1248"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 170.339996 L 615.26001 170.419983 L 615.26001 169.580017 L 616.159973 169.47998 L 616.159973 170.339996 Z"
      />
      <path
        id="path1249"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 172.369995 L 615.26001 172.450012 L 615.26001 171.580017 L 616.159973 171.48999 L 616.159973 172.369995 Z"
      />
      <path
        id="path1250"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 174.399994 L 615.26001 174.470001 L 615.26001 173.589996 L 616.159973 173.51001 L 616.159973 174.399994 Z"
      />
      <path
        id="path1251"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 176.440002 L 615.26001 176.5 L 615.26001 175.600006 L 616.159973 175.52002 L 616.159973 176.440002 Z"
      />
      <path
        id="path1252"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 178.470001 L 615.26001 178.52002 L 615.26001 177.609985 L 616.159973 177.539978 L 616.159973 178.470001 Z"
      />
      <path
        id="path1253"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 180.5 L 615.26001 180.549988 L 615.26001 179.609985 L 616.159973 179.559998 L 616.159973 180.5 Z"
      />
      <path
        id="path1254"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 182.529999 L 615.26001 182.580017 L 615.26001 181.619995 L 616.159973 181.570007 L 616.159973 182.529999 Z"
      />
      <path
        id="path1255"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 184.570007 L 615.25 184.600006 L 615.25 183.630005 L 616.159973 183.589996 L 616.159973 184.570007 Z"
      />
      <path
        id="path1256"
        fill="#cecece"
        stroke="none"
        d="M 616.169983 186.600006 L 615.25 186.630005 L 615.25 185.640015 L 616.169983 185.600006 L 616.169983 186.600006 Z"
      />
      <path
        id="path1257"
        fill="#cecece"
        stroke="none"
        d="M 616.169983 188.630005 L 615.25 188.660004 L 615.25 187.640015 L 616.169983 187.619995 L 616.169983 188.630005 Z"
      />
      <path
        id="path1258"
        fill="#cecece"
        stroke="none"
        d="M 616.169983 190.669983 L 615.25 190.679993 L 615.25 189.649994 L 616.169983 189.630005 L 616.169983 190.669983 Z"
      />
      <path
        id="path1259"
        fill="#cecece"
        stroke="none"
        d="M 616.169983 196.369995 L 615.25 196.369995 L 615.25 197.440002 L 616.169983 197.440002 L 616.169983 196.369995 Z"
      />
      <path
        id="path1260"
        fill="#cecece"
        stroke="none"
        d="M 616.159973 147.309998 L 616.159973 147.970001 L 617.210022 148.669983 L 617.210022 148.029999 L 616.159973 147.309998 Z"
      />
      <path
        id="path1261"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 150.679993 L 616.159973 150 L 616.159973 149.320007 L 617.200012 150.01001 L 617.200012 150.679993 Z"
      />
      <path
        id="path1262"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 152.679993 L 616.159973 152.039978 L 616.159973 151.339996 L 617.200012 152 L 617.200012 152.679993 Z"
      />
      <path
        id="path1263"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 154.679993 L 616.159973 154.070007 L 616.159973 153.350006 L 617.200012 153.97998 L 617.200012 154.679993 Z"
      />
      <path
        id="path1264"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 156.679993 L 616.159973 156.100006 L 616.159973 155.369995 L 617.200012 155.960022 L 617.200012 156.679993 Z"
      />
      <path
        id="path1265"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 158.690002 L 616.159973 158.140015 L 616.159973 157.380005 L 617.200012 157.950012 L 617.200012 158.690002 Z"
      />
      <path
        id="path1266"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 160.690002 L 616.159973 160.169983 L 616.159973 159.399994 L 617.200012 159.929993 L 617.200012 160.690002 Z"
      />
      <path
        id="path1267"
        fill="#cecece"
        stroke="none"
        d="M 617.200012 162.690002 L 616.159973 162.200012 L 616.159973 161.419983 L 617.200012 161.919983 L 617.200012 162.690002 Z"
      />
      <path
        id="path1268"
        fill="#cecece"
        stroke="none"
        d="M 617.190002 164.700012 L 616.159973 164.23999 L 616.159973 163.429993 L 617.190002 163.899994 L 617.190002 164.700012 Z"
      />
      <path
        id="path1269"
        fill="#cecece"
        stroke="none"
        d="M 617.190002 166.700012 L 616.159973 166.27002 L 616.159973 165.450012 L 617.190002 165.890015 L 617.190002 166.700012 Z"
      />
      <path
        id="path1270"
        fill="#cecece"
        stroke="none"
        d="M 617.190002 170.700012 L 616.159973 170.339996 L 616.159973 169.47998 L 617.190002 169.850006 L 617.190002 170.700012 Z"
      />
      <path
        id="path1271"
        fill="#cecece"
        stroke="none"
        d="M 617.190002 172.710022 L 616.159973 172.369995 L 616.159973 171.48999 L 617.190002 171.839996 L 617.190002 172.710022 Z"
      />
      <path
        id="path1272"
        fill="#cecece"
        stroke="none"
        d="M 617.190002 174.710022 L 616.159973 174.399994 L 616.159973 173.51001 L 617.190002 173.820007 L 617.190002 174.710022 Z"
      />
      <path
        id="path1273"
        fill="#cecece"
        stroke="none"
        d="M 617.179993 178.710022 L 616.159973 178.470001 L 616.159973 177.539978 L 617.179993 177.789978 L 617.179993 178.710022 Z"
      />
      <path
        id="path1274"
        fill="#cecece"
        stroke="none"
        d="M 617.179993 180.720001 L 616.159973 180.5 L 616.159973 179.559998 L 617.179993 179.77002 L 617.179993 180.720001 Z"
      />
      <path
        id="path1275"
        fill="#cecece"
        stroke="none"
        d="M 617.179993 184.720001 L 616.159973 184.570007 L 616.159973 183.589996 L 617.179993 183.73999 L 617.179993 184.720001 Z"
      />
      <path
        id="path1276"
        fill="#cecece"
        stroke="none"
        d="M 617.179993 188.72998 L 616.169983 188.630005 L 616.169983 187.619995 L 617.179993 187.710022 L 617.179993 188.72998 Z"
      />
      <path
        id="path1277"
        fill="#cecece"
        stroke="none"
        d="M 617.330017 148.109985 L 617.330017 148.76001 L 618.299988 149.410004 L 618.299988 148.779999 L 617.330017 148.109985 Z"
      />
      <path
        id="path1278"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 151.380005 L 617.330017 150.75 L 617.330017 150.089996 L 618.309998 150.72998 L 618.309998 151.380005 Z"
      />
      <path
        id="path1279"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 153.350006 L 617.330017 152.75 L 617.330017 152.070007 L 618.309998 152.679993 L 618.309998 153.350006 Z"
      />
      <path
        id="path1280"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 155.320007 L 617.330017 154.75 L 617.330017 154.049988 L 618.309998 154.640015 L 618.309998 155.320007 Z"
      />
      <path
        id="path1281"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 157.289978 L 617.330017 156.75 L 617.330017 156.029999 L 618.309998 156.589996 L 618.309998 157.289978 Z"
      />
      <path
        id="path1282"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 159.26001 L 617.330017 158.75 L 617.330017 158.01001 L 618.309998 158.539978 L 618.309998 159.26001 Z"
      />
      <path
        id="path1283"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 161.23999 L 617.330017 160.75 L 617.330017 159.98999 L 618.309998 160.48999 L 618.309998 161.23999 Z"
      />
      <path
        id="path1284"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 163.210022 L 617.330017 162.75 L 617.330017 161.970001 L 618.309998 162.440002 L 618.309998 163.210022 Z"
      />
      <path
        id="path1285"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 165.179993 L 617.330017 164.75 L 617.330017 163.950012 L 618.309998 164.390015 L 618.309998 165.179993 Z"
      />
      <path
        id="path1286"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 167.149994 L 617.330017 166.75 L 617.330017 165.940002 L 618.309998 166.339996 L 618.309998 167.149994 Z"
      />
      <path
        id="path1287"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 169.119995 L 617.330017 168.75 L 617.330017 167.919983 L 618.309998 168.299988 L 618.309998 169.119995 Z"
      />
      <path
        id="path1288"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 171.089996 L 617.330017 170.73999 L 617.330017 169.899994 L 618.309998 170.25 L 618.309998 171.089996 Z"
      />
      <path
        id="path1289"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 173.059998 L 617.330017 172.73999 L 617.330017 171.880005 L 618.309998 172.200012 L 618.309998 173.059998 Z"
      />
      <path
        id="path1290"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 175.029999 L 617.330017 174.73999 L 617.330017 173.859985 L 618.309998 174.149994 L 618.309998 175.029999 Z"
      />
      <path
        id="path1291"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 177 L 617.330017 176.73999 L 617.330017 175.839996 L 618.309998 176.100006 L 618.309998 177 Z"
      />
      <path
        id="path1292"
        fill="#cecece"
        stroke="none"
        d="M 618.309998 178.970001 L 617.340027 178.73999 L 617.340027 177.820007 L 618.309998 178.049988 L 618.309998 178.970001 Z"
      />
      <path
        id="path1293"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 180.940002 L 617.340027 180.73999 L 617.340027 179.799988 L 618.320007 180 L 618.320007 180.940002 Z"
      />
      <path
        id="path1294"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 182.910004 L 617.340027 182.73999 L 617.340027 181.779999 L 618.320007 181.960022 L 618.320007 182.910004 Z"
      />
      <path
        id="path1295"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 184.880005 L 617.340027 184.73999 L 617.340027 183.76001 L 618.320007 183.910004 L 618.320007 184.880005 Z"
      />
      <path
        id="path1296"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 186.850006 L 617.340027 186.73999 L 617.340027 185.73999 L 618.320007 185.859985 L 618.320007 186.850006 Z"
      />
      <path
        id="path1297"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 188.820007 L 617.340027 188.73999 L 617.340027 187.720001 L 618.320007 187.809998 L 618.320007 188.820007 Z"
      />
      <path
        id="path1298"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 190.789978 L 617.340027 190.73999 L 617.340027 189.700012 L 618.320007 189.76001 L 618.320007 190.789978 Z"
      />
      <path
        id="path1299"
        fill="#cecece"
        stroke="none"
        d="M 618.320007 192.76001 L 617.340027 192.72998 L 617.340027 191.679993 L 618.320007 191.710022 L 618.320007 192.76001 Z"
      />
      <path
        id="path1300"
        fill="#cecece"
        stroke="none"
        d="M 619.669983 149.720001 L 619.669983 150.320007 L 620.289978 150.73999 L 620.289978 150.140015 L 619.669983 149.720001 Z"
      />
      <path
        id="path1301"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 152.649994 L 619.659973 152.26001 L 619.659973 151.630005 L 620.289978 152.039978 L 620.289978 152.649994 Z"
      />
      <path
        id="path1302"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 154.570007 L 619.659973 154.190002 L 619.659973 153.539978 L 620.289978 153.929993 L 620.289978 154.570007 Z"
      />
      <path
        id="path1303"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 156.47998 L 619.659973 156.119995 L 619.659973 155.450012 L 620.289978 155.820007 L 620.289978 156.47998 Z"
      />
      <path
        id="path1304"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 158.390015 L 619.659973 158.049988 L 619.659973 157.359985 L 620.289978 157.710022 L 620.289978 158.390015 Z"
      />
      <path
        id="path1305"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 160.299988 L 619.659973 159.97998 L 619.659973 159.27002 L 620.289978 159.609985 L 620.289978 160.299988 Z"
      />
      <path
        id="path1306"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 164.130005 L 619.659973 163.839996 L 619.659973 163.089996 L 620.289978 163.390015 L 620.289978 164.130005 Z"
      />
      <path
        id="path1307"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 166.039978 L 619.650024 165.77002 L 619.650024 165 L 620.289978 165.279999 L 620.289978 166.039978 Z"
      />
      <path
        id="path1308"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 167.960022 L 619.650024 167.700012 L 619.650024 166.910004 L 620.289978 167.169983 L 620.289978 167.960022 Z"
      />
      <path
        id="path1309"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 169.869995 L 619.650024 169.630005 L 619.650024 168.820007 L 620.289978 169.070007 L 620.289978 169.869995 Z"
      />
      <path
        id="path1310"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 171.779999 L 619.650024 171.559998 L 619.650024 170.73999 L 620.289978 170.960022 L 620.289978 171.779999 Z"
      />
      <path
        id="path1311"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 173.690002 L 619.650024 173.48999 L 619.650024 172.649994 L 620.289978 172.850006 L 620.289978 173.690002 Z"
      />
      <path
        id="path1312"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 177.52002 L 619.640015 177.359985 L 619.640015 176.470001 L 620.289978 176.640015 L 620.289978 177.52002 Z"
      />
      <path
        id="path1313"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 179.429993 L 619.640015 179.289978 L 619.640015 178.380005 L 620.289978 178.529999 L 620.289978 179.429993 Z"
      />
      <path
        id="path1314"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 183.26001 L 619.640015 183.149994 L 619.640015 182.200012 L 620.289978 182.309998 L 620.289978 183.26001 Z"
      />
      <path
        id="path1315"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 185.169983 L 619.640015 185.080017 L 619.640015 184.109985 L 620.289978 184.200012 L 620.289978 185.169983 Z"
      />
      <path
        id="path1316"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 187.080017 L 619.640015 187.01001 L 619.640015 186.02002 L 620.289978 186.100006 L 620.289978 187.080017 Z"
      />
      <path
        id="path1317"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 190.910004 L 619.630005 190.869995 L 619.630005 189.839996 L 620.289978 189.880005 L 620.289978 190.910004 Z"
      />
      <path
        id="path1318"
        fill="#cecece"
        stroke="none"
        d="M 620.289978 192.820007 L 619.630005 192.799988 L 619.630005 191.75 L 620.289978 191.77002 L 620.289978 192.820007 Z"
      />
      <path
        id="path1319"
        fill="#cecece"
        stroke="none"
        d="M 620.409973 150.22998 L 620.409973 150.820007 L 620.97998 151.200012 L 620.97998 150.619995 L 620.409973 150.22998 Z"
      />
      <path
        id="path1320"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 153.100006 L 620.409973 152.72998 L 620.409973 152.119995 L 620.97998 152.48999 L 620.97998 153.100006 Z"
      />
      <path
        id="path1321"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 154.98999 L 620.400024 154.640015 L 620.400024 154 L 620.97998 154.359985 L 620.97998 154.98999 Z"
      />
      <path
        id="path1322"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 156.880005 L 620.400024 156.549988 L 620.400024 155.890015 L 620.97998 156.23999 L 620.97998 156.880005 Z"
      />
      <path
        id="path1323"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 158.779999 L 620.400024 158.460022 L 620.400024 157.779999 L 620.97998 158.109985 L 620.97998 158.779999 Z"
      />
      <path
        id="path1324"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 160.669983 L 620.400024 160.369995 L 620.400024 159.669983 L 620.97998 159.97998 L 620.97998 160.669983 Z"
      />
      <path
        id="path1325"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 162.559998 L 620.400024 162.279999 L 620.400024 161.559998 L 620.97998 161.850006 L 620.97998 162.559998 Z"
      />
      <path
        id="path1326"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 164.450012 L 620.400024 164.190002 L 620.400024 163.450012 L 620.97998 163.720001 L 620.97998 164.450012 Z"
      />
      <path
        id="path1327"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 166.350006 L 620.400024 166.100006 L 620.400024 165.339996 L 620.97998 165.589996 L 620.97998 166.350006 Z"
      />
      <path
        id="path1328"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 168.23999 L 620.400024 168 L 620.400024 167.220001 L 620.97998 167.460022 L 620.97998 168.23999 Z"
      />
      <path
        id="path1329"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 170.130005 L 620.400024 169.910004 L 620.400024 169.109985 L 620.97998 169.339996 L 620.97998 170.130005 Z"
      />
      <path
        id="path1330"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 172.02002 L 620.400024 171.820007 L 620.400024 171 L 620.97998 171.210022 L 620.97998 172.02002 Z"
      />
      <path
        id="path1331"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 173.919983 L 620.400024 173.72998 L 620.400024 172.890015 L 620.97998 173.080017 L 620.97998 173.919983 Z"
      />
      <path
        id="path1332"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 175.809998 L 620.400024 175.640015 L 620.400024 174.779999 L 620.97998 174.950012 L 620.97998 175.809998 Z"
      />
      <path
        id="path1333"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 179.589996 L 620.400024 179.460022 L 620.400024 178.559998 L 620.97998 178.690002 L 620.97998 179.589996 Z"
      />
      <path
        id="path1334"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 181.48999 L 620.400024 181.369995 L 620.400024 180.440002 L 620.97998 180.559998 L 620.97998 181.48999 Z"
      />
      <path
        id="path1335"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 183.380005 L 620.400024 183.279999 L 620.400024 182.330017 L 620.97998 182.440002 L 620.97998 183.380005 Z"
      />
      <path
        id="path1336"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 187.160004 L 620.400024 187.100006 L 620.400024 186.109985 L 620.97998 186.179993 L 620.97998 187.160004 Z"
      />
      <path
        id="path1337"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 189.059998 L 620.400024 189.01001 L 620.400024 188 L 620.97998 188.049988 L 620.97998 189.059998 Z"
      />
      <path
        id="path1338"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 190.950012 L 620.400024 190.919983 L 620.400024 189.890015 L 620.97998 189.919983 L 620.97998 190.950012 Z"
      />
      <path
        id="path1339"
        fill="#cecece"
        stroke="none"
        d="M 620.97998 196.369995 L 620.390015 196.369995 L 620.390015 197.440002 L 620.97998 197.440002 L 620.97998 196.369995 Z"
      />
      <path
        id="path1340"
        fill="#cecece"
        stroke="none"
        d="M 622.320007 151.539978 L 622.320007 152.100006 L 623.080017 152.609985 L 623.080017 152.059998 L 622.320007 151.539978 Z"
      />
      <path
        id="path1341"
        fill="#cecece"
        stroke="none"
        d="M 623.080017 154.450012 L 622.320007 153.960022 L 622.320007 153.369995 L 623.080017 153.869995 L 623.080017 154.450012 Z"
      />
      <path
        id="path1342"
        fill="#cecece"
        stroke="none"
        d="M 623.080017 156.279999 L 622.320007 155.809998 L 622.320007 155.200012 L 623.080017 155.679993 L 623.080017 156.279999 Z"
      />
      <path
        id="path1343"
        fill="#cecece"
        stroke="none"
        d="M 623.080017 159.940002 L 622.320007 159.52002 L 622.320007 158.869995 L 623.080017 159.299988 L 623.080017 159.940002 Z"
      />
      <path
        id="path1344"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 161.77002 L 622.320007 161.369995 L 622.320007 160.700012 L 623.070007 161.109985 L 623.070007 161.77002 Z"
      />
      <path
        id="path1345"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 163.600006 L 622.320007 163.220001 L 622.320007 162.529999 L 623.070007 162.919983 L 623.070007 163.600006 Z"
      />
      <path
        id="path1346"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 165.429993 L 622.320007 165.080017 L 622.320007 164.359985 L 623.070007 164.720001 L 623.070007 165.429993 Z"
      />
      <path
        id="path1347"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 167.26001 L 622.320007 166.929993 L 622.320007 166.190002 L 623.070007 166.529999 L 623.070007 167.26001 Z"
      />
      <path
        id="path1348"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 169.100006 L 622.320007 168.779999 L 622.320007 168.02002 L 623.070007 168.339996 L 623.070007 169.100006 Z"
      />
      <path
        id="path1349"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 170.929993 L 622.320007 170.640015 L 622.320007 169.850006 L 623.070007 170.149994 L 623.070007 170.929993 Z"
      />
      <path
        id="path1350"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 176.419983 L 622.320007 176.200012 L 622.320007 175.350006 L 623.070007 175.580017 L 623.070007 176.419983 Z"
      />
      <path
        id="path1351"
        fill="#cecece"
        stroke="none"
        d="M 623.070007 178.25 L 622.330017 178.049988 L 622.330017 177.179993 L 623.070007 177.390015 L 623.070007 178.25 Z"
      />
      <path
        id="path1352"
        fill="#cecece"
        stroke="none"
        d="M 623.059998 180.080017 L 622.330017 179.910004 L 622.330017 179.01001 L 623.059998 179.200012 L 623.059998 180.080017 Z"
      />
      <path
        id="path1353"
        fill="#cecece"
        stroke="none"
        d="M 623.059998 181.910004 L 622.330017 181.76001 L 622.330017 180.839996 L 623.059998 181 L 623.059998 181.910004 Z"
      />
      <path
        id="path1354"
        fill="#cecece"
        stroke="none"
        d="M 623.059998 183.75 L 622.330017 183.609985 L 622.330017 182.669983 L 623.059998 182.809998 L 623.059998 183.75 Z"
      />
      <path
        id="path1355"
        fill="#cecece"
        stroke="none"
        d="M 623.059998 187.410004 L 622.330017 187.320007 L 622.330017 186.339996 L 623.059998 186.429993 L 623.059998 187.410004 Z"
      />
      <path
        id="path1356"
        fill="#cecece"
        stroke="none"
        d="M 623.059998 191.070007 L 622.330017 191.029999 L 622.330017 190 L 623.059998 190.049988 L 623.059998 191.070007 Z"
      />
      <path
        id="path1357"
        fill="#cecece"
        stroke="none"
        d="M 623.059998 192.899994 L 622.330017 192.880005 L 622.330017 191.830017 L 623.059998 191.859985 L 623.059998 192.899994 Z"
      />
      <path
        id="path1358"
        fill="#cecece"
        stroke="none"
        d="M 623.049988 196.369995 L 622.330017 196.369995 L 622.330017 197.440002 L 623.049988 197.440002 L 623.049988 196.369995 Z"
      />
      <path
        id="path1359"
        fill="#cecece"
        stroke="none"
        d="M 623.200012 152.149994 L 623.200012 152.690002 L 623.820007 153.109985 L 623.820007 152.570007 L 623.200012 152.149994 Z"
      />
      <path
        id="path1360"
        fill="#cecece"
        stroke="none"
        d="M 623.820007 154.919983 L 623.200012 154.52002 L 623.200012 153.950012 L 623.820007 154.359985 L 623.820007 154.919983 Z"
      />
      <path
        id="path1361"
        fill="#cecece"
        stroke="none"
        d="M 623.809998 156.72998 L 623.200012 156.350006 L 623.200012 155.76001 L 623.809998 156.149994 L 623.809998 156.72998 Z"
      />
      <path
        id="path1362"
        fill="#cecece"
        stroke="none"
        d="M 623.809998 158.539978 L 623.200012 158.179993 L 623.200012 157.559998 L 623.809998 157.929993 L 623.809998 158.539978 Z"
      />
      <path
        id="path1363"
        fill="#cecece"
        stroke="none"
        d="M 623.809998 160.350006 L 623.200012 160.01001 L 623.200012 159.369995 L 623.809998 159.720001 L 623.809998 160.350006 Z"
      />
      <path
        id="path1364"
        fill="#cecece"
        stroke="none"
        d="M 623.799988 162.160004 L 623.200012 161.830017 L 623.200012 161.169983 L 623.799988 161.51001 L 623.799988 162.160004 Z"
      />
      <path
        id="path1365"
        fill="#cecece"
        stroke="none"
        d="M 623.799988 163.970001 L 623.200012 163.660004 L 623.200012 162.97998 L 623.799988 163.289978 L 623.799988 163.970001 Z"
      />
      <path
        id="path1366"
        fill="#cecece"
        stroke="none"
        d="M 623.799988 167.589996 L 623.200012 167.320007 L 623.200012 166.589996 L 623.799988 166.869995 L 623.799988 167.589996 Z"
      />
      <path
        id="path1367"
        fill="#cecece"
        stroke="none"
        d="M 623.789978 169.399994 L 623.200012 169.140015 L 623.200012 168.390015 L 623.789978 168.649994 L 623.789978 169.399994 Z"
      />
      <path
        id="path1368"
        fill="#cecece"
        stroke="none"
        d="M 623.789978 171.210022 L 623.200012 170.970001 L 623.200012 170.200012 L 623.789978 170.440002 L 623.789978 171.210022 Z"
      />
      <path
        id="path1369"
        fill="#cecece"
        stroke="none"
        d="M 623.789978 173.02002 L 623.200012 172.799988 L 623.200012 172 L 623.789978 172.22998 L 623.789978 173.02002 Z"
      />
      <path
        id="path1370"
        fill="#cecece"
        stroke="none"
        d="M 623.780029 174.830017 L 623.200012 174.630005 L 623.200012 173.809998 L 623.780029 174.01001 L 623.780029 174.830017 Z"
      />
      <path
        id="path1371"
        fill="#cecece"
        stroke="none"
        d="M 623.780029 176.640015 L 623.200012 176.460022 L 623.200012 175.609985 L 623.780029 175.799988 L 623.780029 176.640015 Z"
      />
      <path
        id="path1372"
        fill="#cecece"
        stroke="none"
        d="M 623.780029 178.450012 L 623.200012 178.279999 L 623.200012 177.419983 L 623.780029 177.589996 L 623.780029 178.450012 Z"
      />
      <path
        id="path1373"
        fill="#cecece"
        stroke="none"
        d="M 623.77002 180.26001 L 623.200012 180.109985 L 623.200012 179.220001 L 623.77002 179.369995 L 623.77002 180.26001 Z"
      />
      <path
        id="path1374"
        fill="#cecece"
        stroke="none"
        d="M 623.77002 182.070007 L 623.200012 181.940002 L 623.200012 181.029999 L 623.77002 181.160004 L 623.77002 182.070007 Z"
      />
      <path
        id="path1375"
        fill="#cecece"
        stroke="none"
        d="M 623.77002 183.880005 L 623.210022 183.77002 L 623.210022 182.830017 L 623.77002 182.950012 L 623.77002 183.880005 Z"
      />
      <path
        id="path1376"
        fill="#cecece"
        stroke="none"
        d="M 623.76001 185.690002 L 623.210022 185.600006 L 623.210022 184.640015 L 623.76001 184.72998 L 623.76001 185.690002 Z"
      />
      <path
        id="path1377"
        fill="#cecece"
        stroke="none"
        d="M 623.76001 187.5 L 623.210022 187.419983 L 623.210022 186.440002 L 623.76001 186.52002 L 623.76001 187.5 Z"
      />
      <path
        id="path1378"
        fill="#cecece"
        stroke="none"
        d="M 623.76001 189.309998 L 623.210022 189.25 L 623.210022 188.25 L 623.76001 188.299988 L 623.76001 189.309998 Z"
      />
      <path
        id="path1379"
        fill="#cecece"
        stroke="none"
        d="M 623.75 192.919983 L 623.210022 192.910004 L 623.210022 191.859985 L 623.75 191.880005 L 623.75 192.919983 Z"
      />
      <path
        id="path1380"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 147.809998 L 613.789978 148.410004 L 614.789978 148.220001 L 614.789978 147.600006 L 613.789978 147.809998 Z"
      />
      <path
        id="path1381"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 150.419983 L 614.789978 150.23999 L 614.789978 149.600006 L 613.789978 149.809998 L 613.789978 150.419983 Z"
      />
      <path
        id="path1382"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 152.429993 L 614.789978 152.27002 L 614.789978 151.609985 L 613.789978 151.799988 L 613.789978 152.429993 Z"
      />
      <path
        id="path1383"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 154.450012 L 614.789978 154.289978 L 614.789978 153.609985 L 613.789978 153.799988 L 613.789978 154.450012 Z"
      />
      <path
        id="path1384"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 156.460022 L 614.789978 156.309998 L 614.789978 155.609985 L 613.789978 155.789978 L 613.789978 156.460022 Z"
      />
      <path
        id="path1385"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 158.47998 L 614.780029 158.330017 L 614.780029 157.609985 L 613.789978 157.779999 L 613.789978 158.47998 Z"
      />
      <path
        id="path1386"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 160.48999 L 614.780029 160.359985 L 614.780029 159.619995 L 613.789978 159.779999 L 613.789978 160.48999 Z"
      />
      <path
        id="path1387"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 162.51001 L 614.780029 162.380005 L 614.780029 161.619995 L 613.789978 161.77002 L 613.789978 162.51001 Z"
      />
      <path
        id="path1388"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 164.52002 L 614.780029 164.399994 L 614.780029 163.619995 L 613.789978 163.76001 L 613.789978 164.52002 Z"
      />
      <path
        id="path1389"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 166.529999 L 614.780029 166.419983 L 614.780029 165.630005 L 613.789978 165.76001 L 613.789978 166.529999 Z"
      />
      <path
        id="path1390"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 168.549988 L 614.780029 168.440002 L 614.780029 167.630005 L 613.789978 167.75 L 613.789978 168.549988 Z"
      />
      <path
        id="path1391"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 170.559998 L 614.780029 170.470001 L 614.780029 169.630005 L 613.789978 169.73999 L 613.789978 170.559998 Z"
      />
      <path
        id="path1392"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 172.580017 L 614.780029 172.48999 L 614.780029 171.630005 L 613.789978 171.73999 L 613.789978 172.580017 Z"
      />
      <path
        id="path1393"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 174.589996 L 614.780029 174.51001 L 614.780029 173.640015 L 613.789978 173.72998 L 613.789978 174.589996 Z"
      />
      <path
        id="path1394"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 176.609985 L 614.780029 176.529999 L 614.780029 175.640015 L 613.789978 175.720001 L 613.789978 176.609985 Z"
      />
      <path
        id="path1395"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 180.630005 L 614.780029 180.580017 L 614.780029 179.649994 L 613.789978 179.710022 L 613.789978 180.630005 Z"
      />
      <path
        id="path1396"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 182.649994 L 614.780029 182.600006 L 614.780029 181.649994 L 613.789978 181.700012 L 613.789978 182.649994 Z"
      />
      <path
        id="path1397"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 184.660004 L 614.77002 184.619995 L 614.77002 183.649994 L 613.789978 183.700012 L 613.789978 184.660004 Z"
      />
      <path
        id="path1398"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 188.690002 L 614.77002 188.669983 L 614.77002 187.660004 L 613.789978 187.679993 L 613.789978 188.690002 Z"
      />
      <path
        id="path1399"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 190.710022 L 614.77002 190.690002 L 614.77002 189.660004 L 613.789978 189.679993 L 613.789978 190.710022 Z"
      />
      <path
        id="path1400"
        fill="#cecece"
        stroke="none"
        d="M 613.789978 192.720001 L 614.77002 192.710022 L 614.77002 191.660004 L 613.789978 191.669983 L 613.789978 192.720001 Z"
      />
      <path
        id="path1401"
        fill="#cecece"
        stroke="none"
        d="M 612.429993 148.109985 L 612.429993 148.660004 L 613.330017 148.48999 L 613.330017 147.910004 L 612.429993 148.109985 Z"
      />
      <path
        id="path1402"
        fill="#cecece"
        stroke="none"
        d="M 612.429993 150.660004 L 613.330017 150.5 L 613.330017 149.899994 L 612.429993 150.089996 L 612.429993 150.660004 Z"
      />
      <path
        id="path1403"
        fill="#cecece"
        stroke="none"
        d="M 612.429993 152.660004 L 613.330017 152.51001 L 613.330017 151.890015 L 612.429993 152.070007 L 612.429993 152.660004 Z"
      />
      <path
        id="path1404"
        fill="#cecece"
        stroke="none"
        d="M 612.429993 154.669983 L 613.330017 154.52002 L 613.330017 153.880005 L 612.429993 154.049988 L 612.429993 154.669983 Z"
      />
      <path
        id="path1405"
        fill="#cecece"
        stroke="none"
        d="M 612.429993 156.669983 L 613.330017 156.529999 L 613.330017 155.869995 L 612.429993 156.029999 L 612.429993 156.669983 Z"
      />
      <path
        id="path1406"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 158.669983 L 613.330017 158.539978 L 613.330017 157.859985 L 612.419983 158.01001 L 612.419983 158.669983 Z"
      />
      <path
        id="path1407"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 160.679993 L 613.330017 160.549988 L 613.330017 159.850006 L 612.419983 159.98999 L 612.419983 160.679993 Z"
      />
      <path
        id="path1408"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 162.679993 L 613.330017 162.559998 L 613.330017 161.839996 L 612.419983 161.970001 L 612.419983 162.679993 Z"
      />
      <path
        id="path1409"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 164.679993 L 613.330017 164.580017 L 613.330017 163.830017 L 612.419983 163.950012 L 612.419983 164.679993 Z"
      />
      <path
        id="path1410"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 166.690002 L 613.330017 166.589996 L 613.330017 165.820007 L 612.419983 165.940002 L 612.419983 166.690002 Z"
      />
      <path
        id="path1411"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 168.690002 L 613.330017 168.600006 L 613.330017 167.809998 L 612.419983 167.919983 L 612.419983 168.690002 Z"
      />
      <path
        id="path1412"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 170.690002 L 613.330017 170.609985 L 613.330017 169.799988 L 612.419983 169.899994 L 612.419983 170.690002 Z"
      />
      <path
        id="path1413"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 172.700012 L 613.330017 172.619995 L 613.330017 171.779999 L 612.419983 171.880005 L 612.419983 172.700012 Z"
      />
      <path
        id="path1414"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 176.700012 L 613.330017 176.640015 L 613.330017 175.76001 L 612.419983 175.839996 L 612.419983 176.700012 Z"
      />
      <path
        id="path1415"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 178.710022 L 613.330017 178.649994 L 613.330017 177.75 L 612.419983 177.820007 L 612.419983 178.710022 Z"
      />
      <path
        id="path1416"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 180.710022 L 613.330017 180.660004 L 613.330017 179.73999 L 612.419983 179.799988 L 612.419983 180.710022 Z"
      />
      <path
        id="path1417"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 186.720001 L 613.330017 186.690002 L 613.330017 185.710022 L 612.419983 185.73999 L 612.419983 186.720001 Z"
      />
      <path
        id="path1418"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 188.720001 L 613.330017 188.700012 L 613.330017 187.700012 L 612.419983 187.720001 L 612.419983 188.720001 Z"
      />
      <path
        id="path1419"
        fill="#cecece"
        stroke="none"
        d="M 612.419983 192.72998 L 613.330017 192.720001 L 613.330017 191.679993 L 612.419983 191.679993 L 612.419983 192.72998 Z"
      />
      <path
        id="path1420"
        fill="#cecece"
        stroke="none"
        d="M 611.309998 148.350006 L 611.309998 148.859985 L 612.02002 148.72998 L 612.02002 148.200012 L 611.309998 148.350006 Z"
      />
      <path
        id="path1421"
        fill="#cecece"
        stroke="none"
        d="M 611.309998 150.859985 L 612.02002 150.72998 L 612.02002 150.169983 L 611.309998 150.320007 L 611.309998 150.859985 Z"
      />
      <path
        id="path1422"
        fill="#cecece"
        stroke="none"
        d="M 611.309998 152.850006 L 612.02002 152.72998 L 612.02002 152.149994 L 611.309998 152.289978 L 611.309998 152.850006 Z"
      />
      <path
        id="path1423"
        fill="#cecece"
        stroke="none"
        d="M 611.309998 154.839996 L 612.02002 154.72998 L 612.02002 154.130005 L 611.309998 154.26001 L 611.309998 154.839996 Z"
      />
      <path
        id="path1424"
        fill="#cecece"
        stroke="none"
        d="M 611.309998 156.839996 L 612.02002 156.72998 L 612.02002 156.100006 L 611.309998 156.22998 L 611.309998 156.839996 Z"
      />
      <path
        id="path1425"
        fill="#cecece"
        stroke="none"
        d="M 611.309998 158.830017 L 612.02002 158.72998 L 612.02002 158.080017 L 611.309998 158.200012 L 611.309998 158.830017 Z"
      />
      <path
        id="path1426"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 162.820007 L 612.01001 162.72998 L 612.01001 162.029999 L 611.299988 162.140015 L 611.299988 162.820007 Z"
      />
      <path
        id="path1427"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 164.820007 L 612.01001 164.72998 L 612.01001 164.01001 L 611.299988 164.109985 L 611.299988 164.820007 Z"
      />
      <path
        id="path1428"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 166.809998 L 612.01001 166.72998 L 612.01001 165.98999 L 611.299988 166.080017 L 611.299988 166.809998 Z"
      />
      <path
        id="path1429"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 170.799988 L 612.01001 170.72998 L 612.01001 169.940002 L 611.299988 170.02002 L 611.299988 170.799988 Z"
      />
      <path
        id="path1430"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 172.799988 L 612.01001 172.72998 L 612.01001 171.919983 L 611.299988 171.98999 L 611.299988 172.799988 Z"
      />
      <path
        id="path1431"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 174.789978 L 612.01001 174.72998 L 612.01001 173.899994 L 611.299988 173.960022 L 611.299988 174.789978 Z"
      />
      <path
        id="path1432"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 178.779999 L 612.01001 178.72998 L 612.01001 177.850006 L 611.299988 177.899994 L 611.299988 178.779999 Z"
      />
      <path
        id="path1433"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 180.77002 L 612.01001 180.72998 L 612.01001 179.830017 L 611.299988 179.869995 L 611.299988 180.77002 Z"
      />
      <path
        id="path1434"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 184.76001 L 612.01001 184.72998 L 612.01001 183.779999 L 611.299988 183.809998 L 611.299988 184.76001 Z"
      />
      <path
        id="path1435"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 186.76001 L 612 186.72998 L 612 185.76001 L 611.299988 185.779999 L 611.299988 186.76001 Z"
      />
      <path
        id="path1436"
        fill="#cecece"
        stroke="none"
        d="M 611.299988 188.75 L 612 188.72998 L 612 187.72998 L 611.299988 187.75 L 611.299988 188.75 Z"
      />
      <path
        id="path1437"
        fill="#cecece"
        stroke="none"
        d="M 610.049988 148.619995 L 610.049988 149.089996 L 610.900024 148.940002 L 610.900024 148.440002 L 610.049988 148.619995 Z"
      />
      <path
        id="path1438"
        fill="#cecece"
        stroke="none"
        d="M 610.049988 151.080017 L 610.900024 150.929993 L 610.900024 150.399994 L 610.049988 150.580017 L 610.049988 151.080017 Z"
      />
      <path
        id="path1439"
        fill="#cecece"
        stroke="none"
        d="M 610.049988 153.059998 L 610.900024 152.919983 L 610.900024 152.369995 L 610.049988 152.539978 L 610.049988 153.059998 Z"
      />
      <path
        id="path1440"
        fill="#cecece"
        stroke="none"
        d="M 610.039978 155.049988 L 610.900024 154.910004 L 610.900024 154.339996 L 610.039978 154.5 L 610.039978 155.049988 Z"
      />
      <path
        id="path1441"
        fill="#cecece"
        stroke="none"
        d="M 610.039978 157.029999 L 610.900024 156.899994 L 610.900024 156.299988 L 610.039978 156.450012 L 610.039978 157.029999 Z"
      />
      <path
        id="path1442"
        fill="#cecece"
        stroke="none"
        d="M 610.039978 161 L 610.900024 160.880005 L 610.900024 160.23999 L 610.039978 160.369995 L 610.039978 161 Z"
      />
      <path
        id="path1443"
        fill="#cecece"
        stroke="none"
        d="M 610.039978 162.97998 L 610.900024 162.869995 L 610.900024 162.200012 L 610.039978 162.330017 L 610.039978 162.97998 Z"
      />
      <path
        id="path1444"
        fill="#cecece"
        stroke="none"
        d="M 610.039978 164.970001 L 610.900024 164.869995 L 610.900024 164.169983 L 610.039978 164.289978 L 610.039978 164.970001 Z"
      />
      <path
        id="path1445"
        fill="#cecece"
        stroke="none"
        d="M 610.030029 168.940002 L 610.900024 168.850006 L 610.900024 168.100006 L 610.030029 168.200012 L 610.030029 168.940002 Z"
      />
      <path
        id="path1446"
        fill="#cecece"
        stroke="none"
        d="M 610.030029 172.910004 L 610.900024 172.830017 L 610.900024 172.029999 L 610.030029 172.119995 L 610.030029 172.910004 Z"
      />
      <path
        id="path1447"
        fill="#cecece"
        stroke="none"
        d="M 610.030029 174.890015 L 610.900024 174.820007 L 610.900024 174 L 610.030029 174.080017 L 610.030029 174.890015 Z"
      />
      <path
        id="path1448"
        fill="#cecece"
        stroke="none"
        d="M 610.030029 176.869995 L 610.900024 176.809998 L 610.900024 175.970001 L 610.030029 176.039978 L 610.030029 176.869995 Z"
      />
      <path
        id="path1449"
        fill="#cecece"
        stroke="none"
        d="M 610.030029 178.859985 L 610.900024 178.799988 L 610.900024 177.929993 L 610.030029 178 L 610.030029 178.859985 Z"
      />
      <path
        id="path1450"
        fill="#cecece"
        stroke="none"
        d="M 610.02002 180.839996 L 610.900024 180.799988 L 610.900024 179.899994 L 610.02002 179.960022 L 610.02002 180.839996 Z"
      />
      <path
        id="path1451"
        fill="#cecece"
        stroke="none"
        d="M 610.02002 182.830017 L 610.900024 182.789978 L 610.900024 181.869995 L 610.02002 181.910004 L 610.02002 182.830017 Z"
      />
      <path
        id="path1452"
        fill="#cecece"
        stroke="none"
        d="M 610.02002 186.799988 L 610.900024 186.77002 L 610.900024 185.799988 L 610.02002 185.830017 L 610.02002 186.799988 Z"
      />
      <path
        id="path1453"
        fill="#cecece"
        stroke="none"
        d="M 610.02002 190.77002 L 610.900024 190.75 L 610.900024 189.72998 L 610.02002 189.75 L 610.02002 190.77002 Z"
      />
      <path
        id="path1454"
        fill="#cecece"
        stroke="none"
        d="M 610.02002 192.75 L 610.900024 192.73999 L 610.900024 191.700012 L 610.02002 191.710022 L 610.02002 192.75 Z"
      />
      <path
        id="path1455"
        fill="#cecece"
        stroke="none"
        d="M 618.48999 194.72998 L 619.469971 194.72998 L 619.469971 149.539978 L 618.48999 148.859985 L 618.48999 194.72998 Z"
      />
      <path
        id="path1456"
        fill="#cecece"
        stroke="none"
        d="M 621.150024 194.72998 L 622.130005 194.72998 L 622.130005 151.390015 L 621.150024 150.710022 L 621.150024 194.72998 Z"
      />
      <path
        id="path1457"
        fill="#cecece"
        stroke="none"
        d="M 624.01001 194.72998 L 624.289978 194.72998 L 624.289978 152.890015 L 624.01001 152.700012 L 624.01001 194.72998 Z"
      />
      <path
        id="path1458"
        fill="#cecece"
        stroke="none"
        d="M 624.380005 194.72998 L 624.659973 194.72998 L 624.659973 153.149994 L 624.380005 152.950012 L 624.380005 194.72998 Z"
      />
      <path
        id="path1459"
        fill="#cecece"
        stroke="none"
        d="M 596.609985 134.830017 L 596.609985 135.649994 L 597.75 135.440002 L 597.75 134.580017 L 596.609985 134.830017 Z"
      />
      <path
        id="path1460"
        fill="#cecece"
        stroke="none"
        d="M 597.75 138.039978 L 596.609985 138.23999 L 596.609985 137.399994 L 597.75 137.169983 L 597.75 138.039978 Z"
      />
      <path
        id="path1461"
        fill="#cecece"
        stroke="none"
        d="M 597.75 140.649994 L 596.609985 140.839996 L 596.609985 139.97998 L 597.75 139.75 L 597.75 140.649994 Z"
      />
      <path
        id="path1462"
        fill="#cecece"
        stroke="none"
        d="M 597.75 143.26001 L 596.609985 143.440002 L 596.609985 142.549988 L 597.75 142.339996 L 597.75 143.26001 Z"
      />
      <path
        id="path1463"
        fill="#cecece"
        stroke="none"
        d="M 597.75 145.869995 L 596.609985 146.039978 L 596.609985 145.130005 L 597.75 144.929993 L 597.75 145.869995 Z"
      />
      <path
        id="path1464"
        fill="#cecece"
        stroke="none"
        d="M 597.75 148.47998 L 596.609985 148.640015 L 596.609985 147.700012 L 597.75 147.51001 L 597.75 148.47998 Z"
      />
      <path
        id="path1465"
        fill="#cecece"
        stroke="none"
        d="M 597.75 151.080017 L 596.609985 151.23999 L 596.609985 150.279999 L 597.75 150.100006 L 597.75 151.080017 Z"
      />
      <path
        id="path1466"
        fill="#cecece"
        stroke="none"
        d="M 597.75 153.690002 L 596.599976 153.839996 L 596.599976 152.850006 L 597.75 152.679993 L 597.75 153.690002 Z"
      />
      <path
        id="path1467"
        fill="#cecece"
        stroke="none"
        d="M 597.75 156.299988 L 596.599976 156.440002 L 596.599976 155.429993 L 597.75 155.27002 L 597.75 156.299988 Z"
      />
      <path
        id="path1468"
        fill="#cecece"
        stroke="none"
        d="M 597.75 158.910004 L 596.599976 159.029999 L 596.599976 158 L 597.75 157.850006 L 597.75 158.910004 Z"
      />
      <path
        id="path1469"
        fill="#cecece"
        stroke="none"
        d="M 597.75 161.51001 L 596.599976 161.630005 L 596.599976 160.570007 L 597.75 160.440002 L 597.75 161.51001 Z"
      />
      <path
        id="path1470"
        fill="#cecece"
        stroke="none"
        d="M 597.75 164.119995 L 596.599976 164.22998 L 596.599976 163.149994 L 597.75 163.02002 L 597.75 164.119995 Z"
      />
      <path
        id="path1471"
        fill="#cecece"
        stroke="none"
        d="M 597.75 166.72998 L 596.599976 166.830017 L 596.599976 165.720001 L 597.75 165.609985 L 597.75 166.72998 Z"
      />
      <path
        id="path1472"
        fill="#cecece"
        stroke="none"
        d="M 597.75 169.339996 L 596.599976 169.429993 L 596.599976 168.299988 L 597.75 168.190002 L 597.75 169.339996 Z"
      />
      <path
        id="path1473"
        fill="#cecece"
        stroke="none"
        d="M 597.75 171.950012 L 596.590027 172.029999 L 596.590027 170.869995 L 597.75 170.779999 L 597.75 171.950012 Z"
      />
      <path
        id="path1474"
        fill="#cecece"
        stroke="none"
        d="M 597.75 174.549988 L 596.590027 174.630005 L 596.590027 173.450012 L 597.75 173.359985 L 597.75 174.549988 Z"
      />
      <path
        id="path1475"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 177.160004 L 596.590027 177.220001 L 596.590027 176.02002 L 597.76001 175.950012 L 597.76001 177.160004 Z"
      />
      <path
        id="path1476"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 179.77002 L 596.590027 179.820007 L 596.590027 178.600006 L 597.76001 178.529999 L 597.76001 179.77002 Z"
      />
      <path
        id="path1477"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 182.380005 L 596.590027 182.419983 L 596.590027 181.169983 L 597.76001 181.119995 L 597.76001 182.380005 Z"
      />
      <path
        id="path1478"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 184.97998 L 596.590027 185.02002 L 596.590027 183.75 L 597.76001 183.700012 L 597.76001 184.97998 Z"
      />
      <path
        id="path1479"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 187.589996 L 596.590027 187.619995 L 596.590027 186.320007 L 597.76001 186.289978 L 597.76001 187.589996 Z"
      />
      <path
        id="path1480"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 190.200012 L 596.580017 190.220001 L 596.580017 188.890015 L 597.76001 188.869995 L 597.76001 190.200012 Z"
      />
      <path
        id="path1481"
        fill="#cecece"
        stroke="none"
        d="M 597.76001 194.039978 L 596.580017 194.039978 L 596.580017 195.410004 L 597.76001 195.410004 L 597.76001 194.039978 Z"
      />
      <path
        id="path1482"
        fill="#cecece"
        stroke="none"
        d="M 597.75 134.580017 L 597.75 135.440002 L 599.090027 136.339996 L 599.090027 135.51001 L 597.75 134.580017 Z"
      />
      <path
        id="path1483"
        fill="#cecece"
        stroke="none"
        d="M 599.090027 138.910004 L 597.75 138.039978 L 597.75 137.169983 L 599.090027 138.059998 L 599.090027 138.910004 Z"
      />
      <path
        id="path1484"
        fill="#cecece"
        stroke="none"
        d="M 599.090027 141.47998 L 597.75 140.649994 L 597.75 139.75 L 599.090027 140.600006 L 599.090027 141.47998 Z"
      />
      <path
        id="path1485"
        fill="#cecece"
        stroke="none"
        d="M 599.090027 144.049988 L 597.75 143.26001 L 597.75 142.339996 L 599.090027 143.140015 L 599.090027 144.049988 Z"
      />
      <path
        id="path1486"
        fill="#cecece"
        stroke="none"
        d="M 599.080017 146.609985 L 597.75 145.869995 L 597.75 144.929993 L 599.080017 145.690002 L 599.080017 146.609985 Z"
      />
      <path
        id="path1487"
        fill="#cecece"
        stroke="none"
        d="M 599.080017 149.179993 L 597.75 148.47998 L 597.75 147.51001 L 599.080017 148.22998 L 599.080017 149.179993 Z"
      />
      <path
        id="path1488"
        fill="#cecece"
        stroke="none"
        d="M 599.080017 151.75 L 597.75 151.080017 L 597.75 150.100006 L 599.080017 150.779999 L 599.080017 151.75 Z"
      />
      <path
        id="path1489"
        fill="#cecece"
        stroke="none"
        d="M 599.080017 154.320007 L 597.75 153.690002 L 597.75 152.679993 L 599.080017 153.320007 L 599.080017 154.320007 Z"
      />
      <path
        id="path1490"
        fill="#cecece"
        stroke="none"
        d="M 599.080017 156.890015 L 597.75 156.299988 L 597.75 155.27002 L 599.080017 155.869995 L 599.080017 156.890015 Z"
      />
      <path
        id="path1491"
        fill="#cecece"
        stroke="none"
        d="M 599.070007 159.460022 L 597.75 158.910004 L 597.75 157.850006 L 599.070007 158.410004 L 599.070007 159.460022 Z"
      />
      <path
        id="path1492"
        fill="#cecece"
        stroke="none"
        d="M 599.070007 164.589996 L 597.75 164.119995 L 597.75 163.02002 L 599.070007 163.5 L 599.070007 164.589996 Z"
      />
      <path
        id="path1493"
        fill="#cecece"
        stroke="none"
        d="M 599.070007 167.160004 L 597.75 166.72998 L 597.75 165.609985 L 599.070007 166.049988 L 599.070007 167.160004 Z"
      />
      <path
        id="path1494"
        fill="#cecece"
        stroke="none"
        d="M 599.070007 169.72998 L 597.75 169.339996 L 597.75 168.190002 L 599.070007 168.589996 L 599.070007 169.72998 Z"
      />
      <path
        id="path1495"
        fill="#cecece"
        stroke="none"
        d="M 599.059998 174.869995 L 597.75 174.549988 L 597.75 173.359985 L 599.059998 173.679993 L 599.059998 174.869995 Z"
      />
      <path
        id="path1496"
        fill="#cecece"
        stroke="none"
        d="M 599.059998 177.440002 L 597.76001 177.160004 L 597.76001 175.950012 L 599.059998 176.22998 L 599.059998 177.440002 Z"
      />
      <path
        id="path1497"
        fill="#cecece"
        stroke="none"
        d="M 599.059998 182.570007 L 597.76001 182.380005 L 597.76001 181.119995 L 599.059998 181.320007 L 599.059998 182.570007 Z"
      />
      <path
        id="path1498"
        fill="#cecece"
        stroke="none"
        d="M 599.049988 187.710022 L 597.76001 187.589996 L 597.76001 186.289978 L 599.049988 186.410004 L 599.049988 187.710022 Z"
      />
      <path
        id="path1499"
        fill="#cecece"
        stroke="none"
        d="M 599.23999 135.619995 L 599.23999 136.440002 L 600.5 137.289978 L 600.5 136.47998 L 599.23999 135.619995 Z"
      />
      <path
        id="path1500"
        fill="#cecece"
        stroke="none"
        d="M 600.5 139.809998 L 599.25 139.01001 L 599.25 138.160004 L 600.5 138.97998 L 600.5 139.809998 Z"
      />
      <path
        id="path1501"
        fill="#cecece"
        stroke="none"
        d="M 600.5 142.339996 L 599.25 141.570007 L 599.25 140.700012 L 600.5 141.47998 L 600.5 142.339996 Z"
      />
      <path
        id="path1502"
        fill="#cecece"
        stroke="none"
        d="M 600.5 144.869995 L 599.25 144.140015 L 599.25 143.23999 L 600.5 143.98999 L 600.5 144.869995 Z"
      />
      <path
        id="path1503"
        fill="#cecece"
        stroke="none"
        d="M 600.5 147.399994 L 599.25 146.700012 L 599.25 145.779999 L 600.5 146.48999 L 600.5 147.399994 Z"
      />
      <path
        id="path1504"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 149.919983 L 599.25 149.26001 L 599.25 148.320007 L 600.51001 148.98999 L 600.51001 149.919983 Z"
      />
      <path
        id="path1505"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 152.450012 L 599.25 151.830017 L 599.25 150.859985 L 600.51001 151.5 L 600.51001 152.450012 Z"
      />
      <path
        id="path1506"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 154.97998 L 599.25 154.390015 L 599.25 153.399994 L 600.51001 154 L 600.51001 154.97998 Z"
      />
      <path
        id="path1507"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 157.5 L 599.25 156.960022 L 599.25 155.940002 L 600.51001 156.5 L 600.51001 157.5 Z"
      />
      <path
        id="path1508"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 160.029999 L 599.25 159.52002 L 599.25 158.47998 L 600.51001 159 L 600.51001 160.029999 Z"
      />
      <path
        id="path1509"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 162.559998 L 599.25 162.080017 L 599.25 161.02002 L 600.51001 161.51001 L 600.51001 162.559998 Z"
      />
      <path
        id="path1510"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 165.089996 L 599.25 164.649994 L 599.25 163.559998 L 600.51001 164.01001 L 600.51001 165.089996 Z"
      />
      <path
        id="path1511"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 167.609985 L 599.26001 167.210022 L 599.26001 166.100006 L 600.51001 166.51001 L 600.51001 167.609985 Z"
      />
      <path
        id="path1512"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 170.140015 L 599.26001 169.779999 L 599.26001 168.640015 L 600.51001 169.01001 L 600.51001 170.140015 Z"
      />
      <path
        id="path1513"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 172.669983 L 599.26001 172.339996 L 599.26001 171.179993 L 600.51001 171.52002 L 600.51001 172.669983 Z"
      />
      <path
        id="path1514"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 175.200012 L 599.26001 174.899994 L 599.26001 173.720001 L 600.51001 174.02002 L 600.51001 175.200012 Z"
      />
      <path
        id="path1515"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 177.720001 L 599.26001 177.470001 L 599.26001 176.26001 L 600.51001 176.52002 L 600.51001 177.720001 Z"
      />
      <path
        id="path1516"
        fill="#cecece"
        stroke="none"
        d="M 600.52002 180.25 L 599.26001 180.029999 L 599.26001 178.799988 L 600.52002 179.029999 L 600.52002 180.25 Z"
      />
      <path
        id="path1517"
        fill="#cecece"
        stroke="none"
        d="M 600.52002 182.779999 L 599.26001 182.589996 L 599.26001 181.339996 L 600.52002 181.529999 L 600.52002 182.779999 Z"
      />
      <path
        id="path1518"
        fill="#cecece"
        stroke="none"
        d="M 600.52002 185.309998 L 599.26001 185.160004 L 599.26001 183.880005 L 600.52002 184.029999 L 600.52002 185.309998 Z"
      />
      <path
        id="path1519"
        fill="#cecece"
        stroke="none"
        d="M 600.52002 187.830017 L 599.26001 187.720001 L 599.26001 186.419983 L 600.52002 186.539978 L 600.52002 187.830017 Z"
      />
      <path
        id="path1520"
        fill="#cecece"
        stroke="none"
        d="M 600.52002 190.359985 L 599.26001 190.289978 L 599.26001 188.960022 L 600.52002 189.039978 L 600.52002 190.359985 Z"
      />
      <path
        id="path1521"
        fill="#cecece"
        stroke="none"
        d="M 600.52002 192.890015 L 599.26001 192.850006 L 599.26001 191.5 L 600.52002 191.539978 L 600.52002 192.890015 Z"
      />
      <path
        id="path1522"
        fill="#cecece"
        stroke="none"
        d="M 602.25 137.679993 L 602.25 138.460022 L 603.039978 138.98999 L 603.039978 138.22998 L 602.25 137.679993 Z"
      />
      <path
        id="path1523"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 141.440002 L 602.23999 140.929993 L 602.23999 140.130005 L 603.039978 140.649994 L 603.039978 141.440002 Z"
      />
      <path
        id="path1524"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 143.899994 L 602.23999 143.410004 L 602.23999 142.580017 L 603.039978 143.080017 L 603.039978 143.899994 Z"
      />
      <path
        id="path1525"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 146.350006 L 602.23999 145.890015 L 602.23999 145.029999 L 603.039978 145.51001 L 603.039978 146.350006 Z"
      />
      <path
        id="path1526"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 148.799988 L 602.23999 148.359985 L 602.23999 147.47998 L 603.039978 147.929993 L 603.039978 148.799988 Z"
      />
      <path
        id="path1527"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 151.26001 L 602.23999 150.839996 L 602.23999 149.929993 L 603.039978 150.359985 L 603.039978 151.26001 Z"
      />
      <path
        id="path1528"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 156.160004 L 602.22998 155.789978 L 602.22998 154.830017 L 603.039978 155.210022 L 603.039978 156.160004 Z"
      />
      <path
        id="path1529"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 158.619995 L 602.22998 158.27002 L 602.22998 157.279999 L 603.039978 157.640015 L 603.039978 158.619995 Z"
      />
      <path
        id="path1530"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 161.070007 L 602.22998 160.73999 L 602.22998 159.72998 L 603.039978 160.070007 L 603.039978 161.070007 Z"
      />
      <path
        id="path1531"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 163.52002 L 602.22998 163.220001 L 602.22998 162.179993 L 603.039978 162.48999 L 603.039978 163.52002 Z"
      />
      <path
        id="path1532"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 165.97998 L 602.22998 165.700012 L 602.22998 164.640015 L 603.039978 164.919983 L 603.039978 165.97998 Z"
      />
      <path
        id="path1533"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 168.429993 L 602.219971 168.169983 L 602.219971 167.089996 L 603.039978 167.350006 L 603.039978 168.429993 Z"
      />
      <path
        id="path1534"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 173.339996 L 602.219971 173.130005 L 602.219971 171.98999 L 603.039978 172.200012 L 603.039978 173.339996 Z"
      />
      <path
        id="path1535"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 175.789978 L 602.219971 175.600006 L 602.219971 174.440002 L 603.039978 174.630005 L 603.039978 175.789978 Z"
      />
      <path
        id="path1536"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 180.700012 L 602.210022 180.559998 L 602.210022 179.339996 L 603.039978 179.47998 L 603.039978 180.700012 Z"
      />
      <path
        id="path1537"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 183.149994 L 602.210022 183.029999 L 602.210022 181.789978 L 603.039978 181.910004 L 603.039978 183.149994 Z"
      />
      <path
        id="path1538"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 185.600006 L 602.210022 185.51001 L 602.210022 184.23999 L 603.039978 184.339996 L 603.039978 185.600006 Z"
      />
      <path
        id="path1539"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 190.51001 L 602.210022 190.460022 L 602.210022 189.140015 L 603.039978 189.190002 L 603.039978 190.51001 Z"
      />
      <path
        id="path1540"
        fill="#cecece"
        stroke="none"
        d="M 603.039978 192.960022 L 602.200012 192.940002 L 602.200012 191.589996 L 603.039978 191.619995 L 603.039978 192.960022 Z"
      />
      <path
        id="path1541"
        fill="#cecece"
        stroke="none"
        d="M 603.200012 138.330017 L 603.200012 139.089996 L 603.929993 139.589996 L 603.929993 138.839996 L 603.200012 138.330017 Z"
      />
      <path
        id="path1542"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 142.01001 L 603.200012 141.539978 L 603.200012 140.75 L 603.929993 141.23999 L 603.929993 142.01001 Z"
      />
      <path
        id="path1543"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 144.440002 L 603.200012 143.98999 L 603.200012 143.179993 L 603.929993 143.640015 L 603.929993 144.440002 Z"
      />
      <path
        id="path1544"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 146.869995 L 603.190002 146.440002 L 603.190002 145.600006 L 603.929993 146.039978 L 603.929993 146.869995 Z"
      />
      <path
        id="path1545"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 149.289978 L 603.190002 148.890015 L 603.190002 148.02002 L 603.929993 148.440002 L 603.929993 149.289978 Z"
      />
      <path
        id="path1546"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 151.720001 L 603.190002 151.339996 L 603.190002 150.440002 L 603.929993 150.839996 L 603.929993 151.720001 Z"
      />
      <path
        id="path1547"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 154.149994 L 603.190002 153.789978 L 603.190002 152.859985 L 603.929993 153.23999 L 603.929993 154.149994 Z"
      />
      <path
        id="path1548"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 156.580017 L 603.190002 156.22998 L 603.190002 155.289978 L 603.929993 155.640015 L 603.929993 156.580017 Z"
      />
      <path
        id="path1549"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 159 L 603.190002 158.679993 L 603.190002 157.710022 L 603.929993 158.039978 L 603.929993 159 Z"
      />
      <path
        id="path1550"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 161.429993 L 603.190002 161.130005 L 603.190002 160.130005 L 603.929993 160.440002 L 603.929993 161.429993 Z"
      />
      <path
        id="path1551"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 163.859985 L 603.190002 163.580017 L 603.190002 162.549988 L 603.929993 162.839996 L 603.929993 163.859985 Z"
      />
      <path
        id="path1552"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 166.289978 L 603.190002 166.029999 L 603.190002 164.97998 L 603.929993 165.23999 L 603.929993 166.289978 Z"
      />
      <path
        id="path1553"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 168.710022 L 603.190002 168.47998 L 603.190002 167.399994 L 603.929993 167.640015 L 603.929993 168.710022 Z"
      />
      <path
        id="path1554"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 171.140015 L 603.190002 170.929993 L 603.190002 169.820007 L 603.929993 170.039978 L 603.929993 171.140015 Z"
      />
      <path
        id="path1555"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 176 L 603.190002 175.820007 L 603.190002 174.669983 L 603.929993 174.839996 L 603.929993 176 Z"
      />
      <path
        id="path1556"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 178.419983 L 603.190002 178.27002 L 603.190002 177.089996 L 603.929993 177.23999 L 603.929993 178.419983 Z"
      />
      <path
        id="path1557"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 180.850006 L 603.190002 180.720001 L 603.190002 179.51001 L 603.929993 179.640015 L 603.929993 180.850006 Z"
      />
      <path
        id="path1558"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 185.710022 L 603.179993 185.619995 L 603.179993 184.350006 L 603.929993 184.440002 L 603.929993 185.710022 Z"
      />
      <path
        id="path1559"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 188.130005 L 603.179993 188.070007 L 603.179993 186.779999 L 603.929993 186.839996 L 603.929993 188.130005 Z"
      />
      <path
        id="path1560"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 190.559998 L 603.179993 190.52002 L 603.179993 189.200012 L 603.929993 189.23999 L 603.929993 190.559998 Z"
      />
      <path
        id="path1561"
        fill="#cecece"
        stroke="none"
        d="M 603.929993 194.039978 L 603.179993 194.039978 L 603.179993 195.410004 L 603.929993 195.410004 L 603.929993 194.039978 Z"
      />
      <path
        id="path1562"
        fill="#cecece"
        stroke="none"
        d="M 605.650024 140.01001 L 605.650024 140.73999 L 606.630005 141.390015 L 606.630005 140.690002 L 605.650024 140.01001 Z"
      />
      <path
        id="path1563"
        fill="#cecece"
        stroke="none"
        d="M 606.619995 143.73999 L 605.650024 143.109985 L 605.650024 142.359985 L 606.619995 143.01001 L 606.619995 143.73999 Z"
      />
      <path
        id="path1564"
        fill="#cecece"
        stroke="none"
        d="M 606.619995 146.089996 L 605.650024 145.48999 L 605.650024 144.710022 L 606.619995 145.330017 L 606.619995 146.089996 Z"
      />
      <path
        id="path1565"
        fill="#cecece"
        stroke="none"
        d="M 606.619995 150.789978 L 605.650024 150.23999 L 605.650024 149.410004 L 606.619995 149.970001 L 606.619995 150.789978 Z"
      />
      <path
        id="path1566"
        fill="#cecece"
        stroke="none"
        d="M 606.619995 153.140015 L 605.650024 152.619995 L 605.650024 151.76001 L 606.619995 152.289978 L 606.619995 153.140015 Z"
      />
      <path
        id="path1567"
        fill="#cecece"
        stroke="none"
        d="M 606.619995 155.48999 L 605.650024 155 L 605.650024 154.109985 L 606.619995 154.609985 L 606.619995 155.48999 Z"
      />
      <path
        id="path1568"
        fill="#cecece"
        stroke="none"
        d="M 606.619995 157.830017 L 605.650024 157.380005 L 605.650024 156.460022 L 606.619995 156.929993 L 606.619995 157.830017 Z"
      />
      <path
        id="path1569"
        fill="#cecece"
        stroke="none"
        d="M 606.609985 160.179993 L 605.650024 159.75 L 605.650024 158.809998 L 606.609985 159.25 L 606.609985 160.179993 Z"
      />
      <path
        id="path1570"
        fill="#cecece"
        stroke="none"
        d="M 606.609985 162.529999 L 605.650024 162.130005 L 605.650024 161.160004 L 606.609985 161.570007 L 606.609985 162.529999 Z"
      />
      <path
        id="path1571"
        fill="#cecece"
        stroke="none"
        d="M 606.609985 164.880005 L 605.650024 164.51001 L 605.650024 163.5 L 606.609985 163.890015 L 606.609985 164.880005 Z"
      />
      <path
        id="path1572"
        fill="#cecece"
        stroke="none"
        d="M 606.609985 171.929993 L 605.659973 171.640015 L 605.659973 170.549988 L 606.609985 170.850006 L 606.609985 171.929993 Z"
      />
      <path
        id="path1573"
        fill="#cecece"
        stroke="none"
        d="M 606.609985 174.279999 L 605.659973 174.02002 L 605.659973 172.899994 L 606.609985 173.169983 L 606.609985 174.279999 Z"
      />
      <path
        id="path1574"
        fill="#cecece"
        stroke="none"
        d="M 606.609985 176.630005 L 605.659973 176.399994 L 605.659973 175.25 L 606.609985 175.48999 L 606.609985 176.630005 Z"
      />
      <path
        id="path1575"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 178.970001 L 605.659973 178.77002 L 605.659973 177.600006 L 606.599976 177.799988 L 606.599976 178.970001 Z"
      />
      <path
        id="path1576"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 181.320007 L 605.659973 181.149994 L 605.659973 179.950012 L 606.599976 180.119995 L 606.599976 181.320007 Z"
      />
      <path
        id="path1577"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 186.02002 L 605.659973 185.910004 L 605.659973 184.649994 L 606.599976 184.76001 L 606.599976 186.02002 Z"
      />
      <path
        id="path1578"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 190.720001 L 605.659973 190.660004 L 605.659973 189.350006 L 606.599976 189.399994 L 606.599976 190.720001 Z"
      />
      <path
        id="path1579"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 193.070007 L 605.659973 193.039978 L 605.659973 191.690002 L 606.599976 191.720001 L 606.599976 193.070007 Z"
      />
      <path
        id="path1580"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 194.039978 L 605.669983 194.039978 L 605.669983 195.410004 L 606.599976 195.410004 L 606.599976 194.039978 Z"
      />
      <path
        id="path1581"
        fill="#cecece"
        stroke="none"
        d="M 606.780029 140.789978 L 606.780029 141.5 L 607.570007 142.029999 L 607.570007 141.339996 L 606.780029 140.789978 Z"
      />
      <path
        id="path1582"
        fill="#cecece"
        stroke="none"
        d="M 607.570007 144.350006 L 606.780029 143.839996 L 606.780029 143.109985 L 607.570007 143.630005 L 607.570007 144.350006 Z"
      />
      <path
        id="path1583"
        fill="#cecece"
        stroke="none"
        d="M 607.570007 146.669983 L 606.780029 146.179993 L 606.780029 145.419983 L 607.570007 145.919983 L 607.570007 146.669983 Z"
      />
      <path
        id="path1584"
        fill="#cecece"
        stroke="none"
        d="M 607.559998 148.98999 L 606.780029 148.529999 L 606.780029 147.73999 L 607.559998 148.210022 L 607.559998 148.98999 Z"
      />
      <path
        id="path1585"
        fill="#cecece"
        stroke="none"
        d="M 607.559998 151.309998 L 606.780029 150.869995 L 606.780029 150.049988 L 607.559998 150.51001 L 607.559998 151.309998 Z"
      />
      <path
        id="path1586"
        fill="#cecece"
        stroke="none"
        d="M 607.549988 153.640015 L 606.780029 153.220001 L 606.780029 152.369995 L 607.549988 152.799988 L 607.549988 153.640015 Z"
      />
      <path
        id="path1587"
        fill="#cecece"
        stroke="none"
        d="M 607.549988 155.960022 L 606.780029 155.559998 L 606.780029 154.679993 L 607.549988 155.089996 L 607.549988 155.960022 Z"
      />
      <path
        id="path1588"
        fill="#cecece"
        stroke="none"
        d="M 607.539978 160.600006 L 606.780029 160.25 L 606.780029 159.309998 L 607.539978 159.669983 L 607.539978 160.600006 Z"
      />
      <path
        id="path1589"
        fill="#cecece"
        stroke="none"
        d="M 607.539978 162.919983 L 606.780029 162.589996 L 606.780029 161.630005 L 607.539978 161.960022 L 607.539978 162.919983 Z"
      />
      <path
        id="path1590"
        fill="#cecece"
        stroke="none"
        d="M 607.530029 165.23999 L 606.780029 164.940002 L 606.780029 163.950012 L 607.530029 164.25 L 607.530029 165.23999 Z"
      />
      <path
        id="path1591"
        fill="#cecece"
        stroke="none"
        d="M 607.530029 167.559998 L 606.780029 167.279999 L 606.780029 166.26001 L 607.530029 166.549988 L 607.530029 167.559998 Z"
      />
      <path
        id="path1592"
        fill="#cecece"
        stroke="none"
        d="M 607.530029 169.880005 L 606.780029 169.630005 L 606.780029 168.580017 L 607.530029 168.839996 L 607.530029 169.880005 Z"
      />
      <path
        id="path1593"
        fill="#cecece"
        stroke="none"
        d="M 607.52002 172.200012 L 606.780029 171.970001 L 606.780029 170.890015 L 607.52002 171.130005 L 607.52002 172.200012 Z"
      />
      <path
        id="path1594"
        fill="#cecece"
        stroke="none"
        d="M 607.52002 174.529999 L 606.789978 174.320007 L 606.789978 173.210022 L 607.52002 173.419983 L 607.52002 174.529999 Z"
      />
      <path
        id="path1595"
        fill="#cecece"
        stroke="none"
        d="M 607.52002 176.850006 L 606.789978 176.660004 L 606.789978 175.52002 L 607.52002 175.710022 L 607.52002 176.850006 Z"
      />
      <path
        id="path1596"
        fill="#cecece"
        stroke="none"
        d="M 607.51001 179.169983 L 606.789978 179 L 606.789978 177.839996 L 607.51001 178 L 607.51001 179.169983 Z"
      />
      <path
        id="path1597"
        fill="#cecece"
        stroke="none"
        d="M 607.51001 181.48999 L 606.789978 181.350006 L 606.789978 180.149994 L 607.51001 180.289978 L 607.51001 181.48999 Z"
      />
      <path
        id="path1598"
        fill="#cecece"
        stroke="none"
        d="M 607.5 183.809998 L 606.789978 183.690002 L 606.789978 182.470001 L 607.5 182.589996 L 607.5 183.809998 Z"
      />
      <path
        id="path1599"
        fill="#cecece"
        stroke="none"
        d="M 607.5 186.130005 L 606.789978 186.039978 L 606.789978 184.779999 L 607.5 184.880005 L 607.5 186.130005 Z"
      />
      <path
        id="path1600"
        fill="#cecece"
        stroke="none"
        d="M 607.48999 188.450012 L 606.789978 188.380005 L 606.789978 187.100006 L 607.48999 187.169983 L 607.48999 188.450012 Z"
      />
      <path
        id="path1601"
        fill="#cecece"
        stroke="none"
        d="M 607.48999 193.089996 L 606.789978 193.070007 L 606.789978 191.72998 L 607.48999 191.75 L 607.48999 193.089996 Z"
      />
      <path
        id="path1602"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 135.23999 L 594.710022 135.98999 L 595.98999 135.76001 L 595.98999 134.960022 L 594.710022 135.23999 Z"
      />
      <path
        id="path1603"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 138.580017 L 595.98999 138.350006 L 595.98999 137.529999 L 594.710022 137.789978 L 594.710022 138.580017 Z"
      />
      <path
        id="path1604"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 141.160004 L 595.98999 140.950012 L 595.98999 140.100006 L 594.710022 140.350006 L 594.710022 141.160004 Z"
      />
      <path
        id="path1605"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 143.75 L 595.98999 143.539978 L 595.98999 142.669983 L 594.710022 142.910004 L 594.710022 143.75 Z"
      />
      <path
        id="path1606"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 146.330017 L 595.98999 146.130005 L 595.98999 145.23999 L 594.710022 145.460022 L 594.710022 146.330017 Z"
      />
      <path
        id="path1607"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 148.910004 L 595.98999 148.72998 L 595.98999 147.809998 L 594.710022 148.02002 L 594.710022 148.910004 Z"
      />
      <path
        id="path1608"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 151.5 L 595.98999 151.320007 L 595.98999 150.369995 L 594.710022 150.580017 L 594.710022 151.5 Z"
      />
      <path
        id="path1609"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 154.080017 L 595.97998 153.919983 L 595.97998 152.940002 L 594.710022 153.130005 L 594.710022 154.080017 Z"
      />
      <path
        id="path1610"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 156.660004 L 595.97998 156.51001 L 595.97998 155.51001 L 594.710022 155.690002 L 594.710022 156.660004 Z"
      />
      <path
        id="path1611"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 159.25 L 595.97998 159.100006 L 595.97998 158.080017 L 594.710022 158.25 L 594.710022 159.25 Z"
      />
      <path
        id="path1612"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 161.830017 L 595.97998 161.700012 L 595.97998 160.649994 L 594.710022 160.809998 L 594.710022 161.830017 Z"
      />
      <path
        id="path1613"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 164.410004 L 595.97998 164.289978 L 595.97998 163.220001 L 594.710022 163.359985 L 594.710022 164.410004 Z"
      />
      <path
        id="path1614"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 169.580017 L 595.97998 169.47998 L 595.97998 168.359985 L 594.710022 168.47998 L 594.710022 169.580017 Z"
      />
      <path
        id="path1615"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 172.160004 L 595.97998 172.070007 L 595.97998 170.919983 L 594.710022 171.029999 L 594.710022 172.160004 Z"
      />
      <path
        id="path1616"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 177.330017 L 595.97998 177.26001 L 595.97998 176.059998 L 594.710022 176.149994 L 594.710022 177.330017 Z"
      />
      <path
        id="path1617"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 179.910004 L 595.969971 179.850006 L 595.969971 178.630005 L 594.710022 178.700012 L 594.710022 179.910004 Z"
      />
      <path
        id="path1618"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 182.5 L 595.969971 182.450012 L 595.969971 181.200012 L 594.710022 181.26001 L 594.710022 182.5 Z"
      />
      <path
        id="path1619"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 187.660004 L 595.969971 187.630005 L 595.969971 186.339996 L 594.710022 186.369995 L 594.710022 187.660004 Z"
      />
      <path
        id="path1620"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 190.25 L 595.969971 190.22998 L 595.969971 188.910004 L 594.710022 188.929993 L 594.710022 190.25 Z"
      />
      <path
        id="path1621"
        fill="#cecece"
        stroke="none"
        d="M 594.710022 192.830017 L 595.969971 192.820007 L 595.969971 191.47998 L 594.710022 191.48999 L 594.710022 192.830017 Z"
      />
      <path
        id="path1622"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 135.609985 L 592.960022 136.320007 L 594.119995 136.100006 L 594.119995 135.369995 L 592.960022 135.609985 Z"
      />
      <path
        id="path1623"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 138.890015 L 594.119995 138.679993 L 594.119995 137.919983 L 592.960022 138.149994 L 592.960022 138.890015 Z"
      />
      <path
        id="path1624"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 144.02002 L 594.119995 143.839996 L 594.119995 143.02002 L 592.960022 143.23999 L 592.960022 144.02002 Z"
      />
      <path
        id="path1625"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 146.589996 L 594.119995 146.419983 L 594.119995 145.570007 L 592.960022 145.779999 L 592.960022 146.589996 Z"
      />
      <path
        id="path1626"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 149.160004 L 594.119995 149 L 594.119995 148.119995 L 592.960022 148.320007 L 592.960022 149.160004 Z"
      />
      <path
        id="path1627"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 151.72998 L 594.119995 151.580017 L 594.119995 150.669983 L 592.960022 150.859985 L 592.960022 151.72998 Z"
      />
      <path
        id="path1628"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 154.299988 L 594.119995 154.160004 L 594.119995 153.220001 L 592.960022 153.399994 L 592.960022 154.299988 Z"
      />
      <path
        id="path1629"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 159.440002 L 594.119995 159.309998 L 594.119995 158.330017 L 592.960022 158.47998 L 592.960022 159.440002 Z"
      />
      <path
        id="path1630"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 162.01001 L 594.119995 161.890015 L 594.119995 160.880005 L 592.960022 161.02002 L 592.960022 162.01001 Z"
      />
      <path
        id="path1631"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 164.580017 L 594.119995 164.470001 L 594.119995 163.429993 L 592.960022 163.559998 L 592.960022 164.580017 Z"
      />
      <path
        id="path1632"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 169.690002 L 594.119995 169.589996 L 594.119995 168.52002 L 592.960022 168.640015 L 592.960022 169.690002 Z"
      />
      <path
        id="path1633"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 172.289978 L 594.119995 172.210022 L 594.119995 171.080017 L 592.960022 171.179993 L 592.960022 172.289978 Z"
      />
      <path
        id="path1634"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 174.859985 L 594.119995 174.779999 L 594.119995 173.630005 L 592.960022 173.720001 L 592.960022 174.859985 Z"
      />
      <path
        id="path1635"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 177.429993 L 594.119995 177.359985 L 594.119995 176.179993 L 592.960022 176.26001 L 592.960022 177.429993 Z"
      />
      <path
        id="path1636"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 185.140015 L 594.119995 185.100006 L 594.119995 183.839996 L 592.960022 183.880005 L 592.960022 185.140015 Z"
      />
      <path
        id="path1637"
        fill="#cecece"
        stroke="none"
        d="M 592.960022 187.710022 L 594.119995 187.679993 L 594.119995 186.390015 L 592.960022 186.419983 L 592.960022 187.710022 Z"
      />
      <path
        id="path1638"
        fill="#cecece"
        stroke="none"
        d="M 592.950012 192.850006 L 594.119995 192.839996 L 594.119995 191.48999 L 592.950012 191.5 L 592.950012 192.850006 Z"
      />
      <path
        id="path1639"
        fill="#cecece"
        stroke="none"
        d="M 591.530029 135.919983 L 591.530029 136.580017 L 592.440002 136.410004 L 592.440002 135.72998 L 591.530029 135.919983 Z"
      />
      <path
        id="path1640"
        fill="#cecece"
        stroke="none"
        d="M 591.530029 139.140015 L 592.440002 138.97998 L 592.440002 138.26001 L 591.530029 138.450012 L 591.530029 139.140015 Z"
      />
      <path
        id="path1641"
        fill="#cecece"
        stroke="none"
        d="M 591.530029 144.25 L 592.440002 144.109985 L 592.440002 143.330017 L 591.530029 143.5 L 591.530029 144.25 Z"
      />
      <path
        id="path1642"
        fill="#cecece"
        stroke="none"
        d="M 591.530029 146.809998 L 592.440002 146.669983 L 592.440002 145.869995 L 591.530029 146.029999 L 591.530029 146.809998 Z"
      />
      <path
        id="path1643"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 149.369995 L 592.429993 149.23999 L 592.429993 148.399994 L 591.52002 148.559998 L 591.52002 149.369995 Z"
      />
      <path
        id="path1644"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 154.48999 L 592.429993 154.369995 L 592.429993 153.470001 L 591.52002 153.609985 L 591.52002 154.48999 Z"
      />
      <path
        id="path1645"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 159.600006 L 592.429993 159.5 L 592.429993 158.549988 L 591.52002 158.669983 L 591.52002 159.600006 Z"
      />
      <path
        id="path1646"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 164.720001 L 592.429993 164.630005 L 592.429993 163.619995 L 591.52002 163.720001 L 591.52002 164.720001 Z"
      />
      <path
        id="path1647"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 169.830017 L 592.429993 169.76001 L 592.429993 168.690002 L 591.52002 168.77002 L 591.52002 169.830017 Z"
      />
      <path
        id="path1648"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 174.950012 L 592.419983 174.890015 L 592.419983 173.76001 L 591.52002 173.830017 L 591.52002 174.950012 Z"
      />
      <path
        id="path1649"
        fill="#cecece"
        stroke="none"
        d="M 591.52002 177.51001 L 592.419983 177.460022 L 592.419983 176.299988 L 591.52002 176.350006 L 591.52002 177.51001 Z"
      />
      <path
        id="path1650"
        fill="#cecece"
        stroke="none"
        d="M 591.51001 182.619995 L 592.419983 182.589996 L 592.419983 181.369995 L 591.51001 181.410004 L 591.51001 182.619995 Z"
      />
      <path
        id="path1651"
        fill="#cecece"
        stroke="none"
        d="M 591.51001 185.179993 L 592.419983 185.149994 L 592.419983 183.899994 L 591.51001 183.940002 L 591.51001 185.179993 Z"
      />
      <path
        id="path1652"
        fill="#cecece"
        stroke="none"
        d="M 591.51001 187.73999 L 592.419983 187.720001 L 592.419983 186.440002 L 591.51001 186.460022 L 591.51001 187.73999 Z"
      />
      <path
        id="path1653"
        fill="#cecece"
        stroke="none"
        d="M 589.909973 136.27002 L 589.909973 136.880005 L 591.01001 136.669983 L 591.01001 136.029999 L 589.909973 136.27002 Z"
      />
      <path
        id="path1654"
        fill="#cecece"
        stroke="none"
        d="M 589.909973 139.419983 L 591.01001 139.22998 L 591.01001 138.559998 L 589.909973 138.779999 L 589.909973 139.419983 Z"
      />
      <path
        id="path1655"
        fill="#cecece"
        stroke="none"
        d="M 589.909973 141.970001 L 591.01001 141.779999 L 591.01001 141.080017 L 589.909973 141.289978 L 589.909973 141.970001 Z"
      />
      <path
        id="path1656"
        fill="#cecece"
        stroke="none"
        d="M 589.909973 144.51001 L 591.01001 144.339996 L 591.01001 143.600006 L 589.909973 143.809998 L 589.909973 144.51001 Z"
      />
      <path
        id="path1657"
        fill="#cecece"
        stroke="none"
        d="M 589.900024 147.059998 L 591.01001 146.890015 L 591.01001 146.119995 L 589.900024 146.320007 L 589.900024 147.059998 Z"
      />
      <path
        id="path1658"
        fill="#cecece"
        stroke="none"
        d="M 589.900024 152.149994 L 591.01001 152 L 591.01001 151.169983 L 589.900024 151.339996 L 589.900024 152.149994 Z"
      />
      <path
        id="path1659"
        fill="#cecece"
        stroke="none"
        d="M 589.900024 154.690002 L 591.01001 154.549988 L 591.01001 153.690002 L 589.900024 153.850006 L 589.900024 154.690002 Z"
      />
      <path
        id="path1660"
        fill="#cecece"
        stroke="none"
        d="M 589.900024 157.23999 L 591.01001 157.109985 L 591.01001 156.210022 L 589.900024 156.369995 L 589.900024 157.23999 Z"
      />
      <path
        id="path1661"
        fill="#cecece"
        stroke="none"
        d="M 589.890015 162.330017 L 591.01001 162.210022 L 591.01001 161.26001 L 589.890015 161.390015 L 589.890015 162.330017 Z"
      />
      <path
        id="path1662"
        fill="#cecece"
        stroke="none"
        d="M 589.890015 169.960022 L 591.01001 169.880005 L 591.01001 168.820007 L 589.890015 168.919983 L 589.890015 169.960022 Z"
      />
      <path
        id="path1663"
        fill="#cecece"
        stroke="none"
        d="M 589.890015 172.51001 L 591.01001 172.429993 L 591.01001 171.339996 L 589.890015 171.440002 L 589.890015 172.51001 Z"
      />
      <path
        id="path1664"
        fill="#cecece"
        stroke="none"
        d="M 589.880005 175.049988 L 591.01001 174.97998 L 591.01001 173.869995 L 589.880005 173.950012 L 589.880005 175.049988 Z"
      />
      <path
        id="path1665"
        fill="#cecece"
        stroke="none"
        d="M 589.880005 177.600006 L 591.01001 177.539978 L 591.01001 176.390015 L 589.880005 176.460022 L 589.880005 177.600006 Z"
      />
      <path
        id="path1666"
        fill="#cecece"
        stroke="none"
        d="M 589.880005 180.140015 L 591.01001 180.089996 L 591.01001 178.910004 L 589.880005 178.970001 L 589.880005 180.140015 Z"
      />
      <path
        id="path1667"
        fill="#cecece"
        stroke="none"
        d="M 589.880005 185.22998 L 591.01001 185.200012 L 591.01001 183.950012 L 589.880005 184 L 589.880005 185.22998 Z"
      />
      <path
        id="path1668"
        fill="#cecece"
        stroke="none"
        d="M 589.869995 190.320007 L 591.01001 190.309998 L 591.01001 189 L 589.869995 189.02002 L 589.869995 190.320007 Z"
      />
      <path
        id="path1669"
        fill="#cecece"
        stroke="none"
        d="M 589.869995 192.869995 L 591.01001 192.859985 L 591.01001 191.52002 L 589.869995 191.529999 L 589.869995 192.869995 Z"
      />
      <path
        id="path1670"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 136.580017 L 588.309998 137.27002 L 589.450012 137.070007 L 589.450012 136.339996 L 588.309998 136.580017 Z"
      />
      <path
        id="path1671"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 139.799988 L 589.450012 139.600006 L 589.450012 138.850006 L 588.309998 139.080017 L 588.309998 139.799988 Z"
      />
      <path
        id="path1672"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 142.330017 L 589.450012 142.140015 L 589.450012 141.359985 L 588.309998 141.580017 L 588.309998 142.330017 Z"
      />
      <path
        id="path1673"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 144.850006 L 589.450012 144.669983 L 589.450012 143.859985 L 588.309998 144.080017 L 588.309998 144.850006 Z"
      />
      <path
        id="path1674"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 147.380005 L 589.450012 147.210022 L 589.450012 146.369995 L 588.309998 146.570007 L 588.309998 147.380005 Z"
      />
      <path
        id="path1675"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 152.429993 L 589.450012 152.279999 L 589.450012 151.390015 L 588.309998 151.570007 L 588.309998 152.429993 Z"
      />
      <path
        id="path1676"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 154.960022 L 589.450012 154.809998 L 589.450012 153.899994 L 588.309998 154.070007 L 588.309998 154.960022 Z"
      />
      <path
        id="path1677"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 157.47998 L 589.450012 157.350006 L 589.450012 156.399994 L 588.309998 156.559998 L 588.309998 157.47998 Z"
      />
      <path
        id="path1678"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 160.01001 L 589.450012 159.880005 L 589.450012 158.910004 L 588.309998 159.059998 L 588.309998 160.01001 Z"
      />
      <path
        id="path1679"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 162.529999 L 589.450012 162.419983 L 589.450012 161.419983 L 588.309998 161.559998 L 588.309998 162.529999 Z"
      />
      <path
        id="path1680"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 165.059998 L 589.450012 164.950012 L 589.450012 163.929993 L 588.309998 164.059998 L 588.309998 165.059998 Z"
      />
      <path
        id="path1681"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 172.640015 L 589.450012 172.559998 L 589.450012 171.450012 L 588.309998 171.549988 L 588.309998 172.640015 Z"
      />
      <path
        id="path1682"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 175.160004 L 589.450012 175.089996 L 589.450012 173.960022 L 588.309998 174.039978 L 588.309998 175.160004 Z"
      />
      <path
        id="path1683"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 177.690002 L 589.450012 177.630005 L 589.450012 176.470001 L 588.309998 176.539978 L 588.309998 177.690002 Z"
      />
      <path
        id="path1684"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 185.27002 L 589.450012 185.22998 L 589.450012 183.98999 L 588.309998 184.029999 L 588.309998 185.27002 Z"
      />
      <path
        id="path1685"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 187.789978 L 589.450012 187.77002 L 589.450012 186.5 L 588.309998 186.529999 L 588.309998 187.789978 Z"
      />
      <path
        id="path1686"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 192.850006 L 589.450012 192.839996 L 589.450012 191.52002 L 588.309998 191.529999 L 588.309998 192.850006 Z"
      />
      <path
        id="path1687"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 136.890015 L 586.900024 137.529999 L 587.799988 137.369995 L 587.799988 136.690002 L 586.900024 136.890015 Z"
      />
      <path
        id="path1688"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 140.049988 L 587.799988 139.890015 L 587.799988 139.190002 L 586.900024 139.369995 L 586.900024 140.049988 Z"
      />
      <path
        id="path1689"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 142.559998 L 587.799988 142.410004 L 587.799988 141.679993 L 586.900024 141.859985 L 586.900024 142.559998 Z"
      />
      <path
        id="path1690"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 145.080017 L 587.799988 144.929993 L 587.799988 144.169983 L 586.900024 144.339996 L 586.900024 145.080017 Z"
      />
      <path
        id="path1691"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 147.589996 L 587.799988 147.460022 L 587.799988 146.660004 L 586.900024 146.820007 L 586.900024 147.589996 Z"
      />
      <path
        id="path1692"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 150.109985 L 587.789978 149.97998 L 587.789978 149.160004 L 586.900024 149.309998 L 586.900024 150.109985 Z"
      />
      <path
        id="path1693"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 155.140015 L 587.789978 155.02002 L 587.789978 154.140015 L 586.900024 154.279999 L 586.900024 155.140015 Z"
      />
      <path
        id="path1694"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 157.649994 L 587.789978 157.539978 L 587.789978 156.630005 L 586.900024 156.76001 L 586.900024 157.649994 Z"
      />
      <path
        id="path1695"
        fill="#cecece"
        stroke="none"
        d="M 586.900024 160.169983 L 587.789978 160.070007 L 587.789978 159.130005 L 586.900024 159.25 L 586.900024 160.169983 Z"
      />
      <path
        id="path1696"
        fill="#cecece"
        stroke="none"
        d="M 586.890015 165.190002 L 587.789978 165.109985 L 587.789978 164.109985 L 586.890015 164.210022 L 586.890015 165.190002 Z"
      />
      <path
        id="path1697"
        fill="#cecece"
        stroke="none"
        d="M 586.890015 175.25 L 587.780029 175.200012 L 587.780029 174.210022 L 586.890015 174.27002 L 586.890015 175.25 Z"
      />
      <path
        id="path1698"
        fill="#cecece"
        stroke="none"
        d="M 586.890015 177.77002 L 587.780029 177.720001 L 587.780029 176.580017 L 586.890015 176.630005 L 586.890015 177.77002 Z"
      />
      <path
        id="path1699"
        fill="#cecece"
        stroke="none"
        d="M 586.890015 182.799988 L 587.780029 182.76001 L 587.780029 181.559998 L 586.890015 181.600006 L 586.890015 182.799988 Z"
      />
      <path
        id="path1700"
        fill="#cecece"
        stroke="none"
        d="M 586.890015 185.309998 L 587.780029 185.279999 L 587.780029 184.049988 L 586.890015 184.089996 L 586.890015 185.309998 Z"
      />
      <path
        id="path1701"
        fill="#cecece"
        stroke="none"
        d="M 586.890015 187.830017 L 587.780029 187.809998 L 587.780029 186.549988 L 586.890015 186.570007 L 586.890015 187.830017 Z"
      />
      <path
        id="path1702"
        fill="#cecece"
        stroke="none"
        d="M 585.309998 137.22998 L 585.309998 137.830017 L 586.390015 137.630005 L 586.390015 137 L 585.309998 137.22998 Z"
      />
      <path
        id="path1703"
        fill="#cecece"
        stroke="none"
        d="M 585.309998 140.330017 L 586.390015 140.140015 L 586.390015 139.47998 L 585.309998 139.700012 L 585.309998 140.330017 Z"
      />
      <path
        id="path1704"
        fill="#cecece"
        stroke="none"
        d="M 585.309998 142.830017 L 586.390015 142.649994 L 586.390015 141.960022 L 585.309998 142.169983 L 585.309998 142.830017 Z"
      />
      <path
        id="path1705"
        fill="#cecece"
        stroke="none"
        d="M 585.309998 145.330017 L 586.390015 145.160004 L 586.390015 144.440002 L 585.309998 144.640015 L 585.309998 145.330017 Z"
      />
      <path
        id="path1706"
        fill="#cecece"
        stroke="none"
        d="M 585.309998 147.830017 L 586.390015 147.669983 L 586.390015 146.910004 L 585.309998 147.109985 L 585.309998 147.830017 Z"
      />
      <path
        id="path1707"
        fill="#cecece"
        stroke="none"
        d="M 585.299988 152.839996 L 586.390015 152.690002 L 586.390015 151.869995 L 585.299988 152.039978 L 585.299988 152.839996 Z"
      />
      <path
        id="path1708"
        fill="#cecece"
        stroke="none"
        d="M 585.299988 155.339996 L 586.390015 155.200012 L 586.390015 154.350006 L 585.299988 154.51001 L 585.299988 155.339996 Z"
      />
      <path
        id="path1709"
        fill="#cecece"
        stroke="none"
        d="M 585.299988 157.839996 L 586.390015 157.710022 L 586.390015 156.830017 L 585.299988 156.97998 L 585.299988 157.839996 Z"
      />
      <path
        id="path1710"
        fill="#cecece"
        stroke="none"
        d="M 585.299988 162.850006 L 586.390015 162.72998 L 586.390015 161.789978 L 585.299988 161.919983 L 585.299988 162.850006 Z"
      />
      <path
        id="path1711"
        fill="#cecece"
        stroke="none"
        d="M 585.289978 170.350006 L 586.390015 170.27002 L 586.390015 169.22998 L 585.289978 169.330017 L 585.289978 170.350006 Z"
      />
      <path
        id="path1712"
        fill="#cecece"
        stroke="none"
        d="M 585.289978 172.850006 L 586.390015 172.779999 L 586.390015 171.710022 L 585.289978 171.799988 L 585.289978 172.850006 Z"
      />
      <path
        id="path1713"
        fill="#cecece"
        stroke="none"
        d="M 585.289978 175.429993 L 586.390015 175.350006 L 586.390015 174.289978 L 585.289978 174.380005 L 585.289978 175.429993 Z"
      />
      <path
        id="path1714"
        fill="#cecece"
        stroke="none"
        d="M 585.280029 190.369995 L 586.390015 190.350006 L 586.390015 189.059998 L 585.280029 189.080017 L 585.280029 190.369995 Z"
      />
      <path
        id="path1715"
        fill="#cecece"
        stroke="none"
        d="M 585.27002 192.869995 L 586.390015 192.859985 L 586.390015 191.539978 L 585.27002 191.549988 L 585.27002 192.869995 Z"
      />
      <path
        id="path1716"
        fill="#cecece"
        stroke="none"
        d="M 583.280029 173.179993 L 584.400024 173.100006 L 584.400024 172.01001 L 583.280029 172.109985 L 583.280029 173.179993 Z"
      />
      <path
        id="path1717"
        fill="#cecece"
        stroke="none"
        d="M 583.280029 175.720001 L 584.400024 175.649994 L 584.400024 174.529999 L 583.280029 174.619995 L 583.280029 175.720001 Z"
      />
      <path
        id="path1718"
        fill="#cecece"
        stroke="none"
        d="M 583.27002 178.27002 L 584.400024 178.210022 L 584.400024 177.059998 L 583.27002 177.130005 L 583.27002 178.27002 Z"
      />
      <path
        id="path1719"
        fill="#cecece"
        stroke="none"
        d="M 583.27002 180.809998 L 584.400024 180.76001 L 584.400024 179.580017 L 583.27002 179.640015 L 583.27002 180.809998 Z"
      />
      <path
        id="path1720"
        fill="#cecece"
        stroke="none"
        d="M 581.700012 173.309998 L 582.840027 173.220001 L 582.840027 172.119995 L 581.700012 172.220001 L 581.700012 173.309998 Z"
      />
      <path
        id="path1721"
        fill="#cecece"
        stroke="none"
        d="M 581.700012 175.830017 L 582.840027 175.76001 L 582.840027 174.630005 L 581.700012 174.710022 L 581.700012 175.830017 Z"
      />
      <path
        id="path1722"
        fill="#cecece"
        stroke="none"
        d="M 578.469971 185.940002 L 579.609985 185.899994 L 579.609985 184.660004 L 578.469971 184.700012 L 578.469971 185.940002 Z"
      />
      <path
        id="path1723"
        fill="#cecece"
        stroke="none"
        d="M 580.280029 175.919983 L 581.179993 175.869995 L 581.179993 174.75 L 580.280029 174.820007 L 580.280029 175.919983 Z"
      />
      <path
        id="path1724"
        fill="#cecece"
        stroke="none"
        d="M 577.059998 183.470001 L 577.950012 183.429993 L 577.950012 182.22998 L 577.059998 182.27002 L 577.059998 183.470001 Z"
      />
      <path
        id="path1725"
        fill="#cecece"
        stroke="none"
        d="M 577.049988 188.5 L 577.950012 188.470001 L 577.950012 187.210022 L 577.049988 187.23999 L 577.049988 188.5 Z"
      />
      <path
        id="path1726"
        fill="#cecece"
        stroke="none"
        d="M 578.679993 176.02002 L 579.780029 175.950012 L 579.780029 174.859985 L 578.679993 174.940002 L 578.679993 176.02002 Z"
      />
      <path
        id="path1727"
        fill="#cecece"
        stroke="none"
        d="M 578.679993 181.029999 L 579.780029 180.97998 L 579.780029 179.820007 L 578.679993 179.880005 L 578.679993 181.029999 Z"
      />
      <path
        id="path1728"
        fill="#cecece"
        stroke="none"
        d="M 575.440002 191.039978 L 576.559998 191.02002 L 576.559998 189.72998 L 575.440002 189.75 L 575.440002 191.039978 Z"
      />
      <path
        id="path1729"
        fill="#cecece"
        stroke="none"
        d="M 575.440002 193.539978 L 576.559998 193.529999 L 576.559998 192.210022 L 575.440002 192.220001 L 575.440002 193.539978 Z"
      />
      <path
        id="path1730"
        fill="#cecece"
        stroke="none"
        d="M 577.309998 176.23999 L 578.200012 176.179993 L 578.200012 175.070007 L 577.309998 175.130005 L 577.309998 176.23999 Z"
      />
      <path
        id="path1731"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 183.779999 L 574.969971 183.73999 L 574.969971 182.539978 L 574.080017 182.580017 L 574.080017 183.779999 Z"
      />
      <path
        id="path1732"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 186.299988 L 574.969971 186.27002 L 574.969971 185.039978 L 574.080017 185.070007 L 574.080017 186.299988 Z"
      />
      <path
        id="path1733"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 188.809998 L 574.969971 188.789978 L 574.969971 187.529999 L 574.080017 187.549988 L 574.080017 188.809998 Z"
      />
      <path
        id="path1734"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 193.660004 L 574.969971 193.640015 L 574.969971 192.380005 L 574.080017 192.399994 L 574.080017 193.660004 Z"
      />
      <path
        id="path1735"
        fill="#cecece"
        stroke="none"
        d="M 575.710022 173.839996 L 576.809998 173.76001 L 576.809998 172.690002 L 575.710022 172.779999 L 575.710022 173.839996 Z"
      />
      <path
        id="path1736"
        fill="#cecece"
        stroke="none"
        d="M 575.700012 176.339996 L 576.809998 176.27002 L 576.809998 175.169983 L 575.700012 175.25 L 575.700012 176.339996 Z"
      />
      <path
        id="path1737"
        fill="#cecece"
        stroke="none"
        d="M 575.700012 178.839996 L 576.809998 178.779999 L 576.809998 177.649994 L 575.700012 177.720001 L 575.700012 178.839996 Z"
      />
      <path
        id="path1738"
        fill="#cecece"
        stroke="none"
        d="M 575.700012 181.339996 L 576.809998 181.289978 L 576.809998 180.130005 L 575.700012 180.190002 L 575.700012 181.339996 Z"
      />
      <path
        id="path1739"
        fill="#cecece"
        stroke="none"
        d="M 572.469971 186.350006 L 573.580017 186.309998 L 573.580017 185.089996 L 572.469971 185.130005 L 572.469971 186.350006 Z"
      />
      <path
        id="path1740"
        fill="#cecece"
        stroke="none"
        d="M 572.460022 193.850006 L 573.580017 193.839996 L 573.580017 192.529999 L 572.460022 192.539978 L 572.460022 193.850006 Z"
      />
      <path
        id="path1741"
        fill="#cecece"
        stroke="none"
        d="M 573.700012 174.160004 L 574.820007 174.080017 L 574.820007 172.98999 L 573.700012 173.089996 L 573.700012 174.160004 Z"
      />
      <path
        id="path1742"
        fill="#cecece"
        stroke="none"
        d="M 573.690002 176.700012 L 574.820007 176.630005 L 574.820007 175.52002 L 573.690002 175.600006 L 573.690002 176.700012 Z"
      />
      <path
        id="path1743"
        fill="#cecece"
        stroke="none"
        d="M 573.690002 179.25 L 574.820007 179.190002 L 574.820007 178.039978 L 573.690002 178.109985 L 573.690002 179.25 Z"
      />
      <path
        id="path1744"
        fill="#cecece"
        stroke="none"
        d="M 573.690002 181.789978 L 574.820007 181.73999 L 574.820007 180.559998 L 573.690002 180.619995 L 573.690002 181.789978 Z"
      />
      <path
        id="path1745"
        fill="#cecece"
        stroke="none"
        d="M 572.119995 174.289978 L 573.26001 174.210022 L 573.26001 173.100006 L 572.119995 173.200012 L 572.119995 174.289978 Z"
      />
      <path
        id="path1746"
        fill="#cecece"
        stroke="none"
        d="M 572.119995 176.809998 L 573.26001 176.73999 L 573.26001 175.609985 L 572.119995 175.690002 L 572.119995 176.809998 Z"
      />
      <path
        id="path1747"
        fill="#cecece"
        stroke="none"
        d="M 572.119995 179.339996 L 573.26001 179.279999 L 573.26001 178.119995 L 572.119995 178.190002 L 572.119995 179.339996 Z"
      />
      <path
        id="path1748"
        fill="#cecece"
        stroke="none"
        d="M 589.880005 197.25 L 591.01001 197.200012 L 591.01001 196.02002 L 589.880005 196.080017 L 589.880005 197.25 Z"
      />
      <path
        id="path1749"
        fill="#cecece"
        stroke="none"
        d="M 594.820007 202.070007 L 595.950012 202.029999 L 595.950012 200.789978 L 594.820007 200.830017 L 594.820007 202.070007 Z"
      />
      <path
        id="path1750"
        fill="#cecece"
        stroke="none"
        d="M 593.25 202.100006 L 594.390015 202.070007 L 594.390015 200.830017 L 593.25 200.869995 L 593.25 202.100006 Z"
      />
      <path
        id="path1751"
        fill="#cecece"
        stroke="none"
        d="M 593.25 204.630005 L 594.390015 204.600006 L 594.390015 203.330017 L 593.25 203.369995 L 593.25 204.630005 Z"
      />
      <path
        id="path1752"
        fill="#cecece"
        stroke="none"
        d="M 591.849976 211.390015 L 592.98999 211.380005 L 592.98999 210.059998 L 591.849976 210.070007 L 591.849976 211.390015 Z"
      />
      <path
        id="path1753"
        fill="#cecece"
        stroke="none"
        d="M 588.309998 199.899994 L 589.200012 199.869995 L 589.200012 198.669983 L 588.309998 198.710022 L 588.309998 199.899994 Z"
      />
      <path
        id="path1754"
        fill="#cecece"
        stroke="none"
        d="M 591.830017 202.149994 L 592.719971 202.119995 L 592.719971 200.890015 L 591.830017 200.919983 L 591.830017 202.149994 Z"
      />
      <path
        id="path1755"
        fill="#cecece"
        stroke="none"
        d="M 591.830017 204.660004 L 592.719971 204.640015 L 592.719971 203.380005 L 591.830017 203.410004 L 591.830017 204.660004 Z"
      />
      <path
        id="path1756"
        fill="#cecece"
        stroke="none"
        d="M 597.169983 208.660004 L 598.369995 208.630005 L 598.369995 207.309998 L 597.169983 207.350006 L 597.169983 208.660004 Z"
      />
      <path
        id="path1757"
        fill="#cecece"
        stroke="none"
        d="M 595.52002 208.700012 L 596.719971 208.660004 L 596.719971 207.350006 L 595.52002 207.399994 L 595.52002 208.700012 Z"
      />
      <path
        id="path1758"
        fill="#cecece"
        stroke="none"
        d="M 595.52002 211.369995 L 596.719971 211.339996 L 596.719971 210 L 595.52002 210.029999 L 595.52002 211.369995 Z"
      />
      <path
        id="path1759"
        fill="#cecece"
        stroke="none"
        d="M 594.02002 208.75 L 594.960022 208.720001 L 594.960022 207.419983 L 594.02002 207.450012 L 594.02002 208.75 Z"
      />
      <path
        id="path1760"
        fill="#cecece"
        stroke="none"
        d="M 594.02002 211.399994 L 594.960022 211.380005 L 594.960022 210.049988 L 594.02002 210.080017 L 594.02002 211.399994 Z"
      />
      <path
        id="path1761"
        fill="#cecece"
        stroke="none"
        d="M 578.47998 193.380005 L 579.609985 193.309998 L 579.609985 192.169983 L 578.47998 192.23999 L 578.47998 193.380005 Z"
      />
      <path
        id="path1762"
        fill="#cecece"
        stroke="none"
        d="M 578.47998 195.919983 L 579.609985 195.869995 L 579.609985 194.690002 L 578.47998 194.75 L 578.47998 195.919983 Z"
      />
      <path
        id="path1763"
        fill="#cecece"
        stroke="none"
        d="M 577.049988 202.890015 L 577.950012 202.869995 L 577.950012 201.609985 L 577.049988 201.640015 L 577.049988 202.890015 Z"
      />
      <path
        id="path1764"
        fill="#cecece"
        stroke="none"
        d="M 575.450012 198.130005 L 576.559998 198.080017 L 576.559998 196.919983 L 575.450012 196.97998 L 575.450012 198.130005 Z"
      />
      <path
        id="path1765"
        fill="#cecece"
        stroke="none"
        d="M 572.469971 205.429993 L 573.590027 205.419983 L 573.590027 204.130005 L 572.469971 204.149994 L 572.469971 205.429993 Z"
      />
      <path
        id="path1766"
        fill="#cecece"
        stroke="none"
        d="M 572.469971 207.929993 L 573.590027 207.929993 L 573.590027 206.609985 L 572.469971 206.619995 L 572.469971 207.929993 Z"
      />
      <path
        id="path1767"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 195.859985 L 574.97998 195.809998 L 574.97998 194.660004 L 574.080017 194.720001 L 574.080017 195.859985 Z"
      />
      <path
        id="path1768"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 200.690002 L 574.969971 200.660004 L 574.969971 199.429993 L 574.080017 199.470001 L 574.080017 200.690002 Z"
      />
      <path
        id="path1769"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 203.210022 L 574.969971 203.179993 L 574.969971 201.919983 L 574.080017 201.950012 L 574.080017 203.210022 Z"
      />
      <path
        id="path1770"
        fill="#cecece"
        stroke="none"
        d="M 572.469971 200.73999 L 573.580017 200.710022 L 573.580017 199.47998 L 572.469971 199.52002 L 572.469971 200.73999 Z"
      />
      <path
        id="path1771"
        fill="#cecece"
        stroke="none"
        d="M 575.440002 210.070007 L 576.559998 210.049988 L 576.559998 208.77002 L 575.440002 208.789978 L 575.440002 210.070007 Z"
      />
      <path
        id="path1772"
        fill="#cecece"
        stroke="none"
        d="M 575.440002 212.570007 L 576.559998 212.559998 L 576.559998 211.25 L 575.440002 211.26001 L 575.440002 212.570007 Z"
      />
      <path
        id="path1773"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 207.839996 L 574.969971 207.820007 L 574.969971 206.559998 L 574.080017 206.589996 L 574.080017 207.839996 Z"
      />
      <path
        id="path1774"
        fill="#cecece"
        stroke="none"
        d="M 572.460022 212.890015 L 573.580017 212.880005 L 573.580017 211.559998 L 572.460022 211.570007 L 572.460022 212.890015 Z"
      />
      <path
        id="path1775"
        fill="#cecece"
        stroke="none"
        d="M 574.080017 214.890015 L 574.97998 214.839996 L 574.97998 213.700012 L 574.080017 213.76001 L 574.080017 214.890015 Z"
      />
      <path
        id="path1776"
        fill="#cecece"
        stroke="none"
        d="M 572.469971 219.779999 L 573.580017 219.73999 L 573.580017 218.52002 L 572.469971 218.559998 L 572.469971 219.779999 Z"
      />
      <path
        id="path1777"
        fill="#cecece"
        stroke="none"
        d="M 600.73999 195.410004 L 602 195.410004 L 602 137.450012 L 600.73999 136.580017 L 600.73999 195.410004 Z"
      />
      <path
        id="path1778"
        fill="#cecece"
        stroke="none"
        d="M 604.150024 195.410004 L 605.409973 195.410004 L 605.409973 139.820007 L 604.150024 138.950012 L 604.150024 195.410004 Z"
      />
      <path
        id="path1779"
        fill="#cecece"
        stroke="none"
        d="M 607.820007 195.410004 L 608.179993 195.410004 L 608.179993 141.75 L 607.820007 141.5 L 607.820007 195.410004 Z"
      />
      <path
        id="path1780"
        fill="#cecece"
        stroke="none"
        d="M 608.289978 195.410004 L 608.650024 195.410004 L 608.650024 142.080017 L 608.289978 141.830017 L 608.289978 195.410004 Z"
      />
      <path
        id="path1781"
        fill="#cecece"
        stroke="none"
        d="M 756.570007 167.029999 L 756.570007 167.549988 L 757.289978 167.419983 L 757.289978 166.880005 L 756.570007 167.029999 Z"
      />
      <path
        id="path1782"
        fill="#cecece"
        stroke="none"
        d="M 757.289978 169.089996 L 756.570007 169.210022 L 756.570007 168.679993 L 757.289978 168.529999 L 757.289978 169.089996 Z"
      />
      <path
        id="path1783"
        fill="#cecece"
        stroke="none"
        d="M 757.289978 170.75 L 756.570007 170.869995 L 756.570007 170.320007 L 757.289978 170.179993 L 757.289978 170.75 Z"
      />
      <path
        id="path1784"
        fill="#cecece"
        stroke="none"
        d="M 757.289978 172.419983 L 756.570007 172.529999 L 756.570007 171.970001 L 757.289978 171.830017 L 757.289978 172.419983 Z"
      />
      <path
        id="path1785"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 174.080017 L 756.570007 174.190002 L 756.570007 173.609985 L 757.299988 173.47998 L 757.299988 174.080017 Z"
      />
      <path
        id="path1786"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 175.75 L 756.570007 175.850006 L 756.570007 175.25 L 757.299988 175.130005 L 757.299988 175.75 Z"
      />
      <path
        id="path1787"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 177.410004 L 756.559998 177.51001 L 756.559998 176.899994 L 757.299988 176.779999 L 757.299988 177.410004 Z"
      />
      <path
        id="path1788"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 179.080017 L 756.559998 179.169983 L 756.559998 178.539978 L 757.299988 178.440002 L 757.299988 179.080017 Z"
      />
      <path
        id="path1789"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 180.75 L 756.559998 180.830017 L 756.559998 180.190002 L 757.299988 180.089996 L 757.299988 180.75 Z"
      />
      <path
        id="path1790"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 182.410004 L 756.559998 182.48999 L 756.559998 181.830017 L 757.299988 181.73999 L 757.299988 182.410004 Z"
      />
      <path
        id="path1791"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 184.080017 L 756.559998 184.149994 L 756.559998 183.47998 L 757.299988 183.390015 L 757.299988 184.080017 Z"
      />
      <path
        id="path1792"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 185.73999 L 756.559998 185.809998 L 756.559998 185.119995 L 757.299988 185.039978 L 757.299988 185.73999 Z"
      />
      <path
        id="path1793"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 187.410004 L 756.559998 187.470001 L 756.559998 186.77002 L 757.299988 186.690002 L 757.299988 187.410004 Z"
      />
      <path
        id="path1794"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 189.080017 L 756.559998 189.130005 L 756.559998 188.410004 L 757.299988 188.339996 L 757.299988 189.080017 Z"
      />
      <path
        id="path1795"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 190.73999 L 756.559998 190.789978 L 756.559998 190.059998 L 757.299988 189.98999 L 757.299988 190.73999 Z"
      />
      <path
        id="path1796"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 192.410004 L 756.559998 192.450012 L 756.559998 191.700012 L 757.299988 191.649994 L 757.299988 192.410004 Z"
      />
      <path
        id="path1797"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 194.070007 L 756.559998 194.109985 L 756.559998 193.339996 L 757.299988 193.299988 L 757.299988 194.070007 Z"
      />
      <path
        id="path1798"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 195.73999 L 756.549988 195.77002 L 756.549988 194.98999 L 757.299988 194.950012 L 757.299988 195.73999 Z"
      />
      <path
        id="path1799"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 197.399994 L 756.549988 197.429993 L 756.549988 196.630005 L 757.299988 196.600006 L 757.299988 197.399994 Z"
      />
      <path
        id="path1800"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 199.070007 L 756.549988 199.089996 L 756.549988 198.279999 L 757.299988 198.25 L 757.299988 199.070007 Z"
      />
      <path
        id="path1801"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 200.73999 L 756.549988 200.75 L 756.549988 199.919983 L 757.299988 199.899994 L 757.299988 200.73999 Z"
      />
      <path
        id="path1802"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 202.399994 L 756.549988 202.410004 L 756.549988 201.570007 L 757.299988 201.559998 L 757.299988 202.399994 Z"
      />
      <path
        id="path1803"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 204.859985 L 756.549988 204.859985 L 756.549988 205.73999 L 757.299988 205.73999 L 757.299988 204.859985 Z"
      />
      <path
        id="path1804"
        fill="#cecece"
        stroke="none"
        d="M 757.289978 166.880005 L 757.289978 167.419983 L 758.150024 168 L 758.150024 167.470001 L 757.289978 166.880005 Z"
      />
      <path
        id="path1805"
        fill="#cecece"
        stroke="none"
        d="M 758.150024 169.640015 L 757.289978 169.089996 L 757.289978 168.529999 L 758.150024 169.089996 L 758.150024 169.640015 Z"
      />
      <path
        id="path1806"
        fill="#cecece"
        stroke="none"
        d="M 758.150024 171.279999 L 757.289978 170.75 L 757.289978 170.179993 L 758.150024 170.720001 L 758.150024 171.279999 Z"
      />
      <path
        id="path1807"
        fill="#cecece"
        stroke="none"
        d="M 758.150024 172.919983 L 757.289978 172.419983 L 757.289978 171.830017 L 758.150024 172.339996 L 758.150024 172.919983 Z"
      />
      <path
        id="path1808"
        fill="#cecece"
        stroke="none"
        d="M 758.150024 174.559998 L 757.299988 174.080017 L 757.299988 173.47998 L 758.150024 173.970001 L 758.150024 174.559998 Z"
      />
      <path
        id="path1809"
        fill="#cecece"
        stroke="none"
        d="M 758.150024 176.200012 L 757.299988 175.75 L 757.299988 175.130005 L 758.150024 175.600006 L 758.150024 176.200012 Z"
      />
      <path
        id="path1810"
        fill="#cecece"
        stroke="none"
        d="M 758.150024 177.839996 L 757.299988 177.410004 L 757.299988 176.779999 L 758.150024 177.220001 L 758.150024 177.839996 Z"
      />
      <path
        id="path1811"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 179.47998 L 757.299988 179.080017 L 757.299988 178.440002 L 758.140015 178.850006 L 758.140015 179.47998 Z"
      />
      <path
        id="path1812"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 181.119995 L 757.299988 180.75 L 757.299988 180.089996 L 758.140015 180.470001 L 758.140015 181.119995 Z"
      />
      <path
        id="path1813"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 182.76001 L 757.299988 182.410004 L 757.299988 181.73999 L 758.140015 182.100006 L 758.140015 182.76001 Z"
      />
      <path
        id="path1814"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 186.049988 L 757.299988 185.73999 L 757.299988 185.039978 L 758.140015 185.350006 L 758.140015 186.049988 Z"
      />
      <path
        id="path1815"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 187.690002 L 757.299988 187.410004 L 757.299988 186.690002 L 758.140015 186.97998 L 758.140015 187.690002 Z"
      />
      <path
        id="path1816"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 189.330017 L 757.299988 189.080017 L 757.299988 188.339996 L 758.140015 188.600006 L 758.140015 189.330017 Z"
      />
      <path
        id="path1817"
        fill="#cecece"
        stroke="none"
        d="M 758.140015 192.609985 L 757.299988 192.410004 L 757.299988 191.649994 L 758.140015 191.850006 L 758.140015 192.609985 Z"
      />
      <path
        id="path1818"
        fill="#cecece"
        stroke="none"
        d="M 758.130005 194.25 L 757.299988 194.070007 L 757.299988 193.299988 L 758.130005 193.47998 L 758.130005 194.25 Z"
      />
      <path
        id="path1819"
        fill="#cecece"
        stroke="none"
        d="M 758.130005 197.529999 L 757.299988 197.399994 L 757.299988 196.600006 L 758.130005 196.72998 L 758.130005 197.529999 Z"
      />
      <path
        id="path1820"
        fill="#cecece"
        stroke="none"
        d="M 758.130005 200.809998 L 757.299988 200.73999 L 757.299988 199.899994 L 758.130005 199.97998 L 758.130005 200.809998 Z"
      />
      <path
        id="path1821"
        fill="#cecece"
        stroke="none"
        d="M 758.25 167.529999 L 758.25 168.059998 L 759.049988 168.600006 L 759.049988 168.089996 L 758.25 167.529999 Z"
      />
      <path
        id="path1822"
        fill="#cecece"
        stroke="none"
        d="M 759.049988 170.220001 L 758.25 169.700012 L 758.25 169.160004 L 759.049988 169.679993 L 759.049988 170.220001 Z"
      />
      <path
        id="path1823"
        fill="#cecece"
        stroke="none"
        d="M 759.049988 171.830017 L 758.25 171.339996 L 758.25 170.779999 L 759.049988 171.279999 L 759.049988 171.830017 Z"
      />
      <path
        id="path1824"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 173.440002 L 758.25 172.97998 L 758.25 172.399994 L 759.059998 172.880005 L 759.059998 173.440002 Z"
      />
      <path
        id="path1825"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 175.059998 L 758.25 174.609985 L 758.25 174.029999 L 759.059998 174.47998 L 759.059998 175.059998 Z"
      />
      <path
        id="path1826"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 176.669983 L 758.25 176.25 L 758.25 175.649994 L 759.059998 176.080017 L 759.059998 176.669983 Z"
      />
      <path
        id="path1827"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 178.289978 L 758.25 177.890015 L 758.25 177.27002 L 759.059998 177.679993 L 759.059998 178.289978 Z"
      />
      <path
        id="path1828"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 179.899994 L 758.26001 179.529999 L 758.26001 178.890015 L 759.059998 179.279999 L 759.059998 179.899994 Z"
      />
      <path
        id="path1829"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 181.52002 L 758.26001 181.169983 L 758.26001 180.52002 L 759.059998 180.880005 L 759.059998 181.52002 Z"
      />
      <path
        id="path1830"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 183.130005 L 758.26001 182.799988 L 758.26001 182.140015 L 759.059998 182.470001 L 759.059998 183.130005 Z"
      />
      <path
        id="path1831"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 184.75 L 758.26001 184.440002 L 758.26001 183.76001 L 759.059998 184.070007 L 759.059998 184.75 Z"
      />
      <path
        id="path1832"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 186.359985 L 758.26001 186.080017 L 758.26001 185.380005 L 759.059998 185.669983 L 759.059998 186.359985 Z"
      />
      <path
        id="path1833"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 187.970001 L 758.26001 187.720001 L 758.26001 187.01001 L 759.059998 187.27002 L 759.059998 187.970001 Z"
      />
      <path
        id="path1834"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 189.589996 L 758.26001 189.359985 L 758.26001 188.630005 L 759.059998 188.869995 L 759.059998 189.589996 Z"
      />
      <path
        id="path1835"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 191.200012 L 758.26001 190.98999 L 758.26001 190.25 L 759.059998 190.470001 L 759.059998 191.200012 Z"
      />
      <path
        id="path1836"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 192.820007 L 758.26001 192.630005 L 758.26001 191.880005 L 759.059998 192.070007 L 759.059998 192.820007 Z"
      />
      <path
        id="path1837"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 194.429993 L 758.26001 194.27002 L 758.26001 193.5 L 759.059998 193.669983 L 759.059998 194.429993 Z"
      />
      <path
        id="path1838"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 196.049988 L 758.26001 195.910004 L 758.26001 195.119995 L 759.059998 195.26001 L 759.059998 196.049988 Z"
      />
      <path
        id="path1839"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 197.660004 L 758.26001 197.539978 L 758.26001 196.73999 L 759.059998 196.859985 L 759.059998 197.660004 Z"
      />
      <path
        id="path1840"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 199.279999 L 758.26001 199.179993 L 758.26001 198.369995 L 759.059998 198.460022 L 759.059998 199.279999 Z"
      />
      <path
        id="path1841"
        fill="#cecece"
        stroke="none"
        d="M 759.059998 200.890015 L 758.26001 200.820007 L 758.26001 199.98999 L 759.059998 200.059998 L 759.059998 200.890015 Z"
      />
      <path
        id="path1842"
        fill="#cecece"
        stroke="none"
        d="M 759.070007 202.5 L 758.26001 202.460022 L 758.26001 201.609985 L 759.070007 201.660004 L 759.070007 202.5 Z"
      />
      <path
        id="path1843"
        fill="#cecece"
        stroke="none"
        d="M 759.070007 204.119995 L 758.26001 204.100006 L 758.26001 203.22998 L 759.070007 203.26001 L 759.070007 204.119995 Z"
      />
      <path
        id="path1844"
        fill="#cecece"
        stroke="none"
        d="M 760.169983 168.850006 L 760.169983 169.350006 L 760.679993 169.690002 L 760.679993 169.200012 L 760.169983 168.850006 Z"
      />
      <path
        id="path1845"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 171.26001 L 760.169983 170.929993 L 760.169983 170.419983 L 760.679993 170.75 L 760.679993 171.26001 Z"
      />
      <path
        id="path1846"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 172.820007 L 760.169983 172.51001 L 760.169983 171.97998 L 760.679993 172.299988 L 760.679993 172.820007 Z"
      />
      <path
        id="path1847"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 174.390015 L 760.169983 174.089996 L 760.169983 173.549988 L 760.679993 173.850006 L 760.679993 174.390015 Z"
      />
      <path
        id="path1848"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 175.960022 L 760.159973 175.679993 L 760.159973 175.109985 L 760.679993 175.399994 L 760.679993 175.960022 Z"
      />
      <path
        id="path1849"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 177.529999 L 760.159973 177.26001 L 760.159973 176.679993 L 760.679993 176.950012 L 760.679993 177.529999 Z"
      />
      <path
        id="path1850"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 180.660004 L 760.159973 180.419983 L 760.159973 179.809998 L 760.679993 180.049988 L 760.679993 180.660004 Z"
      />
      <path
        id="path1851"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 182.22998 L 760.159973 182 L 760.159973 181.380005 L 760.679993 181.600006 L 760.679993 182.22998 Z"
      />
      <path
        id="path1852"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 183.789978 L 760.159973 183.589996 L 760.159973 182.940002 L 760.679993 183.149994 L 760.679993 183.789978 Z"
      />
      <path
        id="path1853"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 185.359985 L 760.159973 185.169983 L 760.159973 184.51001 L 760.679993 184.700012 L 760.679993 185.359985 Z"
      />
      <path
        id="path1854"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 186.929993 L 760.150024 186.75 L 760.150024 186.070007 L 760.679993 186.25 L 760.679993 186.929993 Z"
      />
      <path
        id="path1855"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 188.5 L 760.150024 188.330017 L 760.150024 187.640015 L 760.679993 187.799988 L 760.679993 188.5 Z"
      />
      <path
        id="path1856"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 191.630005 L 760.150024 191.5 L 760.150024 190.77002 L 760.679993 190.899994 L 760.679993 191.630005 Z"
      />
      <path
        id="path1857"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 193.200012 L 760.150024 193.080017 L 760.150024 192.330017 L 760.679993 192.460022 L 760.679993 193.200012 Z"
      />
      <path
        id="path1858"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 196.330017 L 760.150024 196.23999 L 760.150024 195.460022 L 760.679993 195.559998 L 760.679993 196.330017 Z"
      />
      <path
        id="path1859"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 197.899994 L 760.150024 197.820007 L 760.150024 197.029999 L 760.679993 197.109985 L 760.679993 197.899994 Z"
      />
      <path
        id="path1860"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 199.470001 L 760.150024 199.410004 L 760.150024 198.600006 L 760.679993 198.660004 L 760.679993 199.470001 Z"
      />
      <path
        id="path1861"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 202.600006 L 760.140015 202.570007 L 760.140015 201.72998 L 760.679993 201.76001 L 760.679993 202.600006 Z"
      />
      <path
        id="path1862"
        fill="#cecece"
        stroke="none"
        d="M 760.679993 204.169983 L 760.140015 204.149994 L 760.140015 203.289978 L 760.679993 203.309998 L 760.679993 204.169983 Z"
      />
      <path
        id="path1863"
        fill="#cecece"
        stroke="none"
        d="M 760.780029 169.27002 L 760.780029 169.76001 L 761.23999 170.070007 L 761.23999 169.589996 L 760.780029 169.27002 Z"
      />
      <path
        id="path1864"
        fill="#cecece"
        stroke="none"
        d="M 761.23999 171.619995 L 760.780029 171.320007 L 760.780029 170.820007 L 761.23999 171.119995 L 761.23999 171.619995 Z"
      />
      <path
        id="path1865"
        fill="#cecece"
        stroke="none"
        d="M 761.23999 173.169983 L 760.77002 172.880005 L 760.77002 172.359985 L 761.23999 172.660004 L 761.23999 173.169983 Z"
      />
      <path
        id="path1866"
        fill="#cecece"
        stroke="none"
        d="M 761.23999 174.720001 L 760.77002 174.450012 L 760.77002 173.910004 L 761.23999 174.190002 L 761.23999 174.720001 Z"
      />
      <path
        id="path1867"
        fill="#cecece"
        stroke="none"
        d="M 761.25 176.27002 L 760.77002 176.01001 L 760.77002 175.460022 L 761.25 175.720001 L 761.25 176.27002 Z"
      />
      <path
        id="path1868"
        fill="#cecece"
        stroke="none"
        d="M 761.25 177.820007 L 760.77002 177.580017 L 760.77002 177.01001 L 761.25 177.26001 L 761.25 177.820007 Z"
      />
      <path
        id="path1869"
        fill="#cecece"
        stroke="none"
        d="M 761.25 179.369995 L 760.77002 179.140015 L 760.77002 178.549988 L 761.25 178.789978 L 761.25 179.369995 Z"
      />
      <path
        id="path1870"
        fill="#cecece"
        stroke="none"
        d="M 761.25 180.919983 L 760.77002 180.710022 L 760.77002 180.100006 L 761.25 180.320007 L 761.25 180.919983 Z"
      />
      <path
        id="path1871"
        fill="#cecece"
        stroke="none"
        d="M 761.25 182.470001 L 760.77002 182.27002 L 760.77002 181.649994 L 761.25 181.859985 L 761.25 182.470001 Z"
      />
      <path
        id="path1872"
        fill="#cecece"
        stroke="none"
        d="M 761.25 184.029999 L 760.77002 183.830017 L 760.77002 183.190002 L 761.25 183.390015 L 761.25 184.029999 Z"
      />
      <path
        id="path1873"
        fill="#cecece"
        stroke="none"
        d="M 761.25 185.580017 L 760.77002 185.399994 L 760.77002 184.73999 L 761.25 184.919983 L 761.25 185.580017 Z"
      />
      <path
        id="path1874"
        fill="#cecece"
        stroke="none"
        d="M 761.25 187.130005 L 760.77002 186.960022 L 760.77002 186.289978 L 761.25 186.460022 L 761.25 187.130005 Z"
      />
      <path
        id="path1875"
        fill="#cecece"
        stroke="none"
        d="M 761.25 188.679993 L 760.77002 188.529999 L 760.77002 187.839996 L 761.25 187.98999 L 761.25 188.679993 Z"
      />
      <path
        id="path1876"
        fill="#cecece"
        stroke="none"
        d="M 761.25 190.22998 L 760.77002 190.089996 L 760.77002 189.380005 L 761.25 189.52002 L 761.25 190.22998 Z"
      />
      <path
        id="path1877"
        fill="#cecece"
        stroke="none"
        d="M 761.25 193.330017 L 760.77002 193.220001 L 760.77002 192.47998 L 761.25 192.589996 L 761.25 193.330017 Z"
      />
      <path
        id="path1878"
        fill="#cecece"
        stroke="none"
        d="M 761.25 194.880005 L 760.77002 194.779999 L 760.77002 194.029999 L 761.25 194.119995 L 761.25 194.880005 Z"
      />
      <path
        id="path1879"
        fill="#cecece"
        stroke="none"
        d="M 761.25 196.429993 L 760.77002 196.350006 L 760.77002 195.570007 L 761.25 195.660004 L 761.25 196.429993 Z"
      />
      <path
        id="path1880"
        fill="#cecece"
        stroke="none"
        d="M 761.25 199.529999 L 760.77002 199.47998 L 760.77002 198.669983 L 761.25 198.720001 L 761.25 199.529999 Z"
      />
      <path
        id="path1881"
        fill="#cecece"
        stroke="none"
        d="M 761.25 201.080017 L 760.77002 201.039978 L 760.77002 200.220001 L 761.25 200.26001 L 761.25 201.080017 Z"
      />
      <path
        id="path1882"
        fill="#cecece"
        stroke="none"
        d="M 761.25 202.630005 L 760.77002 202.609985 L 760.77002 201.76001 L 761.25 201.789978 L 761.25 202.630005 Z"
      />
      <path
        id="path1883"
        fill="#cecece"
        stroke="none"
        d="M 761.25 204.859985 L 760.77002 204.859985 L 760.77002 205.73999 L 761.25 205.73999 L 761.25 204.859985 Z"
      />
      <path
        id="path1884"
        fill="#cecece"
        stroke="none"
        d="M 762.340027 170.339996 L 762.340027 170.799988 L 762.969971 171.220001 L 762.969971 170.77002 L 762.340027 170.339996 Z"
      />
      <path
        id="path1885"
        fill="#cecece"
        stroke="none"
        d="M 762.969971 172.72998 L 762.340027 172.320007 L 762.340027 171.839996 L 762.969971 172.26001 L 762.969971 172.72998 Z"
      />
      <path
        id="path1886"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 174.22998 L 762.340027 173.839996 L 762.340027 173.339996 L 762.960022 173.73999 L 762.960022 174.22998 Z"
      />
      <path
        id="path1887"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 177.22998 L 762.340027 176.880005 L 762.340027 176.350006 L 762.960022 176.700012 L 762.960022 177.22998 Z"
      />
      <path
        id="path1888"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 178.72998 L 762.340027 178.399994 L 762.340027 177.850006 L 762.960022 178.179993 L 762.960022 178.72998 Z"
      />
      <path
        id="path1889"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 180.22998 L 762.340027 179.919983 L 762.340027 179.350006 L 762.960022 179.669983 L 762.960022 180.22998 Z"
      />
      <path
        id="path1890"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 181.72998 L 762.340027 181.429993 L 762.340027 180.850006 L 762.960022 181.149994 L 762.960022 181.72998 Z"
      />
      <path
        id="path1891"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 183.22998 L 762.340027 182.950012 L 762.340027 182.350006 L 762.960022 182.630005 L 762.960022 183.22998 Z"
      />
      <path
        id="path1892"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 184.72998 L 762.340027 184.470001 L 762.340027 183.850006 L 762.960022 184.109985 L 762.960022 184.72998 Z"
      />
      <path
        id="path1893"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 186.22998 L 762.349976 185.98999 L 762.349976 185.350006 L 762.960022 185.589996 L 762.960022 186.22998 Z"
      />
      <path
        id="path1894"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 190.72998 L 762.349976 190.549988 L 762.349976 189.850006 L 762.950012 190.039978 L 762.950012 190.72998 Z"
      />
      <path
        id="path1895"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 192.22998 L 762.349976 192.070007 L 762.349976 191.350006 L 762.950012 191.52002 L 762.950012 192.22998 Z"
      />
      <path
        id="path1896"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 193.72998 L 762.349976 193.580017 L 762.349976 192.850006 L 762.950012 193 L 762.950012 193.72998 Z"
      />
      <path
        id="path1897"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 195.22998 L 762.349976 195.100006 L 762.349976 194.350006 L 762.950012 194.47998 L 762.950012 195.22998 Z"
      />
      <path
        id="path1898"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 196.72998 L 762.349976 196.619995 L 762.349976 195.850006 L 762.950012 195.970001 L 762.950012 196.72998 Z"
      />
      <path
        id="path1899"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 199.72998 L 762.349976 199.660004 L 762.349976 198.850006 L 762.950012 198.929993 L 762.950012 199.72998 Z"
      />
      <path
        id="path1900"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 202.72998 L 762.349976 202.700012 L 762.349976 201.859985 L 762.950012 201.890015 L 762.950012 202.72998 Z"
      />
      <path
        id="path1901"
        fill="#cecece"
        stroke="none"
        d="M 762.950012 204.22998 L 762.349976 204.210022 L 762.349976 203.359985 L 762.950012 203.380005 L 762.950012 204.22998 Z"
      />
      <path
        id="path1902"
        fill="#cecece"
        stroke="none"
        d="M 762.940002 204.859985 L 762.349976 204.859985 L 762.349976 205.73999 L 762.940002 205.73999 L 762.940002 204.859985 Z"
      />
      <path
        id="path1903"
        fill="#cecece"
        stroke="none"
        d="M 763.059998 170.839996 L 763.059998 171.289978 L 763.570007 171.630005 L 763.570007 171.190002 L 763.059998 170.839996 Z"
      />
      <path
        id="path1904"
        fill="#cecece"
        stroke="none"
        d="M 763.570007 173.109985 L 763.059998 172.789978 L 763.059998 172.320007 L 763.570007 172.649994 L 763.570007 173.109985 Z"
      />
      <path
        id="path1905"
        fill="#cecece"
        stroke="none"
        d="M 763.570007 174.600006 L 763.059998 174.279999 L 763.059998 173.799988 L 763.570007 174.119995 L 763.570007 174.600006 Z"
      />
      <path
        id="path1906"
        fill="#cecece"
        stroke="none"
        d="M 763.559998 176.080017 L 763.070007 175.779999 L 763.070007 175.279999 L 763.559998 175.580017 L 763.559998 176.080017 Z"
      />
      <path
        id="path1907"
        fill="#cecece"
        stroke="none"
        d="M 763.559998 177.559998 L 763.070007 177.279999 L 763.070007 176.76001 L 763.559998 177.049988 L 763.559998 177.559998 Z"
      />
      <path
        id="path1908"
        fill="#cecece"
        stroke="none"
        d="M 763.559998 179.039978 L 763.070007 178.779999 L 763.070007 178.23999 L 763.559998 178.51001 L 763.559998 179.039978 Z"
      />
      <path
        id="path1909"
        fill="#cecece"
        stroke="none"
        d="M 763.559998 180.529999 L 763.070007 180.279999 L 763.070007 179.720001 L 763.559998 179.970001 L 763.559998 180.529999 Z"
      />
      <path
        id="path1910"
        fill="#cecece"
        stroke="none"
        d="M 763.549988 183.48999 L 763.070007 183.27002 L 763.070007 182.669983 L 763.549988 182.899994 L 763.549988 183.48999 Z"
      />
      <path
        id="path1911"
        fill="#cecece"
        stroke="none"
        d="M 763.549988 184.97998 L 763.070007 184.77002 L 763.070007 184.149994 L 763.549988 184.359985 L 763.549988 184.97998 Z"
      />
      <path
        id="path1912"
        fill="#cecece"
        stroke="none"
        d="M 763.549988 186.460022 L 763.070007 186.27002 L 763.070007 185.630005 L 763.549988 185.830017 L 763.549988 186.460022 Z"
      />
      <path
        id="path1913"
        fill="#cecece"
        stroke="none"
        d="M 763.539978 187.940002 L 763.070007 187.76001 L 763.070007 187.109985 L 763.539978 187.289978 L 763.539978 187.940002 Z"
      />
      <path
        id="path1914"
        fill="#cecece"
        stroke="none"
        d="M 763.539978 189.419983 L 763.070007 189.26001 L 763.070007 188.589996 L 763.539978 188.76001 L 763.539978 189.419983 Z"
      />
      <path
        id="path1915"
        fill="#cecece"
        stroke="none"
        d="M 763.539978 190.910004 L 763.070007 190.76001 L 763.070007 190.070007 L 763.539978 190.220001 L 763.539978 190.910004 Z"
      />
      <path
        id="path1916"
        fill="#cecece"
        stroke="none"
        d="M 763.539978 192.390015 L 763.070007 192.26001 L 763.070007 191.549988 L 763.539978 191.679993 L 763.539978 192.390015 Z"
      />
      <path
        id="path1917"
        fill="#cecece"
        stroke="none"
        d="M 763.530029 193.869995 L 763.070007 193.75 L 763.070007 193.029999 L 763.530029 193.149994 L 763.530029 193.869995 Z"
      />
      <path
        id="path1918"
        fill="#cecece"
        stroke="none"
        d="M 763.530029 195.350006 L 763.070007 195.25 L 763.070007 194.5 L 763.530029 194.609985 L 763.530029 195.350006 Z"
      />
      <path
        id="path1919"
        fill="#cecece"
        stroke="none"
        d="M 763.530029 196.839996 L 763.070007 196.75 L 763.070007 195.97998 L 763.530029 196.070007 L 763.530029 196.839996 Z"
      />
      <path
        id="path1920"
        fill="#cecece"
        stroke="none"
        d="M 763.530029 198.320007 L 763.070007 198.25 L 763.070007 197.460022 L 763.530029 197.539978 L 763.530029 198.320007 Z"
      />
      <path
        id="path1921"
        fill="#cecece"
        stroke="none"
        d="M 763.52002 199.799988 L 763.070007 199.73999 L 763.070007 198.940002 L 763.52002 199 L 763.52002 199.799988 Z"
      />
      <path
        id="path1922"
        fill="#cecece"
        stroke="none"
        d="M 763.52002 201.289978 L 763.070007 201.23999 L 763.070007 200.419983 L 763.52002 200.470001 L 763.52002 201.289978 Z"
      />
      <path
        id="path1923"
        fill="#cecece"
        stroke="none"
        d="M 763.52002 204.25 L 763.070007 204.23999 L 763.070007 203.380005 L 763.52002 203.390015 L 763.52002 204.25 Z"
      />
      <path
        id="path1924"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 167.289978 L 755.359985 167.779999 L 756.169983 167.630005 L 756.169983 167.119995 L 755.359985 167.289978 Z"
      />
      <path
        id="path1925"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 169.429993 L 756.169983 169.279999 L 756.169983 168.76001 L 755.359985 168.929993 L 755.359985 169.429993 Z"
      />
      <path
        id="path1926"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 171.080017 L 756.169983 170.940002 L 756.169983 170.399994 L 755.359985 170.559998 L 755.359985 171.080017 Z"
      />
      <path
        id="path1927"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 172.72998 L 756.169983 172.600006 L 756.169983 172.039978 L 755.359985 172.190002 L 755.359985 172.72998 Z"
      />
      <path
        id="path1928"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 174.380005 L 756.169983 174.25 L 756.169983 173.679993 L 755.359985 173.830017 L 755.359985 174.380005 Z"
      />
      <path
        id="path1929"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 176.029999 L 756.169983 175.910004 L 756.169983 175.320007 L 755.359985 175.460022 L 755.359985 176.029999 Z"
      />
      <path
        id="path1930"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 177.679993 L 756.169983 177.570007 L 756.169983 176.960022 L 755.359985 177.089996 L 755.359985 177.679993 Z"
      />
      <path
        id="path1931"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 179.330017 L 756.169983 179.220001 L 756.169983 178.600006 L 755.359985 178.72998 L 755.359985 179.330017 Z"
      />
      <path
        id="path1932"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 180.97998 L 756.169983 180.880005 L 756.169983 180.23999 L 755.359985 180.359985 L 755.359985 180.97998 Z"
      />
      <path
        id="path1933"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 182.630005 L 756.169983 182.539978 L 756.169983 181.880005 L 755.359985 181.98999 L 755.359985 182.630005 Z"
      />
      <path
        id="path1934"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 184.279999 L 756.169983 184.190002 L 756.169983 183.529999 L 755.359985 183.619995 L 755.359985 184.279999 Z"
      />
      <path
        id="path1935"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 185.929993 L 756.169983 185.850006 L 756.169983 185.169983 L 755.359985 185.26001 L 755.359985 185.929993 Z"
      />
      <path
        id="path1936"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 187.580017 L 756.169983 187.51001 L 756.169983 186.809998 L 755.359985 186.890015 L 755.359985 187.580017 Z"
      />
      <path
        id="path1937"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 189.22998 L 756.159973 189.169983 L 756.159973 188.450012 L 755.359985 188.52002 L 755.359985 189.22998 Z"
      />
      <path
        id="path1938"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 190.880005 L 756.159973 190.820007 L 756.159973 190.089996 L 755.359985 190.160004 L 755.359985 190.880005 Z"
      />
      <path
        id="path1939"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 194.179993 L 756.159973 194.140015 L 756.159973 193.369995 L 755.359985 193.419983 L 755.359985 194.179993 Z"
      />
      <path
        id="path1940"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 195.830017 L 756.159973 195.789978 L 756.159973 195.01001 L 755.359985 195.059998 L 755.359985 195.830017 Z"
      />
      <path
        id="path1941"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 197.47998 L 756.159973 197.450012 L 756.159973 196.649994 L 755.359985 196.690002 L 755.359985 197.47998 Z"
      />
      <path
        id="path1942"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 200.779999 L 756.159973 200.76001 L 756.159973 199.929993 L 755.359985 199.960022 L 755.359985 200.779999 Z"
      />
      <path
        id="path1943"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 202.429993 L 756.159973 202.419983 L 756.159973 201.580017 L 755.359985 201.589996 L 755.359985 202.429993 Z"
      />
      <path
        id="path1944"
        fill="#cecece"
        stroke="none"
        d="M 755.359985 204.080017 L 756.159973 204.080017 L 756.159973 203.220001 L 755.359985 203.220001 L 755.359985 204.080017 Z"
      />
      <path
        id="path1945"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 167.529999 L 754.23999 167.97998 L 754.969971 167.850006 L 754.969971 167.369995 L 754.23999 167.529999 Z"
      />
      <path
        id="path1946"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 169.619995 L 754.969971 169.48999 L 754.969971 169 L 754.23999 169.160004 L 754.23999 169.619995 Z"
      />
      <path
        id="path1947"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 171.26001 L 754.969971 171.140015 L 754.969971 170.630005 L 754.23999 170.779999 L 754.23999 171.26001 Z"
      />
      <path
        id="path1948"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 172.910004 L 754.969971 172.789978 L 754.969971 172.26001 L 754.23999 172.399994 L 754.23999 172.910004 Z"
      />
      <path
        id="path1949"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 174.549988 L 754.969971 174.440002 L 754.969971 173.890015 L 754.23999 174.02002 L 754.23999 174.549988 Z"
      />
      <path
        id="path1950"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 176.190002 L 754.969971 176.080017 L 754.969971 175.52002 L 754.23999 175.649994 L 754.23999 176.190002 Z"
      />
      <path
        id="path1951"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 177.830017 L 754.969971 177.72998 L 754.969971 177.149994 L 754.23999 177.27002 L 754.23999 177.830017 Z"
      />
      <path
        id="path1952"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 179.470001 L 754.969971 179.380005 L 754.969971 178.779999 L 754.23999 178.890015 L 754.23999 179.470001 Z"
      />
      <path
        id="path1953"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 181.109985 L 754.969971 181.02002 L 754.969971 180.410004 L 754.23999 180.52002 L 754.23999 181.109985 Z"
      />
      <path
        id="path1954"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 182.75 L 754.969971 182.669983 L 754.969971 182.039978 L 754.23999 182.140015 L 754.23999 182.75 Z"
      />
      <path
        id="path1955"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 184.399994 L 754.969971 184.320007 L 754.969971 183.669983 L 754.23999 183.76001 L 754.23999 184.399994 Z"
      />
      <path
        id="path1956"
        fill="#cecece"
        stroke="none"
        d="M 754.23999 186.039978 L 754.969971 185.970001 L 754.969971 185.299988 L 754.23999 185.380005 L 754.23999 186.039978 Z"
      />
      <path
        id="path1957"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 187.679993 L 754.969971 187.609985 L 754.969971 186.929993 L 754.22998 187.01001 L 754.22998 187.679993 Z"
      />
      <path
        id="path1958"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 190.960022 L 754.969971 190.910004 L 754.969971 190.190002 L 754.22998 190.25 L 754.22998 190.960022 Z"
      />
      <path
        id="path1959"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 192.600006 L 754.969971 192.559998 L 754.969971 191.820007 L 754.22998 191.869995 L 754.22998 192.600006 Z"
      />
      <path
        id="path1960"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 194.23999 L 754.969971 194.200012 L 754.969971 193.450012 L 754.22998 193.5 L 754.22998 194.23999 Z"
      />
      <path
        id="path1961"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 199.169983 L 754.969971 199.140015 L 754.969971 198.339996 L 754.22998 198.369995 L 754.22998 199.169983 Z"
      />
      <path
        id="path1962"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 200.809998 L 754.969971 200.789978 L 754.969971 199.970001 L 754.22998 199.98999 L 754.22998 200.809998 Z"
      />
      <path
        id="path1963"
        fill="#cecece"
        stroke="none"
        d="M 754.22998 204.089996 L 754.969971 204.089996 L 754.969971 203.22998 L 754.22998 203.22998 L 754.22998 204.089996 Z"
      />
      <path
        id="path1964"
        fill="#cecece"
        stroke="none"
        d="M 754.969971 205.77002 L 754.22998 205.75 L 754.22998 204.940002 L 754.969971 204.970001 L 754.969971 205.77002 Z"
      />
      <path
        id="path1965"
        fill="#cecece"
        stroke="none"
        d="M 753.969971 205.77002 L 753.22998 205.75 L 753.22998 204.940002 L 753.969971 204.970001 L 753.969971 205.77002 Z"
      />
      <path
        id="path1966"
        fill="#cecece"
        stroke="none"
        d="M 754.969971 207.22998 L 754.22998 207.210022 L 754.22998 206.390015 L 754.969971 206.410004 L 754.969971 207.22998 Z"
      />
      <path
        id="path1967"
        fill="#cecece"
        stroke="none"
        d="M 754.969971 210.27002 L 754.22998 210.26001 L 754.22998 209.399994 L 754.969971 209.410004 L 754.969971 210.27002 Z"
      />
      <path
        id="path1968"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 167.72998 L 753.320007 168.149994 L 753.900024 168.039978 L 753.900024 167.609985 L 753.320007 167.72998 Z"
      />
      <path
        id="path1969"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 169.779999 L 753.900024 169.679993 L 753.900024 169.220001 L 753.320007 169.339996 L 753.320007 169.779999 Z"
      />
      <path
        id="path1970"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 171.419983 L 753.900024 171.320007 L 753.900024 170.839996 L 753.320007 170.960022 L 753.320007 171.419983 Z"
      />
      <path
        id="path1971"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 173.049988 L 753.900024 172.960022 L 753.900024 172.460022 L 753.320007 172.570007 L 753.320007 173.049988 Z"
      />
      <path
        id="path1972"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 174.690002 L 753.900024 174.600006 L 753.900024 174.080017 L 753.320007 174.190002 L 753.320007 174.690002 Z"
      />
      <path
        id="path1973"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 176.320007 L 753.900024 176.23999 L 753.900024 175.700012 L 753.320007 175.799988 L 753.320007 176.320007 Z"
      />
      <path
        id="path1974"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 179.589996 L 753.900024 179.51001 L 753.900024 178.940002 L 753.320007 179.029999 L 753.320007 179.589996 Z"
      />
      <path
        id="path1975"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 181.220001 L 753.900024 181.149994 L 753.900024 180.559998 L 753.320007 180.640015 L 753.320007 181.220001 Z"
      />
      <path
        id="path1976"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 182.859985 L 753.900024 182.789978 L 753.900024 182.179993 L 753.320007 182.26001 L 753.320007 182.859985 Z"
      />
      <path
        id="path1977"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 186.119995 L 753.900024 186.070007 L 753.900024 185.419983 L 753.320007 185.48999 L 753.320007 186.119995 Z"
      />
      <path
        id="path1978"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 187.76001 L 753.900024 187.710022 L 753.900024 187.039978 L 753.320007 187.100006 L 753.320007 187.76001 Z"
      />
      <path
        id="path1979"
        fill="#cecece"
        stroke="none"
        d="M 753.320007 189.390015 L 753.900024 189.350006 L 753.900024 188.660004 L 753.320007 188.720001 L 753.320007 189.390015 Z"
      />
      <path
        id="path1980"
        fill="#cecece"
        stroke="none"
        d="M 753.309998 192.660004 L 753.890015 192.619995 L 753.890015 191.899994 L 753.309998 191.940002 L 753.309998 192.660004 Z"
      />
      <path
        id="path1981"
        fill="#cecece"
        stroke="none"
        d="M 753.309998 194.289978 L 753.890015 194.26001 L 753.890015 193.52002 L 753.309998 193.559998 L 753.309998 194.289978 Z"
      />
      <path
        id="path1982"
        fill="#cecece"
        stroke="none"
        d="M 753.309998 197.559998 L 753.890015 197.539978 L 753.890015 196.76001 L 753.309998 196.789978 L 753.309998 197.559998 Z"
      />
      <path
        id="path1983"
        fill="#cecece"
        stroke="none"
        d="M 753.309998 199.200012 L 753.890015 199.179993 L 753.890015 198.380005 L 753.309998 198.399994 L 753.309998 199.200012 Z"
      />
      <path
        id="path1984"
        fill="#cecece"
        stroke="none"
        d="M 753.309998 200.830017 L 753.890015 200.820007 L 753.890015 200 L 753.309998 200.01001 L 753.309998 200.830017 Z"
      />
      <path
        id="path1985"
        fill="#cecece"
        stroke="none"
        d="M 752.289978 167.950012 L 752.289978 168.339996 L 752.98999 168.210022 L 752.98999 167.799988 L 752.289978 167.950012 Z"
      />
      <path
        id="path1986"
        fill="#cecece"
        stroke="none"
        d="M 752.289978 169.970001 L 752.98999 169.839996 L 752.98999 169.410004 L 752.289978 169.559998 L 752.289978 169.970001 Z"
      />
      <path
        id="path1987"
        fill="#cecece"
        stroke="none"
        d="M 752.289978 171.589996 L 752.98999 171.470001 L 752.98999 171.02002 L 752.289978 171.160004 L 752.289978 171.589996 Z"
      />
      <path
        id="path1988"
        fill="#cecece"
        stroke="none"
        d="M 752.289978 173.220001 L 752.98999 173.100006 L 752.98999 172.640015 L 752.289978 172.77002 L 752.289978 173.220001 Z"
      />
      <path
        id="path1989"
        fill="#cecece"
        stroke="none"
        d="M 752.280029 174.839996 L 752.98999 174.73999 L 752.98999 174.25 L 752.280029 174.369995 L 752.280029 174.839996 Z"
      />
      <path
        id="path1990"
        fill="#cecece"
        stroke="none"
        d="M 752.280029 178.089996 L 752.98999 178 L 752.98999 177.470001 L 752.280029 177.580017 L 752.280029 178.089996 Z"
      />
      <path
        id="path1991"
        fill="#cecece"
        stroke="none"
        d="M 752.280029 179.720001 L 752.98999 179.630005 L 752.98999 179.080017 L 752.280029 179.179993 L 752.280029 179.720001 Z"
      />
      <path
        id="path1992"
        fill="#cecece"
        stroke="none"
        d="M 752.280029 181.350006 L 752.98999 181.26001 L 752.98999 180.690002 L 752.280029 180.789978 L 752.280029 181.350006 Z"
      />
      <path
        id="path1993"
        fill="#cecece"
        stroke="none"
        d="M 752.280029 184.600006 L 752.98999 184.529999 L 752.98999 183.910004 L 752.280029 184 L 752.280029 184.600006 Z"
      />
      <path
        id="path1994"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 187.850006 L 752.98999 187.789978 L 752.98999 187.130005 L 752.27002 187.210022 L 752.27002 187.850006 Z"
      />
      <path
        id="path1995"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 189.47998 L 752.98999 189.419983 L 752.98999 188.75 L 752.27002 188.809998 L 752.27002 189.47998 Z"
      />
      <path
        id="path1996"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 191.100006 L 752.98999 191.049988 L 752.98999 190.359985 L 752.27002 190.419983 L 752.27002 191.100006 Z"
      />
      <path
        id="path1997"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 192.72998 L 752.98999 192.679993 L 752.98999 191.970001 L 752.27002 192.02002 L 752.27002 192.72998 Z"
      />
      <path
        id="path1998"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 194.350006 L 752.98999 194.309998 L 752.98999 193.580017 L 752.27002 193.630005 L 752.27002 194.350006 Z"
      />
      <path
        id="path1999"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 195.97998 L 752.98999 195.940002 L 752.98999 195.190002 L 752.27002 195.22998 L 752.27002 195.97998 Z"
      />
      <path
        id="path2000"
        fill="#cecece"
        stroke="none"
        d="M 752.27002 199.22998 L 752.98999 199.210022 L 752.98999 198.410004 L 752.27002 198.440002 L 752.27002 199.22998 Z"
      />
      <path
        id="path2001"
        fill="#cecece"
        stroke="none"
        d="M 752.26001 202.47998 L 752.98999 202.470001 L 752.98999 201.630005 L 752.26001 201.649994 L 752.26001 202.47998 Z"
      />
      <path
        id="path2002"
        fill="#cecece"
        stroke="none"
        d="M 752.26001 204.109985 L 752.98999 204.100006 L 752.98999 203.25 L 752.26001 203.25 L 752.26001 204.109985 Z"
      />
      <path
        id="path2003"
        fill="#cecece"
        stroke="none"
        d="M 759.210022 205.72998 L 760.01001 205.72998 L 760.01001 168.710022 L 759.210022 168.149994 L 759.210022 205.72998 Z"
      />
      <path
        id="path2004"
        fill="#cecece"
        stroke="none"
        d="M 761.380005 205.72998 L 762.190002 205.72998 L 762.190002 170.220001 L 761.380005 169.660004 L 761.380005 205.72998 Z"
      />
      <path
        id="path2005"
        fill="#cecece"
        stroke="none"
        d="M 763.72998 205.72998 L 763.960022 205.72998 L 763.960022 171.450012 L 763.72998 171.289978 L 763.72998 205.72998 Z"
      />
      <path
        id="path2006"
        fill="#cecece"
        stroke="none"
        d="M 764.030029 205.72998 L 764.26001 205.72998 L 764.26001 171.660004 L 764.030029 171.5 L 764.030029 205.72998 Z"
      />
      <path
        id="path2007"
        fill="#cecece"
        stroke="none"
        d="M 741.409973 159.309998 L 741.409973 159.97998 L 742.340027 159.799988 L 742.340027 159.109985 L 741.409973 159.309998 Z"
      />
      <path
        id="path2008"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 161.940002 L 741.409973 162.100006 L 741.409973 161.419983 L 742.340027 161.220001 L 742.340027 161.940002 Z"
      />
      <path
        id="path2009"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 164.080017 L 741.409973 164.22998 L 741.409973 163.52002 L 742.340027 163.339996 L 742.340027 164.080017 Z"
      />
      <path
        id="path2010"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 166.210022 L 741.409973 166.359985 L 741.409973 165.630005 L 742.340027 165.460022 L 742.340027 166.210022 Z"
      />
      <path
        id="path2011"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 168.350006 L 741.409973 168.48999 L 741.409973 167.73999 L 742.340027 167.580017 L 742.340027 168.350006 Z"
      />
      <path
        id="path2012"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 170.48999 L 741.409973 170.619995 L 741.409973 169.850006 L 742.340027 169.700012 L 742.340027 170.48999 Z"
      />
      <path
        id="path2013"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 172.619995 L 741.409973 172.75 L 741.409973 171.960022 L 742.340027 171.809998 L 742.340027 172.619995 Z"
      />
      <path
        id="path2014"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 174.76001 L 741.409973 174.880005 L 741.409973 174.070007 L 742.349976 173.929993 L 742.349976 174.76001 Z"
      />
      <path
        id="path2015"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 176.899994 L 741.409973 177.01001 L 741.409973 176.179993 L 742.349976 176.049988 L 742.349976 176.899994 Z"
      />
      <path
        id="path2016"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 179.029999 L 741.400024 179.140015 L 741.400024 178.289978 L 742.349976 178.169983 L 742.349976 179.029999 Z"
      />
      <path
        id="path2017"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 181.169983 L 741.400024 181.27002 L 741.400024 180.399994 L 742.349976 180.289978 L 742.349976 181.169983 Z"
      />
      <path
        id="path2018"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 183.309998 L 741.400024 183.399994 L 741.400024 182.51001 L 742.349976 182.399994 L 742.349976 183.309998 Z"
      />
      <path
        id="path2019"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 185.440002 L 741.400024 185.52002 L 741.400024 184.619995 L 742.349976 184.52002 L 742.349976 185.440002 Z"
      />
      <path
        id="path2020"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 187.580017 L 741.400024 187.649994 L 741.400024 186.72998 L 742.349976 186.640015 L 742.349976 187.580017 Z"
      />
      <path
        id="path2021"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 189.720001 L 741.400024 189.779999 L 741.400024 188.839996 L 742.349976 188.76001 L 742.349976 189.720001 Z"
      />
      <path
        id="path2022"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 191.850006 L 741.400024 191.910004 L 741.400024 190.950012 L 742.349976 190.880005 L 742.349976 191.850006 Z"
      />
      <path
        id="path2023"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 193.98999 L 741.400024 194.039978 L 741.400024 193.059998 L 742.349976 192.98999 L 742.349976 193.98999 Z"
      />
      <path
        id="path2024"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 196.130005 L 741.390015 196.169983 L 741.390015 195.160004 L 742.349976 195.109985 L 742.349976 196.130005 Z"
      />
      <path
        id="path2025"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 198.26001 L 741.390015 198.299988 L 741.390015 197.27002 L 742.349976 197.22998 L 742.349976 198.26001 Z"
      />
      <path
        id="path2026"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 200.399994 L 741.390015 200.429993 L 741.390015 199.380005 L 742.349976 199.350006 L 742.349976 200.399994 Z"
      />
      <path
        id="path2027"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 202.529999 L 741.390015 202.559998 L 741.390015 201.48999 L 742.349976 201.470001 L 742.349976 202.529999 Z"
      />
      <path
        id="path2028"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 204.669983 L 741.390015 204.690002 L 741.390015 203.600006 L 742.349976 203.580017 L 742.349976 204.669983 Z"
      />
      <path
        id="path2029"
        fill="#cecece"
        stroke="none"
        d="M 742.359985 207.820007 L 741.390015 207.820007 L 741.390015 208.940002 L 742.359985 208.940002 L 742.359985 207.820007 Z"
      />
      <path
        id="path2030"
        fill="#cecece"
        stroke="none"
        d="M 742.340027 159.109985 L 742.340027 159.799988 L 743.440002 160.539978 L 743.440002 159.859985 L 742.340027 159.109985 Z"
      />
      <path
        id="path2031"
        fill="#cecece"
        stroke="none"
        d="M 743.440002 162.649994 L 742.340027 161.940002 L 742.340027 161.220001 L 743.440002 161.950012 L 743.440002 162.649994 Z"
      />
      <path
        id="path2032"
        fill="#cecece"
        stroke="none"
        d="M 743.440002 164.75 L 742.340027 164.080017 L 742.340027 163.339996 L 743.440002 164.029999 L 743.440002 164.75 Z"
      />
      <path
        id="path2033"
        fill="#cecece"
        stroke="none"
        d="M 743.440002 166.859985 L 742.340027 166.210022 L 742.340027 165.460022 L 743.440002 166.119995 L 743.440002 166.859985 Z"
      />
      <path
        id="path2034"
        fill="#cecece"
        stroke="none"
        d="M 743.440002 168.960022 L 742.340027 168.350006 L 742.340027 167.580017 L 743.440002 168.200012 L 743.440002 168.960022 Z"
      />
      <path
        id="path2035"
        fill="#cecece"
        stroke="none"
        d="M 743.440002 171.070007 L 742.340027 170.48999 L 742.340027 169.700012 L 743.440002 170.289978 L 743.440002 171.070007 Z"
      />
      <path
        id="path2036"
        fill="#cecece"
        stroke="none"
        d="M 743.440002 173.169983 L 742.340027 172.619995 L 742.340027 171.809998 L 743.440002 172.380005 L 743.440002 173.169983 Z"
      />
      <path
        id="path2037"
        fill="#cecece"
        stroke="none"
        d="M 743.429993 175.27002 L 742.349976 174.76001 L 742.349976 173.929993 L 743.429993 174.460022 L 743.429993 175.27002 Z"
      />
      <path
        id="path2038"
        fill="#cecece"
        stroke="none"
        d="M 743.429993 177.380005 L 742.349976 176.899994 L 742.349976 176.049988 L 743.429993 176.549988 L 743.429993 177.380005 Z"
      />
      <path
        id="path2039"
        fill="#cecece"
        stroke="none"
        d="M 743.429993 179.47998 L 742.349976 179.029999 L 742.349976 178.169983 L 743.429993 178.630005 L 743.429993 179.47998 Z"
      />
      <path
        id="path2040"
        fill="#cecece"
        stroke="none"
        d="M 743.429993 183.690002 L 742.349976 183.309998 L 742.349976 182.399994 L 743.429993 182.799988 L 743.429993 183.690002 Z"
      />
      <path
        id="path2041"
        fill="#cecece"
        stroke="none"
        d="M 743.429993 185.799988 L 742.349976 185.440002 L 742.349976 184.52002 L 743.429993 184.890015 L 743.429993 185.799988 Z"
      />
      <path
        id="path2042"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 187.899994 L 742.349976 187.580017 L 742.349976 186.640015 L 743.419983 186.970001 L 743.419983 187.899994 Z"
      />
      <path
        id="path2043"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 192.109985 L 742.349976 191.850006 L 742.349976 190.880005 L 743.419983 191.140015 L 743.419983 192.109985 Z"
      />
      <path
        id="path2044"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 194.210022 L 742.349976 193.98999 L 742.349976 192.98999 L 743.419983 193.22998 L 743.419983 194.210022 Z"
      />
      <path
        id="path2045"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 198.419983 L 742.349976 198.26001 L 742.349976 197.22998 L 743.419983 197.399994 L 743.419983 198.419983 Z"
      />
      <path
        id="path2046"
        fill="#cecece"
        stroke="none"
        d="M 743.409973 202.630005 L 742.349976 202.529999 L 742.349976 201.470001 L 743.409973 201.570007 L 743.409973 202.630005 Z"
      />
      <path
        id="path2047"
        fill="#cecece"
        stroke="none"
        d="M 743.570007 159.950012 L 743.570007 160.630005 L 744.599976 161.320007 L 744.599976 160.660004 L 743.570007 159.950012 Z"
      />
      <path
        id="path2048"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 163.390015 L 743.570007 162.72998 L 743.570007 162.029999 L 744.599976 162.710022 L 744.599976 163.390015 Z"
      />
      <path
        id="path2049"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 165.460022 L 743.570007 164.830017 L 743.570007 164.109985 L 744.599976 164.76001 L 744.599976 165.460022 Z"
      />
      <path
        id="path2050"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 167.529999 L 743.570007 166.929993 L 743.570007 166.190002 L 744.599976 166.809998 L 744.599976 167.529999 Z"
      />
      <path
        id="path2051"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 169.600006 L 743.570007 169.029999 L 743.570007 168.279999 L 744.599976 168.859985 L 744.599976 169.600006 Z"
      />
      <path
        id="path2052"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 171.669983 L 743.570007 171.130005 L 743.570007 170.359985 L 744.599976 170.910004 L 744.599976 171.669983 Z"
      />
      <path
        id="path2053"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 173.73999 L 743.570007 173.22998 L 743.570007 172.440002 L 744.599976 172.960022 L 744.599976 173.73999 Z"
      />
      <path
        id="path2054"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 175.809998 L 743.580017 175.330017 L 743.580017 174.52002 L 744.599976 175.01001 L 744.599976 175.809998 Z"
      />
      <path
        id="path2055"
        fill="#cecece"
        stroke="none"
        d="M 744.599976 177.880005 L 743.580017 177.429993 L 743.580017 176.600006 L 744.599976 177.059998 L 744.599976 177.880005 Z"
      />
      <path
        id="path2056"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 179.960022 L 743.580017 179.539978 L 743.580017 178.679993 L 744.609985 179.109985 L 744.609985 179.960022 Z"
      />
      <path
        id="path2057"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 182.029999 L 743.580017 181.640015 L 743.580017 180.76001 L 744.609985 181.160004 L 744.609985 182.029999 Z"
      />
      <path
        id="path2058"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 184.100006 L 743.580017 183.73999 L 743.580017 182.839996 L 744.609985 183.210022 L 744.609985 184.100006 Z"
      />
      <path
        id="path2059"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 186.169983 L 743.580017 185.839996 L 743.580017 184.929993 L 744.609985 185.26001 L 744.609985 186.169983 Z"
      />
      <path
        id="path2060"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 188.23999 L 743.580017 187.940002 L 743.580017 187.01001 L 744.609985 187.309998 L 744.609985 188.23999 Z"
      />
      <path
        id="path2061"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 190.309998 L 743.580017 190.039978 L 743.580017 189.089996 L 744.609985 189.369995 L 744.609985 190.309998 Z"
      />
      <path
        id="path2062"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 192.380005 L 743.580017 192.140015 L 743.580017 191.169983 L 744.609985 191.419983 L 744.609985 192.380005 Z"
      />
      <path
        id="path2063"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 194.450012 L 743.580017 194.23999 L 743.580017 193.25 L 744.609985 193.470001 L 744.609985 194.450012 Z"
      />
      <path
        id="path2064"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 196.52002 L 743.580017 196.339996 L 743.580017 195.330017 L 744.609985 195.52002 L 744.609985 196.52002 Z"
      />
      <path
        id="path2065"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 198.589996 L 743.580017 198.440002 L 743.580017 197.410004 L 744.609985 197.570007 L 744.609985 198.589996 Z"
      />
      <path
        id="path2066"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 200.660004 L 743.580017 200.539978 L 743.580017 199.5 L 744.609985 199.619995 L 744.609985 200.660004 Z"
      />
      <path
        id="path2067"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 202.72998 L 743.590027 202.640015 L 743.590027 201.580017 L 744.609985 201.669983 L 744.609985 202.72998 Z"
      />
      <path
        id="path2068"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 204.799988 L 743.590027 204.73999 L 743.590027 203.660004 L 744.609985 203.720001 L 744.609985 204.799988 Z"
      />
      <path
        id="path2069"
        fill="#cecece"
        stroke="none"
        d="M 744.609985 206.869995 L 743.590027 206.839996 L 743.590027 205.73999 L 744.609985 205.77002 L 744.609985 206.869995 Z"
      />
      <path
        id="path2070"
        fill="#cecece"
        stroke="none"
        d="M 746.030029 161.640015 L 746.030029 162.279999 L 746.679993 162.720001 L 746.679993 162.089996 L 746.030029 161.640015 Z"
      />
      <path
        id="path2071"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 164.72998 L 746.030029 164.309998 L 746.030029 163.649994 L 746.679993 164.080017 L 746.679993 164.72998 Z"
      />
      <path
        id="path2072"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 166.73999 L 746.030029 166.339996 L 746.030029 165.660004 L 746.679993 166.070007 L 746.679993 166.73999 Z"
      />
      <path
        id="path2073"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 168.75 L 746.02002 168.369995 L 746.02002 167.660004 L 746.679993 168.049988 L 746.679993 168.75 Z"
      />
      <path
        id="path2074"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 170.76001 L 746.02002 170.390015 L 746.02002 169.669983 L 746.679993 170.039978 L 746.679993 170.76001 Z"
      />
      <path
        id="path2075"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 172.77002 L 746.02002 172.419983 L 746.02002 171.679993 L 746.679993 172.029999 L 746.679993 172.77002 Z"
      />
      <path
        id="path2076"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 176.789978 L 746.02002 176.47998 L 746.02002 175.700012 L 746.679993 176.01001 L 746.679993 176.789978 Z"
      />
      <path
        id="path2077"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 178.799988 L 746.02002 178.51001 L 746.02002 177.700012 L 746.679993 178 L 746.679993 178.799988 Z"
      />
      <path
        id="path2078"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 180.809998 L 746.01001 180.539978 L 746.01001 179.710022 L 746.679993 179.97998 L 746.679993 180.809998 Z"
      />
      <path
        id="path2079"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 182.820007 L 746.01001 182.570007 L 746.01001 181.720001 L 746.679993 181.970001 L 746.679993 182.820007 Z"
      />
      <path
        id="path2080"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 184.830017 L 746.01001 184.600006 L 746.01001 183.72998 L 746.679993 183.960022 L 746.679993 184.830017 Z"
      />
      <path
        id="path2081"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 186.839996 L 746.01001 186.630005 L 746.01001 185.72998 L 746.679993 185.950012 L 746.679993 186.839996 Z"
      />
      <path
        id="path2082"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 190.859985 L 746.01001 190.679993 L 746.01001 189.75 L 746.679993 189.929993 L 746.679993 190.859985 Z"
      />
      <path
        id="path2083"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 192.859985 L 746.01001 192.710022 L 746.01001 191.76001 L 746.679993 191.910004 L 746.679993 192.859985 Z"
      />
      <path
        id="path2084"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 196.880005 L 746 196.77002 L 746 195.77002 L 746.679993 195.890015 L 746.679993 196.880005 Z"
      />
      <path
        id="path2085"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 198.899994 L 746 198.799988 L 746 197.779999 L 746.679993 197.880005 L 746.679993 198.899994 Z"
      />
      <path
        id="path2086"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 200.910004 L 746 200.830017 L 746 199.789978 L 746.679993 199.869995 L 746.679993 200.910004 Z"
      />
      <path
        id="path2087"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 204.919983 L 746 204.890015 L 746 203.809998 L 746.679993 203.839996 L 746.679993 204.919983 Z"
      />
      <path
        id="path2088"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 206.929993 L 745.98999 206.919983 L 745.98999 205.809998 L 746.679993 205.830017 L 746.679993 206.929993 Z"
      />
      <path
        id="path2089"
        fill="#cecece"
        stroke="none"
        d="M 746.809998 162.179993 L 746.809998 162.799988 L 747.409973 163.200012 L 747.409973 162.589996 L 746.809998 162.179993 Z"
      />
      <path
        id="path2090"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 165.190002 L 746.809998 164.809998 L 746.809998 164.160004 L 747.409973 164.559998 L 747.409973 165.190002 Z"
      />
      <path
        id="path2091"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 167.179993 L 746.809998 166.809998 L 746.809998 166.140015 L 747.409973 166.52002 L 747.409973 167.179993 Z"
      />
      <path
        id="path2092"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 169.169983 L 746.809998 168.820007 L 746.809998 168.130005 L 747.409973 168.48999 L 747.409973 169.169983 Z"
      />
      <path
        id="path2093"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 171.160004 L 746.809998 170.830017 L 746.809998 170.109985 L 747.409973 170.460022 L 747.409973 171.160004 Z"
      />
      <path
        id="path2094"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 173.149994 L 746.809998 172.830017 L 746.809998 172.100006 L 747.409973 172.419983 L 747.409973 173.149994 Z"
      />
      <path
        id="path2095"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 175.140015 L 746.799988 174.839996 L 746.799988 174.080017 L 747.409973 174.390015 L 747.409973 175.140015 Z"
      />
      <path
        id="path2096"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 177.119995 L 746.799988 176.839996 L 746.799988 176.070007 L 747.409973 176.359985 L 747.409973 177.119995 Z"
      />
      <path
        id="path2097"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 179.109985 L 746.799988 178.850006 L 746.799988 178.049988 L 747.409973 178.320007 L 747.409973 179.109985 Z"
      />
      <path
        id="path2098"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 181.100006 L 746.799988 180.859985 L 746.799988 180.039978 L 747.409973 180.289978 L 747.409973 181.100006 Z"
      />
      <path
        id="path2099"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 183.089996 L 746.799988 182.859985 L 746.799988 182.02002 L 747.409973 182.26001 L 747.409973 183.089996 Z"
      />
      <path
        id="path2100"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 185.080017 L 746.799988 184.869995 L 746.799988 184.01001 L 747.409973 184.220001 L 747.409973 185.080017 Z"
      />
      <path
        id="path2101"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 187.070007 L 746.799988 186.880005 L 746.799988 185.98999 L 747.409973 186.190002 L 747.409973 187.070007 Z"
      />
      <path
        id="path2102"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 189.059998 L 746.799988 188.880005 L 746.799988 187.97998 L 747.409973 188.149994 L 747.409973 189.059998 Z"
      />
      <path
        id="path2103"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 193.029999 L 746.799988 192.890015 L 746.799988 191.940002 L 747.409973 192.089996 L 747.409973 193.029999 Z"
      />
      <path
        id="path2104"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 195.02002 L 746.799988 194.899994 L 746.799988 193.929993 L 747.409973 194.049988 L 747.409973 195.02002 Z"
      />
      <path
        id="path2105"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 197.01001 L 746.799988 196.910004 L 746.799988 195.910004 L 747.409973 196.02002 L 747.409973 197.01001 Z"
      />
      <path
        id="path2106"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 200.98999 L 746.799988 200.919983 L 746.799988 199.880005 L 747.409973 199.950012 L 747.409973 200.98999 Z"
      />
      <path
        id="path2107"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 202.97998 L 746.799988 202.929993 L 746.799988 201.869995 L 747.409973 201.919983 L 747.409973 202.97998 Z"
      />
      <path
        id="path2108"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 204.970001 L 746.799988 204.929993 L 746.799988 203.850006 L 747.409973 203.890015 L 747.409973 204.970001 Z"
      />
      <path
        id="path2109"
        fill="#cecece"
        stroke="none"
        d="M 747.419983 207.820007 L 746.799988 207.820007 L 746.799988 208.940002 L 747.419983 208.940002 L 747.419983 207.820007 Z"
      />
      <path
        id="path2110"
        fill="#cecece"
        stroke="none"
        d="M 748.809998 163.549988 L 748.809998 164.149994 L 749.619995 164.679993 L 749.619995 164.109985 L 748.809998 163.549988 Z"
      />
      <path
        id="path2111"
        fill="#cecece"
        stroke="none"
        d="M 749.619995 166.609985 L 748.820007 166.089996 L 748.820007 165.47998 L 749.619995 166.01001 L 749.619995 166.609985 Z"
      />
      <path
        id="path2112"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 168.529999 L 748.820007 168.039978 L 748.820007 167.399994 L 749.609985 167.910004 L 749.609985 168.529999 Z"
      />
      <path
        id="path2113"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 172.380005 L 748.820007 171.940002 L 748.820007 171.25 L 749.609985 171.710022 L 749.609985 172.380005 Z"
      />
      <path
        id="path2114"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 174.309998 L 748.820007 173.890015 L 748.820007 173.179993 L 749.609985 173.609985 L 749.609985 174.309998 Z"
      />
      <path
        id="path2115"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 176.22998 L 748.820007 175.830017 L 748.820007 175.100006 L 749.609985 175.51001 L 749.609985 176.22998 Z"
      />
      <path
        id="path2116"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 178.160004 L 748.820007 177.779999 L 748.820007 177.029999 L 749.609985 177.410004 L 749.609985 178.160004 Z"
      />
      <path
        id="path2117"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 180.080017 L 748.820007 179.72998 L 748.820007 178.950012 L 749.609985 179.309998 L 749.609985 180.080017 Z"
      />
      <path
        id="path2118"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 182 L 748.820007 181.679993 L 748.820007 180.880005 L 749.609985 181.210022 L 749.609985 182 Z"
      />
      <path
        id="path2119"
        fill="#cecece"
        stroke="none"
        d="M 749.609985 183.929993 L 748.820007 183.619995 L 748.820007 182.799988 L 749.609985 183.109985 L 749.609985 183.929993 Z"
      />
      <path
        id="path2120"
        fill="#cecece"
        stroke="none"
        d="M 749.599976 189.700012 L 748.820007 189.470001 L 748.820007 188.580017 L 749.599976 188.809998 L 749.599976 189.700012 Z"
      />
      <path
        id="path2121"
        fill="#cecece"
        stroke="none"
        d="M 749.599976 191.630005 L 748.820007 191.410004 L 748.820007 190.5 L 749.599976 190.720001 L 749.599976 191.630005 Z"
      />
      <path
        id="path2122"
        fill="#cecece"
        stroke="none"
        d="M 749.599976 193.549988 L 748.820007 193.359985 L 748.820007 192.419983 L 749.599976 192.619995 L 749.599976 193.549988 Z"
      />
      <path
        id="path2123"
        fill="#cecece"
        stroke="none"
        d="M 749.599976 195.470001 L 748.830017 195.309998 L 748.830017 194.350006 L 749.599976 194.52002 L 749.599976 195.470001 Z"
      />
      <path
        id="path2124"
        fill="#cecece"
        stroke="none"
        d="M 749.599976 197.399994 L 748.830017 197.26001 L 748.830017 196.27002 L 749.599976 196.419983 L 749.599976 197.399994 Z"
      />
      <path
        id="path2125"
        fill="#cecece"
        stroke="none"
        d="M 749.599976 201.25 L 748.830017 201.149994 L 748.830017 200.119995 L 749.599976 200.220001 L 749.599976 201.25 Z"
      />
      <path
        id="path2126"
        fill="#cecece"
        stroke="none"
        d="M 749.590027 205.100006 L 748.830017 205.049988 L 748.830017 203.970001 L 749.590027 204.02002 L 749.590027 205.100006 Z"
      />
      <path
        id="path2127"
        fill="#cecece"
        stroke="none"
        d="M 749.590027 207.02002 L 748.830017 207 L 748.830017 205.899994 L 749.590027 205.919983 L 749.590027 207.02002 Z"
      />
      <path
        id="path2128"
        fill="#cecece"
        stroke="none"
        d="M 749.590027 207.820007 L 748.830017 207.820007 L 748.830017 208.940002 L 749.590027 208.940002 L 749.590027 207.820007 Z"
      />
      <path
        id="path2129"
        fill="#cecece"
        stroke="none"
        d="M 749.73999 164.190002 L 749.73999 164.77002 L 750.390015 165.210022 L 750.390015 164.640015 L 749.73999 164.190002 Z"
      />
      <path
        id="path2130"
        fill="#cecece"
        stroke="none"
        d="M 750.390015 167.109985 L 749.73999 166.690002 L 749.73999 166.089996 L 750.390015 166.52002 L 750.390015 167.109985 Z"
      />
      <path
        id="path2131"
        fill="#cecece"
        stroke="none"
        d="M 750.390015 169.01001 L 749.73999 168.609985 L 749.73999 167.98999 L 750.390015 168.399994 L 750.390015 169.01001 Z"
      />
      <path
        id="path2132"
        fill="#cecece"
        stroke="none"
        d="M 750.380005 170.910004 L 749.73999 170.529999 L 749.73999 169.880005 L 750.380005 170.27002 L 750.380005 170.910004 Z"
      />
      <path
        id="path2133"
        fill="#cecece"
        stroke="none"
        d="M 750.380005 172.809998 L 749.73999 172.450012 L 749.73999 171.779999 L 750.380005 172.149994 L 750.380005 172.809998 Z"
      />
      <path
        id="path2134"
        fill="#cecece"
        stroke="none"
        d="M 750.380005 174.710022 L 749.73999 174.369995 L 749.73999 173.679993 L 750.380005 174.029999 L 750.380005 174.710022 Z"
      />
      <path
        id="path2135"
        fill="#cecece"
        stroke="none"
        d="M 750.380005 176.619995 L 749.75 176.289978 L 749.75 175.570007 L 750.380005 175.910004 L 750.380005 176.619995 Z"
      />
      <path
        id="path2136"
        fill="#cecece"
        stroke="none"
        d="M 750.369995 180.419983 L 749.75 180.130005 L 749.75 179.369995 L 750.369995 179.660004 L 750.369995 180.419983 Z"
      />
      <path
        id="path2137"
        fill="#cecece"
        stroke="none"
        d="M 750.369995 182.320007 L 749.75 182.049988 L 749.75 181.26001 L 750.369995 181.539978 L 750.369995 182.320007 Z"
      />
      <path
        id="path2138"
        fill="#cecece"
        stroke="none"
        d="M 750.359985 184.220001 L 749.75 183.97998 L 749.75 183.160004 L 750.359985 183.410004 L 750.359985 184.220001 Z"
      />
      <path
        id="path2139"
        fill="#cecece"
        stroke="none"
        d="M 750.359985 186.119995 L 749.75 185.899994 L 749.75 185.059998 L 750.359985 185.289978 L 750.359985 186.119995 Z"
      />
      <path
        id="path2140"
        fill="#cecece"
        stroke="none"
        d="M 750.359985 188.029999 L 749.75 187.820007 L 749.75 186.950012 L 750.359985 187.169983 L 750.359985 188.029999 Z"
      />
      <path
        id="path2141"
        fill="#cecece"
        stroke="none"
        d="M 750.349976 189.929993 L 749.75 189.73999 L 749.75 188.850006 L 750.349976 189.049988 L 750.349976 189.929993 Z"
      />
      <path
        id="path2142"
        fill="#cecece"
        stroke="none"
        d="M 750.349976 191.830017 L 749.75 191.660004 L 749.75 190.75 L 750.349976 190.919983 L 750.349976 191.830017 Z"
      />
      <path
        id="path2143"
        fill="#cecece"
        stroke="none"
        d="M 750.349976 193.72998 L 749.75 193.580017 L 749.75 192.649994 L 750.349976 192.799988 L 750.349976 193.72998 Z"
      />
      <path
        id="path2144"
        fill="#cecece"
        stroke="none"
        d="M 750.340027 195.630005 L 749.75 195.5 L 749.75 194.539978 L 750.340027 194.679993 L 750.340027 195.630005 Z"
      />
      <path
        id="path2145"
        fill="#cecece"
        stroke="none"
        d="M 750.340027 197.529999 L 749.75 197.419983 L 749.75 196.440002 L 750.340027 196.559998 L 750.340027 197.529999 Z"
      />
      <path
        id="path2146"
        fill="#cecece"
        stroke="none"
        d="M 750.340027 199.440002 L 749.75 199.339996 L 749.75 198.339996 L 750.340027 198.429993 L 750.340027 199.440002 Z"
      />
      <path
        id="path2147"
        fill="#cecece"
        stroke="none"
        d="M 750.330017 201.339996 L 749.75 201.26001 L 749.75 200.22998 L 750.330017 200.309998 L 750.330017 201.339996 Z"
      />
      <path
        id="path2148"
        fill="#cecece"
        stroke="none"
        d="M 750.330017 203.23999 L 749.75 203.179993 L 749.75 202.130005 L 750.330017 202.190002 L 750.330017 203.23999 Z"
      />
      <path
        id="path2149"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 207.039978 L 749.75 207.02002 L 749.75 205.919983 L 750.320007 205.940002 L 750.320007 207.039978 Z"
      />
      <path
        id="path2150"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 159.640015 L 739.859985 160.26001 L 740.900024 160.070007 L 740.900024 159.419983 L 739.859985 159.640015 Z"
      />
      <path
        id="path2151"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 162.380005 L 740.900024 162.190002 L 740.900024 161.52002 L 739.859985 161.73999 L 739.859985 162.380005 Z"
      />
      <path
        id="path2152"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 164.48999 L 740.900024 164.320007 L 740.900024 163.619995 L 739.859985 163.830017 L 739.859985 164.48999 Z"
      />
      <path
        id="path2153"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 166.609985 L 740.900024 166.440002 L 740.900024 165.72998 L 739.859985 165.929993 L 739.859985 166.609985 Z"
      />
      <path
        id="path2154"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 168.72998 L 740.900024 168.570007 L 740.900024 167.830017 L 739.859985 168.02002 L 739.859985 168.72998 Z"
      />
      <path
        id="path2155"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 170.839996 L 740.900024 170.690002 L 740.900024 169.940002 L 739.859985 170.119995 L 739.859985 170.839996 Z"
      />
      <path
        id="path2156"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 172.960022 L 740.900024 172.820007 L 740.900024 172.039978 L 739.859985 172.210022 L 739.859985 172.960022 Z"
      />
      <path
        id="path2157"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 175.080017 L 740.900024 174.940002 L 740.900024 174.149994 L 739.859985 174.299988 L 739.859985 175.080017 Z"
      />
      <path
        id="path2158"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 177.190002 L 740.900024 177.070007 L 740.900024 176.25 L 739.859985 176.399994 L 739.859985 177.190002 Z"
      />
      <path
        id="path2159"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 179.309998 L 740.900024 179.190002 L 740.900024 178.359985 L 739.859985 178.48999 L 739.859985 179.309998 Z"
      />
      <path
        id="path2160"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 181.429993 L 740.900024 181.320007 L 740.900024 180.460022 L 739.859985 180.589996 L 739.859985 181.429993 Z"
      />
      <path
        id="path2161"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 183.539978 L 740.900024 183.440002 L 740.900024 182.570007 L 739.859985 182.679993 L 739.859985 183.539978 Z"
      />
      <path
        id="path2162"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 185.660004 L 740.890015 185.570007 L 740.890015 184.669983 L 739.859985 184.779999 L 739.859985 185.660004 Z"
      />
      <path
        id="path2163"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 187.779999 L 740.890015 187.690002 L 740.890015 186.779999 L 739.859985 186.869995 L 739.859985 187.779999 Z"
      />
      <path
        id="path2164"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 189.890015 L 740.890015 189.820007 L 740.890015 188.880005 L 739.859985 188.970001 L 739.859985 189.890015 Z"
      />
      <path
        id="path2165"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 194.130005 L 740.890015 194.070007 L 740.890015 193.089996 L 739.859985 193.160004 L 739.859985 194.130005 Z"
      />
      <path
        id="path2166"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 196.23999 L 740.890015 196.190002 L 740.890015 195.190002 L 739.859985 195.25 L 739.859985 196.23999 Z"
      />
      <path
        id="path2167"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 198.359985 L 740.890015 198.320007 L 740.890015 197.299988 L 739.859985 197.350006 L 739.859985 198.359985 Z"
      />
      <path
        id="path2168"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 202.589996 L 740.890015 202.570007 L 740.890015 201.51001 L 739.859985 201.539978 L 739.859985 202.589996 Z"
      />
      <path
        id="path2169"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 204.710022 L 740.890015 204.690002 L 740.890015 203.609985 L 739.859985 203.630005 L 739.859985 204.710022 Z"
      />
      <path
        id="path2170"
        fill="#cecece"
        stroke="none"
        d="M 739.859985 206.830017 L 740.890015 206.820007 L 740.890015 205.720001 L 739.859985 205.72998 L 739.859985 206.830017 Z"
      />
      <path
        id="path2171"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 159.950012 L 738.419983 160.52002 L 739.369995 160.350006 L 739.369995 159.75 L 738.419983 159.950012 Z"
      />
      <path
        id="path2172"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 162.630005 L 739.369995 162.460022 L 739.369995 161.839996 L 738.419983 162.029999 L 738.419983 162.630005 Z"
      />
      <path
        id="path2173"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 164.73999 L 739.369995 164.580017 L 739.369995 163.929993 L 738.419983 164.109985 L 738.419983 164.73999 Z"
      />
      <path
        id="path2174"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 166.839996 L 739.369995 166.690002 L 739.369995 166.02002 L 738.419983 166.190002 L 738.419983 166.839996 Z"
      />
      <path
        id="path2175"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 168.950012 L 739.369995 168.799988 L 739.369995 168.109985 L 738.419983 168.279999 L 738.419983 168.950012 Z"
      />
      <path
        id="path2176"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 171.049988 L 739.369995 170.910004 L 739.369995 170.200012 L 738.419983 170.359985 L 738.419983 171.049988 Z"
      />
      <path
        id="path2177"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 173.160004 L 739.369995 173.029999 L 739.369995 172.289978 L 738.419983 172.440002 L 738.419983 173.160004 Z"
      />
      <path
        id="path2178"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 175.26001 L 739.369995 175.140015 L 739.369995 174.380005 L 738.419983 174.52002 L 738.419983 175.26001 Z"
      />
      <path
        id="path2179"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 177.369995 L 739.369995 177.25 L 739.369995 176.470001 L 738.419983 176.600006 L 738.419983 177.369995 Z"
      />
      <path
        id="path2180"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 179.470001 L 739.369995 179.369995 L 739.369995 178.559998 L 738.419983 178.679993 L 738.419983 179.470001 Z"
      />
      <path
        id="path2181"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 181.580017 L 739.369995 181.47998 L 739.369995 180.649994 L 738.419983 180.76001 L 738.419983 181.580017 Z"
      />
      <path
        id="path2182"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 183.679993 L 739.369995 183.589996 L 739.369995 182.73999 L 738.419983 182.839996 L 738.419983 183.679993 Z"
      />
      <path
        id="path2183"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 185.789978 L 739.369995 185.700012 L 739.369995 184.830017 L 738.419983 184.929993 L 738.419983 185.789978 Z"
      />
      <path
        id="path2184"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 190 L 739.369995 189.929993 L 739.369995 189.01001 L 738.419983 189.089996 L 738.419983 190 Z"
      />
      <path
        id="path2185"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 192.100006 L 739.369995 192.039978 L 739.369995 191.100006 L 738.419983 191.169983 L 738.419983 192.100006 Z"
      />
      <path
        id="path2186"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 194.210022 L 739.369995 194.160004 L 739.369995 193.190002 L 738.419983 193.25 L 738.419983 194.210022 Z"
      />
      <path
        id="path2187"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 200.52002 L 739.369995 200.48999 L 739.369995 199.460022 L 738.419983 199.5 L 738.419983 200.52002 Z"
      />
      <path
        id="path2188"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 202.630005 L 739.369995 202.609985 L 739.369995 201.549988 L 738.419983 201.580017 L 738.419983 202.630005 Z"
      />
      <path
        id="path2189"
        fill="#cecece"
        stroke="none"
        d="M 738.419983 206.839996 L 739.369995 206.830017 L 739.369995 205.72998 L 738.419983 205.73999 L 738.419983 206.839996 Z"
      />
      <path
        id="path2190"
        fill="#cecece"
        stroke="none"
        d="M 737.25 160.200012 L 737.25 160.73999 L 738 160.600006 L 738 160.039978 L 737.25 160.200012 Z"
      />
      <path
        id="path2191"
        fill="#cecece"
        stroke="none"
        d="M 737.25 162.839996 L 737.98999 162.710022 L 737.98999 162.119995 L 737.25 162.27002 L 737.25 162.839996 Z"
      />
      <path
        id="path2192"
        fill="#cecece"
        stroke="none"
        d="M 737.25 164.929993 L 737.98999 164.809998 L 737.98999 164.200012 L 737.25 164.339996 L 737.25 164.929993 Z"
      />
      <path
        id="path2193"
        fill="#cecece"
        stroke="none"
        d="M 737.25 167.029999 L 737.98999 166.910004 L 737.98999 166.27002 L 737.25 166.410004 L 737.25 167.029999 Z"
      />
      <path
        id="path2194"
        fill="#cecece"
        stroke="none"
        d="M 737.25 169.119995 L 737.98999 169.01001 L 737.98999 168.350006 L 737.25 168.47998 L 737.25 169.119995 Z"
      />
      <path
        id="path2195"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 171.220001 L 737.98999 171.109985 L 737.98999 170.429993 L 737.23999 170.549988 L 737.23999 171.220001 Z"
      />
      <path
        id="path2196"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 175.410004 L 737.98999 175.320007 L 737.98999 174.580017 L 737.23999 174.690002 L 737.23999 175.410004 Z"
      />
      <path
        id="path2197"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 177.51001 L 737.98999 177.419983 L 737.98999 176.660004 L 737.23999 176.77002 L 737.23999 177.51001 Z"
      />
      <path
        id="path2198"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 179.600006 L 737.98999 179.52002 L 737.98999 178.73999 L 737.23999 178.839996 L 737.23999 179.600006 Z"
      />
      <path
        id="path2199"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 183.789978 L 737.98999 183.720001 L 737.98999 182.890015 L 737.23999 182.97998 L 737.23999 183.789978 Z"
      />
      <path
        id="path2200"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 185.890015 L 737.97998 185.830017 L 737.97998 184.970001 L 737.23999 185.049988 L 737.23999 185.890015 Z"
      />
      <path
        id="path2201"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 187.98999 L 737.97998 187.929993 L 737.97998 187.049988 L 737.23999 187.119995 L 737.23999 187.98999 Z"
      />
      <path
        id="path2202"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 192.179993 L 737.97998 192.130005 L 737.97998 191.200012 L 737.23999 191.26001 L 737.23999 192.179993 Z"
      />
      <path
        id="path2203"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 194.27002 L 737.97998 194.22998 L 737.97998 193.279999 L 737.23999 193.330017 L 737.23999 194.27002 Z"
      />
      <path
        id="path2204"
        fill="#cecece"
        stroke="none"
        d="M 737.23999 198.460022 L 737.97998 198.440002 L 737.97998 197.429993 L 737.23999 197.470001 L 737.23999 198.460022 Z"
      />
      <path
        id="path2205"
        fill="#cecece"
        stroke="none"
        d="M 737.22998 200.559998 L 737.97998 200.539978 L 737.97998 199.51001 L 737.22998 199.539978 L 737.22998 200.559998 Z"
      />
      <path
        id="path2206"
        fill="#cecece"
        stroke="none"
        d="M 737.22998 202.660004 L 737.97998 202.640015 L 737.97998 201.589996 L 737.22998 201.609985 L 737.22998 202.660004 Z"
      />
      <path
        id="path2207"
        fill="#cecece"
        stroke="none"
        d="M 735.919983 160.48999 L 735.919983 160.97998 L 736.820007 160.820007 L 736.820007 160.289978 L 735.919983 160.48999 Z"
      />
      <path
        id="path2208"
        fill="#cecece"
        stroke="none"
        d="M 735.919983 163.070007 L 736.820007 162.910004 L 736.820007 162.359985 L 735.919983 162.549988 L 735.919983 163.070007 Z"
      />
      <path
        id="path2209"
        fill="#cecece"
        stroke="none"
        d="M 735.919983 165.149994 L 736.820007 165 L 736.820007 164.429993 L 735.919983 164.600006 L 735.919983 165.149994 Z"
      />
      <path
        id="path2210"
        fill="#cecece"
        stroke="none"
        d="M 735.919983 167.23999 L 736.820007 167.100006 L 736.820007 166.48999 L 735.919983 166.660004 L 735.919983 167.23999 Z"
      />
      <path
        id="path2211"
        fill="#cecece"
        stroke="none"
        d="M 735.919983 169.320007 L 736.820007 169.190002 L 736.820007 168.559998 L 735.919983 168.720001 L 735.919983 169.320007 Z"
      />
      <path
        id="path2212"
        fill="#cecece"
        stroke="none"
        d="M 735.909973 173.5 L 736.820007 173.369995 L 736.820007 172.690002 L 735.909973 172.839996 L 735.909973 173.5 Z"
      />
      <path
        id="path2213"
        fill="#cecece"
        stroke="none"
        d="M 735.909973 175.580017 L 736.820007 175.470001 L 736.820007 174.76001 L 735.909973 174.890015 L 735.909973 175.580017 Z"
      />
      <path
        id="path2214"
        fill="#cecece"
        stroke="none"
        d="M 735.909973 177.669983 L 736.820007 177.559998 L 736.820007 176.830017 L 735.909973 176.950012 L 735.909973 177.669983 Z"
      />
      <path
        id="path2215"
        fill="#cecece"
        stroke="none"
        d="M 735.909973 181.839996 L 736.820007 181.73999 L 736.820007 180.960022 L 735.909973 181.070007 L 735.909973 181.839996 Z"
      />
      <path
        id="path2216"
        fill="#cecece"
        stroke="none"
        d="M 735.900024 186.01001 L 736.820007 185.929993 L 736.820007 185.089996 L 735.900024 185.179993 L 735.900024 186.01001 Z"
      />
      <path
        id="path2217"
        fill="#cecece"
        stroke="none"
        d="M 735.900024 188.089996 L 736.820007 188.02002 L 736.820007 187.160004 L 735.900024 187.23999 L 735.900024 188.089996 Z"
      />
      <path
        id="path2218"
        fill="#cecece"
        stroke="none"
        d="M 735.900024 190.179993 L 736.820007 190.109985 L 736.820007 189.220001 L 735.900024 189.299988 L 735.900024 190.179993 Z"
      />
      <path
        id="path2219"
        fill="#cecece"
        stroke="none"
        d="M 735.900024 192.26001 L 736.820007 192.210022 L 736.820007 191.289978 L 735.900024 191.359985 L 735.900024 192.26001 Z"
      />
      <path
        id="path2220"
        fill="#cecece"
        stroke="none"
        d="M 735.900024 194.350006 L 736.820007 194.299988 L 736.820007 193.359985 L 735.900024 193.410004 L 735.900024 194.350006 Z"
      />
      <path
        id="path2221"
        fill="#cecece"
        stroke="none"
        d="M 735.900024 196.429993 L 736.820007 196.390015 L 736.820007 195.419983 L 735.900024 195.470001 L 735.900024 196.429993 Z"
      />
      <path
        id="path2222"
        fill="#cecece"
        stroke="none"
        d="M 735.890015 200.600006 L 736.820007 200.570007 L 736.820007 199.559998 L 735.890015 199.589996 L 735.890015 200.600006 Z"
      />
      <path
        id="path2223"
        fill="#cecece"
        stroke="none"
        d="M 735.890015 204.77002 L 736.820007 204.76001 L 736.820007 203.690002 L 735.890015 203.700012 L 735.890015 204.77002 Z"
      />
      <path
        id="path2224"
        fill="#cecece"
        stroke="none"
        d="M 735.890015 206.859985 L 736.820007 206.850006 L 736.820007 205.75 L 735.890015 205.76001 L 735.890015 206.859985 Z"
      />
      <path
        id="path2225"
        fill="#cecece"
        stroke="none"
        d="M 744.789978 208.940002 L 745.830017 208.940002 L 745.830017 161.450012 L 744.789978 160.73999 L 744.789978 208.940002 Z"
      />
      <path
        id="path2226"
        fill="#cecece"
        stroke="none"
        d="M 747.590027 208.940002 L 748.619995 208.940002 L 748.619995 163.399994 L 747.590027 162.679993 L 747.590027 208.940002 Z"
      />
      <path
        id="path2227"
        fill="#cecece"
        stroke="none"
        d="M 750.590027 208.940002 L 750.890015 208.940002 L 750.890015 164.97998 L 750.590027 164.77002 L 750.590027 208.940002 Z"
      />
      <path
        id="path2228"
        fill="#cecece"
        stroke="none"
        d="M 750.97998 208.940002 L 751.280029 208.940002 L 751.280029 165.25 L 750.97998 165.039978 L 750.97998 208.940002 Z"
      />
      <path
        id="path2229"
        fill="#cecece"
        stroke="none"
        d="M 731.650024 161.450012 L 731.650024 161.950012 L 729.52002 162.399994 L 729.52002 161.910004 L 731.650024 161.450012 Z"
      />
      <path
        id="path2230"
        fill="#cecece"
        stroke="none"
        d="M 729.52002 164.01001 L 731.650024 163.580017 L 731.650024 163.059998 L 729.52002 163.5 L 729.52002 164.01001 Z"
      />
      <path
        id="path2231"
        fill="#cecece"
        stroke="none"
        d="M 729.52002 165.619995 L 731.650024 165.210022 L 731.650024 164.669983 L 729.52002 165.089996 L 729.52002 165.619995 Z"
      />
      <path
        id="path2232"
        fill="#cecece"
        stroke="none"
        d="M 729.530029 168.839996 L 731.650024 168.470001 L 731.650024 167.890015 L 729.530029 168.279999 L 729.530029 168.839996 Z"
      />
      <path
        id="path2233"
        fill="#cecece"
        stroke="none"
        d="M 729.530029 170.450012 L 731.640015 170.100006 L 731.640015 169.5 L 729.530029 169.869995 L 729.530029 170.450012 Z"
      />
      <path
        id="path2234"
        fill="#cecece"
        stroke="none"
        d="M 729.530029 172.059998 L 731.640015 171.72998 L 731.640015 171.109985 L 729.530029 171.460022 L 729.530029 172.059998 Z"
      />
      <path
        id="path2235"
        fill="#cecece"
        stroke="none"
        d="M 729.539978 173.669983 L 731.640015 173.359985 L 731.640015 172.72998 L 729.539978 173.049988 L 729.539978 173.669983 Z"
      />
      <path
        id="path2236"
        fill="#cecece"
        stroke="none"
        d="M 729.539978 175.279999 L 731.640015 174.98999 L 731.640015 174.339996 L 729.539978 174.640015 L 729.539978 175.279999 Z"
      />
      <path
        id="path2237"
        fill="#cecece"
        stroke="none"
        d="M 729.539978 176.890015 L 731.640015 176.619995 L 731.640015 175.950012 L 729.539978 176.22998 L 729.539978 176.890015 Z"
      />
      <path
        id="path2238"
        fill="#cecece"
        stroke="none"
        d="M 729.549988 178.5 L 731.630005 178.25 L 731.630005 177.559998 L 729.549988 177.820007 L 729.549988 178.5 Z"
      />
      <path
        id="path2239"
        fill="#cecece"
        stroke="none"
        d="M 729.549988 183.330017 L 731.630005 183.140015 L 731.630005 182.390015 L 729.549988 182.589996 L 729.549988 183.330017 Z"
      />
      <path
        id="path2240"
        fill="#cecece"
        stroke="none"
        d="M 729.559998 184.940002 L 731.630005 184.77002 L 731.630005 184 L 729.559998 184.179993 L 729.559998 184.940002 Z"
      />
      <path
        id="path2241"
        fill="#cecece"
        stroke="none"
        d="M 729.559998 186.549988 L 731.630005 186.399994 L 731.630005 185.609985 L 729.559998 185.77002 L 729.559998 186.549988 Z"
      />
      <path
        id="path2242"
        fill="#cecece"
        stroke="none"
        d="M 729.559998 188.160004 L 731.619995 188.029999 L 731.619995 187.220001 L 729.559998 187.359985 L 729.559998 188.160004 Z"
      />
      <path
        id="path2243"
        fill="#cecece"
        stroke="none"
        d="M 729.570007 189.77002 L 731.619995 189.649994 L 731.619995 188.830017 L 729.570007 188.950012 L 729.570007 189.77002 Z"
      />
      <path
        id="path2244"
        fill="#cecece"
        stroke="none"
        d="M 729.570007 192.98999 L 731.619995 192.919983 L 731.619995 192.049988 L 729.570007 192.130005 L 729.570007 192.98999 Z"
      />
      <path
        id="path2245"
        fill="#cecece"
        stroke="none"
        d="M 729.580017 196.210022 L 731.619995 196.169983 L 731.619995 195.27002 L 729.580017 195.309998 L 729.580017 196.210022 Z"
      />
      <path
        id="path2246"
        fill="#cecece"
        stroke="none"
        d="M 729.580017 197.820007 L 731.609985 197.799988 L 731.609985 196.880005 L 729.580017 196.899994 L 729.580017 197.820007 Z"
      />
      <path
        id="path2247"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 198.48999 L 729.580017 198.48999 L 729.580017 199.429993 L 731.609985 199.429993 L 731.609985 198.48999 Z"
      />
      <path
        id="path2248"
        fill="#cecece"
        stroke="none"
        d="M 729.179993 161.97998 L 729.179993 162.470001 L 727.450012 162.830017 L 727.450012 162.359985 L 729.179993 161.97998 Z"
      />
      <path
        id="path2249"
        fill="#cecece"
        stroke="none"
        d="M 727.450012 164.419983 L 729.179993 164.070007 L 729.179993 163.570007 L 727.450012 163.929993 L 727.450012 164.419983 Z"
      />
      <path
        id="path2250"
        fill="#cecece"
        stroke="none"
        d="M 727.460022 166.02002 L 729.179993 165.679993 L 729.179993 165.160004 L 727.460022 165.5 L 727.460022 166.02002 Z"
      />
      <path
        id="path2251"
        fill="#cecece"
        stroke="none"
        d="M 727.469971 167.609985 L 729.179993 167.289978 L 729.179993 166.75 L 727.469971 167.070007 L 727.469971 167.609985 Z"
      />
      <path
        id="path2252"
        fill="#cecece"
        stroke="none"
        d="M 727.47998 169.200012 L 729.179993 168.899994 L 729.179993 168.330017 L 727.47998 168.640015 L 727.47998 169.200012 Z"
      />
      <path
        id="path2253"
        fill="#cecece"
        stroke="none"
        d="M 727.48999 170.789978 L 729.179993 170.5 L 729.179993 169.919983 L 727.48999 170.220001 L 727.48999 170.789978 Z"
      />
      <path
        id="path2254"
        fill="#cecece"
        stroke="none"
        d="M 727.5 172.380005 L 729.179993 172.109985 L 729.179993 171.51001 L 727.5 171.789978 L 727.5 172.380005 Z"
      />
      <path
        id="path2255"
        fill="#cecece"
        stroke="none"
        d="M 727.51001 175.559998 L 729.169983 175.330017 L 729.169983 174.679993 L 727.51001 174.929993 L 727.51001 175.559998 Z"
      />
      <path
        id="path2256"
        fill="#cecece"
        stroke="none"
        d="M 727.52002 177.160004 L 729.169983 176.929993 L 729.169983 176.27002 L 727.52002 176.5 L 727.52002 177.160004 Z"
      />
      <path
        id="path2257"
        fill="#cecece"
        stroke="none"
        d="M 727.530029 178.75 L 729.169983 178.539978 L 729.169983 177.859985 L 727.530029 178.070007 L 727.530029 178.75 Z"
      />
      <path
        id="path2258"
        fill="#cecece"
        stroke="none"
        d="M 727.539978 180.339996 L 729.169983 180.149994 L 729.169983 179.450012 L 727.539978 179.640015 L 727.539978 180.339996 Z"
      />
      <path
        id="path2259"
        fill="#cecece"
        stroke="none"
        d="M 727.549988 181.929993 L 729.169983 181.75 L 729.169983 181.029999 L 727.549988 181.210022 L 727.549988 181.929993 Z"
      />
      <path
        id="path2260"
        fill="#cecece"
        stroke="none"
        d="M 727.559998 183.52002 L 729.169983 183.359985 L 729.169983 182.619995 L 727.559998 182.779999 L 727.559998 183.52002 Z"
      />
      <path
        id="path2261"
        fill="#cecece"
        stroke="none"
        d="M 727.570007 185.109985 L 729.169983 184.970001 L 729.169983 184.210022 L 727.570007 184.359985 L 727.570007 185.109985 Z"
      />
      <path
        id="path2262"
        fill="#cecece"
        stroke="none"
        d="M 727.570007 186.700012 L 729.169983 186.580017 L 729.169983 185.799988 L 727.570007 185.929993 L 727.570007 186.700012 Z"
      />
      <path
        id="path2263"
        fill="#cecece"
        stroke="none"
        d="M 727.580017 188.299988 L 729.169983 188.179993 L 729.169983 187.380005 L 727.580017 187.5 L 727.580017 188.299988 Z"
      />
      <path
        id="path2264"
        fill="#cecece"
        stroke="none"
        d="M 727.590027 189.890015 L 729.159973 189.789978 L 729.159973 188.970001 L 727.590027 189.070007 L 727.590027 189.890015 Z"
      />
      <path
        id="path2265"
        fill="#cecece"
        stroke="none"
        d="M 727.599976 191.47998 L 729.159973 191.399994 L 729.159973 190.559998 L 727.599976 190.640015 L 727.599976 191.47998 Z"
      />
      <path
        id="path2266"
        fill="#cecece"
        stroke="none"
        d="M 727.609985 193.070007 L 729.159973 193.01001 L 729.159973 192.149994 L 727.609985 192.210022 L 727.609985 193.070007 Z"
      />
      <path
        id="path2267"
        fill="#cecece"
        stroke="none"
        d="M 727.619995 194.660004 L 729.159973 194.609985 L 729.159973 193.72998 L 727.619995 193.779999 L 727.619995 194.660004 Z"
      />
      <path
        id="path2268"
        fill="#cecece"
        stroke="none"
        d="M 727.640015 197.839996 L 729.159973 197.830017 L 729.159973 196.910004 L 727.640015 196.919983 L 727.640015 197.839996 Z"
      />
      <path
        id="path2269"
        fill="#cecece"
        stroke="none"
        d="M 734.919983 199.429993 L 732.179993 199.429993 L 732.179993 161.320007 L 734.919983 160.720001 L 734.919983 199.429993 Z"
      />
      <path
        id="path2270"
        fill="#cecece"
        stroke="none"
        d="M 726.919983 199.429993 L 726.130005 199.429993 L 726.130005 162.640015 L 726.919983 162.470001 L 726.919983 199.429993 Z"
      />
      <path
        id="path2271"
        fill="#cecece"
        stroke="none"
        d="M 725.890015 199.429993 L 725.099976 199.429993 L 725.099976 162.869995 L 725.890015 162.690002 L 725.890015 199.429993 Z"
      />
      <path
        id="path2272"
        fill="#cecece"
        stroke="none"
        d="M 527.400024 119.089996 L 526.650024 119.089996 L 526.650024 156.419983 L 527.400024 156.419983 L 527.400024 119.089996 Z"
      />
      <path
        id="path2273"
        fill="#cecece"
        stroke="none"
        d="M 527.400024 177.960022 L 526.650024 177.960022 L 526.650024 207.899994 L 527.400024 207.899994 L 527.400024 177.960022 Z"
      />
      <path
        id="path2274"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 160.25 L 678.080017 160.25 L 678.080017 161.580017 L 678.789978 161.580017 L 678.789978 160.25 Z"
      />
      <path
        id="path2275"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 680.169983 160.25 L 679.460022 160.25 L 679.460022 161.580017 L 680.169983 161.580017 L 680.169983 160.25 Z"
      />
      <path
        id="path2276"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 162.200012 L 678.080017 162.200012 L 678.080017 163.529999 L 678.789978 163.529999 L 678.789978 162.200012 Z"
      />
      <path
        id="path2277"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 164.149994 L 678.080017 164.149994 L 678.080017 165.47998 L 678.789978 165.47998 L 678.789978 164.149994 Z"
      />
      <path
        id="path2278"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 166.100006 L 678.080017 166.100006 L 678.080017 167.429993 L 678.789978 167.429993 L 678.789978 166.100006 Z"
      />
      <path
        id="path2279"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 168.049988 L 678.080017 168.049988 L 678.080017 169.380005 L 678.789978 169.380005 L 678.789978 168.049988 Z"
      />
      <path
        id="path2280"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 170 L 678.080017 170 L 678.080017 171.330017 L 678.789978 171.330017 L 678.789978 170 Z"
      />
      <path
        id="path2281"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 171.960022 L 678.080017 171.960022 L 678.080017 173.289978 L 678.789978 173.289978 L 678.789978 171.960022 Z"
      />
      <path
        id="path2282"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 678.789978 173.910004 L 678.080017 173.910004 L 678.080017 175.23999 L 678.789978 175.23999 L 678.789978 173.910004 Z"
      />
      <path
        id="path2283"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 677.409973 160.25 L 676.700012 160.25 L 676.700012 161.580017 L 677.409973 161.580017 L 677.409973 160.25 Z"
      />
      <path
        id="path2284"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 677.409973 162.200012 L 676.700012 162.200012 L 676.700012 163.529999 L 677.409973 163.529999 L 677.409973 162.200012 Z"
      />
      <path
        id="path2285"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 677.409973 168.049988 L 676.700012 168.049988 L 676.700012 169.380005 L 677.409973 169.380005 L 677.409973 168.049988 Z"
      />
      <path
        id="path2286"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 677.409973 170 L 676.700012 170 L 676.700012 171.330017 L 677.409973 171.330017 L 677.409973 170 Z"
      />
      <path
        id="path2287"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 677.409973 171.960022 L 676.700012 171.960022 L 676.700012 173.289978 L 677.409973 173.289978 L 677.409973 171.960022 Z"
      />
      <path
        id="path2288"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 677.409973 175.859985 L 676.700012 175.859985 L 676.700012 177.190002 L 677.409973 177.190002 L 677.409973 175.859985 Z"
      />
      <path
        id="path2289"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 160.25 L 675.320007 160.25 L 675.320007 161.580017 L 676.030029 161.580017 L 676.030029 160.25 Z"
      />
      <path
        id="path2290"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 162.200012 L 675.320007 162.200012 L 675.320007 163.529999 L 676.030029 163.529999 L 676.030029 162.200012 Z"
      />
      <path
        id="path2291"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 164.149994 L 675.320007 164.149994 L 675.320007 165.47998 L 676.030029 165.47998 L 676.030029 164.149994 Z"
      />
      <path
        id="path2292"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 166.100006 L 675.320007 166.100006 L 675.320007 167.429993 L 676.030029 167.429993 L 676.030029 166.100006 Z"
      />
      <path
        id="path2293"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 170 L 675.320007 170 L 675.320007 171.330017 L 676.030029 171.330017 L 676.030029 170 Z"
      />
      <path
        id="path2294"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 171.960022 L 675.320007 171.960022 L 675.320007 173.289978 L 676.030029 173.289978 L 676.030029 171.960022 Z"
      />
      <path
        id="path2295"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 173.910004 L 675.320007 173.910004 L 675.320007 175.23999 L 676.030029 175.23999 L 676.030029 173.910004 Z"
      />
      <path
        id="path2296"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 676.030029 175.859985 L 675.320007 175.859985 L 675.320007 177.190002 L 676.030029 177.190002 L 676.030029 175.859985 Z"
      />
      <path
        id="path2297"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 160.25 L 673.929993 160.25 L 673.929993 161.580017 L 674.640015 161.580017 L 674.640015 160.25 Z"
      />
      <path
        id="path2298"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 162.200012 L 673.929993 162.200012 L 673.929993 163.529999 L 674.640015 163.529999 L 674.640015 162.200012 Z"
      />
      <path
        id="path2299"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 164.149994 L 673.929993 164.149994 L 673.929993 165.47998 L 674.640015 165.47998 L 674.640015 164.149994 Z"
      />
      <path
        id="path2300"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 166.100006 L 673.929993 166.100006 L 673.929993 167.429993 L 674.640015 167.429993 L 674.640015 166.100006 Z"
      />
      <path
        id="path2301"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 168.049988 L 673.929993 168.049988 L 673.929993 169.380005 L 674.640015 169.380005 L 674.640015 168.049988 Z"
      />
      <path
        id="path2302"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 170 L 673.929993 170 L 673.929993 171.330017 L 674.640015 171.330017 L 674.640015 170 Z"
      />
      <path
        id="path2303"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 173.910004 L 673.929993 173.910004 L 673.929993 175.23999 L 674.640015 175.23999 L 674.640015 173.910004 Z"
      />
      <path
        id="path2304"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 674.640015 175.859985 L 673.929993 175.859985 L 673.929993 177.190002 L 674.640015 177.190002 L 674.640015 175.859985 Z"
      />
      <path
        id="path2305"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 160.25 L 668.400024 160.25 L 668.400024 161.580017 L 669.109985 161.580017 L 669.109985 160.25 Z"
      />
      <path
        id="path2306"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 162.200012 L 668.400024 162.200012 L 668.400024 163.529999 L 669.109985 163.529999 L 669.109985 162.200012 Z"
      />
      <path
        id="path2307"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 166.100006 L 668.400024 166.100006 L 668.400024 167.429993 L 669.109985 167.429993 L 669.109985 166.100006 Z"
      />
      <path
        id="path2308"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 168.049988 L 668.400024 168.049988 L 668.400024 169.380005 L 669.109985 169.380005 L 669.109985 168.049988 Z"
      />
      <path
        id="path2309"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 170 L 668.400024 170 L 668.400024 171.330017 L 669.109985 171.330017 L 669.109985 170 Z"
      />
      <path
        id="path2310"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 171.960022 L 668.400024 171.960022 L 668.400024 173.289978 L 669.109985 173.289978 L 669.109985 171.960022 Z"
      />
      <path
        id="path2311"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 669.109985 177.809998 L 668.400024 177.809998 L 668.400024 179.140015 L 669.109985 179.140015 L 669.109985 177.809998 Z"
      />
      <path
        id="path2312"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 667.72998 160.25 L 667.02002 160.25 L 667.02002 161.580017 L 667.72998 161.580017 L 667.72998 160.25 Z"
      />
      <path
        id="path2313"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 667.72998 162.200012 L 667.02002 162.200012 L 667.02002 163.529999 L 667.72998 163.529999 L 667.72998 162.200012 Z"
      />
      <path
        id="path2314"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 667.72998 164.149994 L 667.02002 164.149994 L 667.02002 165.47998 L 667.72998 165.47998 L 667.72998 164.149994 Z"
      />
      <path
        id="path2315"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 667.72998 168.049988 L 667.02002 168.049988 L 667.02002 169.380005 L 667.72998 169.380005 L 667.72998 168.049988 Z"
      />
      <path
        id="path2316"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 667.72998 173.910004 L 667.02002 173.910004 L 667.02002 175.23999 L 667.72998 175.23999 L 667.72998 173.910004 Z"
      />
      <path
        id="path2317"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 667.72998 177.809998 L 667.02002 177.809998 L 667.02002 179.140015 L 667.72998 179.140015 L 667.72998 177.809998 Z"
      />
      <path
        id="path2318"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 160.25 L 665.460022 160.25 L 665.460022 161.580017 L 666.169983 161.580017 L 666.169983 160.25 Z"
      />
      <path
        id="path2319"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 162.200012 L 665.460022 162.200012 L 665.460022 163.529999 L 666.169983 163.529999 L 666.169983 162.200012 Z"
      />
      <path
        id="path2320"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 164.149994 L 665.460022 164.149994 L 665.460022 165.47998 L 666.169983 165.47998 L 666.169983 164.149994 Z"
      />
      <path
        id="path2321"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 166.100006 L 665.460022 166.100006 L 665.460022 167.429993 L 666.169983 167.429993 L 666.169983 166.100006 Z"
      />
      <path
        id="path2322"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 168.049988 L 665.460022 168.049988 L 665.460022 169.380005 L 666.169983 169.380005 L 666.169983 168.049988 Z"
      />
      <path
        id="path2323"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 170 L 665.460022 170 L 665.460022 171.330017 L 666.169983 171.330017 L 666.169983 170 Z"
      />
      <path
        id="path2324"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 173.910004 L 665.460022 173.910004 L 665.460022 175.23999 L 666.169983 175.23999 L 666.169983 173.910004 Z"
      />
      <path
        id="path2325"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 175.859985 L 665.460022 175.859985 L 665.460022 177.190002 L 666.169983 177.190002 L 666.169983 175.859985 Z"
      />
      <path
        id="path2326"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 666.169983 177.809998 L 665.460022 177.809998 L 665.460022 179.140015 L 666.169983 179.140015 L 666.169983 177.809998 Z"
      />
      <path
        id="path2327"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 664.780029 160.25 L 664.070007 160.25 L 664.070007 161.580017 L 664.780029 161.580017 L 664.780029 160.25 Z"
      />
      <path
        id="path2328"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 664.780029 164.149994 L 664.070007 164.149994 L 664.070007 165.47998 L 664.780029 165.47998 L 664.780029 164.149994 Z"
      />
      <path
        id="path2329"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 664.780029 168.049988 L 664.070007 168.049988 L 664.070007 169.380005 L 664.780029 169.380005 L 664.780029 168.049988 Z"
      />
      <path
        id="path2330"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 664.780029 170 L 664.070007 170 L 664.070007 171.330017 L 664.780029 171.330017 L 664.780029 170 Z"
      />
      <path
        id="path2331"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 664.780029 171.960022 L 664.070007 171.960022 L 664.070007 173.289978 L 664.780029 173.289978 L 664.780029 171.960022 Z"
      />
      <path
        id="path2332"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 160.25 L 662.690002 160.25 L 662.690002 161.580017 L 663.400024 161.580017 L 663.400024 160.25 Z"
      />
      <path
        id="path2333"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 162.200012 L 662.690002 162.200012 L 662.690002 163.529999 L 663.400024 163.529999 L 663.400024 162.200012 Z"
      />
      <path
        id="path2334"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 164.149994 L 662.690002 164.149994 L 662.690002 165.47998 L 663.400024 165.47998 L 663.400024 164.149994 Z"
      />
      <path
        id="path2335"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 166.100006 L 662.690002 166.100006 L 662.690002 167.429993 L 663.400024 167.429993 L 663.400024 166.100006 Z"
      />
      <path
        id="path2336"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 168.049988 L 662.690002 168.049988 L 662.690002 169.380005 L 663.400024 169.380005 L 663.400024 168.049988 Z"
      />
      <path
        id="path2337"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 171.960022 L 662.690002 171.960022 L 662.690002 173.289978 L 663.400024 173.289978 L 663.400024 171.960022 Z"
      />
      <path
        id="path2338"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 173.910004 L 662.690002 173.910004 L 662.690002 175.23999 L 663.400024 175.23999 L 663.400024 173.910004 Z"
      />
      <path
        id="path2339"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 175.859985 L 662.690002 175.859985 L 662.690002 177.190002 L 663.400024 177.190002 L 663.400024 175.859985 Z"
      />
      <path
        id="path2340"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 663.400024 177.809998 L 662.690002 177.809998 L 662.690002 179.140015 L 663.400024 179.140015 L 663.400024 177.809998 Z"
      />
      <g id="g2" opacity="0.7">
        <path
          id="path2341"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 177.809998 L 679.460022 177.809998 L 679.460022 179.140015 L 680.169983 179.140015 L 680.169983 177.809998 Z"
        />
        <path
          id="path2342"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 162.22998 L 679.460022 162.22998 L 679.460022 163.559998 L 680.169983 163.559998 L 680.169983 162.22998 Z"
        />
        <path
          id="path2343"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 166.130005 L 679.460022 166.130005 L 679.460022 167.460022 L 680.169983 167.460022 L 680.169983 166.130005 Z"
        />
        <path
          id="path2344"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 168.049988 L 679.460022 168.049988 L 679.460022 169.380005 L 680.169983 169.380005 L 680.169983 168.049988 Z"
        />
        <path
          id="path2345"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 170.01001 L 679.460022 170.01001 L 679.460022 171.339996 L 680.169983 171.339996 L 680.169983 170.01001 Z"
        />
        <path
          id="path2346"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 171.960022 L 679.460022 171.960022 L 679.460022 173.289978 L 680.169983 173.289978 L 680.169983 171.960022 Z"
        />
        <path
          id="path2347"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 173.910004 L 679.460022 173.910004 L 679.460022 175.23999 L 680.169983 175.23999 L 680.169983 173.910004 Z"
        />
        <path
          id="path2348"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 680.169983 175.859985 L 679.460022 175.859985 L 679.460022 177.190002 L 680.169983 177.190002 L 680.169983 175.859985 Z"
        />
        <path
          id="path2349"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 678.789978 177.809998 L 678.080017 177.809998 L 678.080017 179.140015 L 678.789978 179.140015 L 678.789978 177.809998 Z"
        />
        <path
          id="path2350"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 677.409973 177.809998 L 676.700012 177.809998 L 676.700012 179.140015 L 677.409973 179.140015 L 677.409973 177.809998 Z"
        />
        <path
          id="path2351"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 676.030029 177.809998 L 675.320007 177.809998 L 675.320007 179.140015 L 676.030029 179.140015 L 676.030029 177.809998 Z"
        />
        <path
          id="path2352"
          fill="#cecece"
          stroke="none"
          opacity="0.7"
          d="M 673.440002 177.809998 L 672.72998 177.809998 L 672.72998 179.140015 L 673.440002 179.140015 L 673.440002 177.809998 Z"
        />
      </g>
      <path
        id="path2353"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 160.25 L 661.309998 160.25 L 661.309998 161.580017 L 662.02002 161.580017 L 662.02002 160.25 Z"
      />
      <path
        id="path2354"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 162.200012 L 661.309998 162.200012 L 661.309998 163.529999 L 662.02002 163.529999 L 662.02002 162.200012 Z"
      />
      <path
        id="path2355"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 164.149994 L 661.309998 164.149994 L 661.309998 165.47998 L 662.02002 165.47998 L 662.02002 164.149994 Z"
      />
      <path
        id="path2356"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 166.100006 L 661.309998 166.100006 L 661.309998 167.429993 L 662.02002 167.429993 L 662.02002 166.100006 Z"
      />
      <path
        id="path2357"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 168.049988 L 661.309998 168.049988 L 661.309998 169.380005 L 662.02002 169.380005 L 662.02002 168.049988 Z"
      />
      <path
        id="path2358"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 170 L 661.309998 170 L 661.309998 171.330017 L 662.02002 171.330017 L 662.02002 170 Z"
      />
      <path
        id="path2359"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 171.960022 L 661.309998 171.960022 L 661.309998 173.289978 L 662.02002 173.289978 L 662.02002 171.960022 Z"
      />
      <path
        id="path2360"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 173.910004 L 661.309998 173.910004 L 661.309998 175.23999 L 662.02002 175.23999 L 662.02002 173.910004 Z"
      />
      <path
        id="path2361"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 175.859985 L 661.309998 175.859985 L 661.309998 177.190002 L 662.02002 177.190002 L 662.02002 175.859985 Z"
      />
      <path
        id="path2362"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 662.02002 177.809998 L 661.309998 177.809998 L 661.309998 179.140015 L 662.02002 179.140015 L 662.02002 177.809998 Z"
      />
      <path
        id="path2363"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 660.640015 160.25 L 659.929993 160.25 L 659.929993 161.580017 L 660.640015 161.580017 L 660.640015 160.25 Z"
      />
      <path
        id="path2364"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 660.640015 166.100006 L 659.929993 166.100006 L 659.929993 167.429993 L 660.640015 167.429993 L 660.640015 166.100006 Z"
      />
      <path
        id="path2365"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 660.640015 168.049988 L 659.929993 168.049988 L 659.929993 169.380005 L 660.640015 169.380005 L 660.640015 168.049988 Z"
      />
      <path
        id="path2366"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 660.640015 170 L 659.929993 170 L 659.929993 171.330017 L 660.640015 171.330017 L 660.640015 170 Z"
      />
      <path
        id="path2367"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 660.640015 171.960022 L 659.929993 171.960022 L 659.929993 173.289978 L 660.640015 173.289978 L 660.640015 171.960022 Z"
      />
      <path
        id="path2368"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 660.640015 177.809998 L 659.929993 177.809998 L 659.929993 179.140015 L 660.640015 179.140015 L 660.640015 177.809998 Z"
      />
      <path
        id="path2369"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 633.789978 181.470001 L 633.280029 181.470001 L 633.280029 182.429993 L 633.789978 182.429993 L 633.789978 181.470001 Z"
      />
      <path
        id="path2370"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 633.789978 182.880005 L 633.280029 182.880005 L 633.280029 183.839996 L 633.789978 183.839996 L 633.789978 182.880005 Z"
      />
      <path
        id="path2371"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 633.789978 184.289978 L 633.280029 184.289978 L 633.280029 185.25 L 633.789978 185.25 L 633.789978 184.289978 Z"
      />
      <path
        id="path2372"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 633.789978 187.109985 L 633.280029 187.109985 L 633.280029 188.070007 L 633.789978 188.070007 L 633.789978 187.109985 Z"
      />
      <path
        id="path2373"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 633.789978 191.350006 L 633.280029 191.350006 L 633.280029 192.309998 L 633.789978 192.309998 L 633.789978 191.350006 Z"
      />
      <path
        id="path2374"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 633.789978 194.169983 L 633.280029 194.169983 L 633.280029 195.130005 L 633.789978 195.130005 L 633.789978 194.169983 Z"
      />
      <path
        id="path2375"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 181.470001 L 632.150024 181.470001 L 632.150024 182.429993 L 632.659973 182.429993 L 632.659973 181.470001 Z"
      />
      <path
        id="path2376"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 182.880005 L 632.150024 182.880005 L 632.150024 183.839996 L 632.659973 183.839996 L 632.659973 182.880005 Z"
      />
      <path
        id="path2377"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 184.289978 L 632.150024 184.289978 L 632.150024 185.25 L 632.659973 185.25 L 632.659973 184.289978 Z"
      />
      <path
        id="path2378"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 185.700012 L 632.150024 185.700012 L 632.150024 186.660004 L 632.659973 186.660004 L 632.659973 185.700012 Z"
      />
      <path
        id="path2379"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 187.109985 L 632.150024 187.109985 L 632.150024 188.070007 L 632.659973 188.070007 L 632.659973 187.109985 Z"
      />
      <path
        id="path2380"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 188.529999 L 632.150024 188.529999 L 632.150024 189.48999 L 632.659973 189.48999 L 632.659973 188.529999 Z"
      />
      <path
        id="path2381"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 191.350006 L 632.150024 191.350006 L 632.150024 192.309998 L 632.659973 192.309998 L 632.659973 191.350006 Z"
      />
      <path
        id="path2382"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 192.76001 L 632.150024 192.76001 L 632.150024 193.720001 L 632.659973 193.720001 L 632.659973 192.76001 Z"
      />
      <path
        id="path2383"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 632.659973 194.169983 L 632.150024 194.169983 L 632.150024 195.130005 L 632.659973 195.130005 L 632.659973 194.169983 Z"
      />
      <path
        id="path2384"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 631.659973 181.470001 L 631.150024 181.470001 L 631.150024 182.429993 L 631.659973 182.429993 L 631.659973 181.470001 Z"
      />
      <path
        id="path2385"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 631.659973 184.289978 L 631.150024 184.289978 L 631.150024 185.25 L 631.659973 185.25 L 631.659973 184.289978 Z"
      />
      <path
        id="path2386"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 631.659973 187.109985 L 631.150024 187.109985 L 631.150024 188.070007 L 631.659973 188.070007 L 631.659973 187.109985 Z"
      />
      <path
        id="path2387"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 631.659973 188.529999 L 631.150024 188.529999 L 631.150024 189.48999 L 631.659973 189.48999 L 631.659973 188.529999 Z"
      />
      <path
        id="path2388"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 631.659973 189.940002 L 631.150024 189.940002 L 631.150024 190.899994 L 631.659973 190.899994 L 631.659973 189.940002 Z"
      />
      <path
        id="path2389"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 181.470001 L 630.150024 181.470001 L 630.150024 182.429993 L 630.659973 182.429993 L 630.659973 181.470001 Z"
      />
      <path
        id="path2390"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 182.880005 L 630.150024 182.880005 L 630.150024 183.839996 L 630.659973 183.839996 L 630.659973 182.880005 Z"
      />
      <path
        id="path2391"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 184.289978 L 630.150024 184.289978 L 630.150024 185.25 L 630.659973 185.25 L 630.659973 184.289978 Z"
      />
      <path
        id="path2392"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 185.700012 L 630.150024 185.700012 L 630.150024 186.660004 L 630.659973 186.660004 L 630.659973 185.700012 Z"
      />
      <path
        id="path2393"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 187.109985 L 630.150024 187.109985 L 630.150024 188.070007 L 630.659973 188.070007 L 630.659973 187.109985 Z"
      />
      <path
        id="path2394"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 189.940002 L 630.150024 189.940002 L 630.150024 190.899994 L 630.659973 190.899994 L 630.659973 189.940002 Z"
      />
      <path
        id="path2395"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 191.350006 L 630.150024 191.350006 L 630.150024 192.309998 L 630.659973 192.309998 L 630.659973 191.350006 Z"
      />
      <path
        id="path2396"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 192.76001 L 630.150024 192.76001 L 630.150024 193.720001 L 630.659973 193.720001 L 630.659973 192.76001 Z"
      />
      <path
        id="path2397"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 630.659973 194.169983 L 630.150024 194.169983 L 630.150024 195.130005 L 630.659973 195.130005 L 630.659973 194.169983 Z"
      />
      <path
        id="path2398"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 181.470001 L 629.150024 181.470001 L 629.150024 182.429993 L 629.659973 182.429993 L 629.659973 181.470001 Z"
      />
      <path
        id="path2399"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 182.880005 L 629.150024 182.880005 L 629.150024 183.839996 L 629.659973 183.839996 L 629.659973 182.880005 Z"
      />
      <path
        id="path2400"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 184.289978 L 629.150024 184.289978 L 629.150024 185.25 L 629.659973 185.25 L 629.659973 184.289978 Z"
      />
      <path
        id="path2401"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 185.700012 L 629.150024 185.700012 L 629.150024 186.660004 L 629.659973 186.660004 L 629.659973 185.700012 Z"
      />
      <path
        id="path2402"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 187.109985 L 629.150024 187.109985 L 629.150024 188.070007 L 629.659973 188.070007 L 629.659973 187.109985 Z"
      />
      <path
        id="path2403"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 188.529999 L 629.150024 188.529999 L 629.150024 189.48999 L 629.659973 189.48999 L 629.659973 188.529999 Z"
      />
      <path
        id="path2404"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 189.940002 L 629.150024 189.940002 L 629.150024 190.899994 L 629.659973 190.899994 L 629.659973 189.940002 Z"
      />
      <path
        id="path2405"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 191.350006 L 629.150024 191.350006 L 629.150024 192.309998 L 629.659973 192.309998 L 629.659973 191.350006 Z"
      />
      <path
        id="path2406"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 192.76001 L 629.150024 192.76001 L 629.150024 193.720001 L 629.659973 193.720001 L 629.659973 192.76001 Z"
      />
      <path
        id="path2407"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 629.659973 194.169983 L 629.150024 194.169983 L 629.150024 195.130005 L 629.659973 195.130005 L 629.659973 194.169983 Z"
      />
      <path
        id="path2408"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 628.659973 181.470001 L 628.150024 181.470001 L 628.150024 182.429993 L 628.659973 182.429993 L 628.659973 181.470001 Z"
      />
      <path
        id="path2409"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 628.659973 185.700012 L 628.150024 185.700012 L 628.150024 186.660004 L 628.659973 186.660004 L 628.659973 185.700012 Z"
      />
      <path
        id="path2410"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 628.659973 187.109985 L 628.150024 187.109985 L 628.150024 188.070007 L 628.659973 188.070007 L 628.659973 187.109985 Z"
      />
      <path
        id="path2411"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 628.659973 188.529999 L 628.150024 188.529999 L 628.150024 189.48999 L 628.659973 189.48999 L 628.659973 188.529999 Z"
      />
      <path
        id="path2412"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 628.659973 189.940002 L 628.150024 189.940002 L 628.150024 190.899994 L 628.659973 190.899994 L 628.659973 189.940002 Z"
      />
      <path
        id="path2413"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 628.659973 194.169983 L 628.150024 194.169983 L 628.150024 195.130005 L 628.659973 195.130005 L 628.659973 194.169983 Z"
      />
      <path
        id="path2414"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 149.580017 L 695.919983 149.580017 L 695.919983 150.910004 L 696.630005 150.910004 L 696.630005 149.580017 Z"
      />
      <path
        id="path2415"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 151.700012 L 695.919983 151.700012 L 695.919983 153.029999 L 696.630005 153.029999 L 696.630005 151.700012 Z"
      />
      <path
        id="path2416"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 153.649994 L 695.919983 153.649994 L 695.919983 154.97998 L 696.630005 154.97998 L 696.630005 153.649994 Z"
      />
      <path
        id="path2417"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 155.600006 L 695.919983 155.600006 L 695.919983 156.929993 L 696.630005 156.929993 L 696.630005 155.600006 Z"
      />
      <path
        id="path2418"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 157.549988 L 695.919983 157.549988 L 695.919983 158.880005 L 696.630005 158.880005 L 696.630005 157.549988 Z"
      />
      <path
        id="path2419"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 159.5 L 695.919983 159.5 L 695.919983 160.830017 L 696.630005 160.830017 L 696.630005 159.5 Z"
      />
      <path
        id="path2420"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 161.450012 L 695.919983 161.450012 L 695.919983 162.779999 L 696.630005 162.779999 L 696.630005 161.450012 Z"
      />
      <path
        id="path2421"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 165.359985 L 695.919983 165.359985 L 695.919983 166.690002 L 696.630005 166.690002 L 696.630005 165.359985 Z"
      />
      <path
        id="path2422"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 167.309998 L 695.919983 167.309998 L 695.919983 168.640015 L 696.630005 168.640015 L 696.630005 167.309998 Z"
      />
      <path
        id="path2423"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 171.210022 L 695.919983 171.210022 L 695.919983 172.539978 L 696.630005 172.539978 L 696.630005 171.210022 Z"
      />
      <path
        id="path2424"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 173.160004 L 695.919983 173.160004 L 695.919983 174.48999 L 696.630005 174.48999 L 696.630005 173.160004 Z"
      />
      <path
        id="path2425"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 175.109985 L 695.919983 175.109985 L 695.919983 176.440002 L 696.630005 176.440002 L 696.630005 175.109985 Z"
      />
      <path
        id="path2426"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 177.059998 L 695.919983 177.059998 L 695.919983 178.390015 L 696.630005 178.390015 L 696.630005 177.059998 Z"
      />
      <path
        id="path2427"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 179.02002 L 695.919983 179.02002 L 695.919983 180.350006 L 696.630005 180.350006 L 696.630005 179.02002 Z"
      />
      <path
        id="path2428"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 180.970001 L 695.919983 180.970001 L 695.919983 182.299988 L 696.630005 182.299988 L 696.630005 180.970001 Z"
      />
      <path
        id="path2429"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 182.919983 L 695.919983 182.919983 L 695.919983 184.25 L 696.630005 184.25 L 696.630005 182.919983 Z"
      />
      <path
        id="path2430"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 184.869995 L 695.919983 184.869995 L 695.919983 186.200012 L 696.630005 186.200012 L 696.630005 184.869995 Z"
      />
      <path
        id="path2431"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 220.140015 L 695.919983 220.140015 L 695.919983 221.470001 L 696.630005 221.470001 L 696.630005 220.140015 Z"
      />
      <path
        id="path2432"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 222.089996 L 695.919983 222.089996 L 695.919983 223.419983 L 696.630005 223.419983 L 696.630005 222.089996 Z"
      />
      <path
        id="path2433"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 224.039978 L 695.919983 224.039978 L 695.919983 225.369995 L 696.630005 225.369995 L 696.630005 224.039978 Z"
      />
      <path
        id="path2434"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 225.98999 L 695.919983 225.98999 L 695.919983 227.320007 L 696.630005 227.320007 L 696.630005 225.98999 Z"
      />
      <path
        id="path2435"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 227.950012 L 695.919983 227.950012 L 695.919983 229.279999 L 696.630005 229.279999 L 696.630005 227.950012 Z"
      />
      <path
        id="path2436"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 229.899994 L 695.919983 229.899994 L 695.919983 231.22998 L 696.630005 231.22998 L 696.630005 229.899994 Z"
      />
      <path
        id="path2437"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 231.850006 L 695.919983 231.850006 L 695.919983 233.179993 L 696.630005 233.179993 L 696.630005 231.850006 Z"
      />
      <path
        id="path2438"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 233.799988 L 695.919983 233.799988 L 695.919983 235.130005 L 696.630005 235.130005 L 696.630005 233.799988 Z"
      />
      <path
        id="path2439"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 188.77002 L 695.919983 188.77002 L 695.919983 190.100006 L 696.630005 190.100006 L 696.630005 188.77002 Z"
      />
      <path
        id="path2440"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 192.679993 L 695.919983 192.679993 L 695.919983 194.01001 L 696.630005 194.01001 L 696.630005 192.679993 Z"
      />
      <path
        id="path2441"
        fill="#cecece"
        stroke="none"
        d="M 695.25 149.580017 L 694.539978 149.580017 L 694.539978 150.910004 L 695.25 150.910004 L 695.25 149.580017 Z"
      />
      <path
        id="path2442"
        fill="#cecece"
        stroke="none"
        d="M 695.25 151.700012 L 694.539978 151.700012 L 694.539978 153.029999 L 695.25 153.029999 L 695.25 151.700012 Z"
      />
      <path
        id="path2443"
        fill="#cecece"
        stroke="none"
        d="M 695.25 153.649994 L 694.539978 153.649994 L 694.539978 154.97998 L 695.25 154.97998 L 695.25 153.649994 Z"
      />
      <path
        id="path2444"
        fill="#cecece"
        stroke="none"
        d="M 695.25 155.600006 L 694.539978 155.600006 L 694.539978 156.929993 L 695.25 156.929993 L 695.25 155.600006 Z"
      />
      <path
        id="path2445"
        fill="#cecece"
        stroke="none"
        d="M 695.25 157.549988 L 694.539978 157.549988 L 694.539978 158.880005 L 695.25 158.880005 L 695.25 157.549988 Z"
      />
      <path
        id="path2446"
        fill="#cecece"
        stroke="none"
        d="M 695.25 159.5 L 694.539978 159.5 L 694.539978 160.830017 L 695.25 160.830017 L 695.25 159.5 Z"
      />
      <path
        id="path2447"
        fill="#cecece"
        stroke="none"
        d="M 695.25 161.450012 L 694.539978 161.450012 L 694.539978 162.779999 L 695.25 162.779999 L 695.25 161.450012 Z"
      />
      <path
        id="path2448"
        fill="#cecece"
        stroke="none"
        d="M 695.25 163.399994 L 694.539978 163.399994 L 694.539978 164.72998 L 695.25 164.72998 L 695.25 163.399994 Z"
      />
      <path
        id="path2449"
        fill="#cecece"
        stroke="none"
        d="M 695.25 165.359985 L 694.539978 165.359985 L 694.539978 166.690002 L 695.25 166.690002 L 695.25 165.359985 Z"
      />
      <path
        id="path2450"
        fill="#cecece"
        stroke="none"
        d="M 695.25 167.309998 L 694.539978 167.309998 L 694.539978 168.640015 L 695.25 168.640015 L 695.25 167.309998 Z"
      />
      <path
        id="path2451"
        fill="#cecece"
        stroke="none"
        d="M 695.25 169.26001 L 694.539978 169.26001 L 694.539978 170.589996 L 695.25 170.589996 L 695.25 169.26001 Z"
      />
      <path
        id="path2452"
        fill="#cecece"
        stroke="none"
        d="M 695.25 171.210022 L 694.539978 171.210022 L 694.539978 172.539978 L 695.25 172.539978 L 695.25 171.210022 Z"
      />
      <path
        id="path2453"
        fill="#cecece"
        stroke="none"
        d="M 695.25 173.160004 L 694.539978 173.160004 L 694.539978 174.48999 L 695.25 174.48999 L 695.25 173.160004 Z"
      />
      <path
        id="path2454"
        fill="#cecece"
        stroke="none"
        d="M 695.25 179.02002 L 694.539978 179.02002 L 694.539978 180.350006 L 695.25 180.350006 L 695.25 179.02002 Z"
      />
      <path
        id="path2455"
        fill="#cecece"
        stroke="none"
        d="M 695.25 180.970001 L 694.539978 180.970001 L 694.539978 182.299988 L 695.25 182.299988 L 695.25 180.970001 Z"
      />
      <path
        id="path2456"
        fill="#cecece"
        stroke="none"
        d="M 695.25 182.919983 L 694.539978 182.919983 L 694.539978 184.25 L 695.25 184.25 L 695.25 182.919983 Z"
      />
      <path
        id="path2457"
        fill="#cecece"
        stroke="none"
        d="M 695.25 186.820007 L 694.539978 186.820007 L 694.539978 188.149994 L 695.25 188.149994 L 695.25 186.820007 Z"
      />
      <path
        id="path2458"
        fill="#cecece"
        stroke="none"
        d="M 695.25 188.77002 L 694.539978 188.77002 L 694.539978 190.100006 L 695.25 190.100006 L 695.25 188.77002 Z"
      />
      <path
        id="path2459"
        fill="#cecece"
        stroke="none"
        d="M 695.25 190.720001 L 694.539978 190.720001 L 694.539978 192.049988 L 695.25 192.049988 L 695.25 190.720001 Z"
      />
      <path
        id="path2460"
        fill="#cecece"
        stroke="none"
        d="M 695.25 192.679993 L 694.539978 192.679993 L 694.539978 194.01001 L 695.25 194.01001 L 695.25 192.679993 Z"
      />
      <path
        id="path2461"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 149.580017 L 693.159973 149.580017 L 693.159973 150.910004 L 693.869995 150.910004 L 693.869995 149.580017 Z"
      />
      <path
        id="path2462"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 151.700012 L 693.159973 151.700012 L 693.159973 153.029999 L 693.869995 153.029999 L 693.869995 151.700012 Z"
      />
      <path
        id="path2463"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 153.649994 L 693.159973 153.649994 L 693.159973 154.97998 L 693.869995 154.97998 L 693.869995 153.649994 Z"
      />
      <path
        id="path2464"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 155.600006 L 693.159973 155.600006 L 693.159973 156.929993 L 693.869995 156.929993 L 693.869995 155.600006 Z"
      />
      <path
        id="path2465"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 159.5 L 693.159973 159.5 L 693.159973 160.830017 L 693.869995 160.830017 L 693.869995 159.5 Z"
      />
      <path
        id="path2466"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 161.450012 L 693.159973 161.450012 L 693.159973 162.779999 L 693.869995 162.779999 L 693.869995 161.450012 Z"
      />
      <path
        id="path2467"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 163.399994 L 693.159973 163.399994 L 693.159973 164.72998 L 693.869995 164.72998 L 693.869995 163.399994 Z"
      />
      <path
        id="path2468"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 165.359985 L 693.159973 165.359985 L 693.159973 166.690002 L 693.869995 166.690002 L 693.869995 165.359985 Z"
      />
      <path
        id="path2469"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 167.309998 L 693.159973 167.309998 L 693.159973 168.640015 L 693.869995 168.640015 L 693.869995 167.309998 Z"
      />
      <path
        id="path2470"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 169.26001 L 693.159973 169.26001 L 693.159973 170.589996 L 693.869995 170.589996 L 693.869995 169.26001 Z"
      />
      <path
        id="path2471"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 171.210022 L 693.159973 171.210022 L 693.159973 172.539978 L 693.869995 172.539978 L 693.869995 171.210022 Z"
      />
      <path
        id="path2472"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 173.160004 L 693.159973 173.160004 L 693.159973 174.48999 L 693.869995 174.48999 L 693.869995 173.160004 Z"
      />
      <path
        id="path2473"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 175.109985 L 693.159973 175.109985 L 693.159973 176.440002 L 693.869995 176.440002 L 693.869995 175.109985 Z"
      />
      <path
        id="path2474"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 177.059998 L 693.159973 177.059998 L 693.159973 178.390015 L 693.869995 178.390015 L 693.869995 177.059998 Z"
      />
      <path
        id="path2475"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 180.970001 L 693.159973 180.970001 L 693.159973 182.299988 L 693.869995 182.299988 L 693.869995 180.970001 Z"
      />
      <path
        id="path2476"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 182.919983 L 693.159973 182.919983 L 693.159973 184.25 L 693.869995 184.25 L 693.869995 182.919983 Z"
      />
      <path
        id="path2477"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 184.869995 L 693.159973 184.869995 L 693.159973 186.200012 L 693.869995 186.200012 L 693.869995 184.869995 Z"
      />
      <path
        id="path2478"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 186.820007 L 693.159973 186.820007 L 693.159973 188.149994 L 693.869995 188.149994 L 693.869995 186.820007 Z"
      />
      <path
        id="path2479"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 188.77002 L 693.159973 188.77002 L 693.159973 190.100006 L 693.869995 190.100006 L 693.869995 188.77002 Z"
      />
      <path
        id="path2480"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 149.580017 L 691.780029 149.580017 L 691.780029 150.910004 L 692.48999 150.910004 L 692.48999 149.580017 Z"
      />
      <path
        id="path2481"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 151.700012 L 691.780029 151.700012 L 691.780029 153.029999 L 692.48999 153.029999 L 692.48999 151.700012 Z"
      />
      <path
        id="path2482"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 153.649994 L 691.780029 153.649994 L 691.780029 154.97998 L 692.48999 154.97998 L 692.48999 153.649994 Z"
      />
      <path
        id="path2483"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 155.600006 L 691.780029 155.600006 L 691.780029 156.929993 L 692.48999 156.929993 L 692.48999 155.600006 Z"
      />
      <path
        id="path2484"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 157.549988 L 691.780029 157.549988 L 691.780029 158.880005 L 692.48999 158.880005 L 692.48999 157.549988 Z"
      />
      <path
        id="path2485"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 159.5 L 691.780029 159.5 L 691.780029 160.830017 L 692.48999 160.830017 L 692.48999 159.5 Z"
      />
      <path
        id="path2486"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 161.450012 L 691.780029 161.450012 L 691.780029 162.779999 L 692.48999 162.779999 L 692.48999 161.450012 Z"
      />
      <path
        id="path2487"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 163.399994 L 691.780029 163.399994 L 691.780029 164.72998 L 692.48999 164.72998 L 692.48999 163.399994 Z"
      />
      <path
        id="path2488"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 165.359985 L 691.780029 165.359985 L 691.780029 166.690002 L 692.48999 166.690002 L 692.48999 165.359985 Z"
      />
      <path
        id="path2489"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 171.210022 L 691.780029 171.210022 L 691.780029 172.539978 L 692.48999 172.539978 L 692.48999 171.210022 Z"
      />
      <path
        id="path2490"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 173.160004 L 691.780029 173.160004 L 691.780029 174.48999 L 692.48999 174.48999 L 692.48999 173.160004 Z"
      />
      <path
        id="path2491"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 175.109985 L 691.780029 175.109985 L 691.780029 176.440002 L 692.48999 176.440002 L 692.48999 175.109985 Z"
      />
      <path
        id="path2492"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 177.059998 L 691.780029 177.059998 L 691.780029 178.390015 L 692.48999 178.390015 L 692.48999 177.059998 Z"
      />
      <path
        id="path2493"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 179.02002 L 691.780029 179.02002 L 691.780029 180.350006 L 692.48999 180.350006 L 692.48999 179.02002 Z"
      />
      <path
        id="path2494"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 180.970001 L 691.780029 180.970001 L 691.780029 182.299988 L 692.48999 182.299988 L 692.48999 180.970001 Z"
      />
      <path
        id="path2495"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 184.869995 L 691.780029 184.869995 L 691.780029 186.200012 L 692.48999 186.200012 L 692.48999 184.869995 Z"
      />
      <path
        id="path2496"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 186.820007 L 691.780029 186.820007 L 691.780029 188.149994 L 692.48999 188.149994 L 692.48999 186.820007 Z"
      />
      <path
        id="path2497"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 188.77002 L 691.780029 188.77002 L 691.780029 190.100006 L 692.48999 190.100006 L 692.48999 188.77002 Z"
      />
      <path
        id="path2498"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 190.720001 L 691.780029 190.720001 L 691.780029 192.049988 L 692.48999 192.049988 L 692.48999 190.720001 Z"
      />
      <path
        id="path2499"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 192.679993 L 691.780029 192.679993 L 691.780029 194.01001 L 692.48999 194.01001 L 692.48999 192.679993 Z"
      />
      <path
        id="path2500"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 149.580017 L 690.390015 149.580017 L 690.390015 150.910004 L 691.099976 150.910004 L 691.099976 149.580017 Z"
      />
      <path
        id="path2501"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 151.700012 L 690.390015 151.700012 L 690.390015 153.029999 L 691.099976 153.029999 L 691.099976 151.700012 Z"
      />
      <path
        id="path2502"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 155.600006 L 690.390015 155.600006 L 690.390015 156.929993 L 691.099976 156.929993 L 691.099976 155.600006 Z"
      />
      <path
        id="path2503"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 157.549988 L 690.390015 157.549988 L 690.390015 158.880005 L 691.099976 158.880005 L 691.099976 157.549988 Z"
      />
      <path
        id="path2504"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 159.5 L 690.390015 159.5 L 690.390015 160.830017 L 691.099976 160.830017 L 691.099976 159.5 Z"
      />
      <path
        id="path2505"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 161.450012 L 690.390015 161.450012 L 690.390015 162.779999 L 691.099976 162.779999 L 691.099976 161.450012 Z"
      />
      <path
        id="path2506"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 163.399994 L 690.390015 163.399994 L 690.390015 164.72998 L 691.099976 164.72998 L 691.099976 163.399994 Z"
      />
      <path
        id="path2507"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 167.309998 L 690.390015 167.309998 L 690.390015 168.640015 L 691.099976 168.640015 L 691.099976 167.309998 Z"
      />
      <path
        id="path2508"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 169.26001 L 690.390015 169.26001 L 690.390015 170.589996 L 691.099976 170.589996 L 691.099976 169.26001 Z"
      />
      <path
        id="path2509"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 171.210022 L 690.390015 171.210022 L 690.390015 172.539978 L 691.099976 172.539978 L 691.099976 171.210022 Z"
      />
      <path
        id="path2510"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 175.109985 L 690.390015 175.109985 L 690.390015 176.440002 L 691.099976 176.440002 L 691.099976 175.109985 Z"
      />
      <path
        id="path2511"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 179.02002 L 690.390015 179.02002 L 690.390015 180.350006 L 691.099976 180.350006 L 691.099976 179.02002 Z"
      />
      <path
        id="path2512"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 180.970001 L 690.390015 180.970001 L 690.390015 182.299988 L 691.099976 182.299988 L 691.099976 180.970001 Z"
      />
      <path
        id="path2513"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 182.919983 L 690.390015 182.919983 L 690.390015 184.25 L 691.099976 184.25 L 691.099976 182.919983 Z"
      />
      <path
        id="path2514"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 194.630005 L 690.390015 194.630005 L 690.390015 195.960022 L 691.099976 195.960022 L 691.099976 194.630005 Z"
      />
      <path
        id="path2515"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 149.580017 L 689.01001 149.580017 L 689.01001 150.910004 L 689.719971 150.910004 L 689.719971 149.580017 Z"
      />
      <path
        id="path2516"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 151.700012 L 689.01001 151.700012 L 689.01001 153.029999 L 689.719971 153.029999 L 689.719971 151.700012 Z"
      />
      <path
        id="path2517"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 153.649994 L 689.01001 153.649994 L 689.01001 154.97998 L 689.719971 154.97998 L 689.719971 153.649994 Z"
      />
      <path
        id="path2518"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 155.600006 L 689.01001 155.600006 L 689.01001 156.929993 L 689.719971 156.929993 L 689.719971 155.600006 Z"
      />
      <path
        id="path2519"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 157.549988 L 689.01001 157.549988 L 689.01001 158.880005 L 689.719971 158.880005 L 689.719971 157.549988 Z"
      />
      <path
        id="path2520"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 159.5 L 689.01001 159.5 L 689.01001 160.830017 L 689.719971 160.830017 L 689.719971 159.5 Z"
      />
      <path
        id="path2521"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 163.399994 L 689.01001 163.399994 L 689.01001 164.72998 L 689.719971 164.72998 L 689.719971 163.399994 Z"
      />
      <path
        id="path2522"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 165.359985 L 689.01001 165.359985 L 689.01001 166.690002 L 689.719971 166.690002 L 689.719971 165.359985 Z"
      />
      <path
        id="path2523"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 167.309998 L 689.01001 167.309998 L 689.01001 168.640015 L 689.719971 168.640015 L 689.719971 167.309998 Z"
      />
      <path
        id="path2524"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 171.210022 L 689.01001 171.210022 L 689.01001 172.539978 L 689.719971 172.539978 L 689.719971 171.210022 Z"
      />
      <path
        id="path2525"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 173.160004 L 689.01001 173.160004 L 689.01001 174.48999 L 689.719971 174.48999 L 689.719971 173.160004 Z"
      />
      <path
        id="path2526"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 175.109985 L 689.01001 175.109985 L 689.01001 176.440002 L 689.719971 176.440002 L 689.719971 175.109985 Z"
      />
      <path
        id="path2527"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 177.059998 L 689.01001 177.059998 L 689.01001 178.390015 L 689.719971 178.390015 L 689.719971 177.059998 Z"
      />
      <path
        id="path2528"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 179.02002 L 689.01001 179.02002 L 689.01001 180.350006 L 689.719971 180.350006 L 689.719971 179.02002 Z"
      />
      <path
        id="path2529"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 182.919983 L 689.01001 182.919983 L 689.01001 184.25 L 689.719971 184.25 L 689.719971 182.919983 Z"
      />
      <path
        id="path2530"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 184.869995 L 689.01001 184.869995 L 689.01001 186.200012 L 689.719971 186.200012 L 689.719971 184.869995 Z"
      />
      <path
        id="path2531"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 186.820007 L 689.01001 186.820007 L 689.01001 188.149994 L 689.719971 188.149994 L 689.719971 186.820007 Z"
      />
      <path
        id="path2532"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 188.77002 L 689.01001 188.77002 L 689.01001 190.100006 L 689.719971 190.100006 L 689.719971 188.77002 Z"
      />
      <path
        id="path2533"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 190.720001 L 689.01001 190.720001 L 689.01001 192.049988 L 689.719971 192.049988 L 689.719971 190.720001 Z"
      />
      <path
        id="path2534"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 192.679993 L 689.01001 192.679993 L 689.01001 194.01001 L 689.719971 194.01001 L 689.719971 192.679993 Z"
      />
      <path
        id="path2535"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 149.580017 L 687.630005 149.580017 L 687.630005 150.910004 L 688.340027 150.910004 L 688.340027 149.580017 Z"
      />
      <path
        id="path2536"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 151.700012 L 687.630005 151.700012 L 687.630005 153.029999 L 688.340027 153.029999 L 688.340027 151.700012 Z"
      />
      <path
        id="path2537"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 153.649994 L 687.630005 153.649994 L 687.630005 154.97998 L 688.340027 154.97998 L 688.340027 153.649994 Z"
      />
      <path
        id="path2538"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 155.600006 L 687.630005 155.600006 L 687.630005 156.929993 L 688.340027 156.929993 L 688.340027 155.600006 Z"
      />
      <path
        id="path2539"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 157.549988 L 687.630005 157.549988 L 687.630005 158.880005 L 688.340027 158.880005 L 688.340027 157.549988 Z"
      />
      <path
        id="path2540"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 159.5 L 687.630005 159.5 L 687.630005 160.830017 L 688.340027 160.830017 L 688.340027 159.5 Z"
      />
      <path
        id="path2541"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 161.450012 L 687.630005 161.450012 L 687.630005 162.779999 L 688.340027 162.779999 L 688.340027 161.450012 Z"
      />
      <path
        id="path2542"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 163.399994 L 687.630005 163.399994 L 687.630005 164.72998 L 688.340027 164.72998 L 688.340027 163.399994 Z"
      />
      <path
        id="path2543"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 167.309998 L 687.630005 167.309998 L 687.630005 168.640015 L 688.340027 168.640015 L 688.340027 167.309998 Z"
      />
      <path
        id="path2544"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 169.26001 L 687.630005 169.26001 L 687.630005 170.589996 L 688.340027 170.589996 L 688.340027 169.26001 Z"
      />
      <path
        id="path2545"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 171.210022 L 687.630005 171.210022 L 687.630005 172.539978 L 688.340027 172.539978 L 688.340027 171.210022 Z"
      />
      <path
        id="path2546"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 173.160004 L 687.630005 173.160004 L 687.630005 174.48999 L 688.340027 174.48999 L 688.340027 173.160004 Z"
      />
      <path
        id="path2547"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 175.109985 L 687.630005 175.109985 L 687.630005 176.440002 L 688.340027 176.440002 L 688.340027 175.109985 Z"
      />
      <path
        id="path2548"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 177.059998 L 687.630005 177.059998 L 687.630005 178.390015 L 688.340027 178.390015 L 688.340027 177.059998 Z"
      />
      <path
        id="path2549"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 179.02002 L 687.630005 179.02002 L 687.630005 180.350006 L 688.340027 180.350006 L 688.340027 179.02002 Z"
      />
      <path
        id="path2550"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 180.970001 L 687.630005 180.970001 L 687.630005 182.299988 L 688.340027 182.299988 L 688.340027 180.970001 Z"
      />
      <path
        id="path2551"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 182.919983 L 687.630005 182.919983 L 687.630005 184.25 L 688.340027 184.25 L 688.340027 182.919983 Z"
      />
      <path
        id="path2552"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 184.869995 L 687.630005 184.869995 L 687.630005 186.200012 L 688.340027 186.200012 L 688.340027 184.869995 Z"
      />
      <path
        id="path2553"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 186.820007 L 687.630005 186.820007 L 687.630005 188.149994 L 688.340027 188.149994 L 688.340027 186.820007 Z"
      />
      <path
        id="path2554"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 188.77002 L 687.630005 188.77002 L 687.630005 190.100006 L 688.340027 190.100006 L 688.340027 188.77002 Z"
      />
      <path
        id="path2555"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 149.580017 L 686.25 149.580017 L 686.25 150.910004 L 686.960022 150.910004 L 686.960022 149.580017 Z"
      />
      <path
        id="path2556"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 151.700012 L 686.25 151.700012 L 686.25 153.029999 L 686.960022 153.029999 L 686.960022 151.700012 Z"
      />
      <path
        id="path2557"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 153.649994 L 686.25 153.649994 L 686.25 154.97998 L 686.960022 154.97998 L 686.960022 153.649994 Z"
      />
      <path
        id="path2558"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 155.600006 L 686.25 155.600006 L 686.25 156.929993 L 686.960022 156.929993 L 686.960022 155.600006 Z"
      />
      <path
        id="path2559"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 159.5 L 686.25 159.5 L 686.25 160.830017 L 686.960022 160.830017 L 686.960022 159.5 Z"
      />
      <path
        id="path2560"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 163.399994 L 686.25 163.399994 L 686.25 164.72998 L 686.960022 164.72998 L 686.960022 163.399994 Z"
      />
      <path
        id="path2561"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 165.359985 L 686.25 165.359985 L 686.25 166.690002 L 686.960022 166.690002 L 686.960022 165.359985 Z"
      />
      <path
        id="path2562"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 167.309998 L 686.25 167.309998 L 686.25 168.640015 L 686.960022 168.640015 L 686.960022 167.309998 Z"
      />
      <path
        id="path2563"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 169.26001 L 686.25 169.26001 L 686.25 170.589996 L 686.960022 170.589996 L 686.960022 169.26001 Z"
      />
      <path
        id="path2564"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 171.210022 L 686.25 171.210022 L 686.25 172.539978 L 686.960022 172.539978 L 686.960022 171.210022 Z"
      />
      <path
        id="path2565"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 177.059998 L 686.25 177.059998 L 686.25 178.390015 L 686.960022 178.390015 L 686.960022 177.059998 Z"
      />
      <path
        id="path2566"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 149.580017 L 684.869995 149.580017 L 684.869995 150.910004 L 685.580017 150.910004 L 685.580017 149.580017 Z"
      />
      <path
        id="path2567"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 151.700012 L 684.869995 151.700012 L 684.869995 153.029999 L 685.580017 153.029999 L 685.580017 151.700012 Z"
      />
      <path
        id="path2568"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 153.649994 L 684.869995 153.649994 L 684.869995 154.97998 L 685.580017 154.97998 L 685.580017 153.649994 Z"
      />
      <path
        id="path2569"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 155.600006 L 684.869995 155.600006 L 684.869995 156.929993 L 685.580017 156.929993 L 685.580017 155.600006 Z"
      />
      <path
        id="path2570"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 157.549988 L 684.869995 157.549988 L 684.869995 158.880005 L 685.580017 158.880005 L 685.580017 157.549988 Z"
      />
      <path
        id="path2571"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 159.5 L 684.869995 159.5 L 684.869995 160.830017 L 685.580017 160.830017 L 685.580017 159.5 Z"
      />
      <path
        id="path2572"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 161.450012 L 684.869995 161.450012 L 684.869995 162.779999 L 685.580017 162.779999 L 685.580017 161.450012 Z"
      />
      <path
        id="path2573"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 163.399994 L 684.869995 163.399994 L 684.869995 164.72998 L 685.580017 164.72998 L 685.580017 163.399994 Z"
      />
      <path
        id="path2574"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 165.359985 L 684.869995 165.359985 L 684.869995 166.690002 L 685.580017 166.690002 L 685.580017 165.359985 Z"
      />
      <path
        id="path2575"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 171.210022 L 684.869995 171.210022 L 684.869995 172.539978 L 685.580017 172.539978 L 685.580017 171.210022 Z"
      />
      <path
        id="path2576"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 173.160004 L 684.869995 173.160004 L 684.869995 174.48999 L 685.580017 174.48999 L 685.580017 173.160004 Z"
      />
      <path
        id="path2577"
        fill="#cecece"
        stroke="none"
        d="M 685.580017 175.109985 L 684.869995 175.109985 L 684.869995 176.440002 L 685.580017 176.440002 L 685.580017 175.109985 Z"
      />
      <path
        id="path2578"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 179.02002 L 686.22998 179.02002 L 686.22998 180.410004 L 686.969971 180.410004 L 686.969971 179.02002 Z"
      />
      <path
        id="path2579"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 185.160004 L 686.22998 185.160004 L 686.22998 186.549988 L 686.969971 186.549988 L 686.969971 185.160004 Z"
      />
      <path
        id="path2580"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 189.25 L 686.22998 189.25 L 686.22998 190.640015 L 686.969971 190.640015 L 686.969971 189.25 Z"
      />
      <path
        id="path2581"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 195.390015 L 686.22998 195.390015 L 686.22998 196.779999 L 686.969971 196.779999 L 686.969971 195.390015 Z"
      />
      <path
        id="path2582"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 145.169983 L 695.859985 145.169983 L 695.859985 148.950012 L 696.630005 148.950012 L 696.630005 145.169983 Z"
      />
      <path
        id="path2583"
        fill="#cecece"
        stroke="none"
        d="M 686.960022 145.169983 L 686.25 145.169983 L 686.25 148.950012 L 686.960022 148.950012 L 686.960022 145.169983 Z"
      />
      <path
        id="path2584"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 145.169983 L 687.630005 145.169983 L 687.630005 148.950012 L 688.340027 148.950012 L 688.340027 145.169983 Z"
      />
      <path
        id="path2585"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 145.169983 L 689.01001 145.169983 L 689.01001 148.950012 L 689.719971 148.950012 L 689.719971 145.169983 Z"
      />
      <path
        id="path2586"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 145.169983 L 690.390015 145.169983 L 690.390015 148.950012 L 691.099976 148.950012 L 691.099976 145.169983 Z"
      />
      <path
        id="path2587"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 145.169983 L 691.780029 145.169983 L 691.780029 148.950012 L 692.48999 148.950012 L 692.48999 145.169983 Z"
      />
      <path
        id="path2588"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 145.169983 L 693.159973 145.169983 L 693.159973 148.950012 L 693.869995 148.950012 L 693.869995 145.169983 Z"
      />
      <path
        id="path2589"
        fill="#cecece"
        stroke="none"
        d="M 695.25 145.169983 L 694.539978 145.169983 L 694.539978 148.950012 L 695.25 148.950012 L 695.25 145.169983 Z"
      />
      <path
        id="path2590"
        fill="#cecece"
        stroke="none"
        d="M 685.609985 145.169983 L 684.869995 145.169983 L 684.869995 148.950012 L 685.609985 148.950012 L 685.609985 145.169983 Z"
      />
      <path
        id="path2591"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 149.580017 L 683.609985 149.580017 L 683.609985 150.910004 L 684.320007 150.910004 L 684.320007 149.580017 Z"
      />
      <path
        id="path2592"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 151.700012 L 683.609985 151.700012 L 683.609985 153.029999 L 684.320007 153.029999 L 684.320007 151.700012 Z"
      />
      <path
        id="path2593"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 153.649994 L 683.609985 153.649994 L 683.609985 154.97998 L 684.320007 154.97998 L 684.320007 153.649994 Z"
      />
      <path
        id="path2594"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 155.600006 L 683.609985 155.600006 L 683.609985 156.929993 L 684.320007 156.929993 L 684.320007 155.600006 Z"
      />
      <path
        id="path2595"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 157.549988 L 683.609985 157.549988 L 683.609985 158.880005 L 684.320007 158.880005 L 684.320007 157.549988 Z"
      />
      <path
        id="path2596"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 159.5 L 683.609985 159.5 L 683.609985 160.830017 L 684.320007 160.830017 L 684.320007 159.5 Z"
      />
      <path
        id="path2597"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 161.450012 L 683.609985 161.450012 L 683.609985 162.779999 L 684.320007 162.779999 L 684.320007 161.450012 Z"
      />
      <path
        id="path2598"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 163.399994 L 683.609985 163.399994 L 683.609985 164.72998 L 684.320007 164.72998 L 684.320007 163.399994 Z"
      />
      <path
        id="path2599"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 167.309998 L 683.609985 167.309998 L 683.609985 168.640015 L 684.320007 168.640015 L 684.320007 167.309998 Z"
      />
      <path
        id="path2600"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 169.26001 L 683.609985 169.26001 L 683.609985 170.589996 L 684.320007 170.589996 L 684.320007 169.26001 Z"
      />
      <path
        id="path2601"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 171.210022 L 683.609985 171.210022 L 683.609985 172.539978 L 684.320007 172.539978 L 684.320007 171.210022 Z"
      />
      <path
        id="path2602"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 173.160004 L 683.609985 173.160004 L 683.609985 174.48999 L 684.320007 174.48999 L 684.320007 173.160004 Z"
      />
      <path
        id="path2603"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 175.109985 L 683.609985 175.109985 L 683.609985 176.440002 L 684.320007 176.440002 L 684.320007 175.109985 Z"
      />
      <path
        id="path2604"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 177.059998 L 683.609985 177.059998 L 683.609985 178.390015 L 684.320007 178.390015 L 684.320007 177.059998 Z"
      />
      <path
        id="path2605"
        fill="#cecece"
        stroke="none"
        d="M 695.25 194.700012 L 694.539978 194.700012 L 694.539978 196.029999 L 695.25 196.029999 L 695.25 194.700012 Z"
      />
      <path
        id="path2606"
        fill="#cecece"
        stroke="none"
        d="M 695.25 198.600006 L 694.539978 198.600006 L 694.539978 199.929993 L 695.25 199.929993 L 695.25 198.600006 Z"
      />
      <path
        id="path2607"
        fill="#cecece"
        stroke="none"
        d="M 695.25 204.450012 L 694.539978 204.450012 L 694.539978 205.779999 L 695.25 205.779999 L 695.25 204.450012 Z"
      />
      <path
        id="path2608"
        fill="#cecece"
        stroke="none"
        d="M 695.25 206.399994 L 694.539978 206.399994 L 694.539978 207.72998 L 695.25 207.72998 L 695.25 206.399994 Z"
      />
      <path
        id="path2609"
        fill="#cecece"
        stroke="none"
        d="M 695.25 208.359985 L 694.539978 208.359985 L 694.539978 209.690002 L 695.25 209.690002 L 695.25 208.359985 Z"
      />
      <path
        id="path2610"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 192.73999 L 693.159973 192.73999 L 693.159973 194.070007 L 693.869995 194.070007 L 693.869995 192.73999 Z"
      />
      <path
        id="path2611"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 196.649994 L 693.159973 196.649994 L 693.159973 197.97998 L 693.869995 197.97998 L 693.869995 196.649994 Z"
      />
      <path
        id="path2612"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 198.600006 L 693.159973 198.600006 L 693.159973 199.929993 L 693.869995 199.929993 L 693.869995 198.600006 Z"
      />
      <path
        id="path2613"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 200.549988 L 693.159973 200.549988 L 693.159973 201.880005 L 693.869995 201.880005 L 693.869995 200.549988 Z"
      />
      <path
        id="path2614"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 202.5 L 693.159973 202.5 L 693.159973 203.830017 L 693.869995 203.830017 L 693.869995 202.5 Z"
      />
      <path
        id="path2615"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 194.700012 L 691.780029 194.700012 L 691.780029 196.029999 L 692.48999 196.029999 L 692.48999 194.700012 Z"
      />
      <path
        id="path2616"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 200.549988 L 691.780029 200.549988 L 691.780029 201.880005 L 692.48999 201.880005 L 692.48999 200.549988 Z"
      />
      <path
        id="path2617"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 202.5 L 691.780029 202.5 L 691.780029 203.830017 L 692.48999 203.830017 L 692.48999 202.5 Z"
      />
      <path
        id="path2618"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 206.399994 L 691.780029 206.399994 L 691.780029 207.72998 L 692.48999 207.72998 L 692.48999 206.399994 Z"
      />
      <path
        id="path2619"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 208.359985 L 691.780029 208.359985 L 691.780029 209.690002 L 692.48999 209.690002 L 692.48999 208.359985 Z"
      />
      <path
        id="path2620"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 196.649994 L 690.390015 196.649994 L 690.390015 197.97998 L 691.099976 197.97998 L 691.099976 196.649994 Z"
      />
      <path
        id="path2621"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 198.600006 L 690.390015 198.600006 L 690.390015 199.929993 L 691.099976 199.929993 L 691.099976 198.600006 Z"
      />
      <path
        id="path2622"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 192.73999 L 689.01001 192.73999 L 689.01001 194.070007 L 689.719971 194.070007 L 689.719971 192.73999 Z"
      />
      <path
        id="path2623"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 198.600006 L 689.01001 198.600006 L 689.01001 199.929993 L 689.719971 199.929993 L 689.719971 198.600006 Z"
      />
      <path
        id="path2624"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 200.549988 L 689.01001 200.549988 L 689.01001 201.880005 L 689.719971 201.880005 L 689.719971 200.549988 Z"
      />
      <path
        id="path2625"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 202.5 L 689.01001 202.5 L 689.01001 203.830017 L 689.719971 203.830017 L 689.719971 202.5 Z"
      />
      <path
        id="path2626"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 204.450012 L 689.01001 204.450012 L 689.01001 205.779999 L 689.719971 205.779999 L 689.719971 204.450012 Z"
      />
      <path
        id="path2627"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 206.399994 L 689.01001 206.399994 L 689.01001 207.72998 L 689.719971 207.72998 L 689.719971 206.399994 Z"
      />
      <path
        id="path2628"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 208.359985 L 689.01001 208.359985 L 689.01001 209.690002 L 689.719971 209.690002 L 689.719971 208.359985 Z"
      />
      <path
        id="path2629"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 192.73999 L 687.630005 192.73999 L 687.630005 194.070007 L 688.340027 194.070007 L 688.340027 192.73999 Z"
      />
      <path
        id="path2630"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 194.700012 L 687.630005 194.700012 L 687.630005 196.029999 L 688.340027 196.029999 L 688.340027 194.700012 Z"
      />
      <path
        id="path2631"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 196.649994 L 687.630005 196.649994 L 687.630005 197.97998 L 688.340027 197.97998 L 688.340027 196.649994 Z"
      />
      <path
        id="path2632"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 200.549988 L 687.630005 200.549988 L 687.630005 201.880005 L 688.340027 201.880005 L 688.340027 200.549988 Z"
      />
      <path
        id="path2633"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 204.450012 L 687.630005 204.450012 L 687.630005 205.779999 L 688.340027 205.779999 L 688.340027 204.450012 Z"
      />
      <path
        id="path2634"
        fill="#cecece"
        stroke="none"
        d="M 695.25 210.350006 L 694.539978 210.350006 L 694.539978 211.679993 L 695.25 211.679993 L 695.25 210.350006 Z"
      />
      <path
        id="path2635"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 200.799988 L 695.919983 200.799988 L 695.919983 202.130005 L 696.630005 202.130005 L 696.630005 200.799988 Z"
      />
      <path
        id="path2636"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 202.75 L 695.919983 202.75 L 695.919983 204.080017 L 696.630005 204.080017 L 696.630005 202.75 Z"
      />
      <path
        id="path2637"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 212.609985 L 695.919983 212.609985 L 695.919983 213.940002 L 696.630005 213.940002 L 696.630005 212.609985 Z"
      />
      <path
        id="path2638"
        fill="#cecece"
        stroke="none"
        d="M 696.630005 206.690002 L 695.919983 206.690002 L 695.919983 208.02002 L 696.630005 208.02002 L 696.630005 206.690002 Z"
      />
      <path
        id="path2639"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 210.350006 L 691.780029 210.350006 L 691.780029 211.679993 L 692.48999 211.679993 L 692.48999 210.350006 Z"
      />
      <path
        id="path2640"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 210.350006 L 689.01001 210.350006 L 689.01001 211.679993 L 689.719971 211.679993 L 689.719971 210.350006 Z"
      />
      <path
        id="path2641"
        fill="#cecece"
        stroke="none"
        d="M 695.25 212.369995 L 694.539978 212.369995 L 694.539978 213.700012 L 695.25 213.700012 L 695.25 212.369995 Z"
      />
      <path
        id="path2642"
        fill="#cecece"
        stroke="none"
        d="M 695.25 216.27002 L 694.539978 216.27002 L 694.539978 217.600006 L 695.25 217.600006 L 695.25 216.27002 Z"
      />
      <path
        id="path2643"
        fill="#cecece"
        stroke="none"
        d="M 695.25 222.119995 L 694.539978 222.119995 L 694.539978 223.450012 L 695.25 223.450012 L 695.25 222.119995 Z"
      />
      <path
        id="path2644"
        fill="#cecece"
        stroke="none"
        d="M 695.25 224.080017 L 694.539978 224.080017 L 694.539978 225.410004 L 695.25 225.410004 L 695.25 224.080017 Z"
      />
      <path
        id="path2645"
        fill="#cecece"
        stroke="none"
        d="M 695.25 226.029999 L 694.539978 226.029999 L 694.539978 227.359985 L 695.25 227.359985 L 695.25 226.029999 Z"
      />
      <path
        id="path2646"
        fill="#cecece"
        stroke="none"
        d="M 695.25 233.799988 L 694.539978 233.799988 L 694.539978 235.130005 L 695.25 235.130005 L 695.25 233.799988 Z"
      />
      <path
        id="path2647"
        fill="#cecece"
        stroke="none"
        d="M 695.25 235.75 L 694.539978 235.75 L 694.539978 237.080002 L 695.25 237.080002 L 695.25 235.75 Z"
      />
      <path
        id="path2648"
        fill="#cecece"
        stroke="none"
        d="M 695.25 237.699997 L 694.539978 237.699997 L 694.539978 239.029999 L 695.25 239.029999 L 695.25 237.699997 Z"
      />
      <path
        id="path2649"
        fill="#cecece"
        stroke="none"
        d="M 695.25 239.649994 L 694.539978 239.649994 L 694.539978 240.979996 L 695.25 240.979996 L 695.25 239.649994 Z"
      />
      <path
        id="path2650"
        fill="#cecece"
        stroke="none"
        d="M 695.25 241.600006 L 694.539978 241.600006 L 694.539978 242.929993 L 695.25 242.929993 L 695.25 241.600006 Z"
      />
      <path
        id="path2651"
        fill="#cecece"
        stroke="none"
        d="M 695.25 243.559998 L 694.539978 243.559998 L 694.539978 244.889999 L 695.25 244.889999 L 695.25 243.559998 Z"
      />
      <path
        id="path2652"
        fill="#cecece"
        stroke="none"
        d="M 695.25 245.509995 L 694.539978 245.509995 L 694.539978 246.839996 L 695.25 246.839996 L 695.25 245.509995 Z"
      />
      <path
        id="path2653"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 233.830017 L 693.159973 233.830017 L 693.159973 235.160004 L 693.869995 235.160004 L 693.869995 233.830017 Z"
      />
      <path
        id="path2654"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 235.779999 L 693.159973 235.779999 L 693.159973 237.110001 L 693.869995 237.110001 L 693.869995 235.779999 Z"
      />
      <path
        id="path2655"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 237.740005 L 693.159973 237.740005 L 693.159973 239.070007 L 693.869995 239.070007 L 693.869995 237.740005 Z"
      />
      <path
        id="path2656"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 227.940002 L 689.01001 227.940002 L 689.01001 229.27002 L 689.719971 229.27002 L 689.719971 227.940002 Z"
      />
      <path
        id="path2657"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 231.850006 L 689.01001 231.850006 L 689.01001 233.179993 L 689.719971 233.179993 L 689.719971 231.850006 Z"
      />
      <path
        id="path2658"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 235.75 L 689.01001 235.75 L 689.01001 237.080002 L 689.719971 237.080002 L 689.719971 235.75 Z"
      />
      <path
        id="path2659"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 227.97998 L 687.630005 227.97998 L 687.630005 229.309998 L 688.340027 229.309998 L 688.340027 227.97998 Z"
      />
      <path
        id="path2660"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 210.410004 L 693.159973 210.410004 L 693.159973 211.73999 L 693.869995 211.73999 L 693.869995 210.410004 Z"
      />
      <path
        id="path2661"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 214.320007 L 693.159973 214.320007 L 693.159973 215.649994 L 693.869995 215.649994 L 693.869995 214.320007 Z"
      />
      <path
        id="path2662"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 216.27002 L 693.159973 216.27002 L 693.159973 217.600006 L 693.869995 217.600006 L 693.869995 216.27002 Z"
      />
      <path
        id="path2663"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 218.220001 L 693.159973 218.220001 L 693.159973 219.549988 L 693.869995 219.549988 L 693.869995 218.220001 Z"
      />
      <path
        id="path2664"
        fill="#cecece"
        stroke="none"
        d="M 693.869995 220.169983 L 693.159973 220.169983 L 693.159973 221.5 L 693.869995 221.5 L 693.869995 220.169983 Z"
      />
      <path
        id="path2665"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 212.369995 L 691.780029 212.369995 L 691.780029 213.700012 L 692.48999 213.700012 L 692.48999 212.369995 Z"
      />
      <path
        id="path2666"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 218.220001 L 691.780029 218.220001 L 691.780029 219.549988 L 692.48999 219.549988 L 692.48999 218.220001 Z"
      />
      <path
        id="path2667"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 220.169983 L 691.780029 220.169983 L 691.780029 221.5 L 692.48999 221.5 L 692.48999 220.169983 Z"
      />
      <path
        id="path2668"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 224.080017 L 691.780029 224.080017 L 691.780029 225.410004 L 692.48999 225.410004 L 692.48999 224.080017 Z"
      />
      <path
        id="path2669"
        fill="#cecece"
        stroke="none"
        d="M 692.48999 226.029999 L 691.780029 226.029999 L 691.780029 227.359985 L 692.48999 227.359985 L 692.48999 226.029999 Z"
      />
      <path
        id="path2670"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 214.320007 L 690.390015 214.320007 L 690.390015 215.649994 L 691.099976 215.649994 L 691.099976 214.320007 Z"
      />
      <path
        id="path2671"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 216.27002 L 690.390015 216.27002 L 690.390015 217.600006 L 691.099976 217.600006 L 691.099976 216.27002 Z"
      />
      <path
        id="path2672"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 224.080017 L 690.390015 224.080017 L 690.390015 225.410004 L 691.099976 225.410004 L 691.099976 224.080017 Z"
      />
      <path
        id="path2673"
        fill="#cecece"
        stroke="none"
        d="M 691.099976 227.97998 L 690.390015 227.97998 L 690.390015 229.309998 L 691.099976 229.309998 L 691.099976 227.97998 Z"
      />
      <path
        id="path2674"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 216.27002 L 689.01001 216.27002 L 689.01001 217.600006 L 689.719971 217.600006 L 689.719971 216.27002 Z"
      />
      <path
        id="path2675"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 218.220001 L 689.01001 218.220001 L 689.01001 219.549988 L 689.719971 219.549988 L 689.719971 218.220001 Z"
      />
      <path
        id="path2676"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 220.169983 L 689.01001 220.169983 L 689.01001 221.5 L 689.719971 221.5 L 689.719971 220.169983 Z"
      />
      <path
        id="path2677"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 222.119995 L 689.01001 222.119995 L 689.01001 223.450012 L 689.719971 223.450012 L 689.719971 222.119995 Z"
      />
      <path
        id="path2678"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 224.080017 L 689.01001 224.080017 L 689.01001 225.410004 L 689.719971 225.410004 L 689.719971 224.080017 Z"
      />
      <path
        id="path2679"
        fill="#cecece"
        stroke="none"
        d="M 689.719971 226.029999 L 689.01001 226.029999 L 689.01001 227.359985 L 689.719971 227.359985 L 689.719971 226.029999 Z"
      />
      <path
        id="path2680"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 210.410004 L 687.630005 210.410004 L 687.630005 211.73999 L 688.340027 211.73999 L 688.340027 210.410004 Z"
      />
      <path
        id="path2681"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 212.369995 L 687.630005 212.369995 L 687.630005 213.700012 L 688.340027 213.700012 L 688.340027 212.369995 Z"
      />
      <path
        id="path2682"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 214.320007 L 687.630005 214.320007 L 687.630005 215.649994 L 688.340027 215.649994 L 688.340027 214.320007 Z"
      />
      <path
        id="path2683"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 218.220001 L 687.630005 218.220001 L 687.630005 219.549988 L 688.340027 219.549988 L 688.340027 218.220001 Z"
      />
      <path
        id="path2684"
        fill="#cecece"
        stroke="none"
        d="M 688.340027 222.119995 L 687.630005 222.119995 L 687.630005 223.450012 L 688.340027 223.450012 L 688.340027 222.119995 Z"
      />
      <path
        id="path2685"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 195.460022 L 686.22998 195.460022 L 686.22998 196.850006 L 686.969971 196.850006 L 686.969971 195.460022 Z"
      />
      <path
        id="path2686"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 149.580017 L 682.22998 149.580017 L 682.22998 150.910004 L 682.940002 150.910004 L 682.940002 149.580017 Z"
      />
      <path
        id="path2687"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 151.700012 L 682.22998 151.700012 L 682.22998 153.029999 L 682.940002 153.029999 L 682.940002 151.700012 Z"
      />
      <path
        id="path2688"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 153.649994 L 682.22998 153.649994 L 682.22998 154.97998 L 682.940002 154.97998 L 682.940002 153.649994 Z"
      />
      <path
        id="path2689"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 155.600006 L 682.22998 155.600006 L 682.22998 156.929993 L 682.940002 156.929993 L 682.940002 155.600006 Z"
      />
      <path
        id="path2690"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 159.5 L 682.22998 159.5 L 682.22998 160.830017 L 682.940002 160.830017 L 682.940002 159.5 Z"
      />
      <path
        id="path2691"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 163.399994 L 682.22998 163.399994 L 682.22998 164.72998 L 682.940002 164.72998 L 682.940002 163.399994 Z"
      />
      <path
        id="path2692"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 165.359985 L 682.22998 165.359985 L 682.22998 166.690002 L 682.940002 166.690002 L 682.940002 165.359985 Z"
      />
      <path
        id="path2693"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 167.309998 L 682.22998 167.309998 L 682.22998 168.640015 L 682.940002 168.640015 L 682.940002 167.309998 Z"
      />
      <path
        id="path2694"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 169.26001 L 682.22998 169.26001 L 682.22998 170.589996 L 682.940002 170.589996 L 682.940002 169.26001 Z"
      />
      <path
        id="path2695"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 171.210022 L 682.22998 171.210022 L 682.22998 172.539978 L 682.940002 172.539978 L 682.940002 171.210022 Z"
      />
      <path
        id="path2696"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 177.059998 L 682.22998 177.059998 L 682.22998 178.390015 L 682.940002 178.390015 L 682.940002 177.059998 Z"
      />
      <path
        id="path2697"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 149.580017 L 680.849976 149.580017 L 680.849976 150.910004 L 681.559998 150.910004 L 681.559998 149.580017 Z"
      />
      <path
        id="path2698"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 151.700012 L 680.849976 151.700012 L 680.849976 153.029999 L 681.559998 153.029999 L 681.559998 151.700012 Z"
      />
      <path
        id="path2699"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 153.649994 L 680.849976 153.649994 L 680.849976 154.97998 L 681.559998 154.97998 L 681.559998 153.649994 Z"
      />
      <path
        id="path2700"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 155.600006 L 680.849976 155.600006 L 680.849976 156.929993 L 681.559998 156.929993 L 681.559998 155.600006 Z"
      />
      <path
        id="path2701"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 157.549988 L 680.849976 157.549988 L 680.849976 158.880005 L 681.559998 158.880005 L 681.559998 157.549988 Z"
      />
      <path
        id="path2702"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 159.5 L 680.849976 159.5 L 680.849976 160.830017 L 681.559998 160.830017 L 681.559998 159.5 Z"
      />
      <path
        id="path2703"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 161.450012 L 680.849976 161.450012 L 680.849976 162.779999 L 681.559998 162.779999 L 681.559998 161.450012 Z"
      />
      <path
        id="path2704"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 163.399994 L 680.849976 163.399994 L 680.849976 164.72998 L 681.559998 164.72998 L 681.559998 163.399994 Z"
      />
      <path
        id="path2705"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 165.359985 L 680.849976 165.359985 L 680.849976 166.690002 L 681.559998 166.690002 L 681.559998 165.359985 Z"
      />
      <path
        id="path2706"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 171.210022 L 680.849976 171.210022 L 680.849976 172.539978 L 681.559998 172.539978 L 681.559998 171.210022 Z"
      />
      <path
        id="path2707"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 173.160004 L 680.849976 173.160004 L 680.849976 174.48999 L 681.559998 174.48999 L 681.559998 173.160004 Z"
      />
      <path
        id="path2708"
        fill="#cecece"
        stroke="none"
        d="M 681.559998 175.109985 L 680.849976 175.109985 L 680.849976 176.440002 L 681.559998 176.440002 L 681.559998 175.109985 Z"
      />
      <path
        id="path2709"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 174.289978 L 500.649994 174.289978 L 500.649994 175.660004 L 502.290009 175.660004 L 502.290009 174.289978 Z"
      />
      <path
        id="path2710"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 176.47998 L 500.649994 176.47998 L 500.649994 177.850006 L 502.290009 177.850006 L 502.290009 176.47998 Z"
      />
      <path
        id="path2711"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 178.5 L 500.649994 178.5 L 500.649994 179.869995 L 502.290009 179.869995 L 502.290009 178.5 Z"
      />
      <path
        id="path2712"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 180.52002 L 500.649994 180.52002 L 500.649994 181.890015 L 502.290009 181.890015 L 502.290009 180.52002 Z"
      />
      <path
        id="path2713"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 182.539978 L 500.649994 182.539978 L 500.649994 183.910004 L 502.290009 183.910004 L 502.290009 182.539978 Z"
      />
      <path
        id="path2714"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 184.549988 L 500.649994 184.549988 L 500.649994 185.919983 L 502.290009 185.919983 L 502.290009 184.549988 Z"
      />
      <path
        id="path2715"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 186.570007 L 500.649994 186.570007 L 500.649994 187.940002 L 502.290009 187.940002 L 502.290009 186.570007 Z"
      />
      <path
        id="path2716"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 190.609985 L 500.649994 190.609985 L 500.649994 191.97998 L 502.290009 191.97998 L 502.290009 190.609985 Z"
      />
      <path
        id="path2717"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 192.630005 L 500.649994 192.630005 L 500.649994 194 L 502.290009 194 L 502.290009 192.630005 Z"
      />
      <path
        id="path2718"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 196.669983 L 500.649994 196.669983 L 500.649994 198.039978 L 502.290009 198.039978 L 502.290009 196.669983 Z"
      />
      <path
        id="path2719"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 198.690002 L 500.649994 198.690002 L 500.649994 200.059998 L 502.290009 200.059998 L 502.290009 198.690002 Z"
      />
      <path
        id="path2720"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 200.710022 L 500.649994 200.710022 L 500.649994 202.080017 L 502.290009 202.080017 L 502.290009 200.710022 Z"
      />
      <path
        id="path2721"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 202.720001 L 500.649994 202.720001 L 500.649994 204.089996 L 502.290009 204.089996 L 502.290009 202.720001 Z"
      />
      <path
        id="path2722"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 204.73999 L 500.649994 204.73999 L 500.649994 206.109985 L 502.290009 206.109985 L 502.290009 204.73999 Z"
      />
      <path
        id="path2723"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 206.76001 L 500.649994 206.76001 L 500.649994 208.130005 L 502.290009 208.130005 L 502.290009 206.76001 Z"
      />
      <path
        id="path2724"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 208.779999 L 500.649994 208.779999 L 500.649994 210.149994 L 502.290009 210.149994 L 502.290009 208.779999 Z"
      />
      <path
        id="path2725"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 210.799988 L 500.649994 210.799988 L 500.649994 212.169983 L 502.290009 212.169983 L 502.290009 210.799988 Z"
      />
      <path
        id="path2726"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 214.839996 L 500.649994 214.839996 L 500.649994 216.210022 L 502.290009 216.210022 L 502.290009 214.839996 Z"
      />
      <path
        id="path2727"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 218.880005 L 500.649994 218.880005 L 500.649994 220.25 L 502.290009 220.25 L 502.290009 218.880005 Z"
      />
      <path
        id="path2728"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 174.289978 L 497.440002 174.289978 L 497.440002 175.660004 L 499.079987 175.660004 L 499.079987 174.289978 Z"
      />
      <path
        id="path2729"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 176.47998 L 497.440002 176.47998 L 497.440002 177.850006 L 499.079987 177.850006 L 499.079987 176.47998 Z"
      />
      <path
        id="path2730"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 178.5 L 497.440002 178.5 L 497.440002 179.869995 L 499.079987 179.869995 L 499.079987 178.5 Z"
      />
      <path
        id="path2731"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 180.52002 L 497.440002 180.52002 L 497.440002 181.890015 L 499.079987 181.890015 L 499.079987 180.52002 Z"
      />
      <path
        id="path2732"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 182.539978 L 497.440002 182.539978 L 497.440002 183.910004 L 499.079987 183.910004 L 499.079987 182.539978 Z"
      />
      <path
        id="path2733"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 184.549988 L 497.440002 184.549988 L 497.440002 185.919983 L 499.079987 185.919983 L 499.079987 184.549988 Z"
      />
      <path
        id="path2734"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 186.570007 L 497.440002 186.570007 L 497.440002 187.940002 L 499.079987 187.940002 L 499.079987 186.570007 Z"
      />
      <path
        id="path2735"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 188.589996 L 497.440002 188.589996 L 497.440002 189.960022 L 499.079987 189.960022 L 499.079987 188.589996 Z"
      />
      <path
        id="path2736"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 190.609985 L 497.440002 190.609985 L 497.440002 191.97998 L 499.079987 191.97998 L 499.079987 190.609985 Z"
      />
      <path
        id="path2737"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 192.630005 L 497.440002 192.630005 L 497.440002 194 L 499.079987 194 L 499.079987 192.630005 Z"
      />
      <path
        id="path2738"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 194.649994 L 497.440002 194.649994 L 497.440002 196.02002 L 499.079987 196.02002 L 499.079987 194.649994 Z"
      />
      <path
        id="path2739"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 196.669983 L 497.440002 196.669983 L 497.440002 198.039978 L 499.079987 198.039978 L 499.079987 196.669983 Z"
      />
      <path
        id="path2740"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 198.690002 L 497.440002 198.690002 L 497.440002 200.059998 L 499.079987 200.059998 L 499.079987 198.690002 Z"
      />
      <path
        id="path2741"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 204.73999 L 497.440002 204.73999 L 497.440002 206.109985 L 499.079987 206.109985 L 499.079987 204.73999 Z"
      />
      <path
        id="path2742"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 206.76001 L 497.440002 206.76001 L 497.440002 208.130005 L 499.079987 208.130005 L 499.079987 206.76001 Z"
      />
      <path
        id="path2743"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 208.779999 L 497.440002 208.779999 L 497.440002 210.149994 L 499.079987 210.149994 L 499.079987 208.779999 Z"
      />
      <path
        id="path2744"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 212.820007 L 497.440002 212.820007 L 497.440002 214.190002 L 499.079987 214.190002 L 499.079987 212.820007 Z"
      />
      <path
        id="path2745"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 214.839996 L 497.440002 214.839996 L 497.440002 216.210022 L 499.079987 216.210022 L 499.079987 214.839996 Z"
      />
      <path
        id="path2746"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 216.859985 L 497.440002 216.859985 L 497.440002 218.22998 L 499.079987 218.22998 L 499.079987 216.859985 Z"
      />
      <path
        id="path2747"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 218.880005 L 497.440002 218.880005 L 497.440002 220.25 L 499.079987 220.25 L 499.079987 218.880005 Z"
      />
      <path
        id="path2748"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 174.289978 L 494.230011 174.289978 L 494.230011 175.660004 L 495.869995 175.660004 L 495.869995 174.289978 Z"
      />
      <path
        id="path2749"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 176.47998 L 494.230011 176.47998 L 494.230011 177.850006 L 495.869995 177.850006 L 495.869995 176.47998 Z"
      />
      <path
        id="path2750"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 178.5 L 494.230011 178.5 L 494.230011 179.869995 L 495.869995 179.869995 L 495.869995 178.5 Z"
      />
      <path
        id="path2751"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 180.52002 L 494.230011 180.52002 L 494.230011 181.890015 L 495.869995 181.890015 L 495.869995 180.52002 Z"
      />
      <path
        id="path2752"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 184.549988 L 494.230011 184.549988 L 494.230011 185.919983 L 495.869995 185.919983 L 495.869995 184.549988 Z"
      />
      <path
        id="path2753"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 186.570007 L 494.230011 186.570007 L 494.230011 187.940002 L 495.869995 187.940002 L 495.869995 186.570007 Z"
      />
      <path
        id="path2754"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 188.589996 L 494.230011 188.589996 L 494.230011 189.960022 L 495.869995 189.960022 L 495.869995 188.589996 Z"
      />
      <path
        id="path2755"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 190.609985 L 494.230011 190.609985 L 494.230011 191.97998 L 495.869995 191.97998 L 495.869995 190.609985 Z"
      />
      <path
        id="path2756"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 192.630005 L 494.230011 192.630005 L 494.230011 194 L 495.869995 194 L 495.869995 192.630005 Z"
      />
      <path
        id="path2757"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 194.649994 L 494.230011 194.649994 L 494.230011 196.02002 L 495.869995 196.02002 L 495.869995 194.649994 Z"
      />
      <path
        id="path2758"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 196.669983 L 494.230011 196.669983 L 494.230011 198.039978 L 495.869995 198.039978 L 495.869995 196.669983 Z"
      />
      <path
        id="path2759"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 198.690002 L 494.230011 198.690002 L 494.230011 200.059998 L 495.869995 200.059998 L 495.869995 198.690002 Z"
      />
      <path
        id="path2760"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 200.710022 L 494.230011 200.710022 L 494.230011 202.080017 L 495.869995 202.080017 L 495.869995 200.710022 Z"
      />
      <path
        id="path2761"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 202.720001 L 494.230011 202.720001 L 494.230011 204.089996 L 495.869995 204.089996 L 495.869995 202.720001 Z"
      />
      <path
        id="path2762"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 206.76001 L 494.230011 206.76001 L 494.230011 208.130005 L 495.869995 208.130005 L 495.869995 206.76001 Z"
      />
      <path
        id="path2763"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 208.779999 L 494.230011 208.779999 L 494.230011 210.149994 L 495.869995 210.149994 L 495.869995 208.779999 Z"
      />
      <path
        id="path2764"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 210.799988 L 494.230011 210.799988 L 494.230011 212.169983 L 495.869995 212.169983 L 495.869995 210.799988 Z"
      />
      <path
        id="path2765"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 212.820007 L 494.230011 212.820007 L 494.230011 214.190002 L 495.869995 214.190002 L 495.869995 212.820007 Z"
      />
      <path
        id="path2766"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 214.839996 L 494.230011 214.839996 L 494.230011 216.210022 L 495.869995 216.210022 L 495.869995 214.839996 Z"
      />
      <path
        id="path2767"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 174.289978 L 491.019989 174.289978 L 491.019989 175.660004 L 492.670013 175.660004 L 492.670013 174.289978 Z"
      />
      <path
        id="path2768"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 176.47998 L 491.019989 176.47998 L 491.019989 177.850006 L 492.670013 177.850006 L 492.670013 176.47998 Z"
      />
      <path
        id="path2769"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 178.5 L 491.019989 178.5 L 491.019989 179.869995 L 492.670013 179.869995 L 492.670013 178.5 Z"
      />
      <path
        id="path2770"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 180.52002 L 491.019989 180.52002 L 491.019989 181.890015 L 492.670013 181.890015 L 492.670013 180.52002 Z"
      />
      <path
        id="path2771"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 182.539978 L 491.019989 182.539978 L 491.019989 183.910004 L 492.670013 183.910004 L 492.670013 182.539978 Z"
      />
      <path
        id="path2772"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 184.549988 L 491.019989 184.549988 L 491.019989 185.919983 L 492.670013 185.919983 L 492.670013 184.549988 Z"
      />
      <path
        id="path2773"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 186.570007 L 491.019989 186.570007 L 491.019989 187.940002 L 492.670013 187.940002 L 492.670013 186.570007 Z"
      />
      <path
        id="path2774"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 188.589996 L 491.019989 188.589996 L 491.019989 189.960022 L 492.670013 189.960022 L 492.670013 188.589996 Z"
      />
      <path
        id="path2775"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 190.609985 L 491.019989 190.609985 L 491.019989 191.97998 L 492.670013 191.97998 L 492.670013 190.609985 Z"
      />
      <path
        id="path2776"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 196.669983 L 491.019989 196.669983 L 491.019989 198.039978 L 492.670013 198.039978 L 492.670013 196.669983 Z"
      />
      <path
        id="path2777"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 198.690002 L 491.019989 198.690002 L 491.019989 200.059998 L 492.670013 200.059998 L 492.670013 198.690002 Z"
      />
      <path
        id="path2778"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 200.710022 L 491.019989 200.710022 L 491.019989 202.080017 L 492.670013 202.080017 L 492.670013 200.710022 Z"
      />
      <path
        id="path2779"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 202.720001 L 491.019989 202.720001 L 491.019989 204.089996 L 492.670013 204.089996 L 492.670013 202.720001 Z"
      />
      <path
        id="path2780"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 204.73999 L 491.019989 204.73999 L 491.019989 206.109985 L 492.670013 206.109985 L 492.670013 204.73999 Z"
      />
      <path
        id="path2781"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 206.76001 L 491.019989 206.76001 L 491.019989 208.130005 L 492.670013 208.130005 L 492.670013 206.76001 Z"
      />
      <path
        id="path2782"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 210.799988 L 491.019989 210.799988 L 491.019989 212.169983 L 492.670013 212.169983 L 492.670013 210.799988 Z"
      />
      <path
        id="path2783"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 212.820007 L 491.019989 212.820007 L 491.019989 214.190002 L 492.670013 214.190002 L 492.670013 212.820007 Z"
      />
      <path
        id="path2784"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 214.839996 L 491.019989 214.839996 L 491.019989 216.210022 L 492.670013 216.210022 L 492.670013 214.839996 Z"
      />
      <path
        id="path2785"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 216.859985 L 491.019989 216.859985 L 491.019989 218.22998 L 492.670013 218.22998 L 492.670013 216.859985 Z"
      />
      <path
        id="path2786"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 218.880005 L 491.019989 218.880005 L 491.019989 220.25 L 492.670013 220.25 L 492.670013 218.880005 Z"
      />
      <path
        id="path2787"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 174.289978 L 487.809998 174.289978 L 487.809998 175.660004 L 489.459991 175.660004 L 489.459991 174.289978 Z"
      />
      <path
        id="path2788"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 176.47998 L 487.809998 176.47998 L 487.809998 177.850006 L 489.459991 177.850006 L 489.459991 176.47998 Z"
      />
      <path
        id="path2789"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 180.52002 L 487.809998 180.52002 L 487.809998 181.890015 L 489.459991 181.890015 L 489.459991 180.52002 Z"
      />
      <path
        id="path2790"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 182.539978 L 487.809998 182.539978 L 487.809998 183.910004 L 489.459991 183.910004 L 489.459991 182.539978 Z"
      />
      <path
        id="path2791"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 184.549988 L 487.809998 184.549988 L 487.809998 185.919983 L 489.459991 185.919983 L 489.459991 184.549988 Z"
      />
      <path
        id="path2792"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 186.570007 L 487.809998 186.570007 L 487.809998 187.940002 L 489.459991 187.940002 L 489.459991 186.570007 Z"
      />
      <path
        id="path2793"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 188.589996 L 487.809998 188.589996 L 487.809998 189.960022 L 489.459991 189.960022 L 489.459991 188.589996 Z"
      />
      <path
        id="path2794"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 192.630005 L 487.809998 192.630005 L 487.809998 194 L 489.459991 194 L 489.459991 192.630005 Z"
      />
      <path
        id="path2795"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 194.649994 L 487.809998 194.649994 L 487.809998 196.02002 L 489.459991 196.02002 L 489.459991 194.649994 Z"
      />
      <path
        id="path2796"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 196.669983 L 487.809998 196.669983 L 487.809998 198.039978 L 489.459991 198.039978 L 489.459991 196.669983 Z"
      />
      <path
        id="path2797"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 200.710022 L 487.809998 200.710022 L 487.809998 202.080017 L 489.459991 202.080017 L 489.459991 200.710022 Z"
      />
      <path
        id="path2798"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 204.73999 L 487.809998 204.73999 L 487.809998 206.109985 L 489.459991 206.109985 L 489.459991 204.73999 Z"
      />
      <path
        id="path2799"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 206.76001 L 487.809998 206.76001 L 487.809998 208.130005 L 489.459991 208.130005 L 489.459991 206.76001 Z"
      />
      <path
        id="path2800"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 208.779999 L 487.809998 208.779999 L 487.809998 210.149994 L 489.459991 210.149994 L 489.459991 208.779999 Z"
      />
      <path
        id="path2801"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 216.859985 L 487.809998 216.859985 L 487.809998 218.22998 L 489.459991 218.22998 L 489.459991 216.859985 Z"
      />
      <path
        id="path2802"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 220.890015 L 487.809998 220.890015 L 487.809998 222.26001 L 489.459991 222.26001 L 489.459991 220.890015 Z"
      />
      <path
        id="path2803"
        fill="#cecece"
        stroke="none"
        d="M 486.25 174.289978 L 484.600006 174.289978 L 484.600006 175.660004 L 486.25 175.660004 L 486.25 174.289978 Z"
      />
      <path
        id="path2804"
        fill="#cecece"
        stroke="none"
        d="M 486.25 176.47998 L 484.600006 176.47998 L 484.600006 177.850006 L 486.25 177.850006 L 486.25 176.47998 Z"
      />
      <path
        id="path2805"
        fill="#cecece"
        stroke="none"
        d="M 486.25 178.5 L 484.600006 178.5 L 484.600006 179.869995 L 486.25 179.869995 L 486.25 178.5 Z"
      />
      <path
        id="path2806"
        fill="#cecece"
        stroke="none"
        d="M 486.25 180.52002 L 484.600006 180.52002 L 484.600006 181.890015 L 486.25 181.890015 L 486.25 180.52002 Z"
      />
      <path
        id="path2807"
        fill="#cecece"
        stroke="none"
        d="M 486.25 182.539978 L 484.600006 182.539978 L 484.600006 183.910004 L 486.25 183.910004 L 486.25 182.539978 Z"
      />
      <path
        id="path2808"
        fill="#cecece"
        stroke="none"
        d="M 486.25 184.549988 L 484.600006 184.549988 L 484.600006 185.919983 L 486.25 185.919983 L 486.25 184.549988 Z"
      />
      <path
        id="path2809"
        fill="#cecece"
        stroke="none"
        d="M 486.25 188.589996 L 484.600006 188.589996 L 484.600006 189.960022 L 486.25 189.960022 L 486.25 188.589996 Z"
      />
      <path
        id="path2810"
        fill="#cecece"
        stroke="none"
        d="M 486.25 190.609985 L 484.600006 190.609985 L 484.600006 191.97998 L 486.25 191.97998 L 486.25 190.609985 Z"
      />
      <path
        id="path2811"
        fill="#cecece"
        stroke="none"
        d="M 486.25 192.630005 L 484.600006 192.630005 L 484.600006 194 L 486.25 194 L 486.25 192.630005 Z"
      />
      <path
        id="path2812"
        fill="#cecece"
        stroke="none"
        d="M 486.25 196.669983 L 484.600006 196.669983 L 484.600006 198.039978 L 486.25 198.039978 L 486.25 196.669983 Z"
      />
      <path
        id="path2813"
        fill="#cecece"
        stroke="none"
        d="M 486.25 198.690002 L 484.600006 198.690002 L 484.600006 200.059998 L 486.25 200.059998 L 486.25 198.690002 Z"
      />
      <path
        id="path2814"
        fill="#cecece"
        stroke="none"
        d="M 486.25 200.710022 L 484.600006 200.710022 L 484.600006 202.080017 L 486.25 202.080017 L 486.25 200.710022 Z"
      />
      <path
        id="path2815"
        fill="#cecece"
        stroke="none"
        d="M 486.25 202.720001 L 484.600006 202.720001 L 484.600006 204.089996 L 486.25 204.089996 L 486.25 202.720001 Z"
      />
      <path
        id="path2816"
        fill="#cecece"
        stroke="none"
        d="M 486.25 204.73999 L 484.600006 204.73999 L 484.600006 206.109985 L 486.25 206.109985 L 486.25 204.73999 Z"
      />
      <path
        id="path2817"
        fill="#cecece"
        stroke="none"
        d="M 486.25 208.779999 L 484.600006 208.779999 L 484.600006 210.149994 L 486.25 210.149994 L 486.25 208.779999 Z"
      />
      <path
        id="path2818"
        fill="#cecece"
        stroke="none"
        d="M 486.25 210.799988 L 484.600006 210.799988 L 484.600006 212.169983 L 486.25 212.169983 L 486.25 210.799988 Z"
      />
      <path
        id="path2819"
        fill="#cecece"
        stroke="none"
        d="M 486.25 212.820007 L 484.600006 212.820007 L 484.600006 214.190002 L 486.25 214.190002 L 486.25 212.820007 Z"
      />
      <path
        id="path2820"
        fill="#cecece"
        stroke="none"
        d="M 486.25 214.839996 L 484.600006 214.839996 L 484.600006 216.210022 L 486.25 216.210022 L 486.25 214.839996 Z"
      />
      <path
        id="path2821"
        fill="#cecece"
        stroke="none"
        d="M 486.25 216.859985 L 484.600006 216.859985 L 484.600006 218.22998 L 486.25 218.22998 L 486.25 216.859985 Z"
      />
      <path
        id="path2822"
        fill="#cecece"
        stroke="none"
        d="M 486.25 218.880005 L 484.600006 218.880005 L 484.600006 220.25 L 486.25 220.25 L 486.25 218.880005 Z"
      />
      <path
        id="path2823"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 174.289978 L 481.390015 174.289978 L 481.390015 175.660004 L 483.029999 175.660004 L 483.029999 174.289978 Z"
      />
      <path
        id="path2824"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 176.47998 L 481.390015 176.47998 L 481.390015 177.850006 L 483.029999 177.850006 L 483.029999 176.47998 Z"
      />
      <path
        id="path2825"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 178.5 L 481.390015 178.5 L 481.390015 179.869995 L 483.029999 179.869995 L 483.029999 178.5 Z"
      />
      <path
        id="path2826"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 180.52002 L 481.390015 180.52002 L 481.390015 181.890015 L 483.029999 181.890015 L 483.029999 180.52002 Z"
      />
      <path
        id="path2827"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 182.539978 L 481.390015 182.539978 L 481.390015 183.910004 L 483.029999 183.910004 L 483.029999 182.539978 Z"
      />
      <path
        id="path2828"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 184.549988 L 481.390015 184.549988 L 481.390015 185.919983 L 483.029999 185.919983 L 483.029999 184.549988 Z"
      />
      <path
        id="path2829"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 186.570007 L 481.390015 186.570007 L 481.390015 187.940002 L 483.029999 187.940002 L 483.029999 186.570007 Z"
      />
      <path
        id="path2830"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 188.589996 L 481.390015 188.589996 L 481.390015 189.960022 L 483.029999 189.960022 L 483.029999 188.589996 Z"
      />
      <path
        id="path2831"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 192.630005 L 481.390015 192.630005 L 481.390015 194 L 483.029999 194 L 483.029999 192.630005 Z"
      />
      <path
        id="path2832"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 194.649994 L 481.390015 194.649994 L 481.390015 196.02002 L 483.029999 196.02002 L 483.029999 194.649994 Z"
      />
      <path
        id="path2833"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 196.669983 L 481.390015 196.669983 L 481.390015 198.039978 L 483.029999 198.039978 L 483.029999 196.669983 Z"
      />
      <path
        id="path2834"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 198.690002 L 481.390015 198.690002 L 481.390015 200.059998 L 483.029999 200.059998 L 483.029999 198.690002 Z"
      />
      <path
        id="path2835"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 200.710022 L 481.390015 200.710022 L 481.390015 202.080017 L 483.029999 202.080017 L 483.029999 200.710022 Z"
      />
      <path
        id="path2836"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 202.720001 L 481.390015 202.720001 L 481.390015 204.089996 L 483.029999 204.089996 L 483.029999 202.720001 Z"
      />
      <path
        id="path2837"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 204.73999 L 481.390015 204.73999 L 481.390015 206.109985 L 483.029999 206.109985 L 483.029999 204.73999 Z"
      />
      <path
        id="path2838"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 206.76001 L 481.390015 206.76001 L 481.390015 208.130005 L 483.029999 208.130005 L 483.029999 206.76001 Z"
      />
      <path
        id="path2839"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 208.779999 L 481.390015 208.779999 L 481.390015 210.149994 L 483.029999 210.149994 L 483.029999 208.779999 Z"
      />
      <path
        id="path2840"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 210.799988 L 481.390015 210.799988 L 481.390015 212.169983 L 483.029999 212.169983 L 483.029999 210.799988 Z"
      />
      <path
        id="path2841"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 212.820007 L 481.390015 212.820007 L 481.390015 214.190002 L 483.029999 214.190002 L 483.029999 212.820007 Z"
      />
      <path
        id="path2842"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 214.839996 L 481.390015 214.839996 L 481.390015 216.210022 L 483.029999 216.210022 L 483.029999 214.839996 Z"
      />
      <path
        id="path2843"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 174.289978 L 478.179993 174.289978 L 478.179993 175.660004 L 479.829987 175.660004 L 479.829987 174.289978 Z"
      />
      <path
        id="path2844"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 176.47998 L 478.179993 176.47998 L 478.179993 177.850006 L 479.829987 177.850006 L 479.829987 176.47998 Z"
      />
      <path
        id="path2845"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 178.5 L 478.179993 178.5 L 478.179993 179.869995 L 479.829987 179.869995 L 479.829987 178.5 Z"
      />
      <path
        id="path2846"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 180.52002 L 478.179993 180.52002 L 478.179993 181.890015 L 479.829987 181.890015 L 479.829987 180.52002 Z"
      />
      <path
        id="path2847"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 184.549988 L 478.179993 184.549988 L 478.179993 185.919983 L 479.829987 185.919983 L 479.829987 184.549988 Z"
      />
      <path
        id="path2848"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 188.589996 L 478.179993 188.589996 L 478.179993 189.960022 L 479.829987 189.960022 L 479.829987 188.589996 Z"
      />
      <path
        id="path2849"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 190.609985 L 478.179993 190.609985 L 478.179993 191.97998 L 479.829987 191.97998 L 479.829987 190.609985 Z"
      />
      <path
        id="path2850"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 192.630005 L 478.179993 192.630005 L 478.179993 194 L 479.829987 194 L 479.829987 192.630005 Z"
      />
      <path
        id="path2851"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 194.649994 L 478.179993 194.649994 L 478.179993 196.02002 L 479.829987 196.02002 L 479.829987 194.649994 Z"
      />
      <path
        id="path2852"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 196.669983 L 478.179993 196.669983 L 478.179993 198.039978 L 479.829987 198.039978 L 479.829987 196.669983 Z"
      />
      <path
        id="path2853"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 202.720001 L 478.179993 202.720001 L 478.179993 204.089996 L 479.829987 204.089996 L 479.829987 202.720001 Z"
      />
      <path
        id="path2854"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 204.73999 L 478.179993 204.73999 L 478.179993 206.109985 L 479.829987 206.109985 L 479.829987 204.73999 Z"
      />
      <path
        id="path2855"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 206.76001 L 478.179993 206.76001 L 478.179993 208.130005 L 479.829987 208.130005 L 479.829987 206.76001 Z"
      />
      <path
        id="path2856"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 208.779999 L 478.179993 208.779999 L 478.179993 210.149994 L 479.829987 210.149994 L 479.829987 208.779999 Z"
      />
      <path
        id="path2857"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 214.839996 L 478.179993 214.839996 L 478.179993 216.210022 L 479.829987 216.210022 L 479.829987 214.839996 Z"
      />
      <path
        id="path2858"
        fill="#cecece"
        stroke="none"
        d="M 479.829987 216.859985 L 478.179993 216.859985 L 478.179993 218.22998 L 479.829987 218.22998 L 479.829987 216.859985 Z"
      />
      <path
        id="path2859"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 220.970001 L 497.440002 220.970001 L 497.440002 222.339996 L 499.079987 222.339996 L 499.079987 220.970001 Z"
      />
      <path
        id="path2860"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 225 L 497.440002 225 L 497.440002 226.369995 L 499.079987 226.369995 L 499.079987 225 Z"
      />
      <path
        id="path2861"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 218.950012 L 494.230011 218.950012 L 494.230011 220.320007 L 495.869995 220.320007 L 495.869995 218.950012 Z"
      />
      <path
        id="path2862"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 222.97998 L 494.230011 222.97998 L 494.230011 224.350006 L 495.869995 224.350006 L 495.869995 222.97998 Z"
      />
      <path
        id="path2863"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 225 L 494.230011 225 L 494.230011 226.369995 L 495.869995 226.369995 L 495.869995 225 Z"
      />
      <path
        id="path2864"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 227.02002 L 494.230011 227.02002 L 494.230011 228.390015 L 495.869995 228.390015 L 495.869995 227.02002 Z"
      />
      <path
        id="path2865"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 229.039978 L 494.230011 229.039978 L 494.230011 230.410004 L 495.869995 230.410004 L 495.869995 229.039978 Z"
      />
      <path
        id="path2866"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 220.970001 L 491.019989 220.970001 L 491.019989 222.339996 L 492.670013 222.339996 L 492.670013 220.970001 Z"
      />
      <path
        id="path2867"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 227.02002 L 491.019989 227.02002 L 491.019989 228.390015 L 492.670013 228.390015 L 492.670013 227.02002 Z"
      />
      <path
        id="path2868"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 229.039978 L 491.019989 229.039978 L 491.019989 230.410004 L 492.670013 230.410004 L 492.670013 229.039978 Z"
      />
      <path
        id="path2869"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 222.97998 L 487.809998 222.97998 L 487.809998 224.350006 L 489.459991 224.350006 L 489.459991 222.97998 Z"
      />
      <path
        id="path2870"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 225 L 487.809998 225 L 487.809998 226.369995 L 489.459991 226.369995 L 489.459991 225 Z"
      />
      <path
        id="path2871"
        fill="#cecece"
        stroke="none"
        d="M 486.25 218.950012 L 484.600006 218.950012 L 484.600006 220.320007 L 486.25 220.320007 L 486.25 218.950012 Z"
      />
      <path
        id="path2872"
        fill="#cecece"
        stroke="none"
        d="M 486.25 225 L 484.600006 225 L 484.600006 226.369995 L 486.25 226.369995 L 486.25 225 Z"
      />
      <path
        id="path2873"
        fill="#cecece"
        stroke="none"
        d="M 486.25 227.02002 L 484.600006 227.02002 L 484.600006 228.390015 L 486.25 228.390015 L 486.25 227.02002 Z"
      />
      <path
        id="path2874"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 218.950012 L 481.390015 218.950012 L 481.390015 220.320007 L 483.029999 220.320007 L 483.029999 218.950012 Z"
      />
      <path
        id="path2875"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 220.970001 L 481.390015 220.970001 L 481.390015 222.339996 L 483.029999 222.339996 L 483.029999 220.970001 Z"
      />
      <path
        id="path2876"
        fill="#cecece"
        stroke="none"
        d="M 483.029999 227.02002 L 481.390015 227.02002 L 481.390015 228.390015 L 483.029999 228.390015 L 483.029999 227.02002 Z"
      />
      <path
        id="path2877"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 227.27002 L 500.649994 227.27002 L 500.649994 228.640015 L 502.290009 228.640015 L 502.290009 227.27002 Z"
      />
      <path
        id="path2878"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 229.289978 L 500.649994 229.289978 L 500.649994 230.660004 L 502.290009 230.660004 L 502.290009 229.289978 Z"
      />
      <path
        id="path2879"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 182.660004 L 657.080017 182.660004 L 657.080017 184.100006 L 658.799988 184.100006 L 658.799988 182.660004 Z"
      />
      <path
        id="path2880"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 184.779999 L 657.080017 184.779999 L 657.080017 186.220001 L 658.799988 186.220001 L 658.799988 184.779999 Z"
      />
      <path
        id="path2881"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 189.01001 L 657.080017 189.01001 L 657.080017 190.450012 L 658.799988 190.450012 L 658.799988 189.01001 Z"
      />
      <path
        id="path2882"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 191.130005 L 657.080017 191.130005 L 657.080017 192.570007 L 658.799988 192.570007 L 658.799988 191.130005 Z"
      />
      <path
        id="path2883"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 193.25 L 657.080017 193.25 L 657.080017 194.690002 L 658.799988 194.690002 L 658.799988 193.25 Z"
      />
      <path
        id="path2884"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 195.359985 L 657.080017 195.359985 L 657.080017 196.799988 L 658.799988 196.799988 L 658.799988 195.359985 Z"
      />
      <path
        id="path2885"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 197.47998 L 657.080017 197.47998 L 657.080017 198.919983 L 658.799988 198.919983 L 658.799988 197.47998 Z"
      />
      <path
        id="path2886"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 199.600006 L 657.080017 199.600006 L 657.080017 201.039978 L 658.799988 201.039978 L 658.799988 199.600006 Z"
      />
      <path
        id="path2887"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 201.720001 L 657.080017 201.720001 L 657.080017 203.160004 L 658.799988 203.160004 L 658.799988 201.720001 Z"
      />
      <path
        id="path2888"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 203.830017 L 657.080017 203.830017 L 657.080017 205.27002 L 658.799988 205.27002 L 658.799988 203.830017 Z"
      />
      <path
        id="path2889"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 208.070007 L 657.080017 208.070007 L 657.080017 209.51001 L 658.799988 209.51001 L 658.799988 208.070007 Z"
      />
      <path
        id="path2890"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 212.309998 L 657.080017 212.309998 L 657.080017 213.75 L 658.799988 213.75 L 658.799988 212.309998 Z"
      />
      <path
        id="path2891"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 182.660004 L 659.880005 182.660004 L 659.880005 184.100006 L 661.599976 184.100006 L 661.599976 182.660004 Z"
      />
      <path
        id="path2892"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 184.779999 L 659.880005 184.779999 L 659.880005 186.220001 L 661.599976 186.220001 L 661.599976 184.779999 Z"
      />
      <path
        id="path2893"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 186.890015 L 659.880005 186.890015 L 659.880005 188.330017 L 661.599976 188.330017 L 661.599976 186.890015 Z"
      />
      <path
        id="path2894"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 189.01001 L 659.880005 189.01001 L 659.880005 190.450012 L 661.599976 190.450012 L 661.599976 189.01001 Z"
      />
      <path
        id="path2895"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 191.130005 L 659.880005 191.130005 L 659.880005 192.570007 L 661.599976 192.570007 L 661.599976 191.130005 Z"
      />
      <path
        id="path2896"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 197.47998 L 659.880005 197.47998 L 659.880005 198.919983 L 661.599976 198.919983 L 661.599976 197.47998 Z"
      />
      <path
        id="path2897"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 199.600006 L 659.880005 199.600006 L 659.880005 201.039978 L 661.599976 201.039978 L 661.599976 199.600006 Z"
      />
      <path
        id="path2898"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 201.720001 L 659.880005 201.720001 L 659.880005 203.160004 L 661.599976 203.160004 L 661.599976 201.720001 Z"
      />
      <path
        id="path2899"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 205.950012 L 659.880005 205.950012 L 659.880005 207.390015 L 661.599976 207.390015 L 661.599976 205.950012 Z"
      />
      <path
        id="path2900"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 208.070007 L 659.880005 208.070007 L 659.880005 209.51001 L 661.599976 209.51001 L 661.599976 208.070007 Z"
      />
      <path
        id="path2901"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 210.190002 L 659.880005 210.190002 L 659.880005 211.630005 L 661.599976 211.630005 L 661.599976 210.190002 Z"
      />
      <path
        id="path2902"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 212.309998 L 659.880005 212.309998 L 659.880005 213.75 L 661.599976 213.75 L 661.599976 212.309998 Z"
      />
      <path
        id="path2903"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 182.660004 L 662.679993 182.660004 L 662.679993 184.100006 L 664.400024 184.100006 L 664.400024 182.660004 Z"
      />
      <path
        id="path2904"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 184.779999 L 662.679993 184.779999 L 662.679993 186.220001 L 664.400024 186.220001 L 664.400024 184.779999 Z"
      />
      <path
        id="path2905"
        fill="#cecece"
        stroke="none"
        d="M 667.119995 184.779999 L 665.400024 184.779999 L 665.400024 186.220001 L 667.119995 186.220001 L 667.119995 184.779999 Z"
      />
      <path
        id="path2906"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 186.890015 L 662.679993 186.890015 L 662.679993 188.330017 L 664.400024 188.330017 L 664.400024 186.890015 Z"
      />
      <path
        id="path2907"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 189.01001 L 662.679993 189.01001 L 662.679993 190.450012 L 664.400024 190.450012 L 664.400024 189.01001 Z"
      />
      <path
        id="path2908"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 191.130005 L 662.679993 191.130005 L 662.679993 192.570007 L 664.400024 192.570007 L 664.400024 191.130005 Z"
      />
      <path
        id="path2909"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 195.359985 L 662.679993 195.359985 L 662.679993 196.799988 L 664.400024 196.799988 L 664.400024 195.359985 Z"
      />
      <path
        id="path2910"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 199.600006 L 662.679993 199.600006 L 662.679993 201.039978 L 664.400024 201.039978 L 664.400024 199.600006 Z"
      />
      <path
        id="path2911"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 201.720001 L 662.679993 201.720001 L 662.679993 203.160004 L 664.400024 203.160004 L 664.400024 201.720001 Z"
      />
      <path
        id="path2912"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 203.830017 L 662.679993 203.830017 L 662.679993 205.27002 L 664.400024 205.27002 L 664.400024 203.830017 Z"
      />
      <path
        id="path2913"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 205.950012 L 662.679993 205.950012 L 662.679993 207.390015 L 664.400024 207.390015 L 664.400024 205.950012 Z"
      />
      <path
        id="path2914"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 208.070007 L 662.679993 208.070007 L 662.679993 209.51001 L 664.400024 209.51001 L 664.400024 208.070007 Z"
      />
      <path
        id="path2915"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 182.660004 L 665.47998 182.660004 L 665.47998 184.100006 L 667.210022 184.100006 L 667.210022 182.660004 Z"
      />
      <path
        id="path2916"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 189.01001 L 665.47998 189.01001 L 665.47998 190.450012 L 667.210022 190.450012 L 667.210022 189.01001 Z"
      />
      <path
        id="path2917"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 191.130005 L 665.47998 191.130005 L 665.47998 192.570007 L 667.210022 192.570007 L 667.210022 191.130005 Z"
      />
      <path
        id="path2918"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 193.25 L 665.47998 193.25 L 665.47998 194.690002 L 667.210022 194.690002 L 667.210022 193.25 Z"
      />
      <path
        id="path2919"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 195.359985 L 665.47998 195.359985 L 665.47998 196.799988 L 667.210022 196.799988 L 667.210022 195.359985 Z"
      />
      <path
        id="path2920"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 197.47998 L 665.47998 197.47998 L 665.47998 198.919983 L 667.210022 198.919983 L 667.210022 197.47998 Z"
      />
      <path
        id="path2921"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 199.600006 L 665.47998 199.600006 L 665.47998 201.039978 L 667.210022 201.039978 L 667.210022 199.600006 Z"
      />
      <path
        id="path2922"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 203.830017 L 665.47998 203.830017 L 665.47998 205.27002 L 667.210022 205.27002 L 667.210022 203.830017 Z"
      />
      <path
        id="path2923"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 205.950012 L 665.47998 205.950012 L 665.47998 207.390015 L 667.210022 207.390015 L 667.210022 205.950012 Z"
      />
      <path
        id="path2924"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 208.070007 L 665.47998 208.070007 L 665.47998 209.51001 L 667.210022 209.51001 L 667.210022 208.070007 Z"
      />
      <path
        id="path2925"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 210.190002 L 665.47998 210.190002 L 665.47998 211.630005 L 667.210022 211.630005 L 667.210022 210.190002 Z"
      />
      <path
        id="path2926"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 212.309998 L 665.47998 212.309998 L 665.47998 213.75 L 667.210022 213.75 L 667.210022 212.309998 Z"
      />
      <path
        id="path2927"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 184.779999 L 668.280029 184.779999 L 668.280029 186.220001 L 670.01001 186.220001 L 670.01001 184.779999 Z"
      />
      <path
        id="path2928"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 186.890015 L 668.280029 186.890015 L 668.280029 188.330017 L 670.01001 188.330017 L 670.01001 186.890015 Z"
      />
      <path
        id="path2929"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 189.01001 L 668.280029 189.01001 L 668.280029 190.450012 L 670.01001 190.450012 L 670.01001 189.01001 Z"
      />
      <path
        id="path2930"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 193.25 L 668.280029 193.25 L 668.280029 194.690002 L 670.01001 194.690002 L 670.01001 193.25 Z"
      />
      <path
        id="path2931"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 197.47998 L 668.280029 197.47998 L 668.280029 198.919983 L 670.01001 198.919983 L 670.01001 197.47998 Z"
      />
      <path
        id="path2932"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 199.600006 L 668.280029 199.600006 L 668.280029 201.039978 L 670.01001 201.039978 L 670.01001 199.600006 Z"
      />
      <path
        id="path2933"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 201.720001 L 668.280029 201.720001 L 668.280029 203.160004 L 670.01001 203.160004 L 670.01001 201.720001 Z"
      />
      <path
        id="path2934"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 210.190002 L 668.280029 210.190002 L 668.280029 211.630005 L 670.01001 211.630005 L 670.01001 210.190002 Z"
      />
      <path
        id="path2935"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 214.419983 L 668.280029 214.419983 L 668.280029 215.859985 L 670.01001 215.859985 L 670.01001 214.419983 Z"
      />
      <path
        id="path2936"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 184.779999 L 673.869995 184.779999 L 673.869995 186.220001 L 675.590027 186.220001 L 675.590027 184.779999 Z"
      />
      <path
        id="path2937"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 186.890015 L 673.869995 186.890015 L 673.869995 188.330017 L 675.590027 188.330017 L 675.590027 186.890015 Z"
      />
      <path
        id="path2938"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 189.01001 L 673.869995 189.01001 L 673.869995 190.450012 L 675.590027 190.450012 L 675.590027 189.01001 Z"
      />
      <path
        id="path2939"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 191.130005 L 673.869995 191.130005 L 673.869995 192.570007 L 675.590027 192.570007 L 675.590027 191.130005 Z"
      />
      <path
        id="path2940"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 193.25 L 673.869995 193.25 L 673.869995 194.690002 L 675.590027 194.690002 L 675.590027 193.25 Z"
      />
      <path
        id="path2941"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 195.359985 L 673.869995 195.359985 L 673.869995 196.799988 L 675.590027 196.799988 L 675.590027 195.359985 Z"
      />
      <path
        id="path2942"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 197.47998 L 673.869995 197.47998 L 673.869995 198.919983 L 675.590027 198.919983 L 675.590027 197.47998 Z"
      />
      <path
        id="path2943"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 199.600006 L 673.869995 199.600006 L 673.869995 201.039978 L 675.590027 201.039978 L 675.590027 199.600006 Z"
      />
      <path
        id="path2944"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 201.720001 L 673.869995 201.720001 L 673.869995 203.160004 L 675.590027 203.160004 L 675.590027 201.720001 Z"
      />
      <path
        id="path2945"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 203.830017 L 673.869995 203.830017 L 673.869995 205.27002 L 675.590027 205.27002 L 675.590027 203.830017 Z"
      />
      <path
        id="path2946"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 205.950012 L 673.869995 205.950012 L 673.869995 207.390015 L 675.590027 207.390015 L 675.590027 205.950012 Z"
      />
      <path
        id="path2947"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 208.070007 L 673.869995 208.070007 L 673.869995 209.51001 L 675.590027 209.51001 L 675.590027 208.070007 Z"
      />
      <path
        id="path2948"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 182.660004 L 676.669983 182.660004 L 676.669983 184.100006 L 678.400024 184.100006 L 678.400024 182.660004 Z"
      />
      <path
        id="path2949"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 184.779999 L 676.669983 184.779999 L 676.669983 186.220001 L 678.400024 186.220001 L 678.400024 184.779999 Z"
      />
      <path
        id="path2950"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 186.890015 L 676.669983 186.890015 L 676.669983 188.330017 L 678.400024 188.330017 L 678.400024 186.890015 Z"
      />
      <path
        id="path2951"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 186.890015 L 679.090027 186.890015 L 679.090027 188.330017 L 680.820007 188.330017 L 680.820007 186.890015 Z"
      />
      <path
        id="path2952"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 189.01001 L 676.669983 189.01001 L 676.669983 190.450012 L 678.400024 190.450012 L 678.400024 189.01001 Z"
      />
      <path
        id="path2953"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 195.359985 L 676.669983 195.359985 L 676.669983 196.799988 L 678.400024 196.799988 L 678.400024 195.359985 Z"
      />
      <path
        id="path2954"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 197.47998 L 676.669983 197.47998 L 676.669983 198.919983 L 678.400024 198.919983 L 678.400024 197.47998 Z"
      />
      <path
        id="path2955"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 199.600006 L 676.669983 199.600006 L 676.669983 201.039978 L 678.400024 201.039978 L 678.400024 199.600006 Z"
      />
      <path
        id="path2956"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 201.720001 L 676.669983 201.720001 L 676.669983 203.160004 L 678.400024 203.160004 L 678.400024 201.720001 Z"
      />
      <path
        id="path2957"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 208.070007 L 676.669983 208.070007 L 676.669983 209.51001 L 678.400024 209.51001 L 678.400024 208.070007 Z"
      />
      <path
        id="path2958"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 210.190002 L 676.669983 210.190002 L 676.669983 211.630005 L 678.400024 211.630005 L 678.400024 210.190002 Z"
      />
      <path
        id="path2959"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 212.309998 L 676.669983 212.309998 L 676.669983 213.75 L 678.400024 213.75 L 678.400024 212.309998 Z"
      />
      <path
        id="path2960"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 214.5 L 659.880005 214.5 L 659.880005 215.940002 L 661.599976 215.940002 L 661.599976 214.5 Z"
      />
      <path
        id="path2961"
        fill="#cecece"
        stroke="none"
        d="M 661.599976 218.72998 L 659.880005 218.72998 L 659.880005 220.169983 L 661.599976 220.169983 L 661.599976 218.72998 Z"
      />
      <path
        id="path2962"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 212.380005 L 662.679993 212.380005 L 662.679993 213.820007 L 664.400024 213.820007 L 664.400024 212.380005 Z"
      />
      <path
        id="path2963"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 216.619995 L 662.679993 216.619995 L 662.679993 218.059998 L 664.400024 218.059998 L 664.400024 216.619995 Z"
      />
      <path
        id="path2964"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 218.72998 L 662.679993 218.72998 L 662.679993 220.169983 L 664.400024 220.169983 L 664.400024 218.72998 Z"
      />
      <path
        id="path2965"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 220.850006 L 662.679993 220.850006 L 662.679993 222.289978 L 664.400024 222.289978 L 664.400024 220.850006 Z"
      />
      <path
        id="path2966"
        fill="#cecece"
        stroke="none"
        d="M 664.400024 222.970001 L 662.679993 222.970001 L 662.679993 224.410004 L 664.400024 224.410004 L 664.400024 222.970001 Z"
      />
      <path
        id="path2967"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 214.5 L 665.47998 214.5 L 665.47998 215.940002 L 667.210022 215.940002 L 667.210022 214.5 Z"
      />
      <path
        id="path2968"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 220.850006 L 665.47998 220.850006 L 665.47998 222.289978 L 667.210022 222.289978 L 667.210022 220.850006 Z"
      />
      <path
        id="path2969"
        fill="#cecece"
        stroke="none"
        d="M 667.210022 222.970001 L 665.47998 222.970001 L 665.47998 224.410004 L 667.210022 224.410004 L 667.210022 222.970001 Z"
      />
      <path
        id="path2970"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 216.619995 L 668.280029 216.619995 L 668.280029 218.059998 L 670.01001 218.059998 L 670.01001 216.619995 Z"
      />
      <path
        id="path2971"
        fill="#cecece"
        stroke="none"
        d="M 670.01001 218.72998 L 668.280029 218.72998 L 668.280029 220.169983 L 670.01001 220.169983 L 670.01001 218.72998 Z"
      />
      <path
        id="path2972"
        fill="#cecece"
        stroke="none"
        d="M 672.799988 218.72998 L 671.070007 218.72998 L 671.070007 220.169983 L 672.799988 220.169983 L 672.799988 218.72998 Z"
      />
      <path
        id="path2973"
        fill="#cecece"
        stroke="none"
        d="M 672.799988 220.850006 L 671.070007 220.850006 L 671.070007 222.289978 L 672.799988 222.289978 L 672.799988 220.850006 Z"
      />
      <path
        id="path2974"
        fill="#cecece"
        stroke="none"
        d="M 672.799988 222.970001 L 671.070007 222.970001 L 671.070007 224.410004 L 672.799988 224.410004 L 672.799988 222.970001 Z"
      />
      <path
        id="path2975"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 212.380005 L 673.869995 212.380005 L 673.869995 213.820007 L 675.590027 213.820007 L 675.590027 212.380005 Z"
      />
      <path
        id="path2976"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 214.5 L 673.869995 214.5 L 673.869995 215.940002 L 675.590027 215.940002 L 675.590027 214.5 Z"
      />
      <path
        id="path2977"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 216.619995 L 673.869995 216.619995 L 673.869995 218.059998 L 675.590027 218.059998 L 675.590027 216.619995 Z"
      />
      <path
        id="path2978"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 220.850006 L 673.869995 220.850006 L 673.869995 222.289978 L 675.590027 222.289978 L 675.590027 220.850006 Z"
      />
      <path
        id="path2979"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 221.119995 L 657.080017 221.119995 L 657.080017 222.559998 L 658.799988 222.559998 L 658.799988 221.119995 Z"
      />
      <path
        id="path2980"
        fill="#cecece"
        stroke="none"
        d="M 658.799988 223.22998 L 657.080017 223.22998 L 657.080017 224.669983 L 658.799988 224.669983 L 658.799988 223.22998 Z"
      />
      <path
        id="path2981"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 212.380005 L 676.669983 212.380005 L 676.669983 213.820007 L 678.400024 213.820007 L 678.400024 212.380005 Z"
      />
      <path
        id="path2982"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 218.72998 L 676.669983 218.72998 L 676.669983 220.169983 L 678.400024 220.169983 L 678.400024 218.72998 Z"
      />
      <path
        id="path2983"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 182.660004 L 679.090027 182.660004 L 679.090027 184.100006 L 680.820007 184.100006 L 680.820007 182.660004 Z"
      />
      <path
        id="path2984"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 184.779999 L 679.090027 184.779999 L 679.090027 186.220001 L 680.820007 186.220001 L 680.820007 184.779999 Z"
      />
      <path
        id="path2985"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 189.01001 L 679.090027 189.01001 L 679.090027 190.450012 L 680.820007 190.450012 L 680.820007 189.01001 Z"
      />
      <path
        id="path2986"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 191.130005 L 679.090027 191.130005 L 679.090027 192.570007 L 680.820007 192.570007 L 680.820007 191.130005 Z"
      />
      <path
        id="path2987"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 193.25 L 679.090027 193.25 L 679.090027 194.690002 L 680.820007 194.690002 L 680.820007 193.25 Z"
      />
      <path
        id="path2988"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 195.359985 L 679.090027 195.359985 L 679.090027 196.799988 L 680.820007 196.799988 L 680.820007 195.359985 Z"
      />
      <path
        id="path2989"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 197.47998 L 679.090027 197.47998 L 679.090027 198.919983 L 680.820007 198.919983 L 680.820007 197.47998 Z"
      />
      <path
        id="path2990"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 201.720001 L 679.090027 201.720001 L 679.090027 203.160004 L 680.820007 203.160004 L 680.820007 201.720001 Z"
      />
      <path
        id="path2991"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 203.830017 L 679.090027 203.830017 L 679.090027 205.27002 L 680.820007 205.27002 L 680.820007 203.830017 Z"
      />
      <path
        id="path2992"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 205.950012 L 679.090027 205.950012 L 679.090027 207.390015 L 680.820007 207.390015 L 680.820007 205.950012 Z"
      />
      <path
        id="path2993"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 208.070007 L 679.090027 208.070007 L 679.090027 209.51001 L 680.820007 209.51001 L 680.820007 208.070007 Z"
      />
      <path
        id="path2994"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 210.190002 L 679.090027 210.190002 L 679.090027 211.630005 L 680.820007 211.630005 L 680.820007 210.190002 Z"
      />
      <path
        id="path2995"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 212.309998 L 679.090027 212.309998 L 679.090027 213.75 L 680.820007 213.75 L 680.820007 212.309998 Z"
      />
      <path
        id="path2996"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 180.539978 L 659.880005 180.539978 L 659.880005 181.97998 L 683.619995 181.97998 L 683.619995 180.539978 Z"
      />
      <path
        id="path2997"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 182.660004 L 681.890015 182.660004 L 681.890015 188.339996 L 683.619995 188.339996 L 683.619995 182.660004 Z"
      />
      <path
        id="path2998"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 189.01001 L 681.890015 189.01001 L 681.890015 190.450012 L 683.619995 190.450012 L 683.619995 189.01001 Z"
      />
      <path
        id="path2999"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 191.130005 L 681.890015 191.130005 L 681.890015 192.570007 L 683.619995 192.570007 L 683.619995 191.130005 Z"
      />
      <path
        id="path3000"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 193.25 L 681.890015 193.25 L 681.890015 194.690002 L 683.619995 194.690002 L 683.619995 193.25 Z"
      />
      <path
        id="path3001"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 195.359985 L 681.890015 195.359985 L 681.890015 196.799988 L 683.619995 196.799988 L 683.619995 195.359985 Z"
      />
      <path
        id="path3002"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 197.47998 L 681.890015 197.47998 L 681.890015 198.919983 L 683.619995 198.919983 L 683.619995 197.47998 Z"
      />
      <path
        id="path3003"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 199.600006 L 681.890015 199.600006 L 681.890015 201.039978 L 683.619995 201.039978 L 683.619995 199.600006 Z"
      />
      <path
        id="path3004"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 201.720001 L 681.890015 201.720001 L 681.890015 203.160004 L 683.619995 203.160004 L 683.619995 201.720001 Z"
      />
      <path
        id="path3005"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 203.830017 L 681.890015 203.830017 L 681.890015 205.27002 L 683.619995 205.27002 L 683.619995 203.830017 Z"
      />
      <path
        id="path3006"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 205.950012 L 681.890015 205.950012 L 681.890015 207.390015 L 683.619995 207.390015 L 683.619995 205.950012 Z"
      />
      <path
        id="path3007"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 208.070007 L 681.890015 208.070007 L 681.890015 209.51001 L 683.619995 209.51001 L 683.619995 208.070007 Z"
      />
      <path
        id="path3008"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 180.539978 L 684.690002 180.539978 L 684.690002 181.97998 L 686.419983 181.97998 L 686.419983 180.539978 Z"
      />
      <path
        id="path3009"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 199.600006 L 684.690002 199.600006 L 684.690002 201.039978 L 686.419983 201.039978 L 686.419983 199.600006 Z"
      />
      <path
        id="path3010"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 201.720001 L 684.690002 201.720001 L 684.690002 203.160004 L 686.419983 203.160004 L 686.419983 201.720001 Z"
      />
      <path
        id="path3011"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 208.070007 L 684.690002 208.070007 L 684.690002 209.51001 L 686.419983 209.51001 L 686.419983 208.070007 Z"
      />
      <path
        id="path3012"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 212.380005 L 679.090027 212.380005 L 679.090027 213.820007 L 680.820007 213.820007 L 680.820007 212.380005 Z"
      />
      <path
        id="path3013"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 218.72998 L 679.090027 218.72998 L 679.090027 220.169983 L 680.820007 220.169983 L 680.820007 218.72998 Z"
      />
      <path
        id="path3014"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 220.850006 L 679.090027 220.850006 L 679.090027 222.289978 L 680.820007 222.289978 L 680.820007 220.850006 Z"
      />
      <path
        id="path3015"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 222.970001 L 679.090027 222.970001 L 679.090027 224.410004 L 680.820007 224.410004 L 680.820007 222.970001 Z"
      />
      <path
        id="path3016"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 212.380005 L 681.890015 212.380005 L 681.890015 213.820007 L 683.619995 213.820007 L 683.619995 212.380005 Z"
      />
      <path
        id="path3017"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 214.5 L 681.890015 214.5 L 681.890015 215.940002 L 683.619995 215.940002 L 683.619995 214.5 Z"
      />
      <path
        id="path3018"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 216.619995 L 681.890015 216.619995 L 681.890015 218.059998 L 683.619995 218.059998 L 683.619995 216.619995 Z"
      />
      <path
        id="path3019"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 220.850006 L 681.890015 220.850006 L 681.890015 222.289978 L 683.619995 222.289978 L 683.619995 220.850006 Z"
      />
      <path
        id="path3020"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 225.039978 L 673.869995 225.039978 L 673.869995 226.47998 L 675.590027 226.47998 L 675.590027 225.039978 Z"
      />
      <path
        id="path3021"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 227.160004 L 673.869995 227.160004 L 673.869995 228.600006 L 675.590027 228.600006 L 675.590027 227.160004 Z"
      />
      <path
        id="path3022"
        fill="#cecece"
        stroke="none"
        d="M 672.799988 227.160004 L 671.070007 227.160004 L 671.070007 228.600006 L 672.799988 228.600006 L 672.799988 227.160004 Z"
      />
      <path
        id="path3023"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 229.27002 L 673.869995 229.27002 L 673.869995 230.710022 L 675.590027 230.710022 L 675.590027 229.27002 Z"
      />
      <path
        id="path3024"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 229.27002 L 676.669983 229.27002 L 676.669983 230.710022 L 678.400024 230.710022 L 678.400024 229.27002 Z"
      />
      <path
        id="path3025"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 233.51001 L 676.669983 233.51001 L 676.669983 234.950012 L 678.400024 234.950012 L 678.400024 233.51001 Z"
      />
      <path
        id="path3026"
        fill="#cecece"
        stroke="none"
        d="M 675.590027 235.700012 L 673.869995 235.700012 L 673.869995 237.139999 L 675.590027 237.139999 L 675.590027 235.700012 Z"
      />
      <path
        id="path3027"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 233.580017 L 676.669983 233.580017 L 676.669983 235.02002 L 678.400024 235.02002 L 678.400024 233.580017 Z"
      />
      <path
        id="path3028"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 237.660004 L 676.669983 237.660004 L 676.669983 239.100006 L 678.400024 239.100006 L 678.400024 237.660004 Z"
      />
      <path
        id="path3029"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 227.160004 L 679.090027 227.160004 L 679.090027 228.600006 L 680.820007 228.600006 L 680.820007 227.160004 Z"
      />
      <path
        id="path3030"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 231.390015 L 679.090027 231.390015 L 679.090027 232.830017 L 680.820007 232.830017 L 680.820007 231.390015 Z"
      />
      <path
        id="path3031"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 233.51001 L 679.090027 233.51001 L 679.090027 234.950012 L 680.820007 234.950012 L 680.820007 233.51001 Z"
      />
      <path
        id="path3032"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 225.039978 L 681.890015 225.039978 L 681.890015 226.47998 L 683.619995 226.47998 L 683.619995 225.039978 Z"
      />
      <path
        id="path3033"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 229.27002 L 681.890015 229.27002 L 681.890015 230.710022 L 683.619995 230.710022 L 683.619995 229.27002 Z"
      />
      <path
        id="path3034"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 229.27002 L 684.690002 229.27002 L 684.690002 230.710022 L 686.419983 230.710022 L 686.419983 229.27002 Z"
      />
      <path
        id="path3035"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 233.51001 L 684.690002 233.51001 L 684.690002 234.950012 L 686.419983 234.950012 L 686.419983 233.51001 Z"
      />
      <path
        id="path3036"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 233.580017 L 679.090027 233.580017 L 679.090027 235.02002 L 680.820007 235.02002 L 680.820007 233.580017 Z"
      />
      <path
        id="path3037"
        fill="#cecece"
        stroke="none"
        d="M 680.820007 239.779999 L 679.090027 239.779999 L 679.090027 241.220001 L 680.820007 241.220001 L 680.820007 239.779999 Z"
      />
      <path
        id="path3038"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 233.580017 L 681.890015 233.580017 L 681.890015 235.02002 L 683.619995 235.02002 L 683.619995 233.580017 Z"
      />
      <path
        id="path3039"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 235.700012 L 681.890015 235.700012 L 681.890015 237.139999 L 683.619995 237.139999 L 683.619995 235.700012 Z"
      />
      <path
        id="path3040"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 242.050003 L 681.890015 242.050003 L 681.890015 243.490005 L 683.619995 243.490005 L 683.619995 242.050003 Z"
      />
      <path
        id="path3041"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 244.300003 L 681.890015 244.300003 L 681.890015 245.740005 L 683.619995 245.740005 L 683.619995 244.300003 Z"
      />
      <path
        id="path3042"
        fill="#cecece"
        stroke="none"
        d="M 683.619995 237.899994 L 681.890015 237.899994 L 681.890015 239.339996 L 683.619995 239.339996 L 683.619995 237.899994 Z"
      />
      <path
        id="path3043"
        fill="#cecece"
        stroke="none"
        d="M 686.419983 233.580017 L 684.690002 233.580017 L 684.690002 235.02002 L 686.419983 235.02002 L 686.419983 233.580017 Z"
      />
      <path
        id="path3044"
        fill="#cecece"
        stroke="none"
        d="M 682.940002 145.169983 L 682.22998 145.169983 L 682.22998 148.950012 L 682.940002 148.950012 L 682.940002 145.169983 Z"
      />
      <path
        id="path3045"
        fill="#cecece"
        stroke="none"
        d="M 684.320007 145.169983 L 683.609985 145.169983 L 683.609985 148.950012 L 684.320007 148.950012 L 684.320007 145.169983 Z"
      />
      <path
        id="path3046"
        fill="#cecece"
        stroke="none"
        d="M 681.590027 145.169983 L 680.849976 145.169983 L 680.849976 148.950012 L 681.590027 148.950012 L 681.590027 145.169983 Z"
      />
      <path
        id="path3047"
        fill="#cecece"
        stroke="none"
        d="M 650.200012 198.789978 L 648.549988 198.789978 L 648.549988 200.130005 L 650.200012 200.130005 L 650.200012 198.789978 Z"
      />
      <path
        id="path3048"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 196.580017 L 650.200012 196.600006 L 650.200012 197.960022 L 649.380005 197.940002 L 648.549988 197.929993 L 648.549988 196.580017 Z"
      />
      <path
        id="path3049"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 194.359985 L 650.200012 194.410004 L 650.200012 195.779999 L 649.380005 195.76001 L 648.549988 195.72998 L 648.549988 194.359985 Z"
      />
      <path
        id="path3050"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 192.149994 L 650.200012 192.220001 L 650.200012 193.609985 L 649.380005 193.570007 L 648.549988 193.539978 L 648.549988 192.149994 Z"
      />
      <path
        id="path3051"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 189.929993 L 650.200012 190.029999 L 650.200012 191.440002 L 649.380005 191.390015 L 648.549988 191.339996 L 648.549988 189.929993 Z"
      />
      <path
        id="path3052"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 187.720001 L 650.200012 187.839996 L 650.200012 189.27002 L 649.380005 189.210022 L 648.549988 189.140015 L 648.549988 187.720001 Z"
      />
      <path
        id="path3053"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 185.5 L 650.200012 185.649994 L 650.200012 187.100006 L 649.380005 187.02002 L 648.549988 186.950012 L 648.549988 185.5 Z"
      />
      <path
        id="path3054"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 181.070007 L 650.200012 181.27002 L 650.200012 182.75 L 649.380005 182.649994 L 648.549988 182.549988 L 648.549988 181.070007 Z"
      />
      <path
        id="path3055"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 178.859985 L 650.200012 179.080017 L 650.200012 180.580017 L 649.380005 180.470001 L 648.549988 180.359985 L 648.549988 178.859985 Z"
      />
      <path
        id="path3056"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 176.640015 L 650.200012 176.890015 L 650.200012 178.410004 L 649.380005 178.289978 L 648.549988 178.160004 L 648.549988 176.640015 Z"
      />
      <path
        id="path3057"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 174.429993 L 650.200012 174.700012 L 650.200012 176.23999 L 649.380005 176.100006 L 648.549988 175.960022 L 648.549988 174.429993 Z"
      />
      <path
        id="path3058"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 172.220001 L 650.200012 172.5 L 650.200012 174.070007 L 649.380005 173.919983 L 648.549988 173.77002 L 648.549988 172.220001 Z"
      />
      <path
        id="path3059"
        fill="#cecece"
        stroke="none"
        d="M 648.549988 170 L 648.549988 171.570007 L 649.380005 171.72998 L 650.200012 171.899994 L 650.200012 170.309998 L 648.549988 170 Z"
      />
      <path
        id="path3060"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 196.619995 L 652.890015 196.640015 L 652.890015 198 L 652.059998 197.97998 L 651.23999 197.970001 L 651.23999 196.619995 Z"
      />
      <path
        id="path3061"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 192.27002 L 652.890015 192.339996 L 652.890015 193.72998 L 652.059998 193.700012 L 651.23999 193.660004 L 651.23999 192.27002 Z"
      />
      <path
        id="path3062"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 190.089996 L 652.880005 190.190002 L 652.880005 191.600006 L 652.059998 191.549988 L 651.23999 191.5 L 651.23999 190.089996 Z"
      />
      <path
        id="path3063"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 187.910004 L 652.880005 188.039978 L 652.880005 189.470001 L 652.059998 189.410004 L 651.23999 189.350006 L 651.23999 187.910004 Z"
      />
      <path
        id="path3064"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 185.73999 L 652.880005 185.880005 L 652.880005 187.339996 L 652.059998 187.27002 L 651.23999 187.190002 L 651.23999 185.73999 Z"
      />
      <path
        id="path3065"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 183.559998 L 652.880005 183.72998 L 652.880005 185.210022 L 652.059998 185.119995 L 651.23999 185.039978 L 651.23999 183.559998 Z"
      />
      <path
        id="path3066"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 181.390015 L 652.880005 181.580017 L 652.880005 183.080017 L 652.059998 182.97998 L 651.23999 182.880005 L 651.23999 181.390015 Z"
      />
      <path
        id="path3067"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 177.039978 L 652.880005 177.279999 L 652.880005 178.820007 L 652.059998 178.690002 L 651.23999 178.570007 L 651.23999 177.039978 Z"
      />
      <path
        id="path3068"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 172.690002 L 652.880005 172.97998 L 652.880005 174.559998 L 652.059998 174.410004 L 651.23999 174.26001 L 651.23999 172.690002 Z"
      />
      <path
        id="path3069"
        fill="#cecece"
        stroke="none"
        d="M 651.23999 170.51001 L 651.23999 172.100006 L 652.059998 172.26001 L 652.880005 172.429993 L 652.880005 170.830017 L 651.23999 170.51001 Z"
      />
      <path
        id="path3070"
        fill="#cecece"
        stroke="none"
        d="M 655.609985 198.789978 L 653.960022 198.789978 L 653.960022 200.130005 L 655.609985 200.130005 L 655.609985 198.789978 Z"
      />
      <path
        id="path3071"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 196.660004 L 655.599976 196.679993 L 655.599976 198.039978 L 654.780029 198.02002 L 653.960022 198.01001 L 653.960022 196.660004 Z"
      />
      <path
        id="path3072"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 194.52002 L 655.599976 194.570007 L 655.599976 195.950012 L 654.780029 195.919983 L 653.960022 195.899994 L 653.960022 194.52002 Z"
      />
      <path
        id="path3073"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 192.380005 L 655.599976 192.460022 L 655.599976 193.859985 L 654.780029 193.820007 L 653.960022 193.779999 L 653.960022 192.380005 Z"
      />
      <path
        id="path3074"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 188.109985 L 655.599976 188.22998 L 655.599976 189.679993 L 654.780029 189.619995 L 653.960022 189.549988 L 653.960022 188.109985 Z"
      />
      <path
        id="path3075"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 183.839996 L 655.599976 184.01001 L 655.599976 185.5 L 654.780029 185.410004 L 653.960022 185.320007 L 653.960022 183.839996 Z"
      />
      <path
        id="path3076"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 181.710022 L 655.599976 181.899994 L 655.599976 183.410004 L 654.780029 183.309998 L 653.960022 183.210022 L 653.960022 181.710022 Z"
      />
      <path
        id="path3077"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 179.570007 L 655.599976 179.789978 L 655.599976 181.320007 L 654.780029 181.210022 L 653.960022 181.100006 L 653.960022 179.570007 Z"
      />
      <path
        id="path3078"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 177.440002 L 655.599976 177.679993 L 655.599976 179.22998 L 654.780029 179.109985 L 653.960022 178.97998 L 653.960022 177.440002 Z"
      />
      <path
        id="path3079"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 173.160004 L 655.599976 173.450012 L 655.599976 175.049988 L 654.780029 174.899994 L 653.960022 174.75 L 653.960022 173.160004 Z"
      />
      <path
        id="path3080"
        fill="#cecece"
        stroke="none"
        d="M 653.960022 171.029999 L 653.960022 172.640015 L 654.780029 172.799988 L 655.599976 172.960022 L 655.599976 171.339996 L 653.960022 171.029999 Z"
      />
      <path
        id="path3081"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 201.929993 L 475.869995 201.929993 L 475.869995 203.210022 L 477.450012 203.210022 L 477.450012 201.929993 Z"
      />
      <path
        id="path3082"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 199.799988 L 475.869995 199.820007 L 475.869995 201.130005 L 476.660004 201.109985 L 477.450012 201.100006 L 477.450012 199.799988 Z"
      />
      <path
        id="path3083"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 197.679993 L 475.869995 197.720001 L 475.869995 199.039978 L 476.660004 199.02002 L 477.450012 198.98999 L 477.450012 197.679993 Z"
      />
      <path
        id="path3084"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 195.549988 L 475.869995 195.619995 L 475.869995 196.960022 L 476.660004 196.919983 L 477.450012 196.880005 L 477.450012 195.549988 Z"
      />
      <path
        id="path3085"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 193.419983 L 475.869995 193.52002 L 475.869995 194.869995 L 476.660004 194.820007 L 477.450012 194.77002 L 477.450012 193.419983 Z"
      />
      <path
        id="path3086"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 191.299988 L 475.869995 191.410004 L 475.869995 192.789978 L 476.660004 192.72998 L 477.450012 192.669983 L 477.450012 191.299988 Z"
      />
      <path
        id="path3087"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 189.169983 L 475.869995 189.309998 L 475.869995 190.700012 L 476.660004 190.630005 L 477.450012 190.559998 L 477.450012 189.169983 Z"
      />
      <path
        id="path3088"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 184.919983 L 475.869995 185.100006 L 475.869995 186.529999 L 476.660004 186.429993 L 477.450012 186.339996 L 477.450012 184.919983 Z"
      />
      <path
        id="path3089"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 182.789978 L 475.869995 183 L 475.869995 184.450012 L 476.660004 184.339996 L 477.450012 184.22998 L 477.450012 182.789978 Z"
      />
      <path
        id="path3090"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 180.660004 L 475.869995 180.899994 L 475.869995 182.359985 L 476.660004 182.23999 L 477.450012 182.119995 L 477.450012 180.660004 Z"
      />
      <path
        id="path3091"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 178.539978 L 475.869995 178.789978 L 475.869995 180.279999 L 476.660004 180.140015 L 477.450012 180.01001 L 477.450012 178.539978 Z"
      />
      <path
        id="path3092"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 176.410004 L 475.869995 176.690002 L 475.869995 178.190002 L 476.660004 178.049988 L 477.450012 177.899994 L 477.450012 176.410004 Z"
      />
      <path
        id="path3093"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 174.289978 L 477.450012 175.789978 L 476.660004 175.950012 L 475.869995 176.109985 L 475.869995 174.589996 L 477.450012 174.289978 Z"
      />
      <path
        id="path3094"
        fill="#cecece"
        stroke="none"
        d="M 474.869995 199.839996 L 473.290009 199.859985 L 473.290009 201.160004 L 474.079987 201.149994 L 474.869995 201.140015 L 474.869995 199.839996 Z"
      />
      <path
        id="path3095"
        fill="#cecece"
        stroke="none"
        d="M 474.869995 195.660004 L 473.290009 195.72998 L 473.290009 197.070007 L 474.079987 197.039978 L 474.869995 197 L 474.869995 195.660004 Z"
      />
      <path
        id="path3096"
        fill="#cecece"
        stroke="none"
        d="M 474.869995 193.570007 L 473.299988 193.669983 L 473.299988 195.029999 L 474.079987 194.97998 L 474.869995 194.929993 L 474.869995 193.570007 Z"
      />
      <path
        id="path3097"
        fill="#cecece"
        stroke="none"
        d="M 474.869995 191.48999 L 473.299988 191.600006 L 473.299988 192.97998 L 474.079987 192.919983 L 474.869995 192.859985 L 474.869995 191.48999 Z"
      />
      <path
        id="path3098"
        fill="#cecece"
        stroke="none"
        d="M 474.869995 189.399994 L 473.299988 189.539978 L 473.299988 190.940002 L 474.079987 190.859985 L 474.869995 190.789978 L 474.869995 189.399994 Z"
      />
      <path
        id="path3099"
        fill="#cecece"
        stroke="none"
        d="M 474.880005 187.309998 L 473.299988 187.470001 L 473.299988 188.890015 L 474.079987 188.809998 L 474.880005 188.720001 L 474.880005 187.309998 Z"
      />
      <path
        id="path3100"
        fill="#cecece"
        stroke="none"
        d="M 474.880005 185.220001 L 473.299988 185.399994 L 473.299988 186.839996 L 474.079987 186.75 L 474.880005 186.649994 L 474.880005 185.220001 Z"
      />
      <path
        id="path3101"
        fill="#cecece"
        stroke="none"
        d="M 474.880005 181.039978 L 473.299988 181.27002 L 473.299988 182.75 L 474.079987 182.630005 L 474.880005 182.51001 L 474.880005 181.039978 Z"
      />
      <path
        id="path3102"
        fill="#cecece"
        stroke="none"
        d="M 474.880005 176.869995 L 473.299988 177.140015 L 473.299988 178.660004 L 474.079987 178.52002 L 474.880005 178.369995 L 474.880005 176.869995 Z"
      />
      <path
        id="path3103"
        fill="#cecece"
        stroke="none"
        d="M 474.880005 174.779999 L 474.880005 176.299988 L 474.079987 176.460022 L 473.299988 176.609985 L 473.299988 175.080017 L 474.880005 174.779999 Z"
      />
      <path
        id="path3104"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 201.929993 L 470.690002 201.929993 L 470.690002 203.210022 L 472.269989 203.210022 L 472.269989 201.929993 Z"
      />
      <path
        id="path3105"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 199.880005 L 470.690002 199.899994 L 470.690002 201.200012 L 471.480011 201.190002 L 472.269989 201.179993 L 472.269989 199.880005 Z"
      />
      <path
        id="path3106"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 197.830017 L 470.690002 197.869995 L 470.690002 199.200012 L 471.480011 199.169983 L 472.269989 199.149994 L 472.269989 197.830017 Z"
      />
      <path
        id="path3107"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 195.779999 L 470.690002 195.850006 L 470.690002 197.190002 L 471.480011 197.149994 L 472.269989 197.119995 L 472.269989 195.779999 Z"
      />
      <path
        id="path3108"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 191.679993 L 470.690002 191.789978 L 470.690002 193.179993 L 471.480011 193.119995 L 472.269989 193.059998 L 472.269989 191.679993 Z"
      />
      <path
        id="path3109"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 187.580017 L 470.690002 187.73999 L 470.690002 189.169983 L 471.480011 189.080017 L 472.269989 189 L 472.269989 187.580017 Z"
      />
      <path
        id="path3110"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 185.529999 L 470.690002 185.710022 L 470.690002 187.160004 L 471.480011 187.059998 L 472.269989 186.970001 L 472.269989 185.529999 Z"
      />
      <path
        id="path3111"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 183.47998 L 470.690002 183.679993 L 470.690002 185.149994 L 471.480011 185.049988 L 472.269989 184.940002 L 472.269989 183.47998 Z"
      />
      <path
        id="path3112"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 181.419983 L 470.690002 181.660004 L 470.690002 183.149994 L 471.480011 183.029999 L 472.269989 182.910004 L 472.269989 181.419983 Z"
      />
      <path
        id="path3113"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 177.320007 L 470.690002 177.600006 L 470.690002 179.140015 L 471.480011 178.98999 L 472.269989 178.850006 L 472.269989 177.320007 Z"
      />
      <path
        id="path3114"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 175.27002 L 472.269989 176.820007 L 471.480011 176.970001 L 470.690002 177.130005 L 470.690002 175.580017 L 472.269989 175.27002 Z"
      />
      <path
        id="path3115"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 197.899994 L 468.140015 197.950012 L 468.140015 199.279999 L 468.929993 199.25 L 469.720001 199.22998 L 469.720001 197.899994 Z"
      />
      <path
        id="path3116"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 195.890015 L 468.140015 195.960022 L 468.140015 197.309998 L 468.929993 197.27002 L 469.720001 197.23999 L 469.720001 195.890015 Z"
      />
      <path
        id="path3117"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 191.859985 L 468.140015 191.97998 L 468.140015 193.369995 L 468.929993 193.309998 L 469.720001 193.25 L 469.720001 191.859985 Z"
      />
      <path
        id="path3118"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 189.850006 L 468.140015 189.98999 L 468.140015 191.399994 L 468.929993 191.330017 L 469.720001 191.26001 L 469.720001 189.850006 Z"
      />
      <path
        id="path3119"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 187.839996 L 468.140015 188 L 468.140015 189.440002 L 468.929993 189.350006 L 469.720001 189.27002 L 469.720001 187.839996 Z"
      />
      <path
        id="path3120"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 185.820007 L 468.140015 186.01001 L 468.140015 187.470001 L 468.929993 187.369995 L 469.720001 187.279999 L 469.720001 185.820007 Z"
      />
      <path
        id="path3121"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 181.799988 L 468.140015 182.029999 L 468.140015 183.529999 L 468.929993 183.410004 L 469.720001 183.289978 L 469.720001 181.799988 Z"
      />
      <path
        id="path3122"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 179.779999 L 468.140015 180.039978 L 468.140015 181.570007 L 468.929993 181.429993 L 469.720001 181.299988 L 469.720001 179.779999 Z"
      />
      <path
        id="path3123"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 175.76001 L 469.720001 177.320007 L 468.929993 177.470001 L 468.140015 177.630005 L 468.140015 176.059998 L 469.720001 175.76001 Z"
      />
      <path
        id="path3124"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 209.380005 L 475.869995 209.380005 L 475.869995 210.660004 L 477.450012 210.660004 L 477.450012 209.380005 Z"
      />
      <path
        id="path3125"
        fill="#cecece"
        stroke="none"
        d="M 477.450012 205.119995 L 475.869995 205.169983 L 475.869995 206.48999 L 476.660004 206.470001 L 477.450012 206.440002 L 477.450012 205.119995 Z"
      />
      <path
        id="path3126"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 209.380005 L 470.690002 209.380005 L 470.690002 210.660004 L 472.269989 210.660004 L 472.269989 209.380005 Z"
      />
      <path
        id="path3127"
        fill="#cecece"
        stroke="none"
        d="M 472.269989 207.330017 L 470.690002 207.350006 L 470.690002 208.649994 L 471.480011 208.640015 L 472.269989 208.630005 L 472.269989 207.330017 Z"
      />
      <path
        id="path3128"
        fill="#cecece"
        stroke="none"
        d="M 469.720001 205.350006 L 468.140015 205.399994 L 468.140015 206.720001 L 468.929993 206.700012 L 469.720001 206.679993 L 469.720001 205.350006 Z"
      />
      <path
        id="path3129"
        fill="#cecece"
        stroke="none"
        d="M 453.76001 153.029999 L 453.059998 152.529999 L 453.059998 153.22998 L 453.76001 153.690002 L 453.76001 153.029999 Z"
      />
      <path
        id="path3130"
        fill="#cecece"
        stroke="none"
        d="M 453.059998 154.929993 L 453.76001 155.380005 L 453.76001 154.700012 L 453.059998 154.220001 L 453.059998 154.929993 Z"
      />
      <path
        id="path3131"
        fill="#cecece"
        stroke="none"
        d="M 453.059998 156.640015 L 453.76001 157.070007 L 453.76001 156.380005 L 453.059998 155.910004 L 453.059998 156.640015 Z"
      />
      <path
        id="path3132"
        fill="#cecece"
        stroke="none"
        d="M 453.059998 158.339996 L 453.76001 158.76001 L 453.76001 158.049988 L 453.059998 157.600006 L 453.059998 158.339996 Z"
      />
      <path
        id="path3133"
        fill="#cecece"
        stroke="none"
        d="M 453.059998 160.049988 L 453.76001 160.450012 L 453.76001 159.72998 L 453.059998 159.289978 L 453.059998 160.049988 Z"
      />
      <path
        id="path3134"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 161.75 L 453.76001 162.149994 L 453.76001 161.399994 L 453.070007 160.97998 L 453.070007 161.75 Z"
      />
      <path
        id="path3135"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 163.450012 L 453.76001 163.839996 L 453.76001 163.080017 L 453.070007 162.669983 L 453.070007 163.450012 Z"
      />
      <path
        id="path3136"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 165.160004 L 453.76001 165.529999 L 453.76001 164.76001 L 453.070007 164.359985 L 453.070007 165.160004 Z"
      />
      <path
        id="path3137"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 166.859985 L 453.76001 167.220001 L 453.76001 166.429993 L 453.070007 166.049988 L 453.070007 166.859985 Z"
      />
      <path
        id="path3138"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 168.570007 L 453.76001 168.910004 L 453.76001 168.109985 L 453.070007 167.73999 L 453.070007 168.570007 Z"
      />
      <path
        id="path3139"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 170.27002 L 453.76001 170.600006 L 453.76001 169.779999 L 453.070007 169.429993 L 453.070007 170.27002 Z"
      />
      <path
        id="path3140"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 171.97998 L 453.76001 172.289978 L 453.76001 171.460022 L 453.070007 171.119995 L 453.070007 171.97998 Z"
      />
      <path
        id="path3141"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 173.679993 L 453.76001 173.97998 L 453.76001 173.130005 L 453.070007 172.809998 L 453.070007 173.679993 Z"
      />
      <path
        id="path3142"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 175.390015 L 453.76001 175.679993 L 453.76001 174.809998 L 453.070007 174.5 L 453.070007 175.390015 Z"
      />
      <path
        id="path3143"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 177.089996 L 453.76001 177.369995 L 453.76001 176.48999 L 453.070007 176.190002 L 453.070007 177.089996 Z"
      />
      <path
        id="path3144"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 178.799988 L 453.76001 179.059998 L 453.76001 178.160004 L 453.070007 177.880005 L 453.070007 178.799988 Z"
      />
      <path
        id="path3145"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 180.5 L 453.76001 180.75 L 453.76001 179.839996 L 453.070007 179.570007 L 453.070007 180.5 Z"
      />
      <path
        id="path3146"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 182.200012 L 453.76001 182.440002 L 453.76001 181.51001 L 453.070007 181.26001 L 453.070007 182.200012 Z"
      />
      <path
        id="path3147"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 185.609985 L 453.76001 185.820007 L 453.76001 184.859985 L 453.070007 184.640015 L 453.070007 185.609985 Z"
      />
      <path
        id="path3148"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 187.320007 L 453.76001 187.52002 L 453.76001 186.539978 L 453.070007 186.330017 L 453.070007 187.320007 Z"
      />
      <path
        id="path3149"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 192.429993 L 453.76001 192.589996 L 453.76001 191.570007 L 453.070007 191.399994 L 453.070007 192.429993 Z"
      />
      <path
        id="path3150"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 195.839996 L 453.76001 195.970001 L 453.76001 194.919983 L 453.070007 194.779999 L 453.070007 195.839996 Z"
      />
      <path
        id="path3151"
        fill="#cecece"
        stroke="none"
        d="M 453.070007 197.549988 L 453.76001 197.660004 L 453.76001 196.589996 L 453.070007 196.470001 L 453.070007 197.549988 Z"
      />
      <path
        id="path3152"
        fill="#cecece"
        stroke="none"
        d="M 453.079987 200.950012 L 453.76001 201.049988 L 453.76001 199.950012 L 453.079987 199.850006 L 453.079987 200.950012 Z"
      />
      <path
        id="path3153"
        fill="#cecece"
        stroke="none"
        d="M 453.079987 202.660004 L 453.76001 202.73999 L 453.76001 201.619995 L 453.079987 201.539978 L 453.079987 202.660004 Z"
      />
      <path
        id="path3154"
        fill="#cecece"
        stroke="none"
        d="M 453.079987 206.070007 L 453.76001 206.119995 L 453.76001 204.970001 L 453.079987 204.919983 L 453.079987 206.070007 Z"
      />
      <path
        id="path3155"
        fill="#cecece"
        stroke="none"
        d="M 453.079987 207.77002 L 453.76001 207.809998 L 453.76001 206.649994 L 453.079987 206.609985 L 453.079987 207.77002 Z"
      />
      <path
        id="path3156"
        fill="#cecece"
        stroke="none"
        d="M 453.079987 211.179993 L 453.76001 211.200012 L 453.76001 210 L 453.079987 209.98999 L 453.079987 211.179993 Z"
      />
      <path
        id="path3157"
        fill="#cecece"
        stroke="none"
        d="M 452.709991 152.330017 L 452.019989 151.839996 L 452.019989 152.539978 L 452.709991 153 L 452.709991 152.330017 Z"
      />
      <path
        id="path3158"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 154.26001 L 452.709991 154.710022 L 452.709991 154.029999 L 452.019989 153.549988 L 452.019989 154.26001 Z"
      />
      <path
        id="path3159"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 155.98999 L 452.709991 156.419983 L 452.709991 155.72998 L 452.019989 155.26001 L 452.019989 155.98999 Z"
      />
      <path
        id="path3160"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 157.710022 L 452.709991 158.130005 L 452.709991 157.419983 L 452.019989 156.970001 L 452.019989 157.710022 Z"
      />
      <path
        id="path3161"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 159.429993 L 452.709991 159.839996 L 452.709991 159.119995 L 452.019989 158.679993 L 452.019989 159.429993 Z"
      />
      <path
        id="path3162"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 161.160004 L 452.709991 161.549988 L 452.709991 160.809998 L 452.019989 160.390015 L 452.019989 161.160004 Z"
      />
      <path
        id="path3163"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 162.880005 L 452.709991 163.26001 L 452.709991 162.51001 L 452.019989 162.100006 L 452.019989 162.880005 Z"
      />
      <path
        id="path3164"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 164.609985 L 452.709991 164.97998 L 452.709991 164.200012 L 452.019989 163.809998 L 452.019989 164.609985 Z"
      />
      <path
        id="path3165"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 166.330017 L 452.709991 166.690002 L 452.709991 165.899994 L 452.019989 165.52002 L 452.019989 166.330017 Z"
      />
      <path
        id="path3166"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 168.059998 L 452.709991 168.399994 L 452.709991 167.589996 L 452.019989 167.22998 L 452.019989 168.059998 Z"
      />
      <path
        id="path3167"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 169.779999 L 452.709991 170.109985 L 452.709991 169.289978 L 452.019989 168.940002 L 452.019989 169.779999 Z"
      />
      <path
        id="path3168"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 171.5 L 452.709991 171.820007 L 452.709991 170.97998 L 452.019989 170.649994 L 452.019989 171.5 Z"
      />
      <path
        id="path3169"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 173.22998 L 452.709991 173.529999 L 452.709991 172.679993 L 452.019989 172.359985 L 452.019989 173.22998 Z"
      />
      <path
        id="path3170"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 174.950012 L 452.709991 175.23999 L 452.709991 174.380005 L 452.019989 174.070007 L 452.019989 174.950012 Z"
      />
      <path
        id="path3171"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 176.679993 L 452.709991 176.950012 L 452.709991 176.070007 L 452.019989 175.779999 L 452.019989 176.679993 Z"
      />
      <path
        id="path3172"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 178.399994 L 452.709991 178.660004 L 452.709991 177.77002 L 452.019989 177.48999 L 452.019989 178.399994 Z"
      />
      <path
        id="path3173"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 180.130005 L 452.709991 180.380005 L 452.709991 179.460022 L 452.019989 179.200012 L 452.019989 180.130005 Z"
      />
      <path
        id="path3174"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 181.850006 L 452.709991 182.089996 L 452.709991 181.160004 L 452.019989 180.910004 L 452.019989 181.850006 Z"
      />
      <path
        id="path3175"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 183.570007 L 452.709991 183.799988 L 452.709991 182.850006 L 452.019989 182.609985 L 452.019989 183.570007 Z"
      />
      <path
        id="path3176"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 185.299988 L 452.700012 185.51001 L 452.700012 184.549988 L 452.019989 184.320007 L 452.019989 185.299988 Z"
      />
      <path
        id="path3177"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 187.02002 L 452.700012 187.220001 L 452.700012 186.23999 L 452.019989 186.029999 L 452.019989 187.02002 Z"
      />
      <path
        id="path3178"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 190.470001 L 452.700012 190.640015 L 452.700012 189.630005 L 452.019989 189.450012 L 452.019989 190.470001 Z"
      />
      <path
        id="path3179"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 192.200012 L 452.700012 192.350006 L 452.700012 191.330017 L 452.019989 191.160004 L 452.019989 192.200012 Z"
      />
      <path
        id="path3180"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 195.640015 L 452.700012 195.779999 L 452.700012 194.720001 L 452.019989 194.580017 L 452.019989 195.640015 Z"
      />
      <path
        id="path3181"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 200.820007 L 452.700012 200.910004 L 452.700012 199.809998 L 452.019989 199.710022 L 452.019989 200.820007 Z"
      />
      <path
        id="path3182"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 205.98999 L 452.700012 206.039978 L 452.700012 204.890015 L 452.019989 204.839996 L 452.019989 205.98999 Z"
      />
      <path
        id="path3183"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 211.160004 L 452.700012 211.179993 L 452.700012 209.97998 L 452.019989 209.970001 L 452.019989 211.160004 Z"
      />
      <path
        id="path3184"
        fill="#cecece"
        stroke="none"
        d="M 452.019989 214.850006 L 452.700012 214.869995 L 452.700012 213.669983 L 452.019989 213.660004 L 452.019989 214.850006 Z"
      />
      <path
        id="path3185"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 216.580017 L 451.660004 216.600006 L 451.660004 215.399994 L 450.980011 215.390015 L 450.980011 216.580017 Z"
      />
      <path
        id="path3186"
        fill="#cecece"
        stroke="none"
        d="M 451.670013 151.660004 L 450.980011 151.160004 L 450.980011 151.859985 L 451.670013 152.320007 L 451.670013 151.660004 Z"
      />
      <path
        id="path3187"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 153.600006 L 451.670013 154.049988 L 451.670013 153.369995 L 450.980011 152.890015 L 450.980011 153.600006 Z"
      />
      <path
        id="path3188"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 155.350006 L 451.670013 155.779999 L 451.670013 155.089996 L 450.980011 154.619995 L 450.980011 155.350006 Z"
      />
      <path
        id="path3189"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 157.089996 L 451.670013 157.51001 L 451.670013 156.799988 L 450.980011 156.350006 L 450.980011 157.089996 Z"
      />
      <path
        id="path3190"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 158.830017 L 451.670013 159.23999 L 451.670013 158.51001 L 450.980011 158.080017 L 450.980011 158.830017 Z"
      />
      <path
        id="path3191"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 160.580017 L 451.670013 160.970001 L 451.670013 160.22998 L 450.980011 159.809998 L 450.980011 160.580017 Z"
      />
      <path
        id="path3192"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 162.320007 L 451.670013 162.700012 L 451.670013 161.940002 L 450.980011 161.539978 L 450.980011 162.320007 Z"
      />
      <path
        id="path3193"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 164.059998 L 451.670013 164.429993 L 451.670013 163.660004 L 450.980011 163.27002 L 450.980011 164.059998 Z"
      />
      <path
        id="path3194"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 165.809998 L 451.670013 166.160004 L 451.670013 165.369995 L 450.980011 165 L 450.980011 165.809998 Z"
      />
      <path
        id="path3195"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 167.549988 L 451.670013 167.890015 L 451.670013 167.089996 L 450.980011 166.720001 L 450.980011 167.549988 Z"
      />
      <path
        id="path3196"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 169.289978 L 451.670013 169.619995 L 451.670013 168.799988 L 450.980011 168.450012 L 450.980011 169.289978 Z"
      />
      <path
        id="path3197"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 172.779999 L 451.670013 173.080017 L 451.670013 172.22998 L 450.980011 171.910004 L 450.980011 172.779999 Z"
      />
      <path
        id="path3198"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 176.27002 L 451.670013 176.549988 L 451.670013 175.660004 L 450.980011 175.369995 L 450.980011 176.27002 Z"
      />
      <path
        id="path3199"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 178.01001 L 451.660004 178.279999 L 451.660004 177.380005 L 450.980011 177.100006 L 450.980011 178.01001 Z"
      />
      <path
        id="path3200"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 179.76001 L 451.660004 180.01001 L 451.660004 179.089996 L 450.980011 178.830017 L 450.980011 179.76001 Z"
      />
      <path
        id="path3201"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 181.5 L 451.660004 181.73999 L 451.660004 180.809998 L 450.980011 180.559998 L 450.980011 181.5 Z"
      />
      <path
        id="path3202"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 183.23999 L 451.660004 183.470001 L 451.660004 182.52002 L 450.980011 182.279999 L 450.980011 183.23999 Z"
      />
      <path
        id="path3203"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 186.72998 L 451.660004 186.929993 L 451.660004 185.950012 L 450.980011 185.73999 L 450.980011 186.72998 Z"
      />
      <path
        id="path3204"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 190.220001 L 451.660004 190.390015 L 451.660004 189.380005 L 450.980011 189.200012 L 450.980011 190.220001 Z"
      />
      <path
        id="path3205"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 191.960022 L 451.660004 192.119995 L 451.660004 191.100006 L 450.980011 190.929993 L 450.980011 191.960022 Z"
      />
      <path
        id="path3206"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 193.710022 L 451.660004 193.850006 L 451.660004 192.809998 L 450.980011 192.660004 L 450.980011 193.710022 Z"
      />
      <path
        id="path3207"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 195.450012 L 451.660004 195.580017 L 451.660004 194.529999 L 450.980011 194.390015 L 450.980011 195.450012 Z"
      />
      <path
        id="path3208"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 198.940002 L 451.660004 199.039978 L 451.660004 197.960022 L 450.980011 197.850006 L 450.980011 198.940002 Z"
      />
      <path
        id="path3209"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 202.419983 L 451.660004 202.5 L 451.660004 201.390015 L 450.980011 201.299988 L 450.980011 202.419983 Z"
      />
      <path
        id="path3210"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 204.169983 L 451.660004 204.22998 L 451.660004 203.100006 L 450.980011 203.029999 L 450.980011 204.169983 Z"
      />
      <path
        id="path3211"
        fill="#cecece"
        stroke="none"
        d="M 450.980011 207.660004 L 451.660004 207.690002 L 451.660004 206.529999 L 450.980011 206.48999 L 450.980011 207.660004 Z"
      />
      <path
        id="path3212"
        fill="#cecece"
        stroke="none"
        d="M 450.600006 150.98999 L 449.910004 150.5 L 449.910004 151.200012 L 450.600006 151.660004 L 450.600006 150.98999 Z"
      />
      <path
        id="path3213"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 152.960022 L 450.600006 153.410004 L 450.600006 152.72998 L 449.910004 152.25 L 449.910004 152.960022 Z"
      />
      <path
        id="path3214"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 156.47998 L 450.600006 156.899994 L 450.600006 156.190002 L 449.910004 155.75 L 449.910004 156.47998 Z"
      />
      <path
        id="path3215"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 158.25 L 450.600006 158.649994 L 450.600006 157.929993 L 449.910004 157.48999 L 449.910004 158.25 Z"
      />
      <path
        id="path3216"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 160.01001 L 450.600006 160.399994 L 450.600006 159.660004 L 449.910004 159.23999 L 449.910004 160.01001 Z"
      />
      <path
        id="path3217"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 161.77002 L 450.600006 162.149994 L 450.600006 161.399994 L 449.910004 160.98999 L 449.910004 161.77002 Z"
      />
      <path
        id="path3218"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 165.299988 L 450.600006 165.649994 L 450.600006 164.859985 L 449.910004 164.47998 L 449.910004 165.299988 Z"
      />
      <path
        id="path3219"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 167.059998 L 450.600006 167.399994 L 450.600006 166.600006 L 449.910004 166.22998 L 449.910004 167.059998 Z"
      />
      <path
        id="path3220"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 168.820007 L 450.600006 169.149994 L 450.600006 168.330017 L 449.910004 167.97998 L 449.910004 168.820007 Z"
      />
      <path
        id="path3221"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 170.580017 L 450.600006 170.899994 L 450.600006 170.070007 L 449.910004 169.72998 L 449.910004 170.580017 Z"
      />
      <path
        id="path3222"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 172.350006 L 450.600006 172.649994 L 450.600006 171.799988 L 449.910004 171.47998 L 449.910004 172.350006 Z"
      />
      <path
        id="path3223"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 174.109985 L 450.600006 174.399994 L 450.600006 173.529999 L 449.910004 173.220001 L 449.910004 174.109985 Z"
      />
      <path
        id="path3224"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 175.869995 L 450.600006 176.149994 L 450.600006 175.27002 L 449.910004 174.970001 L 449.910004 175.869995 Z"
      />
      <path
        id="path3225"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 177.630005 L 450.600006 177.899994 L 450.600006 177 L 449.910004 176.720001 L 449.910004 177.630005 Z"
      />
      <path
        id="path3226"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 181.160004 L 450.589996 181.399994 L 450.589996 180.470001 L 449.910004 180.210022 L 449.910004 181.160004 Z"
      />
      <path
        id="path3227"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 182.919983 L 450.589996 183.149994 L 450.589996 182.200012 L 449.910004 181.960022 L 449.910004 182.919983 Z"
      />
      <path
        id="path3228"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 184.679993 L 450.589996 184.899994 L 450.589996 183.940002 L 449.910004 183.710022 L 449.910004 184.679993 Z"
      />
      <path
        id="path3229"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 186.450012 L 450.589996 186.640015 L 450.589996 185.669983 L 449.910004 185.460022 L 449.910004 186.450012 Z"
      />
      <path
        id="path3230"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 189.970001 L 450.589996 190.140015 L 450.589996 189.140015 L 449.910004 188.950012 L 449.910004 189.970001 Z"
      />
      <path
        id="path3231"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 193.5 L 450.589996 193.640015 L 450.589996 192.600006 L 449.910004 192.450012 L 449.910004 193.5 Z"
      />
      <path
        id="path3232"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 195.26001 L 450.589996 195.390015 L 450.589996 194.339996 L 449.910004 194.200012 L 449.910004 195.26001 Z"
      />
      <path
        id="path3233"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 198.789978 L 450.589996 198.890015 L 450.589996 197.809998 L 449.910004 197.690002 L 449.910004 198.789978 Z"
      />
      <path
        id="path3234"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 202.309998 L 450.589996 202.390015 L 450.589996 201.27002 L 449.910004 201.190002 L 449.910004 202.309998 Z"
      />
      <path
        id="path3235"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 204.070007 L 450.589996 204.140015 L 450.589996 203.01001 L 449.910004 202.940002 L 449.910004 204.070007 Z"
      />
      <path
        id="path3236"
        fill="#cecece"
        stroke="none"
        d="M 449.920013 208.600006 L 450.600006 208.640015 L 450.600006 207.47998 L 449.920013 207.440002 L 449.920013 208.600006 Z"
      />
      <path
        id="path3237"
        fill="#cecece"
        stroke="none"
        d="M 449.910004 209.359985 L 450.579987 209.390015 L 450.579987 208.210022 L 449.910004 208.179993 L 449.910004 209.359985 Z"
      />
      <path
        id="path3238"
        fill="#cecece"
        stroke="none"
        d="M 450.589996 211.679993 L 449.910004 211.679993 L 449.910004 212.890015 L 450.589996 212.890015 L 450.589996 211.679993 Z"
      />
      <path
        id="path3239"
        fill="#cecece"
        stroke="none"
        d="M 449.5 150.320007 L 448.799988 149.830017 L 448.799988 150.529999 L 449.5 150.98999 L 449.5 150.320007 Z"
      />
      <path
        id="path3240"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 152.309998 L 449.5 152.76001 L 449.5 152.080017 L 448.799988 151.600006 L 448.799988 152.309998 Z"
      />
      <path
        id="path3241"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 154.089996 L 449.5 154.529999 L 449.5 153.830017 L 448.799988 153.359985 L 448.799988 154.089996 Z"
      />
      <path
        id="path3242"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 155.869995 L 449.5 156.299988 L 449.5 155.580017 L 448.799988 155.130005 L 448.799988 155.869995 Z"
      />
      <path
        id="path3243"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 157.649994 L 449.5 158.059998 L 449.5 157.330017 L 448.799988 156.899994 L 448.799988 157.649994 Z"
      />
      <path
        id="path3244"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 159.429993 L 449.5 159.830017 L 449.5 159.089996 L 448.799988 158.660004 L 448.799988 159.429993 Z"
      />
      <path
        id="path3245"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 161.220001 L 449.5 161.600006 L 449.5 160.839996 L 448.799988 160.429993 L 448.799988 161.220001 Z"
      />
      <path
        id="path3246"
        fill="#cecece"
        stroke="none"
        d="M 448.799988 163 L 449.5 163.369995 L 449.5 162.589996 L 448.799988 162.200012 L 448.799988 163 Z"
      />
      <path
        id="path3247"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 164.779999 L 449.5 165.140015 L 449.5 164.350006 L 448.809998 163.960022 L 448.809998 164.779999 Z"
      />
      <path
        id="path3248"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 166.559998 L 449.5 166.910004 L 449.5 166.100006 L 448.809998 165.72998 L 448.809998 166.559998 Z"
      />
      <path
        id="path3249"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 168.339996 L 449.5 168.669983 L 449.5 167.850006 L 448.809998 167.5 L 448.809998 168.339996 Z"
      />
      <path
        id="path3250"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 170.130005 L 449.5 170.440002 L 449.5 169.609985 L 448.809998 169.27002 L 448.809998 170.130005 Z"
      />
      <path
        id="path3251"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 171.910004 L 449.5 172.210022 L 449.5 171.359985 L 448.809998 171.029999 L 448.809998 171.910004 Z"
      />
      <path
        id="path3252"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 173.690002 L 449.5 173.97998 L 449.5 173.109985 L 448.809998 172.799988 L 448.809998 173.690002 Z"
      />
      <path
        id="path3253"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 175.470001 L 449.5 175.75 L 449.5 174.859985 L 448.809998 174.570007 L 448.809998 175.470001 Z"
      />
      <path
        id="path3254"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 177.25 L 449.5 177.52002 L 449.5 176.619995 L 448.809998 176.330017 L 448.809998 177.25 Z"
      />
      <path
        id="path3255"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 179.029999 L 449.5 179.289978 L 449.5 178.369995 L 448.809998 178.100006 L 448.809998 179.029999 Z"
      />
      <path
        id="path3256"
        fill="#cecece"
        stroke="none"
        d="M 448.809998 180.820007 L 449.5 181.049988 L 449.5 180.119995 L 448.809998 179.869995 L 448.809998 180.820007 Z"
      />
      <path
        id="path3257"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 184.380005 L 449.5 184.589996 L 449.5 183.630005 L 448.820007 183.399994 L 448.820007 184.380005 Z"
      />
      <path
        id="path3258"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 186.160004 L 449.5 186.359985 L 449.5 185.380005 L 448.820007 185.169983 L 448.820007 186.160004 Z"
      />
      <path
        id="path3259"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 189.720001 L 449.5 189.899994 L 449.5 188.890015 L 448.820007 188.700012 L 448.820007 189.720001 Z"
      />
      <path
        id="path3260"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 191.51001 L 449.5 191.660004 L 449.5 190.640015 L 448.820007 190.470001 L 448.820007 191.51001 Z"
      />
      <path
        id="path3261"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 193.289978 L 449.5 193.429993 L 449.5 192.390015 L 448.820007 192.23999 L 448.820007 193.289978 Z"
      />
      <path
        id="path3262"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 196.850006 L 449.51001 196.970001 L 449.51001 195.899994 L 448.820007 195.77002 L 448.820007 196.850006 Z"
      />
      <path
        id="path3263"
        fill="#cecece"
        stroke="none"
        d="M 448.820007 198.630005 L 449.51001 198.73999 L 449.51001 197.649994 L 448.820007 197.539978 L 448.820007 198.630005 Z"
      />
      <path
        id="path3264"
        fill="#cecece"
        stroke="none"
        d="M 448.829987 200.410004 L 449.51001 200.51001 L 449.51001 199.410004 L 448.829987 199.309998 L 448.829987 200.410004 Z"
      />
      <path
        id="path3265"
        fill="#cecece"
        stroke="none"
        d="M 448.829987 203.97998 L 449.51001 204.039978 L 449.51001 202.910004 L 448.829987 202.839996 L 448.829987 203.97998 Z"
      />
      <path
        id="path3266"
        fill="#cecece"
        stroke="none"
        d="M 448.829987 207.539978 L 449.51001 207.580017 L 449.51001 206.419983 L 448.829987 206.369995 L 448.829987 207.539978 Z"
      />
      <path
        id="path3267"
        fill="#cecece"
        stroke="none"
        d="M 440.769989 149.880005 L 439.839996 150.359985 L 439.839996 149.460022 L 440.769989 149 L 440.769989 149.880005 Z"
      />
      <path
        id="path3268"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 152.140015 L 440.769989 151.679993 L 440.769989 150.789978 L 439.839996 151.23999 L 439.839996 152.140015 Z"
      />
      <path
        id="path3269"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 153.929993 L 440.769989 153.47998 L 440.769989 152.580017 L 439.839996 153.01001 L 439.839996 153.929993 Z"
      />
      <path
        id="path3270"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 155.720001 L 440.769989 155.279999 L 440.769989 154.380005 L 439.839996 154.789978 L 439.839996 155.720001 Z"
      />
      <path
        id="path3271"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 157.5 L 440.779999 157.080017 L 440.779999 156.169983 L 439.839996 156.570007 L 439.839996 157.5 Z"
      />
      <path
        id="path3272"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 159.289978 L 440.779999 158.880005 L 440.779999 157.960022 L 439.839996 158.350006 L 439.839996 159.289978 Z"
      />
      <path
        id="path3273"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 161.080017 L 440.779999 160.679993 L 440.779999 159.75 L 439.839996 160.119995 L 439.839996 161.080017 Z"
      />
      <path
        id="path3274"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 162.859985 L 440.779999 162.47998 L 440.779999 161.539978 L 439.839996 161.899994 L 439.839996 162.859985 Z"
      />
      <path
        id="path3275"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 164.649994 L 440.779999 164.279999 L 440.779999 163.330017 L 439.839996 163.679993 L 439.839996 164.649994 Z"
      />
      <path
        id="path3276"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 166.440002 L 440.779999 166.089996 L 440.779999 165.119995 L 439.839996 165.460022 L 439.839996 166.440002 Z"
      />
      <path
        id="path3277"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 168.220001 L 440.779999 167.880005 L 440.779999 166.910004 L 439.839996 167.23999 L 439.839996 168.220001 Z"
      />
      <path
        id="path3278"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 170.01001 L 440.779999 169.679993 L 440.779999 168.700012 L 439.839996 169.01001 L 439.839996 170.01001 Z"
      />
      <path
        id="path3279"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 171.799988 L 440.779999 171.47998 L 440.779999 170.48999 L 439.839996 170.789978 L 439.839996 171.799988 Z"
      />
      <path
        id="path3280"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 173.580017 L 440.779999 173.289978 L 440.779999 172.279999 L 439.839996 172.570007 L 439.839996 173.580017 Z"
      />
      <path
        id="path3281"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 175.369995 L 440.779999 175.089996 L 440.779999 174.070007 L 439.839996 174.350006 L 439.839996 175.369995 Z"
      />
      <path
        id="path3282"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 178.940002 L 440.779999 178.690002 L 440.779999 177.649994 L 439.839996 177.899994 L 439.839996 178.940002 Z"
      />
      <path
        id="path3283"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 180.72998 L 440.779999 180.48999 L 440.779999 179.440002 L 439.839996 179.679993 L 439.839996 180.72998 Z"
      />
      <path
        id="path3284"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 182.52002 L 440.779999 182.289978 L 440.779999 181.23999 L 439.839996 181.460022 L 439.839996 182.52002 Z"
      />
      <path
        id="path3285"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 184.299988 L 440.779999 184.089996 L 440.779999 183.029999 L 439.839996 183.22998 L 439.839996 184.299988 Z"
      />
      <path
        id="path3286"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 186.089996 L 440.790009 185.890015 L 440.790009 184.820007 L 439.839996 185.01001 L 439.839996 186.089996 Z"
      />
      <path
        id="path3287"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 187.869995 L 440.790009 187.690002 L 440.790009 186.609985 L 439.839996 186.789978 L 439.839996 187.869995 Z"
      />
      <path
        id="path3288"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 189.660004 L 440.790009 189.48999 L 440.790009 188.399994 L 439.839996 188.570007 L 439.839996 189.660004 Z"
      />
      <path
        id="path3289"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 193.22998 L 440.790009 193.089996 L 440.790009 191.97998 L 439.839996 192.119995 L 439.839996 193.22998 Z"
      />
      <path
        id="path3290"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 195.02002 L 440.790009 194.890015 L 440.790009 193.77002 L 439.839996 193.899994 L 439.839996 195.02002 Z"
      />
      <path
        id="path3291"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 196.809998 L 440.790009 196.690002 L 440.790009 195.559998 L 439.839996 195.679993 L 439.839996 196.809998 Z"
      />
      <path
        id="path3292"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 198.589996 L 440.790009 198.48999 L 440.790009 197.350006 L 439.839996 197.450012 L 439.839996 198.589996 Z"
      />
      <path
        id="path3293"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 200.380005 L 440.790009 200.289978 L 440.790009 199.140015 L 439.839996 199.22998 L 439.839996 200.380005 Z"
      />
      <path
        id="path3294"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 205.73999 L 440.790009 205.690002 L 440.790009 204.51001 L 439.839996 204.570007 L 439.839996 205.73999 Z"
      />
      <path
        id="path3295"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 207.529999 L 440.790009 207.48999 L 440.790009 206.299988 L 439.839996 206.339996 L 439.839996 207.529999 Z"
      />
      <path
        id="path3296"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 211.100006 L 440.790009 211.089996 L 440.790009 209.890015 L 439.839996 209.899994 L 439.839996 211.100006 Z"
      />
      <path
        id="path3297"
        fill="#cecece"
        stroke="none"
        d="M 439.390015 150.580017 L 438.619995 151.089996 L 438.619995 150.279999 L 439.390015 149.720001 L 439.390015 150.580017 Z"
      />
      <path
        id="path3298"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 152.859985 L 439.390015 152.359985 L 439.390015 151.48999 L 438.609985 152.029999 L 438.609985 152.859985 Z"
      />
      <path
        id="path3299"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 154.619995 L 439.390015 154.140015 L 439.390015 153.26001 L 438.609985 153.779999 L 438.609985 154.619995 Z"
      />
      <path
        id="path3300"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 156.390015 L 439.399994 155.919983 L 439.399994 155.029999 L 438.609985 155.539978 L 438.609985 156.390015 Z"
      />
      <path
        id="path3301"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 158.160004 L 439.399994 157.700012 L 439.399994 156.799988 L 438.609985 157.289978 L 438.609985 158.160004 Z"
      />
      <path
        id="path3302"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 159.919983 L 439.399994 159.47998 L 439.399994 158.570007 L 438.609985 159.049988 L 438.609985 159.919983 Z"
      />
      <path
        id="path3303"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 161.690002 L 439.399994 161.26001 L 439.399994 160.339996 L 438.609985 160.799988 L 438.609985 161.690002 Z"
      />
      <path
        id="path3304"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 163.450012 L 439.399994 163.039978 L 439.399994 162.109985 L 438.609985 162.559998 L 438.609985 163.450012 Z"
      />
      <path
        id="path3305"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 165.220001 L 439.399994 164.820007 L 439.399994 163.880005 L 438.609985 164.309998 L 438.609985 165.220001 Z"
      />
      <path
        id="path3306"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 166.97998 L 439.399994 166.600006 L 439.399994 165.649994 L 438.609985 166.059998 L 438.609985 166.97998 Z"
      />
      <path
        id="path3307"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 168.75 L 439.399994 168.380005 L 439.399994 167.419983 L 438.609985 167.820007 L 438.609985 168.75 Z"
      />
      <path
        id="path3308"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 174.049988 L 439.410004 173.720001 L 439.410004 172.72998 L 438.609985 173.080017 L 438.609985 174.049988 Z"
      />
      <path
        id="path3309"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 175.809998 L 439.410004 175.5 L 439.410004 174.5 L 438.609985 174.839996 L 438.609985 175.809998 Z"
      />
      <path
        id="path3310"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 177.580017 L 439.410004 177.279999 L 439.410004 176.27002 L 438.609985 176.589996 L 438.609985 177.580017 Z"
      />
      <path
        id="path3311"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 179.339996 L 439.410004 179.059998 L 439.410004 178.039978 L 438.609985 178.339996 L 438.609985 179.339996 Z"
      />
      <path
        id="path3312"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 181.109985 L 439.410004 180.839996 L 439.410004 179.809998 L 438.609985 180.100006 L 438.609985 181.109985 Z"
      />
      <path
        id="path3313"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 182.869995 L 439.410004 182.619995 L 439.410004 181.580017 L 438.609985 181.850006 L 438.609985 182.869995 Z"
      />
      <path
        id="path3314"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 184.640015 L 439.410004 184.399994 L 439.410004 183.350006 L 438.609985 183.609985 L 438.609985 184.640015 Z"
      />
      <path
        id="path3315"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 188.169983 L 439.420013 187.960022 L 439.420013 186.890015 L 438.609985 187.119995 L 438.609985 188.169983 Z"
      />
      <path
        id="path3316"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 191.700012 L 439.420013 191.52002 L 439.420013 190.429993 L 438.609985 190.619995 L 438.609985 191.700012 Z"
      />
      <path
        id="path3317"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 195.22998 L 439.420013 195.080017 L 439.420013 193.970001 L 438.609985 194.130005 L 438.609985 195.22998 Z"
      />
      <path
        id="path3318"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 198.76001 L 439.420013 198.649994 L 439.420013 197.51001 L 438.609985 197.640015 L 438.609985 198.76001 Z"
      />
      <path
        id="path3319"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 200.529999 L 439.420013 200.429993 L 439.420013 199.279999 L 438.609985 199.399994 L 438.609985 200.529999 Z"
      />
      <path
        id="path3320"
        fill="#cecece"
        stroke="none"
        d="M 438.600006 204.559998 L 439.410004 204.48999 L 439.410004 203.330017 L 438.600006 203.410004 L 438.600006 204.559998 Z"
      />
      <path
        id="path3321"
        fill="#cecece"
        stroke="none"
        d="M 438.609985 205.820007 L 439.429993 205.77002 L 439.429993 204.600006 L 438.609985 204.660004 L 438.609985 205.820007 Z"
      />
      <path
        id="path3322"
        fill="#cecece"
        stroke="none"
        d="M 438.23999 151.330017 L 437.600006 151.839996 L 437.600006 151.089996 L 438.23999 150.559998 L 438.23999 151.330017 Z"
      />
      <path
        id="path3323"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 153.589996 L 438.23999 153.089996 L 438.23999 152.309998 L 437.600006 152.820007 L 437.600006 153.589996 Z"
      />
      <path
        id="path3324"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 155.330017 L 438.23999 154.850006 L 438.23999 154.049988 L 437.600006 154.559998 L 437.600006 155.330017 Z"
      />
      <path
        id="path3325"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 157.070007 L 438.23999 156.609985 L 438.23999 155.799988 L 437.600006 156.289978 L 437.600006 157.070007 Z"
      />
      <path
        id="path3326"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 160.559998 L 438.23999 160.119995 L 438.23999 159.289978 L 437.600006 159.75 L 437.600006 160.559998 Z"
      />
      <path
        id="path3327"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 162.309998 L 438.23999 161.880005 L 438.23999 161.039978 L 437.600006 161.47998 L 437.600006 162.309998 Z"
      />
      <path
        id="path3328"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 164.049988 L 438.23999 163.640015 L 438.23999 162.779999 L 437.600006 163.210022 L 437.600006 164.049988 Z"
      />
      <path
        id="path3329"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 165.799988 L 438.23999 165.399994 L 438.23999 164.529999 L 437.600006 164.940002 L 437.600006 165.799988 Z"
      />
      <path
        id="path3330"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 167.539978 L 438.23999 167.160004 L 438.23999 166.279999 L 437.600006 166.669983 L 437.600006 167.539978 Z"
      />
      <path
        id="path3331"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 169.279999 L 438.23999 168.919983 L 438.23999 168.02002 L 437.600006 168.399994 L 437.600006 169.279999 Z"
      />
      <path
        id="path3332"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 171.029999 L 438.23999 170.679993 L 438.23999 169.77002 L 437.600006 170.130005 L 437.600006 171.029999 Z"
      />
      <path
        id="path3333"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 172.77002 L 438.23999 172.440002 L 438.23999 171.51001 L 437.600006 171.859985 L 437.600006 172.77002 Z"
      />
      <path
        id="path3334"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 176.26001 L 438.23999 175.950012 L 438.23999 175.01001 L 437.600006 175.330017 L 437.600006 176.26001 Z"
      />
      <path
        id="path3335"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 181.48999 L 438.23999 181.22998 L 438.23999 180.23999 L 437.600006 180.52002 L 437.600006 181.48999 Z"
      />
      <path
        id="path3336"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 183.23999 L 438.23999 182.98999 L 438.23999 181.98999 L 437.600006 182.25 L 437.600006 183.23999 Z"
      />
      <path
        id="path3337"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 188.470001 L 438.23999 188.26001 L 438.23999 187.22998 L 437.600006 187.440002 L 437.600006 188.470001 Z"
      />
      <path
        id="path3338"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 190.210022 L 438.23999 190.02002 L 438.23999 188.97998 L 437.600006 189.169983 L 437.600006 190.210022 Z"
      />
      <path
        id="path3339"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 191.960022 L 438.23999 191.779999 L 438.23999 190.720001 L 437.600006 190.910004 L 437.600006 191.960022 Z"
      />
      <path
        id="path3340"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 197.190002 L 438.23999 197.059998 L 438.23999 195.960022 L 437.600006 196.100006 L 437.600006 197.190002 Z"
      />
      <path
        id="path3341"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 198.929993 L 438.23999 198.820007 L 438.23999 197.710022 L 437.600006 197.830017 L 437.600006 198.929993 Z"
      />
      <path
        id="path3342"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 205.910004 L 438.23999 205.850006 L 438.23999 204.690002 L 437.600006 204.75 L 437.600006 205.910004 Z"
      />
      <path
        id="path3343"
        fill="#cecece"
        stroke="none"
        d="M 437.600006 211.140015 L 438.23999 211.130005 L 438.23999 209.929993 L 437.600006 209.950012 L 437.600006 211.140015 Z"
      />
      <path
        id="path3344"
        fill="#cecece"
        stroke="none"
        d="M 437.290009 152.039978 L 436.76001 152.460022 L 436.76001 151.77002 L 437.290009 151.320007 L 437.290009 152.039978 Z"
      />
      <path
        id="path3345"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 154.190002 L 437.290009 153.779999 L 437.290009 153.049988 L 436.76001 153.47998 L 436.76001 154.190002 Z"
      />
      <path
        id="path3346"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 155.919983 L 437.290009 155.51001 L 437.290009 154.77002 L 436.76001 155.190002 L 436.76001 155.919983 Z"
      />
      <path
        id="path3347"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 157.640015 L 437.290009 157.25 L 437.290009 156.5 L 436.76001 156.899994 L 436.76001 157.640015 Z"
      />
      <path
        id="path3348"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 159.369995 L 437.290009 158.98999 L 437.290009 158.220001 L 436.76001 158.609985 L 436.76001 159.369995 Z"
      />
      <path
        id="path3349"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 161.089996 L 437.290009 160.72998 L 437.290009 159.950012 L 436.76001 160.320007 L 436.76001 161.089996 Z"
      />
      <path
        id="path3350"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 162.820007 L 437.290009 162.470001 L 437.290009 161.669983 L 436.76001 162.039978 L 436.76001 162.820007 Z"
      />
      <path
        id="path3351"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 164.549988 L 437.290009 164.210022 L 437.290009 163.390015 L 436.76001 163.75 L 436.76001 164.549988 Z"
      />
      <path
        id="path3352"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 166.27002 L 437.290009 165.950012 L 437.290009 165.119995 L 436.76001 165.460022 L 436.76001 166.27002 Z"
      />
      <path
        id="path3353"
        fill="#cecece"
        stroke="none"
        d="M 436.76001 168 L 437.290009 167.679993 L 437.290009 166.839996 L 436.76001 167.169983 L 436.76001 168 Z"
      />
      <path
        id="path3354"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 171.450012 L 437.299988 171.160004 L 437.299988 170.289978 L 436.769989 170.589996 L 436.769989 171.450012 Z"
      />
      <path
        id="path3355"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 173.179993 L 437.299988 172.899994 L 437.299988 172.02002 L 436.769989 172.309998 L 436.769989 173.179993 Z"
      />
      <path
        id="path3356"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 174.910004 L 437.299988 174.640015 L 437.299988 173.73999 L 436.769989 174.02002 L 436.769989 174.910004 Z"
      />
      <path
        id="path3357"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 176.630005 L 437.299988 176.380005 L 437.299988 175.460022 L 436.769989 175.72998 L 436.769989 176.630005 Z"
      />
      <path
        id="path3358"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 178.359985 L 437.299988 178.119995 L 437.299988 177.190002 L 436.769989 177.440002 L 436.769989 178.359985 Z"
      />
      <path
        id="path3359"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 180.080017 L 437.299988 179.850006 L 437.299988 178.910004 L 436.769989 179.149994 L 436.769989 180.080017 Z"
      />
      <path
        id="path3360"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 181.809998 L 437.299988 181.589996 L 437.299988 180.640015 L 436.769989 180.869995 L 436.769989 181.809998 Z"
      />
      <path
        id="path3361"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 183.539978 L 437.299988 183.330017 L 437.299988 182.359985 L 436.769989 182.580017 L 436.769989 183.539978 Z"
      />
      <path
        id="path3362"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 185.26001 L 437.299988 185.070007 L 437.299988 184.089996 L 436.769989 184.289978 L 436.769989 185.26001 Z"
      />
      <path
        id="path3363"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 188.720001 L 437.299988 188.549988 L 437.299988 187.539978 L 436.769989 187.710022 L 436.769989 188.720001 Z"
      />
      <path
        id="path3364"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 195.619995 L 437.309998 195.5 L 437.309998 194.429993 L 436.769989 194.559998 L 436.769989 195.619995 Z"
      />
      <path
        id="path3365"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 197.350006 L 437.309998 197.23999 L 437.309998 196.160004 L 436.769989 196.27002 L 436.769989 197.350006 Z"
      />
      <path
        id="path3366"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 202.529999 L 437.309998 202.460022 L 437.309998 201.330017 L 436.769989 201.410004 L 436.769989 202.529999 Z"
      />
      <path
        id="path3367"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 204.25 L 437.309998 204.190002 L 437.309998 203.049988 L 436.769989 203.119995 L 436.769989 204.25 Z"
      />
      <path
        id="path3368"
        fill="#cecece"
        stroke="none"
        d="M 436.769989 207.710022 L 437.309998 207.669983 L 437.309998 206.5 L 436.769989 206.539978 L 436.769989 207.710022 Z"
      />
      <path
        id="path3369"
        fill="#cecece"
        stroke="none"
        d="M 437.320007 211.679993 L 436.779999 211.679993 L 436.779999 212.890015 L 437.320007 212.890015 L 437.320007 211.679993 Z"
      />
      <path
        id="path3370"
        fill="#cecece"
        stroke="none"
        d="M 436.429993 152.109985 L 436.070007 152.5 L 436.070007 152.950012 L 436.429993 152.640015 L 436.429993 152.109985 Z"
      />
      <path
        id="path3371"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 154.660004 L 436.429993 154.359985 L 436.429993 153.809998 L 436.070007 154.200012 L 436.070007 154.660004 Z"
      />
      <path
        id="path3372"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 156.380005 L 436.429993 156.080017 L 436.429993 155.51001 L 436.070007 155.890015 L 436.070007 156.380005 Z"
      />
      <path
        id="path3373"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 158.089996 L 436.429993 157.799988 L 436.429993 157.210022 L 436.070007 157.580017 L 436.070007 158.089996 Z"
      />
      <path
        id="path3374"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 159.799988 L 436.429993 159.52002 L 436.429993 158.910004 L 436.070007 159.27002 L 436.070007 159.799988 Z"
      />
      <path
        id="path3375"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 161.51001 L 436.429993 161.23999 L 436.429993 160.619995 L 436.070007 160.960022 L 436.070007 161.51001 Z"
      />
      <path
        id="path3376"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 163.22998 L 436.429993 162.970001 L 436.429993 162.320007 L 436.070007 162.649994 L 436.070007 163.22998 Z"
      />
      <path
        id="path3377"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 164.940002 L 436.440002 164.690002 L 436.440002 164.02002 L 436.070007 164.339996 L 436.070007 164.940002 Z"
      />
      <path
        id="path3378"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 166.649994 L 436.440002 166.410004 L 436.440002 165.720001 L 436.070007 166.029999 L 436.070007 166.649994 Z"
      />
      <path
        id="path3379"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 168.359985 L 436.440002 168.130005 L 436.440002 167.419983 L 436.070007 167.720001 L 436.070007 168.359985 Z"
      />
      <path
        id="path3380"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 170.080017 L 436.440002 169.850006 L 436.440002 169.130005 L 436.070007 169.410004 L 436.070007 170.080017 Z"
      />
      <path
        id="path3381"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 171.789978 L 436.440002 171.570007 L 436.440002 170.830017 L 436.070007 171.100006 L 436.070007 171.789978 Z"
      />
      <path
        id="path3382"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 173.5 L 436.440002 173.289978 L 436.440002 172.529999 L 436.070007 172.789978 L 436.070007 173.5 Z"
      />
      <path
        id="path3383"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 175.210022 L 436.440002 175.02002 L 436.440002 174.22998 L 436.070007 174.47998 L 436.070007 175.210022 Z"
      />
      <path
        id="path3384"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 176.929993 L 436.440002 176.73999 L 436.440002 175.929993 L 436.070007 176.169983 L 436.070007 176.929993 Z"
      />
      <path
        id="path3385"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 178.640015 L 436.440002 178.460022 L 436.440002 177.640015 L 436.070007 177.859985 L 436.070007 178.640015 Z"
      />
      <path
        id="path3386"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 180.350006 L 436.440002 180.179993 L 436.440002 179.339996 L 436.070007 179.549988 L 436.070007 180.350006 Z"
      />
      <path
        id="path3387"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 182.059998 L 436.440002 181.899994 L 436.440002 181.039978 L 436.070007 181.23999 L 436.070007 182.059998 Z"
      />
      <path
        id="path3388"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 185.48999 L 436.450012 185.339996 L 436.450012 184.440002 L 436.070007 184.630005 L 436.070007 185.48999 Z"
      />
      <path
        id="path3389"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 188.910004 L 436.450012 188.789978 L 436.450012 187.850006 L 436.070007 188.01001 L 436.070007 188.910004 Z"
      />
      <path
        id="path3390"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 190.619995 L 436.450012 190.51001 L 436.450012 189.549988 L 436.070007 189.700012 L 436.070007 190.619995 Z"
      />
      <path
        id="path3391"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 192.339996 L 436.450012 192.22998 L 436.450012 191.25 L 436.070007 191.390015 L 436.070007 192.339996 Z"
      />
      <path
        id="path3392"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 195.76001 L 436.450012 195.669983 L 436.450012 194.660004 L 436.070007 194.77002 L 436.070007 195.76001 Z"
      />
      <path
        id="path3393"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 197.470001 L 436.450012 197.390015 L 436.450012 196.359985 L 436.070007 196.460022 L 436.070007 197.470001 Z"
      />
      <path
        id="path3394"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 200.899994 L 436.459991 200.839996 L 436.459991 199.76001 L 436.070007 199.839996 L 436.070007 200.899994 Z"
      />
      <path
        id="path3395"
        fill="#cecece"
        stroke="none"
        d="M 436.070007 204.320007 L 436.459991 204.279999 L 436.459991 203.169983 L 436.070007 203.220001 L 436.070007 204.320007 Z"
      />
      <path
        id="path3396"
        fill="#cecece"
        stroke="none"
        d="M 444.98999 148.529999 L 444.98999 149.350006 L 445.980011 149.48999 L 445.980011 148.710022 C 445.980011 148.710022 445.230011 148.559998 444.98999 148.52002 L 444.98999 148.529999 Z"
      />
      <path
        id="path3397"
        fill="#cecece"
        stroke="none"
        d="M 444.98999 151.169983 L 445.980011 151.309998 L 445.980011 150.52002 C 445.980011 150.52002 445.230011 150.380005 444.98999 150.339996 L 444.98999 151.169983 Z"
      />
      <path
        id="path3398"
        fill="#cecece"
        stroke="none"
        d="M 445 152.97998 L 445.980011 153.109985 L 445.980011 152.309998 C 445.980011 152.309998 445.220001 152.169983 445 152.130005 L 445 152.97998 Z"
      />
      <path
        id="path3399"
        fill="#cecece"
        stroke="none"
        d="M 445 154.799988 L 445.980011 154.929993 L 445.980011 154.109985 C 445.980011 154.109985 445.220001 153.97998 445 153.940002 L 445 154.799988 Z"
      />
      <path
        id="path3400"
        fill="#cecece"
        stroke="none"
        d="M 445 156.609985 L 445.980011 156.72998 L 445.980011 155.899994 C 445.980011 155.899994 445.209991 155.77002 445 155.73999 L 445 156.609985 Z"
      />
      <path
        id="path3401"
        fill="#cecece"
        stroke="none"
        d="M 445 158.429993 L 445.980011 158.549988 L 445.980011 157.710022 C 445.980011 157.710022 445.209991 157.580017 445 157.549988 L 445 158.429993 Z"
      />
      <path
        id="path3402"
        fill="#cecece"
        stroke="none"
        d="M 445 160.23999 L 445.980011 160.359985 L 445.980011 159.51001 C 445.980011 159.51001 445.200012 159.390015 445 159.359985 L 445 160.25 L 445 160.23999 Z"
      />
      <path
        id="path3403"
        fill="#cecece"
        stroke="none"
        d="M 445 162.059998 L 445.970001 162.169983 L 445.970001 161.299988 C 445.970001 161.299988 445.190002 161.179993 445 161.149994 L 445 162.049988 L 445 162.059998 Z"
      />
      <path
        id="path3404"
        fill="#cecece"
        stroke="none"
        d="M 445 163.869995 L 445.970001 163.97998 L 445.970001 163.100006 C 445.970001 163.100006 445.179993 162.98999 445 162.960022 L 445 163.869995 Z"
      />
      <path
        id="path3405"
        fill="#cecece"
        stroke="none"
        d="M 445 165.690002 L 445.970001 165.799988 L 445.970001 164.910004 C 445.970001 164.910004 445.179993 164.799988 445 164.77002 L 445 165.690002 Z"
      />
      <path
        id="path3406"
        fill="#cecece"
        stroke="none"
        d="M 445 167.51001 L 445.970001 167.609985 L 445.970001 166.710022 C 445.970001 166.710022 445.170013 166.609985 445 166.580017 L 445 167.51001 Z"
      />
      <path
        id="path3407"
        fill="#cecece"
        stroke="none"
        d="M 445 169.320007 L 445.970001 169.419983 L 445.970001 168.51001 C 445.970001 168.51001 445.170013 168.410004 445 168.380005 L 445 169.330017 L 445 169.320007 Z"
      />
      <path
        id="path3408"
        fill="#cecece"
        stroke="none"
        d="M 445 171.140015 L 445.970001 171.22998 L 445.970001 170.299988 C 445.970001 170.299988 445.160004 170.200012 445 170.179993 L 445 171.140015 Z"
      />
      <path
        id="path3409"
        fill="#cecece"
        stroke="none"
        d="M 445 172.950012 L 445.959991 173.039978 L 445.959991 172.100006 C 445.959991 172.100006 445.149994 172.01001 445 171.97998 L 445 172.950012 Z"
      />
      <path
        id="path3410"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 174.77002 L 445.970001 174.850006 L 445.970001 173.899994 C 445.970001 173.899994 445.149994 173.809998 445.01001 173.789978 L 445.01001 174.77002 Z"
      />
      <path
        id="path3411"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 176.580017 L 445.970001 176.660004 L 445.970001 175.700012 C 445.970001 175.700012 445.149994 175.619995 445.01001 175.589996 L 445.01001 176.580017 Z"
      />
      <path
        id="path3412"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 178.399994 L 445.970001 178.47998 L 445.970001 177.5 C 445.970001 177.5 445.140015 177.419983 445.01001 177.399994 L 445.01001 178.399994 Z"
      />
      <path
        id="path3413"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 180.210022 L 445.970001 180.279999 L 445.970001 179.289978 C 445.970001 179.289978 445.140015 179.210022 445.01001 179.190002 L 445.01001 180.200012 L 445.01001 180.210022 Z"
      />
      <path
        id="path3414"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 182.029999 L 445.959991 182.100006 L 445.959991 181.100006 C 445.959991 181.100006 445.119995 181.029999 445.01001 181.01001 L 445.01001 182.029999 Z"
      />
      <path
        id="path3415"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 183.839996 L 445.959991 183.899994 L 445.959991 182.890015 C 445.959991 182.890015 445.119995 182.820007 445.01001 182.799988 L 445.01001 183.830017 L 445.01001 183.839996 Z"
      />
      <path
        id="path3416"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 185.660004 L 445.959991 185.720001 L 445.959991 184.690002 C 445.959991 184.690002 445.109985 184.630005 445.01001 184.609985 L 445.01001 185.660004 Z"
      />
      <path
        id="path3417"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 187.470001 L 445.959991 187.529999 L 445.959991 186.48999 C 445.959991 186.48999 445.109985 186.429993 445.01001 186.419983 L 445.01001 187.47998 L 445.01001 187.470001 Z"
      />
      <path
        id="path3418"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 189.289978 L 445.959991 189.339996 L 445.959991 188.289978 C 445.959991 188.289978 445.100006 188.23999 445.01001 188.220001 L 445.01001 189.289978 Z"
      />
      <path
        id="path3419"
        fill="#cecece"
        stroke="none"
        d="M 445.01001 192.919983 L 445.950012 192.960022 L 445.950012 191.890015 C 445.950012 191.890015 445.079987 191.839996 445.01001 191.830017 L 445.01001 192.919983 Z"
      />
      <path
        id="path3420"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 194.72998 L 445.959991 194.77002 L 445.959991 193.679993 C 445.959991 193.679993 445.089996 193.640015 445.019989 193.630005 L 445.019989 194.72998 Z"
      />
      <path
        id="path3421"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 196.549988 L 445.959991 196.589996 L 445.959991 195.48999 C 445.959991 195.48999 445.079987 195.450012 445.019989 195.440002 L 445.019989 196.549988 Z"
      />
      <path
        id="path3422"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 198.359985 L 445.959991 198.390015 L 445.959991 197.279999 C 445.959991 197.279999 445.079987 197.25 445.019989 197.23999 L 445.019989 198.359985 Z"
      />
      <path
        id="path3423"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 200.179993 L 445.950012 200.210022 L 445.950012 199.089996 C 445.950012 199.089996 445.059998 199.059998 445.019989 199.049988 L 445.019989 200.179993 Z"
      />
      <path
        id="path3424"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 203.809998 L 445.950012 203.830017 L 445.950012 202.679993 C 445.950012 202.679993 445.049988 202.660004 445.019989 202.649994 L 445.019989 203.799988 L 445.019989 203.809998 Z"
      />
      <path
        id="path3425"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 207.440002 L 445.950012 207.440002 L 445.950012 206.279999 C 445.950012 206.279999 445.040009 206.27002 445.019989 206.26001 L 445.019989 207.440002 Z"
      />
      <path
        id="path3426"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 211.070007 L 445.940002 211.070007 L 445.940002 209.880005 L 445.019989 209.880005 L 445.019989 211.080017 L 445.019989 211.070007 Z"
      />
      <path
        id="path3427"
        fill="#cecece"
        stroke="none"
        d="M 444.399994 148.51001 C 444.399994 148.51001 443.529999 148.419983 443.119995 148.51001 L 443.119995 149.380005 L 444.399994 149.380005 L 444.399994 148.51001 Z"
      />
      <path
        id="path3428"
        fill="#cecece"
        stroke="none"
        d="M 443.119995 151.200012 L 444.399994 151.200012 L 444.399994 150.320007 C 444.399994 150.320007 443.519989 150.22998 443.119995 150.320007 L 443.119995 151.200012 Z"
      />
      <path
        id="path3429"
        fill="#cecece"
        stroke="none"
        d="M 443.119995 153.01001 L 444.399994 153.01001 L 444.399994 152.119995 C 444.399994 152.119995 443.51001 152.029999 443.119995 152.119995 L 443.119995 153.01001 Z"
      />
      <path
        id="path3430"
        fill="#cecece"
        stroke="none"
        d="M 443.130005 154.830017 L 444.399994 154.830017 L 444.399994 153.929993 C 444.399994 153.929993 443.5 153.850006 443.130005 153.929993 L 443.130005 154.830017 Z"
      />
      <path
        id="path3431"
        fill="#cecece"
        stroke="none"
        d="M 443.130005 156.640015 L 444.399994 156.640015 L 444.399994 155.72998 C 444.399994 155.72998 443.48999 155.649994 443.130005 155.72998 L 443.130005 156.640015 Z"
      />
      <path
        id="path3432"
        fill="#cecece"
        stroke="none"
        d="M 443.130005 158.450012 L 444.399994 158.450012 L 444.399994 157.529999 C 444.399994 157.529999 443.480011 157.450012 443.130005 157.529999 L 443.130005 158.450012 Z"
      />
      <path
        id="path3433"
        fill="#cecece"
        stroke="none"
        d="M 443.130005 162.080017 L 444.399994 162.080017 L 444.399994 161.140015 C 444.399994 161.140015 443.459991 161.070007 443.130005 161.140015 L 443.130005 162.080017 Z"
      />
      <path
        id="path3434"
        fill="#cecece"
        stroke="none"
        d="M 443.130005 163.899994 L 444.390015 163.899994 L 444.390015 162.950012 C 444.390015 162.950012 443.440002 162.880005 443.130005 162.950012 L 443.130005 163.899994 Z"
      />
      <path
        id="path3435"
        fill="#cecece"
        stroke="none"
        d="M 443.130005 165.710022 L 444.390015 165.710022 L 444.390015 164.75 C 444.390015 164.75 443.429993 164.679993 443.130005 164.75 L 443.130005 165.710022 Z"
      />
      <path
        id="path3436"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 167.529999 L 444.399994 167.529999 L 444.399994 166.559998 C 444.399994 166.559998 443.429993 166.5 443.140015 166.559998 L 443.140015 167.529999 Z"
      />
      <path
        id="path3437"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 169.339996 L 444.399994 169.339996 L 444.399994 168.359985 C 444.399994 168.359985 443.429993 168.299988 443.140015 168.359985 L 443.140015 169.339996 Z"
      />
      <path
        id="path3438"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 171.160004 L 444.390015 171.160004 L 444.390015 170.169983 C 444.390015 170.169983 443.410004 170.109985 443.140015 170.169983 L 443.140015 171.160004 Z"
      />
      <path
        id="path3439"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 174.779999 L 444.390015 174.779999 L 444.390015 173.77002 C 444.390015 173.77002 443.390015 173.720001 443.140015 173.77002 L 443.140015 174.779999 Z"
      />
      <path
        id="path3440"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 176.600006 L 444.390015 176.600006 L 444.390015 175.580017 C 444.390015 175.580017 443.380005 175.529999 443.140015 175.580017 L 443.140015 176.600006 Z"
      />
      <path
        id="path3441"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 178.410004 L 444.390015 178.410004 L 444.390015 177.380005 C 444.390015 177.380005 443.369995 177.330017 443.140015 177.380005 L 443.140015 178.410004 Z"
      />
      <path
        id="path3442"
        fill="#cecece"
        stroke="none"
        d="M 443.140015 180.22998 L 444.380005 180.22998 L 444.380005 179.190002 C 444.380005 179.190002 443.350006 179.140015 443.140015 179.190002 L 443.140015 180.22998 Z"
      />
      <path
        id="path3443"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 182.039978 L 444.390015 182.039978 L 444.390015 180.98999 C 444.390015 180.98999 443.350006 180.950012 443.149994 180.98999 L 443.149994 182.039978 Z"
      />
      <path
        id="path3444"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 183.859985 L 444.390015 183.859985 L 444.390015 182.799988 C 444.390015 182.799988 443.339996 182.76001 443.149994 182.799988 L 443.149994 183.859985 Z"
      />
      <path
        id="path3445"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 185.669983 L 444.390015 185.669983 L 444.390015 184.600006 C 444.390015 184.600006 443.329987 184.559998 443.149994 184.600006 L 443.149994 185.669983 Z"
      />
      <path
        id="path3446"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 187.48999 L 444.390015 187.48999 L 444.390015 186.410004 C 444.390015 186.410004 443.320007 186.369995 443.149994 186.410004 L 443.149994 187.48999 Z"
      />
      <path
        id="path3447"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 189.299988 L 444.380005 189.299988 L 444.380005 188.220001 C 444.380005 188.220001 443.299988 188.190002 443.149994 188.220001 L 443.149994 189.299988 Z"
      />
      <path
        id="path3448"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 191.109985 L 444.380005 191.109985 L 444.380005 190.02002 C 444.380005 190.02002 443.290009 189.98999 443.149994 190.02002 L 443.149994 191.109985 Z"
      />
      <path
        id="path3449"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 192.929993 L 444.380005 192.929993 L 444.380005 191.830017 C 444.380005 191.830017 443.279999 191.799988 443.149994 191.830017 L 443.149994 192.929993 Z"
      />
      <path
        id="path3450"
        fill="#cecece"
        stroke="none"
        d="M 443.149994 194.73999 L 444.380005 194.73999 L 444.380005 193.630005 C 444.380005 193.630005 443.269989 193.600006 443.149994 193.630005 L 443.149994 194.73999 Z"
      />
      <path
        id="path3451"
        fill="#cecece"
        stroke="none"
        d="M 443.160004 198.369995 L 444.380005 198.369995 L 444.380005 197.23999 C 444.380005 197.23999 443.25 197.220001 443.160004 197.23999 L 443.160004 198.369995 Z"
      />
      <path
        id="path3452"
        fill="#cecece"
        stroke="none"
        d="M 443.160004 200.190002 L 444.380005 200.190002 L 444.380005 199.049988 C 444.380005 199.049988 443.23999 199.029999 443.160004 199.049988 L 443.160004 200.190002 Z"
      />
      <path
        id="path3453"
        fill="#cecece"
        stroke="none"
        d="M 443.160004 203.809998 L 444.380005 203.809998 L 444.380005 202.649994 C 444.380005 202.649994 443.220001 202.640015 443.160004 202.649994 L 443.160004 203.809998 Z"
      />
      <path
        id="path3454"
        fill="#cecece"
        stroke="none"
        d="M 443.160004 207.440002 L 444.369995 207.440002 L 444.369995 206.26001 C 444.369995 206.26001 443.190002 206.26001 443.160004 206.26001 L 443.160004 207.440002 Z"
      />
      <path
        id="path3455"
        fill="#cecece"
        stroke="none"
        d="M 443.170013 211.070007 L 444.380005 211.070007 L 444.380005 209.869995 C 444.380005 209.869995 443.179993 209.869995 443.170013 209.869995 L 443.170013 211.070007 Z"
      />
      <path
        id="path3456"
        fill="#cecece"
        stroke="none"
        d="M 444.380005 211.679993 L 443.170013 211.679993 L 443.170013 212.890015 L 444.380005 212.890015 L 444.380005 211.679993 Z"
      />
      <path
        id="path3457"
        fill="#cecece"
        stroke="none"
        d="M 442.540009 148.559998 C 442.540009 148.559998 441.730011 148.679993 441.399994 148.850006 L 441.399994 149.679993 C 441.399994 149.679993 442.369995 149.410004 442.540009 149.380005 L 442.540009 148.559998 Z"
      />
      <path
        id="path3458"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 151.48999 C 441.399994 151.48999 442.380005 151.22998 442.540009 151.200012 L 442.540009 150.369995 C 442.540009 150.369995 441.720001 150.47998 441.399994 150.649994 L 441.399994 151.48999 Z"
      />
      <path
        id="path3459"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 153.289978 C 441.399994 153.289978 442.380005 153.029999 442.540009 153.01001 L 442.540009 152.160004 C 442.540009 152.160004 441.709991 152.27002 441.399994 152.429993 L 441.399994 153.279999 L 441.399994 153.289978 Z"
      />
      <path
        id="path3460"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 155.100006 C 441.399994 155.100006 442.390015 154.850006 442.540009 154.830017 L 442.540009 153.970001 C 442.540009 153.970001 441.700012 154.080017 441.399994 154.22998 L 441.399994 155.100006 Z"
      />
      <path
        id="path3461"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 156.899994 C 441.399994 156.899994 442.390015 156.660004 442.540009 156.640015 L 442.540009 155.77002 C 442.540009 155.77002 441.690002 155.869995 441.399994 156.029999 L 441.399994 156.910004 L 441.399994 156.899994 Z"
      />
      <path
        id="path3462"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 158.710022 C 441.399994 158.710022 442.399994 158.47998 442.540009 158.450012 L 442.540009 157.570007 C 442.540009 157.570007 441.679993 157.669983 441.399994 157.820007 L 441.399994 158.710022 Z"
      />
      <path
        id="path3463"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 160.52002 C 441.399994 160.52002 442.399994 160.289978 442.540009 160.27002 L 442.540009 159.380005 C 442.540009 159.380005 441.670013 159.47998 441.399994 159.619995 L 441.399994 160.52002 Z"
      />
      <path
        id="path3464"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 162.320007 C 441.399994 162.320007 442.410004 162.100006 442.540009 162.080017 L 442.540009 161.179993 C 442.540009 161.179993 441.660004 161.27002 441.399994 161.410004 L 441.399994 162.320007 Z"
      />
      <path
        id="path3465"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 164.130005 C 441.399994 164.130005 442.410004 163.919983 442.540009 163.899994 L 442.540009 162.98999 C 442.540009 162.98999 441.649994 163.080017 441.399994 163.210022 L 441.399994 164.130005 Z"
      />
      <path
        id="path3466"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 165.929993 C 441.399994 165.929993 442.420013 165.72998 442.540009 165.710022 L 442.540009 164.789978 C 442.540009 164.789978 441.640015 164.880005 441.399994 165 L 441.399994 165.929993 Z"
      />
      <path
        id="path3467"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 167.73999 C 441.399994 167.73999 442.420013 167.549988 442.540009 167.529999 L 442.540009 166.600006 C 442.540009 166.600006 441.640015 166.679993 441.399994 166.809998 L 441.399994 167.75 L 441.399994 167.73999 Z"
      />
      <path
        id="path3468"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 171.350006 C 441.399994 171.350006 442.429993 171.169983 442.540009 171.149994 L 442.540009 170.190002 C 442.540009 170.190002 441.619995 170.27002 441.399994 170.380005 L 441.399994 171.339996 L 441.399994 171.350006 Z"
      />
      <path
        id="path3469"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 173.160004 C 441.399994 173.160004 442.429993 172.98999 442.540009 172.970001 L 442.540009 172 C 442.540009 172 441.609985 172.070007 441.399994 172.179993 L 441.399994 173.149994 L 441.399994 173.160004 Z"
      />
      <path
        id="path3470"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 174.960022 C 441.399994 174.960022 442.440002 174.799988 442.540009 174.779999 L 442.540009 173.799988 C 442.540009 173.799988 441.600006 173.869995 441.399994 173.970001 L 441.399994 174.950012 L 441.399994 174.960022 Z"
      />
      <path
        id="path3471"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 176.77002 C 441.399994 176.77002 442.440002 176.609985 442.540009 176.600006 L 442.540009 175.609985 C 442.540009 175.609985 441.589996 175.679993 441.399994 175.779999 L 441.399994 176.77002 Z"
      />
      <path
        id="path3472"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 178.570007 C 441.399994 178.570007 442.450012 178.419983 442.540009 178.410004 L 442.540009 177.410004 C 442.540009 177.410004 441.579987 177.470001 441.399994 177.570007 L 441.399994 178.580017 L 441.399994 178.570007 Z"
      />
      <path
        id="path3473"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 180.380005 C 441.399994 180.380005 442.450012 180.23999 442.540009 180.22998 L 442.540009 179.220001 C 442.540009 179.220001 441.570007 179.279999 441.399994 179.369995 L 441.399994 180.390015 L 441.399994 180.380005 Z"
      />
      <path
        id="path3474"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 183.98999 C 441.399994 183.98999 442.459991 183.869995 442.540009 183.850006 L 442.540009 182.820007 C 442.540009 182.820007 441.549988 182.869995 441.399994 182.950012 L 441.399994 183.98999 Z"
      />
      <path
        id="path3475"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 185.799988 C 441.399994 185.799988 442.470001 185.679993 442.540009 185.669983 L 442.540009 184.630005 C 442.540009 184.630005 441.540009 184.679993 441.399994 184.75 L 441.399994 185.799988 Z"
      />
      <path
        id="path3476"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 189.410004 C 441.399994 189.410004 442.480011 189.309998 442.540009 189.299988 L 442.540009 188.22998 C 442.540009 188.22998 441.519989 188.27002 441.399994 188.339996 L 441.399994 189.410004 Z"
      />
      <path
        id="path3477"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 191.220001 C 441.399994 191.220001 442.480011 191.130005 442.540009 191.119995 L 442.540009 190.039978 C 442.540009 190.039978 441.519989 190.080017 441.399994 190.140015 L 441.399994 191.220001 Z"
      />
      <path
        id="path3478"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 193.02002 C 441.399994 193.02002 442.48999 192.929993 442.540009 192.929993 L 442.540009 191.839996 C 442.540009 191.839996 441.51001 191.880005 441.399994 191.929993 L 441.399994 193.02002 Z"
      />
      <path
        id="path3479"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 194.830017 C 441.399994 194.830017 442.48999 194.75 442.540009 194.73999 L 442.540009 193.640015 C 442.540009 193.640015 441.5 193.669983 441.399994 193.720001 L 441.399994 194.820007 L 441.399994 194.830017 Z"
      />
      <path
        id="path3480"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 196.630005 C 441.399994 196.630005 442.48999 196.559998 442.540009 196.549988 L 442.540009 195.440002 C 442.540009 195.440002 441.48999 195.470001 441.399994 195.51001 L 441.399994 196.619995 L 441.399994 196.630005 Z"
      />
      <path
        id="path3481"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 198.440002 C 441.399994 198.440002 442.5 198.380005 442.540009 198.369995 L 442.540009 197.25 C 442.540009 197.25 441.480011 197.279999 441.399994 197.320007 L 441.399994 198.440002 Z"
      />
      <path
        id="path3482"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 203.859985 C 441.399994 203.859985 442.51001 203.820007 442.540009 203.820007 L 442.540009 202.669983 C 442.540009 202.669983 441.450012 202.690002 441.399994 202.710022 L 441.399994 203.869995 L 441.399994 203.859985 Z"
      />
      <path
        id="path3483"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 205.660004 C 441.399994 205.660004 442.519989 205.630005 442.540009 205.630005 L 442.540009 204.460022 C 442.540009 204.460022 441.440002 204.470001 441.399994 204.48999 L 441.399994 205.660004 Z"
      />
      <path
        id="path3484"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 216.339996 L 440.790009 216.279999 L 440.790009 215.109985 L 439.839996 215.160004 L 439.839996 216.339996 Z"
      />
      <path
        id="path3485"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 218.119995 L 440.790009 218.080017 L 440.790009 216.899994 L 439.839996 216.940002 L 439.839996 218.119995 Z"
      />
      <path
        id="path3486"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 216.26001 C 441.399994 216.26001 442.519989 216.22998 442.540009 216.22998 L 442.540009 215.059998 C 442.540009 215.059998 441.440002 215.070007 441.399994 215.089996 L 441.399994 216.26001 Z"
      />
      <path
        id="path3487"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 149.570007 L 446.410004 148.850006 C 446.410004 148.850006 446.970001 148.970001 447.23999 149.119995 L 447.23999 149.809998 L 446.410004 149.570007 Z"
      />
      <path
        id="path3488"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 151.380005 L 447.23999 151.609985 L 447.23999 150.899994 C 446.980011 150.76001 446.410004 150.640015 446.410004 150.640015 L 446.410004 151.380005 Z"
      />
      <path
        id="path3489"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 153.190002 L 447.23999 153.419983 L 447.23999 152.700012 C 446.98999 152.559998 446.410004 152.450012 446.410004 152.450012 L 446.410004 153.200012 L 446.410004 153.190002 Z"
      />
      <path
        id="path3490"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 155 L 447.23999 155.220001 L 447.23999 154.47998 C 446.98999 154.350006 446.410004 154.23999 446.410004 154.23999 L 446.410004 155 Z"
      />
      <path
        id="path3491"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 156.799988 L 447.23999 157.01001 L 447.23999 156.26001 C 447 156.130005 446.410004 156.02002 446.410004 156.02002 L 446.410004 156.799988 Z"
      />
      <path
        id="path3492"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 158.609985 L 447.23999 158.820007 L 447.23999 158.049988 C 447.01001 157.919983 446.410004 157.820007 446.410004 157.820007 L 446.410004 158.609985 Z"
      />
      <path
        id="path3493"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 160.419983 L 447.23999 160.619995 L 447.23999 159.839996 C 447.019989 159.720001 446.410004 159.619995 446.410004 159.619995 L 446.410004 160.419983 Z"
      />
      <path
        id="path3494"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 162.22998 L 447.25 162.419983 L 447.25 161.619995 C 447.029999 161.5 446.410004 161.410004 446.410004 161.410004 L 446.410004 162.22998 Z"
      />
      <path
        id="path3495"
        fill="#cecece"
        stroke="none"
        d="M 446.410004 164.039978 L 447.25 164.220001 L 447.25 163.410004 C 447.040009 163.299988 446.410004 163.200012 446.410004 163.200012 L 446.410004 164.029999 L 446.410004 164.039978 Z"
      />
      <path
        id="path3496"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 165.850006 L 447.26001 166.029999 L 447.26001 165.200012 C 447.059998 165.089996 446.420013 165 446.420013 165 L 446.420013 165.850006 Z"
      />
      <path
        id="path3497"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 169.470001 L 447.26001 169.630005 L 447.26001 168.77002 C 447.079987 168.669983 446.420013 168.589996 446.420013 168.589996 L 446.420013 169.470001 Z"
      />
      <path
        id="path3498"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 171.279999 L 447.26001 171.440002 L 447.26001 170.570007 C 447.079987 170.470001 446.420013 170.399994 446.420013 170.399994 L 446.420013 171.289978 L 446.420013 171.279999 Z"
      />
      <path
        id="path3499"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 173.089996 L 447.26001 173.23999 L 447.26001 172.350006 C 447.089996 172.26001 446.420013 172.179993 446.420013 172.179993 L 446.420013 173.080017 L 446.420013 173.089996 Z"
      />
      <path
        id="path3500"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 174.899994 L 447.26001 175.039978 L 447.26001 174.140015 C 447.100006 174.049988 446.420013 173.97998 446.420013 173.97998 L 446.420013 174.899994 Z"
      />
      <path
        id="path3501"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 178.51001 L 447.26001 178.640015 L 447.26001 177.710022 C 447.109985 177.630005 446.420013 177.559998 446.420013 177.559998 L 446.420013 178.51001 Z"
      />
      <path
        id="path3502"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 180.320007 L 447.26001 180.440002 L 447.26001 179.48999 C 447.119995 179.410004 446.420013 179.350006 446.420013 179.350006 L 446.420013 180.309998 L 446.420013 180.320007 Z"
      />
      <path
        id="path3503"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 182.130005 L 447.26001 182.25 L 447.26001 181.289978 C 447.130005 181.220001 446.420013 181.160004 446.420013 181.160004 L 446.420013 182.130005 Z"
      />
      <path
        id="path3504"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 183.940002 L 447.26001 184.049988 L 447.26001 183.080017 C 447.140015 183.01001 446.420013 182.960022 446.420013 182.960022 L 446.420013 183.950012 L 446.420013 183.940002 Z"
      />
      <path
        id="path3505"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 185.75 L 447.26001 185.850006 L 447.26001 184.859985 C 447.140015 184.799988 446.420013 184.75 446.420013 184.75 L 446.420013 185.75 Z"
      />
      <path
        id="path3506"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 189.369995 L 447.26001 189.460022 L 447.26001 188.440002 C 447.160004 188.390015 446.420013 188.339996 446.420013 188.339996 L 446.420013 189.369995 Z"
      />
      <path
        id="path3507"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 191.179993 L 447.26001 191.26001 L 447.26001 190.22998 C 447.170013 190.179993 446.420013 190.140015 446.420013 190.140015 L 446.420013 191.179993 Z"
      />
      <path
        id="path3508"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 192.98999 L 447.26001 193.070007 L 447.26001 192.02002 C 447.179993 191.970001 446.420013 191.940002 446.420013 191.940002 L 446.420013 193 L 446.420013 192.98999 Z"
      />
      <path
        id="path3509"
        fill="#cecece"
        stroke="none"
        d="M 446.420013 194.799988 L 447.26001 194.869995 L 447.26001 193.809998 C 447.179993 193.77002 446.420013 193.72998 446.420013 193.72998 L 446.420013 194.799988 Z"
      />
      <path
        id="path3510"
        fill="#cecece"
        stroke="none"
        d="M 446.429993 200.220001 L 447.269989 200.27002 L 447.269989 199.160004 C 447.220001 199.130005 446.429993 199.109985 446.429993 199.109985 L 446.429993 200.220001 Z"
      />
      <path
        id="path3511"
        fill="#cecece"
        stroke="none"
        d="M 446.429993 202.029999 L 447.269989 202.070007 L 447.269989 200.950012 L 446.429993 200.899994 L 446.429993 202.029999 Z"
      />
      <path
        id="path3512"
        fill="#cecece"
        stroke="none"
        d="M 446.429993 203.839996 L 447.269989 203.869995 L 447.269989 202.72998 L 446.429993 202.690002 L 446.429993 203.830017 L 446.429993 203.839996 Z"
      />
      <path
        id="path3513"
        fill="#cecece"
        stroke="none"
        d="M 447.579987 149.26001 L 447.579987 149.940002 L 448.420013 150.279999 L 448.420013 149.669983 L 447.579987 149.26001 Z"
      />
      <path
        id="path3514"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 151.73999 L 448.420013 152.070007 L 448.420013 151.450012 L 447.589996 151.039978 L 447.589996 151.73999 Z"
      />
      <path
        id="path3515"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 153.539978 L 448.420013 153.859985 L 448.420013 153.220001 L 447.589996 152.830017 L 447.589996 153.539978 Z"
      />
      <path
        id="path3516"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 155.339996 L 448.420013 155.649994 L 448.420013 154.98999 L 447.589996 154.609985 L 447.589996 155.339996 Z"
      />
      <path
        id="path3517"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 157.130005 L 448.420013 157.440002 L 448.420013 156.76001 L 447.589996 156.390015 L 447.589996 157.130005 Z"
      />
      <path
        id="path3518"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 160.72998 L 448.410004 161.01001 L 448.410004 160.299988 L 447.589996 159.960022 L 447.589996 160.72998 Z"
      />
      <path
        id="path3519"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 162.529999 L 448.410004 162.799988 L 448.410004 162.070007 L 447.589996 161.73999 L 447.589996 162.529999 Z"
      />
      <path
        id="path3520"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 164.330017 L 448.410004 164.589996 L 448.410004 163.850006 L 447.589996 163.529999 L 447.589996 164.330017 Z"
      />
      <path
        id="path3521"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 166.130005 L 448.410004 166.380005 L 448.410004 165.619995 L 447.589996 165.309998 L 447.589996 166.130005 Z"
      />
      <path
        id="path3522"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 167.929993 L 448.410004 168.169983 L 448.410004 167.390015 L 447.589996 167.089996 L 447.589996 167.929993 Z"
      />
      <path
        id="path3523"
        fill="#cecece"
        stroke="none"
        d="M 447.589996 169.720001 L 448.410004 169.960022 L 448.410004 169.160004 L 447.589996 168.880005 L 447.589996 169.720001 Z"
      />
      <path
        id="path3524"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 171.52002 L 448.410004 171.75 L 448.410004 170.929993 L 447.600006 170.660004 L 447.600006 171.52002 Z"
      />
      <path
        id="path3525"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 173.320007 L 448.410004 173.529999 L 448.410004 172.700012 L 447.600006 172.440002 L 447.600006 173.320007 Z"
      />
      <path
        id="path3526"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 175.119995 L 448.410004 175.320007 L 448.410004 174.470001 L 447.600006 174.22998 L 447.600006 175.119995 Z"
      />
      <path
        id="path3527"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 176.919983 L 448.410004 177.109985 L 448.410004 176.25 L 447.600006 176.01001 L 447.600006 176.919983 Z"
      />
      <path
        id="path3528"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 178.720001 L 448.410004 178.899994 L 448.410004 178.02002 L 447.600006 177.789978 L 447.600006 178.720001 Z"
      />
      <path
        id="path3529"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 180.51001 L 448.410004 180.690002 L 448.410004 179.789978 L 447.600006 179.580017 L 447.600006 180.51001 Z"
      />
      <path
        id="path3530"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 182.309998 L 448.410004 182.47998 L 448.410004 181.559998 L 447.600006 181.359985 L 447.600006 182.309998 Z"
      />
      <path
        id="path3531"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 184.109985 L 448.410004 184.27002 L 448.410004 183.330017 L 447.600006 183.140015 L 447.600006 184.109985 Z"
      />
      <path
        id="path3532"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 185.910004 L 448.410004 186.059998 L 448.410004 185.100006 L 447.600006 184.929993 L 447.600006 185.910004 Z"
      />
      <path
        id="path3533"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 187.710022 L 448.410004 187.839996 L 448.410004 186.880005 L 447.600006 186.710022 L 447.600006 187.710022 Z"
      />
      <path
        id="path3534"
        fill="#cecece"
        stroke="none"
        d="M 447.600006 189.51001 L 448.410004 189.630005 L 448.410004 188.649994 L 447.600006 188.48999 L 447.600006 189.51001 Z"
      />
      <path
        id="path3535"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 191.299988 L 448.410004 191.419983 L 448.410004 190.419983 L 447.609985 190.279999 L 447.609985 191.299988 Z"
      />
      <path
        id="path3536"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 193.100006 L 448.410004 193.210022 L 448.410004 192.190002 L 447.609985 192.059998 L 447.609985 193.100006 Z"
      />
      <path
        id="path3537"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 194.899994 L 448.410004 195 L 448.410004 193.960022 L 447.609985 193.839996 L 447.609985 194.899994 Z"
      />
      <path
        id="path3538"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 196.700012 L 448.399994 196.789978 L 448.399994 195.72998 L 447.609985 195.630005 L 447.609985 196.700012 Z"
      />
      <path
        id="path3539"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 200.299988 L 448.399994 200.369995 L 448.399994 199.279999 L 447.609985 199.190002 L 447.609985 200.299988 Z"
      />
      <path
        id="path3540"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 202.100006 L 448.399994 202.149994 L 448.399994 201.049988 L 447.609985 200.97998 L 447.609985 202.100006 Z"
      />
      <path
        id="path3541"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 205.690002 L 448.399994 205.72998 L 448.399994 204.589996 L 447.609985 204.539978 L 447.609985 205.690002 Z"
      />
      <path
        id="path3542"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 207.48999 L 448.399994 207.52002 L 448.399994 206.359985 L 447.609985 206.330017 L 447.609985 207.48999 Z"
      />
      <path
        id="path3543"
        fill="#cecece"
        stroke="none"
        d="M 458.170013 179.169983 L 458.799988 179.429993 L 458.799988 178.539978 L 458.170013 178.26001 L 458.170013 179.169983 Z"
      />
      <path
        id="path3544"
        fill="#cecece"
        stroke="none"
        d="M 458.170013 180.869995 L 458.799988 181.119995 L 458.799988 180.210022 L 458.170013 179.940002 L 458.170013 180.869995 Z"
      />
      <path
        id="path3545"
        fill="#cecece"
        stroke="none"
        d="M 458.170013 182.580017 L 458.799988 182.820007 L 458.799988 181.890015 L 458.170013 181.630005 L 458.170013 182.580017 Z"
      />
      <path
        id="path3546"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 178.779999 L 457.839996 179.039978 L 457.839996 178.140015 L 457.209991 177.859985 L 457.209991 178.779999 Z"
      />
      <path
        id="path3547"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 180.5 L 457.829987 180.75 L 457.829987 179.839996 L 457.209991 179.570007 L 457.209991 180.5 Z"
      />
      <path
        id="path3548"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 182.220001 L 457.829987 182.460022 L 457.829987 181.529999 L 457.209991 181.279999 L 457.209991 182.220001 Z"
      />
      <path
        id="path3549"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 185.669983 L 457.829987 185.880005 L 457.829987 184.919983 L 457.209991 184.700012 L 457.209991 185.669983 Z"
      />
      <path
        id="path3550"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 187.399994 L 457.829987 187.589996 L 457.829987 186.619995 L 457.209991 186.410004 L 457.209991 187.399994 Z"
      />
      <path
        id="path3551"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 189.119995 L 457.829987 189.309998 L 457.829987 188.309998 L 457.209991 188.119995 L 457.209991 189.119995 Z"
      />
      <path
        id="path3552"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 190.850006 L 457.829987 191.02002 L 457.829987 190.01001 L 457.209991 189.830017 L 457.209991 190.850006 Z"
      />
      <path
        id="path3553"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 192.570007 L 457.829987 192.72998 L 457.829987 191.700012 L 457.209991 191.539978 L 457.209991 192.570007 Z"
      />
      <path
        id="path3554"
        fill="#cecece"
        stroke="none"
        d="M 457.209991 196.02002 L 457.829987 196.149994 L 457.829987 195.100006 L 457.209991 194.960022 L 457.209991 196.02002 Z"
      />
      <path
        id="path3555"
        fill="#cecece"
        stroke="none"
        d="M 456.25 178.390015 L 456.880005 178.649994 L 456.880005 177.75 L 456.25 177.470001 L 456.25 178.390015 Z"
      />
      <path
        id="path3556"
        fill="#cecece"
        stroke="none"
        d="M 456.25 180.130005 L 456.880005 180.380005 L 456.880005 179.470001 L 456.25 179.200012 L 456.25 180.130005 Z"
      />
      <path
        id="path3557"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 181.869995 L 456.880005 182.109985 L 456.880005 181.179993 L 456.26001 180.929993 L 456.26001 181.869995 Z"
      />
      <path
        id="path3558"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 187.109985 L 456.880005 187.299988 L 456.880005 186.330017 L 456.26001 186.119995 L 456.26001 187.109985 Z"
      />
      <path
        id="path3559"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 188.850006 L 456.880005 189.029999 L 456.880005 188.039978 L 456.26001 187.850006 L 456.26001 188.850006 Z"
      />
      <path
        id="path3560"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 190.589996 L 456.880005 190.76001 L 456.880005 189.76001 L 456.26001 189.570007 L 456.26001 190.589996 Z"
      />
      <path
        id="path3561"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 192.339996 L 456.880005 192.48999 L 456.880005 191.470001 L 456.26001 191.299988 L 456.26001 192.339996 Z"
      />
      <path
        id="path3562"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 195.820007 L 456.880005 195.960022 L 456.880005 194.899994 L 456.26001 194.76001 L 456.26001 195.820007 Z"
      />
      <path
        id="path3563"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 202.799988 L 456.880005 202.880005 L 456.880005 201.76001 L 456.26001 201.679993 L 456.26001 202.799988 Z"
      />
      <path
        id="path3564"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 204.539978 L 456.880005 204.609985 L 456.880005 203.47998 L 456.26001 203.410004 L 456.26001 204.539978 Z"
      />
      <path
        id="path3565"
        fill="#cecece"
        stroke="none"
        d="M 456.26001 208.029999 L 456.880005 208.070007 L 456.880005 206.910004 L 456.26001 206.859985 L 456.26001 208.029999 Z"
      />
      <path
        id="path3566"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 178.01001 L 455.899994 178.27002 L 455.899994 177.369995 L 455.279999 177.089996 L 455.279999 178.01001 Z"
      />
      <path
        id="path3567"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 181.529999 L 455.899994 181.77002 L 455.899994 180.839996 L 455.279999 180.589996 L 455.279999 181.529999 Z"
      />
      <path
        id="path3568"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 185.059998 L 455.899994 185.27002 L 455.899994 184.309998 L 455.279999 184.089996 L 455.279999 185.059998 Z"
      />
      <path
        id="path3569"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 186.820007 L 455.899994 187.02002 L 455.899994 186.039978 L 455.279999 185.830017 L 455.279999 186.820007 Z"
      />
      <path
        id="path3570"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 188.580017 L 455.899994 188.77002 L 455.899994 187.779999 L 455.279999 187.580017 L 455.279999 188.580017 Z"
      />
      <path
        id="path3571"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 190.350006 L 455.899994 190.52002 L 455.899994 189.51001 L 455.279999 189.330017 L 455.279999 190.350006 Z"
      />
      <path
        id="path3572"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 195.630005 L 455.899994 195.77002 L 455.899994 194.710022 L 455.279999 194.570007 L 455.279999 195.630005 Z"
      />
      <path
        id="path3573"
        fill="#cecece"
        stroke="none"
        d="M 455.269989 202.690002 L 455.899994 202.76001 L 455.899994 201.649994 L 455.269989 201.559998 L 455.269989 202.690002 Z"
      />
      <path
        id="path3574"
        fill="#cecece"
        stroke="none"
        d="M 455.269989 204.450012 L 455.899994 204.51001 L 455.899994 203.380005 L 455.269989 203.309998 L 455.269989 204.450012 Z"
      />
      <path
        id="path3575"
        fill="#cecece"
        stroke="none"
        d="M 455.269989 206.210022 L 455.899994 206.26001 L 455.899994 205.119995 L 455.269989 205.059998 L 455.269989 206.210022 Z"
      />
      <path
        id="path3576"
        fill="#cecece"
        stroke="none"
        d="M 455.279999 208.97998 L 455.910004 209.02002 L 455.910004 207.850006 L 455.279999 207.809998 L 455.279999 208.97998 Z"
      />
      <path
        id="path3577"
        fill="#cecece"
        stroke="none"
        d="M 454.269989 177.630005 L 454.899994 177.890015 L 454.899994 176.98999 L 454.269989 176.710022 L 454.269989 177.630005 Z"
      />
      <path
        id="path3578"
        fill="#cecece"
        stroke="none"
        d="M 454.269989 179.410004 L 454.899994 179.660004 L 454.899994 178.73999 L 454.269989 178.47998 L 454.269989 179.410004 Z"
      />
      <path
        id="path3579"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 181.190002 L 454.899994 181.429993 L 454.899994 180.5 L 454.279999 180.23999 L 454.279999 181.190002 Z"
      />
      <path
        id="path3580"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 184.75 L 454.910004 184.970001 L 454.910004 184 L 454.279999 183.779999 L 454.279999 184.75 Z"
      />
      <path
        id="path3581"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 186.539978 L 454.910004 186.72998 L 454.910004 185.76001 L 454.279999 185.539978 L 454.279999 186.539978 Z"
      />
      <path
        id="path3582"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 188.320007 L 454.910004 188.5 L 454.910004 187.51001 L 454.279999 187.309998 L 454.279999 188.320007 Z"
      />
      <path
        id="path3583"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 190.100006 L 454.910004 190.27002 L 454.910004 189.26001 L 454.279999 189.080017 L 454.279999 190.100006 Z"
      />
      <path
        id="path3584"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 191.880005 L 454.910004 192.039978 L 454.910004 191.02002 L 454.279999 190.850006 L 454.279999 191.880005 Z"
      />
      <path
        id="path3585"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 193.660004 L 454.910004 193.809998 L 454.910004 192.77002 L 454.279999 192.609985 L 454.279999 193.660004 Z"
      />
      <path
        id="path3586"
        fill="#cecece"
        stroke="none"
        d="M 454.279999 197.22998 L 454.910004 197.339996 L 454.910004 196.27002 L 454.279999 196.149994 L 454.279999 197.22998 Z"
      />
      <path
        id="path3587"
        fill="#cecece"
        stroke="none"
        d="M 454.290009 200.789978 L 454.910004 200.880005 L 454.910004 199.779999 L 454.290009 199.679993 L 454.290009 200.789978 Z"
      />
      <path
        id="path3588"
        fill="#cecece"
        stroke="none"
        d="M 454.290009 204.350006 L 454.910004 204.419983 L 454.910004 203.289978 L 454.290009 203.220001 L 454.290009 204.350006 Z"
      />
      <path
        id="path3589"
        fill="#cecece"
        stroke="none"
        d="M 454.290009 207.919983 L 454.910004 207.950012 L 454.910004 206.789978 L 454.290009 206.75 L 454.290009 207.919983 Z"
      />
      <path
        id="path3590"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 209.289978 L 448.399994 209.309998 L 448.399994 208.130005 L 447.609985 208.109985 L 447.609985 209.289978 Z"
      />
      <path
        id="path3591"
        fill="#cecece"
        stroke="none"
        d="M 448.399994 211.679993 L 447.619995 211.679993 L 447.619995 212.890015 L 448.399994 212.890015 L 448.399994 211.679993 Z"
      />
      <path
        id="path3592"
        fill="#cecece"
        stroke="none"
        d="M 448.829987 214.820007 L 449.51001 214.859985 L 449.51001 213.700012 L 448.829987 213.660004 L 448.829987 214.820007 Z"
      />
      <path
        id="path3593"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 214.720001 L 445.950012 214.720001 L 445.950012 213.559998 C 445.950012 213.559998 445.040009 213.549988 445.019989 213.539978 L 445.019989 214.720001 Z"
      />
      <path
        id="path3594"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 218.350006 L 445.940002 218.350006 L 445.940002 217.160004 L 445.019989 217.160004 L 445.019989 218.359985 L 445.019989 218.350006 Z"
      />
      <path
        id="path3595"
        fill="#cecece"
        stroke="none"
        d="M 443.160004 214.72998 L 444.369995 214.72998 L 444.369995 213.549988 C 444.369995 213.549988 443.190002 213.549988 443.160004 213.549988 L 443.160004 214.72998 Z"
      />
      <path
        id="path3596"
        fill="#cecece"
        stroke="none"
        d="M 443.170013 218.359985 L 444.380005 218.359985 L 444.380005 217.160004 C 444.380005 217.160004 443.179993 217.160004 443.170013 217.160004 L 443.170013 218.359985 Z"
      />
      <path
        id="path3597"
        fill="#cecece"
        stroke="none"
        d="M 444.380005 218.960022 L 443.170013 218.960022 L 443.170013 220.169983 L 444.380005 220.169983 L 444.380005 218.960022 Z"
      />
      <path
        id="path3598"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 216.570007 L 448.399994 216.589996 L 448.399994 215.419983 L 447.609985 215.390015 L 447.609985 216.570007 Z"
      />
      <path
        id="path3599"
        fill="#cecece"
        stroke="none"
        d="M 447.619995 218.369995 L 448.399994 218.380005 L 448.399994 217.190002 L 447.619995 217.179993 L 447.619995 218.369995 Z"
      />
      <path
        id="path3600"
        fill="#cecece"
        stroke="none"
        d="M 448.399994 218.960022 L 447.619995 218.960022 L 447.619995 220.169983 L 448.399994 220.169983 L 448.399994 218.960022 Z"
      />
      <path
        id="path3601"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 221.960022 L 440.790009 221.950012 L 440.790009 220.75 L 439.839996 220.76001 L 439.839996 221.960022 Z"
      />
      <path
        id="path3602"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 221.929993 L 445.940002 221.929993 L 445.940002 220.73999 L 445.019989 220.73999 L 445.019989 221.940002 L 445.019989 221.929993 Z"
      />
      <path
        id="path3603"
        fill="#cecece"
        stroke="none"
        d="M 443.170013 221.929993 L 444.380005 221.929993 L 444.380005 220.72998 C 444.380005 220.72998 443.179993 220.72998 443.170013 220.72998 L 443.170013 221.929993 Z"
      />
      <path
        id="path3604"
        fill="#cecece"
        stroke="none"
        d="M 444.380005 222.539978 L 443.170013 222.539978 L 443.170013 223.75 L 444.380005 223.75 L 444.380005 222.539978 Z"
      />
      <path
        id="path3605"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 227.200012 L 440.790009 227.149994 L 440.790009 225.970001 L 439.839996 226.029999 L 439.839996 227.200012 Z"
      />
      <path
        id="path3606"
        fill="#cecece"
        stroke="none"
        d="M 439.839996 228.98999 L 440.790009 228.950012 L 440.790009 227.76001 L 439.839996 227.799988 L 439.839996 228.98999 Z"
      />
      <path
        id="path3607"
        fill="#cecece"
        stroke="none"
        d="M 441.399994 227.119995 C 441.399994 227.119995 442.519989 227.089996 442.540009 227.089996 L 442.540009 225.919983 C 442.540009 225.919983 441.440002 225.929993 441.399994 225.950012 L 441.399994 227.119995 Z"
      />
      <path
        id="path3608"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 220.149994 L 448.399994 220.169983 L 448.399994 219 L 447.609985 218.970001 L 447.609985 220.149994 Z"
      />
      <path
        id="path3609"
        fill="#cecece"
        stroke="none"
        d="M 448.399994 222.539978 L 447.619995 222.539978 L 447.619995 223.75 L 448.399994 223.75 L 448.399994 222.539978 Z"
      />
      <path
        id="path3610"
        fill="#cecece"
        stroke="none"
        d="M 442.540009 222.539978 L 441.399994 222.539978 L 441.399994 223.75 L 442.540009 223.75 L 442.540009 222.539978 Z"
      />
      <path
        id="path3611"
        fill="#cecece"
        stroke="none"
        d="M 442.540009 231.539978 L 441.399994 231.539978 L 441.399994 232.75 L 442.540009 232.75 L 442.540009 231.539978 Z"
      />
      <path
        id="path3612"
        fill="#cecece"
        stroke="none"
        d="M 442.540009 207.809998 L 441.399994 207.809998 L 441.399994 209.02002 L 442.540009 209.02002 L 442.540009 207.809998 Z"
      />
      <path
        id="path3613"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 225.589996 L 445.950012 225.589996 L 445.950012 224.429993 C 445.950012 224.429993 445.040009 224.419983 445.019989 224.410004 L 445.019989 225.589996 Z"
      />
      <path
        id="path3614"
        fill="#cecece"
        stroke="none"
        d="M 445.019989 229.220001 L 445.940002 229.220001 L 445.940002 228.029999 L 445.019989 228.029999 L 445.019989 229.22998 L 445.019989 229.220001 Z"
      />
      <path
        id="path3615"
        fill="#cecece"
        stroke="none"
        d="M 443.160004 225.589996 L 444.369995 225.589996 L 444.369995 224.410004 C 444.369995 224.410004 443.190002 224.410004 443.160004 224.410004 L 443.160004 225.589996 Z"
      />
      <path
        id="path3616"
        fill="#cecece"
        stroke="none"
        d="M 443.170013 229.220001 L 444.380005 229.220001 L 444.380005 228.02002 C 444.380005 228.02002 443.179993 228.02002 443.170013 228.02002 L 443.170013 229.220001 Z"
      />
      <path
        id="path3617"
        fill="#cecece"
        stroke="none"
        d="M 444.380005 229.820007 L 443.170013 229.820007 L 443.170013 231.029999 L 444.380005 231.029999 L 444.380005 229.820007 Z"
      />
      <path
        id="path3618"
        fill="#cecece"
        stroke="none"
        d="M 443.170013 234.369995 L 444.380005 234.369995 L 444.380005 233.169983 C 444.380005 233.169983 443.179993 233.169983 443.170013 233.169983 L 443.170013 234.369995 Z"
      />
      <path
        id="path3619"
        fill="#cecece"
        stroke="none"
        d="M 444.380005 236.809998 L 443.170013 236.809998 L 443.170013 238.020004 L 444.380005 238.020004 L 444.380005 236.809998 Z"
      />
      <path
        id="path3620"
        fill="#cecece"
        stroke="none"
        d="M 447.609985 227.440002 L 448.399994 227.450012 L 448.399994 226.279999 L 447.609985 226.26001 L 447.609985 227.440002 Z"
      />
      <path
        id="path3621"
        fill="#cecece"
        stroke="none"
        d="M 447.619995 229.22998 L 448.399994 229.23999 L 448.399994 228.049988 L 447.619995 228.039978 L 447.619995 229.22998 Z"
      />
      <path
        id="path3622"
        fill="#cecece"
        stroke="none"
        d="M 448.399994 229.820007 L 447.619995 229.820007 L 447.619995 231.029999 L 448.399994 231.029999 L 448.399994 229.820007 Z"
      />
      <path
        id="path3623"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 166.169983 L 459.950012 166.910004 C 459.950012 166.910004 456.950012 167.109985 455.369995 168.399994 L 455.369995 167.970001 C 455.369995 167.970001 456.850006 166.609985 459.950012 166.169983 Z"
      />
      <path
        id="path3624"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 168.52002 C 459.950012 168.52002 456.880005 168.710022 455.369995 169.950012 L 455.369995 169.5 C 455.369995 169.5 456.98999 168.200012 459.950012 167.779999 L 459.950012 168.52002 Z"
      />
      <path
        id="path3625"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 170.130005 C 459.950012 170.130005 456.809998 170.309998 455.369995 171.48999 L 455.369995 171.029999 C 455.369995 171.029999 457.119995 169.789978 459.950012 169.390015 L 459.950012 170.130005 Z"
      />
      <path
        id="path3626"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 171.73999 C 459.950012 171.73999 456.73999 171.910004 455.369995 173.039978 L 455.369995 172.570007 C 455.369995 172.570007 457.26001 171.380005 459.950012 171.01001 L 459.950012 171.75 L 459.950012 171.73999 Z"
      />
      <path
        id="path3627"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 173.350006 C 459.950012 173.350006 456.670013 173.51001 455.369995 174.580017 L 455.369995 174.089996 C 455.369995 174.089996 457.390015 172.960022 459.950012 172.609985 L 459.950012 173.350006 Z"
      />
      <path
        id="path3628"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 174.720001 C 459.950012 174.720001 456.73999 174.890015 455.369995 176.02002 L 455.369995 175.549988 C 455.369995 175.549988 457.26001 174.359985 459.950012 173.98999 L 459.950012 174.72998 L 459.950012 174.720001 Z"
      />
      <path
        id="path3629"
        fill="#cecece"
        stroke="none"
        d="M 459.950012 176.330017 C 459.950012 176.330017 458.470001 176.399994 457.109985 176.77002 C 456.839996 176.690002 456.670013 176.619995 456.429993 176.570007 C 457.269989 176.220001 458.529999 175.779999 459.959991 175.580017 L 459.959991 176.320007 L 459.950012 176.330017 Z"
      />
      <path
        id="path3630"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 166.390015 L 467.589996 167.289978 L 466.23999 167.140015 L 466.23999 166.169983 L 467.589996 166.390015 Z"
      />
      <path
        id="path3631"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 167.97998 L 467.589996 168.880005 L 466.23999 168.73999 L 466.23999 167.779999 L 467.589996 167.97998 Z"
      />
      <path
        id="path3632"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 169.580017 L 467.589996 170.47998 L 466.23999 170.339996 L 466.23999 169.380005 L 467.589996 169.580017 Z"
      />
      <path
        id="path3633"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 171.169983 L 467.589996 172.070007 L 466.23999 171.940002 L 466.23999 170.97998 L 467.589996 171.169983 Z"
      />
      <path
        id="path3634"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 172.77002 L 467.589996 173.660004 L 466.23999 173.539978 L 466.23999 172.589996 L 467.589996 172.77002 Z"
      />
      <path
        id="path3635"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 175.950012 L 467.589996 176.850006 L 466.23999 176.73999 L 466.23999 175.789978 L 467.589996 175.950012 Z"
      />
      <path
        id="path3636"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 177.549988 L 467.589996 178.440002 L 466.23999 178.339996 L 466.23999 177.399994 L 467.589996 177.549988 Z"
      />
      <path
        id="path3637"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 180.73999 L 467.589996 181.630005 L 466.23999 181.539978 L 466.23999 180.600006 L 467.589996 180.73999 Z"
      />
      <path
        id="path3638"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 182.330017 L 467.589996 183.220001 L 466.23999 183.140015 L 466.23999 182.210022 L 467.589996 182.330017 Z"
      />
      <path
        id="path3639"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 183.919983 L 467.589996 184.820007 L 466.23999 184.73999 L 466.23999 183.809998 L 467.589996 183.919983 Z"
      />
      <path
        id="path3640"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 185.52002 L 467.589996 186.410004 L 466.23999 186.339996 L 466.23999 185.410004 L 467.589996 185.52002 Z"
      />
      <path
        id="path3641"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 188.700012 L 467.589996 189.600006 L 466.23999 189.539978 L 466.23999 188.619995 L 467.589996 188.700012 Z"
      />
      <path
        id="path3642"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 190.299988 L 467.589996 191.190002 L 466.23999 191.140015 L 466.23999 190.220001 L 467.589996 190.299988 Z"
      />
      <path
        id="path3643"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 191.890015 L 467.589996 192.779999 L 466.23999 192.73999 L 466.23999 191.830017 L 467.589996 191.890015 Z"
      />
      <path
        id="path3644"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 195.080017 L 467.589996 195.970001 L 466.23999 195.940002 L 466.23999 195.029999 L 467.589996 195.080017 Z"
      />
      <path
        id="path3645"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 196.669983 L 467.589996 197.559998 L 466.23999 197.539978 L 466.23999 196.640015 L 467.589996 196.669983 Z"
      />
      <path
        id="path3646"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 199.859985 L 467.589996 200.75 L 466.23999 200.73999 L 466.23999 199.839996 L 467.589996 199.859985 Z"
      />
      <path
        id="path3647"
        fill="#cecece"
        stroke="none"
        d="M 467.600006 203.049988 L 466.23999 203.049988 L 466.23999 203.940002 L 467.600006 203.940002 L 467.600006 203.049988 Z"
      />
      <path
        id="path3648"
        fill="#cecece"
        stroke="none"
        d="M 465.700012 166.100006 L 465.700012 167.070007 L 464.420013 166.98999 L 464.420013 166 L 465.700012 166.100006 Z"
      />
      <path
        id="path3649"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 167.700012 L 465.709991 168.669983 L 464.420013 168.589996 L 464.420013 167.609985 L 465.709991 167.700012 Z"
      />
      <path
        id="path3650"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 169.309998 L 465.709991 170.279999 L 464.420013 170.200012 L 464.420013 169.220001 L 465.709991 169.309998 Z"
      />
      <path
        id="path3651"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 170.919983 L 465.709991 171.880005 L 464.420013 171.809998 L 464.420013 170.830017 L 465.709991 170.919983 Z"
      />
      <path
        id="path3652"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 172.52002 L 465.709991 173.47998 L 464.420013 173.410004 L 464.420013 172.440002 L 465.709991 172.52002 Z"
      />
      <path
        id="path3653"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 174.130005 L 465.709991 175.080017 L 464.420013 175.02002 L 464.420013 174.049988 L 465.709991 174.130005 Z"
      />
      <path
        id="path3654"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 175.73999 L 465.709991 176.690002 L 464.420013 176.630005 L 464.420013 175.660004 L 465.709991 175.73999 Z"
      />
      <path
        id="path3655"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 177.339996 L 465.709991 178.289978 L 464.420013 178.22998 L 464.420013 177.27002 L 465.709991 177.339996 Z"
      />
      <path
        id="path3656"
        fill="#cecece"
        stroke="none"
        d="M 465.720001 178.950012 L 465.720001 179.890015 L 464.420013 179.839996 L 464.420013 178.880005 L 465.720001 178.950012 Z"
      />
      <path
        id="path3657"
        fill="#cecece"
        stroke="none"
        d="M 465.720001 182.160004 L 465.720001 183.100006 L 464.420013 183.049988 L 464.420013 182.109985 L 465.720001 182.160004 Z"
      />
      <path
        id="path3658"
        fill="#cecece"
        stroke="none"
        d="M 465.720001 183.77002 L 465.720001 184.700012 L 464.420013 184.660004 L 464.420013 183.720001 L 465.720001 183.77002 Z"
      />
      <path
        id="path3659"
        fill="#cecece"
        stroke="none"
        d="M 465.720001 186.97998 L 465.720001 187.910004 L 464.420013 187.869995 L 464.420013 186.940002 L 465.720001 186.97998 Z"
      />
      <path
        id="path3660"
        fill="#cecece"
        stroke="none"
        d="M 465.730011 188.589996 L 465.730011 189.51001 L 464.420013 189.47998 L 464.420013 188.549988 L 465.730011 188.589996 Z"
      />
      <path
        id="path3661"
        fill="#cecece"
        stroke="none"
        d="M 465.730011 190.200012 L 465.730011 191.109985 L 464.420013 191.080017 L 464.420013 190.160004 L 465.730011 190.200012 Z"
      />
      <path
        id="path3662"
        fill="#cecece"
        stroke="none"
        d="M 465.730011 191.799988 L 465.730011 192.720001 L 464.420013 192.690002 L 464.420013 191.77002 L 465.730011 191.799988 Z"
      />
      <path
        id="path3663"
        fill="#cecece"
        stroke="none"
        d="M 465.730011 193.410004 L 465.730011 194.320007 L 464.420013 194.299988 L 464.420013 193.380005 L 465.730011 193.410004 Z"
      />
      <path
        id="path3664"
        fill="#cecece"
        stroke="none"
        d="M 465.730011 195.02002 L 465.730011 195.919983 L 464.420013 195.910004 L 464.420013 194.98999 L 465.730011 195.02002 Z"
      />
      <path
        id="path3665"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 198.22998 L 465.73999 199.130005 L 464.420013 199.119995 L 464.420013 198.220001 L 465.73999 198.22998 Z"
      />
      <path
        id="path3666"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 199.839996 L 465.73999 200.72998 L 464.420013 200.72998 L 464.420013 199.830017 L 465.73999 199.839996 Z"
      />
      <path
        id="path3667"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 203.049988 L 464.420013 203.049988 L 464.420013 203.940002 L 465.73999 203.940002 L 465.73999 203.049988 Z"
      />
      <path
        id="path3668"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 165.940002 L 463.859985 166.899994 L 462.529999 166.859985 L 462.529999 165.880005 L 463.859985 165.940002 Z"
      />
      <path
        id="path3669"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 167.549988 L 463.859985 168.51001 L 462.529999 168.470001 L 462.529999 167.48999 L 463.859985 167.549988 Z"
      />
      <path
        id="path3670"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 169.169983 L 463.859985 170.119995 L 462.529999 170.080017 L 462.529999 169.109985 L 463.859985 169.169983 Z"
      />
      <path
        id="path3671"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 170.779999 L 463.859985 171.72998 L 462.529999 171.700012 L 462.529999 170.72998 L 463.859985 170.779999 Z"
      />
      <path
        id="path3672"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 172.390015 L 463.859985 173.339996 L 462.529999 173.309998 L 462.529999 172.339996 L 463.859985 172.390015 Z"
      />
      <path
        id="path3673"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 174.01001 L 463.859985 174.950012 L 462.529999 174.919983 L 462.529999 173.960022 L 463.859985 174.01001 Z"
      />
      <path
        id="path3674"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 175.619995 L 463.859985 176.559998 L 462.519989 176.529999 L 462.519989 175.570007 L 463.859985 175.619995 Z"
      />
      <path
        id="path3675"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 177.22998 L 463.859985 178.169983 L 462.519989 178.140015 L 462.519989 177.190002 L 463.859985 177.22998 Z"
      />
      <path
        id="path3676"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 178.850006 L 463.859985 179.789978 L 462.519989 179.76001 L 462.519989 178.809998 L 463.859985 178.850006 Z"
      />
      <path
        id="path3677"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 180.460022 L 463.859985 181.399994 L 462.519989 181.369995 L 462.519989 180.419983 L 463.859985 180.460022 Z"
      />
      <path
        id="path3678"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 182.070007 L 463.859985 183.01001 L 462.519989 182.97998 L 462.519989 182.039978 L 463.859985 182.070007 Z"
      />
      <path
        id="path3679"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 183.690002 L 463.859985 184.619995 L 462.519989 184.589996 L 462.519989 183.649994 L 463.859985 183.690002 Z"
      />
      <path
        id="path3680"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 185.299988 L 463.859985 186.22998 L 462.519989 186.200012 L 462.519989 185.27002 L 463.859985 185.299988 Z"
      />
      <path
        id="path3681"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 186.919983 L 463.859985 187.839996 L 462.519989 187.820007 L 462.519989 186.890015 L 463.859985 186.919983 Z"
      />
      <path
        id="path3682"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 190.140015 L 463.859985 191.059998 L 462.519989 191.039978 L 462.519989 190.119995 L 463.859985 190.140015 Z"
      />
      <path
        id="path3683"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 193.369995 L 463.859985 194.279999 L 462.519989 194.27002 L 462.519989 193.350006 L 463.859985 193.369995 Z"
      />
      <path
        id="path3684"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 196.600006 L 463.859985 197.5 L 462.519989 197.48999 L 462.519989 196.580017 L 463.859985 196.600006 Z"
      />
      <path
        id="path3685"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 198.210022 L 463.859985 199.109985 L 462.519989 199.100006 L 462.519989 198.200012 L 463.859985 198.210022 Z"
      />
      <path
        id="path3686"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 199.820007 L 463.859985 200.720001 L 462.519989 200.710022 L 462.519989 199.820007 L 463.859985 199.820007 Z"
      />
      <path
        id="path3687"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 201.440002 L 463.859985 202.330017 L 462.51001 202.330017 L 462.51001 201.429993 L 463.859985 201.440002 Z"
      />
      <path
        id="path3688"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 165.850006 L 460.720001 165.850006 L 460.720001 166.839996 L 461.899994 166.839996 L 461.899994 165.850006 Z"
      />
      <path
        id="path3689"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 167.470001 L 460.720001 167.470001 L 460.720001 168.460022 L 461.899994 168.460022 L 461.899994 167.470001 Z"
      />
      <path
        id="path3690"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 169.089996 L 460.720001 169.089996 L 460.720001 170.070007 L 461.899994 170.070007 L 461.899994 169.089996 Z"
      />
      <path
        id="path3691"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 170.710022 L 460.720001 170.710022 L 460.720001 171.690002 L 461.899994 171.690002 L 461.899994 170.710022 Z"
      />
      <path
        id="path3692"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 172.320007 L 460.720001 172.320007 L 460.720001 173.289978 L 461.899994 173.289978 L 461.899994 172.320007 Z"
      />
      <path
        id="path3693"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 173.940002 L 460.720001 173.940002 L 460.720001 174.910004 L 461.899994 174.910004 L 461.899994 173.940002 Z"
      />
      <path
        id="path3694"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 175.559998 L 460.720001 175.559998 L 460.720001 176.52002 L 461.899994 176.52002 L 461.899994 175.559998 Z"
      />
      <path
        id="path3695"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 177.169983 L 460.720001 177.169983 L 460.720001 178.130005 L 461.899994 178.130005 L 461.899994 177.169983 Z"
      />
      <path
        id="path3696"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 178.789978 L 460.720001 178.789978 L 460.720001 179.75 L 461.899994 179.75 L 461.899994 178.789978 Z"
      />
      <path
        id="path3697"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 180.410004 L 460.720001 180.410004 L 460.720001 181.359985 L 461.899994 181.359985 L 461.899994 180.410004 Z"
      />
      <path
        id="path3698"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 182.029999 L 460.720001 182.029999 L 460.720001 182.97998 L 461.899994 182.97998 L 461.899994 182.029999 Z"
      />
      <path
        id="path3699"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 183.640015 L 460.720001 183.640015 L 460.720001 184.580017 L 461.899994 184.580017 L 461.899994 183.640015 Z"
      />
      <path
        id="path3700"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 185.26001 L 460.720001 185.26001 L 460.720001 186.200012 L 461.899994 186.200012 L 461.899994 185.26001 Z"
      />
      <path
        id="path3701"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 186.880005 L 460.720001 186.880005 L 460.720001 187.809998 L 461.899994 187.809998 L 461.899994 186.880005 Z"
      />
      <path
        id="path3702"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 188.48999 L 460.720001 188.48999 L 460.720001 189.419983 L 461.899994 189.419983 L 461.899994 188.48999 Z"
      />
      <path
        id="path3703"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 191.72998 L 460.720001 191.72998 L 460.720001 192.649994 L 461.899994 192.649994 L 461.899994 191.72998 Z"
      />
      <path
        id="path3704"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 193.350006 L 460.720001 193.350006 L 460.720001 194.27002 L 461.899994 194.27002 L 461.899994 193.350006 Z"
      />
      <path
        id="path3705"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 194.960022 L 460.720001 194.960022 L 460.720001 195.869995 L 461.899994 195.869995 L 461.899994 194.960022 Z"
      />
      <path
        id="path3706"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 196.580017 L 460.720001 196.580017 L 460.720001 197.48999 L 461.899994 197.48999 L 461.899994 196.580017 Z"
      />
      <path
        id="path3707"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 198.200012 L 460.720001 198.200012 L 460.720001 199.100006 L 461.899994 199.100006 L 461.899994 198.200012 Z"
      />
      <path
        id="path3708"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 199.809998 L 460.720001 199.809998 L 460.720001 200.710022 L 461.899994 200.710022 L 461.899994 199.809998 Z"
      />
      <path
        id="path3709"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 203.049988 L 460.720001 203.049988 L 460.720001 203.940002 L 461.899994 203.940002 L 461.899994 203.049988 Z"
      />
      <path
        id="path3710"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 205.690002 L 467.589996 206.570007 L 466.23999 206.559998 L 466.23999 205.669983 L 467.589996 205.690002 Z"
      />
      <path
        id="path3711"
        fill="#cecece"
        stroke="none"
        d="M 467.600006 209.820007 L 466.23999 209.820007 L 466.23999 210.710022 L 467.600006 210.710022 L 467.600006 209.820007 Z"
      />
      <path
        id="path3712"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 205.660004 L 465.73999 206.559998 L 464.420013 206.549988 L 464.420013 205.649994 L 465.73999 205.660004 Z"
      />
      <path
        id="path3713"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 209.820007 L 464.420013 209.820007 L 464.420013 210.710022 L 465.73999 210.710022 L 465.73999 209.820007 Z"
      />
      <path
        id="path3714"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 205.649994 L 463.859985 206.539978 L 462.519989 206.539978 L 462.519989 205.640015 L 463.859985 205.649994 Z"
      />
      <path
        id="path3715"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 207.26001 L 463.859985 208.149994 L 462.51001 208.149994 L 462.51001 207.26001 L 463.859985 207.26001 Z"
      />
      <path
        id="path3716"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 205.640015 L 460.720001 205.640015 L 460.720001 206.539978 L 461.899994 206.539978 L 461.899994 205.640015 Z"
      />
      <path
        id="path3717"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 209.820007 L 460.720001 209.820007 L 460.720001 210.710022 L 461.899994 210.710022 L 461.899994 209.820007 Z"
      />
      <path
        id="path3718"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 211.48999 L 460.720001 211.48999 L 460.720001 212.380005 L 461.899994 212.380005 L 461.899994 211.48999 Z"
      />
      <path
        id="path3719"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 213.950012 L 460.720001 213.950012 L 460.720001 214.839996 L 461.899994 214.839996 L 461.899994 213.950012 Z"
      />
      <path
        id="path3720"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 215.710022 L 467.589996 216.600006 L 466.23999 216.580017 L 466.23999 215.690002 L 467.589996 215.710022 Z"
      />
      <path
        id="path3721"
        fill="#cecece"
        stroke="none"
        d="M 467.600006 219.289978 L 466.23999 219.289978 L 466.23999 220.179993 L 467.600006 220.179993 L 467.600006 219.289978 Z"
      />
      <path
        id="path3722"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 215.679993 L 465.73999 216.580017 L 464.420013 216.570007 L 464.420013 215.669983 L 465.73999 215.679993 Z"
      />
      <path
        id="path3723"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 212.830017 L 465.73999 213.720001 L 464.420013 213.720001 L 464.420013 212.820007 L 465.73999 212.830017 Z"
      />
      <path
        id="path3724"
        fill="#cecece"
        stroke="none"
        d="M 465.73999 219.289978 L 464.420013 219.289978 L 464.420013 220.179993 L 465.73999 220.179993 L 465.73999 219.289978 Z"
      />
      <path
        id="path3725"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 215.669983 L 463.859985 216.559998 L 462.519989 216.559998 L 462.519989 215.660004 L 463.859985 215.669983 Z"
      />
      <path
        id="path3726"
        fill="#cecece"
        stroke="none"
        d="M 463.859985 217.279999 L 463.859985 218.169983 L 462.51001 218.169983 L 462.51001 217.279999 L 463.859985 217.279999 Z"
      />
      <path
        id="path3727"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 215.660004 L 460.720001 215.660004 L 460.720001 216.559998 L 461.899994 216.559998 L 461.899994 215.660004 Z"
      />
      <path
        id="path3728"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 219.289978 L 460.720001 219.289978 L 460.720001 220.179993 L 461.899994 220.179993 L 461.899994 219.289978 Z"
      />
      <path
        id="path3729"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 220.960022 L 460.720001 220.960022 L 460.720001 221.850006 L 461.899994 221.850006 L 461.899994 220.960022 Z"
      />
      <path
        id="path3730"
        fill="#cecece"
        stroke="none"
        d="M 461.899994 223.429993 L 460.720001 223.429993 L 460.720001 224.320007 L 461.899994 224.320007 L 461.899994 223.429993 Z"
      />
      <path
        id="path3731"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 220.98999 L 467.589996 221.880005 L 466.269989 221.880005 L 466.269989 220.97998 L 467.589996 220.98999 Z"
      />
      <path
        id="path3732"
        fill="#cecece"
        stroke="none"
        d="M 467.589996 224.600006 L 466.269989 224.600006 L 466.269989 225.48999 L 467.589996 225.48999 L 467.589996 224.600006 Z"
      />
      <path
        id="path3733"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 220.970001 L 465.709991 221.869995 L 464.369995 221.859985 L 464.369995 220.970001 L 465.709991 220.970001 Z"
      />
      <path
        id="path3734"
        fill="#cecece"
        stroke="none"
        d="M 465.709991 222.589996 L 465.709991 223.47998 L 464.359985 223.47998 L 464.359985 222.580017 L 465.709991 222.589996 Z"
      />
      <path
        id="path3735"
        fill="#cecece"
        stroke="none"
        d="M 463.75 220.970001 L 462.570007 220.970001 L 462.570007 221.869995 L 463.75 221.869995 L 463.75 220.970001 Z"
      />
      <path
        id="path3736"
        fill="#cecece"
        stroke="none"
        d="M 463.75 224.600006 L 462.570007 224.600006 L 462.570007 225.48999 L 463.75 225.48999 L 463.75 224.600006 Z"
      />
      <path
        id="path3737"
        fill="#cecece"
        stroke="none"
        d="M 463.75 226.27002 L 462.570007 226.27002 L 462.570007 227.160004 L 463.75 227.160004 L 463.75 226.27002 Z"
      />
      <path
        id="path3738"
        fill="#cecece"
        stroke="none"
        d="M 463.75 228.72998 L 462.570007 228.72998 L 462.570007 229.619995 L 463.75 229.619995 L 463.75 228.72998 Z"
      />
      <path
        id="path3739"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 173.589996 L 546.429993 173.589996 L 546.429993 175.070007 L 548.23999 175.070007 L 548.23999 173.589996 Z"
      />
      <path
        id="path3740"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 173.589996 L 538.880005 173.589996 L 538.880005 175.070007 L 540.22998 175.070007 L 540.22998 173.589996 Z"
      />
      <path
        id="path3741"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 180.410004 L 538.880005 180.410004 L 538.880005 181.890015 L 540.22998 181.890015 L 540.22998 180.410004 Z"
      />
      <path
        id="path3742"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 180.390015 L 531.869995 180.390015 L 531.869995 181.850006 L 532.950012 181.850006 L 532.950012 180.390015 Z"
      />
      <path
        id="path3743"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 184.940002 L 538.880005 184.940002 L 538.880005 186.419983 L 540.22998 186.419983 L 540.22998 184.940002 Z"
      />
      <path
        id="path3744"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 189.390015 L 538.880005 189.390015 L 538.880005 190.869995 L 540.22998 190.869995 L 540.22998 189.390015 Z"
      />
      <path
        id="path3745"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 196.190002 L 538.880005 196.190002 L 538.880005 197.669983 L 540.22998 197.669983 L 540.22998 196.190002 Z"
      />
      <path
        id="path3746"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 175.919983 L 538.880005 175.919983 L 538.880005 177.399994 L 540.22998 177.399994 L 540.22998 175.919983 Z"
      />
      <path
        id="path3747"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 175.779999 L 546.429993 175.779999 L 546.429993 177.26001 L 548.23999 177.26001 L 548.23999 175.779999 Z"
      />
      <path
        id="path3748"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 178.140015 L 546.429993 178.140015 L 546.429993 179.619995 L 548.23999 179.619995 L 548.23999 178.140015 Z"
      />
      <path
        id="path3749"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 182.559998 L 546.429993 182.559998 L 546.429993 184.039978 L 548.23999 184.039978 L 548.23999 182.559998 Z"
      />
      <path
        id="path3750"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 187.02002 L 546.429993 187.02002 L 546.429993 188.5 L 548.23999 188.5 L 548.23999 187.02002 Z"
      />
      <path
        id="path3751"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 191.690002 L 546.429993 191.690002 L 546.429993 193.169983 L 548.23999 193.169983 L 548.23999 191.690002 Z"
      />
      <path
        id="path3752"
        fill="#cecece"
        stroke="none"
        d="M 529.710022 205.119995 L 528.630005 205.169983 L 528.630005 203.720001 L 529.710022 203.669983 L 529.710022 205.119995 Z"
      />
      <path
        id="path3753"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 209.369995 L 528.630005 209.380005 L 528.630005 207.899994 L 529.700012 207.880005 L 529.700012 209.369995 Z"
      />
      <path
        id="path3754"
        fill="#cecece"
        stroke="none"
        d="M 533.02002 204.970001 L 531.950012 205.02002 L 531.950012 203.570007 L 533.02002 203.52002 L 533.02002 204.970001 Z"
      />
      <path
        id="path3755"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 209.97998 L 533.650024 209.97998 L 533.650024 211.48999 L 534.719971 211.48999 L 534.719971 209.97998 Z"
      />
      <path
        id="path3756"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 204.669983 L 549.150024 204.619995 L 549.150024 203.149994 L 550.659973 203.200012 L 550.659973 204.669983 Z"
      />
      <path
        id="path3757"
        fill="#cecece"
        stroke="none"
        d="M 545.190002 204.669983 L 543.679993 204.619995 L 543.679993 203.149994 L 545.190002 203.200012 L 545.190002 204.669983 Z"
      />
      <path
        id="path3758"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 207 L 549.150024 206.97998 L 549.150024 205.47998 L 550.659973 205.5 L 550.659973 207 Z"
      />
      <path
        id="path3759"
        fill="#cecece"
        stroke="none"
        d="M 554.210022 207.27002 L 553.200012 207.26001 L 553.200012 205.76001 L 554.210022 205.779999 L 554.210022 207.27002 Z"
      />
      <path
        id="path3760"
        fill="#cecece"
        stroke="none"
        d="M 555.51001 204.899994 L 554.659973 204.850006 L 554.659973 203.399994 L 555.51001 203.440002 L 555.51001 204.899994 Z"
      />
      <path
        id="path3761"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 204.710022 L 540.98999 204.72998 L 540.98999 203.27002 C 540.98999 203.27002 542.419983 203.25 542.460022 203.25 L 542.460022 204.720001 L 542.460022 204.710022 Z"
      />
      <path
        id="path3762"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 209.22998 L 540.98999 209.22998 L 540.98999 207.73999 C 540.98999 207.73999 542.440002 207.73999 542.450012 207.73999 L 542.450012 209.22998 Z"
      />
      <path
        id="path3763"
        fill="#cecece"
        stroke="none"
        d="M 545.390015 209.97998 L 543.47998 209.97998 L 543.47998 211.48999 L 545.390015 211.48999 L 545.390015 209.97998 Z"
      />
      <path
        id="path3764"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 204.77002 L 537.109985 204.809998 L 537.109985 203.359985 L 538.349976 203.320007 L 538.349976 204.77002 Z"
      />
      <path
        id="path3765"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 214.059998 L 528.630005 214.080017 L 528.630005 212.589996 L 529.700012 212.570007 L 529.700012 214.059998 Z"
      />
      <path
        id="path3766"
        fill="#cecece"
        stroke="none"
        d="M 550.659973 213.799988 L 549.150024 213.779999 L 549.150024 212.279999 L 550.659973 212.299988 L 550.659973 213.799988 Z"
      />
      <path
        id="path3767"
        fill="#cecece"
        stroke="none"
        d="M 554.210022 214.070007 L 553.200012 214.049988 L 553.200012 212.559998 L 554.210022 212.580017 L 554.210022 214.070007 Z"
      />
      <path
        id="path3768"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 216.029999 L 540.98999 216.029999 L 540.98999 214.539978 C 540.98999 214.539978 542.440002 214.539978 542.450012 214.539978 L 542.450012 216.029999 Z"
      />
      <path
        id="path3769"
        fill="#cecece"
        stroke="none"
        d="M 545.390015 216.779999 L 543.47998 216.779999 L 543.47998 218.289978 L 545.390015 218.289978 L 545.390015 216.779999 Z"
      />
      <path
        id="path3770"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 207.029999 L 530.210022 207.049988 L 530.210022 205.549988 L 531.289978 205.529999 L 531.289978 207.029999 Z"
      />
      <path
        id="path3771"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 211.51001 L 530.210022 211.52002 L 530.210022 210.02002 L 531.289978 210 L 531.289978 211.51001 Z"
      />
      <path
        id="path3772"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 218.279999 L 530.210022 218.299988 L 530.210022 216.799988 L 531.289978 216.779999 L 531.289978 218.279999 Z"
      />
      <path
        id="path3773"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 220.539978 L 530.210022 220.549988 L 530.210022 219.049988 L 531.289978 219.039978 L 531.289978 220.539978 Z"
      />
      <path
        id="path3774"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 201 L 533.590027 201 L 533.590027 202.52002 L 534.669983 202.52002 L 534.669983 201 Z"
      />
      <path
        id="path3775"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 201 L 535.349976 201 L 535.349976 202.52002 L 536.429993 202.52002 L 536.429993 201 Z"
      />
      <path
        id="path3776"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 205.22998 L 533.650024 205.22998 L 533.650024 206.73999 L 534.719971 206.73999 L 534.719971 205.22998 Z"
      />
      <path
        id="path3777"
        fill="#cecece"
        stroke="none"
        d="M 536.429993 207.799988 L 535.349976 207.799988 L 535.349976 209.320007 L 536.429993 209.320007 L 536.429993 207.799988 Z"
      />
      <path
        id="path3778"
        fill="#cecece"
        stroke="none"
        d="M 555.619995 201 L 554.76001 201 L 554.76001 202.52002 L 555.619995 202.52002 L 555.619995 201 Z"
      />
      <path
        id="path3779"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 201.070007 L 556.130005 201.01001 L 556.130005 199.619995 L 556.73999 199.690002 L 556.73999 201.070007 Z"
      />
      <path
        id="path3780"
        fill="#cecece"
        stroke="none"
        d="M 556.73999 207.450012 L 556.130005 207.399994 L 556.130005 206 L 556.73999 206.070007 L 556.73999 207.450012 Z"
      />
      <path
        id="path3781"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 197.679993 L 540.98999 197.679993 L 540.98999 196.179993 C 540.98999 196.179993 542.450012 196.179993 542.460022 196.179993 L 542.460022 197.690002 L 542.460022 197.679993 Z"
      />
      <path
        id="path3782"
        fill="#cecece"
        stroke="none"
        d="M 565.280029 198.22998 L 565.280029 199.26001 L 566.849976 199.25 L 566.849976 198.210022 L 565.280029 198.22998 Z"
      />
      <path
        id="path3783"
        fill="#cecece"
        stroke="none"
        d="M 565.280029 196.419983 L 565.280029 197.450012 L 566.849976 197.440002 L 566.849976 196.390015 L 565.280029 196.419983 Z"
      />
      <path
        id="path3784"
        fill="#cecece"
        stroke="none"
        d="M 566.880005 203.660004 L 565.299988 203.660004 L 565.299988 204.690002 L 566.880005 204.690002 L 566.880005 203.660004 Z"
      />
      <path
        id="path3785"
        fill="#cecece"
        stroke="none"
        d="M 560.919983 196.399994 L 560.919983 197.440002 L 562.450012 197.429993 L 562.450012 196.390015 L 560.919983 196.399994 Z"
      />
      <path
        id="path3786"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 196.390015 L 563.099976 197.429993 L 564.659973 197.419983 L 564.659973 196.380005 L 563.099976 196.390015 Z"
      />
      <path
        id="path3787"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 201.940002 L 563.099976 202.97998 L 564.659973 202.97998 L 564.659973 201.940002 L 563.099976 201.940002 Z"
      />
      <path
        id="path3788"
        fill="#cecece"
        stroke="none"
        d="M 566.75 200.059998 L 565.380005 200.059998 L 565.380005 201.100006 L 566.75 201.100006 L 566.75 200.059998 Z"
      />
      <path
        id="path3789"
        fill="#cecece"
        stroke="none"
        d="M 562.450012 206.440002 L 560.919983 206.440002 L 560.919983 207.470001 L 562.450012 207.470001 L 562.450012 206.440002 Z"
      />
      <path
        id="path3790"
        fill="#cecece"
        stroke="none"
        d="M 566.75 206.440002 L 565.380005 206.440002 L 565.380005 207.470001 L 566.75 207.470001 L 566.75 206.440002 Z"
      />
      <path
        id="path3791"
        fill="#cecece"
        stroke="none"
        d="M 564.650024 212.940002 L 563.119995 212.940002 L 563.119995 213.970001 L 564.650024 213.970001 L 564.650024 212.940002 Z"
      />
      <path
        id="path3792"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 209.460022 L 563.099976 210.5 L 564.659973 210.48999 L 564.659973 209.450012 L 563.099976 209.460022 Z"
      />
      <path
        id="path3793"
        fill="#cecece"
        stroke="none"
        d="M 566.75 209.450012 L 565.380005 209.450012 L 565.380005 210.48999 L 566.75 210.48999 L 566.75 209.450012 Z"
      />
      <path
        id="path3794"
        fill="#cecece"
        stroke="none"
        d="M 566.75 211.309998 L 565.380005 211.309998 L 565.380005 212.350006 L 566.75 212.350006 L 566.75 211.309998 Z"
      />
      <path
        id="path3795"
        fill="#cecece"
        stroke="none"
        d="M 566.75 214.299988 L 565.380005 214.299988 L 565.380005 215.330017 L 566.75 215.330017 L 566.75 214.299988 Z"
      />
      <path
        id="path3796"
        fill="#cecece"
        stroke="none"
        d="M 565.280029 217.75 L 565.280029 218.779999 L 566.849976 218.77002 L 566.849976 217.72998 L 565.280029 217.75 Z"
      />
      <path
        id="path3797"
        fill="#cecece"
        stroke="none"
        d="M 566.849976 225.940002 L 565.320007 225.940002 L 565.320007 226.970001 L 566.849976 226.970001 L 566.849976 225.940002 Z"
      />
      <path
        id="path3798"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 215.910004 L 563.099976 216.950012 L 564.659973 216.950012 L 564.659973 215.899994 L 563.099976 215.910004 Z"
      />
      <path
        id="path3799"
        fill="#cecece"
        stroke="none"
        d="M 563.099976 221.470001 L 563.099976 222.5 L 564.659973 222.5 L 564.659973 221.460022 L 563.099976 221.470001 Z"
      />
      <path
        id="path3800"
        fill="#cecece"
        stroke="none"
        d="M 566.75 219.580017 L 565.380005 219.580017 L 565.380005 220.619995 L 566.75 220.619995 L 566.75 219.580017 Z"
      />
      <path
        id="path3801"
        fill="#cecece"
        stroke="none"
        d="M 566.75 224.429993 L 565.380005 224.429993 L 565.380005 225.460022 L 566.75 225.460022 L 566.75 224.429993 Z"
      />
      <path
        id="path3802"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 201.02002 L 538.880005 201.02002 L 538.880005 202.5 L 540.22998 202.5 L 540.22998 201.02002 Z"
      />
      <path
        id="path3803"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 201 L 531.869995 201 L 531.869995 202.460022 L 532.950012 202.460022 L 532.950012 201 Z"
      />
      <path
        id="path3804"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 205.549988 L 538.880005 205.549988 L 538.880005 207.029999 L 540.22998 207.029999 L 540.22998 205.549988 Z"
      />
      <path
        id="path3805"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 198.72998 L 538.880005 198.72998 L 538.880005 200.210022 L 540.22998 200.210022 L 540.22998 198.72998 Z"
      />
      <path
        id="path3806"
        fill="#cecece"
        stroke="none"
        d="M 538.409973 198.72998 L 537.059998 198.72998 L 537.059998 200.210022 L 538.409973 200.210022 L 538.409973 198.72998 Z"
      />
      <path
        id="path3807"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 209.369995 L 528.630005 209.380005 L 528.630005 207.899994 L 529.700012 207.880005 L 529.700012 209.369995 Z"
      />
      <path
        id="path3808"
        fill="#cecece"
        stroke="none"
        d="M 531.380005 209.339996 L 530.309998 209.359985 L 530.309998 207.869995 L 531.380005 207.850006 L 531.380005 209.339996 Z"
      />
      <path
        id="path3809"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 209.97998 L 533.650024 209.97998 L 533.650024 211.48999 L 534.719971 211.48999 L 534.719971 209.97998 Z"
      />
      <path
        id="path3810"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 212.23999 L 533.650024 212.23999 L 533.650024 213.75 L 534.719971 213.75 L 534.719971 212.23999 Z"
      />
      <path
        id="path3811"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 209.22998 L 540.98999 209.22998 L 540.98999 207.73999 C 540.98999 207.73999 542.440002 207.73999 542.450012 207.73999 L 542.450012 209.22998 Z"
      />
      <path
        id="path3812"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 209.25 L 537.109985 209.26001 L 537.109985 207.779999 L 538.349976 207.76001 L 538.349976 209.25 Z"
      />
      <path
        id="path3813"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 211.47998 L 530.210022 211.5 L 530.210022 210 L 531.289978 209.97998 L 531.289978 211.47998 Z"
      />
      <path
        id="path3814"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 213.73999 L 530.210022 213.76001 L 530.210022 212.25 L 531.289978 212.23999 L 531.289978 213.73999 Z"
      />
      <path
        id="path3815"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 210 L 538.880005 210 L 538.880005 211.47998 L 540.22998 211.47998 L 540.22998 210 Z"
      />
      <path
        id="path3816"
        fill="#cecece"
        stroke="none"
        d="M 529.710022 218.929993 L 528.630005 218.97998 L 528.630005 217.529999 L 529.710022 217.47998 L 529.710022 218.929993 Z"
      />
      <path
        id="path3817"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 223.179993 L 528.630005 223.190002 L 528.630005 221.700012 L 529.700012 221.690002 L 529.700012 223.179993 Z"
      />
      <path
        id="path3818"
        fill="#cecece"
        stroke="none"
        d="M 533.02002 218.779999 L 531.950012 218.830017 L 531.950012 217.380005 L 533.02002 217.330017 L 533.02002 218.779999 Z"
      />
      <path
        id="path3819"
        fill="#cecece"
        stroke="none"
        d="M 534.719971 223.789978 L 533.650024 223.789978 L 533.650024 225.299988 L 534.719971 225.299988 L 534.719971 223.789978 Z"
      />
      <path
        id="path3820"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 218.52002 L 540.98999 218.539978 L 540.98999 217.080017 C 540.98999 217.080017 542.419983 217.059998 542.460022 217.059998 L 542.460022 218.529999 L 542.460022 218.52002 Z"
      />
      <path
        id="path3821"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 223.039978 L 540.98999 223.039978 L 540.98999 221.549988 C 540.98999 221.549988 542.440002 221.549988 542.450012 221.549988 L 542.450012 223.039978 Z"
      />
      <path
        id="path3822"
        fill="#cecece"
        stroke="none"
        d="M 538.349976 218.580017 L 537.109985 218.609985 L 537.109985 217.169983 L 538.349976 217.130005 L 538.349976 218.580017 Z"
      />
      <path
        id="path3823"
        fill="#cecece"
        stroke="none"
        d="M 529.700012 227.869995 L 528.630005 227.890015 L 528.630005 226.399994 L 529.700012 226.380005 L 529.700012 227.869995 Z"
      />
      <path
        id="path3824"
        fill="#cecece"
        stroke="none"
        d="M 542.450012 229.839996 L 540.98999 229.839996 L 540.98999 228.350006 C 540.98999 228.350006 542.440002 228.350006 542.450012 228.350006 L 542.450012 229.839996 Z"
      />
      <path
        id="path3825"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 220.839996 L 530.210022 220.859985 L 530.210022 219.350006 L 531.289978 219.339996 L 531.289978 220.839996 Z"
      />
      <path
        id="path3826"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 225.320007 L 530.210022 225.330017 L 530.210022 223.830017 L 531.289978 223.809998 L 531.289978 225.320007 Z"
      />
      <path
        id="path3827"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 232.089996 L 530.210022 232.100006 L 530.210022 230.600006 L 531.289978 230.589996 L 531.289978 232.089996 Z"
      />
      <path
        id="path3828"
        fill="#cecece"
        stroke="none"
        d="M 531.289978 234.350006 L 530.210022 234.359985 L 530.210022 232.859985 L 531.289978 232.850006 L 531.289978 234.350006 Z"
      />
      <path
        id="path3829"
        fill="#cecece"
        stroke="none"
        d="M 534.669983 214.809998 L 533.590027 214.809998 L 533.590027 216.330017 L 534.669983 216.330017 L 534.669983 214.809998 Z"
      />
      <path
        id="path3830"
        fill="#cecece"
        stroke="none"
        d="M 536.460022 223.850006 L 535.390015 223.850006 L 535.390015 225.359985 L 536.460022 225.359985 L 536.460022 223.850006 Z"
      />
      <path
        id="path3831"
        fill="#cecece"
        stroke="none"
        d="M 536.460022 223.850006 L 535.390015 223.850006 L 535.390015 225.359985 L 536.460022 225.359985 L 536.460022 223.850006 Z"
      />
      <path
        id="path3832"
        fill="#cecece"
        stroke="none"
        d="M 536.460022 219.48999 L 535.390015 219.48999 L 535.390015 221 L 536.460022 221 L 536.460022 219.48999 Z"
      />
      <path
        id="path3833"
        fill="#cecece"
        stroke="none"
        d="M 536.460022 226.109985 L 535.390015 226.109985 L 535.390015 227.619995 L 536.460022 227.619995 L 536.460022 226.109985 Z"
      />
      <path
        id="path3834"
        fill="#cecece"
        stroke="none"
        d="M 538.22998 226.109985 L 537.159973 226.109985 L 537.159973 227.619995 L 538.22998 227.619995 L 538.22998 226.109985 Z"
      />
      <path
        id="path3835"
        fill="#cecece"
        stroke="none"
        d="M 536.400024 228.669983 L 535.320007 228.669983 L 535.320007 230.190002 L 536.400024 230.190002 L 536.400024 228.669983 Z"
      />
      <path
        id="path3836"
        fill="#cecece"
        stroke="none"
        d="M 542.460022 211.48999 L 540.98999 211.48999 L 540.98999 209.98999 C 540.98999 209.98999 542.450012 209.98999 542.460022 209.98999 L 542.460022 211.5 L 542.460022 211.48999 Z"
      />
      <path
        id="path3837"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 214.830017 L 538.880005 214.830017 L 538.880005 216.309998 L 540.22998 216.309998 L 540.22998 214.830017 Z"
      />
      <path
        id="path3838"
        fill="#cecece"
        stroke="none"
        d="M 532.950012 214.809998 L 531.869995 214.809998 L 531.869995 216.27002 L 532.950012 216.27002 L 532.950012 214.809998 Z"
      />
      <path
        id="path3839"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 219.350006 L 538.880005 219.350006 L 538.880005 220.830017 L 540.22998 220.830017 L 540.22998 219.350006 Z"
      />
      <path
        id="path3840"
        fill="#cecece"
        stroke="none"
        d="M 540.22998 212.539978 L 538.880005 212.539978 L 538.880005 214.02002 L 540.22998 214.02002 L 540.22998 212.539978 Z"
      />
      <path
        id="path3841"
        fill="#cecece"
        stroke="none"
        d="M 538.409973 212.539978 L 537.059998 212.539978 L 537.059998 214.02002 L 538.409973 214.02002 L 538.409973 212.539978 Z"
      />
      <path
        id="path3842"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 198.580017 L 546.429993 198.580017 L 546.429993 200.059998 L 548.23999 200.059998 L 548.23999 198.580017 Z"
      />
      <path
        id="path3843"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 193.820007 L 546.429993 193.820007 L 546.429993 195.299988 L 548.23999 195.299988 L 548.23999 193.820007 Z"
      />
      <path
        id="path3844"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 207.630005 L 546.429993 207.630005 L 546.429993 209.109985 L 548.23999 209.109985 L 548.23999 207.630005 Z"
      />
      <path
        id="path3845"
        fill="#cecece"
        stroke="none"
        d="M 548.23999 220.940002 L 546.429993 220.940002 L 546.429993 222.419983 L 548.23999 222.419983 L 548.23999 220.940002 Z"
      />
      <path
        id="path3846"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 209.799988 L 746.799988 209.799988 L 746.799988 210.880005 L 747.409973 210.880005 L 747.409973 209.799988 Z"
      />
      <path
        id="path3847"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 209.799988 L 748.830017 209.799988 L 748.830017 210.880005 L 749.52002 210.880005 L 749.52002 209.799988 Z"
      />
      <path
        id="path3848"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 209.799988 L 743.590027 209.799988 L 743.590027 210.880005 L 744.619995 210.880005 L 744.619995 209.799988 Z"
      />
      <path
        id="path3849"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 209.799988 L 741.390015 209.799988 L 741.390015 210.880005 L 742.349976 210.880005 L 742.349976 209.799988 Z"
      />
      <path
        id="path3850"
        fill="#cecece"
        stroke="none"
        d="M 739.369995 209.799988 L 738.419983 209.799988 L 738.419983 210.880005 L 739.369995 210.880005 L 739.369995 209.799988 Z"
      />
      <path
        id="path3851"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 209.799988 L 749.75 209.799988 L 749.75 210.880005 L 750.320007 210.880005 L 750.320007 209.799988 Z"
      />
      <path
        id="path3852"
        fill="#cecece"
        stroke="none"
        d="M 740.890015 207.820007 L 739.859985 207.820007 L 739.859985 208.940002 L 740.890015 208.940002 L 740.890015 207.820007 Z"
      />
      <path
        id="path3853"
        fill="#cecece"
        stroke="none"
        d="M 737.97998 207.820007 L 737.23999 207.820007 L 737.23999 208.940002 L 737.97998 208.940002 L 737.97998 207.820007 Z"
      />
      <path
        id="path3854"
        fill="#cecece"
        stroke="none"
        d="M 736.820007 209.799988 L 735.890015 209.799988 L 735.890015 210.880005 L 736.820007 210.880005 L 736.820007 209.799988 Z"
      />
      <path
        id="path3855"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 207.820007 L 742.580017 207.820007 L 742.580017 208.940002 L 743.419983 208.940002 L 743.419983 207.820007 Z"
      />
      <path
        id="path3856"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 209.799988 L 742.580017 209.799988 L 742.580017 210.880005 L 743.419983 210.880005 L 743.419983 209.799988 Z"
      />
      <path
        id="path3857"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 209.799988 L 745.98999 209.799988 L 745.98999 210.880005 L 746.679993 210.880005 L 746.679993 209.799988 Z"
      />
      <path
        id="path3858"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 211.679993 L 746.799988 211.679993 L 746.799988 212.76001 L 747.409973 212.76001 L 747.409973 211.679993 Z"
      />
      <path
        id="path3859"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 211.679993 L 748.830017 211.679993 L 748.830017 212.76001 L 749.52002 212.76001 L 749.52002 211.679993 Z"
      />
      <path
        id="path3860"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 211.679993 L 743.590027 211.679993 L 743.590027 212.76001 L 744.619995 212.76001 L 744.619995 211.679993 Z"
      />
      <path
        id="path3861"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 211.679993 L 741.390015 211.679993 L 741.390015 212.76001 L 742.349976 212.76001 L 742.349976 211.679993 Z"
      />
      <path
        id="path3862"
        fill="#cecece"
        stroke="none"
        d="M 737.97998 211.679993 L 737.23999 211.679993 L 737.23999 212.76001 L 737.97998 212.76001 L 737.97998 211.679993 Z"
      />
      <path
        id="path3863"
        fill="#cecece"
        stroke="none"
        d="M 740.890015 211.679993 L 739.859985 211.679993 L 739.859985 212.76001 L 740.890015 212.76001 L 740.890015 211.679993 Z"
      />
      <path
        id="path3864"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 213.52002 L 746.799988 213.52002 L 746.799988 214.600006 L 747.409973 214.600006 L 747.409973 213.52002 Z"
      />
      <path
        id="path3865"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 213.52002 L 748.830017 213.52002 L 748.830017 214.600006 L 749.52002 214.600006 L 749.52002 213.52002 Z"
      />
      <path
        id="path3866"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 213.52002 L 743.590027 213.52002 L 743.590027 214.600006 L 744.619995 214.600006 L 744.619995 213.52002 Z"
      />
      <path
        id="path3867"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 213.52002 L 741.390015 213.52002 L 741.390015 214.600006 L 742.349976 214.600006 L 742.349976 213.52002 Z"
      />
      <path
        id="path3868"
        fill="#cecece"
        stroke="none"
        d="M 739.369995 213.52002 L 738.419983 213.52002 L 738.419983 214.600006 L 739.369995 214.600006 L 739.369995 213.52002 Z"
      />
      <path
        id="path3869"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 213.52002 L 749.75 213.52002 L 749.75 214.600006 L 750.320007 214.600006 L 750.320007 213.52002 Z"
      />
      <path
        id="path3870"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 213.52002 L 742.580017 213.52002 L 742.580017 214.600006 L 743.419983 214.600006 L 743.419983 213.52002 Z"
      />
      <path
        id="path3871"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 213.52002 L 745.98999 213.52002 L 745.98999 214.600006 L 746.679993 214.600006 L 746.679993 213.52002 Z"
      />
      <path
        id="path3872"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 215.399994 L 746.799988 215.399994 L 746.799988 216.47998 L 747.409973 216.47998 L 747.409973 215.399994 Z"
      />
      <path
        id="path3873"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 215.399994 L 748.830017 215.399994 L 748.830017 216.47998 L 749.52002 216.47998 L 749.52002 215.399994 Z"
      />
      <path
        id="path3874"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 215.399994 L 743.590027 215.399994 L 743.590027 216.47998 L 744.619995 216.47998 L 744.619995 215.399994 Z"
      />
      <path
        id="path3875"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 215.399994 L 741.390015 215.399994 L 741.390015 216.47998 L 742.349976 216.47998 L 742.349976 215.399994 Z"
      />
      <path
        id="path3876"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 215.399994 L 749.75 215.399994 L 749.75 216.47998 L 750.320007 216.47998 L 750.320007 215.399994 Z"
      />
      <path
        id="path3877"
        fill="#cecece"
        stroke="none"
        d="M 740.890015 215.399994 L 739.859985 215.399994 L 739.859985 216.47998 L 740.890015 216.47998 L 740.890015 215.399994 Z"
      />
      <path
        id="path3878"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 217.169983 L 746.799988 217.169983 L 746.799988 218.25 L 747.409973 218.25 L 747.409973 217.169983 Z"
      />
      <path
        id="path3879"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 217.169983 L 743.590027 217.169983 L 743.590027 218.25 L 744.619995 218.25 L 744.619995 217.169983 Z"
      />
      <path
        id="path3880"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 217.169983 L 741.390015 217.169983 L 741.390015 218.25 L 742.349976 218.25 L 742.349976 217.169983 Z"
      />
      <path
        id="path3881"
        fill="#cecece"
        stroke="none"
        d="M 739.369995 217.169983 L 738.419983 217.169983 L 738.419983 218.25 L 739.369995 218.25 L 739.369995 217.169983 Z"
      />
      <path
        id="path3882"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 217.169983 L 749.75 217.169983 L 749.75 218.25 L 750.320007 218.25 L 750.320007 217.169983 Z"
      />
      <path
        id="path3883"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 217.169983 L 742.580017 217.169983 L 742.580017 218.25 L 743.419983 218.25 L 743.419983 217.169983 Z"
      />
      <path
        id="path3884"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 219.059998 L 746.799988 219.059998 L 746.799988 220.140015 L 747.409973 220.140015 L 747.409973 219.059998 Z"
      />
      <path
        id="path3885"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 219.059998 L 748.830017 219.059998 L 748.830017 220.140015 L 749.52002 220.140015 L 749.52002 219.059998 Z"
      />
      <path
        id="path3886"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 219.059998 L 741.390015 219.059998 L 741.390015 220.140015 L 742.349976 220.140015 L 742.349976 219.059998 Z"
      />
      <path
        id="path3887"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 219.059998 L 749.75 219.059998 L 749.75 220.140015 L 750.320007 220.140015 L 750.320007 219.059998 Z"
      />
      <path
        id="path3888"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 219.059998 L 742.580017 219.059998 L 742.580017 220.140015 L 743.419983 220.140015 L 743.419983 219.059998 Z"
      />
      <path
        id="path3889"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 219.059998 L 745.98999 219.059998 L 745.98999 220.140015 L 746.679993 220.140015 L 746.679993 219.059998 Z"
      />
      <path
        id="path3890"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 220.890015 L 746.799988 220.890015 L 746.799988 221.970001 L 747.409973 221.970001 L 747.409973 220.890015 Z"
      />
      <path
        id="path3891"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 220.890015 L 748.830017 220.890015 L 748.830017 221.970001 L 749.52002 221.970001 L 749.52002 220.890015 Z"
      />
      <path
        id="path3892"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 220.890015 L 743.590027 220.890015 L 743.590027 221.970001 L 744.619995 221.970001 L 744.619995 220.890015 Z"
      />
      <path
        id="path3893"
        fill="#cecece"
        stroke="none"
        d="M 739.369995 220.890015 L 738.419983 220.890015 L 738.419983 221.970001 L 739.369995 221.970001 L 739.369995 220.890015 Z"
      />
      <path
        id="path3894"
        fill="#cecece"
        stroke="none"
        d="M 740.890015 220.890015 L 739.859985 220.890015 L 739.859985 221.970001 L 740.890015 221.970001 L 740.890015 220.890015 Z"
      />
      <path
        id="path3895"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 220.890015 L 742.580017 220.890015 L 742.580017 221.970001 L 743.419983 221.970001 L 743.419983 220.890015 Z"
      />
      <path
        id="path3896"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 220.890015 L 745.98999 220.890015 L 745.98999 221.970001 L 746.679993 221.970001 L 746.679993 220.890015 Z"
      />
      <path
        id="path3897"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 222.779999 L 746.799988 222.779999 L 746.799988 223.859985 L 747.409973 223.859985 L 747.409973 222.779999 Z"
      />
      <path
        id="path3898"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 222.779999 L 748.830017 222.779999 L 748.830017 223.859985 L 749.52002 223.859985 L 749.52002 222.779999 Z"
      />
      <path
        id="path3899"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 222.779999 L 743.590027 222.779999 L 743.590027 223.859985 L 744.619995 223.859985 L 744.619995 222.779999 Z"
      />
      <path
        id="path3900"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 224.720001 L 746.799988 224.720001 L 746.799988 225.799988 L 747.409973 225.799988 L 747.409973 224.720001 Z"
      />
      <path
        id="path3901"
        fill="#cecece"
        stroke="none"
        d="M 743.419983 224.720001 L 742.580017 224.720001 L 742.580017 225.799988 L 743.419983 225.799988 L 743.419983 224.720001 Z"
      />
      <path
        id="path3902"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 224.720001 L 745.98999 224.720001 L 745.98999 225.799988 L 746.679993 225.799988 L 746.679993 224.720001 Z"
      />
      <path
        id="path3903"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 226.559998 L 746.799988 226.559998 L 746.799988 227.640015 L 747.409973 227.640015 L 747.409973 226.559998 Z"
      />
      <path
        id="path3904"
        fill="#cecece"
        stroke="none"
        d="M 749.52002 226.559998 L 748.830017 226.559998 L 748.830017 227.640015 L 749.52002 227.640015 L 749.52002 226.559998 Z"
      />
      <path
        id="path3905"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 226.559998 L 743.590027 226.559998 L 743.590027 227.640015 L 744.619995 227.640015 L 744.619995 226.559998 Z"
      />
      <path
        id="path3906"
        fill="#cecece"
        stroke="none"
        d="M 746.679993 226.559998 L 745.98999 226.559998 L 745.98999 227.640015 L 746.679993 227.640015 L 746.679993 226.559998 Z"
      />
      <path
        id="path3907"
        fill="#cecece"
        stroke="none"
        d="M 747.409973 228.440002 L 746.799988 228.440002 L 746.799988 229.52002 L 747.409973 229.52002 L 747.409973 228.440002 Z"
      />
      <path
        id="path3908"
        fill="#cecece"
        stroke="none"
        d="M 744.619995 228.440002 L 743.590027 228.440002 L 743.590027 229.52002 L 744.619995 229.52002 L 744.619995 228.440002 Z"
      />
      <path
        id="path3909"
        fill="#cecece"
        stroke="none"
        d="M 742.349976 222.779999 L 741.390015 222.779999 L 741.390015 223.859985 L 742.349976 223.859985 L 742.349976 222.779999 Z"
      />
      <path
        id="path3910"
        fill="#cecece"
        stroke="none"
        d="M 603.950012 212.299988 L 603.219971 212.299988 L 603.219971 213.589996 L 603.950012 213.589996 L 603.950012 212.299988 Z"
      />
      <path
        id="path3911"
        fill="#cecece"
        stroke="none"
        d="M 600.609985 212.299988 L 599.380005 212.299988 L 599.380005 213.589996 L 600.609985 213.589996 L 600.609985 212.299988 Z"
      />
      <path
        id="path3912"
        fill="#cecece"
        stroke="none"
        d="M 598.450012 212.299988 L 597.299988 212.299988 L 597.299988 213.589996 L 598.450012 213.589996 L 598.450012 212.299988 Z"
      />
      <path
        id="path3913"
        fill="#cecece"
        stroke="none"
        d="M 594.340027 212.299988 L 593.200012 212.299988 L 593.200012 213.589996 L 594.340027 213.589996 L 594.340027 212.299988 Z"
      />
      <path
        id="path3914"
        fill="#cecece"
        stroke="none"
        d="M 603.950012 214.549988 L 603.219971 214.549988 L 603.219971 215.839996 L 603.950012 215.839996 L 603.950012 214.549988 Z"
      />
      <path
        id="path3915"
        fill="#cecece"
        stroke="none"
        d="M 606.47998 214.549988 L 605.650024 214.549988 L 605.650024 215.839996 L 606.47998 215.839996 L 606.47998 214.549988 Z"
      />
      <path
        id="path3916"
        fill="#cecece"
        stroke="none"
        d="M 606.47998 210.01001 L 605.650024 210.01001 L 605.650024 211.299988 L 606.47998 211.299988 L 606.47998 210.01001 Z"
      />
      <path
        id="path3917"
        fill="#cecece"
        stroke="none"
        d="M 598.450012 214.549988 L 597.299988 214.549988 L 597.299988 215.839996 L 598.450012 215.839996 L 598.450012 214.549988 Z"
      />
      <path
        id="path3918"
        fill="#cecece"
        stroke="none"
        d="M 603.080017 210.01001 L 602.26001 210.01001 L 602.26001 211.299988 L 603.080017 211.299988 L 603.080017 210.01001 Z"
      />
      <path
        id="path3919"
        fill="#cecece"
        stroke="none"
        d="M 606.47998 216.75 L 605.650024 216.75 L 605.650024 218.039978 L 606.47998 218.039978 L 606.47998 216.75 Z"
      />
      <path
        id="path3920"
        fill="#cecece"
        stroke="none"
        d="M 600.609985 216.75 L 599.380005 216.75 L 599.380005 218.039978 L 600.609985 218.039978 L 600.609985 216.75 Z"
      />
      <path
        id="path3921"
        fill="#cecece"
        stroke="none"
        d="M 594.880005 216.75 L 593.73999 216.75 L 593.73999 218.039978 L 594.880005 218.039978 L 594.880005 216.75 Z"
      />
      <path
        id="path3922"
        fill="#cecece"
        stroke="none"
        d="M 596.690002 216.75 L 595.460022 216.75 L 595.460022 218.039978 L 596.690002 218.039978 L 596.690002 216.75 Z"
      />
      <path
        id="path3923"
        fill="#cecece"
        stroke="none"
        d="M 603.080017 216.75 L 602.26001 216.75 L 602.26001 218.039978 L 603.080017 218.039978 L 603.080017 216.75 Z"
      />
      <path
        id="path3924"
        fill="#cecece"
        stroke="none"
        d="M 603.950012 219 L 603.219971 219 L 603.219971 220.289978 L 603.950012 220.289978 L 603.950012 219 Z"
      />
      <path
        id="path3925"
        fill="#cecece"
        stroke="none"
        d="M 600.609985 219 L 599.380005 219 L 599.380005 220.289978 L 600.609985 220.289978 L 600.609985 219 Z"
      />
      <path
        id="path3926"
        fill="#cecece"
        stroke="none"
        d="M 603.950012 221.320007 L 603.219971 221.320007 L 603.219971 222.609985 L 603.950012 222.609985 L 603.950012 221.320007 Z"
      />
      <path
        id="path3927"
        fill="#cecece"
        stroke="none"
        d="M 603.080017 221.320007 L 602.26001 221.320007 L 602.26001 222.609985 L 603.080017 222.609985 L 603.080017 221.320007 Z"
      />
      <path
        id="path3928"
        fill="#cecece"
        stroke="none"
        d="M 603.950012 223.52002 L 603.219971 223.52002 L 603.219971 224.809998 L 603.950012 224.809998 L 603.950012 223.52002 Z"
      />
      <path
        id="path3929"
        fill="#cecece"
        stroke="none"
        d="M 606.47998 223.52002 L 605.650024 223.52002 L 605.650024 224.809998 L 606.47998 224.809998 L 606.47998 223.52002 Z"
      />
      <path
        id="path3930"
        fill="#cecece"
        stroke="none"
        d="M 600.609985 223.52002 L 599.380005 223.52002 L 599.380005 224.809998 L 600.609985 224.809998 L 600.609985 223.52002 Z"
      />
      <path
        id="path3931"
        fill="#cecece"
        stroke="none"
        d="M 603.950012 225.77002 L 603.219971 225.77002 L 603.219971 227.059998 L 603.950012 227.059998 L 603.950012 225.77002 Z"
      />
      <path
        id="path3932"
        fill="#cecece"
        stroke="none"
        d="M 600.609985 225.77002 L 599.380005 225.77002 L 599.380005 227.059998 L 600.609985 227.059998 L 600.609985 225.77002 Z"
      />
      <path
        id="path3933"
        fill="#cecece"
        stroke="none"
        d="M 598.450012 219 L 597.299988 219 L 597.299988 220.289978 L 598.450012 220.289978 L 598.450012 219 Z"
      />
      <path
        id="path3934"
        fill="#cecece"
        stroke="none"
        d="M 750.320007 222.779999 L 749.75 222.779999 L 749.75 223.859985 L 750.320007 223.859985 L 750.320007 222.779999 Z"
      />
      <path
        id="path3935"
        fill="#cecece"
        stroke="none"
        d="M 745.820007 207.450012 L 744.789978 207.450012 L 744.789978 234.570007 L 745.820007 234.570007 L 745.820007 207.450012 Z"
      />
      <path
        id="path3936"
        fill="#cecece"
        stroke="none"
        d="M 750.890015 207.039978 L 750.590027 207.039978 L 750.590027 218.25 L 750.890015 218.25 L 750.890015 207.039978 Z"
      />
      <path
        id="path3937"
        fill="#cecece"
        stroke="none"
        d="M 757.299988 207.940002 L 756.580017 207.940002 L 756.580017 208.779999 L 757.299988 208.779999 L 757.299988 207.940002 Z"
      />
      <path
        id="path3938"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 207.22998 L 758.219971 207.210022 L 758.219971 206.390015 L 758.98999 206.410004 L 758.98999 207.22998 Z"
      />
      <path
        id="path3939"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 207.279999 L 760.280029 207.27002 L 760.280029 206.440002 L 760.789978 206.460022 L 760.789978 207.279999 Z"
      />
      <path
        id="path3940"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 207.940002 L 760.880005 207.940002 L 760.880005 208.779999 L 761.340027 208.779999 L 761.340027 207.940002 Z"
      />
      <path
        id="path3941"
        fill="#cecece"
        stroke="none"
        d="M 762.960022 207.339996 L 762.400024 207.330017 L 762.400024 206.51001 L 762.960022 206.52002 L 762.960022 207.339996 Z"
      />
      <path
        id="path3942"
        fill="#cecece"
        stroke="none"
        d="M 762.969971 207.940002 L 762.400024 207.940002 L 762.400024 208.779999 L 762.969971 208.779999 L 762.969971 207.940002 Z"
      />
      <path
        id="path3943"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 207.359985 L 763.080017 207.339996 L 763.080017 206.529999 L 763.51001 206.539978 L 763.51001 207.359985 Z"
      />
      <path
        id="path3944"
        fill="#cecece"
        stroke="none"
        d="M 755.440002 207.200012 L 756.210022 207.190002 L 756.210022 206.369995 L 755.440002 206.380005 L 755.440002 207.200012 Z"
      />
      <path
        id="path3945"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 209.410004 L 760.880005 209.410004 L 760.880005 210.210022 L 761.340027 210.210022 L 761.340027 209.410004 Z"
      />
      <path
        id="path3946"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 209.410004 L 762.390015 209.410004 L 762.390015 210.210022 L 762.900024 210.210022 L 762.900024 209.410004 Z"
      />
      <path
        id="path3947"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 209.410004 L 758.219971 209.410004 L 758.219971 210.210022 L 758.98999 210.210022 L 758.98999 209.410004 Z"
      />
      <path
        id="path3948"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 209.410004 L 756.590027 209.410004 L 756.590027 210.210022 L 757.309998 210.210022 L 757.309998 209.410004 Z"
      />
      <path
        id="path3949"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 209.410004 L 763.080017 209.410004 L 763.080017 210.210022 L 763.51001 210.210022 L 763.51001 209.410004 Z"
      />
      <path
        id="path3950"
        fill="#cecece"
        stroke="none"
        d="M 756.210022 207.940002 L 755.440002 207.940002 L 755.440002 208.779999 L 756.210022 208.779999 L 756.210022 207.940002 Z"
      />
      <path
        id="path3951"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 207.940002 L 757.469971 207.940002 L 757.469971 208.779999 L 758.090027 208.779999 L 758.090027 207.940002 Z"
      />
      <path
        id="path3952"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 209.410004 L 757.469971 209.410004 L 757.469971 210.210022 L 758.090027 210.210022 L 758.090027 209.410004 Z"
      />
      <path
        id="path3953"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 209.410004 L 760.280029 209.410004 L 760.280029 210.210022 L 760.789978 210.210022 L 760.789978 209.410004 Z"
      />
      <path
        id="path3954"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 210.820007 L 760.880005 210.820007 L 760.880005 211.619995 L 761.340027 211.619995 L 761.340027 210.820007 Z"
      />
      <path
        id="path3955"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 210.820007 L 762.390015 210.820007 L 762.390015 211.619995 L 762.900024 211.619995 L 762.900024 210.820007 Z"
      />
      <path
        id="path3956"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 210.820007 L 758.219971 210.820007 L 758.219971 211.619995 L 758.98999 211.619995 L 758.98999 210.820007 Z"
      />
      <path
        id="path3957"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 210.820007 L 756.590027 210.820007 L 756.590027 211.619995 L 757.309998 211.619995 L 757.309998 210.820007 Z"
      />
      <path
        id="path3958"
        fill="#cecece"
        stroke="none"
        d="M 756.210022 210.820007 L 755.440002 210.820007 L 755.440002 211.619995 L 756.210022 211.619995 L 756.210022 210.820007 Z"
      />
      <path
        id="path3959"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 212.179993 L 760.880005 212.179993 L 760.880005 212.97998 L 761.340027 212.97998 L 761.340027 212.179993 Z"
      />
      <path
        id="path3960"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 212.179993 L 762.390015 212.179993 L 762.390015 212.97998 L 762.900024 212.97998 L 762.900024 212.179993 Z"
      />
      <path
        id="path3961"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 212.179993 L 758.219971 212.179993 L 758.219971 212.97998 L 758.98999 212.97998 L 758.98999 212.179993 Z"
      />
      <path
        id="path3962"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 212.179993 L 756.590027 212.179993 L 756.590027 212.97998 L 757.309998 212.97998 L 757.309998 212.179993 Z"
      />
      <path
        id="path3963"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 212.179993 L 763.080017 212.179993 L 763.080017 212.97998 L 763.51001 212.97998 L 763.51001 212.179993 Z"
      />
      <path
        id="path3964"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 212.179993 L 757.469971 212.179993 L 757.469971 212.97998 L 758.090027 212.97998 L 758.090027 212.179993 Z"
      />
      <path
        id="path3965"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 212.179993 L 760.280029 212.179993 L 760.280029 212.97998 L 760.789978 212.97998 L 760.789978 212.179993 Z"
      />
      <path
        id="path3966"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 213.589996 L 760.880005 213.589996 L 760.880005 214.390015 L 761.340027 214.390015 L 761.340027 213.589996 Z"
      />
      <path
        id="path3967"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 213.589996 L 762.390015 213.589996 L 762.390015 214.390015 L 762.900024 214.390015 L 762.900024 213.589996 Z"
      />
      <path
        id="path3968"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 213.589996 L 758.219971 213.589996 L 758.219971 214.390015 L 758.98999 214.390015 L 758.98999 213.589996 Z"
      />
      <path
        id="path3969"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 213.589996 L 756.590027 213.589996 L 756.590027 214.390015 L 757.309998 214.390015 L 757.309998 213.589996 Z"
      />
      <path
        id="path3970"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 213.589996 L 763.080017 213.589996 L 763.080017 214.390015 L 763.51001 214.390015 L 763.51001 213.589996 Z"
      />
      <path
        id="path3971"
        fill="#cecece"
        stroke="none"
        d="M 756.210022 213.589996 L 755.440002 213.589996 L 755.440002 214.390015 L 756.210022 214.390015 L 756.210022 213.589996 Z"
      />
      <path
        id="path3972"
        fill="#cecece"
        stroke="none"
        d="M 754.98999 212.359985 L 754.219971 212.359985 L 754.219971 213.160004 L 754.98999 213.160004 L 754.98999 212.359985 Z"
      />
      <path
        id="path3973"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 214.899994 L 760.880005 214.899994 L 760.880005 215.700012 L 761.340027 215.700012 L 761.340027 214.899994 Z"
      />
      <path
        id="path3974"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 214.899994 L 758.219971 214.899994 L 758.219971 215.700012 L 758.98999 215.700012 L 758.98999 214.899994 Z"
      />
      <path
        id="path3975"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 214.899994 L 756.590027 214.899994 L 756.590027 215.700012 L 757.309998 215.700012 L 757.309998 214.899994 Z"
      />
      <path
        id="path3976"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 214.899994 L 763.080017 214.899994 L 763.080017 215.700012 L 763.51001 215.700012 L 763.51001 214.899994 Z"
      />
      <path
        id="path3977"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 214.899994 L 757.469971 214.899994 L 757.469971 215.700012 L 758.090027 215.700012 L 758.090027 214.899994 Z"
      />
      <path
        id="path3978"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 216.299988 L 760.880005 216.299988 L 760.880005 217.100006 L 761.340027 217.100006 L 761.340027 216.299988 Z"
      />
      <path
        id="path3979"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 216.299988 L 762.390015 216.299988 L 762.390015 217.100006 L 762.900024 217.100006 L 762.900024 216.299988 Z"
      />
      <path
        id="path3980"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 216.299988 L 756.590027 216.299988 L 756.590027 217.100006 L 757.309998 217.100006 L 757.309998 216.299988 Z"
      />
      <path
        id="path3981"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 216.299988 L 763.080017 216.299988 L 763.080017 217.100006 L 763.51001 217.100006 L 763.51001 216.299988 Z"
      />
      <path
        id="path3982"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 216.299988 L 757.469971 216.299988 L 757.469971 217.100006 L 758.090027 217.100006 L 758.090027 216.299988 Z"
      />
      <path
        id="path3983"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 216.299988 L 760.280029 216.299988 L 760.280029 217.100006 L 760.789978 217.100006 L 760.789978 216.299988 Z"
      />
      <path
        id="path3984"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 217.669983 L 760.880005 217.669983 L 760.880005 218.470001 L 761.340027 218.470001 L 761.340027 217.669983 Z"
      />
      <path
        id="path3985"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 217.669983 L 762.390015 217.669983 L 762.390015 218.470001 L 762.900024 218.470001 L 762.900024 217.669983 Z"
      />
      <path
        id="path3986"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 217.669983 L 758.219971 217.669983 L 758.219971 218.470001 L 758.98999 218.470001 L 758.98999 217.669983 Z"
      />
      <path
        id="path3987"
        fill="#cecece"
        stroke="none"
        d="M 756.210022 217.669983 L 755.440002 217.669983 L 755.440002 218.470001 L 756.210022 218.470001 L 756.210022 217.669983 Z"
      />
      <path
        id="path3988"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 217.669983 L 757.469971 217.669983 L 757.469971 218.470001 L 758.090027 218.470001 L 758.090027 217.669983 Z"
      />
      <path
        id="path3989"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 217.669983 L 760.280029 217.669983 L 760.280029 218.470001 L 760.789978 218.470001 L 760.789978 217.669983 Z"
      />
      <path
        id="path3990"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 219.070007 L 760.880005 219.070007 L 760.880005 219.869995 L 761.340027 219.869995 L 761.340027 219.070007 Z"
      />
      <path
        id="path3991"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 219.070007 L 762.390015 219.070007 L 762.390015 219.869995 L 762.900024 219.869995 L 762.900024 219.070007 Z"
      />
      <path
        id="path3992"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 219.070007 L 758.219971 219.070007 L 758.219971 219.869995 L 758.98999 219.869995 L 758.98999 219.070007 Z"
      />
      <path
        id="path3993"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 220.52002 L 760.880005 220.52002 L 760.880005 221.320007 L 761.340027 221.320007 L 761.340027 220.52002 Z"
      />
      <path
        id="path3994"
        fill="#cecece"
        stroke="none"
        d="M 758.090027 220.52002 L 757.469971 220.52002 L 757.469971 221.320007 L 758.090027 221.320007 L 758.090027 220.52002 Z"
      />
      <path
        id="path3995"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 220.52002 L 760.280029 220.52002 L 760.280029 221.320007 L 760.789978 221.320007 L 760.789978 220.52002 Z"
      />
      <path
        id="path3996"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 221.890015 L 760.880005 221.890015 L 760.880005 222.690002 L 761.340027 222.690002 L 761.340027 221.890015 Z"
      />
      <path
        id="path3997"
        fill="#cecece"
        stroke="none"
        d="M 762.900024 221.890015 L 762.390015 221.890015 L 762.390015 222.690002 L 762.900024 222.690002 L 762.900024 221.890015 Z"
      />
      <path
        id="path3998"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 221.890015 L 758.219971 221.890015 L 758.219971 222.690002 L 758.98999 222.690002 L 758.98999 221.890015 Z"
      />
      <path
        id="path3999"
        fill="#cecece"
        stroke="none"
        d="M 760.789978 221.890015 L 760.280029 221.890015 L 760.280029 222.690002 L 760.789978 222.690002 L 760.789978 221.890015 Z"
      />
      <path
        id="path4000"
        fill="#cecece"
        stroke="none"
        d="M 761.340027 223.289978 L 760.880005 223.289978 L 760.880005 224.089996 L 761.340027 224.089996 L 761.340027 223.289978 Z"
      />
      <path
        id="path4001"
        fill="#cecece"
        stroke="none"
        d="M 758.98999 223.289978 L 758.219971 223.289978 L 758.219971 224.089996 L 758.98999 224.089996 L 758.98999 223.289978 Z"
      />
      <path
        id="path4002"
        fill="#cecece"
        stroke="none"
        d="M 757.309998 219.070007 L 756.590027 219.070007 L 756.590027 219.869995 L 757.309998 219.869995 L 757.309998 219.070007 Z"
      />
      <path
        id="path4003"
        fill="#cecece"
        stroke="none"
        d="M 763.51001 219.070007 L 763.080017 219.070007 L 763.080017 219.869995 L 763.51001 219.869995 L 763.51001 219.070007 Z"
      />
      <path
        id="path4004"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 200.289978 L 729.570007 200.289978 L 729.570007 201.169983 L 731.609985 201.169983 L 731.609985 200.289978 Z"
      />
      <path
        id="path4005"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 200.289978 L 727.640015 200.289978 L 727.640015 201.169983 L 729.159973 201.169983 L 729.159973 200.289978 Z"
      />
      <path
        id="path4006"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 202.049988 L 727.640015 202.049988 L 727.640015 202.929993 L 729.159973 202.929993 L 729.159973 202.049988 Z"
      />
      <path
        id="path4007"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 203.690002 L 729.570007 203.690002 L 729.570007 204.710022 L 731.609985 204.710022 L 731.609985 203.690002 Z"
      />
      <path
        id="path4008"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 203.690002 L 727.640015 203.690002 L 727.640015 204.710022 L 729.159973 204.710022 L 729.159973 203.690002 Z"
      />
      <path
        id="path4009"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 205.720001 L 729.570007 205.720001 L 729.570007 206.73999 L 731.609985 206.73999 L 731.609985 205.720001 Z"
      />
      <path
        id="path4010"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 207.820007 L 727.640015 207.820007 L 727.640015 208.839996 L 729.159973 208.839996 L 729.159973 207.820007 Z"
      />
      <path
        id="path4011"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 209.830017 L 729.570007 209.830017 L 729.570007 210.850006 L 731.609985 210.850006 L 731.609985 209.830017 Z"
      />
      <path
        id="path4012"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 209.830017 L 727.640015 209.830017 L 727.640015 210.850006 L 729.159973 210.850006 L 729.159973 209.830017 Z"
      />
      <path
        id="path4013"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 211.710022 L 727.640015 211.710022 L 727.640015 212.72998 L 729.159973 212.72998 L 729.159973 211.710022 Z"
      />
      <path
        id="path4014"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 213.549988 L 729.570007 213.549988 L 729.570007 214.570007 L 731.609985 214.570007 L 731.609985 213.549988 Z"
      />
      <path
        id="path4015"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 215.429993 L 727.640015 215.429993 L 727.640015 216.450012 L 729.159973 216.450012 L 729.159973 215.429993 Z"
      />
      <path
        id="path4016"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 217.27002 L 729.570007 217.27002 L 729.570007 218.289978 L 731.609985 218.289978 L 731.609985 217.27002 Z"
      />
      <path
        id="path4017"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 217.27002 L 727.640015 217.27002 L 727.640015 218.289978 L 729.159973 218.289978 L 729.159973 217.27002 Z"
      />
      <path
        id="path4018"
        fill="#cecece"
        stroke="none"
        d="M 731.609985 219.799988 L 729.570007 219.799988 L 729.570007 220.820007 L 731.609985 220.820007 L 731.609985 219.799988 Z"
      />
      <path
        id="path4019"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 221.399994 L 727.640015 221.399994 L 727.640015 222.419983 L 729.159973 222.419983 L 729.159973 221.399994 Z"
      />
      <path
        id="path4020"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 223.410004 L 727.640015 223.410004 L 727.640015 224.429993 L 729.159973 224.429993 L 729.159973 223.410004 Z"
      />
      <path
        id="path4021"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 225.289978 L 727.640015 225.289978 L 727.640015 226.309998 L 729.159973 226.309998 L 729.159973 225.289978 Z"
      />
      <path
        id="path4022"
        fill="#cecece"
        stroke="none"
        d="M 729.159973 229.01001 L 727.640015 229.01001 L 727.640015 230.029999 L 729.159973 230.029999 L 729.159973 229.01001 Z"
      />
      <path
        id="path4023"
        fill="#cecece"
        stroke="none"
        d="M 726.919983 199.779999 L 726.130005 199.779999 L 726.130005 212.76001 L 726.919983 212.76001 L 726.919983 199.779999 Z"
      />
      <path
        id="path4024"
        fill="#cecece"
        stroke="none"
        d="M 725.890015 204.539978 L 725.099976 204.539978 L 725.099976 215.210022 L 725.890015 215.210022 L 725.890015 204.539978 Z"
      />
      <path
        id="path4025"
        fill="#cecece"
        stroke="none"
        d="M 603.890015 196.600006 L 603.22998 196.600006 L 603.22998 198.059998 L 603.890015 198.059998 L 603.890015 196.600006 Z"
      />
      <path
        id="path4026"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 196.600006 L 605.669983 196.600006 L 605.669983 198.059998 L 606.599976 198.059998 L 606.599976 196.600006 Z"
      />
      <path
        id="path4027"
        fill="#cecece"
        stroke="none"
        d="M 607.48999 196.600006 L 606.789978 196.600006 L 606.789978 198.059998 L 607.48999 198.059998 L 607.48999 196.600006 Z"
      />
      <path
        id="path4028"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 196.600006 L 599.26001 196.600006 L 599.26001 198.059998 L 600.51001 198.059998 L 600.51001 196.600006 Z"
      />
      <path
        id="path4029"
        fill="#cecece"
        stroke="none"
        d="M 599.049988 196.600006 L 597.909973 196.600006 L 597.909973 198.059998 L 599.049988 198.059998 L 599.049988 196.600006 Z"
      />
      <path
        id="path4030"
        fill="#cecece"
        stroke="none"
        d="M 603.049988 199.179993 L 602.210022 199.179993 L 602.210022 200.640015 L 603.049988 200.640015 L 603.049988 199.179993 Z"
      />
      <path
        id="path4031"
        fill="#cecece"
        stroke="none"
        d="M 603.890015 199.179993 L 603.22998 199.179993 L 603.22998 200.640015 L 603.890015 200.640015 L 603.890015 199.179993 Z"
      />
      <path
        id="path4032"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 199.179993 L 605.669983 199.179993 L 605.669983 200.640015 L 606.599976 200.640015 L 606.599976 199.179993 Z"
      />
      <path
        id="path4033"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 199.179993 L 599.26001 199.179993 L 599.26001 200.640015 L 600.51001 200.640015 L 600.51001 199.179993 Z"
      />
      <path
        id="path4034"
        fill="#cecece"
        stroke="none"
        d="M 603.890015 201.830017 L 603.22998 201.830017 L 603.22998 203.289978 L 603.890015 203.289978 L 603.890015 201.830017 Z"
      />
      <path
        id="path4035"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 201.830017 L 605.669983 201.830017 L 605.669983 203.289978 L 606.599976 203.289978 L 606.599976 201.830017 Z"
      />
      <path
        id="path4036"
        fill="#cecece"
        stroke="none"
        d="M 607.48999 201.830017 L 606.789978 201.830017 L 606.789978 203.289978 L 607.48999 203.289978 L 607.48999 201.830017 Z"
      />
      <path
        id="path4037"
        fill="#cecece"
        stroke="none"
        d="M 599.049988 201.830017 L 597.909973 201.830017 L 597.909973 203.289978 L 599.049988 203.289978 L 599.049988 201.830017 Z"
      />
      <path
        id="path4038"
        fill="#cecece"
        stroke="none"
        d="M 603.049988 204.25 L 602.210022 204.25 L 602.210022 205.710022 L 603.049988 205.710022 L 603.049988 204.25 Z"
      />
      <path
        id="path4039"
        fill="#cecece"
        stroke="none"
        d="M 606.599976 204.25 L 605.669983 204.25 L 605.669983 205.710022 L 606.599976 205.710022 L 606.599976 204.25 Z"
      />
      <path
        id="path4040"
        fill="#cecece"
        stroke="none"
        d="M 600.51001 204.25 L 599.26001 204.25 L 599.26001 205.710022 L 600.51001 205.710022 L 600.51001 204.25 Z"
      />
      <path
        id="path4041"
        fill="#cecece"
        stroke="none"
        d="M 603.890015 206.899994 L 603.22998 206.899994 L 603.22998 208.359985 L 603.890015 208.359985 L 603.890015 206.899994 Z"
      />
      <path
        id="path4042"
        fill="#cecece"
        stroke="none"
        d="M 607.48999 206.899994 L 606.789978 206.899994 L 606.789978 208.359985 L 607.48999 208.359985 L 607.48999 206.899994 Z"
      />
      <path
        id="path4043"
        fill="#cecece"
        stroke="none"
        d="M 602 194.039978 L 600.73999 194.039978 L 600.73999 209.080017 L 602 209.080017 L 602 194.039978 Z"
      />
      <path
        id="path4044"
        fill="#cecece"
        stroke="none"
        d="M 605.409973 194.549988 L 604.150024 194.549988 L 604.150024 203.289978 L 605.409973 203.289978 L 605.409973 194.549988 Z"
      />
      <path
        id="path4045"
        fill="#cecece"
        stroke="none"
        d="M 608.179993 194.339996 L 607.820007 194.339996 L 607.820007 205.710022 L 608.179993 205.710022 L 608.179993 194.339996 Z"
      />
      <path
        id="path4046"
        fill="#cecece"
        stroke="none"
        d="M 568.130005 145.600006 L 567.330017 145.600006 L 567.330017 169.419983 L 568.130005 169.419983 L 568.130005 145.600006 Z"
      />
      <path
        id="path4047"
        fill="#cecece"
        stroke="none"
        d="M 569.219971 141.970001 L 568.590027 141.970001 L 568.590027 165.789978 L 569.219971 165.789978 L 569.219971 141.970001 Z"
      />
      <path
        id="path4048"
        fill="#cecece"
        stroke="none"
        d="M 760.01001 204.859985 L 759.210022 204.859985 L 759.210022 227.339996 L 760.01001 227.339996 L 760.01001 204.859985 Z"
      />
      <path
        id="path4049"
        fill="#cecece"
        stroke="none"
        d="M 762.179993 221.52002 L 761.380005 221.52002 L 761.380005 230.059998 L 762.179993 230.059998 L 762.179993 221.52002 Z"
      />
      <path
        id="path4050"
        fill="#cecece"
        stroke="none"
        d="M 763.960022 205.330017 L 763.72998 205.330017 L 763.72998 215.299988 L 763.960022 215.299988 L 763.960022 205.330017 Z"
      />
      <path
        id="path4051"
        fill="#cecece"
        stroke="none"
        d="M 678.400024 182.559998 L 659.880005 182.559998 L 659.880005 183.380005 L 678.400024 183.380005 L 678.400024 182.559998 Z"
      />
      <path
        id="path4052"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 180.160004 L 686.22998 180.160004 L 686.22998 204.559998 L 686.969971 204.559998 L 686.969971 180.160004 Z"
      />
      <path
        id="path4053"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 198.539978 L 609.77002 198.539978 L 609.77002 199.97998 L 611.48999 199.97998 L 611.48999 198.539978 Z"
      />
      <path
        id="path4054"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 200.660004 L 609.77002 200.660004 L 609.77002 202.100006 L 611.48999 202.100006 L 611.48999 200.660004 Z"
      />
      <path
        id="path4055"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 202.77002 L 609.77002 202.77002 L 609.77002 204.210022 L 611.48999 204.210022 L 611.48999 202.77002 Z"
      />
      <path
        id="path4056"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 204.890015 L 609.77002 204.890015 L 609.77002 206.330017 L 611.48999 206.330017 L 611.48999 204.890015 Z"
      />
      <path
        id="path4057"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 207.01001 L 609.77002 207.01001 L 609.77002 208.450012 L 611.48999 208.450012 L 611.48999 207.01001 Z"
      />
      <path
        id="path4058"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 213.359985 L 609.77002 213.359985 L 609.77002 214.799988 L 611.48999 214.799988 L 611.48999 213.359985 Z"
      />
      <path
        id="path4059"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 215.47998 L 609.77002 215.47998 L 609.77002 216.919983 L 611.48999 216.919983 L 611.48999 215.47998 Z"
      />
      <path
        id="path4060"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 217.600006 L 609.77002 217.600006 L 609.77002 219.039978 L 611.48999 219.039978 L 611.48999 217.600006 Z"
      />
      <path
        id="path4061"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 221.830017 L 609.77002 221.830017 L 609.77002 223.27002 L 611.48999 223.27002 L 611.48999 221.830017 Z"
      />
      <path
        id="path4062"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 223.950012 L 609.77002 223.950012 L 609.77002 225.390015 L 611.48999 225.390015 L 611.48999 223.950012 Z"
      />
      <path
        id="path4063"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 226.070007 L 609.77002 226.070007 L 609.77002 227.51001 L 611.48999 227.51001 L 611.48999 226.070007 Z"
      />
      <path
        id="path4064"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 228.190002 L 609.77002 228.190002 L 609.77002 229.630005 L 611.48999 229.630005 L 611.48999 228.190002 Z"
      />
      <path
        id="path4065"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 198.539978 L 612.570007 198.539978 L 612.570007 199.97998 L 614.289978 199.97998 L 614.289978 198.539978 Z"
      />
      <path
        id="path4066"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 200.660004 L 612.570007 200.660004 L 612.570007 202.100006 L 614.289978 202.100006 L 614.289978 200.660004 Z"
      />
      <path
        id="path4067"
        fill="#cecece"
        stroke="none"
        d="M 617.01001 200.660004 L 615.289978 200.660004 L 615.289978 202.100006 L 617.01001 202.100006 L 617.01001 200.660004 Z"
      />
      <path
        id="path4068"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 202.77002 L 612.570007 202.77002 L 612.570007 204.210022 L 614.289978 204.210022 L 614.289978 202.77002 Z"
      />
      <path
        id="path4069"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 204.890015 L 612.570007 204.890015 L 612.570007 206.330017 L 614.289978 206.330017 L 614.289978 204.890015 Z"
      />
      <path
        id="path4070"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 207.01001 L 612.570007 207.01001 L 612.570007 208.450012 L 614.289978 208.450012 L 614.289978 207.01001 Z"
      />
      <path
        id="path4071"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 211.23999 L 612.570007 211.23999 L 612.570007 212.679993 L 614.289978 212.679993 L 614.289978 211.23999 Z"
      />
      <path
        id="path4072"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 215.47998 L 612.570007 215.47998 L 612.570007 216.919983 L 614.289978 216.919983 L 614.289978 215.47998 Z"
      />
      <path
        id="path4073"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 217.600006 L 612.570007 217.600006 L 612.570007 219.039978 L 614.289978 219.039978 L 614.289978 217.600006 Z"
      />
      <path
        id="path4074"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 219.720001 L 612.570007 219.720001 L 612.570007 221.160004 L 614.289978 221.160004 L 614.289978 219.720001 Z"
      />
      <path
        id="path4075"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 221.830017 L 612.570007 221.830017 L 612.570007 223.27002 L 614.289978 223.27002 L 614.289978 221.830017 Z"
      />
      <path
        id="path4076"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 223.950012 L 612.570007 223.950012 L 612.570007 225.390015 L 614.289978 225.390015 L 614.289978 223.950012 Z"
      />
      <path
        id="path4077"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 198.539978 L 615.359985 198.539978 L 615.359985 199.97998 L 617.090027 199.97998 L 617.090027 198.539978 Z"
      />
      <path
        id="path4078"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 204.890015 L 615.359985 204.890015 L 615.359985 206.330017 L 617.090027 206.330017 L 617.090027 204.890015 Z"
      />
      <path
        id="path4079"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 207.01001 L 615.359985 207.01001 L 615.359985 208.450012 L 617.090027 208.450012 L 617.090027 207.01001 Z"
      />
      <path
        id="path4080"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 209.130005 L 615.359985 209.130005 L 615.359985 210.570007 L 617.090027 210.570007 L 617.090027 209.130005 Z"
      />
      <path
        id="path4081"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 211.23999 L 615.359985 211.23999 L 615.359985 212.679993 L 617.090027 212.679993 L 617.090027 211.23999 Z"
      />
      <path
        id="path4082"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 213.359985 L 615.359985 213.359985 L 615.359985 214.799988 L 617.090027 214.799988 L 617.090027 213.359985 Z"
      />
      <path
        id="path4083"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 215.47998 L 615.359985 215.47998 L 615.359985 216.919983 L 617.090027 216.919983 L 617.090027 215.47998 Z"
      />
      <path
        id="path4084"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 219.720001 L 615.359985 219.720001 L 615.359985 221.160004 L 617.090027 221.160004 L 617.090027 219.720001 Z"
      />
      <path
        id="path4085"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 221.830017 L 615.359985 221.830017 L 615.359985 223.27002 L 617.090027 223.27002 L 617.090027 221.830017 Z"
      />
      <path
        id="path4086"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 223.950012 L 615.359985 223.950012 L 615.359985 225.390015 L 617.090027 225.390015 L 617.090027 223.950012 Z"
      />
      <path
        id="path4087"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 226.070007 L 615.359985 226.070007 L 615.359985 227.51001 L 617.090027 227.51001 L 617.090027 226.070007 Z"
      />
      <path
        id="path4088"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 228.190002 L 615.359985 228.190002 L 615.359985 229.630005 L 617.090027 229.630005 L 617.090027 228.190002 Z"
      />
      <path
        id="path4089"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 200.660004 L 618.169983 200.660004 L 618.169983 202.100006 L 619.900024 202.100006 L 619.900024 200.660004 Z"
      />
      <path
        id="path4090"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 202.77002 L 618.169983 202.77002 L 618.169983 204.210022 L 619.900024 204.210022 L 619.900024 202.77002 Z"
      />
      <path
        id="path4091"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 202.77002 L 620.960022 202.77002 L 620.960022 204.210022 L 622.690002 204.210022 L 622.690002 202.77002 Z"
      />
      <path
        id="path4092"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 204.890015 L 618.169983 204.890015 L 618.169983 206.330017 L 619.900024 206.330017 L 619.900024 204.890015 Z"
      />
      <path
        id="path4093"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 209.130005 L 618.169983 209.130005 L 618.169983 210.570007 L 619.900024 210.570007 L 619.900024 209.130005 Z"
      />
      <path
        id="path4094"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 213.359985 L 618.169983 213.359985 L 618.169983 214.799988 L 619.900024 214.799988 L 619.900024 213.359985 Z"
      />
      <path
        id="path4095"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 215.47998 L 618.169983 215.47998 L 618.169983 216.919983 L 619.900024 216.919983 L 619.900024 215.47998 Z"
      />
      <path
        id="path4096"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 217.600006 L 618.169983 217.600006 L 618.169983 219.039978 L 619.900024 219.039978 L 619.900024 217.600006 Z"
      />
      <path
        id="path4097"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 226.070007 L 618.169983 226.070007 L 618.169983 227.51001 L 619.900024 227.51001 L 619.900024 226.070007 Z"
      />
      <path
        id="path4098"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 230.299988 L 618.169983 230.299988 L 618.169983 231.73999 L 619.900024 231.73999 L 619.900024 230.299988 Z"
      />
      <path
        id="path4099"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 198.539978 L 620.960022 198.539978 L 620.960022 199.97998 L 622.690002 199.97998 L 622.690002 198.539978 Z"
      />
      <path
        id="path4100"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 200.660004 L 620.960022 200.660004 L 620.960022 202.100006 L 622.690002 202.100006 L 622.690002 200.660004 Z"
      />
      <path
        id="path4101"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 204.890015 L 620.960022 204.890015 L 620.960022 206.330017 L 622.690002 206.330017 L 622.690002 204.890015 Z"
      />
      <path
        id="path4102"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 207.01001 L 620.960022 207.01001 L 620.960022 208.450012 L 622.690002 208.450012 L 622.690002 207.01001 Z"
      />
      <path
        id="path4103"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 209.130005 L 620.960022 209.130005 L 620.960022 210.570007 L 622.690002 210.570007 L 622.690002 209.130005 Z"
      />
      <path
        id="path4104"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 211.23999 L 620.960022 211.23999 L 620.960022 212.679993 L 622.690002 212.679993 L 622.690002 211.23999 Z"
      />
      <path
        id="path4105"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 213.359985 L 620.960022 213.359985 L 620.960022 214.799988 L 622.690002 214.799988 L 622.690002 213.359985 Z"
      />
      <path
        id="path4106"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 217.600006 L 620.960022 217.600006 L 620.960022 219.039978 L 622.690002 219.039978 L 622.690002 217.600006 Z"
      />
      <path
        id="path4107"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 219.720001 L 620.960022 219.720001 L 620.960022 221.160004 L 622.690002 221.160004 L 622.690002 219.720001 Z"
      />
      <path
        id="path4108"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 221.830017 L 620.960022 221.830017 L 620.960022 223.27002 L 622.690002 223.27002 L 622.690002 221.830017 Z"
      />
      <path
        id="path4109"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 223.950012 L 620.960022 223.950012 L 620.960022 225.390015 L 622.690002 225.390015 L 622.690002 223.950012 Z"
      />
      <path
        id="path4110"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 226.070007 L 620.960022 226.070007 L 620.960022 227.51001 L 622.690002 227.51001 L 622.690002 226.070007 Z"
      />
      <path
        id="path4111"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 228.190002 L 620.960022 228.190002 L 620.960022 229.630005 L 622.690002 229.630005 L 622.690002 228.190002 Z"
      />
      <path
        id="path4112"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 200.660004 L 623.76001 200.660004 L 623.76001 202.100006 L 625.47998 202.100006 L 625.47998 200.660004 Z"
      />
      <path
        id="path4113"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 202.77002 L 623.76001 202.77002 L 623.76001 204.210022 L 625.47998 204.210022 L 625.47998 202.77002 Z"
      />
      <path
        id="path4114"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 204.890015 L 623.76001 204.890015 L 623.76001 206.330017 L 625.47998 206.330017 L 625.47998 204.890015 Z"
      />
      <path
        id="path4115"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 207.01001 L 623.76001 207.01001 L 623.76001 208.450012 L 625.47998 208.450012 L 625.47998 207.01001 Z"
      />
      <path
        id="path4116"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 209.130005 L 623.76001 209.130005 L 623.76001 210.570007 L 625.47998 210.570007 L 625.47998 209.130005 Z"
      />
      <path
        id="path4117"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 211.23999 L 623.76001 211.23999 L 623.76001 212.679993 L 625.47998 212.679993 L 625.47998 211.23999 Z"
      />
      <path
        id="path4118"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 213.359985 L 623.76001 213.359985 L 623.76001 214.799988 L 625.47998 214.799988 L 625.47998 213.359985 Z"
      />
      <path
        id="path4119"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 215.47998 L 623.76001 215.47998 L 623.76001 216.919983 L 625.47998 216.919983 L 625.47998 215.47998 Z"
      />
      <path
        id="path4120"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 217.600006 L 623.76001 217.600006 L 623.76001 219.039978 L 625.47998 219.039978 L 625.47998 217.600006 Z"
      />
      <path
        id="path4121"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 219.720001 L 623.76001 219.720001 L 623.76001 221.160004 L 625.47998 221.160004 L 625.47998 219.720001 Z"
      />
      <path
        id="path4122"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 221.830017 L 623.76001 221.830017 L 623.76001 223.27002 L 625.47998 223.27002 L 625.47998 221.830017 Z"
      />
      <path
        id="path4123"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 223.950012 L 623.76001 223.950012 L 623.76001 225.390015 L 625.47998 225.390015 L 625.47998 223.950012 Z"
      />
      <path
        id="path4124"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 198.539978 L 626.559998 198.539978 L 626.559998 199.97998 L 628.289978 199.97998 L 628.289978 198.539978 Z"
      />
      <path
        id="path4125"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 200.660004 L 626.559998 200.660004 L 626.559998 202.100006 L 628.289978 202.100006 L 628.289978 200.660004 Z"
      />
      <path
        id="path4126"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 202.77002 L 626.559998 202.77002 L 626.559998 204.210022 L 628.289978 204.210022 L 628.289978 202.77002 Z"
      />
      <path
        id="path4127"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 202.77002 L 628.97998 202.77002 L 628.97998 204.210022 L 630.710022 204.210022 L 630.710022 202.77002 Z"
      />
      <path
        id="path4128"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 204.890015 L 626.559998 204.890015 L 626.559998 206.330017 L 628.289978 206.330017 L 628.289978 204.890015 Z"
      />
      <path
        id="path4129"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 211.23999 L 626.559998 211.23999 L 626.559998 212.679993 L 628.289978 212.679993 L 628.289978 211.23999 Z"
      />
      <path
        id="path4130"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 213.359985 L 626.559998 213.359985 L 626.559998 214.799988 L 628.289978 214.799988 L 628.289978 213.359985 Z"
      />
      <path
        id="path4131"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 215.47998 L 626.559998 215.47998 L 626.559998 216.919983 L 628.289978 216.919983 L 628.289978 215.47998 Z"
      />
      <path
        id="path4132"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 217.600006 L 626.559998 217.600006 L 626.559998 219.039978 L 628.289978 219.039978 L 628.289978 217.600006 Z"
      />
      <path
        id="path4133"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 223.950012 L 626.559998 223.950012 L 626.559998 225.390015 L 628.289978 225.390015 L 628.289978 223.950012 Z"
      />
      <path
        id="path4134"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 226.070007 L 626.559998 226.070007 L 626.559998 227.51001 L 628.289978 227.51001 L 628.289978 226.070007 Z"
      />
      <path
        id="path4135"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 228.190002 L 626.559998 228.190002 L 626.559998 229.630005 L 628.289978 229.630005 L 628.289978 228.190002 Z"
      />
      <path
        id="path4136"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 230.380005 L 609.77002 230.380005 L 609.77002 231.820007 L 611.48999 231.820007 L 611.48999 230.380005 Z"
      />
      <path
        id="path4137"
        fill="#cecece"
        stroke="none"
        d="M 611.48999 234.609985 L 609.77002 234.609985 L 609.77002 236.049988 L 611.48999 236.049988 L 611.48999 234.609985 Z"
      />
      <path
        id="path4138"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 228.26001 L 612.570007 228.26001 L 612.570007 229.700012 L 614.289978 229.700012 L 614.289978 228.26001 Z"
      />
      <path
        id="path4139"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 232.5 L 612.570007 232.5 L 612.570007 233.940002 L 614.289978 233.940002 L 614.289978 232.5 Z"
      />
      <path
        id="path4140"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 234.609985 L 612.570007 234.609985 L 612.570007 236.049988 L 614.289978 236.049988 L 614.289978 234.609985 Z"
      />
      <path
        id="path4141"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 236.72998 L 612.570007 236.72998 L 612.570007 238.169998 L 614.289978 238.169998 L 614.289978 236.72998 Z"
      />
      <path
        id="path4142"
        fill="#cecece"
        stroke="none"
        d="M 614.289978 238.850006 L 612.570007 238.850006 L 612.570007 240.289993 L 614.289978 240.289993 L 614.289978 238.850006 Z"
      />
      <path
        id="path4143"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 230.380005 L 615.359985 230.380005 L 615.359985 231.820007 L 617.090027 231.820007 L 617.090027 230.380005 Z"
      />
      <path
        id="path4144"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 236.72998 L 615.359985 236.72998 L 615.359985 238.169998 L 617.090027 238.169998 L 617.090027 236.72998 Z"
      />
      <path
        id="path4145"
        fill="#cecece"
        stroke="none"
        d="M 617.090027 238.850006 L 615.359985 238.850006 L 615.359985 240.289993 L 617.090027 240.289993 L 617.090027 238.850006 Z"
      />
      <path
        id="path4146"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 232.5 L 618.169983 232.5 L 618.169983 233.940002 L 619.900024 233.940002 L 619.900024 232.5 Z"
      />
      <path
        id="path4147"
        fill="#cecece"
        stroke="none"
        d="M 619.900024 234.609985 L 618.169983 234.609985 L 618.169983 236.049988 L 619.900024 236.049988 L 619.900024 234.609985 Z"
      />
      <path
        id="path4148"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 228.26001 L 620.960022 228.26001 L 620.960022 229.700012 L 622.690002 229.700012 L 622.690002 228.26001 Z"
      />
      <path
        id="path4149"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 234.609985 L 620.960022 234.609985 L 620.960022 236.049988 L 622.690002 236.049988 L 622.690002 234.609985 Z"
      />
      <path
        id="path4150"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 236.72998 L 620.960022 236.72998 L 620.960022 238.169998 L 622.690002 238.169998 L 622.690002 236.72998 Z"
      />
      <path
        id="path4151"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 238.850006 L 620.960022 238.850006 L 620.960022 240.289993 L 622.690002 240.289993 L 622.690002 238.850006 Z"
      />
      <path
        id="path4152"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 228.26001 L 623.76001 228.26001 L 623.76001 229.700012 L 625.47998 229.700012 L 625.47998 228.26001 Z"
      />
      <path
        id="path4153"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 230.380005 L 623.76001 230.380005 L 623.76001 231.820007 L 625.47998 231.820007 L 625.47998 230.380005 Z"
      />
      <path
        id="path4154"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 232.5 L 623.76001 232.5 L 623.76001 233.940002 L 625.47998 233.940002 L 625.47998 232.5 Z"
      />
      <path
        id="path4155"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 236.72998 L 623.76001 236.72998 L 623.76001 238.169998 L 625.47998 238.169998 L 625.47998 236.72998 Z"
      />
      <path
        id="path4156"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 228.26001 L 626.559998 228.26001 L 626.559998 229.700012 L 628.289978 229.700012 L 628.289978 228.26001 Z"
      />
      <path
        id="path4157"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 234.609985 L 626.559998 234.609985 L 626.559998 236.049988 L 628.289978 236.049988 L 628.289978 234.609985 Z"
      />
      <path
        id="path4158"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 198.539978 L 628.97998 198.539978 L 628.97998 199.97998 L 630.710022 199.97998 L 630.710022 198.539978 Z"
      />
      <path
        id="path4159"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 200.660004 L 628.97998 200.660004 L 628.97998 202.100006 L 630.710022 202.100006 L 630.710022 200.660004 Z"
      />
      <path
        id="path4160"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 204.890015 L 628.97998 204.890015 L 628.97998 206.330017 L 630.710022 206.330017 L 630.710022 204.890015 Z"
      />
      <path
        id="path4161"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 207.01001 L 628.97998 207.01001 L 628.97998 208.450012 L 630.710022 208.450012 L 630.710022 207.01001 Z"
      />
      <path
        id="path4162"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 209.130005 L 628.97998 209.130005 L 628.97998 210.570007 L 630.710022 210.570007 L 630.710022 209.130005 Z"
      />
      <path
        id="path4163"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 211.23999 L 628.97998 211.23999 L 628.97998 212.679993 L 630.710022 212.679993 L 630.710022 211.23999 Z"
      />
      <path
        id="path4164"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 213.359985 L 628.97998 213.359985 L 628.97998 214.799988 L 630.710022 214.799988 L 630.710022 213.359985 Z"
      />
      <path
        id="path4165"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 217.600006 L 628.97998 217.600006 L 628.97998 219.039978 L 630.710022 219.039978 L 630.710022 217.600006 Z"
      />
      <path
        id="path4166"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 219.720001 L 628.97998 219.720001 L 628.97998 221.160004 L 630.710022 221.160004 L 630.710022 219.720001 Z"
      />
      <path
        id="path4167"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 221.830017 L 628.97998 221.830017 L 628.97998 223.27002 L 630.710022 223.27002 L 630.710022 221.830017 Z"
      />
      <path
        id="path4168"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 223.950012 L 628.97998 223.950012 L 628.97998 225.390015 L 630.710022 225.390015 L 630.710022 223.950012 Z"
      />
      <path
        id="path4169"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 226.070007 L 628.97998 226.070007 L 628.97998 227.51001 L 630.710022 227.51001 L 630.710022 226.070007 Z"
      />
      <path
        id="path4170"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 228.190002 L 628.97998 228.190002 L 628.97998 229.630005 L 630.710022 229.630005 L 630.710022 228.190002 Z"
      />
      <path
        id="path4171"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 196.419983 L 609.77002 196.419983 L 609.77002 197.859985 L 633.51001 197.859985 L 633.51001 196.419983 Z"
      />
      <path
        id="path4172"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 200.660004 L 631.780029 200.660004 L 631.780029 202.100006 L 633.51001 202.100006 L 633.51001 200.660004 Z"
      />
      <path
        id="path4173"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 202.77002 L 631.780029 202.77002 L 631.780029 204.210022 L 633.51001 204.210022 L 633.51001 202.77002 Z"
      />
      <path
        id="path4174"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 204.890015 L 631.780029 204.890015 L 631.780029 206.330017 L 633.51001 206.330017 L 633.51001 204.890015 Z"
      />
      <path
        id="path4175"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 207.01001 L 631.780029 207.01001 L 631.780029 208.450012 L 633.51001 208.450012 L 633.51001 207.01001 Z"
      />
      <path
        id="path4176"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 209.130005 L 631.780029 209.130005 L 631.780029 210.570007 L 633.51001 210.570007 L 633.51001 209.130005 Z"
      />
      <path
        id="path4177"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 211.23999 L 631.780029 211.23999 L 631.780029 212.679993 L 633.51001 212.679993 L 633.51001 211.23999 Z"
      />
      <path
        id="path4178"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 213.359985 L 631.780029 213.359985 L 631.780029 214.799988 L 633.51001 214.799988 L 633.51001 213.359985 Z"
      />
      <path
        id="path4179"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 215.47998 L 631.780029 215.47998 L 631.780029 216.919983 L 633.51001 216.919983 L 633.51001 215.47998 Z"
      />
      <path
        id="path4180"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 217.600006 L 631.780029 217.600006 L 631.780029 219.039978 L 633.51001 219.039978 L 633.51001 217.600006 Z"
      />
      <path
        id="path4181"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 219.720001 L 631.780029 219.720001 L 631.780029 221.160004 L 633.51001 221.160004 L 633.51001 219.720001 Z"
      />
      <path
        id="path4182"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 221.830017 L 631.780029 221.830017 L 631.780029 223.27002 L 633.51001 223.27002 L 633.51001 221.830017 Z"
      />
      <path
        id="path4183"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 223.950012 L 631.780029 223.950012 L 631.780029 225.390015 L 633.51001 225.390015 L 633.51001 223.950012 Z"
      />
      <path
        id="path4184"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 228.26001 L 628.97998 228.26001 L 628.97998 229.700012 L 630.710022 229.700012 L 630.710022 228.26001 Z"
      />
      <path
        id="path4185"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 234.609985 L 628.97998 234.609985 L 628.97998 236.049988 L 630.710022 236.049988 L 630.710022 234.609985 Z"
      />
      <path
        id="path4186"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 236.72998 L 628.97998 236.72998 L 628.97998 238.169998 L 630.710022 238.169998 L 630.710022 236.72998 Z"
      />
      <path
        id="path4187"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 238.850006 L 628.97998 238.850006 L 628.97998 240.289993 L 630.710022 240.289993 L 630.710022 238.850006 Z"
      />
      <path
        id="path4188"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 228.26001 L 631.780029 228.26001 L 631.780029 229.700012 L 633.51001 229.700012 L 633.51001 228.26001 Z"
      />
      <path
        id="path4189"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 230.380005 L 631.780029 230.380005 L 631.780029 231.820007 L 633.51001 231.820007 L 633.51001 230.380005 Z"
      />
      <path
        id="path4190"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 232.5 L 631.780029 232.5 L 631.780029 233.940002 L 633.51001 233.940002 L 633.51001 232.5 Z"
      />
      <path
        id="path4191"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 236.72998 L 631.780029 236.72998 L 631.780029 238.169998 L 633.51001 238.169998 L 633.51001 236.72998 Z"
      />
      <path
        id="path4192"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 240.919998 L 623.76001 240.919998 L 623.76001 242.360001 L 625.47998 242.360001 L 625.47998 240.919998 Z"
      />
      <path
        id="path4193"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 243.039993 L 623.76001 243.039993 L 623.76001 244.479996 L 625.47998 244.479996 L 625.47998 243.039993 Z"
      />
      <path
        id="path4194"
        fill="#cecece"
        stroke="none"
        d="M 622.690002 243.039993 L 620.960022 243.039993 L 620.960022 244.479996 L 622.690002 244.479996 L 622.690002 243.039993 Z"
      />
      <path
        id="path4195"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 245.160004 L 623.76001 245.160004 L 623.76001 246.600006 L 625.47998 246.600006 L 625.47998 245.160004 Z"
      />
      <path
        id="path4196"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 245.160004 L 626.559998 245.160004 L 626.559998 246.600006 L 628.289978 246.600006 L 628.289978 245.160004 Z"
      />
      <path
        id="path4197"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 249.389999 L 626.559998 249.389999 L 626.559998 250.830002 L 628.289978 250.830002 L 628.289978 249.389999 Z"
      />
      <path
        id="path4198"
        fill="#cecece"
        stroke="none"
        d="M 625.47998 251.580002 L 623.76001 251.580002 L 623.76001 253.020004 L 625.47998 253.020004 L 625.47998 251.580002 Z"
      />
      <path
        id="path4199"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 249.460007 L 626.559998 249.460007 L 626.559998 250.899994 L 628.289978 250.899994 L 628.289978 249.460007 Z"
      />
      <path
        id="path4200"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 253.539993 L 626.559998 253.539993 L 626.559998 254.979996 L 628.289978 254.979996 L 628.289978 253.539993 Z"
      />
      <path
        id="path4201"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 243.039993 L 628.97998 243.039993 L 628.97998 244.479996 L 630.710022 244.479996 L 630.710022 243.039993 Z"
      />
      <path
        id="path4202"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 247.270004 L 628.97998 247.270004 L 628.97998 248.710007 L 630.710022 248.710007 L 630.710022 247.270004 Z"
      />
      <path
        id="path4203"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 249.389999 L 628.97998 249.389999 L 628.97998 250.830002 L 630.710022 250.830002 L 630.710022 249.389999 Z"
      />
      <path
        id="path4204"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 240.919998 L 631.780029 240.919998 L 631.780029 242.360001 L 633.51001 242.360001 L 633.51001 240.919998 Z"
      />
      <path
        id="path4205"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 245.160004 L 631.780029 245.160004 L 631.780029 246.600006 L 633.51001 246.600006 L 633.51001 245.160004 Z"
      />
      <path
        id="path4206"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 249.460007 L 628.97998 249.460007 L 628.97998 250.899994 L 630.710022 250.899994 L 630.710022 249.460007 Z"
      />
      <path
        id="path4207"
        fill="#cecece"
        stroke="none"
        d="M 630.710022 255.660004 L 628.97998 255.660004 L 628.97998 257.100006 L 630.710022 257.100006 L 630.710022 255.660004 Z"
      />
      <path
        id="path4208"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 249.460007 L 631.780029 249.460007 L 631.780029 250.899994 L 633.51001 250.899994 L 633.51001 249.460007 Z"
      />
      <path
        id="path4209"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 251.580002 L 631.780029 251.580002 L 631.780029 253.020004 L 633.51001 253.020004 L 633.51001 251.580002 Z"
      />
      <path
        id="path4210"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 257.940002 L 631.780029 257.940002 L 631.780029 259.380005 L 633.51001 259.380005 L 633.51001 257.940002 Z"
      />
      <path
        id="path4211"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 260.179993 L 631.780029 260.179993 L 631.780029 261.619995 L 633.51001 261.619995 L 633.51001 260.179993 Z"
      />
      <path
        id="path4212"
        fill="#cecece"
        stroke="none"
        d="M 633.51001 253.779999 L 631.780029 253.779999 L 631.780029 255.220001 L 633.51001 255.220001 L 633.51001 253.779999 Z"
      />
      <path
        id="path4213"
        fill="#cecece"
        stroke="none"
        d="M 628.289978 198.440002 L 609.77002 198.440002 L 609.77002 199.26001 L 628.289978 199.26001 L 628.289978 198.440002 Z"
      />
      <path
        id="path4214"
        fill="#cecece"
        stroke="none"
        d="M 577.429993 162.01001 L 578.460022 162.369995 L 578.460022 161.359985 L 577.429993 160.97998 L 577.429993 162.01001 Z"
      />
      <path
        id="path4215"
        fill="#cecece"
        stroke="none"
        d="M 577.429993 166.149994 L 578.460022 166.47998 L 578.460022 165.429993 L 577.429993 165.080017 L 577.429993 166.149994 Z"
      />
      <path
        id="path4216"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 146.850006 L 576.859985 147.320007 L 576.859985 146.440002 L 575.820007 145.940002 L 575.820007 146.850006 Z"
      />
      <path
        id="path4217"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 148.940002 L 576.859985 149.390015 L 576.859985 148.5 L 575.820007 148.01001 L 575.820007 148.940002 Z"
      />
      <path
        id="path4218"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 153.130005 L 576.859985 153.549988 L 576.859985 152.609985 L 575.820007 152.160004 L 575.820007 153.130005 Z"
      />
      <path
        id="path4219"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 155.220001 L 576.849976 155.619995 L 576.849976 154.669983 L 575.820007 154.23999 L 575.820007 155.220001 Z"
      />
      <path
        id="path4220"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 157.309998 L 576.849976 157.700012 L 576.849976 156.72998 L 575.820007 156.309998 L 575.820007 157.309998 Z"
      />
      <path
        id="path4221"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 159.399994 L 576.849976 159.779999 L 576.849976 158.789978 L 575.820007 158.390015 L 575.820007 159.399994 Z"
      />
      <path
        id="path4222"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 161.48999 L 576.849976 161.850006 L 576.849976 160.839996 L 575.820007 160.460022 L 575.820007 161.48999 Z"
      />
      <path
        id="path4223"
        fill="#cecece"
        stroke="none"
        d="M 575.820007 163.589996 L 576.849976 163.929993 L 576.849976 162.899994 L 575.820007 162.539978 L 575.820007 163.589996 Z"
      />
      <path
        id="path4224"
        fill="#cecece"
        stroke="none"
        d="M 575.809998 165.679993 L 576.849976 166.01001 L 576.849976 164.960022 L 575.809998 164.609985 L 575.809998 165.679993 Z"
      />
      <path
        id="path4225"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 146.169983 L 575.190002 146.640015 L 575.190002 145.76001 L 574.150024 145.25 L 574.150024 146.169983 Z"
      />
      <path
        id="path4226"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 148.279999 L 575.190002 148.73999 L 575.190002 147.839996 L 574.150024 147.350006 L 574.150024 148.279999 Z"
      />
      <path
        id="path4227"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 150.399994 L 575.200012 150.839996 L 575.200012 149.919983 L 574.150024 149.450012 L 574.150024 150.399994 Z"
      />
      <path
        id="path4228"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 152.51001 L 575.200012 152.940002 L 575.200012 152 L 574.150024 151.549988 L 574.150024 152.51001 Z"
      />
      <path
        id="path4229"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 154.630005 L 575.200012 155.039978 L 575.200012 154.080017 L 574.150024 153.640015 L 574.150024 154.630005 Z"
      />
      <path
        id="path4230"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 156.73999 L 575.200012 157.140015 L 575.200012 156.160004 L 574.150024 155.73999 L 574.150024 156.73999 Z"
      />
      <path
        id="path4231"
        fill="#cecece"
        stroke="none"
        d="M 574.150024 158.859985 L 575.200012 159.22998 L 575.200012 158.23999 L 574.150024 157.839996 L 574.150024 158.859985 Z"
      />
      <path
        id="path4232"
        fill="#cecece"
        stroke="none"
        d="M 574.159973 160.970001 L 575.200012 161.330017 L 575.200012 160.320007 L 574.159973 159.929993 L 574.159973 160.970001 Z"
      />
      <path
        id="path4233"
        fill="#cecece"
        stroke="none"
        d="M 574.159973 163.089996 L 575.200012 163.429993 L 575.200012 162.399994 L 574.159973 162.029999 L 574.159973 163.089996 Z"
      />
      <path
        id="path4234"
        fill="#cecece"
        stroke="none"
        d="M 574.159973 165.200012 L 575.200012 165.529999 L 575.200012 164.47998 L 574.159973 164.130005 L 574.159973 165.200012 Z"
      />
      <path
        id="path4235"
        fill="#cecece"
        stroke="none"
        d="M 574.159973 167.320007 L 575.200012 167.630005 L 575.200012 166.559998 L 574.159973 166.22998 L 574.159973 167.320007 Z"
      />
      <path
        id="path4236"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 147.710022 L 573.559998 148.039978 L 573.559998 147.200012 L 572.320007 146.789978 L 572.320007 147.710022 Z"
      />
      <path
        id="path4237"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 149.839996 L 573.559998 150.160004 L 573.559998 149.299988 L 572.320007 148.910004 L 572.320007 149.839996 Z"
      />
      <path
        id="path4238"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 151.97998 L 573.559998 152.289978 L 573.559998 151.399994 L 572.320007 151.029999 L 572.320007 151.97998 Z"
      />
      <path
        id="path4239"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 154.109985 L 573.559998 154.410004 L 573.559998 153.51001 L 572.320007 153.140015 L 572.320007 154.109985 Z"
      />
      <path
        id="path4240"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 156.25 L 573.559998 156.529999 L 573.559998 155.609985 L 572.320007 155.26001 L 572.320007 156.25 Z"
      />
      <path
        id="path4241"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 158.380005 L 573.559998 158.660004 L 573.559998 157.710022 L 572.320007 157.380005 L 572.320007 158.380005 Z"
      />
      <path
        id="path4242"
        fill="#cecece"
        stroke="none"
        d="M 572.320007 160.51001 L 573.559998 160.779999 L 573.559998 159.809998 L 572.320007 159.48999 L 572.320007 160.51001 Z"
      />
      <path
        id="path4243"
        fill="#cecece"
        stroke="none"
        d="M 572.330017 162.649994 L 573.559998 162.899994 L 573.559998 161.919983 L 572.330017 161.609985 L 572.330017 162.649994 Z"
      />
      <path
        id="path4244"
        fill="#cecece"
        stroke="none"
        d="M 572.330017 164.779999 L 573.549988 165.029999 L 573.549988 164.02002 L 572.330017 163.72998 L 572.330017 164.779999 Z"
      />
      <path
        id="path4245"
        fill="#cecece"
        stroke="none"
        d="M 572.330017 166.919983 L 573.549988 167.149994 L 573.549988 166.119995 L 572.330017 165.839996 L 572.330017 166.919983 Z"
      />
      <path
        id="path4246"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 233.309998 L 500.649994 233.309998 L 500.649994 234.679993 L 502.290009 234.679993 L 502.290009 233.309998 Z"
      />
      <path
        id="path4247"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 231.289978 L 497.440002 231.289978 L 497.440002 232.660004 L 499.079987 232.660004 L 499.079987 231.289978 Z"
      />
      <path
        id="path4248"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 233.309998 L 497.440002 233.309998 L 497.440002 234.679993 L 499.079987 234.679993 L 499.079987 233.309998 Z"
      />
      <path
        id="path4249"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 231.289978 L 491.019989 231.289978 L 491.019989 232.660004 L 492.670013 232.660004 L 492.670013 231.289978 Z"
      />
      <path
        id="path4250"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 233.309998 L 491.019989 233.309998 L 491.019989 234.679993 L 492.670013 234.679993 L 492.670013 233.309998 Z"
      />
      <path
        id="path4251"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 231.289978 L 487.809998 231.289978 L 487.809998 232.660004 L 489.459991 232.660004 L 489.459991 231.289978 Z"
      />
      <path
        id="path4252"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 235.330017 L 487.809998 235.330017 L 487.809998 236.700012 L 489.459991 236.700012 L 489.459991 235.330017 Z"
      />
      <path
        id="path4253"
        fill="#cecece"
        stroke="none"
        d="M 486.25 231.289978 L 484.600006 231.289978 L 484.600006 232.660004 L 486.25 232.660004 L 486.25 231.289978 Z"
      />
      <path
        id="path4254"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 235.399994 L 497.440002 235.399994 L 497.440002 236.77002 L 499.079987 236.77002 L 499.079987 235.399994 Z"
      />
      <path
        id="path4255"
        fill="#cecece"
        stroke="none"
        d="M 499.079987 239.429993 L 497.440002 239.429993 L 497.440002 240.800003 L 499.079987 240.800003 L 499.079987 239.429993 Z"
      />
      <path
        id="path4256"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 237.410004 L 494.230011 237.410004 L 494.230011 238.779999 L 495.869995 238.779999 L 495.869995 237.410004 Z"
      />
      <path
        id="path4257"
        fill="#cecece"
        stroke="none"
        d="M 495.869995 239.429993 L 494.230011 239.429993 L 494.230011 240.800003 L 495.869995 240.800003 L 495.869995 239.429993 Z"
      />
      <path
        id="path4258"
        fill="#cecece"
        stroke="none"
        d="M 492.670013 243.470001 L 491.019989 243.470001 L 491.019989 244.839996 L 492.670013 244.839996 L 492.670013 243.470001 Z"
      />
      <path
        id="path4259"
        fill="#cecece"
        stroke="none"
        d="M 489.459991 237.410004 L 487.809998 237.410004 L 487.809998 238.779999 L 489.459991 238.779999 L 489.459991 237.410004 Z"
      />
      <path
        id="path4260"
        fill="#cecece"
        stroke="none"
        d="M 486.25 239.429993 L 484.600006 239.429993 L 484.600006 240.800003 L 486.25 240.800003 L 486.25 239.429993 Z"
      />
      <path
        id="path4261"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 241.710007 L 500.649994 241.710007 L 500.649994 243.080002 L 502.290009 243.080002 L 502.290009 241.710007 Z"
      />
      <path
        id="path4262"
        fill="#cecece"
        stroke="none"
        d="M 502.290009 243.729996 L 500.649994 243.729996 L 500.649994 245.100006 L 502.290009 245.100006 L 502.290009 243.729996 Z"
      />
      <g id="g3" opacity="0.4">
        <path
          id="path4263"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 164.910004 L 634.869995 165.190002 L 634.869995 164.580017 L 638.599976 164.299988 L 638.599976 164.910004 Z"
        />
        <path
          id="path4264"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 166.22998 L 634.869995 166.48999 L 634.869995 165.880005 L 638.599976 165.600006 L 638.599976 166.22998 Z"
        />
        <path
          id="path4265"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 167.549988 L 634.880005 167.799988 L 634.880005 167.169983 L 638.599976 166.899994 L 638.599976 167.549988 Z"
        />
        <path
          id="path4266"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 168.859985 L 634.880005 169.100006 L 634.880005 168.470001 L 638.599976 168.210022 L 638.599976 168.859985 Z"
        />
        <path
          id="path4267"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 170.179993 L 634.880005 170.410004 L 634.880005 169.76001 L 638.599976 169.51001 L 638.599976 170.179993 Z"
        />
        <path
          id="path4268"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 171.48999 L 634.880005 171.710022 L 634.880005 171.049988 L 638.590027 170.820007 L 638.590027 171.48999 Z"
        />
        <path
          id="path4269"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 172.809998 L 634.880005 173.02002 L 634.880005 172.350006 L 638.590027 172.119995 L 638.590027 172.809998 Z"
        />
        <path
          id="path4270"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 174.119995 L 634.890015 174.320007 L 634.890015 173.640015 L 638.590027 173.419983 L 638.590027 174.119995 Z"
        />
        <path
          id="path4271"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 175.440002 L 634.890015 175.630005 L 634.890015 174.929993 L 638.590027 174.72998 L 638.590027 175.440002 Z"
        />
        <path
          id="path4272"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 176.75 L 634.890015 176.929993 L 634.890015 176.22998 L 638.590027 176.029999 L 638.590027 176.75 Z"
        />
        <path
          id="path4273"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 178.070007 L 634.890015 178.23999 L 634.890015 177.52002 L 638.590027 177.339996 L 638.590027 178.070007 Z"
        />
        <path
          id="path4274"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 179.380005 L 634.890015 179.549988 L 634.890015 178.809998 L 638.590027 178.640015 L 638.590027 179.380005 Z"
        />
        <path
          id="path4275"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 182.02002 L 634.900024 182.160004 L 634.900024 181.399994 L 638.590027 181.25 L 638.590027 182.02002 Z"
        />
        <path
          id="path4276"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 183.330017 L 634.900024 183.460022 L 634.900024 182.690002 L 638.590027 182.549988 L 638.590027 183.330017 Z"
        />
        <path
          id="path4277"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 184.649994 L 634.900024 184.77002 L 634.900024 183.98999 L 638.590027 183.859985 L 638.590027 184.649994 Z"
        />
        <path
          id="path4278"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 187.279999 L 634.909973 187.380005 L 634.909973 186.570007 L 638.590027 186.470001 L 638.590027 187.279999 Z"
        />
        <path
          id="path4279"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 191.220001 L 634.919983 191.289978 L 634.919983 190.450012 L 638.590027 190.380005 L 638.590027 191.220001 Z"
        />
        <path
          id="path4280"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.590027 195.169983 L 634.919983 195.210022 L 634.919983 194.330017 L 638.590027 194.289978 L 638.590027 195.169983 Z"
        />
        <path
          id="path4281"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.580017 199.899994 L 634.929993 199.910004 L 634.929993 199 L 638.580017 198.98999 L 638.580017 199.899994 Z"
        />
        <path
          id="path4282"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.580017 196.5 L 634.929993 196.51001 L 634.929993 195.600006 L 638.580017 195.589996 L 638.580017 196.5 Z"
        />
        <path
          id="path4283"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.119995 164.399994 L 646.849976 164.669983 L 646.849976 164.070007 L 643.119995 163.779999 L 643.119995 164.399994 Z"
        />
        <path
          id="path4284"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.119995 165.710022 L 646.849976 165.970001 L 646.849976 165.359985 L 643.119995 165.080017 L 643.119995 165.710022 Z"
        />
        <path
          id="path4285"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.119995 167.029999 L 646.840027 167.279999 L 646.840027 166.649994 L 643.119995 166.390015 L 643.119995 167.029999 Z"
        />
        <path
          id="path4286"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.119995 168.339996 L 646.840027 168.580017 L 646.840027 167.950012 L 643.119995 167.690002 L 643.119995 168.339996 Z"
        />
        <path
          id="path4287"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.119995 169.660004 L 646.840027 169.890015 L 646.840027 169.23999 L 643.119995 168.98999 L 643.119995 169.660004 Z"
        />
        <path
          id="path4288"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 170.970001 L 646.840027 171.190002 L 646.840027 170.529999 L 643.130005 170.299988 L 643.130005 170.970001 Z"
        />
        <path
          id="path4289"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 172.289978 L 646.840027 172.5 L 646.840027 171.830017 L 643.130005 171.600006 L 643.130005 172.289978 Z"
        />
        <path
          id="path4290"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 173.600006 L 646.840027 173.809998 L 646.840027 173.119995 L 643.130005 172.910004 L 643.130005 173.600006 Z"
        />
        <path
          id="path4291"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 174.919983 L 646.830017 175.109985 L 646.830017 174.410004 L 643.130005 174.210022 L 643.130005 174.919983 Z"
        />
        <path
          id="path4292"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 176.23999 L 646.830017 176.419983 L 646.830017 175.710022 L 643.130005 175.52002 L 643.130005 176.23999 Z"
        />
        <path
          id="path4293"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 177.549988 L 646.830017 177.720001 L 646.830017 177 L 643.130005 176.820007 L 643.130005 177.549988 Z"
        />
        <path
          id="path4294"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 178.869995 L 646.830017 179.029999 L 646.830017 178.289978 L 643.130005 178.119995 L 643.130005 178.869995 Z"
        />
        <path
          id="path4295"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 180.179993 L 646.830017 180.330017 L 646.830017 179.589996 L 643.130005 179.429993 L 643.130005 180.179993 Z"
        />
        <path
          id="path4296"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 181.5 L 646.820007 181.640015 L 646.820007 180.880005 L 643.130005 180.72998 L 643.130005 181.5 Z"
        />
        <path
          id="path4297"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 182.809998 L 646.820007 182.940002 L 646.820007 182.179993 L 643.130005 182.039978 L 643.130005 182.809998 Z"
        />
        <path
          id="path4298"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 184.130005 L 646.820007 184.25 L 646.820007 183.470001 L 643.130005 183.339996 L 643.130005 184.130005 Z"
        />
        <path
          id="path4299"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 186.76001 L 646.809998 186.859985 L 646.809998 186.059998 L 643.130005 185.950012 L 643.130005 186.76001 Z"
        />
        <path
          id="path4300"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 190.710022 L 646.809998 190.779999 L 646.809998 189.940002 L 643.130005 189.859985 L 643.130005 190.710022 Z"
        />
        <path
          id="path4301"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.130005 194.649994 L 646.799988 194.690002 L 646.799988 193.820007 L 643.130005 193.77002 L 643.130005 194.649994 Z"
        />
        <path
          id="path4302"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 643.140015 198.600006 L 646.789978 198.609985 L 646.789978 197.700012 L 643.140015 197.690002 L 643.140015 198.600006 Z"
        />
        <path
          id="path4303"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 164.52002 L 639.119995 164.789978 L 639.119995 164.190002 L 642.849976 163.899994 L 642.849976 164.52002 Z"
        />
        <path
          id="path4304"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 165.850006 L 639.119995 166.109985 L 639.119995 165.48999 L 642.849976 165.220001 L 642.849976 165.850006 Z"
        />
        <path
          id="path4305"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 167.179993 L 639.130005 167.429993 L 639.130005 166.799988 L 642.849976 166.529999 L 642.849976 167.179993 Z"
        />
        <path
          id="path4306"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 169.839996 L 639.130005 170.070007 L 639.130005 169.419983 L 642.849976 169.169983 L 642.849976 169.839996 Z"
        />
        <path
          id="path4307"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 172.5 L 639.130005 172.710022 L 639.130005 172.029999 L 642.849976 171.809998 L 642.849976 172.5 Z"
        />
        <path
          id="path4308"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 173.830017 L 639.140015 174.029999 L 639.140015 173.339996 L 642.849976 173.130005 L 642.849976 173.830017 Z"
        />
        <path
          id="path4309"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.849976 175.160004 L 639.140015 175.350006 L 639.140015 174.649994 L 642.849976 174.450012 L 642.849976 175.160004 Z"
        />
        <path
          id="path4310"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 176.48999 L 639.140015 176.669983 L 639.140015 175.960022 L 642.840027 175.77002 L 642.840027 176.48999 Z"
        />
        <path
          id="path4311"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 177.820007 L 639.140015 177.98999 L 639.140015 177.27002 L 642.840027 177.089996 L 642.840027 177.820007 Z"
        />
        <path
          id="path4312"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 180.47998 L 639.140015 180.630005 L 639.140015 179.880005 L 642.840027 179.720001 L 642.840027 180.47998 Z"
        />
        <path
          id="path4313"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 181.809998 L 639.140015 181.950012 L 639.140015 181.190002 L 642.840027 181.039978 L 642.840027 181.809998 Z"
        />
        <path
          id="path4314"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 183.140015 L 639.150024 183.27002 L 639.150024 182.5 L 642.840027 182.359985 L 642.840027 183.140015 Z"
        />
        <path
          id="path4315"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 184.470001 L 639.150024 184.589996 L 639.150024 183.809998 L 642.840027 183.679993 L 642.840027 184.470001 Z"
        />
        <path
          id="path4316"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 185.799988 L 639.150024 185.910004 L 639.150024 185.119995 L 642.840027 185 L 642.840027 185.799988 Z"
        />
        <path
          id="path4317"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 187.130005 L 639.150024 187.22998 L 639.150024 186.429993 L 642.840027 186.320007 L 642.840027 187.130005 Z"
        />
        <path
          id="path4318"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.830017 189.789978 L 639.159973 189.869995 L 639.159973 189.039978 L 642.830017 188.960022 L 642.830017 189.789978 Z"
        />
        <path
          id="path4319"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.830017 192.450012 L 639.159973 192.51001 L 639.159973 191.660004 L 642.830017 191.589996 L 642.830017 192.450012 Z"
        />
        <path
          id="path4320"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.830017 193.779999 L 639.159973 193.830017 L 639.159973 192.970001 L 642.830017 192.910004 L 642.830017 193.779999 Z"
        />
        <path
          id="path4321"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.830017 196.440002 L 639.159973 196.470001 L 639.159973 195.580017 L 642.830017 195.549988 L 642.830017 196.440002 Z"
        />
        <path
          id="path4322"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 646.820007 199.299988 L 643.140015 199.299988 L 643.140015 200.140015 L 646.820007 200.140015 L 646.820007 199.299988 Z"
        />
        <path
          id="path4323"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 642.840027 200.630005 L 639.159973 200.630005 L 639.159973 201.470001 L 642.840027 201.470001 L 642.840027 200.630005 Z"
        />
        <path
          id="path4324"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 202.02002 L 634.919983 202.02002 L 634.919983 202.859985 L 638.599976 202.859985 L 638.599976 202.02002 Z"
        />
        <path
          id="path4325"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 200.549988 L 634.919983 200.549988 L 634.919983 201.390015 L 638.599976 201.390015 L 638.599976 200.549988 Z"
        />
        <path
          id="path4326"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 204.820007 L 634.919983 204.820007 L 634.919983 205.660004 L 638.599976 205.660004 L 638.599976 204.820007 Z"
        />
        <path
          id="path4327"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 207.070007 L 634.919983 207.070007 L 634.919983 207.910004 L 638.599976 207.910004 L 638.599976 207.070007 Z"
        />
        <path
          id="path4328"
          fill="#cecece"
          stroke="none"
          opacity="0.4"
          d="M 638.599976 211.140015 L 634.919983 211.140015 L 634.919983 211.97998 L 638.599976 211.97998 L 638.599976 211.140015 Z"
        />
      </g>
      <path
        id="path4329"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 196.419983 L 711.099976 196.690002 L 711.099976 196.089996 L 714.820007 195.799988 L 714.820007 196.419983 Z"
      />
      <path
        id="path4330"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 197.72998 L 711.099976 197.98999 L 711.099976 197.380005 L 714.820007 197.100006 L 714.820007 197.72998 Z"
      />
      <path
        id="path4331"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 199.049988 L 711.099976 199.299988 L 711.099976 198.669983 L 714.820007 198.410004 L 714.820007 199.049988 Z"
      />
      <path
        id="path4332"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 200.359985 L 711.099976 200.600006 L 711.099976 199.970001 L 714.820007 199.710022 L 714.820007 200.359985 Z"
      />
      <path
        id="path4333"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 201.679993 L 711.099976 201.910004 L 711.099976 201.26001 L 714.820007 201.01001 L 714.820007 201.679993 Z"
      />
      <path
        id="path4334"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 202.98999 L 711.109985 203.210022 L 711.109985 202.549988 L 714.820007 202.320007 L 714.820007 202.98999 Z"
      />
      <path
        id="path4335"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 204.309998 L 711.109985 204.52002 L 711.109985 203.850006 L 714.820007 203.619995 L 714.820007 204.309998 Z"
      />
      <path
        id="path4336"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 205.619995 L 711.109985 205.830017 L 711.109985 205.140015 L 714.820007 204.929993 L 714.820007 205.619995 Z"
      />
      <path
        id="path4337"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 206.940002 L 711.109985 207.130005 L 711.109985 206.429993 L 714.820007 206.22998 L 714.820007 206.940002 Z"
      />
      <path
        id="path4338"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 208.26001 L 711.109985 208.440002 L 711.109985 207.72998 L 714.820007 207.529999 L 714.820007 208.26001 Z"
      />
      <path
        id="path4339"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 209.570007 L 711.119995 209.73999 L 711.119995 209.02002 L 714.820007 208.839996 L 714.820007 209.570007 Z"
      />
      <path
        id="path4340"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 210.890015 L 711.119995 211.049988 L 711.119995 210.309998 L 714.820007 210.140015 L 714.820007 210.890015 Z"
      />
      <path
        id="path4341"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 213.52002 L 711.119995 213.660004 L 711.119995 212.899994 L 714.820007 212.75 L 714.820007 213.52002 Z"
      />
      <path
        id="path4342"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 214.830017 L 711.130005 214.960022 L 711.130005 214.190002 L 714.820007 214.059998 L 714.820007 214.830017 Z"
      />
      <path
        id="path4343"
        fill="#cecece"
        stroke="none"
        d="M 714.809998 216.149994 L 711.130005 216.27002 L 711.130005 215.48999 L 714.809998 215.359985 L 714.809998 216.149994 Z"
      />
      <path
        id="path4344"
        fill="#cecece"
        stroke="none"
        d="M 714.809998 218.779999 L 711.130005 218.880005 L 711.130005 218.080017 L 714.809998 217.970001 L 714.809998 218.779999 Z"
      />
      <path
        id="path4345"
        fill="#cecece"
        stroke="none"
        d="M 714.809998 222.72998 L 711.140015 222.799988 L 711.140015 221.960022 L 714.809998 221.880005 L 714.809998 222.72998 Z"
      />
      <path
        id="path4346"
        fill="#cecece"
        stroke="none"
        d="M 714.809998 226.669983 L 711.150024 226.710022 L 711.150024 225.839996 L 714.809998 225.789978 L 714.809998 226.669983 Z"
      />
      <path
        id="path4347"
        fill="#cecece"
        stroke="none"
        d="M 714.809998 231.399994 L 711.150024 231.410004 L 711.150024 230.5 L 714.809998 230.48999 L 714.809998 231.399994 Z"
      />
      <path
        id="path4348"
        fill="#cecece"
        stroke="none"
        d="M 714.809998 228 L 711.150024 228.01001 L 711.150024 227.100006 L 714.809998 227.089996 L 714.809998 228 Z"
      />
      <path
        id="path4349"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 195.899994 L 723.070007 196.169983 L 723.070007 195.570007 L 719.349976 195.279999 L 719.349976 195.899994 Z"
      />
      <path
        id="path4350"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 197.210022 L 723.070007 197.470001 L 723.070007 196.859985 L 719.349976 196.580017 L 719.349976 197.210022 Z"
      />
      <path
        id="path4351"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 198.529999 L 723.070007 198.779999 L 723.070007 198.160004 L 719.349976 197.890015 L 719.349976 198.529999 Z"
      />
      <path
        id="path4352"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 199.839996 L 723.070007 200.089996 L 723.070007 199.450012 L 719.349976 199.190002 L 719.349976 199.839996 Z"
      />
      <path
        id="path4353"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 201.160004 L 723.070007 201.390015 L 723.070007 200.73999 L 719.349976 200.5 L 719.349976 201.160004 Z"
      />
      <path
        id="path4354"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 202.47998 L 723.059998 202.700012 L 723.059998 202.039978 L 719.349976 201.799988 L 719.349976 202.47998 Z"
      />
      <path
        id="path4355"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 203.789978 L 723.059998 204 L 723.059998 203.330017 L 719.349976 203.100006 L 719.349976 203.789978 Z"
      />
      <path
        id="path4356"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 205.109985 L 723.059998 205.309998 L 723.059998 204.619995 L 719.349976 204.410004 L 719.349976 205.109985 Z"
      />
      <path
        id="path4357"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 206.419983 L 723.059998 206.609985 L 723.059998 205.919983 L 719.349976 205.710022 L 719.349976 206.419983 Z"
      />
      <path
        id="path4358"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 207.73999 L 723.059998 207.919983 L 723.059998 207.210022 L 719.349976 207.02002 L 719.349976 207.73999 Z"
      />
      <path
        id="path4359"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 209.049988 L 723.049988 209.220001 L 723.049988 208.5 L 719.349976 208.320007 L 719.349976 209.049988 Z"
      />
      <path
        id="path4360"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 210.369995 L 723.049988 210.529999 L 723.049988 209.799988 L 719.349976 209.619995 L 719.349976 210.369995 Z"
      />
      <path
        id="path4361"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 211.679993 L 723.049988 211.830017 L 723.049988 211.089996 L 719.349976 210.929993 L 719.349976 211.679993 Z"
      />
      <path
        id="path4362"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 213 L 723.049988 213.140015 L 723.049988 212.380005 L 719.349976 212.22998 L 719.349976 213 Z"
      />
      <path
        id="path4363"
        fill="#cecece"
        stroke="none"
        d="M 719.349976 214.309998 L 723.039978 214.450012 L 723.039978 213.679993 L 719.349976 213.539978 L 719.349976 214.309998 Z"
      />
      <path
        id="path4364"
        fill="#cecece"
        stroke="none"
        d="M 719.359985 215.630005 L 723.039978 215.75 L 723.039978 214.970001 L 719.359985 214.839996 L 719.359985 215.630005 Z"
      />
      <path
        id="path4365"
        fill="#cecece"
        stroke="none"
        d="M 719.359985 218.26001 L 723.039978 218.359985 L 723.039978 217.559998 L 719.359985 217.450012 L 719.359985 218.26001 Z"
      />
      <path
        id="path4366"
        fill="#cecece"
        stroke="none"
        d="M 719.359985 222.210022 L 723.030029 222.279999 L 723.030029 221.440002 L 719.359985 221.359985 L 719.359985 222.210022 Z"
      />
      <path
        id="path4367"
        fill="#cecece"
        stroke="none"
        d="M 719.359985 226.149994 L 723.02002 226.190002 L 723.02002 225.320007 L 719.359985 225.279999 L 719.359985 226.149994 Z"
      />
      <path
        id="path4368"
        fill="#cecece"
        stroke="none"
        d="M 719.359985 230.100006 L 723.02002 230.109985 L 723.02002 229.200012 L 719.359985 229.190002 L 719.359985 230.100006 Z"
      />
      <path
        id="path4369"
        fill="#cecece"
        stroke="none"
        d="M 719.080017 196.02002 L 715.349976 196.289978 L 715.349976 195.690002 L 719.080017 195.399994 L 719.080017 196.02002 Z"
      />
      <path
        id="path4370"
        fill="#cecece"
        stroke="none"
        d="M 719.080017 197.350006 L 715.349976 197.609985 L 715.349976 196.98999 L 719.080017 196.720001 L 719.080017 197.350006 Z"
      />
      <path
        id="path4371"
        fill="#cecece"
        stroke="none"
        d="M 719.070007 198.679993 L 715.349976 198.929993 L 715.349976 198.299988 L 719.070007 198.039978 L 719.070007 198.679993 Z"
      />
      <path
        id="path4372"
        fill="#cecece"
        stroke="none"
        d="M 719.070007 201.339996 L 715.359985 201.570007 L 715.359985 200.919983 L 719.070007 200.669983 L 719.070007 201.339996 Z"
      />
      <path
        id="path4373"
        fill="#cecece"
        stroke="none"
        d="M 719.070007 204 L 715.359985 204.210022 L 715.359985 203.539978 L 719.070007 203.309998 L 719.070007 204 Z"
      />
      <path
        id="path4374"
        fill="#cecece"
        stroke="none"
        d="M 719.070007 205.330017 L 715.359985 205.529999 L 715.359985 204.839996 L 719.070007 204.630005 L 719.070007 205.330017 Z"
      />
      <path
        id="path4375"
        fill="#cecece"
        stroke="none"
        d="M 719.070007 206.660004 L 715.359985 206.850006 L 715.359985 206.149994 L 719.070007 205.950012 L 719.070007 206.660004 Z"
      />
      <path
        id="path4376"
        fill="#cecece"
        stroke="none"
        d="M 719.070007 207.98999 L 715.359985 208.169983 L 715.359985 207.460022 L 719.070007 207.27002 L 719.070007 207.98999 Z"
      />
      <path
        id="path4377"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 209.320007 L 715.359985 209.48999 L 715.359985 208.77002 L 719.059998 208.589996 L 719.059998 209.320007 Z"
      />
      <path
        id="path4378"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 211.97998 L 715.369995 212.130005 L 715.369995 211.390015 L 719.059998 211.22998 L 719.059998 211.97998 Z"
      />
      <path
        id="path4379"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 213.309998 L 715.369995 213.450012 L 715.369995 212.690002 L 719.059998 212.539978 L 719.059998 213.309998 Z"
      />
      <path
        id="path4380"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 214.640015 L 715.369995 214.77002 L 715.369995 214 L 719.059998 213.859985 L 719.059998 214.640015 Z"
      />
      <path
        id="path4381"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 215.970001 L 715.369995 216.089996 L 715.369995 215.309998 L 719.059998 215.179993 L 719.059998 215.970001 Z"
      />
      <path
        id="path4382"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 217.299988 L 715.369995 217.410004 L 715.369995 216.619995 L 719.059998 216.5 L 719.059998 217.299988 Z"
      />
      <path
        id="path4383"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 218.630005 L 715.380005 218.72998 L 715.380005 217.929993 L 719.059998 217.820007 L 719.059998 218.630005 Z"
      />
      <path
        id="path4384"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 221.289978 L 715.380005 221.369995 L 715.380005 220.539978 L 719.059998 220.460022 L 719.059998 221.289978 Z"
      />
      <path
        id="path4385"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 223.950012 L 715.380005 224.01001 L 715.380005 223.160004 L 719.059998 223.100006 L 719.059998 223.950012 Z"
      />
      <path
        id="path4386"
        fill="#cecece"
        stroke="none"
        d="M 719.049988 225.279999 L 715.380005 225.330017 L 715.380005 224.470001 L 719.049988 224.419983 L 719.049988 225.279999 Z"
      />
      <path
        id="path4387"
        fill="#cecece"
        stroke="none"
        d="M 719.049988 227.940002 L 715.390015 227.970001 L 715.390015 227.089996 L 719.049988 227.049988 L 719.049988 227.940002 Z"
      />
      <path
        id="path4388"
        fill="#cecece"
        stroke="none"
        d="M 723.039978 230.799988 L 719.359985 230.799988 L 719.359985 231.640015 L 723.039978 231.640015 L 723.039978 230.799988 Z"
      />
      <path
        id="path4389"
        fill="#cecece"
        stroke="none"
        d="M 719.059998 232.130005 L 715.380005 232.130005 L 715.380005 232.970001 L 719.059998 232.970001 L 719.059998 232.130005 Z"
      />
      <path
        id="path4390"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 233.52002 L 711.140015 233.52002 L 711.140015 234.359985 L 714.820007 234.359985 L 714.820007 233.52002 Z"
      />
      <path
        id="path4391"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 232.049988 L 711.140015 232.049988 L 711.140015 232.890015 L 714.820007 232.890015 L 714.820007 232.049988 Z"
      />
      <path
        id="path4392"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 236.320007 L 711.140015 236.320007 L 711.140015 237.160004 L 714.820007 237.160004 L 714.820007 236.320007 Z"
      />
      <path
        id="path4393"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 238.570007 L 711.140015 238.570007 L 711.140015 239.410004 L 714.820007 239.410004 L 714.820007 238.570007 Z"
      />
      <path
        id="path4394"
        fill="#cecece"
        stroke="none"
        d="M 714.820007 242.639999 L 711.140015 242.639999 L 711.140015 243.479996 L 714.820007 243.479996 L 714.820007 242.639999 Z"
      />
      <path
        id="path4395"
        fill="#cecece"
        stroke="none"
        d="M 449.51001 217.179993 L 448.829987 217.179993 L 448.829987 218.390015 L 449.51001 218.390015 L 449.51001 217.179993 Z"
      />
      <path
        id="path4396"
        fill="#cecece"
        stroke="none"
        d="M 450.600006 218.970001 L 449.920013 218.970001 L 449.920013 220.179993 L 450.600006 220.179993 L 450.600006 218.970001 Z"
      />
      <path
        id="path4397"
        fill="#cecece"
        stroke="none"
        d="M 449.51001 222.539978 L 448.829987 222.539978 L 448.829987 223.75 L 449.51001 223.75 L 449.51001 222.539978 Z"
      />
      <path
        id="path4398"
        fill="#cecece"
        stroke="none"
        d="M 602 207.859985 L 600.73999 207.859985 L 600.73999 224.809998 L 602 224.809998 L 602 207.859985 Z"
      />
      <path
        id="path4399"
        fill="#cecece"
        stroke="none"
        d="M 595.97998 165.789978 L 571.27002 168.200012 L 571.27002 169.23999 L 595.97998 166.880005 L 595.97998 165.789978 Z"
      />
      <path
        id="path4400"
        fill="#cecece"
        stroke="none"
        d="M 571.27002 170.73999 L 571.27002 171.77002 L 584.090027 170.450012 L 584.090027 169.419983 L 571.27002 170.73999 Z"
      />
      <path
        id="path4401"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 673.440002 160.25 L 672.719971 160.25 L 672.719971 177.190002 L 673.440002 177.190002 L 673.440002 160.25 Z"
      />
      <path
        id="path4402"
        fill="#cecece"
        stroke="none"
        opacity="0.7"
        d="M 670.5 160.25 L 669.780029 160.25 L 669.780029 177.190002 L 670.5 177.190002 L 670.5 160.25 Z"
      />
      <path
        id="path4403"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 179.299988 L 708.590027 179.570007 L 708.590027 178.970001 L 704.859985 178.679993 L 704.859985 179.299988 Z"
      />
      <path
        id="path4404"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 180.619995 L 708.590027 180.880005 L 708.590027 180.26001 L 704.859985 179.98999 L 704.859985 180.619995 Z"
      />
      <path
        id="path4405"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 181.929993 L 708.580017 182.179993 L 708.580017 181.559998 L 704.859985 181.289978 L 704.859985 181.929993 Z"
      />
      <path
        id="path4406"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 183.25 L 708.580017 183.48999 L 708.580017 182.850006 L 704.859985 182.589996 L 704.859985 183.25 Z"
      />
      <path
        id="path4407"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 184.559998 L 708.580017 184.789978 L 708.580017 184.140015 L 704.859985 183.899994 L 704.859985 184.559998 Z"
      />
      <path
        id="path4408"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 185.880005 L 708.570007 186.100006 L 708.570007 185.440002 L 704.859985 185.200012 L 704.859985 185.880005 Z"
      />
      <path
        id="path4409"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 187.190002 L 708.570007 187.399994 L 708.570007 186.72998 L 704.859985 186.51001 L 704.859985 187.190002 Z"
      />
      <path
        id="path4410"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 188.51001 L 708.570007 188.710022 L 708.570007 188.02002 L 704.859985 187.809998 L 704.859985 188.51001 Z"
      />
      <path
        id="path4411"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 189.820007 L 708.570007 190.01001 L 708.570007 189.320007 L 704.859985 189.109985 L 704.859985 189.820007 Z"
      />
      <path
        id="path4412"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 191.140015 L 708.570007 191.320007 L 708.570007 190.609985 L 704.859985 190.419983 L 704.859985 191.140015 Z"
      />
      <path
        id="path4413"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 192.450012 L 708.570007 192.630005 L 708.570007 191.910004 L 704.859985 191.720001 L 704.859985 192.450012 Z"
      />
      <path
        id="path4414"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 193.77002 L 708.559998 193.929993 L 708.559998 193.200012 L 704.859985 193.029999 L 704.859985 193.77002 Z"
      />
      <path
        id="path4415"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 195.089996 L 708.559998 195.23999 L 708.559998 194.48999 L 704.859985 194.330017 L 704.859985 195.089996 Z"
      />
      <path
        id="path4416"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 196.399994 L 708.559998 196.539978 L 708.559998 195.789978 L 704.859985 195.640015 L 704.859985 196.399994 Z"
      />
      <path
        id="path4417"
        fill="#cecece"
        stroke="none"
        d="M 704.859985 197.720001 L 708.559998 197.850006 L 708.559998 197.080017 L 704.859985 196.940002 L 704.859985 197.720001 Z"
      />
      <path
        id="path4418"
        fill="#cecece"
        stroke="none"
        d="M 704.869995 199.029999 L 708.549988 199.149994 L 708.549988 198.369995 L 704.869995 198.23999 L 704.869995 199.029999 Z"
      />
      <path
        id="path4419"
        fill="#cecece"
        stroke="none"
        d="M 704.869995 201.660004 L 708.549988 201.76001 L 708.549988 200.960022 L 704.869995 200.850006 L 704.869995 201.660004 Z"
      />
      <path
        id="path4420"
        fill="#cecece"
        stroke="none"
        d="M 704.869995 205.609985 L 708.539978 205.679993 L 708.539978 204.839996 L 704.869995 204.76001 L 704.869995 205.609985 Z"
      />
      <path
        id="path4421"
        fill="#cecece"
        stroke="none"
        d="M 704.869995 209.559998 L 708.530029 209.600006 L 708.530029 208.720001 L 704.869995 208.679993 L 704.869995 209.559998 Z"
      />
      <path
        id="path4422"
        fill="#cecece"
        stroke="none"
        d="M 704.869995 213.5 L 708.530029 213.51001 L 708.530029 212.600006 L 704.869995 212.589996 L 704.869995 213.5 Z"
      />
      <path
        id="path4423"
        fill="#cecece"
        stroke="none"
        d="M 704.590027 179.419983 L 700.859985 179.690002 L 700.859985 179.089996 L 704.590027 178.799988 L 704.590027 179.419983 Z"
      />
      <path
        id="path4424"
        fill="#cecece"
        stroke="none"
        d="M 704.590027 180.75 L 700.859985 181.01001 L 700.859985 180.399994 L 704.590027 180.119995 L 704.590027 180.75 Z"
      />
      <path
        id="path4425"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 182.080017 L 700.859985 182.330017 L 700.859985 181.710022 L 704.580017 181.440002 L 704.580017 182.080017 Z"
      />
      <path
        id="path4426"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 184.73999 L 700.869995 184.970001 L 700.869995 184.320007 L 704.580017 184.080017 L 704.580017 184.73999 Z"
      />
      <path
        id="path4427"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 187.399994 L 700.869995 187.609985 L 700.869995 186.940002 L 704.580017 186.710022 L 704.580017 187.399994 Z"
      />
      <path
        id="path4428"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 188.72998 L 700.869995 188.929993 L 700.869995 188.25 L 704.580017 188.029999 L 704.580017 188.72998 Z"
      />
      <path
        id="path4429"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 190.059998 L 700.869995 190.25 L 700.869995 189.549988 L 704.580017 189.350006 L 704.580017 190.059998 Z"
      />
      <path
        id="path4430"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 191.390015 L 700.869995 191.570007 L 700.869995 190.859985 L 704.580017 190.669983 L 704.580017 191.390015 Z"
      />
      <path
        id="path4431"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 192.720001 L 700.869995 192.890015 L 700.869995 192.169983 L 704.580017 191.98999 L 704.580017 192.720001 Z"
      />
      <path
        id="path4432"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 195.380005 L 700.880005 195.529999 L 700.880005 194.789978 L 704.580017 194.630005 L 704.580017 195.380005 Z"
      />
      <path
        id="path4433"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 196.710022 L 700.880005 196.850006 L 700.880005 196.100006 L 704.570007 195.950012 L 704.570007 196.710022 Z"
      />
      <path
        id="path4434"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 198.039978 L 700.880005 198.169983 L 700.880005 197.399994 L 704.570007 197.27002 L 704.570007 198.039978 Z"
      />
      <path
        id="path4435"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 199.369995 L 700.880005 199.48999 L 700.880005 198.710022 L 704.570007 198.580017 L 704.570007 199.369995 Z"
      />
      <path
        id="path4436"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 200.700012 L 700.890015 200.809998 L 700.890015 200.02002 L 704.570007 199.899994 L 704.570007 200.700012 Z"
      />
      <path
        id="path4437"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 202.029999 L 700.890015 202.130005 L 700.890015 201.330017 L 704.570007 201.220001 L 704.570007 202.029999 Z"
      />
      <path
        id="path4438"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 204.690002 L 700.890015 204.77002 L 700.890015 203.950012 L 704.570007 203.859985 L 704.570007 204.690002 Z"
      />
      <path
        id="path4439"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 207.350006 L 700.900024 207.410004 L 700.900024 206.559998 L 704.570007 206.5 L 704.570007 207.350006 Z"
      />
      <path
        id="path4440"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 208.679993 L 700.900024 208.72998 L 700.900024 207.869995 L 704.570007 207.820007 L 704.570007 208.679993 Z"
      />
      <path
        id="path4441"
        fill="#cecece"
        stroke="none"
        d="M 704.570007 211.339996 L 700.900024 211.369995 L 700.900024 210.48999 L 704.570007 210.450012 L 704.570007 211.339996 Z"
      />
      <path
        id="path4442"
        fill="#cecece"
        stroke="none"
        d="M 708.549988 214.200012 L 704.869995 214.200012 L 704.869995 215.039978 L 708.549988 215.039978 L 708.549988 214.200012 Z"
      />
      <path
        id="path4443"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 215.529999 L 700.900024 215.529999 L 700.900024 216.369995 L 704.580017 216.369995 L 704.580017 215.529999 Z"
      />
      <path
        id="path4444"
        fill="#cecece"
        stroke="none"
        d="M 704.580017 218.25 L 700.900024 218.25 L 700.900024 219.089996 L 704.580017 219.089996 L 704.580017 218.25 Z"
      />
      <g id="g4" opacity="0.5">
        <path
          id="path4445"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 189.359985 L 771.820007 189.630005 L 771.820007 189.029999 L 769.869995 188.73999 L 769.869995 189.359985 Z"
        />
        <path
          id="path4446"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 190.679993 L 771.820007 190.940002 L 771.820007 190.320007 L 769.869995 190.049988 L 769.869995 190.679993 Z"
        />
        <path
          id="path4447"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 191.98999 L 771.820007 192.23999 L 771.820007 191.619995 L 769.869995 191.350006 L 769.869995 191.98999 Z"
        />
        <path
          id="path4448"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 193.309998 L 771.809998 193.549988 L 771.809998 192.910004 L 769.869995 192.649994 L 769.869995 193.309998 Z"
        />
        <path
          id="path4449"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 194.619995 L 771.809998 194.850006 L 771.809998 194.200012 L 769.869995 193.960022 L 769.869995 194.619995 Z"
        />
        <path
          id="path4450"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 195.940002 L 771.809998 196.160004 L 771.809998 195.5 L 769.869995 195.26001 L 769.869995 195.940002 Z"
        />
        <path
          id="path4451"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 197.25 L 771.809998 197.460022 L 771.809998 196.789978 L 769.869995 196.570007 L 769.869995 197.25 Z"
        />
        <path
          id="path4452"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 198.570007 L 771.809998 198.77002 L 771.809998 198.080017 L 769.869995 197.869995 L 769.869995 198.570007 Z"
        />
        <path
          id="path4453"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 199.880005 L 771.809998 200.070007 L 771.809998 199.380005 L 769.869995 199.169983 L 769.869995 199.880005 Z"
        />
        <path
          id="path4454"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 201.200012 L 771.809998 201.380005 L 771.809998 200.669983 L 769.869995 200.47998 L 769.869995 201.200012 Z"
        />
        <path
          id="path4455"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 202.51001 L 771.809998 202.679993 L 771.809998 201.960022 L 769.869995 201.779999 L 769.869995 202.51001 Z"
        />
        <path
          id="path4456"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 203.830017 L 771.809998 203.98999 L 771.809998 203.26001 L 769.869995 203.089996 L 769.869995 203.830017 Z"
        />
        <path
          id="path4457"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 205.149994 L 771.809998 205.299988 L 771.809998 204.549988 L 769.869995 204.390015 L 769.869995 205.149994 Z"
        />
        <path
          id="path4458"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 206.460022 L 771.799988 206.600006 L 771.799988 205.850006 L 769.869995 205.700012 L 769.869995 206.460022 Z"
        />
        <path
          id="path4459"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.869995 207.779999 L 771.799988 207.910004 L 771.799988 207.140015 L 769.869995 207 L 769.869995 207.779999 Z"
        />
        <path
          id="path4460"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.880005 209.089996 L 771.799988 209.210022 L 771.799988 208.429993 L 769.880005 208.299988 L 769.880005 209.089996 Z"
        />
        <path
          id="path4461"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.880005 211.720001 L 771.799988 211.820007 L 771.799988 211.02002 L 769.880005 210.910004 L 769.880005 211.720001 Z"
        />
        <path
          id="path4462"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.880005 215.669983 L 771.799988 215.73999 L 771.799988 214.899994 L 769.880005 214.820007 L 769.880005 215.669983 Z"
        />
        <path
          id="path4463"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.880005 219.619995 L 771.789978 219.660004 L 771.789978 218.779999 L 769.880005 218.73999 L 769.880005 219.619995 Z"
        />
        <path
          id="path4464"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.880005 223.559998 L 771.789978 223.570007 L 771.789978 222.660004 L 769.880005 222.649994 L 769.880005 223.559998 Z"
        />
        <path
          id="path4465"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.340027 189.47998 L 765.929993 189.75 L 765.929993 189.149994 L 769.340027 188.859985 L 769.340027 189.47998 Z"
        />
        <path
          id="path4466"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.340027 190.809998 L 765.929993 191.070007 L 765.929993 190.460022 L 769.340027 190.179993 L 769.340027 190.809998 Z"
        />
        <path
          id="path4467"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.340027 192.140015 L 765.940002 192.390015 L 765.940002 191.76001 L 769.340027 191.5 L 769.340027 192.140015 Z"
        />
        <path
          id="path4468"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 194.799988 L 765.940002 195.029999 L 765.940002 194.380005 L 769.330017 194.140015 L 769.330017 194.799988 Z"
        />
        <path
          id="path4469"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 197.460022 L 765.940002 197.669983 L 765.940002 197 L 769.330017 196.77002 L 769.330017 197.460022 Z"
        />
        <path
          id="path4470"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 198.789978 L 765.950012 198.98999 L 765.950012 198.309998 L 769.330017 198.089996 L 769.330017 198.789978 Z"
        />
        <path
          id="path4471"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 200.119995 L 765.950012 200.309998 L 765.950012 199.609985 L 769.330017 199.410004 L 769.330017 200.119995 Z"
        />
        <path
          id="path4472"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 201.450012 L 765.950012 201.630005 L 765.950012 200.919983 L 769.330017 200.72998 L 769.330017 201.450012 Z"
        />
        <path
          id="path4473"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 202.779999 L 765.950012 202.950012 L 765.950012 202.22998 L 769.330017 202.049988 L 769.330017 202.779999 Z"
        />
        <path
          id="path4474"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 205.440002 L 765.950012 205.589996 L 765.950012 204.850006 L 769.330017 204.690002 L 769.330017 205.440002 Z"
        />
        <path
          id="path4475"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 206.77002 L 765.950012 206.910004 L 765.950012 206.160004 L 769.330017 206.01001 L 769.330017 206.77002 Z"
        />
        <path
          id="path4476"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 208.100006 L 765.960022 208.22998 L 765.960022 207.460022 L 769.330017 207.330017 L 769.330017 208.100006 Z"
        />
        <path
          id="path4477"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 209.429993 L 765.960022 209.549988 L 765.960022 208.77002 L 769.320007 208.640015 L 769.320007 209.429993 Z"
        />
        <path
          id="path4478"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 210.76001 L 765.960022 210.869995 L 765.960022 210.080017 L 769.320007 209.960022 L 769.320007 210.76001 Z"
        />
        <path
          id="path4479"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 212.089996 L 765.960022 212.190002 L 765.960022 211.390015 L 769.320007 211.279999 L 769.320007 212.089996 Z"
        />
        <path
          id="path4480"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 214.75 L 765.969971 214.830017 L 765.969971 214.01001 L 769.320007 213.919983 L 769.320007 214.75 Z"
        />
        <path
          id="path4481"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 217.410004 L 765.969971 217.470001 L 765.969971 216.619995 L 769.320007 216.559998 L 769.320007 217.410004 Z"
        />
        <path
          id="path4482"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 218.73999 L 765.969971 218.789978 L 765.969971 217.929993 L 769.320007 217.880005 L 769.320007 218.73999 Z"
        />
        <path
          id="path4483"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.320007 221.399994 L 765.969971 221.429993 L 765.969971 220.549988 L 769.320007 220.51001 L 769.320007 221.399994 Z"
        />
        <path
          id="path4484"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 771.799988 224.26001 L 769.880005 224.26001 L 769.880005 225.100006 L 771.799988 225.100006 L 771.799988 224.26001 Z"
        />
        <path
          id="path4485"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 225.589996 L 765.969971 225.589996 L 765.969971 226.429993 L 769.330017 226.429993 L 769.330017 225.589996 Z"
        />
        <path
          id="path4486"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 769.330017 228.309998 L 765.969971 228.309998 L 765.969971 229.149994 L 769.330017 229.149994 L 769.330017 228.309998 Z"
        />
      </g>
      <g id="g5" opacity="0.5">
        <path
          id="path4487"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 189.799988 L 774.400024 190.080017 L 774.400024 189.47998 L 772.450012 189.190002 L 772.450012 189.799988 Z"
        />
        <path
          id="path4488"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 191.119995 L 774.400024 191.380005 L 774.400024 190.77002 L 772.450012 190.48999 L 772.450012 191.119995 Z"
        />
        <path
          id="path4489"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 192.440002 L 774.390015 192.690002 L 774.390015 192.059998 L 772.450012 191.789978 L 772.450012 192.440002 Z"
        />
        <path
          id="path4490"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 193.75 L 774.390015 193.98999 L 774.390015 193.359985 L 772.450012 193.100006 L 772.450012 193.75 Z"
        />
        <path
          id="path4491"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 195.070007 L 774.390015 195.299988 L 774.390015 194.649994 L 772.450012 194.399994 L 772.450012 195.070007 Z"
        />
        <path
          id="path4492"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 196.380005 L 774.390015 196.600006 L 774.390015 195.940002 L 772.450012 195.710022 L 772.450012 196.380005 Z"
        />
        <path
          id="path4493"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 197.700012 L 774.390015 197.910004 L 774.390015 197.23999 L 772.450012 197.01001 L 772.450012 197.700012 Z"
        />
        <path
          id="path4494"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 199.01001 L 774.390015 199.210022 L 774.390015 198.529999 L 772.450012 198.309998 L 772.450012 199.01001 Z"
        />
        <path
          id="path4495"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 200.330017 L 774.390015 200.52002 L 774.390015 199.820007 L 772.450012 199.619995 L 772.450012 200.330017 Z"
        />
        <path
          id="path4496"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 201.640015 L 774.390015 201.820007 L 774.390015 201.119995 L 772.450012 200.919983 L 772.450012 201.640015 Z"
        />
        <path
          id="path4497"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 202.960022 L 774.390015 203.130005 L 774.390015 202.410004 L 772.450012 202.22998 L 772.450012 202.960022 Z"
        />
        <path
          id="path4498"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 204.279999 L 774.380005 204.440002 L 774.380005 203.700012 L 772.450012 203.529999 L 772.450012 204.279999 Z"
        />
        <path
          id="path4499"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 205.589996 L 774.380005 205.73999 L 774.380005 205 L 772.450012 204.839996 L 772.450012 205.589996 Z"
        />
        <path
          id="path4500"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 206.910004 L 774.380005 207.049988 L 774.380005 206.289978 L 772.450012 206.140015 L 772.450012 206.910004 Z"
        />
        <path
          id="path4501"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 208.220001 L 774.380005 208.350006 L 774.380005 207.580017 L 772.450012 207.440002 L 772.450012 208.220001 Z"
        />
        <path
          id="path4502"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 209.539978 L 774.380005 209.660004 L 774.380005 208.880005 L 772.450012 208.75 L 772.450012 209.539978 Z"
        />
        <path
          id="path4503"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 212.169983 L 774.380005 212.27002 L 774.380005 211.460022 L 772.450012 211.359985 L 772.450012 212.169983 Z"
        />
        <path
          id="path4504"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 216.109985 L 774.369995 216.179993 L 774.369995 215.339996 L 772.450012 215.27002 L 772.450012 216.109985 Z"
        />
        <path
          id="path4505"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.450012 220.059998 L 774.369995 220.100006 L 774.369995 219.220001 L 772.450012 219.179993 L 772.450012 220.059998 Z"
        />
        <path
          id="path4506"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 772.460022 224.01001 L 774.369995 224.02002 L 774.369995 223.100006 L 772.460022 223.089996 L 772.460022 224.01001 Z"
        />
        <path
          id="path4507"
          fill="#cecece"
          stroke="none"
          opacity="0.5"
          d="M 774.380005 224.710022 L 772.460022 224.710022 L 772.460022 225.549988 L 774.380005 225.549988 L 774.380005 224.710022 Z"
        />
      </g>
      <path
        id="path4508"
        fill="#cecece"
        stroke="none"
        d="M 648.880005 206.419983 L 646.809998 206.419983 L 646.809998 208.149994 L 648.880005 208.149994 L 648.880005 206.419983 Z"
      />
      <path
        id="path4509"
        fill="#cecece"
        stroke="none"
        d="M 648.880005 208.960022 L 646.809998 208.960022 L 646.809998 210.690002 L 648.880005 210.690002 L 648.880005 208.960022 Z"
      />
      <path
        id="path4510"
        fill="#cecece"
        stroke="none"
        d="M 648.880005 211.51001 L 646.809998 211.51001 L 646.809998 213.23999 L 648.880005 213.23999 L 648.880005 211.51001 Z"
      />
      <path
        id="path4511"
        fill="#cecece"
        stroke="none"
        d="M 652.23999 206.419983 L 650.169983 206.419983 L 650.169983 208.149994 L 652.23999 208.149994 L 652.23999 206.419983 Z"
      />
      <path
        id="path4512"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 206.419983 L 653.530029 206.419983 L 653.530029 208.149994 L 655.599976 208.149994 L 655.599976 206.419983 Z"
      />
      <path
        id="path4513"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 208.960022 L 653.530029 208.960022 L 653.530029 210.690002 L 655.599976 210.690002 L 655.599976 208.960022 Z"
      />
      <path
        id="path4514"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 211.51001 L 653.530029 211.51001 L 653.530029 213.23999 L 655.599976 213.23999 L 655.599976 211.51001 Z"
      />
      <path
        id="path4515"
        fill="#cecece"
        stroke="none"
        d="M 648.880005 214.140015 L 646.809998 214.140015 L 646.809998 215.869995 L 648.880005 215.869995 L 648.880005 214.140015 Z"
      />
      <path
        id="path4516"
        fill="#cecece"
        stroke="none"
        d="M 648.880005 219.220001 L 646.809998 219.220001 L 646.809998 220.950012 L 648.880005 220.950012 L 648.880005 219.220001 Z"
      />
      <path
        id="path4517"
        fill="#cecece"
        stroke="none"
        d="M 652.23999 211.589996 L 650.169983 211.589996 L 650.169983 213.320007 L 652.23999 213.320007 L 652.23999 211.589996 Z"
      />
      <path
        id="path4518"
        fill="#cecece"
        stroke="none"
        d="M 652.23999 216.679993 L 650.169983 216.679993 L 650.169983 218.410004 L 652.23999 218.410004 L 652.23999 216.679993 Z"
      />
      <path
        id="path4519"
        fill="#cecece"
        stroke="none"
        d="M 652.23999 219.220001 L 650.169983 219.220001 L 650.169983 220.950012 L 652.23999 220.950012 L 652.23999 219.220001 Z"
      />
      <path
        id="path4520"
        fill="#cecece"
        stroke="none"
        d="M 652.23999 221.77002 L 650.169983 221.77002 L 650.169983 223.5 L 652.23999 223.5 L 652.23999 221.77002 Z"
      />
      <path
        id="path4521"
        fill="#cecece"
        stroke="none"
        d="M 652.23999 224.309998 L 650.169983 224.309998 L 650.169983 226.039978 L 652.23999 226.039978 L 652.23999 224.309998 Z"
      />
      <path
        id="path4522"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 206.419983 L 640.26001 206.419983 L 640.26001 208.149994 L 642.330017 208.149994 L 642.330017 206.419983 Z"
      />
      <path
        id="path4523"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 208.960022 L 640.26001 208.960022 L 640.26001 210.690002 L 642.330017 210.690002 L 642.330017 208.960022 Z"
      />
      <path
        id="path4524"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 211.51001 L 640.26001 211.51001 L 640.26001 213.23999 L 642.330017 213.23999 L 642.330017 211.51001 Z"
      />
      <path
        id="path4525"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 206.419983 L 643.619995 206.419983 L 643.619995 208.149994 L 645.690002 208.149994 L 645.690002 206.419983 Z"
      />
      <path
        id="path4526"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 214.140015 L 640.26001 214.140015 L 640.26001 215.869995 L 642.330017 215.869995 L 642.330017 214.140015 Z"
      />
      <path
        id="path4527"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 219.220001 L 640.26001 219.220001 L 640.26001 220.950012 L 642.330017 220.950012 L 642.330017 219.220001 Z"
      />
      <path
        id="path4528"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 211.589996 L 643.619995 211.589996 L 643.619995 213.320007 L 645.690002 213.320007 L 645.690002 211.589996 Z"
      />
      <path
        id="path4529"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 216.679993 L 643.619995 216.679993 L 643.619995 218.410004 L 645.690002 218.410004 L 645.690002 216.679993 Z"
      />
      <path
        id="path4530"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 219.220001 L 643.619995 219.220001 L 643.619995 220.950012 L 645.690002 220.950012 L 645.690002 219.220001 Z"
      />
      <path
        id="path4531"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 221.77002 L 643.619995 221.77002 L 643.619995 223.5 L 645.690002 223.5 L 645.690002 221.77002 Z"
      />
      <path
        id="path4532"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 224.309998 L 643.619995 224.309998 L 643.619995 226.039978 L 645.690002 226.039978 L 645.690002 224.309998 Z"
      />
      <path
        id="path4533"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 214.140015 L 653.530029 214.140015 L 653.530029 215.869995 L 655.599976 215.869995 L 655.599976 214.140015 Z"
      />
      <path
        id="path4534"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 221.77002 L 653.530029 221.77002 L 653.530029 223.5 L 655.599976 223.5 L 655.599976 221.77002 Z"
      />
      <path
        id="path4535"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 224.309998 L 653.530029 224.309998 L 653.530029 226.039978 L 655.599976 226.039978 L 655.599976 224.309998 Z"
      />
      <path
        id="path4536"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 204.01001 L 640.26001 204.01001 L 640.26001 205 L 655.599976 205 L 655.599976 204.01001 Z"
      />
      <path
        id="path4537"
        fill="#cecece"
        stroke="none"
        d="M 655.599976 201.350006 L 643.710022 201.350006 L 643.710022 202.899994 L 655.599976 202.899994 L 655.599976 201.350006 Z"
      />
      <path
        id="path4538"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 214.140015 L 637.030029 214.140015 L 637.030029 215.869995 L 639.099976 215.869995 L 639.099976 214.140015 Z"
      />
      <path
        id="path4539"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 219.320007 L 637.030029 219.320007 L 637.030029 221.049988 L 639.099976 221.049988 L 639.099976 219.320007 Z"
      />
      <path
        id="path4540"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 224.399994 L 637.030029 224.399994 L 637.030029 226.130005 L 639.099976 226.130005 L 639.099976 224.399994 Z"
      />
      <path
        id="path4541"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 229.419983 L 640.26001 229.419983 L 640.26001 231.149994 L 642.330017 231.149994 L 642.330017 229.419983 Z"
      />
      <path
        id="path4542"
        fill="#cecece"
        stroke="none"
        d="M 642.330017 237.139999 L 640.26001 237.139999 L 640.26001 238.869995 L 642.330017 238.869995 L 642.330017 237.139999 Z"
      />
      <path
        id="path4543"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 229.51001 L 643.619995 229.51001 L 643.619995 231.23999 L 645.690002 231.23999 L 645.690002 229.51001 Z"
      />
      <path
        id="path4544"
        fill="#cecece"
        stroke="none"
        d="M 645.690002 234.589996 L 643.619995 234.589996 L 643.619995 236.320007 L 645.690002 236.320007 L 645.690002 234.589996 Z"
      />
      <path
        id="path4545"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 242.320007 L 637.030029 242.320007 L 637.030029 244.050003 L 639.099976 244.050003 L 639.099976 242.320007 Z"
      />
      <path
        id="path4546"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 226.950012 L 637.030029 226.950012 L 637.030029 228.679993 L 639.099976 228.679993 L 639.099976 226.950012 Z"
      />
      <path
        id="path4547"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 229.48999 L 637.030029 229.48999 L 637.030029 231.220001 L 639.099976 231.220001 L 639.099976 229.48999 Z"
      />
      <path
        id="path4548"
        fill="#cecece"
        stroke="none"
        d="M 639.099976 234.589996 L 637.030029 234.589996 L 637.030029 236.320007 L 639.099976 236.320007 L 639.099976 234.589996 Z"
      />
      <path
        id="path4549"
        fill="#cecece"
        stroke="none"
        d="M 635.97998 214.140015 L 634.940002 214.140015 L 634.940002 215.869995 L 635.97998 215.869995 L 635.97998 214.140015 Z"
      />
      <path
        id="path4550"
        fill="#cecece"
        stroke="none"
        d="M 635.97998 219.320007 L 634.940002 219.320007 L 634.940002 221.049988 L 635.97998 221.049988 L 635.97998 219.320007 Z"
      />
      <path
        id="path4551"
        fill="#cecece"
        stroke="none"
        d="M 635.97998 224.399994 L 634.940002 224.399994 L 634.940002 226.130005 L 635.97998 226.130005 L 635.97998 224.399994 Z"
      />
      <path
        id="path4552"
        fill="#cecece"
        stroke="none"
        d="M 635.97998 226.950012 L 634.940002 226.950012 L 634.940002 228.679993 L 635.97998 228.679993 L 635.97998 226.950012 Z"
      />
      <path
        id="path4553"
        fill="#cecece"
        stroke="none"
        d="M 635.97998 229.48999 L 634.940002 229.48999 L 634.940002 231.220001 L 635.97998 231.220001 L 635.97998 229.48999 Z"
      />
      <path
        id="path4554"
        fill="#cecece"
        stroke="none"
        d="M 635.97998 232.029999 L 634.940002 232.029999 L 634.940002 233.76001 L 635.97998 233.76001 L 635.97998 232.029999 Z"
      />
      <path
        id="path4555"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 179.299988 L 698.880005 179.570007 L 698.880005 178.970001 L 695.150024 178.679993 L 695.150024 179.299988 Z"
      />
      <path
        id="path4556"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 180.619995 L 698.880005 180.880005 L 698.880005 180.26001 L 695.150024 179.98999 L 695.150024 180.619995 Z"
      />
      <path
        id="path4557"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 181.929993 L 698.869995 182.179993 L 698.869995 181.559998 L 695.150024 181.289978 L 695.150024 181.929993 Z"
      />
      <path
        id="path4558"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 183.25 L 698.869995 183.48999 L 698.869995 182.850006 L 695.150024 182.589996 L 695.150024 183.25 Z"
      />
      <path
        id="path4559"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 184.559998 L 698.869995 184.789978 L 698.869995 184.140015 L 695.150024 183.899994 L 695.150024 184.559998 Z"
      />
      <path
        id="path4560"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 185.880005 L 698.859985 186.100006 L 698.859985 185.440002 L 695.150024 185.200012 L 695.150024 185.880005 Z"
      />
      <path
        id="path4561"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 187.190002 L 698.859985 187.399994 L 698.859985 186.72998 L 695.150024 186.51001 L 695.150024 187.190002 Z"
      />
      <path
        id="path4562"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 188.51001 L 698.859985 188.710022 L 698.859985 188.02002 L 695.150024 187.809998 L 695.150024 188.51001 Z"
      />
      <path
        id="path4563"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 189.820007 L 698.859985 190.01001 L 698.859985 189.320007 L 695.150024 189.109985 L 695.150024 189.820007 Z"
      />
      <path
        id="path4564"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 191.140015 L 698.859985 191.320007 L 698.859985 190.609985 L 695.150024 190.419983 L 695.150024 191.140015 Z"
      />
      <path
        id="path4565"
        fill="#cecece"
        stroke="none"
        d="M 695.150024 192.450012 L 698.859985 192.630005 L 698.859985 191.910004 L 695.150024 191.720001 L 695.150024 192.450012 Z"
      />
      <path
        id="path4566"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 193.77002 L 698.849976 193.929993 L 698.849976 193.200012 L 695.159973 193.029999 L 695.159973 193.77002 Z"
      />
      <path
        id="path4567"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 195.089996 L 698.849976 195.23999 L 698.849976 194.48999 L 695.159973 194.330017 L 695.159973 195.089996 Z"
      />
      <path
        id="path4568"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 196.399994 L 698.849976 196.539978 L 698.849976 195.789978 L 695.159973 195.640015 L 695.159973 196.399994 Z"
      />
      <path
        id="path4569"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 197.720001 L 698.849976 197.850006 L 698.849976 197.080017 L 695.159973 196.940002 L 695.159973 197.720001 Z"
      />
      <path
        id="path4570"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 199.029999 L 698.840027 199.149994 L 698.840027 198.369995 L 695.159973 198.23999 L 695.159973 199.029999 Z"
      />
      <path
        id="path4571"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 201.660004 L 698.840027 201.76001 L 698.840027 200.960022 L 695.159973 200.850006 L 695.159973 201.660004 Z"
      />
      <path
        id="path4572"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 205.609985 L 698.830017 205.679993 L 698.830017 204.839996 L 695.159973 204.76001 L 695.159973 205.609985 Z"
      />
      <path
        id="path4573"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 209.559998 L 698.830017 209.600006 L 698.830017 208.720001 L 695.159973 208.679993 L 695.159973 209.559998 Z"
      />
      <path
        id="path4574"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 213.5 L 698.820007 213.51001 L 698.820007 212.600006 L 695.159973 212.589996 L 695.159973 213.5 Z"
      />
      <path
        id="path4575"
        fill="#cecece"
        stroke="none"
        d="M 694.880005 179.419983 L 691.150024 179.690002 L 691.150024 179.089996 L 694.880005 178.799988 L 694.880005 179.419983 Z"
      />
      <path
        id="path4576"
        fill="#cecece"
        stroke="none"
        d="M 694.880005 180.75 L 691.150024 181.01001 L 691.150024 180.399994 L 694.880005 180.119995 L 694.880005 180.75 Z"
      />
      <path
        id="path4577"
        fill="#cecece"
        stroke="none"
        d="M 694.880005 182.080017 L 691.150024 182.330017 L 691.150024 181.710022 L 694.880005 181.440002 L 694.880005 182.080017 Z"
      />
      <path
        id="path4578"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 184.73999 L 691.159973 184.970001 L 691.159973 184.320007 L 694.869995 184.080017 L 694.869995 184.73999 Z"
      />
      <path
        id="path4579"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 187.399994 L 691.159973 187.609985 L 691.159973 186.940002 L 694.869995 186.710022 L 694.869995 187.399994 Z"
      />
      <path
        id="path4580"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 188.72998 L 691.159973 188.929993 L 691.159973 188.25 L 694.869995 188.029999 L 694.869995 188.72998 Z"
      />
      <path
        id="path4581"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 190.059998 L 691.159973 190.25 L 691.159973 189.549988 L 694.869995 189.350006 L 694.869995 190.059998 Z"
      />
      <path
        id="path4582"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 191.390015 L 691.169983 191.570007 L 691.169983 190.859985 L 694.869995 190.669983 L 694.869995 191.390015 Z"
      />
      <path
        id="path4583"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 192.720001 L 691.169983 192.890015 L 691.169983 192.169983 L 694.869995 191.98999 L 694.869995 192.720001 Z"
      />
      <path
        id="path4584"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 195.380005 L 691.169983 195.529999 L 691.169983 194.789978 L 694.869995 194.630005 L 694.869995 195.380005 Z"
      />
      <path
        id="path4585"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 196.710022 L 691.169983 196.850006 L 691.169983 196.100006 L 694.869995 195.950012 L 694.869995 196.710022 Z"
      />
      <path
        id="path4586"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 198.039978 L 691.169983 198.169983 L 691.169983 197.399994 L 694.869995 197.27002 L 694.869995 198.039978 Z"
      />
      <path
        id="path4587"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 199.369995 L 691.169983 199.48999 L 691.169983 198.710022 L 694.859985 198.580017 L 694.859985 199.369995 Z"
      />
      <path
        id="path4588"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 200.700012 L 691.179993 200.809998 L 691.179993 200.02002 L 694.859985 199.899994 L 694.859985 200.700012 Z"
      />
      <path
        id="path4589"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 202.029999 L 691.179993 202.130005 L 691.179993 201.330017 L 694.859985 201.220001 L 694.859985 202.029999 Z"
      />
      <path
        id="path4590"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 204.690002 L 691.179993 204.77002 L 691.179993 203.950012 L 694.859985 203.859985 L 694.859985 204.690002 Z"
      />
      <path
        id="path4591"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 207.350006 L 691.190002 207.410004 L 691.190002 206.559998 L 694.859985 206.5 L 694.859985 207.350006 Z"
      />
      <path
        id="path4592"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 208.679993 L 691.190002 208.72998 L 691.190002 207.869995 L 694.859985 207.820007 L 694.859985 208.679993 Z"
      />
      <path
        id="path4593"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 211.339996 L 691.190002 211.369995 L 691.190002 210.48999 L 694.859985 210.450012 L 694.859985 211.339996 Z"
      />
      <path
        id="path4594"
        fill="#cecece"
        stroke="none"
        d="M 698.840027 214.200012 L 695.159973 214.200012 L 695.159973 215.039978 L 698.840027 215.039978 L 698.840027 214.200012 Z"
      />
      <path
        id="path4595"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 215.529999 L 691.190002 215.529999 L 691.190002 216.369995 L 694.869995 216.369995 L 694.869995 215.529999 Z"
      />
      <path
        id="path4596"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 218.25 L 691.190002 218.25 L 691.190002 219.089996 L 694.869995 219.089996 L 694.869995 218.25 Z"
      />
      <path
        id="path4597"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 223.419983 L 698.830017 223.460022 L 698.830017 222.580017 L 695.159973 222.539978 L 695.159973 223.419983 Z"
      />
      <path
        id="path4598"
        fill="#cecece"
        stroke="none"
        d="M 695.159973 227.369995 L 698.820007 227.369995 L 698.820007 226.460022 L 695.159973 226.450012 L 695.159973 227.369995 Z"
      />
      <path
        id="path4599"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 221.220001 L 691.190002 221.279999 L 691.190002 220.429993 L 694.859985 220.359985 L 694.859985 221.220001 Z"
      />
      <path
        id="path4600"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 222.549988 L 691.190002 222.600006 L 691.190002 221.72998 L 694.859985 221.679993 L 694.859985 222.549988 Z"
      />
      <path
        id="path4601"
        fill="#cecece"
        stroke="none"
        d="M 694.859985 225.210022 L 691.190002 225.23999 L 691.190002 224.350006 L 694.859985 224.320007 L 694.859985 225.210022 Z"
      />
      <path
        id="path4602"
        fill="#cecece"
        stroke="none"
        d="M 698.840027 228.070007 L 695.159973 228.070007 L 695.159973 228.910004 L 698.840027 228.910004 L 698.840027 228.070007 Z"
      />
      <path
        id="path4603"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 229.390015 L 691.190002 229.390015 L 691.190002 230.22998 L 694.869995 230.22998 L 694.869995 229.390015 Z"
      />
      <path
        id="path4604"
        fill="#cecece"
        stroke="none"
        d="M 694.869995 232.109985 L 691.190002 232.109985 L 691.190002 232.950012 L 694.869995 232.950012 L 694.869995 232.109985 Z"
      />
      <path
        id="path4605"
        fill="#cecece"
        stroke="none"
        d="M 690.900024 220.929993 L 694.559998 220.970001 L 694.559998 220.089996 L 690.900024 220.049988 L 690.900024 220.929993 Z"
      />
      <path
        id="path4606"
        fill="#cecece"
        stroke="none"
        d="M 690.900024 224.869995 L 694.549988 224.880005 L 694.549988 223.970001 L 690.900024 223.960022 L 690.900024 224.869995 Z"
      />
      <path
        id="path4607"
        fill="#cecece"
        stroke="none"
        d="M 690.590027 218.72998 L 686.919983 218.789978 L 686.919983 217.929993 L 690.590027 217.869995 L 690.590027 218.72998 Z"
      />
      <path
        id="path4608"
        fill="#cecece"
        stroke="none"
        d="M 690.590027 220.059998 L 686.919983 220.109985 L 686.919983 219.23999 L 690.590027 219.190002 L 690.590027 220.059998 Z"
      />
      <path
        id="path4609"
        fill="#cecece"
        stroke="none"
        d="M 690.590027 222.720001 L 686.929993 222.75 L 686.929993 221.859985 L 690.590027 221.830017 L 690.590027 222.720001 Z"
      />
      <path
        id="path4610"
        fill="#cecece"
        stroke="none"
        d="M 694.580017 225.570007 L 690.900024 225.570007 L 690.900024 226.410004 L 694.580017 226.410004 L 694.580017 225.570007 Z"
      />
      <path
        id="path4611"
        fill="#cecece"
        stroke="none"
        d="M 690.599976 226.899994 L 686.919983 226.899994 L 686.919983 227.73999 L 690.599976 227.73999 L 690.599976 226.899994 Z"
      />
      <path
        id="path4612"
        fill="#cecece"
        stroke="none"
        d="M 690.599976 229.619995 L 686.919983 229.619995 L 686.919983 230.460022 L 690.599976 230.460022 L 690.599976 229.619995 Z"
      />
      <path
        id="path4613"
        fill="#cecece"
        stroke="none"
        d="M 686.609985 179.679993 L 690.340027 179.950012 L 690.340027 179.350006 L 686.609985 179.059998 L 686.609985 179.679993 Z"
      />
      <path
        id="path4614"
        fill="#cecece"
        stroke="none"
        d="M 686.609985 181 L 690.340027 181.26001 L 690.340027 180.640015 L 686.609985 180.359985 L 686.609985 181 Z"
      />
      <path
        id="path4615"
        fill="#cecece"
        stroke="none"
        d="M 686.609985 182.309998 L 690.330017 182.559998 L 690.330017 181.940002 L 686.609985 181.669983 L 686.609985 182.309998 Z"
      />
      <path
        id="path4616"
        fill="#cecece"
        stroke="none"
        d="M 686.609985 183.630005 L 690.330017 183.869995 L 690.330017 183.22998 L 686.609985 182.970001 L 686.609985 183.630005 Z"
      />
      <path
        id="path4617"
        fill="#cecece"
        stroke="none"
        d="M 686.609985 184.940002 L 690.330017 185.169983 L 690.330017 184.52002 L 686.609985 184.279999 L 686.609985 184.940002 Z"
      />
      <path
        id="path4618"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 186.26001 L 690.330017 186.47998 L 690.330017 185.820007 L 686.619995 185.580017 L 686.619995 186.26001 Z"
      />
      <path
        id="path4619"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 187.570007 L 690.330017 187.779999 L 690.330017 187.109985 L 686.619995 186.890015 L 686.619995 187.570007 Z"
      />
      <path
        id="path4620"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 188.890015 L 690.320007 189.089996 L 690.320007 188.399994 L 686.619995 188.190002 L 686.619995 188.890015 Z"
      />
      <path
        id="path4621"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 190.200012 L 690.320007 190.390015 L 690.320007 189.700012 L 686.619995 189.48999 L 686.619995 190.200012 Z"
      />
      <path
        id="path4622"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 191.52002 L 690.320007 191.700012 L 690.320007 190.98999 L 686.619995 190.799988 L 686.619995 191.52002 Z"
      />
      <path
        id="path4623"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 192.830017 L 690.320007 193 L 690.320007 192.279999 L 686.619995 192.100006 L 686.619995 192.830017 Z"
      />
      <path
        id="path4624"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 194.149994 L 690.320007 194.309998 L 690.320007 193.580017 L 686.619995 193.410004 L 686.619995 194.149994 Z"
      />
      <path
        id="path4625"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 195.460022 L 690.309998 195.619995 L 690.309998 194.869995 L 686.619995 194.710022 L 686.619995 195.460022 Z"
      />
      <path
        id="path4626"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 196.779999 L 690.309998 196.919983 L 690.309998 196.160004 L 686.619995 196.01001 L 686.619995 196.779999 Z"
      />
      <path
        id="path4627"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 198.100006 L 690.309998 198.22998 L 690.309998 197.460022 L 686.619995 197.320007 L 686.619995 198.100006 Z"
      />
      <path
        id="path4628"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 199.410004 L 690.309998 199.529999 L 690.309998 198.75 L 686.619995 198.619995 L 686.619995 199.410004 Z"
      />
      <path
        id="path4629"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 202.039978 L 690.299988 202.140015 L 690.299988 201.339996 L 686.619995 201.22998 L 686.619995 202.039978 Z"
      />
      <path
        id="path4630"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 205.98999 L 690.289978 206.059998 L 690.289978 205.220001 L 686.619995 205.140015 L 686.619995 205.98999 Z"
      />
      <path
        id="path4631"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 209.929993 L 690.289978 209.97998 L 690.289978 209.100006 L 686.619995 209.059998 L 686.619995 209.929993 Z"
      />
      <path
        id="path4632"
        fill="#cecece"
        stroke="none"
        d="M 686.619995 213.880005 L 690.280029 213.890015 L 690.280029 212.97998 L 686.619995 212.970001 L 686.619995 213.880005 Z"
      />
      <path
        id="path4633"
        fill="#cecece"
        stroke="none"
        d="M 690.299988 214.580017 L 686.619995 214.580017 L 686.619995 215.419983 L 690.299988 215.419983 L 690.299988 214.580017 Z"
      />
      <path
        id="path4634"
        fill="#cecece"
        stroke="none"
        d="M 685.549988 182.5 L 684.700012 182.5 L 684.700012 198.919983 L 685.549988 198.919983 L 685.549988 182.5 Z"
      />
      <path
        id="path4635"
        fill="#cecece"
        stroke="none"
        d="M 686.969971 208.070007 L 686.22998 208.070007 L 686.22998 232.330017 L 686.969971 232.330017 L 686.969971 208.070007 Z"
      />
      <path
        id="path4636"
        fill="#cecece"
        stroke="none"
        d="M 685.549988 210.27002 L 684.700012 210.27002 L 684.700012 226.690002 L 685.549988 226.690002 L 685.549988 210.27002 Z"
      />
      <path
        id="path4637"
        fill="#cecece"
        stroke="none"
        d="M 710.150024 196.169983 L 708.880005 196.169983 L 708.880005 213.429993 L 710.150024 213.429993 L 710.150024 196.169983 Z"
      />
      <path
        id="path4638"
        fill="#cecece"
        stroke="none"
        d="M 672.799988 183.080017 L 671.070007 183.080017 L 671.070007 213.75 L 672.799988 213.75 L 672.799988 183.080017 Z"
      />
      <path
        id="path4639"
        fill="#cecece"
        stroke="none"
        d="M 570.280029 144.23999 L 570.280029 183.97998 L 571.419983 183.940002 L 571.419983 144.410004 L 570.280029 144.23999 Z"
      />
      <path
        id="path4640"
        fill="#cecece"
        stroke="none"
        d="M 505.839996 174.160004 L 503.48999 174.160004 L 503.48999 211.929993 L 505.839996 211.929993 L 505.839996 174.160004 Z"
      />
      <path
        id="path4641"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 410.839996 50.419891 L 416.459991 318.040009 L 431.410004 317.660004 L 426.079987 54.21991 L 410.839996 50.419891 Z"
      />
      <g id="g6" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4642"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 410.839996 50.419891 L 426.079987 54.21991 L 426.179993 59.21991 L 412.98999 66.749908 L 416.459991 318.040009 L 410.839996 50.419891 Z"
        />
      </g>
      <path
        id="path4643"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 354.200012 46.689911 L 359.820007 314.309998 L 374.76001 313.929993 L 369.429993 50.489899 L 354.200012 46.689911 Z"
      />
      <g id="g7" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4644"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 354.200012 46.689911 L 369.429993 50.489899 L 369.529999 55.489899 L 361.890015 61.519897 L 366.820007 316.029999 L 361.890015 313.920013 L 354.200012 46.689911 Z"
        />
      </g>
      <path
        id="path4645"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 343.920013 46.689911 L 349.540009 314.309998 L 364.480011 313.929993 L 359.149994 50.489899 L 343.920013 46.689911 Z"
      />
      <g id="g8" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4646"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 343.920013 46.689911 L 359.149994 50.489899 L 359.25 55.489899 L 351.609985 61.519897 L 356.540009 316.029999 L 351.609985 313.920013 L 343.920013 46.689911 Z"
        />
      </g>
      <path
        id="path4647"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 333.630005 46.689911 L 339.25 314.309998 L 354.200012 313.929993 L 348.869995 50.489899 L 333.630005 46.689911 Z"
      />
      <g id="g9" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4648"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 333.630005 46.689911 L 348.869995 50.489899 L 348.970001 55.489899 L 337.089996 61.519897 L 346.26001 316.029999 L 341.329987 313.920013 L 333.630005 46.689911 Z"
        />
      </g>
      <path
        id="path4649"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 320.839996 46.689911 L 326.459991 314.309998 L 341.410004 313.929993 L 336.079987 50.489899 L 320.839996 46.689911 Z"
      />
      <g id="g10" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4650"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 320.839996 46.689911 L 336.079987 50.489899 L 336.179993 55.489899 L 328.540009 61.519897 L 333.470001 316.029999 L 328.540009 313.920013 L 320.839996 46.689911 Z"
        />
      </g>
      <path
        id="path4651"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 394.109985 50.419891 L 399.730011 318.040009 L 414.670013 317.660004 L 409.339996 54.21991 L 394.109985 50.419891 Z"
      />
      <g id="g11" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4652"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 394.109985 50.419891 L 409.339996 54.21991 L 409.440002 59.21991 L 396.26001 66.749908 L 401.089996 317.649994 L 400.429993 317.649994 L 394.109985 50.419891 Z"
        />
      </g>
      <path
        id="path4653"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 373.220001 50.419891 L 378.839996 318.040009 L 393.790009 317.660004 L 388.459991 54.21991 L 373.220001 50.419891 Z"
      />
      <g id="g12" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4654"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 373.220001 50.419891 L 388.459991 54.21991 L 388.559998 59.21991 L 375.369995 66.749908 L 382.579987 317.649994 L 378.839996 318.040009 L 373.220001 50.419891 Z"
        />
      </g>
      <path
        id="path4655"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 310.559998 46.689911 L 316.179993 314.309998 L 331.119995 313.929993 L 325.790009 50.489899 L 310.559998 46.689911 Z"
      />
      <g id="g13" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4656"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 310.559998 46.689911 L 325.790009 50.489899 L 325.899994 55.489899 L 318.26001 61.519897 L 323.190002 316.029999 L 318.26001 313.920013 L 310.559998 46.689911 Z"
        />
      </g>
      <path
        id="path4657"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 300.279999 46.689911 L 305.899994 314.309998 L 320.839996 313.929993 L 315.51001 50.489899 L 300.279999 46.689911 Z"
      />
      <g id="g14" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4658"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 300.279999 46.689911 L 315.51001 50.489899 L 315.609985 55.489899 L 303.730011 61.519897 L 312.899994 316.029999 L 307.970001 313.920013 L 300.279999 46.689911 Z"
        />
      </g>
      <path
        id="path4659"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 763 51.589813 L 757.380005 318.040009 L 742.429993 317.660004 L 747.76001 55.369812 L 763 51.589813 Z"
      />
      <g id="g15" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4660"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 763 51.589813 L 747.76001 55.369812 L 747.659973 60.349792 L 760.849976 67.849792 L 757.380005 318.040009 L 763 51.589813 Z"
        />
      </g>
      <path
        id="path4661"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 829.919983 47.879913 L 824.299988 314.329987 L 809.359985 313.950012 L 814.690002 51.659912 L 829.919983 47.879913 Z"
      />
      <g id="g16" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4662"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 829.919983 47.879913 L 814.690002 51.659912 L 814.590027 56.629913 L 822.22998 62.639893 L 817.299988 316.029999 L 822.22998 313.940002 L 829.919983 47.879913 Z"
        />
      </g>
      <path
        id="path4663"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 840.210022 47.879913 L 834.590027 314.329987 L 819.640015 313.950012 L 824.969971 51.659912 L 840.210022 47.879913 Z"
      />
      <g id="g17" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4664"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 840.210022 47.879913 L 824.969971 51.659912 L 824.869995 56.629913 L 832.51001 62.639893 L 827.580017 316.029999 L 832.51001 313.940002 L 840.210022 47.879913 Z"
        />
      </g>
      <path
        id="path4665"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 850.48999 47.879913 L 844.869995 314.329987 L 829.919983 313.950012 L 835.25 51.659912 L 850.48999 47.879913 Z"
      />
      <g id="g18" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4666"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 850.48999 47.879913 L 835.25 51.659912 L 835.150024 56.629913 L 847.030029 62.639893 L 837.859985 316.029999 L 842.789978 313.940002 L 850.48999 47.879913 Z"
        />
      </g>
      <path
        id="path4667"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 863.280029 47.879913 L 857.659973 314.329987 L 842.719971 313.950012 L 848.039978 51.659912 L 863.280029 47.879913 Z"
      />
      <g id="g19" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4668"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 863.280029 47.879913 L 848.039978 51.659912 L 847.940002 56.629913 L 855.580017 62.639893 L 850.650024 316.029999 L 855.580017 313.940002 L 863.280029 47.879913 Z"
        />
      </g>
      <path
        id="path4669"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 790.01001 51.589813 L 784.390015 318.040009 L 769.450012 317.660004 L 774.780029 55.369812 L 790.01001 51.589813 Z"
      />
      <g id="g20" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4670"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 790.01001 51.589813 L 774.780029 55.369812 L 774.679993 60.349792 L 787.859985 67.849792 L 783.030029 317.649994 L 783.690002 317.649994 L 790.01001 51.589813 Z"
        />
      </g>
      <path
        id="path4671"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 810.900024 51.589813 L 805.280029 318.040009 L 790.330017 317.660004 L 795.659973 55.369812 L 810.900024 51.589813 Z"
      />
      <g id="g21" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4672"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 810.900024 51.589813 L 795.659973 55.369812 L 795.559998 60.349792 L 808.75 67.849792 L 801.539978 317.649994 L 805.280029 318.040009 L 810.900024 51.589813 Z"
        />
      </g>
      <path
        id="path4673"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 873.559998 47.879913 L 867.940002 314.329987 L 853 313.950012 L 858.330017 51.659912 L 873.559998 47.879913 Z"
      />
      <g id="g22" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4674"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 873.559998 47.879913 L 858.330017 51.659912 L 858.22998 56.629913 L 865.869995 62.639893 L 860.940002 316.029999 L 865.869995 313.940002 L 873.559998 47.879913 Z"
        />
      </g>
      <path
        id="path4675"
        fill="#c1c1c1"
        fillRule="evenodd"
        stroke="none"
        d="M 883.840027 47.879913 L 878.219971 314.329987 L 863.280029 313.950012 L 868.609985 51.659912 L 883.840027 47.879913 Z"
      />
      <g id="g23" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4676"
          fill="#c1c1c1"
          fillRule="evenodd"
          stroke="none"
          d="M 883.840027 47.879913 L 868.609985 51.659912 L 868.51001 56.629913 L 880.390015 62.639893 L 871.219971 316.029999 L 876.150024 313.940002 L 883.840027 47.879913 Z"
        />
      </g>
      <path
        id="path4677"
        fill="#eaeaea"
        fillRule="evenodd"
        stroke="none"
        d="M 1038.060059 14.690094 L 1034.449951 338.130005 L 1010.179993 338.5 L 1016.950012 11.330109 L 1038.060059 14.690094 Z"
      />
      <path
        id="path4678"
        fill="#eaeaea"
        fillRule="evenodd"
        stroke="none"
        d="M 1016.950012 11.330109 C 965.799988 21.640106 927.890015 31.270111 878.72998 38.760101 L 874 314.589996 C 874 314.589996 963.22998 325.950012 1010.179993 338.48999 L 1016.950012 11.330109 Z"
      />
      <path
        id="path4679"
        fill="#f4f4f4"
        fillRule="evenodd"
        stroke="none"
        d="M 1034.579956 326.359985 L 1034.540039 330.290009 L 1034.449951 338.119995 L 1010.179993 338.48999 C 946.840027 323.570007 870.919983 314.200012 870.919983 314.200012 L 870.919983 307.98999 L 874.130005 306.839996 C 922.789978 310.76001 1011.200012 326.019989 1011.200012 326.019989 L 1034.579956 326.359985 Z"
      />
      <path
        id="path4680"
        fill="#f4f4f4"
        fillRule="evenodd"
        stroke="none"
        d="M 1038.060059 14.700104 L 1037.959961 24.700104 L 1037.900024 30.180115 L 1016.950012 26.920105 C 1016.950012 26.920105 936.200012 45.500092 878.530029 49.770111 L 875.380005 47.78009 L 874.530029 38.190094 C 874.679993 38.170105 874.840027 38.150085 874.98999 38.120087 C 875.130005 38.110107 875.280029 38.090088 875.429993 38.060089 C 875.52002 38.05011 875.619995 38.0401 875.710022 38.020111 C 877.789978 37.700104 882.539978 36.990112 889.119995 35.990112 C 889.27002 35.970093 889.440002 35.940094 889.590027 35.910095 C 919.940002 31.260101 987.97998 18.090088 1016.940002 11.360107 L 1038.050049 14.720093 L 1038.060059 14.700104 Z"
      />
      <g id="g24" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4681"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 1038.060059 14.700104 L 1038.060059 24.700104 L 1037.959961 24.700104 L 1016.950012 23.990112 C 938.109985 38.480103 875.380005 47.770111 875.380005 47.770111 L 874.530029 38.180115 C 874.679993 38.160095 874.840027 38.140106 874.98999 38.110107 C 875.130005 38.100098 875.280029 38.080109 875.429993 38.05011 C 875.52002 38.0401 875.619995 38.03009 875.710022 38.010101 C 880.080017 37.400085 884.570007 36.720093 889.119995 35.980103 C 889.27002 35.960083 889.440002 35.930115 889.590027 35.900085 C 919.940002 31.250092 987.97998 18.080109 1016.940002 11.350098 L 1038.050049 14.710114 L 1038.060059 14.700104 Z"
        />
      </g>
      <g id="g25" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4682"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 1034.560059 328.859985 L 1034.459961 338.130005 L 1010.190002 338.5 C 946.849976 323.579987 870.929993 314.209991 870.929993 314.209991 L 870.929993 308 C 931.609985 316.809998 1010.869995 328.700012 1010.869995 328.700012 L 1034.569946 328.869995 L 1034.560059 328.859985 Z"
        />
      </g>
      <path
        id="path4683"
        fill="#eaeaea"
        fillRule="evenodd"
        stroke="none"
        d="M 152.960007 14.690094 L 156.5 336.630005 L 180.399994 338.179993 L 173.740005 11.330109 L 152.960007 14.690094 Z"
      />
      <path
        id="path4684"
        fill="#eaeaea"
        fillRule="evenodd"
        stroke="none"
        d="M 173.740005 11.330109 C 224.080002 21.630096 261.380005 31.250092 309.769989 38.730103 L 314.429993 314.290009 C 314.429993 314.290009 226.619995 325.630005 180.410004 338.170013 L 173.75 11.320099 L 173.740005 11.330109 Z"
      />
      <path
        id="path4685"
        fill="#f4f4f4"
        fillRule="evenodd"
        stroke="none"
        d="M 156.380005 326.059998 L 156.419998 329.98999 L 156.490005 336.640015 L 180.389999 338.179993 C 242.729996 323.279999 317.440002 313.910004 317.440002 313.910004 L 317.440002 307.709991 L 314.279999 306.559998 C 266.390015 310.480011 179.380005 325.730011 179.380005 325.730011 L 156.369995 326.059998 L 156.380005 326.059998 Z"
      />
      <g id="g26" opacity="0.87" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4686"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 152.960007 14.700104 L 153.059998 24.690094 L 153.119995 30.160095 L 173.740005 26.900085 C 173.740005 26.900085 253.210007 45.460083 309.970001 49.720093 L 313.070007 47.730103 L 313.899994 38.150085 C 313.75 38.130096 313.600006 38.110107 313.440002 38.080109 C 313.299988 38.070099 313.160004 38.05011 313 38.020111 C 312.910004 38.010101 312.820007 38.000092 312.730011 37.980103 C 310.679993 37.670105 306.01001 36.950104 299.529999 35.950104 C 299.380005 35.930115 299.220001 35.900085 299.059998 35.870087 C 269.200012 31.220093 202.229996 18.070099 173.740005 11.340088 L 152.960007 14.700104 Z"
        />
      </g>
      <g id="g27" opacity="0.87" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4687"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 152.960007 14.700104 L 152.960007 24.690094 L 153.059998 24.690094 L 173.740005 23.980103 C 189.009995 26.830109 203.669998 29.480103 217.369995 31.890106 C 273.23999 41.750092 313.070007 47.730103 313.070007 47.730103 L 313.899994 38.150085 C 313.75 38.130096 313.600006 38.110107 313.440002 38.080109 C 313.299988 38.070099 313.160004 38.05011 313 38.020111 C 312.910004 38.010101 312.820007 38.000092 312.730011 37.980103 C 308.429993 37.370087 304.01001 36.690094 299.529999 35.950104 C 299.380005 35.930115 299.220001 35.900085 299.059998 35.870087 C 269.200012 31.220093 202.229996 18.070099 173.740005 11.340088 L 152.960007 14.700104 Z"
        />
      </g>
      <g id="g28" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4688"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 156.410004 329.23999 L 156.490005 336.630005 L 180.389999 338.170013 C 242.729996 323.269989 317.440002 313.899994 317.440002 313.899994 L 317.440002 307.700012 C 257.720001 316.5 179.720001 328.380005 179.720001 328.380005 L 156.399994 329.23999 L 156.410004 329.23999 Z"
        />
      </g>
      <linearGradient
        id="linearGradient8"
        x1="177.59"
        y1="186.6"
        x2="312.14"
        y2="186.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset={1} stopColor="#987d8f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path4689"
        fill="url(#linearGradient8)"
        fillRule="evenodd"
        stroke="none"
        style={{ mixBlendMode: 'screen' }}
        d="M 310.640015 90.429901 L 177.589996 200.279999 L 179.229996 282.769989 L 312.140015 178.97998 L 310.640015 90.429901 Z"
      />
      <linearGradient
        id="linearGradient9"
        x1="179.57"
        y1="255.17"
        x2="314.42"
        y2="255.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset={1} stopColor="#987d8f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path4690"
        fill="url(#linearGradient9)"
        fillRule="evenodd"
        stroke="none"
        style={{ mixBlendMode: 'screen' }}
        d="M 312.140015 184.75 L 179.570007 297.329987 L 180.149994 325.579987 L 213.199997 320.269989 L 314.420013 267.609985 L 312.140015 184.75 Z"
      />
      <linearGradient
        id="linearGradient10"
        x1="176.77"
        y1="122.99"
        x2="310.56"
        y2="122.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset={1} stopColor="#987d8f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path4691"
        fill="url(#linearGradient10)"
        fillRule="evenodd"
        stroke="none"
        style={{ mixBlendMode: 'screen' }}
        d="M 310.559998 85.669891 L 177.589996 186.600006 L 176.770004 168.330017 L 309.609985 59.379913 L 310.559998 85.669891 Z"
      />
      <g id="g29" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4692"
          fill="#efefef"
          stroke="none"
          d="M 1031.160034 342.549988 L 1003.48999 340.679993 L 1003.409973 330.929993 L 1001.72998 328.089996 L 1004.960022 177.26001 L 871.280029 75.839905 L 871.909973 52.21991 L 868.809998 50.229889 L 868.52002 46.919891 C 795.219971 55.669891 705.140015 61.879913 595.5 61.879913 C 479.049988 61.879913 382.950012 54.659912 307.019989 44.919891 L 306.559998 50.229889 L 303.459991 52.21991 L 303.700012 67.46991 L 170.259995 170.830017 L 173.630005 328.089996 L 171.949997 330.929993 L 171.869995 340.679993 L 136.470001 343.079987 L 136.360001 342.73999 L 81.179901 357.950012 C 81.179901 357.950012 278.040009 392.799988 592.030029 392.799988 C 822.440002 392.799988 960.700012 377.48999 1029.660034 366.670013 C 1030.119995 358.630005 1030.650024 350.589996 1031.150024 342.549988 L 1031.160034 342.549988 Z"
        />
      </g>
      <g id="g30" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path4693"
          fill="#f4f4f4"
          fillRule="evenodd"
          stroke="none"
          d="M 220.059998 214.950012 L 204 239.830002 L 192.289993 239.910004 L 186.529999 324.339996 L 192.289993 326.470001 L 191.910004 335.73999 L 218.050003 340.440002 L 241.149994 339.279999 L 234.960007 298.410004 L 236.410004 276.690002 L 228.330002 268.980011 L 229.339996 226.600006 L 220.059998 214.950012 Z"
        />
      </g>
      <linearGradient
        id="linearGradient11"
        x1="235.37"
        y1="367.97"
        x2="235.37"
        y2="338.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset={1} stopColor="#eee6e3" stopOpacity={1} />
      </linearGradient>
      <path
        id="path4694"
        fill="url(#linearGradient11)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 217.199997 338.48999 L 216.039993 367.970001 L 254.699997 367.970001 L 253.570007 338.48999 L 217.199997 338.48999 Z"
      />
      <linearGradient
        id="linearGradient12"
        x1="936.67"
        y1="356.97"
        x2="942.37"
        y2="324.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset={1} stopColor="#eee6e3" stopOpacity={1} />
      </linearGradient>
      <path
        id="path4695"
        fill="url(#linearGradient12)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 1007.969971 338.179993 L 1007.969971 368.549988 L 870.919983 345.369995 L 870.919983 313.899994 C 870.919983 313.899994 927.169983 319.579987 1007.969971 338.170013 L 1007.969971 338.179993 Z"
      />
      <path
        id="path4696"
        fill="#ffffff"
        stroke="#9b9b9b"
        strokeWidth={2}
        d="M 301.290009 188.279999 L 166.119995 195.48999 L 165.210007 84.159912 L 300.369995 92.999908 L 301.290009 188.279999 Z"
      />
      <g id="revieion-02" style={{ isolation: 'isolate' }}>
        <g id="Layer1">
          <g id="g31" opacity="0.07">
            <g id="g32">
              <g id="g33">
                <linearGradient
                  id="linearGradient13"
                  x1="249.155685"
                  y1="135.197518"
                  x2="249.251499"
                  y2="127.25998"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                  <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                  <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                  <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4697"
                  fill="url(#linearGradient13)"
                  stroke="none"
                  d="M 258.686859 130.46994 L 244.900009 130.303528 C 242.049927 130.269104 239.721664 131.496429 239.703003 133.043091 C 239.684326 134.589752 241.97998 135.872864 244.832367 135.907318 C 247.684738 135.941742 250.010696 134.714417 250.029373 133.167755 C 250.030396 133.082825 250.022232 132.997833 250.009506 132.91275 L 258.656128 133.01712 L 258.68689 130.467651 Z"
                />
                <path
                  id="path4698"
                  fill="#363636"
                  stroke="none"
                  d="M 263.21344 133.074402 C 262.994354 131.641937 260.798035 130.495453 258.103973 130.462891 C 255.409958 130.430389 253.186584 131.52356 252.932983 132.950317 L 251.471222 132.932648 L 250.983627 173.327179 L 264.185303 173.486511 L 264.672913 133.092041 L 263.211151 133.074402 Z"
                />
                <path
                  id="path4699"
                  fill="#bcbcbc"
                  stroke="none"
                  d="M 258.527557 143.667053 L 266.274628 143.760559 L 265.915558 173.507416 L 258.168488 173.413879 Z"
                />
                <path
                  id="path4700"
                  fill="#c1c1c1"
                  stroke="none"
                  d="M 256.27182 143.639801 L 258.529846 143.667053 L 258.170776 173.41391 L 255.912735 173.386627 Z"
                />
                <path
                  id="path4701"
                  fill="#ffffff"
                  stroke="none"
                  d="M 238.269531 132.773315 L 251.471222 132.932678 L 250.983627 173.327179 L 237.781937 173.167786 Z"
                />
              </g>
              <linearGradient
                id="linearGradient14"
                x1="256.194631"
                y1="143.379541"
                x2="272.331308"
                y2="143.574326"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                <stop offset={1} stopColor="#666666" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4702"
                fill="url(#linearGradient14)"
                stroke="none"
                d="M 256.213593 141.807648 L 272.350281 142.002411 L 272.312347 145.14624 L 256.175659 144.951416 Z"
              />
              <path
                id="path4703"
                fill="#cccccc"
                stroke="none"
                d="M 256.213593 141.807648 L 265.296234 141.917267 L 265.25827 145.061096 L 256.175659 144.951416 Z"
              />
              <linearGradient
                id="linearGradient15"
                x1="259.926516"
                y1="136.718354"
                x2="259.407337"
                y2="179.728841"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.54" stopColor="#f2f2f2" stopOpacity={1} />
                <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4704"
                fill="url(#linearGradient15)"
                stroke="none"
                d="M 264.085663 145.046936 L 264.108124 143.185883 L 255.186142 143.078186 L 255.163681 144.939209 L 253.300339 144.916718 L 252.957108 173.350983 L 266.009613 173.508545 L 266.352875 145.07428 L 264.085663 145.046936 Z"
              />
              <linearGradient
                id="linearGradient16"
                x1="270.180491"
                y1="178.775604"
                x2="270.748473"
                y2="151.305718"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                <stop offset={1} stopColor="#666666" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4705"
                fill="url(#linearGradient16)"
                stroke="none"
                d="M 272.888306 145.153168 L 272.910797 143.292145 L 268.236359 143.235718 L 268.213898 145.096741 L 266.352875 145.07428 L 266.009613 173.508545 L 274.810028 173.614746 L 275.153259 145.180542 L 272.888306 145.153168 Z"
              />
              <path
                id="path4706"
                fill="#ffffff"
                stroke="none"
                d="M 267.164734 143.222778 L 268.236359 143.235718 L 268.213898 145.096741 L 267.142273 145.083801 Z"
              />
              <path
                id="path4707"
                fill="#808080"
                stroke="none"
                d="M 263.552795 143.179169 L 264.62442 143.192108 L 264.601959 145.053131 L 263.530334 145.040222 Z"
              />
              <linearGradient
                id="linearGradient17"
                x1="241.508025"
                y1="139.036682"
                x2="240.982974"
                y2="182.533657"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4708"
                fill="url(#linearGradient17)"
                stroke="none"
                d="M 234.330704 149.163177 L 248.434235 149.333405 L 248.143784 173.396179 L 234.040237 173.225922 Z"
              />
              <linearGradient
                id="linearGradient18"
                x1="246.188993"
                y1="178.667315"
                x2="246.642274"
                y2="141.116036"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                <stop offset={1} stopColor="#666666" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4709"
                fill="url(#linearGradient18)"
                stroke="none"
                d="M 244.673141 149.288025 L 248.413589 149.33316 L 248.123123 173.395905 L 244.382675 173.350739 Z"
              />
              <path
                id="path4710"
                fill="#e8e8e8"
                stroke="none"
                d="M 238.269531 132.773315 L 251.471222 132.932648 L 251.464218 133.513245 L 238.262527 133.353882 Z"
              />
              <path
                id="path4711"
                fill="#9f9f9f"
                stroke="none"
                d="M 251.471222 132.932648 L 264.672913 133.092041 L 264.665924 133.672607 L 251.464218 133.513245 Z"
              />
              <path
                id="path4712"
                fill="#fdfdfd"
                stroke="none"
                d="M 240.774902 132.273407 L 247.544418 132.355103 L 247.53804 132.882904 L 240.768539 132.801208 Z"
              />
              <linearGradient
                id="linearGradient19"
                x1="270.684964"
                y1="145.349209"
                x2="270.371707"
                y2="171.30053"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#b3b3b3" stopOpacity={1} />
                <stop offset="0.12" stopColor="#b8b8b8" stopOpacity={1} />
                <stop offset="0.28" stopColor="#c7c7c7" stopOpacity={1} />
                <stop offset="0.44" stopColor="#dfdfdf" stopOpacity={1} />
                <stop offset="0.54" stopColor="#f2f2f2" stopOpacity={1} />
                <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4713"
                fill="url(#linearGradient19)"
                stroke="none"
                d="M 267.678894 146.639496 L 273.658997 146.71167 L 273.397461 168.378693 L 267.417358 168.306519 Z"
              />
              <g id="g34" opacity="0.1">
                <path
                  id="path4714"
                  fill="#ffffff"
                  stroke="none"
                  d="M 273.435974 168.420471 L 267.375549 168.34729 L 267.638062 146.599945 L 273.698486 146.673126 L 273.435974 168.420471 Z M 267.456848 168.267944 L 273.356628 168.339172 L 273.617218 146.752472 L 267.717407 146.681274 L 267.456848 168.267944 Z"
                />
                <g id="g35">
                  <path
                    id="path4715"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.666992 147.623932 L 273.647125 147.696106 L 273.646149 147.776428 L 267.666046 147.704254 Z"
                  />
                  <path
                    id="path4716"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.6521 148.85849 L 273.632233 148.930695 L 273.631226 149.011017 L 267.651154 148.938812 Z"
                  />
                  <path
                    id="path4717"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.637207 150.09079 L 273.61734 150.162964 L 273.616394 150.243286 L 267.636261 150.171112 Z"
                  />
                  <path
                    id="path4718"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.622345 151.325348 L 273.602417 151.397552 L 273.601471 151.477875 L 267.621338 151.40567 Z"
                  />
                  <path
                    id="path4719"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.607422 152.559937 L 273.587555 152.632111 L 273.586578 152.712433 L 267.606445 152.640259 Z"
                  />
                  <path
                    id="path4720"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.592529 153.794525 L 273.572632 153.866699 L 273.571655 153.947021 L 267.591553 153.874817 Z"
                  />
                  <path
                    id="path4721"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.577606 155.029083 L 273.557739 155.101257 L 273.556793 155.18158 L 267.57666 155.109406 Z"
                  />
                  <path
                    id="path4722"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.562775 156.261353 L 273.542847 156.333557 L 273.541901 156.413879 L 267.561768 156.341675 Z"
                  />
                  <path
                    id="path4723"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.547852 157.495941 L 273.527954 157.568115 L 273.526978 157.648438 L 267.546875 157.576263 Z"
                  />
                  <path
                    id="path4724"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.532928 158.73053 L 273.513062 158.802704 L 273.512085 158.883026 L 267.531952 158.810852 Z"
                  />
                  <path
                    id="path4725"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.518036 159.965088 L 273.498169 160.037262 L 273.497162 160.117615 L 267.51709 160.04541 Z"
                  />
                  <path
                    id="path4726"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.503113 161.199677 L 273.483246 161.271851 L 273.4823 161.352173 L 267.502167 161.279999 Z"
                  />
                  <path
                    id="path4727"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.48822 162.434235 L 273.468353 162.506439 L 273.467377 162.586761 L 267.487274 162.514587 Z"
                  />
                  <path
                    id="path4728"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.473358 163.666534 L 273.453461 163.738708 L 273.452515 163.819031 L 267.472382 163.746857 Z"
                  />
                  <path
                    id="path4729"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.458466 164.901093 L 273.438568 164.973297 L 273.437592 165.053619 L 267.457458 164.981415 Z"
                  />
                  <path
                    id="path4730"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.443542 166.135681 L 273.423676 166.207855 L 273.422699 166.288177 L 267.442596 166.216003 Z"
                  />
                  <path
                    id="path4731"
                    fill="#ffffff"
                    stroke="none"
                    d="M 267.42865 167.370239 L 273.408752 167.442444 L 273.407806 167.522766 L 267.427673 167.450592 Z"
                  />
                </g>
                <path
                  id="path4732"
                  fill="#ffffff"
                  stroke="none"
                  d="M 268.814789 146.653168 L 268.895142 146.654175 L 268.633575 168.321167 L 268.553253 168.320221 Z"
                />
                <path
                  id="path4733"
                  fill="#ffffff"
                  stroke="none"
                  d="M 272.415253 146.696655 L 272.495575 146.697601 L 272.234039 168.364624 L 272.153717 168.363678 Z"
                />
                <path
                  id="path4734"
                  fill="#ffffff"
                  stroke="none"
                  d="M 271.173798 146.681671 L 271.25412 146.682617 L 270.992554 168.34964 L 270.912262 168.348694 Z"
                />
                <path
                  id="path4735"
                  fill="#ffffff"
                  stroke="none"
                  d="M 269.994293 146.66745 L 270.074615 146.668396 L 269.813049 168.335419 L 269.732727 168.334473 Z"
                />
              </g>
              <path
                id="path4736"
                fill="#656565"
                stroke="none"
                d="M 234.314011 150.544586 L 244.638107 150.66925 L 244.636169 150.829865 L 234.312088 150.705231 Z"
              />
              <path
                id="path4737"
                fill="#656565"
                stroke="none"
                d="M 234.303574 151.409729 L 244.62767 151.534332 L 244.625717 151.694977 L 234.301651 151.570374 Z"
              />
              <path
                id="path4738"
                fill="#656565"
                stroke="none"
                d="M 234.293152 152.274841 L 244.617218 152.399475 L 244.61528 152.56012 L 234.291199 152.435455 Z"
              />
              <path
                id="path4739"
                fill="#656565"
                stroke="none"
                d="M 234.282684 153.139984 L 244.606781 153.264587 L 244.604843 153.425201 L 234.280762 153.300598 Z"
              />
              <path
                id="path4740"
                fill="#656565"
                stroke="none"
                d="M 234.272263 154.005066 L 244.596329 154.1297 L 244.594391 154.290344 L 234.270325 154.165741 Z"
              />
              <path
                id="path4741"
                fill="#656565"
                stroke="none"
                d="M 234.26181 154.870209 L 244.585892 154.994843 L 244.583954 155.155487 L 234.259872 155.030823 Z"
              />
              <path
                id="path4742"
                fill="#656565"
                stroke="none"
                d="M 234.251373 155.735352 L 244.575455 155.859955 L 244.573502 156.020569 L 234.249435 155.895966 Z"
              />
              <path
                id="path4743"
                fill="#656565"
                stroke="none"
                d="M 234.240936 156.600433 L 244.565002 156.725067 L 244.563065 156.885712 L 234.238983 156.761078 Z"
              />
              <path
                id="path4744"
                fill="#656565"
                stroke="none"
                d="M 234.230484 157.465576 L 244.554565 157.590179 L 244.552628 157.750824 L 234.228546 157.62619 Z"
              />
              <path
                id="path4745"
                fill="#656565"
                stroke="none"
                d="M 234.220047 158.330688 L 244.544113 158.455322 L 244.542175 158.615936 L 234.218109 158.491333 Z"
              />
              <path
                id="path4746"
                fill="#656565"
                stroke="none"
                d="M 234.209595 159.195801 L 244.533676 159.320404 L 244.531738 159.481079 L 234.207657 159.356445 Z"
              />
              <path
                id="path4747"
                fill="#656565"
                stroke="none"
                d="M 234.199158 160.060944 L 244.523239 160.185547 L 244.521286 160.346191 L 234.19722 160.221588 Z"
              />
              <path
                id="path4748"
                fill="#656565"
                stroke="none"
                d="M 234.188721 160.926056 L 244.512787 161.05069 L 244.510849 161.211304 L 234.186768 161.08667 Z"
              />
              <path
                id="path4749"
                fill="#656565"
                stroke="none"
                d="M 234.178268 161.791168 L 244.50235 161.915802 L 244.500412 162.076416 L 234.176331 161.951813 Z"
              />
              <path
                id="path4750"
                fill="#656565"
                stroke="none"
                d="M 234.167831 162.656281 L 244.491898 162.780914 L 244.48996 162.941559 L 234.165894 162.816925 Z"
              />
              <path
                id="path4751"
                fill="#656565"
                stroke="none"
                d="M 234.157379 163.521423 L 244.481461 163.646027 L 244.479523 163.806671 L 234.155441 163.682037 Z"
              />
              <path
                id="path4752"
                fill="#656565"
                stroke="none"
                d="M 234.146942 164.386505 L 244.471024 164.511169 L 244.46907 164.671783 L 234.145004 164.54718 Z"
              />
              <path
                id="path4753"
                fill="#656565"
                stroke="none"
                d="M 234.136505 165.251648 L 244.460571 165.376282 L 244.458633 165.536926 L 234.134552 165.412292 Z"
              />
              <path
                id="path4754"
                fill="#656565"
                stroke="none"
                d="M 234.126053 166.116791 L 244.450134 166.241394 L 244.448196 166.402008 L 234.124115 166.277405 Z"
              />
              <path
                id="path4755"
                fill="#656565"
                stroke="none"
                d="M 234.115616 166.981903 L 244.439682 167.106537 L 244.437744 167.267151 L 234.113678 167.142517 Z"
              />
              <path
                id="path4756"
                fill="#c9c9c9"
                stroke="none"
                d="M 235.562363 150.559692 L 236.108521 150.566254 L 236.106583 150.726898 L 235.560425 150.720306 Z"
              />
              <path
                id="path4757"
                fill="#c9c9c9"
                stroke="none"
                d="M 239.426727 150.606323 L 239.972885 150.612915 L 239.970932 150.773529 L 239.424789 150.766968 Z"
              />
              <path
                id="path4758"
                fill="#c9c9c9"
                stroke="none"
                d="M 237.757187 151.451416 L 238.303329 151.458008 L 238.301392 151.618652 L 237.755234 151.61203 Z"
              />
              <path
                id="path4759"
                fill="#c9c9c9"
                stroke="none"
                d="M 239.141891 152.337982 L 239.688049 152.344574 L 239.686111 152.505188 L 239.139954 152.498627 Z"
              />
              <path
                id="path4760"
                fill="#c9c9c9"
                stroke="none"
                d="M 236.373215 153.165222 L 236.919357 153.171783 L 236.917419 153.332428 L 236.371277 153.325836 Z"
              />
              <path
                id="path4761"
                fill="#c9c9c9"
                stroke="none"
                d="M 240.461182 154.079803 L 241.007339 154.086365 L 241.005417 154.247009 L 240.459259 154.240417 Z"
              />
              <path
                id="path4762"
                fill="#c9c9c9"
                stroke="none"
                d="M 241.621552 151.498047 L 242.167694 151.504669 L 242.165756 151.665314 L 241.619598 151.658691 Z"
              />
              <path
                id="path4763"
                fill="#c9c9c9"
                stroke="none"
                d="M 238.837555 154.925446 L 239.383698 154.932037 L 239.38176 155.092651 L 238.835602 155.08609 Z"
              />
              <path
                id="path4764"
                fill="#c9c9c9"
                stroke="none"
                d="M 241.032349 155.817169 L 241.578491 155.823792 L 241.576569 155.984375 L 241.030426 155.977814 Z"
              />
              <path
                id="path4765"
                fill="#c9c9c9"
                stroke="none"
                d="M 236.62413 155.763977 L 237.170288 155.770569 L 237.168335 155.931213 L 236.622192 155.924622 Z"
              />
              <path
                id="path4766"
                fill="#c9c9c9"
                stroke="none"
                d="M 240.030579 156.670349 L 240.576736 156.67691 L 240.574799 156.837555 L 240.028641 156.830963 Z"
              />
              <path
                id="path4767"
                fill="#c9c9c9"
                stroke="none"
                d="M 237.14711 157.500763 L 237.693268 157.507385 L 237.691315 157.66803 L 237.145172 157.661407 Z"
              />
              <path
                id="path4768"
                fill="#c9c9c9"
                stroke="none"
                d="M 242.774857 158.43396 L 243.321014 158.440552 L 243.319061 158.601196 L 242.772934 158.594574 Z"
              />
              <path
                id="path4769"
                fill="#c9c9c9"
                stroke="none"
                d="M 235.655304 159.213257 L 236.201447 159.219849 L 236.199493 159.380493 L 235.653351 159.373901 Z"
              />
              <path
                id="path4770"
                fill="#c9c9c9"
                stroke="none"
                d="M 242.359283 160.159424 L 242.905441 160.166046 L 242.903488 160.32666 L 242.357346 160.320038 Z"
              />
              <path
                id="path4771"
                fill="#c9c9c9"
                stroke="none"
                d="M 239.078827 160.985107 L 239.624969 160.991669 L 239.623032 161.152313 L 239.076889 161.145721 Z"
              />
              <path
                id="path4772"
                fill="#c9c9c9"
                stroke="none"
                d="M 241.230026 161.876282 L 241.776184 161.882874 L 241.774261 162.043518 L 241.228088 162.036926 Z"
              />
              <path
                id="path4773"
                fill="#c9c9c9"
                stroke="none"
                d="M 239.400894 163.584686 L 239.947037 163.591309 L 239.945099 163.751953 L 239.398941 163.745361 Z"
              />
              <path
                id="path4774"
                fill="#c9c9c9"
                stroke="none"
                d="M 241.737961 164.47818 L 242.284119 164.484772 L 242.282196 164.645386 L 241.736038 164.638794 Z"
              />
              <g id="g36">
                <path
                  id="path4775"
                  fill="#afafaf"
                  stroke="none"
                  d="M 239.28508 134.011139 L 239.675201 134.015839 L 239.658951 135.360596 L 239.268845 135.355896 Z"
                />
                <path
                  id="path4776"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 239.76239 134.016907 L 240.152496 134.021637 L 240.136261 135.366333 L 239.746155 135.361633 Z"
                />
                <path
                  id="path4777"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 244.138474 134.069733 L 244.52858 134.074463 L 244.51236 135.419159 L 244.122253 135.414459 Z"
                />
                <path
                  id="path4778"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 241.484299 136.628845 L 241.87442 136.633545 L 241.85817 137.978302 L 241.468063 137.973602 Z"
                />
                <path
                  id="path4779"
                  fill="#afafaf"
                  stroke="none"
                  d="M 241.963913 136.634644 L 242.354019 136.639343 L 242.337784 137.98407 L 241.947662 137.97937 Z"
                />
                <path
                  id="path4780"
                  fill="#999999"
                  stroke="none"
                  d="M 246.339996 136.687469 L 246.730103 136.692169 L 246.713867 138.036896 L 246.323761 138.032196 Z"
                />
                <path
                  id="path4781"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.5"
                  d="M 239.87619 139.609131 L 240.266312 139.613831 L 240.250076 140.958557 L 239.85997 140.953827 Z"
                />
                <path
                  id="path4782"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.5"
                  d="M 240.3535 139.614868 L 240.743607 139.619568 L 240.727371 140.964325 L 240.33728 140.959595 Z"
                />
                <path
                  id="path4783"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.5"
                  d="M 244.729584 139.667694 L 245.11969 139.672394 L 245.10347 141.017151 L 244.713364 141.012421 Z"
                />
                <path
                  id="path4784"
                  fill="#afafaf"
                  stroke="none"
                  opacity="0.5"
                  d="M 249.550858 139.725891 L 249.940964 139.730621 L 249.924744 141.075317 L 249.534622 141.070618 Z"
                />
                <path
                  id="path4785"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.9"
                  d="M 242.489609 142.328217 L 242.879715 142.332916 L 242.86348 143.677643 L 242.473373 143.672943 Z"
                />
                <path
                  id="path4786"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.7"
                  d="M 246.239227 145.035767 L 246.629333 145.040466 L 246.613083 146.385193 L 246.222992 146.380493 Z"
                />
                <path
                  id="path4787"
                  fill="#999999"
                  stroke="none"
                  opacity="0.7"
                  d="M 240.490875 144.96637 L 240.880981 144.971069 L 240.864746 146.315826 L 240.47464 146.311096 Z"
                />
                <path
                  id="path4788"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.5"
                  d="M 242.236084 147.170074 L 242.62619 147.174774 L 242.609955 148.519501 L 242.219833 148.514771 Z"
                />
                <path
                  id="path4789"
                  fill="#999999"
                  stroke="none"
                  opacity="0.5"
                  d="M 250.03363 147.264221 L 250.423752 147.268921 L 250.407516 148.613617 L 250.01741 148.608917 Z"
                />
                <path
                  id="path4790"
                  fill="#afafaf"
                  stroke="none"
                  opacity="0.7"
                  d="M 246.84964 145.043121 L 247.239731 145.047852 L 247.223495 146.392548 L 246.833389 146.387848 Z"
                />
                <path
                  id="path4791"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 248.457199 134.121857 L 248.847305 134.126587 L 248.83107 135.471313 L 248.440948 135.466614 Z"
                />
                <path
                  id="path4792"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 247.821548 134.114197 L 248.211655 134.118927 L 248.195419 135.463623 L 247.805313 135.458923 Z"
                />
              </g>
              <path
                id="path4793"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 253.074219 134.177612 L 253.58136 134.183716 L 253.56514 135.528473 L 253.057999 135.522339 Z"
              />
              <path
                id="path4794"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 254.033432 134.189178 L 254.540573 134.195313 L 254.524353 135.540039 L 254.017197 135.533936 Z"
              />
              <path
                id="path4795"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 256.354279 136.80835 L 256.86142 136.814453 L 256.845184 138.15918 L 256.338043 138.153076 Z"
              />
              <path
                id="path4796"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 257.311188 136.819916 L 257.818329 136.826019 L 257.802094 138.170746 L 257.294952 138.164612 Z"
              />
              <path
                id="path4797"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 259.194336 134.251465 L 259.701477 134.257599 L 259.685211 135.602325 L 259.178101 135.596222 Z"
              />
              <path
                id="path4798"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 263.127533 134.298981 L 263.634674 134.305084 L 263.618439 135.64978 L 263.111298 135.643677 Z"
              />
              <path
                id="path4799"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 261.166382 136.866425 L 261.673492 136.872528 L 261.657257 138.217285 L 261.150146 138.211151 Z"
              />
              <path
                id="path4800"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 253.398636 136.772675 L 253.905777 136.778809 L 253.889557 138.123535 L 253.382401 138.117371 Z"
              />
              <path
                id="path4801"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 252.857468 139.586792 L 253.364594 139.592926 L 253.348358 140.937653 L 252.841217 140.931519 Z"
              />
              <path
                id="path4802"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 255.810806 139.622467 L 256.317963 139.628571 L 256.301697 140.973267 L 255.794571 140.967163 Z"
              />
              <path
                id="path4803"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 261.639465 139.69281 L 262.146576 139.698944 L 262.130371 141.04364 L 261.62323 141.037506 Z"
              />
              <path
                id="path4804"
                fill="#000000"
                stroke="none"
                opacity="0.6"
                d="M 262.449524 139.702576 L 262.956635 139.708679 L 262.940399 141.053436 L 262.433289 141.047302 Z"
              />
              <path
                id="path4805"
                fill="#ffffff"
                stroke="none"
                d="M 265.402832 145.062836 L 254.250366 144.928192 L 253.300339 144.916718 L 253.291275 145.667114 L 253.247925 149.258423 L 254.197952 149.269867 L 254.241302 145.678589 L 265.393768 145.813232 L 265.350433 149.40448 L 266.300446 149.415955 L 266.343811 145.824677 L 266.352875 145.07428 L 265.402832 145.062836 Z"
              />
              <g id="g37" opacity="0.6">
                <path
                  id="path4806"
                  fill="#999999"
                  stroke="none"
                  d="M 253.229645 150.772949 L 255.327057 150.798248 L 255.321594 151.250336 L 253.224182 151.225006 Z"
                />
                <path
                  id="path4807"
                  fill="#999999"
                  stroke="none"
                  d="M 256.361969 150.81076 L 256.814056 150.816223 L 256.808594 151.26825 L 256.356506 151.262787 Z"
                />
                <path
                  id="path4808"
                  fill="#999999"
                  stroke="none"
                  d="M 257.415253 150.823456 L 257.679169 150.82666 L 257.673706 151.278717 L 257.409821 151.275543 Z"
                />
                <path
                  id="path4809"
                  fill="#999999"
                  stroke="none"
                  d="M 256.59726 153.184387 L 258.694641 153.209747 L 258.689209 153.661774 L 256.591797 153.636475 Z"
                />
                <path
                  id="path4810"
                  fill="#999999"
                  stroke="none"
                  d="M 254.87619 153.163635 L 255.328262 153.169067 L 255.322815 153.621155 L 254.870743 153.615692 Z"
                />
                <path
                  id="path4811"
                  fill="#999999"
                  stroke="none"
                  d="M 255.929489 153.176361 L 256.19339 153.179535 L 256.187927 153.631592 L 255.924026 153.628418 Z"
                />
                <path
                  id="path4812"
                  fill="#999999"
                  stroke="none"
                  d="M 256.529968 158.758362 L 258.62738 158.783691 L 258.621918 159.235748 L 256.524536 159.210419 Z"
                />
                <path
                  id="path4813"
                  fill="#999999"
                  stroke="none"
                  d="M 254.808914 158.737579 L 255.260971 158.743042 L 255.255524 159.195129 L 254.803452 159.189667 Z"
                />
                <path
                  id="path4814"
                  fill="#999999"
                  stroke="none"
                  d="M 255.862213 158.750305 L 256.126099 158.753479 L 256.120636 159.205536 L 255.85675 159.202362 Z"
                />
                <path
                  id="path4815"
                  fill="#999999"
                  stroke="none"
                  d="M 256.434448 166.672943 L 258.53183 166.698273 L 258.526398 167.15033 L 256.428986 167.125031 Z"
                />
                <path
                  id="path4816"
                  fill="#999999"
                  stroke="none"
                  d="M 254.713379 166.652161 L 255.165451 166.657623 L 255.159988 167.109711 L 254.707916 167.104248 Z"
                />
                <path
                  id="path4817"
                  fill="#999999"
                  stroke="none"
                  d="M 255.766663 166.664886 L 256.030548 166.66806 L 256.025116 167.120117 L 255.7612 167.116943 Z"
                />
                <path
                  id="path4818"
                  fill="#999999"
                  stroke="none"
                  d="M 260.587097 158.807343 L 262.684479 158.832642 L 262.679016 159.284729 L 260.581635 159.259399 Z"
                />
                <path
                  id="path4819"
                  fill="#999999"
                  stroke="none"
                  d="M 258.866028 158.78656 L 259.318115 158.792023 L 259.312653 159.24408 L 258.860565 159.238617 Z"
                />
                <path
                  id="path4820"
                  fill="#999999"
                  stroke="none"
                  d="M 259.919312 158.799255 L 260.183228 158.802429 L 260.177765 159.254517 L 259.913849 159.251343 Z"
                />
                <path
                  id="path4821"
                  fill="#999999"
                  stroke="none"
                  d="M 261.47699 150.872498 L 261.929047 150.87793 L 261.923584 151.330017 L 261.471527 151.324554 Z"
                />
                <path
                  id="path4822"
                  fill="#999999"
                  stroke="none"
                  d="M 262.530273 150.885223 L 262.794159 150.888397 L 262.788696 151.340454 L 262.524811 151.33725 Z"
                />
                <path
                  id="path4823"
                  fill="#999999"
                  stroke="none"
                  d="M 261.448364 153.242981 L 261.900421 153.248444 L 261.894958 153.7005 L 261.442902 153.695038 Z"
                />
                <path
                  id="path4824"
                  fill="#999999"
                  stroke="none"
                  d="M 262.501648 153.255676 L 262.765564 153.25885 L 262.760101 153.710938 L 262.496185 153.707733 Z"
                />
                <path
                  id="path4825"
                  fill="#999999"
                  stroke="none"
                  d="M 263.503235 150.896942 L 263.955292 150.902405 L 263.949829 151.354462 L 263.497772 151.348999 Z"
                />
                <path
                  id="path4826"
                  fill="#999999"
                  stroke="none"
                  d="M 264.556519 150.909668 L 264.820435 150.912872 L 264.814972 151.364899 L 264.551056 151.361725 Z"
                />
                <path
                  id="path4827"
                  fill="#999999"
                  stroke="none"
                  d="M 253.174728 155.511627 L 253.626801 155.51709 L 253.621338 155.969147 L 253.169281 155.963684 Z"
                />
                <path
                  id="path4828"
                  fill="#999999"
                  stroke="none"
                  d="M 254.228027 155.524323 L 254.491913 155.527496 L 254.486465 155.979584 L 254.22258 155.97641 Z"
                />
                <path
                  id="path4829"
                  fill="#999999"
                  stroke="none"
                  d="M 255.201004 155.536072 L 255.653076 155.541534 L 255.647614 155.993622 L 255.195541 155.988159 Z"
                />
                <path
                  id="path4830"
                  fill="#999999"
                  stroke="none"
                  d="M 256.254303 155.548798 L 256.518188 155.551971 L 256.512726 156.004028 L 256.24884 156.000854 Z"
                />
                <path
                  id="path4831"
                  fill="#999999"
                  stroke="none"
                  d="M 260.586761 155.601105 L 261.038849 155.606567 L 261.033386 156.058624 L 260.581329 156.053162 Z"
                />
                <path
                  id="path4832"
                  fill="#999999"
                  stroke="none"
                  d="M 261.640045 155.6138 L 261.903961 155.616974 L 261.898499 156.069061 L 261.634613 156.065857 Z"
                />
                <path
                  id="path4833"
                  fill="#999999"
                  stroke="none"
                  d="M 262.613037 155.625549 L 263.065125 155.631012 L 263.059662 156.083069 L 262.607574 156.077606 Z"
                />
                <path
                  id="path4834"
                  fill="#999999"
                  stroke="none"
                  d="M 263.666351 155.638245 L 263.930206 155.641449 L 263.924744 156.093506 L 263.660889 156.090332 Z"
                />
                <path
                  id="path4835"
                  fill="#999999"
                  stroke="none"
                  d="M 254.381668 161.619629 L 254.83374 161.625092 L 254.828278 162.077148 L 254.376205 162.071686 Z"
                />
                <path
                  id="path4836"
                  fill="#999999"
                  stroke="none"
                  d="M 255.434952 161.632324 L 255.698853 161.635559 L 255.69339 162.087585 L 255.429489 162.084412 Z"
                />
                <path
                  id="path4837"
                  fill="#999999"
                  stroke="none"
                  d="M 256.407928 161.644073 L 256.859985 161.649536 L 256.854523 162.101624 L 256.402496 162.096161 Z"
                />
                <path
                  id="path4838"
                  fill="#999999"
                  stroke="none"
                  d="M 257.461212 161.65683 L 257.725098 161.660004 L 257.719635 162.112091 L 257.45578 162.108856 Z"
                />
                <path
                  id="path4839"
                  fill="#999999"
                  stroke="none"
                  d="M 261.373779 161.704041 L 261.637665 161.707214 L 261.632233 162.159271 L 261.368317 162.156097 Z"
                />
                <path
                  id="path4840"
                  fill="#999999"
                  stroke="none"
                  d="M 262.307709 161.715302 L 262.571625 161.718506 L 262.566162 162.170563 L 262.302246 162.167389 Z"
                />
                <path
                  id="path4841"
                  fill="#999999"
                  stroke="none"
                  d="M 257.890198 164.526245 L 258.154083 164.529449 L 258.148621 164.981506 L 257.884735 164.978333 Z"
                />
                <path
                  id="path4842"
                  fill="#999999"
                  stroke="none"
                  d="M 258.863159 164.537994 L 259.315247 164.543457 L 259.309784 164.995514 L 258.857727 164.990082 Z"
                />
                <path
                  id="path4843"
                  fill="#999999"
                  stroke="none"
                  d="M 259.916443 164.55072 L 260.180328 164.553894 L 260.174896 165.005981 L 259.91098 165.002777 Z"
                />
                <path
                  id="path4844"
                  fill="#999999"
                  stroke="none"
                  d="M 260.301117 166.719604 L 260.564972 166.722809 L 260.559509 167.174866 L 260.295654 167.171692 Z"
                />
                <path
                  id="path4845"
                  fill="#999999"
                  stroke="none"
                  d="M 261.271759 166.731323 L 261.723846 166.736786 L 261.718384 167.188873 L 261.266296 167.183411 Z"
                />
                <path
                  id="path4846"
                  fill="#999999"
                  stroke="none"
                  d="M 262.325073 166.744049 L 262.588959 166.747223 L 262.583496 167.19931 L 262.319611 167.196106 Z"
                />
                <path
                  id="path4847"
                  fill="#999999"
                  stroke="none"
                  d="M 255.685867 168.60556 L 255.949753 168.608734 L 255.944305 169.060791 L 255.680405 169.057617 Z"
                />
                <path
                  id="path4848"
                  fill="#999999"
                  stroke="none"
                  d="M 256.658844 168.617279 L 257.110901 168.622742 L 257.105438 169.074829 L 256.653381 169.069366 Z"
                />
                <path
                  id="path4849"
                  fill="#999999"
                  stroke="none"
                  d="M 257.712128 168.630005 L 257.976013 168.633209 L 257.970581 169.085236 L 257.706665 169.082062 Z"
                />
                <path
                  id="path4850"
                  fill="#999999"
                  stroke="none"
                  d="M 263.826721 164.597931 L 264.090607 164.601105 L 264.085144 165.053162 L 263.821259 165.049988 Z"
                />
                <path
                  id="path4851"
                  fill="#999999"
                  stroke="none"
                  d="M 264.760681 164.609192 L 265.024536 164.612366 L 265.019104 165.064423 L 264.755219 165.061249 Z"
                />
              </g>
              <path
                id="path4852"
                fill="#4f4f4f"
                stroke="none"
                opacity="0.5"
                d="M 267.651642 148.897522 L 268.787537 148.911224 L 268.773834 150.047119 L 267.637909 150.033417 Z"
              />
              <path
                id="path4853"
                fill="#4f4f4f"
                stroke="none"
                opacity="0.5"
                d="M 270.072601 148.926727 L 271.208496 148.94046 L 271.194763 150.076355 L 270.058899 150.062653 Z"
              />
              <path
                id="path4854"
                fill="#4f4f4f"
                stroke="none"
                opacity="0.5"
                d="M 271.197052 151.409821 L 272.332947 151.423523 L 272.319244 152.559448 L 271.183319 152.545715 Z"
              />
              <path
                id="path4855"
                fill="#4f4f4f"
                stroke="none"
                opacity="0.5"
                d="M 268.807098 153.94458 L 269.943024 153.958313 L 269.929291 155.094177 L 268.793427 155.080475 Z"
              />
              <path
                id="path4856"
                fill="#4f4f4f"
                stroke="none"
                opacity="0.5"
                d="M 271.107635 158.817261 L 272.24353 158.830994 L 272.229828 159.966858 L 271.093933 159.953186 Z"
              />
              <path
                id="path4857"
                fill="#4f4f4f"
                stroke="none"
                opacity="0.5"
                d="M 268.719208 161.2258 L 269.855103 161.239532 L 269.8414 162.375458 L 268.705536 162.361725 Z"
              />
              <g id="g38">
                <linearGradient
                  id="linearGradient20"
                  x1="295.326813"
                  y1="154.13388"
                  x2="296.0042"
                  y2="124.064984"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                  <stop offset={1} stopColor="#666666" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4858"
                  fill="url(#linearGradient20)"
                  stroke="none"
                  opacity="0.7"
                  d="M 291.52179 108.482361 L 300.491974 108.590607 L 299.693939 174.704651 L 290.723755 174.596344 Z"
                />
                <path
                  id="path4859"
                  fill="#ffffff"
                  stroke="none"
                  d="M 282.551636 108.374054 L 291.52179 108.482361 L 290.723755 174.596344 L 281.753571 174.488098 Z"
                />
                <path
                  id="path4860"
                  fill="#363636"
                  stroke="none"
                  d="M 298.315094 119.904327 L 304.070313 119.973816 L 303.409149 174.747192 L 297.653931 174.677734 Z"
                />
                <path
                  id="path4861"
                  fill="#b3b3b3"
                  stroke="none"
                  d="M 304.070313 119.973816 L 298.315094 119.904358 L 295.933807 114.686401 L 301.686737 114.75589 L 304.070313 119.973816 Z"
                />
                <linearGradient
                  id="linearGradient21"
                  x1="296.378597"
                  y1="178.988562"
                  x2="297.268954"
                  y2="105.228433"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#b3b3b3" stopOpacity={1} />
                  <stop offset="0.12" stopColor="#b8b8b8" stopOpacity={1} />
                  <stop offset="0.28" stopColor="#c7c7c7" stopOpacity={1} />
                  <stop offset="0.44" stopColor="#dfdfdf" stopOpacity={1} />
                  <stop offset="0.54" stopColor="#f2f2f2" stopOpacity={1} />
                  <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4862"
                  fill="url(#linearGradient21)"
                  stroke="none"
                  d="M 297.65387 174.680023 L 298.315094 119.904358 L 295.933807 114.686401 L 295.209991 174.650513 L 297.65387 174.680023 Z"
                />
                <path
                  id="path4863"
                  fill="#ffffff"
                  stroke="none"
                  d="M 279.96167 119.682831 L 285.716919 119.752289 L 285.055756 174.525635 L 279.300537 174.456177 Z"
                />
                <path
                  id="path4864"
                  fill="#e6e6e6"
                  stroke="none"
                  d="M 279.96167 119.682831 L 285.7146 119.752258 L 288.22345 114.593353 L 282.468231 114.523865 L 279.96167 119.682831 Z"
                />
                <path
                  id="path4865"
                  fill="#666666"
                  stroke="none"
                  opacity="0.6"
                  d="M 287.499634 174.557465 L 288.22345 114.593353 L 285.7146 119.752258 L 285.053436 174.527924 L 287.499634 174.557465 Z"
                />
                <g id="g39" opacity="0.5">
                  <path
                    id="path4866"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.80954 132.097351 L 303.918152 132.388397 L 303.917206 132.468689 L 279.808533 132.177673 Z"
                  />
                  <path
                    id="path4867"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.783447 134.259033 L 303.892059 134.550049 L 303.891083 134.630341 L 279.782471 134.339355 Z"
                  />
                  <path
                    id="path4868"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.757294 136.422974 L 303.865967 136.713989 L 303.86496 136.794312 L 279.756348 136.503296 Z"
                  />
                  <path
                    id="path4869"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.731201 138.584625 L 303.839844 138.875641 L 303.838898 138.955963 L 279.730255 138.664978 Z"
                  />
                  <path
                    id="path4870"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.705109 140.748566 L 303.813721 141.039612 L 303.812775 141.119904 L 279.704102 140.828888 Z"
                  />
                  <path
                    id="path4871"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.679016 142.910217 L 303.787628 143.201233 L 303.786652 143.281555 L 279.67804 142.99054 Z"
                  />
                  <path
                    id="path4872"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.652924 145.071899 L 303.761566 145.362885 L 303.760559 145.443207 L 279.651947 145.152222 Z"
                  />
                  <path
                    id="path4873"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.62677 147.23584 L 303.735413 147.526855 L 303.734467 147.607178 L 279.625824 147.316132 Z"
                  />
                  <path
                    id="path4874"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.600708 149.397491 L 303.70932 149.688507 L 303.708374 149.768799 L 279.599731 149.477814 Z"
                  />
                  <path
                    id="path4875"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.574615 151.559143 L 303.683228 151.850128 L 303.682281 151.93045 L 279.573608 151.639465 Z"
                  />
                  <path
                    id="path4876"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.548492 153.723083 L 303.657135 154.014099 L 303.656128 154.094421 L 279.547516 153.803406 Z"
                  />
                  <path
                    id="path4877"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.522369 155.884766 L 303.631042 156.175751 L 303.630066 156.256073 L 279.521423 155.965057 Z"
                  />
                  <path
                    id="path4878"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.496277 158.048676 L 303.604889 158.339722 L 303.603943 158.420013 L 279.4953 158.128998 Z"
                  />
                  <path
                    id="path4879"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.470184 160.210358 L 303.578796 160.501343 L 303.57785 160.581665 L 279.469177 160.29068 Z"
                  />
                  <path
                    id="path4880"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.444092 162.372009 L 303.552704 162.663025 L 303.551727 162.743347 L 279.443115 162.452332 Z"
                  />
                  <path
                    id="path4881"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.417938 164.53598 L 303.526611 164.826965 L 303.525635 164.907288 L 279.416992 164.616272 Z"
                  />
                  <path
                    id="path4882"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.391846 166.697601 L 303.500488 166.988617 L 303.499542 167.068909 L 279.3909 166.777924 Z"
                  />
                  <path
                    id="path4883"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.365784 168.859253 L 303.474396 169.150269 L 303.47345 169.230591 L 279.364807 168.939575 Z"
                  />
                  <path
                    id="path4884"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.339661 171.023224 L 303.448273 171.314209 L 303.447327 171.394531 L 279.338684 171.103546 Z"
                  />
                  <path
                    id="path4885"
                    fill="#4f4f4f"
                    stroke="none"
                    d="M 279.313568 173.184875 L 303.422211 173.475891 L 303.421204 173.556213 L 279.312592 173.265167 Z"
                  />
                </g>
                <path
                  id="path4886"
                  fill="#d9d9d9"
                  stroke="none"
                  d="M 282.551636 108.374054 L 291.52179 108.482361 L 291.514648 109.074371 L 282.544495 108.966125 Z"
                />
                <path
                  id="path4887"
                  fill="#9f9f9f"
                  stroke="none"
                  d="M 291.52179 108.482361 L 300.491974 108.590607 L 300.484833 109.182648 L 291.514648 109.074371 Z"
                />
                <linearGradient
                  id="linearGradient22"
                  x1="280.774104"
                  y1="135.276233"
                  x2="280.949499"
                  y2="120.74588"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.22" stopColor="#7b7b7b" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#4f4f4f" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4888"
                  fill="url(#linearGradient22)"
                  stroke="none"
                  opacity="0.6"
                  d="M 280.345703 121.52121 L 281.529816 121.535522 L 281.413361 131.182648 L 280.229279 131.168365 Z"
                />
                <linearGradient
                  id="linearGradient23"
                  x1="282.488282"
                  y1="135.296924"
                  x2="282.663677"
                  y2="120.766571"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.22" stopColor="#7b7b7b" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#4f4f4f" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4889"
                  fill="url(#linearGradient23)"
                  stroke="none"
                  opacity="0.6"
                  d="M 282.062195 121.541931 L 283.246277 121.556213 L 283.129822 131.203339 L 281.94574 131.189056 Z"
                />
                <linearGradient
                  id="linearGradient24"
                  x1="284.223112"
                  y1="135.317866"
                  x2="284.398508"
                  y2="120.787512"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.22" stopColor="#7b7b7b" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#4f4f4f" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4890"
                  fill="url(#linearGradient24)"
                  stroke="none"
                  opacity="0.6"
                  d="M 283.797028 121.562866 L 284.981079 121.577148 L 284.864655 131.224304 L 283.680573 131.209991 Z"
                />
                <linearGradient
                  id="linearGradient25"
                  x1="299.278963"
                  y1="135.499604"
                  x2="299.454358"
                  y2="120.969251"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.17" stopColor="#afafaf" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4891"
                  fill="url(#linearGradient25)"
                  stroke="none"
                  opacity="0.6"
                  d="M 298.852875 121.744629 L 300.036957 121.758911 L 299.920532 131.406036 L 298.73642 131.391724 Z"
                />
                <linearGradient
                  id="linearGradient26"
                  x1="300.995435"
                  y1="135.520324"
                  x2="301.170831"
                  y2="120.989971"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.17" stopColor="#afafaf" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4892"
                  fill="url(#linearGradient26)"
                  stroke="none"
                  opacity="0.6"
                  d="M 300.567047 121.76532 L 301.75116 121.779602 L 301.634674 131.426727 L 300.450592 131.412445 Z"
                />
                <linearGradient
                  id="linearGradient27"
                  x1="302.730266"
                  y1="135.541265"
                  x2="302.905661"
                  y2="121.010912"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.17" stopColor="#afafaf" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4893"
                  fill="url(#linearGradient27)"
                  stroke="none"
                  opacity="0.6"
                  d="M 302.304169 121.786285 L 303.488251 121.800568 L 303.371826 131.447693 L 302.187714 131.433411 Z"
                />
                <path
                  id="path4894"
                  fill="#808080"
                  stroke="none"
                  d="M 281.759155 133.908783 L 282.771118 133.92099 L 282.765656 134.373077 L 281.753693 134.36087 Z"
                />
                <path
                  id="path4895"
                  fill="#999999"
                  stroke="none"
                  d="M 281.734314 135.967194 L 282.746277 135.979401 L 282.740814 136.431427 L 281.728851 136.41922 Z"
                />
                <path
                  id="path4896"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 296.512451 126.072418 L 297.524414 126.084656 L 297.518951 126.536713 L 296.506989 126.524506 Z"
                />
                <path
                  id="path4897"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 296.487579 128.133118 L 297.499542 128.145325 L 297.49408 128.597412 L 296.482117 128.585205 Z"
                />
                <path
                  id="path4898"
                  fill="#afafaf"
                  stroke="none"
                  d="M 281.68222 140.2836 L 282.694183 140.295807 L 282.688721 140.747894 L 281.676758 140.735657 Z"
                />
                <path
                  id="path4899"
                  fill="#afafaf"
                  stroke="none"
                  d="M 281.655426 142.502625 L 282.667389 142.514832 L 282.661926 142.966888 L 281.649963 142.954681 Z"
                />
                <path
                  id="path4900"
                  fill="#f8f8f8"
                  stroke="none"
                  d="M 281.882874 123.658112 L 282.894867 123.670349 L 282.889404 124.122406 L 281.877441 124.110199 Z"
                />
                <path
                  id="path4901"
                  fill="#afafaf"
                  stroke="none"
                  d="M 281.70166 138.67038 L 282.713623 138.682587 L 282.708191 139.134674 L 281.696198 139.122437 Z"
                />
                <path
                  id="path4902"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 281.596008 147.422546 L 282.608002 147.434753 L 282.602539 147.886841 L 281.590546 147.874634 Z"
                />
                <path
                  id="path4903"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 281.569244 149.641602 L 282.581207 149.653809 L 282.575745 150.105835 L 281.563782 150.093628 Z"
                />
                <path
                  id="path4904"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 281.542419 151.862915 L 282.554382 151.875122 L 282.54892 152.327179 L 281.536957 152.314972 Z"
                />
                <path
                  id="path4905"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 288.932312 147.511108 L 289.944305 147.523346 L 289.938873 147.975403 L 288.926849 147.963196 Z"
                />
                <path
                  id="path4906"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 288.905548 149.730133 L 289.917511 149.74234 L 289.912079 150.194427 L 288.900085 150.18219 Z"
                />
                <path
                  id="path4907"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 288.878723 151.951447 L 289.890686 151.963654 L 289.885223 152.41571 L 288.87326 152.403503 Z"
                />
                <path
                  id="path4908"
                  fill="#c9c9c9"
                  stroke="none"
                  d="M 280.22583 127.840424 L 281.237793 127.852631 L 281.23233 128.304718 L 280.220367 128.29248 Z"
                />
                <g id="g40" opacity="0.5">
                  <path
                    id="path4909"
                    fill="#191919"
                    stroke="none"
                    d="M 301.002899 134.141052 L 302.014893 134.15329 L 302.00943 134.605347 L 300.997467 134.59314 Z"
                  />
                  <path
                    id="path4910"
                    fill="#191919"
                    stroke="none"
                    d="M 300.978058 136.199463 L 301.990051 136.21167 L 301.984589 136.663757 L 300.972626 136.65152 Z"
                  />
                  <path
                    id="path4911"
                    fill="#191919"
                    stroke="none"
                    d="M 300.421082 140.509796 L 301.433105 140.522003 L 301.427643 140.97406 L 300.415649 140.961853 Z"
                  />
                  <path
                    id="path4912"
                    fill="#191919"
                    stroke="none"
                    d="M 300.394348 142.728821 L 301.406311 142.741028 L 301.400848 143.193115 L 300.388885 143.180878 Z"
                  />
                  <path
                    id="path4913"
                    fill="#191919"
                    stroke="none"
                    d="M 300.367523 144.950134 L 301.379486 144.962341 L 301.374023 145.414398 L 300.362061 145.402191 Z"
                  />
                  <path
                    id="path4914"
                    fill="#191919"
                    stroke="none"
                    d="M 300.149719 164.32489 L 301.161682 164.337097 L 301.156219 164.789185 L 300.144257 164.776947 Z"
                  />
                  <path
                    id="path4915"
                    fill="#191919"
                    stroke="none"
                    d="M 300.122894 166.546204 L 301.134857 166.558411 L 301.129395 167.010498 L 300.117432 166.99826 Z"
                  />
                  <path
                    id="path4916"
                    fill="#191919"
                    stroke="none"
                    d="M 300.0961 168.765259 L 301.108063 168.777466 L 301.1026 169.229492 L 300.090637 169.217285 Z"
                  />
                  <path
                    id="path4917"
                    fill="#191919"
                    stroke="none"
                    d="M 299.30249 153.516296 L 300.314453 153.528503 L 300.30899 153.980591 L 299.297028 153.968353 Z"
                  />
                  <path
                    id="path4918"
                    fill="#191919"
                    stroke="none"
                    d="M 302.235138 153.551697 L 303.247162 153.563904 L 303.241699 154.015991 L 302.229706 154.003754 Z"
                  />
                </g>
                <path
                  id="path4919"
                  fill="#cccccc"
                  stroke="none"
                  d="M 280.452515 132.447113 L 281.469086 132.459381 L 281.466827 132.647552 L 280.450226 132.635284 Z"
                />
                <path
                  id="path4920"
                  fill="#cccccc"
                  stroke="none"
                  d="M 283.607819 132.485168 L 284.624359 132.497437 L 284.622101 132.685638 L 283.60553 132.67337 Z"
                />
                <path
                  id="path4921"
                  fill="#afafaf"
                  stroke="none"
                  d="M 280.29538 145.462921 L 281.311981 145.475189 L 281.309723 145.66333 L 280.293152 145.651093 Z"
                />
                <path
                  id="path4922"
                  fill="#afafaf"
                  stroke="none"
                  d="M 283.450684 145.501038 L 284.467255 145.513275 L 284.464996 145.701447 L 283.448395 145.689178 Z"
                />
                <path
                  id="path4923"
                  fill="#999999"
                  stroke="none"
                  d="M 292.320313 143.48053 L 293.336914 143.492798 L 293.334625 143.680969 L 292.318054 143.668701 Z"
                />
                <path
                  id="path4924"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 292.965759 132.598145 L 293.98233 132.610413 L 293.980103 132.798584 L 292.963531 132.786316 Z"
                />
                <g id="g41" opacity="0.5">
                  <path
                    id="path4925"
                    fill="#363636"
                    stroke="none"
                    d="M 282.632507 109.84848 L 284.190643 109.867279 L 284.174744 111.184448 L 282.616608 111.16568 Z"
                  />
                  <path
                    id="path4926"
                    fill="#363636"
                    stroke="none"
                    d="M 282.604309 112.186829 L 284.162445 112.205627 L 284.146515 113.522797 L 282.588379 113.504028 Z"
                  />
                  <path
                    id="path4927"
                    fill="#363636"
                    stroke="none"
                    d="M 284.376526 109.869537 L 285.934662 109.888336 L 285.918762 111.205536 L 284.360626 111.186707 Z"
                  />
                  <path
                    id="path4928"
                    fill="#363636"
                    stroke="none"
                    d="M 284.348297 112.207886 L 285.906433 112.226685 L 285.890564 113.543884 L 284.332397 113.525055 Z"
                  />
                  <path
                    id="path4929"
                    fill="#363636"
                    stroke="none"
                    d="M 286.200867 109.891541 L 287.758972 109.91037 L 287.743073 111.22757 L 286.184937 111.20874 Z"
                  />
                  <path
                    id="path4930"
                    fill="#363636"
                    stroke="none"
                    d="M 286.172607 112.229919 L 287.730774 112.248718 L 287.714874 113.565918 L 286.156738 113.547089 Z"
                  />
                  <path
                    id="path4931"
                    fill="#363636"
                    stroke="none"
                    d="M 288.025177 109.913574 L 289.583313 109.932373 L 289.567413 111.249573 L 288.009277 111.230774 Z"
                  />
                  <path
                    id="path4932"
                    fill="#363636"
                    stroke="none"
                    d="M 287.996948 112.251923 L 289.555084 112.270721 L 289.539185 113.587921 L 287.981049 113.569122 Z"
                  />
                  <path
                    id="path4933"
                    fill="#363636"
                    stroke="none"
                    d="M 289.849518 109.935577 L 291.407654 109.954407 L 291.391724 111.271576 L 289.833588 111.252777 Z"
                  />
                  <path
                    id="path4934"
                    fill="#363636"
                    stroke="none"
                    d="M 289.821289 112.273926 L 291.379425 112.292755 L 291.363525 113.609924 L 289.805389 113.591125 Z"
                  />
                </g>
                <g id="g42">
                  <path
                    id="path4935"
                    fill="#363636"
                    stroke="none"
                    d="M 291.602661 109.956757 L 293.160828 109.975586 L 293.144928 111.292755 L 291.586792 111.273926 Z"
                  />
                  <path
                    id="path4936"
                    fill="#363636"
                    stroke="none"
                    d="M 291.574463 112.295105 L 293.132629 112.313934 L 293.116699 113.631104 L 291.558533 113.612274 Z"
                  />
                  <path
                    id="path4937"
                    fill="#363636"
                    stroke="none"
                    d="M 293.34671 109.977814 L 294.904816 109.996613 L 294.888916 111.313812 L 293.33078 111.295013 Z"
                  />
                  <path
                    id="path4938"
                    fill="#363636"
                    stroke="none"
                    d="M 293.318481 112.316162 L 294.876617 112.334961 L 294.860718 113.652161 L 293.302582 113.633362 Z"
                  />
                  <path
                    id="path4939"
                    fill="#363636"
                    stroke="none"
                    d="M 295.171051 109.999817 L 296.729187 110.018646 L 296.713257 111.335815 L 295.155121 111.317017 Z"
                  />
                  <path
                    id="path4940"
                    fill="#363636"
                    stroke="none"
                    d="M 295.142792 112.338165 L 296.700928 112.356995 L 296.685059 113.674164 L 295.126923 113.655365 Z"
                  />
                  <path
                    id="path4941"
                    fill="#363636"
                    stroke="none"
                    d="M 296.995361 110.021851 L 298.553497 110.04068 L 298.537598 111.357849 L 296.979431 111.33905 Z"
                  />
                  <path
                    id="path4942"
                    fill="#363636"
                    stroke="none"
                    d="M 296.967102 112.360199 L 298.525269 112.379028 L 298.509369 113.696198 L 296.951233 113.677399 Z"
                  />
                  <path
                    id="path4943"
                    fill="#363636"
                    stroke="none"
                    d="M 298.819672 110.043884 L 300.377838 110.062683 L 300.361908 111.379852 L 298.803802 111.361053 Z"
                  />
                  <path
                    id="path4944"
                    fill="#363636"
                    stroke="none"
                    d="M 298.791443 112.382233 L 300.349579 112.401031 L 300.33371 113.718201 L 298.775543 113.699402 Z"
                  />
                </g>
              </g>
              <linearGradient
                id="linearGradient28"
                x1="294.07462"
                y1="177.443701"
                x2="294.147572"
                y2="158.471124"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                <stop offset={1} stopColor="#666666" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4945"
                fill="url(#linearGradient28)"
                stroke="none"
                d="M 289.612885 161.861298 L 298.752838 161.971619 L 298.607971 173.975464 L 289.467987 173.865143 Z"
              />
              <linearGradient
                id="linearGradient29"
                x1="281.028091"
                y1="179.45048"
                x2="281.081657"
                y2="161.893736"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.22" stopColor="#7b7b7b" stopOpacity={1} />
                <stop offset="0.7" stopColor="#4f4f4f" stopOpacity={1} />
                <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4946"
                fill="url(#linearGradient29)"
                stroke="none"
                d="M 269.489227 164.934784 L 292.732727 165.215363 L 292.626495 174.015717 L 269.382965 173.735168 Z"
              />
              <path
                id="path4947"
                fill="#363636"
                stroke="none"
                d="M 265.427521 164.885773 L 269.489227 164.934784 L 269.385254 173.546967 L 265.323547 173.497955 Z"
              />
              <path
                id="path4948"
                fill="#484848"
                stroke="none"
                d="M 265.438873 163.944916 L 292.74408 164.274506 L 292.732727 165.215363 L 265.427521 164.885773 Z"
              />
              <linearGradient
                id="linearGradient30"
                x1="273.444144"
                y1="164.512038"
                x2="292.738397"
                y2="164.744938"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.01" stopColor="#e8e8e8" stopOpacity={1} />
                <stop offset={1} stopColor="#666666" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4949"
                fill="url(#linearGradient30)"
                stroke="none"
                d="M 273.449799 164.041595 L 292.74408 164.274506 L 292.732727 165.215363 L 273.438446 164.982452 Z"
              />
              <linearGradient
                id="linearGradient31"
                x1="300.948747"
                y1="177.604711"
                x2="301.641929"
                y2="159.346507"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.22" stopColor="#7b7b7b" stopOpacity={1} />
                <stop offset="0.7" stopColor="#4f4f4f" stopOpacity={1} />
                <stop offset="0.91" stopColor="#4f4f4f" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4950"
                fill="url(#linearGradient31)"
                stroke="none"
                d="M 298.752838 161.971619 L 304.012421 162.035126 L 303.86615 174.151398 L 298.606598 174.087891 Z"
              />
              <linearGradient
                id="linearGradient32"
                x1="284.497364"
                y1="175.912027"
                x2="284.563373"
                y2="170.443639"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.26" stopColor="#c9c9c9" stopOpacity={1} />
                <stop offset="0.42" stopColor="#cfcfcf" stopOpacity={1} />
                <stop offset="0.57" stopColor="#d9d9d9" stopOpacity={1} />
                <stop offset="0.62" stopColor="#d3d3d3" stopOpacity={1} />
                <stop offset="0.69" stopColor="#c4c4c4" stopOpacity={1} />
                <stop offset="0.76" stopColor="#ababab" stopOpacity={1} />
                <stop offset="0.83" stopColor="#898989" stopOpacity={1} />
                <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4951"
                fill="url(#linearGradient32)"
                stroke="none"
                d="M 283.353638 171.223145 L 285.753937 171.252106 L 285.721588 173.932373 L 283.321289 173.903381 Z"
              />
              <path
                id="path4952"
                fill="#1d1d1d"
                stroke="none"
                d="M 303.576508 173.239044 L 303.877136 173.242676 L 303.86496 174.250092 L 303.564392 174.24646 Z"
              />
              <linearGradient
                id="linearGradient33"
                x1="287.076244"
                y1="171.224465"
                x2="281.34338"
                y2="168.731655"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#4c4c4c" stopOpacity={1} />
                <stop offset="0.81" stopColor="#d9d9d9" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4953"
                fill="url(#linearGradient33)"
                stroke="none"
                d="M 283.370758 169.804962 L 285.771057 169.833954 L 285.763458 170.465027 L 283.363129 170.436035 Z"
              />
              <linearGradient
                id="linearGradient34"
                x1="289.610798"
                y1="162.033413"
                x2="298.750784"
                y2="162.143741"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.01" stopColor="#e8e8e8" stopOpacity={1} />
                <stop offset={1} stopColor="#666666" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4954"
                fill="url(#linearGradient34)"
                stroke="none"
                d="M 289.612885 161.861298 L 298.752838 161.971619 L 298.748749 162.313568 L 289.608734 162.203217 Z"
              />
              <path
                id="path4955"
                fill="#e6e6e6"
                stroke="none"
                opacity="0.5"
                d="M 298.752838 161.971619 L 304.012421 162.035126 L 304.008331 162.374756 L 298.748749 162.311279 Z"
              />
              <path
                id="path4956"
                fill="#080808"
                stroke="none"
                opacity="0.3"
                d="M 248.455276 149.301544 L 251.244675 155.123413 L 253.220444 155.147278 L 259.96756 169.063446 L 248.165665 168.921021 L 248.455276 149.301544 Z"
              />
              <g id="g43">
                <linearGradient
                  id="linearGradient35"
                  x1="258.499008"
                  y1="169.798525"
                  x2="280.714477"
                  y2="170.066687"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.01" stopColor="#e8e8e8" stopOpacity={1} />
                  <stop offset={1} stopColor="#666666" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4957"
                  fill="url(#linearGradient35)"
                  stroke="none"
                  d="M 258.502106 169.541504 L 280.719879 169.809692 L 280.713715 170.321411 L 258.495941 170.053223 Z"
                />
                <path
                  id="path4958"
                  fill="#1d1d1d"
                  stroke="none"
                  d="M 258.496521 170.005066 L 280.714294 170.273224 L 280.672058 173.770447 L 258.454315 173.502258 Z"
                />
                <g id="g44">
                  <path
                    id="path4959"
                    fill="#1d1d1d"
                    stroke="none"
                    d="M 233.022949 168.520172 L 255.442642 168.790833 C 256.553314 168.80423 257.444244 169.716949 257.430847 170.827606 L 257.395081 173.790131 L 232.962891 173.495209 L 233.022949 168.520172 L 233.022949 168.520172 Z"
                  />
                  <path
                    id="path4960"
                    fill="#1d1d1d"
                    stroke="none"
                    d="M 237.16333 167.945892 L 243.565674 168.023163 L 243.558136 168.647369 L 237.155792 168.570099 Z"
                  />
                </g>
                <path
                  id="path4961"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 259.555359 170.508972 L 261.97403 170.538177 L 261.943176 173.092255 L 259.524536 173.063049 Z"
                />
                <path
                  id="path4962"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 262.790955 170.548035 L 265.209625 170.577209 L 265.178772 173.131287 L 262.760132 173.102112 Z"
                />
                <path
                  id="path4963"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 266.02652 170.587097 L 268.445221 170.616272 L 268.414398 173.170349 L 265.995697 173.141144 Z"
                />
                <path
                  id="path4964"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 269.262146 170.626129 L 271.680786 170.655365 L 271.649963 173.209412 L 269.231293 173.180206 Z"
                />
                <path
                  id="path4965"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 272.497742 170.665222 L 274.916412 170.694427 L 274.885559 173.248474 L 272.466919 173.219269 Z"
                />
                <path
                  id="path4966"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 254.526718 169.566986 L 254.9673 169.572296 C 255.309219 169.576385 255.585846 169.857452 255.581696 170.201691 L 255.57637 170.642242 L 254.513901 170.629456 L 254.526718 169.566986 L 254.526718 169.566986 Z"
                />
                <path
                  id="path4967"
                  fill="#f2f2f2"
                  stroke="none"
                  d="M 253.051208 169.549133 L 254.113663 169.561981 L 254.100845 170.624451 L 253.038361 170.611633 Z"
                />
                <path
                  id="path4968"
                  fill="#e8e8e8"
                  stroke="none"
                  opacity="0.7"
                  d="M 248.184036 169.490387 L 252.638138 169.544189 L 252.62532 170.606628 L 248.171204 170.552887 Z"
                />
                <g id="g45">
                  <path
                    id="path4969"
                    fill="#080808"
                    stroke="none"
                    d="M 303.909576 170.555511 L 296.77243 172.789703 L 297.247559 174.307922 L 303.889374 172.228394 L 303.909576 170.555511 Z"
                  />
                  <linearGradient
                    id="linearGradient36"
                    x1="300.255328"
                    y1="168.693711"
                    x2="301.551936"
                    y2="172.695923"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.23" stopColor="#d3d3d3" stopOpacity={1} />
                    <stop offset="0.27" stopColor="#c9c9c9" stopOpacity={1} />
                    <stop offset="0.62" stopColor="#878787" stopOpacity={1} />
                    <stop offset="0.86" stopColor="#5e5e5e" stopOpacity={1} />
                    <stop offset="0.99" stopColor="#4f4f4f" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4970"
                    fill="url(#linearGradient36)"
                    stroke="none"
                    d="M 303.907867 170.697784 L 298.615967 172.362122 L 298.609589 172.889893 L 303.90152 171.223297 L 303.907867 170.697784 Z"
                  />
                </g>
                <g id="g46">
                  <path
                    id="path4971"
                    fill="#1d1d1d"
                    stroke="none"
                    d="M 292.048126 169.450714 L 300.63739 169.554413 L 300.612549 171.612762 L 292.023285 171.509094 Z"
                  />
                  <path
                    id="path4972"
                    fill="#1d1d1d"
                    stroke="none"
                    d="M 297.13031 167.669098 L 300.659637 167.7117 L 300.624969 170.584717 L 297.095642 170.542114 Z"
                  />
                  <linearGradient
                    id="linearGradient37"
                    x1="291.556532"
                    y1="167.778543"
                    x2="292.753505"
                    y2="171.478897"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.26" stopColor="#c9c9c9" stopOpacity={1} />
                    <stop offset="0.42" stopColor="#cfcfcf" stopOpacity={1} />
                    <stop offset="0.57" stopColor="#d9d9d9" stopOpacity={1} />
                    <stop offset="0.62" stopColor="#d3d3d3" stopOpacity={1} />
                    <stop offset="0.69" stopColor="#c4c4c4" stopOpacity={1} />
                    <stop offset="0.76" stopColor="#ababab" stopOpacity={1} />
                    <stop offset="0.83" stopColor="#898989" stopOpacity={1} />
                    <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4973"
                    fill="url(#linearGradient37)"
                    stroke="none"
                    d="M 292.048126 169.450714 L 292.837524 169.460236 L 292.812683 171.518646 L 292.023285 171.509094 Z"
                  />
                  <linearGradient
                    id="linearGradient38"
                    x1="296.677953"
                    y1="166.167248"
                    x2="297.751019"
                    y2="169.485121"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.26" stopColor="#c9c9c9" stopOpacity={1} />
                    <stop offset="0.42" stopColor="#cfcfcf" stopOpacity={1} />
                    <stop offset="0.57" stopColor="#d9d9d9" stopOpacity={1} />
                    <stop offset="0.62" stopColor="#d3d3d3" stopOpacity={1} />
                    <stop offset="0.69" stopColor="#c4c4c4" stopOpacity={1} />
                    <stop offset="0.76" stopColor="#ababab" stopOpacity={1} />
                    <stop offset="0.83" stopColor="#898989" stopOpacity={1} />
                    <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4974"
                    fill="url(#linearGradient38)"
                    stroke="none"
                    d="M 297.114288 167.668884 L 297.83252 167.677582 L 297.810272 169.520264 L 297.09201 169.511597 Z"
                  />
                  <path
                    id="path4975"
                    fill="#1d1d1d"
                    stroke="none"
                    d="M 286.288727 171.43988 L 303.896332 171.652405 L 303.863983 174.332672 L 286.256378 174.120148 Z"
                  />
                </g>
              </g>
            </g>
            <path
              id="path4976"
              fill="#080808"
              stroke="none"
              opacity="0.15"
              d="M 288.278381 114.795959 L 291.074097 128.648438 L 295.775177 131.057648 L 295.241913 161.92926 L 289.511108 161.926636 L 289.630341 164.025757 L 287.685333 163.926575 L 288.278381 114.795959 Z"
            />
            <g id="g47" opacity="0.7">
              <linearGradient
                id="linearGradient39"
                x1="175.717228"
                y1="179.528784"
                x2="176.383964"
                y2="124.294167"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
              </linearGradient>
              <path
                id="path4977"
                fill="url(#linearGradient39)"
                stroke="none"
                d="M 182.872391 172.378754 L 168.73674 172.20813 L 169.316574 124.172119 L 183.452225 124.342773 Z"
              />
              <path
                id="path4978"
                fill="#666666"
                stroke="none"
                opacity="0.6"
                d="M 187.493988 172.436829 L 182.87236 172.381042 L 183.452255 124.340454 L 188.073883 124.396271 Z"
              />
              <g id="g48">
                <path
                  id="path4979"
                  fill="#ffffff"
                  stroke="none"
                  d="M 226.678345 172.974091 L 218.366776 172.873749 L 219.055481 115.819427 L 227.367065 115.919739 Z"
                />
                <linearGradient
                  id="linearGradient40"
                  x1="219.182714"
                  y1="183.61313"
                  x2="219.898672"
                  y2="124.300743"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                  <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                  <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                  <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4980"
                  fill="url(#linearGradient40)"
                  stroke="none"
                  d="M 222.997574 172.929657 L 215.624542 172.840637 L 216.173828 127.335785 L 223.54686 127.424774 Z"
                />
                <linearGradient
                  id="linearGradient41"
                  x1="223.554119"
                  y1="180.441305"
                  x2="224.044047"
                  y2="139.854072"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                  <stop offset={1} stopColor="#666666" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4981"
                  fill="url(#linearGradient41)"
                  stroke="none"
                  d="M 224.298706 172.945374 L 222.990692 172.929596 L 223.539978 127.424713 L 224.847977 127.440491 Z"
                />
                <linearGradient
                  id="linearGradient42"
                  x1="227.500615"
                  y1="175.774841"
                  x2="227.945669"
                  y2="138.905102"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                  <stop offset={1} stopColor="#666666" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4982"
                  fill="url(#linearGradient42)"
                  stroke="none"
                  d="M 228.390244 172.994751 L 226.676071 172.97406 L 227.363647 116.011505 L 229.07785 116.032166 Z"
                />
              </g>
              <g id="g49">
                <path
                  id="path4983"
                  fill="#ffffff"
                  stroke="none"
                  d="M 204.587723 172.441193 L 189.931152 172.264282 L 190.532913 122.413147 L 205.189484 122.590088 Z"
                />
                <linearGradient
                  id="linearGradient43"
                  x1="205.807332"
                  y1="181.301183"
                  x2="206.368199"
                  y2="134.837097"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                  <stop offset={1} stopColor="#666666" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4984"
                  fill="url(#linearGradient43)"
                  stroke="none"
                  d="M 207.240448 172.473236 L 204.587723 172.441193 L 205.189484 122.590088 L 207.842209 122.622101 Z"
                />
                <path
                  id="path4985"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 206.26799 122.605408 L 203.904388 122.576843 L 203.991608 115.350708 L 206.355209 115.379211 Z"
                />
                <path
                  id="path4986"
                  fill="#e6e6e6"
                  stroke="none"
                  d="M 203.904388 122.576843 L 191.980865 122.432922 L 192.0681 115.206757 L 203.991608 115.350708 Z"
                />
                <path
                  id="path4987"
                  fill="#313131"
                  stroke="none"
                  d="M 205.40976 115.367798 L 202.066315 115.327454 L 202.085312 113.753235 L 205.428772 113.79361 Z"
                />
                <path
                  id="path4988"
                  fill="#b3b3b3"
                  stroke="none"
                  d="M 202.06633 115.327454 L 193.382996 115.222656 L 193.401978 113.648438 L 202.085327 113.753235 Z"
                />
              </g>
              <g id="g50">
                <linearGradient
                  id="linearGradient44"
                  x1="190.952585"
                  y1="147.347419"
                  x2="203.950046"
                  y2="147.504311"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                  <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                  <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                  <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path4989"
                  fill="url(#linearGradient44)"
                  stroke="none"
                  d="M 191.243439 123.252533 L 204.240891 123.409424 L 203.65918 171.601471 L 190.661713 171.44458 L 191.243439 123.252533 Z M 204.199066 123.452545 L 191.286514 123.296661 L 190.705811 171.403809 L 203.618362 171.559692 L 204.199066 123.452545 Z"
                />
                <g id="g51">
                  <linearGradient
                    id="linearGradient45"
                    x1="191.240764"
                    y1="125.184979"
                    x2="204.196919"
                    y2="125.341372"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4990"
                    fill="url(#linearGradient45)"
                    stroke="none"
                    d="M 191.241013 125.164307 L 204.197174 125.320709 L 204.19664 125.364319 L 191.240494 125.207916 Z"
                  />
                  <linearGradient
                    id="linearGradient46"
                    x1="191.21528"
                    y1="127.296148"
                    x2="204.171435"
                    y2="127.452542"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4991"
                    fill="url(#linearGradient46)"
                    stroke="none"
                    d="M 191.21553 127.275482 L 204.171692 127.431885 L 204.171158 127.475464 L 191.214996 127.319092 Z"
                  />
                  <linearGradient
                    id="linearGradient47"
                    x1="191.189796"
                    y1="129.407318"
                    x2="204.145951"
                    y2="129.563711"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4992"
                    fill="url(#linearGradient47)"
                    stroke="none"
                    d="M 191.190079 129.384369 L 204.14624 129.540771 L 204.145706 129.584351 L 191.189545 129.427979 Z"
                  />
                  <linearGradient
                    id="linearGradient48"
                    x1="191.16434"
                    y1="131.516192"
                    x2="204.120495"
                    y2="131.672586"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4993"
                    fill="url(#linearGradient48)"
                    stroke="none"
                    d="M 191.164597 131.495544 L 204.120743 131.651917 L 204.120224 131.695526 L 191.164063 131.539124 Z"
                  />
                  <linearGradient
                    id="linearGradient49"
                    x1="191.138856"
                    y1="133.627362"
                    x2="204.095011"
                    y2="133.783755"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4994"
                    fill="url(#linearGradient49)"
                    stroke="none"
                    d="M 191.139099 133.606689 L 204.095261 133.763092 L 204.094727 133.806702 L 191.13858 133.650299 Z"
                  />
                  <linearGradient
                    id="linearGradient50"
                    x1="191.113372"
                    y1="135.738531"
                    x2="204.069527"
                    y2="135.894925"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4995"
                    fill="url(#linearGradient50)"
                    stroke="none"
                    d="M 191.113617 135.717865 L 204.069778 135.874268 L 204.069244 135.917877 L 191.113098 135.761475 Z"
                  />
                  <linearGradient
                    id="linearGradient51"
                    x1="191.087888"
                    y1="137.849701"
                    x2="204.044043"
                    y2="138.006094"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4996"
                    fill="url(#linearGradient51)"
                    stroke="none"
                    d="M 191.088165 137.826752 L 204.044327 137.983154 L 204.043793 138.026733 L 191.087631 137.870361 Z"
                  />
                  <linearGradient
                    id="linearGradient52"
                    x1="191.062432"
                    y1="139.958575"
                    x2="204.018587"
                    y2="140.114969"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4997"
                    fill="url(#linearGradient52)"
                    stroke="none"
                    d="M 191.062668 139.937927 L 204.018829 140.09433 L 204.018311 140.137909 L 191.062164 139.981506 Z"
                  />
                  <linearGradient
                    id="linearGradient53"
                    x1="191.036948"
                    y1="142.069745"
                    x2="203.993103"
                    y2="142.226138"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4998"
                    fill="url(#linearGradient53)"
                    stroke="none"
                    d="M 191.037201 142.049103 L 203.993347 142.205475 L 203.992828 142.249084 L 191.036682 142.092682 Z"
                  />
                  <linearGradient
                    id="linearGradient54"
                    x1="191.011464"
                    y1="144.180914"
                    x2="203.967619"
                    y2="144.337308"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path4999"
                    fill="url(#linearGradient54)"
                    stroke="none"
                    d="M 191.011719 144.160248 L 203.96788 144.31665 L 203.967346 144.36026 L 191.011185 144.203857 Z"
                  />
                  <linearGradient
                    id="linearGradient55"
                    x1="190.98598"
                    y1="146.292084"
                    x2="203.942135"
                    y2="146.448477"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5000"
                    fill="url(#linearGradient55)"
                    stroke="none"
                    d="M 190.986237 146.271423 L 203.942383 146.427826 L 203.941864 146.471405 L 190.985703 146.315033 Z"
                  />
                  <linearGradient
                    id="linearGradient56"
                    x1="190.960496"
                    y1="148.403253"
                    x2="203.916651"
                    y2="148.559646"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5001"
                    fill="url(#linearGradient56)"
                    stroke="none"
                    d="M 190.96077 148.38031 L 203.916931 148.536713 L 203.916412 148.580292 L 190.960251 148.42392 Z"
                  />
                  <linearGradient
                    id="linearGradient57"
                    x1="190.93504"
                    y1="150.512128"
                    x2="203.891195"
                    y2="150.668521"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5002"
                    fill="url(#linearGradient57)"
                    stroke="none"
                    d="M 190.935287 150.491486 L 203.891449 150.647858 L 203.890915 150.691467 L 190.934753 150.535065 Z"
                  />
                  <linearGradient
                    id="linearGradient58"
                    x1="190.909556"
                    y1="152.623297"
                    x2="203.865711"
                    y2="152.779691"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5003"
                    fill="url(#linearGradient58)"
                    stroke="none"
                    d="M 190.909805 152.602631 L 203.865967 152.759033 L 203.865433 152.802643 L 190.909271 152.64624 Z"
                  />
                  <linearGradient
                    id="linearGradient59"
                    x1="190.884072"
                    y1="154.734467"
                    x2="203.840227"
                    y2="154.89086"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5004"
                    fill="url(#linearGradient59)"
                    stroke="none"
                    d="M 190.884308 154.713806 L 203.840469 154.870209 L 203.839951 154.913818 L 190.883804 154.757416 Z"
                  />
                  <linearGradient
                    id="linearGradient60"
                    x1="190.858588"
                    y1="156.845636"
                    x2="203.814743"
                    y2="157.002029"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5005"
                    fill="url(#linearGradient60)"
                    stroke="none"
                    d="M 190.858856 156.822693 L 203.815018 156.979095 L 203.814499 157.022675 L 190.858337 156.866302 Z"
                  />
                  <linearGradient
                    id="linearGradient61"
                    x1="190.833105"
                    y1="158.956805"
                    x2="203.78926"
                    y2="159.113199"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5006"
                    fill="url(#linearGradient61)"
                    stroke="none"
                    d="M 190.833374 158.933868 L 203.789536 159.090271 L 203.789001 159.13385 L 190.832855 158.977448 Z"
                  />
                  <linearGradient
                    id="linearGradient62"
                    x1="190.807648"
                    y1="161.06568"
                    x2="203.763803"
                    y2="161.222074"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5007"
                    fill="url(#linearGradient62)"
                    stroke="none"
                    d="M 190.807907 161.045044 L 203.764053 161.201416 L 203.763535 161.245026 L 190.807373 161.088623 Z"
                  />
                  <linearGradient
                    id="linearGradient63"
                    x1="190.782164"
                    y1="163.17685"
                    x2="203.738319"
                    y2="163.333243"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5008"
                    fill="url(#linearGradient63)"
                    stroke="none"
                    d="M 190.78241 163.156189 L 203.738571 163.312592 L 203.738052 163.356201 L 190.781891 163.199799 Z"
                  />
                  <linearGradient
                    id="linearGradient64"
                    x1="190.756681"
                    y1="165.288019"
                    x2="203.712836"
                    y2="165.444412"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5009"
                    fill="url(#linearGradient64)"
                    stroke="none"
                    d="M 190.756927 165.267365 L 203.713089 165.423767 L 203.712555 165.467346 L 190.756393 165.310974 Z"
                  />
                  <linearGradient
                    id="linearGradient65"
                    x1="190.731197"
                    y1="167.399188"
                    x2="203.687352"
                    y2="167.555582"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5010"
                    fill="url(#linearGradient65)"
                    stroke="none"
                    d="M 190.731476 167.376251 L 203.687637 167.532654 L 203.687103 167.576233 L 190.730942 167.419861 Z"
                  />
                  <linearGradient
                    id="linearGradient66"
                    x1="190.705741"
                    y1="169.508063"
                    x2="203.661896"
                    y2="169.664457"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5011"
                    fill="url(#linearGradient66)"
                    stroke="none"
                    d="M 190.705994 169.487427 L 203.662155 169.643799 L 203.661621 169.687408 L 190.70546 169.531006 Z"
                  />
                </g>
                <g id="g52">
                  <linearGradient
                    id="linearGradient67"
                    x1="201.71496"
                    y1="147.477331"
                    x2="201.756266"
                    y2="147.47783"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5012"
                    fill="url(#linearGradient67)"
                    stroke="none"
                    d="M 202.005569 123.403107 L 202.049164 123.403656 L 201.467972 171.552063 L 201.424362 171.551544 Z"
                  />
                  <linearGradient
                    id="linearGradient68"
                    x1="199.573959"
                    y1="147.451487"
                    x2="199.615264"
                    y2="147.451986"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5013"
                    fill="url(#linearGradient68)"
                    stroke="none"
                    d="M 199.864563 123.377258 L 199.908157 123.377777 L 199.326965 171.526245 L 199.283356 171.525726 Z"
                  />
                  <linearGradient
                    id="linearGradient69"
                    x1="197.432958"
                    y1="147.425643"
                    x2="197.476558"
                    y2="147.42617"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5014"
                    fill="url(#linearGradient69)"
                    stroke="none"
                    d="M 197.723557 123.35141 L 197.767151 123.351959 L 197.185959 171.500366 L 197.142365 171.499847 Z"
                  />
                  <linearGradient
                    id="linearGradient70"
                    x1="195.291957"
                    y1="147.399799"
                    x2="195.335557"
                    y2="147.400326"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5015"
                    fill="url(#linearGradient70)"
                    stroke="none"
                    d="M 195.58255 123.325592 L 195.626144 123.326111 L 195.044952 171.474548 L 195.001358 171.473999 Z"
                  />
                  <linearGradient
                    id="linearGradient71"
                    x1="193.15325"
                    y1="147.373983"
                    x2="193.194556"
                    y2="147.374482"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.04" stopColor="#afafaf" stopOpacity={1} />
                    <stop offset="0.55" stopColor="#cbcbcb" stopOpacity={1} />
                    <stop offset="0.7" stopColor="#c5c5c5" stopOpacity={1} />
                    <stop offset="0.88" stopColor="#b6b6b6" stopOpacity={1} />
                    <stop offset="0.95" stopColor="#afafaf" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5016"
                    fill="url(#linearGradient71)"
                    stroke="none"
                    d="M 193.443848 123.299744 L 193.487442 123.300293 L 192.90625 171.4487 L 192.862656 171.448212 Z"
                  />
                </g>
              </g>
              <path
                id="path5017"
                fill="#ffffff"
                stroke="none"
                d="M 169.263824 124.169189 L 168.683975 172.20517 L 182.819656 172.375824 L 183.39949 124.339844 L 169.263824 124.169189 Z M 170.104904 125.030853 L 182.540161 125.180908 L 181.980835 171.51651 L 169.545593 171.366394 L 170.104904 125.030853 Z"
              />
              <linearGradient
                id="linearGradient72"
                x1="199.211589"
                y1="120.431682"
                x2="199.144073"
                y2="118.03939"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#3b3b3b" stopOpacity={1} />
                <stop offset="0.7" stopColor="#1b1b1b" stopOpacity={1} />
                <stop offset="0.91" stopColor="#1b1b1b" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5018"
                fill="url(#linearGradient72)"
                stroke="none"
                opacity="0.5"
                d="M 206.308014 119.28949 L 192.020889 119.117004 L 192.028076 118.522675 L 206.31517 118.695129 Z"
              />
              <linearGradient
                id="linearGradient73"
                x1="199.188266"
                y1="122.363861"
                x2="199.12075"
                y2="119.971569"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.15" stopColor="#3b3b3b" stopOpacity={1} />
                <stop offset="0.7" stopColor="#1b1b1b" stopOpacity={1} />
                <stop offset="0.91" stopColor="#1b1b1b" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5019"
                fill="url(#linearGradient73)"
                stroke="none"
                opacity="0.5"
                d="M 206.284683 121.221649 L 191.997574 121.049194 L 192.004745 120.454865 L 206.291855 120.627319 Z"
              />
              <g id="g53">
                <linearGradient
                  id="linearGradient74"
                  x1="181.037701"
                  y1="180.820877"
                  x2="181.428048"
                  y2="148.483269"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#484848" stopOpacity={1} />
                  <stop offset={1} stopColor="#666666" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5020"
                  fill="url(#linearGradient74)"
                  stroke="none"
                  d="M 178.431488 147.464783 L 178.447357 146.149902 L 184.748734 146.225983 L 184.73288 147.540863 L 186.04776 147.556732 L 185.745316 172.613098 L 176.529602 172.501862 L 176.832047 147.445465 L 178.431488 147.464783 Z"
                />
                <linearGradient
                  id="linearGradient75"
                  x1="172.649899"
                  y1="140.452384"
                  x2="172.111026"
                  y2="185.094439"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.54" stopColor="#f2f2f2" stopOpacity={1} />
                  <stop offset="0.9" stopColor="#656565" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5021"
                  fill="url(#linearGradient75)"
                  stroke="none"
                  d="M 175.517151 147.429626 L 175.53302 146.114746 L 169.796158 146.045471 L 169.780289 147.360382 L 168.302475 147.342529 L 168 172.398926 L 176.529602 172.501862 L 176.832047 147.445465 L 175.517151 147.429626 Z"
                />
                <path
                  id="path5022"
                  fill="#313131"
                  stroke="none"
                  d="M 176.272125 147.438721 L 175.514862 147.429596 L 175.530731 146.114685 L 176.287994 146.123871 Z"
                />
                <path
                  id="path5023"
                  fill="#e8e8e8"
                  stroke="none"
                  d="M 168.302475 147.342529 L 176.832047 147.445465 L 176.827469 147.824127 L 168.297882 147.721161 Z"
                />
                <path
                  id="path5024"
                  fill="#3b3b3b"
                  stroke="none"
                  d="M 186.040894 147.935333 L 176.82518 147.824097 L 176.829758 147.445465 L 186.045471 147.556732 Z"
                />
                <g id="g54">
                  <path
                    id="path5025"
                    fill="#999999"
                    stroke="none"
                    d="M 168.189056 156.737244 L 176.718643 156.840179 L 176.714081 157.218842 L 168.184494 157.115875 Z"
                  />
                  <path
                    id="path5026"
                    fill="#999999"
                    stroke="none"
                    d="M 168.17897 157.57251 L 176.708557 157.675507 L 176.703995 158.054108 L 168.174408 157.951172 Z"
                  />
                  <path
                    id="path5027"
                    fill="#999999"
                    stroke="none"
                    d="M 168.084671 165.386139 L 176.614243 165.489136 L 176.609665 165.867737 L 168.080078 165.764771 Z"
                  />
                  <path
                    id="path5028"
                    fill="#999999"
                    stroke="none"
                    d="M 168.073578 166.304047 L 176.603165 166.407013 L 176.598587 166.785645 L 168.069 166.682709 Z"
                  />
                </g>
                <g id="g55">
                  <path
                    id="path5029"
                    fill="#333333"
                    stroke="none"
                    d="M 185.927475 157.332336 L 176.711746 157.2211 L 176.716324 156.842468 L 185.932037 156.953705 Z"
                  />
                  <path
                    id="path5030"
                    fill="#333333"
                    stroke="none"
                    d="M 185.917419 158.165314 L 176.701691 158.054077 L 176.706268 157.675446 L 185.921982 157.786713 Z"
                  />
                  <path
                    id="path5031"
                    fill="#333333"
                    stroke="none"
                    d="M 185.823059 165.981262 L 176.607346 165.870026 L 176.611908 165.491364 L 185.827637 165.602631 Z"
                  />
                  <path
                    id="path5032"
                    fill="#333333"
                    stroke="none"
                    d="M 185.811981 166.89917 L 176.596268 166.787903 L 176.60083 166.409271 L 185.816559 166.520508 Z"
                  />
                </g>
                <g id="g56">
                  <path
                    id="path5033"
                    fill="#b3b3b3"
                    stroke="none"
                    d="M 175.443497 153.531342 L 173.974869 153.513611 L 174.013474 150.314728 L 175.482117 150.332458 Z"
                  />
                  <path
                    id="path5034"
                    fill="#b3b3b3"
                    stroke="none"
                    d="M 171.228043 153.480469 L 169.759415 153.462738 L 169.798019 150.263855 L 171.266663 150.281586 Z"
                  />
                  <path
                    id="path5035"
                    fill="#b3b3b3"
                    stroke="none"
                    d="M 175.329956 162.937561 L 173.861328 162.91983 L 173.899933 159.720947 L 175.368576 159.738678 Z"
                  />
                  <path
                    id="path5036"
                    fill="#b3b3b3"
                    stroke="none"
                    d="M 171.114502 162.886627 L 169.645874 162.868958 L 169.684479 159.670044 L 171.153122 159.687775 Z"
                  />
                  <path
                    id="path5037"
                    fill="#b3b3b3"
                    stroke="none"
                    d="M 175.231598 171.086212 L 173.762955 171.068481 L 173.801559 167.869568 L 175.270218 167.887299 Z"
                  />
                  <path
                    id="path5038"
                    fill="#b3b3b3"
                    stroke="none"
                    d="M 171.016144 171.035339 L 169.547516 171.017609 L 169.586105 167.818695 L 171.054764 167.836426 Z"
                  />
                </g>
                <g id="g57">
                  <path
                    id="path5039"
                    fill="#363636"
                    stroke="none"
                    opacity="0.3"
                    d="M 184.48941 153.640533 L 183.020767 153.622803 L 183.059372 150.42392 L 184.528015 150.44165 Z"
                  />
                  <path
                    id="path5040"
                    fill="#363636"
                    stroke="none"
                    opacity="0.3"
                    d="M 180.276245 153.589691 L 178.807602 153.57196 L 178.846222 150.373077 L 180.31485 150.390808 Z"
                  />
                  <path
                    id="path5041"
                    fill="#363636"
                    stroke="none"
                    opacity="0.3"
                    d="M 184.375854 163.046753 L 182.907227 163.029022 L 182.945831 159.830139 L 184.414474 159.84787 Z"
                  />
                  <path
                    id="path5042"
                    fill="#363636"
                    stroke="none"
                    opacity="0.3"
                    d="M 180.162704 162.99588 L 178.694061 162.978149 L 178.732681 159.779297 L 180.201309 159.796967 Z"
                  />
                  <path
                    id="path5043"
                    fill="#363636"
                    stroke="none"
                    opacity="0.3"
                    d="M 184.277496 171.195404 L 182.808868 171.177673 L 182.847473 167.97876 L 184.316101 167.99649 Z"
                  />
                  <path
                    id="path5044"
                    fill="#363636"
                    stroke="none"
                    opacity="0.3"
                    d="M 180.064346 171.144531 L 178.595703 171.126801 L 178.634308 167.927948 L 180.102951 167.945648 Z"
                  />
                </g>
                <path
                  id="path5045"
                  fill="#484848"
                  stroke="none"
                  d="M 184.745117 146.526581 L 178.443741 146.4505 L 178.447357 146.149902 L 184.748734 146.225983 Z"
                />
              </g>
              <linearGradient
                id="linearGradient76"
                x1="168.205961"
                y1="174.540407"
                x2="168.384376"
                y2="159.759926"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.22" stopColor="#3b3b3b" stopOpacity={1} />
                <stop offset="0.7" stopColor="#1b1b1b" stopOpacity={1} />
                <stop offset="0.91" stopColor="#1b1b1b" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5046"
                fill="url(#linearGradient76)"
                stroke="none"
                d="M 168.058899 167.520264 L 168.527023 167.52594 L 168.468384 172.383911 L 168.000259 172.378235 Z"
              />
              <path
                id="path5047"
                fill="#aaaaaa"
                stroke="none"
                d="M 194.70108 120.487427 L 193.319641 120.470703 L 193.32341 120.158661 L 194.704849 120.175323 Z"
              />
              <path
                id="path5048"
                fill="#aaaaaa"
                stroke="none"
                d="M 198.884415 120.537903 L 197.886185 120.525848 L 197.891373 120.096741 L 198.889587 120.108765 Z"
              />
              <path
                id="path5049"
                fill="#aaaaaa"
                stroke="none"
                d="M 201.500427 120.569489 L 200.945084 120.562775 L 200.950256 120.133636 L 201.5056 120.14035 Z"
              />
              <g id="g58" opacity="0.5">
                <path
                  id="path5050"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 170.085983 126.598145 L 182.52124 126.74826 L 182.516144 127.170502 L 170.080887 127.020386 Z"
                />
                <path
                  id="path5051"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 170.066208 128.236603 L 182.50145 128.386688 L 182.496353 128.808929 L 170.061096 128.658813 Z"
                />
                <path
                  id="path5052"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 170.046432 129.875061 L 182.481674 130.025177 L 182.476578 130.447388 L 170.041336 130.297272 Z"
                />
                <path
                  id="path5053"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 170.026688 131.5112 L 182.461929 131.661316 L 182.456833 132.083527 L 170.021576 131.933441 Z"
                />
                <path
                  id="path5054"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 170.006897 133.149658 L 182.442139 133.299774 L 182.437042 133.721985 L 170.001816 133.571899 Z"
                />
                <path
                  id="path5055"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.987122 134.788086 L 182.422363 134.938202 L 182.417267 135.360443 L 169.982025 135.210358 Z"
                />
                <path
                  id="path5056"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.967346 136.426544 L 182.402603 136.57666 L 182.397491 136.998901 L 169.96225 136.848785 Z"
                />
                <path
                  id="path5057"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.947601 138.062714 L 182.382828 138.212799 L 182.377747 138.635071 L 169.942505 138.484955 Z"
                />
                <path
                  id="path5058"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.927811 139.701141 L 182.363068 139.851257 L 182.357956 140.273499 L 169.922714 140.123383 Z"
                />
                <path
                  id="path5059"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.908035 141.33963 L 182.343292 141.489746 L 182.338196 141.911957 L 169.902939 141.761841 Z"
                />
                <path
                  id="path5060"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.888275 142.978058 L 182.323502 143.128174 L 182.31842 143.550385 L 169.883163 143.400299 Z"
                />
                <path
                  id="path5061"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 169.868515 144.614227 L 182.303757 144.764343 L 182.29866 145.186554 L 169.863403 145.036438 Z"
                />
              </g>
              <path
                id="path5062"
                fill="#aaaaaa"
                stroke="none"
                d="M 222.802078 129.23349 L 221.195755 129.214111 L 221.199539 128.89975 L 222.805862 128.919128 Z"
              />
              <path
                id="path5063"
                fill="#aaaaaa"
                stroke="none"
                d="M 220.860718 129.210083 L 219.254395 129.190674 L 219.258209 128.876282 L 220.864532 128.895691 Z"
              />
              <path
                id="path5064"
                fill="#aaaaaa"
                stroke="none"
                d="M 220.229034 135.529999 L 218.622711 135.51059 L 218.626495 135.196228 L 220.232819 135.215607 Z"
              />
              <path
                id="path5065"
                fill="#aaaaaa"
                stroke="none"
                d="M 218.287659 135.506561 L 216.681335 135.487152 L 216.68515 135.17276 L 218.291473 135.192169 Z"
              />
              <path
                id="path5066"
                fill="#aaaaaa"
                stroke="none"
                d="M 219.983948 155.833923 L 218.377625 155.814545 L 218.381409 155.500153 L 219.987732 155.519531 Z"
              />
              <path
                id="path5067"
                fill="#aaaaaa"
                stroke="none"
                d="M 218.042587 155.810486 L 216.436264 155.791107 L 216.440048 155.476746 L 218.046371 155.496124 Z"
              />
              <path
                id="path5068"
                fill="#aaaaaa"
                stroke="none"
                d="M 222.445465 144.897736 L 220.839142 144.878357 L 220.842926 144.563965 L 222.449249 144.583374 Z"
              />
              <path
                id="path5069"
                fill="#aaaaaa"
                stroke="none"
                d="M 222.051498 150.536591 L 221.179489 150.526031 L 221.181396 150.367737 L 222.053406 150.378235 Z"
              />
              <linearGradient
                id="linearGradient77"
                x1="219.736458"
                y1="179.188008"
                x2="219.888669"
                y2="166.57836"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.03" stopColor="#e8e8e8" stopOpacity={1} />
                <stop offset="0.34" stopColor="#989898" stopOpacity={1} />
                <stop offset="0.46" stopColor="#8f8f8f" stopOpacity={1} />
                <stop offset="0.6" stopColor="#7e7e7e" stopOpacity={1} />
                <stop offset="0.86" stopColor="#575757" stopOpacity={1} />
                <stop offset="0.93" stopColor="#585858" stopOpacity={1} />
                <stop offset="0.95" stopColor="#5f5f5f" stopOpacity={1} />
                <stop offset="0.97" stopColor="#6b6b6b" stopOpacity={1} />
                <stop offset="0.99" stopColor="#7c7c7c" stopOpacity={1} />
                <stop offset={1} stopColor="#919191" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5070"
                fill="url(#linearGradient77)"
                stroke="none"
                d="M 220.333267 171.194519 L 219.330475 171.182465 L 219.354218 169.215851 L 220.357025 169.227936 Z"
              />
              <path
                id="path5071"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 182.039337 126.742432 L 181.029648 126.730255 L 181.034073 126.363068 L 182.043762 126.375275 Z"
              />
              <path
                id="path5072"
                fill="#999999"
                stroke="none"
                opacity="0.5"
                d="M 177.729797 126.69043 L 176.720108 126.678223 L 176.724548 126.311066 L 177.734238 126.323242 Z"
              />
              <path
                id="path5073"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 173.650055 128.325745 L 172.640366 128.313599 L 172.644791 127.946411 L 173.65448 127.958588 Z"
              />
              <path
                id="path5074"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 174.302811 133.190033 L 173.293121 133.177826 L 173.297546 132.810699 L 174.307236 132.822876 Z"
              />
              <path
                id="path5075"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 179.466263 136.463196 L 178.456573 136.450989 L 178.460999 136.083862 L 179.470688 136.096008 Z"
              />
              <path
                id="path5076"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 175.07489 138.055756 L 174.065201 138.043549 L 174.069641 137.676422 L 175.079315 137.688599 Z"
              />
              <path
                id="path5077"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 173.138 126.634979 L 172.128311 126.622803 L 172.132736 126.255646 L 173.142426 126.267822 Z"
              />
              <path
                id="path5078"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 176.459869 128.272461 L 175.955032 128.266388 L 175.958389 127.988708 L 176.463226 127.994812 Z"
              />
              <path
                id="path5079"
                fill="#e8e8e8"
                stroke="none"
                opacity="0.5"
                d="M 180.186554 128.317444 L 179.681717 128.311371 L 179.685059 128.033661 L 180.189896 128.039795 Z"
              />
              <path
                id="path5080"
                fill="#999999"
                stroke="none"
                opacity="0.5"
                d="M 179.187531 131.603424 L 178.294876 131.592651 L 178.297928 131.34024 L 179.190582 131.351013 Z"
              />
              <path
                id="path5081"
                fill="#999999"
                stroke="none"
                opacity="0.5"
                d="M 177.987198 139.78009 L 177.064713 139.768951 L 177.068848 139.427032 L 177.991318 139.438171 Z"
              />
              <path
                id="path5082"
                fill="#080808"
                stroke="none"
                opacity="0.15"
                d="M 190.465851 127.96875 L 196.730515 128.044373 L 196.527664 144.848816 L 198.854538 144.876892 L 198.521896 172.43454 L 189.755966 172.328735 L 190.465851 127.96875 Z"
              />
              <g id="g59">
                <linearGradient
                  id="linearGradient78"
                  x1="202.646817"
                  y1="159.83154"
                  x2="202.516822"
                  y2="170.600799"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.22" stopColor="#3b3b3b" stopOpacity={1} />
                  <stop offset="0.42" stopColor="#2a2a2a" stopOpacity={1} />
                  <stop offset="0.65" stopColor="#1e1e1e" stopOpacity={1} />
                  <stop offset="0.88" stopColor="#1b1b1b" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5083"
                  fill="url(#linearGradient78)"
                  stroke="none"
                  d="M 212.880722 172.940643 L 192.101776 172.68985 L 192.192093 165.206665 L 212.971039 165.457458 Z"
                />
                <path
                  id="path5084"
                  fill="#1b1b1b"
                  stroke="none"
                  d="M 212.96875 165.457458 L 211.103378 162.371002 L 194.27829 162.167908 L 192.189789 165.206635 L 212.96875 165.457458 Z"
                />
                <linearGradient
                  id="linearGradient79"
                  x1="216.033318"
                  y1="163.123623"
                  x2="209.414447"
                  y2="174.519145"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.03" stopColor="#e8e8e8" stopOpacity={1} />
                  <stop offset="0.34" stopColor="#989898" stopOpacity={1} />
                  <stop offset="0.46" stopColor="#8f8f8f" stopOpacity={1} />
                  <stop offset="0.6" stopColor="#7e7e7e" stopOpacity={1} />
                  <stop offset="0.86" stopColor="#575757" stopOpacity={1} />
                  <stop offset="0.93" stopColor="#585858" stopOpacity={1} />
                  <stop offset="0.95" stopColor="#5f5f5f" stopOpacity={1} />
                  <stop offset="0.97" stopColor="#6b6b6b" stopOpacity={1} />
                  <stop offset="0.99" stopColor="#7c7c7c" stopOpacity={1} />
                  <stop offset={1} stopColor="#919191" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5085"
                  fill="url(#linearGradient79)"
                  stroke="none"
                  opacity="0.9"
                  d="M 212.878418 172.940613 L 212.045425 172.930542 L 212.135757 165.447418 L 212.96875 165.457458 Z"
                />
                <linearGradient
                  id="linearGradient80"
                  x1="208.795584"
                  y1="164.755274"
                  x2="208.709216"
                  y2="171.910302"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.03" stopColor="#e8e8e8" stopOpacity={1} />
                  <stop offset="0.34" stopColor="#989898" stopOpacity={1} />
                  <stop offset="0.46" stopColor="#8f8f8f" stopOpacity={1} />
                  <stop offset="0.6" stopColor="#7e7e7e" stopOpacity={1} />
                  <stop offset="0.86" stopColor="#575757" stopOpacity={1} />
                  <stop offset="0.93" stopColor="#585858" stopOpacity={1} />
                  <stop offset="0.95" stopColor="#5f5f5f" stopOpacity={1} />
                  <stop offset="0.97" stopColor="#6b6b6b" stopOpacity={1} />
                  <stop offset="0.99" stopColor="#7c7c7c" stopOpacity={1} />
                  <stop offset={1} stopColor="#919191" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5086"
                  fill="url(#linearGradient80)"
                  stroke="none"
                  d="M 209.61058 169.488403 L 207.866577 169.467346 L 207.895966 167.032593 L 209.639969 167.05368 Z"
                />
                <linearGradient
                  id="linearGradient81"
                  x1="206.620162"
                  y1="164.729014"
                  x2="206.533794"
                  y2="171.884043"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.03" stopColor="#e8e8e8" stopOpacity={1} />
                  <stop offset="0.34" stopColor="#989898" stopOpacity={1} />
                  <stop offset="0.46" stopColor="#8f8f8f" stopOpacity={1} />
                  <stop offset="0.6" stopColor="#7e7e7e" stopOpacity={1} />
                  <stop offset="0.86" stopColor="#575757" stopOpacity={1} />
                  <stop offset="0.93" stopColor="#585858" stopOpacity={1} />
                  <stop offset="0.95" stopColor="#5f5f5f" stopOpacity={1} />
                  <stop offset="0.97" stopColor="#6b6b6b" stopOpacity={1} />
                  <stop offset="0.99" stopColor="#7c7c7c" stopOpacity={1} />
                  <stop offset={1} stopColor="#919191" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5087"
                  fill="url(#linearGradient81)"
                  stroke="none"
                  d="M 207.437454 169.462189 L 205.693451 169.441101 L 205.722839 167.006378 L 207.466858 167.027435 Z"
                />
              </g>
              <g id="g60">
                <linearGradient
                  id="linearGradient82"
                  x1="201.281632"
                  y1="176.91114"
                  x2="201.432458"
                  y2="164.41623"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.22" stopColor="#3b3b3b" stopOpacity={1} />
                  <stop offset="0.7" stopColor="#1b1b1b" stopOpacity={1} />
                  <stop offset="0.91" stopColor="#1b1b1b" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5088"
                  fill="url(#linearGradient82)"
                  stroke="none"
                  d="M 202.05867 172.810028 L 200.606094 172.79248 L 200.645096 169.561493 L 202.097687 169.57901 Z"
                />
                <g id="g61">
                  <path
                    id="path5089"
                    fill="#000000"
                    stroke="none"
                    d="M 200.606247 172.781006 L 182.142685 172.558136 L 182.181992 169.30188 L 200.645538 169.52475 Z"
                  />
                  <path
                    id="path5090"
                    fill="#f2f2f2"
                    stroke="none"
                    d="M 189.751938 172.661469 L 183.526291 172.586304 L 183.548309 170.761993 L 189.773956 170.837158 Z"
                  />
                </g>
              </g>
              <g id="g62">
                <path
                  id="path5091"
                  fill="#000000"
                  stroke="none"
                  d="M 233.611847 170.498749 L 207.027176 170.177856 L 207.030746 169.881836 L 233.615417 170.202728 Z"
                />
                <path
                  id="path5092"
                  fill="#000000"
                  stroke="none"
                  d="M 207.396255 172.874451 L 206.99469 172.869598 L 207.030228 169.925446 L 207.431808 169.930298 Z"
                />
                <path
                  id="path5093"
                  fill="#000000"
                  stroke="none"
                  d="M 209.654297 172.901703 L 209.252731 172.896851 L 209.288254 169.952698 L 209.689835 169.95755 Z"
                />
                <path
                  id="path5094"
                  fill="#000000"
                  stroke="none"
                  d="M 212.047729 172.930603 L 211.646133 172.925751 L 211.681671 169.981567 L 212.083267 169.98645 Z"
                />
                <path
                  id="path5095"
                  fill="#000000"
                  stroke="none"
                  d="M 214.452621 172.959625 L 214.051041 172.954773 L 214.086578 170.01062 L 214.488159 170.015472 Z"
                />
                <path
                  id="path5096"
                  fill="#000000"
                  stroke="none"
                  d="M 216.650986 172.986176 L 216.249405 172.981323 L 216.284943 170.03714 L 216.686539 170.042023 Z"
                />
                <path
                  id="path5097"
                  fill="#000000"
                  stroke="none"
                  d="M 219.069656 173.015381 L 218.668076 173.010498 L 218.703613 170.066345 L 219.105194 170.071198 Z"
                />
                <path
                  id="path5098"
                  fill="#000000"
                  stroke="none"
                  d="M 221.327698 173.042633 L 220.926102 173.03775 L 220.961639 170.093628 L 221.363235 170.09845 Z"
                />
                <path
                  id="path5099"
                  fill="#000000"
                  stroke="none"
                  d="M 223.721115 173.071503 L 223.31955 173.066681 L 223.355072 170.122498 L 223.756653 170.12735 Z"
                />
                <path
                  id="path5100"
                  fill="#000000"
                  stroke="none"
                  d="M 226.126007 173.100555 L 225.724426 173.095673 L 225.759979 170.15152 L 226.161545 170.156372 Z"
                />
                <path
                  id="path5101"
                  fill="#000000"
                  stroke="none"
                  d="M 228.324387 173.127075 L 227.922791 173.122223 L 227.958344 170.17807 L 228.359909 170.182922 Z"
                />
                <path
                  id="path5102"
                  fill="#000000"
                  stroke="none"
                  d="M 230.247375 173.150299 L 229.845795 173.145447 L 229.881332 170.201294 L 230.282913 170.206116 Z"
                />
                <path
                  id="path5103"
                  fill="#000000"
                  stroke="none"
                  d="M 231.970734 173.171112 L 231.569153 173.166229 L 231.604691 170.222076 L 232.006287 170.226929 Z"
                />
                <path
                  id="path5104"
                  fill="#000000"
                  stroke="none"
                  d="M 233.58165 173.190521 L 233.180069 173.185699 L 233.215607 170.241547 L 233.617188 170.246368 Z"
                />
                <linearGradient
                  id="linearGradient83"
                  x1="233.610832"
                  y1="170.202691"
                  x2="207.028455"
                  y2="169.881816"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.12" stopColor="#919191" stopOpacity={1} />
                  <stop offset="0.37" stopColor="#6a6a6a" stopOpacity={1} />
                  <stop offset="0.62" stopColor="#4b4b4b" stopOpacity={1} />
                  <stop offset="0.83" stopColor="#373737" stopOpacity={1} />
                  <stop offset="0.98" stopColor="#313131" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5105"
                  fill="url(#linearGradient83)"
                  stroke="none"
                  d="M 233.610107 170.26236 L 207.030014 169.941528 L 207.031479 169.822174 L 233.611542 170.143036 Z"
                />
              </g>
              <g id="g63">
                <path
                  id="path5106"
                  fill="#a0a0a0"
                  stroke="none"
                  d="M 219.082077 115.897766 L 227.363815 115.997742 L 227.359665 116.341949 L 219.077911 116.242004 Z"
                />
                <path
                  id="path5107"
                  fill="#bcbcbc"
                  stroke="none"
                  opacity="0.5"
                  d="M 219.331024 117.328339 L 220.159439 117.338318 L 220.144257 118.595825 L 219.315857 118.585846 Z"
                />
                <path
                  id="path5108"
                  fill="#bcbcbc"
                  stroke="none"
                  opacity="0.5"
                  d="M 225.914673 117.407776 L 226.743088 117.417755 L 226.727905 118.675323 L 225.899475 118.665314 Z"
                />
                <path
                  id="path5109"
                  fill="#e6e6e6"
                  stroke="none"
                  opacity="0.5"
                  d="M 220.749176 117.345428 L 221.577591 117.355408 L 221.562408 118.612946 L 220.733994 118.602966 Z"
                />
                <path
                  id="path5110"
                  fill="#9f9f9f"
                  stroke="none"
                  opacity="0.5"
                  d="M 222.169632 117.362579 L 222.998032 117.372589 L 222.982864 118.630096 L 222.154449 118.620117 Z"
                />
                <path
                  id="path5111"
                  fill="#b5b5b5"
                  stroke="none"
                  opacity="0.5"
                  d="M 223.587799 117.3797 L 224.416199 117.389679 L 224.401016 118.647217 L 223.572617 118.637207 Z"
                />
              </g>
            </g>
          </g>
          <path
            id="path5112"
            fill="#114684"
            stroke="none"
            d="M 259.690918 145.588287 L 259.690857 145.595215 C 259.690857 145.595215 259.690857 145.595215 259.690887 145.592896 C 259.690887 145.592896 259.690887 145.590607 259.690918 145.588287 Z"
          />
          <g id="g64">
            <g id="g65">
              <linearGradient
                id="linearGradient84"
                x1="190.140984"
                y1="160.965829"
                x2="191.928594"
                y2="160.987408"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5113"
                fill="url(#linearGradient84)"
                stroke="none"
                d="M 190.957153 167.312408 L 190.957153 167.312408 C 190.463791 167.306458 190.069321 166.902344 190.075287 166.408966 L 190.20665 155.524994 C 190.212601 155.031586 190.61673 154.637146 191.110092 154.643097 L 191.110092 154.643097 C 191.603455 154.649048 191.99794 155.053162 191.991974 155.546539 L 191.860596 166.430542 C 191.854645 166.923889 191.450531 167.318359 190.957153 167.312408 Z"
              />
              <linearGradient
                id="linearGradient85"
                x1="185.503922"
                y1="166.181663"
                x2="196.438403"
                y2="166.313653"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5114"
                fill="url(#linearGradient85)"
                stroke="none"
                d="M 185.508438 165.807617 L 196.445221 165.939606 L 196.436203 166.685425 L 185.499435 166.553436 Z"
              />
              <g id="g66">
                <linearGradient
                  id="linearGradient86"
                  x1="183.955706"
                  y1="166.481991"
                  x2="186.617615"
                  y2="166.514123"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5115"
                  fill="url(#linearGradient86)"
                  stroke="none"
                  d="M 186.617599 166.51413 C 186.608734 167.249207 186.005661 167.837891 185.270599 167.82901 C 184.535538 167.820129 183.946838 167.217041 183.955704 166.481995 C 183.964584 165.746948 184.567673 165.158234 185.302719 165.167114 C 186.037796 165.175964 186.62648 165.779053 186.617599 166.51413 Z"
                />
                <linearGradient
                  id="linearGradient87"
                  x1="195.31701"
                  y1="166.619133"
                  x2="197.978919"
                  y2="166.651265"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5116"
                  fill="url(#linearGradient87)"
                  stroke="none"
                  d="M 197.978928 166.651276 C 197.970062 167.386353 197.366974 167.975037 196.631897 167.966125 C 195.896835 167.957275 195.308136 167.354187 195.317017 166.619141 C 195.325882 165.884094 195.92897 165.29538 196.664032 165.30426 C 197.399109 165.31311 197.987808 165.916199 197.978928 166.651276 Z"
                />
              </g>
            </g>
            <g id="g67">
              <g id="g68">
                <linearGradient
                  id="linearGradient88"
                  x1="261.929438"
                  y1="161.302222"
                  x2="263.717048"
                  y2="161.3238"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5117"
                  fill="url(#linearGradient88)"
                  stroke="none"
                  d="M 262.747894 167.648804 L 262.747894 167.648804 C 262.254517 167.642853 261.860077 167.23877 261.866028 166.745392 L 261.997406 155.861389 C 262.003357 155.368042 262.407471 154.973541 262.900848 154.979492 L 262.900848 154.979492 C 263.394226 154.985474 263.788666 155.389557 263.782715 155.882935 L 263.651337 166.766937 C 263.645386 167.260315 263.241302 167.654785 262.747894 167.648804 Z"
                />
                <linearGradient
                  id="linearGradient89"
                  x1="257.292376"
                  y1="166.518056"
                  x2="268.226857"
                  y2="166.650045"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5118"
                  fill="url(#linearGradient89)"
                  stroke="none"
                  d="M 257.296875 166.146301 L 268.233612 166.27832 L 268.22464 167.024139 L 257.287872 166.89212 Z"
                />
                <g id="g69">
                  <linearGradient
                    id="linearGradient90"
                    x1="255.74416"
                    y1="166.818384"
                    x2="258.406069"
                    y2="166.850516"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                    <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5119"
                    fill="url(#linearGradient90)"
                    stroke="none"
                    d="M 258.406067 166.850494 C 258.397186 167.585571 257.794098 168.174255 257.059052 168.165405 C 256.323975 168.156525 255.735291 167.553467 255.744156 166.81839 C 255.753036 166.083313 256.35611 165.494629 257.091187 165.503479 C 257.826233 165.51239 258.414948 166.115479 258.406067 166.850494 Z"
                  />
                  <linearGradient
                    id="linearGradient91"
                    x1="267.105464"
                    y1="166.955526"
                    x2="269.767373"
                    y2="166.987658"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                    <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5120"
                    fill="url(#linearGradient91)"
                    stroke="none"
                    d="M 269.767365 166.98764 C 269.758514 167.722717 269.155426 168.311401 268.420349 168.302551 C 267.685272 168.293671 267.096588 167.690582 267.105438 166.955536 C 267.114349 166.220459 267.717407 165.631744 268.452484 165.640625 C 269.187531 165.649536 269.776245 166.252594 269.767365 166.98764 Z"
                  />
                </g>
              </g>
              <path
                id="path5121"
                fill="#597987"
                stroke="none"
                d="M 264.951996 155.793793 C 265.786194 155.89566 266.620361 155.997528 267.454529 156.099396 C 268.062378 155.558197 268.94342 154.630157 269.602692 153.251862 C 270.664581 151.029297 270.517365 148.966522 270.397278 148.076874 C 269.167175 148.071228 267.937073 148.065521 266.707001 148.059875 C 266.122742 150.639404 265.538513 153.216614 264.951965 155.796082 Z"
              />
              <linearGradient
                id="linearGradient92"
                x1="256.189019"
                y1="157.914238"
                x2="268.192853"
                y2="158.059137"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5122"
                fill="url(#linearGradient92)"
                stroke="none"
                d="M 256.199615 157.03537 C 256.420197 157.396057 256.640778 157.754456 256.863647 158.115173 C 258.059631 158.473877 259.625336 158.816376 261.47641 158.902954 C 264.045471 159.023499 266.173492 158.601654 267.629028 158.187744 C 267.821503 157.832031 268.013947 157.478607 268.206482 157.122925 C 264.206482 157.092987 260.204224 157.063049 256.204224 157.035431 Z"
              />
              <path
                id="path5123"
                fill="#b0784a"
                stroke="none"
                d="M 252.372498 157.326538 L 265.034943 157.47937 C 265.519135 157.485229 265.91626 157.097534 265.922089 156.613373 L 265.922089 156.613373 C 265.933594 155.661041 265.171875 154.880707 264.219543 154.869202 L 254.127243 154.747375 C 253.174911 154.73587 252.394577 155.49762 252.383087 156.449921 L 252.372498 157.326538 Z"
              />
              <path
                id="path5124"
                fill="#1b6d3c"
                stroke="none"
                d="M 263.014862 151.047119 L 271.932251 151.154755 C 272.659698 151.163544 273.292328 150.661652 273.450073 149.952087 L 277.222107 132.929077 C 277.309418 132.539978 277.015564 132.166931 276.613983 132.162079 L 269.514038 132.076355 C 268.178497 132.060242 267.015198 132.982605 266.726379 134.285004 L 263.012573 151.047089 Z"
              />
              <path
                id="path5125"
                fill="#2baf63"
                stroke="none"
                d="M 262.539856 151.041382 L 270.862915 151.141876 C 271.728027 151.152283 272.48114 150.555481 272.66806 149.710846 L 276.37204 133.001465 C 276.466797 132.568817 276.141266 132.156372 275.698364 132.151031 L 268.919708 132.069214 C 267.446442 132.051422 266.16272 133.068726 265.844696 134.506165 L 262.259552 150.686859 C 262.220612 150.867706 262.356262 151.039154 262.539856 151.041382 Z"
              />
              <path
                id="path5126"
                fill="#2baf63"
                stroke="none"
                d="M 257.464539 157.388 L 270.126984 157.540863 C 270.611176 157.546692 271.008301 157.158997 271.01413 156.674835 L 271.01413 156.674835 C 271.025635 155.722504 270.263916 154.942139 269.311615 154.930664 L 259.219299 154.808838 C 258.266968 154.797363 257.486633 155.559113 257.475128 156.511383 L 257.464539 157.388 Z"
              />
              <path
                id="path5127"
                fill="#eba88b"
                stroke="none"
                d="M 248.7995 146.26239 C 248.759735 146.514374 249.051392 146.690033 249.060989 147.034424 C 249.060638 147.06424 249.059784 147.135406 249.098572 147.154236 C 249.151031 147.180084 249.259979 147.091888 249.309265 147.000702 C 249.393829 146.841064 249.30426 146.656372 249.286316 146.621735 C 249.330231 146.594727 249.383575 146.549438 249.42569 146.483398 C 249.556717 146.276154 249.505646 145.942719 249.350449 145.872009 C 249.176987 145.791901 248.839157 146.019592 248.799484 146.264709 Z"
              />
              <path
                id="path5128"
                fill="#232a2b"
                stroke="none"
                d="M 252.528778 166.244812 C 252.557175 166.364502 252.583267 166.484161 252.611679 166.603821 C 252.659317 166.648041 252.72728 166.72229 252.778732 166.833069 C 252.861526 167.008514 252.850418 167.169006 252.840347 167.24234 C 252.359741 167.319153 251.87915 167.395996 251.398544 167.472809 C 251.168076 167.552643 250.880096 167.64328 250.544067 167.721863 C 250.277069 167.785156 250.058578 167.823883 249.849289 167.860352 C 248.641953 168.059235 247.908386 168.178864 247.782883 167.929474 C 247.749283 167.86026 247.743973 167.72937 247.806793 167.658966 C 247.84166 167.62265 247.896866 167.611877 248.007263 167.59256 C 248.200455 167.558136 248.297058 167.540955 248.306244 167.541046 C 248.455582 167.529114 249.215973 167.278931 251.175507 166.556671 C 251.22319 166.41037 251.270859 166.264038 251.318512 166.117737 C 251.719635 166.161621 252.123032 166.205505 252.524139 166.249359 Z"
              />
              <path
                id="path5129"
                fill="#232a2b"
                stroke="none"
                d="M 248.859268 166.028412 C 248.88765 166.148071 248.913742 166.267731 248.942139 166.387421 C 248.989807 166.43161 249.05777 166.505859 249.109207 166.616669 C 249.192001 166.792084 249.180908 166.952606 249.170837 167.025909 C 248.690231 167.102753 248.209641 167.179565 247.729019 167.256378 C 247.498566 167.336212 247.210587 167.426849 246.874542 167.505432 C 246.607559 167.568756 246.389053 167.607422 246.179764 167.643921 C 244.972443 167.842804 244.238861 167.962463 244.113342 167.713043 C 244.079758 167.643829 244.074448 167.512939 244.137268 167.442535 C 244.172134 167.40625 244.227356 167.395447 244.337738 167.376129 C 244.530945 167.341705 244.627548 167.324524 244.636734 167.324615 C 244.786057 167.312683 245.546448 167.0625 247.505997 166.340271 C 247.553665 166.193939 247.601318 166.047607 247.648987 165.901306 C 248.050095 165.94519 248.453506 165.989075 248.854614 166.032928 Z"
              />
              <path
                id="path5130"
                fill="#2b3436"
                stroke="none"
                d="M 263.536346 151.195709 C 263.686707 151.670288 263.842743 152.429565 263.556305 153.155945 C 263.156189 154.170135 262.090546 154.609406 260.822021 154.933746 C 257.688782 155.733643 254.181244 155.597198 251.93457 155.388763 C 251.585266 157.138 251.175278 158.971405 250.688721 160.872772 C 250.226273 162.678009 249.737381 164.391113 249.231277 166.009949 C 248.996231 166.089722 248.591003 166.197266 248.081894 166.163605 C 247.563614 166.129791 247.166229 165.966644 246.942657 165.856049 C 247.179688 163.901215 247.433044 161.925903 247.700409 159.930145 C 248.010574 157.622742 248.336395 155.347656 248.673294 153.104828 C 248.790634 152.32132 249.396729 151.734192 250.136383 151.681183 C 254.60228 151.519348 259.065887 151.357483 263.531738 151.195648 Z"
              />
              <path
                id="path5131"
                fill="#313b3d"
                stroke="none"
                d="M 267.317444 150.915436 C 267.499481 151.427155 267.767395 152.428741 267.372955 153.351196 C 266.926666 154.387787 265.858948 154.808685 264.638733 155.128998 C 263.107666 155.530548 260.28067 156.051849 256.05304 155.679474 C 255.53569 157.470276 255.020569 159.265717 254.505371 161.068024 C 254.016479 162.783447 253.529892 164.496582 253.047958 166.20517 C 252.899902 166.302094 252.419022 166.592346 251.76825 166.506439 C 251.257248 166.440613 250.906967 166.177063 250.759308 166.051331 C 250.996353 164.096497 251.249695 162.121185 251.51709 160.125397 C 251.827225 157.817993 252.153061 155.542877 252.48996 153.300079 C 252.607285 152.516571 253.213379 151.929474 253.953049 151.876434 L 267.312805 150.917694 Z"
              />
              <path
                id="path5132"
                fill="#313b3d"
                stroke="none"
                d="M 257.018829 143.928833 C 257.131805 144.074768 257.380951 144.350922 257.792236 144.502747 C 258.578247 144.792267 259.285583 144.373901 259.38501 144.313141 C 259.622314 143.478302 259.857361 142.636536 260.09021 141.790192 C 260.390259 140.701355 260.685608 139.619324 260.97171 138.544098 C 260.923065 138.199249 260.803619 137.637817 260.468872 137.037048 C 259.988129 136.17746 259.054138 135.218323 258.57196 135.425934 C 258.46582 135.47287 258.317352 135.604187 258.25238 136.041748 C 258.037323 136.936554 257.837738 137.8797 257.660583 138.86673 C 257.338226 140.66449 257.136444 142.360413 257.018829 143.928833 Z"
              />
              <path
                id="path5133"
                fill="#5c3b2f"
                stroke="none"
                d="M 260.487579 130.16806 C 260.035492 130.162598 259.585724 130.157166 259.133667 130.151733 C 259.134888 130.238953 259.136139 130.326172 259.13739 130.413422 C 259.55542 130.384033 259.975739 130.356964 260.393829 130.327606 C 260.424286 130.275177 260.454773 130.222748 260.48526 130.16803 Z"
              />
              <path
                id="path5134"
                fill="#313b3d"
                stroke="none"
                d="M 267.948944 152.977173 C 266.945618 153.580139 264.145996 155.070313 260.671356 154.489014 C 259.521545 154.296082 258.566711 153.921936 257.829926 153.548157 C 257.768677 152.537567 257.700592 151.143616 257.663239 149.483826 C 257.627472 147.883728 257.57724 145.771637 257.692657 143.434357 C 257.789917 141.461761 258.031311 138.765656 258.653229 135.537109 C 259.063751 135.372192 259.502167 135.177826 259.957092 134.946899 C 260.506653 134.668945 260.998993 134.381134 261.436157 134.099548 C 262.242676 134.022034 263.051453 133.946869 263.857971 133.869415 C 264.276886 134.149872 264.734741 134.433105 265.231781 134.707642 C 266.287354 135.29184 267.294281 135.72171 268.197021 136.040161 C 267.951843 137.717194 267.740112 139.474945 267.571167 141.304382 C 267.46283 142.482788 267.377808 143.631592 267.313812 144.750793 C 267.24054 146.067291 267.240631 147.579773 267.388062 149.245483 C 267.509216 150.619385 267.712158 151.870392 267.946625 152.977173 Z"
              />
              <path
                id="path5135"
                fill="#232a2b"
                stroke="none"
                d="M 264.175659 139.872589 C 264.737335 139.922974 265.299042 139.973389 265.858459 140.021454 C 265.819672 140.193085 265.783142 140.367096 265.744324 140.538757 C 265.139069 140.487854 264.536041 140.436951 263.930756 140.388306 C 264.013153 140.217194 264.093262 140.043732 264.175659 139.872589 Z"
              />
              <path
                id="path5136"
                fill="#424f52"
                stroke="none"
                d="M 260.471436 146.905945 C 260.104004 145.400513 259.765747 143.762329 259.490875 142.005554 C 259.258545 140.529297 259.094208 139.122742 258.979401 137.797089 C 259.437378 136.742279 259.893066 135.687469 260.351013 134.63266 C 260.672211 134.452911 260.993408 134.273193 261.314606 134.093445 C 261.189056 137.07785 261.061249 140.059906 260.93573 143.044312 C 260.782471 144.332306 260.626923 145.62027 260.473694 146.908264 Z"
              />
              <path
                id="path5137"
                fill="#424f52"
                stroke="none"
                d="M 260.471649 146.885254 C 261.680389 145.23822 262.914551 143.387207 264.114471 141.329224 C 264.77066 140.203369 265.364624 139.10202 265.905396 138.034454 C 265.808777 136.911011 265.714478 135.787567 265.61792 134.661804 C 264.979553 134.307526 264.341187 133.955597 263.70282 133.601318 C 263.078949 135.661652 262.452728 137.724243 261.828827 139.784607 C 261.377991 142.149994 260.924835 144.517639 260.473969 146.883026 Z"
              />
              <path
                id="path5138"
                fill="#ffffff"
                stroke="none"
                d="M 260.450745 146.90567 C 260.770142 145.546234 261.145203 144.132416 261.582794 142.67572 C 262.512848 139.588593 263.583893 136.801514 264.685577 134.324646 C 264.428345 134.149414 264.171173 133.971893 263.91391 133.796631 C 263.047363 133.905548 262.183075 134.014435 261.316559 134.121033 C 261.207031 134.259705 261.097473 134.398407 260.987885 134.539337 C 260.890228 135.405701 260.803864 136.28598 260.72879 137.182465 C 260.444214 140.603302 260.372864 143.852264 260.450745 146.90567 Z"
              />
              <path
                id="path5139"
                fill="#f7b9a5"
                stroke="none"
                d="M 264.277313 131.450867 C 264.253845 131.684692 264.237152 131.925446 264.227234 132.177826 C 264.200592 132.863739 264.232025 133.49295 264.294037 134.058289 C 264.118256 134.3591 263.882294 134.705109 263.568237 135.054779 C 263.030792 135.658752 262.468353 136.051331 262.036102 136.303162 C 261.879883 136.126862 261.699066 135.895172 261.535126 135.597107 C 261.297089 135.162781 261.187256 134.757507 261.133392 134.465393 C 261.063385 133.420258 260.993347 132.377441 260.921021 131.332336 C 261.502289 131.472443 262.251373 131.589386 263.12381 131.56546 C 263.546234 131.554504 263.932373 131.508667 264.277313 131.450867 Z"
              />
              <path
                id="path5140"
                fill="#f29d83"
                stroke="none"
                d="M 261.08374 133.633972 C 261.111603 133.799561 261.170807 134.027466 261.303223 134.274658 C 261.395294 134.445618 261.496918 134.579926 261.585175 134.681976 C 261.944672 134.562378 262.781769 134.232819 263.464386 133.391876 C 263.990875 132.744141 264.187073 132.083221 264.267151 131.721558 C 264.14859 131.655853 264.03006 131.590179 263.913849 131.522217 C 262.971222 132.226898 262.028656 132.929291 261.08374 133.633972 Z"
              />
              <path
                id="path5141"
                fill="#e0a263"
                stroke="none"
                d="M 259.52478 127.790222 C 259.456696 127.917938 259.378662 128.107483 259.36203 128.343658 C 259.313141 128.971924 259.718536 129.422089 259.806915 129.514923 C 259.928864 129.29837 260.050842 129.081787 260.172791 128.862946 C 259.956787 128.504608 259.740814 128.146271 259.524811 127.787933 Z"
              />
              <path
                id="path5142"
                fill="#e8b582"
                stroke="none"
                d="M 259.968109 128.899506 C 259.861572 128.790344 259.739349 128.648865 259.62912 128.463928 C 259.401886 128.084778 259.335114 127.721375 259.312622 127.493866 C 259.327026 127.441284 259.360382 127.338409 259.448792 127.240784 C 259.534851 127.145416 259.631836 127.098389 259.682556 127.078369 C 259.933502 127.393494 260.186768 127.70871 260.437683 128.023865 C 260.280396 128.315735 260.123138 128.605316 259.96582 128.897186 Z"
              />
              <path
                id="path5143"
                fill="#fcc6ae"
                stroke="none"
                d="M 264.528625 127.933258 C 264.525787 128.167297 264.521362 128.534485 264.504486 128.981812 C 264.387634 132.009918 263.947083 132.569153 263.71933 132.802826 C 263.454437 133.072754 263.198212 133.195862 262.778107 133.395081 C 262.304871 133.621155 261.238464 134.126953 260.447601 133.665283 C 260.253937 133.550507 260.143066 133.418365 260.043518 133.297791 C 259.414642 132.541992 259.479492 131.542145 259.547089 130.505554 C 259.55542 130.386322 259.585785 129.962128 259.686646 129.401031 C 259.814514 128.69339 260.003265 128.078308 260.199951 127.566559 C 260.536621 127.432922 260.958191 127.304901 261.452271 127.25119 C 262.893158 127.094147 264.029449 127.647217 264.526367 127.930939 Z"
              />
              <path
                id="path5144"
                fill="#ffffff"
                stroke="none"
                d="M 260.663544 130.22757 C 260.632782 130.302948 260.564545 130.444397 260.441956 130.523254 C 260.259247 130.640381 260.03064 130.564209 259.861328 130.330353 C 259.838135 130.160217 259.874634 129.988556 259.98111 129.914093 C 260.138458 129.805817 260.474792 129.892517 260.665863 130.225281 Z"
              />
              <path
                id="path5145"
                fill="#4a5969"
                stroke="none"
                d="M 260.372101 130.226349 C 260.370148 130.389282 260.267548 130.521149 260.141327 130.519623 C 260.015106 130.518097 259.915771 130.383789 259.917725 130.220856 C 259.919708 130.057953 260.022247 129.928345 260.148438 129.929871 C 260.274689 129.931427 260.374054 130.065704 260.372101 130.226349 Z"
              />
              <path
                id="path5146"
                fill="#2e1d17"
                stroke="none"
                d="M 260.303131 130.237 C 260.30188 130.340912 260.230988 130.424316 260.144806 130.423279 C 260.058624 130.422241 259.989777 130.337158 259.991028 130.233215 C 259.992279 130.129303 260.063141 130.045898 260.149353 130.046936 C 260.235504 130.047974 260.304382 130.133057 260.303131 130.237 Z"
              />
              <path
                id="path5147"
                fill="#ffffff"
                stroke="none"
                d="M 260.136017 130.200562 C 260.042145 130.181061 259.964386 130.159454 259.904877 130.144989 C 259.845398 130.130493 259.813354 130.120941 259.811279 130.102539 C 259.809296 130.077271 259.862488 130.045776 259.908447 130.039459 C 260.025665 130.024811 260.124756 130.182068 260.136017 130.200562 Z"
              />
              <path
                id="path5148"
                fill="#2e1d17"
                stroke="none"
                d="M 260.638794 130.185944 C 260.638794 130.185944 260.625214 130.172028 260.60025 130.148773 C 260.575287 130.125519 260.541229 130.095276 260.495667 130.06488 C 260.452454 130.034515 260.397736 130.004028 260.338348 129.980377 C 260.308655 129.968536 260.27887 129.963562 260.242249 129.953979 C 260.207916 129.946655 260.175842 129.941681 260.143768 129.938995 C 260.111633 129.938599 260.081787 129.938263 260.054138 129.947113 C 260.026489 129.955963 260.003418 129.967133 259.980255 129.985229 C 259.938538 130.019135 259.905762 130.071533 259.88913 130.119537 C 259.870178 130.167511 259.865051 130.213348 259.860046 130.247711 C 259.857361 130.279816 259.854828 130.300446 259.854828 130.300446 C 259.854828 130.300446 259.845825 130.284271 259.834778 130.249695 C 259.8237 130.217438 259.812805 130.166809 259.818176 130.104919 C 259.823486 130.042999 259.845062 129.967529 259.905487 129.903992 C 259.93338 129.874481 259.972778 129.845154 260.016541 129.831879 C 260.060333 129.816345 260.106293 129.812347 260.149872 129.812836 C 260.193451 129.815674 260.23465 129.825348 260.27356 129.834991 C 260.31015 129.844635 260.348969 129.861176 260.385498 129.877655 C 260.453857 129.915222 260.510651 129.964111 260.546844 130.010406 C 260.585297 130.056793 260.607666 130.102966 260.621063 130.132965 C 260.63446 130.165253 260.638855 130.183685 260.638855 130.183685 Z"
              />
              <path
                id="path5149"
                fill="#cf836a"
                stroke="none"
                d="M 262.21994 132.293579 L 262.096252 132.273712 C 262.098755 132.255371 262.104126 132.191223 262.061249 132.131012 C 262.02063 132.073151 261.958832 132.056305 261.940552 132.053802 L 261.964966 131.930145 C 262.001617 131.9375 262.095398 131.963867 262.163116 132.056488 C 262.230804 132.151428 262.225006 132.25235 262.219971 132.29126 Z"
              />
              <path
                id="path5150"
                fill="#cf836a"
                stroke="none"
                d="M 261.052856 132.961151 C 261.020721 132.960754 260.988586 132.960358 260.954254 132.955353 L 260.967255 132.829254 C 261.063507 132.8396 261.157684 132.833862 261.252014 132.814331 C 261.316406 132.801331 261.378632 132.779144 261.436371 132.752319 L 261.490082 132.865417 C 261.423126 132.896729 261.351685 132.921112 261.278076 132.93631 C 261.204437 132.951477 261.128601 132.959747 261.052887 132.958832 Z"
              />
              <path
                id="path5151"
                fill="#dba36b"
                stroke="none"
                d="M 264.459137 130.457001 C 264.328064 130.290161 264.197144 130.10498 264.071167 129.896881 C 263.558167 129.043823 263.37326 128.19931 263.307312 127.581116 C 263.525421 127.572296 263.773224 127.579865 264.048218 127.615295 C 264.595886 127.686188 265.041443 127.847656 265.363281 127.998383 C 265.41745 128.26297 265.474091 128.702026 265.380554 129.22876 C 265.289429 129.739471 265.096588 130.125031 264.960754 130.352875 C 264.792755 130.387573 264.627106 130.422302 264.459137 130.457001 Z"
              />
              <path
                id="path5152"
                fill="#e8b582"
                stroke="none"
                d="M 265.613129 128.784027 C 265.287323 128.585022 264.89267 128.387482 264.42395 128.239532 C 262.791534 127.719482 261.329315 128.119537 260.665527 128.352509 C 260.53772 128.29361 260.396362 128.216125 260.253052 128.108826 C 259.814087 127.779938 259.598785 127.361938 259.496216 127.115112 C 259.698242 126.917877 259.990356 126.675842 260.380737 126.469391 C 260.985901 126.148499 261.549255 126.061218 261.898438 126.033295 C 262.327332 126.056854 263.051453 126.150482 263.843018 126.550201 C 264.807983 127.036957 265.371155 127.725372 265.632965 128.091156 C 265.659363 128.185577 265.685181 128.328186 265.671631 128.500153 C 265.663361 128.614807 265.639252 128.710938 265.613129 128.784027 Z"
              />
              <path
                id="path5153"
                fill="#8c7054"
                stroke="none"
                d="M 262.61026 129.427124 C 262.484467 129.393494 262.326508 129.359467 262.140808 129.341125 C 261.881775 129.317352 261.661255 129.33075 261.498047 129.351746 C 261.496216 129.315002 261.499268 129.250763 261.543579 129.193939 C 261.618164 129.100708 261.760651 129.081787 261.864105 129.069275 C 262.135315 129.038147 262.550049 129.091339 262.621246 129.280365 C 262.632324 129.312653 262.638611 129.360901 262.61261 129.424866 Z"
              />
              <path
                id="path5154"
                fill="#8c7054"
                stroke="none"
                d="M 260.632233 129.40097 C 260.536255 129.365387 260.417358 129.329529 260.279877 129.311798 C 260.085114 129.28421 259.919678 129.298279 259.797821 129.317444 C 259.795959 129.280701 259.796722 129.216461 259.831848 129.159515 C 259.888062 129.066101 259.993835 129.048981 260.069702 129.038422 C 260.274353 129.008759 260.585785 129.065338 260.640869 129.2565 C 260.649658 129.288696 260.653656 129.336975 260.634521 129.401001 Z"
              />
              <path
                id="path5155"
                fill="#7a4e3f"
                stroke="none"
                d="M 260.187408 131.266113 C 260.001495 131.268433 259.815704 131.257019 259.634735 131.229584 C 259.522491 131.212158 259.410278 131.190155 259.300446 131.163605 L 259.277557 131.158691 L 259.266327 131.137909 C 259.169708 130.969238 259.112183 130.78952 259.091522 130.598785 C 259.075043 130.444794 259.083771 130.291107 259.120026 130.140076 L 259.129669 130.101166 L 259.17099 130.101685 C 259.239929 130.093353 259.313416 130.08963 259.38916 130.088257 C 259.634766 130.084351 259.877838 130.103333 260.118286 130.147552 C 260.271729 130.174652 260.425049 130.210938 260.573669 130.258636 L 260.61026 130.270538 L 260.609802 130.307251 C 260.618805 130.513947 260.574982 130.722229 260.487793 130.907104 C 260.428925 131.032593 260.349457 131.148712 260.251862 131.250793 L 260.235596 131.268982 L 260.185089 131.268341 Z M 259.352112 131.06781 C 259.4505 131.091949 259.551239 131.111542 259.64975 131.126465 C 259.826141 131.15387 260.005035 131.165222 260.184082 131.162781 L 260.184082 131.162781 C 260.265472 131.07196 260.333252 130.971771 260.385071 130.862244 C 260.460449 130.702515 260.499298 130.526245 260.499146 130.347229 C 260.366516 130.308899 260.231506 130.275146 260.094086 130.252838 C 259.862762 130.211029 259.624329 130.192078 259.387848 130.196106 C 259.328217 130.195374 259.270782 130.19928 259.217926 130.203217 C 259.191162 130.331451 259.184998 130.459869 259.199493 130.590881 C 259.218109 130.758636 259.268951 130.919891 259.349762 131.070068 Z"
              />
              <path
                id="path5156"
                fill="#424f52"
                stroke="none"
                d="M 266.137115 149.069733 C 265.113586 149.059662 264.087799 149.05188 263.064331 149.041809 C 263.097748 149.315338 263.133453 149.588867 263.16687 149.862396 C 264.140167 149.846619 265.113525 149.828522 266.086823 149.812744 C 266.103577 149.565033 266.120331 149.317383 266.137115 149.069733 Z"
              />
              <path
                id="path5157"
                fill="#424f52"
                stroke="none"
                d="M 257.253571 149.008392 C 257.273224 149.281738 257.290558 149.555054 257.310242 149.82843 C 257.886536 149.807831 258.462891 149.784943 259.039185 149.764374 C 259.051361 149.516663 259.061249 149.26889 259.073425 149.021179 C 258.46756 149.016144 257.861694 149.013428 257.255859 149.008423 Z"
              />
              <path
                id="path5158"
                fill="#aad5e0"
                stroke="none"
                d="M 263.38739 137.108978 C 262.933594 136.864807 262.477509 136.622925 262.023743 136.378754 C 261.640808 136.539368 261.255585 136.699982 260.87265 136.862885 C 261.240967 136.770966 261.609344 136.676697 261.977631 136.584747 C 262.448303 136.760284 262.916718 136.933472 263.38739 137.108978 Z"
              />
              <path
                id="path5159"
                fill="#7a4e3f"
                stroke="none"
                d="M 264.684753 130.209534 C 264.115662 130.202698 263.546539 130.19809 262.975098 130.193512 C 262.98761 130.299225 263.000122 130.402649 263.012604 130.508362 C 263.538757 130.461975 264.064911 130.415527 264.591064 130.366791 C 264.621521 130.314362 264.651978 130.261932 264.682495 130.207214 Z"
              />
              <path
                id="path5160"
                fill="#fcc6ae"
                stroke="none"
                d="M 264.246613 130.380981 C 264.311584 130.324402 264.42041 130.243073 264.572388 130.201294 C 264.678314 130.17276 264.770111 130.173859 264.836578 130.181549 C 264.902313 130.248901 264.992828 130.355591 265.069031 130.507965 C 265.178864 130.725037 265.215393 130.932037 265.229919 131.056122 C 265.196472 131.168182 265.127869 131.339508 264.997345 131.500854 C 264.778381 131.771332 264.522827 131.837097 264.4216 131.856567 C 264.382629 131.85379 264.295563 131.841248 264.20462 131.766724 C 264.106964 131.685211 264.064636 131.576843 264.049103 131.533051 C 264.113434 131.148254 264.177704 130.765717 264.244324 130.380951 Z"
              />
              <path
                id="path5161"
                fill="#f2aa94"
                stroke="none"
                d="M 264.264893 130.957275 C 264.300201 130.886566 264.365723 130.781769 264.470093 130.691223 C 264.620819 130.562225 264.772644 130.53421 264.846161 130.528229 C 264.896027 130.579315 264.970642 130.674316 265.028564 130.819611 C 265.068634 130.921051 265.083557 131.013062 265.091949 131.079712 C 265.05191 131.166443 264.972229 131.303192 264.83551 131.409393 C 264.571381 131.617371 264.292114 131.554321 264.223511 131.535126 C 264.249084 131.507904 264.307373 131.432892 264.329468 131.313812 C 264.361511 131.128265 264.278412 130.980408 264.264893 130.957275 Z"
              />
              <path
                id="path5162"
                fill="#7a4e3f"
                stroke="none"
                d="M 259.135956 130.149475 L 259.005157 130.150177 L 258.972992 130.34259 L 259.103485 130.369415 L 259.135956 130.149475 Z"
              />
              <path
                id="path5163"
                fill="#ffffff"
                stroke="none"
                d="M 262.715363 130.227112 C 262.670837 130.302307 262.572754 130.44342 262.392792 130.521576 C 262.125153 130.637665 261.790985 130.560211 261.541382 130.325378 C 261.5466 130.272644 261.566895 130.114532 261.694641 129.987549 C 261.694641 129.987549 261.782898 129.901428 261.907349 129.861603 C 262.140015 129.788696 262.459534 129.934814 262.715363 130.224792 Z"
              />
              <path
                id="path5164"
                fill="#4a5969"
                stroke="none"
                d="M 262.247375 130.209961 C 262.245392 130.372894 262.110687 130.504364 261.950073 130.502441 C 261.789429 130.500488 261.65567 130.365784 261.657623 130.20285 C 261.659576 130.039917 261.794281 129.910736 261.957184 129.912689 C 262.120117 129.914642 262.249298 130.049347 262.247375 130.209961 Z"
              />
              <path
                id="path5165"
                fill="#2e1d17"
                stroke="none"
                d="M 262.148743 130.206512 C 262.147491 130.310394 262.062195 130.393616 261.958282 130.392365 C 261.85437 130.391113 261.771149 130.305878 261.772369 130.201935 C 261.773621 130.097992 261.858917 130.014771 261.96283 130.016022 C 262.066772 130.017303 262.149994 130.10257 262.148743 130.206512 Z"
              />
              <path
                id="path5166"
                fill="#ffffff"
                stroke="none"
                d="M 261.952301 130.128357 C 261.858459 130.108887 261.78067 130.08728 261.721161 130.072784 C 261.661652 130.058319 261.629639 130.048737 261.627563 130.030365 C 261.62558 130.005096 261.678772 129.973602 261.724731 129.967285 C 261.841949 129.952637 261.94104 130.109863 261.952301 130.128357 Z"
              />
              <path
                id="path5167"
                fill="#2e1d17"
                stroke="none"
                d="M 262.713074 130.227081 C 262.713074 130.227081 262.694885 130.210754 262.665405 130.18515 C 262.635864 130.159576 262.592682 130.122345 262.538086 130.084961 C 262.483429 130.047546 262.419647 130.007813 262.344269 129.97702 C 262.268921 129.94632 262.191162 129.924713 262.104065 129.91449 C 262.021576 129.902008 261.938934 129.905579 261.867493 129.927673 C 261.830658 129.93869 261.798309 129.954376 261.765991 129.972382 C 261.738251 129.990356 261.70813 130.010681 261.684937 130.031067 C 261.638519 130.074097 261.603546 130.119568 261.582458 130.153748 C 261.561401 130.187897 261.549683 130.208405 261.549683 130.208405 C 261.549683 130.208405 261.549988 130.185486 261.559631 130.144287 C 261.569305 130.103088 261.588348 130.045929 261.630432 129.984467 C 261.651459 129.952637 261.677063 129.923096 261.711853 129.893677 C 261.742004 129.866486 261.783661 129.839447 261.827454 129.821625 C 261.915161 129.781372 262.023132 129.773499 262.119354 129.786133 C 262.167511 129.793579 262.213287 129.803345 262.261261 129.817657 C 262.309326 129.829742 262.350342 129.85318 262.391449 129.874329 C 262.471222 129.918915 262.53479 129.974762 262.582367 130.028107 C 262.629913 130.081451 262.661438 130.132324 262.681671 130.166992 C 262.701874 130.203979 262.708527 130.224731 262.708527 130.224731 Z"
              />
              <path
                id="path5168"
                fill="#5c3d48"
                stroke="none"
                opacity="0.15"
                style={{ mixBlendMode: 'multiply' }}
                d="M 259.827362 128.771576 C 259.917358 128.538544 260.007416 128.305542 260.097443 128.07254 C 260.286774 128.166626 260.476166 128.258423 260.665527 128.352509 C 261.128387 128.222687 261.701263 128.11026 262.362579 128.079224 C 262.684082 128.064728 262.980103 128.070618 263.25296 128.089966 C 263.320557 128.19635 263.388092 128.305054 263.455627 128.411438 L 263.527466 128.166718 C 263.756744 128.183258 264.018005 128.216278 264.301788 128.281677 C 264.757263 128.383545 265.136444 128.535004 265.430786 128.678558 C 265.011536 128.425629 264.254181 128.042389 263.234436 127.913025 C 262.07724 127.763641 261.151611 128.01181 260.672241 128.175873 C 260.464722 128.06778 260.254822 127.962006 260.047302 127.853882 C 259.974731 128.160553 259.899902 128.467194 259.827332 128.773865 Z"
              />
              <path
                id="path5169"
                fill="#fccd9c"
                stroke="none"
                d="M 261.747314 127.718384 C 261.767731 127.73468 261.933441 127.507172 262.128357 127.330505 C 262.771088 126.750732 263.719208 126.730011 263.708435 126.672516 C 263.701965 126.638031 263.368622 126.686798 263.321808 126.569153 C 263.301758 126.518463 263.348175 126.477661 263.323334 126.442963 C 263.269135 126.368866 263.012756 126.505737 262.967651 126.43866 C 262.94281 126.403931 263.003204 126.344971 262.980652 126.312592 C 262.937714 126.256989 262.73175 126.39679 262.634003 126.319885 C 262.593079 126.287262 262.60733 126.246124 262.582489 126.213654 C 262.492004 126.104736 261.998901 126.268616 261.614166 126.5784 C 260.951294 127.114319 260.796753 127.93866 260.842346 127.964478 C 260.865173 127.976227 260.952087 127.807465 261.075897 127.820404 C 261.135468 127.828033 261.141846 127.871704 261.201477 127.874725 C 261.311554 127.880646 261.36615 127.732117 261.455414 127.751556 C 261.503479 127.761322 261.507446 127.811859 261.548767 127.814667 C 261.612946 127.820007 261.666992 127.715088 261.718536 127.62851 C 261.859039 127.396088 262.009979 127.251038 262.016785 127.255707 C 262.025909 127.262726 261.72229 127.697388 261.749573 127.718414 Z"
              />
              <path
                id="path5170"
                fill="#fccd9c"
                stroke="none"
                d="M 261.870758 126.237213 C 261.870758 126.237213 261.632874 126.358276 261.372681 126.61908 C 260.808105 127.188324 260.737549 127.901276 260.69635 127.889282 C 260.662048 127.8797 260.654297 127.381561 260.960419 126.928528 C 261.299255 126.427673 261.859467 126.221008 261.870758 126.237213 Z"
              />
              <path
                id="path5171"
                fill="#fccd9c"
                stroke="none"
                d="M 260.519653 127.887146 C 260.489838 127.889099 260.367371 127.57547 260.422119 127.224976 C 260.51413 126.633972 261.055542 126.273285 261.07373 126.289581 C 261.0896 126.303528 260.746887 126.558746 260.591644 127.059479 C 260.453094 127.50766 260.551849 127.882935 260.519653 127.887146 Z"
              />
              <path
                id="path5172"
                fill="#7a4e3f"
                stroke="none"
                d="M 261.891602 131.355499 C 261.717133 131.358002 261.542877 131.344421 261.371124 131.310211 L 261.355103 131.310028 C 261.355103 131.310028 261.343811 131.293823 261.343811 131.293823 C 261.187408 131.131287 261.072632 130.941711 261.004028 130.732025 C 260.964172 130.612183 260.94046 130.485687 260.9328 130.357056 L 260.933319 130.315765 C 260.933319 130.315765 260.970154 130.304718 260.970154 130.304718 C 261.400909 130.1745 261.842438 130.101807 262.287811 130.093414 C 262.533417 130.089508 262.774231 130.103851 263.012543 130.134277 L 263.053802 130.139374 L 263.057861 130.183044 C 263.073853 130.380585 263.055389 130.577728 263.004913 130.767639 C 262.971252 130.895752 262.91925 131.019073 262.855896 131.135345 L 262.846497 131.151276 L 262.830353 131.15799 C 262.532806 131.28064 262.222168 131.348053 261.905396 131.353394 L 261.89389 131.353241 Z M 261.406799 131.209686 C 261.567078 131.239136 261.7276 131.252533 261.890564 131.249939 L 261.902039 131.250061 C 262.198181 131.242157 262.492676 131.181458 262.771759 131.06778 C 262.828125 130.96286 262.870758 130.853241 262.901978 130.738861 C 262.947601 130.574158 262.965668 130.404541 262.956238 130.234589 C 262.738556 130.206726 262.518372 130.197174 262.300293 130.199127 C 261.871002 130.207733 261.452545 130.271545 261.042572 130.392792 C 261.052795 130.496216 261.072174 130.599701 261.105408 130.698822 C 261.167389 130.887756 261.270905 131.058838 261.409119 131.207397 Z"
              />
              <path
                id="path5173"
                fill="#cf836a"
                stroke="none"
                d="M 260.84021 130.422516 C 260.84021 130.422516 260.832947 130.454529 260.818512 130.507141 C 260.806427 130.559784 260.777954 130.635193 260.735687 130.715027 C 260.712219 130.758301 260.686493 130.797028 260.656128 130.840271 C 260.625793 130.881195 260.588593 130.924377 260.549103 130.962921 C 260.509613 131.003754 260.463257 131.039917 260.416962 131.073792 C 260.365997 131.109863 260.322113 131.134613 260.259827 131.161377 C 260.243652 131.17038 260.227478 131.179382 260.206635 131.19519 C 260.185791 131.210999 260.167084 131.238312 260.162201 131.263489 C 260.147949 131.302338 260.151886 131.357452 260.160645 131.391998 C 260.180359 131.467987 260.223297 131.525879 260.268585 131.574615 C 260.313904 131.623352 260.368561 131.660736 260.425629 131.686676 C 260.455322 131.698517 260.485016 131.708038 260.514832 131.710724 C 260.530914 131.710876 260.544678 131.71109 260.560699 131.711243 C 260.574493 131.711395 260.585968 131.709259 260.597504 131.707092 C 260.700928 131.69458 260.774841 131.656464 260.825623 131.629547 C 260.876465 131.600281 260.89743 131.577606 260.89743 131.577606 C 260.89743 131.577606 260.867401 131.593323 260.814453 131.606445 C 260.761475 131.621857 260.683289 131.634705 260.593811 131.631317 C 260.582336 131.631195 260.570892 131.631073 260.557098 131.63089 L 260.527344 131.625946 C 260.506744 131.618774 260.486176 131.611664 260.465668 131.599945 C 260.424652 131.576477 260.386047 131.541626 260.352112 131.499878 C 260.318176 131.460449 260.293549 131.409668 260.280334 131.363617 C 260.276031 131.338318 260.273865 131.329071 260.281036 131.306213 C 260.283417 131.299377 260.283417 131.299377 260.288055 131.294861 C 260.292664 131.290314 260.30423 131.285858 260.315765 131.279114 C 260.371216 131.252258 260.435883 131.216278 260.489166 131.175629 C 260.54245 131.134949 260.588928 131.087311 260.630798 131.039642 C 260.672668 130.991943 260.707703 130.941864 260.73587 130.891724 C 260.763977 130.843842 260.787598 130.789093 260.80188 130.745636 C 260.835205 130.649658 260.83847 130.567047 260.841492 130.509735 C 260.842163 130.452332 260.837952 130.420197 260.837952 130.420197 Z"
              />
              <path
                id="path5174"
                fill="#7a4e3f"
                stroke="none"
                d="M 261.037231 130.642914 C 261.009155 130.688446 260.974152 130.733948 260.946747 130.724457 C 260.914703 130.714874 260.929474 130.632416 260.884308 130.572205 C 260.825592 130.493469 260.690338 130.480347 260.63678 130.543976 C 260.592529 130.598511 260.616547 130.699799 260.577393 130.713104 C 260.558929 130.719757 260.540771 130.703461 260.529419 130.691864 C 260.539063 130.652954 260.548737 130.614075 260.55835 130.575165 L 260.566589 130.274597 C 260.608032 130.263641 260.656342 130.255035 260.713745 130.253448 C 260.844574 130.250427 260.947357 130.29068 261.01123 130.323578 L 261.037262 130.640625 Z"
              />
              <path
                id="path5175"
                fill="#cf836a"
                stroke="none"
                d="M 260.935333 132.429535 C 261.13269 132.431915 261.328003 132.413635 261.518951 132.374634 C 261.739838 132.329071 261.956421 132.25827 262.157288 132.161987 L 262.101318 132.044281 C 261.909729 132.136078 261.70459 132.204742 261.495239 132.248108 C 261.16394 132.315247 260.824219 132.318024 260.485291 132.256561 L 260.463104 132.384827 C 260.621124 132.411987 260.779297 132.427643 260.935333 132.429535 Z"
              />
              <path
                id="path5176"
                fill="#313b3d"
                stroke="none"
                d="M 269.771851 144.562469 C 269.655334 144.705627 269.399628 144.975677 268.984802 145.117554 C 268.192047 145.38797 267.495026 144.952637 267.397064 144.889496 C 267.180023 144.049225 266.965302 143.201996 266.75296 142.350281 C 266.479309 141.254517 266.210144 140.16571 265.950073 139.083862 C 266.00705 138.740295 266.139984 138.181885 266.489136 137.589386 C 266.990509 136.741638 267.947388 135.805328 268.424377 136.024536 C 268.529388 136.074005 268.674622 136.208893 268.729004 136.647858 C 268.922424 137.547607 269.099152 138.4953 269.252472 139.486328 C 269.531342 141.291351 269.692108 142.991669 269.771851 144.562469 Z"
              />
              <path
                id="path5177"
                fill="#232a2b"
                stroke="none"
                d="M 266.818481 143.195648 C 266.898621 143.405487 267.692169 145.540283 266.754791 146.573242 C 265.791779 147.638031 263.039459 147.490021 260.671051 145.196198 C 262.719482 144.527802 264.770142 143.861755 266.818542 143.193329 Z"
              />
              <path
                id="path5178"
                fill="#313b3d"
                stroke="none"
                d="M 262.224091 146.780212 C 263.031494 146.817474 263.965759 146.801208 264.995605 146.666779 C 266.970154 146.412903 268.570038 145.826294 269.719421 145.291626 C 269.777039 145.081207 269.82428 144.781097 269.76181 144.440704 C 269.576874 143.412537 268.579773 142.927734 268.447418 142.864166 C 268.152374 142.968475 267.679932 143.132599 267.090088 143.320557 C 265.64325 143.780487 264.538055 144.074677 264.197327 144.162384 C 263.603333 144.315857 262.857544 144.495056 261.990143 144.677368 C 261.914551 144.85318 261.767426 145.25531 261.827728 145.772461 C 261.885895 146.275787 262.108917 146.625031 262.221771 146.780182 Z"
              />
              <path
                id="path5179"
                fill="#2baf63"
                stroke="none"
                d="M 262.249268 146.594604 C 262.331055 146.471649 262.439026 146.275574 262.478851 146.016724 C 262.573608 145.393585 262.200653 144.918579 262.126007 144.825897 C 261.923401 144.880829 261.718475 144.933441 261.515839 144.988373 C 261.472778 145.134705 261.428986 145.340759 261.439758 145.588745 C 261.461395 146.077881 261.679749 146.431671 261.790344 146.586761 C 261.944092 146.588623 262.095551 146.590424 262.249298 146.592316 Z"
              />
              <path
                id="path5180"
                fill="#313b3d"
                stroke="none"
                d="M 252.353439 146.546295 C 253.161316 146.546875 254.09613 146.487 255.117294 146.308838 C 257.076874 145.965271 258.650055 145.30722 259.772522 144.721741 C 259.821014 144.508911 259.854462 144.208649 259.77597 143.868011 C 259.544983 142.848511 258.526672 142.409332 258.391968 142.352631 C 258.103638 142.470764 257.637787 142.65564 257.056854 142.868988 C 255.632172 143.393402 254.542435 143.738281 254.206085 143.842102 C 253.618668 144.023224 252.883957 144.236969 252.025238 144.456116 C 251.956543 144.634277 251.829941 145.043579 251.913239 145.558685 C 251.994431 146.057709 252.233597 146.397949 252.353439 146.546295 Z"
              />
              <path
                id="path5181"
                fill="#ccf4ff"
                stroke="none"
                d="M 252.369492 146.358276 C 252.446747 146.233002 252.545563 146.032227 252.571671 145.770874 C 252.638916 145.142853 252.245056 144.688263 252.163528 144.597748 C 251.963089 144.661896 251.762665 144.723755 251.559921 144.787842 C 251.523697 144.936615 251.489059 145.14505 251.511337 145.390869 C 251.555923 145.88028 251.790466 146.222778 251.90799 146.373383 C 252.061829 146.368347 252.213379 146.363281 252.367188 146.358246 Z"
              />
              <path
                id="path5182"
                fill="#232a2b"
                stroke="none"
                d="M 266.282379 139.124603 C 266.325684 139.910034 266.40274 140.753235 266.531982 141.645294 C 266.610291 142.190155 266.702698 142.71228 266.804565 143.209259 C 266.652039 143.296906 266.497162 143.386841 266.344635 143.474518 C 266.528412 143.460693 266.787811 143.456909 267.092499 143.504211 C 267.958405 143.636292 268.437561 144.062073 268.479645 143.998352 C 268.524017 143.932312 268.055389 143.398804 267.364227 143.236664 C 267.245239 143.207703 267.139801 143.197235 267.052643 143.191589 C 266.795868 141.8367 266.536865 140.479462 266.280121 139.124542 Z"
              />
              <path
                id="path5183"
                fill="#232a2b"
                stroke="none"
                d="M 257.736542 144.743073 C 257.706787 144.164368 257.69809 143.553772 257.717346 142.911346 C 257.771118 141.117279 258.029053 139.52298 258.357452 138.17514 C 258.149719 140.364441 257.944275 142.553772 257.736542 144.743073 Z"
              />
              <path
                id="path5184"
                fill="#232a2b"
                stroke="none"
                d="M 267.243805 153.402435 C 266.871826 153.6091 265.53006 154.297485 263.7966 153.971344 C 261.776947 153.591187 260.718384 152.111847 260.515411 151.815643 L 257.586945 151.621948 C 257.636688 151.494019 257.684082 151.368347 257.733826 151.240417 C 258.717804 151.29361 259.701721 151.346802 260.685669 151.399963 C 261.017456 151.863007 261.698547 152.669922 262.835022 153.209198 C 264.86142 154.172363 266.796722 153.555389 267.243866 153.400146 Z"
              />
              <path
                id="path5185"
                fill="#fcc6ae"
                stroke="none"
                d="M 250.388855 146.16684 C 250.190277 146.265442 250.030777 146.359924 249.917435 146.434265 C 249.535736 146.682129 249.50238 146.785004 249.499298 146.849213 C 249.498581 146.908875 249.515732 147.010071 249.588654 147.052277 C 249.759537 147.155304 249.975159 146.786102 250.548996 146.588776 C 250.830185 146.491211 250.958374 146.518005 251.201218 146.364838 C 251.365417 146.26123 251.479294 146.14328 251.549194 146.056915 C 251.650116 146.062744 251.751022 146.068512 251.851929 146.074341 C 251.892288 145.964661 251.947525 145.761047 251.920761 145.505981 C 251.885712 145.177368 251.732376 144.950592 251.657791 144.855591 C 251.439514 144.875916 251.262512 144.899017 251.145248 144.915955 C 250.181992 145.051239 250.13678 145.183807 249.278397 145.375397 C 249.207077 145.390625 249.069 145.421082 248.939194 145.527344 C 248.902115 145.556763 248.837128 145.61795 248.670273 145.939545 C 248.531647 146.20639 248.46344 146.343262 248.457458 146.457947 C 248.451111 146.604767 248.494843 146.593811 248.509827 146.873993 C 248.51535 146.986511 248.512238 147.05304 248.557724 147.088043 C 248.616898 147.130035 248.72525 147.090057 248.783142 147.047119 C 248.996231 146.886749 248.852768 146.412231 248.848434 146.391541 C 248.980865 146.25769 249.115585 146.123932 249.248032 145.990112 C 249.452209 145.997162 249.656387 146.004211 249.860565 146.011292 C 250.036652 146.063904 250.212738 146.116516 250.386536 146.169098 Z"
              />
              <g id="g70">
                <path
                  id="path5186"
                  fill="#fcc6ae"
                  stroke="none"
                  d="M 260.245941 146.382202 C 260.44281 146.423615 260.692596 146.456451 260.977203 146.453033 C 261.160858 146.450653 261.324036 146.431946 261.468903 146.408478 C 261.57428 146.425812 261.677338 146.443115 261.782684 146.460449 C 261.836823 146.350952 261.919617 146.145355 261.922882 145.874573 C 261.927063 145.528076 261.792419 145.274017 261.727203 145.165344 C 261.315735 145.217743 260.978027 145.2435 260.741486 145.256714 C 260.220123 145.28714 259.705048 145.370422 259.185699 145.423859 C 259.109863 145.432098 258.962799 145.446411 258.814789 145.541016 C 258.773132 145.568054 258.699036 145.622223 258.486359 145.93869 C 258.311066 146.2005 258.222229 146.334839 258.202423 146.453949 C 258.177673 146.605133 258.225922 146.598816 258.206329 146.892334 C 258.198029 147.009308 258.185699 147.080292 258.23114 147.119843 C 258.287872 147.171021 258.405273 147.142609 258.470001 147.10437 C 258.710388 146.962708 258.617859 146.452057 258.615875 146.429108 C 258.771088 146.307037 258.924072 146.182648 259.079315 146.060577 C 259.292358 146.092987 259.503143 146.123108 259.716217 146.155487 C 259.892029 146.231079 260.070129 146.306641 260.245941 146.382202 Z"
                />
                <path
                  id="path5187"
                  fill="#fcc6ae"
                  stroke="none"
                  d="M 258.448303 147.000824 C 258.530548 147.031677 258.651825 147.062958 258.762604 147.011536 C 258.921844 146.937714 258.926361 146.754181 259.080261 146.554047 C 259.150208 146.463074 259.273285 146.342926 259.490143 146.249176 C 259.431946 146.317291 259.359589 146.419708 259.298218 146.55899 C 259.260468 146.643433 259.154266 146.885437 259.229279 146.945984 C 259.279297 146.985626 259.387756 146.936432 259.443298 146.900421 C 259.572815 146.817047 259.59256 146.700226 259.660431 146.590881 C 259.84082 146.2901 260.182159 146.340118 260.197662 146.19574 C 260.21579 146.026123 259.764709 145.749847 259.314453 145.785736 C 259.236328 145.791656 258.949127 145.818054 258.712219 146.051575 C 258.333649 146.421112 258.441895 146.961731 258.450592 147.000885 Z"
                />
                <path
                  id="path5188"
                  fill="#fcc6ae"
                  stroke="none"
                  d="M 257.7789 146.556702 C 257.731232 146.512512 257.76474 146.398193 257.826294 146.242859 C 257.994354 145.820282 258.077209 145.610138 258.24176 145.479004 C 258.452606 145.311707 258.675018 145.330475 259.163818 145.334076 C 259.503448 145.338196 259.999268 145.332703 260.619324 145.298859 C 259.660126 145.668274 259.149292 145.779144 258.857513 145.803162 C 258.749512 145.813324 258.609467 145.816223 258.477448 145.915619 C 258.24588 146.08725 258.293091 146.358643 258.031921 146.511536 C 257.957947 146.554291 257.833405 146.60556 257.781189 146.559021 Z"
                />
              </g>
            </g>
            <g id="g71">
              <linearGradient
                id="linearGradient93"
                x1="182.582071"
                y1="151.558841"
                x2="188.052753"
                y2="151.624878"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5189"
                fill="url(#linearGradient93)"
                stroke="none"
                d="M 188.007263 155.392853 C 187.168579 155.474548 186.327591 155.556183 185.488907 155.637848 C 184.892029 155.079834 184.031418 154.12616 183.403366 152.727783 C 182.390945 150.470978 182.590302 148.405487 182.731873 147.514404 C 183.966339 147.538483 185.200806 147.562561 186.437561 147.5867 C 186.961563 150.188751 187.485565 152.790833 188.009598 155.390594 Z"
              />
              <linearGradient
                id="linearGradient94"
                x1="184.701121"
                y1="157.586064"
                x2="196.748556"
                y2="157.731488"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5190"
                fill="url(#linearGradient94)"
                stroke="none"
                d="M 196.759216 156.847992 C 196.527725 157.203278 196.298523 157.558533 196.067017 157.913757 C 194.858078 158.245728 193.277695 158.550262 191.420471 158.592102 C 188.840088 158.650452 186.715988 158.174988 185.264023 157.725983 C 185.08017 157.365723 184.896317 157.005463 184.712479 156.645233 C 188.728058 156.712036 192.743652 156.7789 196.759216 156.847992 Z"
              />
              <path
                id="path5191"
                fill="#1b6d3c"
                stroke="none"
                d="M 200.591934 157.233948 L 187.881317 157.080505 C 187.394836 157.074646 187.004898 156.675171 187.010773 156.18869 L 187.010773 156.18869 C 187.022308 155.23407 187.807297 154.467804 188.761902 154.47934 L 198.89093 154.601624 C 199.845535 154.613129 200.611801 155.398102 200.600296 156.352753 L 200.589645 157.233917 Z"
              />
              <path
                id="path5192"
                fill="#1b6d3c"
                stroke="none"
                d="M 190.065536 150.673767 L 181.113724 150.565704 C 180.384003 150.556915 179.759109 150.037537 179.618576 149.322083 L 176.24556 132.14856 C 176.167664 131.755157 176.472733 131.389343 176.874329 131.394196 L 184.001831 131.480225 C 185.341949 131.496399 186.487137 132.451202 186.744415 133.764832 L 190.065521 150.676056 Z"
              />
              <path
                id="path5193"
                fill="#2baf63"
                stroke="none"
                d="M 190.542862 150.679535 L 182.187668 150.578674 C 181.320251 150.568176 180.577209 149.95105 180.410797 149.097565 L 177.10051 132.239197 C 177.013992 131.802094 177.351669 131.397644 177.796829 131.403015 L 184.600784 131.485138 C 186.078598 131.503021 187.341965 132.555634 187.627411 134.004974 L 190.833969 150.32959 C 190.870789 150.511353 190.72876 150.679474 190.542877 150.677246 Z"
              />
              <path
                id="path5194"
                fill="#203b45"
                stroke="none"
                d="M 201.673721 166.484711 C 201.80159 166.539032 202.100983 166.643646 202.451141 166.725891 C 202.796707 166.808105 202.906982 166.797974 203.011383 166.89563 C 203.138504 167.011902 203.243271 167.267914 203.084198 167.897156 C 202.771255 167.964508 202.389587 168.021881 201.951141 168.028076 C 201.661926 168.031464 201.400528 168.012238 201.169052 167.984192 C 201.084045 167.80188 200.935669 167.545319 200.693207 167.287628 C 200.45752 167.039215 200.216156 166.880249 200.042908 166.784058 C 200.011673 166.898438 199.98703 167.038116 199.980515 167.19873 C 199.964966 167.535889 200.041977 167.809937 200.10643 167.985138 C 200.074081 168.003113 199.977142 168.047852 199.85347 168.025665 C 199.768723 168.010895 199.709518 167.97345 199.679962 167.950165 C 199.728683 167.716675 199.762604 167.37738 199.659271 167.002045 C 199.555939 166.626678 199.385269 166.50528 199.306015 166.226654 C 199.228973 165.954865 199.236465 165.523499 199.687408 164.861053 C 199.790314 164.892151 199.966354 164.949341 200.164658 165.06192 C 200.978455 165.521576 200.947586 166.177582 201.669128 166.48465 Z"
              />
              <path
                id="path5195"
                fill="#9e6354"
                stroke="none"
                d="M 194.39563 150.735199 C 196.810196 151.294525 199.224716 151.85614 201.639282 152.415466 C 201.535278 153.23584 201.440308 154.070099 201.35434 154.915924 C 200.997482 158.432281 200.835159 161.801788 200.821854 164.996399 C 201.114578 165.463562 201.405029 165.928345 201.697754 166.395508 C 201.759079 166.449036 201.852295 166.521301 201.97554 166.577881 C 202.167252 166.667419 202.3461 166.68103 202.345535 166.726929 C 202.345276 166.749878 202.299332 166.753906 202.211349 166.817139 C 202.153458 166.860016 202.123154 166.898651 202.106918 166.912231 C 202.04425 166.971161 201.869553 166.992004 201.579758 166.853088 C 201.080017 166.615234 200.686676 166.117065 200.242142 165.677948 C 199.965454 165.403778 199.722382 165.196564 199.56102 165.066101 C 199.589142 165.01593 199.619629 164.963531 199.647766 164.913361 C 199.065094 163.178131 198.679169 161.686249 198.419785 160.549347 C 198.140778 159.327301 197.915833 158.56723 197.900894 157.525085 C 197.885391 156.52652 198.028442 155.704315 198.159088 155.148193 L 193.031891 154.576813 C 193.485718 153.294708 193.93956 152.012665 194.393356 150.73288 Z"
              />
              <path
                id="path5196"
                fill="#874e3f"
                stroke="none"
                d="M 195.356796 154.958282 C 195.876389 154.881958 196.437653 154.778534 197.029175 154.638824 C 197.622986 154.499084 198.173416 154.340485 198.675735 154.176727 C 198.809128 154.534058 198.962997 154.905426 199.144302 155.286285 C 199.723938 156.511993 200.414276 157.502625 201.05899 158.279236 C 200.506119 156.358459 199.955521 154.437744 199.402649 152.516968 C 198.328659 152.127594 197.15593 152.313141 196.341843 153.017059 C 195.516174 153.73233 195.382813 154.703857 195.356812 154.956024 Z"
              />
              <path
                id="path5197"
                fill="#203b45"
                stroke="none"
                d="M 205.744247 162.760742 C 205.88179 162.773865 206.198395 162.784607 206.559036 162.759094 C 206.912766 162.733521 207.016571 162.691193 207.144348 162.75238 C 207.301819 162.825439 207.478302 163.036407 207.514053 163.68634 C 207.236725 163.845978 206.888138 164.013885 206.473373 164.151154 C 206.199158 164.241974 205.943665 164.303162 205.715958 164.344025 C 205.580048 164.195496 205.362152 163.993195 205.052094 163.821899 C 204.753464 163.655304 204.476685 163.576263 204.28212 163.534882 C 204.287567 163.654297 204.304214 163.794525 204.345963 163.948761 C 204.433853 164.273468 204.587021 164.513977 204.702271 164.662262 C 204.676697 164.689484 204.597824 164.759674 204.473663 164.778839 C 204.38858 164.791595 204.319962 164.772369 204.285706 164.758209 C 204.261017 164.521515 204.191635 164.185608 203.982132 163.859467 C 203.770325 163.533295 203.571457 163.466644 203.413712 163.226074 C 203.258194 162.990082 203.134674 162.57547 203.368835 161.809448 C 203.474426 161.808411 203.662582 161.812988 203.884628 161.859253 C 204.798035 162.053894 204.964783 162.689362 205.74649 162.76535 Z"
              />
              <path
                id="path5198"
                fill="#9e6354"
                stroke="none"
                d="M 194.081894 149.916687 C 196.163162 149.758179 198.244446 149.597412 200.325699 149.438934 C 200.989609 149.387238 201.585434 149.84201 201.710663 150.4953 C 201.794876 150.934692 201.883667 151.374115 201.974701 151.818176 C 202.687973 155.280884 203.543671 158.543335 204.486832 161.595734 C 204.904846 161.951904 205.3228 162.310425 205.740799 162.666595 C 205.816132 162.699646 205.925812 162.73996 206.061005 162.75766 C 206.27182 162.785461 206.446716 162.746246 206.457672 162.789978 C 206.464279 162.813049 206.420441 162.830872 206.357437 162.917297 C 206.315399 162.976471 206.296539 163.019836 206.287109 163.040405 C 206.244888 163.115631 206.083359 163.187134 205.764893 163.141968 C 205.2173 163.064209 204.691452 162.706726 204.137222 162.420044 C 203.790512 162.241425 203.498245 162.116241 203.304092 162.040466 C 203.316254 161.983246 203.328415 161.925995 203.340591 161.868774 C 202.266006 160.386932 201.448669 159.080353 200.859497 158.07489 C 200.227631 156.993164 199.785736 156.335999 199.458023 155.345184 C 199.143539 154.398102 199.034225 153.568268 198.992874 153.000885 C 197.436462 153.408966 195.880081 153.817047 194.323669 154.225189 C 194.103683 154.006744 193.569229 153.410492 193.410706 152.474457 C 193.18161 151.108429 193.942093 150.091705 194.077316 149.916595 Z"
              />
              <path
                id="path5199"
                fill="#2baf63"
                stroke="none"
                d="M 195.483826 157.172272 L 182.773209 157.01886 C 182.286728 157.013 181.89679 156.613495 181.902664 156.127014 L 181.902664 156.127014 C 181.9142 155.172424 182.699173 154.406158 183.653793 154.417694 L 193.782822 154.539948 C 194.737427 154.551453 195.503693 155.336456 195.492188 156.291046 L 195.481522 157.172272 Z"
              />
              <path
                id="path5200"
                fill="#1c343d"
                stroke="none"
                d="M 191.96283 139.329102 C 192.348999 140.419342 192.725449 141.555359 193.080688 142.73703 C 193.239639 143.259918 193.38945 143.778137 193.532425 144.291687 C 193.584671 144.335907 194.011932 144.685333 194.584854 144.56601 C 195.249802 144.427155 195.486984 143.791992 195.498871 143.75769 C 194.446243 138.936798 193.932526 137.193207 193.669785 136.714966 C 193.626633 136.487244 193.46283 135.796722 192.850418 135.385406 C 192.70929 135.289612 192.567764 135.225922 192.437454 135.183014 C 192.304703 135.913574 192.189682 136.697083 192.101624 137.526855 C 192.034393 138.152618 191.988129 138.753357 191.960526 139.329071 Z"
              />
              <path
                id="path5201"
                fill="#203b45"
                stroke="none"
                d="M 193.56279 147.098907 C 193.856812 147.648712 194.148514 148.200745 194.442535 148.750519 C 196.416046 148.962555 198.387253 149.17453 200.360764 149.386566 C 200.015396 150.238464 199.464935 151.349518 198.58345 152.504761 C 197.594666 153.803314 196.54422 154.694916 195.750061 155.270599 C 193.526093 155.46405 191.684189 155.377563 190.361496 155.246826 C 187.727539 154.990112 186.086502 154.805084 185.389359 153.617004 C 184.917114 152.812592 185.084198 151.898865 185.257599 150.842926 C 185.544922 149.095276 186.370056 147.854401 186.871246 147.213226 C 189.102539 147.173615 191.331543 147.136261 193.562836 147.096619 Z"
              />
              <path
                id="path5202"
                fill="#14252b"
                stroke="none"
                d="M 194.146194 148.012512 C 194.317947 148.425415 194.232712 148.640137 194.188141 148.71994 C 193.95343 149.150879 193.024979 149.254395 191.896637 148.804718 C 191.653503 148.983093 190.49617 149.79306 188.880615 149.587677 C 187.223816 149.377167 186.294083 148.255096 186.113235 148.025726 C 187.099945 147.661255 188.755646 147.201569 190.817535 147.318268 C 192.198227 147.396881 193.332779 147.711243 194.146255 148.007935 Z"
              />
              <path
                id="path5203"
                fill="#203b45"
                stroke="none"
                d="M 192.770493 135.352325 C 192.287521 135.055023 191.441162 134.631683 190.320084 134.530914 C 188.132935 134.334686 186.546494 135.520447 186.145599 135.839233 C 186.0616 138.993958 186.403214 140.735443 186.767258 141.75885 C 186.869354 142.046967 187.229691 142.996918 187.330872 144.310944 C 187.38446 145.004669 187.349945 145.582642 187.310898 145.965424 C 186.86441 146.639404 186.417908 147.313324 185.971451 147.984985 C 186.335114 148.278564 187.508865 149.148834 189.225342 149.169525 C 190.512695 149.185089 191.470825 148.714661 191.900696 148.467407 C 191.946136 148.506958 192.636612 149.105133 193.47966 148.853668 C 194.009399 148.697113 194.289658 148.29657 194.369202 148.171295 C 194.011108 147.416473 193.652969 146.66394 193.292572 145.909119 C 193.28717 144.834961 193.281815 143.758484 193.274124 142.684296 C 194.073532 141.674927 194.216431 140.864197 194.206909 140.320129 C 194.19162 139.496033 193.836838 139.037292 193.38858 137.765045 C 193.031342 136.748566 192.855804 135.890381 192.768204 135.352295 Z"
              />
              <path
                id="path5204"
                fill="#203b45"
                stroke="none"
                d="M 186.802551 139.975983 C 186.390152 141.05661 185.986389 142.183197 185.602722 143.355957 C 185.431213 143.874847 185.268951 144.389282 185.113617 144.899231 C 185.060303 144.9422 184.624725 145.281189 184.054871 145.148071 C 183.393463 144.993195 183.171692 144.352509 183.160629 144.317932 C 183.450241 142.760773 183.872711 141.0354 184.493881 139.199951 C 184.81041 138.265076 185.1492 137.387848 185.496414 136.572693 C 185.543945 136.437866 185.64537 136.211853 185.856735 136.003265 C 186.174988 135.685822 186.545532 135.600769 186.692688 135.577301 C 186.673538 136.40329 186.676834 137.270874 186.70723 138.175507 C 186.729584 138.795471 186.761337 139.397156 186.804779 139.980621 Z"
              />
              <path
                id="path5205"
                fill="#203b45"
                stroke="none"
                d="M 184.104874 143.096893 C 185.032669 143.238892 186.258255 143.428131 187.183777 143.56781 C 188.285706 143.734894 189.522751 143.924255 190.62468 144.091309 C 190.663223 144.130829 190.946396 144.437195 190.886032 144.874817 C 190.840744 145.204742 190.624924 145.401825 190.56694 145.451599 C 189.867676 145.580872 189.06781 145.679077 188.186234 145.700592 C 186.237137 145.74823 184.595657 145.409363 183.397385 145.04834 C 183.374756 145.020538 182.974747 144.506195 183.19577 143.877686 C 183.421494 143.240112 184.075012 143.098846 184.104935 143.092285 Z"
              />
              <path
                id="path5206"
                fill="#ffd3a6"
                stroke="none"
                d="M 189.873734 143.937683 C 189.764755 144.030457 189.551132 144.234406 189.441544 144.568176 C 189.248566 145.153412 189.531647 145.659454 189.583405 145.744995 C 189.965164 145.680756 190.349243 145.614227 190.731003 145.549988 C 190.821747 145.447815 190.947754 145.274902 191.026459 145.030273 C 191.167191 144.58902 191.052429 144.208954 191.003586 144.072968 C 190.627747 144.02713 190.251892 143.983551 189.873734 143.937683 Z"
              />
              <path
                id="path5207"
                fill="#1c343d"
                stroke="none"
                d="M 194.487808 142.529083 C 195.398499 142.755859 196.602081 143.057251 197.510498 143.283936 C 198.590515 143.554016 199.807861 143.855591 200.887909 144.123413 C 200.921829 144.165131 201.177139 144.498718 201.075562 144.928955 C 200.998184 145.253937 200.766556 145.430145 200.704041 145.475281 C 199.996384 145.540192 199.190536 145.562592 198.309921 145.503784 C 196.36528 145.372406 194.762329 144.882599 193.599792 144.414124 C 193.579498 144.384033 193.228088 143.835846 193.508514 143.231049 C 193.79361 142.617126 194.455582 142.535614 194.487732 142.533691 Z"
              />
              <path
                id="path5208"
                fill="#b8d6ff"
                stroke="none"
                d="M 200.14032 143.882599 C 200.012009 144.05545 199.862183 144.299225 199.741409 144.607605 C 199.580292 145.025665 199.539063 145.399292 199.531387 145.653931 C 199.919617 145.624176 200.305557 145.594421 200.693787 145.564667 C 200.79361 145.469513 200.935547 145.310516 201.034775 145.075348 C 201.214325 144.650635 201.136429 144.259521 201.099091 144.11908 C 200.778748 144.039459 200.460663 143.962189 200.14032 143.882599 Z"
              />
              <path
                id="path5209"
                fill="#14252b"
                stroke="none"
                d="M 185.514297 143.26767 C 185.535614 143.21286 185.208023 142.972504 184.818237 142.940247 C 184.485779 142.9133 184.174347 143.044952 184.180542 143.102417 C 184.184586 143.148346 184.389099 143.127869 184.923019 143.196289 C 185.365295 143.252075 185.504715 143.299683 185.516571 143.2677 Z"
              />
              <g id="g72">
                <path
                  id="path5210"
                  fill="#874e3f"
                  stroke="none"
                  d="M 203.519073 145.181091 C 203.587524 145.404541 203.344116 145.605865 203.381592 145.923004 C 203.385849 145.950623 203.394241 146.014954 203.361847 146.037537 C 203.317886 146.066833 203.206223 146.001251 203.149796 145.922516 C 203.052734 145.788208 203.107697 145.607574 203.119583 145.573303 C 203.076202 145.554413 203.021545 145.519318 202.973984 145.465973 C 202.82692 145.292084 202.830658 144.982269 202.962509 144.896637 C 203.110565 144.799774 203.450546 144.964539 203.516754 145.18335 Z"
                />
                <path
                  id="path5211"
                  fill="#9e6354"
                  stroke="none"
                  d="M 202.051056 145.301056 C 202.247665 145.365417 202.405228 145.431549 202.519348 145.483429 C 202.900497 145.660156 202.945328 145.750214 202.956085 145.807739 C 202.966934 145.860626 202.961182 145.95697 202.900909 146.006744 C 202.757202 146.124329 202.513062 145.813843 201.961227 145.708496 C 201.69104 145.657013 201.578094 145.696991 201.333817 145.58844 C 201.169449 145.51535 201.051254 145.422089 200.97406 145.352325 C 200.882034 145.369568 200.789993 145.38913 200.700287 145.406403 C 200.669601 145.286682 200.639557 145.114166 200.655807 144.907837 C 200.685242 144.561646 200.828262 144.310883 200.910065 144.187958 C 201.92067 144.314911 202.654007 144.406372 202.961273 144.428467 C 203.0186 144.431427 203.153915 144.439941 203.290649 144.521942 C 203.329361 144.545349 203.395386 144.589752 203.589447 144.865204 C 203.749664 145.092041 203.830887 145.207794 203.852585 145.31131 C 203.87851 145.444763 203.834961 145.439636 203.859406 145.696991 C 203.869629 145.800385 203.880356 145.862488 203.843201 145.898773 C 203.794434 145.94635 203.689148 145.92215 203.632126 145.891632 C 203.415543 145.771942 203.48526 145.320648 203.487793 145.300049 C 203.349075 145.195099 203.208038 145.090088 203.069305 144.985138 C 202.883011 145.017334 202.696701 145.051788 202.510406 145.083984 C 202.355759 145.155548 202.203461 145.224854 202.048828 145.296448 Z"
                />
              </g>
              <g id="g73">
                <path
                  id="path5212"
                  fill="#9e6354"
                  stroke="none"
                  d="M 192.030457 145.324677 C 191.855637 145.356995 191.634995 145.381866 191.384964 145.371979 C 191.22438 145.365448 191.080017 145.345367 190.954102 145.320892 C 190.862137 145.333557 190.770157 145.348511 190.675903 145.361145 C 190.631195 145.261902 190.559967 145.079742 190.565109 144.843384 C 190.568802 144.538208 190.6931 144.317078 190.751633 144.221375 C 191.113602 144.276245 191.409302 144.305054 191.61795 144.323639 C 192.076492 144.361298 192.529922 144.444824 192.985947 144.503113 C 193.052399 144.510803 193.18071 144.528412 193.310486 144.614899 C 193.346893 144.640594 193.410568 144.689545 193.590744 144.97403 C 193.739365 145.2099 193.81369 145.32785 193.828476 145.433624 C 193.847519 145.566956 193.80397 145.561829 193.814636 145.819 C 193.817993 145.922333 193.82872 145.984436 193.786987 146.018341 C 193.735977 146.06134 193.633026 146.034851 193.57608 145.999756 C 193.366501 145.868683 193.459106 145.422272 193.463943 145.401672 C 193.329895 145.289886 193.195816 145.178101 193.064056 145.066345 C 192.87558 145.089325 192.689407 145.112335 192.500931 145.135284 C 192.344101 145.197662 192.187286 145.26001 192.028152 145.324646 Z"
                />
                <path
                  id="path5213"
                  fill="#9e6354"
                  stroke="none"
                  d="M 193.602417 145.908264 C 193.528656 145.934906 193.420486 145.958832 193.326965 145.911835 C 193.18779 145.843597 193.187454 145.680634 193.056534 145.500031 C 192.99556 145.416687 192.891281 145.309845 192.701843 145.222626 C 192.751572 145.285187 192.814743 145.375458 192.863724 145.5 C 192.894958 145.576111 192.984177 145.790619 192.916992 145.84259 C 192.872955 145.876495 192.777115 145.831757 192.729324 145.799042 C 192.615463 145.724213 192.600647 145.620728 192.544464 145.521393 C 192.391663 145.251007 192.088257 145.288666 192.078293 145.162292 C 192.066345 145.013 192.468506 144.779144 192.865051 144.820679 C 192.933807 144.828369 193.185928 144.856659 193.392227 145.067993 C 193.718689 145.402466 193.611984 145.876221 193.602386 145.910553 Z"
                />
                <path
                  id="path5214"
                  fill="#9e6354"
                  stroke="none"
                  d="M 194.201385 145.532227 C 194.245453 145.493713 194.216843 145.392395 194.165726 145.254059 C 194.027954 144.878326 193.956772 144.691559 193.815918 144.572815 C 193.634125 144.421417 193.436615 144.432831 193.007538 144.425354 C 192.706924 144.421722 192.271027 144.407257 191.725327 144.363953 C 192.563431 144.711456 193.009674 144.81781 193.266373 144.846161 C 193.360352 144.856506 193.484222 144.862579 193.600174 144.953491 C 193.800247 145.10965 193.753769 145.347778 193.979279 145.48822 C 194.043076 145.527985 194.152664 145.575226 194.199066 145.534454 Z"
                />
              </g>
              <path
                id="path5215"
                fill="#ffd3a6"
                stroke="none"
                d="M 188.474976 139.842438 C 189.021301 139.835236 189.567642 139.825775 190.113953 139.818604 C 190.135483 139.935913 190.154739 140.053192 190.1763 140.168213 C 189.629868 140.18457 189.083481 140.198608 188.537033 140.214996 C 188.515579 140.09079 188.496429 139.966614 188.474976 139.842438 Z"
              />
              <path
                id="path5216"
                fill="#c27e67"
                stroke="none"
                d="M 192.104233 130.086212 C 192.563187 130.091766 193.022125 130.097321 193.481079 130.102844 C 193.477707 130.192322 193.474319 130.281799 193.470963 130.368958 C 193.044571 130.329376 192.620453 130.289825 192.194031 130.252533 C 192.164856 130.197113 192.133362 130.143951 192.104202 130.088501 Z"
              />
              <path
                id="path5217"
                fill="#3d221d"
                stroke="none"
                d="M 187.663452 129.688354 C 187.57338 129.735474 187.252136 129.919769 187.086624 130.321716 C 186.939972 130.682556 187.007248 131.002411 187.033524 131.108276 C 186.844574 131.170288 186.704987 131.326965 186.679794 131.512543 C 186.652252 131.702698 186.753784 131.846222 186.776352 131.878662 C 186.609955 131.975311 186.50914 132.150818 186.523071 132.327728 C 186.53476 132.5 186.650482 132.609253 186.680008 132.634857 C 186.578949 132.831024 186.592224 133.062958 186.716415 133.232025 C 186.865433 133.435791 187.149109 133.510345 187.398224 133.407776 C 187.411728 133.430878 187.51091 133.578979 187.701035 133.608826 C 187.916397 133.641235 188.067291 133.498474 188.081268 133.482605 C 188.071106 133.562775 188.062668 133.691223 188.106888 133.831726 C 188.431549 134.884521 191.140106 135.233917 191.536331 134.543335 C 191.616028 134.404266 191.595093 134.23877 191.555359 134.107483 C 191.576004 134.107697 191.860611 134.106537 192.010239 133.878876 C 192.092087 133.753632 192.08905 133.625061 192.087357 133.574554 C 192.202713 133.525452 192.359833 133.437836 192.455902 133.273773 C 192.690323 132.868073 192.373505 132.30423 192.223038 132.031616 C 191.477203 130.696014 188.114166 129.806244 187.663452 129.688354 Z"
              />
              <path
                id="path5218"
                fill="#291713"
                stroke="none"
                d="M 187.934128 131.410645 C 187.873611 131.481049 187.761856 131.612823 187.784988 131.787506 C 187.816528 132.026611 188.072281 132.135284 188.085999 132.140015 C 188.076401 132.174347 188.059326 132.256744 188.09729 132.344421 C 188.146393 132.459778 188.271713 132.534729 188.41626 132.538757 C 188.406601 132.577667 188.367737 132.756195 188.469223 132.904327 C 188.595535 133.087128 188.877228 133.136444 189.020676 133.041779 C 189.326019 132.843506 189.033279 131.997681 189.004379 131.919312 C 188.906723 131.64502 188.751343 131.207062 188.430511 131.168762 C 188.171524 131.138092 187.950455 131.390167 187.931854 131.410614 Z"
              />
              <path
                id="path5219"
                fill="#ffd3a6"
                stroke="none"
                d="M 190.663666 134.397369 C 191.240814 134.686615 191.815689 134.975861 192.392822 135.267395 C 191.86026 136.036713 191.325363 136.808289 190.792801 137.577606 C 189.656754 136.815704 188.520706 136.053772 187.384659 135.291901 C 187.706451 135.061646 188.23819 134.742188 188.963501 134.546692 C 189.668076 134.357819 190.273926 134.362823 190.661362 134.397339 Z"
              />
              <path
                id="path5220"
                fill="#e8bb92"
                stroke="none"
                d="M 190.894592 134.090302 C 191.049515 134.18399 191.231583 134.31012 191.420074 134.477631 C 191.585815 134.626526 191.717133 134.774994 191.818817 134.907043 C 192.178772 135.508118 192.538742 136.109192 192.901001 136.710297 C 192.798584 136.637878 192.188507 136.224304 191.440384 136.408051 C 191.074371 136.497742 190.824127 136.694366 190.691833 136.816711 C 190.54158 136.716217 189.953857 136.351105 189.167542 136.465546 C 188.613464 136.546051 188.238266 136.826141 188.080566 136.961914 C 188.0177 136.655914 187.96524 136.249054 187.989349 135.771942 C 188.00798 135.370544 188.076416 135.024811 188.150833 134.754883 C 188.28093 134.623383 188.464172 134.462616 188.706924 134.316376 C 188.991287 134.145386 189.258591 134.056793 189.454285 134.006348 C 189.935928 134.032867 190.415283 134.059296 190.896896 134.088074 Z"
              />
              <path
                id="path5221"
                fill="#9e6354"
                stroke="none"
                d="M 188.597275 131.232758 C 188.675125 131.628448 188.742813 132.10434 188.76384 132.643951 C 188.78978 133.346527 188.731934 133.956329 188.652664 134.439667 C 189.331863 135.212097 190.013367 135.984589 190.692581 136.754761 C 190.815201 136.483154 190.943161 136.149567 191.04422 135.76297 C 191.150101 135.357971 191.202713 134.991394 191.227097 134.684174 C 191.208038 134.550842 191.195969 134.410675 191.190903 134.259155 C 191.171661 133.760895 191.243439 133.330261 191.332474 132.987091 C 190.599823 132.080872 189.869263 131.569397 189.540314 131.441528 C 189.236511 131.32309 188.934158 131.27356 188.934158 131.27356 C 188.815048 131.253723 188.702744 131.240906 188.599533 131.235077 Z"
              />
              <path
                id="path5222"
                fill="#874e3f"
                stroke="none"
                d="M 191.259293 133.537018 C 191.106186 134.051544 190.888748 134.193512 190.752792 134.237762 C 190.123764 134.443634 189.030518 133.367798 188.762421 132.191803 C 188.681717 131.84198 188.687729 131.534515 188.70874 131.314423 C 188.841721 131.325226 188.972412 131.335968 189.105408 131.346741 C 189.824127 132.076111 190.542847 132.807678 191.261597 133.537048 Z"
              />
              <path
                id="path5223"
                fill="#9e6354"
                stroke="none"
                d="M 189.033844 127.767853 C 188.832016 128.137207 188.563385 128.716919 188.432602 129.472717 C 188.314178 130.157501 188.168655 130.995758 188.598633 131.879974 C 189.028641 132.761871 189.763168 133.133392 190.488586 133.500153 C 191.033798 133.775269 191.366058 133.818298 191.64505 133.711487 C 191.813339 133.649261 191.929367 133.545105 192.087616 133.363403 C 192.54837 132.838776 193.137131 132.168854 193.14917 131.170624 C 193.151505 130.977905 193.134445 130.679321 193.017136 130.319855 C 193.084122 130.095764 193.137955 129.818695 193.139481 129.501984 C 193.151627 128.494598 192.644119 127.758636 192.413589 127.464386 C 192.190384 127.321686 191.652405 127.019135 190.913345 127.021667 C 189.882813 127.025299 189.198624 127.616058 189.029221 127.770111 Z"
              />
              <path
                id="path5224"
                fill="#ffffff"
                stroke="none"
                d="M 192.017563 130.229767 C 192.048706 130.312775 192.120224 130.471985 192.252258 130.560791 C 192.450333 130.694 192.703751 130.614471 192.894958 130.364288 C 192.924744 130.178741 192.890305 129.990143 192.774277 129.906128 C 192.603638 129.78244 192.235352 129.869751 192.015289 130.229767 Z"
              />
              <path
                id="path5225"
                fill="#692624"
                stroke="none"
                d="M 192.350662 130.203949 C 192.348511 130.382935 192.456909 130.528839 192.594604 130.530518 C 192.732285 130.532166 192.844177 130.388916 192.846329 130.20993 C 192.848495 130.030945 192.740097 129.88504 192.602417 129.883392 C 192.464722 129.881744 192.352829 130.024963 192.350662 130.203949 Z"
              />
              <path
                id="path5226"
                fill="#2e1d17"
                stroke="none"
                d="M 192.426239 130.218628 C 192.42485 130.333344 192.50177 130.426117 192.59584 130.427246 C 192.689941 130.428406 192.769058 130.337524 192.770447 130.222778 C 192.771835 130.108063 192.694916 130.01532 192.600845 130.014191 C 192.506744 130.013062 192.427628 130.103882 192.426239 130.218628 Z"
              />
              <path
                id="path5227"
                fill="#ffffff"
                stroke="none"
                d="M 189.881454 130.178741 C 189.924057 130.261871 190.023132 130.421448 190.207947 130.510895 C 190.481735 130.644989 190.829239 130.566559 191.091599 130.317291 C 191.087692 130.259857 191.069153 130.085205 190.942337 129.943665 C 190.942337 129.943665 190.854004 129.846222 190.726059 129.798767 C 190.488403 129.713257 190.153778 129.865295 189.881485 130.176422 Z"
              />
              <path
                id="path5228"
                fill="#692624"
                stroke="none"
                d="M 190.361465 130.152405 C 190.359299 130.33139 190.49295 130.4776 190.66275 130.479614 C 190.832565 130.481689 190.969696 130.338745 190.971863 130.15976 C 190.97403 129.980774 190.840378 129.834564 190.670563 129.83252 C 190.500748 129.830475 190.363632 129.973389 190.361465 130.152405 Z"
              />
              <path
                id="path5229"
                fill="#2e1d17"
                stroke="none"
                d="M 190.462448 130.151337 C 190.46106 130.266083 190.547165 130.358887 190.655014 130.360229 C 190.762863 130.361511 190.851166 130.270782 190.852554 130.156036 C 190.853943 130.041321 190.767853 129.948456 190.659988 129.947174 C 190.552139 129.945831 190.463837 130.036591 190.462448 130.151337 Z"
              />
              <path
                id="path5230"
                fill="#ffffff"
                stroke="none"
                d="M 190.669983 130.071198 C 190.768906 130.051758 190.849472 130.032074 190.909317 130.016724 C 190.971481 130.001404 191.003708 129.992615 191.006256 129.971985 C 191.008896 129.944489 190.954224 129.909393 190.908417 129.901947 C 190.787018 129.882141 190.681671 130.052979 190.669952 130.073486 Z"
              />
              <path
                id="path5231"
                fill="#2e1d17"
                stroke="none"
                d="M 189.883789 130.176453 C 189.883789 130.176453 189.902344 130.160614 189.932526 130.131134 C 189.964996 130.104034 190.009094 130.063232 190.066956 130.022614 C 190.124817 129.981995 190.191895 129.939178 190.268021 129.90799 C 190.34642 129.876801 190.427017 129.854858 190.516617 129.846741 C 190.603989 129.834015 190.686523 129.841919 190.759644 129.868042 C 190.796188 129.882233 190.830429 129.898712 190.862305 129.919739 C 190.891907 129.938477 190.919144 129.96405 190.944107 129.987305 C 190.991714 130.036072 191.025528 130.086975 191.045746 130.123932 C 191.068237 130.160919 191.077148 130.184021 191.077148 130.184021 C 191.077148 130.184021 191.077438 130.158722 191.068832 130.112762 C 191.060165 130.069031 191.042572 130.004547 190.999786 129.937469 C 190.979553 129.902802 190.952408 129.870361 190.918365 129.837799 C 190.886597 129.807617 190.845657 129.777283 190.802307 129.756073 C 190.713364 129.709106 190.601028 129.698578 190.502197 129.711151 C 190.453918 129.717468 190.405624 129.726044 190.35495 129.741516 C 190.30658 129.754669 190.260406 129.777069 190.218826 129.79953 C 190.133362 129.844391 190.066071 129.905548 190.017197 129.962341 C 189.966003 130.019104 189.933228 130.073792 189.912109 130.112549 C 189.890991 130.151337 189.881485 130.176422 189.881485 130.176422 Z"
              />
              <path
                id="path5232"
                fill="#ffffff"
                stroke="none"
                d="M 192.610291 130.181854 C 192.713806 130.162445 192.801239 130.142822 192.863403 130.127502 C 192.927841 130.112213 192.964676 130.103485 192.967224 130.082886 C 192.969849 130.055359 192.912888 130.020233 192.862488 130.012756 C 192.734192 129.992859 192.621979 130.163635 192.607971 130.184113 Z"
              />
              <path
                id="path5233"
                fill="#2e1d17"
                stroke="none"
                d="M 192.900558 130.091248 C 192.937286 130.091675 192.983185 130.092255 193.036041 130.085999 C 193.079712 130.079651 193.118866 130.068634 193.148804 130.059845 C 193.14621 130.085022 193.136307 130.144592 193.089722 130.201416 C 193.026825 130.278687 192.941696 130.296021 192.918732 130.298035 C 192.912674 130.229095 192.906616 130.160156 192.900528 130.093536 Z"
              />
              <path
                id="path5234"
                fill="#2e1d17"
                stroke="none"
                d="M 190.074615 129.958435 C 190.035522 129.964874 189.948181 129.975281 189.852386 129.925934 C 189.804474 129.902405 189.770416 129.872131 189.747772 129.846649 C 189.74057 129.871765 189.726089 129.931274 189.74588 130.002686 C 189.776688 130.11322 189.86792 130.160217 189.883911 130.167297 C 189.949005 130.096954 190.01181 130.028839 190.07692 129.958466 Z"
              />
              <path
                id="path5235"
                fill="#3d221d"
                stroke="none"
                d="M 191.11557 129.282501 C 191.017441 129.235413 190.889526 129.185669 190.736038 129.160858 C 190.337479 129.096375 190.014557 129.230194 189.876022 129.299652 C 189.975677 129.218262 190.214188 129.042114 190.568146 129.000458 C 190.795685 128.973358 190.983383 129.014648 191.097733 129.048157 C 191.147995 129.067139 191.179581 129.113434 191.181229 129.166229 C 191.180649 129.214417 191.157181 129.257751 191.11557 129.282501 Z"
              />
              <path
                id="path5236"
                fill="#3d221d"
                stroke="none"
                d="M 192.29277 129.296722 C 192.355286 129.251556 192.438477 129.204346 192.539734 129.182617 C 192.797455 129.126068 193.000031 129.266205 193.088669 129.338409 C 193.027695 129.255066 192.876114 129.074219 192.649475 129.025604 C 192.502975 128.993988 192.383179 129.031555 192.309372 129.062805 C 192.277023 129.08078 192.255814 129.126434 192.252869 129.179169 C 192.252289 129.227356 192.265533 129.271118 192.29277 129.296722 Z"
              />
              <path
                id="path5237"
                fill="#7d483a"
                stroke="none"
                d="M 191.384491 131.530334 C 191.359695 131.493317 191.335098 131.440216 191.335876 131.375946 C 191.337143 131.270416 191.40683 131.202393 191.388641 131.186127 C 191.372757 131.17215 191.280441 131.21463 191.256638 131.285492 C 191.230484 131.360931 191.279739 131.462494 191.384521 131.528015 Z"
              />
              <path
                id="path5238"
                fill="#3d221d"
                stroke="none"
                d="M 188.006454 130.17218 C 188.22377 130.422668 188.538177 130.424164 188.65451 130.29245 C 188.738235 130.20166 188.735703 130.031769 188.666428 129.877167 C 188.731888 129.776978 188.799957 129.651581 188.852264 129.500732 C 188.98056 129.139648 188.96611 128.815887 188.940872 128.625092 C 189.044678 128.582733 189.194763 128.5065 189.336441 128.368225 C 189.60817 128.102966 189.676285 127.782471 189.693848 127.658752 C 189.727982 127.684418 189.914505 127.822083 190.158279 127.781433 C 190.383636 127.745117 190.573944 127.570709 190.643341 127.335144 C 190.73938 127.363831 190.897293 127.400177 191.094879 127.384216 C 191.283249 127.370422 191.428513 127.314789 191.518509 127.272278 C 191.579834 127.325806 191.700378 127.416748 191.881088 127.467133 C 192.050369 127.512787 192.195099 127.500763 192.273315 127.485626 C 192.37114 127.557983 192.489273 127.658081 192.604675 127.794891 C 192.765305 127.987335 192.859375 128.178955 192.910522 128.314972 C 193.048981 128.25238 193.117081 128.124664 193.08844 128.025635 C 193.068619 127.956543 193.004776 127.921326 192.979706 127.907288 C 192.94252 127.755341 192.878174 127.573242 192.767929 127.388336 C 192.419296 126.801178 191.845978 126.573914 191.62883 126.500153 C 191.547867 126.36145 191.410156 126.171631 191.182388 126.02887 C 190.524124 125.612396 189.739426 125.974731 189.667831 126.01059 C 189.624435 125.993988 188.996185 125.754608 188.456772 126.140564 C 188.06781 126.420441 187.982422 126.839417 187.967499 126.935638 C 187.872757 126.989594 187.715347 127.100128 187.614288 127.296295 C 187.454468 127.606506 187.50473 128.006439 187.732605 128.332794 C 187.69812 128.336975 187.57399 128.353851 187.513184 128.447174 C 187.431366 128.570129 187.479233 128.788757 187.66803 128.928741 C 187.616867 128.983185 187.558502 129.065125 187.520462 129.174805 C 187.406448 129.494751 187.568146 129.788177 187.599579 129.845947 C 187.587799 129.871063 187.540695 129.971466 187.583176 130.063782 C 187.636871 130.179169 187.817383 130.245636 188.004196 130.169861 Z"
              />
              <path
                id="path5239"
                fill="#522e27"
                stroke="none"
                d="M 188.741135 126.160034 C 188.824036 126.135803 189.1026 126.065735 189.410828 126.197998 C 189.655151 126.30191 189.790756 126.475677 189.842621 126.552032 C 189.928284 126.491089 190.04306 126.487885 190.134232 126.541809 C 190.225372 126.595673 190.274612 126.699554 190.261856 126.804962 C 190.294296 126.78009 190.579132 126.570129 190.947449 126.668671 C 191.304306 126.76474 191.447495 127.071747 191.467667 127.110992 C 191.484039 127.085938 191.561264 126.962952 191.528732 126.806488 C 191.509232 126.709869 191.454941 126.644928 191.430054 126.614807 C 191.526016 126.650391 191.624283 126.686005 191.720276 126.719299 C 191.634628 126.589722 191.514725 126.445984 191.346375 126.322327 C 190.697998 125.848572 189.882828 126.072845 189.746948 126.112518 C 189.687744 126.072784 189.464508 125.934692 189.165665 125.97467 C 188.949585 126.001892 188.803711 126.108002 188.741135 126.160034 Z"
              />
              <path
                id="path5240"
                fill="#d4957f"
                stroke="none"
                d="M 187.923218 130.033478 C 188.471664 130.04007 189.0224 130.046722 189.570847 130.053345 C 189.555786 130.161041 189.540741 130.266449 189.523361 130.374084 C 188.989365 130.312561 188.453033 130.253296 187.919006 130.191772 C 187.919662 130.138977 187.920288 130.086212 187.920898 130.035706 Z"
              />
              <path
                id="path5241"
                fill="#f0bead"
                stroke="none"
                d="M 190.648712 131.262115 C 190.825348 131.268829 191.004517 131.257202 191.179276 131.229492 L 191.195343 131.229675 C 191.195343 131.229675 191.207016 131.213776 191.207016 131.213776 C 191.369629 131.050476 191.491257 130.86145 191.56723 130.651215 C 191.610001 130.530121 191.636795 130.401886 191.647568 130.27121 L 191.648071 130.229889 C 191.648071 130.229889 191.611511 130.215698 191.611511 130.215698 C 191.17717 130.072723 190.728348 129.989288 190.276443 129.970062 C 190.026413 129.960175 189.780716 129.968658 189.539444 129.993317 L 189.495773 129.997345 L 189.490677 130.040924 C 189.469879 130.242615 189.483521 130.442444 189.531647 130.638123 C 189.564499 130.769318 189.61116 130.896118 189.673981 131.016235 L 189.682968 131.03241 L 189.701248 131.03952 C 190.00029 131.171661 190.316132 131.246613 190.637253 131.261963 L 190.648712 131.262115 Z M 191.146103 131.125824 C 190.982834 131.151398 190.817474 131.160858 190.654602 131.154297 L 190.643143 131.154175 C 190.340378 131.139038 190.04512 131.071198 189.762009 130.948456 C 189.708237 130.839935 189.666 130.726959 189.637558 130.611847 C 189.595978 130.443817 189.581985 130.271545 189.595566 130.097229 C 189.818466 130.074707 190.043457 130.068237 190.265961 130.077789 C 190.701797 130.096832 191.127777 130.173126 191.541565 130.306671 C 191.528824 130.412079 191.506882 130.517365 191.471283 130.615662 C 191.402405 130.807617 191.294769 130.978424 191.150696 131.125854 Z"
              />
              <path
                id="path5242"
                fill="#f0bead"
                stroke="none"
                d="M 191.533966 130.556702 C 191.560928 130.602936 191.594803 130.649261 191.622421 130.6427 C 191.656982 130.631653 191.641907 130.548828 191.688538 130.489716 C 191.749176 130.410126 191.889282 130.40033 191.941254 130.467529 C 191.986496 130.523163 191.959991 130.626129 191.996552 130.64032 C 192.014816 130.64743 192.035675 130.631622 192.047287 130.62027 C 192.038574 130.581177 192.029877 130.542053 192.021164 130.50293 C 192.022385 130.401947 192.021332 130.298645 192.020264 130.197662 C 191.97908 130.185699 191.928741 130.173615 191.871384 130.172913 C 191.738342 130.166748 191.632263 130.206757 191.567627 130.238129 C 191.557159 130.345856 191.544373 130.453552 191.53389 130.56131 Z"
              />
              <path
                id="path5243"
                fill="#7d483a"
                stroke="none"
                d="M 192.263275 131.55011 C 192.263275 131.55011 192.316528 131.511749 192.352112 131.415771 C 192.366425 131.370026 192.383331 131.301392 192.349823 131.22525 C 192.336441 131.192963 192.300262 131.148895 192.268326 131.132477 L 192.190811 131.087921 C 192.120132 131.050354 192.070602 130.969421 192.03717 130.888672 C 192.003677 130.810242 191.979156 130.750275 191.979156 130.750275 C 191.979156 130.750275 191.946335 130.807281 191.940598 130.903595 C 191.940018 130.951782 191.939285 131.011475 191.963776 131.07373 C 191.977188 131.103729 191.992844 131.138336 192.017746 131.166168 C 192.044922 131.19635 192.072174 131.219604 192.10408 131.238342 L 192.181671 131.276031 C 192.199875 131.287689 192.204514 131.285461 192.218079 131.301697 C 192.238449 131.32489 192.256348 131.364105 192.258163 131.403168 C 192.266373 131.483582 192.265579 131.55014 192.265579 131.55014 Z"
              />
              <path
                id="path5244"
                fill="#9e6354"
                stroke="none"
                d="M 188.444366 130.400085 C 188.176285 130.174225 187.853821 130.078522 187.65506 130.193176 C 187.343048 130.373016 187.385559 131.034515 187.696259 131.343506 C 187.820969 131.468933 188.098801 131.649017 188.302231 131.527557 C 188.415497 131.460083 188.467529 131.332153 188.491348 131.261322 C 188.476456 130.974243 188.461533 130.689484 188.444336 130.402405 Z"
              />
              <path
                id="path5245"
                fill="#874e3f"
                stroke="none"
                d="M 188.333252 131.238739 C 188.28476 131.263397 188.204071 131.294556 188.105499 131.28421 C 187.89003 131.260956 187.683853 131.040405 187.673187 130.783234 C 187.667831 130.656921 187.709412 130.444 187.847809 130.385986 C 187.988541 130.325714 188.191498 130.433746 188.282639 130.678131 C 188.275681 130.684906 188.152512 130.811981 188.18013 130.995911 C 188.203491 131.152252 188.317337 131.227081 188.333252 131.238739 Z"
              />
              <path
                id="path5246"
                fill="#944e3d"
                stroke="none"
                d="M 191.926331 132.464081 C 191.935257 132.487122 191.990845 132.634705 191.918488 132.734833 C 191.843811 132.837158 191.687912 132.823822 191.56636 132.81546 C 191.525085 132.812683 191.353195 132.792236 191.180267 132.668518 C 191.036926 132.565796 190.960419 132.438629 190.924591 132.364777 C 191.110123 132.394531 191.304901 132.419861 191.513535 132.438446 C 191.65567 132.45163 191.793274 132.460175 191.926331 132.464081 Z"
              />
              <path
                id="path5247"
                fill="#7a4232"
                stroke="none"
                d="M 192.037933 132.346069 C 192.037933 132.346069 191.959091 132.22348 191.830582 132.221924 C 191.764023 132.22113 191.713181 132.250366 191.692337 132.266174 C 191.658142 132.247406 191.598831 132.216858 191.5186 132.209015 C 191.307739 132.185791 191.197769 132.358887 190.977524 132.351654 C 190.929352 132.351074 190.856049 132.338715 190.767166 132.28714 C 190.814911 132.324463 190.87413 132.361847 190.942581 132.394836 C 191.175354 132.505524 191.39798 132.50589 191.526627 132.493683 C 191.572266 132.517212 191.615585 132.540649 191.661194 132.564178 C 191.677322 132.559784 191.700348 132.553162 191.725784 132.537415 C 191.746567 132.526154 191.762802 132.512604 191.774429 132.501251 C 191.831406 132.534058 191.902542 132.534912 191.958038 132.498901 C 192.041306 132.447113 192.040192 132.348389 192.040253 132.343842 Z"
              />
              <path
                id="path5248"
                fill="#874e3f"
                stroke="none"
                d="M 190.810059 132.15683 C 190.801041 132.142944 190.74115 132.160583 190.704071 132.189972 C 190.650772 132.232941 190.631531 132.306152 190.645172 132.315491 C 190.670197 132.334167 190.828094 132.182312 190.810074 132.15451 Z"
              />
              <path
                id="path5249"
                fill="#f2b8bd"
                stroke="none"
                d="M 191.4767 132.637665 C 191.48381 132.619415 191.44754 132.582214 191.408691 132.567993 C 191.376709 132.556122 191.330811 132.555573 191.32373 132.571533 C 191.31665 132.587555 191.346161 132.615448 191.371231 132.629486 C 191.412262 132.652954 191.46962 132.653656 191.47673 132.635376 Z"
              />
              <path
                id="path5250"
                fill="#2e1d17"
                stroke="none"
                d="M 192.045639 130.186493 C 192.045639 130.186493 192.061859 130.172913 192.089706 130.14801 C 192.117554 130.123108 192.156937 130.091461 192.205551 130.057617 C 192.254166 130.023773 192.314209 129.99234 192.381027 129.970215 C 192.415604 129.959167 192.4478 129.952667 192.486938 129.94397 C 192.523758 129.935211 192.560516 129.931091 192.594955 129.931488 C 192.629364 129.931915 192.663788 129.932312 192.693481 129.944153 C 192.723175 129.955994 192.748306 129.965485 192.775558 129.988739 C 192.821014 130.026031 192.854721 130.08609 192.872437 130.13913 C 192.890121 130.194397 192.896408 130.244965 192.900574 130.279449 C 192.904739 130.316223 192.90448 130.336853 192.90448 130.336853 C 192.90448 130.336853 192.916183 130.318634 192.928085 130.282074 C 192.940018 130.245514 192.954422 130.192871 192.950668 130.123962 C 192.946884 130.055115 192.924942 129.972198 192.859253 129.900269 C 192.829803 129.867767 192.786591 129.835114 192.738617 129.818451 C 192.690613 129.801819 192.640198 129.794342 192.592026 129.793762 C 192.543793 129.795471 192.497803 129.804108 192.45636 129.815063 C 192.417221 129.823792 192.371109 129.841583 192.334183 129.859497 C 192.25798 129.897583 192.195374 129.949615 192.153442 130.001923 C 192.109222 130.051849 192.083405 130.099762 192.069214 130.134003 C 192.05275 130.168243 192.047897 130.188843 192.047897 130.188843 Z"
              />
              <path
                id="path5251"
                fill="#f0bead"
                stroke="none"
                d="M 192.384415 131.211884 C 192.572525 131.218781 192.763092 131.211884 192.94931 131.186584 C 193.06424 131.171936 193.179214 131.152649 193.289703 131.126434 L 193.312744 131.119843 L 193.324448 131.099335 C 193.427475 130.930725 193.491638 130.747894 193.516922 130.55542 C 193.537155 130.399567 193.532196 130.24118 193.49733 130.086975 L 193.488617 130.047852 L 193.447311 130.047363 C 193.378586 130.037323 193.302917 130.03186 193.224915 130.028595 C 192.977173 130.018707 192.726822 130.034058 192.48082 130.070129 C 192.324463 130.093475 192.165695 130.128265 192.013702 130.170044 L 191.974548 130.181061 L 191.974091 130.220062 C 191.960068 130.43103 191.99881 130.64267 192.08374 130.831879 C 192.141861 130.961121 192.21843 131.08136 192.315842 131.188141 L 192.33168 131.206665 L 192.382172 131.207275 Z M 193.238083 131.029419 C 193.136841 131.051147 193.03566 131.068298 192.93219 131.083099 C 192.752899 131.106201 192.569199 131.113159 192.387985 131.106354 L 192.387985 131.106354 C 192.306503 131.011292 192.241196 130.907227 192.189758 130.796448 C 192.115997 130.632599 192.081451 130.450897 192.085938 130.269623 C 192.221817 130.232239 192.359848 130.204041 192.500107 130.182831 C 192.736938 130.146667 192.980377 130.133514 193.221237 130.143311 C 193.280899 130.144043 193.340515 130.149353 193.393234 130.154572 C 193.416901 130.285706 193.419907 130.416534 193.402237 130.549438 C 193.379547 130.718994 193.324799 130.881287 193.235764 131.031677 Z"
              />
            </g>
            <g id="g74">
              <linearGradient
                id="linearGradient95"
                x1="281.816222"
                y1="162.072439"
                x2="283.603832"
                y2="162.094018"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5252"
                fill="url(#linearGradient95)"
                stroke="none"
                d="M 282.632416 168.419006 L 282.632416 168.419006 C 282.139008 168.413055 281.744568 168.008972 281.750519 167.515564 L 281.881897 156.631592 C 281.887848 156.138214 282.291962 155.743744 282.785339 155.749695 L 282.785339 155.749695 C 283.278717 155.755646 283.673157 156.15976 283.667206 156.653137 L 283.535828 167.53714 C 283.529877 168.030518 283.125793 168.424957 282.632416 168.419006 Z"
              />
              <linearGradient
                id="linearGradient96"
                x1="277.176865"
                y1="167.288245"
                x2="288.113641"
                y2="167.420263"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5253"
                fill="url(#linearGradient96)"
                stroke="none"
                d="M 277.181396 166.914215 L 288.118164 167.046234 L 288.109161 167.792023 L 277.172394 167.660004 Z"
              />
              <g id="g75">
                <linearGradient
                  id="linearGradient97"
                  x1="275.628649"
                  y1="167.588573"
                  x2="278.290558"
                  y2="167.620705"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5254"
                  fill="url(#linearGradient97)"
                  stroke="none"
                  d="M 278.290558 167.620697 C 278.281677 168.355774 277.678619 168.944458 276.943542 168.935608 C 276.208496 168.926697 275.619781 168.323639 275.628662 167.588593 C 275.637512 166.853516 276.240601 166.264801 276.975677 166.273682 C 277.710754 166.282532 278.299438 166.88562 278.290558 167.620697 Z"
                />
                <linearGradient
                  id="linearGradient98"
                  x1="286.992248"
                  y1="167.725743"
                  x2="289.654157"
                  y2="167.757875"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5255"
                  fill="url(#linearGradient98)"
                  stroke="none"
                  d="M 289.654144 167.757874 C 289.645294 168.49295 289.042206 169.081635 288.307129 169.072754 C 287.572052 169.063873 286.983368 168.460785 286.992218 167.725769 C 287.001129 166.990692 287.604218 166.401978 288.339264 166.410858 C 289.074341 166.419708 289.663055 167.022797 289.654144 167.757874 Z"
                />
              </g>
            </g>
            <path
              id="path5256"
              fill="#235c6b"
              stroke="none"
              d="M 279.738129 143.907013 C 278.940735 143.419983 277.885834 142.778442 277.08844 142.291412 C 276.140656 141.713074 275.076691 141.062225 274.128937 140.483887 C 274.07608 140.490143 273.660095 140.540222 273.428345 140.913818 C 273.252777 141.196259 273.288361 141.483582 273.301208 141.559448 C 273.751312 142.106537 274.297333 142.693787 274.958191 143.277832 C 276.413757 144.564575 277.882263 145.358063 279.028412 145.851563 C 279.065216 145.845123 279.697998 145.70816 279.930389 145.088989 C 280.167542 144.458435 279.760742 143.932556 279.740387 143.907043 Z"
            />
            <path
              id="path5257"
              fill="#b8d6ff"
              stroke="none"
              d="M 274.822266 140.848022 C 274.787567 141.061035 274.72226 141.335663 274.587799 141.636963 C 274.40387 142.043274 274.168579 142.334229 273.994232 142.518005 C 273.743011 142.22348 273.494171 141.926727 273.24295 141.632202 C 273.23999 141.496765 273.254059 141.283478 273.350983 141.04599 C 273.52597 140.621185 273.856812 140.402588 273.983887 140.330658 C 274.26413 140.501587 274.542053 140.674774 274.822266 140.845703 Z"
            />
            <path
              id="path5258"
              fill="#fcc6ae"
              stroke="none"
              d="M 274.039215 140.69165 C 274.006165 140.578827 273.928986 140.509033 273.89035 140.47641 C 273.806 140.239014 273.634491 139.80777 273.409821 139.598511 C 273.396179 139.584534 273.328125 139.51947 273.237213 139.444916 C 273.130402 139.356445 273.062103 139.312012 272.91452 139.179413 C 272.392242 138.71637 272.210754 138.351532 272.104553 138.400757 C 272.037659 138.432098 272.046936 138.611206 272.080048 138.721802 C 272.121887 138.866882 272.212891 138.934509 272.35788 139.092346 C 272.439423 139.180573 272.550323 139.310394 272.669891 139.481689 C 272.576324 139.436951 272.427948 139.37088 272.249939 139.286102 C 271.672577 139.015228 271.608734 138.980042 271.464722 138.932373 C 271.064697 138.796753 270.612946 138.763733 270.591461 138.834625 C 270.557922 138.951294 271.759766 139.397247 271.745605 139.429199 C 271.731415 139.46347 270.434509 138.910767 270.340668 139.079468 C 270.305481 139.141022 270.443726 139.287262 270.614044 139.436218 C 270.608856 139.486633 270.610168 139.566986 270.641266 139.652283 C 270.694702 139.790619 270.803955 139.865387 270.869965 139.909821 C 271.213776 140.138885 271.653839 140.378265 271.724518 140.415833 C 271.223236 140.306519 271.110657 140.314362 271.101135 140.344055 C 271.072479 140.433228 272.011047 140.825562 272.529388 141.042938 C 272.917603 141.205994 273.242004 141.331543 273.459045 141.41452 C 273.498108 141.408081 273.792389 141.365723 273.95166 141.099152 C 273.991486 141.033051 274.092102 140.875885 274.036926 140.69162 Z"
            />
            <linearGradient
              id="linearGradient99"
              x1="286.312018"
              y1="161.144412"
              x2="289.27385"
              y2="144.125397"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
              <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
            </linearGradient>
            <path
              id="path5259"
              fill="url(#linearGradient99)"
              stroke="none"
              d="M 284.838776 156.563995 C 285.672974 156.665863 286.507141 156.767761 287.341339 156.869629 C 287.949158 156.32843 288.8302 155.400391 289.489502 154.022095 C 290.551361 151.7995 290.404144 149.736755 290.284058 148.847107 C 289.053986 148.841431 287.823883 148.835754 286.59375 148.830109 C 286.009521 151.409607 285.425293 153.986816 284.838745 156.566315 Z"
            />
            <linearGradient
              id="linearGradient100"
              x1="276.075802"
              y1="158.684456"
              x2="288.077342"
              y2="158.829326"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
              <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
            </linearGradient>
            <path
              id="path5260"
              fill="url(#linearGradient100)"
              stroke="none"
              d="M 276.086426 157.805542 C 276.306976 158.16629 276.527588 158.524658 276.750427 158.885376 C 277.946411 159.24408 279.512115 159.586609 281.36319 159.673187 C 283.932251 159.793701 286.060303 159.371857 287.515808 158.957947 C 287.708282 158.602264 287.900726 158.24884 288.093231 157.893127 C 284.093262 157.86322 280.091003 157.833252 276.091034 157.805634 Z"
            />
            <path
              id="path5261"
              fill="#1b6d3c"
              stroke="none"
              d="M 272.259277 158.096741 L 284.921722 158.249603 C 285.405914 158.255463 285.803009 157.867767 285.808868 157.383575 L 285.808868 157.383575 C 285.820404 156.431274 285.058655 155.650909 284.106323 155.639404 L 274.014008 155.517578 C 273.061737 155.506104 272.281372 156.267853 272.269867 157.220154 L 272.259277 158.096741 Z"
            />
            <path
              id="path5262"
              fill="#1b6d3c"
              stroke="none"
              d="M 282.901642 151.817322 L 291.819031 151.924957 C 292.546478 151.933777 293.179108 151.431885 293.336853 150.72229 L 297.108887 133.69931 C 297.196198 133.310181 296.902344 132.937134 296.500763 132.932312 L 289.400818 132.846588 C 288.065247 132.830475 286.901978 133.752808 286.61319 135.055237 L 282.899353 151.817291 Z"
            />
            <path
              id="path5263"
              fill="#2baf63"
              stroke="none"
              d="M 282.426636 151.811615 L 290.749725 151.912079 C 291.614807 151.922516 292.36792 151.325714 292.55484 150.481079 L 296.25882 133.771667 C 296.353577 133.33902 296.028046 132.926575 295.585144 132.921265 L 288.806488 132.839417 C 287.333221 132.821655 286.0495 133.838928 285.731476 135.276398 L 282.146332 151.457062 C 282.107422 151.637909 282.243042 151.809387 282.426636 151.811615 Z"
            />
            <path
              id="path5264"
              fill="#313b3d"
              stroke="none"
              d="M 270.959564 167.282043 C 270.830414 167.333282 270.530884 167.430634 270.178833 167.504425 C 269.83374 167.576019 269.723663 167.565491 269.617004 167.658325 C 269.487091 167.771484 269.37619 168.022614 269.52005 168.653198 C 269.82901 168.728058 270.209167 168.794617 270.64505 168.811371 C 270.931793 168.821716 271.193573 168.808807 271.42337 168.786346 C 271.512756 168.60611 271.664978 168.35318 271.913574 168.10376 C 272.155182 167.861084 272.39801 167.710236 272.573547 167.618256 C 272.601959 167.733368 272.62323 167.873627 272.625916 168.032013 C 272.633362 168.367188 272.549744 168.639282 272.481079 168.812866 C 272.513 168.831604 272.608826 168.878662 272.730682 168.859497 C 272.815765 168.846741 272.875854 168.81076 272.905945 168.788177 C 272.862885 168.553558 272.837158 168.215851 272.949493 167.845398 C 273.061859 167.472687 273.235382 167.357727 273.319 167.083313 C 273.402588 166.813507 273.405487 166.384369 272.9729 165.713562 C 272.869263 165.742126 272.691956 165.795105 272.490967 165.902832 C 271.66864 166.340424 271.686005 166.994751 270.957245 167.282013 Z"
            />
            <path
              id="path5265"
              fill="#f7b9a5"
              stroke="none"
              d="M 278.587463 151.772156 C 276.16925 152.273102 273.751129 152.77182 271.332916 153.272766 C 271.417145 154.09314 271.492035 154.924866 271.557526 155.770233 C 271.829559 159.282715 271.908386 162.639069 271.846985 165.823914 C 271.54541 166.281586 271.243835 166.739258 270.939972 167.19458 C 270.87735 167.246643 270.78244 167.314331 270.657837 167.370209 C 270.464081 167.452789 270.287201 167.464447 270.286652 167.510315 C 270.286377 167.533264 270.332184 167.538391 270.416351 167.603699 C 270.473175 167.64798 270.502563 167.685059 270.518433 167.701324 C 270.579651 167.761719 270.753784 167.786774 271.044556 167.654877 C 271.547638 167.429138 271.95285 166.942902 272.403229 166.516846 C 272.686432 166.25174 272.932129 166.050476 273.094299 165.923859 C 273.067383 165.873077 273.038208 165.819946 273.011292 165.769104 C 273.63327 164.055298 274.055054 162.577789 274.339447 161.452026 C 274.647827 160.241669 274.888672 159.49176 274.928772 158.452576 C 274.968292 157.45929 274.845123 156.636169 274.727875 156.079315 L 279.846741 155.633911 C 279.426208 154.345886 279.003387 153.06012 278.582855 151.772064 Z"
            />
            <path
              id="path5266"
              fill="#f29d83"
              stroke="none"
              d="M 277.52713 155.954742 C 277.01178 155.865936 276.455505 155.749023 275.869781 155.597382 C 275.28183 155.44339 274.73761 155.273865 274.24173 155.098053 C 274.102051 155.449799 273.939301 155.815063 273.74884 156.191467 C 273.142151 157.398224 272.432709 158.36969 271.76947 159.125916 C 272.36618 157.225891 272.960602 155.325867 273.557281 153.428162 C 274.635742 153.067078 275.801392 153.278503 276.593689 153.999542 C 277.397308 154.729919 277.507202 155.702057 277.52713 155.954742 Z"
            />
            <path
              id="path5267"
              fill="#313b3d"
              stroke="none"
              d="M 266.996002 163.474854 C 266.858185 163.48468 266.543701 163.487732 266.186096 163.453613 C 265.833069 163.419495 265.732635 163.374695 265.603394 163.4328 C 265.446503 163.502075 265.264954 163.70871 265.213593 164.352997 C 265.48703 164.516968 265.829163 164.693237 266.23819 164.840454 C 266.507843 164.937805 266.761841 165.002838 266.988495 165.049194 C 267.127899 164.903992 267.348328 164.709259 267.660156 164.545502 C 267.962708 164.3862 268.238983 164.313812 268.434479 164.279449 C 268.426178 164.396362 268.406128 164.538452 268.360687 164.689362 C 268.267303 165.011841 268.10611 165.246307 267.989594 165.389496 C 268.014557 165.415039 268.091675 165.48938 268.215363 165.509247 C 268.30011 165.524048 268.369171 165.506531 268.403778 165.493164 C 268.434143 165.257141 268.509308 164.925262 268.728912 164.606598 C 268.948517 164.285645 269.146576 164.226044 269.31012 163.989349 C 269.468964 163.757172 269.602448 163.347961 269.38913 162.578827 C 269.283569 162.575226 269.097656 162.575317 268.874573 162.616211 C 267.959076 162.786469 267.779327 163.415466 266.998352 163.472595 Z"
            />
            <path
              id="path5268"
              fill="#fcc6ae"
              stroke="none"
              d="M 278.920807 150.963715 C 276.853149 150.755157 274.783234 150.546539 272.715546 150.337982 C 272.055389 150.270355 271.45108 150.710602 271.31012 151.358398 C 271.215393 151.793304 271.118286 152.230499 271.016602 152.669922 C 270.222412 156.100677 269.292938 159.330109 268.278778 162.347382 C 267.854614 162.69342 267.428131 163.039429 267.003967 163.385437 C 266.927856 163.416656 266.819519 163.454376 266.681641 163.46875 C 266.472534 163.491486 266.298615 163.44809 266.284302 163.491516 C 266.277161 163.514374 266.320526 163.533264 266.38147 163.621216 C 266.422058 163.681396 266.43985 163.725189 266.448853 163.743683 C 266.489227 163.819885 266.648956 163.895264 266.966156 163.857758 C 267.513153 163.793213 268.045135 163.450806 268.603851 163.177521 C 268.952484 163.007324 269.24765 162.891541 269.441315 162.818146 L 269.408966 162.64563 C 270.514313 161.196991 271.360657 159.912781 271.969269 158.926361 C 272.624725 157.862488 273.080017 157.220764 273.431519 156.242706 C 273.766418 155.305756 273.895691 154.483398 273.950714 153.919464 C 275.492218 154.36264 277.031464 154.805847 278.572998 155.251312 C 278.795868 155.038269 279.344543 154.457367 279.523285 153.529999 C 279.785217 152.174469 279.051727 151.144318 278.920776 150.966034 Z"
            />
            <path
              id="path5269"
              fill="#2baf63"
              stroke="none"
              d="M 277.34906 158.158173 L 290.011475 158.311035 C 290.495667 158.316895 290.892822 157.929199 290.898651 157.445038 L 290.898651 157.445038 C 290.910156 156.492706 290.148407 155.712341 289.196075 155.700867 L 279.10376 155.579041 C 278.151489 155.567535 277.371124 156.329254 277.35965 157.281586 L 277.34906 158.158173 Z"
            />
            <path
              id="path5270"
              fill="#633828"
              stroke="none"
              d="M 280.264954 129.541565 C 280.376526 130.945221 280.407074 132.600311 280.247101 134.443665 C 280.049683 136.729431 279.612793 138.697937 279.148468 140.278259 C 280.02066 140.653717 281.26413 141.072632 282.800018 141.224304 C 285.170288 141.457184 287.081451 140.943176 288.164795 140.556915 C 288.235291 138.138763 288.0383 135.065552 287.08786 131.666565 C 286.751251 130.459839 286.358368 129.355743 285.943542 128.354706 C 284.049927 128.749512 282.156311 129.144379 280.262726 129.539246 Z"
            />
            <path
              id="path5271"
              fill="#235c6b"
              stroke="none"
              d="M 281.282837 140.471558 C 280.870483 141.549866 280.471405 142.671936 280.08783 143.837799 C 279.91864 144.354431 279.754059 144.868866 279.601044 145.374207 C 279.54776 145.417175 279.114502 145.756195 278.544617 145.623077 C 277.885468 145.470551 277.663696 144.829834 277.652649 144.795258 C 278.816528 140.019501 279.369781 138.295685 279.641724 137.823883 L 280.14798 136.9487 L 280.14798 136.9487 C 280.357635 136.694153 280.570831 136.524597 280.70282 136.42749 C 280.894928 137.054077 281.076294 137.809052 281.182953 138.673309 C 281.264465 139.332977 281.289307 139.939178 281.280579 140.471558 Z"
            />
            <path
              id="path5272"
              fill="#633828"
              stroke="none"
              d="M 280.32843 128.846924 C 279.894623 129.231842 279.685669 129.619476 279.578979 129.902771 C 279.076508 131.218689 279.726013 132.931763 281.188171 134.246155 C 281.024536 134.113373 279.536438 132.853729 279.701202 130.994415 C 279.772919 130.187408 280.128967 129.590424 280.360107 129.267303 C 280.350311 129.127197 280.340546 128.984741 280.33075 128.844666 Z"
            />
            <path
              id="path5273"
              fill="#4f2513"
              stroke="none"
              d="M 285.834808 132.039276 C 286.200287 132.183685 286.373596 132.656281 286.394745 132.996216 C 286.434601 133.6875 285.875214 134.39682 284.979401 134.647644 C 285.098297 134.685822 285.281342 134.731628 285.506409 134.718262 C 285.873901 134.69519 286.135193 134.533051 286.248657 134.451813 C 286.072235 134.80542 285.852753 134.926727 285.735138 134.973511 C 285.05246 135.249847 283.972961 134.557465 283.868011 133.746033 C 283.740051 132.746124 285.117615 131.75293 285.83255 132.036957 Z"
            />
            <path
              id="path5274"
              fill="#313b3d"
              stroke="none"
              d="M 279.503021 148.173035 C 279.198151 148.713287 278.893219 149.255829 278.586029 149.796082 C 276.617157 149.96051 274.646027 150.124908 272.677124 150.289337 C 273.001892 151.147034 273.523132 152.26413 274.371918 153.437988 C 275.324585 154.753082 276.348602 155.667419 277.128662 156.262085 C 279.338135 156.509094 281.177002 156.46701 282.495575 156.368164 C 285.123474 156.174988 286.763885 156.03183 287.487152 154.865479 C 287.976379 154.075012 287.831329 153.162109 287.683411 152.106873 C 287.440582 150.35965 286.647858 149.103882 286.162262 148.453094 C 283.941742 148.359741 281.721191 148.268677 279.502991 148.175323 Z"
            />
            <path
              id="path5275"
              fill="#232a2b"
              stroke="none"
              d="M 278.900085 149.067719 C 278.718414 149.476318 278.798462 149.690735 278.841095 149.771576 C 279.06308 150.20575 279.986481 150.331635 281.123016 149.911621 C 281.359528 150.093475 282.49469 150.928802 284.107819 150.764679 C 285.764587 150.596466 286.716522 149.499451 286.900513 149.276764 C 285.925171 148.890869 284.290222 148.391449 282.233002 148.460724 C 280.857697 148.506104 279.71817 148.79071 278.900085 149.067719 Z"
            />
            <path
              id="path5276"
              fill="#313b3d"
              stroke="none"
              d="M 280.573547 136.490234 C 281.063538 136.20694 281.915283 135.804108 283.033875 135.730408 C 285.215912 135.589203 286.768738 136.806 287.159576 137.132019 C 287.167511 140.276337 286.784058 142.002228 286.397766 143.011993 C 286.288757 143.297577 285.907959 144.233948 285.775146 145.540558 C 285.704803 146.230499 285.725433 146.806824 285.755219 147.188171 C 286.183075 147.870361 286.61322 148.550323 287.041046 149.232544 C 286.67041 149.517242 285.48291 150.354401 283.773315 150.333771 C 282.49057 150.318268 281.548645 149.82724 281.124878 149.569641 C 281.078491 149.608124 280.376068 150.187195 279.541626 149.917755 C 279.018097 149.748505 278.747559 149.343597 278.671082 149.216431 C 279.047241 148.475067 279.421143 147.731384 279.797302 146.990021 C 279.828583 145.91861 279.859863 144.849457 279.893463 143.778076 C 279.123199 142.754364 278.997559 141.942688 279.020142 141.401276 C 279.055328 140.580078 279.418732 140.132324 279.895233 138.875763 C 280.276917 137.870544 280.470734 137.021423 280.571259 136.487885 Z"
            />
            <path
              id="path5277"
              fill="#424f52"
              stroke="none"
              d="M 281.849884 142.931854 C 282.437592 142.349121 283.12677 141.723999 283.928436 141.097931 C 284.716156 140.483154 285.475128 139.971344 286.17337 139.546021 C 286.299225 139.198639 286.455139 138.640564 286.447479 137.942749 C 286.439026 137.313812 286.302826 136.807251 286.182892 136.475311 C 285.848389 136.239441 285.419769 136.002472 284.89386 135.840057 C 282.975464 135.245453 281.255096 136.117462 280.772217 136.382446 C 280.536743 136.877625 280.303192 137.402679 280.076202 137.953033 C 279.931946 138.304779 279.794647 138.651978 279.668945 138.990082 C 279.800079 139.533325 280.027985 140.238373 280.434204 141.000671 C 280.894257 141.864563 281.428192 142.502167 281.847565 142.934113 Z"
            />
            <path
              id="path5278"
              fill="#235c6b"
              stroke="none"
              d="M 282.70047 135.590942 C 282.118774 135.866241 281.539398 136.141541 280.957733 136.41449 C 280.812225 136.871765 280.68866 137.409637 280.642334 138.017242 C 280.4711 140.223053 281.402771 141.946442 281.900543 142.72818 C 282.057556 142.461578 282.291809 142.067352 282.591278 141.595886 C 283.290833 140.488922 283.766693 139.856628 284.348297 139.016754 C 284.747711 138.438629 285.306274 137.607666 285.943207 136.559631 C 285.629333 136.324036 285.105469 135.991791 284.389679 135.7789 C 283.692169 135.57309 283.088623 135.565796 282.7005 135.588654 Z"
            />
            <path
              id="path5279"
              fill="#1b4652"
              stroke="none"
              d="M 282.47699 135.280731 C 282.319855 135.368317 282.134796 135.490021 281.944611 135.655273 C 281.77533 135.80014 281.642731 135.945404 281.537933 136.072662 C 281.163605 136.662567 280.791565 137.252502 280.417206 137.842407 C 280.521362 137.772552 281.138916 137.376068 281.877808 137.577728 C 282.239258 137.676208 282.48465 137.878845 282.611725 138.002045 C 282.764343 137.905182 283.358398 137.55661 284.137115 137.687653 C 284.689117 137.781525 285.055115 138.070557 285.209534 138.207825 C 285.279755 137.905701 285.34201 137.500244 285.329407 137.024994 C 285.320465 136.62323 285.260345 136.280579 285.194763 136.008942 C 285.07016 135.874329 284.890839 135.709198 284.651672 135.559418 C 284.37149 135.383911 284.108734 135.286652 283.916595 135.233826 L 282.479309 135.280731 Z"
            />
            <path
              id="path5280"
              fill="#633828"
              stroke="none"
              d="M 284.737274 127.706696 C 284.513947 127.57547 284.237762 127.4505 283.910461 127.373108 C 282.644928 127.073242 281.56778 127.705139 281.255524 127.90564 C 281.020416 127.990021 280.830841 128.104797 280.673187 128.235992 C 278.790283 129.833618 280.950745 134.901947 281.069122 135.171906 C 282.292603 132.68277 283.516083 130.195892 284.737274 127.706696 Z"
            />
            <path
              id="path5281"
              fill="#ffeac4"
              stroke="none"
              d="M 281.684601 131.146881 C 281.061218 131.263306 280.440155 131.37973 279.816772 131.496155 L 279.814392 131.693512 C 280.444946 131.55423 281.07547 131.412628 281.708313 131.273407 C 281.699646 131.231995 281.693268 131.190613 281.684601 131.146881 Z"
            />
            <path
              id="path5282"
              fill="#f7b9a5"
              stroke="none"
              d="M 284.833344 132.488525 C 284.745972 132.882233 284.666809 133.354034 284.635101 133.890717 C 284.592224 134.590179 284.635345 135.198914 284.703003 135.681671 C 284.00766 136.435272 283.312347 137.186554 282.614716 137.940094 C 282.498718 137.665558 282.381104 137.33136 282.289398 136.942413 C 282.193298 136.537292 282.149536 136.169556 282.132599 135.861816 C 282.154846 135.731262 282.170319 135.589172 282.179016 135.440063 C 282.210236 134.944733 282.148926 134.512482 282.068146 134.169556 C 282.820099 133.285828 283.558197 132.792145 283.890137 132.672211 C 284.194397 132.563416 284.497894 132.51889 284.497894 132.51889 C 284.615143 132.501953 284.727722 132.491821 284.833344 132.488525 Z"
            />
            <path
              id="path5283"
              fill="#f29d83"
              stroke="none"
              d="M 282.127991 134.72113 C 282.268646 135.239197 282.480347 135.384033 282.617462 135.43161 C 283.239075 135.652527 284.353333 134.607941 284.649719 133.44104 C 284.738831 133.093262 284.740204 132.788055 284.724487 132.567505 C 284.593597 132.575104 284.460388 132.582703 284.329468 132.590302 C 283.595673 133.299805 282.864136 134.009338 282.130341 134.718842 Z"
            />
            <path
              id="path5284"
              fill="#fcc6ae"
              stroke="none"
              d="M 284.482666 129.027893 C 284.675537 129.399719 284.927795 129.985687 285.040344 130.739868 C 285.142242 131.425018 285.267517 132.264252 284.816345 133.133209 C 284.367523 134.002228 283.626556 134.353607 282.894806 134.70282 C 282.345398 134.964722 282.012238 134.997406 281.738129 134.88623 C 281.5737 134.819977 281.460236 134.713043 281.306396 134.529846 C 280.860718 133.996643 280.288269 133.314941 280.302582 132.319061 C 280.304932 132.126312 280.329132 131.830536 280.452789 131.476288 C 280.393494 131.250641 280.346344 130.97467 280.350159 130.65799 C 280.362274 129.655182 280.885071 128.93396 281.120361 128.645325 C 281.346954 128.508057 281.889771 128.220825 282.626221 128.241211 C 283.654083 128.269684 284.321533 128.874451 284.482605 129.032471 Z"
            />
            <path
              id="path5285"
              fill="#ffffff"
              stroke="none"
              d="M 281.451935 131.40802 C 281.418793 131.490234 281.343475 131.645416 281.209351 131.730988 C 281.008179 131.857086 280.759033 131.773773 280.573853 131.521362 C 280.548584 131.335144 280.587555 131.14743 280.705566 131.066223 C 280.876892 130.946655 281.245209 131.042877 281.451935 131.40802 Z"
            />
            <path
              id="path5286"
              fill="#a8dcff"
              stroke="none"
              d="M 281.129486 131.312317 C 281.12735 131.491302 281.015472 131.632263 280.877777 131.630585 C 280.740112 131.628937 280.631714 131.483032 280.63382 131.306335 C 280.635956 131.129669 280.747833 130.986389 280.885559 130.988068 C 281.023224 130.989746 281.131622 131.135651 281.129486 131.312317 Z"
            />
            <path
              id="path5287"
              fill="#2e1d17"
              stroke="none"
              d="M 281.053619 131.322906 C 281.052246 131.437622 280.975433 131.528473 280.879028 131.527313 C 280.782684 131.526154 280.708038 131.433472 280.709412 131.318726 C 280.710785 131.203979 280.787628 131.113129 280.884033 131.114258 C 280.980377 131.115417 281.054993 131.20816 281.053619 131.322906 Z"
            />
            <path
              id="path5288"
              fill="#ffffff"
              stroke="none"
              d="M 280.870483 131.283966 C 280.790405 131.262329 280.724121 131.240875 280.673828 131.224182 C 280.623535 131.20752 280.5961 131.198029 280.594055 131.177307 C 280.592102 131.14978 280.638428 131.115906 280.677521 131.109467 C 280.778717 131.092346 280.861542 131.265472 280.870483 131.283966 Z"
            />
            <path
              id="path5289"
              fill="#2e1d17"
              stroke="none"
              d="M 281.422638 131.364044 C 281.422638 131.364044 281.406738 131.350098 281.381775 131.324554 C 281.354553 131.298981 281.315948 131.266357 281.268158 131.231384 C 281.220398 131.196381 281.161133 131.163513 281.097137 131.139801 C 281.062836 131.127899 281.030823 131.120636 280.991913 131.110992 C 280.955322 131.101379 280.918671 131.096344 280.884216 131.095917 C 280.849823 131.09552 280.815399 131.095093 280.785431 131.106201 C 280.755463 131.11731 280.730103 131.12619 280.704559 131.148834 C 280.658264 131.184998 280.623138 131.241943 280.604126 131.296814 C 280.585114 131.349365 280.577606 131.39978 280.572601 131.436432 C 280.567566 131.473083 280.567291 131.493744 280.567291 131.493744 C 280.567291 131.493744 280.556061 131.47522 280.545013 131.438385 C 280.533997 131.40152 280.520844 131.348572 280.526276 131.279785 C 280.531677 131.213318 280.555664 131.128662 280.623047 131.05835 C 280.653259 131.026581 280.697266 130.994965 280.743347 130.979492 C 280.791748 130.963989 280.842316 130.957703 280.888184 130.958282 C 280.93634 130.961151 280.982147 130.970886 281.023315 130.982849 C 281.062225 130.992493 281.10788 131.011414 281.144379 131.030212 C 281.219635 131.07016 281.280945 131.123657 281.321655 131.174652 C 281.364624 131.225647 281.387024 131.274109 281.402649 131.308746 C 281.418304 131.343353 281.422638 131.364044 281.422638 131.364044 Z"
            />
            <path
              id="path5290"
              fill="#ffffff"
              stroke="none"
              d="M 283.6185 131.408936 C 283.573914 131.490997 283.471069 131.645844 283.286407 131.730835 C 283.01181 131.856018 282.66626 131.771545 282.409973 131.51825 C 282.415253 131.460968 282.437958 131.289093 282.568146 131.150665 C 282.568146 131.150665 282.658813 131.055359 282.787842 131.013306 C 283.027496 130.933594 283.356079 131.093628 283.620758 131.411255 Z"
            />
            <path
              id="path5291"
              fill="#a8dcff"
              stroke="none"
              d="M 283.167236 131.336914 C 283.16507 131.5159 283.027985 131.656555 282.860474 131.65451 C 282.692932 131.652496 282.559296 131.506317 282.561432 131.32962 C 282.563538 131.152924 282.700684 131.009979 282.868195 131.011993 C 283.035706 131.014008 283.169373 131.160217 283.167236 131.336914 Z"
            />
            <path
              id="path5292"
              fill="#2e1d17"
              stroke="none"
              d="M 283.066315 131.333405 C 283.064911 131.44812 282.976593 131.538879 282.868744 131.537567 C 282.760895 131.536285 282.674805 131.443451 282.676178 131.328674 C 282.677582 131.213959 282.7659 131.12323 282.873718 131.124542 C 282.981598 131.125824 283.067657 131.218658 283.066315 131.333405 Z"
            />
            <path
              id="path5293"
              fill="#ffffff"
              stroke="none"
              d="M 282.863037 131.248352 C 282.766907 131.226501 282.686859 131.204865 282.62738 131.18811 C 282.565643 131.171295 282.5336 131.161743 282.531555 131.141052 C 282.529602 131.113464 282.585083 131.079742 282.631073 131.073395 C 282.75061 131.056488 282.854065 131.229858 282.865356 131.248383 Z"
            />
            <path
              id="path5294"
              fill="#2e1d17"
              stroke="none"
              d="M 283.616241 131.406586 C 283.616241 131.406586 283.598053 131.39032 283.568604 131.360107 C 283.536774 131.332184 283.493683 131.290375 283.436798 131.250641 C 283.379913 131.208679 283.313873 131.166565 283.238556 131.133514 C 283.160919 131.100433 283.083191 131.076569 282.991486 131.066284 C 282.904449 131.051453 282.821747 131.057343 282.748016 131.081696 C 282.711151 131.095032 282.678833 131.110687 282.644135 131.130951 C 282.614105 131.148926 282.586243 131.173859 282.56073 131.196472 C 282.511932 131.24411 282.476929 131.294159 282.455811 131.330627 C 282.432465 131.367065 282.422974 131.389923 282.422974 131.389923 C 282.422974 131.389923 282.423309 131.364685 282.432983 131.321167 C 282.442719 131.277679 282.461823 131.213654 282.506226 131.147614 C 282.527283 131.113434 282.552917 131.081635 282.590057 131.049957 C 282.622528 131.020508 282.664215 130.99118 282.708038 130.971039 C 282.798096 130.926208 282.908356 130.918396 283.009155 130.93338 C 283.057281 130.940857 283.105347 130.950592 283.155609 130.967285 C 283.203644 130.981628 283.246979 131.005066 283.290283 131.028564 C 283.372345 131.07547 283.438141 131.138214 283.487915 131.196198 C 283.53775 131.25415 283.569214 131.309631 283.589386 131.348907 C 283.609558 131.388153 283.618469 131.411224 283.618469 131.411224 Z"
            />
            <path
              id="path5295"
              fill="#2e1d17"
              stroke="none"
              d="M 280.574829 131.250549 C 280.538116 131.250092 280.492218 131.249542 280.441833 131.242065 C 280.398285 131.23465 280.359436 131.222717 280.329681 131.213135 C 280.331665 131.238403 280.340149 131.298187 280.385376 131.353821 C 280.446381 131.432587 280.531097 131.449677 280.553986 131.454559 C 280.561707 131.385803 280.569427 131.319336 280.577118 131.250549 Z"
            />
            <path
              id="path5296"
              fill="#2e1d17"
              stroke="none"
              d="M 283.430664 131.18631 C 283.469635 131.193695 283.556671 131.206207 283.653656 131.15918 C 283.702118 131.136841 283.736877 131.107391 283.760132 131.082458 C 283.766724 131.107758 283.779785 131.167603 283.75824 131.238495 C 283.724792 131.348236 283.632477 131.390747 283.616302 131.399719 C 283.555206 131.32782 283.491791 131.25824 283.430664 131.18631 Z"
            />
            <path
              id="path5297"
              fill="#cf836a"
              stroke="none"
              d="M 281.650085 132.865479 C 281.599762 132.851135 281.551849 132.829895 281.508545 132.804108 C 281.488037 132.7901 281.46756 132.776062 281.447083 132.762054 C 281.431183 132.748077 281.408478 132.727173 281.392578 132.713196 C 281.326874 132.643555 281.284302 132.555847 281.262451 132.466064 L 281.243408 132.523224 C 281.331451 132.455414 281.410431 132.376038 281.4758 132.285034 C 281.492126 132.262268 281.506165 132.239502 281.522552 132.214417 C 281.53656 132.191681 281.55069 132.164276 281.562439 132.141479 C 281.588257 132.093597 281.611877 132.038818 281.62854 131.988495 C 281.702209 131.778259 281.709595 131.548828 281.652405 131.341583 C 281.642975 131.554901 281.599152 131.760956 281.521179 131.945892 C 281.499939 131.993835 281.478821 132.034912 281.453003 132.080505 C 281.438904 132.10556 281.427246 132.12381 281.413177 132.146545 L 281.371124 132.208008 C 281.312775 132.289948 281.243011 132.364838 281.168762 132.4328 L 281.164154 132.432739 C 281.147888 132.450897 281.143066 132.471527 281.149689 132.492218 C 281.1828 132.600525 281.250427 132.700012 281.339142 132.767639 C 281.384644 132.802643 281.432526 132.826141 281.485138 132.842865 C 281.53772 132.859558 281.590393 132.867065 281.643219 132.865417 Z"
            />
            <path
              id="path5298"
              fill="#f24655"
              stroke="none"
              d="M 281.416016 133.624634 C 281.406525 133.647491 281.347412 133.791351 281.417328 133.895477 C 281.487213 133.999603 281.645691 133.990021 281.767426 133.984619 C 281.808746 133.982819 281.981079 133.966522 282.156921 133.847015 C 282.302734 133.747772 282.382233 133.622528 282.419861 133.551819 C 282.235931 133.577179 282.0383 133.597717 281.831604 133.611298 C 281.689178 133.621063 281.551392 133.626282 281.420563 133.626984 Z"
            />
            <path
              id="path5299"
              fill="#e02f40"
              stroke="none"
              d="M 281.307281 133.503998 C 281.307281 133.503998 281.389099 133.383331 281.517609 133.384888 C 281.584137 133.385681 281.634277 133.416138 281.654724 133.432434 C 281.689362 133.41449 281.74939 133.385376 281.827484 133.379456 C 282.038849 133.361328 282.144623 133.537048 282.362671 133.535095 C 282.410858 133.535645 282.484436 133.525055 282.574493 133.477966 C 282.525879 133.514069 282.465759 133.55011 282.396545 133.58139 C 282.161194 133.686432 281.940887 133.681458 281.812561 133.666138 C 281.766388 133.688538 281.722504 133.710968 281.676331 133.733368 C 281.660339 133.728577 281.637451 133.721405 281.612427 133.705048 C 281.591888 133.693298 281.575989 133.679352 281.564667 133.667725 C 281.506897 133.699188 281.43576 133.698334 281.383453 133.66095 C 281.301483 133.607208 281.304962 133.508514 281.305023 133.503967 Z"
            />
            <path
              id="path5300"
              fill="#3d221d"
              stroke="none"
              d="M 282.371948 130.485016 C 282.471161 130.440338 282.597961 130.393646 282.754272 130.372589 C 283.151978 130.317719 283.469299 130.459259 283.608429 130.529785 C 283.513062 130.446014 283.276581 130.26416 282.926025 130.21402 C 282.699219 130.181427 282.510559 130.21817 282.397736 130.248932 C 282.349335 130.266693 282.314362 130.312195 282.311432 130.36496 C 282.310852 130.410858 282.333252 130.457001 282.374268 130.482758 Z"
            />
            <path
              id="path5301"
              fill="#3d221d"
              stroke="none"
              d="M 281.199341 130.470856 C 281.137939 130.424225 281.055908 130.375031 280.957489 130.350891 C 280.703491 130.288177 280.497589 130.423401 280.407257 130.49115 C 280.470215 130.409271 280.626129 130.232147 280.851563 130.188965 C 280.99881 130.160919 281.117645 130.201385 281.190704 130.234375 C 281.222626 130.253113 281.242737 130.299255 281.244354 130.352081 C 281.243805 130.397949 281.229492 130.443695 281.20163 130.468628 Z"
            />
            <path
              id="path5302"
              fill="#cf836a"
              stroke="none"
              d="M 282.53479 133.34436 C 282.544128 133.330688 282.601288 133.349762 282.639954 133.380096 C 282.6922 133.424316 282.709686 133.497955 282.695801 133.506958 C 282.670319 133.525024 282.518433 133.369446 282.534851 133.342072 Z"
            />
            <path
              id="path5303"
              fill="#b5715a"
              stroke="none"
              d="M 284.146423 132.165802 C 284.146027 132.197449 284.120026 132.222839 284.088348 132.222473 C 284.056641 132.222076 284.031311 132.196106 284.031677 132.164429 C 284.032074 132.132721 284.058044 132.107361 284.089722 132.107727 C 284.121399 132.108124 284.14679 132.134125 284.146423 132.165802 Z"
            />
            <path
              id="path5304"
              fill="#f2b8bd"
              stroke="none"
              d="M 281.861328 133.809021 C 281.854645 133.790588 281.891815 133.754303 281.931 133.740997 C 281.963257 133.729919 282.009155 133.730469 282.015839 133.746613 C 282.022522 133.762756 281.992371 133.789948 281.96698 133.803406 C 281.925354 133.825867 281.868011 133.825195 281.861359 133.806732 Z"
            />
            <path
              id="path5305"
              fill="#ffeac4"
              stroke="none"
              d="M 285.665527 131.233948 C 285.042145 131.350372 284.421082 131.466827 283.797699 131.583221 L 283.795319 131.780579 C 284.425873 131.641266 285.056396 131.499725 285.68924 131.360474 C 285.680573 131.319061 285.674194 131.277679 285.665527 131.233948 Z"
            />
            <path
              id="path5306"
              fill="#ffeac4"
              stroke="none"
              d="M 282.00354 131.915009 C 281.964172 131.944366 281.890625 131.950378 281.847443 131.917725 C 281.795135 131.878052 281.825745 131.814178 281.780579 131.751648 C 281.724121 131.675262 281.568207 131.661896 281.510132 131.720856 C 281.452057 131.779816 281.501129 131.895142 281.441071 131.928864 C 281.422607 131.937836 281.401947 131.937592 281.388245 131.932831 C 281.384308 131.877686 281.38269 131.822571 281.378723 131.769745 C 281.389221 131.659698 281.399719 131.551971 281.410248 131.441956 C 281.460907 131.426514 281.523071 131.411194 281.594299 131.405121 C 281.750549 131.388672 281.883301 131.417816 281.967896 131.444092 C 282.07077 131.667938 282.084534 131.858612 282.00351 131.917297 Z"
            />
            <path
              id="path5307"
              fill="#fcc6ae"
              stroke="none"
              d="M 285.034241 131.625702 C 285.295898 131.433777 285.60434 131.357178 285.798004 131.476563 C 286.107819 131.668457 286.044861 132.321838 285.729126 132.620972 C 285.60141 132.743347 285.319336 132.914368 285.121185 132.788055 C 285.009583 132.717865 284.960663 132.588745 284.938538 132.517334 C 284.969666 132.21933 285.003113 131.921387 285.034241 131.625702 Z"
            />
            <path
              id="path5308"
              fill="#f2aa94"
              stroke="none"
              d="M 285.097137 132.500854 C 285.144989 132.526703 285.224945 132.559814 285.321411 132.551758 C 285.537384 132.533722 285.74884 132.318268 285.763367 132.06366 C 285.771759 131.937531 285.735321 131.725952 285.598389 131.662354 C 285.461456 131.598694 285.253662 131.701782 285.158905 131.943909 C 285.165741 131.950897 285.285767 132.080872 285.253754 132.264069 C 285.226624 132.4198 285.110992 132.491852 285.094818 132.500854 Z"
            />
            <path
              id="path5309"
              fill="#ffe8c9"
              stroke="none"
              d="M 282.894165 132.283783 C 283.121338 132.28653 283.348877 132.261719 283.569824 132.209351 C 283.606689 132.196014 283.655212 132.171326 283.697052 132.125946 C 283.727295 132.094177 283.748352 132.057709 283.762604 132.016541 L 283.817017 131.693604 C 283.83194 131.599701 283.812317 131.512238 283.758026 131.449615 C 283.717255 131.40094 283.660248 131.372711 283.596008 131.371918 L 282.095215 131.353821 C 282.030975 131.353027 281.973267 131.379883 281.931396 131.427582 C 281.877869 131.488892 281.853821 131.578094 281.866486 131.670044 C 281.865723 131.732056 281.876801 131.957092 282.056335 132.103851 C 282.115417 132.15274 282.186127 132.188019 282.263947 132.205048 C 282.435608 132.246124 282.614319 132.27124 282.790924 132.280243 C 282.825378 132.28064 282.859772 132.281097 282.894196 132.281494 Z M 283.59549 131.413239 C 283.645966 131.413818 283.69162 131.435059 283.725555 131.474457 C 283.770813 131.527832 283.788269 131.60376 283.773499 131.686188 L 283.721466 132.004578 C 283.709625 132.03656 283.690857 132.068481 283.665283 132.095703 C 283.628082 132.136597 283.586548 132.156738 283.55658 132.167847 C 283.34021 132.218048 283.11496 132.242859 282.892395 132.240173 C 282.86026 132.239777 282.825867 132.23938 282.791443 132.238953 C 282.617096 132.22995 282.442993 132.204895 282.273651 132.163849 C 282.200409 132.146881 282.136505 132.116272 282.082001 132.069702 C 281.918396 131.934631 281.907135 131.725616 281.907837 131.665985 C 281.895111 131.580902 281.916656 131.505432 281.960938 131.453186 C 281.995789 131.414581 282.041931 131.39447 282.092407 131.395111 L 283.59317 131.413208 Z"
            />
            <path
              id="path5310"
              fill="#ffe8c9"
              stroke="none"
              d="M 280.647614 132.256683 C 280.796753 132.258453 280.946106 132.244202 281.093353 132.213867 C 281.162384 132.200897 281.224731 132.169556 281.280334 132.124298 C 281.442657 131.988556 281.470581 131.766296 281.473633 131.702057 C 281.493164 131.605896 281.475952 131.509308 281.42395 131.444397 C 281.390015 131.402679 281.34671 131.376923 281.296295 131.373993 L 280.000488 131.296417 C 279.952332 131.295807 279.906158 131.315918 279.871246 131.354523 C 279.81781 131.411255 279.789124 131.505005 279.79483 131.60376 L 279.818481 131.925354 C 279.827148 131.969055 279.845032 132.00827 279.867554 132.042999 C 279.901367 132.093903 279.942352 132.121948 279.969696 132.136047 C 280.186829 132.212067 280.411224 132.253815 280.636139 132.256531 L 280.647614 132.256683 Z M 279.999969 131.339996 L 280.006836 131.340088 C 280.006836 131.340088 281.293457 131.417572 281.293457 131.417572 C 281.3302 131.41803 281.364349 131.439117 281.389191 131.471527 C 281.432159 131.524841 281.447205 131.609924 281.430084 131.69696 C 281.427002 131.761169 281.401581 131.967407 281.250885 132.091797 C 281.202209 132.132568 281.144531 132.159393 281.082397 132.172424 C 280.937439 132.2005 280.790405 132.214783 280.645813 132.213043 L 280.634338 132.212921 C 280.414093 132.210236 280.196533 132.16861 279.983978 132.094879 C 279.96344 132.08316 279.929321 132.059814 279.899994 132.018127 C 279.879669 131.990356 279.866302 131.95575 279.857605 131.918945 L 279.836182 131.59967 C 279.830353 131.51236 279.854248 131.432312 279.900757 131.382416 C 279.92868 131.352905 279.963287 131.33725 280 131.337708 Z"
            />
            <path
              id="path5311"
              fill="#ffffff"
              stroke="none"
              opacity="0.4"
              d="M 282.271057 132.186737 C 282.417511 132.222961 282.593872 132.252625 282.793457 132.261932 C 283.105377 132.277161 283.369812 132.236755 283.56543 132.190918 C 283.59079 132.182037 283.639252 132.159637 283.683441 132.11203 C 283.718323 132.073425 283.737213 132.032318 283.744354 132.009491 C 283.761719 131.904083 283.779053 131.796448 283.796387 131.691071 C 283.823578 131.530731 283.733429 131.394257 283.598022 131.392639 L 282.09729 131.374512 C 281.959595 131.372833 281.868439 131.507141 281.891754 131.66806 C 281.891296 131.704803 281.893097 131.938934 282.07489 132.088013 C 282.147583 132.148529 282.223053 132.174713 282.273376 132.184479 Z"
            />
            <path
              id="path5312"
              fill="#ffffff"
              stroke="none"
              opacity="0.4"
              d="M 281.08902 132.195435 C 280.962463 132.221436 280.808441 132.240265 280.636322 132.23819 C 280.367859 132.234924 280.145935 132.177185 279.979095 132.120087 C 279.958588 132.108337 279.917542 132.0849 279.883728 132.034027 C 279.85672 131.992371 279.843414 131.953186 279.839111 131.927917 C 279.831238 131.819946 279.823334 131.714264 279.81546 131.606293 C 279.803619 131.445496 279.890106 131.315735 280.00708 131.321747 L 281.293701 131.3992 C 281.410675 131.405243 281.480133 131.546082 281.450653 131.704071 C 281.450226 131.740784 281.431335 131.97464 281.264435 132.11264 C 281.197205 132.166901 281.130402 132.189056 281.08667 132.197693 Z"
            />
            <path
              id="path5313"
              fill="#cf836a"
              stroke="none"
              d="M 281.836853 132.794281 C 281.836853 132.794281 281.850586 132.799072 281.871185 132.801605 C 281.891815 132.804138 281.917053 132.802155 281.942383 132.800171 C 281.967682 132.79361 281.992981 132.789307 282.011444 132.780334 C 282.029938 132.771393 282.041504 132.762329 282.041504 132.762329 C 282.041504 132.762329 282.027771 132.757568 282.007172 132.755066 C 281.986542 132.752502 281.961243 132.754517 281.935974 132.7565 C 281.910675 132.763062 281.885376 132.767334 281.866913 132.776306 C 281.848419 132.785278 281.836884 132.792023 281.836884 132.792023 Z"
            />
            <path
              id="path5314"
              fill="#1b4652"
              stroke="none"
              d="M 286.363586 142.421753 C 286.207916 142.390015 286.283752 141.43161 286.342712 140.730011 C 286.463867 139.24884 286.810303 137.169098 287.062531 137.188202 C 287.264313 137.202087 287.406036 138.578583 287.241486 139.852692 C 287.069336 141.18634 286.551361 142.458435 286.365906 142.419464 Z"
            />
            <path
              id="path5315"
              fill="#235c6b"
              stroke="none"
              d="M 286.407684 141.238007 C 286.793915 142.325958 287.165863 143.457336 287.521179 144.632111 C 287.677856 145.152679 287.829926 145.670929 287.970703 146.17984 C 288.022919 146.224091 288.447906 146.573456 289.020844 146.454163 C 289.683472 146.317566 289.920624 145.682404 289.932495 145.648102 C 289.680511 144.08902 289.302032 142.360809 288.72757 140.517822 C 288.433655 139.57785 288.118378 138.697357 287.793213 137.876373 C 287.723358 137.767639 287.621765 137.628723 287.474243 137.491547 C 287.333557 137.359039 287.194641 137.270142 287.085205 137.209137 C 286.878021 137.830902 286.678467 138.581268 286.551025 139.442719 C 286.453583 140.10022 286.414154 140.705627 286.410004 141.238037 Z"
            />
            <path
              id="path5316"
              fill="#235c6b"
              stroke="none"
              d="M 289.020203 144.413818 C 288.093842 144.533447 286.868652 144.690796 285.942322 144.810425 C 284.841278 144.950897 283.602295 145.110382 282.503571 145.248596 C 282.4664 145.28717 282.173584 145.586578 282.225677 146.023254 C 282.263 146.354218 282.47171 146.554108 282.530762 146.607605 C 283.224426 146.753662 284.01709 146.871124 284.897888 146.913879 C 286.838379 147.008453 288.480652 146.711578 289.682709 146.379517 C 289.705994 146.352234 290.115997 145.850006 289.910187 145.218658 C 289.69986 144.578064 289.054535 144.421112 289.022491 144.413849 Z"
            />
            <path
              id="path5317"
              fill="#633828"
              stroke="none"
              d="M 286.028412 135.204254 C 286.689392 133.683716 286.476746 132.859497 286.231934 132.415863 C 285.991547 131.983795 285.248444 131.563995 283.757599 130.724365 C 282.918701 130.250641 282.368713 129.991547 281.703766 129.368439 C 281.338379 129.026672 281.07605 128.706757 280.911072 128.491302 C 280.96344 128.338196 281.050507 128.157928 281.192566 127.987488 C 282.133423 126.855927 284.835785 126.961975 285.999298 128.300293 C 286.526733 128.90567 286.58847 129.686737 286.68924 131.225647 C 286.801788 132.927673 286.672333 134.337616 286.534515 135.295288 L 286.028412 135.204254 Z"
            />
            <path
              id="path5318"
              fill="#4f2513"
              stroke="none"
              d="M 280.352509 130.27475 C 280.422516 129.988708 280.519958 129.7099 280.6539 129.452148 C 280.787872 129.192108 280.946869 128.948486 281.135406 128.730438 L 281.04364 128.729309 C 281.210999 128.933319 281.383087 129.128174 281.57135 129.309448 C 281.757385 129.490723 281.954926 129.665253 282.157257 129.828339 C 282.259521 129.909882 282.364105 129.991486 282.468781 130.066193 C 282.573425 130.143188 282.680389 130.220215 282.789703 130.290375 C 283.008301 130.433014 283.231598 130.568848 283.457245 130.697784 C 283.682892 130.826752 283.913239 130.946564 284.148254 131.06189 C 284.383301 131.174866 284.623077 131.27417 284.848877 131.389343 C 285.079315 131.504608 285.298004 131.638031 285.512024 131.78064 C 285.726044 131.923218 285.930695 132.081757 286.130676 132.247101 C 285.95166 132.059052 285.756317 131.88916 285.551697 131.728333 C 285.349396 131.565247 285.128479 131.422577 284.900543 131.293579 C 284.672607 131.164581 284.43985 131.051636 284.211792 130.931824 C 283.981384 130.81427 283.755676 130.69223 283.534637 130.561035 C 283.313599 130.42984 283.094879 130.294098 282.883179 130.149231 C 282.669159 130.006653 282.459808 129.859528 282.257477 129.701019 C 282.052826 129.54248 281.859741 129.377197 281.673676 129.200531 C 281.48761 129.023834 281.306183 128.842651 281.134064 128.652374 L 281.086487 128.59903 L 281.044556 128.653595 C 280.860382 128.890045 280.703491 129.147491 280.587738 129.421509 C 280.471954 129.695526 280.390472 129.983704 280.352509 130.27475 Z"
            />
            <path
              id="path5319"
              fill="#7a4531"
              stroke="none"
              d="M 281.439911 128.412781 C 281.532684 128.52179 281.68222 128.684235 281.877441 128.861023 C 282.794617 129.693726 283.523804 129.746155 284.650269 130.351868 C 285.338898 130.722809 285.904419 131.028015 286.367767 131.618805 C 287.041321 132.478424 287.141571 133.489471 287.141083 134.099976 C 287.267761 132.731354 286.905334 131.955811 286.580139 131.515808 C 286.040497 130.781769 285.351593 130.621979 283.76886 129.790405 C 282.744843 129.252472 281.947662 128.747101 281.439941 128.410492 Z"
            />
            <path
              id="path5320"
              fill="#7a4531"
              stroke="none"
              d="M 281.408173 128.1875 C 281.416382 128.270233 281.756714 128.216919 282.181641 128.380432 C 282.784698 128.61261 283.14209 129.046112 283.188568 128.998474 C 283.216461 128.968994 283.092255 128.804535 283.074158 128.781372 C 282.868561 128.510376 282.615173 128.394867 282.624634 128.374329 C 282.641113 128.340088 283.31955 128.793518 283.671173 128.565948 C 283.786835 128.491608 283.764648 128.427063 283.885376 128.313782 C 284.159241 128.05777 284.730316 128.282684 284.744781 128.225464 C 284.759247 128.170563 284.24231 128.022034 284.254639 127.951019 C 284.266937 127.886902 284.726074 127.874115 285.197113 128.019775 C 285.595001 128.141632 285.852081 128.328339 285.85672 128.323792 C 285.861389 128.316956 285.350403 127.867859 284.596222 127.604004 C 283.2547 127.133392 281.957703 127.535461 281.961517 127.599762 C 281.96109 127.636475 282.410858 127.641907 282.410278 127.690094 C 282.409637 127.742859 281.888367 127.766388 281.887482 127.839844 C 281.887177 127.867371 281.962555 127.893524 282.042664 127.912842 C 281.506165 128.057861 281.399597 128.139191 281.405914 128.187469 Z"
            />
            <path
              id="path5321"
              fill="#7a4531"
              stroke="none"
              d="M 283.463257 129.437866 C 284.06723 129.789429 284.578491 130.022827 284.934723 130.173981 C 285.501007 130.412659 285.876068 130.522736 286.291748 130.881195 C 286.589294 131.137238 286.77655 131.405731 286.889069 131.592987 C 286.855164 131.35849 286.771973 131.026978 286.532227 130.730316 C 286.258667 130.389648 285.828979 130.239868 284.978729 129.949615 C 284.219879 129.692566 283.669006 129.506927 283.463257 129.437866 Z"
            />
            <path
              id="path5322"
              fill="#7a4531"
              stroke="none"
              d="M 285.91217 128.482849 C 285.977142 128.614441 286.066559 128.812897 286.14386 129.063995 C 286.313965 129.612274 286.302246 130.011475 286.343597 130.009674 C 286.38031 130.010132 286.448395 129.694214 286.39267 129.363068 C 286.317719 128.91922 286.052795 128.622253 285.909912 128.482819 Z"
            />
            <path
              id="path5323"
              fill="#1b4652"
              stroke="none"
              d="M 283.253448 145.110779 C 283.360138 145.206146 283.566498 145.415192 283.667999 145.749207 C 283.844543 146.336578 283.551666 146.833374 283.500122 146.917664 C 283.120056 146.844238 282.73996 146.768494 282.359894 146.695068 C 282.271637 146.590698 282.149811 146.414825 282.079315 146.170715 C 281.949249 145.728455 282.07312 145.353577 282.125275 145.216492 C 282.502045 145.182007 282.876617 145.145233 283.253448 145.110779 Z"
            />
            <path
              id="path5324"
              fill="#1b4652"
              stroke="none"
              d="M 287.611694 144.550598 C 287.591675 144.495239 287.922699 144.262878 288.31308 144.24231 C 288.643799 144.223358 288.951965 144.362488 288.944397 144.4198 C 288.939301 144.463318 288.735291 144.440186 288.204468 144.495758 C 287.763245 144.540924 287.622742 144.585144 287.611664 144.552856 Z"
            />
            <g id="g76">
              <path
                id="path5325"
                fill="#fcc6ae"
                stroke="none"
                d="M 281.070831 146.440826 C 281.244812 146.477325 281.462463 146.507507 281.712677 146.503632 C 281.873383 146.500977 282.018158 146.484375 282.144653 146.462952 C 282.236267 146.477844 282.327881 146.494995 282.419495 146.509888 C 282.466553 146.414063 282.539856 146.233612 282.542755 145.997284 C 282.546417 145.692047 282.42746 145.468018 282.371246 145.373199 C 282.010345 145.419342 281.71402 145.44101 281.505005 145.45459 C 281.047974 145.481171 280.59494 145.553741 280.139954 145.601044 C 280.073334 145.607117 279.944641 145.621643 279.815094 145.704987 C 279.778107 145.727478 279.713257 145.777191 279.526276 146.054962 C 279.37204 146.284882 279.294861 146.40332 279.277557 146.506378 C 279.25531 146.639221 279.298981 146.632874 279.282074 146.891998 C 279.276245 146.995209 279.264038 147.057037 279.304932 147.091949 C 279.354858 147.136169 279.458435 147.112152 279.516235 147.07843 C 279.728851 146.954773 279.647064 146.506256 279.642731 146.485535 C 279.779449 146.377014 279.913879 146.268494 280.050568 146.159943 C 280.236145 146.187469 280.424042 146.214966 280.609619 146.242462 L 281.075409 146.440857 Z"
              />
              <path
                id="path5326"
                fill="#fcc6ae"
                stroke="none"
                d="M 279.492126 146.984039 C 279.565216 147.012482 279.670471 147.038971 279.767395 146.994263 C 279.908203 146.929382 279.910126 146.768768 280.047668 146.5914 C 280.110626 146.511841 280.217468 146.405273 280.406677 146.322632 C 280.355438 146.383972 280.292389 146.472717 280.238129 146.593719 C 280.205078 146.669037 280.110779 146.879028 280.178955 146.934937 C 280.222137 146.96991 280.316742 146.927429 280.367615 146.895905 C 280.480927 146.823822 280.500549 146.720795 280.556824 146.622772 C 280.716095 146.35849 281.016174 146.403442 281.029205 146.275055 C 281.0448 146.126068 280.648346 145.884857 280.253204 145.914551 C 280.184326 145.920593 279.93161 145.94278 279.722534 146.14682 C 279.390442 146.471008 279.483429 146.944946 279.492157 146.98175 Z"
              />
              <path
                id="path5327"
                fill="#fcc6ae"
                stroke="none"
                d="M 278.904663 146.595947 C 278.861542 146.556427 278.892609 146.455841 278.947052 146.318787 C 279.093781 145.94873 279.167175 145.763733 279.310883 145.648438 C 279.496246 145.501465 279.691162 145.517609 280.12027 145.520477 C 280.41861 145.524078 280.854706 145.520172 281.399017 145.490021 C 280.557373 145.814941 280.108704 145.910492 279.851379 145.932648 C 279.757172 145.940674 279.633209 145.943787 279.517395 146.031891 C 279.315918 146.183228 279.35434 146.420074 279.125519 146.555054 C 279.06076 146.593292 278.950104 146.637848 278.904663 146.595947 Z"
              />
            </g>
            <path
              id="path5328"
              fill="#85939c"
              stroke="none"
              d="M 192.62149 146.745605 L 285.350006 147.864899 L 285.328278 149.663971 L 192.599777 148.544678 Z"
            />
            <path
              id="path5329"
              fill="#aabbc7"
              stroke="none"
              d="M 286.379608 148.508484 L 191.576645 147.364136 C 191.227859 147.359894 190.951294 147.07431 190.955505 146.725494 L 190.955505 146.725494 C 190.959717 146.376678 191.245346 146.100159 191.591843 146.104309 L 286.394836 147.248688 C 286.743652 147.252899 287.022491 147.538574 287.01828 147.885071 L 287.01828 147.885071 C 287.014099 148.233856 286.728424 148.512726 286.379608 148.508484 Z"
            />
            <g id="g77">
              <path
                id="path5330"
                fill="#41484d"
                stroke="none"
                d="M 206.832413 146.005981 L 197.827805 145.897308 C 197.433105 145.892548 197.191437 145.568298 197.287994 145.174713 L 198.733215 139.337372 C 198.829758 138.943817 199.230637 138.627319 199.625336 138.63208 L 208.629929 138.740784 C 209.024628 138.745544 209.266281 139.069763 209.169724 139.463379 L 207.724518 145.30069 C 207.62796 145.694275 207.227097 146.010773 206.832413 146.005981 Z"
              />
              <path
                id="path5331"
                fill="#85939c"
                stroke="none"
                d="M 206.450348 146.283661 L 194.646164 146.141205 C 194.552078 146.140045 194.477264 146.063385 194.478409 145.96933 L 194.478409 145.96933 C 194.479538 145.875244 194.556168 145.800415 194.650269 145.801544 L 206.454453 145.944061 C 206.548538 145.94516 206.623352 146.02182 206.622223 146.115936 L 206.622223 146.115936 C 206.621078 146.209991 206.544449 146.284821 206.450348 146.283661 Z"
              />
            </g>
            <path
              id="path5332"
              fill="#aabbc7"
              stroke="none"
              d="M 204.316452 142.817596 C 204.14389 143.423706 203.721207 143.836334 203.371277 143.735687 C 203.021317 143.63736 202.876755 143.064148 203.049316 142.458038 C 203.221878 141.851898 203.644562 141.439331 203.994507 141.539917 C 204.344452 141.638245 204.489029 142.211487 204.316452 142.817596 Z"
            />
            <path
              id="path5333"
              fill="#fcc6ae"
              stroke="none"
              d="M 273.578003 139.921844 C 273.582428 139.749725 273.460052 139.617462 273.213135 139.350555 C 272.986572 139.104553 272.938171 139.122314 272.757019 138.918152 C 272.476227 138.602631 272.406158 138.326385 272.337036 138.346191 C 272.27948 138.361572 272.283875 138.565887 272.298553 138.683105 C 272.339966 139.05542 272.554504 139.344879 272.749542 139.540009 C 272.748108 139.657043 272.753296 139.797119 272.778992 139.948914 C 272.8414 140.293915 272.980591 140.552643 273.088745 140.716919 C 273.144623 140.651031 273.221527 140.555573 273.305573 140.434937 C 273.485443 140.177765 273.574188 140.050323 273.577972 139.924133 Z"
            />
            <g id="g78">
              <path
                id="path5334"
                fill="#85939c"
                stroke="none"
                d="M 280.918732 171.400299 L 282.116547 171.414764 L 283.043549 150.329559 L 279.594513 150.287903 L 280.918732 171.400299 Z"
              />
              <path
                id="path5335"
                fill="#aabbc7"
                stroke="none"
                d="M 281.55896 171.40802 L 282.756805 171.422485 L 283.683777 150.33725 L 280.234772 150.295654 L 281.55896 171.40802 Z"
              />
              <path
                id="path5336"
                fill="#41484d"
                stroke="none"
                d="M 282.92569 150.775665 L 282.519226 149.083862 L 280.272675 149.056763 L 280.975159 150.752106 L 282.92569 150.775665 Z"
              />
              <linearGradient
                id="linearGradient101"
                x1="279.815035"
                y1="149.89352"
                x2="280.985357"
                y2="149.907646"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5337"
                fill="url(#linearGradient101)"
                stroke="none"
                d="M 280.272675 149.056763 L 279.912415 149.052399 L 279.810272 150.290527 L 280.457336 150.29834 L 280.975159 150.752106 L 280.272675 149.056763 Z"
              />
            </g>
            <g id="g79">
              <path
                id="path5338"
                fill="#85939c"
                stroke="none"
                d="M 268.807007 171.25412 L 270.004883 171.268555 L 270.931854 150.18335 L 267.485168 150.141724 L 268.807007 171.25412 Z"
              />
              <path
                id="path5339"
                fill="#aabbc7"
                stroke="none"
                d="M 269.447235 171.26181 L 270.645111 171.276306 L 271.572113 150.191071 L 268.125366 150.149475 L 269.447235 171.26181 Z"
              />
              <path
                id="path5340"
                fill="#41484d"
                stroke="none"
                d="M 270.816284 150.629486 L 270.409851 148.937683 L 268.16098 148.910553 L 268.863464 150.605927 L 270.816284 150.629486 Z"
              />
              <linearGradient
                id="linearGradient102"
                x1="267.705643"
                y1="149.747347"
                x2="268.87367"
                y2="149.761447"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5341"
                fill="url(#linearGradient102)"
                stroke="none"
                d="M 268.16098 148.910553 L 267.80072 148.906189 L 267.700867 150.144348 L 268.345673 150.15213 L 268.863464 150.605927 L 268.16098 148.910553 Z"
              />
            </g>
            <g id="g80">
              <path
                id="path5342"
                fill="#85939c"
                stroke="none"
                d="M 196.217209 170.377869 L 195.019363 170.363403 L 194.601608 149.261963 L 198.048325 149.303558 L 196.217209 170.377869 Z"
              />
              <path
                id="path5343"
                fill="#aabbc7"
                stroke="none"
                d="M 195.576981 170.370148 L 194.37912 170.355682 L 193.96138 149.254242 L 197.410385 149.295868 L 195.576981 170.370148 Z"
              />
              <path
                id="path5344"
                fill="#41484d"
                stroke="none"
                d="M 194.708649 149.710785 L 195.153534 148.029266 L 197.40239 148.056427 L 196.659195 149.734344 L 194.708649 149.710785 Z"
              />
              <linearGradient
                id="linearGradient103"
                x1="196.669381"
                y1="148.88987"
                x2="197.837408"
                y2="148.903969"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5345"
                fill="url(#linearGradient103)"
                stroke="none"
                d="M 197.40239 148.056427 L 197.762665 148.06076 L 197.832611 149.300964 L 197.187805 149.293182 L 196.659195 149.734344 L 197.40239 148.056427 Z"
              />
            </g>
            <g id="g81">
              <path
                id="path5346"
                fill="#85939c"
                stroke="none"
                d="M 208.326614 170.524017 L 207.128738 170.509583 L 206.711014 149.408112 L 210.160019 149.449768 L 208.326614 170.524017 Z"
              />
              <path
                id="path5347"
                fill="#aabbc7"
                stroke="none"
                d="M 207.68866 170.516357 L 206.490799 170.501862 L 206.073059 149.400452 L 209.51976 149.442017 L 207.68866 170.516357 Z"
              />
              <path
                id="path5348"
                fill="#627b7d"
                stroke="none"
                d="M 206.818054 149.856964 L 207.265228 148.175476 L 209.51178 148.202606 L 208.76857 149.880524 L 206.818054 149.856964 Z"
              />
              <path
                id="path5349"
                fill="#779496"
                stroke="none"
                d="M 209.51178 148.202606 L 209.874359 148.20697 L 209.94429 149.447144 L 209.299484 149.439392 L 208.76857 149.880524 L 209.51178 148.202606 Z"
              />
            </g>
            <g id="g82">
              <linearGradient
                id="linearGradient104"
                x1="266.009753"
                y1="143.078019"
                x2="277.859839"
                y2="143.221061"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5350"
                fill="url(#linearGradient104)"
                stroke="none"
                d="M 268.244476 146.747284 L 277.249054 146.855988 C 277.643799 146.860748 277.893158 146.54245 277.806183 146.146667 L 276.502289 140.276154 C 276.415253 139.880341 276.022156 139.554291 275.627411 139.54953 L 266.622833 139.440826 C 266.228149 139.436066 265.978729 139.754364 266.065765 140.150146 L 267.369659 146.02066 C 267.456665 146.416473 267.849792 146.742523 268.244476 146.747284 Z"
              />
              <path
                id="path5351"
                fill="#85939c"
                stroke="none"
                d="M 268.617401 147.034088 L 280.421631 147.176575 C 280.515686 147.177704 280.592346 147.102875 280.593475 147.00882 L 280.593475 147.00882 C 280.594574 146.914734 280.519806 146.838104 280.42572 146.836975 L 268.62149 146.694458 C 268.527435 146.693329 268.450775 146.768127 268.449615 146.862244 L 268.449615 146.862244 C 268.448517 146.956329 268.523315 147.032959 268.617401 147.034088 Z"
              />
            </g>
            <path
              id="path5352"
              fill="#aabbc7"
              stroke="none"
              d="M 270.834351 143.620514 C 270.992249 144.230621 271.404816 144.65332 271.757111 144.561157 C 272.109344 144.471313 272.26767 143.901764 272.109802 143.291656 C 271.951904 142.681549 271.539337 142.258881 271.187042 142.350983 C 270.834808 142.440826 270.676483 143.010406 270.834351 143.620514 Z"
            />
            <path
              id="path5353"
              fill="#1a2530"
              stroke="none"
              d="M 241.971451 168.141663 C 241.935211 168.292694 241.896698 168.441406 241.860443 168.592438 C 241.900635 168.684723 241.953934 168.832275 241.960846 169.020538 C 241.971512 169.27771 241.89563 169.47876 241.848526 169.579163 C 241.513077 169.609558 241.136566 169.618774 240.730667 169.593231 C 239.618393 169.5224 238.710999 169.210815 238.076447 168.923157 C 238.048111 168.798889 238.025223 168.603516 238.134674 168.47171 C 238.276764 168.299011 238.565582 168.330048 238.748978 168.346008 C 239.115829 168.375702 239.632111 168.386536 240.319229 168.312195 C 240.481888 168.146606 240.642273 167.978699 240.804916 167.813141 C 241.193756 167.923401 241.582565 168.03598 241.971405 168.14621 Z"
            />
            <path
              id="path5354"
              fill="#1a2530"
              stroke="none"
              d="M 234.729233 168.05423 C 234.692978 168.205261 234.654465 168.353973 234.61821 168.505005 C 234.658417 168.597321 234.7117 168.744843 234.718613 168.933136 C 234.729279 169.190308 234.653412 169.391357 234.606293 169.49176 C 234.270844 169.522156 233.894348 169.531342 233.488434 169.505798 C 232.37616 169.434998 231.468765 169.123383 230.834213 168.835724 C 230.805878 168.711456 230.78299 168.516113 230.892441 168.384308 C 231.034531 168.211578 231.323349 168.242615 231.50676 168.258575 C 231.873627 168.2883 232.389877 168.299103 233.076996 168.224792 C 233.239655 168.059174 233.40004 167.891296 233.562698 167.725739 C 233.951523 167.835968 234.340332 167.948547 234.729172 168.058838 Z"
            />
            <path
              id="path5355"
              fill="#233242"
              stroke="none"
              d="M 239.871185 154.664825 C 239.092346 154.73114 238.443695 154.849518 237.951218 154.960632 C 237.237793 155.121857 237.043732 155.227386 236.935059 155.294922 C 236.232086 155.729401 235.992767 156.543549 235.902512 156.985413 C 234.989319 160.577698 234.076111 164.169952 233.162918 167.762207 C 233.205627 167.836182 233.457397 168.27298 234.006577 168.410431 C 234.528244 168.542969 234.941879 168.309265 235.020493 168.261993 C 235.973892 166.852844 236.950089 165.267273 237.900864 163.504639 C 239.093475 161.292786 240.034607 159.18811 240.78067 157.273834 C 240.476761 156.402588 240.175125 155.533722 239.871201 154.662506 Z"
            />
            <path
              id="path5356"
              fill="#1e2b38"
              stroke="none"
              d="M 247.005569 154.750916 C 246.226715 154.817261 245.578079 154.935669 245.085587 155.046783 C 244.372177 155.207977 244.178101 155.313538 244.069427 155.381073 C 243.36647 155.815521 243.127136 156.629669 243.036896 157.071533 C 242.123672 160.663788 241.210495 164.256042 240.297287 167.848328 C 240.340012 167.922272 240.591782 168.35907 241.14093 168.496521 C 241.662613 168.629059 242.076263 168.395355 242.154861 168.348114 C 243.108261 166.938995 244.084457 165.353363 245.035248 163.590759 C 246.227844 161.378937 247.168991 159.2742 247.915039 157.359924 C 247.61113 156.488739 247.309494 155.619843 247.005585 154.748657 Z"
            />
            <path
              id="path5357"
              fill="#233242"
              stroke="none"
              d="M 254.920837 156.31073 C 254.98967 156.502075 255.155182 157.050262 254.956909 157.695099 C 254.818298 158.150177 254.559967 158.447662 254.413605 158.592804 C 250.94873 158.725403 247.278625 158.74765 243.426712 158.62085 C 241.130249 158.544922 238.905518 158.419403 236.757004 158.255768 C 236.687149 157.958832 236.601868 157.418488 236.756439 156.782288 C 237.007584 155.750214 237.714645 155.164337 237.948608 154.98584 C 239.903137 154.488495 242.849365 153.973206 246.424225 154.236694 C 250.118317 154.508484 253.037125 155.503052 254.918564 156.308411 Z"
            />
            <path
              id="path5358"
              fill="#15232b"
              stroke="none"
              d="M 255.146454 155.301331 C 254.964828 155.707642 254.780914 156.113953 254.599289 156.520294 C 253.723846 156.603821 252.677032 156.62561 251.510559 156.483002 C 248.804031 156.154266 246.751083 155.108185 245.518784 154.333649 C 245.645691 154.087311 245.772629 153.838654 245.899536 153.592316 C 248.981857 154.161987 252.061859 154.731628 255.144165 155.3013 Z"
            />
            <g id="g83">
              <path
                id="path5359"
                fill="#85939c"
                stroke="none"
                d="M 236.443848 146.363403 L 245.448441 146.472107 C 245.84314 146.476868 246.092545 146.1586 246.005524 145.762787 L 244.70163 139.892273 C 244.614609 139.49649 244.221497 139.17041 243.826797 139.165649 L 234.822205 139.056946 C 234.427505 139.052185 234.178085 139.370483 234.265106 139.766296 L 235.569016 145.63681 C 235.656021 146.032593 236.049149 146.358643 236.443848 146.363403 Z"
              />
              <path
                id="path5360"
                fill="#85939c"
                stroke="none"
                d="M 236.816772 146.650238 L 248.620972 146.792694 C 248.715057 146.793823 248.791687 146.719055 248.792831 146.624969 L 248.792831 146.624969 C 248.793976 146.530853 248.719147 146.454224 248.625076 146.453094 L 236.820862 146.310577 C 236.726791 146.309479 236.650146 146.384277 236.649017 146.478363 L 236.649017 146.478363 C 236.647888 146.572449 236.722687 146.649078 236.816772 146.650238 Z"
              />
            </g>
            <path
              id="path5361"
              fill="#41484d"
              stroke="none"
              d="M 244.594513 139.831299 L 234.398926 139.708252 L 235.763443 145.689636 L 245.844299 145.81134 L 244.594513 139.831299 Z"
            />
            <path
              id="path5362"
              fill="#e0a66b"
              stroke="none"
              d="M 241.369553 146.70517 C 242.053879 146.102966 243.389969 145.123016 245.260773 144.906891 C 246.02153 144.817383 247.986557 144.590973 248.817169 145.748505 C 249.07222 146.105042 249.154694 146.498505 249.176285 146.799408 L 241.367264 146.705139 Z"
            />
            <path
              id="path5363"
              fill="#f29d83"
              stroke="none"
              d="M 251.861572 136.150513 C 251.717621 136.286499 251.813766 136.686981 252.006119 137.483398 C 252.176529 138.19693 252.266296 138.55603 252.471603 138.659515 C 252.991714 138.922852 254.180267 138.186676 254.189102 137.454651 C 254.200455 136.513824 252.258606 135.769745 251.861588 136.148224 Z"
            />
            <path
              id="path5364"
              fill="#ffd3a6"
              stroke="none"
              d="M 254.242493 137.404816 C 253.928894 137.336761 253.319458 137.249084 252.591919 137.437683 C 251.94725 137.606628 251.495972 137.917877 251.252609 138.114624 C 251.338669 138.400269 251.42247 138.683563 251.508514 138.969208 C 250.489883 139.507751 249.471283 140.043945 248.454941 140.58252 C 248.092072 142.694183 247.661606 144.892273 247.149857 147.169708 C 246.62587 149.508942 246.059601 151.739838 245.471802 153.853394 C 246.232208 154.362885 247.221664 154.909607 248.435333 155.325897 C 251.324326 156.320099 253.89595 156.036713 255.280823 155.76886 C 255.820145 155.00882 259.838348 149.156616 257.640015 142.662567 C 256.79126 140.155243 255.311157 138.425262 254.242523 137.402527 Z"
            />
            <path
              id="path5365"
              fill="#fcc6ae"
              stroke="none"
              d="M 251.530334 131.267151 C 251.450378 131.61734 251.350677 131.891541 251.272659 132.081085 C 251.15918 132.355133 251.079666 132.478119 250.998291 132.754822 C 250.916946 133.029297 250.903107 133.224182 250.885345 133.366241 C 250.794022 134.085815 250.518433 134.291321 250.415924 134.797333 C 250.306122 135.337646 250.406464 136.151306 250.874634 136.533356 C 251.59964 137.125061 253.15242 136.636597 253.866776 135.637665 C 254.47374 134.78894 254.299545 133.818298 254.271408 133.677948 C 254.0401 132.495483 252.952286 131.541382 251.532639 131.267181 Z"
            />
            <path
              id="path5366"
              fill="#59301d"
              stroke="none"
              d="M 258.358398 133.532196 C 258.255676 134.058838 258.031525 134.565643 257.670441 135.00882 C 256.631409 136.286133 254.756332 136.665131 253.533264 136.267059 L 253.533264 136.267059 C 253.274933 136.183655 253.044571 136.063812 252.858246 135.910095 C 252.306015 135.455902 252.722412 135.183197 251.893707 132.726624 C 251.56572 131.758728 251.24823 131.061768 251.585358 130.322235 C 251.769211 129.920532 252.063568 129.683105 252.190994 129.583679 C 253.29393 128.715668 254.89505 129.166473 255.098587 129.226288 C 255.446838 129.276398 256.731689 129.498474 257.6138 130.571747 C 258.285614 131.387726 258.561432 132.494995 258.360718 133.532257 Z"
            />
            <g id="g84">
              <g id="g85">
                <linearGradient
                  id="linearGradient105"
                  x1="217.48853"
                  y1="165.204469"
                  x2="219.276139"
                  y2="165.226047"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5367"
                  fill="url(#linearGradient105)"
                  stroke="none"
                  d="M 218.304718 171.551056 L 218.304718 171.551056 C 218.79808 171.557007 219.202179 171.162537 219.208145 170.669159 L 219.339523 159.785156 C 219.345474 159.291809 218.951004 158.887695 218.457642 158.881744 L 218.457642 158.881744 C 217.964264 158.875763 217.560165 159.270233 217.554214 159.763611 L 217.422821 170.647614 C 217.41687 171.140991 217.81134 171.545105 218.304718 171.551056 Z"
                />
                <linearGradient
                  id="linearGradient106"
                  x1="212.851467"
                  y1="170.420302"
                  x2="223.785948"
                  y2="170.552292"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5368"
                  fill="url(#linearGradient106)"
                  stroke="none"
                  d="M 223.781464 170.924042 L 212.844681 170.792023 L 212.853699 170.046204 L 223.790466 170.178223 Z"
                />
                <g id="g86">
                  <linearGradient
                    id="linearGradient107"
                    x1="222.664555"
                    y1="170.857772"
                    x2="225.326464"
                    y2="170.889904"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                    <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5369"
                    fill="url(#linearGradient107)"
                    stroke="none"
                    d="M 225.326462 170.889923 C 225.317581 171.624969 224.714508 172.213684 223.979446 172.204773 C 223.24437 172.195923 222.65567 171.592834 222.664551 170.857758 C 222.673416 170.122711 223.276505 169.533997 224.011581 169.542877 C 224.746643 169.551758 225.335327 170.154846 225.326462 170.889923 Z"
                  />
                  <linearGradient
                    id="linearGradient108"
                    x1="211.303251"
                    y1="170.72063"
                    x2="213.96516"
                    y2="170.752762"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                    <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5370"
                    fill="url(#linearGradient108)"
                    stroke="none"
                    d="M 213.965149 170.752777 C 213.956284 171.487823 213.353195 172.076538 212.618149 172.067627 C 211.883072 172.058777 211.294373 171.455688 211.303253 170.720612 C 211.312119 169.985565 211.915207 169.396881 212.650269 169.405762 C 213.38533 169.414612 213.97403 170.0177 213.965149 170.752777 Z"
                  />
                </g>
              </g>
              <linearGradient
                id="linearGradient109"
                x1="213.092861"
                y1="161.830423"
                x2="225.096695"
                y2="161.975321"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5371"
                fill="url(#linearGradient109)"
                stroke="none"
                d="M 225.1073 161.096436 C 224.878098 161.451691 224.648911 161.804688 224.417419 162.159912 C 223.21312 162.489624 221.639587 162.79425 219.786957 162.836121 C 217.215759 162.894623 215.098511 162.421539 213.653442 161.972626 C 213.469589 161.612366 213.285721 161.254395 213.101868 160.894135 C 217.10141 160.960785 221.103226 161.027435 225.102722 161.096375 Z"
              />
              <path
                id="path5372"
                fill="#1b6d3c"
                stroke="none"
                d="M 228.047363 161.471619 L 216.261536 161.329346 C 215.777344 161.323486 215.389679 160.926331 215.395508 160.442139 L 215.395508 160.442139 C 215.407013 159.489838 216.187363 158.728119 217.139679 158.739594 L 227.231995 158.86142 C 228.184311 158.872894 228.946045 159.653259 228.934555 160.605591 L 228.934555 160.605591 C 228.928696 161.089783 228.531555 161.477448 228.047363 161.471619 Z"
              />
              <path
                id="path5373"
                fill="#1b6d3c"
                stroke="none"
                d="M 218.913605 154.951172 L 210.590546 154.850677 C 209.725433 154.840271 208.986954 154.225433 208.820465 153.376556 L 205.523193 136.582642 C 205.436646 136.147827 205.774307 135.743378 206.217194 135.748718 L 212.99588 135.830536 C 214.469116 135.848328 215.727936 136.896301 216.011154 138.341034 L 219.204697 154.603516 C 219.239212 154.785248 219.099472 154.9534 218.915909 154.951172 Z"
              />
              <path
                id="path5374"
                fill="#2baf63"
                stroke="none"
                d="M 223.834213 161.420746 L 211.171783 161.267883 C 210.687592 161.262054 210.299927 160.864929 210.305756 160.380707 L 210.305756 160.380707 C 210.317261 159.428375 211.09761 158.666656 212.049927 158.678162 L 222.142227 158.799988 C 223.094559 158.811462 223.856293 159.591827 223.844788 160.544159 L 223.834213 161.420746 Z"
              />
              <path
                id="path5375"
                fill="#2baf63"
                stroke="none"
                d="M 218.438599 154.945435 L 209.52121 154.837799 C 208.793762 154.82901 208.173462 154.312012 208.032867 153.598846 L 204.672852 136.489746 C 204.594925 136.098633 204.897705 135.732788 205.299301 135.73764 L 212.399246 135.823364 C 213.734787 135.839478 214.875458 136.789612 215.132767 138.098633 L 218.440903 154.945465 Z"
              />
              <linearGradient
                id="linearGradient110"
                x1="212.61647"
                y1="144.63679"
                x2="213.428111"
                y2="162.006601"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5376"
                fill="url(#linearGradient110)"
                stroke="none"
                d="M 216.585938 162.024048 C 215.710464 161.919403 214.837311 161.814758 213.961868 161.707794 C 213.054077 160.670959 212.001968 159.228394 211.175537 157.343353 C 209.205429 152.85791 209.733154 148.687256 210.095322 146.823395 C 210.804672 146.809021 211.516357 146.792389 212.225708 146.777985 C 212.870041 150.058533 213.745361 153.596649 214.937485 157.317627 C 215.461639 158.958038 216.016495 160.52536 216.583649 162.024017 Z"
              />
            </g>
            <path
              id="path5377"
              fill="#ffd3a6"
              stroke="none"
              d="M 249.612381 144.70697 C 247.573074 145.382385 245.536087 146.055481 243.49678 146.730865 L 241.082718 146.701721 C 240.973953 146.585632 240.813446 146.384064 240.731979 146.096161 C 240.628555 145.730011 240.710297 145.421143 240.818497 145.013947 C 240.921967 144.618134 241.06572 144.307739 241.173798 144.100189 C 241.324707 143.957428 241.58667 143.740265 241.971771 143.588837 C 242.31076 143.455231 242.611801 143.42215 242.80925 143.417633 C 244.243851 142.643158 245.678421 141.868683 247.115326 141.094208 C 247.58403 140.672974 248.332138 140.108246 249.367569 139.700745 C 250.013214 139.449188 250.602264 139.323181 251.075821 139.26004 C 250.588028 141.074158 250.0979 142.890533 249.610092 144.704651 Z"
            />
            <path
              id="path5378"
              fill="#fcc6ae"
              stroke="none"
              d="M 251.820618 133.648376 C 251.951141 133.482391 252.217346 133.295135 252.427567 133.371124 C 252.683502 133.463715 252.733322 133.90036 252.702698 134.154755 C 252.628998 134.746002 252.0354 135.057861 251.945328 135.10495 C 251.612213 134.561615 251.557175 133.987183 251.820618 133.648376 Z"
            />
            <path
              id="path5379"
              fill="#f2aa94"
              stroke="none"
              d="M 251.815765 134.049957 C 251.831863 133.857361 252.070694 133.655975 252.210159 133.699005 C 252.377106 133.749207 252.452515 134.156342 252.306946 134.427673 C 252.203598 134.62384 251.981689 134.754272 251.913406 134.70752 C 251.865601 134.674805 251.931046 134.576935 251.899124 134.369995 C 251.871506 134.186035 251.805283 134.157684 251.813477 134.049927 Z"
            />
            <path
              id="path5380"
              fill="#693a25"
              stroke="none"
              d="M 256.241302 130.766327 C 256.220123 130.809692 255.857956 130.582672 255.41777 130.542938 C 254.924881 130.497986 254.488586 130.706146 254.162323 130.927124 C 254.235428 130.765076 254.304413 130.563904 254.220566 130.475708 C 254.071014 130.315521 253.534866 130.621216 253.474121 130.519501 C 253.422394 130.431641 253.795197 130.158447 253.745773 130.070618 C 253.676102 129.948151 252.875031 130.335541 252.784958 130.192139 C 252.728668 130.101929 253.004456 129.880371 252.950409 129.7948 C 252.871567 129.672211 252.22287 129.985687 252.202682 129.946442 C 252.187012 129.914124 252.597214 129.583954 253.16864 129.398102 C 254.336853 129.017426 255.564346 129.429291 255.562119 129.612885 C 255.56102 129.704681 255.250473 129.762878 255.265503 129.847992 C 255.282761 129.940002 255.652451 129.926086 255.662857 130.013458 C 255.673401 130.091583 255.360443 130.158966 255.366241 130.248535 C 255.370056 130.312836 255.528259 130.326233 255.736053 130.413666 C 256.026093 130.53421 256.255524 130.729767 256.236725 130.766266 Z"
            />
            <path
              id="path5381"
              fill="#693a25"
              stroke="none"
              d="M 256.51944 130.730652 C 256.643921 130.686279 256.821167 130.642517 257.025085 130.670227 C 257.338989 130.713043 257.518158 130.891876 257.555389 130.848755 C 257.592651 130.805573 257.457855 130.562988 257.227478 130.445435 C 257.063263 130.36084 256.895721 130.361115 256.896179 130.322113 C 256.896698 130.278503 257.101044 130.27179 257.111053 130.205353 C 257.118561 130.152649 256.999817 130.103027 256.742035 129.973694 C 256.397522 129.801971 256.363525 129.767151 256.198914 129.714661 C 255.993149 129.650208 255.796036 129.627167 255.786514 129.656891 C 255.772186 129.702606 256.215668 129.847992 256.195862 129.967072 C 256.185852 130.035828 256.036621 130.040924 256.03363 130.098236 C 256.032684 130.17627 256.305786 130.179565 256.443634 130.355652 C 256.531799 130.469177 256.532288 130.616089 256.51947 130.728394 Z"
            />
            <path
              id="path5382"
              fill="#452516"
              stroke="none"
              d="M 258.358398 133.532196 C 258.255676 134.058838 258.031525 134.565643 257.670441 135.00882 C 256.631409 136.286133 254.756332 136.665131 253.533264 136.267059 L 253.533264 136.267059 C 253.283691 136.027679 253.11705 135.764008 253.149796 135.523438 C 253.182495 135.285126 253.390244 135.186676 253.370911 134.888062 C 253.345474 134.522858 253.01268 134.332947 253.097198 134.175598 C 253.172379 134.031891 253.467133 134.141022 253.558304 134.002136 C 253.714905 133.767639 253.047302 133.176605 253.143066 133.037781 C 253.278427 132.851227 254.529663 133.958801 255.796829 133.744568 C 256.38327 133.646057 256.807526 133.293152 257.049164 133.050476 C 257.254547 133.337585 257.555939 133.65564 257.927643 133.664734 C 258.090576 133.666687 258.233459 133.615631 258.358398 133.534485 Z"
            />
            <g id="g87">
              <g id="g88">
                <linearGradient
                  id="linearGradient111"
                  x1="248.601475"
                  y1="164.948884"
                  x2="250.389085"
                  y2="164.970463"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5383"
                  fill="url(#linearGradient111)"
                  stroke="none"
                  d="M 249.417648 171.295441 L 249.417648 171.295441 C 248.924286 171.28949 248.529816 170.885406 248.535782 170.392029 L 248.667145 159.508026 C 248.673096 159.014679 249.077209 158.620209 249.570587 158.62616 L 249.570587 158.62616 C 250.06395 158.632111 250.458435 159.036194 250.452469 159.529572 L 250.321091 170.413574 C 250.31514 170.906952 249.911026 171.301422 249.417648 171.295441 Z"
                />
                <linearGradient
                  id="linearGradient112"
                  x1="243.962118"
                  y1="170.16469"
                  x2="254.898894"
                  y2="170.296708"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                  <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                </linearGradient>
                <path
                  id="path5384"
                  fill="url(#linearGradient112)"
                  stroke="none"
                  d="M 243.966629 169.790649 L 254.903412 169.922668 L 254.894394 170.668457 L 243.957626 170.536438 Z"
                />
                <g id="g89">
                  <linearGradient
                    id="linearGradient113"
                    x1="242.413901"
                    y1="170.465018"
                    x2="245.078105"
                    y2="170.497178"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                    <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5385"
                    fill="url(#linearGradient113)"
                    stroke="none"
                    d="M 245.078094 170.497162 C 245.069229 171.232239 244.466141 171.820953 243.731079 171.812073 C 242.996017 171.803162 242.407333 171.200134 242.416199 170.465057 C 242.425079 169.72998 243.028137 169.141296 243.763214 169.150146 C 244.498291 169.159027 245.086975 169.762115 245.078094 170.497162 Z"
                  />
                  <linearGradient
                    id="linearGradient114"
                    x1="253.7775"
                    y1="170.602188"
                    x2="256.43941"
                    y2="170.63432"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                    <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
                  </linearGradient>
                  <path
                    id="path5386"
                    fill="url(#linearGradient114)"
                    stroke="none"
                    d="M 256.439423 170.634308 C 256.430542 171.369385 255.827438 171.958069 255.092392 171.949219 C 254.357315 171.940308 253.768631 171.33728 253.777512 170.602203 C 253.786377 169.867126 254.38945 169.278442 255.124527 169.287292 C 255.859573 169.296173 256.448273 169.899231 256.439423 170.634308 Z"
                  />
                </g>
              </g>
              <linearGradient
                id="linearGradient115"
                x1="242.861083"
                y1="161.558606"
                x2="254.862622"
                y2="161.703476"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5387"
                fill="url(#linearGradient115)"
                stroke="none"
                d="M 242.871704 160.679718 C 243.09227 161.040405 243.312851 161.398804 243.535721 161.759521 C 244.731705 162.118225 246.297409 162.460724 248.148499 162.547363 C 250.717529 162.667847 252.845581 162.246002 254.301071 161.832092 C 254.493561 161.47641 254.68602 161.122986 254.878525 160.767273 C 250.87854 160.737335 246.876282 160.707397 242.876282 160.679779 Z"
              />
              <path
                id="path5388"
                fill="#1b6d3c"
                stroke="none"
                d="M 239.921127 160.983765 L 251.706955 161.126038 C 252.191162 161.131897 252.588303 160.744202 252.594147 160.26001 L 252.594147 160.26001 C 252.605637 159.307709 251.843903 158.527374 250.891586 158.515839 L 240.799286 158.394043 C 239.84697 158.382538 239.06662 159.144287 239.055115 160.096619 L 239.055115 160.096619 C 239.049286 160.58078 239.436951 160.977936 239.921127 160.983765 Z"
              />
              <path
                id="path5389"
                fill="#1b6d3c"
                stroke="none"
                d="M 249.211914 154.68576 L 257.534973 154.786224 C 258.400085 154.796661 259.153198 154.199829 259.340118 153.355225 L 263.044098 136.645813 C 263.138855 136.213196 262.813324 135.80072 262.370453 135.79541 L 255.591766 135.713562 C 254.11853 135.69577 252.834763 136.713074 252.516769 138.150574 L 248.93161 154.331238 C 248.892715 154.512054 249.028351 154.683533 249.211914 154.68576 Z"
              />
              <path
                id="path5390"
                fill="#2baf63"
                stroke="none"
                d="M 244.134293 161.034637 L 256.796722 161.187469 C 257.280914 161.193329 257.67804 160.805634 257.683899 160.321472 L 257.683899 160.321472 C 257.695374 159.369141 256.933685 158.588776 255.981339 158.577301 L 245.889038 158.455475 C 244.936722 158.44397 244.156372 159.205688 244.144867 160.15802 L 244.134293 161.034637 Z"
              />
              <path
                id="path5391"
                fill="#2baf63"
                stroke="none"
                d="M 249.686935 154.691498 L 258.60434 154.799133 C 259.331757 154.807922 259.964386 154.30603 260.122131 153.596466 L 263.894165 136.573456 C 263.981476 136.184357 263.687653 135.811279 263.286041 135.806458 L 256.186096 135.720734 C 254.850555 135.704651 253.687286 136.626953 253.398453 137.929382 L 249.684647 154.691437 Z"
              />
              <linearGradient
                id="linearGradient116"
                x1="254.321024"
                y1="142.68676"
                x2="255.132638"
                y2="160.058866"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="1e-05" stopColor="#a9b2bb" stopOpacity={1} />
                <stop offset={1} stopColor="#4c5054" stopOpacity={1} />
              </linearGradient>
              <path
                id="path5392"
                fill="url(#linearGradient116)"
                stroke="none"
                d="M 251.365875 161.815033 C 252.243591 161.731537 253.119034 161.64798 253.99678 161.562225 C 254.929367 160.547577 256.015961 159.130859 256.887665 157.266266 C 258.965485 152.829742 258.538605 148.647522 258.221497 146.775482 C 257.512695 146.743988 256.801636 146.710144 256.092834 146.67865 C 255.369507 149.942719 254.409042 153.458649 253.127426 157.14975 C 252.563843 158.777039 251.971329 160.330536 251.368149 161.815063 Z"
              />
            </g>
            <path
              id="path5393"
              fill="#ebb886"
              stroke="none"
              d="M 247.705017 145.289856 C 248.067123 145.142761 248.450165 144.970642 248.847336 144.771179 C 249.348404 144.520172 249.799057 144.261688 250.206055 144.007263 C 250.163193 144.137573 249.921036 144.804779 249.198303 145.165588 C 248.498672 145.515198 247.844513 145.330536 247.705017 145.289856 Z"
            />
          </g>
        </g>
      </g>
      <path
        id="path5394"
        fill="#4d2f1d"
        stroke="none"
        d="M 201.179993 142.399994 C 201.080002 142.160004 201.190002 141.880005 201.440002 141.77002 L 207.699997 138.919983 C 207.949997 138.809998 208.240005 138.899994 208.339996 139.130005 C 208.440002 139.369995 208.330002 139.649994 208.080002 139.76001 L 201.820007 142.609985 C 201.570007 142.720001 201.279999 142.630005 201.179993 142.399994 Z"
      />
      <g id="g90" style={{ mixBlendMode: 'screen' }}>
        <path
          id="path5395"
          fill="#414042"
          stroke="none"
          d="M 210.279999 147.140015 L 212.039993 148.429993 L 209.619995 147.440002 L 210.470001 144.970001 L 210.279999 147.140015 Z"
        />
      </g>
      <g id="g91" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path5396"
          fill="#f1f2f2"
          stroke="none"
          d="M 205.940002 149.119995 L 204.179993 147.830017 L 206.600006 148.820007 L 205.75 151.289978 L 205.940002 149.119995 Z"
        />
      </g>
      <path
        id="path5397"
        fill="#6b4129"
        stroke="none"
        visibility="hidden"
        d="M 190.800003 154.119995 C 190.910004 154.169983 191.039993 154.22998 191.25 154.369995 C 197.009995 151.649994 204.910004 148.369995 204.910004 148.369995 L 205.940002 149.119995 L 205.830002 150.390015 C 205.830002 150.390015 198.160004 154.190002 192.330002 156.73999 C 192.300003 156.98999 192.259995 157.130005 192.220001 157.23999 C 192.179993 157.380005 192.029999 157.460022 191.889999 157.410004 C 191.729996 157.350006 191.619995 157.299988 191.509995 157.200012 C 191.179993 157.309998 181.520004 161.850006 180.559998 162.289978 C 179.600006 162.72998 178.710007 163.149994 178.710007 163.149994 L 178.080002 161.77002 L 177.449997 160.390015 C 177.449997 160.390015 178.360001 160 179.309998 159.570007 C 180.270004 159.130005 190.050003 154.830017 190.339996 154.660004 C 190.339996 154.52002 190.369995 154.399994 190.429993 154.23999 C 190.479996 154.100006 190.639999 154.039978 190.770004 154.100006 L 190.800003 154.119995 Z"
      />
      <g id="g92" style={{ mixBlendMode: 'multiply' }}>
        <path
          id="path5398"
          fill="#e6e7e8"
          stroke="none"
          visibility="hidden"
          d="M 205.940002 149.119995 L 178.100006 161.779999 L 178.729996 163.160004 C 178.729996 163.160004 179.619995 162.72998 180.580002 162.299988 C 181.539993 161.859985 191.210007 157.320007 191.529999 157.210022 C 191.639999 157.299988 191.740005 157.359985 191.910004 157.419983 C 192.050003 157.470001 192.199997 157.390015 192.240005 157.25 C 192.270004 157.130005 192.309998 156.98999 192.350006 156.75 C 198.179993 154.200012 205.850006 150.399994 205.850006 150.399994 L 205.960007 149.130005 L 205.940002 149.119995 Z"
        />
      </g>
      <path
        id="path5399"
        fill="#4d2f1d"
        stroke="none"
        visibility="hidden"
        d="M 176.460007 160.910004 L 177.679993 163.580017 C 177.800003 163.839996 178.139999 163.929993 178.440002 163.799988 L 178.449997 163.799988 C 178.75 163.660004 178.899994 163.339996 178.789993 163.080017 L 177.570007 160.410004 C 177.449997 160.149994 177.110001 160.059998 176.809998 160.190002 L 176.800003 160.190002 C 176.5 160.330017 176.350006 160.649994 176.460007 160.910004 Z"
      />
      <linearGradient
        id="linearGradient117"
        x1="242.98"
        y1="133.334"
        x2="235.058"
        y2="166.282"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset="0.02" stopColor="#0e0e0e" stopOpacity={1} />
        <stop offset="0.08" stopColor="#464646" stopOpacity={1} />
        <stop offset="0.15" stopColor="#767676" stopOpacity={1} />
        <stop offset="0.22" stopColor="#9e9e9e" stopOpacity={1} />
        <stop offset="0.29" stopColor="#bcbcbc" stopOpacity={1} />
        <stop offset="0.35" stopColor="#d2d2d2" stopOpacity={1} />
        <stop offset="0.41" stopColor="#dfdfdf" stopOpacity={1} />
        <stop offset="0.47" stopColor="#e4e4e4" stopOpacity={1} />
        <stop offset="0.52" stopColor="#dbdbdb" stopOpacity={1} />
        <stop offset="0.6" stopColor="#c4c4c4" stopOpacity={1} />
        <stop offset="0.69" stopColor="#9e9e9e" stopOpacity={1} />
        <stop offset="0.81" stopColor="#6a6a6a" stopOpacity={1} />
        <stop offset="0.93" stopColor="#282828" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5400"
        fill="url(#linearGradient117)"
        stroke="none"
        opacity="0.8"
        style={{ mixBlendMode: 'screen' }}
        d="M 241.410004 134.460022 C 241.160004 134.690002 232.509995 164.710022 232.25 165.619995 C 231.990005 166.529999 233.460007 167.470001 234.449997 168.02002 C 235.440002 168.570007 237.300003 169.119995 237.580002 168.25 C 237.860001 167.390015 241.800003 134.47998 241.800003 134.47998 L 241.410004 134.460022 Z"
      />
      <linearGradient
        id="linearGradient118"
        x1="242.404"
        y1="134.797"
        x2="255.257"
        y2="165.344"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset="0.02" stopColor="#0e0e0e" stopOpacity={1} />
        <stop offset="0.08" stopColor="#464646" stopOpacity={1} />
        <stop offset="0.15" stopColor="#767676" stopOpacity={1} />
        <stop offset="0.22" stopColor="#9e9e9e" stopOpacity={1} />
        <stop offset="0.29" stopColor="#bcbcbc" stopOpacity={1} />
        <stop offset="0.35" stopColor="#d2d2d2" stopOpacity={1} />
        <stop offset="0.41" stopColor="#dfdfdf" stopOpacity={1} />
        <stop offset="0.47" stopColor="#e4e4e4" stopOpacity={1} />
        <stop offset="0.52" stopColor="#dbdbdb" stopOpacity={1} />
        <stop offset="0.6" stopColor="#c4c4c4" stopOpacity={1} />
        <stop offset="0.69" stopColor="#9e9e9e" stopOpacity={1} />
        <stop offset="0.81" stopColor="#6a6a6a" stopOpacity={1} />
        <stop offset="0.93" stopColor="#282828" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5401"
        fill="url(#linearGradient118)"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 244 135.419983 C 244.100006 135.649994 250.960007 166.890015 251.149994 167.789978 C 251.339996 168.690002 250.869995 169 250.419998 169.279999 C 249.990005 169.559998 249.610001 169.75 249.410004 168.899994 C 249.220001 168.039978 243.869995 135.429993 243.869995 135.429993 L 243.990005 135.410004 L 244 135.419983 Z"
      />
      <g
        id="g143"
        opacity="0.3"
        style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
      >
        <g id="g144" opacity="0.02" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5402"
            fill="#050505"
            stroke="none"
            d="M 240.210007 135.98999 C 240.119995 136.059998 240.320007 136.23999 240.679993 136.399994 C 241.059998 136.570007 241.539993 136.649994 242.330002 136.720001 C 243.119995 136.779999 243.75 136.619995 243.949997 136.539978 C 244.149994 136.460022 244.369995 136.339996 244.320007 136.299988 C 244.229996 136.220001 244.089996 136.339996 243.350006 136.410004 C 242.600006 136.47998 241.970001 136.419983 241.470001 136.339996 C 240.970001 136.25 240.529999 136.059998 240.369995 135.98999 C 240.279999 135.950012 240.25 135.960022 240.199997 136 L 240.210007 135.98999 Z"
          />
        </g>
        <g id="g145" opacity="0.04" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5403"
            fill="#0a0a0a"
            stroke="none"
            d="M 240.210007 135.98999 C 240.119995 136.059998 240.320007 136.23999 240.679993 136.399994 C 241.059998 136.570007 241.539993 136.649994 242.330002 136.710022 C 243.119995 136.77002 243.740005 136.609985 243.940002 136.529999 C 244.139999 136.450012 244.360001 136.330017 244.320007 136.289978 C 244.229996 136.210022 244.089996 136.330017 243.350006 136.399994 C 242.600006 136.470001 241.970001 136.410004 241.470001 136.330017 C 240.979996 136.25 240.539993 136.049988 240.380005 135.97998 C 240.289993 135.940002 240.259995 135.950012 240.210007 135.97998 L 240.210007 135.98999 Z"
          />
        </g>
        <g id="g146" opacity="0.06" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5404"
            fill="#0f0f0f"
            stroke="none"
            d="M 240.220001 136 C 240.130005 136.070007 240.330002 136.25 240.690002 136.410004 C 241.070007 136.580017 241.550003 136.660004 242.330002 136.720001 C 243.119995 136.779999 243.740005 136.619995 243.940002 136.549988 C 244.139999 136.470001 244.360001 136.350006 244.320007 136.309998 C 244.229996 136.22998 244.089996 136.350006 243.350006 136.419983 C 242.600006 136.48999 241.970001 136.429993 241.470001 136.350006 C 240.979996 136.27002 240.539993 136.070007 240.380005 136 C 240.289993 135.960022 240.259995 135.970001 240.210007 136 L 240.220001 136 Z"
          />
        </g>
        <g id="g147" opacity="0.08" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5405"
            fill="#141414"
            stroke="none"
            d="M 240.220001 136 C 240.130005 136.070007 240.330002 136.25 240.690002 136.399994 C 241.059998 136.570007 241.539993 136.649994 242.330002 136.710022 C 243.119995 136.77002 243.729996 136.609985 243.929993 136.539978 C 244.130005 136.470001 244.360001 136.339996 244.309998 136.299988 C 244.220001 136.22998 244.080002 136.339996 243.350006 136.410004 C 242.600006 136.47998 241.970001 136.419983 241.470001 136.339996 C 240.979996 136.26001 240.550003 136.070007 240.389999 135.98999 C 240.300003 135.950012 240.259995 135.960022 240.220001 135.98999 L 240.220001 136 Z"
          />
        </g>
        <g id="g148" opacity="0.1" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5406"
            fill="#191919"
            stroke="none"
            d="M 240.220001 136 C 240.130005 136.059998 240.339996 136.23999 240.690002 136.399994 C 241.059998 136.570007 241.539993 136.649994 242.330002 136.710022 C 243.119995 136.77002 243.729996 136.609985 243.929993 136.539978 C 244.130005 136.470001 244.360001 136.339996 244.320007 136.309998 C 244.229996 136.23999 244.089996 136.350006 243.360001 136.419983 C 242.610001 136.48999 241.979996 136.429993 241.479996 136.350006 C 240.990005 136.27002 240.559998 136.080017 240.399994 136 C 240.309998 135.960022 240.270004 135.970001 240.229996 136 L 240.220001 136 Z"
          />
        </g>
        <g id="g149" opacity="0.12" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5407"
            fill="#1e1e1e"
            stroke="none"
            d="M 240.220001 136 C 240.130005 136.059998 240.339996 136.23999 240.690002 136.399994 C 241.059998 136.559998 241.539993 136.649994 242.320007 136.710022 C 243.110001 136.77002 243.710007 136.609985 243.910004 136.539978 C 244.110001 136.470001 244.339996 136.339996 244.300003 136.309998 C 244.210007 136.23999 244.070007 136.350006 243.339996 136.419983 C 242.589996 136.48999 241.960007 136.429993 241.460007 136.350006 C 240.979996 136.27002 240.539993 136.080017 240.389999 136.01001 C 240.300003 135.970001 240.259995 135.970001 240.210007 136.01001 L 240.220001 136 Z"
          />
        </g>
        <g id="g150" opacity="0.14" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5408"
            fill="#232323"
            stroke="none"
            d="M 240.229996 136 C 240.149994 136.059998 240.350006 136.23999 240.699997 136.390015 C 241.070007 136.549988 241.539993 136.640015 242.330002 136.700012 C 243.119995 136.76001 243.720001 136.609985 243.919998 136.529999 C 244.119995 136.460022 244.350006 136.330017 244.309998 136.299988 C 244.220001 136.22998 244.089996 136.350006 243.350006 136.410004 C 242.600006 136.47998 241.970001 136.419983 241.470001 136.339996 C 240.990005 136.26001 240.559998 136.070007 240.399994 136 C 240.309998 135.960022 240.270004 135.960022 240.220001 136 L 240.229996 136 Z"
          />
        </g>
        <g id="g151" opacity="0.16" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5409"
            fill="#282828"
            stroke="none"
            d="M 240.229996 136 C 240.149994 136.059998 240.350006 136.23999 240.699997 136.390015 C 241.070007 136.549988 241.539993 136.640015 242.320007 136.700012 C 243.110001 136.76001 243.699997 136.609985 243.899994 136.539978 C 244.100006 136.470001 244.339996 136.339996 244.300003 136.309998 C 244.210007 136.23999 244.080002 136.359985 243.350006 136.429993 C 242.600006 136.5 241.970001 136.440002 241.470001 136.359985 C 240.990005 136.279999 240.559998 136.089996 240.399994 136.02002 C 240.309998 135.97998 240.270004 135.97998 240.220001 136.02002 L 240.229996 136 Z"
          />
        </g>
        <g id="g152" opacity="0.18" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5410"
            fill="#2d2d2d"
            stroke="none"
            d="M 240.229996 136.01001 C 240.149994 136.070007 240.350006 136.25 240.699997 136.399994 C 241.070007 136.559998 241.539993 136.640015 242.320007 136.700012 C 243.110001 136.76001 243.699997 136.609985 243.899994 136.539978 C 244.100006 136.470001 244.339996 136.350006 244.300003 136.309998 C 244.220001 136.23999 244.080002 136.359985 243.350006 136.429993 C 242.600006 136.5 241.970001 136.440002 241.470001 136.359985 C 240.990005 136.279999 240.559998 136.089996 240.410004 136.02002 C 240.320007 135.97998 240.270004 135.97998 240.229996 136.02002 L 240.229996 136.01001 Z"
          />
        </g>
        <g id="g153" opacity="0.2" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5411"
            fill="#323232"
            stroke="none"
            d="M 240.229996 136.01001 C 240.149994 136.070007 240.350006 136.23999 240.710007 136.399994 C 241.080002 136.559998 241.539993 136.640015 242.330002 136.700012 C 243.119995 136.76001 243.699997 136.609985 243.899994 136.539978 C 244.100006 136.470001 244.339996 136.350006 244.300003 136.309998 C 244.220001 136.23999 244.080002 136.359985 243.350006 136.429993 C 242.600006 136.5 241.970001 136.440002 241.470001 136.359985 C 241 136.279999 240.570007 136.100006 240.410004 136.02002 C 240.320007 135.97998 240.270004 135.97998 240.229996 136.01001 Z"
          />
        </g>
        <g id="g154" opacity="0.22" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5412"
            fill="#373737"
            stroke="none"
            d="M 240.240005 136.01001 C 240.160004 136.070007 240.360001 136.23999 240.720001 136.390015 C 241.089996 136.549988 241.550003 136.630005 242.330002 136.690002 C 243.119995 136.75 243.699997 136.600006 243.899994 136.529999 C 244.100006 136.460022 244.350006 136.339996 244.300003 136.299988 C 244.220001 136.23999 244.080002 136.350006 243.350006 136.419983 C 242.600006 136.48999 241.970001 136.429993 241.470001 136.350006 C 241 136.27002 240.570007 136.089996 240.419998 136.01001 C 240.330002 135.970001 240.279999 135.970001 240.240005 136 L 240.240005 136.01001 Z"
          />
        </g>
        <g id="g155" opacity="0.24" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5413"
            fill="#3c3c3c"
            stroke="none"
            d="M 240.240005 136.01001 C 240.160004 136.070007 240.360001 136.23999 240.720001 136.390015 C 241.089996 136.549988 241.539993 136.630005 242.330002 136.690002 C 243.119995 136.75 243.690002 136.600006 243.889999 136.529999 C 244.089996 136.460022 244.339996 136.339996 244.300003 136.309998 C 244.220001 136.25 244.080002 136.359985 243.360001 136.429993 C 242.610001 136.5 241.979996 136.440002 241.479996 136.359985 C 241.009995 136.279999 240.589996 136.100006 240.429993 136.029999 C 240.339996 135.98999 240.289993 135.97998 240.25 136.01001 L 240.240005 136.01001 Z"
          />
        </g>
        <g id="g156" opacity="0.25" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5414"
            fill="#414141"
            stroke="none"
            d="M 240.240005 136.01001 C 240.160004 136.059998 240.369995 136.23999 240.720001 136.390015 C 241.089996 136.549988 241.539993 136.630005 242.330002 136.690002 C 243.119995 136.75 243.690002 136.600006 243.889999 136.529999 C 244.089996 136.460022 244.339996 136.339996 244.300003 136.309998 C 244.220001 136.25 244.089996 136.359985 243.360001 136.429993 C 242.610001 136.5 241.979996 136.440002 241.479996 136.359985 C 241.009995 136.279999 240.589996 136.100006 240.429993 136.029999 C 240.339996 135.98999 240.289993 135.97998 240.25 136.01001 L 240.240005 136.01001 Z"
          />
        </g>
        <g id="g157" opacity="0.27" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5415"
            fill="#464646"
            stroke="none"
            d="M 240.25 136.01001 C 240.179993 136.059998 240.380005 136.22998 240.729996 136.380005 C 241.100006 136.539978 241.550003 136.619995 242.330002 136.679993 C 243.119995 136.73999 243.679993 136.589996 243.880005 136.529999 C 244.080002 136.470001 244.330002 136.339996 244.289993 136.309998 C 244.210007 136.25 244.080002 136.369995 243.350006 136.429993 C 242.600006 136.5 241.970001 136.440002 241.470001 136.359985 C 241.009995 136.279999 240.580002 136.100006 240.429993 136.029999 C 240.339996 135.98999 240.289993 135.97998 240.25 136.01001 Z"
          />
        </g>
        <g id="g158" opacity="0.29" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5416"
            fill="#4b4b4b"
            stroke="none"
            d="M 240.25 136.01001 C 240.179993 136.059998 240.380005 136.22998 240.729996 136.380005 C 241.100006 136.539978 241.539993 136.619995 242.330002 136.679993 C 243.119995 136.73999 243.679993 136.589996 243.880005 136.529999 C 244.080002 136.470001 244.339996 136.339996 244.300003 136.309998 C 244.220001 136.25 244.089996 136.369995 243.360001 136.440002 C 242.610001 136.51001 241.979996 136.450012 241.479996 136.369995 C 241.020004 136.289978 240.600006 136.109985 240.440002 136.039978 C 240.350006 136 240.289993 135.98999 240.259995 136.02002 L 240.25 136.01001 Z"
          />
        </g>
        <g id="g159" opacity="0.31" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5417"
            fill="#505050"
            stroke="none"
            d="M 240.25 136.02002 C 240.179993 136.070007 240.380005 136.23999 240.729996 136.390015 C 241.100006 136.549988 241.539993 136.630005 242.330002 136.690002 C 243.119995 136.75 243.669998 136.600006 243.869995 136.539978 C 244.070007 136.47998 244.330002 136.350006 244.289993 136.320007 C 244.210007 136.26001 244.080002 136.380005 243.350006 136.450012 C 242.600006 136.52002 241.970001 136.460022 241.470001 136.380005 C 241.009995 136.299988 240.589996 136.130005 240.440002 136.049988 C 240.350006 136.01001 240.289993 136 240.25 136.02002 Z"
          />
        </g>
        <g id="g160" opacity="0.33" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5418"
            fill="#555555"
            stroke="none"
            d="M 240.25 136.02002 C 240.179993 136.070007 240.380005 136.23999 240.729996 136.390015 C 241.100006 136.549988 241.539993 136.630005 242.320007 136.679993 C 243.110001 136.73999 243.660004 136.589996 243.850006 136.529999 C 244.050003 136.470001 244.309998 136.339996 244.270004 136.309998 C 244.190002 136.25 244.059998 136.369995 243.339996 136.440002 C 242.589996 136.51001 241.960007 136.450012 241.460007 136.369995 C 241 136.299988 240.580002 136.119995 240.429993 136.049988 C 240.339996 136.01001 240.279999 136 240.240005 136.02002 L 240.25 136.02002 Z"
          />
        </g>
        <g id="g161" opacity="0.35" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5419"
            fill="#5a5a5a"
            stroke="none"
            d="M 240.259995 136.02002 C 240.190002 136.070007 240.389999 136.23999 240.740005 136.380005 C 241.110001 136.529999 241.539993 136.619995 242.330002 136.669983 C 243.119995 136.72998 243.660004 136.580017 243.860001 136.52002 C 244.059998 136.460022 244.330002 136.339996 244.279999 136.299988 C 244.199997 136.23999 244.070007 136.359985 243.350006 136.429993 C 242.600006 136.5 241.970001 136.440002 241.470001 136.359985 C 241.020004 136.289978 240.600006 136.109985 240.449997 136.039978 C 240.360001 136 240.300003 135.97998 240.259995 136.01001 L 240.259995 136.02002 Z"
          />
        </g>
        <g id="g162" opacity="0.37" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5420"
            fill="#5f5f5f"
            stroke="none"
            d="M 240.259995 136.02002 C 240.190002 136.070007 240.389999 136.22998 240.75 136.380005 C 241.119995 136.529999 241.550003 136.619995 242.330002 136.669983 C 243.119995 136.72998 243.660004 136.589996 243.850006 136.529999 C 244.050003 136.470001 244.320007 136.350006 244.279999 136.320007 C 244.210007 136.27002 244.070007 136.380005 243.350006 136.450012 C 242.600006 136.52002 241.970001 136.450012 241.470001 136.380005 C 241.020004 136.309998 240.600006 136.130005 240.449997 136.059998 C 240.360001 136.02002 240.300003 136 240.259995 136.029999 L 240.259995 136.02002 Z"
          />
        </g>
        <g id="g163" opacity="0.39" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5421"
            fill="#646464"
            stroke="none"
            d="M 240.259995 136.02002 C 240.190002 136.059998 240.389999 136.22998 240.75 136.380005 C 241.119995 136.529999 241.539993 136.609985 242.330002 136.669983 C 243.119995 136.72998 243.649994 136.589996 243.850006 136.529999 C 244.050003 136.470001 244.320007 136.350006 244.279999 136.320007 C 244.210007 136.27002 244.080002 136.380005 243.350006 136.450012 C 242.600006 136.52002 241.970001 136.450012 241.470001 136.380005 C 241.020004 136.309998 240.610001 136.130005 240.449997 136.059998 C 240.360001 136.02002 240.300003 136 240.259995 136.02002 Z"
          />
        </g>
        <g id="g164" opacity="0.41" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5422"
            fill="#696969"
            stroke="none"
            d="M 240.259995 136.02002 C 240.199997 136.059998 240.389999 136.22998 240.75 136.369995 C 241.119995 136.52002 241.539993 136.600006 242.330002 136.660004 C 243.119995 136.720001 243.639999 136.580017 243.839996 136.52002 C 244.039993 136.460022 244.309998 136.339996 244.270004 136.309998 C 244.199997 136.26001 244.070007 136.380005 243.350006 136.440002 C 242.600006 136.51001 241.970001 136.440002 241.470001 136.369995 C 241.020004 136.299988 240.610001 136.130005 240.460007 136.049988 C 240.369995 136.01001 240.300003 135.98999 240.270004 136.01001 L 240.259995 136.02002 Z"
          />
        </g>
        <g id="g165" opacity="0.43" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5423"
            fill="#6e6e6e"
            stroke="none"
            d="M 240.270004 136.029999 C 240.210007 136.070007 240.410004 136.23999 240.759995 136.380005 C 241.130005 136.529999 241.550003 136.609985 242.330002 136.669983 C 243.119995 136.72998 243.639999 136.589996 243.839996 136.529999 C 244.039993 136.470001 244.320007 136.350006 244.279999 136.320007 C 244.210007 136.27002 244.080002 136.390015 243.360001 136.460022 C 242.610001 136.529999 241.979996 136.460022 241.479996 136.390015 C 241.039993 136.320007 240.619995 136.149994 240.470001 136.070007 C 240.380005 136.029999 240.309998 136.01001 240.279999 136.029999 L 240.270004 136.029999 Z"
          />
        </g>
        <g id="g166" opacity="0.45" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5424"
            fill="#737373"
            stroke="none"
            d="M 240.270004 136.029999 C 240.210007 136.070007 240.410004 136.22998 240.759995 136.380005 C 241.130005 136.529999 241.539993 136.609985 242.330002 136.669983 C 243.119995 136.72998 243.630005 136.589996 243.830002 136.529999 C 244.029999 136.470001 244.309998 136.350006 244.270004 136.320007 C 244.199997 136.27002 244.070007 136.390015 243.350006 136.460022 C 242.600006 136.529999 241.970001 136.460022 241.470001 136.390015 C 241.029999 136.320007 240.619995 136.149994 240.470001 136.080017 C 240.380005 136.039978 240.309998 136.02002 240.279999 136.039978 L 240.270004 136.029999 Z"
          />
        </g>
        <g id="g167" opacity="0.47" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5425"
            fill="#787878"
            stroke="none"
            d="M 240.270004 136.029999 C 240.210007 136.070007 240.410004 136.22998 240.759995 136.380005 C 241.130005 136.529999 241.539993 136.609985 242.330002 136.669983 C 243.119995 136.720001 243.630005 136.589996 243.830002 136.529999 C 244.029999 136.47998 244.309998 136.350006 244.270004 136.320007 C 244.199997 136.27002 244.070007 136.390015 243.350006 136.460022 C 242.600006 136.529999 241.970001 136.460022 241.470001 136.390015 C 241.029999 136.320007 240.619995 136.149994 240.470001 136.080017 C 240.380005 136.039978 240.309998 136.01001 240.279999 136.039978 L 240.270004 136.029999 Z"
          />
        </g>
        <g id="g168" opacity="0.49" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5426"
            fill="#7d7d7d"
            stroke="none"
            d="M 240.270004 136.029999 C 240.210007 136.070007 240.410004 136.22998 240.759995 136.369995 C 241.130005 136.52002 241.539993 136.600006 242.320007 136.649994 C 243.110001 136.700012 243.610001 136.570007 243.809998 136.52002 C 244.009995 136.470001 244.300003 136.339996 244.25 136.309998 C 244.179993 136.26001 244.050003 136.380005 243.330002 136.450012 C 242.580002 136.52002 241.949997 136.450012 241.449997 136.380005 C 241.009995 136.309998 240.600006 136.140015 240.449997 136.070007 C 240.360001 136.029999 240.289993 136 240.259995 136.02002 L 240.270004 136.029999 Z"
          />
        </g>
        <g id="g169" opacity="0.51" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5427"
            fill="#828282"
            stroke="none"
            d="M 240.279999 136.029999 C 240.220001 136.070007 240.419998 136.22998 240.770004 136.369995 C 241.139999 136.52002 241.539993 136.600006 242.330002 136.649994 C 243.119995 136.700012 243.619995 136.570007 243.820007 136.52002 C 244.020004 136.470001 244.309998 136.339996 244.270004 136.320007 C 244.199997 136.27002 244.070007 136.390015 243.360001 136.460022 C 242.610001 136.529999 241.979996 136.460022 241.479996 136.390015 C 241.050003 136.320007 240.639999 136.149994 240.490005 136.080017 C 240.399994 136.039978 240.320007 136.01001 240.289993 136.029999 L 240.279999 136.029999 Z"
          />
        </g>
        <g id="g170" opacity="0.53" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5428"
            fill="#878787"
            stroke="none"
            d="M 240.279999 136.029999 C 240.220001 136.070007 240.419998 136.22998 240.770004 136.369995 C 241.139999 136.52002 241.539993 136.600006 242.330002 136.649994 C 243.119995 136.700012 243.610001 136.570007 243.809998 136.52002 C 244.009995 136.470001 244.300003 136.350006 244.259995 136.320007 C 244.190002 136.279999 244.070007 136.390015 243.350006 136.460022 C 242.600006 136.529999 241.970001 136.460022 241.460007 136.390015 C 241.029999 136.320007 240.619995 136.160004 240.470001 136.080017 C 240.380005 136.039978 240.300003 136.01001 240.270004 136.029999 L 240.279999 136.029999 Z"
          />
        </g>
        <g id="g171" opacity="0.55" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5429"
            fill="#8c8c8c"
            stroke="none"
            d="M 240.279999 136.039978 C 240.229996 136.070007 240.419998 136.22998 240.779999 136.369995 C 241.149994 136.52002 241.550003 136.600006 242.330002 136.649994 C 243.119995 136.700012 243.610001 136.570007 243.809998 136.52002 C 244.009995 136.470001 244.300003 136.350006 244.259995 136.320007 C 244.190002 136.279999 244.070007 136.390015 243.350006 136.460022 C 242.600006 136.529999 241.970001 136.460022 241.460007 136.390015 C 241.029999 136.320007 240.630005 136.160004 240.479996 136.080017 C 240.389999 136.039978 240.309998 136.01001 240.279999 136.029999 L 240.279999 136.039978 Z"
          />
        </g>
        <g id="g172" opacity="0.57" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5430"
            fill="#919191"
            stroke="none"
            d="M 240.289993 136.039978 C 240.240005 136.070007 240.429993 136.22998 240.789993 136.369995 C 241.160004 136.51001 241.550003 136.600006 242.339996 136.649994 C 243.130005 136.700012 243.610001 136.570007 243.809998 136.52002 C 244.009995 136.470001 244.309998 136.350006 244.270004 136.320007 C 244.210007 136.279999 244.080002 136.399994 243.360001 136.470001 C 242.610001 136.539978 241.970001 136.470001 241.470001 136.399994 C 241.039993 136.330017 240.639999 136.169983 240.490005 136.100006 C 240.399994 136.059998 240.320007 136.029999 240.289993 136.039978 Z"
          />
        </g>
        <g id="g173" opacity="0.59" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5431"
            fill="#969696"
            stroke="none"
            d="M 240.289993 136.039978 C 240.240005 136.070007 240.440002 136.22998 240.789993 136.369995 C 241.160004 136.51001 241.550003 136.600006 242.330002 136.649994 C 243.119995 136.700012 243.600006 136.570007 243.800003 136.529999 C 244 136.47998 244.300003 136.359985 244.259995 136.330017 C 244.199997 136.289978 244.070007 136.410004 243.360001 136.47998 C 242.610001 136.549988 241.970001 136.47998 241.470001 136.410004 C 241.050003 136.339996 240.639999 136.179993 240.490005 136.109985 C 240.399994 136.070007 240.320007 136.029999 240.289993 136.049988 L 240.289993 136.039978 Z"
          />
        </g>
        <g id="g174" opacity="0.61" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5432"
            fill="#9b9b9b"
            stroke="none"
            d="M 240.289993 136.039978 C 240.240005 136.070007 240.440002 136.22998 240.789993 136.359985 C 241.160004 136.5 241.539993 136.580017 242.330002 136.640015 C 243.119995 136.690002 243.589996 136.570007 243.789993 136.52002 C 243.990005 136.470001 244.289993 136.350006 244.25 136.320007 C 244.190002 136.279999 244.059998 136.399994 243.350006 136.470001 C 242.600006 136.539978 241.960007 136.470001 241.460007 136.399994 C 241.039993 136.330017 240.639999 136.169983 240.490005 136.100006 C 240.399994 136.059998 240.320007 136.02002 240.289993 136.039978 Z"
          />
        </g>
        <g id="g175" opacity="0.63" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5433"
            fill="#a0a0a0"
            stroke="none"
            d="M 240.289993 136.039978 C 240.289993 136.039978 240.440002 136.22998 240.789993 136.359985 C 241.160004 136.5 241.539993 136.580017 242.330002 136.640015 C 243.119995 136.690002 243.589996 136.570007 243.779999 136.52002 C 243.979996 136.470001 244.289993 136.350006 244.240005 136.330017 C 244.179993 136.289978 244.050003 136.410004 243.339996 136.47998 C 242.589996 136.549988 241.949997 136.47998 241.449997 136.410004 C 241.029999 136.339996 240.630005 136.190002 240.479996 136.109985 C 240.389999 136.070007 240.300003 136.029999 240.279999 136.049988 L 240.289993 136.039978 Z"
          />
        </g>
        <g id="g176" opacity="0.65" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5434"
            fill="#a5a5a5"
            stroke="none"
            d="M 240.300003 136.039978 C 240.300003 136.039978 240.449997 136.220001 240.800003 136.359985 C 241.169998 136.5 241.550003 136.580017 242.330002 136.630005 C 243.119995 136.679993 243.580002 136.559998 243.779999 136.51001 C 243.979996 136.460022 244.289993 136.339996 244.25 136.320007 C 244.190002 136.279999 244.070007 136.399994 243.350006 136.470001 C 242.600006 136.539978 241.960007 136.470001 241.460007 136.399994 C 241.039993 136.339996 240.639999 136.179993 240.5 136.100006 C 240.410004 136.059998 240.320007 136.02002 240.300003 136.029999 L 240.300003 136.039978 Z"
          />
        </g>
        <g id="g177" opacity="0.67" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5435"
            fill="#aaaaaa"
            stroke="none"
            d="M 240.300003 136.039978 C 240.300003 136.039978 240.449997 136.220001 240.800003 136.359985 C 241.169998 136.5 241.539993 136.580017 242.330002 136.630005 C 243.119995 136.679993 243.580002 136.559998 243.770004 136.51001 C 243.970001 136.460022 244.279999 136.339996 244.240005 136.320007 C 244.179993 136.279999 244.059998 136.399994 243.350006 136.470001 C 242.600006 136.539978 241.960007 136.470001 241.460007 136.399994 C 241.050003 136.339996 240.649994 136.179993 240.5 136.109985 C 240.410004 136.070007 240.320007 136.029999 240.300003 136.039978 Z"
          />
        </g>
        <g id="g178" opacity="0.69" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5436"
            fill="#afafaf"
            stroke="none"
            d="M 240.300003 136.049988 C 240.300003 136.049988 240.449997 136.22998 240.800003 136.359985 C 241.160004 136.5 241.539993 136.580017 242.330002 136.630005 C 243.119995 136.679993 243.570007 136.559998 243.770004 136.51001 C 243.970001 136.470001 244.279999 136.339996 244.240005 136.320007 C 244.179993 136.279999 244.059998 136.399994 243.350006 136.470001 C 242.600006 136.539978 241.960007 136.470001 241.460007 136.399994 C 241.050003 136.339996 240.649994 136.179993 240.509995 136.109985 C 240.429993 136.070007 240.330002 136.029999 240.300003 136.039978 L 240.300003 136.049988 Z"
          />
        </g>
        <g id="g179" opacity="0.71" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5437"
            fill="#b4b4b4"
            stroke="none"
            d="M 240.300003 136.049988 C 240.300003 136.049988 240.449997 136.22998 240.800003 136.359985 C 241.160004 136.5 241.539993 136.580017 242.320007 136.630005 C 243.110001 136.679993 243.559998 136.559998 243.75 136.52002 C 243.949997 136.47998 244.270004 136.359985 244.229996 136.330017 C 244.169998 136.299988 244.050003 136.419983 243.339996 136.48999 C 242.589996 136.559998 241.949997 136.48999 241.449997 136.419983 C 241.039993 136.359985 240.649994 136.200012 240.5 136.130005 C 240.419998 136.089996 240.320007 136.039978 240.289993 136.059998 L 240.300003 136.049988 Z"
          />
        </g>
        <g id="g180" opacity="0.73" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5438"
            fill="#b9b9b9"
            stroke="none"
            d="M 240.309998 136.049988 C 240.309998 136.049988 240.460007 136.220001 240.820007 136.359985 C 241.179993 136.5 241.550003 136.580017 242.339996 136.630005 C 243.130005 136.679993 243.570007 136.559998 243.770004 136.52002 C 243.970001 136.47998 244.289993 136.359985 244.25 136.330017 C 244.190002 136.299988 244.070007 136.419983 243.360001 136.48999 C 242.610001 136.559998 241.970001 136.48999 241.470001 136.419983 C 241.059998 136.359985 240.669998 136.200012 240.520004 136.130005 C 240.440002 136.089996 240.339996 136.039978 240.309998 136.049988 Z"
          />
        </g>
        <g id="g181" opacity="0.75" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5439"
            fill="#bebebe"
            stroke="none"
            d="M 240.309998 136.049988 C 240.309998 136.049988 240.460007 136.220001 240.820007 136.350006 C 241.179993 136.48999 241.550003 136.570007 242.330002 136.619995 C 243.119995 136.669983 243.550003 136.549988 243.75 136.51001 C 243.949997 136.470001 244.270004 136.350006 244.229996 136.320007 C 244.169998 136.289978 244.050003 136.410004 243.339996 136.47998 C 242.589996 136.549988 241.949997 136.47998 241.449997 136.410004 C 241.050003 136.350006 240.649994 136.200012 240.509995 136.119995 C 240.429993 136.080017 240.320007 136.029999 240.300003 136.039978 L 240.309998 136.049988 Z"
          />
        </g>
        <g id="g182" opacity="0.76" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5440"
            fill="#c3c3c3"
            stroke="none"
            d="M 240.309998 136.049988 C 240.309998 136.049988 240.470001 136.220001 240.820007 136.350006 C 241.179993 136.48999 241.539993 136.570007 242.330002 136.619995 C 243.119995 136.669983 243.550003 136.549988 243.75 136.51001 C 243.949997 136.470001 244.279999 136.350006 244.229996 136.330017 C 244.179993 136.299988 244.050003 136.419983 243.350006 136.48999 C 242.600006 136.559998 241.960007 136.48999 241.460007 136.419983 C 241.059998 136.359985 240.669998 136.210022 240.520004 136.130005 C 240.440002 136.089996 240.330002 136.039978 240.309998 136.049988 Z"
          />
        </g>
        <g id="g183" opacity="0.78" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5441"
            fill="#c8c8c8"
            stroke="none"
            d="M 240.320007 136.049988 C 240.320007 136.049988 240.479996 136.220001 240.830002 136.350006 C 241.190002 136.48999 241.550003 136.570007 242.339996 136.619995 C 243.130005 136.669983 243.550003 136.549988 243.75 136.51001 C 243.949997 136.470001 244.279999 136.350006 244.240005 136.330017 C 244.190002 136.299988 244.070007 136.419983 243.360001 136.48999 C 242.610001 136.559998 241.970001 136.48999 241.470001 136.419983 C 241.070007 136.359985 240.679993 136.210022 240.539993 136.140015 C 240.460007 136.100006 240.350006 136.049988 240.330002 136.059998 L 240.320007 136.049988 Z"
          />
        </g>
        <g id="g184" opacity="0.8" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5442"
            fill="#cdcdcd"
            stroke="none"
            d="M 240.320007 136.059998 C 240.320007 136.059998 240.479996 136.22998 240.830002 136.359985 C 241.190002 136.48999 241.550003 136.580017 242.330002 136.619995 C 243.119995 136.669983 243.539993 136.549988 243.740005 136.52002 C 243.940002 136.47998 244.270004 136.359985 244.229996 136.339996 C 244.179993 136.309998 244.059998 136.429993 243.350006 136.5 C 242.600006 136.570007 241.960007 136.5 241.460007 136.429993 C 241.059998 136.369995 240.669998 136.220001 240.529999 136.149994 C 240.449997 136.109985 240.339996 136.059998 240.320007 136.059998 Z"
          />
        </g>
        <g id="g185" opacity="0.82" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5443"
            fill="#d2d2d2"
            stroke="none"
            d="M 240.320007 136.059998 C 240.320007 136.059998 240.479996 136.220001 240.830002 136.350006 C 241.190002 136.47998 241.539993 136.559998 242.330002 136.609985 C 243.119995 136.660004 243.529999 136.549988 243.729996 136.51001 C 243.929993 136.470001 244.259995 136.350006 244.220001 136.330017 C 244.169998 136.299988 244.050003 136.419983 243.339996 136.48999 C 242.589996 136.559998 241.949997 136.48999 241.449997 136.419983 C 241.059998 136.359985 240.669998 136.210022 240.520004 136.140015 C 240.440002 136.100006 240.330002 136.039978 240.309998 136.049988 L 240.320007 136.059998 Z"
          />
        </g>
        <g id="g186" opacity="0.84" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5444"
            fill="#d7d7d7"
            stroke="none"
            d="M 240.320007 136.059998 C 240.320007 136.059998 240.479996 136.220001 240.830002 136.350006 C 241.190002 136.47998 241.539993 136.559998 242.330002 136.609985 C 243.119995 136.660004 243.529999 136.549988 243.729996 136.51001 C 243.929993 136.470001 244.270004 136.350006 244.229996 136.330017 C 244.179993 136.299988 244.059998 136.419983 243.360001 136.48999 C 242.610001 136.559998 241.970001 136.48999 241.470001 136.419983 C 241.080002 136.359985 240.690002 136.210022 240.550003 136.140015 C 240.470001 136.100006 240.360001 136.039978 240.339996 136.049988 L 240.320007 136.059998 Z"
          />
        </g>
        <g id="g187" opacity="0.86" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5445"
            fill="#dcdcdc"
            stroke="none"
            d="M 240.330002 136.059998 C 240.330002 136.059998 240.490005 136.220001 240.839996 136.350006 C 241.199997 136.47998 241.550003 136.559998 242.330002 136.609985 C 243.119995 136.660004 243.520004 136.549988 243.720001 136.51001 C 243.919998 136.470001 244.259995 136.350006 244.220001 136.330017 C 244.169998 136.309998 244.050003 136.429993 243.350006 136.5 C 242.600006 136.570007 241.960007 136.5 241.460007 136.429993 C 241.070007 136.369995 240.679993 136.22998 240.539993 136.149994 C 240.460007 136.109985 240.339996 136.049988 240.330002 136.059998 Z"
          />
        </g>
        <g id="g188" opacity="0.88" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5446"
            fill="#e1e1e1"
            stroke="none"
            d="M 240.330002 136.059998 C 240.330002 136.059998 240.490005 136.220001 240.839996 136.339996 C 241.199997 136.470001 241.539993 136.549988 242.330002 136.600006 C 243.119995 136.649994 243.520004 136.539978 243.720001 136.5 C 243.919998 136.470001 244.259995 136.339996 244.220001 136.320007 C 244.169998 136.299988 244.050003 136.419983 243.350006 136.48999 C 242.600006 136.559998 241.960007 136.48999 241.460007 136.419983 C 241.070007 136.359985 240.690002 136.220001 240.550003 136.149994 C 240.470001 136.109985 240.350006 136.049988 240.330002 136.049988 L 240.330002 136.059998 Z"
          />
        </g>
        <g id="g189" opacity="0.9" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5447"
            fill="#e6e6e6"
            stroke="none"
            d="M 240.330002 136.059998 C 240.330002 136.059998 240.490005 136.210022 240.850006 136.339996 C 241.210007 136.470001 241.550003 136.549988 242.339996 136.600006 C 243.130005 136.649994 243.520004 136.539978 243.720001 136.5 C 243.919998 136.470001 244.270004 136.350006 244.220001 136.330017 C 244.169998 136.309998 244.050003 136.429993 243.350006 136.5 C 242.600006 136.570007 241.960007 136.5 241.460007 136.429993 C 241.070007 136.369995 240.690002 136.22998 240.550003 136.160004 C 240.470001 136.119995 240.350006 136.059998 240.330002 136.059998 Z"
          />
        </g>
        <g id="g190" opacity="0.92" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5448"
            fill="#ebebeb"
            stroke="none"
            d="M 240.330002 136.070007 C 240.330002 136.070007 240.5 136.220001 240.850006 136.350006 C 241.210007 136.47998 241.539993 136.559998 242.330002 136.609985 C 243.119995 136.660004 243.509995 136.549988 243.699997 136.52002 C 243.899994 136.48999 244.25 136.369995 244.210007 136.350006 C 244.160004 136.330017 244.050003 136.450012 243.339996 136.52002 C 242.589996 136.589996 241.949997 136.52002 241.449997 136.450012 C 241.070007 136.390015 240.690002 136.25 240.550003 136.179993 C 240.470001 136.140015 240.350006 136.080017 240.330002 136.080017 L 240.330002 136.070007 Z"
          />
        </g>
        <g id="g191" opacity="0.94" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5449"
            fill="#f0f0f0"
            stroke="none"
            d="M 240.339996 136.070007 C 240.339996 136.070007 240.509995 136.220001 240.860001 136.350006 C 241.220001 136.47998 241.550003 136.559998 242.339996 136.609985 C 243.130005 136.660004 243.509995 136.549988 243.710007 136.52002 C 243.910004 136.48999 244.259995 136.369995 244.220001 136.350006 C 244.179993 136.330017 244.059998 136.450012 243.360001 136.52002 C 242.610001 136.589996 241.970001 136.52002 241.470001 136.450012 C 241.089996 136.399994 240.710007 136.25 240.570007 136.179993 C 240.490005 136.140015 240.369995 136.070007 240.350006 136.080017 L 240.339996 136.070007 Z"
          />
        </g>
        <g id="g192" opacity="0.96" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5450"
            fill="#f5f5f5"
            stroke="none"
            d="M 240.339996 136.070007 C 240.339996 136.070007 240.509995 136.220001 240.860001 136.339996 C 241.220001 136.470001 241.550003 136.549988 242.330002 136.589996 C 243.119995 136.640015 243.5 136.529999 243.690002 136.5 C 243.889999 136.470001 244.240005 136.350006 244.199997 136.330017 C 244.160004 136.309998 244.039993 136.429993 243.339996 136.5 C 242.589996 136.570007 241.949997 136.5 241.449997 136.429993 C 241.070007 136.380005 240.690002 136.23999 240.550003 136.160004 C 240.470001 136.119995 240.339996 136.049988 240.330002 136.059998 L 240.339996 136.070007 Z"
          />
        </g>
        <g id="g193" opacity="0.98" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5451"
            fill="#fafafa"
            stroke="none"
            d="M 240.339996 136.070007 C 240.339996 136.070007 240.509995 136.220001 240.860001 136.339996 C 241.220001 136.470001 241.539993 136.549988 242.330002 136.589996 C 243.119995 136.640015 243.490005 136.529999 243.690002 136.5 C 243.889999 136.470001 244.25 136.350006 244.210007 136.330017 C 244.169998 136.309998 244.050003 136.429993 243.350006 136.5 C 242.600006 136.580017 241.960007 136.5 241.460007 136.429993 C 241.080002 136.380005 240.710007 136.23999 240.570007 136.160004 C 240.490005 136.119995 240.360001 136.049988 240.350006 136.049988 L 240.339996 136.070007 Z"
          />
        </g>
        <g id="g194" opacity="0.3" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5452"
            fill="#ffffff"
            stroke="none"
            d="M 240.339996 136.070007 C 240.339996 136.070007 240.509995 136.210022 240.860001 136.339996 C 241.220001 136.470001 241.539993 136.549988 242.330002 136.589996 C 243.119995 136.630005 243.490005 136.529999 243.679993 136.5 C 243.869995 136.470001 244.240005 136.350006 244.199997 136.330017 C 244.160004 136.309998 244.039993 136.440002 243.339996 136.51001 C 242.589996 136.589996 241.949997 136.51001 241.449997 136.440002 C 241.080002 136.390015 240.699997 136.25 240.559998 136.179993 C 240.479996 136.140015 240.350006 136.070007 240.339996 136.070007 Z"
          />
        </g>
      </g>
      <g
        id="g195"
        opacity="0.3"
        style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
      >
        <g id="g196" opacity="0.02" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5453"
            fill="#050505"
            stroke="none"
            d="M 240.789993 136.02002 C 240.729996 135.97998 240.880005 135.899994 241.139999 135.839996 C 241.410004 135.779999 241.759995 135.76001 242.320007 135.77002 C 242.880005 135.779999 243.309998 135.899994 243.449997 135.950012 C 243.589996 136 243.729996 136.070007 243.699997 136.089996 C 243.630005 136.119995 243.539993 136.059998 243.020004 135.98999 C 242.5 135.919983 242.050003 135.910004 241.699997 135.929993 C 241.350006 135.950012 241.029999 136.02002 240.910004 136.049988 C 240.839996 136.070007 240.820007 136.049988 240.789993 136.039978 L 240.789993 136.02002 Z"
          />
        </g>
        <g id="g197" opacity="0.04" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5454"
            fill="#0a0a0a"
            stroke="none"
            d="M 240.789993 136.02002 C 240.729996 135.97998 240.880005 135.899994 241.139999 135.839996 C 241.410004 135.779999 241.759995 135.76001 242.309998 135.77002 C 242.869995 135.779999 243.300003 135.899994 243.440002 135.940002 C 243.580002 135.98999 243.729996 136.059998 243.690002 136.080017 C 243.619995 136.109985 243.529999 136.049988 243.020004 135.970001 C 242.5 135.899994 242.050003 135.890015 241.699997 135.910004 C 241.350006 135.929993 241.029999 136 240.910004 136.029999 C 240.839996 136.049988 240.820007 136.029999 240.789993 136.02002 Z"
          />
        </g>
        <g id="g198" opacity="0.06" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5455"
            fill="#0f0f0f"
            stroke="none"
            d="M 240.789993 136.02002 C 240.729996 135.97998 240.880005 135.899994 241.139999 135.839996 C 241.410004 135.779999 241.759995 135.76001 242.309998 135.77002 C 242.869995 135.779999 243.300003 135.890015 243.429993 135.940002 C 243.570007 135.98999 243.720001 136.059998 243.690002 136.080017 C 243.619995 136.109985 243.529999 136.049988 243.020004 135.970001 C 242.5 135.899994 242.050003 135.890015 241.699997 135.910004 C 241.350006 135.929993 241.029999 136 240.919998 136.029999 C 240.850006 136.049988 240.830002 136.029999 240.800003 136.02002 L 240.789993 136.02002 Z"
          />
        </g>
        <g id="g199" opacity="0.08" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5456"
            fill="#141414"
            stroke="none"
            d="M 240.789993 136.02002 C 240.729996 135.97998 240.880005 135.899994 241.139999 135.839996 C 241.410004 135.779999 241.75 135.76001 242.309998 135.77002 C 242.869995 135.779999 243.289993 135.890015 243.429993 135.940002 C 243.570007 135.98999 243.720001 136.059998 243.690002 136.080017 C 243.619995 136.109985 243.529999 136.049988 243.020004 135.970001 C 242.5 135.899994 242.050003 135.890015 241.699997 135.910004 C 241.350006 135.929993 241.039993 136 240.919998 136.029999 C 240.850006 136.049988 240.830002 136.029999 240.800003 136.02002 L 240.789993 136.02002 Z"
          />
        </g>
        <g id="g200" opacity="0.1" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5457"
            fill="#191919"
            stroke="none"
            d="M 240.800003 136.02002 C 240.740005 135.97998 240.889999 135.899994 241.149994 135.839996 C 241.419998 135.779999 241.759995 135.76001 242.320007 135.77002 C 242.880005 135.779999 243.300003 135.890015 243.440002 135.940002 C 243.580002 135.98999 243.729996 136.059998 243.699997 136.080017 C 243.630005 136.109985 243.539993 136.049988 243.029999 135.970001 C 242.509995 135.899994 242.059998 135.890015 241.710007 135.910004 C 241.360001 135.929993 241.050003 136 240.929993 136.029999 C 240.860001 136.049988 240.839996 136.029999 240.809998 136.029999 L 240.800003 136.02002 Z"
          />
        </g>
        <g id="g201" opacity="0.12" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5458"
            fill="#1e1e1e"
            stroke="none"
            d="M 240.800003 136.02002 C 240.740005 135.97998 240.889999 135.910004 241.149994 135.850006 C 241.419998 135.789978 241.759995 135.77002 242.309998 135.779999 C 242.869995 135.789978 243.289993 135.899994 243.419998 135.950012 C 243.559998 136 243.710007 136.070007 243.679993 136.089996 C 243.619995 136.119995 243.520004 136.059998 243.009995 135.97998 C 242.490005 135.910004 242.039993 135.899994 241.690002 135.919983 C 241.350006 135.940002 241.029999 136.01001 240.919998 136.039978 C 240.860001 136.059998 240.830002 136.049988 240.800003 136.039978 L 240.800003 136.02002 Z"
          />
        </g>
        <g id="g202" opacity="0.14" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5459"
            fill="#232323"
            stroke="none"
            d="M 240.800003 136.02002 C 240.740005 135.97998 240.899994 135.910004 241.149994 135.850006 C 241.419998 135.789978 241.759995 135.77002 242.309998 135.779999 C 242.869995 135.789978 243.279999 135.899994 243.419998 135.950012 C 243.559998 136 243.720001 136.070007 243.679993 136.089996 C 243.619995 136.119995 243.529999 136.049988 243.009995 135.97998 C 242.490005 135.899994 242.039993 135.899994 241.690002 135.919983 C 241.350006 135.929993 241.029999 136.01001 240.919998 136.029999 C 240.860001 136.049988 240.830002 136.039978 240.800003 136.029999 L 240.800003 136.02002 Z"
          />
        </g>
        <g id="g203" opacity="0.16" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5460"
            fill="#282828"
            stroke="none"
            d="M 240.800003 136.02002 C 240.740005 135.98999 240.899994 135.910004 241.149994 135.850006 C 241.419998 135.789978 241.75 135.77002 242.309998 135.779999 C 242.869995 135.789978 243.279999 135.899994 243.410004 135.950012 C 243.550003 136 243.710007 136.070007 243.679993 136.089996 C 243.619995 136.119995 243.529999 136.049988 243.020004 135.97998 C 242.5 135.899994 242.050003 135.899994 241.699997 135.919983 C 241.360001 135.929993 241.050003 136.01001 240.929993 136.029999 C 240.869995 136.049988 240.830002 136.039978 240.809998 136.029999 L 240.800003 136.02002 Z"
          />
        </g>
        <g id="g204" opacity="0.18" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5461"
            fill="#2d2d2d"
            stroke="none"
            d="M 240.800003 136.02002 C 240.75 135.98999 240.899994 135.910004 241.149994 135.850006 C 241.419998 135.789978 241.75 135.77002 242.309998 135.779999 C 242.869995 135.789978 243.270004 135.899994 243.410004 135.950012 C 243.550003 136 243.710007 136.070007 243.679993 136.089996 C 243.619995 136.119995 243.529999 136.049988 243.020004 135.97998 C 242.5 135.899994 242.050003 135.899994 241.699997 135.919983 C 241.360001 135.929993 241.050003 136 240.940002 136.029999 C 240.880005 136.049988 240.839996 136.039978 240.809998 136.029999 L 240.800003 136.02002 Z"
          />
        </g>
        <g id="g205" opacity="0.2" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5462"
            fill="#323232"
            stroke="none"
            d="M 240.800003 136.02002 C 240.75 135.98999 240.899994 135.910004 241.149994 135.850006 C 241.419998 135.789978 241.75 135.77002 242.300003 135.779999 C 242.860001 135.789978 243.259995 135.899994 243.399994 135.940002 C 243.539993 135.97998 243.699997 136.059998 243.669998 136.080017 C 243.610001 136.109985 243.520004 136.039978 243.009995 135.970001 C 242.490005 135.890015 242.039993 135.890015 241.679993 135.910004 C 241.339996 135.919983 241.029999 135.98999 240.919998 136.02002 C 240.860001 136.039978 240.820007 136.029999 240.789993 136.02002 L 240.800003 136.02002 Z"
          />
        </g>
        <g id="g206" opacity="0.22" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5463"
            fill="#373737"
            stroke="none"
            d="M 240.809998 136.02002 C 240.759995 135.98999 240.910004 135.910004 241.169998 135.850006 C 241.440002 135.789978 241.759995 135.77002 242.320007 135.779999 C 242.880005 135.789978 243.279999 135.899994 243.410004 135.940002 C 243.550003 135.97998 243.710007 136.059998 243.679993 136.070007 C 243.619995 136.100006 243.529999 136.029999 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.899994 C 241.350006 135.910004 241.039993 135.97998 240.929993 136.01001 C 240.869995 136.029999 240.830002 136.02002 240.800003 136.01001 L 240.809998 136.02002 Z"
          />
        </g>
        <g id="g207" opacity="0.24" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5464"
            fill="#3c3c3c"
            stroke="none"
            d="M 240.809998 136.02002 C 240.759995 135.98999 240.910004 135.910004 241.169998 135.859985 C 241.440002 135.799988 241.759995 135.779999 242.320007 135.799988 C 242.880005 135.809998 243.270004 135.919983 243.410004 135.960022 C 243.550003 136 243.720001 136.080017 243.679993 136.089996 C 243.619995 136.119995 243.529999 136.049988 243.020004 135.97998 C 242.5 135.899994 242.050003 135.899994 241.690002 135.919983 C 241.360001 135.929993 241.050003 136 240.929993 136.029999 C 240.869995 136.049988 240.830002 136.049988 240.800003 136.029999 L 240.809998 136.02002 Z"
          />
        </g>
        <g id="g208" opacity="0.25" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5465"
            fill="#414141"
            stroke="none"
            d="M 240.809998 136.02002 C 240.759995 135.98999 240.910004 135.910004 241.169998 135.859985 C 241.440002 135.799988 241.759995 135.779999 242.320007 135.799988 C 242.880005 135.809998 243.270004 135.919983 243.410004 135.960022 C 243.550003 136 243.720001 136.080017 243.690002 136.089996 C 243.630005 136.119995 243.539993 136.049988 243.029999 135.97998 C 242.509995 135.899994 242.059998 135.899994 241.699997 135.919983 C 241.369995 135.929993 241.059998 136 240.949997 136.029999 C 240.889999 136.049988 240.850006 136.049988 240.820007 136.029999 L 240.809998 136.02002 Z"
          />
        </g>
        <g id="g209" opacity="0.27" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5466"
            fill="#464646"
            stroke="none"
            d="M 240.809998 136.01001 C 240.809998 136.01001 240.910004 135.899994 241.169998 135.850006 C 241.440002 135.789978 241.759995 135.77002 242.309998 135.789978 C 242.869995 135.799988 243.259995 135.910004 243.389999 135.950012 C 243.529999 135.98999 243.699997 136.070007 243.669998 136.080017 C 243.610001 136.109985 243.520004 136.039978 243.020004 135.970001 C 242.5 135.890015 242.050003 135.890015 241.690002 135.910004 C 241.360001 135.919983 241.050003 135.98999 240.940002 136.02002 C 240.880005 136.039978 240.839996 136.039978 240.809998 136.02002 L 240.809998 136.01001 Z"
          />
        </g>
        <g id="g210" opacity="0.29" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5467"
            fill="#4b4b4b"
            stroke="none"
            d="M 240.809998 136.01001 C 240.809998 136.01001 240.910004 135.910004 241.169998 135.850006 C 241.440002 135.789978 241.75 135.77002 242.309998 135.789978 C 242.869995 135.799988 243.25 135.910004 243.389999 135.950012 C 243.529999 135.98999 243.699997 136.070007 243.669998 136.080017 C 243.610001 136.109985 243.520004 136.039978 243.020004 135.970001 C 242.5 135.890015 242.050003 135.890015 241.690002 135.899994 C 241.360001 135.910004 241.059998 135.97998 240.940002 136.01001 C 240.880005 136.029999 240.830002 136.029999 240.809998 136.01001 Z"
          />
        </g>
        <g id="g211" opacity="0.31" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5468"
            fill="#505050"
            stroke="none"
            d="M 240.820007 136.01001 C 240.820007 136.01001 240.919998 135.910004 241.179993 135.850006 C 241.449997 135.789978 241.759995 135.77002 242.320007 135.789978 C 242.880005 135.799988 243.259995 135.910004 243.389999 135.950012 C 243.529999 135.98999 243.699997 136.070007 243.669998 136.080017 C 243.610001 136.100006 243.529999 136.039978 243.020004 135.970001 C 242.5 135.890015 242.050003 135.890015 241.690002 135.899994 C 241.360001 135.910004 241.059998 135.97998 240.949997 136.01001 C 240.889999 136.029999 240.839996 136.029999 240.820007 136.01001 Z"
          />
        </g>
        <g id="g212" opacity="0.33" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5469"
            fill="#555555"
            stroke="none"
            d="M 240.820007 136.01001 C 240.820007 136.01001 240.919998 135.910004 241.179993 135.850006 C 241.449997 135.789978 241.759995 135.77002 242.309998 135.789978 C 242.869995 135.799988 243.240005 135.899994 243.380005 135.950012 C 243.520004 135.98999 243.699997 136.070007 243.660004 136.080017 C 243.600006 136.100006 243.520004 136.039978 243.009995 135.970001 C 242.490005 135.890015 242.039993 135.890015 241.679993 135.899994 C 241.360001 135.910004 241.050003 135.97998 240.940002 136.01001 C 240.880005 136.029999 240.830002 136.029999 240.809998 136.01001 L 240.820007 136.01001 Z"
          />
        </g>
        <g id="g213" opacity="0.35" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5470"
            fill="#5a5a5a"
            stroke="none"
            d="M 240.820007 136.01001 C 240.820007 136.01001 240.919998 135.910004 241.179993 135.850006 C 241.449997 135.789978 241.759995 135.77002 242.309998 135.789978 C 242.869995 135.799988 243.240005 135.899994 243.380005 135.940002 C 243.520004 135.97998 243.699997 136.059998 243.669998 136.070007 C 243.610001 136.089996 243.529999 136.029999 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.369995 135.899994 241.059998 135.970001 240.949997 136 C 240.889999 136.02002 240.839996 136.02002 240.820007 136 L 240.820007 136.01001 Z"
          />
        </g>
        <g id="g214" opacity="0.37" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5471"
            fill="#5f5f5f"
            stroke="none"
            d="M 240.820007 136.01001 C 240.820007 136.01001 240.919998 135.910004 241.179993 135.859985 C 241.449997 135.799988 241.75 135.779999 242.309998 135.799988 C 242.869995 135.809998 243.240005 135.910004 243.369995 135.950012 C 243.509995 135.98999 243.690002 136.070007 243.660004 136.080017 C 243.600006 136.100006 243.520004 136.039978 243.009995 135.960022 C 242.490005 135.880005 242.039993 135.880005 241.679993 135.890015 C 241.360001 135.899994 241.059998 135.970001 240.949997 136 C 240.889999 136.02002 240.839996 136.02002 240.820007 136 L 240.820007 136.01001 Z"
          />
        </g>
        <g id="g215" opacity="0.39" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5472"
            fill="#646464"
            stroke="none"
            d="M 240.820007 136.01001 C 240.820007 136.01001 240.919998 135.910004 241.179993 135.859985 C 241.449997 135.799988 241.75 135.789978 242.309998 135.799988 C 242.869995 135.809998 243.229996 135.910004 243.369995 135.950012 C 243.509995 135.98999 243.690002 136.070007 243.660004 136.080017 C 243.610001 136.100006 243.520004 136.039978 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.369995 135.899994 241.070007 135.970001 240.960007 136 C 240.899994 136.02002 240.850006 136.02002 240.820007 136 L 240.820007 136.01001 Z"
          />
        </g>
        <g id="g216" opacity="0.41" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5473"
            fill="#696969"
            stroke="none"
            d="M 240.830002 136.01001 C 240.830002 136.01001 240.940002 135.910004 241.190002 135.859985 C 241.460007 135.799988 241.759995 135.789978 242.309998 135.799988 C 242.869995 135.809998 243.229996 135.910004 243.369995 135.950012 C 243.509995 135.98999 243.690002 136.070007 243.660004 136.080017 C 243.610001 136.100006 243.520004 136.039978 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.369995 135.899994 241.070007 135.970001 240.960007 135.98999 C 240.899994 136.01001 240.850006 136.01001 240.820007 135.98999 L 240.830002 136.01001 Z"
          />
        </g>
        <g id="g217" opacity="0.43" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5474"
            fill="#6e6e6e"
            stroke="none"
            d="M 240.830002 136.01001 C 240.830002 136.01001 240.940002 135.910004 241.190002 135.859985 C 241.460007 135.799988 241.759995 135.789978 242.309998 135.799988 C 242.869995 135.809998 243.229996 135.910004 243.360001 135.950012 C 243.5 135.98999 243.690002 136.070007 243.660004 136.080017 C 243.610001 136.100006 243.520004 136.039978 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.369995 135.899994 241.070007 135.970001 240.960007 135.98999 C 240.899994 136.01001 240.850006 136.01001 240.820007 135.98999 L 240.830002 136.01001 Z"
          />
        </g>
        <g id="g218" opacity="0.45" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5475"
            fill="#737373"
            stroke="none"
            d="M 240.830002 136.01001 C 240.830002 136.01001 240.940002 135.910004 241.190002 135.859985 C 241.460007 135.799988 241.75 135.789978 242.309998 135.799988 C 242.869995 135.809998 243.220001 135.910004 243.360001 135.950012 C 243.5 135.98999 243.690002 136.070007 243.660004 136.080017 C 243.610001 136.100006 243.520004 136.039978 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.380005 135.899994 241.080002 135.960022 240.970001 135.98999 C 240.910004 136.01001 240.850006 136.01001 240.830002 136 L 240.830002 136.01001 Z"
          />
        </g>
        <g id="g219" opacity="0.47" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5476"
            fill="#787878"
            stroke="none"
            d="M 240.830002 136.01001 C 240.830002 136.01001 240.940002 135.919983 241.190002 135.859985 C 241.460007 135.809998 241.75 135.789978 242.309998 135.799988 C 242.869995 135.809998 243.220001 135.910004 243.360001 135.950012 C 243.5 135.98999 243.690002 136.059998 243.660004 136.080017 C 243.610001 136.100006 243.520004 136.029999 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.380005 135.899994 241.080002 135.960022 240.970001 135.98999 C 240.910004 136.01001 240.850006 136.01001 240.830002 136 L 240.830002 136.01001 Z"
          />
        </g>
        <g id="g220" opacity="0.49" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5477"
            fill="#7d7d7d"
            stroke="none"
            d="M 240.830002 136.01001 C 240.830002 136.01001 240.940002 135.919983 241.190002 135.869995 C 241.460007 135.820007 241.75 135.799988 242.300003 135.809998 C 242.860001 135.820007 243.210007 135.919983 243.339996 135.960022 C 243.479996 136 243.669998 136.070007 243.639999 136.089996 C 243.589996 136.109985 243.509995 136.039978 243 135.970001 C 242.479996 135.890015 242.029999 135.890015 241.669998 135.899994 C 241.360001 135.910004 241.059998 135.970001 240.949997 136 C 240.889999 136.02002 240.830002 136.029999 240.809998 136.01001 L 240.830002 136.01001 Z"
          />
        </g>
        <g id="g221" opacity="0.51" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5478"
            fill="#828282"
            stroke="none"
            d="M 240.839996 136.01001 C 240.839996 136.01001 240.949997 135.919983 241.199997 135.869995 C 241.470001 135.820007 241.75 135.799988 242.309998 135.809998 C 242.869995 135.820007 243.210007 135.919983 243.350006 135.960022 C 243.490005 136 243.679993 136.070007 243.649994 136.089996 C 243.600006 136.109985 243.520004 136.039978 243.020004 135.970001 C 242.5 135.890015 242.050003 135.890015 241.690002 135.899994 C 241.380005 135.910004 241.089996 135.970001 240.979996 136 C 240.919998 136.02002 240.860001 136.029999 240.839996 136.01001 Z"
          />
        </g>
        <g id="g222" opacity="0.53" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5479"
            fill="#878787"
            stroke="none"
            d="M 240.839996 136.01001 C 240.839996 136.01001 240.949997 135.919983 241.199997 135.869995 C 241.470001 135.820007 241.75 135.799988 242.309998 135.809998 C 242.869995 135.830017 243.210007 135.919983 243.339996 135.950012 C 243.479996 135.98999 243.679993 136.059998 243.649994 136.080017 C 243.600006 136.100006 243.520004 136.029999 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.380005 135.899994 241.089996 135.960022 240.979996 135.98999 C 240.919998 136.01001 240.860001 136.02002 240.839996 136.01001 Z"
          />
        </g>
        <g id="g223" opacity="0.55" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5480"
            fill="#8c8c8c"
            stroke="none"
            d="M 240.839996 136.01001 C 240.839996 136.01001 240.949997 135.919983 241.210007 135.869995 C 241.479996 135.820007 241.759995 135.799988 242.320007 135.809998 C 242.880005 135.830017 243.210007 135.919983 243.350006 135.950012 C 243.490005 135.98999 243.690002 136.059998 243.660004 136.070007 C 243.610001 136.089996 243.529999 136.02002 243.029999 135.950012 C 242.509995 135.869995 242.059998 135.869995 241.699997 135.880005 C 241.389999 135.890015 241.100006 135.950012 240.990005 135.97998 C 240.929993 136 240.869995 136.01001 240.850006 136 L 240.839996 136.01001 Z"
          />
        </g>
        <g id="g224" opacity="0.57" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5481"
            fill="#919191"
            stroke="none"
            d="M 240.839996 136 C 240.839996 136 240.949997 135.910004 241.210007 135.859985 C 241.479996 135.809998 241.759995 135.789978 242.309998 135.799988 C 242.869995 135.820007 243.199997 135.910004 243.339996 135.940002 C 243.479996 135.97998 243.679993 136.049988 243.649994 136.059998 C 243.600006 136.080017 243.520004 136.01001 243.020004 135.940002 C 242.5 135.859985 242.050003 135.859985 241.690002 135.869995 C 241.389999 135.880005 241.089996 135.940002 240.990005 135.970001 C 240.929993 135.98999 240.869995 136 240.850006 135.98999 L 240.839996 136 Z"
          />
        </g>
        <g id="g225" opacity="0.59" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5482"
            fill="#969696"
            stroke="none"
            d="M 240.839996 136 C 240.839996 136 240.949997 135.910004 241.210007 135.859985 C 241.479996 135.809998 241.75 135.789978 242.309998 135.799988 C 242.869995 135.820007 243.199997 135.910004 243.330002 135.940002 C 243.470001 135.97998 243.669998 136.049988 243.639999 136.059998 C 243.589996 136.080017 243.509995 136.01001 243.009995 135.940002 C 242.490005 135.859985 242.039993 135.859985 241.679993 135.869995 C 241.380005 135.880005 241.089996 135.940002 240.979996 135.970001 C 240.919998 135.98999 240.860001 136 240.839996 135.98999 L 240.839996 136 Z"
          />
        </g>
        <g id="g226" opacity="0.61" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5483"
            fill="#9b9b9b"
            stroke="none"
            d="M 240.850006 136 C 240.850006 136 240.960007 135.910004 241.220001 135.859985 C 241.479996 135.809998 241.759995 135.789978 242.320007 135.799988 C 242.880005 135.820007 243.199997 135.899994 243.339996 135.940002 C 243.479996 135.970001 243.679993 136.049988 243.649994 136.059998 C 243.600006 136.080017 243.520004 136.01001 243.020004 135.940002 C 242.5 135.859985 242.050003 135.859985 241.690002 135.869995 C 241.389999 135.880005 241.100006 135.940002 240.990005 135.970001 C 240.929993 135.98999 240.860001 136 240.850006 135.98999 L 240.850006 136 Z"
          />
        </g>
        <g id="g227" opacity="0.63" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5484"
            fill="#a0a0a0"
            stroke="none"
            d="M 240.850006 136 C 240.850006 136 240.960007 135.919983 241.220001 135.869995 C 241.479996 135.820007 241.759995 135.799988 242.309998 135.809998 C 242.869995 135.830017 243.190002 135.910004 243.330002 135.950012 C 243.470001 135.97998 243.679993 136.059998 243.649994 136.070007 C 243.600006 136.089996 243.520004 136.02002 243.029999 135.950012 C 242.509995 135.869995 242.059998 135.869995 241.699997 135.880005 C 241.399994 135.890015 241.110001 135.950012 241 135.97998 C 240.940002 136 240.869995 136.01001 240.850006 136 Z"
          />
        </g>
        <g id="g228" opacity="0.65" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5485"
            fill="#a5a5a5"
            stroke="none"
            d="M 240.850006 136 C 240.850006 136 240.960007 135.919983 241.220001 135.869995 C 241.479996 135.820007 241.759995 135.799988 242.309998 135.809998 C 242.869995 135.830017 243.190002 135.910004 243.320007 135.950012 C 243.460007 135.97998 243.669998 136.059998 243.639999 136.070007 C 243.600006 136.089996 243.509995 136.02002 243.020004 135.950012 C 242.5 135.869995 242.050003 135.869995 241.690002 135.880005 C 241.389999 135.890015 241.100006 135.950012 241 135.97998 C 240.940002 136 240.869995 136.01001 240.850006 136 Z"
          />
        </g>
        <g id="g229" opacity="0.67" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5486"
            fill="#aaaaaa"
            stroke="none"
            d="M 240.850006 136 C 240.850006 136 240.960007 135.919983 241.220001 135.869995 C 241.479996 135.820007 241.75 135.799988 242.309998 135.820007 C 242.869995 135.839996 243.179993 135.919983 243.320007 135.960022 C 243.460007 135.98999 243.669998 136.070007 243.639999 136.080017 C 243.600006 136.089996 243.520004 136.029999 243.020004 135.960022 C 242.5 135.880005 242.050003 135.880005 241.690002 135.890015 C 241.399994 135.890015 241.110001 135.960022 241 135.98999 C 240.940002 136.01001 240.869995 136.02002 240.850006 136.01001 L 240.850006 136 Z"
          />
        </g>
        <g id="g230" opacity="0.69" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5487"
            fill="#afafaf"
            stroke="none"
            d="M 240.850006 136 C 240.850006 136 240.970001 135.919983 241.220001 135.869995 C 241.479996 135.820007 241.75 135.799988 242.309998 135.820007 C 242.869995 135.839996 243.179993 135.919983 243.320007 135.950012 C 243.460007 135.97998 243.669998 136.059998 243.639999 136.070007 C 243.600006 136.080017 243.520004 136.02002 243.020004 135.950012 C 242.5 135.869995 242.039993 135.869995 241.690002 135.880005 C 241.399994 135.880005 241.110001 135.950012 241 135.97998 C 240.940002 136 240.869995 136.01001 240.850006 136 Z"
          />
        </g>
        <g id="g231" opacity="0.71" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5488"
            fill="#b4b4b4"
            stroke="none"
            d="M 240.860001 136 C 240.860001 136 240.979996 135.919983 241.229996 135.869995 C 241.490005 135.820007 241.759995 135.799988 242.309998 135.820007 C 242.869995 135.839996 243.169998 135.919983 243.309998 135.950012 C 243.449997 135.97998 243.669998 136.059998 243.630005 136.070007 C 243.589996 136.080017 243.509995 136.02002 243.009995 135.940002 C 242.490005 135.859985 242.029999 135.859985 241.679993 135.869995 C 241.389999 135.869995 241.100006 135.940002 241 135.960022 C 240.940002 135.97998 240.869995 135.98999 240.850006 135.98999 L 240.860001 136 Z"
          />
        </g>
        <g id="g232" opacity="0.73" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5489"
            fill="#b9b9b9"
            stroke="none"
            d="M 240.860001 136 C 240.860001 136 240.979996 135.919983 241.229996 135.869995 C 241.490005 135.820007 241.759995 135.799988 242.309998 135.820007 C 242.869995 135.839996 243.169998 135.919983 243.309998 135.950012 C 243.449997 135.97998 243.669998 136.059998 243.639999 136.070007 C 243.600006 136.080017 243.520004 136.02002 243.020004 135.940002 C 242.5 135.859985 242.039993 135.859985 241.690002 135.869995 C 241.399994 135.869995 241.119995 135.940002 241.009995 135.960022 C 240.949997 135.97998 240.880005 135.98999 240.860001 135.98999 L 240.860001 136 Z"
          />
        </g>
        <g id="g233" opacity="0.75" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5490"
            fill="#bebebe"
            stroke="none"
            d="M 240.860001 136 C 240.860001 136 240.979996 135.919983 241.229996 135.869995 C 241.490005 135.820007 241.75 135.799988 242.309998 135.820007 C 242.869995 135.839996 243.169998 135.919983 243.300003 135.950012 C 243.440002 135.97998 243.660004 136.059998 243.630005 136.070007 C 243.589996 136.080017 243.509995 136.02002 243.020004 135.940002 C 242.5 135.859985 242.039993 135.859985 241.690002 135.869995 C 241.399994 135.869995 241.119995 135.929993 241.009995 135.960022 C 240.949997 135.97998 240.869995 135.98999 240.860001 135.98999 L 240.860001 136 Z"
          />
        </g>
        <g id="g234" opacity="0.76" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5491"
            fill="#c3c3c3"
            stroke="none"
            d="M 240.860001 136 C 240.860001 136 240.979996 135.919983 241.229996 135.880005 C 241.490005 135.830017 241.75 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.160004 135.929993 243.300003 135.960022 C 243.440002 135.98999 243.660004 136.070007 243.630005 136.080017 C 243.589996 136.089996 243.509995 136.029999 243.020004 135.950012 C 242.5 135.869995 242.039993 135.869995 241.690002 135.880005 C 241.399994 135.880005 241.119995 135.940002 241.020004 135.970001 C 240.960007 135.98999 240.880005 136.01001 240.869995 136 L 240.860001 136 Z"
          />
        </g>
        <g id="g235" opacity="0.78" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5492"
            fill="#c8c8c8"
            stroke="none"
            d="M 240.860001 136 C 240.860001 136 240.979996 135.919983 241.229996 135.880005 C 241.490005 135.830017 241.75 135.809998 242.300003 135.830017 C 242.860001 135.850006 243.149994 135.929993 243.289993 135.960022 C 243.429993 135.98999 243.649994 136.070007 243.619995 136.080017 C 243.580002 136.089996 243.5 136.029999 243.009995 135.950012 C 242.490005 135.869995 242.029999 135.869995 241.679993 135.880005 C 241.399994 135.880005 241.110001 135.940002 241.009995 135.970001 C 240.949997 135.98999 240.869995 136.01001 240.860001 136 Z"
          />
        </g>
        <g id="g236" opacity="0.8" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5493"
            fill="#cdcdcd"
            stroke="none"
            d="M 240.869995 136 C 240.869995 136 240.990005 135.929993 241.240005 135.880005 C 241.5 135.830017 241.759995 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.160004 135.929993 243.289993 135.960022 C 243.429993 135.98999 243.660004 136.070007 243.630005 136.080017 C 243.589996 136.089996 243.509995 136.02002 243.020004 135.950012 C 242.5 135.869995 242.039993 135.869995 241.690002 135.880005 C 241.410004 135.880005 241.130005 135.940002 241.020004 135.970001 C 240.960007 135.98999 240.880005 136.01001 240.869995 136 Z"
          />
        </g>
        <g id="g237" opacity="0.82" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5494"
            fill="#d2d2d2"
            stroke="none"
            d="M 240.869995 136 C 240.869995 136 240.990005 135.929993 241.240005 135.880005 C 241.5 135.830017 241.75 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.149994 135.929993 243.289993 135.960022 C 243.429993 135.98999 243.660004 136.070007 243.630005 136.080017 C 243.589996 136.089996 243.509995 136.02002 243.020004 135.950012 C 242.5 135.869995 242.039993 135.869995 241.690002 135.880005 C 241.410004 135.880005 241.130005 135.940002 241.020004 135.970001 C 240.960007 135.98999 240.880005 136.01001 240.869995 136 Z"
          />
        </g>
        <g id="g238" opacity="0.84" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5495"
            fill="#d7d7d7"
            stroke="none"
            d="M 240.869995 136 C 240.869995 136 240.990005 135.929993 241.240005 135.880005 C 241.5 135.830017 241.75 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.149994 135.929993 243.289993 135.950012 C 243.429993 135.97998 243.660004 136.059998 243.630005 136.070007 C 243.589996 136.080017 243.520004 136.01001 243.020004 135.940002 C 242.5 135.859985 242.039993 135.859985 241.690002 135.869995 C 241.410004 135.869995 241.130005 135.929993 241.029999 135.960022 C 240.970001 135.97998 240.889999 136 240.880005 135.98999 L 240.869995 136 Z"
          />
        </g>
        <g id="g239" opacity="0.86" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5496"
            fill="#dcdcdc"
            stroke="none"
            d="M 240.869995 136 C 240.869995 136 240.990005 135.929993 241.25 135.880005 C 241.509995 135.830017 241.759995 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.149994 135.929993 243.279999 135.950012 C 243.419998 135.97998 243.649994 136.059998 243.619995 136.070007 C 243.580002 136.070007 243.509995 136.01001 243.020004 135.940002 C 242.5 135.859985 242.039993 135.859985 241.690002 135.869995 C 241.410004 135.869995 241.130005 135.929993 241.029999 135.960022 C 240.970001 135.97998 240.889999 136 240.869995 135.98999 L 240.869995 136 Z"
          />
        </g>
        <g id="g240" opacity="0.88" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5497"
            fill="#e1e1e1"
            stroke="none"
            d="M 240.869995 135.98999 C 240.869995 135.98999 240.990005 135.919983 241.25 135.880005 C 241.509995 135.830017 241.75 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.139999 135.919983 243.279999 135.950012 C 243.419998 135.97998 243.649994 136.059998 243.619995 136.059998 C 243.589996 136.059998 243.509995 136 243.020004 135.929993 C 242.5 135.850006 242.039993 135.850006 241.690002 135.859985 C 241.410004 135.859985 241.139999 135.919983 241.029999 135.950012 C 240.970001 135.970001 240.889999 135.98999 240.869995 135.98999 Z"
          />
        </g>
        <g id="g241" opacity="0.9" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5498"
            fill="#e6e6e6"
            stroke="none"
            d="M 240.880005 135.98999 C 240.880005 135.98999 241 135.919983 241.259995 135.880005 C 241.520004 135.830017 241.759995 135.809998 242.320007 135.830017 C 242.880005 135.850006 243.149994 135.919983 243.289993 135.950012 C 243.429993 135.97998 243.669998 136.059998 243.639999 136.059998 C 243.610001 136.059998 243.529999 136 243.039993 135.929993 C 242.520004 135.850006 242.059998 135.850006 241.710007 135.859985 C 241.440002 135.859985 241.160004 135.919983 241.059998 135.950012 C 241 135.970001 240.910004 135.98999 240.899994 135.98999 L 240.880005 135.98999 Z"
          />
        </g>
        <g id="g242" opacity="0.92" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5499"
            fill="#ebebeb"
            stroke="none"
            d="M 240.880005 135.98999 C 240.880005 135.98999 241 135.919983 241.259995 135.880005 C 241.520004 135.830017 241.759995 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.130005 135.919983 243.270004 135.950012 C 243.410004 135.97998 243.649994 136.059998 243.619995 136.059998 C 243.589996 136.059998 243.509995 136 243.020004 135.929993 C 242.5 135.850006 242.039993 135.850006 241.690002 135.859985 C 241.419998 135.859985 241.139999 135.919983 241.039993 135.950012 C 240.979996 135.970001 240.889999 135.98999 240.880005 135.98999 Z"
          />
        </g>
        <g id="g243" opacity="0.94" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5500"
            fill="#f0f0f0"
            stroke="none"
            d="M 240.880005 135.98999 C 240.880005 135.98999 241.009995 135.919983 241.259995 135.880005 C 241.520004 135.830017 241.759995 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.130005 135.919983 243.270004 135.950012 C 243.410004 135.97998 243.649994 136.059998 243.619995 136.059998 C 243.589996 136.059998 243.509995 136 243.020004 135.929993 C 242.5 135.850006 242.039993 135.850006 241.690002 135.859985 C 241.419998 135.859985 241.149994 135.919983 241.039993 135.950012 C 240.979996 135.970001 240.889999 135.98999 240.880005 135.98999 Z"
          />
        </g>
        <g id="g244" opacity="0.96" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5501"
            fill="#f5f5f5"
            stroke="none"
            d="M 240.880005 135.98999 C 240.880005 135.98999 241.009995 135.919983 241.259995 135.880005 C 241.520004 135.839996 241.75 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.130005 135.919983 243.259995 135.950012 C 243.399994 135.97998 243.639999 136.059998 243.610001 136.059998 C 243.580002 136.059998 243.5 136 243.009995 135.929993 C 242.490005 135.850006 242.029999 135.850006 241.679993 135.859985 C 241.410004 135.859985 241.139999 135.919983 241.039993 135.950012 C 240.979996 135.970001 240.889999 135.98999 240.880005 135.98999 Z"
          />
        </g>
        <g id="g245" opacity="0.98" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5502"
            fill="#fafafa"
            stroke="none"
            d="M 240.880005 135.98999 C 240.880005 135.98999 241.009995 135.929993 241.259995 135.880005 C 241.520004 135.839996 241.75 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.119995 135.919983 243.259995 135.950012 C 243.399994 135.97998 243.639999 136.049988 243.610001 136.059998 C 243.580002 136.070007 243.5 136 243.020004 135.929993 C 242.5 135.850006 242.039993 135.850006 241.690002 135.859985 C 241.419998 135.859985 241.149994 135.919983 241.050003 135.950012 C 240.990005 135.970001 240.899994 135.98999 240.889999 135.98999 L 240.880005 135.98999 Z"
          />
        </g>
        <g id="g246" opacity="0.3" style={{ mixBlendMode: 'screen' }}>
          <path
            id="path5503"
            fill="#ffffff"
            stroke="none"
            d="M 240.889999 135.98999 C 240.889999 135.98999 241.020004 135.929993 241.270004 135.880005 C 241.529999 135.839996 241.759995 135.809998 242.309998 135.830017 C 242.869995 135.850006 243.119995 135.919983 243.259995 135.950012 C 243.399994 135.970001 243.649994 136.049988 243.619995 136.059998 C 243.589996 136.059998 243.509995 136 243.029999 135.929993 C 242.509995 135.850006 242.050003 135.850006 241.699997 135.859985 C 241.440002 135.859985 241.160004 135.919983 241.059998 135.940002 C 241 135.960022 240.910004 135.97998 240.899994 135.97998 L 240.889999 135.98999 Z"
          />
        </g>
      </g>
      <radialGradient
        id="radialGradient1"
        cx="816.04"
        cy="293.15"
        r="31.85"
        fx="816.04"
        fy="293.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5504"
        fill="url(#radialGradient1)"
        fillRule="evenodd"
        stroke="none"
        d="M 844.98999 284.679993 C 844.98999 284.679993 832.02002 267.019989 797.650024 265.570007 C 797.650024 265.570007 783.200012 293.149994 790.52002 323.98999 L 783.210022 323.299988 C 783.210022 323.299988 786.059998 285.98999 795.599976 262.299988 C 795.599976 262.299988 820.51001 264.480011 848.869995 276.429993 C 848.869995 276.429993 848.869995 284.200012 844.98999 284.679993 Z"
      />
      <radialGradient
        id="radialGradient2"
        cx="846.04"
        cy="279.93"
        r="2.52"
        fx="846.04"
        fy="279.93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5505"
        fill="url(#radialGradient2)"
        fillRule="evenodd"
        stroke="none"
        d="M 847.97998 279.929993 C 847.97998 281.579987 847.109985 282.910004 846.039978 282.910004 C 844.969971 282.910004 844.099976 281.570007 844.099976 279.929993 C 844.099976 278.290009 844.969971 276.950012 846.039978 276.950012 C 847.109985 276.950012 847.97998 278.290009 847.97998 279.929993 Z"
      />
      <radialGradient
        id="radialGradient3"
        cx="786.7"
        cy="320.33"
        r="2.52"
        fx="786.7"
        fy="320.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b998b4" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5506"
        fill="url(#radialGradient3)"
        fillRule="evenodd"
        stroke="none"
        d="M 788.640015 320.329987 C 788.640015 321.980011 787.77002 323.309998 786.700012 323.309998 C 785.630005 323.309998 784.76001 321.970001 784.76001 320.329987 C 784.76001 318.690002 785.630005 317.350006 786.700012 317.350006 C 787.77002 317.350006 788.640015 318.690002 788.640015 320.329987 Z"
      />
      <radialGradient
        id="radialGradient4"
        cx="788.24"
        cy="292.81"
        r="22.19"
        fx="788.24"
        fy="292.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5507"
        fill="url(#radialGradient4)"
        fillRule="evenodd"
        stroke="none"
        d="M 795.590027 262.309998 L 790.27002 262.309998 C 790.27002 262.309998 779.859985 294.839996 780.960022 323.309998 L 783.200012 323.309998 C 783.200012 323.309998 787.119995 285.700012 795.590027 262.309998 Z"
      />
      <path
        id="path5508"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 797.210022 266.73999 C 797.210022 266.73999 826.130005 266.609985 844.98999 284.690002 C 844.98999 284.690002 833.690002 267.350006 797.72998 265.100006 L 797.210022 266.75 L 797.210022 266.73999 Z"
      />
      <path
        id="path5509"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 832.070007 353.519989 L 810.109985 366.950012 C 810.109985 366.950012 808.48999 370.269989 808.119995 373.970001 L 810.090027 373.970001 C 810.090027 373.970001 811.349976 370.970001 812.039978 370.070007 C 813.570007 368.100006 833.369995 363.079987 833.369995 363.079987 L 835.830017 353.51001 L 832.070007 353.51001 L 832.070007 353.519989 Z"
      />
      <radialGradient
        id="radialGradient5"
        cx="821.977"
        cy="363.75"
        r="9.73631"
        fx="821.977"
        fy="363.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5510"
        fill="url(#radialGradient5)"
        fillRule="evenodd"
        stroke="none"
        d="M 831.190002 353.519989 L 809.22998 366.950012 C 809.22998 366.950012 807.609985 370.269989 807.23999 373.970001 L 809.210022 373.970001 C 809.210022 373.970001 810.469971 370.970001 811.159973 370.070007 C 812.690002 368.100006 832.48999 363.079987 832.48999 363.079987 L 832.820007 361.359985 L 831.190002 353.5 L 831.190002 353.519989 Z"
      />
      <radialGradient
        id="radialGradient6"
        cx="803.245"
        cy="374.918"
        r="8.59"
        fx="803.245"
        fy="374.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5511"
        fill="url(#radialGradient6)"
        stroke="none"
        d="M 813.77301 377.895996 C 814.393982 374.069 811.794983 370.463013 807.968018 369.841003 C 804.140991 369.220001 800.534973 371.819 799.914001 375.645996 C 799.29303 379.472992 801.892029 383.07901 805.718994 383.700012 C 809.546021 384.321014 813.151978 381.721985 813.77301 377.895996 Z"
      />
      <radialGradient
        id="radialGradient7"
        cx="795.966"
        cy="374.24"
        r="4.9302"
        fx="795.966"
        fy="374.24"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5512"
        fill="url(#radialGradient7)"
        stroke="none"
        d="M 804.380005 382.200012 C 806.622009 382.200012 808.440002 379.76001 808.440002 376.75 C 808.440002 373.73999 806.622009 371.299988 804.380005 371.299988 C 802.138 371.299988 800.320007 373.73999 800.320007 376.75 C 800.320007 379.76001 802.138 382.200012 804.380005 382.200012 Z"
      />
      <radialGradient
        id="radialGradient8"
        cx="872.71"
        cy="251.06"
        r="59.43"
        fx="872.71"
        fy="251.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#b099b4" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5513"
        fill="url(#radialGradient8)"
        fillRule="evenodd"
        stroke="none"
        d="M 863.289978 186.820007 C 863.289978 186.820007 842.450012 262.140015 826.679993 321.380005 L 887.400024 315.519989 C 887.400024 315.519989 912.390015 253.240005 918.73999 181.839996 C 918.73999 181.839996 896.140015 177.26001 863.289978 186.830017 L 863.289978 186.820007 Z"
      />
      <linearGradient
        id="linearGradient119"
        x1="758.95"
        y1="324.88"
        x2="891.38"
        y2="324.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#6e5f85" stopOpacity={1} />
        <stop offset={1} stopColor="#3f1f49" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5514"
        fill="url(#linearGradient119)"
        fillRule="evenodd"
        stroke="none"
        d="M 758.950012 323.649994 C 758.950012 323.649994 825.169983 330.850006 891.380005 325.859985 C 891.380005 325.859985 853.169983 321.420013 822 322.23999 L 758.940002 323.649994 L 758.950012 323.649994 Z"
      />
      <radialGradient
        id="radialGradient9"
        cx="872.34"
        cy="253.6"
        r="62.48"
        fx="872.34"
        fy="253.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5515"
        fill="url(#radialGradient9)"
        fillRule="evenodd"
        stroke="none"
        d="M 822 318.200012 C 822 318.200012 862.75 316.799988 887.390015 315.519989 C 887.390015 315.519989 906.48999 253.600006 918.820007 180.97998 L 922.669983 180.97998 C 922.669983 180.97998 911.159973 265.269989 891.369995 325.869995 C 891.369995 325.869995 872.51001 327.899994 821.98999 322.25 L 821.98999 318.209991 L 822 318.200012 Z"
      />
      <radialGradient
        id="radialGradient10"
        cx="790.48"
        cy="320.93"
        r="22.38"
        fx="790.48"
        fy="320.93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5516"
        fill="url(#radialGradient10)"
        fillRule="evenodd"
        stroke="none"
        d="M 822 318.200012 L 758.950012 318.200012 L 758.950012 323.649994 L 822 322.23999 L 822 318.200012 Z"
      />
      <radialGradient
        id="radialGradient11"
        cx="891.57"
        cy="182.6"
        r="22.11"
        fx="891.57"
        fy="182.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#b099b4" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5517"
        fill="url(#radialGradient11)"
        fillRule="evenodd"
        stroke="none"
        d="M 922.679993 180.970001 C 922.679993 180.970001 902.200012 175.470001 860.460022 185.700012 C 860.460022 185.700012 886.130005 177.690002 918.73999 181.830017 L 922.679993 180.970001 Z"
      />
      <radialGradient
        id="radialGradient12"
        cx="855.51"
        cy="304.616"
        r="31.82"
        fx="855.51"
        fy="304.616"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5518"
        fill="url(#radialGradient12)"
        fillRule="evenodd"
        stroke="none"
        d="M 758.950012 318.200012 C 758.950012 318.200012 757.98999 309.809998 761.23999 306.980011 C 761.23999 306.980011 826.679993 302.25 883.169983 311.73999 L 887.059998 315.579987 L 822.890015 318.170013 L 758.950012 318.200012 Z"
      />
      <g id="g247" opacity="0.5" style={{ mixBlendMode: 'screen' }}>
        <path
          id="path5519"
          fill="#41243f"
          fillRule="evenodd"
          stroke="none"
          d="M 822 318.200012 L 824.799988 310.339996 L 761.23999 306.980011 C 761.23999 306.980011 757.820007 309.630005 758.950012 318.200012 L 822.01001 318.200012 L 822 318.200012 Z"
        />
      </g>
      <path
        id="path5520"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 761.23999 306.970001 L 818.940002 310.48999 C 818.940002 310.48999 857.919983 309.100006 883.169983 311.730011 C 883.169983 311.730011 832.97998 302.119995 761.23999 306.970001 Z"
      />
      <path
        id="path5521"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 883.169983 311.73999 C 883.169983 311.73999 902.880005 252.5 907.72998 228.529999 C 907.72998 228.529999 898.669983 192.940002 913.299988 180.97998 L 918.75 181.839996 C 918.75 181.839996 902.130005 274.709991 887.070007 315.579987 L 883.179993 311.73999 L 883.169983 311.73999 Z"
      />
      <radialGradient
        id="radialGradient13"
        cx="892.95"
        cy="217.025"
        r="89.66"
        fx="892.95"
        fy="217.025"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5522"
        fill="url(#radialGradient13)"
        fillRule="evenodd"
        stroke="none"
        d="M 913.289978 180.970001 C 913.289978 180.970001 886.710022 177.350006 860.460022 185.700012 C 860.460022 185.700012 847.52002 205.380005 851.559998 228.600006 L 830.599976 306.299988 C 830.599976 306.299988 864.98999 308.220001 883.169983 311.720001 C 883.169983 311.720001 903.960022 250.059998 907.72998 228.51001 C 907.72998 228.51001 902.169983 201.539978 913.299988 180.960022 L 913.289978 180.970001 Z"
      />
      <path
        id="path5523"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 817.390015 327.089996 L 854.26001 327.089996 C 854.26001 327.089996 845.440002 332.679993 834.799988 332.679993 C 824.159973 332.679993 817.390015 327.089996 817.390015 327.089996 Z"
      />
      <radialGradient
        id="radialGradient14"
        cx="836.864"
        cy="335.09"
        r="5.72401"
        fx="836.864"
        fy="335.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5524"
        fill="url(#radialGradient14)"
        fillRule="evenodd"
        stroke="none"
        d="M 830.650024 332.390015 L 831.700012 350.700012 L 838.48999 350.700012 L 839.169983 332.350006 L 830.650024 332.390015 Z"
      />
      <radialGradient
        id="radialGradient15"
        cx="839.444"
        cy="344.417"
        r="15.48"
        fx="839.444"
        fy="344.417"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5525"
        fill="url(#radialGradient15)"
        fillRule="evenodd"
        stroke="none"
        d="M 829.849976 343.51001 L 839.969971 343.51001 L 838.960022 362.679993 L 831.049988 362.679993 L 829.849976 343.51001 Z"
      />
      <radialGradient
        id="radialGradient16"
        cx="807.051"
        cy="363.32"
        r="21.857"
        fx="807.051"
        fy="363.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5526"
        fill="url(#radialGradient16)"
        fillRule="evenodd"
        stroke="none"
        d="M 830.650024 353.089996 L 781.289978 366.519989 C 781.289978 366.519989 777.650024 369.839996 776.809998 373.540009 L 781.22998 373.540009 C 781.22998 373.540009 784.059998 370.540009 785.619995 369.640015 C 789.049988 367.670013 833.559998 362.649994 833.559998 362.649994 L 834.289978 360.929993 L 830.640015 353.070007 L 830.650024 353.089996 Z"
      />
      <radialGradient
        id="radialGradient17"
        cx="777.63"
        cy="373.86"
        r="8.58999"
        fx="777.63"
        fy="373.86"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5527"
        fill="url(#radialGradient17)"
        stroke="none"
        d="M 781.25 382.690002 C 785.127014 382.690002 788.27002 379.546997 788.27002 375.670013 C 788.27002 371.792999 785.127014 368.649994 781.25 368.649994 C 777.372986 368.649994 774.22998 371.792999 774.22998 375.670013 C 774.22998 379.546997 777.372986 382.690002 781.25 382.690002 Z"
      />
      <radialGradient
        id="radialGradient18"
        cx="776.662"
        cy="373.812"
        r="4.9302"
        fx="776.662"
        fy="373.812"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5528"
        fill="url(#radialGradient18)"
        fillRule="evenodd"
        stroke="none"
        d="M 787.349976 376.320007 C 787.349976 379.329987 785.530029 381.769989 783.289978 381.769989 C 781.049988 381.769989 779.22998 379.329987 779.22998 376.320007 C 779.22998 373.309998 781.049988 370.869995 783.289978 370.869995 C 785.530029 370.869995 787.349976 373.309998 787.349976 376.320007 Z"
      />
      <radialGradient
        id="radialGradient19"
        cx="863.881"
        cy="363.32"
        r="21.857"
        fx="863.881"
        fy="363.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5529"
        fill="url(#radialGradient19)"
        fillRule="evenodd"
        stroke="none"
        d="M 839.47998 353.089996 L 888.840027 366.519989 C 888.840027 366.519989 892.47998 369.839996 893.320007 373.540009 L 888.900024 373.540009 C 888.900024 373.540009 886.070007 370.540009 884.51001 369.640015 C 881.080017 367.670013 836.570007 362.649994 836.570007 362.649994 L 835.840027 360.929993 L 839.48999 353.070007 L 839.47998 353.089996 Z"
      />
      <path
        id="path5530"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 839.080017 353.089996 L 861.039978 366.519989 C 861.039978 366.519989 862.659973 369.839996 863.030029 373.540009 L 861.059998 373.540009 C 861.059998 373.540009 859.799988 370.540009 859.109985 369.640015 C 857.580017 367.670013 837.780029 362.649994 837.780029 362.649994 L 835.320007 353.079987 L 839.080017 353.079987 L 839.080017 353.089996 Z"
      />
      <radialGradient
        id="radialGradient20"
        cx="846.488"
        cy="363.32"
        r="9.73631"
        fx="846.488"
        fy="363.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5531"
        fill="url(#radialGradient20)"
        fillRule="evenodd"
        stroke="none"
        d="M 835.320007 353.089996 L 857.280029 366.519989 C 857.280029 366.519989 858.900024 369.839996 859.27002 373.540009 L 857.299988 373.540009 C 857.299988 373.540009 856.039978 370.540009 855.349976 369.640015 C 853.820007 367.670013 834.02002 362.649994 834.02002 362.649994 L 833.690002 360.929993 L 835.320007 353.070007 L 835.320007 353.089996 Z"
      />
      <radialGradient
        id="radialGradient21"
        cx="892.5"
        cy="373.86"
        r="8.59002"
        fx="892.5"
        fy="373.86"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5532"
        fill="url(#radialGradient21)"
        stroke="none"
        d="M 888.890015 382.690002 C 892.767029 382.690002 895.909973 379.546997 895.909973 375.670013 C 895.909973 371.792999 892.767029 368.649994 888.890015 368.649994 C 885.013 368.649994 881.869995 371.792999 881.869995 375.670013 C 881.869995 379.546997 885.013 382.690002 888.890015 382.690002 Z"
      />
      <radialGradient
        id="radialGradient22"
        cx="890.137"
        cy="373.812"
        r="4.9302"
        fx="890.137"
        fy="373.812"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5533"
        fill="url(#radialGradient22)"
        fillRule="evenodd"
        stroke="none"
        d="M 882.780029 376.320007 C 882.780029 379.329987 884.599976 381.769989 886.840027 381.769989 C 889.080017 381.769989 890.900024 379.329987 890.900024 376.320007 C 890.900024 373.309998 889.080017 370.869995 886.840027 370.869995 C 884.599976 370.869995 882.780029 373.309998 882.780029 376.320007 Z"
      />
      <path
        id="path5534"
        fill="#482f54"
        fillRule="evenodd"
        stroke="none"
        d="M 861.039978 366.529999 L 857.280029 366.529999 C 857.280029 366.529999 858.929993 369.950012 859.27002 373.549988 L 863.030029 373.549988 C 863.030029 373.549988 862.580017 369.01001 861.039978 366.529999 Z"
      />
      <radialGradient
        id="radialGradient23"
        cx="863.31"
        cy="374.51"
        r="8.59002"
        fx="863.31"
        fy="374.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5535"
        fill="url(#radialGradient23)"
        stroke="none"
        d="M 859.700012 383.339996 C 863.577026 383.339996 866.719971 380.196991 866.719971 376.320007 C 866.719971 372.442993 863.577026 369.299988 859.700012 369.299988 C 855.822998 369.299988 852.679993 372.442993 852.679993 376.320007 C 852.679993 380.196991 855.822998 383.339996 859.700012 383.339996 Z"
      />
      <radialGradient
        id="radialGradient24"
        cx="861.163"
        cy="374.462"
        r="4.9302"
        fx="861.163"
        fy="374.462"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5536"
        fill="url(#radialGradient24)"
        fillRule="evenodd"
        stroke="none"
        d="M 853.599976 376.970001 C 853.599976 379.980011 855.419983 382.420013 857.659973 382.420013 C 859.900024 382.420013 861.719971 379.980011 861.719971 376.970001 C 861.719971 373.959991 859.900024 371.519989 857.659973 371.519989 C 855.419983 371.519989 853.599976 373.959991 853.599976 376.970001 Z"
      />
      <radialGradient
        id="radialGradient25"
        cx="886.15"
        cy="186.92"
        r="19.67"
        fx="886.15"
        fy="186.92"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5537"
        fill="url(#radialGradient25)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 859.109985 193.02002 C 859.109985 193.02002 864.5 185.789978 877.25 184.429993 C 894.419983 182.600006 908.150024 187.859985 908.150024 187.859985 C 908.150024 187.859985 909.5 183.119995 913.289978 180.970001 C 913.289978 180.970001 885.309998 179.48999 861.599976 185.700012 C 861.599976 185.700012 858.369995 188.02002 859.099976 193.01001 L 859.109985 193.02002 Z"
      />
      <path
        id="path5538"
        fill="#26132a"
        fillRule="evenodd"
        stroke="none"
        d="M 853.169983 228.529999 L 906.76001 227.210022 C 906.76001 227.210022 897.070007 228.470001 885.330017 229.880005 C 871.890015 231.48999 853.169983 228.529999 853.169983 228.529999 Z"
      />
      <radialGradient
        id="radialGradient26"
        cx="875.29"
        cy="232.44"
        r="10.07"
        fx="875.29"
        fy="232.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5539"
        fill="url(#radialGradient26)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.3"
        style={{ mixBlendMode: 'screen' }}
        d="M 861.450012 230.359985 C 860.030029 230.660004 864.809998 233.72998 873.950012 234.460022 C 883.090027 235.190002 889.950012 230.210022 889.349976 230.359985 C 888.75 230.52002 884.590027 231.720001 875.299988 231.47998 C 865.98999 231.23999 861.659973 230.320007 861.450012 230.359985 Z"
      />
      <linearGradient
        id="linearGradient120"
        x1="854.69"
        y1="243.09"
        x2="854.69"
        y2="230.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5540"
        fill="url(#linearGradient120)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.3"
        style={{ mixBlendMode: 'screen' }}
        d="M 857.5 230.359985 C 853.179993 229.669983 850.400024 241.729996 850.72998 242.940002 C 851.049988 244.149994 852.669983 238.190002 854.840027 237.130005 C 859.109985 235.039978 859.530029 230.690002 857.5 230.369995 L 857.5 230.359985 Z"
      />
      <linearGradient
        id="linearGradient121"
        x1="856.04"
        y1="212.21"
        x2="856.04"
        y2="195.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5541"
        fill="url(#linearGradient121)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 854.140015 212.210022 C 854.140015 212.210022 852.73999 200.76001 857.419983 195.440002 C 859.969971 198.75 854.919983 203.830017 854.140015 212.210022 Z"
      />
      <path
        id="path5542"
        fill="#9b9b9b"
        stroke="none"
        d="M 856.26001 218.669983 C 856.26001 218.669983 850.059998 210.5 845.059998 206.5 C 840.539978 202.880005 832.619995 202.940002 833.059998 202.5 C 833.059998 202.5 846.059998 185.5 859.409973 187.339996 L 860.840027 177.289978 C 860.840027 177.289978 834.599976 181.940002 816.049988 200.5 C 811.049988 205.5 850.51001 235.950012 850.51001 235.950012 L 856.25 218.669983 L 856.26001 218.669983 Z"
      />
      <path
        id="path5543"
        fill="#00a504"
        stroke="none"
        d="M 873.679993 214.73999 C 873.679993 214.73999 897.679993 218.179993 892.72998 232.690002 C 888.960022 237.119995 888.299988 239.160004 887.890015 241.550003 C 887.47998 243.940002 878.669983 295.390015 855.640015 303.359985 L 836.02002 277.890015 C 836.02002 277.890015 821.820007 271.679993 840.320007 233.119995 C 842.109985 229.380005 843.549988 224.589996 849.070007 218.940002 C 854.22998 213.660004 860.659973 209.910004 873.679993 214.72998 L 873.679993 214.73999 Z"
      />
      <path
        id="path5544"
        fill="#9b9b9b"
        stroke="none"
        d="M 883.059998 242.5 C 907.73999 242.199997 927.059998 220.27002 927.059998 220.27002 C 931.559998 215.77002 913.679993 195.149994 905.330017 188.559998 L 899.429993 198.22998 C 905.51001 204.390015 911.049988 210.5 913.049988 216.5 C 914.349976 220.410004 909.049988 216.5 903.049988 219.5 C 898.580017 221.73999 894.309998 224.809998 889.25 220.410004 C 887.049988 218.5 883.619995 219.119995 881.090027 220.5 C 869.200012 227.049988 876.390015 242.630005 883.049988 242.5 L 883.059998 242.5 Z"
      />
      <path
        id="path5545"
        fill="#fcba7e"
        stroke="none"
        d="M 899.950012 185.75 C 899.950012 185.75 896.059998 180.600006 889.299988 176.76001 C 882.530029 172.919983 879.549988 171.98999 878.710022 173.419983 C 877.869995 174.850006 886.359985 176.589996 885.200012 178.440002 C 884.51001 179.529999 876.919983 173.47998 875.659973 175.299988 C 874.119995 177.51001 884.559998 180.169983 883.700012 181.789978 C 882.869995 183.359985 875.030029 176.619995 874.070007 178.399994 C 872.590027 181.169983 883.460022 183.600006 882.039978 185.23999 C 881.289978 186.100006 874.289978 180.549988 873.559998 181.910004 C 872.570007 183.73999 877.169983 186.25 883.700012 189.200012 C 885.679993 190.100006 885.549988 190.789978 884.880005 191.179993 C 883.080017 192.22998 880.5 193.929993 880.940002 195.359985 C 881.609985 197.549988 888.400024 191.350006 895.049988 193.059998 C 901.710022 194.77002 901.72998 187.26001 899.960022 185.76001 L 899.950012 185.75 Z"
      />
      <path
        id="path5546"
        fill="#dbf5ff"
        stroke="none"
        d="M 894.190002 193.830017 C 896.27002 195.289978 898.390015 197 899.820007 198.450012 L 905.599976 188.97998 C 902.440002 186.470001 899.780029 184.679993 899.780029 184.679993 L 894.179993 193.839996 L 894.190002 193.830017 Z"
      />
      <path
        id="path5547"
        fill="#d49c6a"
        stroke="none"
        d="M 879.859985 188.179993 C 880.280029 187.669983 880.890015 187.289978 881.599976 187.200012 C 882.309998 187.109985 883.090027 187.390015 883.630005 187.929993 C 884.179993 188.470001 884.48999 189.200012 884.619995 189.929993 C 884.75 190.669983 884.690002 191.419983 884.5 192.119995 C 884.130005 193.52002 883.119995 194.820007 881.679993 195.27002 C 881.320007 195.369995 880.940002 195.419983 880.570007 195.369995 C 880.200012 195.309998 879.840027 195.190002 879.539978 194.98999 C 878.929993 194.580017 878.559998 193.919983 878.460022 193.27002 C 878.820007 193.820007 879.289978 194.26001 879.820007 194.429993 C 880.349976 194.609985 880.890015 194.559998 881.359985 194.330017 C 882.320007 193.880005 883.01001 192.859985 883.330017 191.779999 C 883.650024 190.700012 883.570007 189.460022 882.940002 188.600006 C 882.619995 188.190002 882.159973 187.880005 881.599976 187.809998 C 881.039978 187.72998 880.429993 187.890015 879.859985 188.190002 L 879.859985 188.179993 Z"
      />
      <path
        id="path5548"
        fill="#d49c6a"
        stroke="none"
        d="M 860.76001 178.679993 C 860.679993 179.23999 860.570007 179.799988 860.400024 180.350006 C 860.359985 180.48999 860.309998 180.619995 860.26001 180.77002 C 860.200012 180.919983 860.130005 181.039978 860.070007 181.169983 C 859.940002 181.429993 859.780029 181.679993 859.590027 181.929993 C 859.400024 182.169983 859.179993 182.399994 858.919983 182.589996 C 858.780029 182.679993 858.659973 182.76001 858.51001 182.839996 C 858.349976 182.919983 858.190002 182.970001 858.030029 183.02002 C 857.869995 183.059998 857.710022 183.089996 857.549988 183.100006 C 857.390015 183.109985 857.219971 183.100006 857.099976 183.100006 C 856.830017 183.100006 856.619995 183.109985 856.469971 183.160004 L 856.429993 183.160004 C 856.309998 183.200012 856.200012 183.25 856.099976 183.299988 C 855.98999 183.359985 855.900024 183.429993 855.830017 183.51001 C 855.76001 183.589996 855.710022 183.669983 855.690002 183.72998 C 855.679993 183.76001 855.669983 183.809998 855.659973 183.839996 C 855.659973 183.869995 855.659973 183.910004 855.659973 183.950012 C 855.679993 184.029999 855.710022 184.130005 855.77002 184.23999 C 855.830017 184.350006 855.909973 184.450012 856 184.549988 C 856.049988 184.600006 856.090027 184.649994 856.150024 184.700012 C 856.210022 184.75 856.280029 184.809998 856.340027 184.859985 C 856.460022 184.960022 856.590027 185.070007 856.719971 185.169983 C 856.98999 185.369995 857.26001 185.570007 857.539978 185.76001 L 857.75 185.899994 L 857.960022 186.029999 C 858.099976 186.119995 858.23999 186.200012 858.390015 186.279999 C 858.539978 186.359985 858.679993 186.429993 858.820007 186.48999 C 858.969971 186.539978 859.119995 186.589996 859.27002 186.609985 C 859.309998 186.609985 859.349976 186.609985 859.390015 186.609985 C 859.429993 186.609985 859.460022 186.609985 859.5 186.609985 C 859.570007 186.609985 859.640015 186.580017 859.719971 186.549988 C 859.859985 186.48999 860 186.369995 860.099976 186.22998 C 860.059998 186.410004 859.969971 186.580017 859.840027 186.72998 C 859.77002 186.799988 859.690002 186.859985 859.590027 186.910004 C 859.539978 186.929993 859.48999 186.950012 859.440002 186.970001 C 859.390015 186.97998 859.349976 187 859.299988 187.01001 C 858.919983 187.089996 858.52002 187.02002 858.169983 186.929993 C 857.98999 186.880005 857.820007 186.830017 857.640015 186.76001 C 857.549988 186.72998 857.469971 186.690002 857.380005 186.660004 L 857.140015 186.549988 C 856.820007 186.399994 856.5 186.23999 856.179993 186.049988 C 856.02002 185.960022 855.869995 185.859985 855.710022 185.75 C 855.630005 185.690002 855.559998 185.640015 855.48999 185.589996 C 855.409973 185.529999 855.330017 185.460022 855.25 185.390015 C 855.090027 185.23999 854.950012 185.080017 854.820007 184.880005 C 854.700012 184.679993 854.590027 184.460022 854.539978 184.190002 C 854.52002 184.049988 854.5 183.910004 854.52002 183.77002 C 854.530029 183.619995 854.559998 183.5 854.599976 183.359985 C 854.690002 183.089996 854.840027 182.869995 855.01001 182.700012 C 855.349976 182.350006 855.77002 182.149994 856.210022 182.059998 L 856.169983 182.059998 C 856.349976 182.02002 856.530029 182 856.700012 181.98999 C 856.869995 181.98999 857.02002 181.98999 857.159973 182.01001 C 857.309998 182.02002 857.409973 182.029999 857.52002 182.029999 C 857.630005 182.029999 857.73999 182.029999 857.840027 182.01001 C 857.940002 181.98999 858.039978 181.970001 858.140015 181.940002 C 858.22998 181.910004 858.349976 181.850006 858.450012 181.799988 C 858.650024 181.690002 858.840027 181.549988 859.02002 181.380005 C 859.200012 181.210022 859.369995 181.02002 859.539978 180.809998 C 859.619995 180.710022 859.710022 180.600006 859.77002 180.5 C 859.840027 180.399994 859.909973 180.279999 859.97998 180.160004 C 860.25 179.690002 860.51001 179.190002 860.780029 178.700012 L 860.76001 178.679993 Z"
      />
      <path
        id="path5549"
        fill="#fcba7e"
        stroke="none"
        d="M 855.090027 183.679993 C 854.969971 184.200012 855.320007 184.77002 855.830017 185.160004 C 856.330017 185.570007 856.960022 185.950012 857.549988 186.279999 C 857.849976 186.440002 858.159973 186.580017 858.460022 186.679993 C 858.780029 186.789978 859.099976 186.839996 859.400024 186.799988 C 859.700012 186.76001 859.950012 186.549988 860.090027 186.23999 C 860.25 185.940002 860.289978 185.580017 860.340027 185.220001 L 860.77002 178.679993 C 860.77002 178.679993 860.309998 180.089996 859.969971 180.710022 C 859.599976 181.339996 859.140015 181.970001 858.429993 182.330017 C 858.080017 182.51001 857.659973 182.580017 857.25 182.559998 C 856.919983 182.549988 856.619995 182.529999 856.320007 182.619995 C 855.72998 182.73999 855.200012 183.169983 855.099976 183.690002 L 855.090027 183.679993 Z"
      />
      <path
        id="path5550"
        fill="#534741"
        stroke="none"
        d="M 860.200012 188.350006 C 859.090027 187.549988 857.809998 186.910004 856.460022 186.929993 C 855.109985 186.960022 853.710022 187.830017 853.390015 189.179993 C 855.809998 190.98999 859.849976 192.5 864.210022 192.5 C 863.359985 190.609985 861.799988 189.48999 860.200012 188.339996 L 860.200012 188.350006 Z"
      />
      <path
        id="path5551"
        fill="#333333"
        stroke="none"
        d="M 865.830017 182.789978 C 865.359985 184.160004 864.359985 185.039978 863.590027 184.76001 C 862.820007 184.47998 862.559998 183.149994 863.030029 181.779999 C 863.5 180.410004 864.5 179.529999 865.27002 179.809998 C 866.039978 180.089996 866.299988 181.419983 865.830017 182.789978 Z"
      />
      <path
        id="path5552"
        fill="#e6e6e6"
        stroke="none"
        d="M 865.140015 181.179993 C 865.080017 181.570007 864.72998 181.830017 864.349976 181.77002 C 863.969971 181.710022 863.719971 181.350006 863.77002 180.960022 C 863.830017 180.570007 864.179993 180.309998 864.559998 180.369995 C 864.940002 180.429993 865.190002 180.789978 865.140015 181.179993 Z"
      />
      <path
        id="path5553"
        fill="#d49c6a"
        stroke="none"
        d="M 864 178.179993 C 865.030029 176.76001 866.98999 176.47998 868.369995 177.549988 C 869.75 178.619995 870.039978 180.630005 869.01001 182.049988 L 864 178.179993 Z"
      />
      <path
        id="path5554"
        fill="#333333"
        stroke="none"
        d="M 859.27002 179.220001 C 858.869995 180.410004 858.039978 181.179993 857.409973 180.960022 C 856.789978 180.72998 856.599976 179.589996 857.01001 178.399994 C 857.409973 177.210022 858.23999 176.440002 858.869995 176.660004 C 859.5 176.880005 859.679993 178.029999 859.27002 179.220001 Z"
      />
      <path
        id="path5555"
        fill="#e6e6e6"
        stroke="none"
        d="M 858.72998 177.839996 C 858.679993 178.169983 858.380005 178.410004 858.080017 178.359985 C 857.780029 178.309998 857.570007 178.01001 857.630005 177.669983 C 857.679993 177.339996 857.97998 177.100006 858.280029 177.149994 C 858.580017 177.200012 858.789978 177.5 858.72998 177.839996 Z"
      />
      <path
        id="path5556"
        fill="#d49c6a"
        stroke="none"
        d="M 857.830017 175.320007 C 858.820007 174.100006 860.22998 173.649994 860.98999 174.299988 C 861.75 174.950012 861.570007 176.470001 860.580017 177.690002 L 857.830017 175.320007 Z"
      />
      <path
        id="path5557"
        fill="#fcba7e"
        stroke="none"
        d="M 883.859985 192.169983 C 883.200012 194.160004 881.460022 195.350006 879.969971 194.830017 C 878.47998 194.309998 877.809998 192.27002 878.460022 190.279999 C 879.119995 188.289978 880.859985 187.100006 882.349976 187.619995 C 883.840027 188.140015 884.51001 190.179993 883.859985 192.169983 Z"
      />
      <path
        id="path5558"
        fill="#bd6855"
        stroke="none"
        d="M 853.929993 191.100006 C 854.159973 191.320007 854.27002 191.330017 854.340027 191.440002 C 854.400024 191.539978 854.440002 191.660004 854.48999 191.76001 C 854.590027 191.97998 854.700012 192.200012 854.820007 192.419983 C 855.059998 192.869995 855.380005 193.279999 855.77002 193.51001 C 856.549988 193.97998 857.390015 194.179993 858.219971 194.26001 C 859.049988 194.330017 859.869995 194.390015 860.690002 194.26001 L 861.900024 194.089996 C 862.099976 194.070007 862.299988 194.049988 862.5 194.049988 C 862.700012 194.070007 862.900024 193.910004 863.070007 194.529999 C 863.440002 194.549988 863.75 194.25 863.76001 193.869995 C 863.780029 193.48999 863.48999 193.169983 863.119995 193.160004 C 862.900024 193.75 862.710022 193.570007 862.52002 193.559998 C 862.330017 193.539978 862.130005 193.48999 861.940002 193.450012 C 861.549988 193.359985 861.179993 193.200012 860.809998 193.059998 C 860.070007 192.76001 859.330017 192.570007 858.630005 192.309998 C 857.940002 192.029999 857.23999 191.830017 856.590027 191.619995 C 856.27002 191.51001 855.890015 191.539978 855.51001 191.48999 C 855.320007 191.470001 855.140015 191.419983 854.97998 191.330017 C 854.909973 191.279999 854.830017 191.22998 854.789978 191.160004 C 854.76001 191.109985 854.789978 190.929993 854.969971 190.950012 C 854.929993 190.649994 854.659973 190.440002 854.369995 190.47998 C 854.080017 190.52002 853.869995 190.799988 853.909973 191.100006 L 853.929993 191.100006 Z"
      />
      <path
        id="path5559"
        fill="#dbf5ff"
        stroke="none"
        d="M 866.23999 221.25 C 866.380005 223.059998 866.359985 224.410004 866.359985 224.410004 C 870.090027 218.950012 880.099976 216.179993 880.099976 216.179993 L 876.909973 210.529999 C 872.179993 214.080017 864.710022 214.080017 864.710022 214.080017 C 865.669983 215.97998 866.070007 218.970001 866.23999 221.25 Z"
      />
      <path
        id="path5560"
        fill="#dbf5ff"
        stroke="none"
        d="M 852.859985 220.559998 C 853.320007 220.01001 853.77002 219.51001 854.22998 219.049988 C 859.47998 213.76001 864.710022 214.080017 864.710022 214.080017 C 861.559998 211.559998 861.559998 207.130005 861.559998 207.130005 C 861.27002 208.539978 856.25 212.940002 856.25 212.940002 C 855.789978 214.309998 854.929993 216.210022 854.210022 217.77002 C 853.51001 219.26001 852.940002 220.429993 852.869995 220.559998 L 852.859985 220.559998 Z"
      />
      <path
        id="path5561"
        fill="#00253d"
        stroke="none"
        d="M 758.309998 267.670013 C 759.070007 275.049988 763.039978 274.809998 763.039978 274.809998 C 763.039978 274.809998 766.5 273.440002 766.210022 266.679993 C 765.880005 258.899994 761.099976 258.410004 761.099976 258.410004 C 759.590027 258.959991 757.539978 260.290009 758.299988 267.670013 L 758.309998 267.670013 Z"
      />
      <path
        id="path5562"
        fill="#c7b299"
        stroke="none"
        d="M 767.030029 260.839996 C 767.030029 260.839996 760.919983 263.23999 758.159973 261.98999 L 759.919983 273.140015 C 759.919983 273.140015 764.549988 271.480011 768.73999 271.369995 L 767.02002 260.839996 L 767.030029 260.839996 Z"
      />
      <path
        id="path5563"
        fill="#00375c"
        stroke="none"
        d="M 763.049988 274.809998 C 787.369995 270.380005 796.409973 281.019989 809.539978 291.209991 C 810.159973 291.690002 810.77002 292.140015 811.380005 292.559998 C 817.01001 293.440002 823.150024 295.200012 829.150024 298.730011 L 829.22998 298.730011 C 832.619995 298.850006 834.719971 298.299988 834.719971 298.299988 C 834.719971 298.299988 847.630005 300.519989 825.679993 277.019989 C 803.72998 253.529999 761.109985 258.399994 761.109985 258.399994 C 761.109985 258.399994 764.929993 258.940002 765.559998 265.76001 C 765.590027 266.089996 765.609985 266.420013 765.630005 266.779999 C 765.909973 273.540009 763.049988 274.799988 763.049988 274.799988 L 763.049988 274.809998 Z"
      />
      <path
        id="path5564"
        fill="#333333"
        stroke="none"
        d="M 868.390015 295 L 864.640015 298.73999 C 864.640015 298.73999 856.609985 278.5 829.200012 264.170013 C 829.200012 264.170013 854.559998 268.809998 868.559998 293.769989 C 868.780029 294.170013 868.710022 294.679993 868.390015 295.01001 L 868.390015 295 Z"
      />
      <path
        id="path5565"
        fill="#808080"
        stroke="none"
        d="M 845.27002 269.410004 L 843.690002 273.329987 L 835.51001 267.859985 L 836.440002 265.869995 C 836.440002 265.869995 842.179993 267.859985 845.26001 269.420013 L 845.27002 269.410004 Z"
      />
      <path
        id="path5566"
        fill="#00406b"
        stroke="none"
        d="M 754.659973 252.759995 L 755.309998 264.390015 C 758.929993 264.679993 762.349976 265.070007 765.570007 265.540009 C 779.409973 267.570007 789.070007 270.5 799.070007 275.5 C 812.719971 282.329987 819.799988 291.839996 829.219971 298.5 C 829.320007 298.579987 829.440002 298.649994 829.539978 298.730011 C 829.559998 298.730011 829.580017 298.76001 829.609985 298.769989 C 830.159973 299.100006 830.710022 299.440002 831.25 299.820007 C 834.75 299.959991 840.440002 301.920013 849.780029 306.160004 C 858.609985 306.049988 863.640015 300.779999 864.969971 299.149994 C 865.210022 298.859985 865.299988 298.470001 865.190002 298.100006 C 864.48999 295.519989 861.140015 284.859985 851.919983 277.690002 C 839.049988 268.5 821.049988 260.279999 807.030029 258.51001 C 773.23999 254.25 754.640015 252.759995 754.640015 252.759995 L 754.659973 252.759995 Z"
      />
      <path
        id="path5567"
        fill="#42210b"
        stroke="none"
        d="M 739.52002 230.899994 L 739.159973 230.950012 L 740.960022 246.179993 C 741.26001 248.75 742.109985 251.229996 743.380005 253.460007 C 743.820007 254.220001 744.280029 255.059998 744.75 256.029999 C 745.960022 258.540009 747.150024 261.910004 747.73999 267.209991 C 751.219971 266.75 752.909973 265.769989 754.809998 264.850006 C 755.929993 264.309998 756.119995 262.76001 755.169983 261.950012 C 752.099976 259.339996 749.869995 258.820007 754.299988 248.770004 C 754.719971 247.830002 754.77002 246.770004 753.919983 246.210007 C 751.080017 244.350006 744.150024 239.789993 742.549988 232.77002 C 742.27002 231.529999 740.76001 230.75 739.530029 230.910004 L 739.52002 230.899994 Z"
      />
      <path
        id="path5568"
        fill="#42210b"
        stroke="none"
        d="M 744.049988 256.649994 C 742.549988 257.299988 741.090027 257.559998 741.090027 257.559998 L 742.219971 267.119995 C 743.679993 267.369995 745.539978 267.369995 746.98999 267.269989 C 746.619995 264.619995 745.820007 260.720001 744.049988 256.649994 Z"
      />
      <path
        id="path5569"
        fill="#603813"
        stroke="none"
        d="M 739.460022 230.330017 L 737.900024 230.529999 L 739.799988 246.570007 C 740.099976 249.070007 740.950012 251.460007 742.179993 253.639999 C 742.75 254.660004 743.25 255.679993 743.690002 256.690002 C 745.460022 260.75 746.27002 264.660004 746.630005 267.309998 C 747.130005 267.269989 747.619995 267.220001 748.109985 267.160004 C 747.52002 261.859985 746.330017 258.48999 745.119995 255.979996 C 744.659973 255.009995 744.190002 254.169998 743.75 253.410004 C 742.47998 251.169998 741.630005 248.699997 741.330017 246.130005 L 739.460022 230.330017 Z"
      />
      <path
        id="path5570"
        fill="#42210b"
        stroke="none"
        d="M 749.380005 243.110001 C 749.380005 243.110001 754.5 243.869995 756.659973 253.410004 C 757.549988 256.040009 758.799988 258.079987 759.460022 259.049988 C 759.73999 259.459991 759.890015 259.950012 759.890015 260.450012 C 759.890015 262.160004 760.070007 266.549988 761.369995 272.440002 C 761.590027 273.410004 761.210022 274.429993 760.429993 275.029999 C 759.119995 276.029999 757.119995 277.420013 755.890015 277.619995 C 753.929993 277.929993 749.390015 243.110001 749.390015 243.110001 L 749.380005 243.110001 Z"
      />
      <path
        id="path5571"
        fill="#603813"
        stroke="none"
        d="M 754.460022 277.089996 L 755.23999 268.049988 L 757.25 267.670013 C 756.450012 263.380005 755.390015 258.25 755.169983 253.160004 C 754.659973 241.009995 749.599976 242.059998 749.599976 242.059998 C 749.51001 242.059998 749.419983 242.059998 749.330017 242.080002 C 742.650024 244.339996 748.869995 271 754.450012 277.089996 L 754.460022 277.089996 Z"
      />
      <path
        id="path5572"
        fill="#4d260d"
        stroke="none"
        d="M 749.190002 268.290009 C 750.75 272.799988 752.630005 276.480011 754.390015 277.869995 L 754.460022 277.089996 L 755.23999 268.049988 L 757.25 267.670013 C 757.200012 267.369995 757.140015 267.079987 757.080017 266.779999 L 749.190002 268.279999 L 749.190002 268.290009 Z"
      />
      <path
        id="path5573"
        fill="#5c2d10"
        stroke="none"
        d="M 749.190002 268.290009 L 757.080017 266.790009 C 756.309998 262.690002 755.369995 257.910004 755.169983 253.169998 C 754.659973 241.020004 749.599976 242.070007 749.599976 242.070007 C 749.51001 242.070007 749.419983 242.070007 749.330017 242.089996 C 743.599976 242.479996 745.5 257.679993 749.179993 268.299988 L 749.190002 268.290009 Z"
      />
      <path
        id="path5574"
        fill="#603813"
        stroke="none"
        d="M 755.169983 253.169998 C 755.380005 258.26001 756.450012 263.380005 757.25 267.679993 C 758.289978 273.269989 758.890015 277.459991 756.559998 278.329987 C 756.630005 278.329987 756.700012 278.329987 756.77002 278.320007 C 756.789978 278.320007 756.809998 278.320007 756.820007 278.320007 C 761.780029 277.51001 756.440002 265.190002 755.919983 253.029999 C 755.409973 240.880005 750.349976 241.929993 750.349976 241.929993 C 749.97998 241.929993 749.650024 241.970001 749.340027 242.089996 C 749.419983 242.070007 749.52002 242.070007 749.609985 242.070007 C 749.609985 242.070007 754.669983 241.020004 755.179993 253.169998 L 755.169983 253.169998 Z"
      />
      <path
        id="path5575"
        fill="#42210b"
        stroke="none"
        d="M 754.299988 278.959991 L 756.289978 278.420013 C 756.460022 278.410004 756.619995 278.369995 756.77002 278.309998 C 756.700012 278.320007 756.630005 278.329987 756.559998 278.320007 C 758.890015 277.440002 758.289978 273.26001 757.25 267.670013 L 755.23999 268.049988 L 754.460022 277.089996 L 754.390015 277.869995 L 754.299988 278.959991 Z"
      />
      <path
        id="path5576"
        fill="#5c2d10"
        stroke="none"
        d="M 753.969971 279.01001 C 753.849976 279.01001 753.719971 279.019989 753.599976 279.029999 C 752.440002 279.079987 751.340027 278.519989 750.690002 277.540009 C 749.73999 276.130005 748.700012 274.179993 748.409973 269.369995 L 755.25 268.049988 C 755.25 268.049988 756.799988 274.390015 755.640015 277.720001 C 755.390015 278.450012 754.72998 278.959991 753.97998 279 L 753.969971 279.01001 Z"
      />
      <linearGradient
        id="linearGradient122"
        x1="880.371"
        y1="208.69"
        x2="880.374"
        y2="208.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#da8e79" stopOpacity={1} />
        <stop offset="0.46" stopColor="#e29b84" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b298" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5577"
        fill="url(#linearGradient122)"
        stroke="none"
        d="M 880.349976 208.720001 L 880.369995 208.669983 L 880.349976 208.720001 Z"
      />
      <path
        id="path5578"
        fill="#f0b299"
        stroke="none"
        d="M 848.859985 181.73999 C 846.559998 181.859985 846.849976 183.470001 847.469971 186.309998 C 847.469971 193.630005 849.099976 195.309998 849.929993 194.970001 C 851.460022 194.359985 851.640015 181.589996 848.859985 181.73999 Z"
      />
      <linearGradient
        id="linearGradient123"
        x1="805.591"
        y1="167.899"
        x2="806.885"
        y2="178.443"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#db8f79" stopOpacity={1} />
        <stop offset="0.47" stopColor="#e39c85" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5579"
        fill="url(#linearGradient123)"
        stroke="none"
        d="M 849.299988 192.220001 C 849.299988 192.220001 848.429993 190.72998 849.190002 188.26001 C 850.969971 182.429993 847.440002 181.350006 847.580017 185.589996 C 847.580017 185.589996 848.400024 183.76001 848.76001 184.419983 C 849.200012 185.22998 847.97998 185.410004 848.059998 188.600006 C 848.099976 190.26001 849.299988 192.22998 849.299988 192.22998 L 849.299988 192.220001 Z"
      />
      <path
        id="path5580"
        fill="#f0b299"
        stroke="none"
        d="M 891.070007 187.320007 C 893.289978 187.929993 892.679993 189.450012 891.47998 192.089996 C 889.969971 199.23999 888.02002 200.529999 887.280029 200.02002 C 885.919983 199.089996 888.380005 186.580017 891.070007 187.320007 Z"
      />
      <linearGradient
        id="linearGradient124"
        x1="943.474"
        y1="179.725"
        x2="939.89"
        y2="189.716"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#db8f79" stopOpacity={1} />
        <stop offset="0.47" stopColor="#e39c85" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5581"
        fill="url(#linearGradient124)"
        stroke="none"
        d="M 888.460022 197.470001 C 888.460022 197.470001 889.619995 196.210022 889.390015 193.630005 C 888.859985 187.549988 892.530029 187.26001 891.51001 191.359985 C 891.51001 191.359985 891.090027 189.390015 890.599976 189.960022 C 890 190.649994 891.159973 191.089996 890.419983 194.200012 C 890.030029 195.809998 888.450012 197.470001 888.450012 197.470001 L 888.460022 197.470001 Z"
      />
      <path
        id="path5582"
        fill="#f7c3a9"
        stroke="none"
        d="M 889.349976 186.73999 C 892.280029 169.910004 887.460022 166.950012 886.22998 165.029999 C 883.72998 161.119995 879.26001 158.970001 871.25 158.089996 C 871.25 158.089996 860.799988 157.070007 857.429993 162.48999 C 853.830017 168.279999 852.200012 176.700012 851.380005 184.679993 C 850.390015 194.369995 850.039978 196.929993 850.599976 199.059998 C 850.859985 200.049988 851.169983 201.399994 852.820007 203.130005 C 855.460022 205.890015 858.76001 210.869995 860.890015 213.140015 C 861.75 214.049988 867.98999 216.600006 873.539978 213.789978 C 876.450012 212.320007 879.530029 210.369995 883.219971 207.51001 C 884.849976 206.25 886.099976 204.01001 886.25 202.830017 C 886.429993 201.47998 887.960022 194.820007 888.049988 193.799988 C 888.51001 188.320007 888.52002 191.419983 889.330017 186.73999 L 889.349976 186.73999 Z"
      />
      <linearGradient
        id="linearGradient125"
        x1="879.407"
        y1="191.369"
        x2="879.733"
        y2="184.623"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5583"
        fill="url(#linearGradient125)"
        stroke="none"
        d="M 875.450012 180.76001 C 874.97998 182.369995 872.25 188.23999 873.130005 188.940002 C 878.619995 193.289978 886.059998 189.589996 886.059998 189.589996 C 887.049988 178.720001 875.450012 180.76001 875.450012 180.76001 Z"
      />
      <linearGradient
        id="linearGradient126"
        x1="860.101"
        y1="188.77"
        x2="860.406"
        y2="182.334"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5584"
        fill="url(#linearGradient126)"
        stroke="none"
        d="M 853.830017 185.539978 C 853.830017 185.539978 859.590027 190.669983 866.210022 187.52002 C 867.219971 187.039978 866.099976 181.410004 866.070007 179.72998 C 866.070007 179.72998 855.130005 174.809998 853.830017 185.539978 Z"
      />
      <radialGradient
        id="radialGradient27"
        cx="880.948"
        cy="194.864"
        r="8.16502"
        fx="880.948"
        fy="194.864"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8b09c" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5585"
        fill="url(#radialGradient27)"
        stroke="none"
        d="M 879.099976 201.640015 C 882.359985 202.299988 886.109985 202.320007 887.719971 195.51001 C 888.640015 191.630005 888.469971 189.570007 886.890015 189.039978 C 883.530029 187.919983 878.380005 188.789978 876.169983 189.609985 C 871.51001 191.330017 873.330017 200.460022 879.099976 201.640015 Z"
      />
      <radialGradient
        id="radialGradient28"
        cx="856.622"
        cy="191.856"
        r="8.324997"
        fx="856.622"
        fy="191.856"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8b09c" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5586"
        fill="url(#radialGradient28)"
        stroke="none"
        d="M 862.48999 187.450012 C 859.210022 185.710022 855.950012 184.169983 852.450012 184.710022 C 851.190002 184.910004 850.789978 187.720001 850.640015 190.380005 C 850.570007 191.660004 850.210022 193.619995 850.380005 194.450012 C 851.23999 198.529999 857.070007 199.47998 860.25 198.799988 C 865.669983 197.640015 867.02002 189.850006 862.48999 187.450012 Z"
      />
      <linearGradient
        id="linearGradient127"
        x1="886.337"
        y1="191.529"
        x2="880.374"
        y2="192.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fbc6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5587"
        fill="url(#linearGradient127)"
        stroke="none"
        d="M 886.23999 190.880005 C 885.690002 190.460022 885.190002 190.890015 883.900024 191.140015 C 882.640015 191.380005 879.25 191.570007 880.690002 192.630005 C 882.280029 193.799988 884.849976 192.830017 885.169983 192.630005 C 885.48999 192.429993 886.919983 191.399994 886.23999 190.880005 Z"
      />
      <linearGradient
        id="linearGradient128"
        x1="876.067"
        y1="204.362"
        x2="876.161"
        y2="203.577"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5588"
        fill="url(#linearGradient128)"
        stroke="none"
        d="M 876.330017 203.649994 C 876.190002 203.73999 876.059998 203.830017 875.929993 203.910004 C 875.929993 203.910004 876.099976 203.820007 876.330017 203.649994 Z"
      />
      <linearGradient
        id="linearGradient129"
        x1="876.262"
        y1="213.094"
        x2="878.112"
        y2="197.209"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5589"
        fill="url(#linearGradient129)"
        stroke="none"
        d="M 875.669983 197.23999 C 879.099976 200.910004 877.23999 202.960022 876.330017 203.649994 C 877.97998 202.589996 880.159973 201.460022 880.099976 200.890015 C 879.890015 198.820007 875.659973 197.25 875.659973 197.25 L 875.669983 197.23999 Z"
      />
      <path
        id="path5590"
        fill="#e19f8c"
        stroke="none"
        d="M 876.25 201.22998 C 876.25 201.22998 878.289978 201.029999 878.47998 200.910004 C 878.669983 200.789978 878.900024 200.299988 878.900024 200.299988 L 877.590027 200.52002 L 876.25 201.22998 Z"
      />
      <linearGradient
        id="linearGradient130"
        x1="857.998"
        y1="211.38"
        x2="859.897"
        y2="195.129"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5591"
        fill="url(#linearGradient130)"
        stroke="none"
        d="M 857.429993 198.160004 C 857.429993 198.789978 858.950012 200.529999 859.919983 201.869995 C 859.919983 201.869995 857.349976 198.190002 861.929993 195.789978 C 861.929993 195.789978 857.409973 196.049988 857.429993 198.160004 Z"
      />
      <path
        id="path5592"
        fill="#e19f8c"
        stroke="none"
        d="M 858.539978 197.710022 C 858.539978 197.710022 858.630005 198.23999 858.789978 198.410004 C 858.950012 198.580017 860.859985 199.299988 860.859985 199.299988 L 859.75 198.26001 L 858.549988 197.710022 L 858.539978 197.710022 Z"
      />
      <linearGradient
        id="linearGradient131"
        x1="867.136"
        y1="215.931"
        x2="868.229"
        y2="204.878"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5593"
        fill="url(#linearGradient131)"
        stroke="none"
        d="M 863.549988 207.23999 C 868.859985 207.350006 872.299988 208.47998 872.299988 208.47998 C 868.669983 205.450012 863.549988 207.23999 863.549988 207.23999 Z"
      />
      <path
        id="path5594"
        fill="#962865"
        stroke="none"
        d="M 858.969971 198.02002 C 859.059998 198.149994 859.119995 198.309998 859.25 198.390015 C 861.609985 199.850006 861.5 200.929993 862.5 201.660004 C 866.039978 204.25 870.559998 204.339996 873.780029 203.070007 C 875.630005 202.339996 876 201.23999 878.169983 200.710022 C 878.460022 200.640015 878.539978 200.429993 878.539978 200.429993 C 867.159973 201.690002 858.969971 198.029999 858.969971 198.029999 L 858.969971 198.02002 Z"
      />
      <path
        id="path5595"
        fill="#fdc9b3"
        stroke="none"
        d="M 868.130005 204.649994 C 866.640015 204.450012 865.219971 203.960022 865.179993 204.26001 C 865.140015 204.559998 866.340027 205.380005 867.830017 205.580017 C 869.320007 205.779999 870.869995 205.320007 870.909973 205.029999 C 870.950012 204.73999 869.619995 204.859985 868.130005 204.660004 L 868.130005 204.649994 Z"
      />
      <linearGradient
        id="linearGradient132"
        x1="861.744"
        y1="201.691"
        x2="875.351"
        y2="203.751"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d7db" stopOpacity={1} />
        <stop offset="0.14" stopColor="#efe4e6" stopOpacity={1} />
        <stop offset="0.39" stopColor="#faf7f8" stopOpacity={1} />
        <stop offset="0.57" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d1d8" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5596"
        fill="url(#linearGradient132)"
        stroke="none"
        d="M 872.820007 202.22998 C 871.780029 202.299988 869.830017 202.429993 868.080017 202.200012 C 866.159973 201.940002 864.25 201.330017 863.219971 200.98999 C 862.77002 200.839996 862.460022 201.640015 862.460022 201.640015 C 863.719971 202.859985 865.349976 203.47998 868.039978 203.859985 C 871.630005 204.369995 873.830017 203.059998 873.830017 203.059998 C 873.830017 203.059998 873.429993 202.200012 872.820007 202.23999 L 872.820007 202.22998 Z"
      />
      <linearGradient
        id="linearGradient133"
        x1="867.175"
        y1="215.714"
        x2="868.227"
        y2="204.969"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5597"
        fill="url(#linearGradient133)"
        stroke="none"
        d="M 862.590027 204.299988 C 867.710022 209.690002 873.859985 205.47998 873.859985 205.47998 C 867.640015 207.830017 862.590027 204.299988 862.590027 204.299988 Z"
      />
      <linearGradient
        id="linearGradient134"
        x1="868.766"
        y1="197.313"
        x2="868.304"
        y2="202.507"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d7db" stopOpacity={1} />
        <stop offset="0.4" stopColor="#efe3e6" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5598"
        fill="url(#linearGradient134)"
        stroke="none"
        d="M 861.390015 198.880005 C 861.390015 198.880005 861.299988 199.839996 862.200012 200.390015 C 862.719971 200.710022 863.840027 201.830017 868.710022 202.330017 C 873.580017 202.830017 874.690002 201.77002 874.940002 201.589996 C 875.400024 201.26001 875.679993 200.630005 875.679993 200.630005 C 875.679993 200.630005 868.179993 201.100006 861.390015 198.869995 L 861.390015 198.880005 Z"
      />
      <path
        id="path5599"
        fill="#f3ebed"
        stroke="none"
        d="M 861.390015 198.789978 C 861.390015 198.789978 861.359985 199.22998 861.48999 199.51001 C 861.590027 199.73999 865.390015 200.830017 868.309998 201.23999 C 871.22998 201.649994 875.150024 201.399994 875.309998 201.23999 C 875.559998 201 875.72998 200.549988 875.72998 200.549988 C 875.72998 200.549988 872.289978 201.22998 861.390015 198.789978 Z"
      />
      <linearGradient
        id="linearGradient135"
        x1="866.606"
        y1="217.706"
        x2="869.208"
        y2="195.515"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5600"
        fill="url(#linearGradient135)"
        stroke="none"
        d="M 858.409973 197.640015 C 858.409973 197.640015 859.059998 198.149994 858.969971 198.02002 C 858.969971 198.02002 867.159973 201.679993 878.539978 200.419983 L 879.179993 200.200012 C 873.059998 200.410004 858.409973 197.640015 858.409973 197.640015 Z"
      />
      <linearGradient
        id="linearGradient136"
        x1="858.355"
        y1="189.677"
        x2="850.177"
        y2="186.476"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fbc6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5601"
        fill="url(#linearGradient136)"
        stroke="none"
        d="M 854.880005 187.410004 C 853.679993 186.899994 853.27002 186.369995 852.650024 186.660004 C 851.880005 187.02002 853.049988 188.330017 853.320007 188.589996 C 853.590027 188.859985 855.890015 190.350006 857.700012 189.539978 C 859.330017 188.809998 856.070007 187.899994 854.880005 187.399994 L 854.880005 187.410004 Z"
      />
      <linearGradient
        id="linearGradient137"
        x1="874.729"
        y1="186.356"
        x2="883.442"
        y2="190.012"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0b299" stopOpacity={1} />
        <stop offset="0.53" stopColor="#e39c85" stopOpacity={1} />
        <stop offset={1} stopColor="#db8f79" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5602"
        fill="url(#linearGradient137)"
        stroke="none"
        d="M 879.309998 185.619995 C 877.549988 185.47998 875.140015 185.589996 874.059998 188.399994 C 873.609985 189.570007 877.200012 190.600006 879.380005 190.720001 C 882.289978 190.880005 884.080017 188.72998 883.969971 188.410004 C 883.169983 186.140015 880.320007 185.700012 879.309998 185.619995 Z"
      />
      <linearGradient
        id="linearGradient138"
        x1="882.968"
        y1="189.484"
        x2="876.235"
        y2="186.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ece7ea" stopOpacity={1} />
        <stop offset="0.23" stopColor="#f5f3f4" stopOpacity={1} />
        <stop offset="0.53" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5603"
        fill="url(#linearGradient138)"
        stroke="none"
        d="M 877.210022 185.869995 C 876.059998 185.859985 875.659973 186.25 875.380005 186.529999 C 874.73999 187.179993 874.369995 188.25 874.369995 188.25 C 874.320007 188.47998 874.849976 189.080017 875.380005 189.26001 C 876.609985 189.690002 877.5 190.23999 880.549988 190.059998 C 881.5 190.01001 882.859985 189.130005 883.179993 188.76001 C 883.47998 188.410004 883.559998 188.070007 883.559998 188.070007 C 882.22998 186.309998 881.919983 185.919983 877.210022 185.859985 L 877.210022 185.869995 Z"
      />
      <path
        id="path5604"
        fill="#dddddd"
        stroke="none"
        d="M 881.039978 186.169983 C 879.659973 186.140015 876.630005 185.359985 874.73999 187.450012 C 875.969971 187.070007 878.859985 187.049988 883.210022 188.75 C 883.409973 188.51001 883.530029 188.22998 883.570007 188.089996 C 883.570007 188.089996 882.799988 186.220001 881.049988 186.179993 L 881.039978 186.169983 Z"
      />
      <linearGradient
        id="linearGradient139"
        x1="881.267"
        y1="188.168"
        x2="873.893"
        y2="187.485"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#935955" stopOpacity={1} />
        <stop offset={1} stopColor="#5a3532" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5605"
        fill="url(#linearGradient139)"
        stroke="none"
        d="M 878.940002 185.869995 C 877.159973 185.539978 875.940002 186.589996 875.830017 188.149994 C 875.780029 188.73999 876.02002 189.440002 876.080017 189.51001 C 876.320007 189.630005 877.280029 189.950012 878.349976 190.049988 C 879.140015 190.169983 880.280029 190.100006 880.559998 190.049988 C 880.849976 190.01001 881.109985 189.289978 881.150024 188.970001 C 881.450012 186.830017 880.440002 186.140015 878.940002 185.859985 L 878.940002 185.869995 Z"
      />
      <linearGradient
        id="linearGradient140"
        x1="878.621"
        y1="187.511"
        x2="879.302"
        y2="193.363"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#5a3532" stopOpacity={1} />
        <stop offset={1} stopColor="#935955" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5606"
        fill="url(#linearGradient140)"
        stroke="none"
        d="M 879.080017 185.690002 C 876.780029 185.279999 876.039978 187.23999 876.039978 187.23999 C 879.02002 187.190002 881.190002 188.039978 881.190002 188.039978 C 881.190002 187.399994 880.830017 186 879.080017 185.690002 Z"
      />
      <radialGradient
        id="radialGradient29"
        cx="882.903"
        cy="189.458"
        r="4.730337"
        fx="882.903"
        fy="189.458"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3b33" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2721" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5607"
        fill="url(#radialGradient29)"
        stroke="none"
        d="M 878.830017 186.299988 C 877.940002 186.160004 877.099976 186.77002 876.969971 187.649994 C 876.840027 188.539978 877.460022 189.359985 878.349976 189.5 C 879.25 189.630005 880.080017 189.029999 880.210022 188.140015 C 880.340027 187.25 879.719971 186.429993 878.820007 186.289978 L 878.830017 186.299988 Z"
      />
      <linearGradient
        id="linearGradient141"
        x1="874.772"
        y1="186.261"
        x2="883.321"
        y2="186.989"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.45" stopColor="#2c1d1a" stopOpacity={1} />
        <stop offset="0.92" stopColor="#382323" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2525" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5608"
        fill="url(#linearGradient141)"
        stroke="none"
        d="M 881.820007 186.179993 C 880.580017 185.450012 877.419983 185.299988 876.659973 185.570007 C 875.369995 186.01001 874.73999 187.450012 874.73999 187.450012 C 874.73999 187.450012 876.150024 186.109985 879.630005 186.690002 C 882.380005 187.149994 883.570007 188.080017 883.570007 188.080017 C 883.570007 188.080017 883.320007 187.070007 881.830017 186.190002 L 881.820007 186.179993 Z"
      />
      <path
        id="path5609"
        fill="#ffffff"
        stroke="none"
        d="M 879.940002 188.140015 C 879.549988 188.140015 879.22998 188.460022 879.219971 188.859985 C 879.219971 189.26001 879.52002 189.589996 879.909973 189.589996 C 880.299988 189.589996 880.630005 189.27002 880.630005 188.869995 C 880.640015 188.470001 880.330017 188.140015 879.940002 188.140015 Z"
      />
      <path
        id="path5610"
        fill="#ffffff"
        stroke="none"
        d="M 878.51001 187.27002 C 878.200012 187.27002 877.950012 187.52002 877.940002 187.839996 C 877.940002 188.160004 878.179993 188.419983 878.48999 188.419983 C 878.799988 188.419983 879.049988 188.169983 879.059998 187.850006 C 879.059998 187.529999 878.820007 187.27002 878.51001 187.27002 Z"
      />
      <linearGradient
        id="linearGradient142"
        x1="855.954"
        y1="183.787"
        x2="865.345"
        y2="187.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#db8f79" stopOpacity={1} />
        <stop offset="0.47" stopColor="#e39c85" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5611"
        fill="url(#linearGradient142)"
        stroke="none"
        d="M 860.969971 183.25 C 859.97998 183.059998 857.109985 182.72998 855.73999 184.720001 C 855.549988 185 856.710022 187.539978 859.559998 188.149994 C 861.700012 188.609985 865.429993 188.559998 865.299988 187.309998 C 864.98999 184.320007 862.700012 183.580017 860.960022 183.25 L 860.969971 183.25 Z"
      />
      <linearGradient
        id="linearGradient143"
        x1="864.952"
        y1="187.198"
        x2="857.709"
        y2="184.395"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ece7ea" stopOpacity={1} />
        <stop offset="0.23" stopColor="#f5f3f4" stopOpacity={1} />
        <stop offset="0.53" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5612"
        fill="url(#linearGradient143)"
        stroke="none"
        d="M 862.929993 184.039978 C 858.369995 182.859985 857.969971 183.149994 856.219971 184.5 C 856.219971 184.5 856.210022 184.850006 856.409973 185.27002 C 856.619995 185.700012 857.700012 186.910004 858.599976 187.210022 C 861.5 188.179993 862.5 187.880005 863.799988 187.789978 C 864.359985 187.75 865.02002 187.309998 865.039978 187.080017 C 865.039978 187.080017 864.960022 185.950012 864.51001 185.160004 C 864.320007 184.820007 864.030029 184.330017 862.919983 184.039978 L 862.929993 184.039978 Z"
      />
      <path
        id="path5613"
        fill="#dddddd"
        stroke="none"
        d="M 859.159973 183.320007 C 857.460022 182.899994 856.22998 184.5 856.22998 184.5 C 856.210022 184.679993 856.27002 185 856.400024 185.23999 C 861.039978 184.75 863.820007 185.52002 864.909973 186.210022 C 863.630005 183.700012 860.5 183.649994 859.159973 183.320007 Z"
      />
      <linearGradient
        id="linearGradient144"
        x1="863.779"
        y1="185.932"
        x2="856.386"
        y2="185.237"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#935955" stopOpacity={1} />
        <stop offset={1} stopColor="#5a3532" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5614"
        fill="url(#linearGradient144)"
        stroke="none"
        d="M 861.26001 183.589996 C 859.73999 183.460022 858.580017 183.869995 858.320007 186.01001 C 858.280029 186.330017 858.469971 187.119995 858.609985 187.210022 C 858.849976 187.369995 859.950012 187.690002 860.73999 187.779999 C 861.799988 187.970001 862.809998 187.899994 863.070007 187.850006 C 863.140015 187.789978 863.549988 187.190002 863.659973 186.600006 C 863.960022 185.059998 863.059998 183.72998 861.25 183.580017 L 861.26001 183.589996 Z"
      />
      <linearGradient
        id="linearGradient145"
        x1="861.095"
        y1="185.18"
        x2="861.752"
        y2="190.837"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#5a3532" stopOpacity={1} />
        <stop offset={1} stopColor="#935955" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5615"
        fill="url(#linearGradient145)"
        stroke="none"
        d="M 861.169983 183.380005 C 859.390015 183.220001 858.690002 184.47998 858.51001 185.089996 C 858.51001 185.089996 860.830017 184.839996 863.690002 185.669983 C 863.690002 185.669983 863.5 183.580017 861.169983 183.380005 Z"
      />
      <radialGradient
        id="radialGradient30"
        cx="865.307"
        cy="187.194"
        r="4.730431"
        fx="865.307"
        fy="187.194"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3b33" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2721" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5616"
        fill="url(#radialGradient30)"
        stroke="none"
        d="M 861.25 184.039978 C 860.349976 183.929993 859.530029 184.570007 859.429993 185.460022 C 859.320007 186.350006 859.969971 187.149994 860.869995 187.26001 C 861.77002 187.359985 862.590027 186.72998 862.690002 185.839996 C 862.789978 184.950012 862.150024 184.149994 861.25 184.039978 Z"
      />
      <linearGradient
        id="linearGradient146"
        x1="856.2"
        y1="184.062"
        x2="864.699"
        y2="184.784"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.45" stopColor="#2c1d1a" stopOpacity={1} />
        <stop offset="0.92" stopColor="#382323" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2525" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5617"
        fill="url(#linearGradient146)"
        stroke="none"
        d="M 863.549988 183.899994 C 862.880005 183.450012 859.789978 182.75 858.409973 183.140015 C 856.73999 183.600006 856.22998 184.51001 856.22998 184.51001 C 856.22998 184.51001 857.619995 183.919983 860.400024 184.200012 C 863.900024 184.549988 864.909973 186.220001 864.909973 186.220001 C 864.909973 186.220001 864.679993 184.669983 863.549988 183.899994 Z"
      />
      <path
        id="path5618"
        fill="#ffffff"
        stroke="none"
        d="M 862.280029 185.859985 C 861.890015 185.859985 861.570007 186.179993 861.559998 186.580017 C 861.559998 186.97998 861.859985 187.309998 862.25 187.309998 C 862.640015 187.309998 862.969971 186.98999 862.969971 186.589996 C 862.97998 186.190002 862.669983 185.859985 862.280029 185.859985 Z"
      />
      <path
        id="path5619"
        fill="#ffffff"
        stroke="none"
        d="M 860.840027 185 C 860.530029 185 860.280029 185.25 860.27002 185.570007 C 860.27002 185.890015 860.51001 186.149994 860.820007 186.149994 C 861.130005 186.149994 861.380005 185.899994 861.390015 185.580017 C 861.390015 185.26001 861.150024 185 860.840027 185 Z"
      />
      <linearGradient
        id="linearGradient147"
        x1="875.24"
        y1="180.946"
        x2="885.797"
        y2="182.356"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.45" stopColor="#2c1d1a" stopOpacity={1} />
        <stop offset="0.92" stopColor="#382323" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2525" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5620"
        fill="url(#linearGradient147)"
        stroke="none"
        d="M 875.409973 180.23999 C 875.159973 181.200012 874.969971 182.119995 875.570007 182.200012 C 877.75 182.47998 885.679993 183.26001 885.679993 183.26001 C 885.679993 183.26001 883.780029 181.570007 882.950012 181.119995 C 881.880005 180.539978 878.200012 180.140015 875.419983 180.23999 L 875.409973 180.23999 Z"
      />
      <linearGradient
        id="linearGradient148"
        x1="855.723"
        y1="178.419"
        x2="866.279"
        y2="179.829"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.45" stopColor="#2c1d1a" stopOpacity={1} />
        <stop offset="0.92" stopColor="#382323" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2525" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5621"
        fill="url(#linearGradient148)"
        stroke="none"
        d="M 858.789978 177.970001 C 857.869995 178.190002 855.590027 179.320007 855.590027 179.320007 C 855.590027 179.320007 863.440002 180.649994 865.619995 180.950012 C 866.219971 181.029999 866.27002 180.089996 866.289978 179.100006 C 863.630005 178.279999 859.97998 177.690002 858.789978 177.970001 Z"
      />
      <linearGradient
        id="linearGradient149"
        x1="857.559"
        y1="212.099"
        x2="849.634"
        y2="190.317"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f6c2aa" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b298" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5622"
        fill="url(#linearGradient149)"
        stroke="none"
        d="M 850.890015 186.779999 C 850.530029 190.52002 849.950012 196.48999 850.210022 198.320007 C 850.280029 198.799988 850.52002 200.869995 852.039978 202.73999 C 854.559998 205.859985 858.02002 209.570007 858.02002 209.570007 C 857.570007 208.660004 853.52002 202.429993 852.840027 201.02002 C 850.23999 195.649994 850.900024 186.779999 850.900024 186.779999 L 850.890015 186.779999 Z"
      />
      <linearGradient
        id="linearGradient150"
        x1="876.206"
        y1="215.326"
        x2="888.236"
        y2="197.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f6c2aa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffc8b2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5623"
        fill="url(#linearGradient150)"
        stroke="none"
        d="M 875.799988 212.570007 C 877.150024 211.77002 880.460022 209.679993 883.320007 207.580017 C 884.679993 206.580017 885.719971 204.630005 886.23999 203.330017 C 886.76001 202.02002 888.070007 193.799988 888.070007 193.799988 C 887.25 197.140015 885.830017 202.309998 883.619995 205.299988 C 881.419983 208.289978 876.619995 211.72998 875.789978 212.570007 L 875.799988 212.570007 Z"
      />
      <linearGradient
        id="linearGradient151"
        x1="871.093"
        y1="177.476"
        x2="869.226"
        y2="194.549"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffc9b3" stopOpacity={1} />
        <stop offset="0.3" stopColor="#fbc6ae" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5624"
        fill="url(#linearGradient151)"
        stroke="none"
        d="M 871.440002 189.049988 C 872.130005 185.339996 870.890015 184.619995 869.919983 184.529999 C 868.969971 184.440002 868.280029 185.660004 868.090027 188.539978 C 867.900024 191.410004 867.200012 192.419983 867.150024 193.77002 C 867.130005 194.380005 867.359985 194.820007 868.890015 195.029999 C 870.580017 195.27002 871.210022 194.950012 871.359985 194.390015 C 871.76001 192.869995 870.950012 191.720001 871.440002 189.049988 Z"
      />
      <linearGradient
        id="linearGradient152"
        x1="868.811"
        y1="199.842"
        x2="869.097"
        y2="195.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5625"
        fill="url(#linearGradient152)"
        stroke="none"
        d="M 864.289978 194.880005 C 864.289978 194.880005 868.109985 198.52002 869.059998 198.470001 C 870.01001 198.410004 873.77002 196.149994 873.77002 196.149994 C 873.77002 196.149994 869.859985 196.109985 868.97998 195.98999 C 868.099976 195.869995 864.289978 194.880005 864.289978 194.880005 Z"
      />
      <path
        id="path5626"
        fill="#e19f8c"
        stroke="none"
        d="M 870.659973 196.339996 C 873.02002 196.080017 873.869995 196.529999 873.869995 196.529999 C 872.700012 195.190002 870.659973 196.339996 870.659973 196.339996 Z"
      />
      <path
        id="path5627"
        fill="#e19f8c"
        stroke="none"
        d="M 864.25 195.080017 C 864.25 195.080017 865.460022 195.049988 867.169983 195.890015 C 867.169983 195.890015 865.599976 194.330017 864.25 195.080017 Z"
      />
      <linearGradient
        id="linearGradient153"
        x1="869.858"
        y1="187.285"
        x2="868.864"
        y2="196.928"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f5c0a6" stopOpacity={1} />
        <stop offset="0.89" stopColor="#f2b79e" stopOpacity={1} />
        <stop offset={1} stopColor="#f1b39a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5628"
        fill="url(#linearGradient153)"
        stroke="none"
        d="M 872.929993 192.789978 C 872.789978 193.720001 872.929993 194.380005 872.570007 194.869995 C 871.780029 195.970001 870.070007 196.220001 868.98999 195.98999 C 868.140015 195.97998 866.25 195.299988 865.609985 193.950012 C 865.349976 193.399994 865.609985 192.970001 865.599976 191.960022 C 865.599976 191.960022 862.97998 194.380005 864.26001 195.089996 C 864.26001 195.089996 864.700012 194.850006 865.77002 195.089996 C 866.849976 195.339996 866.460022 196.5 868.960022 196.859985 C 871.140015 197.169983 870.580017 196.029999 872 196.02002 C 873.409973 196.01001 873.549988 196.390015 873.840027 196.570007 C 874.530029 196.660004 874.340027 194.289978 872.929993 192.789978 Z"
      />
      <linearGradient
        id="linearGradient154"
        x1="868.676"
        y1="195.343"
        x2="869.818"
        y2="191.178"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffc9b3" stopOpacity={1} />
        <stop offset="0.36" stopColor="#fac5ad" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5629"
        fill="url(#linearGradient154)"
        stroke="none"
        d="M 866.919983 193.609985 C 866.73999 194.210022 867.51001 194.97998 869.049988 195.190002 C 870.72998 195.429993 871.200012 194.809998 871.140015 194.22998 C 870.75 190.799988 867.590027 191.380005 866.929993 193.600006 L 866.919983 193.609985 Z"
      />
      <linearGradient
        id="linearGradient155"
        x1="873.204"
        y1="146.351"
        x2="870.422"
        y2="186.355"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.43" stopColor="#f3b9a0" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5630"
        fill="url(#linearGradient155)"
        stroke="none"
        d="M 886.780029 167.929993 C 880.169983 161.77002 859.950012 164.26001 857.940002 164.039978 C 855.940002 163.820007 850.960022 188.820007 850.960022 188.820007 C 850.960022 188.820007 853.169983 184 854.289978 181.029999 C 855.419983 178.059998 856.679993 170.820007 859.599976 168.609985 C 868.030029 162.210022 880.840027 167.130005 883.630005 170.52002 C 886.619995 174.160004 886.169983 182.23999 886.609985 184.210022 C 887.049988 186.179993 888.130005 193.130005 888.130005 193.130005 C 888.130005 193.130005 893.390015 174.089996 886.780029 167.940002 L 886.780029 167.929993 Z"
      />
      <linearGradient
        id="linearGradient156"
        x1="874.526"
        y1="138.043"
        x2="870.317"
        y2="188.571"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2525" stopOpacity={1} />
        <stop offset="0.16" stopColor="#352120" stopOpacity={1} />
        <stop offset="0.54" stopColor="#2b1c1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5631"
        fill="url(#linearGradient156)"
        stroke="none"
        d="M 889.679993 163.140015 C 889.679993 163.140015 891.01001 163.679993 893.76001 165.47998 C 893.76001 165.47998 889.650024 156.399994 878.349976 154.26001 C 872.440002 153.140015 863.700012 152.929993 860.210022 157.850006 C 860.210022 157.850006 856.27002 153.910004 851.809998 161.619995 C 851.809998 161.619995 853.380005 160 855.969971 160.399994 C 855.969971 160.399994 851.52002 160.73999 849.400024 168.51001 C 848.570007 171.559998 848.599976 176.5 848.640015 181.76001 C 848.640015 181.76001 851.400024 182.01001 850.820007 189 C 850.820007 189 853.159973 179.929993 854.75 175.289978 C 854.75 175.289978 855.109985 178.039978 854.599976 179.789978 C 855.219971 179.01001 858.02002 177.01001 859.710022 164.220001 C 859.710022 164.220001 860.799988 176.539978 875.700012 175.369995 C 875.700012 175.369995 873.049988 174.47998 872.549988 172.410004 C 876.309998 176.309998 881.75 178.869995 887.150024 180.570007 L 886.190002 174.710022 C 886.190002 174.710022 888.960022 181.98999 888.390015 188.029999 C 888.23999 189.649994 888.090027 193.779999 888.090027 193.779999 C 888.090027 193.779999 889.030029 187.119995 891.530029 187.460022 C 891.530029 187.460022 893.119995 180.399994 892.710022 176.73999 C 892.710022 176.73999 893.549988 177.859985 893.659973 179.630005 C 893.659973 179.630005 896.48999 170.570007 889.690002 163.119995 L 889.679993 163.140015 Z"
      />
      <path
        id="path5632"
        fill="#1e1412"
        stroke="none"
        d="M 888.070007 193.789978 C 888.070007 193.789978 891.969971 183.210022 886.559998 173.77002 C 886.559998 173.77002 888.909973 182.25 888.070007 193.789978 Z"
      />
      <path
        id="path5633"
        fill="#1e1412"
        stroke="none"
        d="M 861.159973 170.109985 C 860.47998 168.359985 859.73999 165.799988 859.630005 162.320007 C 859.359985 164.070007 858.869995 166.410004 859.200012 168.149994 C 859.51001 169.75 859.940002 171.51001 860.849976 172.880005 C 862.380005 175.169983 865.219971 176.059998 867.789978 176.460022 C 866.400024 175.76001 864.98999 175.039978 863.77002 174.049988 C 862.599976 173.089996 861.700012 171.52002 861.150024 170.119995 L 861.159973 170.109985 Z"
      />
      <path
        id="path5634"
        fill="#1e1412"
        stroke="none"
        d="M 866.359985 172.559998 C 865.070007 171.649994 863.679993 170.669983 862.650024 169.470001 C 861.679993 168.339996 859.950012 165.190002 859.52002 163.140015 C 859.539978 165.660004 859.570007 167.210022 860.51001 168.910004 C 861.340027 170.399994 862.409973 171.549988 863.76001 172.570007 C 865.119995 173.589996 866.48999 174.5 868.130005 174.97998 C 870.549988 175.700012 873.280029 175.97998 875.799988 175.700012 C 874.030029 175.440002 872.280029 175.029999 870.570007 174.48999 C 869.090027 174.02002 867.640015 173.470001 866.359985 172.559998 Z"
      />
      <path
        id="path5635"
        fill="#1e1412"
        stroke="none"
        d="M 880.51001 177.779999 C 879.030029 176.960022 877.73999 176.089996 876.580017 175.309998 C 874.280029 173.76001 872.609985 172.48999 871.359985 171.470001 C 870.119995 170.460022 869.289978 169.72998 868.73999 169.27002 C 868.200012 168.809998 867.929993 168.640015 867.929993 168.640015 C 869.179993 171.179993 871.159973 173.27002 873.190002 174.839996 C 874.210022 175.630005 875.25 176.320007 876.26001 176.910004 C 877.27002 177.5 878.25 178.02002 879.200012 178.429993 C 881.080017 179.26001 882.77002 179.600006 883.919983 179.630005 C 884.5 179.649994 884.940002 179.619995 885.23999 179.580017 L 885.700012 179.51001 C 883.700012 179.330017 881.98999 178.570007 880.51001 177.76001 L 880.51001 177.779999 Z"
      />
      <path
        id="path5636"
        fill="#1e1412"
        stroke="none"
        d="M 885.130005 178.460022 C 884.390015 177.859985 883.679993 177.220001 882.950012 176.609985 C 882.369995 176.130005 881.72998 175.559998 881.01001 175.299988 C 882.539978 179.089996 886.820007 182.950012 891.109985 181.089996 C 888.859985 181.02002 886.849976 179.850006 885.130005 178.470001 L 885.130005 178.460022 Z"
      />
      <path
        id="path5637"
        fill="#1e1412"
        stroke="none"
        d="M 851.619995 182.179993 C 851.109985 184.350006 850.77002 186.76001 850.820007 189.22998 C 850.820007 189.22998 854.080017 180.119995 854.869995 174.22998 C 854.98999 173.330017 854.650024 171.25 854.200012 170.450012 C 853.140015 174.289978 852.330017 178.25 851.630005 182.190002 L 851.619995 182.179993 Z"
      />
      <path
        id="path5638"
        fill="#1e1412"
        stroke="none"
        d="M 886.190002 174.640015 C 886.909973 176.940002 887.109985 177.320007 887.359985 178.51001 C 887.599976 179.679993 887.73999 180.859985 887.909973 182.039978 C 888.210022 184.049988 888.650024 186.059998 890 187.619995 C 889.169983 185.130005 889.630005 182.440002 889.169983 179.890015 C 888.849976 178.070007 887.390015 176.029999 886.179993 174.649994 L 886.190002 174.640015 Z"
      />
      <path
        id="path5639"
        fill="#1e1412"
        stroke="none"
        d="M 859.419983 163.470001 C 859.080017 166.899994 858.830017 169.470001 857.309998 173.380005 C 856.289978 176.02002 854.679993 179.089996 852.960022 181.320007 C 854.280029 180.350006 855.419983 179.130005 856.340027 177.77002 C 857.929993 175.410004 859.280029 172.460022 859.52002 169.619995 C 859.619995 168.429993 859.450012 166.26001 859.409973 163.470001 L 859.419983 163.470001 Z"
      />
      <linearGradient
        id="linearGradient157"
        x1="870.249"
        y1="189.611"
        x2="871.733"
        y2="154.418"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.46" stopColor="#2b1c1a" stopOpacity={1} />
        <stop offset="0.84" stopColor="#352120" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2525" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5640"
        fill="url(#linearGradient157)"
        stroke="none"
        d="M 889.960022 163.22998 C 892.210022 164.5 893.76001 165.47998 893.76001 165.47998 C 893.76001 165.47998 889.98999 156.330017 877.820007 153.73999 C 864.210022 150.839996 860.200012 157.850006 860.200012 157.850006 C 852.919983 155.070007 847.859985 163.940002 847.469971 172.799988 C 851.570007 162.330017 860.340027 160.330017 860.340027 160.330017 C 859.929993 166.289978 872.099976 168.109985 872.099976 168.109985 C 870.409973 165.369995 871.27002 162.660004 871.27002 162.660004 C 873.22998 168.089996 886.840027 170.820007 886.840027 170.820007 C 884.469971 166.470001 882.809998 164.080017 882.809998 164.080017 C 889.98999 167.399994 893.640015 179.630005 893.640015 179.630005 C 896.47998 167.869995 889.950012 163.220001 889.950012 163.220001 L 889.960022 163.22998 Z"
      />
      <linearGradient
        id="linearGradient158"
        x1="863.774"
        y1="149.803"
        x2="872.579"
        y2="175.869"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#4c3338" stopOpacity={1} />
        <stop offset="0.04" stopColor="#4a3236" stopOpacity={1} />
        <stop offset="0.54" stopColor="#3f2829" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2525" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5641"
        fill="url(#linearGradient158)"
        stroke="none"
        d="M 873.650024 153.109985 C 870.72998 152.660004 867.419983 152.76001 864.640015 153.890015 C 867.640015 151.369995 871.700012 151.380005 875.390015 151.339996 C 872.400024 150.52002 869.140015 150.029999 866.150024 151.179993 C 864.840027 151.690002 863.690002 152.52002 862.75 153.580017 C 861.840027 154.609985 860.919983 155.929993 860.570007 157.289978 C 858.890015 155.309998 855.580017 155.169983 853.52002 156.559998 C 851.570007 157.880005 849.369995 161.299988 849.169983 162.820007 C 850.940002 159.839996 852.380005 158.850006 854.330017 158.179993 C 856.590027 157.410004 858.679993 157.589996 860.48999 158.570007 C 860.48999 158.649994 861.159973 158.539978 861.159973 158.539978 C 861.159973 158.539978 861.609985 157.529999 861.869995 157.27002 C 862.549988 156.600006 863.27002 155.940002 864.130005 155.52002 C 865.01001 155.089996 865.98999 154.919983 866.950012 154.77002 C 868 154.600006 869.070007 154.5 870.140015 154.47998 C 874.070007 154.399994 878.01001 155.26001 881.570007 156.929993 C 883.159973 157.679993 884.609985 158.619995 886.049988 159.630005 C 885 158.52002 883.880005 157.580017 882.75 156.779999 C 880.070007 154.869995 876.890015 153.619995 873.650024 153.130005 L 873.650024 153.109985 Z"
      />
      <linearGradient
        id="linearGradient159"
        x1="867.411"
        y1="206.696"
        x2="866.898"
        y2="213.407"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffc9b3" stopOpacity={1} />
        <stop offset="0.99" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset={1} stopColor="#f7c3a9" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5642"
        fill="url(#linearGradient159)"
        stroke="none"
        d="M 867.440002 209.130005 C 866.299988 208.97998 863.340027 209.369995 863.359985 209.799988 C 863.440002 211.100006 866.059998 211.660004 867.200012 211.809998 C 868.340027 211.960022 870.690002 211.97998 870.880005 210.899994 C 870.960022 210.47998 868.570007 209.27002 867.429993 209.119995 L 867.440002 209.130005 Z"
      />
      <linearGradient
        id="linearGradient160"
        x1="866.554"
        y1="213.492"
        x2="867.435"
        y2="208.031"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7c3a9" stopOpacity={1} />
        <stop offset="0.64" stopColor="#fac5ad" stopOpacity={1} />
        <stop offset={1} stopColor="#ffc9b3" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5643"
        fill="url(#linearGradient160)"
        stroke="none"
        d="M 867.72998 207.869995 C 864.799988 207.47998 862.299988 208.160004 862.140015 208.899994 C 861.840027 210.320007 864.109985 210.98999 866.320007 211.539978 C 868.52002 212.089996 872.090027 211.309998 872.22998 210.25 C 872.369995 209.190002 871.719971 208.399994 867.72998 207.869995 Z"
      />
      <linearGradient
        id="linearGradient161"
        x1="868.458"
        y1="201.731"
        x2="866.179"
        y2="218.264"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#db8f79" stopOpacity={1} />
        <stop offset="0.47" stopColor="#e39c85" stopOpacity={1} />
        <stop offset={1} stopColor="#f0b299" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5644"
        fill="url(#linearGradient161)"
        stroke="none"
        d="M 862.179993 213.48999 C 860.919983 212.970001 858.02002 209.570007 858.02002 209.570007 C 858.02002 209.570007 860.330017 213.839996 861.929993 214.390015 C 863.530029 214.940002 868.369995 215.799988 870.419983 215.52002 C 872.460022 215.23999 876.359985 212.220001 876.359985 212.220001 C 876.359985 212.220001 872.719971 214.059998 870.710022 214.619995 C 868.700012 215.179993 863.450012 214 862.190002 213.47998 L 862.179993 213.48999 Z"
      />
      <radialGradient
        id="radialGradient31"
        cx="873.59"
        cy="288.34"
        r="31.85"
        fx="873.59"
        fy="288.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5645"
        fill="url(#radialGradient31)"
        fillRule="evenodd"
        stroke="none"
        d="M 902.539978 279.869995 C 902.539978 279.869995 889.570007 262.209991 855.200012 260.76001 C 855.200012 260.76001 840.75 288.339996 848.070007 319.179993 L 840.76001 318.48999 C 840.76001 318.48999 843.609985 281.179993 853.150024 257.48999 C 853.150024 257.48999 878.059998 259.670013 906.419983 271.619995 C 906.419983 271.619995 906.419983 279.390015 902.539978 279.869995 Z"
      />
      <radialGradient
        id="radialGradient32"
        cx="903.59"
        cy="275.12"
        r="2.52"
        fx="903.59"
        fy="275.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5646"
        fill="url(#radialGradient32)"
        fillRule="evenodd"
        stroke="none"
        d="M 905.530029 275.119995 C 905.530029 276.769989 904.659973 278.100006 903.590027 278.100006 C 902.52002 278.100006 901.650024 276.76001 901.650024 275.119995 C 901.650024 273.480011 902.52002 272.140015 903.590027 272.140015 C 904.659973 272.140015 905.530029 273.480011 905.530029 275.119995 Z"
      />
      <radialGradient
        id="radialGradient33"
        cx="844.25"
        cy="315.51"
        r="2.52"
        fx="844.25"
        fy="315.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b998b4" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5647"
        fill="url(#radialGradient33)"
        fillRule="evenodd"
        stroke="none"
        d="M 846.190002 315.51001 C 846.190002 317.160004 845.320007 318.48999 844.25 318.48999 C 843.179993 318.48999 842.309998 317.149994 842.309998 315.51001 C 842.309998 313.869995 843.179993 312.529999 844.25 312.529999 C 845.320007 312.529999 846.190002 313.869995 846.190002 315.51001 Z"
      />
      <radialGradient
        id="radialGradient34"
        cx="845.79"
        cy={288}
        r="22.19"
        fx="845.79"
        fy={288}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5648"
        fill="url(#radialGradient34)"
        fillRule="evenodd"
        stroke="none"
        d="M 853.140015 257.5 L 847.820007 257.5 C 847.820007 257.5 837.409973 290.029999 838.51001 318.5 L 840.75 318.5 C 840.75 318.5 844.669983 280.890015 853.140015 257.5 Z"
      />
      <path
        id="path5649"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 854.76001 261.929993 C 854.76001 261.929993 883.679993 261.799988 902.539978 279.880005 C 902.539978 279.880005 891.23999 262.540009 855.280029 260.290009 L 854.76001 261.940002 L 854.76001 261.929993 Z"
      />
      <radialGradient
        id="radialGradient35"
        cx="399.248"
        cy="290.51"
        r="13.8123"
        fx="399.248"
        fy="290.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5650"
        fill="url(#radialGradient35)"
        fillRule="evenodd"
        stroke="none"
        d="M 395.929993 311.049988 C 395.929993 311.049988 402.049988 283.859985 402.48999 266.200012 L 395.929993 266.200012 C 395.929993 266.200012 395.779999 296.339996 392.290009 311.049988 L 395.929993 311.049988 Z"
      />
      <radialGradient
        id="radialGradient36"
        cx="393.223"
        cy="290.51"
        r="13.7196"
        fx="393.223"
        fy="290.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5651"
        fill="url(#radialGradient36)"
        fillRule="evenodd"
        stroke="none"
        d="M 387.01001 270.799988 L 395.929993 266.190002 C 395.929993 266.190002 396.359985 295.179993 392.290009 311.040009 L 391.470001 311.040009 C 391.470001 311.040009 395.73999 288.140015 394.429993 269.179993 L 386.829987 274.109985 L 387 270.790009 L 387.01001 270.799988 Z"
      />
      <path
        id="path5652"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 388.100006 273.309998 L 394.589996 272.119995 L 394.440002 269.190002 L 388.100006 273.309998 Z"
      />
      <radialGradient
        id="radialGradient37"
        cx="324.456"
        cy="290.51"
        r="13.8123"
        fx="324.456"
        fy="290.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5653"
        fill="url(#radialGradient37)"
        fillRule="evenodd"
        stroke="none"
        d="M 323.220001 310.390015 C 323.220001 310.390015 317.200012 283.850006 316.75 266.190002 L 323.309998 266.190002 C 323.309998 266.190002 323.459991 296.329987 326.950012 311.040009 L 323.220001 310.390015 Z"
      />
      <radialGradient
        id="radialGradient38"
        cx="330.482"
        cy="290.51"
        r="13.7196"
        fx="330.482"
        fy="290.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5654"
        fill="url(#radialGradient38)"
        fillRule="evenodd"
        stroke="none"
        d="M 332.23999 270.799988 L 323.320007 266.190002 C 323.320007 266.190002 322.890015 295.179993 326.959991 311.040009 L 327.779999 311.040009 C 327.779999 311.040009 323.51001 288.140015 324.820007 269.179993 L 332.420013 274.109985 L 332.25 270.790009 L 332.23999 270.799988 Z"
      />
      <path
        id="path5655"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 331.140015 273.309998 L 324.649994 272.119995 L 324.799988 269.190002 L 331.140015 273.309998 Z"
      />
      <radialGradient
        id="radialGradient39"
        cx="358.739"
        cy="249.54"
        r="43.0231"
        fx="358.739"
        fy="249.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5656"
        fill="url(#radialGradient39)"
        fillRule="evenodd"
        stroke="none"
        d="M 388.459991 199.359985 C 388.459991 199.359985 390.48999 260.880005 386.920013 298.399994 L 332.380005 299.709991 C 332.380005 299.709991 325.549988 230.339996 325.059998 199.619995 L 388.459991 199.359985 Z"
      />
      <radialGradient
        id="radialGradient40"
        cx="342.351"
        cy="223.38"
        r="74.8913"
        fx="342.351"
        fy="223.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5657"
        fill="url(#radialGradient40)"
        fillRule="evenodd"
        stroke="none"
        d="M 385.540009 299.390015 C 385.540009 299.390015 389.970001 236.23999 388.459991 199.359985 C 388.459991 199.359985 359.029999 187.890015 325.059998 199.619995 C 325.059998 199.619995 328.48999 264.399994 334.440002 301.410004 L 385.540009 299.390015 Z"
      />
      <path
        id="path5658"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 362.190002 331.75 L 378.480011 341.459991 C 378.480011 341.459991 379.679993 343.859985 379.959991 346.540009 L 378.5 346.540009 C 378.5 346.540009 377.570007 344.369995 377.049988 343.720001 C 375.920013 342.299988 361.230011 338.670013 361.230011 338.670013 L 359.399994 331.75 L 362.190002 331.75 Z"
      />
      <radialGradient
        id="radialGradient41"
        cx="369.6"
        cy="339.14"
        r="7.18"
        fx="369.6"
        fy="339.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5659"
        fill="url(#radialGradient41)"
        fillRule="evenodd"
        stroke="none"
        d="M 362.839996 331.75 L 379.130005 341.459991 C 379.130005 341.459991 380.329987 343.859985 380.609985 346.540009 L 379.149994 346.540009 C 379.149994 346.540009 378.220001 344.369995 377.700012 343.720001 C 376.570007 342.299988 361.880005 338.670013 361.880005 338.670013 L 361.640015 337.429993 L 362.850006 331.75 L 362.839996 331.75 Z"
      />
      <radialGradient
        id="radialGradient42"
        cx="384.47"
        cy="347.23"
        r="6.39629"
        fx="384.47"
        fy="347.23"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5660"
        fill="url(#radialGradient42)"
        stroke="none"
        d="M 380.920013 353.619995 C 383.796997 353.619995 386.130005 351.346008 386.130005 348.540009 C 386.130005 345.734009 383.796997 343.459991 380.920013 343.459991 C 378.042999 343.459991 375.709991 345.734009 375.709991 348.540009 C 375.709991 351.346008 378.042999 353.619995 380.920013 353.619995 Z"
      />
      <radialGradient
        id="radialGradient43"
        cx="383.159"
        cy="346.525"
        r="3.67199"
        fx="383.159"
        fy="346.525"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5661"
        fill="url(#radialGradient43)"
        stroke="none"
        d="M 382.720001 352.480011 C 384.381989 352.480011 385.730011 350.716003 385.730011 348.540009 C 385.730011 346.364014 384.381989 344.600006 382.720001 344.600006 C 381.058014 344.600006 379.709991 346.364014 379.709991 348.540009 C 379.709991 350.716003 381.058014 352.480011 382.720001 352.480011 Z"
      />
      <linearGradient
        id="linearGradient162"
        x1="399.04"
        y1="311.69"
        x2="320.72"
        y2="311.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#6e5f85" stopOpacity={1} />
        <stop offset={1} stopColor="#3f1f49" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5662"
        fill="url(#linearGradient162)"
        fillRule="evenodd"
        stroke="none"
        d="M 399.040009 311.25 C 399.040009 311.25 369.609985 316.700012 320.709991 310.230011 C 320.709991 310.230011 329.160004 309.640015 352.279999 310.230011 L 399.040009 311.25 Z"
      />
      <radialGradient
        id="radialGradient44"
        cx="360.266"
        cy="309.28"
        r="27.8296"
        fx="360.266"
        fy="309.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5663"
        fill="url(#radialGradient44)"
        fillRule="evenodd"
        stroke="none"
        d="M 320.709991 307.309998 L 399.040009 307.309998 L 399.040009 311.25 L 320.709991 310.230011 L 320.709991 307.309998 Z"
      />
      <radialGradient
        id="radialGradient45"
        cx="341.63"
        cy="295.764"
        r="19.9511"
        fx="341.63"
        fy="295.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5664"
        fill="url(#radialGradient45)"
        fillRule="evenodd"
        stroke="none"
        d="M 399.040009 307.309998 C 399.040009 307.309998 399.75 301.23999 397.339996 299.200012 C 397.339996 299.200012 362.600006 294.890015 320.709991 301.76001 L 320.709991 307.320007 L 351.619995 307.299988 L 399.040009 307.320007 L 399.040009 307.309998 Z"
      />
      <g id="g248" opacity="0.5" style={{ mixBlendMode: 'screen' }}>
        <path
          id="path5665"
          fill="#41243f"
          fillRule="evenodd"
          stroke="none"
          d="M 320.709991 307.309998 L 320.709991 301.75 C 350.019989 300.26001 367.679993 299.170013 397.339996 299.190002 C 397.339996 299.190002 399.869995 301.100006 399.040009 307.299988 L 320.709991 307.299988 L 320.709991 307.309998 Z"
        />
      </g>
      <path
        id="path5666"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 397.339996 299.200012 L 359.029999 299.929993 C 359.029999 299.929993 339.440002 299.859985 320.720001 301.75 C 320.720001 301.75 347.910004 294.75 397.350006 299.190002 L 397.339996 299.200012 Z"
      />
      <path
        id="path5667"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 373.070007 312.649994 L 345.730011 312.649994 C 345.730011 312.649994 351.51001 316.690002 359.399994 316.690002 C 367.290009 316.690002 373.070007 312.649994 373.070007 312.649994 Z"
      />
      <radialGradient
        id="radialGradient46"
        cx="360.472"
        cy="314.741"
        r="4.2435"
        fx="360.472"
        fy="314.741"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5668"
        fill="url(#radialGradient46)"
        fillRule="evenodd"
        stroke="none"
        d="M 363.230011 316.480011 L 362.459991 329.709991 L 357.420013 329.709991 L 356.920013 316.450012 L 363.230011 316.480011 Z"
      />
      <radialGradient
        id="radialGradient47"
        cx="358.566"
        cy="323.764"
        r="11.4759"
        fx="358.566"
        fy="323.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5669"
        fill="url(#radialGradient47)"
        fillRule="evenodd"
        stroke="none"
        d="M 363.829987 324.51001 L 356.320007 324.51001 L 357.070007 338.369995 L 362.940002 338.369995 L 363.829987 324.51001 Z"
      />
      <radialGradient
        id="radialGradient48"
        cx="383.036"
        cy="338.83"
        r="16.2268"
        fx="383.036"
        fy="338.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5670"
        fill="url(#radialGradient48)"
        fillRule="evenodd"
        stroke="none"
        d="M 363.230011 331.440002 L 399.829987 341.149994 C 399.829987 341.149994 402.529999 343.549988 403.149994 346.230011 L 399.869995 346.230011 C 399.869995 346.230011 397.769989 344.059998 396.609985 343.410004 C 394.070007 341.98999 361.059998 338.359985 361.059998 338.359985 L 360.519989 337.119995 L 363.230011 331.440002 Z"
      />
      <radialGradient
        id="radialGradient49"
        cx="404.429"
        cy="346.45"
        r="6.39631"
        fx="404.429"
        fy="346.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5671"
        fill="url(#radialGradient49)"
        fillRule="evenodd"
        stroke="none"
        d="M 394.670013 347.76001 C 394.670013 350.559998 397 352.839996 399.880005 352.839996 C 402.76001 352.839996 405.089996 350.570007 405.089996 347.76001 C 405.089996 344.950012 402.76001 342.679993 399.880005 342.679993 C 397 342.679993 394.670013 344.950012 394.670013 347.76001 Z"
      />
      <radialGradient
        id="radialGradient50"
        cx="398.064"
        cy="346.214"
        r="3.67201"
        fx="398.064"
        fy="346.214"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5672"
        fill="url(#radialGradient50)"
        fillRule="evenodd"
        stroke="none"
        d="M 395.350006 348.230011 C 395.350006 350.410004 396.700012 352.170013 398.359985 352.170013 C 400.019989 352.170013 401.369995 350.399994 401.369995 348.230011 C 401.369995 346.059998 400.019989 344.290009 398.359985 344.290009 C 396.700012 344.290009 395.350006 346.059998 395.350006 348.230011 Z"
      />
      <radialGradient
        id="radialGradient51"
        cx="343.219"
        cy="338.83"
        r="16.2268"
        fx="343.219"
        fy="338.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5673"
        fill="url(#radialGradient51)"
        fillRule="evenodd"
        stroke="none"
        d="M 356.690002 331.440002 L 320.089996 341.149994 C 320.089996 341.149994 317.390015 343.549988 316.769989 346.230011 L 320.049988 346.230011 C 320.049988 346.230011 322.149994 344.059998 323.309998 343.410004 C 325.850006 341.98999 358.859985 338.359985 358.859985 338.359985 L 359.399994 337.119995 L 356.690002 331.440002 Z"
      />
      <path
        id="path5674"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 356.98999 331.440002 L 340.700012 341.149994 C 340.700012 341.149994 339.5 343.549988 339.220001 346.230011 L 340.679993 346.230011 C 340.679993 346.230011 341.609985 344.059998 342.130005 343.410004 C 343.26001 341.98999 357.950012 338.359985 357.950012 338.359985 L 359.779999 331.440002 L 356.98999 331.440002 Z"
      />
      <radialGradient
        id="radialGradient52"
        cx="348.155"
        cy="338.83"
        r="7.18"
        fx="348.155"
        fy="338.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5675"
        fill="url(#radialGradient52)"
        fillRule="evenodd"
        stroke="none"
        d="M 359.779999 331.440002 L 343.48999 341.149994 C 343.48999 341.149994 342.290009 343.549988 342.01001 346.230011 L 343.470001 346.230011 C 343.470001 346.230011 344.399994 344.059998 344.920013 343.410004 C 346.049988 341.98999 360.73999 338.359985 360.73999 338.359985 L 360.980011 337.119995 L 359.769989 331.440002 L 359.779999 331.440002 Z"
      />
      <radialGradient
        id="radialGradient53"
        cx="323.897"
        cy="346.45"
        r="6.39631"
        fx="323.897"
        fy="346.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5676"
        fill="url(#radialGradient53)"
        fillRule="evenodd"
        stroke="none"
        d="M 325.25 347.76001 C 325.25 350.559998 322.920013 352.839996 320.040009 352.839996 C 317.160004 352.839996 314.829987 350.570007 314.829987 347.76001 C 314.829987 344.950012 317.160004 342.679993 320.040009 342.679993 C 322.920013 342.679993 325.25 344.950012 325.25 347.76001 Z"
      />
      <radialGradient
        id="radialGradient54"
        cx="315.69"
        cy="346.214"
        r="3.67199"
        fx="315.69"
        fy="346.214"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5677"
        fill="url(#radialGradient54)"
        fillRule="evenodd"
        stroke="none"
        d="M 324.579987 348.230011 C 324.579987 350.410004 323.230011 352.170013 321.570007 352.170013 C 319.910004 352.170013 318.559998 350.399994 318.559998 348.230011 C 318.559998 346.059998 319.910004 344.290009 321.570007 344.290009 C 323.230011 344.290009 324.579987 346.059998 324.579987 348.230011 Z"
      />
      <path
        id="path5678"
        fill="#482f54"
        fillRule="evenodd"
        stroke="none"
        d="M 340.700012 341.149994 L 343.48999 341.149994 C 343.48999 341.149994 342.269989 343.619995 342.01001 346.230011 L 339.220001 346.230011 C 339.220001 346.230011 339.549988 342.950012 340.700012 341.149994 Z"
      />
      <radialGradient
        id="radialGradient55"
        cx="345.63"
        cy="346.92"
        r="6.39631"
        fx="345.63"
        fy="346.92"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5679"
        fill="url(#radialGradient55)"
        fillRule="evenodd"
        stroke="none"
        d="M 346.899994 348.230011 C 346.899994 351.029999 344.570007 353.309998 341.690002 353.309998 C 338.809998 353.309998 336.480011 351.040009 336.480011 348.230011 C 336.480011 345.420013 338.809998 343.149994 341.690002 343.149994 C 344.570007 343.149994 346.899994 345.420013 346.899994 348.230011 Z"
      />
      <radialGradient
        id="radialGradient56"
        cx="337.273"
        cy="346.685"
        r="3.67201"
        fx="337.273"
        fy="346.685"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5680"
        fill="url(#radialGradient56)"
        fillRule="evenodd"
        stroke="none"
        d="M 346.220001 348.700012 C 346.220001 350.880005 344.869995 352.640015 343.209991 352.640015 C 341.549988 352.640015 340.200012 350.869995 340.200012 348.700012 C 340.200012 346.529999 341.549988 344.76001 343.209991 344.76001 C 344.869995 344.76001 346.220001 346.529999 346.220001 348.700012 Z"
      />
      <path
        id="path5681"
        fill="#26132a"
        fillRule="evenodd"
        stroke="none"
        d="M 332.369995 226.890015 L 383.320007 226.890015 C 383.320007 226.890015 371.76001 229.619995 357.850006 229.619995 C 343.940002 229.619995 332.380005 226.890015 332.380005 226.890015 L 332.369995 226.890015 Z"
      />
      <radialGradient
        id="radialGradient57"
        cx="358.028"
        cy="198.74"
        r="21.012"
        fx="358.028"
        fy="198.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5682"
        fill="url(#radialGradient57)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 385.730011 199.369995 L 381.839996 202.100006 C 381.839996 202.100006 358.040009 196.059998 331.140015 202.100006 L 326.950012 199.609985 C 326.950012 199.609985 353 190.220001 385.730011 199.369995 Z"
      />
      <linearGradient
        id="linearGradient163"
        x1="382.75"
        y1="216.1"
        x2="382.75"
        y2="205.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5683"
        fill="url(#linearGradient163)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 383.320007 205.380005 C 385.859985 206.039978 386.26001 214.940002 384.200012 215.950012 C 382.140015 216.960022 382.649994 212.929993 380.970001 210.669983 C 379.290009 208.410004 379.480011 204.380005 383.320007 205.390015 L 383.320007 205.380005 Z"
      />
      <radialGradient
        id="radialGradient58"
        cx="358.563"
        cy="231.25"
        r="16.0989"
        fx="358.563"
        fy="231.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5684"
        fill="url(#radialGradient58)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 379.420013 229.619995 C 376.709991 229.149994 368.829987 230.76001 357.040009 230.940002 C 345.25 231.130005 334.309998 228.960022 334.309998 228.960022 C 334.309998 228.960022 349.98999 234.049988 358.600006 233.48999 C 367.209991 232.919983 379.410004 229.619995 379.410004 229.619995 L 379.420013 229.619995 Z"
      />
      <linearGradient
        id="linearGradient164"
        x1="383.91"
        y1="234.69"
        x2="383.91"
        y2="227.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5685"
        fill="url(#linearGradient164)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 384.01001 227.809998 C 384.01001 227.809998 386.369995 230.72998 384.01001 234.700012 C 384.01001 234.700012 381.149994 230.820007 384.01001 227.809998 Z"
      />
      <linearGradient
        id="linearGradient165"
        x1="331.61"
        y1="268.24"
        x2="331.61"
        y2="248.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5686"
        fill="url(#linearGradient165)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 332.859985 268.23999 C 332.859985 268.23999 332.480011 252.440002 330.350006 248.970001 C 330.350006 248.970001 330.720001 261.480011 332.859985 268.23999 Z"
      />
      <radialGradient
        id="radialGradient59"
        cx="551.204"
        cy="286.647"
        r="13.8123"
        fx="551.204"
        fy="286.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5687"
        fill="url(#radialGradient59)"
        fillRule="evenodd"
        stroke="none"
        d="M 547.289978 307.200012 C 547.289978 307.200012 553.409973 280.01001 553.849976 262.350006 L 547.289978 262.350006 C 547.289978 262.350006 547.140015 292.48999 543.650024 307.200012 L 547.289978 307.200012 Z"
      />
      <radialGradient
        id="radialGradient60"
        cx="545.179"
        cy="286.647"
        r="13.7197"
        fx="545.179"
        fy="286.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5688"
        fill="url(#radialGradient60)"
        fillRule="evenodd"
        stroke="none"
        d="M 538.359985 266.950012 L 547.280029 262.339996 C 547.280029 262.339996 547.710022 291.329987 543.640015 307.190002 L 542.820007 307.190002 C 542.820007 307.190002 547.090027 284.290009 545.780029 265.329987 L 538.179993 270.26001 L 538.349976 266.940002 L 538.359985 266.950012 Z"
      />
      <path
        id="path5689"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 539.460022 269.459991 L 545.950012 268.269989 L 545.799988 265.339996 L 539.460022 269.459991 Z"
      />
      <radialGradient
        id="radialGradient61"
        cx="476.412"
        cy="286.647"
        r="13.8123"
        fx="476.412"
        fy="286.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5690"
        fill="url(#radialGradient61)"
        fillRule="evenodd"
        stroke="none"
        d="M 474.570007 306.540009 C 474.570007 306.540009 468.549988 280 468.100006 262.339996 L 474.660004 262.339996 C 474.660004 262.339996 474.809998 292.480011 478.299988 307.190002 L 474.570007 306.540009 Z"
      />
      <radialGradient
        id="radialGradient62"
        cx="482.438"
        cy="286.647"
        r="13.7196"
        fx="482.438"
        fy="286.647"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5691"
        fill="url(#radialGradient62)"
        fillRule="evenodd"
        stroke="none"
        d="M 483.589996 266.950012 L 474.670013 262.339996 C 474.670013 262.339996 474.23999 291.329987 478.309998 307.190002 L 479.130005 307.190002 C 479.130005 307.190002 474.859985 284.290009 476.170013 265.329987 L 483.769989 270.26001 L 483.600006 266.940002 L 483.589996 266.950012 Z"
      />
      <path
        id="path5692"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 482.5 269.459991 L 476.01001 268.269989 L 476.160004 265.339996 L 482.5 269.459991 Z"
      />
      <radialGradient
        id="radialGradient63"
        cx="510.694"
        cy="245.69"
        r="43.0231"
        fx="510.694"
        fy="245.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5693"
        fill="url(#radialGradient63)"
        fillRule="evenodd"
        stroke="none"
        d="M 539.809998 195.51001 C 539.809998 195.51001 541.840027 257.029999 538.27002 294.549988 L 483.730011 295.859985 C 483.730011 295.859985 476.899994 226.48999 476.410004 195.77002 L 539.809998 195.51001 Z"
      />
      <radialGradient
        id="radialGradient64"
        cx="494.317"
        cy="219.534"
        r="74.8913"
        fx="494.317"
        fy="219.534"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5694"
        fill="url(#radialGradient64)"
        fillRule="evenodd"
        stroke="none"
        d="M 536.900024 295.540009 C 536.900024 295.540009 541.330017 232.390015 539.820007 195.51001 C 539.820007 195.51001 510.390015 184.039978 476.420013 195.77002 C 476.420013 195.77002 479.850006 260.549988 485.799988 297.559998 L 536.900024 295.540009 Z"
      />
      <path
        id="path5695"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 513.539978 327.899994 L 529.830017 337.609985 C 529.830017 337.609985 531.030029 340.01001 531.309998 342.690002 L 529.849976 342.690002 C 529.849976 342.690002 528.919983 340.519989 528.400024 339.869995 C 527.27002 338.450012 512.580017 334.820007 512.580017 334.820007 L 510.75 327.899994 L 513.539978 327.899994 Z"
      />
      <radialGradient
        id="radialGradient65"
        cx="520.565"
        cy="335.3"
        r="7.18001"
        fx="520.565"
        fy="335.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5696"
        fill="url(#radialGradient65)"
        fillRule="evenodd"
        stroke="none"
        d="M 514.190002 327.899994 L 530.47998 337.609985 C 530.47998 337.609985 531.679993 340.01001 531.960022 342.690002 L 530.5 342.690002 C 530.5 342.690002 529.570007 340.519989 529.049988 339.869995 C 527.919983 338.450012 513.22998 334.820007 513.22998 334.820007 L 512.98999 333.579987 L 514.200012 327.899994 L 514.190002 327.899994 Z"
      />
      <radialGradient
        id="radialGradient66"
        cx="536.436"
        cy="343.38"
        r="6.39629"
        fx="536.436"
        fy="343.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5697"
        fill="url(#radialGradient66)"
        stroke="none"
        d="M 532.280029 349.769989 C 535.156982 349.769989 537.48999 347.494995 537.48999 344.690002 C 537.48999 341.884003 535.156982 339.609985 532.280029 339.609985 C 529.403015 339.609985 527.070007 341.884003 527.070007 344.690002 C 527.070007 347.494995 529.403015 349.769989 532.280029 349.769989 Z"
      />
      <radialGradient
        id="radialGradient67"
        cx="534.071"
        cy="342.689"
        r="3.67201"
        fx="534.071"
        fy="342.689"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5698"
        fill="url(#radialGradient67)"
        stroke="none"
        d="M 534.080017 348.630005 C 535.742004 348.630005 537.090027 346.865997 537.090027 344.690002 C 537.090027 342.514008 535.742004 340.75 534.080017 340.75 C 532.41803 340.75 531.070007 342.514008 531.070007 344.690002 C 531.070007 346.865997 532.41803 348.630005 534.080017 348.630005 Z"
      />
      <linearGradient
        id="linearGradient166"
        x1="550.4"
        y1="307.84"
        x2="472.07"
        y2="307.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#6e5f85" stopOpacity={1} />
        <stop offset={1} stopColor="#3f1f49" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5699"
        fill="url(#linearGradient166)"
        fillRule="evenodd"
        stroke="none"
        d="M 550.400024 307.410004 C 550.400024 307.410004 520.969971 312.859985 472.070007 306.390015 C 472.070007 306.390015 480.519989 305.799988 503.640015 306.390015 L 550.400024 307.410004 Z"
      />
      <radialGradient
        id="radialGradient68"
        cx="511.763"
        cy="305.43"
        r="27.8296"
        fx="511.763"
        fy="305.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5700"
        fill="url(#radialGradient68)"
        fillRule="evenodd"
        stroke="none"
        d="M 472.070007 303.459991 L 550.400024 303.459991 L 550.400024 307.410004 L 472.070007 306.380005 L 472.070007 303.459991 Z"
      />
      <radialGradient
        id="radialGradient69"
        cx="493.586"
        cy="291.918"
        r="19.9511"
        fx="493.586"
        fy="291.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5701"
        fill="url(#radialGradient69)"
        fillRule="evenodd"
        stroke="none"
        d="M 550.400024 303.459991 C 550.400024 303.459991 551.109985 297.390015 548.700012 295.350006 C 548.700012 295.350006 513.960022 291.040009 472.070007 297.910004 L 472.070007 303.470001 L 502.980011 303.450012 L 550.400024 303.470001 L 550.400024 303.459991 Z"
      />
      <g id="g249" opacity="0.5" style={{ mixBlendMode: 'screen' }}>
        <path
          id="path5702"
          fill="#41243f"
          fillRule="evenodd"
          stroke="none"
          d="M 472.070007 303.459991 L 472.070007 297.899994 C 501.380005 296.410004 519.039978 295.320007 548.700012 295.339996 C 548.700012 295.339996 551.22998 297.25 550.400024 303.450012 L 472.070007 303.450012 L 472.070007 303.459991 Z"
        />
      </g>
      <path
        id="path5703"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 548.700012 295.350006 L 510.390015 296.079987 C 510.390015 296.079987 490.799988 296.01001 472.079987 297.899994 C 472.079987 297.899994 499.269989 290.899994 548.710022 295.339996 L 548.700012 295.350006 Z"
      />
      <path
        id="path5704"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 524.429993 308.799988 L 497.089996 308.799988 C 497.089996 308.799988 502.869995 312.839996 510.76001 312.839996 C 518.650024 312.839996 524.429993 308.799988 524.429993 308.799988 Z"
      />
      <radialGradient
        id="radialGradient70"
        cx="512.008"
        cy="310.885"
        r="4.2435"
        fx="512.008"
        fy="310.885"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5705"
        fill="url(#radialGradient70)"
        fillRule="evenodd"
        stroke="none"
        d="M 514.590027 312.630005 L 513.809998 325.859985 L 508.779999 325.859985 L 508.279999 312.600006 L 514.590027 312.630005 Z"
      />
      <radialGradient
        id="radialGradient71"
        cx="510.102"
        cy="319.924"
        r="11.4759"
        fx="510.102"
        fy="319.924"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5706"
        fill="url(#radialGradient71)"
        fillRule="evenodd"
        stroke="none"
        d="M 515.190002 320.660004 L 507.679993 320.660004 L 508.429993 334.519989 L 514.299988 334.519989 L 515.190002 320.660004 Z"
      />
      <radialGradient
        id="radialGradient72"
        cx="534.851"
        cy="334.98"
        r="16.2268"
        fx="534.851"
        fy="334.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5707"
        fill="url(#radialGradient72)"
        fillRule="evenodd"
        stroke="none"
        d="M 514.590027 327.589996 L 551.190002 337.299988 C 551.190002 337.299988 553.890015 339.700012 554.51001 342.380005 L 551.22998 342.380005 C 551.22998 342.380005 549.130005 340.209991 547.969971 339.559998 C 545.429993 338.140015 512.419983 334.51001 512.419983 334.51001 L 511.880005 333.269989 L 514.590027 327.589996 Z"
      />
      <radialGradient
        id="radialGradient73"
        cx="556.385"
        cy="342.6"
        r="6.39629"
        fx="556.385"
        fy="342.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5708"
        fill="url(#radialGradient73)"
        fillRule="evenodd"
        stroke="none"
        d="M 546.02002 343.910004 C 546.02002 346.709991 548.349976 348.98999 551.22998 348.98999 C 554.109985 348.98999 556.440002 346.720001 556.440002 343.910004 C 556.440002 341.100006 554.109985 338.829987 551.22998 338.829987 C 548.349976 338.829987 546.02002 341.100006 546.02002 343.910004 Z"
      />
      <radialGradient
        id="radialGradient74"
        cx="548.976"
        cy="342.378"
        r="3.67201"
        fx="548.976"
        fy="342.378"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5709"
        fill="url(#radialGradient74)"
        fillRule="evenodd"
        stroke="none"
        d="M 546.700012 344.380005 C 546.700012 346.559998 548.049988 348.320007 549.710022 348.320007 C 551.369995 348.320007 552.719971 346.549988 552.719971 344.380005 C 552.719971 342.209991 551.369995 340.440002 549.710022 340.440002 C 548.049988 340.440002 546.700012 342.209991 546.700012 344.380005 Z"
      />
      <radialGradient
        id="radialGradient75"
        cx="495.034"
        cy="334.98"
        r="16.2268"
        fx="495.034"
        fy="334.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5710"
        fill="url(#radialGradient75)"
        fillRule="evenodd"
        stroke="none"
        d="M 508.040009 327.589996 L 471.440002 337.299988 C 471.440002 337.299988 468.73999 339.700012 468.119995 342.380005 L 471.399994 342.380005 C 471.399994 342.380005 473.5 340.209991 474.660004 339.559998 C 477.200012 338.140015 510.209991 334.51001 510.209991 334.51001 L 510.75 333.269989 L 508.040009 327.589996 Z"
      />
      <path
        id="path5711"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 508.339996 327.589996 L 492.049988 337.299988 C 492.049988 337.299988 490.850006 339.700012 490.570007 342.380005 L 492.029999 342.380005 C 492.029999 342.380005 492.959991 340.209991 493.480011 339.559998 C 494.609985 338.140015 509.299988 334.51001 509.299988 334.51001 L 511.130005 327.589996 L 508.339996 327.589996 Z"
      />
      <radialGradient
        id="radialGradient76"
        cx="499.12"
        cy="334.98"
        r="7.18"
        fx="499.12"
        fy="334.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5712"
        fill="url(#radialGradient76)"
        fillRule="evenodd"
        stroke="none"
        d="M 511.130005 327.589996 L 494.839996 337.299988 C 494.839996 337.299988 493.640015 339.700012 493.359985 342.380005 L 494.820007 342.380005 C 494.820007 342.380005 495.75 340.209991 496.269989 339.559998 C 497.399994 338.140015 512.090027 334.51001 512.090027 334.51001 L 512.330017 333.269989 L 511.119995 327.589996 L 511.130005 327.589996 Z"
      />
      <radialGradient
        id="radialGradient77"
        cx="475.853"
        cy="342.6"
        r="6.39629"
        fx="475.853"
        fy="342.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5713"
        fill="url(#radialGradient77)"
        fillRule="evenodd"
        stroke="none"
        d="M 476.609985 343.910004 C 476.609985 346.709991 474.279999 348.98999 471.399994 348.98999 C 468.519989 348.98999 466.190002 346.720001 466.190002 343.910004 C 466.190002 341.100006 468.519989 338.829987 471.399994 338.829987 C 474.279999 338.829987 476.609985 341.100006 476.609985 343.910004 Z"
      />
      <radialGradient
        id="radialGradient78"
        cx="466.602"
        cy="342.378"
        r="3.67199"
        fx="466.602"
        fy="342.378"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5714"
        fill="url(#radialGradient78)"
        fillRule="evenodd"
        stroke="none"
        d="M 475.929993 344.380005 C 475.929993 346.559998 474.579987 348.320007 472.920013 348.320007 C 471.26001 348.320007 469.910004 346.549988 469.910004 344.380005 C 469.910004 342.209991 471.26001 340.440002 472.920013 340.440002 C 474.579987 340.440002 475.929993 342.209991 475.929993 344.380005 Z"
      />
      <path
        id="path5715"
        fill="#482f54"
        fillRule="evenodd"
        stroke="none"
        d="M 492.059998 337.299988 L 494.850006 337.299988 C 494.850006 337.299988 493.630005 339.769989 493.369995 342.380005 L 490.579987 342.380005 C 490.579987 342.380005 490.910004 339.100006 492.059998 337.299988 Z"
      />
      <radialGradient
        id="radialGradient79"
        cx="497.586"
        cy="343.07"
        r="6.39629"
        fx="497.586"
        fy="343.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5716"
        fill="url(#radialGradient79)"
        fillRule="evenodd"
        stroke="none"
        d="M 498.26001 344.380005 C 498.26001 347.179993 495.929993 349.459991 493.049988 349.459991 C 490.170013 349.459991 487.839996 347.190002 487.839996 344.380005 C 487.839996 341.570007 490.170013 339.299988 493.049988 339.299988 C 495.929993 339.299988 498.26001 341.570007 498.26001 344.380005 Z"
      />
      <radialGradient
        id="radialGradient80"
        cx="488.185"
        cy="342.849"
        r="3.67199"
        fx="488.185"
        fy="342.849"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5717"
        fill="url(#radialGradient80)"
        fillRule="evenodd"
        stroke="none"
        d="M 497.579987 344.850006 C 497.579987 347.029999 496.230011 348.790009 494.570007 348.790009 C 492.910004 348.790009 491.559998 347.019989 491.559998 344.850006 C 491.559998 342.679993 492.910004 340.910004 494.570007 340.910004 C 496.230011 340.910004 497.579987 342.679993 497.579987 344.850006 Z"
      />
      <path
        id="path5718"
        fill="#26132a"
        fillRule="evenodd"
        stroke="none"
        d="M 483.730011 223.039978 L 534.679993 223.039978 C 534.679993 223.039978 523.119995 225.77002 509.209991 225.77002 C 495.299988 225.77002 483.73999 223.039978 483.73999 223.039978 L 483.730011 223.039978 Z"
      />
      <radialGradient
        id="radialGradient81"
        cx="509.994"
        cy="194.89"
        r="21.012"
        fx="509.994"
        fy="194.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5719"
        fill="url(#radialGradient81)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 537.090027 195.52002 L 533.200012 198.25 C 533.200012 198.25 509.399994 192.210022 482.5 198.25 L 478.309998 195.76001 C 478.309998 195.76001 504.359985 186.369995 537.090027 195.52002 Z"
      />
      <linearGradient
        id="linearGradient167"
        x1="534.1"
        y1="212.25"
        x2="534.1"
        y2="201.37"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5720"
        fill="url(#linearGradient167)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 534.679993 201.529999 C 537.219971 202.190002 537.619995 211.089996 535.559998 212.100006 C 533.5 213.109985 534.01001 209.080017 532.330017 206.820007 C 530.650024 204.559998 530.840027 200.529999 534.679993 201.539978 L 534.679993 201.529999 Z"
      />
      <radialGradient
        id="radialGradient82"
        cx="510.519"
        cy="227.4"
        r="16.0989"
        fx="510.519"
        fy="227.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5721"
        fill="url(#radialGradient82)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 530.780029 225.77002 C 528.070007 225.299988 520.190002 226.910004 508.399994 227.089996 C 496.609985 227.279999 485.670013 225.109985 485.670013 225.109985 C 485.670013 225.109985 501.350006 230.200012 509.959991 229.640015 C 518.570007 229.070007 530.77002 225.77002 530.77002 225.77002 L 530.780029 225.77002 Z"
      />
      <linearGradient
        id="linearGradient168"
        x1="535.26"
        y1="230.84"
        x2="535.26"
        y2="223.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5722"
        fill="url(#linearGradient168)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 535.369995 223.960022 C 535.369995 223.960022 537.72998 226.880005 535.369995 230.850006 C 535.369995 230.850006 532.51001 226.970001 535.369995 223.960022 Z"
      />
      <linearGradient
        id="linearGradient169"
        x1="482.96"
        y1="264.39"
        x2="482.96"
        y2="245.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5723"
        fill="url(#linearGradient169)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 484.220001 264.390015 C 484.220001 264.390015 483.839996 248.589996 481.709991 245.119995 C 481.709991 245.119995 482.079987 257.630005 484.220001 264.390015 Z"
      />
      <radialGradient
        id="radialGradient83"
        cx="701.131"
        cy="288.16"
        r="13.8123"
        fx="701.131"
        fy="288.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5724"
        fill="url(#radialGradient83)"
        fillRule="evenodd"
        stroke="none"
        d="M 696.609985 308.700012 C 696.609985 308.700012 702.72998 281.51001 703.169983 263.850006 L 696.609985 263.850006 C 696.609985 263.850006 696.460022 293.98999 692.969971 308.700012 L 696.609985 308.700012 Z"
      />
      <radialGradient
        id="radialGradient84"
        cx="695.106"
        cy="288.16"
        r="13.7197"
        fx="695.106"
        fy="288.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5725"
        fill="url(#radialGradient84)"
        fillRule="evenodd"
        stroke="none"
        d="M 687.690002 268.459991 L 696.609985 263.850006 C 696.609985 263.850006 697.039978 292.839996 692.969971 308.700012 L 692.150024 308.700012 C 692.150024 308.700012 696.419983 285.799988 695.109985 266.839996 L 687.51001 271.769989 L 687.679993 268.450012 L 687.690002 268.459991 Z"
      />
      <path
        id="path5726"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 688.780029 270.959991 L 695.27002 269.779999 L 695.119995 266.850006 L 688.780029 270.959991 Z"
      />
      <radialGradient
        id="radialGradient85"
        cx="626.339"
        cy="288.16"
        r="13.8123"
        fx="626.339"
        fy="288.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5727"
        fill="url(#radialGradient85)"
        fillRule="evenodd"
        stroke="none"
        d="M 623.900024 308.049988 C 623.900024 308.049988 617.880005 281.51001 617.429993 263.850006 L 623.98999 263.850006 C 623.98999 263.850006 624.140015 293.98999 627.630005 308.700012 L 623.900024 308.049988 Z"
      />
      <radialGradient
        id="radialGradient86"
        cx="632.364"
        cy="288.16"
        r="13.7197"
        fx="632.364"
        fy="288.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5728"
        fill="url(#radialGradient86)"
        fillRule="evenodd"
        stroke="none"
        d="M 632.919983 268.459991 L 624 263.850006 C 624 263.850006 623.570007 292.839996 627.640015 308.700012 L 628.460022 308.700012 C 628.460022 308.700012 624.190002 285.799988 625.5 266.839996 L 633.099976 271.769989 L 632.929993 268.450012 L 632.919983 268.459991 Z"
      />
      <path
        id="path5729"
        fill="#5a3361"
        fillRule="evenodd"
        stroke="none"
        d="M 631.820007 270.959991 L 625.330017 269.779999 L 625.47998 266.850006 L 631.820007 270.959991 Z"
      />
      <radialGradient
        id="radialGradient87"
        cx="660.621"
        cy="247.19"
        r="43.0231"
        fx="660.621"
        fy="247.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5730"
        fill="url(#radialGradient87)"
        fillRule="evenodd"
        stroke="none"
        d="M 689.140015 197.02002 C 689.140015 197.02002 691.169983 258.540009 687.599976 296.059998 L 633.059998 297.369995 C 633.059998 297.369995 626.22998 228 625.73999 197.279999 L 689.140015 197.02002 Z"
      />
      <radialGradient
        id="radialGradient88"
        cx="644.234"
        cy="221.038"
        r="74.8913"
        fx="644.234"
        fy="221.038"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5731"
        fill="url(#radialGradient88)"
        fillRule="evenodd"
        stroke="none"
        d="M 686.219971 297.049988 C 686.219971 297.049988 690.650024 233.899994 689.140015 197.02002 C 689.140015 197.02002 659.710022 185.549988 625.73999 197.279999 C 625.73999 197.279999 629.169983 262.059998 635.119995 299.070007 L 686.219971 297.049988 Z"
      />
      <path
        id="path5732"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 662.869995 329.410004 L 679.159973 339.119995 C 679.159973 339.119995 680.359985 341.519989 680.640015 344.200012 L 679.179993 344.200012 C 679.179993 344.200012 678.25 342.029999 677.72998 341.380005 C 676.599976 339.959991 661.909973 336.329987 661.909973 336.329987 L 660.080017 329.410004 L 662.869995 329.410004 Z"
      />
      <radialGradient
        id="radialGradient89"
        cx="669.5"
        cy="336.8"
        r="7.18001"
        fx="669.5"
        fy="336.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5733"
        fill="url(#radialGradient89)"
        fillRule="evenodd"
        stroke="none"
        d="M 663.52002 329.410004 L 679.809998 339.119995 C 679.809998 339.119995 681.01001 341.519989 681.289978 344.200012 L 679.830017 344.200012 C 679.830017 344.200012 678.900024 342.029999 678.380005 341.380005 C 677.25 339.959991 662.559998 336.329987 662.559998 336.329987 L 662.320007 335.089996 L 663.530029 329.410004 L 663.52002 329.410004 Z"
      />
      <radialGradient
        id="radialGradient90"
        cx="686.353"
        cy="344.89"
        r="6.39629"
        fx="686.353"
        fy="344.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5734"
        fill="url(#radialGradient90)"
        stroke="none"
        d="M 681.599976 351.279999 C 684.47699 351.279999 686.809998 349.005005 686.809998 346.200012 C 686.809998 343.394012 684.47699 341.119995 681.599976 341.119995 C 678.723022 341.119995 676.390015 343.394012 676.390015 346.200012 C 676.390015 349.005005 678.723022 351.279999 681.599976 351.279999 Z"
      />
      <radialGradient
        id="radialGradient91"
        cx="682.958"
        cy="344.185"
        r="3.67201"
        fx="682.958"
        fy="344.185"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5735"
        fill="url(#radialGradient91)"
        stroke="none"
        d="M 683.400024 350.140015 C 685.062012 350.140015 686.409973 348.376007 686.409973 346.200012 C 686.409973 344.023987 685.062012 342.26001 683.400024 342.26001 C 681.737976 342.26001 680.390015 344.023987 680.390015 346.200012 C 680.390015 348.376007 681.737976 350.140015 683.400024 350.140015 Z"
      />
      <linearGradient
        id="linearGradient170"
        x1="699.72"
        y1="309.34"
        x2="621.4"
        y2="309.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#6e5f85" stopOpacity={1} />
        <stop offset={1} stopColor="#3f1f49" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5736"
        fill="url(#linearGradient170)"
        fillRule="evenodd"
        stroke="none"
        d="M 699.719971 308.910004 C 699.719971 308.910004 670.289978 314.359985 621.390015 307.890015 C 621.390015 307.890015 629.840027 307.299988 652.960022 307.890015 L 699.719971 308.910004 Z"
      />
      <radialGradient
        id="radialGradient92"
        cx="661.231"
        cy="306.94"
        r="27.8296"
        fx="661.231"
        fy="306.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5737"
        fill="url(#radialGradient92)"
        fillRule="evenodd"
        stroke="none"
        d="M 621.390015 304.970001 L 699.719971 304.970001 L 699.719971 308.910004 L 621.390015 307.890015 L 621.390015 304.970001 Z"
      />
      <radialGradient
        id="radialGradient93"
        cx="643.503"
        cy="293.422"
        r="19.9511"
        fx="643.503"
        fy="293.422"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5738"
        fill="url(#radialGradient93)"
        fillRule="evenodd"
        stroke="none"
        d="M 699.719971 304.970001 C 699.719971 304.970001 700.429993 298.899994 698.02002 296.859985 C 698.02002 296.859985 663.280029 292.549988 621.390015 299.420013 L 621.390015 304.980011 L 652.299988 304.959991 L 699.719971 304.980011 L 699.719971 304.970001 Z"
      />
      <g id="g250" opacity="0.5" style={{ mixBlendMode: 'screen' }}>
        <path
          id="path5739"
          fill="#41243f"
          fillRule="evenodd"
          stroke="none"
          d="M 621.390015 304.970001 L 621.390015 299.410004 C 650.700012 297.920013 668.359985 296.829987 698.02002 296.850006 C 698.02002 296.850006 700.549988 298.76001 699.719971 304.959991 L 621.390015 304.959991 L 621.390015 304.970001 Z"
        />
      </g>
      <path
        id="path5740"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 698.02002 296.850006 L 659.710022 297.579987 C 659.710022 297.579987 640.119995 297.51001 621.400024 299.399994 C 621.400024 299.399994 648.590027 292.399994 698.030029 296.839996 L 698.02002 296.850006 Z"
      />
      <path
        id="path5741"
        fill="#180b1c"
        fillRule="evenodd"
        stroke="none"
        d="M 673.75 310.299988 L 646.409973 310.299988 C 646.409973 310.299988 652.190002 314.339996 660.080017 314.339996 C 667.969971 314.339996 673.75 310.299988 673.75 310.299988 Z"
      />
      <radialGradient
        id="radialGradient94"
        cx="661.515"
        cy="312.408"
        r="4.2435"
        fx="661.515"
        fy="312.408"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#9f84a5" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5742"
        fill="url(#radialGradient94)"
        fillRule="evenodd"
        stroke="none"
        d="M 663.909973 314.130005 L 663.140015 327.359985 L 658.099976 327.359985 L 657.599976 314.100006 L 663.909973 314.130005 Z"
      />
      <radialGradient
        id="radialGradient95"
        cx="659.608"
        cy="321.422"
        r="11.4759"
        fx="659.608"
        fy="321.422"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5743"
        fill="url(#radialGradient95)"
        fillRule="evenodd"
        stroke="none"
        d="M 664.51001 322.170013 L 657 322.170013 L 657.75 336.019989 L 663.619995 336.019989 L 664.51001 322.170013 Z"
      />
      <radialGradient
        id="radialGradient96"
        cx="684.621"
        cy="336.49"
        r="16.2268"
        fx="684.621"
        fy="336.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5744"
        fill="url(#radialGradient96)"
        fillRule="evenodd"
        stroke="none"
        d="M 663.909973 329.100006 L 700.51001 338.809998 C 700.51001 338.809998 703.210022 341.209991 703.830017 343.890015 L 700.549988 343.890015 C 700.549988 343.890015 698.450012 341.720001 697.289978 341.070007 C 694.75 339.649994 661.73999 336.019989 661.73999 336.019989 L 661.200012 334.779999 L 663.909973 329.100006 Z"
      />
      <radialGradient
        id="radialGradient97"
        cx="706.312"
        cy="344.11"
        r="6.39629"
        fx="706.312"
        fy="344.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5745"
        fill="url(#radialGradient97)"
        fillRule="evenodd"
        stroke="none"
        d="M 695.349976 345.410004 C 695.349976 348.209991 697.679993 350.48999 700.559998 350.48999 C 703.440002 350.48999 705.77002 348.220001 705.77002 345.410004 C 705.77002 342.600006 703.440002 340.329987 700.559998 340.329987 C 697.679993 340.329987 695.349976 342.600006 695.349976 345.410004 Z"
      />
      <radialGradient
        id="radialGradient98"
        cx="697.862"
        cy="343.882"
        r="3.67201"
        fx="697.862"
        fy="343.882"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5746"
        fill="url(#radialGradient98)"
        fillRule="evenodd"
        stroke="none"
        d="M 696.030029 345.890015 C 696.030029 348.070007 697.380005 349.829987 699.039978 349.829987 C 700.700012 349.829987 702.049988 348.059998 702.049988 345.890015 C 702.049988 343.720001 700.700012 341.950012 699.039978 341.950012 C 697.380005 341.950012 696.030029 343.720001 696.030029 345.890015 Z"
      />
      <radialGradient
        id="radialGradient99"
        cx="644.816"
        cy="336.49"
        r="16.2268"
        fx="644.816"
        fy="336.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5747"
        fill="url(#radialGradient99)"
        fillRule="evenodd"
        stroke="none"
        d="M 657.369995 329.100006 L 620.77002 338.809998 C 620.77002 338.809998 618.070007 341.209991 617.450012 343.890015 L 620.72998 343.890015 C 620.72998 343.890015 622.830017 341.720001 623.98999 341.070007 C 626.530029 339.649994 659.539978 336.019989 659.539978 336.019989 L 660.080017 334.779999 L 657.369995 329.100006 Z"
      />
      <path
        id="path5748"
        fill="#714a6a"
        fillRule="evenodd"
        stroke="none"
        d="M 657.669983 329.100006 L 641.380005 338.809998 C 641.380005 338.809998 640.179993 341.209991 639.900024 343.890015 L 641.359985 343.890015 C 641.359985 343.890015 642.289978 341.720001 642.809998 341.070007 C 643.940002 339.649994 658.630005 336.019989 658.630005 336.019989 L 660.460022 329.100006 L 657.669983 329.100006 Z"
      />
      <radialGradient
        id="radialGradient100"
        cx="648.055"
        cy="336.49"
        r="7.18001"
        fx="648.055"
        fy="336.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5749"
        fill="url(#radialGradient100)"
        fillRule="evenodd"
        stroke="none"
        d="M 660.460022 329.100006 L 644.169983 338.809998 C 644.169983 338.809998 642.969971 341.209991 642.690002 343.890015 L 644.150024 343.890015 C 644.150024 343.890015 645.080017 341.720001 645.599976 341.070007 C 646.72998 339.649994 661.419983 336.019989 661.419983 336.019989 L 661.659973 334.779999 L 660.450012 329.100006 L 660.460022 329.100006 Z"
      />
      <radialGradient
        id="radialGradient101"
        cx="625.769"
        cy="344.11"
        r="6.39629"
        fx="625.769"
        fy="344.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5750"
        fill="url(#radialGradient101)"
        fillRule="evenodd"
        stroke="none"
        d="M 625.929993 345.410004 C 625.929993 348.209991 623.599976 350.48999 620.719971 350.48999 C 617.840027 350.48999 615.51001 348.220001 615.51001 345.410004 C 615.51001 342.600006 617.840027 340.329987 620.719971 340.329987 C 623.599976 340.329987 625.929993 342.600006 625.929993 345.410004 Z"
      />
      <radialGradient
        id="radialGradient102"
        cx="615.488"
        cy="343.882"
        r="3.67201"
        fx="615.488"
        fy="343.882"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b898b3" stopOpacity={1} />
        <stop offset={1} stopColor="#7d5885" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5751"
        fill="url(#radialGradient102)"
        fillRule="evenodd"
        stroke="none"
        d="M 625.26001 345.890015 C 625.26001 348.070007 623.909973 349.829987 622.25 349.829987 C 620.590027 349.829987 619.23999 348.059998 619.23999 345.890015 C 619.23999 343.720001 620.590027 341.950012 622.25 341.950012 C 623.909973 341.950012 625.26001 343.720001 625.26001 345.890015 Z"
      />
      <path
        id="path5752"
        fill="#482f54"
        fillRule="evenodd"
        stroke="none"
        d="M 641.380005 338.809998 L 644.169983 338.809998 C 644.169983 338.809998 642.950012 341.279999 642.690002 343.890015 L 639.900024 343.890015 C 639.900024 343.890015 640.22998 340.609985 641.380005 338.809998 Z"
      />
      <radialGradient
        id="radialGradient103"
        cx="647.502"
        cy="344.58"
        r="6.39629"
        fx="647.502"
        fy="344.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5753"
        fill="url(#radialGradient103)"
        fillRule="evenodd"
        stroke="none"
        d="M 647.580017 345.890015 C 647.580017 348.690002 645.25 350.970001 642.369995 350.970001 C 639.48999 350.970001 637.159973 348.700012 637.159973 345.890015 C 637.159973 343.079987 639.48999 340.809998 642.369995 340.809998 C 645.25 340.809998 647.580017 343.079987 647.580017 345.890015 Z"
      />
      <radialGradient
        id="radialGradient104"
        cx="637.071"
        cy="344.345"
        r="3.67201"
        fx="637.071"
        fy="344.345"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e5d9e3" stopOpacity={1} />
        <stop offset={1} stopColor="#8a6991" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5754"
        fill="url(#radialGradient104)"
        fillRule="evenodd"
        stroke="none"
        d="M 646.900024 346.359985 C 646.900024 348.540009 645.549988 350.299988 643.890015 350.299988 C 642.22998 350.299988 640.880005 348.529999 640.880005 346.359985 C 640.880005 344.190002 642.22998 342.420013 643.890015 342.420013 C 645.549988 342.420013 646.900024 344.190002 646.900024 346.359985 Z"
      />
      <path
        id="path5755"
        fill="#26132a"
        fillRule="evenodd"
        stroke="none"
        d="M 633.049988 224.539978 L 684 224.539978 C 684 224.539978 672.440002 227.27002 658.530029 227.27002 C 644.619995 227.27002 633.059998 224.539978 633.059998 224.539978 L 633.049988 224.539978 Z"
      />
      <radialGradient
        id="radialGradient105"
        cx="659.91"
        cy="196.39"
        r="21.012"
        fx="659.91"
        fy="196.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5756"
        fill="url(#radialGradient105)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 686.409973 197.029999 L 682.52002 199.76001 C 682.52002 199.76001 658.719971 193.720001 631.820007 199.76001 L 627.630005 197.27002 C 627.630005 197.27002 653.679993 187.880005 686.409973 197.029999 Z"
      />
      <linearGradient
        id="linearGradient171"
        x1="683.42"
        y1="213.76"
        x2="683.42"
        y2="202.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5757"
        fill="url(#linearGradient171)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 684 203.029999 C 686.539978 203.690002 686.940002 212.589996 684.880005 213.600006 C 682.820007 214.609985 683.330017 210.580017 681.650024 208.320007 C 679.969971 206.059998 680.159973 202.029999 684 203.039978 L 684 203.029999 Z"
      />
      <radialGradient
        id="radialGradient106"
        cx="660.446"
        cy="228.91"
        r="16.0989"
        fx="660.446"
        fy="228.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#7c7077" stopOpacity={1} />
        <stop offset={1} stopColor="#242235" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5758"
        fill="url(#radialGradient106)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 680.099976 227.279999 C 677.390015 226.809998 669.51001 228.419983 657.719971 228.600006 C 645.929993 228.789978 634.98999 226.619995 634.98999 226.619995 C 634.98999 226.619995 650.669983 231.710022 659.280029 231.149994 C 667.890015 230.580017 680.090027 227.279999 680.090027 227.279999 L 680.099976 227.279999 Z"
      />
      <linearGradient
        id="linearGradient172"
        x1="684.59"
        y1="232.35"
        x2="684.59"
        y2="225.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5759"
        fill="url(#linearGradient172)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 684.690002 225.460022 C 684.690002 225.460022 687.049988 228.380005 684.690002 232.350006 C 684.690002 232.350006 681.830017 228.470001 684.690002 225.460022 Z"
      />
      <linearGradient
        id="linearGradient173"
        x1="632.29"
        y1="265.89"
        x2="632.29"
        y2="246.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#242235" stopOpacity={1} />
        <stop offset={1} stopColor="#7c7077" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5760"
        fill="url(#linearGradient173)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.55"
        style={{ mixBlendMode: 'screen' }}
        d="M 633.539978 265.890015 C 633.539978 265.890015 633.159973 250.089996 631.030029 246.619995 C 631.030029 246.619995 631.400024 259.130005 633.539978 265.890015 Z"
      />
      <path
        id="path5761"
        fill="#f1f0f4"
        stroke="none"
        d="M 462.23999 213.01001 C 456.920013 216.890015 451.649994 220.940002 451.649994 220.940002 C 452.040009 222.059998 452.429993 223.160004 452.820007 224.22998 L 441.299988 247.360001 C 441.299988 247.360001 447.48999 246.279999 449.779999 245.210007 C 454.209991 243.139999 476.109985 231.529999 476.109985 231.529999 L 478.230011 230.640015 C 478.230011 230.640015 478.640015 223.48999 479.200012 221.77002 C 479.76001 220.039978 481.140015 203.830017 481.140015 203.830017 C 471.230011 205.98999 467.299988 209.309998 462.23999 213 L 462.23999 213.01001 Z"
      />
      <linearGradient
        id="linearGradient174"
        x1="493.91"
        y1="527.9"
        x2="495.04"
        y2="397.92"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5762"
        fill="url(#linearGradient174)"
        stroke="none"
        d="M 503.149994 349.779999 C 505.019989 335.899994 506.559998 324.279999 506.559998 324.279999 C 506.559998 324.309998 507.230011 324.329987 507.230011 324.359985 C 507.299988 318.529999 507.619995 312.690002 508.380005 306.959991 C 509 300.720001 506.380005 295.079987 506.100006 288.910004 C 498.589996 288.399994 491.350006 288.75 490.589996 291.880005 C 487.309998 305.369995 483.170013 340.079987 483.170013 341.540009 C 483.170013 342.059998 483.029999 347.380005 482.779999 354.299988 C 489.589996 352.869995 496.369995 351.359985 503.149994 349.799988 L 503.149994 349.779999 Z"
      />
      <linearGradient
        id="linearGradient175"
        x1="495.22"
        y1="554.15"
        x2="489.56"
        y2="340.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5763"
        fill="url(#linearGradient175)"
        stroke="none"
        d="M 488.140015 353.140015 C 489.98999 343.470001 491.700012 334.809998 491.700012 334.119995 C 491.700012 332.660004 497.880005 298.820007 501.160004 285.329987 C 502.790009 278.630005 476.929993 290.48999 476.929993 290.48999 L 476.829987 355.529999 C 480.600006 354.769989 484.369995 353.970001 488.140015 353.149994 L 488.140015 353.140015 Z"
      />
      <linearGradient
        id="linearGradient176"
        x1="520.74"
        y1="527.9"
        x2="519.62"
        y2="397.92"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5764"
        fill="url(#linearGradient176)"
        stroke="none"
        d="M 508.179993 324.359985 C 508.179993 324.359985 507.029999 322.540009 507.029999 322.519989 C 507.029999 322.519989 508.720001 333.809998 510.859985 347.98999 C 510.959991 347.970001 511.059998 347.940002 511.160004 347.920013 C 518.150024 346.279999 525 345.670013 531.710022 346.049988 C 531.630005 343.48999 531.590027 341.809998 531.590027 341.529999 C 531.590027 340.070007 527.450012 305.359985 524.169983 291.869995 C 523.409973 288.73999 516.169983 288.390015 508.660004 288.899994 C 508.380005 295.070007 505.76001 300.720001 506.380005 306.950012 C 507.140015 312.679993 508.119995 318.529999 508.190002 324.350006 L 508.179993 324.359985 Z"
      />
      <linearGradient
        id="linearGradient177"
        x1="519.41"
        y1="554.15"
        x2="525.07"
        y2="340.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5765"
        fill="url(#linearGradient177)"
        stroke="none"
        d="M 523.059998 334.119995 C 523.059998 334.630005 524 339.549988 525.23999 346 C 529.52002 345.839996 533.73999 346.070007 537.909973 346.690002 L 537.830017 290.48999 C 537.830017 290.48999 511.970001 278.630005 513.599976 285.329987 C 516.880005 298.820007 523.059998 332.670013 523.059998 334.119995 Z"
      />
      <path
        id="path5766"
        fill="#f1f0f4"
        stroke="none"
        d="M 564.599976 230.619995 C 564.599976 230.619995 546.799988 208.97998 539.809998 206.130005 C 539.809998 206.130005 535.75 220.359985 535.359985 222.130005 C 534.969971 223.899994 535.080017 233.559998 535.080017 233.559998 L 549.340027 247.509995 C 549.340027 247.509995 558.309998 238.779999 564.599976 230.609985 L 564.599976 230.619995 Z"
      />
      <path
        id="path5767"
        fill="#b5b4b8"
        stroke="none"
        d="M 494.970001 195.029999 C 494.970001 195.029999 496.51001 192.119995 505.76001 191.799988 C 511 191.619995 517.950012 192.880005 519.580017 195.029999 C 519.580017 195.029999 520.849976 204.23999 507.660004 204.22998 C 492.98999 204.22998 494.970001 195.029999 494.970001 195.029999 Z"
      />
      <linearGradient
        id="linearGradient178"
        x1="513.05"
        y1="213.95"
        x2="505.17"
        y2="194.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5768"
        fill="url(#linearGradient178)"
        stroke="none"
        d="M 492.100006 200.589996 C 492.100006 200.589996 495.619995 199.029999 497.420013 197.73999 L 497.910004 188.779999 L 517.320007 189.609985 C 517.320007 189.609985 517.859985 196.97998 518.02002 197.73999 C 518.179993 198.48999 523.469971 200.589996 523.469971 200.589996 C 523.469971 200.589996 518.309998 210.25 507.309998 210.77002 C 498.790009 211.169983 491.829987 203.600006 492.100006 200.589996 Z"
      />
      <path
        id="path5769"
        fill="#f1f0f4"
        stroke="none"
        d="M 539.039978 229.369995 C 539.840027 224.299988 539.809998 206.140015 539.809998 206.140015 C 534.309998 203.619995 520.099976 199.109985 520.099976 199.109985 C 520.099976 199.109985 518.23999 206.220001 510.480011 207.5 C 508.140015 206.789978 503.529999 206.27002 503.019989 206.27002 C 499.940002 205.359985 494.089996 199.539978 494.089996 199.539978 C 479.920013 203.929993 475.540009 206.140015 475.540009 206.140015 C 475.970001 207 474.73999 222.100006 475.950012 229.369995 C 475.950012 229.369995 477.690002 234.399994 477.679993 234.890015 C 477.390015 254.25 477.179993 280.399994 477.179993 309.190002 C 477.179993 310.329987 503.950012 310.359985 509.070007 309.959991 C 514.090027 309.570007 538.640015 309.850006 538.669983 308.200012 C 539.070007 282.820007 537.859985 259.559998 537.590027 234.890015 C 537.570007 233.419983 539.039978 229.369995 539.039978 229.369995 Z"
      />
      <linearGradient
        id="linearGradient179"
        x1="506.66"
        y1="241.57"
        x2="508.19"
        y2="206.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset="0.64" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5770"
        fill="url(#linearGradient179)"
        stroke="none"
        d="M 485.320007 217.97998 C 492.579987 213.710022 496.779999 215.039978 508.100006 215.359985 C 519.419983 215.679993 526.690002 213.440002 530.75 217.5 C 534.809998 221.559998 533.219971 238.380005 510.450012 239.929993 C 483.690002 241.75 478.049988 222.26001 485.320007 217.98999 L 485.320007 217.97998 Z"
      />
      <linearGradient
        id="linearGradient180"
        x1="541.1"
        y1="261.12"
        x2="528.94"
        y2="216.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e1e1e5" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5771"
        fill="url(#linearGradient180)"
        stroke="none"
        d="M 535.090027 226.830017 C 534.75 228.470001 535.080017 233.570007 534.539978 238.789993 C 534.22998 241.759995 538.179993 263.559998 538.179993 263.559998 C 538.179993 263.559998 538.179993 256.410004 537.75 236.179993 C 537.75 236.179993 535.289978 225.820007 535.090027 226.820007 L 535.090027 226.830017 Z"
      />
      <linearGradient
        id="linearGradient181"
        x1="474.42"
        y1="260.58"
        x2="486.36"
        y2="216.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e1e1e5" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5772"
        fill="url(#linearGradient181)"
        stroke="none"
        d="M 480.290009 226.890015 C 480.630005 228.529999 480.299988 233.630005 480.839996 238.850006 C 481.149994 241.820007 477.359985 263.01001 477.359985 263.01001 C 477.359985 263.01001 477.470001 251.029999 477.630005 235.799988 C 477.630005 235.799988 480.079987 225.890015 480.290009 226.890015 Z"
      />
      <linearGradient
        id="linearGradient182"
        x1="507.111"
        y1="213.356"
        x2="506.818"
        y2="208.814"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5773"
        fill="url(#linearGradient182)"
        stroke="none"
        d="M 508.380005 210.210022 C 508.410004 211.059998 507.790009 211.77002 506.980011 211.799988 C 506.170013 211.830017 505.48999 211.169983 505.459991 210.320007 C 505.429993 209.470001 506.049988 208.76001 506.859985 208.72998 C 507.670013 208.700012 508.350006 209.359985 508.380005 210.210022 Z"
      />
      <linearGradient
        id="linearGradient183"
        x1="460.16"
        y1="212.77"
        x2="450.5"
        y2="237.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5774"
        fill="url(#linearGradient183)"
        stroke="none"
        d="M 453.51001 219.450012 L 464.820007 211.119995 C 464.820007 211.119995 457.380005 225.22998 455.320007 231.26001 C 453.910004 235.399994 451.480011 243.25 444.779999 246.229996 L 453.5 219.450012 L 453.51001 219.450012 Z"
      />
      <path
        id="path5775"
        fill="#f7d4ab"
        stroke="none"
        d="M 436.730011 246.669998 C 437.070007 247.210007 437.480011 247.139999 438.190002 247.229996 C 438.899994 247.320007 443.600006 248.029999 447.049988 245.100006 C 450.51001 242.169998 451.660004 236.130005 452.01001 231.440002 C 452.359985 226.75 455.559998 217 455.910004 215.940002 C 456.26001 214.880005 458.299988 210.529999 458.390015 210.27002 C 458.480011 210 447.48999 209.289978 447.48999 209.289978 C 447.48999 209.289978 446.059998 215.100006 445.059998 216.850006 C 443.859985 218.950012 442.649994 220 437.820007 229.149994 C 437.209991 230.309998 434.76001 243.570007 436.709991 246.669998 L 436.730011 246.669998 Z"
      />
      <linearGradient
        id="linearGradient184"
        x1="448.97"
        y1="225.42"
        x2="448.42"
        y2="219.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5776"
        fill="url(#linearGradient184)"
        stroke="none"
        d="M 440.850006 217.589996 C 440.850006 217.589996 440.649994 217.049988 443.529999 216.660004 C 445.820007 216.350006 453.519989 216.5 455.769989 218.470001 C 455.769989 218.470001 448.209991 224.359985 443.269989 221.470001 C 441 220.149994 440.850006 217.589996 440.850006 217.589996 Z"
      />
      <path
        id="path5777"
        fill="#f7d4ab"
        stroke="none"
        d="M 459.23999 208.26001 C 459.329987 207.97998 447.75 207.22998 447.75 207.22998 C 447.75 207.22998 446.559998 212.210022 445.76001 214.649994 C 445.329987 215.97998 444.839996 217.220001 444.019989 218.48999 C 447.609985 220.27002 450.920013 221.169983 454.799988 219.839996 C 455.609985 217.049988 456.459991 214.720001 456.619995 214.22998 C 456.98999 213.109985 459.140015 208.529999 459.230011 208.25 L 459.23999 208.26001 Z"
      />
      <path
        id="path5778"
        fill="#f7d4ab"
        stroke="none"
        d="M 464.079987 192.070007 C 464.079987 192.070007 462.920013 182.539978 462.839996 182.149994 C 461.959991 177.710022 461.820007 171.380005 460.170013 171.380005 C 458.519989 171.380005 458.570007 173.850006 458.980011 177.179993 C 459.390015 180.51001 459.26001 187.919983 459.26001 187.919983 L 447.859985 193.77002 C 447.859985 193.77002 447.100006 194.539978 447.070007 195.070007 C 447.040009 195.600006 448.23999 199.859985 448.079987 200.470001 C 447.920013 201.080017 447.839996 204.690002 447.959991 205.640015 C 448.079987 206.589996 446.709991 211.029999 446.709991 211.029999 L 455.179993 213.919983 L 464.070007 192.070007 L 464.079987 192.070007 Z"
      />
      <linearGradient
        id="linearGradient185"
        x1="459.37"
        y1="175.947"
        x2="475.325"
        y2="203.691"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5779"
        fill="url(#linearGradient185)"
        stroke="none"
        d="M 460.359985 171.410004 C 460.359985 171.410004 461.100006 171.470001 461.670013 173.27002 C 462.220001 175 463.950012 191.140015 463.950012 191.140015 C 463.950012 191.140015 461.529999 176.589996 461.339996 175.02002 C 461.040009 172.570007 460.359985 171.419983 460.359985 171.419983 L 460.359985 171.410004 Z"
      />
      <linearGradient
        id="linearGradient186"
        x1="459.985"
        y1="187.916"
        x2="465.457"
        y2="197.445"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5780"
        fill="url(#linearGradient186)"
        stroke="none"
        d="M 457.619995 188.76001 L 464.040009 191.720001 L 463.820007 189.910004 L 458.380005 187.5 L 457.619995 188.76001 Z"
      />
      <linearGradient
        id="linearGradient187"
        x1="459.37"
        y1="182.692"
        x2="456.088"
        y2="202.403"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5781"
        fill="url(#linearGradient187)"
        stroke="none"
        d="M 454.480011 206.830017 C 454.480011 206.830017 459.709991 200.700012 461.579987 199.359985 C 463.450012 198.01001 460.519989 192.630005 460.519989 192.630005 L 457.089996 190.25 L 450.940002 200.640015 C 450.940002 200.640015 453.640015 204.440002 454.480011 206.839996 L 454.480011 206.830017 Z"
      />
      <path
        id="path5782"
        fill="#f7d4ab"
        stroke="none"
        d="M 455.839996 216.600006 C 455.839996 216.600006 459.059998 209.299988 459.149994 209.169983 C 459.23999 209.039978 465.25 200.350006 465.170013 200.029999 C 465.089996 199.710022 465.029999 191.839996 464.450012 191.539978 C 463.869995 191.23999 459.190002 188.910004 458.869995 189.109985 C 458.549988 189.309998 458.179993 190.789978 458.179993 191.380005 C 458.179993 191.970001 460.959991 194.460022 460.959991 194.460022 C 460.959991 194.460022 460.359985 196.809998 460.390015 197.75 C 460.390015 197.75 456.320007 200.600006 454.619995 201.960022 C 452.929993 203.320007 453.76001 208.72998 453.76001 208.72998 L 452.100006 215.119995 L 455.820007 216.589996 L 455.839996 216.600006 Z"
      />
      <linearGradient
        id="linearGradient188"
        x1="444.852"
        y1="197.927"
        x2="458.316"
        y2="221.332"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5783"
        fill="url(#linearGradient188)"
        stroke="none"
        d="M 448.089996 192.720001 C 448.089996 192.720001 447.220001 194.25 447.079987 195.070007 C 446.940002 195.890015 447.529999 199.830017 447.609985 200.589996 C 447.690002 201.350006 447.910004 205.25 447.779999 205.839996 C 447.640015 206.440002 446.549988 211.98999 446.549988 211.98999 C 446.549988 211.98999 449.630005 207.460022 449.720001 207.330017 C 449.809998 207.200012 448.119995 203 448.790009 201.619995 C 449.459991 200.23999 450.549988 199.080017 450.549988 199.080017 L 448.100006 192.710022 L 448.089996 192.720001 Z"
      />
      <linearGradient
        id="linearGradient189"
        x1="457.301"
        y1="175.7"
        x2="468.88"
        y2="195.825"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5784"
        fill="url(#linearGradient189)"
        stroke="none"
        d="M 459.559998 171.529999 C 459.559998 171.529999 458.690002 171.919983 458.640015 173.27002 C 458.619995 173.789978 458.859985 176.660004 458.980011 178.580017 C 459.23999 182.820007 459.269989 187.5 459.269989 187.5 C 459.269989 187.5 460.059998 182.830017 459.359985 177.799988 C 458.98999 175.130005 458.910004 173.880005 459.01001 172.98999 C 459.130005 171.880005 459.549988 171.539978 459.549988 171.539978 L 459.559998 171.529999 Z"
      />
      <linearGradient
        id="linearGradient190"
        x1="458.793"
        y1="192.22"
        x2="466.631"
        y2="205.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5785"
        fill="url(#linearGradient190)"
        stroke="none"
        d="M 458.290009 190.570007 C 458.290009 190.570007 458.01001 192.070007 458.359985 192.72998 C 458.709991 193.390015 460.390015 194.899994 460.390015 194.899994 L 460.390015 197.76001 L 460.959991 199.73999 C 460.959991 199.73999 461.079987 195.789978 462 194.330017 C 462 194.330017 459.119995 193.339996 458.290009 190.570007 Z"
      />
      <linearGradient
        id="linearGradient191"
        x1="459.701"
        y1="194.378"
        x2="471.654"
        y2="215.154"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5786"
        fill="url(#linearGradient191)"
        stroke="none"
        d="M 461.75 190.22998 C 461.75 190.22998 464.429993 191.309998 464.730011 191.720001 C 465.130005 192.27002 465.230011 199.830017 465.269989 200.100006 C 465.299988 200.369995 460.429993 207.299988 460.429993 207.299988 C 460.429993 207.299988 463.790009 200.669983 463.809998 200 C 463.829987 199.330017 463.649994 192.26001 463.410004 191.899994 C 463.179993 191.529999 461.75 190.220001 461.75 190.220001 L 461.75 190.22998 Z"
      />
      <linearGradient
        id="linearGradient192"
        x1="451.542"
        y1="190.72"
        x2="450.029"
        y2="199.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5787"
        fill="url(#linearGradient192)"
        stroke="none"
        d="M 448.369995 193.890015 C 448.369995 193.890015 449.529999 200.179993 450.359985 201.51001 C 450.720001 202.089996 451.339996 202.399994 452.209991 202.220001 L 448.380005 193.899994 L 448.369995 193.890015 Z"
      />
      <path
        id="path5788"
        fill="#f7d4ab"
        stroke="none"
        d="M 448.179993 193.130005 C 448.299988 193.830017 450.350006 200.450012 450.450012 200.929993 C 450.709991 202.22998 453.820007 202.100006 453.380005 200.339996 C 452.649994 197.460022 451.070007 191.320007 451.070007 191.320007 C 451.070007 191.320007 449.640015 191.140015 448.709991 191.929993 C 448.390015 192.210022 448.100006 192.720001 448.100006 192.720001 C 448.100006 192.720001 448.149994 192.929993 448.190002 193.130005 L 448.179993 193.130005 Z"
      />
      <path
        id="path5789"
        fill="#ffdebd"
        stroke="none"
        d="M 451.579987 198.73999 C 451.209991 198.799988 450.73999 199.070007 450.73999 199.410004 C 450.73999 200.02002 450.820007 201.01001 451.160004 201.320007 C 451.480011 201.600006 452.470001 201.529999 452.720001 200.950012 C 452.820007 200.720001 452.790009 199.410004 452.350006 199.02002 C 452.170013 198.859985 451.820007 198.700012 451.570007 198.73999 L 451.579987 198.73999 Z"
      />
      <linearGradient
        id="linearGradient193"
        x1="450.182"
        y1="193.347"
        x2="458.672"
        y2="208.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5790"
        fill="url(#linearGradient193)"
        stroke="none"
        d="M 451.059998 191.320007 C 450.73999 191.220001 450 191.359985 450 191.359985 C 450 191.359985 451.25 199.47998 451.940002 200.220001 C 452.630005 200.960022 453.369995 201 453.369995 201 C 453.369995 201 453.48999 200.710022 453.48999 200.380005 C 453.070007 198.26001 451.440002 191.429993 451.070007 191.320007 L 451.059998 191.320007 Z"
      />
      <path
        id="path5791"
        fill="#f7d4ab"
        stroke="none"
        d="M 451.26001 188.339996 C 451.480011 187.880005 453.75 186.76001 454.350006 188.140015 C 454.959991 189.529999 455.140015 198.899994 455.100006 199.549988 C 455.029999 200.690002 452.899994 201.369995 452.179993 200.140015 C 451.119995 198.330017 450.799988 189.289978 451.25 188.339996 L 451.26001 188.339996 Z"
      />
      <path
        id="path5792"
        fill="#ffdebd"
        stroke="none"
        d="M 461.25 190 C 461.589996 190.149994 460.890015 191.589996 460.040009 191.390015 C 459.630005 191.289978 457.390015 189.869995 457.589996 189.52002 C 457.779999 189.179993 457.75 188.720001 458.579987 188.850006 C 459.420013 188.97998 460.910004 189.850006 461.25 190 Z"
      />
      <linearGradient
        id="linearGradient194"
        x1="452.887"
        y1="189.721"
        x2="460.95"
        y2="203.729"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5793"
        fill="url(#linearGradient194)"
        stroke="none"
        d="M 453.339996 187.47998 C 453.339996 187.47998 454.089996 187.470001 454.470001 188.070007 C 454.869995 188.690002 455.070007 197.48999 455.070007 197.48999 C 455.070007 197.48999 454.350006 197.029999 453.880005 196.149994 C 453.420013 195.27002 453.329987 187.48999 453.329987 187.48999 L 453.339996 187.47998 Z"
      />
      <path
        id="path5794"
        fill="#f7d4ab"
        stroke="none"
        d="M 459.269989 187.919983 C 459.269989 187.919983 458.179993 191.830017 458.140015 192.190002 C 458.100006 192.549988 457.619995 195.700012 457.140015 196.299988 C 456.660004 196.899994 455.130005 197.339996 454.410004 196.330017 C 453.690002 195.320007 454.299988 190.100006 454.299988 190.100006 C 454.299988 190.100006 454.279999 185.059998 455.179993 184.130005 C 455.730011 183.559998 458.26001 183.580017 458.579987 184.919983 C 458.910004 186.25 459.279999 187.919983 459.279999 187.919983 L 459.269989 187.919983 Z"
      />
      <linearGradient
        id="linearGradient195"
        x1="456.022"
        y1="184.206"
        x2="458.777"
        y2="188.982"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5795"
        fill="url(#linearGradient195)"
        stroke="none"
        d="M 458.769989 185.720001 C 458.769989 185.720001 458.519989 184.029999 458.140015 183.899994 C 457.320007 183.600006 455.410004 183.700012 455.109985 184.109985 C 454.609985 184.799988 454.559998 186.02002 454.559998 186.02002 C 454.559998 186.02002 455.079987 184.390015 455.619995 184.350006 C 456.160004 184.309998 457.380005 184.140015 457.940002 184.339996 C 458.190002 184.429993 458.769989 185.72998 458.769989 185.72998 L 458.769989 185.720001 Z"
      />
      <path
        id="path5796"
        fill="#ffdebd"
        stroke="none"
        d="M 456.029999 193.529999 C 455.549988 193.470001 454.859985 193.47998 454.73999 193.910004 C 454.529999 194.690002 454.320007 195.660004 454.649994 196.169983 C 454.959991 196.649994 456.619995 197.039978 456.850006 196.25 C 456.940002 195.940002 457.320007 194.660004 456.899994 194.02002 C 456.720001 193.75 456.350006 193.570007 456.029999 193.529999 Z"
      />
      <path
        id="path5797"
        fill="#ffdebd"
        stroke="none"
        d="M 453.5 197.320007 C 453.019989 197.299988 452.329987 197.350006 452.25 197.789978 C 452.100006 198.580017 451.959991 199.559998 452.329987 200.039978 C 452.670013 200.48999 454.350006 200.75 454.519989 199.960022 C 454.589996 199.640015 454.869995 198.350006 454.399994 197.73999 C 454.200012 197.47998 453.820007 197.330017 453.5 197.320007 Z"
      />
      <linearGradient
        id="linearGradient196"
        x1="459.943"
        y1="201.019"
        x2="454.954"
        y2="208.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5798"
        fill="url(#linearGradient196)"
        stroke="none"
        d="M 460.899994 201.890015 C 461.179993 203.100006 459.75 208.619995 455.779999 208.47998 C 451.809998 208.339996 455.410004 203 456.700012 202.190002 C 457.98999 201.380005 460.339996 199.460022 460.899994 201.899994 L 460.899994 201.890015 Z"
      />
      <linearGradient
        id="linearGradient197"
        x1="457.333"
        y1="210.243"
        x2="462.087"
        y2="218.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5799"
        fill="url(#linearGradient197)"
        stroke="none"
        d="M 460.429993 207.309998 C 460.429993 207.309998 457.390015 210.839996 456.369995 211.049988 C 455.350006 211.26001 455.940002 216.380005 455.940002 216.380005 C 455.940002 216.380005 457.429993 212.950012 457.950012 211.850006 C 458.450012 210.799988 460.429993 207.309998 460.429993 207.309998 Z"
      />
      <linearGradient
        id="linearGradient198"
        x1="458.07"
        y1="191.55"
        x2="459.36"
        y2="185.53"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5800"
        fill="url(#linearGradient198)"
        stroke="none"
        d="M 458.160004 192.080017 L 459.269989 187.919983 L 458.839996 186.02002 L 458.160004 192.080017 Z"
      />
      <linearGradient
        id="linearGradient199"
        x1="466.6"
        y1="218.56"
        x2="443.03"
        y2="219.64"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5801"
        fill="url(#linearGradient199)"
        stroke="none"
        d="M 443.040009 219.98999 L 444.029999 218.5 C 444.029999 218.5 446.029999 218.970001 449.100006 218.710022 C 450.720001 218.570007 454.399994 217.839996 455.690002 217 L 454.410004 221.200012 L 443.040009 220 L 443.040009 219.98999 Z"
      />
      <path
        id="path5802"
        fill="#f1f0f4"
        stroke="none"
        d="M 440.850006 217.589996 C 440.850006 217.589996 440.640015 219.350006 446.339996 219.600006 C 452.549988 219.869995 454.299988 219.080017 455.769989 218.460022 C 455.769989 218.460022 452.369995 235.809998 451.950012 237.919998 C 451.529999 240.029999 448.940002 249.300003 436.799988 247.139999 C 436.799988 247.139999 435.109985 238.649994 436.799988 232.26001 C 438.48999 225.869995 439.929993 219.73999 440.850006 217.580017 L 440.850006 217.589996 Z"
      />
      <linearGradient
        id="linearGradient200"
        x1="439.54"
        y1="263.11"
        x2="436.8"
        y2="209.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5803"
        fill="url(#linearGradient200)"
        stroke="none"
        d="M 440.850006 217.589996 C 440.850006 217.589996 438.630005 224.779999 436.410004 230.169983 C 435.350006 232.76001 434.350006 242.25 435.160004 245.479996 C 435.5 246.839996 436.799988 247.149994 436.799988 247.149994 C 436.799988 247.149994 435.950012 244.169998 438.299988 231.26001 C 438.809998 228.440002 440.850006 217.589996 440.850006 217.589996 Z"
      />
      <linearGradient
        id="linearGradient201"
        x1="448.75"
        y1="215.4"
        x2="431.31"
        y2="255.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5804"
        fill="url(#linearGradient201)"
        stroke="none"
        d="M 438.790009 240.929993 C 440.350006 244.289993 442.950012 241.429993 444.070007 239.669998 C 445.190002 237.910004 451.959991 219.48999 451.959991 219.48999 C 451.959991 219.48999 444.089996 220.25 441.459991 218.5 C 441.459991 218.5 436.940002 236.940002 438.790009 240.929993 Z"
      />
      <linearGradient
        id="linearGradient202"
        x1="504.848"
        y1="210.105"
        x2="507.766"
        y2="209.987"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset="0.64" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5805"
        fill="url(#linearGradient202)"
        stroke="none"
        d="M 507.779999 209.98999 C 507.809998 210.839996 507.190002 211.549988 506.380005 211.580017 C 505.570007 211.609985 504.890015 210.950012 504.859985 210.100006 C 504.829987 209.25 505.450012 208.539978 506.26001 208.51001 C 507.070007 208.47998 507.75 209.140015 507.779999 209.98999 Z"
      />
      <linearGradient
        id="linearGradient203"
        x1="522.023"
        y1="189.59"
        x2="520.994"
        y2="196.093"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5806"
        fill="url(#linearGradient203)"
        stroke="none"
        d="M 495.799988 198.01001 C 495.799988 198.01001 503.299988 199.76001 503.929993 200.460022 C 504.559998 201.160004 504.790009 206.190002 504.790009 206.190002 L 509.679993 206.27002 C 509.679993 206.27002 509.910004 202.089996 511.480011 201.149994 C 511.839996 200.929993 516.640015 198.799988 518.349976 197.289978 C 518.349976 197.289978 510.829987 204.690002 510.480011 207.5 C 507.980011 206.529999 503.019989 206.27002 503.019989 206.27002 L 495.809998 198.01001 L 495.799988 198.01001 Z"
      />
      <linearGradient
        id="linearGradient204"
        x1="481.31"
        y1="238.03"
        x2="435.67"
        y2="252.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e1e1e5" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5807"
        fill="url(#linearGradient204)"
        stroke="none"
        d="M 480.339996 238.020004 C 479.369995 228.72998 478.320007 222.940002 478.320007 222.940002 C 478.320007 222.940002 467.399994 232.72998 456.230011 239.479996 C 447.73999 244.610001 438.829987 247.220001 436.049988 246.820007 C 436.049988 246.820007 438.230011 247.910004 442.790009 247.910004 C 443.809998 247.910004 447.119995 247.300003 450.019989 245.990005 C 451.140015 245.479996 476.01001 231.830017 476.130005 231.830017 C 476.899994 231.830017 478.070007 255.110001 478.070007 255.110001 C 478.070007 255.110001 480.570007 240.279999 480.339996 238.009995 L 480.339996 238.020004 Z"
      />
      <linearGradient
        id="linearGradient205"
        x1="506.761"
        y1="195.506"
        x2="506.844"
        y2="230.791"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5808"
        fill="url(#linearGradient205)"
        stroke="none"
        d="M 503.019989 206.27002 C 504.5 206.27002 508.48999 206.130005 510.290009 207.320007 C 512.090027 208.52002 504.980011 232.029999 504.980011 232.029999 C 504.980011 232.029999 510.170013 208.789978 509.579987 207.799988 C 509.040009 206.880005 503.690002 206.48999 503.029999 206.27002 L 503.019989 206.27002 Z"
      />
      <linearGradient
        id="linearGradient206"
        x1="477.9"
        y1="247.12"
        x2="488.85"
        y2="205.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d1d0d4" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5809"
        fill="url(#linearGradient206)"
        stroke="none"
        d="M 485.950012 217.97998 L 477.51001 253.449997 L 477.549988 243.630005 L 485.950012 217.97998 Z"
      />
      <linearGradient
        id="linearGradient207"
        x1="503.252"
        y1="209.969"
        x2="511.523"
        y2="219.273"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset="0.64" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5810"
        fill="url(#linearGradient207)"
        stroke="none"
        d="M 505.089996 206.589996 C 505.089996 206.589996 509.25 206.839996 509.570007 207.799988 C 509.850006 208.640015 509.480011 213.700012 506.850006 223.339996 C 506.850006 223.339996 509.339996 209.609985 508.130005 208.440002 C 506.920013 207.27002 505.079987 206.580017 505.079987 206.580017 L 505.089996 206.589996 Z"
      />
      <path
        id="path5811"
        fill="#333333"
        stroke="none"
        d="M 476.100006 355.670013 C 487.829987 353.309998 499.5 350.660004 511.149994 347.920013 C 521.950012 345.380005 532.409973 345.299988 542.530029 347.540009 L 538.059998 250.5 L 529.359985 221.460022 L 485.070007 221.460022 L 477.429993 250.649994 L 471.209991 357.109985 C 472.799988 356.559998 474.420013 356.070007 476.100006 355.670013 Z"
      />
      <linearGradient
        id="linearGradient208"
        x1="537.51"
        y1="247.62"
        x2="526.3"
        y2="204.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d1d0d4" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5812"
        fill="url(#linearGradient208)"
        stroke="none"
        d="M 528.51001 217.97998 L 538.130005 254.039993 L 537.919983 244.429993 L 528.51001 217.97998 Z"
      />
      <linearGradient
        id="linearGradient209"
        x1="507.96"
        y1="250.17"
        x2="505.11"
        y2="216.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset="0.75" stopColor="#3b3b3b" stopOpacity={1} />
        <stop offset={1} stopColor="#3f3f3f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5813"
        fill="url(#linearGradient209)"
        stroke="none"
        d="M 518.210022 228.23999 C 527.200012 229.309998 528.340027 238.179993 528.159973 241.169998 C 527.97998 244.160004 518.359985 253.649994 506.579987 252.789993 C 494.799988 251.929993 487.720001 246.990005 486.309998 241.610001 C 485.190002 237.339996 486.290009 230.070007 496.170013 228.710022 C 499.200012 228.289978 514.109985 227.75 518.219971 228.22998 L 518.210022 228.23999 Z"
      />
      <linearGradient
        id="linearGradient210"
        x1="535.21"
        y1="222.4"
        x2="535.42"
        y2="302.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5814"
        fill="url(#linearGradient210)"
        stroke="none"
        d="M 529.840027 223.049988 L 538.359985 250.509995 L 540.809998 310.190002 L 529.840027 223.049988 Z"
      />
      <linearGradient
        id="linearGradient211"
        x1="479.32"
        y1="222.36"
        x2="479.53"
        y2="298.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5815"
        fill="url(#linearGradient211)"
        stroke="none"
        d="M 484.679993 222.950012 L 477.429993 250.649994 L 474.190002 306.140015 L 484.679993 222.950012 Z"
      />
      <path
        id="path5816"
        fill="#f1f0f5"
        stroke="none"
        d="M 510.480011 207.5 C 510.480011 207.5 510.779999 201.929993 512.429993 201.369995 C 512.659973 201.289978 519.390015 197.890015 519.590027 195.02002 L 521.349976 200.77002 C 521.349976 200.77002 519.090027 206.77002 510.480011 207.48999 L 510.480011 207.5 Z"
      />
      <linearGradient
        id="linearGradient212"
        x1="515.53"
        y1="180.41"
        x2="515.715"
        y2="262.909"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5817"
        fill="url(#linearGradient212)"
        stroke="none"
        d="M 510.480011 207.5 C 510.480011 207.5 516.799988 207.660004 520.719971 201.960022 C 520.719971 201.960022 516.640015 206.390015 510.480011 207.5 Z"
      />
      <path
        id="path5818"
        fill="#f1f0f5"
        stroke="none"
        d="M 503.140015 207.179993 C 503.140015 207.179993 502.839996 201.609985 501.190002 201.049988 C 500.959991 200.970001 494.480011 199 494.970001 195.029999 L 493 202.039978 C 493 202.039978 494.880005 207.23999 503.140015 207.179993 Z"
      />
      <linearGradient
        id="linearGradient213"
        x1="498.922"
        y1="182.259"
        x2="498.759"
        y2="258.244"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5819"
        fill="url(#linearGradient213)"
        stroke="none"
        d="M 503.140015 207.179993 C 503.140015 207.179993 495.690002 208.169983 494.480011 202.140015 C 494.480011 202.140015 496.470001 206.73999 503.140015 207.179993 Z"
      />
      <linearGradient
        id="linearGradient214"
        x1="525.52"
        y1="219.26"
        x2="523.81"
        y2="196.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5820"
        fill="url(#linearGradient214)"
        stroke="none"
        d="M 529.369995 221.460022 C 529.369995 221.460022 524.22998 197.98999 520.169983 196.910004 L 520.619995 198.369995 C 520.619995 198.369995 523.330017 203.130005 526.429993 221.460022 L 529.380005 221.460022 L 529.369995 221.460022 Z"
      />
      <linearGradient
        id="linearGradient215"
        x1="513.37"
        y1="200.553"
        x2="515.551"
        y2="202.997"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset="0.64" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5821"
        fill="url(#linearGradient215)"
        stroke="none"
        d="M 510.480011 207.5 C 510.480011 207.5 510.649994 201.859985 512.099976 201.309998 C 513.27002 200.859985 516.640015 199.029999 518.940002 196.580017 C 518.940002 196.580017 516.969971 199.98999 514.080017 201.51001 C 512.159973 202.52002 510.579987 206.710022 510.48999 207.5 L 510.480011 207.5 Z"
      />
      <linearGradient
        id="linearGradient216"
        x1="496.933"
        y1="197.974"
        x2="504.229"
        y2="206.176"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset="0.64" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5822"
        fill="url(#linearGradient216)"
        stroke="none"
        d="M 495.660004 197.570007 C 495.660004 197.570007 496.480011 198.799988 499.109985 199.940002 C 501.170013 200.830017 502.279999 200.320007 502.869995 203.73999 C 503.269989 206.070007 503.019989 207.179993 503.019989 207.179993 C 503.019989 207.179993 502.339996 203.649994 501.179993 201.970001 C 500.410004 200.850006 496.089996 199.77002 495.660004 197.570007 Z"
      />
      <path
        id="path5823"
        fill="#f7d4ab"
        stroke="none"
        d="M 547.47998 268.51001 C 547.47998 268.51001 545.01001 271.920013 543.940002 272.529999 C 542.869995 273.140015 536.330017 274.529999 535.530029 274.700012 C 534.73999 274.869995 530.51001 275.980011 528.940002 276.940002 C 527.380005 277.899994 524.580017 279.959991 523.719971 280.980011 C 523.23999 281.549988 522.960022 282.140015 523.609985 282.730011 C 524.26001 283.320007 525.320007 282.98999 526.340027 282.109985 C 526.960022 281.570007 529.659973 280.350006 530.960022 279.839996 C 532.25 279.329987 534.299988 279.290009 534.719971 279.459991 C 535.619995 279.839996 532.150024 282.429993 530.950012 283.809998 C 529.780029 285.170013 527.679993 287.190002 527.080017 287.839996 C 526.47998 288.48999 525.090027 290.089996 526.179993 291.040009 C 527.27002 291.98999 529.51001 289.339996 531 288.269989 C 532.640015 287.100006 536.469971 282.880005 537.799988 282.410004 C 538.830017 282.040009 535.419983 285.519989 534.51001 286.380005 C 533.599976 287.23999 529.700012 290.899994 529.700012 290.899994 C 529.700012 290.899994 528.440002 292.230011 529.349976 293.109985 C 530.619995 294.339996 532.349976 292.220001 533.640015 291.130005 C 534.530029 290.369995 538.210022 287.329987 538.549988 287.049988 C 538.890015 286.769989 540.419983 285.279999 540.789978 285.429993 C 541.710022 285.820007 537.929993 289.450012 537.590027 289.850006 C 536.580017 291 535.77002 291.980011 535.650024 292.529999 C 535.429993 293.589996 536.23999 293.790009 537.049988 293.390015 C 537.859985 292.98999 539.359985 291.869995 539.630005 291.51001 C 539.900024 291.140015 545.01001 286.070007 546.299988 284.690002 C 547.590027 283.309998 551.400024 280.570007 552.150024 277.380005 C 552.5 275.890015 553.919983 274.959991 553.580017 274.619995 L 547.47998 268.51001 Z"
      />
      <linearGradient
        id="linearGradient217"
        x1="534.55"
        y1="288.31"
        x2="529.14"
        y2="293.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5824"
        fill="url(#linearGradient217)"
        stroke="none"
        d="M 529.539978 291.5 C 529.830017 291.100006 532.369995 289.01001 532.76001 288.670013 C 533.73999 287.820007 536.27002 287.98999 534.119995 290.220001 C 531.530029 292.899994 530.400024 293.399994 530.090027 293.329987 C 529.780029 293.26001 528.75 292.630005 529.549988 291.51001 L 529.539978 291.5 Z"
      />
      <path
        id="path5825"
        fill="#ffdebd"
        stroke="none"
        d="M 531.590027 291.329987 C 531.390015 290.869995 530.809998 290.75 530.309998 291.119995 C 530.090027 291.279999 529.330017 291.890015 529.280029 292.269989 C 529.210022 292.779999 529.76001 293.160004 529.849976 293.170013 C 530 293.179993 530.380005 293.450012 530.840027 292.929993 C 531.289978 292.410004 531.809998 291.839996 531.590027 291.329987 Z"
      />
      <linearGradient
        id="linearGradient218"
        x1="590.77"
        y1="239.6"
        x2="539.53"
        y2="281.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5826"
        fill="url(#linearGradient218)"
        stroke="none"
        d="M 551.25 275.779999 C 552.47998 276.450012 546.940002 284.540009 545.640015 284.269989 C 544.700012 284.070007 537.030029 274.730011 538.049988 274.470001 C 540.039978 273.959991 545 272.570007 545 272.570007 C 544.820007 274.619995 550.309998 275.279999 551.25 275.790009 L 551.25 275.779999 Z"
      />
      <linearGradient
        id="linearGradient219"
        x1="541.71"
        y1="277.82"
        x2="541.49"
        y2="261.73"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5827"
        fill="url(#linearGradient219)"
        stroke="none"
        d="M 543.640015 272.649994 C 540.799988 273.75 535.460022 274.559998 533.27002 275.299988 C 533.27002 275.299988 540.880005 275.100006 544 274.049988 C 545.940002 273.399994 550.409973 264.079987 549.880005 263.73999 C 546.950012 268.51001 543.640015 272.649994 543.640015 272.649994 Z"
      />
      <linearGradient
        id="linearGradient220"
        x1="552.95"
        y1="267.97"
        x2="522.19"
        y2="286.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5828"
        fill="url(#linearGradient220)"
        stroke="none"
        d="M 523.609985 282.73999 C 523.609985 282.73999 524.880005 283.420013 527.559998 281.049988 C 530.080017 278.820007 531.469971 278.029999 532.400024 277.929993 C 533.340027 277.829987 536.869995 277.480011 537.280029 277.720001 C 537.700012 277.959991 530.5 284.839996 529.679993 285.190002 C 531.900024 282.380005 535.359985 279.959991 534.679993 279.51001 C 534.349976 279.290009 532.140015 279.339996 530.950012 279.839996 C 529.76001 280.339996 525.679993 282.799988 525.070007 282.959991 C 524.469971 283.119995 524.02002 283.170013 523.599976 282.730011 L 523.609985 282.73999 Z"
      />
      <linearGradient
        id="linearGradient221"
        x1="556.56"
        y1="271.76"
        x2="524.69"
        y2="291.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5829"
        fill="url(#linearGradient221)"
        stroke="none"
        d="M 528.280029 290.540009 C 528.280029 290.540009 533.460022 285.790009 533.799988 285.429993 C 534.710022 284.440002 538.109985 280.98999 539.200012 280.609985 C 540.549988 280.140015 538.200012 282.980011 536.76001 284.559998 C 535.51001 285.929993 532.890015 287.910004 532.890015 287.910004 C 532.890015 287.910004 537.130005 283.589996 537.549988 283.100006 C 538.460022 282.029999 537.549988 282.459991 536.890015 283.100006 C 536.280029 283.690002 530.640015 289.160004 528.280029 290.540009 Z"
      />
      <linearGradient
        id="linearGradient222"
        x1="553.39"
        y1="278.44"
        x2="532.66"
        y2="291.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5830"
        fill="url(#linearGradient222)"
        stroke="none"
        d="M 534.73999 290.209991 C 534.73999 290.209991 540.159973 284.640015 541.429993 283.920013 C 542.469971 283.329987 542.599976 284.48999 541.26001 286.089996 C 539.909973 287.700012 537.590027 289.850006 537.590027 289.850006 C 537.590027 289.850006 541.200012 286.170013 540.909973 285.549988 C 540.690002 285.079987 537.5 288.100006 534.73999 290.209991 Z"
      />
      <linearGradient
        id="linearGradient223"
        x1="531.46"
        y1="285.63"
        x2="525.7"
        y2="291.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5831"
        fill="url(#linearGradient223)"
        stroke="none"
        d="M 526.349976 289.140015 C 526.640015 288.75 529.530029 286.140015 529.919983 285.820007 C 530.909973 285 532.98999 285.369995 530.820007 287.529999 C 528.210022 290.119995 526.940002 291.070007 526.630005 291.01001 C 526.320007 290.940002 525.549988 290.230011 526.349976 289.140015 Z"
      />
      <path
        id="path5832"
        fill="#ffdebd"
        stroke="none"
        d="M 528.349976 289.089996 C 528.150024 288.630005 527.570007 288.51001 527.070007 288.880005 C 526.849976 289.040009 526.090027 289.649994 526.039978 290.029999 C 525.969971 290.540009 526.52002 290.920013 526.609985 290.929993 C 526.76001 290.940002 527.140015 291.209991 527.599976 290.690002 C 528.049988 290.170013 528.570007 289.600006 528.349976 289.089996 Z"
      />
      <linearGradient
        id="linearGradient224"
        x1="529.69"
        y1="277.44"
        x2="523.48"
        y2="282.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5833"
        fill="url(#linearGradient224)"
        stroke="none"
        d="M 527.669983 278.040009 C 527.950012 277.890015 528.950012 277.329987 529.429993 277.880005 C 530.159973 278.720001 526.72998 281.160004 526.070007 281.769989 C 525.119995 282.649994 522.679993 282.679993 524 281.049988 C 525.320007 279.420013 527.380005 278.190002 527.659973 278.040009 L 527.669983 278.040009 Z"
      />
      <path
        id="path5834"
        fill="#ffdebd"
        stroke="none"
        d="M 525.700012 280.630005 C 525.409973 280.380005 524.909973 280.23999 524.440002 280.630005 C 523.969971 281.029999 523.409973 281.470001 523.369995 281.910004 C 523.340027 282.320007 523.809998 282.859985 524.460022 282.730011 C 524.719971 282.679993 525.940002 281.869995 525.98999 281.320007 C 526.01001 281.089996 525.890015 280.790009 525.700012 280.619995 L 525.700012 280.630005 Z"
      />
      <linearGradient
        id="linearGradient225"
        x1="538.91"
        y1="290.31"
        x2="535.54"
        y2="293.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5835"
        fill="url(#linearGradient225)"
        stroke="none"
        d="M 538.48999 290.209991 C 538.840027 290.549988 539.02002 291.48999 536.549988 293.390015 C 536.109985 293.730011 535.419983 292.779999 536.169983 291.799988 C 536.359985 291.549988 537.780029 289.519989 538.48999 290.209991 Z"
      />
      <path
        id="path5836"
        fill="#ffdebd"
        stroke="none"
        d="M 537.070007 291.559998 C 536.75 291.470001 536.26001 291.910004 535.859985 292.480011 C 535.469971 293.049988 535.859985 293.480011 536.27002 293.459991 C 536.619995 293.450012 537.419983 292.369995 537.409973 292.130005 C 537.409973 291.890015 537.409973 291.649994 537.059998 291.559998 L 537.070007 291.559998 Z"
      />
      <linearGradient
        id="linearGradient226"
        x1="542.64"
        y1="297.41"
        x2="549.35"
        y2="278.95"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5837"
        fill="url(#linearGradient226)"
        stroke="none"
        d="M 559.469971 270.519989 C 559.469971 270.519989 551.549988 275.5 551.23999 275.779999 C 550.929993 276.059998 549.890015 279.570007 546.909973 282.869995 C 543.929993 286.170013 537.039978 293.390015 537.039978 293.390015 C 537.039978 293.390015 538.75 292.690002 541.109985 290.029999 C 543.710022 287.100006 549.719971 281.850006 550.73999 280.399994 C 552.190002 278.329987 552 277.619995 554.080017 275.630005 C 556.169983 273.630005 557.580017 272.529999 559.469971 270.519989 Z"
      />
      <linearGradient
        id="linearGradient227"
        x1="552.91"
        y1="276.73"
        x2="545.06"
        y2="270.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5838"
        fill="url(#linearGradient227)"
        stroke="none"
        d="M 544.690002 271.299988 L 552.22998 277.899994 C 552.22998 277.899994 552.700012 277.179993 552.72998 277.140015 C 552.76001 277.089996 553.880005 275.799988 553.880005 275.799988 L 545.419983 270.269989 L 544.690002 271.299988 Z"
      />
      <path
        id="path5839"
        fill="#f1f0f4"
        stroke="none"
        d="M 564.599976 230.619995 C 564.599976 230.619995 572.880005 240.080002 574.640015 246.949997 C 576.409973 253.820007 556.98999 279.690002 556.98999 279.690002 L 544.690002 270.200012 C 544.690002 270.200012 552.669983 252.460007 552.880005 251.699997 C 553.090027 250.940002 549.340027 247.509995 549.340027 247.509995 L 564.599976 230.609985 L 564.599976 230.619995 Z"
      />
      <linearGradient
        id="linearGradient228"
        x1="548.57"
        y1="226.39"
        x2="547.66"
        y2="257.57"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5840"
        fill="url(#linearGradient228)"
        stroke="none"
        d="M 561.419983 245.639999 C 560.429993 244.729996 553.890015 245.369995 535.090027 226.820007 L 537.75 236.179993 C 537.75 236.179993 543.98999 242 552.880005 251.710007 C 552.880005 251.710007 549.830017 258.720001 544.690002 270.209991 C 545.26001 270.690002 545.669983 270.970001 546.320007 271.470001 C 548.01001 269.100006 550.309998 265.519989 551.869995 262.369995 C 560.090027 245.740005 561.820007 246.020004 561.419983 245.649994 L 561.419983 245.639999 Z"
      />
      <linearGradient
        id="linearGradient229"
        x1="570.62"
        y1="245.13"
        x2="552.06"
        y2="275.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.36" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5841"
        fill="url(#linearGradient229)"
        stroke="none"
        d="M 572.809998 249.649994 C 572.809998 253.330002 570.919983 255.580002 564.090027 264.320007 C 556.719971 273.76001 548.869995 275.190002 548.650024 271.459991 C 548.440002 267.690002 572.799988 238.630005 572.799988 249.649994 L 572.809998 249.649994 Z"
      />
      <linearGradient
        id="linearGradient230"
        x1="578.86"
        y1="259.22"
        x2="534.6"
        y2="205.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.36" stopColor="#f8f8fa" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5842"
        fill="url(#linearGradient230)"
        stroke="none"
        d="M 542.280029 207.580017 C 540.330017 206.539978 537.580017 218.029999 540.169983 223.220001 C 542.76001 228.410004 552.039978 233.580017 555.030029 236.02002 C 567.099976 245.869995 566.859985 238.389999 566.570007 237.600006 C 561.460022 223.460022 545.179993 209.140015 542.27002 207.589996 L 542.280029 207.580017 Z"
      />
      <linearGradient
        id="linearGradient231"
        x1="487.19"
        y1="187.05"
        x2="474.36"
        y2="216.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f0f5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5843"
        fill="url(#linearGradient231)"
        stroke="none"
        d="M 466.690002 209.73999 C 466.690002 209.73999 474.799988 203.77002 492.089996 200.160004 C 492.089996 200.160004 482.859985 206.309998 478.029999 208.160004 C 473.200012 210.01001 466.690002 209.73999 466.690002 209.73999 Z"
      />
      <path
        id="path5844"
        fill="#f0c499"
        stroke="none"
        d="M 488.399994 174.089996 C 486.480011 174.440002 486.899994 175.76001 487.73999 178.049988 C 488.559998 184.149994 490.130005 185.359985 490.790009 184.98999 C 492.01001 184.309998 490.730011 173.660004 488.399994 174.089996 Z"
      />
      <linearGradient
        id="linearGradient232"
        x1="438.707"
        y1="164.994"
        x2="440.957"
        y2="173.638"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5845"
        fill="url(#linearGradient232)"
        stroke="none"
        d="M 489.959991 182.77002 C 489.959991 182.77002 489.059998 181.630005 489.420013 179.48999 C 490.269989 174.440002 487.170013 173.929993 487.76001 177.440002 C 487.76001 177.440002 488.23999 175.820007 488.619995 176.330017 C 489.079987 176.960022 488.070007 177.23999 488.5 179.890015 C 488.720001 181.27002 489.959991 182.77002 489.959991 182.77002 Z"
      />
      <path
        id="path5846"
        fill="#f0c499"
        stroke="none"
        d="M 524.630005 174.049988 C 526.570007 174.320007 526.219971 175.640015 525.51001 177.970001 C 525.039978 184.089996 523.549988 185.380005 522.859985 185.039978 C 521.609985 184.419983 522.280029 173.720001 524.619995 174.039978 L 524.630005 174.049988 Z"
      />
      <linearGradient
        id="linearGradient233"
        x1="572.584"
        y1="160.4"
        x2="570.71"
        y2="169.117"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5847"
        fill="url(#linearGradient233)"
        stroke="none"
        d="M 523.570007 182.779999 C 523.570007 182.779999 524.400024 181.600006 523.919983 179.47998 C 522.780029 174.470001 525.849976 173.830017 525.460022 177.359985 C 525.460022 177.359985 524.880005 175.77002 524.539978 176.299988 C 524.109985 176.950012 525.140015 177.179993 524.869995 179.850006 C 524.72998 181.23999 523.580017 182.789978 523.580017 182.789978 L 523.570007 182.779999 Z"
      />
      <path
        id="path5848"
        fill="#f7d4ab"
        stroke="none"
        d="M 523.109985 173.75 C 523.679993 159.410004 519.289978 157.47998 518.030029 156.01001 C 515.47998 153.039978 511.470001 151.73999 504.619995 151.899994 C 504.619995 151.899994 495.690002 152.210022 493.459991 157.100006 C 491.070007 162.330017 490.649994 169.51001 490.859985 176.25 C 491.109985 184.429993 491.109985 186.600006 491.829987 188.309998 C 492.160004 189.100006 495.399994 192.690002 496.779999 194.179993 C 499.089996 196.679993 499.829987 196.679993 501.880005 198.330017 C 502.709991 199 507.970001 201.839996 512.330017 198.880005 C 514.619995 197.330017 514.789978 197.330017 518.030029 193.48999 C 519.150024 192.160004 522.320007 188.47998 522.320007 187.47998 C 522.320007 186.330017 523 181.97998 522.960022 181.130005 C 522.72998 176.51001 522.950012 177.72998 523.099976 173.73999 L 523.109985 173.75 Z"
      />
      <linearGradient
        id="linearGradient234"
        x1="515.22"
        y1="178.76"
        x2="514.75"
        y2="173.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5849"
        fill="url(#linearGradient234)"
        stroke="none"
        d="M 510.359985 170.369995 C 510.140015 171.76001 508.859985 176.899994 509.679993 177.380005 C 514.799988 180.390015 520.390015 176.580017 520.390015 176.580017 C 521.809998 168.190002 510.359985 170.369995 510.359985 170.369995 Z"
      />
      <radialGradient
        id="radialGradient107"
        cx="526.435"
        cy="182.121"
        r="8.16103"
        fx="526.435"
        fy="182.121"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8c39c" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5850"
        fill="url(#radialGradient107)"
        stroke="none"
        d="M 516.140015 187.299988 C 518.960022 187.48999 522.380005 187.130005 522.969971 181.279999 C 523.309998 177.950012 522.679993 176.210022 521.289978 175.950012 C 518.330017 175.399994 514.090027 176.690002 512.320007 177.619995 C 508.589996 179.570007 511.149994 186.970001 516.150024 187.309998 L 516.140015 187.299988 Z"
      />
      <linearGradient
        id="linearGradient235"
        x1="498.47"
        y1="178.68"
        x2="498.01"
        y2="173.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5851"
        fill="url(#linearGradient235)"
        stroke="none"
        d="M 492.609985 176.330017 C 492.609985 176.330017 498.459991 180.339996 503.690002 176.97998 C 504.48999 176.460022 502.910004 171.899994 502.690002 170.51001 C 502.690002 170.51001 492.48999 167.25 492.609985 176.330017 Z"
      />
      <radialGradient
        id="radialGradient108"
        cx="516.289"
        cy="180.323"
        r="8.484575"
        fx="516.289"
        fy="180.323"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8c39c" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5852"
        fill="url(#radialGradient108)"
        stroke="none"
        d="M 500.540009 177.330017 C 499.730011 177.029999 493.600006 175.630005 491.769989 176.169983 C 490.730011 176.470001 490.380005 178.839996 490.559998 181.070007 C 490.640015 182.140015 490.880005 183.839996 491.119995 184.51001 C 492.299988 187.809998 497.329987 187.950012 499.929993 187.029999 C 504.369995 185.460022 504.630005 178.820007 500.540009 177.330017 Z"
      />
      <linearGradient
        id="linearGradient236"
        x1="521.1"
        y1="178.09"
        x2="516.21"
        y2="179.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5853"
        fill="url(#linearGradient236)"
        stroke="none"
        d="M 520.960022 177.549988 C 520.450012 177.26001 520.070007 177.679993 519.02002 178.029999 C 517.97998 178.369995 515.150024 178.910004 516.47998 179.630005 C 517.950012 180.429993 520.01001 179.330017 520.26001 179.130005 C 520.51001 178.919983 521.590027 177.910004 520.960022 177.549988 Z"
      />
      <linearGradient
        id="linearGradient237"
        x1="497.3"
        y1="179.68"
        x2="490.05"
        y2="177.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5854"
        fill="url(#linearGradient237)"
        stroke="none"
        d="M 494.119995 178.140015 C 493.049988 177.850006 492.649994 177.450012 492.149994 177.76001 C 491.540009 178.149994 492.670013 179.100006 492.929993 179.299988 C 493.190002 179.48999 495.299988 180.47998 496.730011 179.609985 C 498.019989 178.820007 495.170013 178.429993 494.109985 178.140015 L 494.119995 178.140015 Z"
      />
      <linearGradient
        id="linearGradient238"
        x1="518.7"
        y1="174.26"
        x2="509.81"
        y2="176.77"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5855"
        fill="url(#linearGradient238)"
        stroke="none"
        d="M 514.830017 172.850006 C 515.919983 172.809998 517.280029 173.169983 517.690002 173.5 C 518.48999 174.149994 519.090027 175.73999 519.080017 176.200012 C 519.070007 176.660004 517.340027 177.789978 515.5 177.929993 C 513.72998 178.070007 510.679993 177.839996 510.209991 176.910004 C 510.049988 176.589996 510.450012 174.950012 510.51001 174.640015 C 510.670013 173.77002 511.799988 172.970001 514.840027 172.850006 L 514.830017 172.850006 Z"
      />
      <linearGradient
        id="linearGradient239"
        x1="511.04"
        y1="175.99"
        x2="519.21"
        y2="175.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.47" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.77" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e7" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5856"
        fill="url(#linearGradient239)"
        stroke="none"
        d="M 513.030029 173.919983 C 517.440002 173.559998 516.700012 174.22998 518.210022 176.130005 C 518.210022 176.130005 517.599976 177 516.469971 177.27002 C 514.440002 177.75 513.48999 177.660004 511.410004 177.200012 C 510.869995 177.080017 510.850006 176.809998 510.850006 176.809998 C 510.850006 176.809998 510.640015 174.119995 513.030029 173.929993 L 513.030029 173.919983 Z"
      />
      <path
        id="path5857"
        fill="#dddddd"
        stroke="none"
        d="M 516.049988 174.130005 C 517.469971 173.97998 518.200012 176.130005 518.200012 176.130005 C 518.109985 176.26001 518.070007 176.309998 517.880005 176.48999 C 516.51001 175.779999 513.840027 175.73999 513.619995 175.77002 C 511.850006 176.049988 510.839996 176.47998 510.839996 176.47998 C 510.929993 174.809998 511.420013 174.51001 511.420013 174.51001 C 511.420013 174.51001 514.630005 174.27002 516.049988 174.119995 L 516.049988 174.130005 Z"
      />
      <linearGradient
        id="linearGradient240"
        x1="516.56"
        y1="175.97"
        x2="511.86"
        y2="175.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5858"
        fill="url(#linearGradient240)"
        stroke="none"
        d="M 514.289978 174.279999 C 515.580017 174.359985 516.72998 175.089996 516.549988 176.410004 C 516.51001 176.690002 516.450012 177 516.130005 177.359985 C 515.849976 177.440002 514.929993 177.669983 514.280029 177.649994 C 513.650024 177.630005 512.469971 177.470001 512.25 177.399994 C 512.190002 177.339996 511.890015 176.76001 511.869995 176.25 C 511.809998 174.890015 513.01001 174.210022 514.299988 174.289978 L 514.289978 174.279999 Z"
      />
      <linearGradient
        id="linearGradient241"
        x1="518.94"
        y1="154.4"
        x2="517.32"
        y2="161.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5859"
        fill="url(#linearGradient241)"
        stroke="none"
        d="M 514.809998 173.850006 C 516.609985 174.190002 516.559998 176.02002 516.559998 176.02002 C 513.969971 175.350006 511.859985 176.169983 511.859985 176.169983 C 511.76001 174.640015 513.23999 173.549988 514.809998 173.850006 Z"
      />
      <radialGradient
        id="radialGradient109"
        cx="498.253"
        cy="176.696"
        r="4.11948"
        fx="498.253"
        fy="176.696"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3a3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2727" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5860"
        fill="url(#radialGradient109)"
        stroke="none"
        d="M 514.429993 174.440002 C 515.219971 174.460022 515.840027 175.109985 515.820007 175.890015 C 515.799988 176.669983 515.140015 177.279999 514.349976 177.26001 C 513.559998 177.23999 512.940002 176.580017 512.960022 175.809998 C 512.97998 175.029999 513.640015 174.419983 514.429993 174.440002 Z"
      />
      <path
        id="path5861"
        fill="#ffffff"
        stroke="none"
        d="M 515.780029 175.880005 C 516.099976 175.919983 516.340027 176.22998 516.299988 176.559998 C 516.26001 176.899994 515.969971 177.140015 515.640015 177.089996 C 515.309998 177.049988 515.080017 176.73999 515.119995 176.410004 C 515.159973 176.070007 515.450012 175.830017 515.780029 175.880005 Z"
      />
      <path
        id="path5862"
        fill="#ffffff"
        stroke="none"
        d="M 514.440002 175.369995 C 514.700012 175.399994 514.880005 175.640015 514.849976 175.910004 C 514.820007 176.169983 514.590027 176.359985 514.330017 176.330017 C 514.070007 176.299988 513.890015 176.059998 513.919983 175.789978 C 513.950012 175.52002 514.179993 175.330017 514.440002 175.369995 Z"
      />
      <linearGradient
        id="linearGradient242"
        x1="518.32"
        y1="174.89"
        x2="511.26"
        y2="174.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#421f16" stopOpacity={1} />
        <stop offset="0.32" stopColor="#462017" stopOpacity={1} />
        <stop offset="0.66" stopColor="#52261c" stopOpacity={1} />
        <stop offset={1} stopColor="#673024" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5863"
        fill="url(#linearGradient242)"
        stroke="none"
        d="M 516.919983 173.789978 C 518.070007 174.210022 518.210022 176.130005 518.210022 176.130005 C 518.210022 176.130005 517.75 175.059998 516.669983 174.890015 C 514.539978 174.559998 512.820007 174.830017 512.109985 175.059998 C 511.26001 175.330017 510.920013 175.73999 510.920013 175.73999 C 510.920013 175.73999 511 174.850006 511.329987 174.48999 C 512.380005 173.320007 515.51001 173.27002 516.909973 173.789978 L 516.919983 173.789978 Z"
      />
      <linearGradient
        id="linearGradient243"
        x1="494.73"
        y1="174.26"
        x2="503.62"
        y2="176.77"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5864"
        fill="url(#linearGradient243)"
        stroke="none"
        d="M 498.600006 172.850006 C 497.51001 172.809998 496.149994 173.169983 495.73999 173.5 C 494.940002 174.149994 494.339996 175.73999 494.350006 176.200012 C 494.359985 176.660004 496.089996 177.789978 497.929993 177.929993 C 499.700012 178.070007 502.75 177.839996 503.220001 176.910004 C 503.380005 176.589996 502.980011 174.950012 502.920013 174.640015 C 502.76001 173.77002 501.630005 172.970001 498.589996 172.850006 L 498.600006 172.850006 Z"
      />
      <linearGradient
        id="linearGradient244"
        x1="502.38"
        y1="175.99"
        x2="494.22"
        y2="175.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.47" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.77" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e7" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5865"
        fill="url(#linearGradient244)"
        stroke="none"
        d="M 500.399994 173.919983 C 495.98999 173.559998 496.730011 174.22998 495.220001 176.130005 C 495.220001 176.130005 495.829987 177 496.959991 177.27002 C 498.98999 177.75 499.940002 177.660004 502.019989 177.200012 C 502.559998 177.080017 502.579987 176.809998 502.579987 176.809998 C 502.579987 176.809998 502.790009 174.119995 500.399994 173.929993 L 500.399994 173.919983 Z"
      />
      <path
        id="path5866"
        fill="#dddddd"
        stroke="none"
        d="M 497.369995 174.130005 C 495.950012 173.97998 495.220001 176.130005 495.220001 176.130005 C 495.309998 176.26001 495.350006 176.309998 495.540009 176.48999 C 496.910004 175.779999 499.579987 175.73999 499.799988 175.77002 C 501.570007 176.049988 502.579987 176.47998 502.579987 176.47998 C 502.48999 174.809998 502 174.51001 502 174.51001 C 502 174.51001 498.790009 174.27002 497.369995 174.119995 L 497.369995 174.130005 Z"
      />
      <linearGradient
        id="linearGradient245"
        x1="496.87"
        y1="175.97"
        x2="501.57"
        y2="175.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#715241" stopOpacity={1} />
        <stop offset={1} stopColor="#b89c8c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5867"
        fill="url(#linearGradient245)"
        stroke="none"
        d="M 499.140015 174.279999 C 497.850006 174.359985 496.700012 175.089996 496.880005 176.410004 C 496.920013 176.690002 496.980011 177 497.299988 177.359985 C 497.579987 177.440002 498.5 177.669983 499.149994 177.649994 C 499.779999 177.630005 500.959991 177.470001 501.179993 177.399994 C 501.23999 177.339996 501.540009 176.76001 501.559998 176.25 C 501.619995 174.890015 500.420013 174.210022 499.130005 174.289978 L 499.140015 174.279999 Z"
      />
      <linearGradient
        id="linearGradient246"
        x1="494.48"
        y1="154.4"
        x2="496.11"
        y2="161.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5868"
        fill="url(#linearGradient246)"
        stroke="none"
        d="M 498.619995 173.850006 C 496.820007 174.190002 496.869995 176.02002 496.869995 176.02002 C 499.459991 175.350006 501.570007 176.169983 501.570007 176.169983 C 501.670013 174.640015 500.190002 173.549988 498.619995 173.850006 Z"
      />
      <radialGradient
        id="radialGradient110"
        cx="502.091"
        cy="-145.771"
        r="4.11952"
        fx="502.091"
        fy="-145.771"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3a3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2727" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5869"
        fill="url(#radialGradient110)"
        stroke="none"
        d="M 499 174.440002 C 498.209991 174.460022 497.589996 175.109985 497.609985 175.890015 C 497.630005 176.669983 498.290009 177.279999 499.079987 177.26001 C 499.869995 177.23999 500.48999 176.580017 500.470001 175.809998 C 500.450012 175.029999 499.790009 174.419983 499 174.440002 Z"
      />
      <path
        id="path5870"
        fill="#ffffff"
        stroke="none"
        d="M 500.279999 175.880005 C 499.959991 175.919983 499.720001 176.22998 499.76001 176.559998 C 499.799988 176.899994 500.089996 177.140015 500.420013 177.089996 C 500.75 177.049988 500.980011 176.73999 500.940002 176.410004 C 500.899994 176.070007 500.609985 175.830017 500.279999 175.880005 Z"
      />
      <path
        id="path5871"
        fill="#ffffff"
        stroke="none"
        d="M 498.98999 175.369995 C 498.730011 175.399994 498.549988 175.640015 498.579987 175.910004 C 498.609985 176.169983 498.839996 176.359985 499.100006 176.330017 C 499.359985 176.299988 499.540009 176.059998 499.51001 175.789978 C 499.480011 175.52002 499.25 175.330017 498.98999 175.369995 Z"
      />
      <linearGradient
        id="linearGradient247"
        x1="495.1"
        y1="174.89"
        x2="502.17"
        y2="174.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#421f16" stopOpacity={1} />
        <stop offset="0.32" stopColor="#462017" stopOpacity={1} />
        <stop offset="0.66" stopColor="#52261c" stopOpacity={1} />
        <stop offset={1} stopColor="#673024" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5872"
        fill="url(#linearGradient247)"
        stroke="none"
        d="M 496.51001 173.789978 C 495.359985 174.210022 495.220001 176.130005 495.220001 176.130005 C 495.220001 176.130005 495.679993 175.059998 496.76001 174.890015 C 498.890015 174.559998 500.609985 174.830017 501.320007 175.059998 C 502.170013 175.330017 502.51001 175.73999 502.51001 175.73999 C 502.51001 175.73999 502.429993 174.850006 502.100006 174.48999 C 501.049988 173.320007 497.920013 173.27002 496.519989 173.789978 L 496.51001 173.789978 Z"
      />
      <linearGradient
        id="linearGradient248"
        x1="498.72"
        y1="198.72"
        x2="490.3"
        y2="182.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f6d2aa" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c498" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5873"
        fill="url(#linearGradient248)"
        stroke="none"
        d="M 490.359985 179.97998 C 490.480011 183.130005 490.98999 186.25 491.410004 187.75 C 491.519989 188.140015 492.089996 189.710022 493.450012 191.22998 C 496.040009 194.109985 498.589996 196 499.26001 196.450012 C 496.980011 194.039978 494.660004 190.799988 493.920013 189.710022 C 491.119995 185.52002 490.359985 179.98999 490.359985 179.98999 L 490.359985 179.97998 Z"
      />
      <linearGradient
        id="linearGradient249"
        x1="515.21"
        y1="199.55"
        x2="523.32"
        y2="182.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f6d2aa" stopOpacity={1} />
        <stop offset={1} stopColor="#ffd8b2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5874"
        fill="url(#linearGradient249)"
        stroke="none"
        d="M 514.599976 197.26001 C 515.650024 196.440002 518.210022 193.850006 520.380005 191.779999 C 521.409973 190.799988 522.070007 189.059998 522.369995 187.910004 C 522.659973 186.77002 523.059998 180.149994 523.059998 180.149994 C 522.75 183.02002 521.900024 187.100006 520.380005 189.839996 C 518.859985 192.580017 515.200012 196.460022 514.599976 197.26001 Z"
      />
      <linearGradient
        id="linearGradient250"
        x1="504.77"
        y1="141.95"
        x2="506.91"
        y2="175.59"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.45" stopColor="#f3caa0" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5875"
        fill="url(#linearGradient250)"
        stroke="none"
        d="M 518.820007 158.369995 C 512.549988 153.97998 495.779999 158.299988 494.059998 158.339996 C 492.339996 158.380005 490.600006 180.109985 490.600006 180.109985 C 490.600006 180.109985 492.399994 176.679993 493.01001 174.080017 C 493.619995 171.47998 495.970001 169.789978 499.019989 169.299988 C 507.920013 167.869995 512.049988 167.890015 515.619995 168.880005 C 518.590027 169.700012 519.900024 170.359985 520.5 171.950012 C 521.090027 173.539978 522.789978 179.210022 522.789978 179.210022 C 522.789978 179.210022 525.080017 162.77002 518.820007 158.380005 L 518.820007 158.369995 Z"
      />
      <linearGradient
        id="linearGradient251"
        x1="504.39"
        y1="145.72"
        x2="507.08"
        y2="186.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#673024" stopOpacity={1} />
        <stop offset="0.34" stopColor="#52261c" stopOpacity={1} />
        <stop offset="0.68" stopColor="#462017" stopOpacity={1} />
        <stop offset={1} stopColor="#421f16" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5876"
        fill="url(#linearGradient251)"
        stroke="none"
        d="M 520.830017 155.47998 C 520.830017 155.47998 522.02002 151.960022 519.340027 149.589996 C 519.340027 149.589996 520.23999 150.47998 519.340027 151.970001 C 519.340027 151.970001 516.460022 145.830017 507.700012 145.51001 L 509.420013 147.470001 C 509.420013 147.470001 501.350006 144.359985 494.269989 148.700012 C 494.269989 148.700012 495.600006 149.330017 496.359985 150.190002 C 491.98999 149.890015 489.709991 152.47998 488.579987 155.220001 C 488.579987 155.220001 491.279999 153.690002 493.679993 155.5 C 493.679993 155.5 488.839996 154.539978 487.109985 159.589996 C 487.109985 159.589996 489.980011 156.700012 491.890015 159.589996 C 491.890015 159.589996 488.609985 159.179993 487.019989 164.830017 C 488.359985 162.73999 490.839996 162.289978 490.839996 162.289978 C 490.839996 162.289978 489.470001 166.72998 488.839996 174.160004 C 488.839996 174.160004 490.380005 174.690002 490.570007 178.970001 C 490.570007 178.970001 492.190002 162.359985 495.23999 160.339996 C 502.970001 155.220001 515.049988 157.710022 516.820007 158.97998 C 522.419983 163 523.070007 179.049988 523.070007 179.049988 C 523.070007 179.049988 523.030029 173.899994 524.840027 174.089996 C 524.840027 174.089996 524.650024 158.589996 520.840027 155.48999 L 520.830017 155.47998 Z"
      />
      <linearGradient
        id="linearGradient252"
        x1="499.93"
        y1="130.741"
        x2="500.13"
        y2="156.447"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#673024" stopOpacity={1} />
        <stop offset="0.34" stopColor="#52261c" stopOpacity={1} />
        <stop offset="0.68" stopColor="#462017" stopOpacity={1} />
        <stop offset={1} stopColor="#421f16" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5877"
        fill="url(#linearGradient252)"
        stroke="none"
        d="M 500.119995 151.109985 C 500.070007 151.100006 500.040009 151.089996 500.040009 151.089996 C 500.070007 151.089996 500.089996 151.100006 500.119995 151.109985 Z"
      />
      <linearGradient
        id="linearGradient253"
        x1="504.87"
        y1="148.59"
        x2="505.66"
        y2="161.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#673024" stopOpacity={1} />
        <stop offset="0.34" stopColor="#52261c" stopOpacity={1} />
        <stop offset="0.68" stopColor="#462017" stopOpacity={1} />
        <stop offset={1} stopColor="#421f16" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5878"
        fill="url(#linearGradient253)"
        stroke="none"
        d="M 512.210022 151.089996 C 512.210022 151.089996 516.070007 154.799988 516.150024 157.73999 C 514.22998 156.51001 508.940002 156.390015 507.890015 156.399994 C 506.859985 155.01001 504.619995 151.890015 500.119995 151.100006 C 500.630005 151.220001 502.570007 151.77002 505.179993 156.26001 C 503.390015 156.109985 500.059998 157.289978 499.350006 157.440002 C 498.850006 157.080017 496.700012 155.960022 495.220001 155.960022 C 495.220001 155.960022 497.51001 157.02002 497.720001 157.970001 C 497.720001 157.970001 495.299988 158.970001 494.059998 161.059998 C 490.51001 167.059998 490.51001 180.440002 490.51001 180.440002 C 490.51001 180.440002 491.76001 175.669983 492.410004 172.25 C 493.160004 168.279999 493.410004 163.549988 494.799988 161.669983 C 498.350006 156.880005 511.380005 155.97998 516.789978 159.600006 C 519.780029 161.600006 520.27002 166.76001 521.140015 171.25 C 521.880005 175.100006 523.039978 180.52002 523.039978 180.52002 C 523.039978 180.52002 523.200012 165.299988 519.580017 159.98999 C 519.580017 159.98999 517.340027 153.559998 512.200012 151.100006 L 512.210022 151.089996 Z"
      />
      <path
        id="path5879"
        fill="#ccccd0"
        stroke="none"
        d="M 524.320007 147.72998 C 524.320007 147.72998 534.349976 141.649994 531.830017 138.700012 C 529.309998 135.75 520.090027 137.039978 518.25 137.22998 C 516.409973 137.419983 509.730011 132.98999 506.440002 134.470001 C 503.149994 135.940002 496.390015 140.619995 493.600006 140.950012 C 490.799988 141.289978 486.470001 146.960022 481.820007 147.710022 C 477.170013 148.470001 475.649994 157.169983 478.049988 158.350006 C 480.450012 159.52002 470.98999 167.399994 481.369995 173.190002 C 484.450012 174.910004 489.200012 170.200012 489.200012 170.200012 L 489.269989 158.549988 C 489.269989 158.549988 502.76001 148.350006 524.330017 147.72998 L 524.320007 147.72998 Z"
      />
      <path
        id="path5880"
        fill="#ccccd0"
        stroke="none"
        d="M 488.880005 173.179993 C 488.880005 173.179993 491.369995 170.649994 496.529999 168.899994 C 502.459991 166.890015 514.840027 165.399994 524.659973 170.299988 C 525.02002 162.279999 524.320007 147.72998 524.320007 147.72998 C 524.320007 147.72998 505.929993 146.789978 489.470001 157.429993 C 488.420013 171.350006 488.880005 173.179993 488.880005 173.179993 Z"
      />
      <linearGradient
        id="linearGradient254"
        x1="497.79"
        y1="146.98"
        x2="515.04"
        y2="172.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.31" stopColor="#eaeaeb" stopOpacity={1} />
        <stop offset="0.73" stopColor="#d4d4d7" stopOpacity={1} />
        <stop offset={1} stopColor="#ccccd0" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5881"
        fill="url(#linearGradient254)"
        stroke="none"
        d="M 492.649994 169.929993 C 492.649994 169.929993 497.269989 167.109985 505.549988 166.309998 C 514.01001 165.48999 521.640015 168 521.640015 168 C 521.640015 168 522.159973 152.160004 520.909973 151.059998 C 519.659973 149.960022 502.380005 154.5 494.040009 159.450012 C 492.25 160.51001 492.649994 169.940002 492.649994 169.940002 L 492.649994 169.929993 Z"
      />
      <linearGradient
        id="linearGradient255"
        x1="493.95"
        y1="141.83"
        x2="505.25"
        y2="165.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ccccd0" stopOpacity={1} />
        <stop offset={1} stopColor="#b6b6ba" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5882"
        fill="url(#linearGradient255)"
        stroke="none"
        d="M 521.280029 147.890015 C 521.280029 147.890015 522.549988 142.450012 520.940002 143.919983 C 519.330017 145.390015 515.619995 149.419983 514.950012 148.450012 C 514.280029 147.47998 514 142.75 513.070007 144.289978 C 512.140015 145.830017 511.170013 147.47998 510.209991 147.72998 C 509.25 147.97998 497.899994 145.640015 499.549988 146.630005 C 501.200012 147.609985 502.309998 148.839996 498.559998 149.820007 C 494.809998 150.799988 483.880005 153.029999 485.779999 153.970001 C 487.679993 154.910004 486.390015 158 484.859985 160.330017 C 483.329987 162.660004 487.559998 165.539978 486.950012 166.220001 C 486.339996 166.899994 480.23999 171.25 481.970001 171.830017 C 483.709991 172.399994 488.779999 170.359985 488.779999 170.359985 C 488.779999 170.359985 489.940002 157.070007 491.019989 155.630005 C 492.100006 154.190002 521.27002 147.899994 521.27002 147.899994 L 521.280029 147.890015 Z"
      />
      <linearGradient
        id="linearGradient256"
        x1="503.6"
        y1="176.79"
        x2="507.1"
        y2="150.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#aaaaad" stopOpacity={1} />
        <stop offset={1} stopColor="#b6b6ba" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5883"
        fill="url(#linearGradient256)"
        stroke="none"
        d="M 524.320007 147.72998 C 524.320007 147.72998 491.119995 148.75 489.26001 158.549988 C 488.829987 160.789978 488.779999 170.359985 488.779999 170.359985 C 488.779999 170.359985 490.519989 159.22998 491.019989 158.350006 C 494.450012 152.320007 524.320007 147.73999 524.320007 147.73999 L 524.320007 147.72998 Z"
      />
      <linearGradient
        id="linearGradient257"
        x1="488.41"
        y1="131.2"
        x2="507.24"
        y2="159.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.31" stopColor="#eaeaeb" stopOpacity={1} />
        <stop offset="0.73" stopColor="#d4d4d7" stopOpacity={1} />
        <stop offset={1} stopColor="#ccccd0" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5884"
        fill="url(#linearGradient257)"
        stroke="none"
        d="M 528.330017 144.890015 C 528.330017 144.890015 534.619995 140.419983 531.52002 138.23999 C 527.640015 135.52002 518.840027 137.140015 517.789978 137.029999 C 515.799988 136.820007 510.809998 133.549988 507.589996 134.100006 C 504.369995 134.649994 496.559998 139.859985 495.579987 140.22998 C 494.600006 140.600006 492.769989 140.779999 491.859985 141.339996 C 490.959991 141.899994 484.640015 146.619995 484.100006 146.850006 C 483.559998 147.080017 479.26001 146.630005 477.170013 150.440002 C 475.079987 154.25 476.799988 156.75 477.170013 157.799988 C 477.540009 158.850006 473.790009 166.779999 475.079987 169.169983 C 476.369995 171.570007 481.350006 173.179993 481.350006 173.179993 C 481.350006 173.179993 476.679993 169.47998 477.170013 168.130005 C 477.660004 166.779999 480.179993 160.289978 481.959991 159.450012 C 483.73999 158.609985 483.5 154.549988 483.98999 153.02002 C 484.480011 151.47998 491.390015 149.52002 492.940002 148.970001 C 494.48999 148.419983 500.079987 140.73999 501.399994 140.619995 C 502.720001 140.5 507.459991 142.089996 510.309998 142.220001 C 513.159973 142.339996 518.369995 140.070007 519.400024 140.619995 C 523.77002 142.950012 531.650024 139.640015 528.309998 144.910004 L 528.330017 144.890015 Z"
      />
      <linearGradient
        id="linearGradient258"
        x1="518.31"
        y1="153.95"
        x2="527.93"
        y2="168.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ccccd0" stopOpacity={1} />
        <stop offset={1} stopColor="#b6b6ba" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5885"
        fill="url(#linearGradient258)"
        stroke="none"
        d="M 524.599976 155.320007 C 525.030029 166.160004 524.659973 170.299988 524.659973 170.299988 C 524.659973 170.299988 523.640015 169.820007 523.419983 169.72998 C 523.419983 169.72998 524.47998 156.649994 524.599976 155.320007 Z"
      />
      <linearGradient
        id="linearGradient259"
        x1="507.64"
        y1="192.91"
        x2="507.19"
        y2="202.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.28" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5886"
        fill="url(#linearGradient259)"
        stroke="none"
        d="M 507.730011 193.529999 C 506.140015 193.529999 502.160004 194.630005 502.279999 195.210022 C 502.630005 196.98999 506.320007 197.289978 507.899994 197.279999 C 509.48999 197.279999 512.700012 196.859985 512.77002 195.339996 C 512.799988 194.73999 509.320007 193.51001 507.730011 193.52002 L 507.730011 193.529999 Z"
      />
      <linearGradient
        id="linearGradient260"
        x1="514.76"
        y1="196.67"
        x2="514.55"
        y2="183.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5887"
        fill="url(#linearGradient260)"
        stroke="none"
        d="M 512.619995 184.130005 C 515.72998 186.669983 514.469971 188.5 513.820007 189.140015 C 515.02002 188.130005 516.630005 186.98999 516.52002 186.549988 C 516.130005 184.929993 512.609985 184.130005 512.609985 184.130005 L 512.619995 184.130005 Z"
      />
      <linearGradient
        id="linearGradient261"
        x1="513.68"
        y1="189.77"
        x2="513.67"
        y2="189.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5888"
        fill="url(#linearGradient261)"
        stroke="none"
        d="M 513.820007 189.140015 C 513.719971 189.22998 513.619995 189.309998 513.530029 189.390015 C 513.530029 189.390015 513.659973 189.299988 513.820007 189.140015 Z"
      />
      <linearGradient
        id="linearGradient262"
        x1="513.5"
        y1="186.72"
        x2="515.5"
        y2="186.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5889"
        fill="url(#linearGradient262)"
        stroke="none"
        d="M 513.5 187.22998 C 513.5 187.22998 515.090027 186.850006 515.22998 186.73999 C 515.369995 186.630005 515.5 186.210022 515.5 186.210022 L 514.48999 186.52002 L 513.5 187.220001 L 513.5 187.22998 Z"
      />
      <linearGradient
        id="linearGradient263"
        x1="500.09"
        y1="197.25"
        x2="499.88"
        y2="184.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5890"
        fill="url(#linearGradient263)"
        stroke="none"
        d="M 498.23999 186.799988 C 498.309998 187.299988 499.700012 188.52002 500.609985 189.47998 C 500.609985 189.47998 498.179993 186.830017 501.559998 184.450012 C 501.559998 184.450012 498 185.130005 498.23999 186.809998 L 498.23999 186.799988 Z"
      />
      <linearGradient
        id="linearGradient264"
        x1="499.07"
        y1="186.82"
        x2="501.08"
        y2="186.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5891"
        fill="url(#linearGradient264)"
        stroke="none"
        d="M 499.070007 186.320007 C 499.070007 186.320007 499.200012 186.72998 499.339996 186.850006 C 499.480011 186.970001 501.070007 187.339996 501.070007 187.339996 L 500.079987 186.640015 L 499.070007 186.330017 L 499.070007 186.320007 Z"
      />
      <linearGradient
        id="linearGradient265"
        x1="507.82"
        y1="199.89"
        x2="507.52"
        y2="191.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5892"
        fill="url(#linearGradient265)"
        stroke="none"
        d="M 504.059998 193.350006 C 508.279999 192.880005 511.140015 193.399994 511.140015 193.399994 C 507.940002 191.380005 504.059998 193.350006 504.059998 193.350006 Z"
      />
      <path
        id="path5893"
        fill="#fdd8b3"
        stroke="none"
        d="M 507.420013 190.809998 C 506.220001 190.809998 505.040009 190.570007 505.040009 190.809998 C 505.040009 191.049988 506.079987 191.580017 507.279999 191.580017 C 508.480011 191.580017 509.670013 191.049988 509.670013 190.809998 C 509.670013 190.570007 508.630005 190.809998 507.420013 190.809998 Z"
      />
      <linearGradient
        id="linearGradient266"
        x1="502.04"
        y1="189.16"
        x2="513.05"
        y2="189.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d9d7" stopOpacity={1} />
        <stop offset="0.14" stopColor="#efe5e4" stopOpacity={1} />
        <stop offset="0.39" stopColor="#faf8f7" stopOpacity={1} />
        <stop offset="0.57" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d3d1" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5894"
        fill="url(#linearGradient266)"
        stroke="none"
        d="M 510.890015 188.390015 C 510.070007 188.559998 508.540009 188.869995 507.130005 188.869995 C 505.579987 188.869995 504 188.580017 503.140015 188.419983 C 502.76001 188.350006 502.600006 189.01001 502.600006 189.01001 C 503.730011 189.850006 505.089996 190.160004 507.269989 190.179993 C 510.170013 190.200012 511.779999 188.929993 511.779999 188.929993 C 511.779999 188.929993 511.369995 188.289978 510.890015 188.390015 Z"
      />
      <linearGradient
        id="linearGradient267"
        x1="507.83"
        y1="199.71"
        x2="507.53"
        y2="191.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5895"
        fill="url(#linearGradient267)"
        stroke="none"
        d="M 502.98999 191.109985 C 507.619995 194.839996 512.059998 190.850006 512.059998 190.850006 C 507.380005 193.369995 502.98999 191.109985 502.98999 191.109985 Z"
      />
      <linearGradient
        id="linearGradient268"
        x1="507.14"
        y1="184.95"
        x2="507.32"
        y2="189.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d9d7" stopOpacity={1} />
        <stop offset="0.4" stopColor="#efe5e3" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5896"
        fill="url(#linearGradient268)"
        stroke="none"
        d="M 501.459991 186.950012 C 501.459991 186.950012 501.48999 187.720001 502.26001 188.059998 C 502.709991 188.26001 503.720001 189.029999 507.630005 188.910004 C 511.540009 188.789978 512.320007 187.830017 512.5 187.660004 C 512.830017 187.350006 512.97998 186.820007 512.97998 186.820007 C 512.97998 186.820007 507.079987 187.98999 501.459991 186.940002 L 501.459991 186.950012 Z"
      />
      <path
        id="path5897"
        fill="#f3eceb"
        stroke="none"
        d="M 501.450012 186.869995 C 501.450012 186.869995 501.480011 187.220001 501.600006 187.429993 C 501.709991 187.600006 504.829987 188.070007 507.200012 188.080017 C 509.559998 188.089996 512.640015 187.47998 512.75 187.339996 C 512.919983 187.119995 513.01001 186.73999 513.01001 186.73999 C 513.01001 186.73999 510.350006 187.640015 501.440002 186.869995 L 501.450012 186.869995 Z"
      />
      <linearGradient
        id="linearGradient269"
        x1="507.59"
        y1="201.35"
        x2="507.3"
        y2="183.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5898"
        fill="url(#linearGradient269)"
        stroke="none"
        d="M 498.970001 186.27002 C 498.970001 186.27002 499.339996 186.47998 499.450012 186.51001 C 499.450012 186.51001 506.339996 188.549988 515.22998 186.339996 L 515.710022 186.089996 C 510.880005 186.910004 498.959991 186.26001 498.959991 186.26001 L 498.970001 186.27002 Z"
      />
      <linearGradient
        id="linearGradient270"
        x1="506.9"
        y1="165.79"
        x2="507.31"
        y2="182.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.2" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5899"
        fill="url(#linearGradient270)"
        stroke="none"
        d="M 508.73999 176.669983 C 508.929993 172.950012 507.640015 172.419983 506.690002 172.450012 C 505.76001 172.47998 505.25 173.77002 505.440002 176.609985 C 505.630005 179.429993 505.079987 180.52002 505.209991 181.839996 C 505.269989 182.440002 505.540009 182.839996 507.049988 182.850006 C 508.709991 182.859985 509.279999 182.470001 509.350006 181.899994 C 509.540009 180.359985 508.609985 179.350006 508.73999 176.669983 Z"
      />
      <linearGradient
        id="linearGradient271"
        x1="510.73"
        y1="190.24"
        x2="510.52"
        y2="184.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5900"
        fill="url(#linearGradient271)"
        stroke="none"
        d="M 508.920013 183.899994 C 511.160004 183.339996 512.039978 183.669983 512.039978 183.669983 C 510.73999 182.51001 508.920013 183.899994 508.920013 183.899994 Z"
      />
      <linearGradient
        id="linearGradient272"
        x1="504.3"
        y1="190.48"
        x2="504.09"
        y2="184.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5901"
        fill="url(#linearGradient272)"
        stroke="none"
        d="M 502.579987 183.51001 C 502.579987 183.51001 503.73999 183.320007 505.5 183.919983 C 505.5 183.919983 503.779999 182.600006 502.579987 183.51001 Z"
      />
      <linearGradient
        id="linearGradient273"
        x1={507}
        y1="175.09"
        x2="507.28"
        y2="184.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.51" stopColor="#f4cea5" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5902"
        fill="url(#linearGradient273)"
        stroke="none"
        d="M 510.649994 180.130005 C 510.640015 181.059998 510.850006 181.679993 510.570007 182.210022 C 509.950012 183.390015 508.339996 183.859985 507.26001 183.77002 C 506.440002 183.869995 504.529999 183.460022 503.730011 182.220001 C 503.410004 181.720001 503.609985 181.26001 503.459991 180.27002 C 503.459991 180.27002 501.23999 182.97998 502.570007 183.5 C 502.570007 183.5 502.959991 183.200012 504.029999 183.299988 C 505.100006 183.399994 504.880005 184.589996 507.339996 184.609985 C 509.480011 184.630005 508.799988 183.589996 510.160004 183.390015 C 511.519989 183.190002 511.700012 183.549988 512.01001 183.690002 C 512.690002 183.690002 512.200012 181.399994 510.640015 180.119995 L 510.649994 180.130005 Z"
      />
      <linearGradient
        id="linearGradient274"
        x1="506.87"
        y1="183.22"
        x2="507.44"
        y2={179}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.28" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5903"
        fill="url(#linearGradient274)"
        stroke="none"
        d="M 504.970001 181.720001 C 504.880005 182.330017 505.720001 182.97998 507.230011 182.98999 C 508.890015 183 509.26001 182.339996 509.119995 181.779999 C 508.299988 178.47998 505.320007 179.460022 504.980011 181.720001 L 504.970001 181.720001 Z"
      />
      <linearGradient
        id="linearGradient275"
        x1="506.08"
        y1="168.2"
        x2="518.42"
        y2="172.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#673024" stopOpacity={1} />
        <stop offset="0.34" stopColor="#52261c" stopOpacity={1} />
        <stop offset="0.68" stopColor="#462017" stopOpacity={1} />
        <stop offset={1} stopColor="#421f16" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5904"
        fill="url(#linearGradient275)"
        stroke="none"
        d="M 516.450012 169.600006 C 515.799988 169.52002 513.669983 169.02002 510.630005 169.669983 C 509.850006 169.839996 509.709991 171.559998 510.549988 171.529999 C 512.119995 171.47998 514.349976 171.210022 515.849976 171.179993 C 518.039978 171.140015 519.169983 171.640015 519.169983 171.640015 C 519.169983 171.640015 517.880005 169.77002 516.440002 169.589996 L 516.450012 169.600006 Z"
      />
      <linearGradient
        id="linearGradient276"
        x1="507.37"
        y1="168.8"
        x2="492.5"
        y2="171.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#673024" stopOpacity={1} />
        <stop offset="0.34" stopColor="#52261c" stopOpacity={1} />
        <stop offset="0.68" stopColor="#462017" stopOpacity={1} />
        <stop offset={1} stopColor="#421f16" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5905"
        fill="url(#linearGradient276)"
        stroke="none"
        d="M 502.470001 169.47998 C 499.429993 168.830017 497.309998 169.330017 496.649994 169.410004 C 495.220001 169.589996 493.920013 171.460022 493.920013 171.460022 C 493.920013 171.460022 495.059998 170.950012 497.23999 171 C 498.73999 171.029999 500.959991 171.299988 502.540009 171.350006 C 503.380005 171.380005 503.23999 169.660004 502.459991 169.48999 L 502.470001 169.47998 Z"
      />
      <linearGradient
        id="linearGradient277"
        x1="509.17"
        y1="192.26"
        x2="508.36"
        y2="195.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5906"
        fill="url(#linearGradient277)"
        stroke="none"
        d="M 501.079987 197.710022 C 501.079987 197.710022 504.790009 200.529999 508.019989 200.200012 C 511.26001 199.869995 512.77002 198.799988 514.590027 197.25 C 514.590027 197.25 512.01001 201.140015 508.100006 201.100006 C 504.190002 201.059998 502.329987 198.950012 501.070007 197.710022 L 501.079987 197.710022 Z"
      />
      <linearGradient
        id="linearGradient278"
        x1="488.99"
        y1="219.28"
        x2="490.69"
        y2="196.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#333333" stopOpacity={1} />
        <stop offset={1} stopColor="#212121" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5907"
        fill="url(#linearGradient278)"
        stroke="none"
        d="M 485.070007 221.460022 C 485.070007 221.460022 490.339996 198.109985 494.410004 197.029999 L 493.970001 198.589996 C 493.970001 198.589996 491.109985 203.130005 488.019989 221.470001 L 485.070007 221.470001 L 485.070007 221.460022 Z"
      />
      <radialGradient
        id="radialGradient111"
        cx="692.08"
        cy="235.19"
        r="18.79"
        fx="692.08"
        fy="235.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5908"
        fill="url(#radialGradient111)"
        stroke="none"
        d="M 696.369995 233.419983 C 691.179993 210.080017 690.390015 210.799988 690.390015 210.799988 C 685.619995 208.070007 681.539978 226.52002 682.289978 235.369995 C 682.48999 237.669998 684.070007 251.979996 684.219971 253.339996 C 690.460022 255.25 695.599976 257.899994 701.950012 259.850006 C 701.619995 257.339996 700.359985 251.389999 696.359985 233.419983 L 696.369995 233.419983 Z"
      />
      <radialGradient
        id="radialGradient112"
        cx="688.4"
        cy="241.35"
        r="12.04"
        fx="688.4"
        fy="241.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5909"
        fill="url(#radialGradient112)"
        stroke="none"
        d="M 681.539978 235.929993 C 681.539978 235.929993 681.969971 228.049988 682.789978 225.77002 C 682.789978 225.77002 682.030029 245.759995 695.289978 256.920013 C 695.289978 256.920013 689.26001 253.25 684.23999 253.440002 C 684.23999 253.440002 681.210022 238.179993 681.539978 235.929993 Z"
      />
      <radialGradient
        id="radialGradient113"
        cx="693.02"
        cy="226.78"
        r={11}
        fx="693.02"
        fy="226.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5910"
        fill="url(#radialGradient113)"
        stroke="none"
        d="M 691.340027 212.98999 C 693.090027 216.039978 697.669983 232.460022 696.549988 238.839996 C 693.75 254.710007 685.539978 202.859985 691.340027 212.98999 Z"
      />
      <path
        id="path5911"
        fill="#908989"
        stroke="none"
        d="M 684.580017 218.559998 C 685.549988 214.539978 686.789978 210.309998 688.190002 208.600006 C 691.400024 210.289978 693.200012 214.130005 693.909973 217.52002 C 694.700012 221.27002 695.280029 224.440002 695.940002 228.429993 C 694.450012 230.119995 682.609985 232.119995 682.609985 232.119995 C 683.369995 226.570007 683.880005 221.470001 684.580017 218.570007 L 684.580017 218.559998 Z"
      />
      <radialGradient
        id="radialGradient114"
        cx="611.57"
        cy="247.43"
        r="29.23"
        fx="611.57"
        fy="247.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5912"
        fill="url(#radialGradient114)"
        stroke="none"
        d="M 627.059998 209.289978 C 625.320007 210.049988 623.72998 210.960022 622.52002 212.100006 C 617.5 216.789978 610.130005 227.830017 608.130005 230.51001 C 606.119995 233.190002 594.400024 242.899994 595.73999 251.600006 C 597.080017 260.299988 623.73999 285.570007 623.73999 285.570007 L 627.080017 276.910004 C 627.080017 276.910004 624.419983 275.119995 618.51001 265.660004 C 616.48999 262.420013 610.140015 249.259995 610.140015 249.259995 C 621.52002 242.899994 626.880005 232.859985 626.880005 232.859985 C 626.880005 232.859985 628.210022 217.630005 627.070007 209.299988 L 627.059998 209.289978 Z"
      />
      <radialGradient
        id="radialGradient115"
        cx="613.97"
        cy="250.7"
        r="16.87"
        fx="613.97"
        fy="250.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5913"
        fill="url(#radialGradient115)"
        stroke="none"
        d="M 601.710022 248.550003 C 601.450012 247.320007 616.400024 243.300003 623.049988 230.220001 L 626.219971 233.940002 C 626.219971 233.940002 621.650024 242.729996 610.130005 249.25 C 610.130005 249.25 615.919983 261.329987 621.419983 270.109985 C 620.919983 270.440002 620.359985 270.929993 619.859985 271.160004 C 618.280029 268.940002 616.630005 266.320007 615 263.480011 C 610.700012 255.970001 601.969971 249.770004 601.710022 248.539993 L 601.710022 248.550003 Z"
      />
      <radialGradient
        id="radialGradient116"
        cx="606.63"
        cy="235.23"
        r="8.66"
        fx="606.63"
        fy="235.23"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5914"
        fill="url(#radialGradient116)"
        stroke="none"
        d="M 610.849976 226.679993 C 610.849976 226.679993 608.440002 230.200012 607.73999 230.960022 C 607.049988 231.720001 599.799988 238.910004 598.080017 242.539993 C 596.359985 246.169998 604.570007 240.789993 606.400024 238.899994 C 608.219971 237.009995 615.390015 230.160004 615.390015 230.160004 L 610.840027 226.679993 L 610.849976 226.679993 Z"
      />
      <radialGradient
        id="radialGradient117"
        cx="607.75"
        cy="263.27"
        r="13.35"
        fx="607.75"
        fy="263.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5915"
        fill="url(#radialGradient117)"
        stroke="none"
        d="M 595.630005 250.789993 C 595.630005 254.229996 597.400024 256.329987 603.77002 264.48999 C 610.659973 273.309998 619.659973 280.309998 619.859985 276.829987 C 620.059998 273.309998 595.630005 240.5 595.630005 250.789993 Z"
      />
      <linearGradient
        id="linearGradient279"
        x1="640.42"
        y1="206.35"
        x2="672.49"
        y2="206.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5916"
        fill="url(#linearGradient279)"
        stroke="none"
        d="M 640.419983 203.559998 C 640.419983 203.559998 645.900024 201.960022 646.969971 200.48999 C 646.969971 200.48999 660.830017 205.119995 666.710022 199.77002 L 672.48999 202.48999 C 672.48999 202.48999 667.280029 213.049988 658.190002 212.910004 C 649.099976 212.779999 640.419983 203.559998 640.419983 203.559998 Z"
      />
      <path
        id="path5917"
        fill="#908989"
        stroke="none"
        d="M 683.080017 229.76001 L 686.590027 229.76001 C 687.340027 224.98999 688.590027 208.839996 688.590027 208.839996 C 686.26001 207.140015 670.47998 201.359985 670.47998 201.359985 C 670.47998 201.359985 668.320007 211.100006 657.26001 211.710022 C 646.210022 212.320007 644.349976 201.859985 644.349976 201.859985 C 624.919983 209.660004 624.869995 209.72998 624.869995 209.72998 C 625.27002 210.539978 626.130005 222.910004 627.26001 229.75 L 630.52002 229.75 C 631.080017 233.049988 631.47998 235.679993 631.549988 236.130005 C 633.419983 248.039993 635.780029 273.390015 635.280029 299.359985 C 637.059998 300.48999 646.659973 302.089996 658.690002 301.149994 C 671.919983 300.119995 677.77002 297.339996 680.440002 295.630005 C 679.280029 276.730011 680.01001 258.470001 682.140015 235.059998 C 682.26001 233.690002 682.619995 231.820007 683.090027 229.73999 L 683.080017 229.76001 Z"
      />
      <radialGradient
        id="radialGradient118"
        cx="657.77"
        cy="209.18"
        r="2.66002"
        fx="657.77"
        fy="209.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5918"
        fill="url(#radialGradient118)"
        stroke="none"
        d="M 654.75 207.589996 L 657.929993 211.410004 L 660.789978 206.950012 L 656.969971 208.859985 L 654.75 207.589996 Z"
      />
      <linearGradient
        id="linearGradient280"
        x1="696.75"
        y1="227.33"
        x2="683.95"
        y2="229.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset="0.49" stopColor="#848282" stopOpacity={1} />
        <stop offset={1} stopColor="#7f7f7f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5919"
        fill="url(#linearGradient280)"
        stroke="none"
        d="M 695.419983 225.309998 L 696.01001 228.549988 C 696.01001 228.549988 693.01001 230.669983 682.619995 232.100006 L 682.919983 228.899994 C 682.919983 228.899994 692.950012 227.369995 695.419983 225.309998 Z"
      />
      <radialGradient
        id="radialGradient119"
        cx="657.69"
        cy="201.6"
        r="13.15"
        fx="657.69"
        fy="201.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5920"
        fill="url(#radialGradient119)"
        stroke="none"
        d="M 667.549988 199.960022 C 667.23999 199.72998 666.940002 197.76001 666.72998 195.880005 C 666.590027 193.410004 666.419983 190.679993 666.369995 190.23999 C 666.369995 190.23999 659.26001 195.369995 646.820007 191.039978 C 646.820007 191.039978 646.820007 195.140015 646.880005 198.559998 C 646.830017 199.339996 646.789978 199.700012 646.719971 200.130005 C 646.590027 201.070007 642.960022 202.47998 642.960022 202.47998 C 642.960022 202.47998 644.429993 212.100006 656.590027 212.899994 C 668.75 213.700012 672.419983 202.190002 672.419983 202.190002 C 672.419983 202.190002 668.090027 200.339996 667.549988 199.940002 L 667.549988 199.960022 Z M 657.200012 210.720001 C 648.219971 211.02002 645.909973 203.710022 645.909973 203.710022 C 645.909973 203.710022 646.97998 202.910004 647.51001 202.640015 C 647.880005 202.460022 648.099976 201.789978 648.23999 201.080017 C 651.289978 203.899994 654.840027 205.580017 656.869995 205.399994 C 659.109985 205.200012 662.570007 203.580017 665.130005 201.660004 L 668.219971 204.049988 C 665.609985 209.460022 659.200012 210.660004 657.200012 210.72998 L 657.200012 210.720001 Z"
      />
      <linearGradient
        id="linearGradient281"
        x1="657.39"
        y1="216.42"
        x2="657.21"
        y2="198.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset="0.49" stopColor="#848282" stopOpacity={1} />
        <stop offset={1} stopColor="#7f7f7f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5921"
        fill="url(#linearGradient281)"
        stroke="none"
        d="M 644.349976 201.869995 C 644.349976 201.869995 646.630005 211.910004 657.330017 211.450012 C 668.150024 210.97998 670.47998 201.359985 670.47998 201.359985 L 673.219971 202.380005 C 673.219971 202.380005 669.159973 215.850006 656.059998 215.049988 C 642.969971 214.25 641.299988 203.089996 641.299988 203.089996 L 644.349976 201.859985 L 644.349976 201.869995 Z"
      />
      <linearGradient
        id="linearGradient282"
        x1="656.14"
        y1="241.24"
        x2="657.58"
        y2="208.29"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset={1} stopColor="#919191" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5922"
        fill="url(#linearGradient282)"
        stroke="none"
        d="M 636.070007 219.059998 C 642.900024 215.039978 646.849976 216.289978 657.48999 216.589996 C 668.130005 216.890015 674.969971 214.779999 678.780029 218.600006 C 682.599976 222.419983 681.099976 238.240005 659.700012 239.690002 C 634.539978 241.399994 629.23999 223.070007 636.070007 219.059998 Z"
      />
      <linearGradient
        id="linearGradient283"
        x1="682.22"
        y1="262.07"
        x2="680.99"
        y2="220.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset="0.49" stopColor="#848282" stopOpacity={1} />
        <stop offset={1} stopColor="#7f7f7f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5923"
        fill="url(#linearGradient283)"
        stroke="none"
        d="M 683.070007 230.789978 C 683.169983 228.559998 683.599976 225.279999 683.27002 224.369995 C 682.940002 223.470001 683 226.380005 681.969971 230.710022 C 681.390015 233.130005 680.580017 236.279999 679.450012 240.210007 C 678.669983 242.910004 682.619995 260.630005 682.619995 260.630005 C 682.619995 260.630005 682.460022 257 682.330017 252.259995 C 682.27002 250.070007 682.650024 239.979996 683.080017 230.779999 L 683.070007 230.789978 Z"
      />
      <path
        id="path5924"
        fill="#908989"
        stroke="none"
        d="M 610.960022 225.700012 C 610.960022 225.700012 617.679993 216.25 619.880005 213.809998 C 622.059998 211.380005 623.890015 210.200012 624.869995 209.75 C 625.849976 209.299988 632 231.660004 632 231.660004 L 624.460022 237.529999 L 610.960022 225.700012 Z"
      />
      <path
        id="path5925"
        fill="#908989"
        stroke="none"
        d="M 624.460022 237.520004 L 622.679993 236.039978 C 622.679993 236.039978 629.109985 231.140015 630.809998 230.72998 C 632.099976 230.419983 635.210022 249.300003 632.419983 268.940002 C 632.419983 268.940002 632.859985 253.820007 627.52002 235.429993 C 626.5 236.190002 624.460022 237.520004 624.460022 237.520004 Z"
      />
      <linearGradient
        id="linearGradient284"
        x1="635.89"
        y1="190.14"
        x2="632.58"
        y2="250.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset={1} stopColor="#919191" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5926"
        fill="url(#linearGradient284)"
        stroke="none"
        d="M 630.820007 250.110001 C 630.820007 250.110001 631.25 253.25 631.25 253.740005 C 631.25 253.740005 635.210022 243.259995 635.309998 242.419998 C 635.409973 241.589996 637.890015 224.220001 637.890015 224.220001 L 632.77002 206.52002 L 631.090027 207.200012 C 631.090027 207.200012 634.929993 223.799988 634.869995 224.210022 C 634.809998 224.619995 630.820007 250.110001 630.820007 250.110001 Z"
      />
      <linearGradient
        id="linearGradient285"
        x1="681.92"
        y1="188.46"
        x2="678.49"
        y2="251.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset="0.49" stopColor="#848282" stopOpacity={1} />
        <stop offset={1} stopColor="#7f7f7f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5927"
        fill="url(#linearGradient285)"
        stroke="none"
        d="M 681.599976 205.630005 L 683.75 206.52002 L 678.25 224.419983 L 682.549988 243.089996 L 682.400024 254.820007 L 675.830017 225.609985 L 681.599976 205.630005 Z"
      />
      <path
        id="path5928"
        fill="#1b2c60"
        stroke="none"
        d="M 636.320007 343.660004 C 642.320007 343.540009 648.330017 343.429993 654.330017 343.309998 C 654.090027 336.339996 653.919983 331.320007 653.919983 331.320007 C 653.919983 331.320007 659.98999 319.040009 659.75 313.26001 C 659.5 303.899994 661.059998 289.890015 659.909973 280.359985 C 650.640015 279.51001 641.799988 281.940002 632.97998 278.769989 L 632.97998 278.869995 C 632.659973 283.809998 628.070007 299.369995 627.880005 302.649994 C 627.51001 309.269989 627.719971 328.869995 627.960022 344.350006 C 630.73999 343.970001 633.539978 343.730011 636.330017 343.670013 L 636.320007 343.660004 Z"
      />
      <path
        id="path5929"
        fill="#1b2c60"
        stroke="none"
        d="M 663.559998 333.109985 C 663.559998 333.109985 663.76001 337.200012 664.039978 343.130005 C 672.830017 342.959991 681.619995 342.790009 690.419983 342.619995 C 689.390015 327.399994 688.030029 308.769989 687.140015 302.390015 C 686.690002 299.130005 680.820007 284.01001 680.109985 279.109985 L 680.109985 279.01001 C 671.559998 282.899994 662.590027 278.76001 653.429993 280.369995 C 653.070007 289.970001 658.109985 302.390015 658.640015 311.73999 C 658.880005 317.529999 663.559998 333.119995 663.559998 333.119995 L 663.559998 333.109985 Z"
      />
      <linearGradient
        id="linearGradient286"
        x1="657.9"
        y1="327.84"
        x2="655.45"
        y2="280.59"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5930"
        fill="url(#linearGradient286)"
        stroke="none"
        d="M 656.73999 280.570007 L 658.630005 311.730011 L 654.969971 301.600006 L 656.73999 280.570007 Z"
      />
      <linearGradient
        id="linearGradient287"
        x1="653.66"
        y1="281.44"
        x2="662.22"
        y2="359.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5931"
        fill="url(#linearGradient287)"
        stroke="none"
        d="M 656.22998 343.269989 L 657.559998 324.459991 L 660.349976 323.329987 L 662.960022 343.140015 L 664.419983 343.109985 L 663.969971 319.190002 L 658.799988 314.140015 L 653.400024 322.160004 L 654.25 343.309998 C 654.909973 343.299988 655.570007 343.279999 656.22998 343.269989 Z"
      />
      <linearGradient
        id="linearGradient288"
        x1="637.767"
        y1="312.507"
        x2="652.185"
        y2="402.529"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5932"
        fill="url(#linearGradient288)"
        stroke="none"
        d="M 636.320007 343.660004 C 640.700012 343.579987 645.070007 343.48999 649.450012 343.410004 C 650.309998 325.109985 647.77002 304.519989 643.02002 305.399994 C 637.75 306.369995 633.5 326.220001 632.880005 343.820007 C 634.030029 343.73999 635.169983 343.690002 636.320007 343.670013 L 636.320007 343.660004 Z"
      />
      <linearGradient
        id="linearGradient289"
        x1="656.77"
        y1="296.59"
        x2="665.09"
        y2="332.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5933"
        fill="url(#linearGradient289)"
        stroke="none"
        d="M 657.539978 293.820007 L 658.799988 314.149994 L 663.969971 319.200012 C 663.969971 319.200012 661.359985 314.529999 660.609985 313.390015 C 659.859985 312.25 657.539978 293.820007 657.539978 293.820007 Z"
      />
      <linearGradient
        id="linearGradient290"
        x1="678.496"
        y1="312.791"
        x2="671.566"
        y2="403.695"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5934"
        fill="url(#linearGradient290)"
        stroke="none"
        d="M 685.900024 342.700012 C 683.73999 325.459991 677.97998 306.690002 672.73999 306.170013 C 668.070007 305.700012 667.150024 325.25 669.27002 343.029999 C 674.809998 342.920013 680.359985 342.820007 685.900024 342.709991 L 685.900024 342.700012 Z"
      />
      <path
        id="path5935"
        fill="#1b2c60"
        stroke="none"
        d="M 639.799988 280.410004 C 654.799988 283.140015 669.47998 285.230011 684.070007 284.51001 C 683.710022 282.359985 683.460022 280.829987 683.400024 280.450012 C 682 271.48999 681.299988 252.649994 681.299988 252.649994 L 677.01001 225.309998 L 682.76001 205.98999 L 676.320007 203.410004 L 670.289978 223.47998 L 644.450012 223.47998 L 638.48999 204.070007 L 631.789978 206.820007 C 631.789978 206.820007 635.539978 220.789978 635.929993 225.299988 C 636.320007 229.809998 631.859985 250.229996 631.080017 252.830002 C 631.080017 252.830002 631.820007 273.23999 631.849976 278.190002 C 631.849976 278.709991 631.809998 279.350006 631.75 280.070007 C 634.52002 280.040009 637.02002 279.779999 639.820007 280.399994 L 639.799988 280.410004 Z"
      />
      <linearGradient
        id="linearGradient291"
        x1="654.51"
        y1="253.51"
        x2="656.93"
        y2="225.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5936"
        fill="url(#linearGradient291)"
        stroke="none"
        d="M 638.840027 232.940002 C 638.570007 230.619995 643.650024 226.850006 660.5 228.76001 C 664.559998 229.220001 672.359985 230.369995 673.599976 231.929993 C 674.849976 233.48999 670.349976 250.110001 656.219971 250.820007 C 642.090027 251.529999 639.02002 234.5 638.840027 232.940002 Z"
      />
      <linearGradient
        id="linearGradient292"
        x1="656.25"
        y1="257.37"
        x2="657.53"
        y2="228.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5937"
        fill="url(#linearGradient292)"
        stroke="none"
        d="M 641.570007 232.049988 C 641.570007 232.049988 666.700012 233.640015 673.169983 232.190002 C 673.169983 232.190002 647.080017 231.910004 641.570007 232.049988 Z"
      />
      <linearGradient
        id="linearGradient293"
        x1="656.33"
        y1="256.31"
        x2="657.55"
        y2="228.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5938"
        fill="url(#linearGradient293)"
        stroke="none"
        d="M 641.570007 234.390015 L 641.570007 241.119995 L 673.030029 241.119995 L 673.030029 235.149994 L 673.960022 242.179993 L 639.950012 242.160004 L 641.570007 234.390015 Z"
      />
      <linearGradient
        id="linearGradient294"
        x1="639.99"
        y1="216.36"
        x2="674.84"
        y2="216.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5939"
        fill="url(#linearGradient294)"
        stroke="none"
        d="M 639.98999 208.98999 L 644.690002 224.309998 C 644.690002 224.309998 670.97998 224.669983 671.5 224.070007 C 672.02002 223.47998 674.840027 208.289978 674.840027 208.289978 L 670.280029 223.470001 L 645.219971 223.52002 L 639.97998 208.97998 L 639.98999 208.98999 Z"
      />
      <linearGradient
        id="linearGradient295"
        x1="635.91"
        y1="212.81"
        x2="635.47"
        y2="204.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5940"
        fill="url(#linearGradient295)"
        stroke="none"
        d="M 631.780029 206.830017 L 638.47998 204.070007 L 639.450012 207.22998 L 632.619995 210.059998 L 631.780029 206.830017 Z"
      />
      <linearGradient
        id="linearGradient296"
        x1="679.35"
        y1="212.44"
        x2="678.88"
        y2="203.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5941"
        fill="url(#linearGradient296)"
        stroke="none"
        d="M 675.320007 206.710022 L 676.320007 203.410004 L 682.75 205.98999 L 681.799988 209.190002 L 675.320007 206.710022 Z"
      />
      <linearGradient
        id="linearGradient297"
        x1="660.28"
        y1="241.01"
        x2="704.18"
        y2="287.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5942"
        fill="url(#linearGradient297)"
        stroke="none"
        d="M 660 254.100006 C 659.599976 258.48999 659.580017 262.390015 659.580017 262.390015 L 681.840027 262.390015 C 681.840027 262.390015 681.900024 256.799988 681.969971 251.119995 C 680.869995 247.089996 680.190002 242.770004 678.98999 238.800003 C 676.659973 249.490005 676.690002 254.460007 660 254.110001 L 660 254.100006 Z"
      />
      <linearGradient
        id="linearGradient298"
        x1="631.68"
        y1="216.24"
        x2="633.21"
        y2="301.27"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5943"
        fill="url(#linearGradient298)"
        stroke="none"
        d="M 633.73999 214.549988 C 633.73999 214.549988 635.840027 223.75 635.909973 225.299988 C 635.73999 226.859985 632.299988 248.289993 631.059998 252.830002 L 631.280029 278.190002 C 631.280029 278.190002 627.549988 295.51001 627.869995 302.630005 C 627.869995 302.630005 634.200012 278.98999 633.859985 276.899994 C 633.52002 274.809998 633.72998 254.880005 633.840027 254.210007 C 633.950012 253.539993 637.080017 228.309998 637.200012 226.029999 C 637.23999 225.320007 633.72998 214.549988 633.72998 214.549988 L 633.73999 214.549988 Z"
      />
      <linearGradient
        id="linearGradient299"
        x1="680.63"
        y1="216.37"
        x2="682.17"
        y2="302.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5944"
        fill="url(#linearGradient299)"
        stroke="none"
        d="M 679.820007 215.830017 L 677 225.299988 C 677 225.299988 682.330017 250.429993 682.539978 253.220001 C 682.619995 254.289993 683.27002 277.880005 683.320007 278.869995 C 683.400024 280.440002 687.140015 302.359985 687.140015 302.359985 C 687.140015 302.359985 679.700012 279.429993 679.700012 278.160004 C 679.700012 276.890015 679.440002 253.589996 679.440002 252.990005 C 679.440002 252.389999 675.830017 226.160004 675.830017 225.600006 C 675.830017 225.039978 679.820007 215.820007 679.820007 215.820007 L 679.820007 215.830017 Z"
      />
      <linearGradient
        id="linearGradient300"
        x1="656.17"
        y1="221.58"
        x2="657.63"
        y2="302.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5945"
        fill="url(#linearGradient300)"
        stroke="none"
        d="M 631.289978 278.190002 C 631.289978 278.190002 647.809998 281.660004 683.099976 278.640015 C 683.099976 278.640015 650.590027 278.700012 631.289978 278.190002 Z"
      />
      <linearGradient
        id="linearGradient301"
        x1="630.44"
        y1="283.45"
        x2="640.1"
        y2="283.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5946"
        fill="url(#linearGradient301)"
        stroke="none"
        d="M 630.440002 288.019989 C 630.440002 288.019989 635.419983 285.980011 636.799988 285.059998 C 638.179993 284.149994 640.099976 278.880005 640.099976 278.880005 L 635.98999 283.51001 L 630.440002 288.019989 Z"
      />
      <linearGradient
        id="linearGradient302"
        x1="684.46"
        y1="283.45"
        x2="674.28"
        y2="283.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5947"
        fill="url(#linearGradient302)"
        stroke="none"
        d="M 684.460022 288.019989 C 684.460022 288.019989 678.960022 285.980011 677.590027 285.059998 C 676.210022 284.149994 674.289978 278.880005 674.289978 278.880005 L 678.400024 283.51001 L 684.460022 288.019989 Z"
      />
      <linearGradient
        id="linearGradient303"
        x1="678.24"
        y1="305.27"
        x2="679.68"
        y2="277.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5948"
        fill="url(#linearGradient303)"
        stroke="none"
        d="M 674.289978 278.880005 C 674.289978 278.880005 676.76001 284.600006 677.590027 285.059998 C 678.419983 285.519989 684.460022 288.019989 684.460022 288.019989 C 684.460022 288.019989 676.400024 286.769989 675.98999 285.959991 C 675.590027 285.149994 674.280029 278.880005 674.280029 278.880005 L 674.289978 278.880005 Z"
      />
      <linearGradient
        id="linearGradient304"
        x1="634.24"
        y1="303.27"
        x2="635.69"
        y2="275.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5949"
        fill="url(#linearGradient304)"
        stroke="none"
        d="M 630.440002 288.019989 C 630.440002 288.019989 635.960022 286 636.799988 285.059998 C 637.640015 284.119995 640.099976 278.880005 640.099976 278.880005 C 640.099976 278.880005 639.359985 285.480011 638.179993 286.119995 C 637 286.76001 630.440002 288.019989 630.440002 288.019989 Z"
      />
      <linearGradient
        id="linearGradient305"
        x1="650.54"
        y1="250.12"
        x2="693.95"
        y2="296.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5950"
        fill="url(#linearGradient305)"
        stroke="none"
        d="M 669.27002 258.170013 L 663.929993 258.059998 C 663.929993 258.059998 662.679993 256.75 661.619995 255.630005 C 660.909973 254.860001 660.25 254.119995 660.01001 253.759995 C 659.590027 253.130005 657.940002 250.440002 657.940002 250.440002 L 655.450012 247.270004 C 655.059998 246.649994 654.75 246.119995 654.669983 245.889999 C 654.669983 245.889999 654.380005 243.139999 653.76001 242.860001 C 653.690002 242.830002 653.619995 242.820007 653.559998 242.830002 C 653.349976 242.779999 653.039978 242.779999 652.700012 242.940002 C 652.409973 243.080002 652.109985 243.320007 651.859985 243.720001 C 651.650024 244.039993 651.440002 244.479996 651.289978 245.119995 C 650.940002 246.600006 651.039978 247.979996 652.090027 249.990005 C 652.48999 250.75 653.359985 252.350006 653.359985 252.779999 C 653.359985 253.160004 652.48999 254.210007 652.309998 254.429993 L 651.400024 254.899994 C 651.400024 254.899994 650.539978 255.020004 649.530029 255.169998 L 649.609985 255.149994 C 649.609985 255.149994 647.359985 255.479996 646.630005 255.610001 C 646.559998 255.619995 646.51001 255.630005 646.47998 255.639999 C 646.01001 255.75 645.320007 256.269989 645.23999 257.190002 C 645.200012 257.700012 645.340027 258.209991 645.539978 258.600006 C 645.539978 258.600006 645.559998 258.630005 645.590027 258.679993 C 645.73999 258.950012 645.909973 259.149994 646.049988 259.23999 C 646.049988 259.23999 645.320007 259.769989 645.5 261.040009 C 645.580017 261.600006 645.73999 262.029999 645.890015 262.350006 L 645.940002 262.429993 C 646.039978 262.619995 646.130005 262.76001 646.190002 262.850006 C 646.219971 262.899994 646.25 262.940002 646.27002 262.950012 C 646.27002 262.950012 646.22998 262.980011 646.179993 263.040009 C 645.98999 263.25 645.580017 263.839996 645.830017 264.75 C 646.070007 265.600006 646.539978 266.109985 646.780029 266.329987 L 646.799988 266.350006 C 646.880005 266.420013 646.929993 266.450012 646.929993 266.450012 C 646.929993 266.450012 646.75 267.720001 646.820007 268.140015 C 646.859985 268.380005 647.549988 269.029999 648.23999 269.600006 C 648.799988 270.079987 649.349976 270.480011 649.539978 270.570007 C 649.97998 270.779999 651.5 271.100006 651.940002 271.100006 L 657.609985 271.100006 C 657.679993 271.100006 657.77002 271.089996 657.859985 271.070007 C 660.23999 271.190002 666.469971 271.209991 668.590027 272.130005 L 683.109985 272.75 L 683.109985 262.670013 L 669.280029 258.190002 L 669.27002 258.170013 Z"
      />
      <linearGradient
        id="linearGradient306"
        x1="606.69"
        y1="215.34"
        x2="625.1"
        y2="238.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#908989" stopOpacity={1} />
        <stop offset="0.49" stopColor="#848282" stopOpacity={1} />
        <stop offset={1} stopColor="#7f7f7f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5951"
        fill="url(#linearGradient306)"
        stroke="none"
        d="M 624.460022 237.520004 L 627.059998 235.76001 C 627.059998 235.76001 613.73999 223.660004 612.98999 222.869995 C 612.98999 222.869995 611.47998 224.929993 610.960022 225.690002 C 610.960022 225.690002 622.969971 236.339996 624.460022 237.520004 Z"
      />
      <radialGradient
        id="radialGradient120"
        cx="631.51"
        cy="284.52"
        r="13.32"
        fx="631.51"
        fy="284.52"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5952"
        fill="url(#radialGradient120)"
        stroke="none"
        d="M 622.549988 272.730011 C 622.549988 272.730011 625.72998 275.940002 626.72998 276.51001 C 627.72998 277.079987 633.890015 278.390015 634.640015 278.549988 C 635.390015 278.709991 639.359985 279.76001 640.830017 280.660004 C 642.299988 281.559998 644.929993 283.5 645.73999 284.459991 C 646.190002 285 646.460022 285.549988 645.840027 286.100006 C 645.22998 286.660004 644.22998 286.350006 643.280029 285.519989 C 642.690002 285.01001 640.150024 283.869995 638.940002 283.390015 C 637.72998 282.910004 635.789978 282.869995 635.409973 283.029999 C 634.570007 283.390015 637.830017 285.820007 638.950012 287.130005 C 640.049988 288.410004 642.030029 290.309998 642.590027 290.920013 C 643.159973 291.529999 644.460022 293.029999 643.440002 293.929993 C 642.419983 294.820007 640.309998 292.329987 638.909973 291.329987 C 637.369995 290.230011 633.76001 286.26001 632.52002 285.809998 C 631.549988 285.470001 634.76001 288.730011 635.609985 289.540009 C 636.460022 290.350006 640.130005 293.790009 640.130005 293.790009 C 640.130005 293.790009 641.309998 295.040009 640.460022 295.869995 C 639.27002 297.029999 637.640015 295.029999 636.429993 294 C 635.599976 293.290009 632.130005 290.429993 631.820007 290.160004 C 631.51001 289.890015 630.059998 288.48999 629.710022 288.640015 C 628.849976 289 632.400024 292.420013 632.719971 292.790009 C 633.669983 293.869995 634.440002 294.790009 634.549988 295.309998 C 634.76001 296.309998 634 296.48999 633.22998 296.119995 C 632.460022 295.75 631.049988 294.690002 630.799988 294.350006 C 630.549988 294 625.73999 289.230011 624.530029 287.929993 C 623.320007 286.630005 619.73999 284.059998 619.030029 281.059998 C 618.700012 279.660004 617.369995 278.779999 616.830017 278.459991 L 622.570007 272.720001 L 622.549988 272.730011 Z"
      />
      <radialGradient
        id="radialGradient121"
        cx="637.87"
        cy="293.66"
        r="2.56"
        fx="637.87"
        fy="293.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5953"
        fill="url(#radialGradient121)"
        stroke="none"
        d="M 640.280029 294.350006 C 640.01001 293.970001 637.619995 292.01001 637.25 291.690002 C 636.330017 290.890015 633.950012 291.049988 635.97998 293.140015 C 638.419983 295.660004 639.47998 296.130005 639.77002 296.059998 C 640.059998 296 641.030029 295.399994 640.280029 294.339996 L 640.280029 294.350006 Z"
      />
      <radialGradient
        id="radialGradient122"
        cx="639.41"
        cy="294.9"
        r="1.10999"
        fx="639.41"
        fy="294.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5954"
        fill="url(#radialGradient122)"
        stroke="none"
        d="M 638.340027 294.200012 C 638.52002 293.769989 639.070007 293.660004 639.539978 294 C 639.73999 294.149994 640.460022 294.720001 640.5 295.079987 C 640.559998 295.559998 640.049988 295.920013 639.969971 295.920013 C 639.830017 295.929993 639.469971 296.179993 639.039978 295.700012 C 638.609985 295.209991 638.130005 294.679993 638.330017 294.190002 L 638.340027 294.200012 Z"
      />
      <radialGradient
        id="radialGradient123"
        cx="626.03"
        cy="282.6"
        r="5.68999"
        fx="626.03"
        fy="282.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5955"
        fill="url(#radialGradient123)"
        stroke="none"
        d="M 619.859985 279.570007 C 618.700012 280.200012 623.919983 287.809998 625.130005 287.549988 C 626.01001 287.359985 633.22998 278.579987 632.27002 278.329987 C 630.400024 277.850006 627.349976 277.640015 627.349976 277.640015 C 627.52002 279.570007 620.75 279.079987 619.859985 279.570007 Z"
      />
      <radialGradient
        id="radialGradient124"
        cx="628.32"
        cy="274.62"
        r="6.77001"
        fx="628.32"
        fy="274.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5956"
        fill="url(#radialGradient124)"
        stroke="none"
        d="M 626.900024 276.600006 C 629.570007 277.640015 634.700012 278.429993 636.77002 279.119995 C 636.77002 279.119995 629.619995 278.929993 626.679993 277.950012 C 624.859985 277.339996 622.450012 274.799988 619.869995 271.170013 C 620.369995 270.940002 620.929993 270.450012 621.429993 270.119995 C 623.75 273.290009 625.909973 276.209991 626.909973 276.600006 L 626.900024 276.600006 Z"
      />
      <radialGradient
        id="radialGradient125"
        cx="623.03"
        cy="285.38"
        r="10.48"
        fx="623.03"
        fy="285.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5957"
        fill="url(#radialGradient125)"
        stroke="none"
        d="M 612.830017 274.619995 C 612.830017 274.619995 619.570007 279.309998 619.859985 279.570007 C 620.150024 279.829987 621.130005 283.130005 623.929993 286.23999 C 626.72998 289.350006 633.219971 296.140015 633.219971 296.140015 C 633.219971 296.140015 631.609985 295.480011 629.390015 292.980011 C 626.950012 290.230011 621.289978 285.290009 620.330017 283.920013 C 618.969971 281.970001 619.320007 281.179993 617.359985 279.299988 C 615.400024 277.420013 614.609985 276.519989 612.830017 274.630005 L 612.830017 274.619995 Z"
      />
      <radialGradient
        id="radialGradient126"
        cx="639.42"
        cy="284.87"
        r="5.2"
        fx="639.42"
        fy="284.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5958"
        fill="url(#radialGradient126)"
        stroke="none"
        d="M 645.849976 286.109985 C 645.849976 286.109985 644.650024 286.75 642.140015 284.519989 C 639.77002 282.420013 638.469971 281.679993 637.590027 281.579987 C 636.710022 281.480011 633.390015 281.160004 633 281.380005 C 632.609985 281.609985 639.380005 288.070007 640.150024 288.410004 C 638.059998 285.76001 634.809998 283.48999 635.450012 283.070007 C 635.76001 282.869995 637.840027 282.910004 638.960022 283.380005 C 640.080017 283.850006 643.919983 286.160004 644.48999 286.309998 C 645.059998 286.459991 645.47998 286.51001 645.869995 286.100006 L 645.849976 286.109985 Z"
      />
      <radialGradient
        id="radialGradient127"
        cx="636.14"
        cy="288.76"
        r="5.02001"
        fx="636.14"
        fy="288.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5959"
        fill="url(#radialGradient127)"
        stroke="none"
        d="M 641.460022 293.450012 C 641.460022 293.450012 636.590027 288.980011 636.27002 288.640015 C 635.409973 287.709991 632.210022 284.459991 631.190002 284.109985 C 629.919983 283.670013 632.130005 286.339996 633.48999 287.820007 C 634.659973 289.109985 637.130005 290.970001 637.130005 290.970001 C 637.130005 290.970001 633.140015 286.899994 632.75 286.440002 C 631.890015 285.429993 632.75 285.839996 633.369995 286.440002 C 633.940002 286.98999 639.25 292.140015 641.460022 293.440002 L 641.460022 293.450012 Z"
      />
      <radialGradient
        id="radialGradient128"
        cx="631.87"
        cy="290.11"
        r="3.29"
        fx="631.87"
        fy="290.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5960"
        fill="url(#radialGradient128)"
        stroke="none"
        d="M 635.390015 293.140015 C 635.390015 293.140015 630.289978 287.910004 629.099976 287.220001 C 628.119995 286.660004 628 287.76001 629.26001 289.26001 C 630.530029 290.769989 632.710022 292.790009 632.710022 292.790009 C 632.710022 292.790009 629.320007 289.329987 629.580017 288.73999 C 629.780029 288.299988 632.789978 291.140015 635.380005 293.130005 L 635.390015 293.140015 Z"
      />
      <radialGradient
        id="radialGradient129"
        cx="640.9"
        cy="291.26"
        r="2.67"
        fx="640.9"
        fy="291.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5961"
        fill="url(#radialGradient129)"
        stroke="none"
        d="M 643.280029 292.140015 C 643.01001 291.769989 640.289978 289.320007 639.919983 289.01001 C 638.98999 288.23999 637.039978 288.589996 639.080017 290.619995 C 641.530029 293.059998 642.719971 293.950012 643.02002 293.890015 C 643.320007 293.829987 644.039978 293.160004 643.280029 292.130005 L 643.280029 292.140015 Z"
      />
      <radialGradient
        id="radialGradient130"
        cx="642.46"
        cy="292.79"
        r="1.11002"
        fx="642.46"
        fy="292.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5962"
        fill="url(#radialGradient130)"
        stroke="none"
        d="M 641.390015 292.089996 C 641.570007 291.660004 642.119995 291.549988 642.590027 291.890015 C 642.789978 292.040009 643.51001 292.609985 643.549988 292.970001 C 643.609985 293.450012 643.099976 293.809998 643.02002 293.809998 C 642.880005 293.820007 642.52002 294.070007 642.090027 293.589996 C 641.659973 293.100006 641.179993 292.570007 641.380005 292.079987 L 641.390015 292.089996 Z"
      />
      <radialGradient
        id="radialGradient131"
        cx="643.07"
        cy="283.54"
        r="2.52002"
        fx="643.07"
        fy="283.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5963"
        fill="url(#radialGradient131)"
        stroke="none"
        d="M 642.039978 281.690002 C 641.780029 281.549988 640.840027 281.019989 640.380005 281.540009 C 639.690002 282.329987 642.919983 284.619995 643.539978 285.200012 C 644.440002 286.029999 646.72998 286.059998 645.47998 284.519989 C 644.23999 282.980011 642.299988 281.829987 642.030029 281.690002 L 642.039978 281.690002 Z"
      />
      <radialGradient
        id="radialGradient132"
        cx="644.99"
        cy="285.18"
        r="1.17001"
        fx="644.99"
        fy="285.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5964"
        fill="url(#radialGradient132)"
        stroke="none"
        d="M 644.039978 284.290009 C 644.309998 284.059998 644.780029 283.920013 645.219971 284.290009 C 645.659973 284.660004 646.190002 285.079987 646.219971 285.48999 C 646.25 285.869995 645.809998 286.380005 645.190002 286.26001 C 644.950012 286.209991 643.799988 285.459991 643.76001 284.940002 C 643.73999 284.720001 643.849976 284.440002 644.030029 284.279999 L 644.039978 284.290009 Z"
      />
      <radialGradient
        id="radialGradient133"
        cx="633.02"
        cy="294.6"
        r="1.48"
        fx="633.02"
        fy="294.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5965"
        fill="url(#radialGradient133)"
        stroke="none"
        d="M 631.859985 293.140015 C 631.530029 293.459991 631.359985 294.350006 633.690002 296.130005 C 634.109985 296.450012 634.76001 295.549988 634.049988 294.640015 C 633.869995 294.399994 632.530029 292.5 631.859985 293.149994 L 631.859985 293.140015 Z"
      />
      <radialGradient
        id="radialGradient134"
        cx="633.68"
        cy="295.3"
        r="0.859983"
        fx="633.68"
        fy="295.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5966"
        fill="url(#radialGradient134)"
        stroke="none"
        d="M 633.200012 294.410004 C 633.5 294.320007 633.969971 294.73999 634.330017 295.279999 C 634.690002 295.820007 634.330017 296.220001 633.940002 296.209991 C 633.609985 296.200012 632.859985 295.179993 632.859985 294.959991 C 632.859985 294.73999 632.859985 294.51001 633.190002 294.420013 L 633.200012 294.410004 Z"
      />
      <radialGradient
        id="radialGradient135"
        cx="685.59"
        cy="260.86"
        r="12.78"
        fx="685.59"
        fy="260.86"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5967"
        fill="url(#radialGradient135)"
        stroke="none"
        d="M 684.23999 253.440002 C 678.880005 255.970001 669.109985 256.399994 669.109985 256.399994 C 669.76001 259.559998 669.51001 266.809998 669.51001 266.809998 C 669.51001 266.809998 675.98999 267.579987 681.109985 267.579987 C 689.059998 267.579987 697.539978 268.880005 699.23999 267.929993 C 699.960022 267.529999 702.059998 262.76001 702.059998 261.149994 C 702.059998 260.829987 702.030029 260.429993 701.950012 259.839996 C 687.76001 252.889999 684.22998 253.440002 684.22998 253.440002 L 684.23999 253.440002 Z"
      />
      <radialGradient
        id="radialGradient136"
        cx="683.73"
        cy="260.19"
        r="9.99002"
        fx="683.73"
        fy="260.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5968"
        fill="url(#radialGradient136)"
        stroke="none"
        d="M 670.369995 257.399994 C 670.369995 257.399994 692.23999 252.580002 696.919983 258.589996 C 699.559998 261.980011 670.5 264.799988 670.5 264.799988 L 670.369995 257.390015 L 670.369995 257.399994 Z"
      />
      <radialGradient
        id="radialGradient137"
        cx="659.92"
        cy="255.25"
        r="13.06"
        fx="659.92"
        fy="255.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5969"
        fill="url(#radialGradient137)"
        stroke="none"
        d="M 669.109985 256.410004 L 664.219971 256.309998 C 664.219971 256.309998 661.619995 253.509995 660.929993 252.720001 C 660.22998 251.919998 658.929993 249.229996 658.330017 248.729996 C 657.72998 248.229996 655.929993 245.440002 655.72998 244.839996 C 655.530029 244.240005 655.159973 242.210007 654.869995 242.009995 C 654.570007 241.809998 653.340027 241.809998 652.840027 243.539993 C 652.47998 244.800003 652.340027 247.330002 654.73999 249.729996 L 654.440002 252.429993 L 652.73999 253.330002 C 652.73999 253.330002 648.650024 253.929993 648.25 254.029999 C 647.849976 254.130005 647.049988 254.729996 647.150024 255.630005 C 647.25 256.529999 647.849976 257.429993 647.849976 257.429993 C 647.849976 257.429993 647.349976 257.929993 647.349976 258.929993 C 647.349976 259.929993 648.049988 260.929993 648.049988 260.929993 C 648.049988 260.929993 647.549988 261.329987 647.650024 262.329987 C 647.75 263.329987 648.650024 264.230011 648.650024 264.230011 C 648.650024 264.230011 648.549988 265.029999 648.549988 265.630005 C 648.549988 266.230011 650.650024 267.929993 651.049988 268.130005 C 651.450012 268.329987 652.849976 268.630005 653.25 268.630005 L 658.440002 268.630005 C 659.23999 268.630005 662.26001 266.859985 663.159973 266.76001 C 664.059998 266.660004 672.700012 266.970001 672.700012 266.970001 L 669.119995 256.459991 L 669.109985 256.410004 Z"
      />
      <radialGradient
        id="radialGradient138"
        cx="655.01"
        cy="247.46"
        r="4.24002"
        fx="655.01"
        fy="247.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5970"
        fill="url(#radialGradient138)"
        stroke="none"
        d="M 653.539978 252.899994 C 653.539978 252.899994 656.539978 251.520004 657.539978 251.720001 C 657.539978 251.720001 654.940002 247.830002 654.450012 246.929993 C 653.950012 246.029999 653.150024 244.429993 653.950012 242.039993 C 653.929993 242.100006 653.080017 242.149994 652.650024 244.100006 C 652.340027 245.490005 652.419983 246.800003 653.380005 248.690002 C 653.73999 249.410004 654.539978 250.919998 654.539978 251.320007 C 654.539978 251.720001 653.539978 252.899994 653.539978 252.899994 Z"
      />
      <radialGradient
        id="radialGradient139"
        cx="655.02"
        cy="243.46"
        r="1.20002"
        fx="655.02"
        fy="243.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5971"
        fill="url(#radialGradient139)"
        stroke="none"
        d="M 654.900024 241.960007 C 655.469971 242.229996 655.72998 244.820007 655.72998 244.820007 C 655.72998 244.820007 654.429993 245.449997 654.330017 244.25 C 654.22998 243.050003 654.330017 241.690002 654.900024 241.949997 L 654.900024 241.960007 Z"
      />
      <radialGradient
        id="radialGradient140"
        cx="662.56"
        cy="251.28"
        r="6.30001"
        fx="662.56"
        fy="251.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5972"
        fill="url(#radialGradient140)"
        stroke="none"
        d="M 655.960022 245.300003 L 658.72998 249.119995 C 658.72998 249.119995 660.23999 251.660004 660.630005 252.25 C 661.200012 253.119995 664.26001 256.23999 664.26001 256.23999 L 669.169983 256.399994 C 669.169983 256.399994 664.419983 257.5 663.820007 257.200012 C 663.219971 256.899994 660.429993 253.410004 660.22998 253.009995 C 660.030029 252.610001 656.059998 245.589996 655.960022 245.300003 Z"
      />
      <radialGradient
        id="radialGradient141"
        cx="649.12"
        cy="260.82"
        r="5.32997"
        fx="649.12"
        fy="260.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5973"
        fill="url(#radialGradient141)"
        stroke="none"
        d="M 651.140015 253.550003 C 651.140015 253.550003 648.640015 253.899994 648.200012 254 C 647.77002 254.100006 647.169983 254.619995 647.099976 255.479996 C 647.030029 256.350006 647.51001 257.200012 647.840027 257.399994 C 647.840027 257.399994 647.169983 257.899994 647.340027 259.100006 C 647.51001 260.299988 648.039978 260.899994 648.039978 260.899994 C 648.039978 260.899994 647.340027 261.5 647.640015 262.600006 C 647.940002 263.700012 648.640015 264.200012 648.640015 264.200012 C 648.640015 264.200012 648.469971 265.399994 648.539978 265.799988 C 648.609985 266.200012 650.400024 267.75 651.039978 268.100006 C 651.039978 268.100006 649.039978 266.5 648.940002 265.73999 C 648.840027 264.970001 648.909973 264.309998 648.909973 264.309998 C 648.909973 264.309998 648.039978 263.179993 647.909973 262.579987 C 647.780029 261.980011 648.340027 261.019989 648.340027 261.019989 C 648.340027 261.019989 647.710022 260.190002 647.640015 259.119995 C 647.570007 258.049988 648.070007 257.48999 648.070007 257.48999 C 648.070007 257.48999 647.369995 256.76001 647.409973 255.789993 C 647.440002 254.820007 647.710022 254.460007 648.340027 254.289993 C 648.969971 254.119995 651.140015 253.559998 651.140015 253.559998 L 651.140015 253.550003 Z"
      />
      <radialGradient
        id="radialGradient142"
        cx="658.28"
        cy="261.21"
        r="6.11002"
        fx="658.28"
        fy="261.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5974"
        fill="url(#radialGradient142)"
        stroke="none"
        d="M 660.72998 265.98999 C 660.72998 265.98999 655.320007 267.519989 653.890015 267.589996 C 652.890015 267.640015 652.340027 266.589996 653.039978 266.089996 C 653.73999 265.589996 652.590027 264.790009 652.539978 264.190002 C 652.390015 262.440002 653.23999 262.290009 653.289978 261.640015 C 653.309998 261.339996 653.080017 261.109985 652.73999 260.48999 C 651.789978 258.73999 653.48999 258.089996 653.539978 257.5 C 653.580017 257.049988 652.960022 256.700012 653.140015 255.850006 C 653.440002 254.449997 655.039978 254.75 656.130005 255.149994 C 657.22998 255.550003 662.820007 258.790009 663.219971 259.690002 C 663.619995 260.589996 666.02002 264.480011 660.719971 265.980011 L 660.72998 265.98999 Z"
      />
      <radialGradient
        id="radialGradient143"
        cx="650.26"
        cy="257.36"
        r="2.07"
        fx="650.26"
        fy="257.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5975"
        fill="url(#radialGradient143)"
        stroke="none"
        d="M 647.380005 256.799988 C 647.380005 256.799988 647.559998 257.220001 647.849976 257.399994 C 647.849976 257.399994 653.27002 258.149994 653.140015 257.850006 C 653.01001 257.549988 647.700012 256.839996 647.380005 256.799988 Z"
      />
      <radialGradient
        id="radialGradient144"
        cx="650.27"
        cy="261.13"
        r="1.9"
        fx="650.27"
        fy="261.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5976"
        fill="url(#radialGradient144)"
        stroke="none"
        d="M 647.710022 260.329987 C 647.710022 260.329987 647.890015 260.720001 648.049988 260.899994 C 648.049988 260.899994 652.780029 262.109985 652.840027 261.899994 C 652.909973 261.679993 647.710022 260.329987 647.710022 260.329987 Z"
      />
      <radialGradient
        id="radialGradient145"
        cx="650.35"
        cy="264.54"
        r="1.76999"
        fx="650.35"
        fy="264.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5977"
        fill="url(#radialGradient145)"
        stroke="none"
        d="M 648.650024 264.190002 C 648.650024 264.190002 652.679993 265.720001 652.640015 265.540009 C 652.609985 265.359985 648.049988 263.519989 648.049988 263.519989 C 648.049988 263.519989 648.320007 263.940002 648.640015 264.190002 L 648.650024 264.190002 Z"
      />
      <radialGradient
        id="radialGradient146"
        cx="679.77"
        cy="266.69"
        r="15.08"
        fx="679.77"
        fy="266.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5978"
        fill="url(#radialGradient146)"
        stroke="none"
        d="M 696.719971 266.119995 C 695.700012 266.329987 664.299988 265.320007 664.299988 265.320007 C 663.690002 265.320007 663.280029 265.339996 663.219971 265.390015 C 662.919983 265.589996 658.859985 268.279999 658.530029 268.579987 C 659.799988 268.329987 662.320007 266.98999 663.02002 266.890015 C 663.080017 266.890015 663.400024 266.890015 663.400024 266.890015 C 663.400024 266.890015 685.73999 268.160004 685.969971 268.170013 C 686.369995 268.179993 697.909973 268.73999 699.150024 267.98999 C 700.179993 267.369995 701 264.809998 701 264.809998 C 701 264.809998 698.200012 265.829987 696.719971 266.119995 Z"
      />
      <path
        id="path5979"
        fill="#cd8845"
        stroke="none"
        d="M 675.070007 174.970001 C 677.140015 175.200012 676.76001 176.419983 675.98999 178.570007 C 675.460022 184.200012 673.719971 186.880005 672.98999 186.580017 C 671.659973 186.02002 672.570007 174.700012 675.070007 174.97998 L 675.070007 174.970001 Z"
      />
      <linearGradient
        id="linearGradient307"
        x1="675.37"
        y1="183.56"
        x2="674.45"
        y2="175.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5980"
        fill="url(#linearGradient307)"
        stroke="none"
        d="M 673.890015 182.850006 C 673.890015 182.850006 674.789978 181.76001 674.289978 179.809998 C 673.109985 175.220001 676.380005 174.609985 675.940002 177.850006 C 675.940002 177.850006 675.340027 176.390015 674.960022 176.880005 C 674.5 177.47998 675.590027 177.679993 675.289978 180.130005 C 675.130005 181.399994 673.890015 182.839996 673.890015 182.839996 L 673.890015 182.850006 Z"
      />
      <path
        id="path5981"
        fill="#cd8845"
        stroke="none"
        d="M 636.47998 175.200012 C 634.429993 175.539978 634.869995 176.73999 635.75 178.839996 C 636.580017 184.429993 638.690002 186.669983 639.400024 186.320007 C 640.700012 185.690002 638.960022 174.789978 636.47998 175.200012 Z"
      />
      <path
        id="path5982"
        fill="#cd8845"
        stroke="none"
        d="M 673.179993 174.799988 C 673.780029 159.679993 667.48999 153.410004 653.690002 154.26001 C 653.690002 154.26001 644.280029 154.589996 641.929993 159.75 C 639.419983 165.26001 638.5 170.22998 638.690002 177.330017 C 639.080017 192.160004 641.919983 192.450012 644.22998 195.320007 C 645.799988 197.27002 649.98999 201.289978 651.340027 202.02002 C 653.52002 203.200012 660.190002 203.02002 662.27002 201.710022 C 664.090027 200.559998 666.359985 197.75 669 194.320007 C 671.159973 191.52002 673.219971 190.929993 672.97998 182.929993 C 672.840027 178.059998 673.01001 179 673.179993 174.809998 L 673.179993 174.799988 Z"
      />
      <radialGradient
        id="radialGradient147"
        cx="667.28"
        cy="182.746"
        r="7.394359"
        fx="667.28"
        fy="182.746"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5983"
        fill="url(#radialGradient147)"
        stroke="none"
        d="M 663.799988 187.97998 C 666.77002 188.26001 671.789978 189.690002 672.619995 184.649994 C 673.409973 179.899994 672.72998 177.549988 671.26001 177.169983 C 667.650024 176.220001 663.48999 178.399994 661.799988 179.640015 C 657.869995 182.529999 658.530029 187.48999 663.799988 187.97998 Z"
      />
      <linearGradient
        id="linearGradient308"
        x1="656.8"
        y1="198.34"
        x2="656.8"
        y2="201.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#d59149" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5984"
        fill="url(#linearGradient308)"
        stroke="none"
        d="M 656.929993 198.399994 C 655.900024 198.399994 653.309998 199.100006 653.390015 199.47998 C 653.619995 200.630005 656.01001 200.820007 657.049988 200.809998 C 658.080017 200.809998 660.169983 200.539978 660.210022 199.559998 C 660.22998 199.179993 657.969971 198.390015 656.929993 198.390015 L 656.929993 198.399994 Z"
      />
      <radialGradient
        id="radialGradient148"
        cx="644.505"
        cy="183.221"
        r="7.454363"
        fx="644.505"
        fy="183.221"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d78144" stopOpacity={1} />
        <stop offset={1} stopColor="#cd8845" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5985"
        fill="url(#radialGradient148)"
        stroke="none"
        d="M 649.390015 179.190002 C 648.840027 178.899994 642.440002 176.440002 640.140015 177.410004 C 638.51001 178.100006 638.369995 181.700012 639.830017 186.450012 C 641.5 191.880005 646.210022 189.070007 648.130005 188.02002 C 652.77002 185.47998 653.690002 181.47998 649.380005 179.190002 L 649.390015 179.190002 Z"
      />
      <linearGradient
        id="linearGradient309"
        x1="658.89"
        y1="191.51"
        x2="659.47"
        y2="185.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5986"
        fill="url(#linearGradient309)"
        stroke="none"
        d="M 658.090027 185.470001 C 660.140015 184.960022 660.940002 185.26001 660.940002 185.26001 C 659.75 184.220001 658.090027 185.470001 658.090027 185.470001 Z"
      />
      <linearGradient
        id="linearGradient310"
        x1="667.59"
        y1="179.71"
        x2="654.72"
        y2="164.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset="0.3" stopColor="#c98243" stopOpacity={1} />
        <stop offset="0.66" stopColor="#c0733e" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5987"
        fill="url(#linearGradient310)"
        stroke="none"
        d="M 670.330017 177.710022 C 671.619995 167.940002 659.77002 172.109985 659.77002 172.109985 C 658.830017 172.97998 658.289978 178.039978 659.150024 178.549988 C 664.48999 181.700012 670.340027 177.710022 670.340027 177.710022 L 670.330017 177.710022 Z"
      />
      <linearGradient
        id="linearGradient311"
        x1="641.27"
        y1="180.78"
        x2="660.24"
        y2="166.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset="0.3" stopColor="#c98243" stopOpacity={1} />
        <stop offset="0.66" stopColor="#c0733e" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5988"
        fill="url(#linearGradient311)"
        stroke="none"
        d="M 642.190002 177.970001 C 641.330017 167.789978 652.23999 172.200012 652.23999 172.200012 C 652.929993 173.25 654.159973 177.710022 653.330017 178.25 C 647.869995 181.76001 642.200012 177.970001 642.200012 177.970001 L 642.190002 177.970001 Z"
      />
      <linearGradient
        id="linearGradient312"
        x1="653.05"
        y1="190.9"
        x2="653.64"
        y2="185.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5989"
        fill="url(#linearGradient312)"
        stroke="none"
        d="M 652.289978 185.109985 C 652.289978 185.109985 653.349976 184.940002 654.960022 185.47998 C 654.960022 185.47998 653.390015 184.289978 652.289978 185.109985 Z"
      />
      <linearGradient
        id="linearGradient313"
        x1="656.32"
        y1="180.84"
        x2="656.59"
        y2="188.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5990"
        fill="url(#linearGradient313)"
        stroke="none"
        d="M 659.679993 182.059998 C 660.150024 183.25 659.599976 184.100006 658.780029 184.609985 C 657.900024 185.190002 655.330017 185.350006 654.369995 184.820007 C 653.549988 184.399994 652.909973 183.549988 653.140015 181.910004 C 653.140015 181.910004 652.630005 182.289978 652.169983 182.73999 C 651.190002 183.619995 651.099976 185.160004 652.169983 185.169983 C 652.169983 185.169983 652.809998 184.779999 653.619995 184.919983 C 654.590027 185.089996 654.400024 186.089996 656.650024 186.109985 C 658.609985 186.130005 657.97998 185.190002 659.22998 185.01001 C 660.47998 184.830017 660.640015 185.149994 660.919983 185.279999 C 661.539978 185.279999 662.159973 183.339996 659.669983 182.049988 L 659.679993 182.059998 Z"
      />
      <linearGradient
        id="linearGradient314"
        x1="656.98"
        y1="184.16"
        x2="653.22"
        y2="152.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5991"
        fill="url(#linearGradient314)"
        stroke="none"
        d="M 654.700012 154.23999 C 642.789978 155.609985 639.390015 161.700012 638.76001 167.369995 C 638.559998 169.210022 639.01001 181.52002 639.090027 183.26001 C 639.51001 179.25 640.890015 177.839996 641.559998 175.830017 C 642.650024 172.73999 643.409973 171.450012 643.349976 167.320007 C 643.429993 159.75 650.98999 158.600006 655.130005 158.529999 C 663.98999 158.369995 667.97998 160.76001 668.099976 166.890015 C 668.179993 171.23999 669.570007 172.589996 670.400024 175.119995 C 671.450012 177.76001 672.840027 181.339996 673.169983 184.27002 C 673.169983 184.27002 672.73999 167.809998 672.440002 164.600006 C 672.049988 160.399994 668.570007 152.649994 654.679993 154.23999 L 654.700012 154.23999 Z"
      />
      <linearGradient
        id="linearGradient315"
        x1="667.08"
        y1="180.98"
        x2="673.35"
        y2="179.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#d59149" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5992"
        fill="url(#linearGradient315)"
        stroke="none"
        d="M 671.530029 179.070007 C 670.98999 178.77002 670.599976 179.210022 669.47998 179.570007 C 668.390015 179.929993 665.400024 180.48999 666.809998 181.26001 C 668.359985 182.100006 670.530029 180.950012 670.789978 180.72998 C 671.049988 180.51001 672.190002 179.440002 671.530029 179.070007 Z"
      />
      <linearGradient
        id="linearGradient316"
        x1="641.14"
        y1="180.38"
        x2="651.73"
        y2="174.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5993"
        fill="url(#linearGradient316)"
        stroke="none"
        d="M 652.429993 177.970001 C 652.799988 177.549988 652.460022 176.619995 652.280029 176.039978 C 651.719971 174.220001 650.380005 173.580017 647.580017 173.419983 C 646.659973 173.369995 645.070007 173.51001 644.059998 174.380005 C 643.280029 175.049988 642.820007 176.350006 642.880005 176.97998 C 642.909973 177.299988 643.460022 178.839996 646.51001 179.049988 C 648.5 179.179993 651.659973 178.850006 652.429993 177.97998 L 652.429993 177.970001 Z"
      />
      <linearGradient
        id="linearGradient317"
        x1="651.781"
        y1="177.79"
        x2="645.091"
        y2="176.182"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.46" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.76" stopColor="#f6f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e6" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5994"
        fill="url(#linearGradient317)"
        stroke="none"
        d="M 649.460022 175.25 C 650.929993 175.460022 651.809998 177.839996 651.809998 177.839996 C 651.640015 178.140015 651.099976 178.309998 650.700012 178.380005 C 649.559998 178.570007 647.880005 178.950012 645.330017 178.289978 C 644.419983 178.049988 643.669983 177 643.669983 177 C 645.400024 174.940002 644.52002 174.539978 649.460022 175.25 Z"
      />
      <path
        id="path5995"
        fill="#dededd"
        stroke="none"
        d="M 651.809998 177.830017 C 651.809998 177.830017 650.98999 176.77002 646.539978 176.669983 C 645.23999 176.640015 644.409973 177.339996 644.119995 177.539978 C 643.869995 177.330017 643.76001 177.140015 643.679993 177 C 643.679993 177 645.780029 174.700012 647.369995 174.880005 C 648.969971 175.059998 651.48999 175.809998 651.809998 177.830017 Z"
      />
      <linearGradient
        id="linearGradient318"
        x1="650.541"
        y1="176.77"
        x2="643.741"
        y2="177.043"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a9734f" stopOpacity={1} />
        <stop offset={1} stopColor="#633726" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5996"
        fill="url(#linearGradient318)"
        stroke="none"
        d="M 650.51001 177.23999 C 650.590027 175.77002 649.320007 175.070007 647.969971 175.130005 C 646.619995 175.200012 645.419983 175.919983 645.590027 177.350006 C 645.630005 177.649994 645.659973 178.029999 646 178.429993 C 646.130005 178.470001 646.47998 178.539978 646.890015 178.600006 C 646.659973 178.339996 646.51001 178 646.5 177.619995 C 646.48999 176.779999 647.150024 176.089996 647.97998 176.070007 C 648.809998 176.049988 649.48999 176.720001 649.5 177.559998 C 649.5 177.970001 649.349976 178.339996 649.099976 178.619995 C 649.450012 178.589996 649.809998 178.539978 650.150024 178.470001 C 650.210022 178.410004 650.48999 177.789978 650.52002 177.23999 L 650.51001 177.23999 Z"
      />
      <linearGradient
        id="linearGradient319"
        x1="650.681"
        y1="176.57"
        x2="646.28"
        y2="175.762"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#936444" stopOpacity={1} />
        <stop offset={1} stopColor="#593427" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5997"
        fill="url(#linearGradient319)"
        stroke="none"
        d="M 650.51001 177.179993 C 650.51001 177.179993 647.710022 176.309998 645.590027 176.779999 C 645.590027 176.779999 645.919983 175.039978 647.48999 175.039978 C 649.200012 175.039978 650.5 175.350006 650.51001 177.169983 L 650.51001 177.179993 Z"
      />
      <linearGradient
        id="linearGradient320"
        x1="650.561"
        y1="177.25"
        x2="643.761"
        y2="177.523"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a9734f" stopOpacity={1} />
        <stop offset={1} stopColor="#633726" stopOpacity={1} />
      </linearGradient>
      <path
        id="path5998"
        fill="url(#linearGradient320)"
        stroke="none"
        d="M 647.97998 176.070007 C 647.150024 176.080017 646.48999 176.779999 646.5 177.619995 C 646.5 178 646.650024 178.339996 646.890015 178.600006 C 647.23999 178.649994 647.630005 178.690002 647.969971 178.679993 C 648.320007 178.679993 648.710022 178.660004 649.099976 178.619995 C 649.349976 178.339996 649.51001 177.970001 649.5 177.559998 C 649.48999 176.720001 648.799988 176.049988 647.97998 176.070007 Z"
      />
      <radialGradient
        id="radialGradient149"
        cx="648.837"
        cy="178.604"
        r="4.235226"
        fx="648.837"
        fy="178.604"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b3b3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1d2827" stopOpacity={1} />
      </radialGradient>
      <path
        id="path5999"
        fill="url(#radialGradient149)"
        stroke="none"
        d="M 647.97998 176.070007 C 647.150024 176.080017 646.48999 176.779999 646.5 177.619995 C 646.5 178 646.650024 178.339996 646.890015 178.600006 C 647.23999 178.649994 647.630005 178.690002 647.969971 178.679993 C 648.320007 178.679993 648.710022 178.660004 649.099976 178.619995 C 649.349976 178.339996 649.51001 177.970001 649.5 177.559998 C 649.48999 176.720001 648.799988 176.049988 647.97998 176.070007 Z"
      />
      <path
        id="path6000"
        fill="#ffffff"
        stroke="none"
        d="M 648.640015 177.600006 C 648.48999 177.289978 648.630005 176.899994 648.950012 176.72998 C 649.27002 176.559998 649.659973 176.679993 649.809998 176.98999 C 649.960022 177.299988 649.820007 177.690002 649.5 177.859985 C 649.179993 178.029999 648.789978 177.910004 648.640015 177.600006 Z"
      />
      <linearGradient
        id="linearGradient321"
        x1="670.8"
        y1="180.536"
        x2="660.286"
        y2="174.139"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6001"
        fill="url(#linearGradient321)"
        stroke="none"
        d="M 659.51001 178.02002 C 659.150024 177.600006 659.5 176.669983 659.679993 176.089996 C 660.27002 174.279999 661.609985 173.649994 664.409973 173.529999 C 665.330017 173.48999 666.919983 173.649994 667.919983 174.529999 C 668.690002 175.210022 669.140015 176.52002 669.070007 177.140015 C 669.030029 177.460022 668.469971 179 665.409973 179.160004 C 663.409973 179.27002 660.26001 178.890015 659.51001 178.02002 Z"
      />
      <linearGradient
        id="linearGradient322"
        x1="660.186"
        y1="177.872"
        x2="666.885"
        y2="176.335"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.46" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.76" stopColor="#f6f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e6" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6002"
        fill="url(#linearGradient322)"
        stroke="none"
        d="M 662.51001 175.330017 C 661.039978 175.529999 660.119995 177.899994 660.119995 177.899994 C 660.280029 178.200012 660.820007 178.380005 661.219971 178.450012 C 662.359985 178.649994 664.039978 179.049988 666.590027 178.419983 C 667.51001 178.190002 668.27002 177.149994 668.27002 177.149994 C 666.559998 175.070007 667.450012 174.679993 662.51001 175.330017 Z"
      />
      <path
        id="path6003"
        fill="#dededd"
        stroke="none"
        d="M 660.130005 177.880005 C 660.130005 177.880005 660.960022 176.830017 665.409973 176.779999 C 666.710022 176.76001 667.530029 177.47998 667.820007 177.679993 C 668.080017 177.47998 668.179993 177.289978 668.27002 177.149994 C 668.27002 177.149994 666.200012 174.830017 664.609985 174.98999 C 663.01001 175.149994 660.469971 175.869995 660.130005 177.890015 L 660.130005 177.880005 Z"
      />
      <linearGradient
        id="linearGradient323"
        x1="661.438"
        y1="176.867"
        x2="668.224"
        y2="177.221"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a9734f" stopOpacity={1} />
        <stop offset={1} stopColor="#633726" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6004"
        fill="url(#linearGradient323)"
        stroke="none"
        d="M 664 175.23999 C 662.650024 175.160004 661.369995 175.839996 661.429993 177.320007 C 661.450012 177.880005 661.73999 178.48999 661.799988 178.559998 C 661.919983 178.600006 662.359985 178.669983 662.840027 178.720001 C 662.590027 178.440002 662.440002 178.070007 662.450012 177.660004 C 662.469971 176.820007 663.159973 176.160004 663.98999 176.179993 C 664.820007 176.200012 665.469971 176.910004 665.450012 177.75 C 665.450012 178.130005 665.289978 178.47998 665.049988 178.73999 C 665.450012 178.679993 665.799988 178.609985 665.929993 178.570007 C 666.27002 178.179993 666.309998 177.799988 666.349976 177.48999 C 666.539978 176.070007 665.349976 175.330017 664 175.25 L 664 175.23999 Z"
      />
      <linearGradient
        id="linearGradient324"
        x1="661.291"
        y1="176.655"
        x2="665.7"
        y2="175.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#936444" stopOpacity={1} />
        <stop offset={1} stopColor="#593427" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6005"
        fill="url(#linearGradient324)"
        stroke="none"
        d="M 661.440002 177.23999 C 661.440002 177.23999 664.25 176.410004 666.359985 176.899994 C 666.359985 176.899994 666.049988 175.160004 664.47998 175.140015 C 662.77002 175.119995 661.460022 175.410004 661.440002 177.23999 Z"
      />
      <linearGradient
        id="linearGradient325"
        x1="661.412"
        y1="177.347"
        x2="668.198"
        y2="177.701"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a9734f" stopOpacity={1} />
        <stop offset={1} stopColor="#633726" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6006"
        fill="url(#linearGradient325)"
        stroke="none"
        d="M 664 176.169983 C 663.169983 176.140015 662.47998 176.799988 662.460022 177.649994 C 662.450012 178.059998 662.599976 178.429993 662.849976 178.710022 C 663.26001 178.75 663.690002 178.789978 663.98999 178.799988 C 664.330017 178.799988 664.719971 178.77002 665.059998 178.72998 C 665.299988 178.470001 665.450012 178.130005 665.460022 177.73999 C 665.47998 176.899994 664.830017 176.200012 664 176.169983 Z"
      />
      <radialGradient
        id="radialGradient150"
        cx="661.546"
        cy="178.563"
        r="4.235974"
        fx="661.546"
        fy="178.563"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b3b3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1d2827" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6007"
        fill="url(#radialGradient150)"
        stroke="none"
        d="M 664 176.169983 C 663.169983 176.140015 662.47998 176.799988 662.460022 177.649994 C 662.450012 178.059998 662.599976 178.429993 662.849976 178.710022 C 663.26001 178.75 663.690002 178.789978 663.98999 178.799988 C 664.330017 178.799988 664.719971 178.77002 665.059998 178.72998 C 665.299988 178.470001 665.450012 178.130005 665.460022 177.73999 C 665.47998 176.899994 664.830017 176.200012 664 176.169983 Z"
      />
      <path
        id="path6008"
        fill="#ffffff"
        stroke="none"
        d="M 665.77002 177.600006 C 665.919983 177.289978 665.789978 176.899994 665.469971 176.72998 C 665.150024 176.559998 664.76001 176.669983 664.609985 176.97998 C 664.450012 177.289978 664.590027 177.679993 664.909973 177.850006 C 665.22998 178.02002 665.619995 177.910004 665.77002 177.600006 Z"
      />
      <path
        id="path6009"
        fill="#ffffff"
        stroke="none"
        d="M 664.22998 178.26001 C 664.349976 178.02002 664.25 177.710022 663.98999 177.580017 C 663.73999 177.450012 663.429993 177.529999 663.309998 177.779999 C 663.190002 178.02002 663.289978 178.330017 663.549988 178.460022 C 663.799988 178.589996 664.109985 178.5 664.22998 178.26001 Z"
      />
      <linearGradient
        id="linearGradient326"
        x1="659.998"
        y1="176.363"
        x2="667.918"
        y2="175.973"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#43241d" stopOpacity={1} />
        <stop offset="0.36" stopColor="#3f221b" stopOpacity={1} />
        <stop offset="0.66" stopColor="#351d17" stopOpacity={1} />
        <stop offset="0.93" stopColor="#241411" stopOpacity={1} />
        <stop offset={1} stopColor="#1f120f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6010"
        fill="url(#linearGradient326)"
        stroke="none"
        d="M 660.130005 177.890015 C 660.130005 177.890015 660.190002 176.440002 661.539978 175.470001 C 662.960022 174.450012 665.710022 174.5 667.150024 175.359985 C 668.01001 175.880005 668.280029 177.149994 668.280029 177.149994 C 668.280029 177.149994 667.400024 176.910004 666.450012 176.470001 C 665.27002 175.910004 664.789978 175.960022 664.049988 175.950012 C 662.97998 175.950012 662.580017 176.130005 662.099976 176.26001 C 660.849976 176.589996 660.130005 177.899994 660.130005 177.899994 L 660.130005 177.890015 Z"
      />
      <linearGradient
        id="linearGradient327"
        x1="667.42"
        y1="197.137"
        x2="665.996"
        y2="180.058"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6011"
        fill="url(#linearGradient327)"
        stroke="none"
        d="M 668.280029 177.149994 C 668.280029 177.149994 667.5 178.169983 666.419983 178.429993 C 665.75 178.589996 664.789978 178.850006 663.299988 178.75 C 663.299988 178.75 664.429993 179.190002 666.609985 178.630005 C 667.780029 178.330017 668.280029 177.149994 668.280029 177.149994 Z"
      />
      <path
        id="path6012"
        fill="#ffffff"
        stroke="none"
        d="M 647.369995 178.26001 C 647.25 178.01001 647.359985 177.710022 647.609985 177.580017 C 647.869995 177.450012 648.169983 177.539978 648.289978 177.789978 C 648.409973 178.039978 648.299988 178.339996 648.049988 178.470001 C 647.789978 178.600006 647.48999 178.51001 647.369995 178.26001 Z"
      />
      <linearGradient
        id="linearGradient328"
        x1="651.972"
        y1="176.383"
        x2="644.057"
        y2="175.898"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#43241d" stopOpacity={1} />
        <stop offset="0.36" stopColor="#3f221b" stopOpacity={1} />
        <stop offset="0.66" stopColor="#351d17" stopOpacity={1} />
        <stop offset="0.93" stopColor="#241411" stopOpacity={1} />
        <stop offset={1} stopColor="#1f120f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6013"
        fill="url(#linearGradient328)"
        stroke="none"
        d="M 651.809998 177.839996 C 651.809998 177.839996 651.780029 176.390015 650.429993 175.399994 C 649.02002 174.359985 646.27002 174.380005 644.830017 175.220001 C 643.960022 175.72998 643.669983 177 643.669983 177 C 643.669983 177 644.559998 176.77002 645.51001 176.339996 C 646.700012 175.799988 647.179993 175.850006 647.909973 175.850006 C 648.97998 175.859985 649.380005 176.049988 649.859985 176.179993 C 651.099976 176.529999 651.809998 177.839996 651.809998 177.839996 Z"
      />
      <linearGradient
        id="linearGradient329"
        x1="644.34"
        y1="197.02"
        x2="645.97"
        y2="179.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6014"
        fill="url(#linearGradient329)"
        stroke="none"
        d="M 643.669983 177 C 643.669983 177 644.440002 178.029999 645.51001 178.309998 C 646.179993 178.47998 647.169983 178.75 648.659973 178.660004 C 648.659973 178.660004 647.47998 179.089996 645.320007 178.5 C 644.159973 178.190002 643.659973 177 643.659973 177 L 643.669983 177 Z"
      />
      <linearGradient
        id="linearGradient330"
        x1="645.892"
        y1="181.522"
        x2="638.242"
        y2="179.655"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#d59149" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6015"
        fill="url(#linearGradient330)"
        stroke="none"
        d="M 642.530029 179.929993 C 641.400024 179.619995 640.97998 179.210022 640.460022 179.529999 C 639.820007 179.940002 641.01001 180.950012 641.289978 181.149994 C 641.559998 181.350006 643.789978 182.399994 645.289978 181.470001 C 646.650024 180.630005 643.640015 180.22998 642.530029 179.919983 L 642.530029 179.929993 Z"
      />
      <linearGradient
        id="linearGradient331"
        x1="663.92"
        y1="188.38"
        x2="668.12"
        y2="187.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6016"
        fill="url(#linearGradient331)"
        stroke="none"
        d="M 662.73999 185.369995 C 667.390015 189.130005 663.830017 191.559998 663.830017 191.559998 C 665.26001 190.299988 667.530029 188.789978 667.390015 188.220001 C 666.929993 186.309998 662.73999 185.380005 662.73999 185.380005 L 662.73999 185.369995 Z"
      />
      <linearGradient
        id="linearGradient332"
        x1="649.3"
        y1="188.74"
        x2="644.72"
        y2="187.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6017"
        fill="url(#linearGradient332)"
        stroke="none"
        d="M 645.640015 188.51001 C 645.719971 189.089996 647.380005 190.529999 648.460022 191.660004 C 648.460022 191.660004 645.570007 188.549988 649.590027 185.75 C 649.590027 185.75 645.359985 186.549988 645.640015 188.52002 L 645.640015 188.51001 Z"
      />
      <linearGradient
        id="linearGradient333"
        x1="656.85"
        y1="192.55"
        x2="656.75"
        y2="197.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6018"
        fill="url(#linearGradient333)"
        stroke="none"
        d="M 652.559998 196.210022 C 657.590027 195.649994 660.97998 196.27002 660.97998 196.27002 C 657.169983 193.899994 652.559998 196.210022 652.559998 196.210022 Z"
      />
      <path
        id="path6019"
        fill="#96282d"
        stroke="none"
        d="M 647.080017 188.179993 C 647.179993 188.289978 647.26001 188.429993 647.390015 188.48999 C 649.799988 189.559998 649.840027 190.580017 650.869995 191.140015 C 654.539978 193.119995 658.809998 192.640015 661.690002 191.049988 C 663.349976 190.140015 663.559998 189.070007 665.539978 188.299988 C 665.799988 188.200012 665.859985 187.98999 665.859985 187.98999 C 655.280029 190.580017 647.080017 188.190002 647.080017 188.190002 L 647.080017 188.179993 Z"
      />
      <linearGradient
        id="linearGradient334"
        x1="653.73"
        y1="193.61"
        x2="659.24"
        y2="193.61"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#d59149" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6020"
        fill="url(#linearGradient334)"
        stroke="none"
        d="M 656.559998 193.220001 C 655.130005 193.220001 653.719971 192.940002 653.719971 193.220001 C 653.719971 193.5 654.960022 194.119995 656.390015 194.119995 C 657.820007 194.119995 659.22998 193.5 659.22998 193.220001 C 659.22998 192.940002 657.98999 193.220001 656.559998 193.220001 Z"
      />
      <linearGradient
        id="linearGradient335"
        x1="650.156"
        y1="191.261"
        x2="663.266"
        y2="191.476"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d9d7" stopOpacity={1} />
        <stop offset="0.14" stopColor="#efe5e4" stopOpacity={1} />
        <stop offset="0.39" stopColor="#faf8f7" stopOpacity={1} />
        <stop offset="0.57" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d3d1" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6021"
        fill="url(#linearGradient335)"
        stroke="none"
        d="M 651.469971 190.419983 C 651.02002 190.339996 650.830017 191.119995 650.830017 191.119995 C 652.169983 192.100006 653.789978 192.470001 656.380005 192.48999 C 659.830017 192.51001 661.73999 191.02002 661.73999 191.02002 C 661.73999 191.02002 661.25 190.27002 660.690002 190.380005 C 659.719971 190.580017 657.890015 190.940002 656.219971 190.940002 C 654.369995 190.940002 652.5 190.600006 651.47998 190.419983 L 651.469971 190.419983 Z"
      />
      <linearGradient
        id="linearGradient336"
        x1="656.7"
        y1="192.55"
        x2="656.61"
        y2="197.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6022"
        fill="url(#linearGradient336)"
        stroke="none"
        d="M 651.289978 193.580017 C 656.799988 197.960022 662.080017 193.279999 662.080017 193.279999 C 656.51001 196.25 651.289978 193.580017 651.289978 193.580017 Z"
      />
      <linearGradient
        id="linearGradient337"
        x1="656.23"
        y1="186.33"
        x2="656.44"
        y2="191.23"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d9d7" stopOpacity={1} />
        <stop offset="0.4" stopColor="#efe5e3" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6023"
        fill="url(#linearGradient337)"
        stroke="none"
        d="M 649.469971 188.679993 C 649.469971 188.679993 649.5 189.589996 650.429993 189.97998 C 650.960022 190.210022 652.159973 191.119995 656.820007 190.97998 C 661.47998 190.839996 662.400024 189.710022 662.609985 189.52002 C 663.01001 189.149994 663.190002 188.539978 663.190002 188.539978 C 663.190002 188.539978 656.169983 189.910004 649.47998 188.679993 L 649.469971 188.679993 Z"
      />
      <path
        id="path6024"
        fill="#f3eceb"
        stroke="none"
        d="M 649.460022 188.600006 C 649.460022 188.600006 649.48999 189.01001 649.640015 189.26001 C 649.77002 189.460022 653.48999 190.01001 656.299988 190.02002 C 659.109985 190.039978 662.780029 189.309998 662.909973 189.149994 C 663.109985 188.899994 663.219971 188.450012 663.219971 188.450012 C 663.219971 188.450012 660.059998 189.51001 649.460022 188.600006 Z"
      />
      <linearGradient
        id="linearGradient338"
        x1="656.771"
        y1="205.639"
        x2="656.424"
        y2="184.559"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6025"
        fill="url(#linearGradient338)"
        stroke="none"
        d="M 646.5 187.890015 C 646.5 187.890015 647.179993 188.279999 647.070007 188.179993 C 647.070007 188.179993 655.26001 190.570007 665.849976 187.97998 L 666.419983 187.690002 C 660.669983 188.649994 646.48999 187.890015 646.48999 187.890015 L 646.5 187.890015 Z"
      />
      <linearGradient
        id="linearGradient339"
        x1="638.01"
        y1="187.35"
        x2="637.09"
        y2="179.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6026"
        fill="url(#linearGradient339)"
        stroke="none"
        d="M 638.25 183.049988 C 638.25 183.049988 637.299988 182.01001 637.700012 180.039978 C 638.630005 175.399994 635.340027 174.960022 635.950012 178.169983 C 635.950012 178.169983 636.469971 176.679993 636.880005 177.149994 C 637.369995 177.720001 636.289978 177.98999 636.72998 180.419983 C 636.960022 181.679993 638.27002 183.049988 638.27002 183.049988 L 638.25 183.049988 Z"
      />
      <linearGradient
        id="linearGradient340"
        x1="656.317"
        y1="194.659"
        x2="656.23"
        y2="202.689"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6027"
        fill="url(#linearGradient340)"
        stroke="none"
        d="M 647.799988 199.059998 C 647.799988 199.059998 650.880005 203.539978 656.73999 203.52002 C 662.47998 203.5 664.73999 199.529999 664.73999 199.529999 C 664.73999 199.529999 661.789978 202.649994 656.390015 202.580017 C 651.179993 202.51001 647.799988 199.059998 647.799988 199.059998 Z"
      />
      <linearGradient
        id="linearGradient341"
        x1="664.859"
        y1="201.016"
        x2="673.723"
        y2="182.773"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#d59149" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6028"
        fill="url(#linearGradient341)"
        stroke="none"
        d="M 673.109985 179.660004 C 673.109985 179.660004 673.359985 187.549988 672.080017 190.580017 C 671.299988 192.410004 665.969971 198.01001 665.179993 199.01001 C 665.179993 199.01001 665.869995 195.369995 667.429993 193.440002 C 668.98999 191.51001 672.940002 189.859985 673.119995 179.660004 L 673.109985 179.660004 Z"
      />
      <linearGradient
        id="linearGradient342"
        x1="648.28"
        y1="200.441"
        x2="638.515"
        y2="183.831"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#b35f38" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6029"
        fill="url(#linearGradient342)"
        stroke="none"
        d="M 638.98999 180.72998 C 638.98999 180.72998 638.98999 188.660004 640.640015 191.22998 C 642.130005 193.549988 646.849976 198.160004 647.47998 198.75 C 647.47998 198.75 647.309998 196.070007 645.609985 194.279999 C 643.900024 192.47998 639.630005 190 638.98999 180.73999 L 638.98999 180.72998 Z"
      />
      <linearGradient
        id="linearGradient343"
        x1="643.315"
        y1="171.737"
        x2="653.06"
        y2="171.417"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#43241d" stopOpacity={1} />
        <stop offset="0.36" stopColor="#3f221b" stopOpacity={1} />
        <stop offset="0.66" stopColor="#351d17" stopOpacity={1} />
        <stop offset="0.93" stopColor="#241411" stopOpacity={1} />
        <stop offset={1} stopColor="#1f120f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6030"
        fill="url(#linearGradient343)"
        stroke="none"
        d="M 644.530029 170.830017 C 646.75 170.039978 649.650024 170.440002 651.669983 171.25 C 652.429993 171.559998 652.340027 172.76001 651.440002 172.77002 C 649.75 172.779999 647.830017 172.169983 645.840027 172.27002 C 643.5 172.380005 642.47998 173.089996 642.47998 173.089996 C 642.47998 173.089996 643.679993 171.140015 644.530029 170.839996 L 644.530029 170.830017 Z"
      />
      <linearGradient
        id="linearGradient344"
        x1="670.428"
        y1="171.644"
        x2="660.679"
        y2="171.466"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#43241d" stopOpacity={1} />
        <stop offset="0.36" stopColor="#3f221b" stopOpacity={1} />
        <stop offset="0.66" stopColor="#351d17" stopOpacity={1} />
        <stop offset="0.93" stopColor="#241411" stopOpacity={1} />
        <stop offset={1} stopColor="#1f120f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6031"
        fill="url(#linearGradient344)"
        stroke="none"
        d="M 667.330017 170.669983 C 665.099976 169.910004 662.210022 170.350006 660.200012 171.190002 C 659.440002 171.51001 659.549988 172.710022 660.450012 172.700012 C 662.140015 172.700012 664.049988 172.049988 666.049988 172.119995 C 668.390015 172.200012 669.419983 172.890015 669.419983 172.890015 C 669.419983 172.890015 668.190002 170.960022 667.330017 170.669983 Z"
      />
      <linearGradient
        id="linearGradient345"
        x1="654.61"
        y1="150.96"
        x2="656.36"
        y2="181.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#43241d" stopOpacity={1} />
        <stop offset="0.36" stopColor="#3f221b" stopOpacity={1} />
        <stop offset="0.66" stopColor="#351d17" stopOpacity={1} />
        <stop offset="0.93" stopColor="#241411" stopOpacity={1} />
        <stop offset={1} stopColor="#1f120f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6032"
        fill="url(#linearGradient345)"
        stroke="none"
        d="M 639 181.029999 C 639 181.029999 639.349976 177.630005 640.169983 174.649994 C 640.919983 171.910004 641.690002 171.059998 641.609985 169.080017 C 641.48999 166.210022 643.200012 160.859985 644.200012 160.27002 C 651.650024 155.929993 664.700012 158.179993 667.429993 160.059998 C 668.599976 160.869995 669.929993 166.559998 670.02002 168.839996 C 670.099976 170.970001 671.25 172.029999 672 174.710022 C 672.719971 177.26001 673.130005 180.350006 673.130005 180.350006 C 673.130005 180.350006 673.450012 176.109985 674.210022 175.359985 C 674.150024 172.73999 674.01001 165.559998 673.109985 160.950012 C 672.570007 158.169983 669.52002 152.059998 660.330017 151.330017 C 654.969971 150.910004 650.01001 151.419983 646.960022 152.330017 C 644.099976 153.190002 639.27002 157.47998 638.599976 162.630005 C 638.059998 166.830017 637.679993 175.869995 637.679993 175.869995 C 637.679993 175.869995 639.030029 177.580017 639 181.02002 L 639 181.029999 Z"
      />
      <linearGradient
        id="linearGradient346"
        x1="655.48"
        y1="178.85"
        x2="656.66"
        y2="184.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#cd8845" stopOpacity={1} />
        <stop offset={1} stopColor="#d59149" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6033"
        fill="url(#linearGradient346)"
        stroke="none"
        d="M 656.48999 180.089996 C 657.98999 180.089996 658.460022 182.720001 658.25 183.470001 C 658.039978 184.220001 654.700012 185.080017 654.469971 183.160004 C 654.26001 181.470001 655.549988 180.089996 656.48999 180.089996 Z"
      />
      <linearGradient
        id="linearGradient347"
        x1="656.07"
        y1="157.98"
        x2="654.47"
        y2="151.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3f221a" stopOpacity={1} />
        <stop offset="0.41" stopColor="#43241c" stopOpacity={1} />
        <stop offset="0.87" stopColor="#502c25" stopOpacity={1} />
        <stop offset={1} stopColor="#563029" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6034"
        fill="url(#linearGradient347)"
        stroke="none"
        d="M 640.97998 157.080017 C 640.97998 157.080017 642.789978 154.23999 645.75 152.73999 C 649.169983 151 660.320007 150.200012 665.51001 152.169983 C 668.280029 153.220001 670.469971 155.919983 670.469971 155.919983 C 670.469971 155.919983 666.75 152.73999 659.5 152.359985 C 652.25 151.97998 645.950012 152.309998 640.97998 157.080017 Z"
      />
      <path
        id="path6035"
        fill="#006838"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 676.820007 161.049988 L 635.880005 161.049988 C 636.630005 153.570007 641.419983 147.25 648.030029 144.299988 C 648.289978 144.179993 648.559998 144.070007 648.820007 143.970001 C 649.619995 143.649994 650.450012 143.380005 651.289978 143.169983 C 651.869995 143.02002 652.469971 142.899994 653.070007 142.799988 C 654.140015 142.630005 655.23999 142.539978 656.349976 142.539978 C 658.090027 142.539978 659.789978 142.76001 661.409973 143.169983 C 661.97998 143.309998 662.530029 143.47998 663.080017 143.669983 C 663.200012 143.710022 663.320007 143.76001 663.440002 143.799988 C 663.559998 143.839996 663.679993 143.890015 663.799988 143.940002 C 663.97998 144.01001 664.159973 144.080017 664.330017 144.160004 C 664.440002 144.210022 664.549988 144.26001 664.669983 144.309998 C 671.27002 147.26001 676.070007 153.589996 676.820007 161.059998 L 676.820007 161.049988 Z"
      />
      <path
        id="path6036"
        fill="#006838"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 676.919983 162.26001 L 676.919983 168 L 635.77002 168 L 635.77002 162.26001 C 635.77002 162.02002 635.77002 161.789978 635.780029 161.559998 L 676.900024 161.559998 C 676.900024 161.789978 676.909973 162.029999 676.909973 162.26001 L 676.919983 162.26001 Z"
      />
      <path
        id="path6037"
        fill="#39b54a"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 664.669983 144.299988 L 664.669983 161.049988 L 648.02002 161.049988 L 648.02002 144.299988 C 648.280029 144.179993 648.549988 144.070007 648.809998 143.970001 C 649.609985 143.649994 650.440002 143.380005 651.280029 143.169983 C 651.859985 143.02002 652.460022 142.899994 653.059998 142.799988 C 654.130005 142.630005 655.22998 142.539978 656.340027 142.539978 C 658.080017 142.539978 659.780029 142.76001 661.400024 143.169983 C 661.969971 143.309998 662.52002 143.47998 663.070007 143.669983 C 663.190002 143.710022 663.309998 143.76001 663.429993 143.799988 C 663.549988 143.839996 663.669983 143.890015 663.789978 143.940002 C 663.969971 144.01001 664.150024 144.080017 664.320007 144.160004 C 664.429993 144.210022 664.539978 144.26001 664.659973 144.309998 L 664.669983 144.299988 Z"
      />
      <path
        id="path6038"
        fill="#006838"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 661.409973 143.169983 L 661.409973 158.27002 C 661.409973 158.619995 661.299988 158.940002 661.099976 159.200012 C 660.820007 159.580017 660.369995 159.820007 659.859985 159.820007 L 652.830017 159.820007 C 652.320007 159.820007 651.880005 159.580017 651.590027 159.200012 C 651.400024 158.940002 651.280029 158.619995 651.280029 158.27002 L 651.280029 143.169983 C 651.280029 142.580017 651.609985 142.059998 652.119995 141.799988 C 652.25 141.72998 652.390015 141.679993 652.549988 141.649994 C 653.780029 141.419983 655.049988 141.299988 656.349976 141.299988 C 657.650024 141.299988 658.909973 141.419983 660.150024 141.649994 C 660.880005 141.789978 661.409973 142.419983 661.409973 143.169983 Z"
      />
      <path
        id="path6039"
        fill="#004715"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 679.409973 168.679993 C 679.409973 168.869995 679.330017 169.039978 679.210022 169.160004 C 679.090027 169.279999 678.919983 169.359985 678.72998 169.359985 L 633.960022 169.359985 C 633.590027 169.359985 633.280029 169.059998 633.280029 168.679993 C 633.280029 168.48999 633.359985 168.320007 633.47998 168.200012 C 633.599976 168.080017 633.77002 168 633.960022 168 L 678.72998 168 C 679.099976 168 679.409973 168.299988 679.409973 168.679993 Z"
      />
      <path
        id="path6040"
        fill="#bcbec0"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 661.200012 160.210022 C 661.200012 160.5 661.169983 160.779999 661.130005 161.049988 C 661.099976 161.220001 661.059998 161.390015 661.01001 161.559998 C 660.419983 163.589996 658.559998 165.070007 656.340027 165.070007 C 655.72998 165.070007 655.140015 164.960022 654.599976 164.75 C 653.190002 164.210022 652.090027 163.029999 651.669983 161.559998 C 651.619995 161.390015 651.580017 161.22998 651.549988 161.049988 C 651.5 160.779999 651.47998 160.48999 651.47998 160.210022 C 651.47998 159.859985 651.52002 159.52002 651.590027 159.200012 C 652.059998 157 654.01001 155.359985 656.340027 155.359985 C 656.780029 155.359985 657.219971 155.419983 657.619995 155.529999 C 659.359985 156.01001 660.710022 157.419983 661.090027 159.200012 C 661.159973 159.529999 661.200012 159.869995 661.200012 160.210022 Z"
      />
      <path
        id="path6041"
        fill="#39b54a"
        stroke="#231f20"
        strokeWidth="0.2"
        d="M 656.349976 163.460022 C 658.195007 163.460022 659.690002 161.964996 659.690002 160.119995 C 659.690002 158.274994 658.195007 156.779999 656.349976 156.779999 C 654.505005 156.779999 653.01001 158.274994 653.01001 160.119995 C 653.01001 161.964996 654.505005 163.460022 656.349976 163.460022 Z"
      />
      <linearGradient
        id="linearGradient348"
        x1="634.74"
        y1="170.41"
        x2="657.74"
        y2="147.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fff33b" stopOpacity={1} />
        <stop offset="0.04" stopColor="#fee62d" stopOpacity={1} />
        <stop offset="0.12" stopColor="#fdd51b" stopOpacity={1} />
        <stop offset="0.2" stopColor="#fdca0f" stopOpacity={1} />
        <stop offset="0.28" stopColor="#fdc70c" stopOpacity={1} />
        <stop offset="0.67" stopColor="#808285" stopOpacity={1} />
        <stop offset="0.89" stopColor="#d1d3d4" stopOpacity={1} />
        <stop offset={1} stopColor="#f1f2f2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6042"
        fill="url(#linearGradient348)"
        stroke="none"
        opacity="0.09"
        d="M 657.650024 154.779999 C 657.650024 155.029999 657.650024 155.27002 657.630005 155.52002 C 657.609985 156.02002 657.570007 156.51001 657.51001 156.98999 C 657.390015 157.950012 657.190002 158.890015 656.919983 159.809998 C 656.799988 160.22998 656.659973 160.640015 656.5 161.049988 C 656.440002 161.220001 656.369995 161.390015 656.299988 161.559998 C 656.049988 162.169983 655.77002 162.76001 655.450012 163.339996 C 655.190002 163.820007 654.909973 164.289978 654.599976 164.73999 C 653.820007 165.910004 652.909973 167.01001 651.880005 168 C 651.390015 168.470001 650.869995 168.929993 650.330017 169.350006 L 633.950012 169.350006 C 633.580017 169.350006 633.27002 169.049988 633.27002 168.669983 C 633.27002 168.47998 633.349976 168.309998 633.469971 168.190002 C 633.590027 168.070007 633.76001 167.98999 633.950012 167.98999 L 635.76001 167.98999 L 635.76001 162.25 C 635.76001 162.01001 635.76001 161.779999 635.77002 161.549988 L 651.669983 161.549988 C 651.619995 161.380005 651.580017 161.220001 651.549988 161.039978 L 635.859985 161.039978 C 636.609985 153.559998 641.400024 147.23999 648.01001 144.289978 C 648.27002 144.169983 648.539978 144.059998 648.799988 143.960022 C 649.599976 143.640015 650.429993 143.369995 651.27002 143.160004 C 651.27002 142.570007 651.599976 142.049988 652.109985 141.789978 C 652.429993 142.109985 652.75 142.450012 653.049988 142.789978 C 655.919983 146.080017 657.630005 150.23999 657.630005 154.779999 L 657.650024 154.779999 Z"
      />
      <path
        id="path6043"
        fill="#f7d4ab"
        stroke="none"
        d="M 265.209991 203.72998 C 265.209991 203.72998 262.079987 200.419983 261.670013 199.559998 C 261.119995 198.410004 261.220001 196.890015 261.440002 195.52002 C 261.600006 194.470001 262.410004 191.399994 262.410004 191.399994 C 262.410004 191.399994 261.959991 186.700012 261.899994 186.089996 C 261.790009 185.109985 261.98999 183.109985 261.149994 182.609985 C 259.779999 181.799988 258.859985 184.289978 258.940002 185.820007 C 259.019989 187.350006 258.25 192.130005 258.25 192.130005 L 253.710007 192.23999 L 245.350006 186.839996 C 245.350006 186.839996 240.960007 184.419983 238.910004 183.850006 C 237.470001 183.450012 237.529999 185.470001 237.529999 185.470001 C 237.529999 185.470001 235.389999 183.210022 234.300003 184.839996 C 233.429993 186.130005 234.940002 187.47998 234.940002 187.47998 C 234.940002 187.47998 233.929993 187.440002 233.610001 188.48999 C 233.210007 189.799988 235.330002 191.77002 235.5 192.02002 C 234.809998 192.02002 232.789993 193.289978 234.550003 195.200012 C 235.130005 195.830017 239.929993 199.580017 240.460007 200 C 240.990005 200.419983 245.979996 205.970001 247.529999 206.72998 C 249.080002 207.48999 257.320007 210.02002 258.040009 210.76001 L 265.220001 203.72998 L 265.209991 203.72998 Z"
      />
      <path
        id="path6044"
        fill="#f7dbb6"
        stroke="none"
        d="M 261.859985 185.559998 C 261.859985 185.559998 261.049988 185.529999 260.839996 185.410004 C 260.630005 185.289978 260.609985 182.619995 261.049988 182.609985 C 261.48999 182.589996 261.970001 183.549988 261.859985 185.570007 L 261.859985 185.559998 Z"
      />
      <linearGradient
        id="linearGradient349"
        x1="257.307"
        y1="196.182"
        x2="254.29"
        y2="186.076"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6045"
        fill="url(#linearGradient349)"
        stroke="none"
        d="M 260.5 182.470001 C 260.5 182.470001 259.420013 182.580017 259.119995 183.839996 C 258.720001 185.51001 258.579987 191.059998 258.100006 191.619995 C 257.5 192.309998 253.690002 192.179993 253.690002 192.179993 C 250.520004 190.149994 248.550003 188.830017 247.649994 188.359985 C 247.649994 188.359985 251.869995 192.200012 252.949997 193.01001 C 253.75 193.609985 258.209991 193.119995 258.640015 193.190002 C 259.779999 193.369995 258.920013 191.309998 259.019989 190.429993 C 259.070007 190.02002 258.790009 185.440002 260.5 182.47998 L 260.5 182.470001 Z"
      />
      <linearGradient
        id="linearGradient350"
        x1="237.405"
        y1="185.18"
        x2="245.384"
        y2="185.348"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6046"
        fill="url(#linearGradient350)"
        stroke="none"
        d="M 245.339996 186.859985 C 245.339996 186.859985 240.720001 184.23999 238.830002 183.77002 C 238.190002 183.609985 237.029999 184.179993 237.509995 185.47998 C 237.509995 185.47998 237.770004 183.97998 238.770004 184.399994 C 239.770004 184.820007 245.339996 186.850006 245.339996 186.850006 L 245.339996 186.859985 Z"
      />
      <linearGradient
        id="linearGradient351"
        x1="233.911"
        y1="185.806"
        x2="237.51"
        y2="185.882"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6047"
        fill="url(#linearGradient351)"
        stroke="none"
        d="M 234.919998 187.47998 C 234.919998 187.47998 233.210007 186.029999 234.229996 184.75 C 235.470001 183.190002 237.509995 185.470001 237.509995 185.470001 C 237.509995 185.470001 235.660004 184.160004 234.740005 185.160004 C 233.960007 186 234.919998 187.470001 234.919998 187.470001 L 234.919998 187.47998 Z"
      />
      <linearGradient
        id="linearGradient352"
        x1="233.337"
        y1="189.775"
        x2="235.787"
        y2="189.827"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6048"
        fill="url(#linearGradient352)"
        stroke="none"
        d="M 235.729996 192.220001 C 235.729996 192.220001 232.740005 190.130005 233.460007 188.5 C 234.050003 187.169983 234.929993 187.470001 234.929993 187.470001 C 234.929993 187.470001 233.779999 187.660004 233.759995 189.109985 C 233.75 189.830017 235.740005 192.210022 235.740005 192.210022 L 235.729996 192.220001 Z"
      />
      <linearGradient
        id="linearGradient353"
        x1="233.727"
        y1="195.934"
        x2="240.596"
        y2="196.08"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6049"
        fill="url(#linearGradient353)"
        stroke="none"
        d="M 240.5 200.049988 C 240.5 200.049988 234.419998 195.570007 233.949997 194.609985 C 233.389999 193.460022 234.080002 191.960022 235.470001 192.029999 C 235.470001 192.029999 233.759995 192.440002 234.220001 194.140015 C 234.460007 195.039978 240.5 200.049988 240.5 200.049988 Z"
      />
      <linearGradient
        id="linearGradient354"
        x1="253.117"
        y1="216.038"
        x2="248.587"
        y2="200.829"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1c59a" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6050"
        fill="url(#linearGradient354)"
        stroke="none"
        d="M 240.910004 200.450012 C 240.910004 200.450012 243.419998 203.309998 247.020004 206.76001 C 247.460007 207.179993 258.029999 210.76001 258.029999 210.76001 L 258.720001 209.539978 C 258.720001 209.539978 247.899994 206.700012 247.479996 206.410004 C 247.059998 206.119995 240.910004 200.460022 240.910004 200.460022 L 240.910004 200.450012 Z"
      />
      <linearGradient
        id="linearGradient355"
        x1="265.011"
        y1="206.988"
        x2="260.696"
        y2="192.513"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6051"
        fill="url(#linearGradient355)"
        stroke="none"
        d="M 262.220001 189.52002 C 262.220001 189.52002 262.350006 190.859985 262.399994 191.399994 C 262.450012 191.940002 261.420013 197.890015 261.350006 198.279999 C 261.130005 199.669983 264.980011 203.359985 264.980011 203.359985 L 262.859985 203.669983 C 262.859985 203.669983 260.450012 199.419983 260.130005 198.820007 C 259.809998 198.220001 260.970001 195.450012 261.269989 194.660004 C 261.829987 193.190002 262.100006 190.820007 262.209991 189.52002 L 262.220001 189.52002 Z"
      />
      <linearGradient
        id="linearGradient356"
        x1="242.878"
        y1="186.546"
        x2="247.924"
        y2="191.013"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6052"
        fill="url(#linearGradient356)"
        stroke="none"
        d="M 244.830002 189.660004 C 244.669998 189.02002 246.399994 188.380005 246.399994 188.380005 C 246.399994 188.380005 248.419998 189.75 248.300003 190.359985 C 248.179993 190.970001 247.320007 191.539978 247.100006 191.549988 C 246.880005 191.549988 244.880005 189.880005 244.820007 189.660004 L 244.830002 189.660004 Z"
      />
      <linearGradient
        id="linearGradient357"
        x1="240.227"
        y1="189.38"
        x2="245.382"
        y2="193.95"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6053"
        fill="url(#linearGradient357)"
        stroke="none"
        d="M 242.169998 192.660004 C 241.830002 192.289978 243.699997 191 243.830002 191.220001 C 243.960007 191.440002 246.130005 192.809998 245.889999 193.119995 C 245.639999 193.429993 245.199997 194.369995 244.830002 194.460022 C 244.449997 194.549988 242.380005 192.880005 242.179993 192.660004 L 242.169998 192.660004 Z"
      />
      <linearGradient
        id="linearGradient358"
        x1="238.369"
        y1="192.112"
        x2="243.622"
        y2="196.774"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6054"
        fill="url(#linearGradient358)"
        stroke="none"
        d="M 241.389999 194.140015 C 241.699997 193.899994 243.929993 195.570007 243.970001 195.950012 C 244.009995 196.330017 243.440002 197.109985 243.220001 197.119995 C 243 197.119995 240.470001 195.630005 240.509995 195.169983 C 240.550003 194.710022 241.399994 194.140015 241.399994 194.140015 L 241.389999 194.140015 Z"
      />
      <linearGradient
        id="linearGradient359"
        x1="236.973"
        y1="186.721"
        x2="242.127"
        y2="191.291"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6055"
        fill="url(#linearGradient359)"
        stroke="none"
        d="M 239.669998 188.869995 C 239.960007 188.580017 240.729996 188.450012 240.729996 188.450012 C 240.729996 188.450012 242.869995 190.27002 242.770004 190.51001 C 242.679993 190.73999 241.800003 191.619995 241.419998 191.779999 C 241.039993 191.950012 238.75 190.210022 238.850006 189.899994 C 238.949997 189.589996 239.429993 189.119995 239.669998 188.880005 L 239.669998 188.869995 Z"
      />
      <linearGradient
        id="linearGradient360"
        x1="234.428"
        y1="188.828"
        x2="240.466"
        y2="194.176"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6056"
        fill="url(#linearGradient360)"
        stroke="none"
        d="M 237.320007 191.700012 C 237.320007 191.700012 237.75 190.919983 238.029999 191.059998 C 238.309998 191.200012 240.889999 193.080017 240.860001 193.390015 C 240.839996 193.700012 240.169998 194.640015 239.949997 194.649994 C 239.729996 194.649994 236.779999 192.869995 237.309998 191.700012 L 237.320007 191.700012 Z"
      />
      <linearGradient
        id="linearGradient361"
        x1="247.554"
        y1="192.436"
        x2="237.669"
        y2="183.585"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1c59a" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6057"
        fill="url(#linearGradient361)"
        stroke="none"
        d="M 248.759995 191.160004 C 248.5 191.289978 246.850006 191.869995 246.839996 191.869995 C 245.619995 191.210022 239.570007 186.51001 238 185.77002 C 238.660004 186.26001 246.199997 192.330017 246.559998 192.619995 C 246.410004 193.100006 245.899994 193.970001 246.25 193.429993 C 246.630005 192.839996 249.009995 191.02002 248.759995 191.160004 Z"
      />
      <linearGradient
        id="linearGradient362"
        x1="244.53"
        y1="195.433"
        x2="229.66"
        y2="181.536"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1c59a" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6058"
        fill="url(#linearGradient362)"
        stroke="none"
        d="M 245.690002 194.429993 C 245.529999 194.549988 244.960007 194.789978 244.589996 194.929993 C 243.289993 194.429993 235.850006 188.01001 235.130005 187.710022 C 234.440002 187.419983 242.839996 194.48999 244.139999 195.580017 C 244.139999 195.619995 244.139999 195.660004 244.139999 195.710022 C 244.139999 196.130005 243.509995 197.279999 243.860001 196.72998 C 244.229996 196.140015 245.929993 194.25 245.699997 194.429993 L 245.690002 194.429993 Z"
      />
      <linearGradient
        id="linearGradient363"
        x1="243.742"
        y1="199.147"
        x2="228.697"
        y2="186.426"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1c59a" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6059"
        fill="url(#linearGradient363)"
        stroke="none"
        d="M 243.669998 196.779999 C 243.550003 196.919983 243.199997 197.330017 242.910004 197.619995 C 242.289993 197.059998 236.089996 192.210022 235.619995 192.22998 C 235.179993 192.25 241.589996 197.23999 242.570007 197.98999 C 242.570007 198.070007 242.229996 200.910004 242.410004 200.27002 C 242.479996 200.02002 243.850006 196.570007 243.669998 196.779999 Z"
      />
      <linearGradient
        id="linearGradient364"
        x1="278.705"
        y1="211.648"
        x2="248.019"
        y2="196.486"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1c59a" stopOpacity={1} />
        <stop offset="0.53" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6060"
        fill="url(#linearGradient364)"
        stroke="none"
        d="M 245.869995 199.850006 C 245.869995 199.850006 251.169998 194.950012 251.419998 193.919983 C 251.669998 192.880005 253.850006 200.799988 255.089996 201.960022 C 256.320007 203.109985 247.130005 200.100006 245.880005 199.859985 L 245.869995 199.850006 Z"
      />
      <linearGradient
        id="linearGradient365"
        x1="252.571"
        y1="211.106"
        x2="249.526"
        y2="200.909"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6061"
        fill="url(#linearGradient365)"
        stroke="none"
        d="M 244.25 201.649994 C 244.25 201.649994 246.389999 205.299988 247.960007 205.929993 C 249.529999 206.549988 254.449997 208.570007 255.399994 207.619995 C 256.359985 206.669983 257.299988 204.119995 254.490005 203.309998 C 251.690002 202.5 242.259995 198.910004 244.25 201.649994 Z"
      />
      <path
        id="path6062"
        fill="#f7d4ab"
        stroke="none"
        d="M 264.98999 203.359985 C 264.98999 203.359985 284 218.200012 293.480011 220.51001 C 298.980011 221.850006 312.059998 217.119995 313.109985 216.649994 C 320.089996 213.51001 325.959991 210.109985 325.959991 210.109985 L 324.25 233.72998 L 289.799988 234.369995 L 276.070007 226.529999 L 258.170013 210.580017 C 258.170013 210.580017 259.089996 208.320007 264.98999 203.369995 L 264.98999 203.359985 Z"
      />
      <linearGradient
        id="linearGradient366"
        x1="259.21"
        y1={213}
        x2="324.81"
        y2="240.82"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f2c59a" stopOpacity={1} />
        <stop offset="0.37" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset={1} stopColor="#f3c79d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6063"
        fill="url(#linearGradient366)"
        stroke="none"
        d="M 258.019989 210.76001 C 258.019989 210.76001 283.649994 234.640015 289.079987 236.47998 C 294.51001 238.330002 326.76001 234.72998 326.76001 234.72998 L 324.76001 229.970001 C 324.76001 229.970001 299.390015 236.929993 288.76001 232.049988 C 282.880005 229.350006 258.709991 209.529999 258.709991 209.529999 C 258.709991 209.529999 258.23999 210.190002 258.019989 210.75 L 258.019989 210.76001 Z"
      />
      <linearGradient
        id="linearGradient367"
        x1="268.84"
        y1="209.27"
        x2="336.15"
        y2="220.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6064"
        fill="url(#linearGradient367)"
        stroke="none"
        d="M 264.690002 203.160004 C 264.690002 203.160004 285.670013 216.97998 292.98999 218.899994 C 295.290009 219.5 312.76001 216.070007 312.76001 216.070007 C 312.76001 216.070007 323.230011 211.809998 326.959991 210.089996 C 323.470001 213.419983 317.26001 215.039978 315.269989 217.140015 C 313.73999 218.76001 294.350006 222.660004 293.48999 222.660004 C 292.630005 222.660004 262.880005 203.669983 262.880005 203.669983 L 264.690002 203.160004 Z"
      />
      <path
        id="path6065"
        fill="#d1d1d1"
        stroke="none"
        d="M 326.410004 209.929993 L 313.920013 215.179993 L 319.100006 235.580017 L 333.309998 233.27002 L 326.410004 209.929993 Z"
      />
      <linearGradient
        id="linearGradient368"
        x1="314.18"
        y1="214.76"
        x2="319.1"
        y2="236.54"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f6d1a8" stopOpacity={1} />
        <stop offset={1} stopColor="#f2c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6066"
        fill="url(#linearGradient368)"
        stroke="none"
        d="M 312.019989 216.210022 L 316.609985 214.51001 L 320.25 235.410004 L 317.690002 235.580017 L 312.019989 216.210022 Z"
      />
      <path
        id="path6067"
        fill="#f7d4ab"
        stroke="none"
        d="M 391.059998 212.460022 C 392.940002 213.279999 394.660004 214.27002 395.980011 215.5 C 401.410004 220.570007 409.380005 232.52002 411.549988 235.419983 C 413.720001 238.320007 426.399994 248.820007 424.950012 258.23999 C 423.5 267.660004 394.649994 294.98999 394.649994 294.98999 L 391.040009 285.619995 C 391.040009 285.619995 393.920013 283.690002 400.320007 273.440002 C 402.51001 269.940002 409.369995 255.690002 409.369995 255.690002 C 397.059998 248.809998 391.26001 237.940002 391.26001 237.940002 C 391.26001 237.940002 389.820007 221.470001 391.049988 212.450012 L 391.059998 212.460022 Z"
      />
      <linearGradient
        id="linearGradient369"
        x1="404.38"
        y1="229.46"
        x2="407.7"
        y2="298.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6068"
        fill="url(#linearGradient369)"
        stroke="none"
        d="M 418.480011 254.929993 C 418.76001 253.600006 402.579987 249.25 395.390015 235.100006 L 391.959991 239.130005 C 391.959991 239.130005 396.899994 248.639999 409.369995 255.690002 C 409.369995 255.690002 403.109985 268.76001 397.149994 278.26001 C 397.690002 278.609985 398.290009 279.149994 398.839996 279.390015 C 400.549988 276.98999 402.329987 274.160004 404.089996 271.079987 C 408.73999 262.959991 418.190002 256.25 418.470001 254.919998 L 418.480011 254.929993 Z"
      />
      <linearGradient
        id="linearGradient370"
        x1="412.89"
        y1="231.04"
        x2="413.48"
        y2="254.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6069"
        fill="url(#linearGradient370)"
        stroke="none"
        d="M 408.589996 231.279999 C 408.589996 231.279999 411.200012 235.089996 411.950012 235.910004 C 412.700012 236.72998 420.540009 244.509995 422.399994 248.429993 C 424.26001 252.350006 415.380005 246.539993 413.399994 244.490005 C 411.429993 242.449997 403.670013 235.039978 403.670013 235.039978 L 408.589996 231.27002 L 408.589996 231.279999 Z"
      />
      <linearGradient
        id="linearGradient371"
        x1="394.67"
        y1="242.93"
        x2="407.25"
        y2="230.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6070"
        fill="url(#linearGradient371)"
        stroke="none"
        d="M 393.459991 241.350006 L 395.589996 244.110001 L 408.809998 231.580017 L 406.76001 228.710022 L 393.459991 241.350006 Z"
      />
      <linearGradient
        id="linearGradient372"
        x1="411.55"
        y1="255.31"
        x2="412.52"
        y2="293.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6071"
        fill="url(#linearGradient372)"
        stroke="none"
        d="M 425.059998 257.359985 C 425.059998 261.079987 423.149994 263.350006 416.25 272.190002 C 408.799988 281.730011 399.049988 289.299988 398.839996 285.540009 C 398.619995 281.730011 425.059998 246.240005 425.059998 257.369995 L 425.059998 257.359985 Z"
      />
      <path
        id="path6072"
        fill="#f7d4ab"
        stroke="none"
        d="M 376.600006 206.27002 C 376.600006 206.27002 370.670013 204.539978 369.519989 202.940002 C 369.519989 202.940002 354.519989 207.950012 348.160004 202.160004 L 341.910004 205.100006 C 341.910004 205.100006 347.549988 216.52002 357.380005 216.380005 C 367.209991 216.23999 376.609985 206.26001 376.609985 206.26001 L 376.600006 206.27002 Z"
      />
      <path
        id="path6073"
        fill="#d1d1d1"
        stroke="none"
        d="M 326.660004 234.609985 C 325.850006 229.450012 324.690002 210.830017 324.690002 210.830017 C 327.220001 208.98999 344.079987 203.880005 344.079987 203.880005 C 344.079987 203.880005 346.420013 214.419983 358.380005 215.080017 C 370.339996 215.73999 372.350006 204.429993 372.350006 204.429993 C 393.369995 212.869995 393.429993 212.950012 393.429993 212.950012 C 392.98999 213.830017 392.070007 227.210022 390.839996 234.609985 L 387.320007 234.609985 C 386.720001 238.179993 386.279999 241.020004 386.200012 241.520004 C 384.179993 254.410004 381.619995 281.829987 382.160004 309.929993 C 380.230011 311.160004 369.850006 312.880005 356.829987 311.869995 C 342.51001 310.75 336.190002 307.73999 333.299988 305.899994 C 334.559998 285.450012 332.48999 268.130005 330.190002 242.800003 C 330.059998 241.309998 326.649994 234.609985 326.649994 234.609985 L 326.660004 234.609985 Z"
      />
      <linearGradient
        id="linearGradient373"
        x1="354.61"
        y1="212.56"
        x2="360.27"
        y2="211.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.13" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset="0.47" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6074"
        fill="url(#linearGradient373)"
        stroke="none"
        d="M 361.100006 210.619995 L 357.660004 214.75 L 354.559998 209.929993 L 358.690002 212 L 361.100006 210.619995 Z"
      />
      <linearGradient
        id="linearGradient374"
        x1="342.81"
        y1="195.86"
        x2="373.94"
        y2="210.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.13" stopColor="#f5cfa5" stopOpacity={1} />
        <stop offset="0.47" stopColor="#f1c79c" stopOpacity={1} />
        <stop offset={1} stopColor="#f1c59a" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6075"
        fill="url(#linearGradient374)"
        stroke="none"
        d="M 341.980011 204.799988 C 341.980011 204.799988 345.950012 217.25 359.100006 216.380005 C 372.25 215.51001 373.839996 205.100006 373.839996 205.100006 C 373.839996 205.100006 369.920013 203.559998 369.769989 202.549988 C 369.700012 202.080017 369.649994 201.690002 369.600006 200.850006 C 369.649994 197.149994 369.660004 192.710022 369.660004 192.710022 C 356.200012 197.390015 348.51001 191.839996 348.51001 191.839996 C 348.459991 192.309998 348.279999 195.27002 348.119995 197.940002 C 347.899994 199.970001 347.570007 202.100006 347.23999 202.350006 C 346.660004 202.779999 341.970001 204.789978 341.970001 204.789978 L 341.980011 204.799988 Z M 346.519989 206.77002 L 349.869995 204.190002 C 352.640015 206.27002 356.380005 208.02002 358.809998 208.23999 C 361.01001 208.440002 364.839996 206.609985 368.140015 203.570007 C 368.290009 204.339996 368.529999 205.059998 368.920013 205.26001 C 369.5 205.549988 370.649994 206.419983 370.649994 206.419983 C 370.649994 206.419983 368.149994 214.330017 358.429993 214.01001 C 356.26001 213.940002 349.320007 212.640015 346.5 206.779999 L 346.519989 206.77002 Z"
      />
      <path
        id="path6076"
        fill="#d1d1d1"
        stroke="none"
        d="M 372.350006 204.429993 C 372.350006 204.429993 369.890015 215.289978 358.309998 214.789978 C 346.600006 214.279999 344.079987 203.880005 344.079987 203.880005 L 341.119995 204.799988 C 341.119995 204.799988 345.519989 219.570007 359.679993 218.700012 C 373.850006 217.830017 375.649994 205.76001 375.649994 205.76001 L 372.350006 204.429993 Z"
      />
      <path
        id="path6077"
        fill="#efefef"
        stroke="#f4f4f4"
        strokeWidth="1.06"
        d="M 381.299988 223.029999 C 373.910004 218.679993 369.640015 220.029999 358.119995 220.359985 C 346.600006 220.679993 339.209991 218.399994 335.079987 222.529999 C 330.950012 226.660004 332.570007 243.770004 355.730011 245.350006 C 382.950012 247.199997 388.690002 227.369995 381.299988 223.029999 Z"
      />
      <path
        id="path6078"
        fill="#d1d1d1"
        stroke="none"
        d="M 408.470001 230.210022 C 408.470001 230.210022 401.200012 219.98999 398.820007 217.339996 C 396.470001 214.720001 394.48999 213.429993 393.420013 212.940002 C 392.359985 212.450012 385.700012 236.649994 385.700012 236.649994 L 393.859985 243 L 408.459991 230.200012 L 408.470001 230.210022 Z"
      />
      <path
        id="path6079"
        fill="#f2f2f2"
        stroke="none"
        d="M 393.869995 243 L 395.790009 241.399994 C 395.790009 241.399994 388.829987 236.089996 387 235.649994 C 385.600006 235.309998 382.23999 255.740005 385.26001 276.98999 C 385.26001 276.98999 384.779999 260.640015 390.559998 240.740005 C 391.660004 241.559998 393.869995 243 393.869995 243 Z"
      />
      <path
        id="path6080"
        fill="#d1d1d1"
        stroke="none"
        d="M 386.980011 256.619995 C 386.980011 256.619995 386.51001 260.019989 386.51001 260.540009 C 386.51001 260.540009 382.220001 249.199997 382.109985 248.300003 C 382 247.399994 379.320007 228.609985 379.320007 228.609985 L 384.859985 209.460022 L 386.679993 210.190002 C 386.679993 210.190002 382.089996 228.380005 382.160004 228.820007 C 382.230011 229.26001 386.980011 256.619995 386.980011 256.619995 Z"
      />
      <linearGradient
        id="linearGradient375"
        x1="331.42"
        y1="188.51"
        x2="335.28"
        y2="259.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fe4e21" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f24027" stopOpacity={1} />
        <stop offset={1} stopColor="#ed3b2b" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6081"
        fill="url(#linearGradient375)"
        stroke="none"
        d="M 331.899994 207.839996 L 329.450012 208.720001 L 335.670013 228.830017 L 330.48999 256.320007 L 331.720001 263.170013 L 338.290009 230.119995 L 331.899994 207.839996 Z"
      />
      <path
        id="path6082"
        fill="#d1d1d1"
        stroke="none"
        d="M 319.970001 231.690002 C 319.970001 231.690002 326.459991 229.76001 327.769989 229.809998 C 328.959991 229.859985 330.959991 241.580002 333 252.440002 C 333.450012 254.839996 332.609985 265.880005 332.609985 265.880005 C 332.609985 265.880005 326.779999 236.600006 325.390015 235.330017 C 324.98999 234.960022 320.019989 235.52002 320.019989 235.52002 L 319.950012 231.690002 L 319.970001 231.690002 Z"
      />
      <linearGradient
        id="linearGradient376"
        x1="353.43"
        y1="195.85"
        x2="355.23"
        y2="229.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fe4e21" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f24027" stopOpacity={1} />
        <stop offset={1} stopColor="#ed3b2b" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6083"
        fill="url(#linearGradient376)"
        stroke="none"
        d="M 372.459991 227.130005 L 345.140015 227.130005 L 338.290009 205.700012 L 336.670013 206.220001 L 343.890015 228.619995 L 372.459991 229.649994 L 372.459991 227.130005 Z"
      />
      <path
        id="path6084"
        fill="#1b2c60"
        stroke="none"
        d="M 349.450012 357.850006 C 351.929993 346.299988 354.839996 332.980011 354.839996 332.980011 L 359.450012 342.109985 C 359.450012 342.109985 358.820007 348.299988 357.970001 356.640015 C 359.540009 356.420013 361.089996 356.200012 362.660004 355.98999 C 370.769989 356.019989 378.519989 357.339996 385.910004 359.959991 C 387.529999 343.01001 389.549988 320.5 389.640015 313.040009 C 389.679993 309.48999 385.850006 292.359985 385.880005 287 C 385.910004 281.649994 386.709991 259.559998 386.709991 259.559998 C 385.869995 256.75 379.320007 231.160004 379.480011 229.640015 L 385.940002 209.779999 L 378.690002 206.799988 L 372.23999 227.799988 L 344.279999 227.799988 L 337.690002 205.880005 L 330.609985 208.279999 L 337.01001 229.77002 L 332.369995 259.350006 C 332.369995 259.350006 331.619995 279.730011 330.100006 289.429993 C 329.820007 291.23999 325.339996 318.029999 325.339996 318.029999 C 325.339996 318.029999 323.670013 338.220001 323.350006 345.910004 C 323.220001 349.070007 322.119995 355.779999 320.859985 362.609985 C 330.410004 360.829987 339.880005 359.25 349.450012 357.829987 L 349.450012 357.850006 Z"
      />
      <linearGradient
        id="linearGradient377"
        x1="357.28"
        y1="260.3"
        x2="359.89"
        y2="230.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6085"
        fill="url(#linearGradient377)"
        stroke="none"
        d="M 340.320007 238.039993 C 340.029999 235.529999 345.529999 231.450012 363.75 233.51001 C 368.149994 234.01001 376.579987 235.25 377.929993 236.929993 C 379.279999 238.619995 374.410004 256.600006 359.119995 257.369995 C 343.829987 258.140015 340.51001 239.710007 340.309998 238.029999 L 340.320007 238.039993 Z"
      />
      <linearGradient
        id="linearGradient378"
        x1="357.64"
        y1="340.18"
        x2="360.28"
        y2="289.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6086"
        fill="url(#linearGradient378)"
        stroke="none"
        d="M 358.899994 289.040009 L 356.850006 322.75 L 360.799988 311.790009 L 358.899994 289.040009 Z"
      />
      <linearGradient
        id="linearGradient379"
        x1="359.17"
        y1="264.48"
        x2="360.54"
        y2="233.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6087"
        fill="url(#linearGradient379)"
        stroke="none"
        d="M 343.279999 237.080002 C 343.279999 237.080002 370.470001 238.800003 377.470001 237.229996 C 377.470001 237.229996 349.23999 236.929993 343.279999 237.080002 Z"
      />
      <linearGradient
        id="linearGradient380"
        x1="359.24"
        y1="263.33"
        x2="360.57"
        y2="233.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6088"
        fill="url(#linearGradient380)"
        stroke="none"
        d="M 343.279999 239.610001 L 343.279999 246.889999 L 351.700012 246.889999 L 377.309998 246.889999 L 377.309998 240.440002 L 378.320007 248.039993 L 341.519989 248.020004 L 343.279999 239.610001 Z"
      />
      <linearGradient
        id="linearGradient381"
        x1="377.07"
        y1="220.11"
        x2="339.36"
        y2="220.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6089"
        fill="url(#linearGradient381)"
        stroke="none"
        d="M 377.070007 212.140015 L 371.98999 228.720001 C 371.98999 228.720001 365.820007 228.799988 359.170013 228.830017 C 351.540009 228.859985 343.279999 228.809998 342.980011 228.470001 C 342.420013 227.830017 339.359985 211.399994 339.359985 211.399994 L 344.290009 227.820007 L 371.399994 227.880005 L 377.059998 212.149994 L 377.070007 212.140015 Z"
      />
      <linearGradient
        id="linearGradient382"
        x1="363.21"
        y1="281.33"
        x2="351.7"
        y2="386.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6090"
        fill="url(#linearGradient382)"
        stroke="none"
        d="M 349.850006 357.790009 L 354.980011 335.299988 L 359.459991 342.109985 L 357.980011 356.640015 C 358.920013 356.51001 359.850006 356.380005 360.790009 356.25 L 363.359985 342.690002 L 356.649994 325.359985 L 351.059998 330.820007 L 347.920013 358.079987 C 348.559998 357.980011 349.200012 357.880005 349.839996 357.790009 L 349.850006 357.790009 Z"
      />
      <linearGradient
        id="linearGradient383"
        x1="341.56"
        y1="313.68"
        x2="322.18"
        y2="397.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6091"
        fill="url(#linearGradient383)"
        stroke="none"
        d="M 341.869995 359.01001 C 346.049988 348.790009 347.48999 332.579987 347.790009 324.910004 C 348.079987 317.410004 344.899994 303.51001 335.269989 308.079987 C 327.429993 311.799988 322.769989 346.959991 326.720001 361.559998 C 331.769989 360.660004 336.820007 359.799988 341.880005 359 L 341.869995 359.01001 Z"
      />
      <linearGradient
        id="linearGradient384"
        x1="382.47"
        y1="316.46"
        x2="360.37"
        y2="412.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6092"
        fill="url(#linearGradient384)"
        stroke="none"
        d="M 384.140015 359.359985 C 386.309998 338.950012 383.119995 309.899994 376.589996 308.230011 C 370.880005 306.769989 366.230011 334.899994 366.920013 356.130005 C 372.850006 356.48999 378.589996 357.570007 384.140015 359.359985 Z"
      />
      <linearGradient
        id="linearGradient385"
        x1="358.86"
        y1="306.37"
        x2="349.86"
        y2="345.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6093"
        fill="url(#linearGradient385)"
        stroke="none"
        d="M 358.019989 303.369995 L 356.660004 325.359985 L 351.070007 330.820007 C 351.070007 330.820007 353.899994 325.769989 354.700012 324.529999 C 355.51001 323.299988 358.019989 303.359985 358.019989 303.359985 L 358.019989 303.369995 Z"
      />
      <linearGradient
        id="linearGradient386"
        x1="381.51"
        y1="215.7"
        x2="381.96"
        y2="206.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6094"
        fill="url(#linearGradient386)"
        stroke="none"
        d="M 385.950012 209.789978 L 378.700012 206.809998 L 377.649994 210.22998 L 384.940002 212.910004 L 385.950012 209.789978 Z"
      />
      <linearGradient
        id="linearGradient387"
        x1="334.37"
        y1="215.96"
        x2="334.9"
        y2="205.73"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6095"
        fill="url(#linearGradient387)"
        stroke="none"
        d="M 338.839996 209.669983 L 337.700012 205.890015 L 330.630005 208.289978 L 331.829987 212.350006 L 338.839996 209.669983 Z"
      />
      <linearGradient
        id="linearGradient388"
        x1="385.18"
        y1="217.67"
        x2="383.48"
        y2="312.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6096"
        fill="url(#linearGradient388)"
        stroke="none"
        d="M 383.98999 215.809998 L 379.929993 229.830017 C 379.929993 229.830017 385.380005 254.660004 386.720001 259.570007 L 386.480011 287.01001 C 386.480011 287.01001 389.98999 306.100006 389.640015 313.809998 C 389.640015 313.809998 383.309998 287.880005 383.679993 285.609985 C 384.049988 283.339996 383.820007 261.790009 383.700012 261.059998 C 383.579987 260.329987 378.899994 232.47998 378.76001 230.02002 C 378.720001 229.26001 383.980011 215.809998 383.980011 215.809998 L 383.98999 215.809998 Z"
      />
      <linearGradient
        id="linearGradient389"
        x1="332.99"
        y1="220.14"
        x2="331.29"
        y2="315.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6097"
        fill="url(#linearGradient389)"
        stroke="none"
        d="M 333.980011 219.539978 L 337.029999 229.789978 C 337.029999 229.789978 331.269989 256.980011 331.040009 260 C 330.950012 261.149994 330.25 286.679993 330.200012 287.76001 C 330.119995 289.450012 325.820007 315.279999 325.820007 315.279999 C 325.820007 315.279999 334.119995 288.369995 334.119995 286.98999 C 334.119995 285.609985 334.399994 260.410004 334.399994 259.76001 C 334.399994 259.109985 338.309998 230.73999 338.309998 230.119995 C 338.309998 229.5 334 219.539978 334 219.539978 L 333.980011 219.539978 Z"
      />
      <linearGradient
        id="linearGradient390"
        x1="359.56"
        y1="225.761"
        x2="357.98"
        y2="313.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6098"
        fill="url(#linearGradient390)"
        stroke="none"
        d="M 386.480011 287.01001 C 386.480011 287.01001 368.609985 290.769989 330.420013 287.48999 C 330.420013 287.48999 365.589996 287.549988 386.480011 287.01001 Z"
      />
      <linearGradient
        id="linearGradient391"
        x1="387.39"
        y1="292.7"
        x2="376.94"
        y2="292.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6099"
        fill="url(#linearGradient391)"
        stroke="none"
        d="M 387.390015 297.640015 C 387.390015 297.640015 382 295.429993 380.51001 294.440002 C 379.019989 293.450012 376.940002 287.75 376.940002 287.75 L 381.390015 292.76001 L 387.390015 297.640015 Z"
      />
      <linearGradient
        id="linearGradient392"
        x1="328.95"
        y1="292.7"
        x2="339.96"
        y2="292.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#0d1834" stopOpacity={1} />
        <stop offset={1} stopColor="#1b2c60" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6100"
        fill="url(#linearGradient392)"
        stroke="none"
        d="M 328.950012 297.640015 C 328.950012 297.640015 334.899994 295.429993 336.390015 294.440002 C 337.880005 293.450012 339.959991 287.75 339.959991 287.75 L 335.51001 292.76001 L 328.950012 297.640015 Z"
      />
      <linearGradient
        id="linearGradient393"
        x1="335.69"
        y1="316.3"
        x2="334.12"
        y2="286.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6101"
        fill="url(#linearGradient393)"
        stroke="none"
        d="M 339.959991 287.75 C 339.959991 287.75 337.279999 293.940002 336.390015 294.440002 C 335.48999 294.940002 328.950012 297.640015 328.950012 297.640015 C 328.950012 297.640015 337.670013 296.279999 338.109985 295.410004 C 338.549988 294.540009 339.959991 287.75 339.959991 287.75 Z"
      />
      <linearGradient
        id="linearGradient394"
        x1="383.29"
        y1="314.14"
        x2="381.71"
        y2="283.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6102"
        fill="url(#linearGradient394)"
        stroke="none"
        d="M 387.390015 297.640015 C 387.390015 297.640015 381.420013 295.459991 380.51001 294.440002 C 379.600006 293.420013 376.940002 287.75 376.940002 287.75 C 376.940002 287.75 377.73999 294.890015 379.019989 295.579987 C 380.299988 296.279999 387.390015 297.630005 387.390015 297.630005 L 387.390015 297.640015 Z"
      />
      <path
        id="path6103"
        fill="#f2f2f2"
        stroke="none"
        d="M 393.869995 243 L 391.059998 241.100006 C 391.059998 241.100006 405.470001 228.01001 406.279999 227.149994 C 406.279999 227.149994 407.910004 229.380005 408.470001 230.200012 C 408.470001 230.200012 395.480011 241.720001 393.869995 243 Z"
      />
      <path
        id="path6104"
        fill="#f7d4ab"
        stroke="none"
        d="M 395.929993 281.100006 C 395.929993 281.100006 392.48999 284.570007 391.410004 285.190002 C 390.329987 285.809998 383.660004 287.230011 382.859985 287.399994 C 382.049988 287.570007 377.75 288.709991 376.160004 289.679993 C 374.570007 290.649994 371.730011 292.76001 370.850006 293.799988 C 370.359985 294.380005 370.079987 294.980011 370.73999 295.579987 C 371.399994 296.179993 372.480011 295.850006 373.51001 294.950012 C 374.140015 294.399994 376.890015 293.160004 378.209991 292.640015 C 379.519989 292.119995 381.609985 292.079987 382.029999 292.25 C 382.940002 292.630005 379.410004 295.269989 378.200012 296.679993 C 377.01001 298.070007 374.869995 300.119995 374.26001 300.779999 C 373.649994 301.440002 372.23999 303.070007 373.350006 304.029999 C 374.459991 305 376.73999 302.299988 378.26001 301.209991 C 379.929993 300.019989 383.829987 295.720001 385.179993 295.23999 C 386.230011 294.869995 382.76001 298.399994 381.829987 299.279999 C 380.910004 300.149994 376.940002 303.880005 376.940002 303.880005 C 376.940002 303.880005 375.660004 305.230011 376.589996 306.130005 C 377.880005 307.380005 379.640015 305.230011 380.950012 304.109985 C 381.850006 303.339996 385.600006 300.23999 385.940002 299.950012 C 386.279999 299.660004 387.850006 298.149994 388.220001 298.299988 C 389.149994 298.690002 385.309998 302.390015 384.959991 302.790009 C 383.929993 303.959991 383.100006 304.950012 382.980011 305.519989 C 382.75 306.600006 383.579987 306.799988 384.410004 306.399994 C 385.23999 306 386.76001 304.859985 387.029999 304.480011 C 387.299988 304.109985 392.5 298.940002 393.809998 297.540009 C 395.119995 296.140015 398.98999 293.350006 399.76001 290.109985 C 400.119995 288.589996 401.559998 287.649994 402.140015 287.299988 L 395.929993 281.089996 L 395.929993 281.100006 Z"
      />
      <linearGradient
        id="linearGradient395"
        x1="381.86"
        y1="301.24"
        x2="376.35"
        y2="306.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6105"
        fill="url(#linearGradient395)"
        stroke="none"
        d="M 376.75 304.48999 C 377.040009 304.079987 379.630005 301.950012 380.019989 301.609985 C 381.019989 300.75 383.589996 300.920013 381.399994 303.179993 C 378.76001 305.899994 377.609985 306.410004 377.299988 306.339996 C 376.980011 306.269989 375.940002 305.630005 376.75 304.480011 L 376.75 304.48999 Z"
      />
      <path
        id="path6106"
        fill="#ffdebd"
        stroke="none"
        d="M 378.850006 304.320007 C 378.649994 303.850006 378.059998 303.730011 377.549988 304.109985 C 377.329987 304.269989 376.559998 304.890015 376.51001 305.279999 C 376.440002 305.799988 377 306.190002 377.089996 306.190002 C 377.23999 306.200012 377.630005 306.470001 378.089996 305.950012 C 378.549988 305.420013 379.079987 304.839996 378.850006 304.320007 Z"
      />
      <linearGradient
        id="linearGradient396"
        x1="439.07"
        y1="251.68"
        x2="386.92"
        y2="294.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6107"
        fill="url(#linearGradient396)"
        stroke="none"
        d="M 398.850006 288.48999 C 400.100006 289.179993 394.459991 297.399994 393.149994 297.130005 C 392.190002 296.929993 384.390015 287.420013 385.420013 287.149994 C 387.450012 286.630005 390.75 286.410004 390.75 286.410004 C 390.559998 288.48999 397.899994 287.970001 398.850006 288.48999 Z"
      />
      <linearGradient
        id="linearGradient397"
        x1="387.2"
        y1="231.59"
        x2="390.42"
        y2="298.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6108"
        fill="url(#linearGradient397)"
        stroke="none"
        d="M 391.230011 285.279999 C 388.339996 286.399994 382.790009 287.26001 380.549988 288.01001 C 380.549988 288.01001 388.290009 287.809998 391.470001 286.73999 C 393.440002 286.079987 396.040009 283.329987 398.839996 279.410004 C 398.299988 279.160004 397.700012 278.630005 397.149994 278.279999 C 394.640015 281.709991 392.299988 284.869995 391.220001 285.290009 L 391.230011 285.279999 Z"
      />
      <linearGradient
        id="linearGradient398"
        x1="389.76"
        y1="310.36"
        x2="396.53"
        y2="291.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba779" stopOpacity={1} />
        <stop offset="0.5" stopColor="#e4b386" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6109"
        fill="url(#linearGradient398)"
        stroke="none"
        d="M 406.450012 283.140015 C 406.450012 283.140015 399.160004 288.209991 398.839996 288.48999 C 398.519989 288.769989 397.470001 292.350006 394.440002 295.709991 C 391.410004 299.070007 384.390015 306.420013 384.390015 306.420013 C 384.390015 306.420013 386.130005 305.709991 388.529999 303 C 391.170013 300.019989 397.299988 294.679993 398.329987 293.200012 C 399.809998 291.089996 399.420013 290.230011 401.540009 288.200012 C 403.660004 286.170013 404.519989 285.190002 406.440002 283.140015 L 406.450012 283.140015 Z"
      />
      <linearGradient
        id="linearGradient399"
        x1="400.58"
        y1="280.55"
        x2="369.28"
        y2="299.59"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba779" stopOpacity={1} />
        <stop offset="0.5" stopColor="#e4b386" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6110"
        fill="url(#linearGradient399)"
        stroke="none"
        d="M 370.730011 295.570007 C 370.730011 295.570007 372.019989 296.26001 374.75 293.850006 C 377.309998 291.579987 378.720001 290.779999 379.679993 290.670013 C 380.630005 290.559998 384.230011 290.209991 384.649994 290.459991 C 385.070007 290.709991 377.75 297.700012 376.920013 298.059998 C 379.179993 295.200012 382.700012 292.730011 382.01001 292.279999 C 381.670013 292.059998 379.420013 292.109985 378.209991 292.619995 C 377 293.130005 372.850006 295.630005 372.230011 295.790009 C 371.609985 295.950012 371.160004 296 370.73999 295.559998 L 370.730011 295.570007 Z"
      />
      <linearGradient
        id="linearGradient400"
        x1="404.26"
        y1="284.41"
        x2="371.82"
        y2="304.13"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba779" stopOpacity={1} />
        <stop offset="0.5" stopColor="#e4b386" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6111"
        fill="url(#linearGradient400)"
        stroke="none"
        d="M 375.480011 303.51001 C 375.480011 303.51001 380.75 298.679993 381.089996 298.309998 C 382.019989 297.299988 385.480011 293.790009 386.589996 293.410004 C 387.959991 292.929993 385.570007 295.820007 384.100006 297.429993 C 382.829987 298.820007 380.160004 300.839996 380.160004 300.839996 C 380.160004 300.839996 384.480011 296.440002 384.899994 295.940002 C 385.829987 294.850006 384.899994 295.290009 384.230011 295.940002 C 383.609985 296.540009 377.869995 302.109985 375.470001 303.51001 L 375.480011 303.51001 Z"
      />
      <linearGradient
        id="linearGradient401"
        x1="401.03"
        y1="291.2"
        x2="379.94"
        y2="304.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba779" stopOpacity={1} />
        <stop offset="0.5" stopColor="#e4b386" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6112"
        fill="url(#linearGradient401)"
        stroke="none"
        d="M 382.049988 303.179993 C 382.049988 303.179993 387.559998 297.519989 388.859985 296.779999 C 389.920013 296.179993 390.049988 297.359985 388.679993 298.98999 C 387.309998 300.630005 384.940002 302.809998 384.940002 302.809998 C 384.940002 302.809998 388.609985 299.070007 388.320007 298.429993 C 388.100006 297.950012 384.850006 301.029999 382.040009 303.170013 L 382.049988 303.179993 Z"
      />
      <linearGradient
        id="linearGradient402"
        x1="378.72"
        y1="298.51"
        x2="372.85"
        y2="304.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6113"
        fill="url(#linearGradient402)"
        stroke="none"
        d="M 373.51001 302.089996 C 373.799988 301.690002 376.75 299.040009 377.140015 298.709991 C 378.149994 297.869995 380.26001 298.26001 378.049988 300.450012 C 375.399994 303.089996 374.109985 304.059998 373.790009 303.98999 C 373.470001 303.920013 372.690002 303.200012 373.51001 302.089996 Z"
      />
      <path
        id="path6114"
        fill="#ffdebd"
        stroke="none"
        d="M 375.549988 302.040009 C 375.350006 301.570007 374.76001 301.450012 374.25 301.829987 C 374.029999 301.98999 373.26001 302.609985 373.209991 303 C 373.140015 303.519989 373.700012 303.910004 373.790009 303.910004 C 373.940002 303.920013 374.329987 304.190002 374.790009 303.670013 C 375.25 303.140015 375.779999 302.559998 375.549988 302.040009 Z"
      />
      <linearGradient
        id="linearGradient403"
        x1="376.91"
        y1="290.19"
        x2="370.59"
        y2="295.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6115"
        fill="url(#linearGradient403)"
        stroke="none"
        d="M 374.850006 290.790009 C 375.130005 290.640015 376.149994 290.070007 376.640015 290.630005 C 377.380005 291.480011 373.890015 293.959991 373.220001 294.589996 C 372.25 295.480011 369.769989 295.519989 371.119995 293.859985 C 372.470001 292.200012 374.559998 290.950012 374.850006 290.799988 L 374.850006 290.790009 Z"
      />
      <path
        id="path6116"
        fill="#ffdebd"
        stroke="none"
        d="M 372.690002 293.600006 C 372.399994 293.350006 371.890015 293.200012 371.410004 293.600006 C 370.929993 294 370.359985 294.459991 370.320007 294.899994 C 370.279999 295.309998 370.76001 295.869995 371.429993 295.730011 C 371.690002 295.679993 372.929993 294.859985 372.980011 294.299988 C 373 294.059998 372.880005 293.76001 372.679993 293.589996 L 372.690002 293.600006 Z"
      />
      <linearGradient
        id="linearGradient404"
        x1="386.29"
        y1="303.28"
        x2="382.87"
        y2="306.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6117"
        fill="url(#linearGradient404)"
        stroke="none"
        d="M 385.859985 303.179993 C 386.209991 303.519989 386.399994 304.48999 383.880005 306.410004 C 383.429993 306.75 382.730011 305.790009 383.48999 304.790009 C 383.690002 304.529999 385.130005 302.470001 385.850006 303.170013 L 385.859985 303.179993 Z"
      />
      <path
        id="path6118"
        fill="#ffdebd"
        stroke="none"
        d="M 384.420013 304.549988 C 384.089996 304.459991 383.589996 304.899994 383.190002 305.48999 C 382.790009 306.079987 383.190002 306.51001 383.609985 306.48999 C 383.970001 306.480011 384.779999 305.380005 384.769989 305.140015 C 384.76001 304.899994 384.769989 304.660004 384.420013 304.559998 L 384.420013 304.549988 Z"
      />
      <path
        id="path6119"
        fill="#d1d1d1"
        stroke="none"
        d="M 313.549988 215.339996 L 316.859985 213.899994 L 322.640015 235.22998 L 319.100006 235.580017 L 313.549988 215.339996 Z"
      />
      <path
        id="path6120"
        fill="#f0c499"
        stroke="none"
        d="M 337.899994 173.669983 C 335.769989 174.059998 336.23999 175.51001 337.170013 178.039978 C 338.070007 184.779999 339.809998 186.119995 340.540009 185.710022 C 341.890015 184.960022 340.470001 173.190002 337.899994 173.660004 L 337.899994 173.669983 Z"
      />
      <linearGradient
        id="linearGradient405"
        x1="285.981"
        y1="164.23"
        x2="288.466"
        y2="173.786"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6121"
        fill="url(#linearGradient405)"
        stroke="none"
        d="M 339.619995 183.26001 C 339.619995 183.26001 338.630005 182 339.019989 179.630005 C 339.959991 174.049988 336.529999 173.48999 337.190002 177.369995 C 337.190002 177.369995 337.720001 175.580017 338.140015 176.149994 C 338.649994 176.839996 337.529999 177.149994 338 180.080017 C 338.25 181.600006 339.609985 183.26001 339.609985 183.26001 L 339.619995 183.26001 Z"
      />
      <path
        id="path6122"
        fill="#f0c499"
        stroke="none"
        d="M 377.649994 173.619995 C 379.790009 173.910004 379.410004 175.380005 378.630005 177.950012 C 378.119995 184.720001 376.459991 186.140015 375.700012 185.77002 C 374.309998 185.080017 375.049988 173.26001 377.649994 173.619995 Z"
      />
      <linearGradient
        id="linearGradient406"
        x1="424.575"
        y1="160.411"
        x2="422.506"
        y2="170.046"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6123"
        fill="url(#linearGradient406)"
        stroke="none"
        d="M 376.480011 183.279999 C 376.480011 183.279999 377.399994 181.970001 376.869995 179.630005 C 375.619995 174.100006 379 173.380005 378.570007 177.279999 C 378.570007 177.279999 377.929993 175.52002 377.549988 176.100006 C 377.079987 176.809998 378.209991 177.070007 377.910004 180.02002 C 377.75 181.549988 376.480011 183.27002 376.480011 183.27002 L 376.480011 183.279999 Z"
      />
      <linearGradient
        id="linearGradient407"
        x1="358.42"
        y1="156.63"
        x2="358.06"
        y2="175.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.28" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6124"
        fill="url(#linearGradient407)"
        stroke="none"
        d="M 375.980011 173.289978 C 376.609985 157.440002 371.75 155.309998 370.369995 153.690002 C 367.549988 150.399994 363.119995 148.970001 355.549988 149.149994 C 355.549988 149.149994 345.690002 149.5 343.220001 154.899994 C 340.579987 160.679993 340.059998 168.630005 340.290009 176.080017 C 340.570007 185.119995 340.290009 188.070007 342.709991 191.890015 C 345.130005 195.710022 349.369995 197.929993 352.76001 201.089996 C 353.619995 201.890015 360.420013 204.160004 364.630005 200.130005 C 366.600006 198.25 371.75 194.589996 373.480011 191.890015 C 375.209991 189.190002 375.869995 182.410004 375.820007 181.460022 C 375.570007 176.359985 375.799988 177.700012 375.980011 173.299988 L 375.980011 173.289978 Z"
      />
      <radialGradient
        id="radialGradient151"
        cx="378.837"
        cy="182.495"
        r="9.02113"
        fx="378.837"
        fy="182.495"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8c39c" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6125"
        fill="url(#radialGradient151)"
        stroke="none"
        d="M 368.269989 188.279999 C 371.390015 188.48999 375.170013 188.089996 375.820007 181.630005 C 376.190002 177.950012 375.5 176.02002 373.959991 175.72998 C 370.690002 175.119995 366 176.549988 364.040009 177.570007 C 359.910004 179.720001 362.75 187.910004 368.269989 188.279999 Z"
      />
      <linearGradient
        id="linearGradient408"
        x1="358.18"
        y1="194.42"
        x2="358.54"
        y2="200.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6126"
        fill="url(#linearGradient408)"
        stroke="none"
        d="M 358.519989 196.660004 C 357.440002 196.660004 354.730011 197.399994 354.799988 197.789978 C 355.040009 198.98999 357.549988 199.190002 358.630005 199.190002 C 359.709991 199.190002 361.899994 198.910004 361.950012 197.890015 C 361.970001 197.48999 359.600006 196.660004 358.519989 196.660004 Z"
      />
      <radialGradient
        id="radialGradient152"
        cx="366.822"
        cy="180.685"
        r="9.263442"
        fx="366.822"
        fy="180.685"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8c39c" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6127"
        fill="url(#radialGradient152)"
        stroke="none"
        d="M 351.029999 177.26001 C 350.140015 176.929993 343.359985 175.390015 341.329987 175.97998 C 340.179993 176.320007 340.359985 178.910004 340.559998 181.380005 C 340.649994 182.559998 340.640015 184.460022 340.899994 185.200012 C 342.209991 188.850006 347.480011 189.01001 350.350006 187.98999 C 355.25 186.25 355.540009 178.919983 351.019989 177.27002 L 351.029999 177.26001 Z"
      />
      <linearGradient
        id="linearGradient409"
        x1="352.29"
        y1="241.59"
        x2="350.39"
        y2="187.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6128"
        fill="url(#linearGradient409)"
        stroke="none"
        d="M 348.029999 186.690002 C 348.029999 186.690002 347.5 191.97998 348.029999 192.929993 C 348.559998 193.880005 353.48999 197.299988 353.48999 197.299988 C 353.48999 197.299988 349.480011 193 349.070007 191.440002 C 348.869995 190.669983 349 188.02002 348.790009 187.029999 C 348.579987 186.01001 348.029999 186.690002 348.029999 186.690002 Z"
      />
      <linearGradient
        id="linearGradient410"
        x1="367.92"
        y1="239.99"
        x2="366.08"
        y2="187.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6129"
        fill="url(#linearGradient410)"
        stroke="none"
        d="M 368.679993 186.559998 C 368.679993 186.559998 370.329987 189.929993 368.890015 192.669983 C 367.450012 195.410004 363.130005 197.23999 363.130005 197.23999 C 363.130005 197.23999 367.23999 193.200012 367.720001 191.440002 C 367.929993 190.640015 367.779999 188 367.950012 187.059998 C 368.160004 185.929993 368.679993 186.559998 368.679993 186.559998 Z"
      />
      <linearGradient
        id="linearGradient411"
        x1="373.75"
        y1="178.1"
        x2="368.35"
        y2="179.96"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6130"
        fill="url(#linearGradient411)"
        stroke="none"
        d="M 373.589996 177.48999 C 373.029999 177.169983 372.609985 177.630005 371.440002 178.02002 C 370.290009 178.399994 367.160004 178.98999 368.640015 179.789978 C 370.269989 180.679993 372.540009 179.460022 372.809998 179.23999 C 373.089996 179.01001 374.279999 177.890015 373.589996 177.5 L 373.589996 177.48999 Z"
      />
      <path
        id="path6131"
        fill="#e1b18c"
        stroke="none"
        d="M 367.350006 186.950012 L 368.619995 186.559998 C 368.619995 186.559998 368.459991 187.070007 368.279999 187.210022 C 368.100006 187.350006 366.100006 187.820007 366.100006 187.820007 L 367.339996 186.950012 L 367.350006 186.950012 Z"
      />
      <path
        id="path6132"
        fill="#e1b18c"
        stroke="none"
        d="M 349.23999 187.080017 L 347.970001 186.690002 C 347.970001 186.690002 348.130005 187.200012 348.309998 187.339996 C 348.48999 187.47998 350.48999 187.950012 350.48999 187.950012 L 349.25 187.080017 L 349.23999 187.080017 Z"
      />
      <linearGradient
        id="linearGradient412"
        x1="358.849"
        y1="203.2"
        x2="358.617"
        y2="192.606"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6133"
        fill="url(#linearGradient412)"
        stroke="none"
        d="M 354.230011 195.419983 C 359.540009 194.830017 363.130005 195.48999 363.130005 195.48999 C 359.100006 192.97998 354.230011 195.419983 354.230011 195.419983 Z"
      />
      <path
        id="path6134"
        fill="#711e22"
        stroke="none"
        d="M 348.440002 186.940002 C 348.549988 187.049988 348.630005 187.210022 348.769989 187.27002 C 351.320007 188.399994 351.350006 189.47998 352.450012 190.070007 C 356.329987 192.160004 360.839996 191.649994 363.890015 189.970001 C 365.640015 189 365.859985 187.880005 367.959991 187.059998 C 368.23999 186.950012 368.290009 186.72998 368.290009 186.72998 C 357.100006 189.470001 348.450012 186.940002 348.450012 186.940002 L 348.440002 186.940002 Z"
      />
      <path
        id="path6135"
        fill="#fdd8b3"
        stroke="none"
        d="M 358.459991 192.26001 C 356.950012 192.26001 355.459991 191.970001 355.459991 192.26001 C 355.459991 192.549988 356.769989 193.210022 358.279999 193.210022 C 359.790009 193.210022 361.279999 192.549988 361.279999 192.26001 C 361.279999 191.970001 359.970001 192.26001 358.459991 192.26001 Z"
      />
      <linearGradient
        id="linearGradient413"
        x1="351.695"
        y1="190.205"
        x2="365.546"
        y2="190.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d9d7" stopOpacity={1} />
        <stop offset="0.14" stopColor="#efe5e4" stopOpacity={1} />
        <stop offset="0.39" stopColor="#faf8f7" stopOpacity={1} />
        <stop offset="0.57" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d3d1" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6136"
        fill="url(#linearGradient413)"
        stroke="none"
        d="M 353.079987 189.309998 C 352.609985 189.220001 352.399994 190.049988 352.399994 190.049988 C 353.820007 191.089996 355.529999 191.47998 358.26001 191.5 C 361.910004 191.529999 363.920013 189.950012 363.920013 189.950012 C 363.920013 189.950012 363.410004 189.160004 362.809998 189.279999 C 361.779999 189.48999 359.850006 189.869995 358.079987 189.869995 C 356.130005 189.869995 354.149994 189.51001 353.070007 189.320007 L 353.079987 189.309998 Z"
      />
      <linearGradient
        id="linearGradient414"
        x1="358.98"
        y1="203.312"
        x2="358.596"
        y2="192.582"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6137"
        fill="url(#linearGradient414)"
        stroke="none"
        d="M 352.890015 192.649994 C 358.720001 197.279999 364.290009 192.330017 364.290009 192.330017 C 358.399994 195.460022 352.890015 192.649994 352.890015 192.649994 Z"
      />
      <linearGradient
        id="linearGradient415"
        x1="358.11"
        y1="184.98"
        x2="358.33"
        y2="190.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d9d7" stopOpacity={1} />
        <stop offset="0.4" stopColor="#efe5e3" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6138"
        fill="url(#linearGradient415)"
        stroke="none"
        d="M 350.970001 187.470001 C 350.970001 187.470001 351.01001 188.429993 351.980011 188.850006 C 352.549988 189.089996 353.809998 190.059998 358.730011 189.910004 C 363.649994 189.76001 364.619995 188.570007 364.850006 188.359985 C 365.269989 187.970001 365.459991 187.320007 365.459991 187.320007 C 365.459991 187.320007 358.049988 188.77002 350.970001 187.470001 Z"
      />
      <path
        id="path6139"
        fill="#f3eceb"
        stroke="none"
        d="M 350.950012 187.380005 C 350.950012 187.380005 350.980011 187.820007 351.140015 188.070007 C 351.279999 188.279999 355.209991 188.859985 358.179993 188.880005 C 361.149994 188.899994 365.019989 188.130005 365.160004 187.960022 C 365.369995 187.690002 365.48999 187.220001 365.48999 187.220001 C 365.48999 187.220001 362.149994 188.339996 350.950012 187.380005 Z"
      />
      <linearGradient
        id="linearGradient416"
        x1="358.681"
        y1="205.402"
        x2="358.313"
        y2="183.122"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6140"
        fill="url(#linearGradient416)"
        stroke="none"
        d="M 347.829987 186.640015 C 347.829987 186.640015 348.549988 187.049988 348.440002 186.940002 C 348.440002 186.940002 357.100006 189.470001 368.279999 186.72998 L 368.890015 186.429993 C 362.820007 187.440002 347.829987 186.640015 347.829987 186.640015 Z"
      />
      <linearGradient
        id="linearGradient417"
        x1="347.45"
        y1="179.85"
        x2="339.43"
        y2="177.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6141"
        fill="url(#linearGradient417)"
        stroke="none"
        d="M 343.940002 178.149994 C 342.75 177.830017 342.309998 177.390015 341.769989 177.72998 C 341.100006 178.160004 342.350006 179.210022 342.640015 179.429993 C 342.929993 179.640015 345.26001 180.73999 346.839996 179.77002 C 348.269989 178.890015 345.109985 178.470001 343.950012 178.149994 L 343.940002 178.149994 Z"
      />
      <linearGradient
        id="linearGradient418"
        x1="367.162"
        y1="178.829"
        x2="366.629"
        y2="172.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6142"
        fill="url(#linearGradient418)"
        stroke="none"
        d="M 372.970001 176.429993 C 373.410004 166.839996 361.890015 169.559998 361.890015 169.559998 C 361.649994 171.100006 360.230011 176.779999 361.140015 177.309998 C 366.790009 180.640015 372.980011 176.419983 372.980011 176.419983 L 372.970001 176.429993 Z"
      />
      <linearGradient
        id="linearGradient419"
        x1="348.504"
        y1="178.825"
        x2="349.002"
        y2="172.734"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6143"
        fill="url(#linearGradient419)"
        stroke="none"
        d="M 342.720001 176.559998 C 342.230011 166.130005 353.399994 169.700012 353.399994 169.700012 C 353.640015 171.23999 355.390015 176.279999 354.5 176.850006 C 348.720001 180.570007 342.720001 176.549988 342.720001 176.549988 L 342.720001 176.559998 Z"
      />
      <linearGradient
        id="linearGradient420"
        x1="353.739"
        y1="174.253"
        x2="343.572"
        y2="176.968"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6144"
        fill="url(#linearGradient420)"
        stroke="none"
        d="M 354.040009 176.839996 C 354.420013 176.429993 353.929993 174.779999 353.779999 174.200012 C 353.48999 173.100006 351.940002 172.5 349.059998 172.339996 C 348.109985 172.289978 346.100006 172.570007 345.420013 173.100006 C 344.220001 174.039978 343.790009 174.880005 343.890015 175.960022 C 343.920013 176.27002 345.209991 177.48999 347.950012 177.700012 C 350 177.859985 353.25 177.700012 354.040009 176.850006 L 354.040009 176.839996 Z"
      />
      <linearGradient
        id="linearGradient421"
        x1="353.24"
        y1="176.8"
        x2="346.59"
        y2="175.202"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ece7e7" stopOpacity={1} />
        <stop offset="0.23" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset="0.53" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6145"
        fill="url(#linearGradient421)"
        stroke="none"
        d="M 351.070007 173.47998 C 352.140015 173.609985 352.700012 174.149994 352.980011 174.77002 C 353.350006 175.570007 353.25 176.47998 353.25 176.47998 C 353.26001 176.700012 352.700012 177.190002 352.179993 177.289978 C 350.980011 177.529999 350.079987 177.929993 347.26001 177.390015 C 346.380005 177.220001 345.679993 176.700012 345.429993 176.330017 C 345.190002 175.970001 345.160004 175.649994 345.160004 175.649994 C 346.940002 173.609985 346.679993 172.960022 351.070007 173.48999 L 351.070007 173.47998 Z"
      />
      <path
        id="path6146"
        fill="#dddddd"
        stroke="none"
        d="M 345.410004 176.299988 C 345.25 176.059998 345.160004 175.779999 345.160004 175.640015 C 345.160004 175.640015 345.649994 173.559998 347.290009 173.73999 C 348.579987 173.880005 351.190002 173.630005 352.970001 174.77002 C 351.970001 174.799988 348.559998 174.350006 345.399994 176.299988 L 345.410004 176.299988 Z"
      />
      <linearGradient
        id="linearGradient422"
        x1="351.93"
        y1={176}
        x2="344.94"
        y2="176.283"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#94958d" stopOpacity={1} />
        <stop offset={1} stopColor="#c5c6c0" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6147"
        fill="url(#linearGradient422)"
        stroke="none"
        d="M 349.279999 173.72998 C 350.98999 173.649994 351.980011 174.76001 351.899994 176.210022 C 351.869995 176.76001 351.559998 177.369995 351.5 177.429993 C 351.26001 177.51001 350.329987 177.690002 349.309998 177.649994 C 348.559998 177.660004 347.51001 177.460022 347.25 177.380005 C 346.910004 176.98999 346.869995 176.609985 346.829987 176.309998 C 346.660004 174.899994 347.839996 173.789978 349.269989 173.720001 L 349.279999 173.72998 Z"
      />
      <linearGradient
        id="linearGradient423"
        x1="350.85"
        y1="173.79"
        x2="342.39"
        y2="178.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#94958d" stopOpacity={1} />
        <stop offset={1} stopColor="#c5c6c0" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6148"
        fill="url(#linearGradient423)"
        stroke="none"
        d="M 351.549988 174.75 C 351.549988 174.75 350.720001 173.429993 349.179993 173.549988 C 347.640015 173.679993 346.970001 174.970001 346.880005 175.559998 C 346.880005 175.559998 348.579987 174.73999 351.549988 174.75 Z"
      />
      <radialGradient
        id="radialGradient153"
        cx="348.311"
        cy="177.266"
        r="4.350251"
        fx="348.311"
        fy="177.266"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3a3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2727" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6149"
        fill="url(#radialGradient153)"
        stroke="none"
        d="M 349.329987 174.140015 C 350.179993 174.119995 350.880005 174.789978 350.899994 175.619995 C 350.910004 176.450012 350.230011 177.140015 349.380005 177.149994 C 348.529999 177.160004 347.820007 176.5 347.809998 175.669983 C 347.799988 174.839996 348.480011 174.149994 349.329987 174.140015 Z"
      />
      <linearGradient
        id="linearGradient424"
        x1="345.15"
        y1="174.39"
        x2="352.97"
        y2="174.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2a25" stopOpacity={1} />
        <stop offset="0.08" stopColor="#382723" stopOpacity={1} />
        <stop offset="0.55" stopColor="#2c1e1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6150"
        fill="url(#linearGradient424)"
        stroke="none"
        d="M 352.970001 174.77002 C 352.970001 174.77002 352.670013 174.070007 352.070007 173.72998 C 350.519989 172.859985 348.100006 173.029999 346.559998 173.660004 C 345.049988 174.27002 345.149994 175.649994 345.149994 175.649994 C 345.149994 175.649994 345.940002 174.75 348.540009 174.399994 C 351.140015 174.049988 352.970001 174.779999 352.970001 174.779999 L 352.970001 174.77002 Z"
      />
      <path
        id="path6151"
        fill="#ffffff"
        stroke="none"
        d="M 350.269989 176.619995 C 350.109985 176.309998 350.26001 175.929993 350.589996 175.76001 C 350.920013 175.600006 351.320007 175.710022 351.470001 176.02002 C 351.630005 176.330017 351.480011 176.710022 351.149994 176.880005 C 350.820007 177.049988 350.420013 176.929993 350.269989 176.619995 Z"
      />
      <path
        id="path6152"
        fill="#ffffff"
        stroke="none"
        d="M 348.959991 175.799988 C 348.839996 175.559998 348.950012 175.26001 349.209991 175.130005 C 349.470001 175 349.790009 175.089996 349.910004 175.330017 C 350.029999 175.570007 349.920013 175.869995 349.660004 176 C 349.399994 176.130005 349.079987 176.039978 348.959991 175.789978 L 348.959991 175.799988 Z"
      />
      <linearGradient
        id="linearGradient425"
        x1="361.703"
        y1="174.009"
        x2="371.87"
        y2="176.725"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6153"
        fill="url(#linearGradient425)"
        stroke="none"
        d="M 361.480011 176.839996 C 361.100006 176.429993 361.589996 174.779999 361.73999 174.200012 C 362.029999 173.100006 363.579987 172.5 366.459991 172.339996 C 367.410004 172.289978 369.420013 172.570007 370.100006 173.100006 C 371.299988 174.039978 371.730011 174.880005 371.630005 175.960022 C 371.600006 176.27002 370.309998 177.48999 367.570007 177.700012 C 365.519989 177.859985 362.269989 177.700012 361.480011 176.850006 L 361.480011 176.839996 Z"
      />
      <linearGradient
        id="linearGradient426"
        x1="362.289"
        y1="176.462"
        x2="368.93"
        y2="174.864"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ece7e7" stopOpacity={1} />
        <stop offset="0.23" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset="0.53" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset={1} stopColor="#ffffff" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6154"
        fill="url(#linearGradient426)"
        stroke="none"
        d="M 364.450012 173.47998 C 363.380005 173.609985 362.820007 174.149994 362.540009 174.77002 C 362.170013 175.570007 362.269989 176.47998 362.269989 176.47998 C 362.26001 176.700012 362.820007 177.190002 363.339996 177.289978 C 364.540009 177.529999 365.440002 177.929993 368.26001 177.390015 C 369.140015 177.220001 369.839996 176.700012 370.089996 176.330017 C 370.329987 175.970001 370.359985 175.649994 370.359985 175.649994 C 368.579987 173.609985 368.839996 172.960022 364.450012 173.48999 L 364.450012 173.47998 Z"
      />
      <path
        id="path6155"
        fill="#dddddd"
        stroke="none"
        d="M 370.109985 176.299988 C 370.269989 176.059998 370.359985 175.779999 370.359985 175.640015 C 370.359985 175.640015 369.869995 173.559998 368.230011 173.73999 C 366.940002 173.880005 364.329987 173.630005 362.549988 174.77002 C 363.549988 174.799988 366.959991 174.350006 370.119995 176.299988 L 370.109985 176.299988 Z"
      />
      <linearGradient
        id="linearGradient427"
        x1="363.59"
        y1="175.662"
        x2="370.579"
        y2="175.944"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#94958d" stopOpacity={1} />
        <stop offset={1} stopColor="#c5c6c0" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6156"
        fill="url(#linearGradient427)"
        stroke="none"
        d="M 366.23999 173.72998 C 364.529999 173.649994 363.540009 174.76001 363.619995 176.210022 C 363.649994 176.76001 363.959991 177.369995 364.019989 177.429993 C 364.26001 177.51001 365.190002 177.690002 366.209991 177.649994 C 366.959991 177.660004 368.01001 177.460022 368.269989 177.380005 C 368.609985 176.98999 368.649994 176.609985 368.690002 176.309998 C 368.859985 174.899994 367.679993 173.789978 366.25 173.720001 L 366.23999 173.72998 Z"
      />
      <linearGradient
        id="linearGradient428"
        x1="364.67"
        y1="173.79"
        x2="373.14"
        y2="178.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#94958d" stopOpacity={1} />
        <stop offset={1} stopColor="#c5c6c0" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6157"
        fill="url(#linearGradient428)"
        stroke="none"
        d="M 363.970001 174.75 C 363.970001 174.75 364.799988 173.429993 366.339996 173.549988 C 367.880005 173.679993 368.549988 174.970001 368.640015 175.559998 C 368.640015 175.559998 366.940002 174.73999 363.970001 174.75 Z"
      />
      <radialGradient
        id="radialGradient154"
        cx="366.933"
        cy="176.886"
        r="4.350251"
        fx="366.933"
        fy="176.886"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3a3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2727" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6158"
        fill="url(#radialGradient154)"
        stroke="none"
        d="M 366.190002 174.140015 C 365.339996 174.119995 364.640015 174.789978 364.619995 175.619995 C 364.609985 176.450012 365.290009 177.140015 366.140015 177.149994 C 366.98999 177.160004 367.700012 176.5 367.709991 175.669983 C 367.720001 174.839996 367.040009 174.149994 366.190002 174.140015 Z"
      />
      <linearGradient
        id="linearGradient429"
        x1="362.55"
        y1="-23.1202"
        x2="370.37"
        y2="-23.1202"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2a25" stopOpacity={1} />
        <stop offset="0.08" stopColor="#382723" stopOpacity={1} />
        <stop offset="0.55" stopColor="#2c1e1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6159"
        fill="url(#linearGradient429)"
        stroke="none"
        d="M 362.549988 174.77002 C 362.549988 174.77002 362.850006 174.070007 363.450012 173.72998 C 365 172.859985 367.420013 173.029999 368.959991 173.660004 C 370.470001 174.27002 370.369995 175.649994 370.369995 175.649994 C 370.369995 175.649994 369.579987 174.75 366.980011 174.399994 C 364.380005 174.049988 362.549988 174.779999 362.549988 174.779999 L 362.549988 174.77002 Z"
      />
      <path
        id="path6160"
        fill="#ffffff"
        stroke="none"
        d="M 367.450012 175.690002 C 367.089996 175.72998 366.820007 176.070007 366.859985 176.440002 C 366.899994 176.809998 367.230011 177.080017 367.589996 177.029999 C 367.959991 176.98999 368.220001 176.649994 368.179993 176.279999 C 368.140015 175.910004 367.809998 175.640015 367.450012 175.690002 Z"
      />
      <path
        id="path6161"
        fill="#ffffff"
        stroke="none"
        d="M 366.01001 175.070007 C 365.720001 175.100006 365.519989 175.369995 365.549988 175.660004 C 365.589996 175.950012 365.839996 176.160004 366.130005 176.130005 C 366.420013 176.100006 366.619995 175.830017 366.589996 175.539978 C 366.559998 175.25 366.299988 175.039978 366.01001 175.070007 Z"
      />
      <linearGradient
        id="linearGradient430"
        x1="361.84"
        y1="170.12"
        x2="371.67"
        y2="170.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.45" stopColor="#2c1e1a" stopOpacity={1} />
        <stop offset="0.92" stopColor="#382723" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2a25" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6162"
        fill="url(#linearGradient430)"
        stroke="none"
        d="M 362.100006 168.669983 C 362.01001 169.140015 362.149994 169.529999 362.420013 169.940002 C 362.269989 169.48999 362.179993 169.029999 362.420013 168.630005 C 364.769989 168.539978 366.730011 168.52002 369.880005 169.609985 C 371.440002 170.149994 371.679993 171.649994 371.679993 171.649994 C 371.679993 171.649994 370.660004 171.299988 368.190002 170.850006 C 366.079987 170.470001 363.230011 170.660004 362.130005 170.600006 C 362.130005 170.600006 361.51001 168.950012 362.109985 168.669983 L 362.100006 168.669983 Z"
      />
      <linearGradient
        id="linearGradient431"
        x1="343.73"
        y1="-23.1204"
        x2="353.57"
        y2="-23.1204"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#281b18" stopOpacity={1} />
        <stop offset="0.45" stopColor="#2c1e1a" stopOpacity={1} />
        <stop offset="0.92" stopColor="#382723" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2a25" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6163"
        fill="url(#linearGradient431)"
        stroke="none"
        d="M 353.309998 168.669983 C 353.399994 169.140015 353.26001 169.529999 352.98999 169.940002 C 353.140015 169.48999 353.230011 169.029999 352.98999 168.630005 C 350.640015 168.539978 348.679993 168.52002 345.529999 169.609985 C 343.970001 170.149994 343.730011 171.649994 343.730011 171.649994 C 343.730011 171.649994 344.75 171.299988 347.220001 170.850006 C 349.329987 170.470001 352.179993 170.660004 353.279999 170.600006 C 353.279999 170.600006 353.899994 168.950012 353.299988 168.669983 L 353.309998 168.669983 Z"
      />
      <linearGradient
        id="linearGradient432"
        x1="356.24"
        y1="151.38"
        x2="358.39"
        y2="177.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.45" stopColor="#f3caa0" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6164"
        fill="url(#linearGradient432)"
        stroke="none"
        d="M 340.339996 180.330017 C 340.339996 180.330017 341.859985 172.649994 343.869995 170.48999 C 345.149994 169.119995 347.429993 168.049988 351.540009 167.119995 C 353.899994 166.589996 362.579987 165.600006 368.399994 167.25 C 371.029999 168.589996 372.600006 170.119995 373.100006 171.299988 C 373.829987 173.029999 375.630005 179.320007 375.630005 179.320007 C 375.630005 179.320007 378.160004 161.149994 371.23999 156.299988 C 364.320007 151.450012 345.779999 156.220001 343.880005 156.27002 C 341.980011 156.320007 340.350006 180.320007 340.350006 180.320007 L 340.339996 180.330017 Z"
      />
      <linearGradient
        id="linearGradient433"
        x1="373.36"
        y1="224.38"
        x2="371.91"
        y2="182.85"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6165"
        fill="url(#linearGradient433)"
        stroke="none"
        d="M 369.48999 186.75 C 369.48999 186.75 370.730011 190.359985 371.640015 190.640015 C 372.549988 190.929993 374.480011 189.080017 374.440002 182.179993 C 374.440002 182.179993 373.299988 193.539978 369.48999 186.75 Z"
      />
      <linearGradient
        id="linearGradient434"
        x1="345.97"
        y1="221.68"
        x2="344.63"
        y2="183.37"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6166"
        fill="url(#linearGradient434)"
        stroke="none"
        d="M 342.200012 182.919983 C 342.200012 182.919983 342.5 189.149994 344.380005 190.369995 C 346.26001 191.589996 347.149994 186.73999 347.149994 186.73999 C 347.149994 186.73999 345.899994 189.210022 344.670013 188.51001 C 343.440002 187.809998 342.190002 182.910004 342.190002 182.910004 L 342.200012 182.919983 Z"
      />
      <path
        id="path6167"
        fill="#a89383"
        stroke="none"
        d="M 375.950012 177.859985 L 374.799988 171.22998 C 374.320007 182.190002 374.910004 189.600006 371.76001 189.649994 C 371.089996 189.660004 369.890015 186.710022 368.450012 185.669983 C 368.149994 185.450012 367.089996 185.169983 365.619995 184.919983 L 362.809998 184.179993 L 360.829987 183.850006 L 359.380005 184.350006 C 359.049988 184.350006 358.709991 184.350006 358.369995 184.350006 C 357.910004 184.350006 357.440002 184.369995 356.980011 184.390015 L 355.820007 184 L 353.670013 184 L 348.410004 185.52002 C 348.320007 185.539978 348.25 185.559998 348.209991 185.580017 C 347.01001 185.98999 346.109985 189.679993 345.190002 189.649994 C 341.980011 189.559998 341.910004 180.390015 341.549988 171.22998 C 341.440002 168.369995 340.320007 180.330017 340.320007 180.330017 C 340.660004 190.350006 341.350006 188.720001 343.269989 192.23999 C 344.619995 194.710022 346.899994 196.609985 350.609985 199.929993 C 352.170013 201.320007 353.649994 203.029999 358.769989 203.149994 C 362.269989 203.22998 364.730011 201.51001 364.730011 201.51001 C 369.450012 195.619995 372.320007 194.98999 373.779999 191.130005 C 376.200012 184.720001 375.920013 177.880005 375.920013 177.880005 L 375.950012 177.859985 Z M 368.429993 190.609985 C 368.079987 192.880005 364.950012 196.029999 363.140015 197.23999 C 361.660004 198.22998 361.029999 194.619995 358.390015 194.619995 C 355.75 194.619995 355.019989 198.390015 353.290009 197.169983 C 352.100006 196.320007 348.899994 193.470001 348.459991 191.02002 C 348.170013 189.440002 348.029999 187.690002 348.049988 186.690002 C 348.049988 186.690002 362.01001 187.220001 368.700012 186.559998 C 368.700012 186.559998 368.779999 188.429993 368.440002 190.609985 L 368.429993 190.609985 Z"
      />
      <linearGradient
        id="linearGradient435"
        x1="336.2"
        y1="164.32"
        x2="348.7"
        y2="201.73"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#867569" stopOpacity={1} />
        <stop offset={1} stopColor="#a89383" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6168"
        fill="url(#linearGradient435)"
        stroke="none"
        d="M 340.339996 180.330017 C 340.339996 180.330017 340.369995 186.809998 341.570007 189.869995 C 342.769989 192.929993 344.929993 195.059998 346.220001 196.419983 C 347.51001 197.779999 351.549988 200.75 351.549988 200.75 C 351.549988 200.75 348.079987 195.919983 347.220001 194.929993 C 346.359985 193.940002 341.410004 191.27002 340.339996 180.330017 Z"
      />
      <linearGradient
        id="linearGradient436"
        x1="378.22"
        y1="165.56"
        x2="368.11"
        y2="201.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#867569" stopOpacity={1} />
        <stop offset={1} stopColor="#a89383" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6169"
        fill="url(#linearGradient436)"
        stroke="none"
        d="M 375.890015 180.72998 C 375.890015 180.72998 375.859985 187.309998 374.660004 190.380005 C 373.459991 193.440002 371.630005 195.100006 370.339996 196.460022 C 369.049988 197.820007 364.76001 201.5 364.76001 201.5 C 364.76001 201.5 368.230011 196.669983 369.089996 195.679993 C 369.950012 194.690002 374.820007 191.679993 375.890015 180.73999 L 375.890015 180.72998 Z"
      />
      <linearGradient
        id="linearGradient437"
        x1="358.25"
        y1="202.11"
        x2="358.9"
        y2="190.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a89383" stopOpacity={1} />
        <stop offset={1} stopColor="#c0afa2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6170"
        fill="url(#linearGradient437)"
        stroke="none"
        d="M 355.130005 198.440002 C 355.790009 197.799988 359.559998 196.130005 361.679993 198.559998 C 363.799988 200.98999 360.089996 201.440002 358.200012 201.26001 C 356.309998 201.080017 353.029999 200.47998 355.130005 198.440002 Z"
      />
      <linearGradient
        id="linearGradient438"
        x1="357.84"
        y1="181.97"
        x2="357.99"
        y2="185.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#867569" stopOpacity={1} />
        <stop offset={1} stopColor="#a89383" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6171"
        fill="url(#linearGradient438)"
        stroke="none"
        d="M 348.420013 185.52002 L 353.679993 184 L 355.720001 183.799988 L 358.359985 184.76001 L 361.640015 183.51001 L 362.809998 184.190002 L 367.529999 185.330017 L 348.420013 185.52002 Z"
      />
      <linearGradient
        id="linearGradient439"
        x1="357.86"
        y1="166.76"
        x2="358.25"
        y2="182.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.2" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6172"
        fill="url(#linearGradient439)"
        stroke="none"
        d="M 359.640015 177.47998 C 359.820007 173.929993 358.579987 173.419983 357.660004 173.450012 C 356.769989 173.47998 356.269989 174.710022 356.450012 177.419983 C 356.630005 180.119995 356.100006 181.149994 356.220001 182.410004 C 356.279999 182.98999 356.540009 183.359985 358 183.369995 C 359.600006 183.380005 360.160004 183 360.220001 182.470001 C 360.410004 181 359.5 180.039978 359.630005 177.47998 L 359.640015 177.47998 Z"
      />
      <path
        id="path6173"
        fill="#dca57b"
        stroke="none"
        d="M 359.809998 184.380005 C 361.970001 183.839996 362.820007 184.160004 362.820007 184.160004 C 361.559998 183.059998 359.809998 184.380005 359.809998 184.380005 Z"
      />
      <path
        id="path6174"
        fill="#dca57b"
        stroke="none"
        d="M 353.679993 184 C 353.679993 184 354.799988 183.820007 356.5 184.390015 C 356.5 184.390015 354.839996 183.130005 353.679993 184 Z"
      />
      <linearGradient
        id="linearGradient440"
        x1="358.02"
        y1="177.62"
        x2="358.16"
        y2="182.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6175"
        fill="url(#linearGradient440)"
        stroke="none"
        d="M 361.48999 180.779999 C 361.480011 181.669983 361.679993 182.26001 361.410004 182.77002 C 360.809998 183.899994 359.25 184.339996 358.209991 184.26001 C 357.420013 184.359985 355.570007 183.960022 354.799988 182.779999 C 354.48999 182.299988 354.679993 181.869995 354.540009 180.919983 C 354.540009 180.919983 352.399994 183.5 353.679993 184.01001 C 353.679993 184.01001 354.059998 183.72998 355.089996 183.820007 C 356.119995 183.910004 355.910004 185.049988 358.290009 185.070007 C 360.359985 185.089996 359.700012 184.100006 361.019989 183.910004 C 362.339996 183.720001 362.51001 184.059998 362.809998 184.190002 C 363.470001 184.190002 363 182 361.48999 180.779999 Z"
      />
      <linearGradient
        id="linearGradient441"
        x1="357.84"
        y1="183.73"
        x2="358.38"
        y2="179.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.28" stopColor="#fbd6af" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6176"
        fill="url(#linearGradient441)"
        stroke="none"
        d="M 356 182.299988 C 355.910004 182.880005 356.720001 183.5 358.179993 183.51001 C 359.779999 183.52002 360.140015 182.890015 360 182.359985 C 359.209991 179.210022 356.329987 180.149994 356 182.299988 Z"
      />
      <linearGradient
        id="linearGradient442"
        x1="358.44"
        y1="193.08"
        x2="358.58"
        y2="196.44"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#867569" stopOpacity={1} />
        <stop offset={1} stopColor="#a89383" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6177"
        fill="url(#linearGradient442)"
        stroke="none"
        d="M 355.98999 195.799988 C 355.98999 195.799988 356.910004 194.619995 358.450012 194.559998 C 359.920013 194.51001 361.140015 196.23999 361.140015 196.23999 C 361.140015 196.23999 360.019989 195.450012 358.390015 195.419983 C 357.339996 195.399994 355.98999 195.799988 355.98999 195.799988 Z"
      />
      <linearGradient
        id="linearGradient443"
        x1="358.25"
        y1="198.92"
        x2={358}
        y2="204.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#867569" stopOpacity={1} />
        <stop offset={1} stopColor="#a89383" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6178"
        fill="url(#linearGradient443)"
        stroke="none"
        d="M 351.549988 200.75 C 351.549988 200.75 354.230011 204.140015 358.559998 203.98999 C 362.899994 203.839996 364.76001 201.48999 364.76001 201.48999 C 364.76001 201.48999 361.929993 202.809998 358.359985 202.839996 C 354.529999 202.880005 351.549988 200.73999 351.549988 200.73999 L 351.549988 200.75 Z"
      />
      <linearGradient
        id="linearGradient444"
        x1="359.26"
        y1="146.69"
        x2="357.65"
        y2="176.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2a25" stopOpacity={1} />
        <stop offset="0.16" stopColor="#352520" stopOpacity={1} />
        <stop offset="0.54" stopColor="#2b1d1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6179"
        fill="url(#linearGradient444)"
        stroke="none"
        d="M 373.809998 153.669983 C 373.149994 153.109985 373.350006 152.059998 372.559998 151.940002 C 372.399994 151.919983 372.309998 151.899994 372.26001 151.890015 C 372.649994 151.22998 373.269989 149.380005 369.589996 147.529999 C 369.589996 147.529999 369.920013 148.279999 370.350006 149.179993 C 366.320007 146.210022 365.470001 145.72998 356.959991 147.190002 C 353.399994 147.799988 346.140015 148.619995 343.73999 151.130005 C 340.420013 154.609985 343.109985 154.910004 341.070007 154.690002 C 342.269989 155.429993 339.220001 156.51001 340.609985 156.089996 C 338.98999 157.119995 339.670013 158.859985 339 160.630005 C 338.200012 162.75 339.049988 163.48999 339.619995 165.600006 C 339.76001 166.119995 338 167.890015 338.160004 168.399994 C 338.380005 169.080017 338.299988 169.640015 338.25 170.350006 C 338.190002 171.25 338.359985 173.720001 338.359985 173.720001 C 338.359985 173.720001 340.200012 175.419983 340.269989 177.890015 C 340.279999 178.309998 340.329987 179.539978 340.329987 180.330017 C 340.51001 179.410004 340.679993 178.48999 340.850006 177.570007 C 341.170013 175.830017 340.98999 173.809998 341.700012 172.190002 C 342.320007 170.799988 342.890015 169.380005 343.559998 168.01001 C 343.839996 167.440002 344.040009 167.070007 344.140015 166.450012 C 344.339996 165.089996 344.200012 163.600006 344.140015 162.23999 C 344.059998 160.589996 344.369995 158.470001 345.920013 157.679993 C 347.440002 156.899994 348.299988 157.679993 349.980011 157.919983 C 351.910004 158.200012 353.899994 158.609985 355.779999 157.859985 C 355.450012 158.48999 355.25 159.179993 355.179993 159.890015 C 356.700012 157.359985 359.880005 157.419983 362.48999 157.350006 C 364.640015 157.289978 367.779999 157.850006 369.369995 155.970001 C 370.929993 157.72998 370.970001 159.75 371.220001 161.970001 C 371.48999 164.279999 372.019989 166.539978 373.130005 168.600006 C 373.619995 169.5 374.369995 170.23999 374.579987 171.22998 C 374.809998 172.330017 375.019989 173.429993 375.220001 174.539978 C 375.420013 175.640015 375.720001 179.330017 375.890015 180.440002 C 376.029999 179.26001 376.079987 175.02002 376.910004 174.070007 C 377.059998 173.899994 377.630005 173.640015 377.630005 173.640015 C 377.630005 173.640015 377.829987 171.210022 377.829987 170.809998 C 377.829987 169.630005 376.869995 166.77002 377.109985 165.619995 C 377.799988 162.289978 376.350006 161.01001 375.869995 158.350006 C 375.470001 156.140015 375.630005 155.23999 373.790009 153.690002 L 373.809998 153.669983 Z"
      />
      <linearGradient
        id="linearGradient445"
        x1="340.2"
        y1="167.12"
        x2="376.08"
        y2="167.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2a25" stopOpacity={1} />
        <stop offset="0.16" stopColor="#352520" stopOpacity={1} />
        <stop offset="0.54" stopColor="#2b1d1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6180"
        fill="url(#linearGradient445)"
        stroke="none"
        d="M 369.929993 153.809998 C 368.450012 155.72998 353.73999 156.950012 350.209991 156.309998 C 345.160004 155.390015 343.480011 156.429993 342.820007 158.190002 C 342.019989 160.309998 342.790009 162.940002 342.5 165.690002 C 342.209991 168.440002 340.339996 170.48999 340.209991 176.690002 C 340.350006 177.950012 340.350006 179.720001 340.350006 180.330017 C 340.529999 179.410004 340.700012 178.48999 340.869995 177.570007 C 341.190002 175.830017 341.01001 173.809998 341.720001 172.190002 C 342.339996 170.799988 342.910004 169.380005 343.579987 168.01001 C 343.859985 167.440002 344.059998 167.070007 344.160004 166.450012 C 344.359985 165.089996 344.220001 163.600006 344.160004 162.23999 C 344.079987 160.589996 344.179993 158.899994 345.720001 158.109985 C 347.23999 157.330017 348.290009 158.080017 349.970001 158.330017 C 351.899994 158.609985 353.910004 158.609985 355.790009 157.850006 C 355.459991 158.47998 355.26001 159.169983 355.190002 159.880005 C 356.709991 157.75 359.890015 157.410004 362.5 157.339996 C 364.649994 157.279999 367.790009 157.839996 369.380005 155.960022 C 370.940002 157.720001 370.980011 159.73999 371.230011 161.960022 C 371.5 164.27002 372.029999 166.529999 373.140015 168.589996 C 373.630005 169.48999 374.380005 170.22998 374.589996 171.220001 C 374.820007 172.320007 375.029999 173.419983 375.230011 174.529999 C 375.429993 175.630005 375.709991 177.75 375.899994 180.429993 C 376.890015 167.660004 373.320007 168.899994 373.410004 162.149994 C 373.480011 156.369995 371.01001 154.919983 369.929993 153.799988 L 369.929993 153.809998 Z"
      />
      <linearGradient
        id="linearGradient446"
        x1="357.14"
        y1="147.08"
        x2="355.28"
        y2="158.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2a25" stopOpacity={1} />
        <stop offset="0.16" stopColor="#352520" stopOpacity={1} />
        <stop offset="0.54" stopColor="#2b1d1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6181"
        fill="url(#linearGradient446)"
        stroke="none"
        d="M 368.399994 149.98999 C 366.230011 149.98999 364.130005 150.679993 362.559998 152.210022 C 360.799988 153.929993 359.5 155.950012 357.309998 157.210022 C 352.359985 160.059998 347.570007 157 344.450012 153.029999 C 348.410004 154.789978 352.390015 156.679993 356.329987 153.809998 C 358.190002 152.450012 359.690002 150.51001 361.829987 149.559998 C 363.910004 148.640015 366.48999 148.669983 368.399994 149.98999 Z"
      />
      <linearGradient
        id="linearGradient447"
        x1="365.83"
        y1="148.26"
        x2="362.02"
        y2="158.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3c2a25" stopOpacity={1} />
        <stop offset="0.16" stopColor="#352520" stopOpacity={1} />
        <stop offset="0.54" stopColor="#2b1d1a" stopOpacity={1} />
        <stop offset={1} stopColor="#281b18" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6182"
        fill="url(#linearGradient447)"
        stroke="none"
        d="M 355.190002 159.890015 C 354.600006 158.609985 355.899994 157.100006 356.890015 156.410004 C 358.380005 155.369995 360.26001 155.26001 362 155.589996 C 363.589996 155.890015 364.970001 156.210022 366.549988 155.589996 C 368.119995 154.970001 369.329987 153.640015 369.940002 152.080017 C 370.880005 155.22998 368.51001 158.399994 365.470001 159.140015 C 363.660004 159.580017 362.089996 158.98999 360.350006 158.570007 C 358.829987 158.210022 355.940002 158.080017 355.190002 159.880005 L 355.190002 159.890015 Z"
      />
      <linearGradient
        id="linearGradient448"
        x1="370.97"
        y1="136.86"
        x2="352.07"
        y2="155.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#4c3633" stopOpacity={1} />
        <stop offset="0.5" stopColor="#402d28" stopOpacity={1} />
        <stop offset={1} stopColor="#3c2a25" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6183"
        fill="url(#linearGradient448)"
        stroke="none"
        d="M 368.399994 149.98999 C 368.399994 149.98999 365.369995 147.570007 361.829987 149.559998 C 360.230011 150.460022 354.649994 159.52002 344.450012 153.039978 C 344.450012 153.039978 350.609985 156.080017 354.170013 152.720001 C 357.730011 149.359985 363.73999 145.339996 368.390015 150 L 368.399994 149.98999 Z"
      />
      <path
        id="path6184"
        fill="#1b2c60"
        stroke="none"
        d="M 377.799988 169.880005 C 377.799988 169.880005 377.779999 165.75 376.440002 158.320007 C 375.200012 151.470001 369.290009 145.460022 357.329987 145.600006 C 345.26001 145.73999 339.829987 152.039978 339.029999 158.960022 C 338.220001 165.98999 338.190002 169.880005 338.190002 169.880005 C 338.190002 169.880005 347.869995 163.210022 357.079987 163.279999 C 368.609985 163.369995 371.059998 163.910004 377.790009 169.880005 L 377.799988 169.880005 Z"
      />
      <linearGradient
        id="linearGradient449"
        x1="357.82"
        y1="156.71"
        x2="357.19"
        y2="140.17"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6185"
        fill="url(#linearGradient449)"
        stroke="none"
        d="M 338.730011 160.140015 C 338.730011 160.140015 338.920013 145.789978 355.970001 145.089996 C 374.529999 144.330017 376.679993 154.630005 377.230011 161.779999 C 377.230011 161.779999 376.109985 145.460022 357.200012 146.070007 C 340.059998 146.619995 338.720001 160.130005 338.720001 160.130005 L 338.730011 160.140015 Z"
      />
      <linearGradient
        id="linearGradient450"
        x1="375.58"
        y1="154.17"
        x2="376.39"
        y2="170.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6186"
        fill="url(#linearGradient450)"
        stroke="none"
        d="M 377.799988 169.880005 C 377.799988 169.880005 378.329987 159.869995 375.410004 153.669983 L 374.619995 167.359985 L 377.809998 169.880005 L 377.799988 169.880005 Z"
      />
      <linearGradient
        id="linearGradient451"
        x1="339.07"
        y1="154.78"
        x2="339.94"
        y2="172.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6187"
        fill="url(#linearGradient451)"
        stroke="none"
        d="M 338.190002 169.880005 L 340.690002 168.890015 L 340.649994 153.419983 C 340.649994 153.419983 337.640015 157.570007 338.190002 169.880005 Z"
      />
      <linearGradient
        id="linearGradient452"
        x1="356.43"
        y1="148.85"
        x2="358.34"
        y2="174.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#0d1834" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6188"
        fill="url(#linearGradient452)"
        stroke="none"
        d="M 338.190002 169.880005 C 338.190002 169.880005 348.5 162.779999 358.73999 162.830017 C 368.980011 162.869995 377.799988 169.880005 377.799988 169.880005 C 377.799988 169.880005 374.829987 161.320007 358.790009 161.320007 C 342.75 161.320007 338.200012 169.880005 338.200012 169.880005 L 338.190002 169.880005 Z"
      />
      <linearGradient
        id="linearGradient453"
        x1="358.68"
        y1="176.59"
        x2="357.43"
        y2="164.43"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#1b2c60" stopOpacity={1} />
        <stop offset={1} stopColor="#394e7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6189"
        fill="url(#linearGradient453)"
        stroke="none"
        d="M 338.190002 169.880005 C 338.190002 169.880005 340.5 172.440002 340.820007 172.119995 C 343 169.899994 346.570007 164.309998 357.880005 163.899994 C 369.470001 163.47998 372.290009 168.339996 375.589996 172.119995 C 375.929993 172.51001 377.799988 169.880005 377.799988 169.880005 C 377.799988 169.880005 377.230011 168.720001 375.630005 167.309998 C 373.01001 165 367.640015 162.029999 357.540009 162.369995 C 342.170013 162.890015 338.200012 169.880005 338.200012 169.880005 L 338.190002 169.880005 Z"
      />
      <path
        id="path6190"
        fill="#617197"
        stroke="none"
        d="M 340.820007 172.119995 C 340.820007 172.119995 347.200012 163.789978 359.149994 163.880005 C 368.649994 163.950012 371.679993 167.450012 375.579987 172.119995 C 375.579987 172.119995 371.679993 163.200012 359.230011 163.299988 C 345.149994 163.419983 340.809998 172.119995 340.809998 172.119995 L 340.820007 172.119995 Z"
      />
      <radialGradient
        id="radialGradient155"
        cx="585.79"
        cy="289.65"
        r="237.17"
        fx="585.79"
        fy="289.65"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#e0ded2" stopOpacity={1} />
        <stop offset="0.99" stopColor="#d4cab4" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6191"
        fill="url(#radialGradient155)"
        fillRule="evenodd"
        stroke="none"
        d="M 252.050003 287.839996 L 250.509995 296.200012 C 250.509995 296.200012 360.070007 299.309998 581.030029 299.309998 C 801.98999 299.309998 921.070007 296.200012 921.070007 296.200012 L 921.049988 279.980011 L 252.059998 287.839996 L 252.050003 287.839996 Z"
      />
      <linearGradient
        id="linearGradient454"
        x1="252.064"
        y1="287.835"
        x2="921.069"
        y2="280.011"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f6f7e1" stopOpacity={1} />
        <stop offset={1} stopColor="#f8fddc" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6192"
        fill="url(#linearGradient454)"
        fillRule="evenodd"
        stroke="none"
        d="M 921.039978 279.980011 C 921.070007 282.299988 771.330017 285.940002 586.590027 288.109985 C 401.850006 290.279999 252.070007 290.160004 252.050003 287.839996 C 252.020004 285.519989 401.76001 281.880005 586.5 279.709991 C 771.23999 277.540009 921.02002 277.660004 921.039978 279.980011 Z"
      />
      <radialGradient
        id="radialGradient156"
        cx="581.95"
        cy="346.15"
        r="217.86"
        fx="581.95"
        fy="346.15"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#e1dec5" stopOpacity={1} />
        <stop offset="0.99" stopColor="#cbbe9f" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6193"
        fill="url(#radialGradient156)"
        fillRule="evenodd"
        stroke="none"
        d="M 277.820007 296.829987 L 295.619995 395.459991 L 860.929993 395.459991 L 886.080017 296.829987 L 277.820007 296.829987 Z"
      />
      <radialGradient
        id="radialGradient157"
        cx="579.34"
        cy="388.25"
        r="201.78"
        fx="579.34"
        fy="388.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f8f3f6" stopOpacity={1} />
        <stop offset={1} stopColor="#e1dedc" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6194"
        fill="url(#radialGradient157)"
        fillRule="evenodd"
        stroke="none"
        d="M 295.619995 395.459991 L 294.070007 386.899994 L 864.599976 381.040009 L 860.929993 395.459991 L 295.619995 395.459991 Z"
      />
      <radialGradient
        id="radialGradient158"
        cx="581.95"
        cy="314.25"
        r="215.41"
        fx="581.95"
        fy="314.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d7d3c9" stopOpacity={1} />
        <stop offset={1} stopColor="#ebeae0" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6195"
        fill="url(#radialGradient158)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'multiply' }}
        d="M 284.109985 331.670013 C 284.109985 331.670013 344.980011 308.76001 588.669983 305.589996 C 832.369995 302.420013 877.77002 329.399994 877.77002 329.399994 L 886.080017 296.820007 L 277.820007 296.820007 L 284.109985 331.670013 Z"
      />
      <linearGradient
        id="linearGradient455"
        x1="710.69"
        y1="382.89"
        x2="710.69"
        y2="296.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d8d0c2" stopOpacity={1} />
        <stop offset={1} stopColor="#fffff2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6196"
        fill="url(#linearGradient455)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'multiply' }}
        d="M 724.700012 381.730011 L 736.840027 296.829987 L 697.01001 296.829987 L 684.539978 382.890015 L 724.700012 381.730011 Z"
      />
      <linearGradient
        id="linearGradient456"
        x1="766.76"
        y1="356.31"
        x2="803.91"
        y2="291.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#000000" stopOpacity={1} />
        <stop offset={1} stopColor="#e3e7da" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6197"
        fill="url(#linearGradient456)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 777.599976 296.829987 L 770.440002 358.429993 L 781.02002 358.429993 L 787.559998 337.279999 L 806.830017 327.630005 L 812.330017 296.829987 L 777.599976 296.829987 Z"
      />
      <linearGradient
        id="linearGradient457"
        x1="841.41"
        y1="378.31"
        x2="887.86"
        y2="297.86"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e3e7da" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6198"
        fill="url(#linearGradient457)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 864.599976 381.040009 L 846.130005 381.040009 L 863.690002 296.829987 L 886.080017 296.829987 L 864.599976 381.040009 Z"
      />
      <linearGradient
        id="linearGradient458"
        x1="770.44"
        y1="381.73"
        x2="770.44"
        y2="-23.1199"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d8d0c2" stopOpacity={1} />
        <stop offset={1} stopColor="#fffff2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6199"
        fill="url(#linearGradient458)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'multiply' }}
        d="M 770.440002 296.829987 L 763.289978 381.730011 L 770.440002 381.730011 L 777.599976 296.829987 L 770.440002 296.829987 Z"
      />
      <linearGradient
        id="linearGradient459"
        x1="441.16"
        y1="385.3"
        x2="441.16"
        y2="-23.1199"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d8d0c2" stopOpacity={1} />
        <stop offset={1} stopColor="#fffff2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6200"
        fill="url(#linearGradient459)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'multiply' }}
        d="M 441.160004 385.119995 L 432.359985 296.829987 L 438.809998 296.829987 L 449.950012 385.299988 L 441.160004 385.119995 Z"
      />
      <linearGradient
        id="linearGradient460"
        x1="522.24"
        y1="385.3"
        x2="522.24"
        y2="296.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9ed684" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6201"
        fill="url(#linearGradient460)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 557.02002 384.51001 L 555.549988 327.630005 L 545.320007 327.630005 L 541.590027 296.829987 L 499.119995 296.829987 L 507.049988 365.589996 L 499.119995 366.059998 L 494.450012 335.720001 L 487.450012 338.929993 L 492.109985 385.299988 L 557.02002 384.51001 Z"
      />
      <linearGradient
        id="linearGradient461"
        x1="568.5"
        y1="384.51"
        x2="568.5"
        y2="296.83"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#fffff2" stopOpacity={1} />
        <stop offset={1} stopColor="#d8d0c2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6202"
        fill="url(#linearGradient461)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'multiply' }}
        d="M 557.02002 384.51001 L 553.880005 296.829987 L 581.950012 296.829987 L 583.119995 382.890015 L 557.02002 384.51001 Z"
      />
      <linearGradient
        id="linearGradient462"
        x1="328.1"
        y1="386.66"
        x2="328.1"
        y2="-23.1199"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#d8d0c2" stopOpacity={1} />
        <stop offset={1} stopColor="#fffff2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6203"
        fill="url(#linearGradient462)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'multiply' }}
        d="M 316.779999 386.660004 L 302.459991 296.829987 L 334.200012 296.829987 L 342.290009 372.440002 L 347.269989 373.369995 L 338.25 306.160004 L 341.049988 306.160004 L 353.75 386.279999 L 316.779999 386.660004 Z"
      />
      <linearGradient
        id="linearGradient463"
        x1="363.41"
        y1="386.28"
        x2="363.41"
        y2="-23.1199"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9ed684" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6204"
        fill="url(#linearGradient463)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 340.109985 298.070007 L 353.75 386.279999 L 386.709991 385.950012 L 374.339996 296.829987 L 340.109985 298.070007 Z"
      />
      <linearGradient
        id="linearGradient464"
        x1="611.29"
        y1="383.59"
        x2="611.29"
        y2="-23.1198"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9ed684" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6205"
        fill="url(#linearGradient464)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 583.119995 382.890015 L 585.789978 296.829987 L 639.450012 296.829987 L 634.780029 383.399994 L 625.130005 382.890015 L 627.619995 311.140015 L 624.200012 310.209991 L 616.109985 383.589996 L 583.119995 382.890015 Z"
      />
      <linearGradient
        id="linearGradient465"
        x1="577.72"
        y1={384}
        x2="577.72"
        y2="-23.1199"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#9ed684" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6206"
        fill="url(#linearGradient465)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.2"
        style={{ mixBlendMode: 'screen' }}
        d="M 573.640015 296.829987 L 575.890015 384 L 581.799988 383.589996 L 575.969971 296.829987 L 573.640015 296.829987 Z"
      />
      <g id="g251" style={{ mixBlendMode: 'soft-light' }}>
        <path
          id="path6207"
          fill="#ffffff"
          fillRule="evenodd"
          stroke="none"
          d="M 555.549988 395.459991 L 553.880005 385.299988 L 619.070007 384.950012 L 616.969971 395.459991 L 555.549988 395.459991 Z"
        />
      </g>
      <g id="g252" style={{ mixBlendMode: 'soft-light' }}>
        <path
          id="path6208"
          fill="#ffffff"
          fillRule="evenodd"
          stroke="none"
          d="M 620.619995 395.459991 L 622.330017 384.950012 L 634.469971 384.51001 L 631.049988 395.459991 L 620.619995 395.459991 Z"
        />
      </g>
      <g id="g253" style={{ mixBlendMode: 'soft-light' }}>
        <path
          id="path6209"
          fill="#ffffff"
          fillRule="evenodd"
          stroke="none"
          d="M 512.030029 385.299988 L 506.119995 385.299988 L 512.030029 395.459991 L 516.070007 395.459991 L 512.030029 385.299988 Z"
        />
      </g>
      <g id="g254" opacity="0.8" style={{ mixBlendMode: 'soft-light' }}>
        <path
          id="path6210"
          fill="#faffef"
          fillRule="evenodd"
          stroke="none"
          d="M 601.799988 296.829987 L 601.799988 287.929993 L 637.27002 287.470001 L 635.869995 296.829987 L 601.799988 296.829987 Z"
        />
      </g>
      <g id="g255" opacity="0.5" style={{ mixBlendMode: 'soft-light' }}>
        <path
          id="path6211"
          fill="#faffef"
          fillRule="evenodd"
          stroke="none"
          d="M 641.940002 296.829987 L 644.73999 287.369995 L 649.409973 287.299988 L 645.669983 296.829987 L 641.940002 296.829987 Z"
        />
      </g>
      <g id="g256" opacity="0.5" style={{ mixBlendMode: 'soft-light' }}>
        <path
          id="path6212"
          fill="#faffef"
          fillRule="evenodd"
          stroke="none"
          d="M 563.530029 288.369995 L 566.789978 296.829987 L 547.419983 296.829987 L 541.590027 288.600006 L 563.530029 288.369995 Z"
        />
      </g>
      <g
        id="g257"
        opacity="0.5"
        style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
      >
        <g id="g258" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
          <path
            id="path6213"
            fill="#d9d2c2"
            stroke="none"
            d="M 693.135986 296.765991 L 684.059998 382.82901 L 684.984985 382.925995 L 694.060974 296.864014 L 693.135986 296.765991 Z"
          />
        </g>
      </g>
      <g
        id="g259"
        opacity="0.5"
        style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
      >
        <g id="g260" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
          <path
            id="path6214"
            fill="#d9d2c2"
            stroke="none"
            d="M 811.838989 296.721008 L 796.627014 381.609009 L 797.541992 381.77301 L 812.755005 296.88501 L 811.838989 296.721008 Z"
          />
        </g>
      </g>
      <g
        id="g261"
        opacity="0.5"
        style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
      >
        <g id="g262" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
          <path
            id="path6215"
            fill="#d9d2c2"
            stroke="none"
            d="M 582.659973 382.899994 L 580.559998 299.329987 L 581.48999 299.299988 L 583.590027 382.880005 L 582.659973 382.899994 Z"
          />
        </g>
      </g>
      <g
        id="g263"
        opacity="0.5"
        style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
      >
        <g id="g264" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
          <path
            id="path6216"
            fill="#d9d2c2"
            stroke="none"
            d="M 479.359985 384.98999 L 471.26001 296.869995 L 472.190002 296.790009 L 480.290009 384.899994 L 479.359985 384.98999 Z"
          />
        </g>
      </g>
      <g
        id="g265"
        opacity="0.5"
        style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
      >
        <g id="g266" opacity="0.5" style={{ mixBlendMode: 'multiply' }}>
          <path
            id="path6217"
            fill="#d9d2c2"
            stroke="none"
            d="M 376.890991 296.808014 L 375.967987 296.920013 L 386.584991 385.041992 L 387.507996 384.931 L 376.890991 296.808014 Z"
          />
        </g>
      </g>
      <path
        id="path6218"
        fill="#3dc0cd"
        stroke="none"
        d="M 308.829987 249.119995 L 303.660004 249.179993 L 301.130005 253.690002 L 303.769989 258.140015 L 307.440002 258.100006 L 314.600006 270.160004 L 316.839996 268.829987 L 309.679993 256.769989 L 311.470001 253.570007 L 308.829987 249.119995 Z M 308.769989 253.600006 L 307.559998 255.759995 L 305.079987 255.789993 L 303.820007 253.660004 L 305.029999 251.5 L 307.5 251.470001 L 308.76001 253.600006 L 308.769989 253.600006 Z"
      />
      <path
        id="path6219"
        fill="#445164"
        stroke="none"
        d="M 340.630005 252.740005 L 341.579987 253.619995 L 336.299988 259.820007 L 334.890015 258.529999 L 340.630005 252.740005 Z"
      />
      <path
        id="path6220"
        fill="#3dc0cd"
        stroke="none"
        d="M 330.149994 268.100006 L 337.600006 259.209991 L 335.390015 257.179993 L 327.160004 265.359985 C 326.410004 266.109985 326.429993 267.329987 327.209991 268.040009 L 327.459991 268.269989 C 328.23999 268.98999 329.459991 268.910004 330.140015 268.100006 L 330.149994 268.100006 Z M 328.339996 267.079987 C 328.029999 266.799988 328.01001 266.309998 328.290009 266 C 328.570007 265.690002 329.059998 265.670013 329.359985 265.950012 C 329.670013 266.230011 329.690002 266.720001 329.410004 267.029999 C 329.130005 267.339996 328.640015 267.359985 328.329987 267.079987 L 328.339996 267.079987 Z"
      />
      <path
        id="path6221"
        fill="#313c3b"
        stroke="none"
        d="M 346.480011 250.039993 L 346.329987 249.899994 L 343.940002 252.509995 L 342.100006 252.100006 L 341.540009 250.300003 L 343.929993 247.690002 L 343.779999 247.550003 C 342.380005 247.169998 340.820007 247.550003 339.769989 248.699997 C 338.269989 250.330002 338.380005 252.869995 340.01001 254.369995 C 341.640015 255.869995 344.179993 255.759995 345.679993 254.130005 C 346.730011 252.990005 346.98999 251.399994 346.48999 250.029999 L 346.480011 250.039993 Z"
      />
      <path
        id="path6222"
        fill="#445164"
        stroke="none"
        d="M 330.410004 259.839996 L 329.130005 260.040009 L 327.589996 252.029999 L 329.480011 251.740005 L 330.410004 259.839996 Z"
      />
      <path
        id="path6223"
        fill="#3dc0cd"
        stroke="none"
        d="M 324.970001 242.059998 L 327.25 253.429993 L 330.220001 252.970001 L 328.980011 241.440002 C 328.869995 240.389999 327.899994 239.639999 326.850006 239.809998 L 326.51001 239.860001 C 325.459991 240.020004 324.769989 241.020004 324.970001 242.059998 Z M 326.899994 241.289993 C 327.320007 241.229996 327.700012 241.509995 327.769989 241.929993 C 327.829987 242.350006 327.549988 242.729996 327.130005 242.800003 C 326.709991 242.860001 326.329987 242.580002 326.26001 242.160004 C 326.200012 241.740005 326.480011 241.360001 326.899994 241.289993 Z"
      />
      <path
        id="path6224"
        fill="#313c3b"
        stroke="none"
        d="M 328.859985 266.100006 L 329.059998 266.070007 L 328.519989 262.570007 L 329.98999 261.390015 L 331.75 262.070007 L 332.290009 265.570007 L 332.48999 265.540009 C 333.670013 264.690002 334.339996 263.220001 334.100006 261.690002 C 333.76001 259.5 331.720001 258 329.529999 258.329987 C 327.339996 258.670013 325.839996 260.709991 326.170013 262.899994 C 326.410004 264.440002 327.480011 265.630005 328.859985 266.089996 L 328.859985 266.100006 Z"
      />
      <path
        id="path6225"
        fill="#445164"
        stroke="none"
        d="M 322.100006 237.979996 L 323.480011 237.979996 L 323.799988 246.600006 L 321.779999 246.600006 L 322.100006 237.979996 Z"
      />
      <path
        id="path6226"
        fill="#ffb91d"
        stroke="none"
        d="M 321.209991 245.190002 L 324.380005 245.190002 L 324.940002 257.450012 C 324.98999 258.570007 324.100006 259.5 322.980011 259.5 L 322.609985 259.5 C 321.48999 259.5 320.600006 258.570007 320.649994 257.450012 L 321.209991 245.190002 Z"
      />
      <path
        id="path6227"
        fill="#313c3b"
        stroke="none"
        d="M 324.730011 232.5 L 324.730011 236.27002 L 320.850006 236.27002 L 320.850006 232.5 C 319.480011 233.210022 318.549988 234.630005 318.549988 236.27002 C 318.549988 238.610001 320.450012 240.509995 322.790009 240.509995 C 325.130005 240.509995 327.029999 238.610001 327.029999 236.27002 C 327.029999 234.630005 326.089996 233.200012 324.730011 232.5 Z"
      />
      <path
        id="path6228"
        fill="#f73906"
        stroke="none"
        d="M 333.425995 247.830002 L 332.717987 249.901993 L 335.972992 251.014999 L 336.681 248.942993 L 333.425995 247.830002 Z"
      />
      <path
        id="path6229"
        fill="#db6a2a"
        stroke="none"
        d="M 329.850006 263.589996 L 334.339996 250.449997 L 335.549988 250.860001 C 334.230011 260.25 331.290009 264.109985 329.839996 263.589996 L 329.850006 263.589996 Z"
      />
      <path
        id="path6230"
        fill="#b2440d"
        stroke="none"
        d="M 333.119995 250.020004 L 334.339996 250.440002 L 329.850006 263.579987 C 328.410004 263.059998 328.459991 258.160004 333.119995 250.020004 Z"
      />
      <path
        id="path6231"
        fill="#f73906"
        stroke="none"
        d="M 334.640015 249.539993 L 336.76001 243.339996 L 342.959991 245.460007 C 341.790009 248.880005 338.070007 250.710007 334.649994 249.539993 L 334.640015 249.539993 Z"
      />
      <path
        id="path6232"
        fill="#cc2605"
        stroke="none"
        d="M 330.559998 241.220001 L 336.76001 243.339996 L 334.640015 249.539993 C 331.220001 248.369995 329.390015 244.649994 330.559998 241.229996 L 330.559998 241.220001 Z"
      />
      <path
        id="path6233"
        fill="#f73906"
        stroke="none"
        d="M 342.950012 245.460007 C 342.950012 245.460007 344.089996 244.899994 344.880005 243 L 337.709991 240.550003 L 336.76001 243.339996 L 342.959991 245.460007 L 342.950012 245.460007 Z"
      />
      <path
        id="path6234"
        fill="#cc2605"
        stroke="none"
        d="M 330.559998 241.220001 C 330.559998 241.220001 330 240.080002 330.540009 238.089996 L 337.709991 240.539993 L 336.76001 243.330002 L 330.559998 241.210007 L 330.559998 241.220001 Z"
      />
      <path
        id="path6235"
        fill="#445164"
        stroke="none"
        d="M 309.070007 265.540009 L 307.920013 265.899994 L 303.809998 253.830002 L 305.5 253.289993 L 309.070007 265.540009 Z"
      />
      <path
        id="path6236"
        fill="#ea3207"
        stroke="none"
        d="M 306.350006 254.320007 L 303.700012 255.160004 L 300 245.070007 C 299.660004 244.149994 300.160004 243.139999 301.100006 242.839996 L 301.410004 242.740005 C 302.339996 242.449997 303.329987 242.990005 303.589996 243.940002 L 306.359985 254.320007 L 306.350006 254.320007 Z"
      />
      <path
        id="path6237"
        fill="#4591cf"
        stroke="none"
        d="M 313.984009 243.203995 L 310.661011 245.320999 C 310.144012 245.651001 309.992004 246.337006 310.321991 246.854004 L 316.743988 256.931 C 317.074005 257.447998 317.76001 257.600006 318.277008 257.270996 L 321.598999 255.153 C 322.115997 254.824005 322.268005 254.136993 321.938995 253.621002 L 315.515991 243.542999 C 315.187012 243.026001 314.501007 242.873993 313.984009 243.203995 Z"
      />
      <path
        id="path6238"
        fill="#4591cf"
        stroke="none"
        d="M 314.829987 255.360001 L 310.470001 260.329987 L 308.779999 257.679993 L 315.329987 251.119995 L 317.609985 254.690002 L 315.850006 256.959991 L 314.829987 255.360001 Z"
      />
      <path
        id="path6239"
        fill="#d1311a"
        stroke="none"
        d="M 315.713989 239.054993 L 305.645996 245.472 L 308.477997 249.916 L 318.546997 243.498993 L 315.713989 239.054993 Z"
      />
      <path
        id="path6240"
        fill="#f73906"
        stroke="none"
        d="M 310.709991 239.330002 L 308.029999 241.039993 L 306.589996 244.860001 L 314.790009 239.639999 L 310.709991 239.330002 Z"
      />
      <path
        id="path6241"
        fill="#4a4c50"
        stroke="none"
        d="M 308.089996 239.679993 L 308.029999 241.039993 L 310.709991 239.330002 L 309.459991 238.809998 L 308.089996 239.679993 Z"
      />
      <path
        id="path6242"
        fill="#4a4c50"
        stroke="none"
        d="M 307.600006 235.899994 L 307.660004 234.549988 L 304.98999 236.25 L 306.23999 236.77002 L 307.600006 235.899994 Z"
      />
      <path
        id="path6243"
        fill="#4a4c50"
        stroke="none"
        d="M 305.401001 233.299988 L 304.811005 233.677002 L 308.481995 239.436005 L 309.071991 239.059998 L 305.401001 233.299988 Z"
      />
      <path
        id="path6244"
        fill="#4a4c50"
        stroke="none"
        d="M 306.033997 232.505005 L 303.84201 233.901978 C 303.752991 233.958984 303.72699 234.075989 303.783997 234.164978 L 304.546997 235.362 C 304.604004 235.450989 304.721008 235.47699 304.809998 235.419983 L 307.002014 234.02301 C 307.089996 233.966003 307.115997 233.848999 307.059998 233.76001 L 306.296997 232.562988 C 306.23999 232.473999 306.122986 232.447998 306.033997 232.505005 Z"
      />
      <path
        id="path6245"
        fill="#4591cf"
        stroke="none"
        d="M 312.029999 251.869995 L 314.100006 250.550003 L 313.660004 249.860001 L 310.899994 251.619995 L 312.660004 254.380005 L 313.350006 253.949997 L 312.029999 251.869995 Z"
      />
      <path
        id="path6246"
        fill="#d1311a"
        stroke="none"
        d="M 311.730011 262.309998 L 310.470001 260.329987 L 314.829987 255.360001 L 315.850006 256.959991 L 311.730011 262.309998 Z"
      />
      <path
        id="path6247"
        fill="#475150"
        stroke="none"
        d="M 305.160004 260.940002 L 305.160004 282.660004 C 305.160004 283.630005 305.950012 284.410004 306.910004 284.410004 L 337.899994 284.410004 C 338.869995 284.410004 339.649994 283.619995 339.649994 282.660004 L 339.649994 260.940002 L 305.149994 260.940002 L 305.160004 260.940002 Z"
      />
      <path
        id="path6248"
        fill="#313c3b"
        stroke="none"
        d="M 339.799988 266.190002 L 305.299988 266.190002 L 305.299988 269.339996 L 339.799988 269.339996 L 339.799988 266.190002 Z"
      />
      <path
        id="path6249"
        fill="#8f9b9a"
        stroke="none"
        d="M 326.559998 280.029999 L 321.570007 275.470001 L 321.329987 275.709991 L 316.089996 270.700012 L 315.549988 271.23999 L 320.559998 276.480011 L 320.320007 276.720001 L 324.869995 281.709991 C 325.079987 281.940002 325.380005 282.059998 325.670013 282.059998 C 325.950012 282.059998 326.220001 281.950012 326.429993 281.73999 L 326.570007 281.600006 C 327.01001 281.160004 326.98999 280.450012 326.529999 280.040009 L 326.559998 280.029999 Z"
      />
      <path
        id="path6250"
        fill="#8f9b9a"
        stroke="none"
        d="M 326.269989 273.019989 L 326.809998 273.549988 L 323.579987 277.029999 L 322.790009 276.25 L 326.269989 273.019989 Z"
      />
      <path
        id="path6251"
        fill="#8f9b9a"
        stroke="none"
        d="M 323.119995 275.470001 L 324.350006 276.709991 L 319.799988 281.700012 C 319.380005 282.149994 318.670013 282.170013 318.23999 281.73999 L 318.100006 281.600006 C 317.660004 281.160004 317.679993 280.450012 318.140015 280.040009 L 323.130005 275.480011 L 323.119995 275.470001 Z"
      />
      <path
        id="path6252"
        fill="#8f9b9a"
        stroke="none"
        d="M 329.429993 271.910004 L 327.959991 273.380005 L 326.450012 271.869995 L 327.920013 270.399994 C 327.109985 270.140015 326.200012 270.329987 325.559998 270.970001 C 324.649994 271.880005 324.649994 273.359985 325.559998 274.269989 C 326.470001 275.179993 327.950012 275.179993 328.859985 274.269989 C 329.5 273.630005 329.690002 272.709991 329.429993 271.910004 Z"
      />
      <path
        id="path6253"
        fill="#313c3b"
        stroke="none"
        d="M 317.309998 254.279999 L 314.549988 254.279999 L 314.549988 258.890015 L 317.309998 258.890015 L 317.309998 254.279999 Z"
      />
      <path
        id="path6254"
        fill="#313c3b"
        stroke="none"
        d="M 330.559998 254.279999 L 327.799988 254.279999 L 327.799988 258.890015 L 330.559998 258.890015 L 330.559998 254.279999 Z"
      />
      <path
        id="path6255"
        fill="#475150"
        stroke="none"
        d="M 342.279999 258.089996 L 302.829987 258.089996 C 302.442993 258.089996 302.130005 258.403015 302.130005 258.790009 L 302.130005 265.799988 C 302.130005 266.186005 302.442993 266.5 302.829987 266.5 L 342.279999 266.5 C 342.666992 266.5 342.980011 266.186005 342.980011 265.799988 L 342.980011 258.790009 C 342.980011 258.403015 342.666992 258.089996 342.279999 258.089996 Z"
      />
      <path
        id="path6256"
        fill="#313c3b"
        stroke="none"
        d="M 331.570007 250.110001 L 313.529999 250.110001 L 313.529999 254.360001 L 331.570007 254.360001 L 331.570007 250.110001 Z"
      />
      <path
        id="path6257"
        fill="#ffb91d"
        stroke="none"
        d="M 314.980011 257.670013 L 310.359985 257.670013 L 310.359985 267.070007 L 314.980011 267.070007 L 314.980011 257.670013 Z"
      />
      <path
        id="path6258"
        fill="#ffb91d"
        stroke="none"
        d="M 334.75 257.670013 L 330.130005 257.670013 L 330.130005 267.070007 L 334.75 267.070007 L 334.75 257.670013 Z"
      />
      <path
        id="path6259"
        fill="#475150"
        stroke="none"
        d="M 317.049988 253.059998 C 317.049988 253.979996 315.670013 253.970001 315.670013 253.059998 L 315.670013 251.550003 C 315.670013 250.639999 317.049988 250.639999 317.049988 251.550003 L 317.049988 253.059998 Z"
      />
      <path
        id="path6260"
        fill="#475150"
        stroke="none"
        d="M 320.140015 253.059998 C 320.140015 253.979996 318.76001 253.970001 318.76001 253.059998 L 318.76001 251.550003 C 318.76001 250.639999 320.140015 250.639999 320.140015 251.550003 L 320.140015 253.059998 Z"
      />
      <path
        id="path6261"
        fill="#475150"
        stroke="none"
        d="M 323.23999 253.059998 C 323.23999 253.979996 321.859985 253.970001 321.859985 253.059998 L 321.859985 251.550003 C 321.859985 250.639999 323.23999 250.639999 323.23999 251.550003 L 323.23999 253.059998 Z"
      />
      <path
        id="path6262"
        fill="#475150"
        stroke="none"
        d="M 326.339996 253.059998 C 326.339996 253.979996 324.959991 253.970001 324.959991 253.059998 L 324.959991 251.550003 C 324.959991 250.639999 326.339996 250.639999 326.339996 251.550003 L 326.339996 253.059998 Z"
      />
      <path
        id="path6263"
        fill="#475150"
        stroke="none"
        d="M 329.440002 253.059998 C 329.440002 253.979996 328.059998 253.970001 328.059998 253.059998 L 328.059998 251.550003 C 328.059998 250.639999 329.440002 250.639999 329.440002 251.550003 L 329.440002 253.059998 Z"
      />
      <path
        id="path6264"
        fill="#475150"
        stroke="none"
        d="M 326.940002 279.619995 L 321.950012 275.059998 L 321.549988 274.700012 L 321.320007 274.929993 L 316.480011 270.299988 L 316.079987 269.920013 L 315.690002 270.309998 L 315.149994 270.850006 L 314.76001 271.23999 L 315.140015 271.640015 L 319.769989 276.480011 L 319.540009 276.709991 L 319.899994 277.109985 L 324.450012 282.100006 C 324.76001 282.440002 325.200012 282.630005 325.660004 282.630005 C 326.119995 282.630005 326.51001 282.459991 326.820007 282.149994 L 326.959991 282.01001 C 327.279999 281.690002 327.450012 281.269989 327.440002 280.809998 C 327.429993 280.359985 327.23999 279.940002 326.910004 279.640015 L 326.940002 279.619995 Z M 326.459991 281.73999 C 326.25 281.950012 325.970001 282.059998 325.700012 282.059998 C 325.410004 282.059998 325.119995 281.940002 324.899994 281.709991 L 320.350006 276.720001 L 320.589996 276.480011 L 315.579987 271.23999 L 316.119995 270.700012 L 321.359985 275.709991 L 321.600006 275.470001 L 326.589996 280.029999 C 327.040009 280.450012 327.059998 281.160004 326.630005 281.589996 L 326.48999 281.730011 L 326.459991 281.73999 Z"
      />
      <path
        id="path6265"
        fill="#2b2b2b"
        stroke="none"
        d="M 525.650024 350.890015 C 524.099976 350.890015 522.849976 350.429993 521.900024 349.519989 C 520.969971 348.589996 520.5 347.350006 520.5 345.790009 L 520.5 337.410004 C 520.5 335.869995 520.969971 334.649994 521.900024 333.73999 C 522.849976 332.829987 524.099976 332.369995 525.650024 332.369995 C 527.200012 332.369995 528.469971 332.829987 529.400024 333.73999 C 530.349976 334.649994 530.820007 335.880005 530.820007 337.410004 L 530.820007 337.690002 C 530.820007 337.779999 530.789978 337.850006 530.719971 337.920013 C 530.669983 337.970001 530.599976 338 530.51001 338 L 527.47998 338.130005 C 527.27002 338.130005 527.169983 338.040009 527.169983 337.850006 L 527.169983 337.179993 C 527.169983 336.679993 527.030029 336.269989 526.76001 335.959991 C 526.47998 335.649994 526.109985 335.48999 525.650024 335.48999 C 525.190002 335.48999 524.840027 335.649994 524.559998 335.959991 C 524.280029 336.269989 524.150024 336.679993 524.150024 337.179993 L 524.150024 346.109985 C 524.150024 346.609985 524.289978 347.019989 524.559998 347.329987 C 524.840027 347.619995 525.200012 347.769989 525.650024 347.769989 C 526.099976 347.769989 526.48999 347.619995 526.76001 347.329987 C 527.039978 347.019989 527.169983 346.609985 527.169983 346.109985 L 527.169983 345.410004 C 527.169983 345.320007 527.200012 345.25 527.25 345.200012 C 527.320007 345.130005 527.400024 345.100006 527.47998 345.100006 L 530.51001 345.230011 C 530.599976 345.230011 530.669983 345.26001 530.719971 345.329987 C 530.789978 345.380005 530.820007 345.450012 530.820007 345.540009 L 530.820007 345.799988 C 530.820007 347.350006 530.349976 348.589996 529.400024 349.529999 C 528.450012 350.440002 527.200012 350.899994 525.650024 350.899994 L 525.650024 350.890015 Z M 537.219971 350.890015 C 535.679993 350.890015 534.47998 350.5 533.599976 349.730011 C 532.73999 348.950012 532.309998 347.890015 532.309998 346.549988 L 532.309998 341.529999 C 532.309998 340.220001 532.75 339.170013 533.630005 338.369995 C 534.51001 337.579987 535.710022 337.179993 537.22998 337.179993 C 538.75 337.179993 539.969971 337.579987 540.849976 338.369995 C 541.72998 339.160004 542.169983 340.220001 542.169983 341.529999 L 542.169983 346.549988 C 542.169983 347.899994 541.72998 348.959991 540.849976 349.730011 C 539.98999 350.51001 538.780029 350.890015 537.22998 350.890015 L 537.219971 350.890015 Z M 537.219971 347.730011 C 537.599976 347.730011 537.909973 347.589996 538.150024 347.320007 C 538.390015 347.040009 538.51001 346.690002 538.51001 346.26001 L 538.51001 341.779999 C 538.51001 341.350006 538.390015 341 538.150024 340.720001 C 537.909973 340.440002 537.599976 340.309998 537.219971 340.309998 C 536.840027 340.309998 536.530029 340.450012 536.289978 340.720001 C 536.070007 341 535.950012 341.350006 535.950012 341.779999 L 535.950012 346.26001 C 535.950012 346.690002 536.059998 347.049988 536.289978 347.320007 C 536.530029 347.600006 536.840027 347.730011 537.219971 347.730011 Z M 546.450012 350.679993 C 546.26001 350.679993 546.140015 350.589996 546.090027 350.420013 L 542.960022 337.690002 L 542.960022 337.589996 C 542.960022 337.429993 543.059998 337.359985 543.23999 337.359985 L 546.580017 337.359985 C 546.789978 337.359985 546.900024 337.450012 546.919983 337.640015 L 548.109985 344.76001 C 548.130005 344.809998 548.150024 344.839996 548.190002 344.839996 C 548.22998 344.839996 548.25 344.809998 548.27002 344.76001 L 549.429993 337.640015 C 549.450012 337.450012 549.559998 337.359985 549.77002 337.359985 L 553.109985 337.410004 C 553.349976 337.410004 553.450012 337.519989 553.390015 337.75 L 550.280029 350.429993 C 550.22998 350.600006 550.109985 350.690002 549.919983 350.690002 L 546.450012 350.690002 L 546.450012 350.679993 Z M 563.98999 344.859985 C 563.98999 344.950012 563.960022 345.019989 563.890015 345.089996 C 563.840027 345.140015 563.77002 345.170013 563.679993 345.170013 L 557.98999 345.170013 C 557.900024 345.170013 557.859985 345.209991 557.859985 345.299988 L 557.859985 346.26001 C 557.859985 346.690002 557.969971 347.049988 558.200012 347.350006 C 558.440002 347.630005 558.73999 347.76001 559.109985 347.76001 C 559.440002 347.76001 559.710022 347.660004 559.909973 347.450012 C 560.119995 347.230011 560.25 346.950012 560.320007 346.619995 C 560.369995 346.450012 560.47998 346.359985 560.659973 346.359985 L 563.640015 346.519989 C 563.72998 346.519989 563.799988 346.549988 563.849976 346.619995 C 563.919983 346.670013 563.950012 346.75 563.929993 346.850006 C 563.809998 348.179993 563.340027 349.190002 562.530029 349.880005 C 561.73999 350.549988 560.599976 350.890015 559.109985 350.890015 C 557.619995 350.890015 556.380005 350.51001 555.51001 349.75 C 554.650024 348.970001 554.219971 347.899994 554.219971 346.540009 L 554.219971 341.519989 C 554.219971 340.209991 554.650024 339.160004 555.51001 338.359985 C 556.390015 337.570007 557.590027 337.170013 559.109985 337.170013 C 560.630005 337.170013 561.820007 337.570007 562.679993 338.359985 C 563.559998 339.149994 564 340.209991 564 341.519989 L 564 344.859985 L 563.98999 344.859985 Z M 559.099976 340.309998 C 558.73999 340.309998 558.440002 340.450012 558.190002 340.720001 C 557.969971 341 557.849976 341.350006 557.849976 341.779999 L 557.849976 342.790009 C 557.849976 342.880005 557.890015 342.920013 557.97998 342.920013 L 560.210022 342.920013 C 560.299988 342.920013 560.340027 342.880005 560.340027 342.790009 L 560.340027 341.779999 C 560.340027 341.350006 560.219971 341 559.97998 340.720001 C 559.76001 340.440002 559.460022 340.309998 559.099976 340.309998 Z M 571.609985 337.230011 C 572.080017 337.230011 572.440002 337.320007 572.700012 337.48999 C 572.840027 337.579987 572.890015 337.709991 572.859985 337.880005 L 572.369995 340.910004 C 572.349976 341.100006 572.22998 341.170013 572.01001 341.119995 C 571.820007 341.049988 571.590027 341.019989 571.309998 341.019989 C 571.049988 341.019989 570.830017 341.049988 570.640015 341.119995 C 570.23999 341.190002 569.919983 341.429993 569.679993 341.839996 C 569.440002 342.23999 569.320007 342.700012 569.320007 343.23999 L 569.320007 350.359985 C 569.320007 350.450012 569.289978 350.519989 569.219971 350.589996 C 569.169983 350.640015 569.099976 350.670013 569.01001 350.670013 L 565.97998 350.670013 C 565.890015 350.670013 565.820007 350.640015 565.75 350.589996 C 565.700012 350.519989 565.669983 350.440002 565.669983 350.359985 L 565.669983 337.709991 C 565.669983 337.619995 565.700012 337.549988 565.75 337.5 C 565.820007 337.429993 565.900024 337.399994 565.97998 337.399994 L 569.01001 337.399994 C 569.099976 337.399994 569.169983 337.429993 569.219971 337.5 C 569.289978 337.549988 569.320007 337.619995 569.320007 337.709991 L 569.320007 338.720001 C 569.320007 338.790009 569.320007 338.829987 569.349976 338.850006 C 569.380005 338.850006 569.419983 338.820007 569.450012 338.769989 C 569.919983 337.75 570.640015 337.23999 571.619995 337.23999 L 571.609985 337.230011 Z M 578.73999 337.179993 C 580.210022 337.179993 581.400024 337.579987 582.309998 338.369995 C 583.219971 339.160004 583.679993 340.209991 583.679993 341.5 L 583.679993 350.380005 C 583.679993 350.470001 583.650024 350.540009 583.580017 350.609985 C 583.530029 350.660004 583.460022 350.690002 583.369995 350.690002 L 580.340027 350.690002 C 580.25 350.690002 580.179993 350.660004 580.109985 350.609985 C 580.059998 350.540009 580.030029 350.459991 580.030029 350.380005 L 580.030029 349.809998 C 580.030029 349.76001 580.01001 349.720001 579.97998 349.709991 C 579.950012 349.690002 579.909973 349.709991 579.880005 349.76001 C 579.309998 350.480011 578.429993 350.859985 577.23999 350.899994 C 576.23999 350.899994 575.369995 350.619995 574.630005 350.070007 C 573.909973 349.519989 573.539978 348.470001 573.539978 346.910004 C 573.539978 345.350006 573.97998 344.200012 574.859985 343.600006 C 575.76001 343 577.039978 342.690002 578.719971 342.690002 L 579.909973 342.690002 C 580 342.690002 580.039978 342.649994 580.039978 342.559998 L 580.039978 341.910004 C 580.039978 341.440002 579.909973 341.059998 579.650024 340.769989 C 579.409973 340.459991 579.099976 340.299988 578.719971 340.299988 C 578.429993 340.299988 578.179993 340.390015 577.969971 340.579987 C 577.780029 340.75 577.659973 341 577.609985 341.329987 C 577.590027 341.540009 577.47998 341.640015 577.27002 341.640015 L 574.159973 341.609985 C 573.950012 341.609985 573.849976 341.51001 573.849976 341.299988 C 573.940002 340.040009 574.429993 339.040009 575.330017 338.299988 C 576.22998 337.540009 577.369995 337.160004 578.75 337.160004 L 578.73999 337.179993 Z M 578.47998 348.070007 C 578.880005 348.070007 579.22998 347.940002 579.539978 347.679993 C 579.869995 347.399994 580.030029 347.040009 580.030029 346.589996 L 580.030029 345.369995 C 580.030029 345.279999 579.98999 345.23999 579.900024 345.23999 L 578.840027 345.23999 C 578.369995 345.23999 577.98999 345.380005 577.700012 345.649994 C 577.419983 345.910004 577.289978 346.269989 577.289978 346.73999 C 577.289978 347.170013 577.390015 347.5 577.599976 347.720001 C 577.820007 347.940002 578.119995 348.059998 578.47998 348.059998 L 578.47998 348.070007 Z M 591.400024 337.690002 C 591.400024 337.600006 591.429993 337.529999 591.47998 337.480011 C 591.549988 337.410004 591.630005 337.380005 591.710022 337.380005 L 594.73999 337.380005 C 594.830017 337.380005 594.900024 337.410004 594.950012 337.480011 C 595.02002 337.529999 595.049988 337.600006 595.049988 337.690002 L 595.049988 350.059998 C 595.049988 351.970001 594.590027 353.450012 593.679993 354.48999 C 592.780029 355.529999 591.159973 356.040009 588.809998 356.040009 C 588.340027 356.040009 587.97998 356.040009 587.719971 356.01001 C 587.51001 355.98999 587.409973 355.880005 587.409973 355.670013 L 587.409973 353.130005 C 587.409973 352.910004 587.52002 352.809998 587.75 352.850006 C 588.77002 352.880005 589.539978 352.779999 590.049988 352.540009 C 590.590027 352.320007 590.940002 351.970001 591.109985 351.5 C 591.299988 351.029999 591.390015 350.420013 591.390015 349.660004 C 591.390015 349.609985 591.369995 349.579987 591.340027 349.579987 C 591.309998 349.579987 591.27002 349.609985 591.23999 349.660004 C 590.929993 350.070007 590.549988 350.369995 590.099976 350.540009 C 589.669983 350.700012 589.25 350.769989 588.830017 350.769989 C 587.640015 350.769989 586.75 350.390015 586.159973 349.630005 C 585.570007 348.850006 585.280029 347.779999 585.280029 346.420013 L 585.280029 341.5 C 585.280029 340.100006 585.570007 339.029999 586.159973 338.290009 C 586.76001 337.529999 587.650024 337.149994 588.830017 337.149994 C 589.880005 337.149994 590.679993 337.540009 591.23999 338.309998 C 591.27002 338.359985 591.309998 338.380005 591.340027 338.359985 C 591.369995 338.339996 591.390015 338.309998 591.390015 338.26001 L 591.390015 337.660004 L 591.400024 337.690002 Z M 590.159973 347.630005 C 590.52002 347.630005 590.820007 347.48999 591.039978 347.220001 C 591.280029 346.940002 591.400024 346.589996 591.400024 346.160004 L 591.400024 341.790009 C 591.400024 341.359985 591.280029 341.01001 591.039978 340.730011 C 590.820007 340.450012 590.52002 340.320007 590.159973 340.320007 C 589.799988 340.320007 589.5 340.459991 589.280029 340.730011 C 589.059998 341.01001 588.940002 341.359985 588.940002 341.790009 L 588.940002 346.160004 C 588.940002 346.589996 589.049988 346.950012 589.280029 347.220001 C 589.5 347.5 589.799988 347.630005 590.159973 347.630005 Z M 606.5 344.859985 C 606.5 344.950012 606.469971 345.019989 606.400024 345.089996 C 606.349976 345.140015 606.280029 345.170013 606.190002 345.170013 L 600.5 345.170013 C 600.409973 345.170013 600.369995 345.209991 600.369995 345.299988 L 600.369995 346.26001 C 600.369995 346.690002 600.47998 347.049988 600.710022 347.350006 C 600.950012 347.630005 601.25 347.76001 601.619995 347.76001 C 601.950012 347.76001 602.219971 347.660004 602.419983 347.450012 C 602.630005 347.230011 602.77002 346.950012 602.830017 346.619995 C 602.880005 346.450012 602.98999 346.359985 603.169983 346.359985 L 606.150024 346.519989 C 606.23999 346.519989 606.309998 346.549988 606.359985 346.619995 C 606.429993 346.670013 606.460022 346.75 606.440002 346.850006 C 606.320007 348.179993 605.849976 349.190002 605.039978 349.880005 C 604.25 350.549988 603.109985 350.890015 601.619995 350.890015 C 600.130005 350.890015 598.890015 350.51001 598.02002 349.75 C 597.159973 348.970001 596.72998 347.899994 596.72998 346.540009 L 596.72998 341.519989 C 596.72998 340.209991 597.159973 339.160004 598.02002 338.359985 C 598.900024 337.570007 600.099976 337.170013 601.619995 337.170013 C 603.140015 337.170013 604.330017 337.570007 605.190002 338.359985 C 606.070007 339.149994 606.51001 340.209991 606.51001 341.519989 L 606.51001 344.859985 L 606.5 344.859985 Z M 601.609985 340.309998 C 601.25 340.309998 600.950012 340.450012 600.700012 340.720001 C 600.47998 341 600.359985 341.350006 600.359985 341.779999 L 600.359985 342.790009 C 600.359985 342.880005 600.400024 342.920013 600.48999 342.920013 L 602.719971 342.920013 C 602.809998 342.920013 602.849976 342.880005 602.849976 342.790009 L 602.849976 341.779999 C 602.849976 341.350006 602.72998 341 602.48999 340.720001 C 602.27002 340.440002 601.969971 340.309998 601.609985 340.309998 Z M 613.820007 350.690002 C 613.72998 350.690002 613.659973 350.660004 613.590027 350.609985 C 613.539978 350.540009 613.51001 350.459991 613.51001 350.380005 L 613.51001 332.890015 C 613.51001 332.799988 613.539978 332.730011 613.590027 332.679993 C 613.659973 332.609985 613.73999 332.579987 613.820007 332.579987 L 616.849976 332.579987 C 616.940002 332.579987 617.01001 332.609985 617.059998 332.679993 C 617.130005 332.730011 617.159973 332.799988 617.159973 332.890015 L 617.159973 350.380005 C 617.159973 350.470001 617.130005 350.540009 617.059998 350.609985 C 617.01001 350.660004 616.940002 350.690002 616.849976 350.690002 L 613.820007 350.690002 Z M 625.5 337.179993 C 626.669983 337.179993 627.549988 337.570007 628.140015 338.339996 C 628.72998 339.119995 629.02002 340.200012 629.02002 341.600006 L 629.02002 350.369995 C 629.02002 350.459991 628.98999 350.529999 628.919983 350.600006 C 628.869995 350.649994 628.799988 350.679993 628.710022 350.679993 L 625.679993 350.679993 C 625.590027 350.679993 625.52002 350.649994 625.450012 350.600006 C 625.400024 350.529999 625.369995 350.450012 625.369995 350.369995 L 625.369995 341.880005 C 625.369995 341.380005 625.27002 340.98999 625.059998 340.720001 C 624.869995 340.440002 624.590027 340.309998 624.210022 340.309998 C 623.830017 340.309998 623.5 340.459991 623.280029 340.75 C 623.070007 341.029999 622.969971 341.420013 622.969971 341.940002 L 622.969971 350.380005 C 622.969971 350.470001 622.940002 350.540009 622.869995 350.609985 C 622.820007 350.660004 622.75 350.690002 622.659973 350.690002 L 619.630005 350.690002 C 619.539978 350.690002 619.469971 350.660004 619.400024 350.609985 C 619.349976 350.540009 619.320007 350.459991 619.320007 350.380005 L 619.320007 337.700012 C 619.320007 337.609985 619.349976 337.540009 619.400024 337.48999 C 619.469971 337.420013 619.549988 337.390015 619.630005 337.390015 L 622.659973 337.390015 C 622.75 337.390015 622.820007 337.420013 622.869995 337.48999 C 622.940002 337.540009 622.969971 337.609985 622.969971 337.700012 L 622.969971 338.190002 C 622.969971 338.23999 622.98999 338.269989 623.02002 338.269989 C 623.070007 338.269989 623.130005 338.23999 623.200012 338.170013 C 623.75 337.51001 624.52002 337.190002 625.5 337.190002 L 625.5 337.179993 Z M 644.51001 332.779999 C 644.580017 332.640015 644.710022 332.570007 644.900024 332.570007 L 647.900024 332.570007 C 647.98999 332.570007 648.059998 332.600006 648.109985 332.670013 C 648.179993 332.720001 648.210022 332.790009 648.210022 332.880005 L 648.210022 350.369995 C 648.210022 350.459991 648.179993 350.529999 648.109985 350.600006 C 648.059998 350.649994 647.98999 350.679993 647.900024 350.679993 L 644.869995 350.679993 C 644.780029 350.679993 644.710022 350.649994 644.640015 350.600006 C 644.590027 350.529999 644.559998 350.450012 644.559998 350.369995 L 644.559998 338.75 C 644.559998 338.679993 644.539978 338.649994 644.51001 338.649994 C 644.47998 338.649994 644.440002 338.679993 644.409973 338.730011 L 642.390015 342.299988 C 642.299988 342.440002 642.22998 342.51001 642.179993 342.51001 C 642.130005 342.51001 642.059998 342.440002 641.969971 342.299988 L 639.950012 338.730011 C 639.919983 338.679993 639.880005 338.649994 639.849976 338.649994 C 639.820007 338.649994 639.799988 338.679993 639.799988 338.75 L 639.799988 350.369995 C 639.799988 350.459991 639.77002 350.529999 639.700012 350.600006 C 639.650024 350.649994 639.580017 350.679993 639.48999 350.679993 L 636.460022 350.679993 C 636.369995 350.679993 636.299988 350.649994 636.22998 350.600006 C 636.179993 350.529999 636.150024 350.450012 636.150024 350.369995 L 636.150024 332.880005 C 636.150024 332.790009 636.179993 332.720001 636.22998 332.670013 C 636.299988 332.600006 636.380005 332.570007 636.460022 332.570007 L 639.440002 332.570007 C 639.609985 332.570007 639.73999 332.640015 639.830017 332.779999 L 642.130005 336.890015 C 642.179993 336.959991 642.22998 336.959991 642.289978 336.890015 L 644.52002 332.779999 L 644.51001 332.779999 Z M 652.090027 335.890015 C 651.5 335.890015 651.01001 335.700012 650.609985 335.320007 C 650.22998 334.920013 650.039978 334.429993 650.039978 333.839996 C 650.039978 333.25 650.22998 332.73999 650.609985 332.359985 C 650.98999 331.980011 651.47998 331.790009 652.090027 331.790009 C 652.700012 331.790009 653.179993 331.980011 653.539978 332.359985 C 653.919983 332.73999 654.109985 333.230011 654.109985 333.839996 C 654.109985 334.450012 653.919983 334.920013 653.539978 335.320007 C 653.159973 335.700012 652.679993 335.890015 652.090027 335.890015 Z M 650.609985 350.690002 C 650.52002 350.690002 650.450012 350.660004 650.380005 350.609985 C 650.330017 350.540009 650.299988 350.459991 650.299988 350.380005 L 650.299988 337.700012 C 650.299988 337.609985 650.330017 337.540009 650.380005 337.48999 C 650.450012 337.420013 650.530029 337.390015 650.609985 337.390015 L 653.640015 337.390015 C 653.72998 337.390015 653.799988 337.420013 653.849976 337.48999 C 653.919983 337.540009 653.950012 337.609985 653.950012 337.700012 L 653.950012 350.380005 C 653.950012 350.470001 653.919983 350.540009 653.849976 350.609985 C 653.799988 350.660004 653.72998 350.690002 653.640015 350.690002 L 650.609985 350.690002 Z M 662.090027 337.179993 C 663.26001 337.179993 664.140015 337.570007 664.72998 338.339996 C 665.320007 339.119995 665.609985 340.200012 665.609985 341.600006 L 665.609985 350.369995 C 665.609985 350.459991 665.580017 350.529999 665.51001 350.600006 C 665.460022 350.649994 665.390015 350.679993 665.299988 350.679993 L 662.27002 350.679993 C 662.179993 350.679993 662.109985 350.649994 662.039978 350.600006 C 661.98999 350.529999 661.960022 350.450012 661.960022 350.369995 L 661.960022 341.880005 C 661.960022 341.380005 661.859985 340.98999 661.650024 340.720001 C 661.460022 340.440002 661.179993 340.309998 660.799988 340.309998 C 660.419983 340.309998 660.090027 340.459991 659.869995 340.75 C 659.659973 341.029999 659.559998 341.420013 659.559998 341.940002 L 659.559998 350.380005 C 659.559998 350.470001 659.530029 350.540009 659.460022 350.609985 C 659.409973 350.660004 659.340027 350.690002 659.25 350.690002 L 656.219971 350.690002 C 656.130005 350.690002 656.059998 350.660004 655.98999 350.609985 C 655.940002 350.540009 655.909973 350.459991 655.909973 350.380005 L 655.909973 337.700012 C 655.909973 337.609985 655.940002 337.540009 655.98999 337.48999 C 656.059998 337.420013 656.140015 337.390015 656.219971 337.390015 L 659.25 337.390015 C 659.340027 337.390015 659.409973 337.420013 659.460022 337.48999 C 659.530029 337.540009 659.559998 337.609985 659.559998 337.700012 L 659.559998 338.190002 C 659.559998 338.23999 659.580017 338.269989 659.609985 338.269989 C 659.659973 338.269989 659.719971 338.23999 659.789978 338.170013 C 660.340027 337.51001 661.109985 337.190002 662.090027 337.190002 L 662.090027 337.179993 Z M 673.429993 337.700012 C 673.429993 337.609985 673.460022 337.540009 673.51001 337.48999 C 673.580017 337.420013 673.659973 337.390015 673.73999 337.390015 L 676.77002 337.390015 C 676.859985 337.390015 676.929993 337.420013 676.97998 337.48999 C 677.049988 337.540009 677.080017 337.609985 677.080017 337.700012 L 677.080017 350.380005 C 677.080017 350.470001 677.049988 350.540009 676.97998 350.609985 C 676.929993 350.660004 676.859985 350.690002 676.77002 350.690002 L 673.73999 350.690002 C 673.650024 350.690002 673.580017 350.660004 673.51001 350.609985 C 673.460022 350.540009 673.429993 350.459991 673.429993 350.380005 L 673.429993 349.940002 C 673.429993 349.890015 673.409973 349.850006 673.380005 349.839996 C 673.349976 349.820007 673.309998 349.839996 673.280029 349.890015 C 673.02002 350.25 672.690002 350.51001 672.299988 350.670013 C 671.919983 350.809998 671.469971 350.880005 670.950012 350.880005 C 669.909973 350.880005 669.059998 350.570007 668.390015 349.950012 C 667.719971 349.309998 667.380005 348.339996 667.380005 347.029999 L 667.380005 337.709991 C 667.380005 337.619995 667.409973 337.549988 667.460022 337.5 C 667.530029 337.429993 667.609985 337.399994 667.690002 337.399994 L 670.719971 337.399994 C 670.809998 337.399994 670.880005 337.429993 670.929993 337.5 C 671 337.549988 671.030029 337.619995 671.030029 337.709991 L 671.030029 346.220001 C 671.030029 346.720001 671.130005 347.109985 671.309998 347.380005 C 671.52002 347.640015 671.809998 347.769989 672.190002 347.769989 C 672.570007 347.769989 672.869995 347.619995 673.099976 347.329987 C 673.320007 347.040009 673.440002 346.640015 673.440002 346.140015 L 673.440002 337.700012 L 673.429993 337.700012 Z M 685.109985 339.640015 C 685.109985 339.730011 685.080017 339.799988 685.01001 339.869995 C 684.960022 339.920013 684.890015 339.950012 684.799988 339.950012 L 683.349976 339.950012 C 683.26001 339.950012 683.219971 339.98999 683.219971 340.079987 L 683.219971 346.23999 C 683.219971 346.73999 683.320007 347.089996 683.5 347.279999 C 683.690002 347.470001 683.969971 347.559998 684.349976 347.540009 L 684.530029 347.540009 C 684.619995 347.540009 684.690002 347.570007 684.73999 347.640015 C 684.809998 347.690002 684.840027 347.76001 684.840027 347.850006 L 684.840027 350.390015 C 684.840027 350.480011 684.809998 350.549988 684.73999 350.619995 C 684.690002 350.670013 684.619995 350.700012 684.530029 350.700012 L 683.48999 350.700012 C 682.22998 350.700012 681.280029 350.48999 680.640015 350.079987 C 680 349.649994 679.679993 348.839996 679.679993 347.649994 L 679.679993 340.089996 C 679.679993 340 679.640015 339.959991 679.549988 339.959991 L 678.700012 339.959991 C 678.609985 339.959991 678.539978 339.929993 678.469971 339.880005 C 678.419983 339.809998 678.390015 339.730011 678.390015 339.649994 L 678.390015 337.709991 C 678.390015 337.619995 678.419983 337.549988 678.469971 337.5 C 678.539978 337.429993 678.619995 337.399994 678.700012 337.399994 L 679.549988 337.399994 C 679.640015 337.399994 679.679993 337.359985 679.679993 337.269989 L 679.679993 334.399994 C 679.679993 334.309998 679.710022 334.23999 679.76001 334.190002 C 679.830017 334.119995 679.909973 334.089996 679.98999 334.089996 L 682.890015 334.089996 C 682.97998 334.089996 683.049988 334.119995 683.099976 334.190002 C 683.169983 334.23999 683.200012 334.309998 683.200012 334.399994 L 683.200012 337.269989 C 683.200012 337.359985 683.23999 337.399994 683.330017 337.399994 L 684.780029 337.399994 C 684.869995 337.399994 684.940002 337.429993 684.98999 337.5 C 685.059998 337.549988 685.090027 337.619995 685.090027 337.709991 L 685.090027 339.649994 L 685.109985 339.640015 Z M 696.190002 344.869995 C 696.190002 344.959991 696.159973 345.029999 696.090027 345.100006 C 696.039978 345.149994 695.969971 345.179993 695.880005 345.179993 L 690.190002 345.179993 C 690.099976 345.179993 690.059998 345.220001 690.059998 345.309998 L 690.059998 346.269989 C 690.059998 346.700012 690.169983 347.059998 690.400024 347.359985 C 690.640015 347.640015 690.940002 347.769989 691.309998 347.769989 C 691.640015 347.769989 691.909973 347.670013 692.109985 347.459991 C 692.320007 347.23999 692.450012 346.959991 692.52002 346.630005 C 692.570007 346.459991 692.679993 346.369995 692.859985 346.369995 L 695.840027 346.529999 C 695.929993 346.529999 696 346.559998 696.049988 346.630005 C 696.119995 346.679993 696.140015 346.76001 696.130005 346.859985 C 696.01001 348.190002 695.539978 349.200012 694.72998 349.890015 C 693.940002 350.559998 692.799988 350.899994 691.309998 350.899994 C 689.820007 350.899994 688.580017 350.519989 687.710022 349.76001 C 686.849976 348.980011 686.419983 347.910004 686.419983 346.549988 L 686.419983 341.529999 C 686.419983 340.220001 686.849976 339.170013 687.710022 338.369995 C 688.590027 337.579987 689.789978 337.179993 691.309998 337.179993 C 692.830017 337.179993 694.02002 337.579987 694.880005 338.369995 C 695.76001 339.160004 696.200012 340.220001 696.200012 341.529999 L 696.200012 344.869995 L 696.190002 344.869995 Z M 691.299988 340.320007 C 690.940002 340.320007 690.640015 340.459991 690.390015 340.730011 C 690.169983 341.01001 690.049988 341.359985 690.049988 341.790009 L 690.049988 342.799988 C 690.049988 342.890015 690.090027 342.929993 690.179993 342.929993 L 692.409973 342.929993 C 692.5 342.929993 692.539978 342.890015 692.539978 342.799988 L 692.539978 341.790009 C 692.539978 341.359985 692.419983 341.01001 692.179993 340.730011 C 691.960022 340.450012 691.659973 340.320007 691.299988 340.320007 Z M 702.289978 350.880005 C 700.820007 350.880005 699.650024 350.529999 698.77002 349.839996 C 697.909973 349.130005 697.47998 348.190002 697.47998 347.019989 L 697.47998 346.839996 C 697.47998 346.75 697.51001 346.679993 697.559998 346.630005 C 697.630005 346.559998 697.710022 346.529999 697.789978 346.529999 L 700.640015 346.529999 C 700.72998 346.529999 700.799988 346.559998 700.849976 346.630005 C 700.919983 346.679993 700.950012 346.75 700.950012 346.839996 L 700.950012 346.920013 C 700.950012 347.279999 701.080017 347.579987 701.340027 347.829987 C 701.599976 348.049988 701.919983 348.170013 702.299988 348.170013 C 702.640015 348.170013 702.909973 348.079987 703.099976 347.890015 C 703.309998 347.679993 703.409973 347.420013 703.409973 347.109985 C 703.409973 346.730011 703.25 346.440002 702.919983 346.230011 C 702.590027 346.01001 702.219971 345.820007 701.809998 345.690002 C 701.409973 345.529999 701.140015 345.429993 700.97998 345.380005 C 700.030029 345.029999 699.22998 344.559998 698.570007 343.959991 C 697.929993 343.339996 697.609985 342.450012 697.609985 341.290009 C 697.609985 340.029999 698.02002 339.040009 698.849976 338.309998 C 699.679993 337.589996 700.780029 337.220001 702.159973 337.220001 C 703.539978 337.220001 704.719971 337.600006 705.549988 338.359985 C 706.400024 339.119995 706.820007 340.149994 706.820007 341.440002 C 706.820007 341.529999 706.789978 341.600006 706.719971 341.670013 C 706.669983 341.720001 706.599976 341.75 706.51001 341.75 L 703.73999 341.75 C 703.650024 341.75 703.580017 341.720001 703.51001 341.670013 C 703.460022 341.600006 703.429993 341.519989 703.429993 341.440002 L 703.429993 341.230011 C 703.429993 340.880005 703.320007 340.609985 703.090027 340.399994 C 702.880005 340.179993 702.609985 340.059998 702.26001 340.059998 C 701.900024 340.059998 701.609985 340.179993 701.409973 340.420013 C 701.200012 340.640015 701.099976 340.910004 701.099976 341.220001 C 701.099976 341.630005 701.27002 341.959991 701.619995 342.200012 C 701.97998 342.420013 702.530029 342.670013 703.25 342.950012 C 703.98999 343.230011 704.619995 343.51001 705.140015 343.799988 C 705.679993 344.079987 706.130005 344.480011 706.51001 345.019989 C 706.890015 345.540009 707.080017 346.190002 707.080017 346.98999 C 707.080017 348.179993 706.640015 349.130005 705.76001 349.839996 C 704.900024 350.529999 703.73999 350.880005 702.289978 350.880005 Z"
      />
      <path
        id="path6266"
        fill="#27ae60"
        stroke="none"
        d="M 491.649994 363.269989 C 504.01001 363.269989 514.030029 353.25 514.030029 340.890015 C 514.030029 328.529999 504.01001 318.51001 491.649994 318.51001 C 479.290009 318.51001 469.269989 328.529999 469.269989 340.890015 C 469.269989 353.25 479.290009 363.269989 491.649994 363.269989 Z"
      />
      <path
        id="path6267"
        fill="#ffffff"
        stroke="none"
        d="M 491.630005 328.839996 L 491.01001 329.540009 C 488.380005 332.5 484.720001 333.890015 480.359985 334.429993 L 479.600006 334.519989 L 479.600006 335.279999 C 479.600006 339.720001 480.540009 344.029999 482.48999 347.559998 C 484.440002 351.089996 487.420013 353.850006 491.410004 355.040009 L 491.670013 355.119995 L 491.929993 355.029999 C 499.640015 352.540009 503.720001 344.420013 503.720001 335.279999 L 503.720001 334.589996 L 503.049988 334.429993 C 498.809998 333.450012 494.890015 332.26001 492.290009 329.519989 L 491.640015 328.839996 L 491.630005 328.839996 Z M 491.670013 331.130005 C 494.459991 333.730011 498.119995 334.98999 501.910004 335.890015 C 501.730011 344.119995 498.130005 350.98999 491.640015 353.25 C 488.26001 352.160004 485.709991 349.859985 483.98999 346.730011 C 482.309998 343.679993 481.480011 339.880005 481.390015 335.920013 C 485.380005 335.309998 488.929993 333.890015 491.670013 331.140015 L 491.670013 331.130005 Z M 496.25 338.5 L 489.970001 343.98999 L 487.100006 341.119995 L 485.880005 342.339996 L 489.890015 346.350006 L 497.390015 339.790009 L 496.25 338.5 Z"
      />
      <path
        id="path6268"
        fill="#4f4f4f"
        stroke="none"
        visibility="hidden"
        d="M 208.710999 109.397003 C 207.789001 109.351013 206.983002 109.125 206.294006 108.718018 C 205.606003 108.311005 205.080002 107.768005 204.718002 107.088989 C 204.367996 106.398987 204.214996 105.615997 204.257996 104.740997 L 204.459 100.713989 C 204.503006 99.839203 204.733994 99.075806 205.151001 98.423798 C 205.580002 97.7724 206.156998 97.284607 206.882004 96.960297 C 207.606995 96.624084 208.432007 96.479095 209.354996 96.525208 C 210.264999 96.570709 211.059006 96.790588 211.737 97.184906 C 212.425995 97.579712 212.947006 98.098389 213.298996 98.740692 C 213.664001 99.371704 213.826996 100.065002 213.789993 100.820007 L 213.783005 100.945984 C 213.779999 101.005981 213.753998 101.057983 213.703003 101.104004 C 213.666 101.138 213.617004 101.153992 213.557007 101.151001 L 211.453995 101.04599 C 211.393997 101.042999 211.341003 101.022003 211.294006 100.984009 C 211.261002 100.93399 211.246002 100.878998 211.248993 100.819 L 211.251007 100.765015 C 211.279007 100.213989 211.110001 99.742798 210.744995 99.352112 C 210.380997 98.949402 209.880997 98.732208 209.246002 98.7005 C 208.598999 98.668091 208.067001 98.845795 207.651001 99.233582 C 207.248001 99.609894 207.029999 100.122009 206.998001 100.768982 L 206.789001 104.940002 C 206.757004 105.587006 206.940994 106.125 207.339996 106.553009 C 207.738998 106.970001 208.263 107.194 208.910004 107.226013 C 209.533005 107.257019 210.039001 107.121002 210.425995 106.815002 C 210.815002 106.497986 211.024002 106.04599 211.052994 105.458984 L 211.093002 104.649994 C 211.095993 104.589996 211.067993 104.55899 211.007996 104.556 L 208.994003 104.455017 C 208.934006 104.451996 208.880997 104.431 208.835007 104.393005 C 208.802002 104.343018 208.785995 104.289001 208.789001 104.229004 L 208.871994 102.575012 C 208.875 102.515015 208.895004 102.468018 208.932999 102.43399 C 208.983994 102.388 209.039001 102.367004 209.098999 102.369995 L 213.485001 102.588989 C 213.544998 102.59201 213.591995 102.617981 213.625 102.667999 C 213.671005 102.705994 213.692993 102.755005 213.690002 102.815002 L 213.572006 105.187988 C 213.526001 106.098999 213.294998 106.880981 212.878006 107.53299 C 212.460999 108.184998 211.889999 108.673004 211.164001 108.997009 C 210.451996 109.309998 209.634003 109.442993 208.710999 109.397003 Z M 223.582993 104.408997 C 223.632004 104.867981 223.630005 105.378998 223.578003 105.94101 C 223.559006 106.083984 223.477997 106.152008 223.334 106.144989 L 217.779007 105.867004 C 217.707001 105.864014 217.681 105.891998 217.701996 105.953003 C 217.725998 106.195007 217.779999 106.437988 217.863998 106.682007 C 218.141998 107.369019 218.761002 107.735992 219.720001 107.783997 C 220.487 107.811005 221.108002 107.528992 221.582001 106.940002 C 221.634003 106.871002 221.688995 106.837006 221.748993 106.839996 C 221.785004 106.84201 221.826004 106.867981 221.871002 106.919006 L 223.102005 108.26001 C 223.158997 108.322998 223.186005 108.377991 223.184006 108.425995 C 223.182999 108.450012 223.156006 108.497009 223.104996 108.56601 C 222.684998 109.037994 222.156006 109.395996 221.518997 109.640015 C 220.882996 109.872986 220.192993 109.971008 219.449997 109.93399 C 218.419006 109.882019 217.556 109.605011 216.860001 109.101013 C 216.177002 108.598999 215.699997 107.919983 215.429993 107.065002 C 215.207993 106.45401 215.121994 105.661987 215.169998 104.692017 C 215.203003 104.031982 215.322006 103.455994 215.526993 102.960999 C 215.845001 102.123993 216.358002 101.471008 217.067001 101.002014 C 217.787003 100.53299 218.621002 100.321991 219.567001 100.369995 C 220.766006 100.429016 221.707001 100.825012 222.391998 101.556 C 223.087997 102.287994 223.485001 103.239014 223.582993 104.408997 Z M 219.475998 102.563995 C 218.720993 102.526001 218.205994 102.855011 217.931 103.549988 C 217.875 103.703003 217.822998 103.893005 217.776001 104.119019 C 217.772995 104.179016 217.800995 104.209991 217.860992 104.213013 L 220.972 104.369019 C 221.042999 104.372009 221.069 104.343018 221.048004 104.281982 C 221.005005 103.932007 220.983994 103.761993 220.983002 103.773987 C 220.893005 103.408997 220.714996 103.123993 220.449005 102.919006 C 220.195999 102.701996 219.871002 102.583008 219.475998 102.563995 Z M 230.225006 100.919983 C 231.184006 100.968018 231.942001 101.299988 232.5 101.916992 C 233.057999 102.53299 233.311996 103.345001 233.261993 104.35199 L 232.966995 110.247986 C 232.964005 110.307983 232.938004 110.360992 232.886993 110.406982 C 232.850006 110.44101 232.800995 110.455994 232.740997 110.453003 L 230.636993 110.347992 C 230.576996 110.345001 230.524002 110.325012 230.477997 110.286011 C 230.445007 110.237 230.429001 110.182007 230.432007 110.122009 L 230.701004 104.747009 C 230.725006 104.266998 230.606995 103.871002 230.345993 103.557007 C 230.097 103.244995 229.751007 103.076996 229.307999 103.054993 C 228.863998 103.03299 228.496994 103.165009 228.207001 103.450012 C 227.927994 103.737 227.776993 104.119995 227.753006 104.598999 L 227.483994 109.975006 C 227.481003 110.033997 227.453995 110.087006 227.404007 110.132996 C 227.365997 110.166992 227.317993 110.182007 227.257996 110.179016 L 225.154007 110.074005 C 225.093994 110.070984 225.041 110.050995 224.994995 110.011993 C 224.962006 109.963013 224.945999 109.90799 224.949005 109.847992 L 225.389008 101.039001 C 225.391998 100.979004 225.412994 100.932007 225.449997 100.89801 C 225.501007 100.85199 225.556 100.830994 225.615997 100.833984 L 227.718994 100.938995 C 227.779007 100.942017 227.826004 100.968018 227.858994 101.018005 C 227.906006 101.056 227.927002 101.106018 227.923996 101.166016 L 227.893005 101.794983 C 227.891006 101.830994 227.901993 101.855011 227.925003 101.867981 C 227.947998 101.882019 227.966995 101.877014 227.979996 101.852997 C 228.505997 101.182983 229.255005 100.872009 230.225006 100.919983 Z M 243.175995 105.388 C 243.225006 105.846985 243.223007 106.356995 243.171005 106.919006 C 243.151993 107.062988 243.070007 107.130981 242.927002 107.122986 L 237.371994 106.846008 C 237.300003 106.84201 237.274002 106.871002 237.294998 106.932007 C 237.319 107.174011 237.373001 107.416992 237.457001 107.661011 C 237.735001 108.347992 238.354004 108.714996 239.311996 108.763 C 240.080002 108.790009 240.701004 108.507996 241.175003 107.919006 C 241.225998 107.850006 241.281998 107.81601 241.341995 107.819 C 241.378006 107.820984 241.419006 107.846985 241.464005 107.897003 L 242.695007 109.239014 C 242.751999 109.300995 242.779007 109.356995 242.776993 109.404999 C 242.774994 109.429016 242.748993 109.476013 242.697998 109.544983 C 242.276993 110.016998 241.748993 110.375 241.112 110.619019 C 240.475998 110.85199 239.785995 110.950012 239.042999 110.911987 C 238.011993 110.860992 237.149002 110.583984 236.453003 110.080017 C 235.768997 109.576996 235.292999 108.898987 235.022995 108.044006 C 234.800995 107.432007 234.714005 106.640991 234.763 105.669983 C 234.796005 105.010986 234.914993 104.43399 235.119995 103.940002 C 235.438004 103.102997 235.951004 102.450012 236.658997 101.980011 C 237.380005 101.511993 238.212997 101.300995 239.160004 101.347992 C 240.358994 101.40799 241.300003 101.804016 241.983994 102.535004 C 242.681 103.265991 243.078003 104.21701 243.175995 105.388 Z M 239.067993 103.542999 C 238.313004 103.505005 237.798004 103.833984 237.522995 104.528992 C 237.468002 104.682007 237.416 104.872009 237.369003 105.097992 C 237.365997 105.15799 237.393997 105.188995 237.453995 105.192017 L 240.563995 105.346985 C 240.636002 105.351013 240.662003 105.321991 240.641006 105.260986 C 240.598007 104.911011 240.576996 104.740997 240.576004 104.752991 C 240.485992 104.388 240.307999 104.102997 240.042007 103.89801 C 239.787994 103.681 239.464005 103.562012 239.067993 103.542999 Z M 249.600998 101.906006 C 250.033005 101.928009 250.369995 102.028992 250.613998 102.208984 C 250.707001 102.261993 250.738998 102.352997 250.707993 102.484009 L 250.227997 104.515015 C 250.209 104.65799 250.123001 104.695984 249.970001 104.627991 C 249.792999 104.55899 249.585007 104.518005 249.345001 104.505981 C 249.248993 104.502014 249.117004 104.507019 248.947998 104.52301 C 248.514999 104.536987 248.141006 104.681 247.826996 104.953003 C 247.514008 105.213989 247.345001 105.578003 247.322006 106.044983 L 247.076996 110.953003 C 247.074005 111.013 247.046997 111.06601 246.996994 111.112 C 246.959 111.145996 246.910004 111.161011 246.850006 111.15799 L 244.746994 111.053009 C 244.686996 111.049988 244.634003 111.029999 244.587997 110.990997 C 244.554001 110.94101 244.539001 110.886993 244.542007 110.826996 L 244.981995 102.018005 C 244.985001 101.958008 245.005005 101.911011 245.042999 101.877014 C 245.093994 101.830994 245.149002 101.809998 245.209 101.812988 L 247.311996 101.917999 C 247.371994 101.92099 247.419006 101.946991 247.451996 101.997009 C 247.498001 102.035004 247.520004 102.083984 247.516998 102.143982 L 247.483002 102.826996 C 247.481003 102.863007 247.492004 102.888 247.514999 102.901001 C 247.539001 102.914001 247.557007 102.908997 247.570007 102.885986 C 248.097 102.19101 248.774002 101.86499 249.600998 101.906006 Z M 255.462006 102.181 C 256.240997 102.220001 256.928986 102.391998 257.527008 102.697998 C 258.125 102.992981 258.579987 103.382019 258.891998 103.865997 C 259.21701 104.351013 259.364014 104.880981 259.335999 105.455994 L 259.031006 111.550995 C 259.028015 111.609985 259.001007 111.662994 258.950989 111.708984 C 258.912994 111.742981 258.86499 111.757996 258.804993 111.755005 L 256.700989 111.649994 C 256.640991 111.647003 256.588013 111.627014 256.541992 111.588013 C 256.509003 111.539001 256.493011 111.484009 256.496002 111.424011 L 256.526001 110.830994 C 256.528015 110.794983 256.516998 110.769989 256.493988 110.757019 C 256.470001 110.744019 256.446014 110.755005 256.420013 110.789001 C 255.884003 111.423004 255.057999 111.713013 253.942993 111.656982 C 253.009003 111.609985 252.264999 111.345001 251.712006 110.860992 C 251.160004 110.376007 250.906006 109.69101 250.949997 108.804016 C 250.996002 107.880981 251.354996 107.18399 252.028 106.713013 C 252.701004 106.230011 253.636002 106.018005 254.835007 106.078003 L 256.669006 106.169983 C 256.729004 106.173004 256.76001 106.143982 256.763 106.084991 L 256.78299 105.688995 C 256.803009 105.294006 256.697998 104.981995 256.468994 104.753998 C 256.240997 104.515015 255.886993 104.382996 255.406998 104.359009 C 255.035995 104.339996 254.720993 104.390991 254.462997 104.51001 C 254.216003 104.630005 254.050995 104.807983 253.966995 105.044006 C 253.925003 105.174011 253.843994 105.230011 253.725006 105.212006 L 251.563995 104.81601 C 251.421005 104.783997 251.358002 104.72699 251.373993 104.643982 C 251.447006 104.143005 251.667999 103.696991 252.035995 103.307007 C 252.416 102.917999 252.899002 102.622986 253.485992 102.424011 C 254.084 102.226013 254.742996 102.144989 255.462006 102.181 Z M 254.720993 109.803009 C 255.235992 109.82901 255.681 109.713013 256.053986 109.455017 C 256.427002 109.197998 256.625 108.852997 256.645996 108.421997 L 256.678986 107.773987 C 256.682007 107.714996 256.653015 107.682983 256.592987 107.679993 L 255.298996 107.61499 C 254.759003 107.588013 254.328995 107.669006 254.007004 107.856995 C 253.697006 108.04599 253.533005 108.325989 253.514999 108.697998 C 253.498001 109.020996 253.598999 109.285004 253.817993 109.488007 C 254.035995 109.679016 254.337006 109.783997 254.720993 109.803009 Z M 261.022003 111.865997 C 260.962006 111.863007 260.908997 111.843018 260.863007 111.804016 C 260.82901 111.753998 260.813995 111.700012 260.816986 111.640015 L 261.424011 99.486908 C 261.427002 99.427002 261.446991 99.379883 261.484985 99.345795 C 261.535004 99.300201 261.589996 99.2789 261.649994 99.281891 L 263.753998 99.386993 C 263.813995 99.390015 263.859985 99.416382 263.894012 99.466095 C 263.940002 99.504517 263.962006 99.553589 263.959015 99.613495 L 263.351013 111.765991 C 263.348999 111.825989 263.321991 111.878998 263.272003 111.924988 C 263.234009 111.958984 263.184998 111.973999 263.125 111.971008 L 261.022003 111.865997 Z"
      />
      <image
        id="Management"
        x={190}
        y={95}
        width={91}
        height={17}
        xlinkHref="data:image/png;base64, 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"
      />
      <path
        id="path6269"
        fill="#27ae60"
        fillRule="evenodd"
        stroke="none"
        d="M 233.059998 367.959991 L 234.949997 323.329987 L 191.050003 322 L 193.869995 367.950012 C 207.339996 368.98999 217.460007 368.98999 233.059998 367.950012 L 233.059998 367.959991 Z"
      />
      <path
        id="path6270"
        fill="#e2e2ff"
        fillRule="evenodd"
        stroke="none"
        d="M 234.949997 323.329987 C 234.949997 323.329987 212.619995 328.859985 191.050003 322 C 191.050003 322 213.210007 318.809998 234.949997 323.329987 Z"
      />
      <linearGradient
        id="linearGradient466"
        x1="213.01"
        y1="324.62"
        x2="213.01"
        y2="321.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#c5aebd" stopOpacity={1} />
        <stop offset={1} stopColor="#8481d2" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6271"
        fill="url(#linearGradient466)"
        fillRule="evenodd"
        stroke="none"
        d="M 231.220001 323.26001 C 231.220001 323.26001 213.679993 319.920013 194.789993 322.420013 C 194.789993 322.420013 206.740005 326.76001 231.220001 323.26001 Z"
      />
      <radialGradient
        id="radialGradient159"
        cx="203.75"
        cy="317.947"
        r="7.75"
        fx="203.75"
        fy="317.947"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#402743" stopOpacity={1} />
        <stop offset="0.99" stopColor="#2a1032" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6272"
        fill="url(#radialGradient159)"
        fillRule="evenodd"
        stroke="none"
        d="M 227.559998 323.730011 C 227.559998 323.730011 216.130005 321.290009 195.979996 322.769989 C 195.979996 322.769989 206.520004 326.540009 227.559998 323.730011 Z"
      />
      <linearGradient
        id="linearGradient467"
        x1="234.79"
        y1="348.06"
        x2="215.3"
        y2="348.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#71656c" stopOpacity={1} />
        <stop offset={1} stopColor="#000000" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6273"
        fill="url(#linearGradient467)"
        fillRule="evenodd"
        stroke="none"
        opacity="0.5"
        style={{ mixBlendMode: 'screen' }}
        d="M 234.779999 327.309998 C 234.779999 327.309998 229.070007 334.869995 216.820007 340.220001 L 215.300003 368.730011 C 215.300003 368.730011 222.789993 369.200012 233.059998 367.970001 L 234.779999 327.320007 L 234.779999 327.309998 Z"
      />
      <radialGradient
        id="radialGradient160"
        cx="210.74"
        cy="286.89"
        r="26.47"
        fx="210.74"
        fy="286.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.02" stopColor="#b54533" stopOpacity={1} />
        <stop offset="0.99" stopColor="#791d36" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6274"
        fill="url(#radialGradient160)"
        fillRule="evenodd"
        stroke="none"
        d="M 215.619995 323.790009 L 214.570007 301.380005 C 214.570007 301.380005 210.350006 300.019989 209.809998 295.25 L 207.229996 261.640015 L 208.589996 249.779999 L 205.880005 249.779999 L 205.880005 297.440002 L 207.460007 303.149994 C 207.460007 303.149994 209.740005 304.959991 210.75 306.320007 C 211.759995 307.679993 210.75 324.01001 210.75 324.01001 L 215.619995 323.790009 Z"
      />
      <linearGradient
        id="linearGradient468"
        x1="220.39"
        y1="282.34"
        x2="220.39"
        y2="252.28"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2f2c08" stopOpacity={1} />
        <stop offset={1} stopColor="#615a0e" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6275"
        fill="url(#linearGradient468)"
        fillRule="evenodd"
        stroke="none"
        d="M 208.809998 282.339996 C 208.809998 282.339996 225.809998 273.549988 232.649994 252.679993 C 232.649994 252.679993 223.460007 251.070007 215.610001 254.289993 C 207.770004 257.51001 208.119995 273.429993 208.119995 273.429993 L 208.800003 282.329987 L 208.809998 282.339996 Z"
      />
      <linearGradient
        id="linearGradient469"
        x1="186.45"
        y1="276.89"
        x2="186.45"
        y2="259.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#484525" stopOpacity={1} />
        <stop offset={1} stopColor="#798633" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6276"
        fill="url(#linearGradient469)"
        fillRule="evenodd"
        stroke="none"
        d="M 205.869995 276.410004 C 205.869995 276.410004 200.710007 266.450012 191.529999 261.76001 C 182.350006 257.070007 167.039993 261.76001 167.039993 261.76001 C 167.039993 261.76001 193.309998 280.079987 205.869995 276.410004 Z"
      />
      <linearGradient
        id="linearGradient470"
        x1="221.55"
        y1="282.41"
        x2="221.55"
        y2="264.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#484525" stopOpacity={1} />
        <stop offset={1} stopColor="#798633" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6277"
        fill="url(#linearGradient470)"
        fillRule="evenodd"
        stroke="none"
        d="M 208.809998 282.339996 C 208.809998 282.339996 216.520004 265.98999 220.350006 264.630005 C 224.179993 263.26001 234.279999 271.470001 234.279999 271.470001 C 234.279999 271.470001 223.910004 278.029999 219.529999 280.48999 C 215.160004 282.950012 208.809998 282.339996 208.809998 282.339996 Z"
      />
      <linearGradient
        id="linearGradient471"
        x1="195.36"
        y1="293.09"
        x2="195.36"
        y2="276.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#484525" stopOpacity={1} />
        <stop offset={1} stopColor="#798633" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6278"
        fill="url(#linearGradient471)"
        fillRule="evenodd"
        stroke="none"
        d="M 205.869995 293.070007 C 205.869995 293.070007 204.770004 285.970001 200.389999 282.410004 C 196.020004 278.850006 184.850006 276.890015 184.850006 276.890015 C 184.850006 276.890015 193.839996 293.880005 205.860001 293.059998 L 205.869995 293.070007 Z"
      />
      <linearGradient
        id="linearGradient472"
        x1="201.97"
        y1="256.15"
        x2="201.97"
        y2="218.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2f2c08" stopOpacity={1} />
        <stop offset={1} stopColor="#615a0e" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6279"
        fill="url(#linearGradient472)"
        fillRule="evenodd"
        stroke="none"
        d="M 205.869995 256.149994 C 205.869995 256.149994 212.479996 235.710022 202.880005 218.5 C 202.880005 218.5 195.880005 231.549988 195.860001 244.130005 C 195.839996 256.709991 205.869995 256.149994 205.869995 256.149994 Z"
      />
      <linearGradient
        id="linearGradient473"
        x1="199.27"
        y1="288.58"
        x2="199.27"
        y2="254.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2f2c08" stopOpacity={1} />
        <stop offset={1} stopColor="#615a0e" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6280"
        fill="url(#linearGradient473)"
        fillRule="evenodd"
        stroke="none"
        d="M 205.869995 288.579987 C 205.869995 288.579987 207.279999 265.390015 195.360001 254.300003 C 195.360001 254.300003 184.550003 280.359985 205.869995 288.579987 Z"
      />
      <linearGradient
        id="linearGradient474"
        x1="215.1"
        y1="300.27"
        x2="215.1"
        y2="276.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#706500" stopOpacity={1} />
        <stop offset={1} stopColor="#818400" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6281"
        fill="url(#linearGradient474)"
        fillRule="evenodd"
        stroke="none"
        d="M 212.610001 300.269989 L 212.910004 297.170013 C 212.910004 297.170013 219.949997 291.619995 219.669998 276.899994 C 219.669998 276.899994 211.679993 281.920013 210.75 288.589996 C 209.809998 295.26001 212.25 297.359985 212.25 297.359985 L 211.729996 299.480011 L 212.610001 300.279999 L 212.610001 300.269989 Z"
      />
      <linearGradient
        id="linearGradient475"
        x1="214.51"
        y1="264.48"
        x2="214.51"
        y2="244.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#706500" stopOpacity={1} />
        <stop offset={1} stopColor="#818400" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6282"
        fill="url(#linearGradient475)"
        fillRule="evenodd"
        stroke="none"
        d="M 205.869995 264.480011 L 208.820007 259.670013 C 208.820007 259.670013 217.889999 260.350006 224.089996 244.119995 C 224.089996 244.119995 211.789993 244.479996 206.960007 247.399994 C 202.130005 250.320007 207.460007 259.670013 207.460007 259.670013 L 205.880005 263.26001 L 205.880005 264.470001 L 205.869995 264.480011 Z"
      />
      <linearGradient
        id="linearGradient476"
        x1="70.2999"
        y1="243.42"
        x2="67.7599"
        y2="253.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6283"
        fill="url(#linearGradient476)"
        stroke="none"
        d="M 73.909897 249.350006 C 71.849899 252.929993 69.679901 253.610001 68.739899 253.360001 C 67.809898 253.110001 63.009899 249.490005 63.009899 249.490005 C 63.009899 249.490005 66.599899 250.550003 67.429901 250.270004 C 68.259903 249.990005 70.809898 248.779999 71.289902 248.410004 C 71.759903 248.029999 73.499901 244.240005 74.429901 244.490005 C 75.359901 244.740005 75.969902 245.759995 73.909897 249.350006 Z"
      />
      <path
        id="path6284"
        fill="#f7d4ab"
        stroke="none"
        d="M 50.3699 238.75 C 51.569901 239 55.749901 239.110001 59.2799 240.410004 C 62.809898 241.710007 74.219902 245.309998 74.039902 246.020004 C 73.859901 246.720001 74.219902 248.690002 67.319901 246.880005 C 60.429901 245.080002 60.339901 245.429993 60.069901 245.979996 C 59.7999 246.529999 61.629902 248.630005 63.6399 249.529999 C 65.649902 250.429993 69.119904 251.960007 69.769897 251.880005 C 70.409897 251.800003 74.409897 247.470001 75.179901 246.929993 C 75.949898 246.380005 78.1399 244.639999 78.789902 246 C 79.299896 247.070007 72.2099 254.770004 70.089897 256.459991 C 69.179901 257.179993 62.5299 254.729996 60.019901 253.830002 C 57.509899 252.919998 48.969898 245.949997 45.949902 244.160004 C 42.919899 242.369995 40.539902 240.5 40.539902 240.5 L 40.6199 235.02002 C 42.109901 235.710022 48.379902 238.339996 50.379902 238.75 L 50.3699 238.75 Z"
      />
      <linearGradient
        id="linearGradient477"
        x1="63.3999"
        y1="245.76"
        x2="62.5199"
        y2="249.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6285"
        fill="url(#linearGradient477)"
        stroke="none"
        d="M 66.659897 246.699997 C 66.659897 246.699997 60.329899 244.520004 59.849899 245.850006 C 59.379902 247.190002 63.059898 249.25 63.059898 249.25 C 63.059898 249.25 60.5499 245.529999 66.649902 246.690002 L 66.659897 246.699997 Z"
      />
      <path
        id="path6286"
        fill="#ffdebd"
        stroke="none"
        d="M 71.159897 245.389999 C 70.469902 245.009995 70.739899 244.429993 70.739899 244.429993 C 70.739899 244.429993 72.809898 244.860001 74.2099 245.869995 C 74.099899 246.570007 72.649902 246.210007 71.159897 245.399994 L 71.159897 245.389999 Z"
      />
      <path
        id="path6287"
        fill="#ffdebd"
        stroke="none"
        d="M 76.790001 249.220001 C 76.790001 249.220001 76.260002 248.860001 76.650002 248.179993 C 77.489998 246.710007 78.540001 245.649994 79.010002 246.179993 C 78.339996 247.759995 76.800003 249.210007 76.800003 249.210007 L 76.790001 249.220001 Z"
      />
      <linearGradient
        id="linearGradient478"
        x1="57.0299"
        y1="252.57"
        x2="47.4499"
        y2="240.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6288"
        fill="url(#linearGradient478)"
        stroke="none"
        d="M 45.899899 242.759995 C 46.2299 243.580002 58.839901 253.779999 59.239899 251.289993 C 59.509899 249.610001 43.809898 237.580002 45.899899 242.759995 Z"
      />
      <linearGradient
        id="linearGradient479"
        x1="50.5399"
        y1="237.3"
        x2="48.6299"
        y2="241.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6289"
        fill="url(#linearGradient479)"
        stroke="none"
        d="M 40.599899 235.01001 L 50.019901 238.300003 C 51.559898 238.479996 55.159901 238.729996 60.0299 240.669998 C 60.0299 240.669998 50.689899 239.800003 48.3899 239.669998 L 40.609901 235.01001 L 40.599899 235.01001 Z"
      />
      <linearGradient
        id="linearGradient480"
        x1="79.5699"
        y1="48.96"
        x2="87.1699"
        y2="109.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#a3753d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6290"
        fill="url(#linearGradient480)"
        stroke="none"
        d="M 55.039902 111.790009 C 54.1399 99.730011 56.419899 84.070007 65.379898 75.700012 C 70.929901 70.529999 84.799896 70.450012 84.799896 70.450012 C 124.099998 67.779999 130.820007 139.369995 104.029999 150.049988 C 101.769997 150.399994 80.839897 163.440002 75.689903 164.339996 C 77.8899 160.649994 70.989899 150.809998 65.3899 142.899994 C 60.609901 136.160004 55.989899 124.669983 55.039902 111.779999 L 55.039902 111.790009 Z"
      />
      <linearGradient
        id="linearGradient481"
        x1="103.97"
        y1="158.48"
        x2="110.41"
        y2="106.63"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#a3753d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6291"
        fill="url(#linearGradient481)"
        stroke="none"
        d="M 102.449997 91.730011 C 102.449997 91.730011 137.309998 104.149994 102.370003 173.070007 L 97.959999 166.220001 C 97.959999 166.220001 108.410004 131.5 103.199997 118.190002 C 99.489998 108.720001 102.82 102.5 102.440002 91.730011 L 102.449997 91.730011 Z"
      />
      <linearGradient
        id="linearGradient482"
        x1="78.1799"
        y1="211.3"
        x2="68.8099"
        y2="121.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#a3753d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6292"
        fill="url(#linearGradient482)"
        stroke="none"
        d="M 87.899902 173.460022 C 86.989899 173.460022 75.219902 173.200012 74.829903 172.700012 C 53.499901 145 51.879902 116 57.669899 105.790009 C 77.109901 71.529999 77.689903 79.529999 77.689903 79.529999 C 82.079903 95.359985 80.309898 106.089996 74.699898 115.109985 C 66.949898 127.580017 81.249901 159.910004 87.879898 173.450012 L 87.899902 173.460022 Z"
      />
      <path
        id="path6293"
        fill="#f7d4ab"
        stroke="none"
        d="M 53.929901 155.039978 C 57.159901 153.619995 60.069901 147.76001 60.9599 147.669983 C 64.069901 147.369995 75.219902 143.839996 76.519897 139.669983 C 78.129898 134.470001 76.199898 127.790009 76.199898 127.790009 L 95.599899 126.809998 C 93.419899 130.47998 93.499901 134.369995 93.589897 138.330017 C 93.689903 142.669983 106.610001 146.460022 111.099998 146.950012 C 113.550003 147.22998 120.870003 152.029999 122.07 156.279999 C 123.75 162.25 125.059998 161.580017 124.559998 169.419983 L 46.489899 161.880005 C 46.969898 157.52002 47.849899 157.720001 53.929901 155.029999 L 53.929901 155.039978 Z"
      />
      <linearGradient
        id="linearGradient483"
        x1="94.3699"
        y1="133.96"
        x2="78.2499"
        y2="152.21"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6294"
        fill="url(#linearGradient483)"
        stroke="none"
        d="M 66.969902 144.399994 C 66.299896 144.119995 66.599899 144 65.929901 143.589996 C 73.509903 141.369995 74.769897 141.029999 75.309898 140.649994 C 75.8899 140.25 76.449898 138.359985 76.659897 136.140015 C 76.749901 135.179993 76.8899 132.76001 76.919899 131.5 C 77.179901 131.820007 93.719902 131.220001 94.359901 130.27002 L 96.2799 130.289978 C 96.2799 130.289978 95.919899 135.77002 96.609901 140.809998 C 96.789902 141.710022 102.150002 142.970001 105.669998 143.710022 C 105.419998 143.910004 104.519997 144.52002 104.309998 144.630005 C 101.300003 144.929993 98.7099 145.289978 97.479897 145.070007 C 95.979897 144.809998 93.449898 143.649994 91.619904 142.799988 C 81.7099 138.220001 78.609901 136.710022 78.609901 136.710022 C 78.1399 140.970001 75.019897 143.789978 75.189903 143.73999 C 72.689903 144.350006 69.659897 144.470001 66.9599 144.399994 L 66.969902 144.399994 Z"
      />
      <linearGradient
        id="linearGradient484"
        x1="96.6099"
        y1="147.68"
        x2="81.6799"
        y2="149.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6295"
        fill="url(#linearGradient484)"
        stroke="none"
        d="M 82.769897 150.600006 C 82.769897 150.600006 83.799896 147.72998 87.2799 148.850006 C 87.2799 148.850006 83.7099 149.48999 82.769897 150.600006 Z"
      />
      <linearGradient
        id="linearGradient485"
        x1="84.6399"
        y1="147.19"
        x2="67.3799"
        y2="144.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6296"
        fill="url(#linearGradient485)"
        stroke="none"
        d="M 82.649902 148.140015 C 82.649902 148.140015 81.649902 145.539978 80.259903 145.190002 C 78.869904 144.839996 67.449898 144.529999 65.659897 144.179993 C 65.659897 144.179993 68.559898 145.47998 72.499901 145.940002 C 76.449898 146.399994 79.549896 145.710022 82.649902 148.140015 Z"
      />
      <linearGradient
        id="linearGradient486"
        x1="86.2499"
        y1="148.39"
        x2="104.76"
        y2="143.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6297"
        fill="url(#linearGradient486)"
        stroke="none"
        d="M 87.559898 148.119995 C 87.559898 148.119995 88.519897 146.130005 90.229897 145.549988 C 91.939903 144.970001 104.989998 144.160004 107.339996 144.390015 C 107.339996 144.390015 90.879898 146.049988 87.559898 148.119995 Z"
      />
      <linearGradient
        id="linearGradient487"
        x1="87.8099"
        y1="128.66"
        x2="85.1599"
        y2="140.3"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6298"
        fill="url(#linearGradient487)"
        stroke="none"
        d="M 96.559898 140.130005 C 96.559898 140.130005 96.479897 129.549988 96.819901 127.669983 C 96.819901 127.669983 77.379898 128.380005 76.489899 128.450012 C 76.849899 130.649994 76.869904 133.399994 76.869904 133.399994 C 76.869904 133.399994 85.159897 143.779999 96.549896 140.130005 L 96.559898 140.130005 Z"
      />
      <path
        id="path6299"
        fill="#f0c499"
        stroke="none"
        d="M 107.330002 108.640015 C 106.519997 115.279999 106.290001 120.320007 106.290001 120.320007 C 108.919998 120.320007 109.449997 117.480011 110.470001 114.970001 C 112.050003 111.140015 112.900002 107.01001 108.75 106.640015 C 108.059998 106.580017 107.330002 108.630005 107.330002 108.630005 L 107.330002 108.640015 Z"
      />
      <linearGradient
        id="linearGradient488"
        x1="109.65"
        y1="109.01"
        x2="109.13"
        y2="127.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6300"
        fill="url(#linearGradient488)"
        stroke="none"
        d="M 107.809998 118.100006 C 107.809998 118.100006 109.099998 116.630005 108.709999 113.73999 C 107.769997 106.919983 112.059998 106.450012 111.089996 111.109985 C 111.089996 111.109985 110.5 108.910004 109.949997 109.570007 C 109.279999 110.380005 110.660004 110.820007 109.949997 114.350006 C 109.580002 116.179993 107.809998 118.109985 107.809998 118.109985 L 107.809998 118.100006 Z"
      />
      <path
        id="path6301"
        fill="#f7d4ab"
        stroke="none"
        d="M 83.2799 78.679993 C 95.7099 76.440002 104.480003 88.290009 106.830002 102.529999 C 108.150002 110.529999 107.739998 117.570007 103.760002 123.450012 C 102.150002 125.830017 100.160004 126.98999 97.839897 128.869995 C 96.369904 130.070007 94.059898 132.630005 92.489899 133.869995 C 91.059898 135 89.499901 135.919983 87.569901 135.98999 C 81.719902 136.220001 77.879898 131.539978 76.189903 129.850006 C 70.2799 123.910004 64.859901 121.709991 66.019897 105.179993 C 66.939903 92.179993 75.129898 78.959991 83.2799 78.669983 L 83.2799 78.679993 Z"
      />
      <linearGradient
        id="linearGradient489"
        x1="1269.17"
        y1="4077.09"
        x2="1264.9"
        y2="4062.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6302"
        fill="url(#linearGradient489)"
        stroke="none"
        d="M 83.620003 111.919983 C 83.089996 105.350006 83.360001 99.720093 76.43 98.400085 C 69.959999 97.160095 67.980003 101.220001 67.389999 102.190002 C 65.849998 104.690002 65.970001 111.070007 65.970001 111.070007 C 65.970001 111.070007 72.440002 116.880005 83.629997 111.919983 L 83.620003 111.919983 Z"
      />
      <radialGradient
        id="radialGradient161"
        cx="1115.86"
        cy="347.897"
        r="7.370766"
        fx="1115.86"
        fy="347.897"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f9b38e" stopOpacity={1} />
        <stop offset="0.61" stopColor="#f7c59e" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6303"
        fill="url(#radialGradient161)"
        stroke="none"
        d="M 79.7099 116.029999 C 78.999901 119.790009 76.719902 123.019989 73.629898 124.339996 C 69.589897 126.070007 66.629898 120.480011 65.929901 113.559998 C 65.539902 109.75 70.679901 106.940002 73.929901 107.649994 C 77.189903 108.359985 80.419899 112.279999 79.7099 116.029999 Z"
      />
      <linearGradient
        id="linearGradient490"
        x1="-1024.02"
        y1="3992.02"
        x2="-1019.88"
        y2="3977.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6304"
        fill="url(#linearGradient490)"
        stroke="none"
        d="M 88.999901 112.549988 C 89.7799 107.339996 88.439903 99.390015 97.599899 98.679993 C 100.459999 98.459991 102.769997 99.309998 104.239998 100.5 C 107.68 103.269989 105.68 110.570007 105.68 110.570007 C 105.68 110.570007 100.32 117.330017 88.999901 112.549988 Z"
      />
      <radialGradient
        id="radialGradient162"
        cx="-1040.27"
        cy="422.917"
        r="7.015918"
        fx="-1040.27"
        fy="422.917"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f9b38e" stopOpacity={1} />
        <stop offset="0.61" stopColor="#f7c59e" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6305"
        fill="url(#radialGradient162)"
        stroke="none"
        d="M 93.819901 116.080017 C 94.579903 119.290009 96.759903 125.029999 99.799896 124.540009 C 103.730003 123.910004 106.68 121.589996 106.809998 113.75 C 106.870003 110.419983 102.160004 108.040009 99.179901 108.850006 C 96.199898 109.669983 93.059898 112.859985 93.819901 116.089996 L 93.819901 116.080017 Z"
      />
      <linearGradient
        id="linearGradient491"
        x1="71.9999"
        y1="112.55"
        x2="67.9299"
        y2="112.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6306"
        fill="url(#linearGradient491)"
        stroke="none"
        d="M 70.109901 111.140015 C 71.219902 111.440002 71.989899 112.209991 71.839897 112.850006 C 71.689903 113.48999 70.669899 113.779999 69.569901 113.48999 C 68.469902 113.190002 67.689903 112.419983 67.839897 111.779999 C 67.989899 111.140015 69.009903 110.850006 70.119904 111.140015 L 70.109901 111.140015 Z"
      />
      <linearGradient
        id="linearGradient492"
        x1="103.46"
        y1="112.45"
        x2="99.3699"
        y2="112.47"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6307"
        fill="url(#linearGradient492)"
        stroke="none"
        d="M 103.32 111.26001 C 104.43 111.029999 105.419998 111.369995 105.540001 112.019989 C 105.650002 112.679993 104.849998 113.390015 103.75 113.619995 C 102.639999 113.850006 101.650002 113.51001 101.529999 112.859985 C 101.419998 112.200012 102.220001 111.48999 103.330002 111.26001 L 103.32 111.26001 Z"
      />
      <linearGradient
        id="linearGradient493"
        x1="91.9099"
        y1="124.97"
        x2="94.5999"
        y2="122.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6308"
        fill="url(#linearGradient493)"
        stroke="none"
        d="M 96.649902 121.450012 C 97.199898 121.269989 97.489899 120.830017 97.269897 120.399994 C 97.069901 120.019989 94.789902 121.649994 93.909897 122.929993 C 95.099899 122.040009 96.109901 121.630005 96.649902 121.450012 Z"
      />
      <linearGradient
        id="linearGradient494"
        x1="77.2399"
        y1="121.35"
        x2="73.19"
        y2="118.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6309"
        fill="url(#linearGradient494)"
        stroke="none"
        d="M 76.389999 121.279999 C 75.860001 121.059998 75.589996 120.600006 75.849998 120.200012 C 76.080002 119.839996 78.239899 121.630005 79.019897 122.970001 C 77.8899 122 76.919998 121.51001 76.389999 121.290009 L 76.389999 121.279999 Z"
      />
      <path
        id="path6310"
        fill="#f0c499"
        stroke="none"
        d="M 91.790001 125.73999 C 90.769997 127.950012 85.120003 131.029999 80.959999 125.679993 C 80.959999 125.679993 86.870003 128.350006 91.790001 125.73999 Z"
      />
      <path
        id="path6311"
        fill="#961b27"
        stroke="none"
        d="M 87.029999 121.970001 C 92.339996 121.910004 95.439903 121.100006 96.689903 120.839996 C 96.659897 120.899994 96.629997 120.929993 96.599998 120.98999 C 95.93 121.290009 95.169899 121.480011 94.189903 122.190002 C 93.519897 122.679993 92.860001 125.959991 86.25 125.890015 C 82.650002 125.850006 80.4599 124.600006 78.329903 122.119995 C 77.669899 121.339996 77.0299 121.109985 76.509903 120.799988 C 76.499901 120.73999 76.470001 120.709991 76.449997 120.649994 C 77.889999 121.059998 80.800003 122.049988 87.019997 121.980011 L 87.029999 121.970001 Z"
      />
      <linearGradient
        id="linearGradient495"
        x1="87.7099"
        y1="124.28"
        x2="99.6999"
        y2="124.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d8d7" stopOpacity={1} />
        <stop offset="0.14" stopColor="#efe4e4" stopOpacity={1} />
        <stop offset="0.39" stopColor="#faf8f7" stopOpacity={1} />
        <stop offset="0.57" stopColor="#ffffff" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d2d1" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6312"
        fill="url(#linearGradient495)"
        stroke="none"
        d="M 81.079903 122.549988 C 84.7799 123.390015 89.829903 123.290009 91.659897 122.950012 C 92.719902 122.480011 92.609901 123.839996 92.609901 123.839996 C 90.2799 126.230011 88.429901 125.779999 86.549896 125.830017 C 84.7099 125.880005 81.9599 125.130005 80.319901 123.660004 C 80.159897 123.220001 80.559898 122.429993 81.069901 122.540009 L 81.079903 122.540009 L 81.079903 122.549988 Z"
      />
      <linearGradient
        id="linearGradient496"
        x1="1364.22"
        y1="135.3"
        x2="1345.32"
        y2="135.12"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d8d7" stopOpacity={1} />
        <stop offset="0.04" stopColor="#ebdddc" stopOpacity={1} />
        <stop offset="0.21" stopColor="#f6f0ef" stopOpacity={1} />
        <stop offset="0.38" stopColor="#fcfbfb" stopOpacity={1} />
        <stop offset="0.57" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.69" stopColor="#fbf7f7" stopOpacity={1} />
        <stop offset="0.87" stopColor="#f1e3e3" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d2d1" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6313"
        fill="url(#linearGradient496)"
        stroke="none"
        d="M 79.439903 121.160004 C 79.439903 121.160004 80.6399 121.75 83.489899 122.059998 C 86.349899 122.369995 87.559898 122.200012 90.1399 122.070007 C 91.319901 122.01001 92.039902 121.839996 93.519897 121.480011 C 93.519897 121.480011 93.249901 121.820007 93.069901 122.220001 C 92.839897 122.73999 91.729897 124.51001 86.409897 124.440002 C 82.409897 124.380005 80.299896 122.950012 80.019897 122.080017 C 79.849899 121.559998 79.469902 121.320007 79.449898 121.149994 L 79.439903 121.149994 L 79.439903 121.160004 Z"
      />
      <path
        id="path6314"
        fill="#f86d78"
        stroke="none"
        d="M 85.899902 125.640015 C 94.019897 125.640015 91.2099 122.290009 96.599899 120.980011 C 96.569901 120.980011 95.359901 121.640015 93.929901 123.299988 C 92.359901 125.130005 91.009903 128.01001 86.449898 127.959991 C 82.349899 127.919983 80.079903 124.899994 78.769897 123.25 C 77.269897 121.350006 76.519897 120.790009 76.489899 120.790009 C 80.899902 122.01001 79.429901 125.440002 85.8899 125.649994 L 85.899902 125.640015 Z"
      />
      <linearGradient
        id="linearGradient497"
        x1="94.9599"
        y1="125.61"
        x2="81.3099"
        y2="124.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f96e7e" stopOpacity={1} />
        <stop offset="0.03" stopColor="#f9707f" stopOpacity={1} />
        <stop offset="0.25" stopColor="#fd7985" stopOpacity={1} />
        <stop offset="0.53" stopColor="#ff7d88" stopOpacity={1} />
        <stop offset="0.76" stopColor="#fd7985" stopOpacity={1} />
        <stop offset={1} stopColor="#f86d7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6315"
        fill="url(#linearGradient497)"
        stroke="none"
        d="M 90.7099 124.890015 C 91.9599 124.25 93.069901 122.880005 93.309898 122.700012 C 93.009903 123.100006 91.249901 127.429993 86.679901 127.330017 C 81.3899 127.209991 80.439903 123.640015 79.499901 122.570007 C 79.949898 123.040009 81.069901 124.320007 82.439903 124.799988 C 83.349899 125.119995 84.879898 125.48999 86.589897 125.570007 C 87.679901 125.619995 89.499901 125.399994 90.7099 124.880005 L 90.7099 124.890015 Z"
      />
      <path
        id="path6316"
        fill="#ff9aa2"
        stroke="none"
        d="M 82.599998 125.339996 C 82.529999 125.519989 83.0299 126.149994 84.109901 126.459991 C 85.499901 126.850006 86.589996 126.480011 86.669998 126.290009 C 86.739998 126.109985 84.909897 125.980011 84.359901 125.790009 C 83.829903 125.609985 82.660004 125.169983 82.599998 125.350006 L 82.599998 125.339996 Z"
      />
      <path
        id="path6317"
        fill="#961b27"
        stroke="none"
        d="M 96.519897 121.299988 C 96.199898 121.440002 95.949898 121.209991 94.679901 121.669983 C 94.679901 121.669983 96.849899 120.529999 96.989899 120.600006 C 97.089897 120.649994 96.989899 121.089996 96.519897 121.309998 L 96.519897 121.299988 Z"
      />
      <path
        id="path6318"
        fill="#961b27"
        stroke="none"
        d="M 76.489899 121.109985 C 76.809898 121.269989 77.159897 121.029999 78.2799 121.540009 C 78.2799 121.540009 76.2099 120.290009 76.039902 120.399994 C 75.949898 120.459991 76.0299 120.890015 76.489899 121.109985 Z"
      />
      <linearGradient
        id="linearGradient498"
        x1="99.2599"
        y1="122.43"
        x2="84.6299"
        y2="122.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e8d8d7" stopOpacity={1} />
        <stop offset="0.05" stopColor="#eadcdb" stopOpacity={1} />
        <stop offset="0.31" stopColor="#f6efee" stopOpacity={1} />
        <stop offset="0.48" stopColor="#fbf6f6" stopOpacity={1} />
        <stop offset={1} stopColor="#e8d2d1" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6319"
        fill="url(#linearGradient498)"
        stroke="none"
        d="M 93.399902 121.619995 L 93.049896 122.26001 C 93.049896 122.26001 90.739899 123.5 86.019897 123.48999 C 82.609901 123.480011 80.0299 122.169983 80.0299 122.169983 L 79.769897 121.540009 L 93.409897 121.630005 L 93.399902 121.619995 Z"
      />
      <path
        id="path6320"
        fill="#f86d78"
        stroke="none"
        d="M 83.469902 121.149994 C 85.049896 121.019989 85.219902 121.290009 86.359901 121.299988 C 87.4599 121.299988 88.359901 120.980011 89.719902 121.100006 C 91.499901 121.26001 93.669899 121.399994 96.259903 120.859985 C 96.259903 120.859985 95.299896 121.459991 90.539902 122.380005 C 89.119904 122.660004 87.869904 122.929993 86.409897 122.899994 C 84.659897 122.899994 83.219902 122.540009 81.869904 122.309998 C 79.579903 121.919983 76.879898 120.769989 76.869904 120.720001 C 78.089897 121.070007 81.729897 121.279999 83.469902 121.160004 L 83.469902 121.149994 Z"
      />
      <linearGradient
        id="linearGradient499"
        x1="93.8299"
        y1="121.9"
        x2="83.3599"
        y2="121.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f96e7e" stopOpacity={1} />
        <stop offset="0.03" stopColor="#f9707f" stopOpacity={1} />
        <stop offset="0.25" stopColor="#fd7985" stopOpacity={1} />
        <stop offset="0.53" stopColor="#ff7d88" stopOpacity={1} />
        <stop offset="0.76" stopColor="#fd7985" stopOpacity={1} />
        <stop offset={1} stopColor="#f86d7d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6321"
        fill="url(#linearGradient499)"
        stroke="none"
        d="M 91.599899 121.619995 C 91.549896 121.459991 89.189903 121.23999 88.799896 121.23999 C 88.409897 121.23999 87.119904 121.470001 86.649902 121.470001 C 86.179901 121.470001 84.759903 121.380005 84.369904 121.290009 C 83.979897 121.200012 81.109901 121.450012 81.129898 121.660004 C 81.159897 121.869995 85.329903 122.369995 85.819901 122.419983 C 86.309898 122.470001 91.729897 122.119995 91.589897 121.630005 L 91.599899 121.619995 Z"
      />
      <linearGradient
        id="linearGradient500"
        x1="86.6699"
        y1="129.9"
        x2="86.6299"
        y2="132.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6322"
        fill="url(#linearGradient500)"
        stroke="none"
        d="M 86.519897 130.529999 C 88.059898 130.410004 89.369904 130.789978 89.439903 131.369995 C 89.519897 131.950012 88.319901 132.51001 86.7799 132.619995 C 85.239899 132.72998 83.939903 132.359985 83.859901 131.779999 C 83.7799 131.200012 84.979897 130.640015 86.519897 130.529999 Z"
      />
      <path
        id="path6323"
        fill="#f0c499"
        stroke="none"
        d="M 105.779999 109.309998 C 105.779999 109.309998 108.160004 120.269989 100.269997 126.410004 C 96.569901 129.299988 95.509903 131.02002 93.5299 132.960022 C 93.5299 132.960022 98.439903 128.589996 101.400002 126.470001 C 102.830002 125.450012 109.910004 120.429993 105.790001 109.309998 L 105.779999 109.309998 Z"
      />
      <linearGradient
        id="linearGradient501"
        x1="86.1699"
        y1="135.07"
        x2="84.6699"
        y2="149.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6324"
        fill="url(#linearGradient501)"
        stroke="none"
        d="M 92.739899 133.660004 C 92.739899 133.660004 87.909897 140.529999 79.909897 133.359985 C 79.909897 133.359985 86.339897 138.75 92.739899 133.660004 Z"
      />
      <path
        id="path6325"
        fill="#f0c499"
        stroke="none"
        d="M 65.599899 113.080017 C 65.599899 113.080017 65.689903 102.399994 67.6399 95.240112 C 69.809898 87.220093 73.049797 80.970093 79.509804 79.520111 C 79.509804 79.520111 96.999901 74.350098 102.75 88.850098 C 108.830002 104.169983 107.519997 112.070007 107.129997 115.649994 C 107.129997 115.649994 105.720001 106.820007 103.870003 104.089996 C 103.870003 104.089996 98.299797 99.060089 94.109802 92.460083 C 85.719803 79.240112 77.329903 81.320099 74.499901 85.53009 C 69.909897 92.370117 67.899803 101.919983 65.609802 113.059998 L 65.599899 113.080017 Z"
      />
      <path
        id="path6326"
        fill="#f0c499"
        stroke="none"
        d="M 66.069901 108.630005 C 66.879898 115.269989 67.109901 120.309998 67.109901 120.309998 C 64.479897 120.309998 63.949902 117.470001 62.929901 114.959991 C 61.349899 111.130005 60.429901 107.019989 64.009903 106.799988 C 64.699898 106.76001 66.069901 108.630005 66.069901 108.630005 Z"
      />
      <linearGradient
        id="linearGradient502"
        x1="65.4399"
        y1="170.26"
        x2="65.9499"
        y2="189.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6327"
        fill="url(#linearGradient502)"
        stroke="none"
        d="M 65.599899 118.089996 C 65.599899 118.089996 64.309898 116.619995 64.699898 113.730011 C 65.6399 106.910004 61.349899 106.440002 62.319901 111.100006 C 62.319901 111.100006 62.909901 108.899994 63.4599 109.559998 C 64.129898 110.369995 62.739899 110.809998 63.4599 114.339996 C 63.829899 116.169983 65.599899 118.100006 65.599899 118.100006 L 65.599899 118.089996 Z"
      />
      <path
        id="path6328"
        fill="#f7d4ab"
        stroke="none"
        d="M 74.4599 98.020111 C 74.4599 98.020111 71.919899 96.900085 67.9599 99.410095 C 65.649902 100.869995 67.099899 107.399994 67.099899 107.399994 C 67.099899 107.399994 66.649902 99.110107 74.449898 98.020111 L 74.4599 98.020111 Z"
      />
      <linearGradient
        id="linearGradient503"
        x1="66.2999"
        y1="105.17"
        x2="69.8799"
        y2="146.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a3753d" stopOpacity={1} />
        <stop offset={1} stopColor="#e0b163" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6329"
        fill="url(#linearGradient503)"
        stroke="none"
        d="M 66.899902 98.100098 C 66.899902 98.100098 66.219902 108.649994 65.699898 111.169983 L 65.299896 107.390015 C 65.299896 107.390015 66.319901 99.420105 66.909897 98.100098 L 66.899902 98.100098 Z"
      />
      <linearGradient
        id="linearGradient504"
        x1="105.71"
        y1="116.92"
        x2="110.29"
        y2="80.69"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a3753d" stopOpacity={1} />
        <stop offset={1} stopColor="#e0b163" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6330"
        fill="url(#linearGradient504)"
        stroke="none"
        d="M 106.620003 100.25 C 106.620003 100.25 106.940002 108.200012 107.639999 111.169983 L 108.279999 105.820007 L 106.620003 100.25 Z"
      />
      <linearGradient
        id="linearGradient505"
        x1="104.4"
        y1="31.7399"
        x2="98.0299"
        y2="111.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#a3753d" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6331"
        fill="url(#linearGradient505)"
        stroke="none"
        d="M 116.290001 88.159912 C 105.629997 65.109894 85.719902 63.899902 78.119904 71.339905 C 77.699898 73.71991 76.839897 77.289917 80.919899 80.549896 C 90.079903 73.259888 94.789902 92.4599 102.830002 97.269897 C 108.739998 100.809998 111.779999 109.910004 120.389999 120.720001 C 122.839996 106.070007 118.290001 92.44989 116.309998 88.169891 L 116.300003 88.169891 L 116.290001 88.159912 Z"
      />
      <linearGradient
        id="linearGradient506"
        x1="118.41"
        y1="89.62"
        x2="83.2599"
        y2="95.34"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#f4c381" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6332"
        fill="url(#linearGradient506)"
        stroke="none"
        d="M 120.019997 111.339996 C 119.379997 106.100006 118.190002 96.98999 106.199997 83.269989 C 100.419998 76.720001 92.879898 71.98999 86.619904 72.809998 C 83.569901 73.160004 81.539902 74.779999 80.5299 75.98999 C 79.469902 77.200012 78.839897 78.100006 78.809898 78.119995 C 78.9599 78.019989 81.969902 75.119995 86.619904 75.959991 C 91.179901 76.700012 96.429901 81.470001 101.660004 87.279999 C 112.099998 98.779999 120.220001 111.049988 120.029999 111.330017 L 120.019997 111.339996 Z"
      />
      <linearGradient
        id="linearGradient507"
        x1="47.8199"
        y1="106.78"
        x2="70.3399"
        y2="81.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#f4c381" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6333"
        fill="url(#linearGradient507)"
        stroke="none"
        d="M 57.5299 94.589996 C 57.5299 94.669983 60.759899 88.690002 66.5299 82.580017 C 69.359901 79.589996 72.399902 77.51001 74.919899 77.290009 C 77.429901 77.019989 78.729897 78.070007 78.819901 78.130005 C 78.7099 78.019989 77.789902 76.529999 74.919899 76.230011 C 72.059898 75.899994 68.299896 77.809998 65.369904 80.869995 C 59.439899 87 57.539902 94.630005 57.539902 94.589996 L 57.5299 94.589996 Z"
      />
      <linearGradient
        id="linearGradient508"
        x1="120.69"
        y1="86.07"
        x2="55.3699"
        y2="86.07"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#e0b163" stopOpacity={1} />
        <stop offset={1} stopColor="#f4c381" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6334"
        fill="url(#linearGradient508)"
        stroke="none"
        d="M 78.419899 70.929993 C 78.419899 70.929993 71.369904 69.970001 63.969898 76.549988 C 58.759899 81.179993 55.539902 89.98999 55.289902 99.26001 C 55.289902 99.26001 57.219898 85.940002 64.349899 78.339996 C 68.309898 74.109985 75.489899 71.230011 78.4599 71.649994 C 78.4599 71.649994 86.399902 66.919983 96.859901 70.029999 C 105.650002 72.630005 116.970001 81.540009 120.68 105.100006 C 120.68 105.100006 117.769997 68.410004 89.679901 67.049988 C 82.549896 66.709991 78.419899 70.929993 78.419899 70.929993 L 78.409897 70.929993 L 78.419899 70.929993 Z"
      />
      <linearGradient
        id="linearGradient509"
        x1="74.4599"
        y1="119.86"
        x2="65.0299"
        y2="121.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6335"
        fill="url(#linearGradient509)"
        stroke="none"
        d="M 65.759903 111.630005 C 65.759903 111.630005 66.619904 108.649994 68.559898 107.700012 C 64.089897 114.580017 68.759903 122.149994 72.379898 125.640015 C 76.369904 129.48999 78.019897 131.679993 78.659897 132.330017 C 78.089897 131.789978 72.769897 126.809998 71.249901 125.660004 C 69.839897 124.600006 64.419899 118.850006 65.769897 111.640015 L 65.759903 111.630005 Z"
      />
      <linearGradient
        id="linearGradient510"
        x1="80.6699"
        y1="99.11"
        x2="67.3299"
        y2="99.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#956134" stopOpacity={1} />
        <stop offset="0.34" stopColor="#80552b" stopOpacity={1} />
        <stop offset="0.68" stopColor="#744d26" stopOpacity={1} />
        <stop offset={1} stopColor="#704b25" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6336"
        fill="url(#linearGradient510)"
        stroke="none"
        d="M 78.609901 98.549988 C 80.219902 99.309998 81.379898 101.450012 79.969902 100.98999 C 78.569901 100.519989 73.409897 98.549988 72.2799 98.529999 C 70.5299 98.48999 67.939903 99.419983 67.259903 99.839996 C 67.259903 99.839996 70.3899 97.390015 72.329903 97.190002 C 74.249901 96.98999 77.749901 98.149994 78.609901 98.549988 Z"
      />
      <linearGradient
        id="linearGradient511"
        x1="106.15"
        y1="99.05"
        x2="92.7299"
        y2="99.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#704b25" stopOpacity={1} />
        <stop offset="0.32" stopColor="#744d26" stopOpacity={1} />
        <stop offset="0.66" stopColor="#80552b" stopOpacity={1} />
        <stop offset={1} stopColor="#956134" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6337"
        fill="url(#linearGradient511)"
        stroke="none"
        d="M 94.569901 98.540009 C 95.4599 98.169983 99.269897 97.01001 101.18 97.299988 C 103.099998 97.600006 106.110001 100.220001 106.110001 100.220001 C 105.449997 99.76001 102.75 98.589996 101.160004 98.630005 C 100.029999 98.660004 94.7799 100.369995 93.369904 100.769989 C 91.949898 101.169983 92.929901 99.230011 94.569901 98.540009 Z"
      />
      <linearGradient
        id="linearGradient512"
        x1="93.0499"
        y1="104.33"
        x2="103.49"
        y2="108.55"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.51" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#dba379" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6338"
        fill="url(#linearGradient512)"
        stroke="none"
        d="M 99.319901 102.140015 C 100.879997 102.269989 104.199997 102.839996 104.150002 105.799988 C 104.089996 109.540009 100.239998 110.429993 98.509903 110.440002 C 96.319901 110.459991 94.789902 109.820007 93.499901 109.410004 C 92.539902 109.109985 92.0299 109.019989 91.5299 108.910004 C 91.669899 106.040009 92.849899 102.130005 99.309898 102.130005 L 99.319901 102.140015 Z"
      />
      <linearGradient
        id="linearGradient513"
        x1="95.62"
        y1="107.03"
        x2="91.97"
        y2="107.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.47" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.77" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e7" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6339"
        fill="url(#linearGradient513)"
        stroke="none"
        d="M 95.489998 104.399994 C 94.830002 105.01001 94.07 106.109985 94.019997 107.130005 C 93.959999 108.299988 94.400002 108.940002 95.169998 109.649994 C 94.190002 109.380005 93.25 108.890015 91.839996 108.690002 C 91.839996 108.690002 93.199997 105.769989 95.5 104.399994 L 95.489998 104.399994 Z"
      />
      <path
        id="path6340"
        fill="#dddddd"
        stroke="none"
        d="M 95.300003 104.820007 C 94.660004 105.309998 94.220001 106.01001 94.080002 106.799988 C 92.949997 107.470001 92.239998 108.279999 91.839996 108.679993 C 91.839996 108.679993 93.209999 105.839996 95.309998 104.820007 L 95.300003 104.820007 Z"
      />
      <linearGradient
        id="linearGradient514"
        x1="102.29"
        y1="106.91"
        x2="99.2499"
        y2="106.91"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.47" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.77" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e7" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6341"
        fill="url(#linearGradient514)"
        stroke="none"
        d="M 98.159897 103.809998 C 99.749901 103.950012 101.68 104.769989 104.019997 106.720001 C 104.019997 106.720001 102.690002 109.519989 98.919899 110.019989 C 99.809898 109.429993 100.440002 108.669983 100.5 107.450012 C 100.580002 105.769989 99.589897 104.290009 98.169899 103.799988 L 98.159897 103.809998 Z"
      />
      <linearGradient
        id="linearGradient515"
        x1="92.1599"
        y1="111.71"
        x2="100.77"
        y2="105.35"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6342"
        fill="url(#linearGradient515)"
        stroke="none"
        d="M 94.079903 106.720001 C 96.319901 105.190002 98.739899 105.179993 100.580002 105.809998 C 100.830002 106.330017 100.949997 106.910004 100.919998 107.519989 C 100.849998 108.690002 100.18 109.429993 99.259903 110.01001 C 97.819901 110.25 95.449898 109.769989 95.179901 109.640015 C 94.379898 108.959991 93.939903 108.25 94.0299 107.119995 C 94.039902 106.959991 94.059898 106.859985 94.089897 106.720001 L 94.079903 106.720001 Z"
      />
      <path
        id="path6343"
        fill="#dddddd"
        stroke="none"
        d="M 103.410004 106.809998 L 102.959999 107.640015 C 102.959999 107.640015 102.099998 106.919983 100.769997 106.359985 C 100.519997 105.580017 99.969902 104.919983 99.239899 104.519989 C 100.919998 104.839996 102.489998 105.640015 103.410004 106.809998 Z"
      />
      <linearGradient
        id="linearGradient516"
        x1="85.6999"
        y1="112.47"
        x2="94.6399"
        y2="107.49"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6344"
        fill="url(#linearGradient516)"
        stroke="none"
        d="M 95.299896 104.820007 C 95.579903 104.679993 95.8899 104.570007 96.199898 104.51001 C 97.179901 104.309998 98.219902 104.330017 99.239899 104.519989 C 99.9599 104.919983 100.559998 105.570007 100.790001 106.369995 C 99.809898 105.959991 98.579903 105.630005 97.269897 105.76001 C 95.9599 105.890015 94.8899 106.299988 94.059898 106.809998 C 94.179901 106.019989 94.659897 105.330017 95.299896 104.830017 L 95.299896 104.820007 Z"
      />
      <radialGradient
        id="radialGradient163"
        cx="97.6141"
        cy="113.252"
        r="2.4941"
        fx="97.6141"
        fy="113.252"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3a3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2727" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6345"
        fill="url(#radialGradient163)"
        stroke="none"
        d="M 97.569901 104.73999 C 98.759903 104.830017 99.659897 105.839996 99.579903 107.01001 C 99.489899 108.169983 98.449898 109.049988 97.259903 108.950012 C 96.069901 108.859985 95.169899 107.850006 95.259903 106.679993 C 95.339897 105.519989 96.3899 104.640015 97.579903 104.73999 L 97.569901 104.73999 Z"
      />
      <path
        id="path6346"
        fill="#ffffff"
        stroke="none"
        d="M 96.970001 106.029999 C 97.260002 105.880005 97.620003 106.01001 97.769997 106.309998 C 97.919998 106.619995 97.800003 106.98999 97.510002 107.140015 C 97.220001 107.290009 96.860001 107.160004 96.709999 106.850006 C 96.559998 106.540009 96.68 106.169983 96.970001 106.019989 L 96.970001 106.029999 Z"
      />
      <path
        id="path6347"
        fill="#ffffff"
        stroke="none"
        d="M 94.979897 106.859985 C 95.379898 106.649994 95.879997 106.820007 96.07 107.220001 C 96.269997 107.619995 96.099998 108.109985 95.699997 108.309998 C 95.300003 108.51001 94.809998 108.350006 94.599998 107.940002 C 94.400002 107.540009 94.569901 107.049988 94.969902 106.859985 L 94.979897 106.859985 Z"
      />
      <linearGradient
        id="linearGradient517"
        x1="105.6"
        y1="106.61"
        x2="91.97"
        y2="106.61"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#391b13" stopOpacity={1} />
        <stop offset="0.34" stopColor="#3d1c14" stopOpacity={1} />
        <stop offset="0.71" stopColor="#492219" stopOpacity={1} />
        <stop offset={1} stopColor="#5a2a1f" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6348"
        fill="url(#linearGradient517)"
        stroke="none"
        d="M 101.639999 103.929993 C 103.660004 104.950012 105.440002 104.070007 105.470001 104.049988 C 105.459999 104.130005 105.730003 106.429993 104.080002 107.01001 C 104.080002 107.040009 104.059998 107.130005 104.019997 107.25 C 104.739998 107.190002 104.93 107.589996 105.120003 107.799988 C 105.120003 107.809998 104.440002 107.429993 102.949997 108.529999 C 101.980003 109.23999 100.440002 110.019989 98.830002 110.070007 C 101.019997 109.220001 102.080002 108.700012 103.220001 106.919983 C 101.440002 105.399994 99.300003 104.809998 97.199997 104.929993 C 94.150002 105.100006 91.839996 108.690002 91.839996 108.690002 C 92.830002 104.790009 95.900002 101.609985 101.650002 103.940002 L 101.639999 103.929993 Z"
      />
      <linearGradient
        id="linearGradient518"
        x1="98.1699"
        y1="102.39"
        x2="92.2199"
        y2="111.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6349"
        fill="url(#linearGradient518)"
        stroke="none"
        d="M 95.929901 102.470001 C 98.039902 101.73999 100.150002 102.070007 101.75 102.640015 C 101.75 102.640015 98.349899 102 96.069901 102.869995 C 93.7799 103.75 92.849899 104.720001 92.849899 104.720001 C 92.849899 104.720001 93.829803 103.190002 95.939796 102.459991 L 95.929901 102.470001 Z"
      />
      <path
        id="path6350"
        fill="#391b13"
        stroke="none"
        d="M 96.789803 104.600006 C 101.739998 104.089996 103.230003 106.910004 103.230003 106.910004 C 102.010002 105.940002 99.759903 104.669983 96.949898 104.940002 C 94.1399 105.209991 91.849899 108.679993 91.849899 108.679993 C 91.849899 108.679993 93.0998 104.970001 96.789803 104.589996 L 96.789803 104.600006 Z"
      />
      <linearGradient
        id="linearGradient519"
        x1="86.5899"
        y1="120.43"
        x2="86.6299"
        y2="117.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f5d1a8" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f2c99f" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6351"
        fill="url(#linearGradient519)"
        stroke="none"
        d="M 90.689903 117.26001 C 90.689903 117.26001 87.269897 119.559998 86.509903 119.459991 C 85.749901 119.359985 82.569901 117.26001 82.569901 117.26001 L 90.689903 117.26001 Z"
      />
      <linearGradient
        id="linearGradient520"
        x1="86.4999"
        y1="117.14"
        x2="86.5899"
        y2="110.84"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6352"
        fill="url(#linearGradient520)"
        stroke="none"
        d="M 86.609901 113.839996 C 88.769897 113.899994 89.379898 114.450012 89.2099 115.029999 C 88.819901 116.440002 87.909897 116.709991 86.559898 116.700012 C 85.1399 116.700012 84.039902 116.380005 83.819901 114.859985 C 83.759903 114.410004 84.439903 113.779999 86.599899 113.839996 L 86.609901 113.839996 Z"
      />
      <linearGradient
        id="linearGradient521"
        x1="82.43"
        y1="116.61"
        x2="85.1"
        y2="117.99"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6353"
        fill="url(#linearGradient521)"
        stroke="none"
        d="M 85.160004 117.630005 C 85.160004 117.630005 82.910004 115.929993 82.480003 116.380005 C 81.199997 117.700012 85.160004 117.630005 85.160004 117.630005 Z"
      />
      <linearGradient
        id="linearGradient522"
        x1="90.7899"
        y1="116.72"
        x2="87.9199"
        y2="117.93"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6354"
        fill="url(#linearGradient522)"
        stroke="none"
        d="M 87.819901 117.630005 C 87.819901 117.630005 90.2099 116.160004 90.669899 116.559998 C 91.989899 117.690002 87.819901 117.630005 87.819901 117.630005 Z"
      />
      <path
        id="path6355"
        fill="#f0c499"
        stroke="none"
        d="M 90.689903 117.26001 C 90.689903 117.26001 90.919899 116.669983 90.019897 116.73999 C 89.369904 116.779999 88.849899 118.179993 86.5299 118.109985 C 84.049896 118.040009 83.7099 116.790009 83.079903 116.75 C 82.499901 116.720001 82.559898 117.269989 82.559898 117.269989 C 82.559898 117.269989 81.3899 116.660004 81.829903 116.119995 C 82.6399 115.119995 82.879898 117.169983 86.579903 117.119995 C 90.589897 117.059998 91.049896 115.080017 91.599899 116.350006 C 91.829903 116.869995 91.399902 117.019989 90.689903 117.279999 L 90.689903 117.26001 Z"
      />
      <linearGradient
        id="linearGradient523"
        x1="69.9199"
        y1="104.01"
        x2="81.9399"
        y2="108.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6356"
        fill="url(#linearGradient523)"
        stroke="none"
        d="M 74.129898 101.919983 C 80.599899 101.919983 81.769897 105.809998 81.909897 108.700012 C 81.419899 108.809998 80.909897 108.910004 79.939903 109.200012 C 78.6399 109.600006 77.119904 110.25 74.929901 110.230011 C 73.199898 110.220001 69.339897 109.320007 69.289902 105.589996 C 69.249901 102.630005 72.559898 102.059998 74.119904 101.929993 L 74.129898 101.919983 Z"
      />
      <linearGradient
        id="linearGradient524"
        x1="81.74"
        y1="106.8"
        x2="78.09"
        y2="106.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.47" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.77" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e7" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6357"
        fill="url(#linearGradient524)"
        stroke="none"
        d="M 81.610001 108.459991 C 80.199997 108.669983 79.260002 109.149994 78.279999 109.419983 C 79.040001 108.709991 79.480003 108.070007 79.43 106.899994 C 79.370003 105.890015 78.610001 104.779999 77.959999 104.169983 C 80.239998 105.529999 81.620003 108.459991 81.620003 108.459991 L 81.610001 108.459991 Z"
      />
      <path
        id="path6358"
        fill="#dddddd"
        stroke="none"
        d="M 81.609901 108.459991 C 81.2099 108.059998 80.479897 107.25 79.369904 106.580017 C 79.219902 105.790009 78.7799 105.100006 78.149902 104.600006 C 80.239899 105.619995 81.619904 108.459991 81.619904 108.459991 L 81.609901 108.459991 Z"
      />
      <linearGradient
        id="linearGradient525"
        x1="73.5799"
        y1="106.7"
        x2="70.5499"
        y2="106.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffffff" stopOpacity={1} />
        <stop offset="0.47" stopColor="#fcfcfc" stopOpacity={1} />
        <stop offset="0.77" stopColor="#f5f3f3" stopOpacity={1} />
        <stop offset={1} stopColor="#ece7e7" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6359"
        fill="url(#linearGradient525)"
        stroke="none"
        d="M 72.949898 107.230011 C 73.009903 108.450012 73.6399 109.209991 74.5299 109.799988 C 70.759903 109.309998 69.429901 106.5 69.429901 106.5 C 71.759903 104.549988 73.689903 103.730011 75.289902 103.589996 C 73.869904 104.070007 72.869904 105.559998 72.9599 107.23999 L 72.949898 107.230011 Z"
      />
      <linearGradient
        id="linearGradient526"
        x1="71.7899"
        y1="109.98"
        x2="80.1899"
        y2="104.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6360"
        fill="url(#linearGradient526)"
        stroke="none"
        d="M 79.369904 106.48999 C 79.399902 106.630005 79.409897 106.73999 79.429901 106.890015 C 79.509903 108.019989 79.079903 108.720001 78.2799 109.410004 C 78.019897 109.540009 75.649902 110.029999 74.199898 109.779999 C 73.269897 109.200012 72.609901 108.480011 72.539902 107.299988 C 72.509903 106.690002 72.629898 106.100006 72.879898 105.589996 C 74.7099 104.950012 77.129898 104.970001 79.379898 106.5 L 79.369904 106.48999 Z"
      />
      <path
        id="path6361"
        fill="#dddddd"
        stroke="none"
        d="M 74.199898 104.299988 C 73.479897 104.700012 72.929901 105.359985 72.669899 106.140015 C 71.349899 106.690002 70.479897 107.419983 70.479897 107.419983 L 70.0299 106.589996 C 70.949898 105.419983 72.519897 104.619995 74.199898 104.299988 Z"
      />
      <linearGradient
        id="linearGradient527"
        x1="64.6999"
        y1="106.93"
        x2="75.7499"
        y2="105.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#b89c8c" stopOpacity={1} />
        <stop offset={1} stopColor="#715241" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6362"
        fill="url(#linearGradient527)"
        stroke="none"
        d="M 74.199898 104.299988 C 75.2099 104.100006 76.269897 104.100006 77.239899 104.290009 C 77.559898 104.350006 77.849899 104.459991 78.1399 104.600006 C 78.7799 105.089996 79.259903 105.779999 79.379898 106.580017 C 78.549896 106.089996 77.479897 105.660004 76.169899 105.529999 C 74.859901 105.399994 73.629898 105.73999 72.649902 106.140015 C 72.879898 105.350006 73.469902 104.700012 74.199898 104.290009 L 74.199898 104.299988 Z"
      />
      <radialGradient
        id="radialGradient164"
        cx="76.1756"
        cy="112.987"
        r="2.4941"
        fx="76.1756"
        fy="112.987"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2a3a3b" stopOpacity={1} />
        <stop offset={1} stopColor="#1c2727" stopOpacity={1} />
      </radialGradient>
      <path
        id="path6363"
        fill="url(#radialGradient164)"
        stroke="none"
        d="M 75.879898 104.51001 C 77.069901 104.419983 78.119904 105.290009 78.199898 106.450012 C 78.289902 107.609985 77.3899 108.630005 76.199898 108.720001 C 75.009903 108.809998 73.9599 107.940002 73.879898 106.779999 C 73.789902 105.619995 74.689903 104.600006 75.8899 104.51001 L 75.879898 104.51001 Z"
      />
      <path
        id="path6364"
        fill="#ffffff"
        stroke="none"
        d="M 75.509903 105.75 C 75.789902 105.589996 76.169899 105.690002 76.339897 105.980011 C 76.519897 106.279999 76.429901 106.649994 76.149902 106.809998 C 75.869904 106.970001 75.489998 106.869995 75.32 106.580017 C 75.139999 106.279999 75.229897 105.919983 75.519897 105.75 L 75.509903 105.75 Z"
      />
      <path
        id="path6365"
        fill="#ffffff"
        stroke="none"
        d="M 73.549896 106.640015 C 73.939903 106.410004 74.439903 106.540009 74.649902 106.919983 C 74.879898 107.309998 74.739899 107.809998 74.349899 108.040009 C 73.9599 108.269989 73.4599 108.140015 73.249901 107.76001 C 73.019897 107.380005 73.159897 106.869995 73.549896 106.640015 Z"
      />
      <linearGradient
        id="linearGradient528"
        x1="81.7399"
        y1="106.37"
        x2="68.0999"
        y2="106.37"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#5a2a1f" stopOpacity={1} />
        <stop offset="0.29" stopColor="#492219" stopOpacity={1} />
        <stop offset="0.66" stopColor="#3d1c14" stopOpacity={1} />
        <stop offset={1} stopColor="#391b13" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6366"
        fill="url(#linearGradient528)"
        stroke="none"
        d="M 67.979897 103.820007 C 67.979897 103.820007 69.799896 104.730011 71.809898 103.700012 C 77.559898 101.359985 80.629898 104.540009 81.619904 108.450012 C 81.619904 108.450012 79.299896 104.859985 76.259903 104.690002 C 74.149902 104.570007 72.019897 105.160004 70.239899 106.679993 C 71.379898 108.459991 72.439903 108.980011 74.629898 109.830017 C 73.0299 109.769989 71.469902 108.98999 70.509903 108.290009 C 69.019897 107.200012 68.339897 107.580017 68.339897 107.559998 C 68.539902 107.359985 68.719902 106.959991 69.439903 107.01001 C 69.409897 106.880005 69.3899 106.799988 69.379898 106.769989 C 67.719902 106.179993 68.009903 103.899994 67.989899 103.809998 L 67.979897 103.820007 Z"
      />
      <linearGradient
        id="linearGradient529"
        x1="75.61"
        y1="102.74"
        x2="84.36"
        y2="114.32"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6367"
        fill="url(#linearGradient529)"
        stroke="none"
        d="M 77.519997 102.23999 C 79.620003 102.970001 80.610001 104.5 80.610001 104.5 C 80.610001 104.5 79.68 103.529999 77.389999 102.649994 C 75.099998 101.769989 71.709999 102.419983 71.709999 102.419983 C 73.309998 101.859985 75.419998 101.529999 77.529999 102.25 L 77.519997 102.23999 Z"
      />
      <path
        id="path6368"
        fill="#391b13"
        stroke="none"
        d="M 76.660004 104.369995 C 80.349998 104.75 81.599998 108.459991 81.599998 108.459991 C 81.599998 108.459991 79.300003 104.98999 76.5 104.720001 C 73.690002 104.450012 71.449997 105.720001 70.220001 106.690002 C 70.220001 106.690002 71.699997 103.869995 76.650002 104.380005 L 76.660004 104.369995 Z"
      />
      <path
        id="path6369"
        fill="#ffffff"
        stroke="none"
        d="M 80.539902 179.830017 C 81.849899 185.940002 84.689903 192.960022 90.909897 197.309998 C 88.989899 196.76001 87.189903 195.779999 85.539902 194.359985 C 82.449898 191.720001 80.7099 188.350006 80.329903 184.27002 C 80.179901 182.72998 80.249901 181.23999 80.5299 179.830017 L 80.539902 179.830017 Z"
      />
      <path
        id="path6370"
        fill="#ffffff"
        stroke="none"
        d="M 103.779999 170.080017 C 100.830002 169.419983 98.239899 168.48999 96.119904 167.330017 C 98.909897 167.460022 101.459999 168.369995 103.779999 170.080017 Z"
      />
      <path
        id="path6371"
        fill="#ffffff"
        stroke="none"
        d="M 91.2099 167.73999 C 89.449898 169.179993 87.229897 170.48999 84.649902 171.640015 C 86.499901 169.690002 88.689903 168.399994 91.2099 167.73999 Z"
      />
      <path
        id="path6372"
        fill="#ffffff"
        stroke="none"
        d="M 108.830002 176.220001 C 109.5 177.710022 109.93 179.330017 110.089996 181.100006 C 110.470001 185.190002 109.379997 188.809998 106.82 191.97998 C 105.330002 193.820007 103.589996 195.179993 101.629997 196.080017 C 107.279999 190.47998 108.739998 182.640015 108.830002 176.210022 L 108.830002 176.220001 Z"
      />
      <path
        id="path6373"
        fill="#ffffff"
        stroke="none"
        d="M 82.069901 179.589996 C 81.669899 177.75 81.419899 176 81.269897 174.470001 C 82.849899 173.98999 84.299896 173.419983 85.679901 172.820007 C 88.019897 171.779999 90.039902 170.580017 91.659897 169.27002 C 92.319901 168.72998 92.929901 168.179993 93.439903 167.600006 L 93.719902 167.570007 C 94.309898 168.02002 94.989899 168.440002 95.719902 168.839996 C 97.649902 169.899994 100.010002 170.75 102.699997 171.350006 C 104.040001 171.649994 105.449997 171.890015 106.940002 172.049988 C 107.050003 173.440002 107.129997 175.02002 107.099998 176.710022 C 107.019997 182.570007 105.68 189.700012 100.540001 194.799988 C 99.359901 195.970001 97.999901 197.059998 96.369904 197.960022 C 94.5299 197.339996 92.929901 196.47998 91.509903 195.48999 C 85.829903 191.529999 83.249901 185.140015 82.059898 179.580017 L 82.069901 179.589996 Z M 92.019897 192.559998 C 92.699898 193.049988 93.419899 193.470001 94.169899 193.850006 C 94.569901 194.049988 94.979897 194.220001 95.3899 194.380005 C 95.579903 194.460022 95.859901 194.609985 96.069901 194.600006 C 96.259903 194.580017 96.509903 194.369995 96.669899 194.279999 C 98.099899 193.399994 99.409897 192.279999 100.470001 190.970001 C 100.669998 190.720001 100.870003 190.470001 101.050003 190.210022 C 102.639999 187.970001 103.589996 185.320007 104.059998 182.619995 C 104.209999 181.73999 104.32 180.859985 104.379997 179.970001 C 104.5 178.220001 104.470001 176.450012 104.32 174.690002 C 104.309998 174.559998 104.209999 174.440002 104.080002 174.429993 C 103.120003 174.320007 102.160004 174.169983 101.220001 173.970001 C 100.5 173.820007 99.799896 173.649994 99.099899 173.429993 C 98.449898 173.22998 97.809898 173 97.179901 172.75 C 97.089897 172.720001 96.999901 172.679993 96.919899 172.640015 C 96.319901 172.380005 95.729897 172.080017 95.159897 171.72998 C 94.909897 171.580017 94.659897 171.410004 94.419899 171.23999 C 94.2799 171.140015 94.169899 171.029999 93.999901 171.029999 C 93.939903 171.029999 93.859901 171.039978 93.799896 171.049988 C 93.7099 171.049988 93.649902 171.100006 93.599899 171.149994 C 93.169899 171.630005 92.689903 172.070007 92.179901 172.470001 C 89.939903 174.25 87.239899 175.410004 84.5299 176.25 C 84.409897 176.279999 84.329903 176.429993 84.339897 176.549988 C 84.369904 176.830017 84.399902 177.100006 84.429901 177.380005 C 84.649902 179.160004 84.989899 180.940002 85.499901 182.660004 C 85.759903 183.559998 86.069901 184.440002 86.439903 185.289978 C 87.289902 187.289978 88.449898 189.169983 89.939903 190.73999 C 90.579903 191.410004 91.269897 192.02002 92.0299 192.559998 L 92.019897 192.559998 Z"
      />
      <path
        id="path6374"
        fill="#f7d4ab"
        stroke="none"
        d="M 115.089996 148.47998 C 115.089996 148.47998 118.669998 150.570007 121.559998 154.52002 C 125.470001 159.859985 145.899994 196.669983 146.080002 197 C 147.029999 198.72998 143.740005 217.52002 140.330002 218.200012 C 136.910004 218.869995 110.93 181.48999 106.379997 163.47998 C 101.43 143.910004 115.099998 148.47998 115.099998 148.47998 L 115.089996 148.47998 Z"
      />
      <linearGradient
        id="linearGradient530"
        x1="170.29"
        y1="187.55"
        x2="151.47"
        y2="197.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6375"
        fill="url(#linearGradient530)"
        stroke="none"
        d="M 145.970001 196.76001 C 145.970001 196.76001 139.649994 211.52002 162.880005 194.690002 L 145.970001 196.76001 Z"
      />
      <linearGradient
        id="linearGradient531"
        x1="126.67"
        y1="297.21"
        x2="120.81"
        y2="159.36"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6376"
        fill="url(#linearGradient531)"
        stroke="none"
        d="M 124.300003 171.350006 C 124.300003 171.350006 122.309998 166.859985 117.730003 156.929993 C 117.519997 156.47998 122.629997 174.359985 122.629997 174.359985 L 124.300003 171.339996 L 124.300003 171.350006 Z"
      />
      <path
        id="path6377"
        fill="#f7d4ab"
        stroke="none"
        d="M 49.929901 182.619995 C 51.169899 183.330017 51.659901 184.149994 52.569901 185.279999 C 54.539902 187.710022 59.059898 186.200012 60.309898 181.380005 C 61.249901 177.76001 60.669899 156.799988 54.1399 152.070007 C 54.1399 152.070007 49.769901 152.779999 46.769901 154.77002 C 38.399899 160.339996 20.3099 183.789978 19.1399 185.149994 C 17.9699 186.51001 0.039936 206.070007 1.21994 213.669983 C 2.04994 219.01001 17.999901 227.589996 21.8599 230.460022 C 25.7099 233.330017 47.589901 245.520004 47.589901 245.520004 L 50.649899 237.619995 C 50.649899 237.619995 29.1999 220.669983 21.659901 209.440002 C 21.659901 209.440002 47.019901 185.919983 49.949902 182.609985 L 49.939899 182.609985 L 49.929901 182.619995 Z"
      />
      <linearGradient
        id="linearGradient532"
        x1="99.91"
        y1="145.18"
        x2="48.74"
        y2="171.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6378"
        fill="url(#linearGradient532)"
        stroke="none"
        d="M 100.330002 145.48999 C 100.330002 145.48999 101.970001 152.029999 89.730003 153.119995 C 73.519997 154.559998 70.459999 147.52002 70.459999 147.52002 L 58.959999 150.410004 C 58.959999 150.410004 75.120003 165.289978 92.620003 162.660004 C 110.120003 160.029999 113.57 148.029999 113.57 148.029999 L 100.339996 145.5 L 100.330002 145.48999 Z"
      />
      <path
        id="path6379"
        fill="#27ae60"
        stroke="none"
        d="M 54.339901 260.630005 C 61.149899 240.300003 66.179901 227.880005 66.879898 225.710022 C 67.859901 222.619995 67.299896 212.950012 65.659897 209.22998 C 63.879902 205.210022 54.649899 188.700012 54.649899 188.700012 L 55.1199 182 C 57.399899 161.76001 51.249901 154.350006 48.559898 153.539978 C 55.419899 150.859985 69.929901 147.679993 69.929901 147.679993 C 72.739899 153.559998 81.449898 154.799988 90.869904 153.859985 C 103.440002 152.619995 101.029999 145.380005 101.029999 145.380005 L 116.93 149.51001 C 120.080002 158.160004 119.18 158.950012 120.93 167.140015 C 122.610001 174.970001 124.43 180.410004 124.650002 187.350006 C 124.839996 193.380005 116.949997 201.109985 116.599998 215.589996 C 116.279999 228.799988 120.660004 242.899994 125.870003 262.519989 C 120.239998 267.01001 82.4599 271.01001 54.319901 260.619995 L 54.329899 260.619995 L 54.339901 260.630005 Z"
      />
      <path
        id="path6380"
        fill="#27ae60"
        stroke="none"
        d="M 122.769997 174.859985 C 122.769997 174.859985 127.690002 190.049988 111.860001 191.460022 C 100.18 192.51001 74.329903 197.899994 56.269901 172.850006 C 56.269901 172.850006 56.969898 175.869995 54.859901 181.77002 C 60.7099 194.149994 80.169899 210.640015 60.1199 242.539993 C 101.400002 225.289978 117.269997 228.23999 117.800003 227.529999 C 117.620003 225.48999 114.559998 212.080017 120.400002 201.169983 C 128.229996 186.539978 122.779999 174.839996 122.779999 174.839996 L 122.769997 174.859985 Z"
      />
      <linearGradient
        id="linearGradient533"
        x1="66.6799"
        y1="292.82"
        x2="61.7299"
        y2="176.11"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6381"
        fill="url(#linearGradient533)"
        stroke="none"
        d="M 56.009899 171.289978 C 56.009899 171.289978 56.759899 182.380005 51.559898 184.27002 C 51.559898 184.27002 58.149899 192.140015 65.669899 210 C 66.429901 211.799988 67.769897 221.289978 66.849899 224.380005 C 65.929901 227.470001 62.269901 236.26001 55.849899 256.100006 C 57.839901 251.970001 71.219902 221.390015 73.369904 217.059998 C 75.019897 213.75 72.1399 203.580017 67.799896 196.160004 C 63.469898 188.72998 57.769901 179.140015 55.9799 171.279999 L 55.989899 171.279999 L 56.009899 171.289978 Z"
      />
      <path
        id="path6382"
        fill="#34b769"
        stroke="none"
        d="M 103.769997 164.089996 C 98.249901 163 80.969902 162.51001 75.859901 166.600006 C 70.749901 170.690002 68.009903 179.98999 79.669899 180.869995 C 87.599899 181.470001 101.970001 182.039978 114.040001 179.559998 C 122.379997 177.839996 118.800003 167.070007 103.769997 164.089996 Z"
      />
      <path
        id="path6383"
        fill="#27ae60"
        stroke="none"
        d="M 119.900002 161.630005 C 119.900002 161.630005 124.410004 179.26001 124.699997 180.690002 C 125.029999 182.289978 126.809998 185.899994 123.169998 196.600006 C 120.230003 205.22998 117.660004 206.859985 117.080002 214.539978 C 116.239998 225.539978 121.459999 246.070007 121.459999 246.070007 C 121.459999 246.070007 109.410004 220.779999 108.870003 212.049988 C 108.470001 205.679993 121.419998 206.380005 123.279999 185.080017 C 123.769997 179.5 119.349998 163.460022 119.900002 161.630005 Z"
      />
      <linearGradient
        id="linearGradient534"
        x1="171.93"
        y1="197.43"
        x2={168}
        y2="184.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6384"
        fill="url(#linearGradient534)"
        stroke="none"
        d="M 174.75 195.850006 L 167.839996 186.77002 L 165.740005 187.830017 L 173.009995 197.22998 L 174.75 195.839996 L 174.75 195.850006 Z"
      />
      <linearGradient
        id="linearGradient535"
        x1="153.92"
        y1="213.48"
        x2="127.09"
        y2="124.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#39383c" stopOpacity={1} />
        <stop offset="0.37" stopColor="#333236" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6385"
        fill="url(#linearGradient535)"
        stroke="none"
        d="M 108.050003 146.109985 C 108.050003 146.109985 114.879997 147.100006 118.440002 148.809998 C 120.300003 149.710022 145.5 194.859985 146.270004 195.859985 C 146.830002 196.600006 166.729996 186.77002 166.729996 186.77002 L 175.039993 197.380005 C 175.039993 197.380005 153.880005 212.27002 152.979996 212.679993 C 152.080002 213.100006 141 219.390015 140.479996 217.899994 C 139.949997 216.419983 121.849998 193.140015 121.849998 193.140015 C 121.849998 193.140015 120.790001 180.799988 121.040001 178.029999 C 121.290001 175.26001 108.07 146.109985 108.07 146.109985 L 108.050003 146.109985 Z"
      />
      <linearGradient
        id="linearGradient536"
        x1="106.61"
        y1="148.62"
        x2="144.7"
        y2="207.05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6386"
        fill="url(#linearGradient536)"
        stroke="none"
        d="M 120.18 171.339996 C 117.480003 162.710022 112.940002 153.429993 113.849998 155.130005 C 118.910004 164.619995 124.279999 176.440002 126.510002 187.440002 C 128.419998 196.869995 139.929993 215.22998 142.110001 215.429993 C 147.270004 215.899994 160.110001 207.820007 160.110001 207.820007 C 160.110001 207.820007 146.720001 218.679993 140.880005 218.640015 C 138.039993 218.619995 132.479996 211.01001 130.199997 207.580017 C 127.300003 203.660004 125.260002 199.01001 121.959999 194.279999 C 121.959999 190.279999 124.349998 184.75 120.169998 171.359985 L 120.18 171.339996 Z"
      />
      <linearGradient
        id="linearGradient537"
        x1="116.55"
        y1="195.6"
        x2="130.69"
        y2="194.4"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset="0.25" stopColor="#2a292c" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6387"
        fill="url(#linearGradient537)"
        stroke="none"
        d="M 122.160004 188.51001 C 122.699997 187.98999 124.18 186.52002 124.82 183.640015 C 125.18 189.720001 122.849998 195.029999 128.990005 205.799988 C 128.990005 205.799988 121.620003 195.359985 121.739998 194.429993 C 121.669998 195.02002 121.639999 188.779999 122.169998 188.5 L 122.160004 188.51001 Z"
      />
      <linearGradient
        id="linearGradient538"
        x1="3.5199"
        y1="209.83"
        x2="36.2599"
        y2="236.81"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6388"
        fill="url(#linearGradient538)"
        stroke="none"
        d="M 11.9299 217.549988 C 8.6299 214.869995 1.5099 211.690002 5.2099 203.02002 C 5.2099 203.02002 0.129902 210.700012 0.439902 213.190002 C 0.789902 216.029999 7.6399 221.669983 13.1599 225.720001 C 18.7099 229.799988 48.539902 246.25 48.539902 246.25 C 48.539902 246.25 30.919901 232.98999 11.9199 217.570007 L 11.9299 217.549988 Z"
      />
      <linearGradient
        id="linearGradient539"
        x1="63.9499"
        y1="151.03"
        x2="60.6599"
        y2="280.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#39383c" stopOpacity={1} />
        <stop offset="0.37" stopColor="#333236" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6389"
        fill="url(#linearGradient539)"
        stroke="none"
        d="M 75.479897 140.73999 C 75.479897 140.73999 67.7799 143.190002 67.099899 148.27002 C 66.189903 155.059998 76.409897 183.039978 76.909897 185.450012 C 77.399902 187.859985 79.219902 201.169983 79.149902 203.130005 C 79.079903 205.089996 77.379898 234.100006 76.909897 237.789993 C 76.439903 241.479996 75.969902 267.480011 73.539902 268.350006 C 67.429901 270.540009 50.819901 273.600006 50.819901 272.570007 C 50.819901 262.399994 55.8899 246.130005 57.269901 238.520004 C 57.8899 235.089996 62.159901 212.330017 61.659901 210.01001 C 61.159901 207.700012 55.849899 189.51001 55.849899 189.51001 C 55.849899 189.51001 57.759899 170.850006 56.669899 168.77002 C 55.579899 166.700012 47.359901 153.559998 47.359901 153.559998 C 47.359901 153.559998 53.499901 149.309998 73.979897 141.450012 L 75.489899 140.73999 L 75.479897 140.73999 Z"
      />
      <linearGradient
        id="linearGradient540"
        x1="67.13"
        y1="175.57"
        x2="52.91"
        y2="230.98"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6390"
        fill="url(#linearGradient540)"
        stroke="none"
        d="M 57.68 184.380005 C 55.52 184.380005 56.799999 192.220001 56.759998 192.630005 C 56.759998 192.630005 60.310001 205 60.459999 205.539978 C 60.610001 206.080017 61.66 210.01001 61.66 210.01001 C 61.66 210.01001 57.880001 236.419983 56.549999 241.940002 C 56.549999 241.940002 61.369999 228.859985 62.490002 224.47998 C 63.610001 220.109985 65.400002 207.609985 65.480003 206.049988 C 65.57 204.48999 59.830002 184.359985 57.669998 184.359985 L 57.68 184.380005 Z"
      />
      <path
        id="path6391"
        fill="#34b769"
        stroke="none"
        d="M 69.939903 147.700012 L 67.109901 148.279999 C 67.109901 148.279999 61.669899 158.289978 66.409897 167.98999 C 71.149902 177.690002 75.969902 191.359985 76.969902 194.179993 C 77.969902 197.01001 76.319901 234.210022 76.319901 234.210022 L 78.549896 234.660004 C 78.549896 234.660004 79.4599 225.109985 79.769897 222.359985 C 80.079903 219.609985 82.149902 194.140015 81.689903 191.350006 C 81.219902 188.559998 73.599899 165.839996 71.119904 158.839996 C 68.309898 150.919983 69.949898 147.679993 69.949898 147.679993 L 69.939903 147.679993 L 69.939903 147.700012 Z"
      />
      <linearGradient
        id="linearGradient541"
        x1="74.5699"
        y1="234.76"
        x2="60.2199"
        y2="141.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6392"
        fill="url(#linearGradient541)"
        stroke="none"
        d="M 63.539902 146.460022 L 56.949902 155.809998 L 64.409897 156.72998 L 56.649899 161.98999 C 56.649899 161.98999 69.879898 184.570007 70.599899 185.929993 C 71.319901 187.299988 72.449898 190.850006 72.929901 192.799988 C 73.419899 194.73999 74.7799 216.25 74.7799 216.25 L 76.609901 235.429993 L 76.1399 207.039978 C 76.1399 207.039978 74.609901 187.210022 72.5299 180.419983 C 70.439903 173.630005 63.5499 146.460022 63.5499 146.460022 L 63.539902 146.460022 Z"
      />
      <linearGradient
        id="linearGradient542"
        x1="76.7599"
        y1="205.65"
        x2="62.8799"
        y2="128.79"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3a3a3e" stopOpacity={1} />
        <stop offset={1} stopColor="#39383c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6393"
        fill="url(#linearGradient542)"
        stroke="none"
        d="M 75.829903 139.869995 C 75.829903 139.869995 70.489899 141.76001 65.769897 144.029999 C 63.249901 145.25 56.6399 154.839996 56.6399 154.839996 L 64.399902 155.850006 L 57.909901 160.600006 C 57.909901 160.600006 72.969902 186.089996 73.989899 191.070007 C 75.229897 197.059998 76.099899 233.5 76.859901 238.25 C 76.859901 238.25 80.549896 195.410004 79.849899 191.890015 C 78.489899 185.100006 72.439903 168.330017 72.439903 168.330017 C 72.439903 168.330017 68.0299 156.309998 67.759903 153.630005 C 67.039902 146.539978 71.829903 141.960022 75.399902 140.799988 L 75.819901 139.859985 L 75.829903 139.869995 Z"
      />
      <linearGradient
        id="linearGradient543"
        x1="75.94"
        y1="150.22"
        x2="67.15"
        y2="150.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6394"
        fill="url(#linearGradient543)"
        stroke="none"
        d="M 75.870003 139.799988 C 75.870003 139.799988 75.889999 139.799988 75.470001 140.75 C 75.239998 140.850006 71.199997 142.940002 69.580002 146.070007 C 68.260002 148.609985 67.550003 149.609985 68.120003 153.859985 C 68.5 156.700012 69.75 160.630005 69.75 160.630005 C 69.75 160.630005 66.739998 154.140015 67.099998 150.77002 C 67.459999 147.399994 68.949997 142.320007 75.150002 140.77002 L 75.870003 139.799988 Z"
      />
      <linearGradient
        id="linearGradient544"
        x1="36.7599"
        y1="217.81"
        x2="0.819927"
        y2="187.88"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c499" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1c69b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4cea4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6395"
        fill="url(#linearGradient544)"
        stroke="none"
        d="M 52.559898 238.729996 C 53.569901 239.5 53.7099 242.589996 51.569901 241.070007 C 45.1199 236.460022 32.0499 224.359985 31.2799 223.76001 C 30.2199 222.929993 16.3799 210.22998 15.0999 209.399994 C 13.8099 208.570007 21.939899 207.109985 30.3799 201.320007 L 22.1299 209.51001 C 22.1299 209.51001 35.199902 225.72998 52.559898 238.729996 Z"
      />
      <linearGradient
        id="linearGradient545"
        x1="30.1199"
        y1="151.36"
        x2="26.8499"
        y2="279.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#39383c" stopOpacity={1} />
        <stop offset="0.37" stopColor="#333236" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6396"
        fill="url(#linearGradient545)"
        stroke="none"
        d="M 47.759899 153.380005 C 47.759899 153.380005 44.929901 153.869995 29.9699 171.880005 C 14.9999 189.899994 -0.820091 206.450012 0.429909 213.169983 C 1.67991 219.890015 36.439899 240.710007 36.439899 240.710007 L 44.5299 231.02002 C 44.5299 231.02002 25.429899 212.179993 25.1099 211.440002 C 24.7899 210.679993 48.849899 183.02002 50.199902 183.649994 C 51.5499 184.27002 56.749901 192.640015 56.749901 192.640015 C 56.749901 192.640015 57.8699 169.940002 57.859901 168.410004 C 57.849899 166.869995 47.759899 153.380005 47.759899 153.380005 Z"
      />
      <path
        id="path6397"
        fill="#34b769"
        stroke="none"
        d="M 106.290001 146.410004 L 101.709999 145.580017 C 101.709999 145.580017 104.610001 148.77002 106.120003 151.5 C 107.639999 154.22998 119.269997 183.779999 119.360001 186.339996 C 119.449997 188.919983 114.089996 218.429993 113.849998 220.179993 C 113.610001 221.929993 114.629997 233.23999 114.629997 233.23999 C 114.629997 233.23999 117.720001 232.160004 118.139999 231.690002 C 118.139999 231.690002 118.449997 216.51001 118.419998 215.130005 C 118.389999 213.76001 123.919998 187.059998 123.279999 185.089996 C 122.639999 183.109985 106.279999 146.410004 106.279999 146.410004 L 106.290001 146.410004 Z"
      />
      <linearGradient
        id="linearGradient546"
        x1="46.1499"
        y1="170.15"
        x2="32.0599"
        y2="225.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6398"
        fill="url(#linearGradient546)"
        stroke="none"
        d="M 59.499901 186.580017 C 59.499901 186.580017 54.089901 173.100006 53.269901 174.399994 C 39.649899 195.890015 18.519899 209.380005 18.519899 209.380005 L 25.1199 211.440002 C 25.1199 211.440002 50.239899 182.390015 50.899899 183.330017 C 51.559898 184.279999 56.749901 192.630005 56.749901 192.630005 L 59.489899 186.580017 L 59.499901 186.580017 Z"
      />
      <linearGradient
        id="linearGradient547"
        x1="128.15"
        y1="229.16"
        x2="115.05"
        y2="229.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#38373b" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6399"
        fill="url(#linearGradient547)"
        stroke="none"
        d="M 120.25 199.690002 C 120.25 199.690002 115.18 219.289978 115.029999 220.75 C 114.889999 222.210022 120.120003 265.429993 121 266.440002 C 122.300003 267.929993 128.149994 268.410004 128.149994 268.410004 C 128.149994 268.410004 121.550003 217.609985 121.720001 216.160004 C 121.900002 214.700012 123.57 189.919983 123.57 189.919983 L 120.25 199.690002 Z"
      />
      <linearGradient
        id="linearGradient548"
        x1={121}
        y1="198.91"
        x2="117.81"
        y2="147.73"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6400"
        fill="url(#linearGradient548)"
        stroke="none"
        d="M 116.199997 152.640015 L 117.730003 153.869995 L 113.050003 154.919983 L 121.5 157.51001 C 121.5 157.51001 123.160004 166.789978 123.720001 170.029999 C 124.269997 173.27002 126.949997 182.919983 126.949997 182.919983 L 123.160004 197.130005 L 121 193.710022 L 122.599998 175.720001 L 111.050003 150.609985 L 116.209999 152.619995 L 116.199997 152.640015 Z"
      />
      <linearGradient
        id="linearGradient549"
        x1="126.9"
        y1="241.82"
        x2="97.4498"
        y2="92.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3a3a3e" stopOpacity={1} />
        <stop offset={1} stopColor="#39383c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6401"
        fill="url(#linearGradient549)"
        stroke="none"
        d="M 96.479897 140.25 C 96.479897 140.25 99.1399 140.23999 106.970001 143.839996 C 109.059998 144.799988 117.720001 152.929993 117.720001 152.929993 L 112.620003 153.419983 L 119.940002 156.089996 C 119.940002 156.089996 121.629997 166.940002 121.830002 167.809998 C 122.540001 171.02002 126.059998 181.929993 125.639999 183.5 C 125.220001 185.080017 123.790001 192.22998 123.790001 192.22998 L 117.150002 220.549988 L 116.830002 237.169998 C 116.830002 237.169998 114.959999 221.75 115.050003 220.75 C 115.139999 219.75 119.519997 202.399994 120.730003 185.559998 C 118.830002 179.839996 108.830002 153.140015 106.440002 149.619995 C 101.389999 142.210022 96.489899 140.25 96.489899 140.25 L 96.479897 140.25 Z"
      />
      <linearGradient
        id="linearGradient550"
        x1="113.84"
        y1="153.57"
        x2="96.5199"
        y2="153.57"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6402"
        fill="url(#linearGradient550)"
        stroke="none"
        d="M 113.809998 166.880005 C 113.809998 166.880005 108.169998 152.960022 107.550003 151.75 C 104.970001 146.679993 100.889999 143.869995 99.689903 142.919983 C 98.239899 141.779999 96.479897 141.25 96.479897 141.25 L 96.479897 140.25 C 96.479897 140.25 98.789902 141.02002 100.290001 142.029999 C 100.839996 142.410004 105.589996 145.26001 108.360001 151.119995 C 111.43 157.609985 113.82 166.880005 113.82 166.880005 L 113.809998 166.880005 Z"
      />
      <linearGradient
        id="linearGradient551"
        x1="85.4899"
        y1="146.85"
        x2="85.8899"
        y2="160.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6403"
        fill="url(#linearGradient551)"
        stroke="none"
        d="M 102.18 145.660004 L 101.040001 145.399994 C 101.040001 145.399994 101.699997 148.830017 99.6399 150.619995 C 97.579903 152.410004 91.979897 153.98999 86.259903 154.140015 C 80.329903 154.299988 76.099899 153.109985 73.579903 151.589996 C 71.059898 150.070007 69.909897 147.640015 69.909897 147.640015 L 68.749901 147.929993 C 68.749901 147.929993 70.049896 151.01001 73.299896 152.580017 C 76.549896 154.160004 81.199898 156.220001 89.109901 155.210022 C 97.009903 154.200012 99.039902 153.02002 100.900002 151.109985 C 102.75 149.210022 102.169998 145.640015 102.169998 145.640015 L 102.18 145.660004 Z"
      />
      <linearGradient
        id="linearGradient552"
        x1="2.07991"
        y1="207.62"
        x2="37.5199"
        y2="238.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3f3e42" stopOpacity={1} />
        <stop offset="0.32" stopColor="#39383c" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6404"
        fill="url(#linearGradient552)"
        stroke="none"
        d="M 5.69991 201.309998 C 5.69991 201.309998 -0.480086 209.720001 0.029914 213.02002 C 0.459914 215.799988 5.31991 220.820007 16.849899 228.27002 C 28.489901 235.799988 36.449902 240.720001 36.449902 240.720001 L 38.349899 238.449997 C 38.349899 238.449997 15.2799 222.179993 11.7899 219.72998 C 8.29991 217.279999 0.329915 211.929993 5.69991 201.330017 L 5.69991 201.309998 Z"
      />
      <linearGradient
        id="linearGradient553"
        x1="43.8899"
        y1="231.01"
        x2="11.9999"
        y2="204.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#272628" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6405"
        fill="url(#linearGradient553)"
        stroke="none"
        d="M 44.539902 231.02002 C 44.539902 231.02002 25.6299 212.330017 25.1199 211.440002 C 25.1199 211.440002 20.2199 208.419983 18.169901 209.52002 C 16.1199 210.609985 42.3699 233.630005 42.3699 233.630005 L 44.539902 231.029999 L 44.539902 231.02002 Z"
      />
      <linearGradient
        id="linearGradient554"
        x1="51.16"
        y1="160.35"
        x2="10.73"
        y2="201.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3f3f43" stopOpacity={1} />
        <stop offset="0.48" stopColor="#353437" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6406"
        fill="url(#linearGradient554)"
        stroke="none"
        d="M 50.169998 163.910004 C 53.18 157.950012 50.200001 151.660004 45.919998 154.609985 C 41.630001 157.570007 26.719999 173.080017 16.41 195.47998 C 13.47 201.890015 21.23 205.580017 31.74 191.179993 C 42.950001 175.809998 47.459999 169.27002 50.18 163.910004 L 50.169998 163.910004 Z"
      />
      <linearGradient
        id="linearGradient555"
        x1="169.13"
        y1="189.87"
        x2="120.98"
        y2="211.29"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3f3f43" stopOpacity={1} />
        <stop offset="0.48" stopColor="#353437" stopOpacity={1} />
        <stop offset={1} stopColor="#2f2e31" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6407"
        fill="url(#linearGradient555)"
        stroke="none"
        d="M 169.160004 189.899994 L 166.710007 186.77002 C 166.710007 186.77002 148.169998 195.76001 146.25 195.859985 C 145.880005 199.089996 146.630005 204.309998 149.5 202.720001 C 155.520004 199.419983 169.160004 189.880005 169.160004 189.880005 L 169.149994 189.880005 L 169.160004 189.899994 Z"
      />
      <linearGradient
        id="linearGradient556"
        x1="114.88"
        y1="146.61"
        x2="125.33"
        y2="164.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3f3e42" stopOpacity={1} />
        <stop offset="0.32" stopColor="#39383c" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6408"
        fill="url(#linearGradient556)"
        stroke="none"
        d="M 124.620003 158.350006 C 124.620003 158.350006 119.720001 149.799988 118.589996 148.880005 C 117.470001 147.960022 112.050003 146.850006 112.050003 146.850006 C 112.050003 146.850006 116.900002 149.450012 117.730003 150.049988 C 118.57 150.649994 124.629997 158.350006 124.629997 158.350006 L 124.620003 158.350006 Z"
      />
      <linearGradient
        id="linearGradient557"
        x1="73.0499"
        y1="80.46"
        x2="59.2899"
        y2="155.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a3753d" stopOpacity={1} />
        <stop offset={1} stopColor="#e0b163" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6409"
        fill="url(#linearGradient557)"
        stroke="none"
        d="M 57.379902 127.190002 C 51.769901 101.660004 65.599899 86.480011 68.299896 82.830017 C 71.2799 78.799988 76.689903 75.190002 80.069901 79.940002 C 80.069901 79.940002 77.269897 78.570007 73.669899 81.709991 C 58.239899 100.51001 60.489899 112.200012 64.059898 126.700012 C 67.669899 141.369995 76.879898 144.169983 67.799896 161.789978 C 71.289902 140.369995 61.309898 145.01001 57.3899 127.190002 L 57.379902 127.190002 Z"
      />
      <linearGradient
        id="linearGradient558"
        x1="57.0599"
        y1="74.2399"
        x2="63.8199"
        y2="136.71"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a3753d" stopOpacity={1} />
        <stop offset={1} stopColor="#e0b163" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6410"
        fill="url(#linearGradient558)"
        stroke="none"
        d="M 60.109901 106.690002 C 60.109901 106.690002 58.329899 116.01001 59.3699 125.01001 C 60.399899 133.970001 67.289902 139.440002 67.289902 139.440002 C 67.289902 139.440002 62.599899 133.960022 60.969898 123.459991 C 60.319901 119.26001 60.089901 106.700012 60.089901 106.700012 L 60.109901 106.690002 Z"
      />
      <linearGradient
        id="linearGradient559"
        x1="91.0499"
        y1="80.5599"
        x2="111.87"
        y2="133.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#a3753d" stopOpacity={1} />
        <stop offset={1} stopColor="#e0b163" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6411"
        fill="url(#linearGradient559)"
        stroke="none"
        d="M 107.57 140.01001 C 128.610001 118.160004 106.489998 100.869995 97.319901 89.989899 C 94.369904 86.489899 89.469902 76.249908 82.739899 78.079895 C 81.009903 78.549896 80.119904 79.899902 80.009903 79.999908 C 80.069901 79.9599 81.519897 79.149902 83.329903 79.289917 C 85.319901 79.439911 86.579903 80.359894 88.699898 82.94989 C 90.8899 85.489899 92.359901 87.999908 94.979897 91.869904 C 105.059998 106.76001 120.07 116.98999 107.57 140.02002 L 107.57 140.01001 Z"
      />
      <linearGradient
        id="linearGradient560"
        x1="110.18"
        y1="359.51"
        x2="90.0099"
        y2="359.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba779" stopOpacity={1} />
        <stop offset="0.38" stopColor="#e0b081" stopOpacity={1} />
        <stop offset="0.99" stopColor="#efc898" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c999" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6412"
        fill="url(#linearGradient560)"
        stroke="none"
        d="M 110.150002 350.369995 L 105.709999 371.380005 L 89.989899 366.899994 L 95.799896 347.609985 L 110.160004 350.359985 L 110.150002 350.369995 Z"
      />
      <path
        id="path6413"
        fill="#f7d9ab"
        stroke="none"
        d="M 105.730003 375.420013 C 105.730003 375.420013 102.660004 402.779999 102.660004 406.910004 C 102.660004 411.040009 95.749901 452.329987 95.769897 455.980011 C 95.809898 464.559998 100.82 475.350006 103.209999 482 C 104.919998 486.76001 97.219902 491.649994 88.649902 480 C 85.829903 476.179993 82.949898 465.429993 83.299896 460.269989 C 83.3899 458.899994 84.629898 454.799988 84.7799 454.190002 C 85.159897 451.130005 85.619904 447.519989 85.759903 444.059998 C 86.269897 431.679993 83.189903 403.279999 83.189903 403.279999 L 105.730003 375.399994 L 105.720001 375.399994 L 105.730003 375.420013 Z"
      />
      <linearGradient
        id="linearGradient561"
        x1="74.2199"
        y1="428.92"
        x2="101.92"
        y2="431.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c999" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1cb9b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4d3a4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d9ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6414"
        fill="url(#linearGradient561)"
        stroke="none"
        d="M 84.7799 454.200012 C 84.7799 454.200012 87.309898 440.540009 83.879898 413.350006 L 105.529999 378.350006 L 104.029999 391.140015 C 104.029999 391.140015 99.469902 409.709991 95.859901 423.059998 C 94.109901 429.549988 93.399902 436.630005 90.559898 443.929993 C 89.069901 448.859985 87.1399 459.459991 88.0299 465.410004 C 89.7099 476.570007 91.899902 479.910004 93.829903 482.820007 C 93.829903 482.820007 89.119904 488.829987 83.339897 466.980011 C 82.629898 464.309998 83.339897 459.220001 84.7799 454.190002 L 84.789902 454.190002 L 84.7799 454.200012 Z"
      />
      <path
        id="path6415"
        fill="#f7d9ab"
        stroke="none"
        d="M 53.469898 449.899994 C 55.5299 446.809998 58.609901 443.040009 60.659901 440.459991 C 62.7099 437.880005 65.269897 402.779999 73.4599 390.910004 C 81.649902 379.040009 83.699898 374.910004 83.699898 374.910004 L 83.859901 374.910004 C 83.699898 368.619995 74.579903 343.149994 74.579903 343.149994 L 104.669998 339.359985 C 107.07 352.100006 108.769997 375.179993 106.230003 383.170013 C 105.440002 385.679993 72.729897 435.700012 71.189903 442.410004 C 69.649902 449.119995 67.399902 459.670013 61.789902 475.929993 L 61.8699 477.920013 C 61.8699 477.920013 48.579899 486.230011 48.499901 473.649994 C 48.499901 473.649994 50.009899 455.040009 53.449902 449.910004 L 53.469898 449.899994 Z"
      />
      <linearGradient
        id="linearGradient562"
        x1="55.3298"
        y1="437.44"
        x2="52.9698"
        y2="483.58"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f3d0a0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d9ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6416"
        fill="url(#linearGradient562)"
        stroke="none"
        d="M 60.659801 440.459991 C 60.659801 440.459991 57.349899 443.829987 55.899899 446.73999 C 54.4799 449.609985 45.579899 464.600006 49.009899 475.059998 C 49.069901 475.23999 56.589802 445.910004 60.649799 440.459991 L 60.659801 440.459991 Z"
      />
      <path
        id="path6417"
        fill="#434343"
        stroke="none"
        d="M 61.8699 477.51001 C 59.589901 479.970001 51.379902 477.940002 49.449902 472.869995 C 48.219898 469.660004 50.719898 456.359985 56.589901 445.529999 C 56.589901 445.529999 53.019901 447.73999 50.569901 451.179993 C 48.1199 454.630005 49.449902 461.049988 48.469898 464.01001 C 47.489899 466.970001 44.899899 472.290009 45.629902 475.929993 C 46.929901 482.359985 53.299801 490.75 59.039799 489.429993 C 62.629799 488.609985 62.199902 482.600006 61.8699 477.51001 Z"
      />
      <linearGradient
        id="linearGradient563"
        x1="88.6699"
        y1="389.06"
        x2="61.1699"
        y2="389.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f3d0a0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d9ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6418"
        fill="url(#linearGradient563)"
        stroke="none"
        d="M 71.589897 394.040009 C 73.599899 389.98999 79.629898 381.540009 79.9599 380.970001 C 79.9599 380.970001 83.2099 376.420013 83.479897 374.839996 C 83.729897 373.440002 72.539902 340.73999 72.539902 340.73999 L 81.089897 338.670013 C 81.089897 338.670013 88.9599 373.809998 88.619904 376.220001 C 88.679901 377.399994 76.299896 389.76001 72.619904 398.190002 C 66.479897 412.269989 64.789902 427.320007 61.1199 439.459991 C 64.549896 417.23999 67.259903 402.779999 71.599899 394.040009 L 71.589897 394.040009 Z"
      />
      <linearGradient
        id="linearGradient564"
        x1="107.08"
        y1="353.2"
        x2="75.5299"
        y2="353.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f0c999" stopOpacity={1} />
        <stop offset="0.52" stopColor="#f1cb9b" stopOpacity={1} />
        <stop offset="0.85" stopColor="#f4d3a4" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d9ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6419"
        fill="url(#linearGradient564)"
        stroke="none"
        d="M 105.169998 346.019989 C 105.169998 346.019989 106.849998 354.559998 107.089996 359.190002 C 100.139999 361.140015 79.089897 360.089996 79.089897 360.089996 L 75.539902 349.5 L 105.169998 346.01001 L 105.169998 346.019989 Z"
      />
      <path
        id="path6420"
        fill="#434343"
        stroke="none"
        d="M 84.1399 472.380005 C 82.539902 469.299988 80.949898 466.089996 81.099899 464.190002 C 81.5299 459.049988 84.609901 454.75 84.609901 454.75 C 83.479897 458.970001 83.249901 464.820007 84.449898 468.079987 C 87.659897 476.850006 89.269897 480.649994 90.749901 481.450012 C 97.4599 485.109985 103.43 482.579987 102.620003 480.440002 C 106.019997 486.149994 106.279999 488.649994 106.050003 490.25 C 105.699997 492.75 101.440002 494.25 91.399902 490.200012 C 87.799896 488.75 87.5299 486.390015 87.5299 486.390015 C 87.309898 482.839996 87.079903 479.690002 86.539902 477.579987 L 86.539902 481.73999 L 85.099899 481.5 C 85.589897 479.670013 84.339897 473.390015 84.1399 472.390015 L 84.1399 472.380005 Z"
      />
      <path
        id="path6421"
        fill="#27ae60"
        stroke="none"
        d="M 89.309898 235.330017 C 97.259903 236.450012 105.220001 237.619995 113.199997 238.509995 C 114.150002 238.619995 115.089996 238.669998 116.029999 238.710007 C 117.660004 246.710007 120.209999 255.589996 123.019997 266.140015 C 117.669998 270.410004 81.749901 274.220001 54.9799 264.320007 C 60.039902 249.199997 64.069901 238.679993 65.909897 233.830017 C 73.749901 233.72998 81.499901 234.350006 89.309898 235.320007 L 89.309898 235.330017 Z"
      />
      <path
        id="path6422"
        fill="#27ae60"
        stroke="none"
        d="M 89.309998 235.330017 C 90.709999 235.529999 92.110001 235.72998 93.510002 235.919983 C 85.239998 237.919998 74.370003 241.309998 60.470001 247.130005 C 63.48 242.339996 65.550003 237.919998 66.889999 233.820007 C 74.400002 233.779999 81.82 234.390015 89.309998 235.330017 Z"
      />
      <linearGradient
        id="linearGradient565"
        x1="62.8799"
        y1="260.89"
        x2="58.1899"
        y2="150.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f1f0f5" stopOpacity={1} />
        <stop offset={1} stopColor="#e1e1e5" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6423"
        fill="url(#linearGradient565)"
        stroke="none"
        d="M 68.149902 233.830017 C 63.649899 243.929993 57.689899 257.450012 56.439899 260.049988 C 60.7999 246.570007 63.819901 238.460007 65.509903 233.850006 C 66.3899 233.839996 67.269897 233.820007 68.149902 233.830017 Z"
      />
      <path
        id="path6424"
        fill="#27ae60"
        stroke="none"
        d="M 116.300003 238.720001 C 117.470001 245.240005 118.809998 250.490005 118.809998 250.490005 C 118.809998 250.490005 116.239998 245.100006 113.480003 238.529999 C 114.43 238.630005 115.360001 238.679993 116.300003 238.710007 L 116.300003 238.720001 Z"
      />
      <path
        id="path6425"
        fill="#2dba66"
        stroke="none"
        d="M 78.519897 234.23999 C 78.239899 237.050003 77.999901 239.639999 77.999901 239.639999 L 75.879898 239.220001 C 75.879898 239.220001 75.969902 237.199997 76.089897 234.100006 C 76.899902 234.149994 77.7099 234.190002 78.519897 234.25 L 78.519897 234.23999 Z"
      />
      <linearGradient
        id="linearGradient566"
        x1="106.45"
        y1="366.96"
        x2="68.7"
        y2="175.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#38373b" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6426"
        fill="url(#linearGradient566)"
        stroke="none"
        d="M 68.410004 236.619995 C 88.239998 243.940002 104.419998 240.880005 112.300003 238.399994 C 112.599998 238.429993 112.900002 238.479996 113.199997 238.509995 C 114.779999 238.690002 116.339996 238.759995 117.910004 238.740005 C 118.370003 241.850006 119.300003 249.009995 121.059998 265.170013 C 123.93 291.600006 116.279999 325.829987 111.760002 357.420013 C 97.550003 358.329987 82.010002 358.75 68.260002 358.75 C 70.559998 338.970001 52.34 294.140015 52.34 272.709991 C 52.34 267.559998 68.410004 236.619995 68.410004 236.619995 Z"
      />
      <linearGradient
        id="linearGradient567"
        x1="73.3899"
        y1="242.92"
        x2="117.14"
        y2="242.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6427"
        fill="url(#linearGradient567)"
        stroke="none"
        d="M 95.5299 241.169998 C 103.540001 240.800003 108.900002 239.470001 112.059998 238.380005 C 112.440002 238.419998 112.82 238.470001 113.199997 238.520004 C 114.18 238.630005 115.150002 238.679993 116.110001 238.720001 L 117.089996 242.820007 C 117.089996 242.820007 111.110001 247.089996 97.049896 247.800003 C 83.769897 248.460007 71.899902 245.369995 71.899902 245.369995 L 72.929901 237.520004 C 72.929901 237.520004 81.249901 241.820007 95.519897 241.169998 L 95.5299 241.169998 Z"
      />
      <linearGradient
        id="linearGradient568"
        x1="67.8299"
        y1="238.95"
        x2="60.9899"
        y2="296.45"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6428"
        fill="url(#linearGradient568)"
        stroke="none"
        d="M 77.8899 239.320007 C 77.8899 239.320007 77.479897 251.940002 77.129898 256.459991 C 76.789902 260.970001 76.179901 271.119995 74.579903 272.269989 C 72.979897 273.420013 56.829899 276.649994 52.559898 277.269989 L 52.1399 272.76001 L 74.719902 238.649994 L 77.879898 239.320007 L 77.8899 239.320007 Z"
      />
      <linearGradient
        id="linearGradient569"
        x1="66.6099"
        y1={167}
        x2="63.6599"
        y2="282.48"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#38373b" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6429"
        fill="url(#linearGradient569)"
        stroke="none"
        d="M 59.449902 234.070007 C 59.689899 234.059998 59.929901 234.049988 60.159901 234.039978 C 65.859901 233.690002 71.489899 233.789978 77.099899 234.149994 C 76.819901 238.270004 76.579903 241.559998 76.439903 242.619995 C 75.989899 246.119995 75.549896 270.850006 73.229897 271.679993 C 67.429901 273.769989 51.6199 276.670013 51.6199 275.690002 C 51.6199 266.019989 56.449902 250.539993 57.749901 243.309998 C 57.969898 242.110001 58.659901 238.389999 59.419899 234.059998 L 59.429901 234.059998 L 59.449902 234.070007 Z"
      />
      <linearGradient
        id="linearGradient570"
        x1="82.7799"
        y1="200.74"
        x2="64.6901"
        y2="237.37"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6430"
        fill="url(#linearGradient570)"
        stroke="none"
        d="M 60.169899 234.039978 C 64.469902 233.779999 68.739899 233.77002 72.999901 233.940002 L 59.309898 235.929993 L 59.7299 234.059998 C 59.879902 234.059998 60.0299 234.049988 60.179901 234.039978 L 60.169899 234.039978 Z"
      />
      <linearGradient
        id="linearGradient571"
        x1="72.9298"
        y1="185.18"
        x2="59.4598"
        y2="237.67"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6431"
        fill="url(#linearGradient571)"
        stroke="none"
        d="M 60.169899 234.039978 C 60.6199 234.01001 61.069901 234 61.519901 233.97998 C 59.7799 239.259995 57.099899 246.570007 57.099899 246.570007 C 57.589901 244.529999 58.429901 239.490005 59.2799 234.080017 C 59.579899 234.070007 59.879902 234.049988 60.179901 234.039978 L 60.169899 234.039978 Z"
      />
      <linearGradient
        id="linearGradient572"
        x1="76.4499"
        y1="239.47"
        x2="64.0499"
        y2="159.06"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6432"
        fill="url(#linearGradient572)"
        stroke="none"
        d="M 76.059898 234.089996 L 76.159897 240.369995 L 75.559898 234.059998 C 75.719902 234.059998 75.8899 234.080017 76.059898 234.089996 Z"
      />
      <linearGradient
        id="linearGradient573"
        x1="72.3399"
        y1="213.94"
        x2="59.63"
        y2="143.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3a3a3e" stopOpacity={1} />
        <stop offset={1} stopColor="#38373b" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6433"
        fill="url(#linearGradient573)"
        stroke="none"
        d="M 77.159897 234.149994 C 76.739899 239.380005 76.419899 243.059998 76.419899 243.059998 C 76.219902 241.850006 76.019897 238.470001 75.809898 234.070007 C 76.259903 234.100006 76.7099 234.130005 77.169899 234.149994 L 77.159897 234.149994 Z"
      />
      <linearGradient
        id="linearGradient574"
        x1="118.6"
        y1="242.17"
        x2="110.97"
        y2="306.38"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6434"
        fill="url(#linearGradient574)"
        stroke="none"
        d="M 113.199997 238.520004 C 114.709999 238.690002 116.209999 238.759995 117.709999 238.759995 C 118.220001 243.899994 119.5 256.130005 121.099998 267.049988 C 121.419998 269.190002 121.669998 271.290009 121.610001 273.390015 C 121.610001 273.390015 117.540001 271.279999 117.010002 270.589996 C 116.489998 269.920013 112.599998 240.5 112.330002 238.419998 C 112.620003 238.449997 112.910004 238.490005 113.199997 238.520004 Z"
      />
      <linearGradient
        id="linearGradient575"
        x1="125.19"
        y1="255.16"
        x2="112.73"
        y2="255.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#38373b" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6435"
        fill="url(#linearGradient575)"
        stroke="none"
        d="M 120.959999 238.630005 C 122.760002 253.080002 125.18 271.720001 125.18 271.720001 C 125.18 271.720001 119.620003 271.26001 118.389999 269.839996 C 117.839996 269.200012 115.5 251.210007 114 238.570007 C 116.339996 238.779999 118.660004 238.779999 120.959999 238.619995 L 120.959999 238.630005 Z"
      />
      <linearGradient
        id="linearGradient576"
        x1="115.96"
        y1="248.01"
        x2="88.0199"
        y2="106.071"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#3a3a3e" stopOpacity={1} />
        <stop offset={1} stopColor="#38373b" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6436"
        fill="url(#linearGradient576)"
        stroke="none"
        d="M 114.480003 238.619995 L 114.419998 242.029999 C 114.419998 242.029999 114.239998 240.589996 114 238.580002 C 114.160004 238.589996 114.32 238.610001 114.480003 238.619995 Z"
      />
      <linearGradient
        id="linearGradient577"
        x1="68.8599"
        y1="303.57"
        x2="59.4398"
        y2="382.72"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6437"
        fill="url(#linearGradient577)"
        stroke="none"
        d="M 68.259804 358.75 C 68.259804 358.75 68.879898 354 68.019897 348.130005 C 67.159897 342.26001 60.079899 313.730011 57.099899 300.630005 C 57.099899 300.630005 62.599899 318.01001 67.6399 333.350006 C 72.649902 348.600006 74.399803 358.709991 74.399803 358.709991 L 68.269897 358.73999 L 68.259804 358.75 Z"
      />
      <linearGradient
        id="linearGradient578"
        x1="114.44"
        y1="308.54"
        x2="111.04"
        y2="360.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#38373b" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6438"
        fill="url(#linearGradient578)"
        stroke="none"
        d="M 111.760002 357.420013 L 106.059998 357.75 C 106.059998 357.75 116.510002 325.820007 119.910004 303.579987 C 119.910004 303.579987 117.360001 325.929993 111.760002 357.420013 Z"
      />
      <path
        id="path6439"
        fill="#38373b"
        stroke="none"
        d="M 81.249901 287.179993 C 75.719902 289.320007 85.4599 346.609985 94.839897 348.579987 C 104.220001 350.549988 100.589996 332.230011 98.409897 320.040009 C 96.239899 307.839996 93.0299 282.630005 81.249901 287.190002 L 81.249901 287.179993 Z"
      />
      <linearGradient
        id="linearGradient579"
        x1="95.0599"
        y1="261.48"
        x2="95.9499"
        y2="300.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#38373b" stopOpacity={1} />
        <stop offset="0.64" stopColor="#302f32" stopOpacity={1} />
        <stop offset={1} stopColor="#2a292c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6440"
        fill="url(#linearGradient579)"
        stroke="none"
        d="M 111.459999 257.209991 C 110.879997 255.279999 78.409897 257.540009 78.4599 258.790009 C 78.509903 260.040009 87.049896 275.089996 94.989899 274.940002 C 102.93 274.790009 112.360001 260.220001 111.459999 257.200012 L 111.459999 257.209991 Z"
      />
      <linearGradient
        id="linearGradient580"
        x1="58.19"
        y1="463.98"
        x2={106}
        y2="369.18"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffdeb3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcdcb0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d9ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6441"
        fill="url(#linearGradient580)"
        stroke="none"
        d="M 107.389999 365.01001 C 107.389999 365.01001 108.010002 379.48999 106.120003 383.440002 C 104.43 386.970001 78.009903 428.790009 75.619904 433.450012 C 73.5299 437.529999 71.749901 441.109985 71.299896 443.100006 C 70.849899 445.089996 64.779999 469.450012 62.389999 473.209991 C 60.91 475.540009 56.689899 475.820007 55.769901 470.380005 C 54.859901 464.950012 60.769901 447.880005 62.079899 444.649994 C 63.3899 441.420013 74.2799 415.119995 74.859901 413.279999 C 75.449898 411.429993 101.400002 386.679993 102.769997 383.75 C 104.139999 380.829987 107.379997 365.01001 107.379997 365.01001 L 107.389999 365.01001 Z"
      />
      <linearGradient
        id="linearGradient581"
        x1="66.0899"
        y1="226.68"
        x2="58.5396"
        y2={244}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#2b2a2d" stopOpacity={1} />
        <stop offset={1} stopColor="#333236" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6442"
        fill="url(#linearGradient581)"
        stroke="none"
        d="M 60.169899 234.039978 C 63.249901 233.850006 66.309898 233.799988 69.349899 233.839996 C 69.349899 233.960022 69.359901 234.070007 69.369904 234.169983 C 68.259903 234.299988 62.589901 234.350006 56.269901 234.160004 C 57.569901 234.160004 58.8699 234.119995 60.169899 234.029999 L 60.169899 234.039978 Z"
      />
      <path
        id="path6443"
        fill="#f7d4ab"
        stroke="none"
        d="M 171.350006 190.97998 C 170.490005 189.570007 169.839996 188.01001 169.809998 186.460022 C 173.820007 183.950012 176.259995 182.190002 176.690002 181.669983 L 183.759995 186.97998 C 183.759995 186.97998 179.449997 190.73999 175.619995 194.869995 C 173.509995 194.390015 171.949997 192.679993 171.350006 190.970001 L 171.350006 190.97998 Z"
      />
      <path
        id="path6444"
        fill="#ffdebd"
        stroke="none"
        d="M 202.889999 163.330017 C 202.889999 163.330017 203.580002 162.609985 203.580002 162 C 203.580002 161.619995 202.75 160.72998 202.210007 160.919983 C 201.880005 161.029999 201.699997 161.140015 201.110001 161.589996 L 202.899994 163.330017 L 202.889999 163.330017 Z"
      />
      <path
        id="path6445"
        fill="#f7d4ab"
        stroke="none"
        d="M 194.490005 171.98999 C 194.490005 171.98999 199.119995 167.140015 201.369995 165.089996 C 203.669998 162.98999 203.639999 161.839996 202.899994 161.390015 C 202.240005 160.98999 201.080002 161.51001 200.419998 162 C 195.589996 165.539978 190.389999 169.76001 190.389999 169.76001 L 185.220001 173.059998 L 194.490005 171.98999 Z"
      />
      <linearGradient
        id="linearGradient582"
        x1="187.32"
        y1="172.18"
        x2="196.35"
        y2="170.78"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.45" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.46" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.71" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6446"
        fill="url(#linearGradient582)"
        stroke="none"
        d="M 194.949997 171.51001 L 194.360001 172.149994 L 191.309998 171.309998 L 185.589996 172.710022 L 188.259995 171.119995 C 188.259995 171.119995 191.809998 170.309998 192.559998 170.309998 C 193.309998 170.309998 194.960007 171.51001 194.960007 171.51001 L 194.949997 171.51001 Z"
      />
      <linearGradient
        id="linearGradient583"
        x1="200.8"
        y1="160.35"
        x2="192.18"
        y2="171.41"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6447"
        fill="url(#linearGradient583)"
        stroke="none"
        d="M 202.639999 161.279999 C 202.639999 161.279999 201.320007 160.899994 198.949997 162.77002 C 196.630005 164.609985 192.669998 167.910004 191.740005 168.660004 C 192.869995 168.140015 194.339996 166.75 197.259995 164.660004 C 199.470001 163.089996 202.139999 161.410004 202.630005 161.27002 L 202.639999 161.279999 Z"
      />
      <linearGradient
        id="linearGradient584"
        x1="203.1"
        y1="162.37"
        x2="194.46"
        y2="173.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6448"
        fill="url(#linearGradient584)"
        stroke="none"
        d="M 196.169998 170.279999 C 196.169998 170.279999 200.539993 165.97998 201.360001 165.089996 C 202.190002 164.200012 204.229996 162.929993 203.089996 161.539978 L 196.169998 170.279999 Z"
      />
      <path
        id="path6449"
        fill="#f7d4ab"
        stroke="none"
        d="M 192.729996 172.809998 C 192.729996 172.809998 196.059998 170.75 197.160004 171.22998 C 198.259995 171.710022 199.449997 173.080017 199.300003 174.080017 C 199.160004 175.080017 194.509995 177.210022 194.509995 177.210022 C 194.509995 177.210022 192.25 179.089996 191.639999 178.720001 C 191.029999 178.350006 188.389999 175.539978 189.130005 175.220001 C 189.860001 174.899994 192.729996 172.809998 192.729996 172.809998 Z"
      />
      <linearGradient
        id="linearGradient585"
        x1="202.84"
        y1="174.57"
        x2="196.6"
        y2="173.68"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.29" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.55" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6450"
        fill="url(#linearGradient585)"
        stroke="none"
        d="M 197.869995 175.450012 C 198.360001 175.220001 199.130005 174.410004 199.130005 174.410004 C 199.160004 174.029999 198.660004 173.22998 197.619995 172.830017 C 196.589996 172.450012 194.660004 171.779999 194.660004 171.779999 L 193.240005 172.440002 C 193.240005 172.440002 197.389999 175.679993 197.869995 175.450012 Z"
      />
      <path
        id="path6451"
        fill="#f7d4ab"
        stroke="none"
        d="M 167.470001 186.890015 C 167.669998 186.97998 176.410004 181.51001 176.720001 181.220001 C 177.029999 180.919983 178.690002 177.710022 178.979996 177.23999 C 179.270004 176.77002 185.089996 172.609985 185.089996 172.609985 C 185.089996 172.609985 191.619995 171.02002 192.100006 171.119995 C 192.589996 171.22998 197.550003 173.410004 197.919998 173.73999 C 198.289993 174.059998 198.949997 175.330017 197.429993 175.929993 C 195.910004 176.529999 192.289993 175.720001 191.779999 175.350006 C 191.270004 174.97998 190.149994 175.77002 190.169998 176.039978 C 190.199997 176.299988 194.949997 187.660004 194.949997 187.660004 C 194.949997 187.660004 190.509995 189.640015 188.690002 190.059998 C 186.869995 190.47998 182.729996 190.059998 181.809998 190.380005 C 180.880005 190.700012 174.509995 195.570007 174.509995 195.570007 L 167.479996 186.899994 L 167.470001 186.890015 Z"
      />
      <linearGradient
        id="linearGradient586"
        x1="185.43"
        y1="190.8"
        x2="194.01"
        y2="177.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.23" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.44" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.45" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6452"
        fill="url(#linearGradient586)"
        stroke="none"
        d="M 192.130005 175.350006 L 189.039993 176.320007 C 189.039993 176.320007 188.690002 181.140015 183.770004 184.369995 C 182.059998 185.48999 184.320007 185.130005 187.029999 185.380005 C 190.279999 185.690002 194.289993 186.5 194.289993 186.5 L 192.130005 175.339996 L 192.130005 175.350006 Z"
      />
      <linearGradient
        id="linearGradient587"
        x1="200.81"
        y1="174.86"
        x2="188.76"
        y2="183.16"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6453"
        fill="url(#linearGradient587)"
        stroke="none"
        d="M 194.080002 186.5 L 191.119995 174.859985 L 188.899994 176.039978 C 188.899994 176.039978 189.309998 179.140015 187.039993 181.369995 C 186.380005 182.02002 194.089996 186.48999 194.089996 186.48999 L 194.080002 186.5 Z"
      />
      <linearGradient
        id="linearGradient588"
        x1="196.59"
        y1="172.89"
        x2="190.91"
        y2="176.94"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6454"
        fill="url(#linearGradient588)"
        stroke="none"
        d="M 194.740005 176.029999 L 191.360001 177.100006 C 191.360001 177.100006 189.990005 176.580017 190.449997 175.619995 C 190.770004 174.950012 191.399994 175.01001 191.399994 175.01001 L 194.729996 176.039978 L 194.740005 176.029999 Z"
      />
      <linearGradient
        id="linearGradient589"
        x1="178.44"
        y1="182.16"
        x2="186.69"
        y2="176.77"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6455"
        fill="url(#linearGradient589)"
        stroke="none"
        d="M 179.259995 183.100006 C 177.429993 183.299988 181.160004 177.149994 181.779999 176.890015 C 182.399994 176.630005 186.110001 176.5 186.770004 177.200012 C 187.429993 177.910004 185.940002 182.359985 179.259995 183.100006 Z"
      />
      <path
        id="path6456"
        fill="#f7d4ab"
        stroke="none"
        d="M 196.990005 180.830017 C 196.990005 180.830017 197.710007 180.419983 197.970001 179.839996 C 198.229996 179.26001 198.350006 177.869995 197.570007 176.950012 C 196.75 175.970001 195.949997 175.640015 195.949997 175.640015 C 195.949997 175.640015 190.179993 177.27002 190.039993 177.789978 C 189.889999 178.309998 190.630005 181.130005 191.449997 181.210022 C 192.270004 181.289978 197 180.839996 197 180.839996 L 196.990005 180.830017 Z"
      />
      <linearGradient
        id="linearGradient590"
        x1="202.24"
        y1="178.51"
        x2="191.39"
        y2="181.01"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.29" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.55" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6457"
        fill="url(#linearGradient590)"
        stroke="none"
        d="M 196.990005 180.830017 C 196.990005 180.830017 198.149994 180.330017 198.149994 179.059998 L 190.550003 180.080017 C 190.550003 180.080017 190.919998 181.200012 191.449997 181.190002 C 191.729996 181.190002 197 180.820007 197 180.820007 L 196.990005 180.830017 Z"
      />
      <path
        id="path6458"
        fill="#f7d4ab"
        stroke="none"
        d="M 194.940002 187.649994 C 194.940002 187.649994 196.520004 186.140015 196.910004 185.75 C 197.309998 185.369995 198.119995 183.350006 197.970001 182.72998 C 197.820007 182.109985 197.380005 181 196.990005 180.809998 C 196.589996 180.619995 191.929993 180.720001 191.710007 180.919983 C 191.490005 181.130005 190.839996 182.460022 192.029999 183.929993 C 192.199997 184.140015 194.949997 187.640015 194.949997 187.640015 L 194.940002 187.649994 Z"
      />
      <linearGradient
        id="linearGradient591"
        x1="198.07"
        y1="189.77"
        x2="194.73"
        y2="184.87"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.29" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.55" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6459"
        fill="url(#linearGradient591)"
        stroke="none"
        d="M 196.559998 184.47998 C 196.559998 184.47998 192.139999 183.559998 191.759995 183.549988 C 192.080002 184.169983 194.649994 187.309998 194.649994 187.309998 C 194.649994 187.309998 193.960007 185.26001 194.600006 185.220001 C 195.229996 185.179993 196.570007 184.47998 196.570007 184.47998 L 196.559998 184.47998 Z"
      />
      <linearGradient
        id="linearGradient592"
        x1="198.15"
        y1="182.13"
        x2="184.92"
        y2="186.02"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.29" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.55" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6460"
        fill="url(#linearGradient592)"
        stroke="none"
        d="M 197.710007 182.76001 C 197.710007 182.76001 195.160004 183.570007 191.389999 182.669983 C 191.389999 182.669983 191.570007 183.48999 191.830002 183.600006 C 192.720001 183.97998 195.649994 184.460022 196.399994 184.070007 C 197.149994 183.690002 197.710007 182.77002 197.710007 182.77002 L 197.710007 182.76001 Z"
      />
      <linearGradient
        id="linearGradient593"
        x1="196.86"
        y1="175.66"
        x2="197.22"
        y2="173.66"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#ffd9b3" stopOpacity={1} />
        <stop offset="0.68" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#f7d4ab" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6461"
        fill="url(#linearGradient593)"
        stroke="none"
        d="M 199.169998 174.350006 C 199.169998 174.350006 199.740005 173.73999 199.039993 172.619995 C 198.339996 171.5 197.410004 170.97998 196.850006 171.039978 C 196.279999 171.100006 195.429993 171.460022 195.429993 171.460022 C 195.429993 171.460022 197.369995 171.600006 197.649994 171.809998 C 197.929993 172.02002 198.759995 172.850006 199 173.350006 C 199.389999 174.140015 199.179993 174.350006 199.179993 174.350006 L 199.169998 174.350006 Z"
      />
      <linearGradient
        id="linearGradient594"
        x1="176.34"
        y1="199.8"
        x2="183.41"
        y2="188.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.29" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.55" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6462"
        fill="url(#linearGradient594)"
        stroke="none"
        d="M 187.160004 190.220001 L 181.800003 190.369995 C 181.220001 190.679993 175.389999 195.339996 175.389999 195.339996 C 175.389999 195.339996 179.130005 188.02002 179.559998 187.820007 C 180 187.609985 187.149994 190.22998 187.149994 190.22998 L 187.160004 190.220001 Z"
      />
      <linearGradient
        id="linearGradient595"
        x1="168.2"
        y1="191.35"
        x2="176.46"
        y2="178.62"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.29" stopColor="#f5d0a7" stopOpacity={1} />
        <stop offset="0.54" stopColor="#f1c69c" stopOpacity={1} />
        <stop offset="0.55" stopColor="#f1c69c" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6463"
        fill="url(#linearGradient595)"
        stroke="none"
        d="M 178.220001 178.640015 C 178.220001 178.640015 176.720001 181.119995 176.369995 181.390015 C 176.020004 181.660004 167.860001 186.789978 167.860001 186.789978 C 167.860001 186.789978 176.139999 184.089996 176.559998 183.559998 C 176.990005 183.02002 178.220001 178.640015 178.220001 178.640015 Z"
      />
      <linearGradient
        id="linearGradient596"
        x1="195.32"
        y1="187.8"
        x2="195.93"
        y2="184.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#f7d4ab" stopOpacity={1} />
        <stop offset="0.32" stopColor="#fcd7b0" stopOpacity={1} />
        <stop offset={1} stopColor="#ffd9b3" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6464"
        fill="url(#linearGradient596)"
        stroke="none"
        d="M 197.009995 185.660004 C 197.009995 185.660004 197.970001 183.950012 198.020004 183.169983 C 198.080002 182.390015 197.529999 181.26001 197.059998 180.789978 C 196.880005 180.609985 194.699997 180.720001 194.699997 180.720001 C 194.699997 180.720001 196.440002 181.369995 196.789993 181.600006 C 197.139999 181.830017 197.559998 183.23999 197.600006 183.470001 C 197.639999 183.700012 197 185.660004 197 185.660004 L 197.009995 185.660004 Z"
      />
      <linearGradient
        id="linearGradient597"
        x1="168.92"
        y1="185.3"
        x2="176.49"
        y2="196.51"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="1e-05" stopColor="#dba379" stopOpacity={1} />
        <stop offset="0.49" stopColor="#e3b086" stopOpacity={1} />
        <stop offset={1} stopColor="#f0c499" stopOpacity={1} />
      </linearGradient>
      <path
        id="path6465"
        fill="url(#linearGradient597)"
        stroke="none"
        d="M 177.300003 193.809998 L 174.699997 195.869995 C 174.699997 195.869995 171.029999 193.529999 170.289993 190.660004 C 169.550003 187.789978 170.960007 185.23999 170.960007 185.23999 C 170.960007 185.23999 170.960007 185.609985 172.690002 188.549988 C 173.550003 190.02002 175.820007 193.27002 177.300003 193.799988 L 177.300003 193.809998 Z"
      />
      <path
        id="path6466"
        fill="#ffffff"
        stroke="none"
        d="M 110.080002 173.640015 C 110.339996 179.649994 109.389999 186.890015 104.610001 192.460022 C 106.269997 191.47998 107.720001 190.130005 108.93 188.390015 C 111.190002 185.179993 112 181.609985 111.360001 177.720001 C 111.110001 176.25 110.690002 174.880005 110.089996 173.640015 L 110.080002 173.640015 Z"
      />
      <path
        id="path6467"
        fill="#ffffff"
        stroke="none"
        d="M 85.899902 170.26001 C 88.509903 168.919983 90.7099 167.410004 92.419899 165.809998 C 89.839897 166.609985 87.659897 168.089996 85.899902 170.26001 Z"
      />
      <path
        id="path6468"
        fill="#ffffff"
        stroke="none"
        d="M 97.119904 165 C 99.129898 165.910004 101.529999 166.589996 104.220001 167.02002 C 102.010002 165.660004 99.6399 164.98999 97.119904 165 Z"
      />
      <path
        id="path6469"
        fill="#ffffff"
        stroke="none"
        d="M 82.649902 177.220001 C 82.3899 178.779999 82.379898 180.390015 82.649902 182.070007 C 83.289902 185.970001 85.199898 189.080017 88.369904 191.399994 C 90.219902 192.75 92.179901 193.589996 94.239899 193.940002 C 87.579903 190.109985 84.289902 183.179993 82.6399 177.220001 L 82.649902 177.220001 Z"
      />
      <path
        id="path6470"
        fill="#ffffff"
        stroke="none"
        d="M 108.580002 173.799988 C 108.5 171.98999 108.309998 170.299988 108.080002 168.839996 C 106.489998 168.779999 104.980003 168.609985 103.550003 168.390015 C 101.089996 168 98.909897 167.380005 97.079903 166.559998 C 96.329903 166.220001 95.619904 165.850006 94.999901 165.440002 L 94.719902 165.47998 C 94.269897 166.049988 93.739899 166.609985 93.149902 167.160004 C 91.599899 168.619995 89.599899 170 87.2099 171.210022 C 86.0299 171.809998 84.759903 172.390015 83.409897 172.910004 C 83.6399 174.22998 83.9599 175.720001 84.3899 177.279999 C 85.899902 182.710022 88.8899 189.02002 94.949898 192.51001 C 96.339897 193.309998 97.8899 193.97998 99.629898 194.429993 C 101.209999 193.399994 102.5 192.210022 103.589996 190.929993 C 107.949997 185.859985 108.809998 179.26001 108.580002 173.789978 L 108.580002 173.799988 Z M 102.400002 188.299988 C 101.879997 188.919983 101.309998 189.5 100.699997 190.02002 C 100.370003 190.299988 100.029999 190.559998 99.689903 190.809998 C 99.5299 190.929993 99.309898 191.140015 99.099899 191.179993 C 98.919899 191.210022 98.629898 191.080017 98.4599 191.029999 C 96.899902 190.559998 95.409897 189.839996 94.089897 188.880005 C 93.839897 188.700012 93.599899 188.51001 93.369904 188.309998 C 91.329903 186.609985 89.799896 184.380005 88.699898 181.97998 C 88.349899 181.200012 88.0299 180.399994 87.749901 179.589996 C 87.2099 177.98999 86.809898 176.330017 86.519897 174.669983 C 86.499901 174.549988 86.569901 174.410004 86.679901 174.369995 C 87.549896 174.029999 88.409897 173.660004 89.249901 173.23999 C 89.8899 172.929993 90.499901 172.589996 91.099899 172.220001 C 91.659897 171.880005 92.2099 171.51001 92.729897 171.109985 C 92.809898 171.049988 92.879898 171 92.949898 170.940002 C 93.449898 170.549988 93.929901 170.130005 94.379898 169.660004 C 94.579903 169.450012 94.769897 169.23999 94.949898 169.02002 C 95.059898 168.890015 95.129898 168.76001 95.299896 168.720001 C 95.359901 168.700012 95.429901 168.700012 95.499901 168.690002 C 95.579903 168.679993 95.649902 168.690002 95.7099 168.73999 C 96.239899 169.089996 96.789902 169.369995 97.369904 169.619995 C 99.909897 170.720001 102.720001 171.140015 105.470001 171.25 C 105.589996 171.25 105.699997 171.369995 105.720001 171.47998 C 105.760002 171.73999 105.800003 172.01001 105.830002 172.27002 C 106.059998 173.97998 106.18 175.720001 106.110001 177.450012 C 106.080002 178.350006 106 179.25 105.870003 180.130005 C 105.559998 182.200012 104.919998 184.23999 103.919998 186.070007 C 103.489998 186.850006 102.989998 187.589996 102.410004 188.279999 L 102.400002 188.279999 L 102.400002 188.299988 Z"
      />
      <g id="g267" opacity="0.65">
        <path
          id="path6471"
          fill="#7e607f"
          stroke="none"
          opacity="0.65"
          d="M 964.710022 126.26001 C 964.710022 113.919983 954.710022 103.919983 942.369995 103.919983 C 930.030029 103.919983 920.030029 113.919983 920.030029 126.26001 C 920.030029 138.600006 930.030029 148.600006 942.369995 148.600006 C 954.710022 148.600006 964.710022 138.600006 964.710022 126.26001 Z"
        />
        <path
          id="path6472"
          fill="#f2f2f5"
          stroke="none"
          opacity="0.65"
          d="M 963.48999 126.26001 C 963.48999 114.589996 954.030029 105.140015 942.369995 105.140015 C 930.710022 105.140015 921.25 114.600006 921.25 126.26001 C 921.25 137.919983 930.710022 147.380005 942.369995 147.380005 C 954.030029 147.380005 963.48999 137.919983 963.48999 126.26001 Z"
        />
        <path
          id="path6473"
          fill="#3b0e19"
          stroke="none"
          opacity="0.65"
          d="M 953.328003 114.739014 L 939.133972 129.182007 L 939.625977 129.666016 L 953.820007 115.221985 L 953.328003 114.739014 Z"
        />
        <path
          id="path6474"
          fill="#3b0e19"
          stroke="none"
          opacity="0.65"
          d="M 933.539978 118.065002 L 933.085022 118.583008 L 945.434021 129.421021 L 945.888977 128.901978 L 933.539978 118.065002 Z"
        />
        <path
          id="path6475"
          fill="#3b0e19"
          stroke="none"
          opacity="0.65"
          d="M 943.460022 126.26001 C 943.460022 125.660004 942.969971 125.169983 942.369995 125.169983 C 941.77002 125.169983 941.280029 125.660004 941.280029 126.26001 C 941.280029 126.859985 941.77002 127.350006 942.369995 127.350006 C 942.969971 127.350006 943.460022 126.859985 943.460022 126.26001 Z"
        />
        <g id="g268" opacity="0.65">
          <path
            id="path6476"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 950.849976 113 L 950.849976 109.609985 L 950.080017 109.609985 L 950.080017 109.200012 L 951.280029 109.200012 L 951.280029 113 L 950.849976 113 Z"
          />
          <path
            id="path6477"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 958.070007 116.720001 C 958.070007 117.080017 957.799988 117.519989 957.400024 117.950012 L 956.22998 119.190002 L 958.289978 119.190002 L 958.289978 119.600006 L 955.679993 119.600006 L 955.679993 119.23999 L 957.099976 117.690002 C 957.419983 117.369995 957.619995 117.019989 957.619995 116.769989 C 957.619995 116.399994 957.340027 116.179993 956.859985 116.179993 C 956.51001 116.179993 956.130005 116.359985 955.820007 116.649994 L 955.630005 116.299988 C 956 115.970001 956.460022 115.769989 956.909973 115.769989 C 957.609985 115.769989 958.070007 116.130005 958.070007 116.700012 L 958.070007 116.720001 Z"
          />
          <path
            id="path6478"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 959.659973 125.970001 C 960.340027 126 960.809998 126.369995 960.809998 126.980011 C 960.809998 127.679993 960.289978 128.169983 959.47998 128.169983 C 959.039978 128.169983 958.590027 128.01001 958.280029 127.779999 L 958.469971 127.419983 C 958.73999 127.640015 959.099976 127.779999 959.450012 127.779999 C 960.039978 127.779999 960.390015 127.459991 960.390015 127 C 960.390015 126.540009 960.039978 126.279999 959.450012 126.279999 L 958.97998 126.279999 L 958.97998 126 L 960.090027 124.769989 L 958.450012 124.769989 L 958.450012 124.359985 L 960.640015 124.359985 L 960.640015 124.649994 L 959.460022 125.959991 L 959.669983 125.980011 L 959.659973 125.970001 Z"
          />
          <path
            id="path6479"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 957.619995 135.309998 L 957.619995 134.309998 L 958.030029 134.309998 L 958.030029 135.309998 L 958.609985 135.309998 L 958.609985 135.72998 L 958.030029 135.72998 L 958.030029 136.72998 L 957.619995 136.72998 L 957.619995 135.72998 L 955.799988 135.72998 L 955.799988 135.369995 L 957.159973 132.929993 L 957.590027 132.929993 L 956.27002 135.309998 L 957.630005 135.309998 L 957.619995 135.309998 Z"
          />
          <path
            id="path6480"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 950.299988 139.609985 L 950.299988 140.679993 C 950.5 140.649994 950.77002 140.630005 950.940002 140.630005 C 951.73999 140.630005 952.25 141.100006 952.25 141.75 C 952.25 142.51001 951.719971 143 950.909973 143 C 950.48999 143 949.98999 142.839996 949.630005 142.589996 L 949.809998 142.220001 C 950.119995 142.460022 950.530029 142.600006 950.869995 142.600006 C 951.440002 142.600006 951.789978 142.289978 951.789978 141.77002 C 951.789978 141.320007 951.440002 141.039978 950.880005 141.039978 C 950.630005 141.039978 950.169983 141.080017 949.900024 141.130005 L 949.900024 139.190002 L 952.099976 139.190002 L 952.099976 139.609985 L 950.299988 139.609985 Z"
          />
          <path
            id="path6481"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 943.549988 141.710022 L 943.380005 142.059998 C 943.130005 141.910004 942.799988 141.830017 942.51001 141.830017 C 941.700012 141.830017 941.289978 142.5 941.349976 143.52002 C 941.52002 143.070007 941.929993 142.820007 942.47998 142.820007 C 943.219971 142.820007 943.690002 143.279999 943.690002 144.01001 C 943.690002 144.789978 943.190002 145.27002 942.400024 145.27002 C 941.47998 145.27002 940.919983 144.600006 940.919983 143.429993 C 940.919983 142.26001 941.52002 141.429993 942.47998 141.429993 C 942.830017 141.429993 943.25 141.539978 943.549988 141.700012 L 943.549988 141.710022 Z M 941.440002 144.039978 C 941.440002 144.399994 941.719971 144.869995 942.359985 144.869995 C 942.900024 144.869995 943.27002 144.539978 943.27002 144.01001 C 943.27002 143.51001 942.929993 143.190002 942.400024 143.190002 C 941.799988 143.190002 941.440002 143.589996 941.440002 144.039978 Z"
          />
          <path
            id="path6482"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 933.539978 143 L 933.080017 143 L 934.640015 139.619995 L 932.869995 139.619995 L 932.869995 140.169983 L 932.47998 140.169983 L 932.47998 139.200012 L 935.119995 139.200012 L 935.119995 139.559998 L 933.539978 143 Z"
          />
          <path
            id="path6483"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 928.76001 133.859985 C 928.76001 134.25 928.530029 134.539978 928.140015 134.690002 C 928.630005 134.839996 928.940002 135.179993 928.940002 135.660004 C 928.940002 136.339996 928.400024 136.75 927.549988 136.75 C 926.700012 136.75 926.140015 136.339996 926.140015 135.679993 C 926.140015 135.200012 926.450012 134.850006 926.960022 134.700012 C 926.559998 134.539978 926.320007 134.25 926.320007 133.859985 C 926.320007 133.27002 926.789978 132.919983 927.539978 132.919983 C 928.289978 132.919983 928.76001 133.279999 928.76001 133.880005 L 928.76001 133.859985 Z M 926.549988 135.619995 C 926.549988 136.100006 926.919983 136.369995 927.539978 136.369995 C 928.159973 136.369995 928.530029 136.089996 928.530029 135.619995 C 928.530029 135.169983 928.159973 134.899994 927.539978 134.899994 C 926.919983 134.899994 926.549988 135.169983 926.549988 135.619995 Z M 926.700012 133.890015 C 926.700012 134.299988 927.01001 134.539978 927.549988 134.539978 C 928.090027 134.539978 928.390015 134.299988 928.390015 133.890015 C 928.390015 133.47998 928.070007 133.23999 927.549988 133.23999 C 927.030029 133.23999 926.700012 133.47998 926.700012 133.890015 Z"
          />
          <path
            id="path6484"
            fill="#3b0e19"
            stroke="none"
            opacity="0.65"
            d="M 923.97998 127.910004 L 924.150024 127.559998 C 924.400024 127.709991 924.72998 127.790009 925.02002 127.790009 C 925.830017 127.790009 926.23999 127.119995 926.179993 126.100006 C 926.01001 126.540009 925.599976 126.790009 925.049988 126.790009 C 924.309998 126.790009 923.840027 126.330017 923.840027 125.600006 C 923.840027 124.820007 924.340027 124.339996 925.130005 124.339996 C 926.049988 124.339996 926.609985 125.01001 926.609985 126.169983 C 926.609985 127.330017 926.01001 128.169983 925.049988 128.169983 C 924.700012 128.169983 924.280029 128.059998 923.97998 127.899994 L 923.97998 127.910004 Z M 926.090027 125.580017 C 926.090027 125.220001 925.809998 124.75 925.159973 124.75 C 924.619995 124.75 924.25 125.070007 924.25 125.609985 C 924.25 126.109985 924.590027 126.429993 925.119995 126.429993 C 925.719971 126.429993 926.080017 126.029999 926.080017 125.580017 L 926.090027 125.580017 Z"
          />
          <g id="g269" opacity="0.65">
            <path
              id="path6485"
              fill="#3b0e19"
              stroke="none"
              opacity="0.65"
              d="M 926.25 119.809998 L 926.25 116.419983 L 925.47998 116.419983 L 925.47998 116.01001 L 926.679993 116.01001 L 926.679993 119.809998 L 926.25 119.809998 Z"
            />
            <path
              id="path6486"
              fill="#3b0e19"
              stroke="none"
              opacity="0.65"
              d="M 930.890015 117.910004 C 930.890015 119.140015 930.330017 119.820007 929.320007 119.820007 C 928.309998 119.820007 927.75 119.140015 927.75 117.910004 C 927.75 116.679993 928.309998 116 929.320007 116 C 930.330017 116 930.890015 116.679993 930.890015 117.910004 Z M 928.190002 117.910004 C 928.190002 118.940002 928.580017 119.450012 929.320007 119.450012 C 930.059998 119.450012 930.450012 118.929993 930.450012 117.910004 C 930.450012 116.890015 930.059998 116.369995 929.320007 116.369995 C 928.580017 116.369995 928.190002 116.880005 928.190002 117.910004 Z"
            />
          </g>
          <g id="g270" opacity="0.65">
            <path
              id="path6487"
              fill="#3b0e19"
              stroke="none"
              opacity="0.65"
              d="M 932.630005 113.570007 L 932.630005 110.179993 L 931.859985 110.179993 L 931.859985 109.769989 L 933.059998 109.769989 L 933.059998 113.570007 L 932.630005 113.570007 Z"
            />
            <path
              id="path6488"
              fill="#3b0e19"
              stroke="none"
              opacity="0.65"
              d="M 935.320007 113.570007 L 935.320007 110.179993 L 934.549988 110.179993 L 934.549988 109.769989 L 935.75 109.769989 L 935.75 113.570007 L 935.320007 113.570007 Z"
            />
          </g>
          <g id="g271" opacity="0.65">
            <path
              id="path6489"
              fill="#3b0e19"
              stroke="none"
              opacity="0.65"
              d="M 940.669983 111.109985 L 940.669983 107.720001 L 939.900024 107.720001 L 939.900024 107.309998 L 941.099976 107.309998 L 941.099976 111.109985 L 940.669983 111.109985 Z"
            />
            <path
              id="path6490"
              fill="#3b0e19"
              stroke="none"
              opacity="0.65"
              d="M 944.619995 108.230011 C 944.619995 108.589996 944.349976 109.029999 943.950012 109.459991 L 942.780029 110.700012 L 944.840027 110.700012 L 944.840027 111.109985 L 942.22998 111.109985 L 942.22998 110.75 L 943.650024 109.200012 C 943.969971 108.880005 944.169983 108.529999 944.169983 108.279999 C 944.169983 107.910004 943.890015 107.690002 943.409973 107.690002 C 943.059998 107.690002 942.679993 107.869995 942.369995 108.160004 L 942.179993 107.809998 C 942.549988 107.480011 943.01001 107.279999 943.460022 107.279999 C 944.159973 107.279999 944.619995 107.640015 944.619995 108.209991 L 944.619995 108.230011 Z"
            />
          </g>
        </g>
        <path
          id="path6491"
          fill="#6c5f84"
          stroke="none"
          opacity="0.65"
          d="M 936.450012 111.609985 L 944.900024 132.960022 C 944.960022 133.119995 944.919983 133.289978 944.789978 133.410004 C 944.460022 133.710022 944.330017 134.179993 944.5 134.619995 C 944.719971 135.179993 945.349976 135.450012 945.909973 135.22998 C 946.469971 135.01001 946.73999 134.380005 946.52002 133.820007 C 946.349976 133.380005 945.919983 133.119995 945.47998 133.140015 C 945.309998 133.140015 945.159973 133.039978 945.090027 132.890015 L 936.640015 111.549988 C 936.619995 111.48999 936.549988 111.459991 936.48999 111.48999 C 936.429993 111.51001 936.400024 111.580017 936.429993 111.640015 L 936.450012 111.609985 Z"
        />
        <path
          id="path6492"
          fill="#6c5f84"
          stroke="none"
          opacity="0.65"
          d="M 943.090027 126.26001 C 943.090027 125.859985 942.77002 125.540009 942.369995 125.540009 C 941.969971 125.540009 941.650024 125.859985 941.650024 126.26001 C 941.650024 126.660004 941.969971 126.980011 942.369995 126.980011 C 942.77002 126.980011 943.090027 126.660004 943.090027 126.26001 Z"
        />
      </g>
      <path
        id="path6493"
        fill="#dfd5dc"
        stroke="none"
        d="M 823.780029 275.380005 C 824.72998 275.380005 825.460022 274.940002 825.820007 274.130005 C 825.960022 273.820007 825.820007 273.450012 825.51001 273.309998 C 825.200012 273.170013 824.830017 273.309998 824.690002 273.619995 C 824.619995 273.790009 824.419983 274.230011 823.52002 274.119995 C 821.840027 273.910004 819.380005 271.929993 819.070007 270.119995 C 818.869995 268.940002 819.01001 267.98999 819.47998 267.429993 C 819.869995 266.970001 820.52002 266.730011 821.419983 266.730011 C 821.940002 266.730011 823.51001 266.730011 823.51001 269.820007 C 823.51001 270.160004 823.789978 270.440002 824.130005 270.440002 C 824.469971 270.440002 824.75 270.160004 824.75 269.820007 C 824.75 266.059998 822.669983 265.5 821.419983 265.5 C 820.169983 265.5 819.169983 265.880005 818.539978 266.640015 C 817.820007 267.48999 817.590027 268.769989 817.859985 270.329987 C 818.280029 272.779999 821.219971 275.079987 823.380005 275.350006 C 823.52002 275.369995 823.659973 275.380005 823.789978 275.380005 L 823.780029 275.380005 Z"
      />
      <path
        id="path6494"
        fill="#f0ecef"
        stroke="none"
        d="M 840.72998 277.600006 C 840.169983 278.01001 839.51001 278.230011 838.820007 278.230011 L 830.140015 278.230011 C 829.450012 278.230011 828.780029 278.01001 828.22998 277.600006 C 825.630005 275.679993 823.940002 272.600006 823.940002 269.130005 C 823.940002 268.179993 824.070007 267.26001 824.309998 266.380005 C 824.450012 265.859985 824.929993 265.5 825.469971 265.5 L 843.48999 265.5 C 844.030029 265.5 844.51001 265.859985 844.650024 266.380005 C 844.890015 267.26001 845.02002 268.179993 845.02002 269.130005 C 845.02002 272.609985 843.330017 275.679993 840.72998 277.600006 Z"
      />
      <path
        id="path6495"
        fill="#dfd5dc"
        stroke="none"
        d="M 848.27002 277.480011 C 848.409973 277.480011 848.539978 277.559998 848.609985 277.690002 C 848.669983 277.820007 848.659973 277.970001 848.570007 278.079987 C 848.429993 278.26001 848.280029 278.440002 848.130005 278.619995 C 847.190002 279.720001 845.809998 280.359985 844.359985 280.359985 L 824.609985 280.359985 C 823.159973 280.359985 821.780029 279.730011 820.840027 278.619995 C 820.669983 278.420013 820.5 278.209991 820.340027 278 C 820.26001 277.899994 820.25 277.769989 820.309998 277.660004 C 820.369995 277.549988 820.47998 277.480011 820.599976 277.480011 L 848.280029 277.480011 L 848.27002 277.480011 Z"
      />
      <path
        id="path6496"
        fill="#dfd5dc"
        stroke="none"
        d="M 462.559998 278.959991 C 463.51001 278.959991 464.23999 278.519989 464.600006 277.709991 C 464.73999 277.399994 464.600006 277.029999 464.290009 276.890015 C 463.980011 276.75 463.609985 276.890015 463.470001 277.200012 C 463.399994 277.369995 463.200012 277.809998 462.299988 277.700012 C 460.619995 277.48999 458.160004 275.51001 457.850006 273.700012 C 457.649994 272.519989 457.790009 271.570007 458.26001 271.01001 C 458.649994 270.549988 459.299988 270.309998 460.200012 270.309998 C 460.720001 270.309998 462.290009 270.309998 462.290009 273.399994 C 462.290009 273.73999 462.570007 274.019989 462.910004 274.019989 C 463.25 274.019989 463.529999 273.73999 463.529999 273.399994 C 463.529999 269.640015 461.450012 269.079987 460.200012 269.079987 C 458.950012 269.079987 457.950012 269.459991 457.320007 270.220001 C 456.600006 271.070007 456.369995 272.350006 456.640015 273.910004 C 457.059998 276.359985 460 278.660004 462.160004 278.929993 C 462.299988 278.950012 462.440002 278.959991 462.570007 278.959991 L 462.559998 278.959991 Z"
      />
      <path
        id="path6497"
        fill="#f0ecef"
        stroke="none"
        d="M 479.51001 281.190002 C 478.950012 281.600006 478.290009 281.820007 477.600006 281.820007 L 468.920013 281.820007 C 468.230011 281.820007 467.559998 281.600006 467.01001 281.190002 C 464.410004 279.269989 462.720001 276.190002 462.720001 272.720001 C 462.720001 271.769989 462.850006 270.850006 463.089996 269.970001 C 463.230011 269.450012 463.709991 269.089996 464.25 269.089996 L 482.269989 269.089996 C 482.809998 269.089996 483.290009 269.450012 483.429993 269.970001 C 483.670013 270.850006 483.799988 271.769989 483.799988 272.720001 C 483.799988 276.200012 482.109985 279.269989 479.51001 281.190002 Z"
      />
      <path
        id="path6498"
        fill="#dfd5dc"
        stroke="none"
        d="M 487.040009 281.070007 C 487.179993 281.070007 487.309998 281.149994 487.380005 281.279999 C 487.440002 281.410004 487.429993 281.559998 487.339996 281.670013 C 487.200012 281.850006 487.049988 282.029999 486.899994 282.209991 C 485.959991 283.309998 484.579987 283.950012 483.130005 283.950012 L 463.380005 283.950012 C 461.929993 283.950012 460.549988 283.320007 459.609985 282.209991 C 459.440002 282.01001 459.269989 281.799988 459.109985 281.589996 C 459.029999 281.48999 459.019989 281.359985 459.079987 281.25 C 459.140015 281.140015 459.25 281.070007 459.369995 281.070007 L 487.049988 281.070007 L 487.040009 281.070007 Z"
      />
      <g id="g272" opacity="0.8">
        <path
          id="path6499"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 957.690002 212.27002 L 987.700012 212.27002 C 987.700012 211.839996 988.059998 211.48999 988.48999 211.48999 L 995.76001 211.48999 L 995.76001 209.169983 L 957.700012 209.169983 L 957.700012 212.27002 L 957.690002 212.27002 Z"
        />
        <path
          id="path6500"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 988.47998 239.529999 C 988.039978 239.529999 987.690002 239.179993 987.690002 238.740005 L 987.690002 237.259995 L 957.679993 237.259995 L 957.679993 240.360001 L 995.73999 240.360001 L 995.73999 239.529999 L 988.469971 239.529999 L 988.47998 239.529999 Z"
        />
        <path
          id="path6501"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 995.75 202.970001 L 957.690002 202.970001 L 957.690002 206.070007 L 995.75 206.070007 L 995.75 202.970001 Z"
        />
        <path
          id="path6502"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 987.700012 215.369995 L 957.690002 215.369995 L 957.690002 218.470001 L 987.700012 218.470001 L 987.700012 215.369995 Z"
        />
        <path
          id="path6503"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 987.700012 231.220001 L 957.690002 231.220001 L 957.690002 234.160004 L 987.700012 234.160004 L 987.700012 231.220001 Z"
        />
        <path
          id="path6504"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 995.75 243.470001 L 957.690002 243.470001 L 957.690002 246.369995 L 995.75 246.369995 L 995.75 243.470001 Z"
        />
        <path
          id="path6505"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 996.380005 202.970001 C 996.820007 202.970001 997.169983 202.619995 997.169983 202.179993 L 997.169983 201.47998 C 997.169983 198.72998 994.940002 196.5 992.190002 196.5 L 961.25 196.5 C 958.5 196.5 956.27002 198.72998 956.27002 201.47998 L 956.27002 202.179993 C 956.27002 202.619995 956.619995 202.970001 957.059998 202.970001 L 996.390015 202.970001 L 996.380005 202.970001 Z"
        />
        <path
          id="path6506"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 957.059998 206.070007 C 956.619995 206.070007 956.27002 206.419983 956.27002 206.859985 L 956.27002 208.380005 C 956.27002 208.820007 956.619995 209.169983 957.059998 209.169983 L 996.390015 209.169983 C 996.830017 209.169983 997.179993 208.820007 997.179993 208.380005 L 997.179993 206.859985 C 997.179993 206.419983 996.830017 206.070007 996.390015 206.070007 L 957.059998 206.070007 Z"
        />
        <path
          id="path6507"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 987.690002 212.279999 L 957.049988 212.279999 C 956.609985 212.279999 956.26001 212.630005 956.26001 213.059998 L 956.26001 214.580017 C 956.26001 215.02002 956.609985 215.369995 957.049988 215.369995 L 987.690002 215.369995 L 987.690002 212.279999 Z"
        />
        <path
          id="path6508"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 987.690002 218.47998 L 957.049988 218.47998 C 956.609985 218.47998 956.26001 218.830017 956.26001 219.27002 L 956.26001 230.440002 C 956.26001 230.880005 956.609985 231.22998 957.049988 231.22998 L 987.690002 231.22998 L 987.690002 218.47998 Z"
        />
        <path
          id="path6509"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 957.059998 246.369995 C 956.619995 246.369995 956.27002 246.720001 956.27002 247.160004 L 956.27002 247.699997 C 956.27002 251.320007 959.210022 254.259995 962.830017 254.259995 L 965.700012 254.259995 C 967.159973 254.259995 973.52002 256.570007 973.52002 260.929993 L 973.52002 261.399994 C 973.52002 261.570007 973.659973 261.720001 973.840027 261.720001 L 979.609985 261.720001 C 979.780029 261.720001 979.929993 261.579987 979.929993 261.399994 L 979.929993 260.929993 C 979.929993 256.570007 986.289978 254.259995 987.75 254.259995 L 990.619995 254.259995 C 994.23999 254.259995 997.179993 251.320007 997.179993 247.699997 L 997.179993 247.160004 C 997.179993 246.720001 996.830017 246.369995 996.390015 246.369995 L 957.059998 246.369995 Z"
        />
        <path
          id="path6510"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 979.530029 261.720001 L 973.909973 261.720001 L 973.909973 265.149994 L 979.530029 265.149994 L 979.530029 261.720001 Z"
        />
        <path
          id="path6511"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 973.830017 265.160004 C 973.659973 265.160004 973.51001 265.299988 973.51001 265.480011 L 973.51001 266.109985 C 973.51001 266.279999 973.650024 266.429993 973.830017 266.429993 L 979.599976 266.429993 C 979.77002 266.429993 979.919983 266.290009 979.919983 266.109985 L 979.919983 265.480011 C 979.919983 265.309998 979.780029 265.160004 979.599976 265.160004 L 973.830017 265.160004 Z"
        />
        <path
          id="path6512"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 987.690002 234.160004 L 957.049988 234.160004 C 956.609985 234.160004 956.26001 234.51001 956.26001 234.950012 L 956.26001 236.470001 C 956.26001 236.910004 956.609985 237.259995 957.049988 237.259995 L 987.690002 237.259995 L 987.690002 234.160004 Z"
        />
        <path
          id="path6513"
          fill="#66b8ec"
          stroke="none"
          opacity="0.8"
          d="M 957.059998 240.369995 C 956.619995 240.369995 956.27002 240.720001 956.27002 241.160004 L 956.27002 242.679993 C 956.27002 243.119995 956.619995 243.470001 957.059998 243.470001 L 996.390015 243.470001 C 996.830017 243.470001 997.179993 243.119995 997.179993 242.679993 L 997.179993 241.160004 C 997.179993 240.720001 996.830017 240.369995 996.390015 240.369995 L 957.059998 240.369995 Z"
        />
        <path
          id="path6514"
          fill="#5ba8e5"
          stroke="none"
          opacity="0.8"
          d="M 991.390015 239.529999 L 995.75 239.529999 L 995.75 237.270004 L 995.75 234.160004 L 995.75 231.220001 L 995.75 218.47998 L 995.75 215.369995 L 995.75 212.27002 L 995.75 211.48999 L 991.390015 211.48999 L 991.390015 239.529999 Z"
        />
      </g>
      <path
        id="path6515"
        fill="#5a5278"
        stroke="none"
        d="M 986.400024 256.589996 L 967.030029 256.589996 C 966.380005 256.589996 965.76001 256.859985 965.309998 257.329987 L 961.799988 261.049988 L 991.630005 261.049988 L 988.119995 257.329987 C 987.669983 256.859985 987.049988 256.589996 986.400024 256.589996 Z"
      />
      <path
        id="path6516"
        fill="#e2dfe5"
        stroke="none"
        d="M 997.150024 387.140015 L 956.27002 387.140015 C 955.830017 387.140015 955.47998 386.790009 955.47998 386.350006 L 955.47998 264.109985 C 955.47998 262.410004 956.849976 261.040009 958.549988 261.040009 L 994.869995 261.040009 C 996.570007 261.040009 997.940002 262.410004 997.940002 264.109985 L 997.940002 386.350006 C 997.940002 386.790009 997.590027 387.140015 997.150024 387.140015 Z"
      />
      <path
        id="path6517"
        fill="#d1ccd6"
        stroke="none"
        d="M 997.150024 387.140015 L 956.27002 387.140015 C 955.830017 387.140015 955.47998 386.790009 955.47998 386.350006 L 955.47998 264.190002 L 997.940002 264.190002 L 997.940002 386.350006 C 997.940002 386.790009 997.590027 387.140015 997.150024 387.140015 Z"
      />
      <path
        id="path6518"
        fill="#eeecf0"
        stroke="none"
        d="M 958.880005 264.190002 L 958.880005 387.140015 L 994.549988 387.140015 L 994.549988 264.190002 L 958.880005 264.190002 Z"
      />
      <path
        id="path6519"
        fill="#5a5278"
        stroke="none"
        d="M 994.549988 384.040009 L 958.880005 384.040009 L 958.880005 387.140015 L 994.549988 387.140015 L 994.549988 384.040009 Z"
      />
      <path
        id="path6520"
        fill="#5a5278"
        stroke="none"
        d="M 994.549988 322.350006 L 958.880005 322.350006 L 958.880005 333.23999 L 994.549988 333.23999 L 994.549988 322.350006 Z"
      />
      <path
        id="path6521"
        fill="#686185"
        stroke="none"
        d="M 994.549988 293.23999 L 958.880005 293.23999 L 958.880005 322.350006 L 994.549988 322.350006 L 994.549988 293.23999 Z"
      />
      <path
        id="path6522"
        fill="#dad6df"
        stroke="none"
        d="M 994.549988 264.190002 L 958.880005 264.190002 L 958.880005 272.820007 L 994.549988 272.820007 L 994.549988 264.190002 Z"
      />
      <path
        id="path6523"
        fill="#493d62"
        stroke="none"
        d="M 993.52002 293.23999 L 959.900024 293.23999 L 959.900024 322.350006 L 993.52002 322.350006 L 993.52002 293.23999 Z"
      />
      <path
        id="path6524"
        fill="#eeecf0"
        stroke="none"
        d="M 994.070007 261.049988 L 959.349976 261.049988 C 958.76001 261.049988 958.880005 264.190002 958.880005 264.190002 L 994.549988 264.190002 C 994.549988 264.190002 994.51001 261.049988 994.080017 261.049988 L 994.070007 261.049988 Z"
      />
      <path
        id="path6525"
        fill="#ed4e5b"
        stroke="none"
        d="M 966.650024 293.23999 L 966.650024 294.369995 C 966.650024 294.630005 966.679993 294.890015 966.73999 295.149994 L 967.690002 299.209991 C 967.73999 299.420013 967.929993 299.579987 968.150024 299.579987 L 969.25 299.579987 C 969.469971 299.579987 969.659973 299.429993 969.710022 299.209991 L 970.659973 295.149994 C 970.719971 294.899994 970.75 294.630005 970.75 294.369995 L 970.75 293.23999 L 966.650024 293.23999 Z"
      />
      <path
        id="path6526"
        fill="#66b8ec"
        stroke="none"
        d="M 982.669983 293.23999 L 982.669983 294.369995 C 982.669983 294.630005 982.700012 294.890015 982.76001 295.149994 L 983.710022 299.209991 C 983.76001 299.420013 983.950012 299.579987 984.169983 299.579987 L 985.27002 299.579987 C 985.48999 299.579987 985.679993 299.429993 985.72998 299.209991 L 986.679993 295.149994 C 986.73999 294.899994 986.77002 294.630005 986.77002 294.369995 L 986.77002 293.23999 L 982.669983 293.23999 Z"
      />
      <path
        id="path6527"
        fill="#ed4e5b"
        stroke="none"
        d="M 972.52002 284.209991 L 964.890015 284.209991 C 964.453979 284.209991 964.099976 284.563995 964.099976 285 L 964.099976 288.470001 C 964.099976 288.906006 964.453979 289.26001 964.890015 289.26001 L 972.52002 289.26001 C 972.955994 289.26001 973.309998 288.906006 973.309998 288.470001 L 973.309998 285 C 973.309998 284.563995 972.955994 284.209991 972.52002 284.209991 Z"
      />
      <path
        id="path6528"
        fill="#66b8ec"
        stroke="none"
        d="M 988.539978 284.209991 L 980.909973 284.209991 C 980.473999 284.209991 980.119995 284.563995 980.119995 285 L 980.119995 288.470001 C 980.119995 288.906006 980.473999 289.26001 980.909973 289.26001 L 988.539978 289.26001 C 988.976013 289.26001 989.330017 288.906006 989.330017 288.470001 L 989.330017 285 C 989.330017 284.563995 988.976013 284.209991 988.539978 284.209991 Z"
      />
      <path
        id="path6529"
        fill="#ed4e5b"
        stroke="none"
        d="M 970 270.230011 C 970 270.709991 969.609985 271.100006 969.130005 271.100006 C 968.650024 271.100006 968.26001 270.709991 968.26001 270.230011 C 968.26001 269.75 968.650024 269.359985 969.130005 269.359985 C 969.609985 269.359985 970 269.75 970 270.230011 Z"
      />
      <path
        id="path6530"
        fill="#c3d06b"
        stroke="none"
        d="M 977.590027 270.230011 C 977.590027 270.709991 977.200012 271.100006 976.719971 271.100006 C 976.23999 271.100006 975.849976 270.709991 975.849976 270.230011 C 975.849976 269.75 976.23999 269.359985 976.719971 269.359985 C 977.200012 269.359985 977.590027 269.75 977.590027 270.230011 Z"
      />
      <path
        id="path6531"
        fill="#66b8ec"
        stroke="none"
        d="M 985.179993 270.230011 C 985.179993 270.709991 984.789978 271.100006 984.309998 271.100006 C 983.830017 271.100006 983.440002 270.709991 983.440002 270.230011 C 983.440002 269.75 983.830017 269.359985 984.309998 269.359985 C 984.789978 269.359985 985.179993 269.75 985.179993 270.230011 Z"
      />
      <path
        id="path6532"
        fill="#f7d4ab"
        stroke="none"
        d="M 179.529999 176.850006 C 179.820007 176.380005 185.639999 172.220001 185.639999 172.220001 C 185.639999 172.220001 192.169998 170.630005 192.649994 170.72998 C 193.139999 170.839996 198.100006 173.02002 198.470001 173.350006 C 198.839996 173.669983 199.5 174.940002 197.979996 175.539978 C 196.460007 176.140015 192.839996 175.330017 192.330002 174.960022 C 191.820007 174.589996 190.699997 175.380005 190.720001 175.649994"
      />
      <mask
        id="mask1"
        x={0}
        y={126}
        width={290}
        height={367}
        maskUnits="userSpaceOnUse"
        maskContentUnits="userSpaceOnUse"
      >
        <image
          x={0}
          y={126}
          width={290}
          height={367}
          xlinkHref="data:image/png;base64, iVBORw0KGgoAAAANSUhEUgAAASIAAAFvCAAAAADLE5nYAAAAOGVYSWZNTQAqAAAACAABh2kABAAAAAEAAAAaAAAAAAACoAIABAAAAAEAAAEioAMABAAAAAEAAAFvAAAAAKXfetIAAAIiSURBVHgB7dLBFUBAEAVBPPmHJRAnWRBCzxW1575M7V+X/757dPqxjbJfR4jy+xEhSoEMrAhRCmRgRYhSIAMrQpQCGVgRohTIwIoQpUAGVoQoBTKwIkQpkIEVIUqBDKwIUQpksGfx3eAcnXaNKhEBAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACBNws8NAgDwZopLHkAAAAASUVORK5CYII="
        />
      </mask>
      <g id="g273" mask="url(#mask1)">
        <path
          id="path6533"
          fill="#bbc1c7"
          stroke="none"
          visibility="hidden"
          d="M 257.431 128.524994 L 256.799988 131.11499 L 252.235992 149.880005 L 250.770004 149.880005 L 255.960999 128.524994 L 257.431 128.524994 Z"
        />
        <g
          id="g274"
          opacity="0.15"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g275" opacity="0.15" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6534"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 257.431 128.524994 L 256.799988 131.11499 L 252.235992 149.880005 L 250.770004 149.880005 L 250.923996 149.239014 L 255.686005 129.660004 L 255.960999 128.524994 L 257.431 128.524994 Z"
            />
          </g>
        </g>
        <g
          id="g276"
          opacity="0.15"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g277" opacity="0.15" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6535"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 257.431 128.524994 L 256.799988 131.11499 L 252.235992 149.880005 L 250.770004 149.880005 L 250.923996 149.23999 C 251.296997 149.266998 251.703003 149.14801 252.078995 148.531006 C 252.884003 147.218018 256.25 132.190979 256.307007 131.122009 C 256.330994 130.667999 256.035004 130.130005 255.686005 129.661011 L 255.960999 128.526001 L 257.431 128.526001 L 257.431 128.524994 Z"
            />
          </g>
        </g>
        <path
          id="path6536"
          fill="#bbc1c7"
          stroke="none"
          visibility="hidden"
          d="M 262.829987 149.880005 L 261.364014 149.880005 L 259.722992 143.135986 L 259.216003 141.050995 L 258.018005 136.119995 L 257.510986 134.035004 L 256.799988 131.11499 L 256.169006 128.524994 L 257.639008 128.524994 L 258.977997 134.035004 L 259.484009 136.119995 L 260.682007 141.050995 L 261.188995 143.135986 L 262.829987 149.880005 Z"
        />
        <g
          id="g278"
          opacity="0.45"
          style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
        >
          <g
            id="g279"
            opacity="0.45"
            style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
          >
            <g id="g280" opacity="0.45" style={{ mixBlendMode: 'screen' }}>
              <path
                id="path6537"
                fill="#fdfdfd"
                stroke="none"
                visibility="hidden"
                d="M 262.303986 149.880005 L 261.734985 149.880005 L 257.17099 131.11499 L 256.540985 128.524994 L 257.112 128.524994 L 262.303986 149.880005 Z"
              />
            </g>
          </g>
        </g>
        <g
          id="g281"
          opacity="0.55"
          style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
        >
          <g
            id="g282"
            opacity="0.55"
            style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
          >
            <g id="g283" opacity="0.55" style={{ mixBlendMode: 'screen' }}>
              <path
                id="path6538"
                fill="#fdfdfd"
                stroke="none"
                visibility="hidden"
                d="M 257.597992 132.031006 C 257.924011 133.197998 258.229004 134.371002 258.529999 135.544006 L 259.411011 139.070007 L 260.247986 142.606018 C 260.518005 143.786987 260.786011 144.968018 261.032013 146.153992 C 260.705994 144.987 260.399994 143.813995 260.097992 142.640991 L 259.217987 139.11499 L 258.381012 135.578979 C 258.109985 134.39801 257.842987 133.21698 257.596985 132.031006 L 257.597992 132.031006 Z"
              />
            </g>
          </g>
        </g>
        <path
          id="path6539"
          fill="#bbc1c7"
          stroke="none"
          visibility="hidden"
          d="M 284.066986 128.524994 L 283.436005 131.11499 L 278.872009 149.880005 L 277.406006 149.880005 L 282.596985 128.524994 L 284.066986 128.524994 Z"
        />
        <g
          id="g284"
          opacity="0.15"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g285" opacity="0.15" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6540"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 284.066986 128.524994 L 283.436005 131.11499 L 278.872009 149.880005 L 277.406006 149.880005 L 277.559998 149.239014 L 282.321991 129.660004 L 282.596985 128.524994 L 284.066986 128.524994 Z"
            />
          </g>
        </g>
        <g
          id="g286"
          opacity="0.15"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g287" opacity="0.15" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6541"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 284.066986 128.524994 L 283.437012 131.11499 L 278.872986 149.878998 L 277.407013 149.878998 L 277.561005 149.239014 C 277.93399 149.265991 278.339996 149.147003 278.716003 148.529999 C 279.520996 147.21698 282.886993 132.190002 282.944 131.122009 C 282.967987 130.666992 282.671997 130.128998 282.322998 129.660004 L 282.597992 128.524994 L 284.067993 128.524994 L 284.066986 128.524994 Z"
            />
          </g>
        </g>
        <path
          id="path6542"
          fill="#bbc1c7"
          stroke="none"
          visibility="hidden"
          d="M 289.46701 149.880005 L 288.001007 149.880005 L 286.359985 143.135986 L 285.852997 141.050995 L 284.654999 136.119995 L 284.14801 134.035004 L 283.436005 131.11499 L 282.806 128.524994 L 284.276001 128.524994 L 285.614014 134.035004 L 286.121002 136.119995 L 287.319 141.050995 L 287.825989 143.135986 L 289.46701 149.880005 Z"
        />
        <g
          id="g288"
          opacity="0.45"
          style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
        >
          <g
            id="g289"
            opacity="0.45"
            style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
          >
            <g id="g290" opacity="0.45" style={{ mixBlendMode: 'screen' }}>
              <path
                id="path6543"
                fill="#fdfdfd"
                stroke="none"
                visibility="hidden"
                d="M 288.940002 149.880005 L 288.371002 149.880005 L 283.807007 131.11499 L 283.177002 128.524994 L 283.748993 128.524994 L 288.940002 149.880005 Z"
              />
            </g>
          </g>
        </g>
        <g
          id="g291"
          opacity="0.55"
          style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
        >
          <g
            id="g292"
            opacity="0.55"
            style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
          >
            <g id="g293" opacity="0.55" style={{ mixBlendMode: 'screen' }}>
              <path
                id="path6544"
                fill="#fdfdfd"
                stroke="none"
                visibility="hidden"
                d="M 284.234009 132.031006 C 284.559998 133.197998 284.86499 134.371002 285.165985 135.544006 L 286.046997 139.070007 L 286.884003 142.606018 C 287.154999 143.786987 287.421997 144.968018 287.667999 146.153992 C 287.34201 144.987 287.036011 143.813995 286.734009 142.640991 L 285.854004 139.11499 L 285.016998 135.578979 C 284.746002 134.39801 284.479004 133.21698 284.233002 132.031006 L 284.234009 132.031006 Z"
              />
            </g>
          </g>
        </g>
        <path
          id="path6545"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 258.35199 127.399994 C 258.35199 128.203979 257.688995 128.856995 256.871002 128.856995 C 256.052002 128.856995 255.389008 128.203979 255.389008 127.399994 C 255.389008 126.596008 256.050995 125.942993 256.871002 125.942993 C 257.690002 125.942993 258.35199 126.596008 258.35199 127.399994 Z"
        />
        <path
          id="path6546"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 284.968994 127.337006 C 284.968994 128.140991 284.306 128.792999 283.487 128.792999 C 282.669006 128.792999 282.006012 128.140991 282.006012 127.337006 C 282.006012 126.531982 282.669006 125.880005 283.487 125.880005 C 284.306 125.880005 284.968994 126.531982 284.968994 127.337006 Z"
        />
        <g
          id="g294"
          opacity="0.25"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g295" opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6547"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 259.484009 136.119995 L 258.018005 136.119995 L 257.510986 134.035004 L 258.977997 134.035004 L 259.484009 136.119995 Z"
            />
          </g>
        </g>
        <g
          id="g296"
          opacity="0.25"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g297" opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6548"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 286.121002 136.119995 L 284.654999 136.119995 L 284.14801 134.035004 L 285.614014 134.035004 L 286.121002 136.119995 Z"
            />
          </g>
        </g>
        <g
          id="g298"
          opacity="0.25"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g299" opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6549"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 261.188995 143.135986 L 259.722992 143.135986 L 259.216003 141.050995 L 260.682007 141.050995 L 261.188995 143.135986 Z"
            />
          </g>
        </g>
        <g
          id="g300"
          opacity="0.25"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g301" opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6550"
              fill="#606060"
              stroke="none"
              visibility="hidden"
              d="M 287.825989 143.135986 L 286.359985 143.135986 L 285.852997 141.050995 L 287.319 141.050995 L 287.825989 143.135986 Z"
            />
          </g>
        </g>
        <path
          id="path6551"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 287.704987 130.677979 L 288.53299 135.291992 L 255.718994 135.291992 L 254.891006 130.677979 L 287.704987 130.677979 Z"
        />
        <path
          id="path6552"
          fill="#009b0f"
          stroke="none"
          visibility="hidden"
          d="M 261.276001 135.291992 L 255.718994 135.291992 L 254.953995 131.028015 L 257.794006 132.942993 L 260.576996 134.820984 L 261.276001 135.291992 Z"
        />
        <path
          id="path6553"
          fill="#009b0f"
          stroke="none"
          visibility="hidden"
          d="M 272.380005 135.291992 L 266.819 135.291992 L 266.063995 134.781982 L 259.980988 130.677979 L 265.541992 130.677979 L 271.523987 134.716003 L 272.380005 135.291992 Z"
        />
        <path
          id="path6554"
          fill="#009b0f"
          stroke="none"
          visibility="hidden"
          d="M 283.483002 135.291992 L 277.923004 135.291992 L 271.084991 130.677979 L 276.641998 130.677979 L 282.184998 134.416016 L 283.483002 135.291992 Z"
        />
        <path
          id="path6555"
          fill="#009b0f"
          stroke="none"
          visibility="hidden"
          d="M 287.704987 130.677979 L 288.464996 134.912994 L 284.998993 132.574005 L 282.186005 130.677979 L 287.704987 130.677979 Z"
        />
        <g
          id="g302"
          opacity="0.55"
          style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
        >
          <g
            id="g303"
            opacity="0.55"
            style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
          >
            <g id="g304" opacity="0.55" style={{ mixBlendMode: 'screen' }}>
              <path
                id="path6556"
                fill="#fdfdfd"
                stroke="none"
                visibility="hidden"
                d="M 257.596985 131.278015 C 259.537994 131.223999 261.477997 131.199005 263.417999 131.177979 L 269.23999 131.147003 L 275.061005 131.177979 L 277.971985 131.213989 L 280.882996 131.278992 L 277.971985 131.343018 L 275.061005 131.380005 L 269.23999 131.410004 L 263.417999 131.380005 C 261.477997 131.359009 259.537994 131.333008 257.596985 131.278992 L 257.596985 131.278015 Z"
              />
            </g>
          </g>
        </g>
        <path
          id="path6557"
          fill="#009b0f"
          stroke="none"
          visibility="hidden"
          d="M 288.941986 137.479004 L 289.769989 142.093018 L 256.954987 142.093018 L 256.127991 137.479004 L 288.941986 137.479004 Z"
        />
        <path
          id="path6558"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 262.511993 142.093018 L 256.954987 142.093018 L 256.19101 137.828979 L 259.029999 139.744019 L 261.812988 141.621002 L 262.511993 142.093018 Z"
        />
        <path
          id="path6559"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 273.615997 142.093018 L 268.054993 142.093018 L 267.299988 141.583008 L 261.217987 137.479004 L 266.778015 137.479004 L 272.760986 141.515991 L 273.615997 142.093018 Z"
        />
        <path
          id="path6560"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 284.718994 142.093018 L 279.160004 142.093018 L 272.321991 137.479004 L 277.878998 137.479004 L 283.421997 141.21698 L 284.718994 142.093018 Z"
        />
        <path
          id="path6561"
          fill="#8e8e8e"
          stroke="none"
          visibility="hidden"
          d="M 288.941986 137.479004 L 289.701996 141.713989 L 286.234985 139.375 L 283.421997 137.479004 L 288.941986 137.479004 Z"
        />
        <g
          id="g305"
          opacity="0.25"
          style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}
        >
          <g id="g306" opacity="0.25" style={{ mixBlendMode: 'multiply' }}>
            <path
              id="path6562"
              fill="#d9690d"
              stroke="none"
              visibility="hidden"
              d="M 288.953003 137.535004 L 289.769989 142.093018 L 256.954987 142.093018 L 256.881012 141.681 L 257.252991 141.636993 C 257.252991 141.636993 259.07901 141.63501 261.813995 141.622009 C 263.397003 141.614014 265.28299 141.60199 267.299988 141.583984 C 269.062012 141.565979 270.92099 141.544983 272.760986 141.516998 C 274.622009 141.490997 276.458008 141.455017 278.151001 141.414001 C 280.188995 141.359009 282.019012 141.294983 283.42099 141.218018 C 285.098999 141.125 285.677002 140.729004 285.759003 140.589996 C 285.904999 140.339996 286.354004 140.037994 286.234985 139.375 C 286.121002 138.744019 285.934998 138.037994 285.773987 137.479004 L 288.92099 137.479004 C 288.931 137.497009 288.94101 137.516998 288.950989 137.535004 L 288.953003 137.535004 Z"
            />
          </g>
        </g>
        <g
          id="g307"
          opacity="0.55"
          style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
        >
          <g
            id="g308"
            opacity="0.55"
            style={{ mixBlendMode: 'screen', isolation: 'isolate' }}
          >
            <g id="g309" opacity="0.55" style={{ mixBlendMode: 'screen' }}>
              <path
                id="path6563"
                fill="#fdfdfd"
                stroke="none"
                visibility="hidden"
                d="M 258.833008 138.078003 C 260.773987 138.023987 262.713989 137.998993 264.654999 137.977997 L 270.476013 137.947998 L 276.298004 137.977997 L 279.209015 138.015015 L 282.118988 138.078979 L 279.209015 138.143005 L 276.298004 138.179993 L 270.476013 138.210022 L 264.654999 138.179993 C 262.713989 138.158997 260.773987 138.132996 258.833008 138.080017 L 258.833008 138.078003 Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
